(function () {
  Window.data = Window.data || {};
  Window.data.json = { interes: null };

  Window.data.json.interes = {
    type: "Topology",
    arcs: [
      [
        [286563, 70266],
        [119, -1774],
        [2682, 3432],
        [78, -59],
        [12, -42],
        [-7, -66],
        [32, -43],
        [32, -53],
        [27, -30],
        [21, -34],
        [55, -42],
        [12, -63],
        [44, -42],
        [14, -46],
        [15, -46],
        [35, -39],
        [28, -26],
        [29, -29],
        [46, -54],
        [4, -45],
        [27, -15],
        [8, -23],
        [24, -49],
        [24, -55],
        [11, -33],
        [-21, -66],
        [27, -62],
        [-45, -49],
        [-17, -72],
        [-37, -116],
        [-47, -34],
        [-46, -83],
        [-55, -23],
        [-18, -55],
        [-28, -62],
        [-22, -105],
        [-37, -65],
        [-38, -4],
        [-106, 11],
        [-93, 15],
        [-62, -1],
        [-30, -18],
        [-15, -97],
        [-26, -55],
        [-6, -100],
        [-24, -113],
        [-51, -77],
        [-56, -7],
        [-98, 9],
        [-29, -23],
        [-26, -89],
        [12, -78],
        [59, -64],
        [-6, -133],
        [-49, -50],
        [-29, -83],
        [4, -63],
        [29, -43],
        [-27, -44],
        [6, -48],
        [-18, -30],
        [-12, -92],
        [-39, -83],
        [6, -42],
        [-41, -55],
        [-56, -73],
        [-28, -90],
        [14, -44],
        [-19, -85],
        [-3, -60],
        [-17, -96],
        [27, -48],
        [-4, -69],
        [-52, -50],
        [-76, -57],
        [-20, -60],
        [-70, -65],
        [21, -79],
        [-43, -64],
        [-55, -58],
        [-86, -12],
        [-48, -82],
        [-77, 8],
        [-52, -41],
        [-28, -48],
        [-87, -16],
        [-80, -13],
        [-56, -70],
        [-124, -20],
        [-99, -5],
        [-80, -44],
        [-84, 2],
        [-88, -30],
        [-4, -61],
        [-22, -52],
        [-7, -34],
        [-6, -38],
        [0, -47],
        [-10, -46],
        [-37, -22],
        [-54, 15],
        [-37, -2],
        [-31, 10],
        [-28, 6],
        [-37, -11],
        [-25, -34],
        [-15, -36],
        [-18, -68],
        [16, -72],
        [36, -33],
        [16, -82],
        [17, -107],
        [-41, -84],
        [12, -80],
        [-2, -82],
        [-2, -84],
        [36, -26],
        [-16, -131],
        [-30, -57],
        [-9, -52],
        [-2, -55],
        [-23, -65],
        [-33, -56],
        [-5, -110],
        [-19, -79],
        [-23, -59],
        [-20, -64],
        [24, -60],
        [-21, -39],
        [7, -43],
        [-33, -35],
        [-90, -37],
        [-15, -44],
        [5, -34],
        [-21, -43],
        [0, -27],
        [-12, -21],
        [-33, -12],
        [-68, -6],
        [-45, -93],
        [-21, -88],
        [22, -83],
        [38, -36],
        [99, -51],
        [39, -56],
        [-14, -119],
        [25, -44],
        [3, -57],
        [-11, -52],
        [11, -97],
        [-7, -67],
        [-2, -52],
        [57, -63],
        [67, -92],
        [-8, -70],
        [33, -58],
        [43, -108],
        [3, -73],
        [-14, -66],
        [-10, -64],
        [-58, -69],
        [-63, -55],
        [-41, -3],
        [-35, -23],
        [-76, 2],
        [-70, -17],
        [-53, -3],
        [-55, -3],
        [-55, -49],
        [-12, -55],
        [-65, -74],
        [-6, -32],
        [-45, -49],
        [-43, -2],
        [-18, -14],
        [-106, -54],
        [-30, -79],
        [-8, -59],
        [-10, -82],
        [-3, -79],
        [-4, -104],
        [-34, -70],
        [-40, -100],
        [-38, -133],
        [22, -80],
        [-7, -73],
        [-30, -122],
        [-10, -77],
        [-12, -76],
        [-15, -94],
        [-24, -64],
        [-22, -70],
        [-21, -48],
        [-19, -42],
        [1, -76],
        [10, -35],
        [-33, -94],
        [-6, -118],
        [20, -14],
        [3, -101],
        [2, -47],
        [-17, -61],
        [15, -47],
        [20, -53],
        [9, -43],
        [16, -55],
        [2, -60],
        [1, -65],
        [10, -46],
        [9, -28],
        [-12, -37],
        [3, -34],
        [1, -38],
        [18, -39],
        [48, -50],
        [44, -37],
        [35, -28],
        [28, -33],
        [25, -29],
        [7, -18],
        [54, -64],
        [4, -28],
        [15, -21],
        [17, -33],
        [14, -19],
        [10, -65],
        [72, -46],
        [35, -34],
        [37, -35],
        [24, -13],
        [23, 0],
        [12, -17],
        [4, -22],
        [10, -26],
        [24, -46],
        [13, -70],
        [16, -23],
        [61, -25],
        [21, -72],
        [0, -31],
        [15, -25],
        [27, -26],
        [10, -11],
        [3, -18],
        [1, -36],
        [-3, -10],
        [6, -33],
        [-1, -30],
        [-8, -45],
        [-22, -53],
        [-9, -37],
        [11, -23],
        [0, -35],
        [3, -24],
        [-3, -35],
        [-34, -25],
        [-60, -13],
        [-51, 9],
        [-20, -9],
        [-24, -3],
        [-8, -20],
        [-22, -3],
        [-18, -8],
        [-1, -8],
        [8, -5],
        [-9, -10],
        [-8, -2],
        [-5, -12],
        [-31, -4],
        [-4, -8],
        [-18, -2],
        [-16, -6],
        [-17, -28],
        [-14, -6],
        [-42, -99],
        [-38, -76],
        [-95, -73],
        [-48, -75],
        [-20, -54],
        [-10, -65],
        [40, -66],
        [36, -30],
        [30, -2],
        [77, -45],
        [70, -39],
        [47, -23],
        [28, -36],
        [21, -39],
        [28, -41],
        [0, -76],
        [11, -90],
        [26, -63],
        [32, -88],
        [51, -67],
        [28, -36],
        [49, -8],
        [58, -10],
        [43, 7],
        [33, 13],
        [27, -2],
        [22, -11],
        [20, -13],
        [9, -18],
        [6, -52],
        [23, -11],
        [52, 20],
        [36, 12],
        [33, 12],
        [30, 2],
        [22, -12],
        [10, -19],
        [6, -21],
        [8, -20],
        [-4, -43],
        [-1, -26],
        [32, -32],
        [48, -12],
        [60, 10],
        [41, 20],
        [38, 6],
        [43, -22],
        [36, -32],
        [21, -37],
        [20, -29],
        [19, -35],
        [26, -32],
        [39, -18],
        [40, -7],
        [32, -6],
        [27, -12],
        [21, -19],
        [10, -22],
        [8, -32],
        [6, -24],
        [8, -46],
        [-8, -81],
        [4, -53],
        [34, -75],
        [2, -71],
        [-23, -42],
        [-17, -46],
        [-12, -34],
        [2, -49],
        [18, -45],
        [31, -26],
        [13, -46],
        [29, -41],
        [8, -12],
        [6, -26],
        [-8, -27],
        [-29, -39],
        [-17, -48],
        [-25, -29],
        [-45, -61],
        [-30, -80],
        [-23, -70],
        [-12, -39],
        [-8, -50],
        [16, -31],
        [-2, -58],
        [-8, -45],
        [-27, -53],
        [-57, -49],
        [-13, -9],
        [-4, -27],
        [10, -68],
        [13, -46],
        [25, -20],
        [27, -48],
        [2, -33],
        [4, -18],
        [-7, -21],
        [-10, -10],
        [-3, -20],
        [1, -40],
        [10, -28],
        [17, -28],
        [25, -34],
        [16, -26],
        [13, -34],
        [32, -36],
        [22, -59],
        [14, -46],
        [24, -19],
        [9, -33],
        [-8, -23],
        [-12, -20],
        [-25, -14],
        [-10, -39],
        [-15, -78],
        [5, -72],
        [12, -15],
        [0, -75],
        [14, -71],
        [8, -53],
        [-26, -20],
        [-25, -36],
        [-16, -47],
        [-15, -52],
        [15, -76],
        [-2, -32],
        [-41, -14],
        [-39, 2],
        [-36, -36],
        [-53, -48],
        [-35, 18],
        [-24, -12],
        [-30, -19],
        [-4, -30],
        [-4, -44],
        [-99, -86],
        [-88, -89],
        [-81, -117],
        [-49, -73],
        [-40, -68],
        [3, -48],
        [0, -51],
        [19, -51],
        [28, -36],
        [8, -43],
        [0, -88],
        [17, -87],
        [26, -91],
        [64, -72],
        [76, -74],
        [82, -14],
        [42, -17],
        [32, -36],
        [55, -31],
        [31, -46],
        [37, -70],
        [34, -58],
        [40, -49],
        [-12, -54],
        [-8, -35],
        [-56, -32],
        [-15, -32],
        [1, -26],
        [-23, -36],
        [-2, -33],
        [-12, -69],
        [20, -63],
        [46, -73],
        [-1017, -620],
        [-1269, -1964],
        [-101, 26],
        [-119, 9],
        [-69, -18],
        [-61, -10],
        [-73, -1],
        [-63, -4],
        [-66, 1],
        [-40, -12],
        [-32, -5],
        [-46, 8],
        [-42, -10],
        [-48, 2],
        [-55, -13],
        [-42, -15],
        [-40, -35],
        [-20, -27],
        [-38, -36],
        [-37, -47],
        [-29, -53],
        [0, -75],
        [-20, -42],
        [-17, -54],
        [-20, -19],
        [-26, -10],
        [-71, -7],
        [-61, 6],
        [-56, 34],
        [-43, 34],
        [-23, 8],
        [-25, -12],
        [-11, -20],
        [-3, -34],
        [-18, -46],
        [-16, -44],
        [-35, -40],
        [-43, -9],
        [-25, -14],
        [-2, -32],
        [-88, -30],
        [-74, -4],
        [-33, -6],
        [-8, -30],
        [18, -58],
        [8, -44],
        [-12, -33],
        [-25, -32],
        [-28, -22],
        [-53, 8],
        [-37, 55],
        [-29, 59],
        [-20, 33],
        [-28, 34],
        [-26, 34],
        [-26, 52],
        [-17, 38],
        [-16, 21],
        [-21, 10],
        [-47, -6],
        [-66, -16],
        [-70, -28],
        [-58, -35],
        [-36, -40],
        [-15, -18],
        [-33, -30],
        [-8, -16],
        [16, -13],
        [13, -17],
        [-12, -35],
        [-14, -46],
        [4, -48],
        [-1, -43],
        [-33, -103],
        [-24, -60],
        [-40, -34],
        [-74, -23],
        [-79, 35],
        [-46, 20],
        [-47, 2],
        [-47, -24],
        [-71, -25],
        [-40, -8],
        [-29, -16],
        [-19, -88],
        [16, -73],
        [62, -62],
        [73, -49],
        [55, -28],
        [20, -20],
        [19, -43],
        [16, -42],
        [-10, -41],
        [-14, -41],
        [-25, -27],
        [-44, -10],
        [-54, -6],
        [-28, -28],
        [-20, -25],
        [-69, -30],
        [-78, -19],
        [-89, -11],
        [-82, 3],
        [-32, 19],
        [-50, -5],
        [-51, -20],
        [-61, 2],
        [-57, 19],
        [-49, -2],
        [-100, -37],
        [-72, -34],
        [-74, -48],
        [-47, -56],
        [-22, -74],
        [-28, -73],
        [-6, -48],
        [-29, -77],
        [-69, -73],
        [-73, -29],
        [-92, -10],
        [-77, 0],
        [-85, -8],
        [-62, -28],
        [-26, -37],
        [-56, -64],
        [-59, -56],
        [-65, -22],
        [-48, -22],
        [-25, -27],
        [-71, -21],
        [-69, -27],
        [-61, -29],
        [-69, -27],
        [-66, -40],
        [-66, -29],
        [-66, -28],
        [-74, -38],
        [-55, -42],
        [-45, -51],
        [-58, -50],
        [-31, -36],
        [-57, -81],
        [-25, -34],
        [-55, -80],
        [-60, -55],
        [-56, -33],
        [-46, -27],
        [-45, -18],
        [-46, -13],
        [-45, -4],
        [-63, 9],
        [-67, 14],
        [-49, -10],
        [-35, -39],
        [-28, -41],
        [-33, -26],
        [-48, -10],
        [-100, 23],
        [-94, 33],
        [-50, 54],
        [-16, 73],
        [-27, 45],
        [-28, 38],
        [-50, 55],
        [-51, 44],
        [-41, 16],
        [-35, -10],
        [-15, -14],
        [-53, -28],
        [-96, -40],
        [-63, -48],
        [-63, -43],
        [-88, -20],
        [-81, -19],
        [-82, -35],
        [-65, -73],
        [-44, -57],
        [-50, -78],
        [-19, -88],
        [-18, -70],
        [-56, -88],
        [-66, -37],
        [-77, 10],
        [-157, -16],
        [-109, -38],
        [-69, -37],
        [-70, -38],
        [-58, -22],
        [-91, -8],
        [-79, -14],
        [-78, -24],
        [-76, -16],
        [-88, -36],
        [-74, -37],
        [-60, -73],
        [-10, -56],
        [-18, -25],
        [-18, -17],
        [-20, -6],
        [-59, -12],
        [-44, -6],
        [-27, -29],
        [-49, -9],
        [-33, 16],
        [-26, -12],
        [-16, -51],
        [-12, -41],
        [-67, -55],
        [-14, -75],
        [-37, -75],
        [-31, -34],
        [-74, -52],
        [-104, -26],
        [-23, -6],
        [-66, -37],
        [-64, -49],
        [-44, -42],
        [-45, -50],
        [-36, -48],
        [-12, -59],
        [-35, -53],
        [-19, -41],
        [-12, -42],
        [-17, -39],
        [-48, -31],
        [-66, -20],
        [-54, -10],
        [-91, 14],
        [-58, 30],
        [-85, 11],
        [-28, 6],
        [-63, -2],
        [-42, -25],
        [-20, -34],
        [-69, -47],
        [-44, -28],
        [-90, -12],
        [-56, -34],
        [-29, -28],
        [-24, -43],
        [-9, -41],
        [23, -84],
        [20, -67],
        [20, -50],
        [153, -13],
        [41, -46],
        [-1, -96],
        [5, -102],
        [13, -65],
        [10, -65],
        [-11, -54],
        [-75, -11],
        [-103, -3],
        [-58, -15],
        [-23, -64],
        [-1, -2],
        [0, -2],
        [-57, -179],
        [-5, -30],
        [-6, -42],
        [4, -28],
        [-18, -72],
        [-25, -72],
        [-63, -90],
        [-64, -29],
        [-51, 36],
        [-23, 25],
        [-76, 22],
        [-55, -3],
        [-50, -1],
        [-45, 6],
        [-48, 14],
        [-59, 24],
        [-42, 19],
        [-45, -8],
        [-34, -23],
        [-26, -63],
        [-11, -94],
        [9, -114],
        [-4, -107],
        [17, -87],
        [59, -85],
        [83, -57],
        [116, -23],
        [52, -33],
        [84, -64],
        [26, -79],
        [45, -62],
        [35, -61],
        [20, -49],
        [24, -58],
        [-7, -93],
        [-14, -16],
      ],
      [
        [274602, 42191],
        [-652, 45],
        [-3596, -1126],
        [-249, -78],
        [-1842, -131],
        [-28, -2],
        [-3543, -252],
        [-5183, 148],
        [-411, 12],
        [-2696, -141],
        [-1065, -570],
        [-536, -286],
        [-294, 109],
        [12, 33],
        [-10, 11],
        [-5, 18],
        [-2, 2],
        [0, 26],
        [0, 23],
        [2, 20],
        [0, 61],
        [3, 19],
        [0, 16],
        [-3, 16],
        [-2, 9],
        [-2, 17],
        [-6, 13],
        [-12, 13],
        [-19, 2],
        [-7, 1],
        [-16, 0],
        [-30, 2],
        [-30, 13],
        [-7, 20],
        [7, 32],
        [16, 25],
        [14, 28],
        [0, 0],
        [25, 48],
        [24, 47],
        [16, 29],
        [14, 25],
        [3, 4],
        [8, 14],
        [11, 17],
        [6, 18],
        [-2, 24],
        [-19, 11],
        [-37, 6],
        [-5, -1],
        [-27, -1],
        [-25, -10],
        [-28, -19],
        [-10, -5],
        [-16, -7],
        [-16, -15],
        [-3, -3],
        [-22, -15],
        [-6, -2],
        [-23, -2],
        [-25, 11],
        [-8, 4],
        [-34, 22],
        [-14, 13],
        [-29, 29],
        [-21, 35],
        [-8, 40],
        [1, 17],
        [1, 13],
        [20, 52],
        [2, 24],
        [2, 34],
        [21, 56],
        [8, 17],
        [3, 8],
        [20, 46],
        [22, 50],
        [85, 161],
        [20, 50],
        [17, 52],
        [-10, 32],
        [-6, 5],
        [-13, 11],
        [-27, 6],
        [-25, -8],
        [-24, -22],
        [-24, -33],
        [-35, -31],
        [-42, -4],
        [-53, 16],
        [-50, 21],
        [-22, 14],
        [-27, 16],
        [-18, 17],
        [-12, 10],
        [-11, 26],
        [-10, 20],
        [4, 41],
        [19, 92],
        [-8, 54],
        [2, 35],
        [-5, 16],
        [-30, 4],
        [-19, -17],
        [-7, -15],
        [-9, -21],
        [-17, -32],
        [-37, -4],
        [-21, 2],
        [-54, 6],
        [-66, 10],
        [-25, 10],
        [-27, 10],
        [-37, 33],
        [-12, 30],
        [-6, 15],
        [0, 30],
        [0, 25],
        [13, 53],
        [20, 43],
        [22, 6],
        [17, -10],
        [22, -12],
        [57, -21],
        [44, -8],
        [40, -7],
        [30, 2],
        [22, 2],
        [34, 20],
        [38, 28],
        [17, 34],
        [8, 17],
        [0, 6],
        [-2, 27],
        [-15, 19],
        [-10, 12],
        [-38, 46],
        [-18, 30],
        [-8, 10],
        [-8, 37],
        [-19, 59],
        [-27, 45],
        [-6, 12],
        [-12, 24],
        [1, 21],
        [22, 14],
        [8, 4],
        [25, 8],
        [41, 22],
        [27, 12],
        [10, 6],
        [13, 24],
        [32, 99],
        [3, 34],
        [17, 19],
        [-2, 31],
        [-28, 32],
        [-36, 19],
        [-19, 4],
        [-15, 4],
        [-43, 3],
        [-17, 5],
        [-4, 1],
        [-14, 5],
        [-2, 0],
        [-33, 13],
        [-4, 3],
        [-18, 12],
        [-4, 28],
        [0, 5],
        [4, 12],
        [4, 20],
        [10, 13],
        [14, 22],
        [49, 22],
        [52, 8],
        [36, 18],
        [42, 35],
        [9, 25],
        [4, 39],
        [21, 41],
        [19, 42],
        [4, 8],
        [8, 18],
        [35, 73],
        [2, 22],
        [-16, 16],
        [-31, 30],
        [-73, 54],
        [-87, 60],
        [-16, 23],
        [-2, 0],
        [-17, 36],
        [0, 55],
        [12, 43],
        [29, 35],
        [24, 14],
        [53, 0],
        [44, 0],
        [13, -6],
        [17, -6],
        [43, -24],
        [36, -19],
        [31, 7],
        [5, 9],
        [7, 9],
        [3, 12],
        [2, 12],
        [6, 36],
        [-6, 36],
        [-17, 17],
        [-7, 7],
        [-30, 19],
        [-12, 4],
        [-6, 2],
        [-30, -6],
        [-6, 0],
        [-19, 0],
        [-18, 11],
        [-12, 30],
        [-13, 42],
        [-11, 30],
        [-10, 16],
        [-8, 14],
        [-12, 18],
        [-37, 31],
        [-22, 26],
        [-8, 10],
        [-18, 24],
        [-4, 23],
        [-46, 107],
        [-38, 70],
        [-25, 59],
        [2, 50],
        [15, 44],
        [8, 49],
        [-36, 94],
        [-4, 28],
        [-3, 29],
        [-20, 30],
        [-19, -5],
        [-25, -7],
        [-40, -27],
        [-22, -38],
        [-30, 6],
        [-54, 32],
        [-5, 21],
        [-12, 53],
        [-20, 34],
        [-16, 36],
        [10, 30],
        [22, 15],
        [44, 21],
        [4, 4],
        [21, 18],
        [14, 39],
        [-2, 33],
        [-34, 29],
        [-9, 6],
        [-76, 46],
        [-124, 64],
        [-65, 18],
        [-17, 6],
        [-20, 5],
        [-25, -2],
        [-17, -2],
        [-23, 16],
        [3, 36],
        [14, 13],
        [8, 8],
        [8, 30],
        [-14, 44],
        [-2, 7],
        [-64, 61],
        [-85, 56],
        [-52, 44],
        [-25, -4],
        [-22, -13],
        [-15, 4],
        [-4, 15],
        [-3, 10],
        [3, 32],
        [15, 26],
        [4, 6],
        [20, 20],
        [9, 24],
        [0, 22],
        [0, 43],
        [4, 46],
        [24, 35],
        [7, 77],
        [-28, 50],
        [-8, 52],
        [-20, 58],
        [0, 65],
        [4, 28],
        [10, 24],
        [6, 12],
        [4, 8],
        [42, 38],
        [16, 28],
        [13, 26],
        [12, 28],
        [2, 17],
        [2, 23],
        [2, 13],
        [2, 21],
        [-6, 24],
        [6, 56],
        [12, 44],
        [4, 9],
        [6, 14],
        [11, 28],
        [16, 24],
        [-5, 37],
        [-11, 19],
        [-9, 24],
        [-2, 5],
        [-8, 13],
        [-14, 29],
        [-20, 28],
        [-29, 13],
        [-32, 9],
        [-14, -2],
        [-18, -7],
        [-8, -3],
        [-8, 0],
        [-3, 0],
        [-5, -1],
        [-10, -1],
        [-20, 2],
        [-23, 17],
        [-7, 16],
        [-12, 15],
        [-18, 12],
        [-7, 19],
        [-6, 29],
        [4, 16],
        [13, 9],
        [4, 7],
        [8, 10],
        [4, 19],
        [4, 13],
        [2, 6],
        [-18, 23],
        [-16, 22],
        [-8, 26],
        [-3, 6],
        [0, 2],
        [-10, 13],
        [3, 26],
        [3, 21],
        [0, 15],
        [-2, 9],
        [-2, 8],
        [-17, 21],
        [-5, 12],
        [-2, 8],
        [-2, 8],
        [-1, 11],
        [-1, 12],
        [-1, 11],
        [-17, 15],
        [-21, 12],
        [-30, 13],
        [-22, 14],
        [-43, 21],
        [-13, 12],
        [-8, 9],
        [-12, 21],
        [0, 22],
        [14, 16],
        [26, 20],
        [38, 15],
        [18, -6],
        [24, 1],
        [26, 3],
        [23, 4],
        [23, 0],
        [13, -6],
        [23, 10],
        [22, 18],
        [18, 26],
        [16, 35],
        [11, 16],
        [10, 12],
        [8, 22],
        [-2, 12],
        [-1, 12],
        [-9, 26],
        [-6, 10],
        [-3, 4],
        [-3, 8],
        [-1, 2],
        [6, 7],
        [34, 11],
        [67, 8],
        [50, 1],
        [11, 4],
        [13, 5],
        [19, 16],
        [4, 13],
        [4, 16],
        [2, 18],
        [1, 14],
        [-7, 31],
        [-27, 36],
        [-8, 9],
        [-36, 34],
        [-35, 32],
        [-13, 20],
        [-4, 36],
        [-4, 32],
        [18, 28],
        [9, 10],
        [6, 6],
        [14, 16],
        [13, 19],
        [32, 48],
        [20, 31],
        [25, 47],
        [15, 61],
        [4, 61],
        [-7, 26],
        [-26, 30],
        [-37, 32],
        [-28, 18],
        [-37, 17],
        [-31, 8],
        [-19, 2],
        [-16, -2],
        [-9, -2],
        [-8, 0],
        [-15, -4],
        [-11, -2],
        [-29, -4],
        [-24, 4],
        [-25, 6],
        [-18, 10],
        [-10, 10],
        [-12, 10],
        [-17, 10],
        [-12, 6],
        [-14, 2],
        [-26, 2],
        [-23, 6],
        [-15, 15],
        [-12, 21],
        [-2, 19],
        [2, 17],
        [8, 16],
        [22, 25],
        [15, 6],
        [15, 12],
        [12, 9],
        [13, 0],
        [10, -9],
        [10, -12],
        [11, 0],
        [7, 12],
        [0, 14],
        [-10, 15],
        [-21, 21],
        [-20, 17],
        [-18, 8],
        [-19, 1],
        [-32, 0],
        [-1, 0],
        [-12, 4],
        [-14, 11],
        [-16, 28],
        [-2, 6],
        [-4, 11],
        [-6, 8],
        [1, 8],
        [7, 10],
        [10, 28],
        [4, 11],
        [2, 9],
        [6, 6],
        [8, 8],
        [2, 6],
        [0, 10],
        [-6, 14],
        [-6, 10],
        [-16, 12],
        [-14, 14],
        [0, 6],
        [-2, 9],
        [7, 11],
        [7, 5],
        [8, 18],
        [19, 8],
        [15, 18],
        [13, 22],
        [16, 26],
        [6, 10],
        [2, 8],
        [4, 12],
        [7, 23],
        [-4, 20],
        [-2, 9],
        [-9, 30],
        [-24, 20],
        [-9, 25],
        [-6, 5],
        [-2, 3],
        [-4, 23],
        [-8, -2],
        [-6, 0],
        [-30, -4],
        [-14, -4],
        [-17, -3],
        [-97, -23],
        [-13, 0],
        [-36, 9],
        [-5, 1],
        [-8, 19],
        [-21, 28],
        [-7, 7],
        [-8, 8],
        [-28, 13],
        [-26, 22],
        [-23, 10],
        [-6, 4],
        [-28, 4],
        [-27, -16],
        [-17, -39],
        [-10, -9],
        [-20, -18],
        [-11, -1],
        [-29, -5],
        [-45, -3],
        [-8, 0],
        [-43, 10],
        [-36, 18],
        [-22, 16],
        [-25, 21],
        [-19, 2],
        [-24, 2],
        [-24, -5],
        [-22, 5],
        [-18, 26],
        [-15, 35],
        [-10, 36],
        [-17, 20],
        [-37, 12],
        [-13, 1],
        [-21, 1],
        [-28, -4],
        [-6, 2],
        [-1, 1],
        [-23, 10],
        [-31, 39],
        [-56, 63],
        [-6, 19],
        [-14, 13],
        [-11, 4],
        [-8, 2],
        [-14, 0],
        [-11, -9],
        [-15, -15],
        [-3, -5],
        [-6, -12],
        [-31, -26],
        [-6, -4],
        [-23, -12],
        [-10, -4],
        [-15, -4],
        [-15, 4],
        [-10, 8],
        [-9, 6],
        [-15, 9],
        [-12, 15],
        [-8, 13],
        [-10, 9],
        [-8, 6],
        [-5, 1],
        [-13, 3],
        [-16, 0],
        [-19, 2],
        [-12, 1],
        [-14, 11],
        [2, 13],
        [4, 6],
        [8, 8],
        [13, 19],
        [16, 18],
        [5, 11],
        [3, 4],
        [1, 21],
        [-7, 24],
        [-35, 48],
        [-23, 26],
        [-23, 9],
        [-13, 1],
        [-14, 1],
        [-17, -9],
        [-14, -6],
        [-20, -10],
        [-19, -10],
        [-32, -4],
        [-18, 8],
        [-10, 20],
        [0, 9],
        [6, 13],
        [16, 10],
        [17, 14],
        [2, 1],
        [2, 9],
        [-1, 15],
        [-20, 12],
        [-12, 6],
        [-22, 14],
        [-12, 16],
        [-8, 12],
        [-7, 12],
        [-19, 18],
        [-3, 2],
        [-17, 2],
        [-18, -8],
        [-10, -22],
        [-8, -20],
        [-10, -6],
        [-7, -2],
        [-1, -8],
        [-3, -14],
        [13, -27],
        [10, -26],
        [8, -19],
        [4, -29],
        [-4, -16],
        [-16, -11],
        [-26, -1],
        [-31, 10],
        [-49, 16],
        [-38, 37],
        [-50, 45],
        [-4, 3],
        [-12, 10],
        [-12, 4],
        [-16, 6],
        [-29, 2],
        [-18, 0],
        [-8, -1],
        [-8, 0],
        [-20, 0],
        [-29, 7],
        [-23, 14],
        [-32, 28],
      ],
      [
        [250556, 49341],
        [-14, 24],
        [14, 46],
        [-6, 13],
        [-28, 5],
        [-19, 3],
        [-29, 7],
        [-23, 10],
        [-16, 12],
        [-36, 13],
        [-34, 14],
        [-30, 12],
        [-14, 13],
        [-24, 16],
        [-20, 12],
        [-16, 11],
        [-24, 19],
        [-24, 17],
        [-29, 28],
        [-37, 40],
        [-27, 31],
        [-18, 31],
        [2, 38],
        [10, 25],
        [12, 23],
        [10, 53],
        [-8, 32],
        [-8, 20],
        [-22, 2],
        [-18, 2],
        [-22, 14],
        [5, 31],
        [15, 26],
        [5, 24],
        [2, 25],
        [-13, 18],
        [-12, 14],
        [-28, 4],
        [-16, 8],
        [-17, 38],
        [0, 33],
        [9, 14],
        [24, 16],
        [12, 24],
        [-14, 28],
        [-6, 34],
        [10, 10],
        [16, 15],
        [8, 18],
        [-3, 40],
        [-2, 56],
        [13, 27],
        [19, 11],
        [25, 2],
        [8, 6],
        [4, 32],
        [12, 23],
        [6, 31],
        [8, 16],
        [-10, 11],
        [-68, 61],
        [-82, 12],
        [-40, -4],
        [-65, -14],
        [-44, -22],
        [-50, -6],
        [-38, 2],
        [-33, 24],
        [-54, 16],
        [-43, -12],
        [-37, -18],
        [-37, 16],
        [-41, 57],
        [-22, 72],
        [-36, 34],
        [-41, 50],
        [3, 50],
        [-40, 37],
        [-75, 63],
        [-30, 59],
        [-6, 62],
        [15, 64],
        [-4, 73],
        [-13, 37],
        [-51, 29],
        [-33, 54],
        [-81, 174],
        [-164, 59],
        [-75, -18],
        [-90, 66],
        [-69, 85],
        [-130, 34],
        [-118, -18],
        [-171, -7],
        [-89, 3],
        [-61, 38],
        [-157, -4],
        [-188, -92],
        [-66, -117],
        [-135, -44],
        [-145, 52],
        [-76, 34],
        [-74, 79],
        [-17, 8],
        [-48, 24],
        [-85, 4],
        [-118, -35],
        [-128, -23],
        [-164, -81],
        [-69, -18],
        [-1041, 270],
        [-110, 29],
        [-45, 11],
        [-1688, 403],
        [-128, -19],
        [-150, -146],
        [-81, -33],
        [-77, 0],
        [-73, -4],
        [-68, 18],
        [-66, -7],
        [-39, -35],
        [-55, -41],
        [-65, -1],
        [-58, 49],
        [-50, 19],
        [-73, -7],
        [-81, -37],
        [-51, -58],
        [-73, -83],
        [-77, -60],
        [-89, -55],
        [-78, -42],
        [-73, -27],
        [-50, 11],
        [-24, 18],
        [-55, -29],
        [-31, -35],
        [-25, 6],
        [-63, -33],
        [-56, -34],
        [-30, -59],
        [8, -42],
        [-11, -46],
        [-43, -48],
        [8, -36],
        [28, -40],
        [6, -20],
        [9, -23],
        [-20, -32],
        [-12, -24],
        [-37, -6],
        [-37, -17],
        [-27, -32],
        [-23, -119],
        [-52, -28],
        [-46, -31],
        [-43, -25],
        [-46, -35],
        [-18, -33],
        [24, -56],
        [-26, -44],
        [14, -33],
        [6, -34],
        [6, -39],
        [-28, -4],
        [-34, 6],
        [-25, -36],
        [-28, -20],
        [-43, -13],
        [-26, 12],
        [-46, 15],
        [-16, 19],
        [-22, 6],
        [-31, 8],
        [-28, -6],
        [-37, -6],
        [-22, -8],
        [-25, -15],
        [-20, -7],
        [-27, -9],
        [-28, -12],
        [-42, -6],
        [-37, -8],
        [-42, 6],
        [-21, -6],
        [-20, 0],
        [-25, 14],
        [-9, 17],
        [-9, 27],
        [-23, 17],
        [-22, -17],
        [-3, -28],
        [-14, -36],
        [-13, -20],
        [-2, -47],
        [4, -37],
        [6, -33],
        [3, -46],
        [-3, -6],
        [-22, 1],
        [-11, -7],
        [-17, -18],
        [-17, -22],
        [-35, -33],
        [-28, 8],
        [-26, 6],
        [-16, -8],
        [-17, -14],
        [-18, -8],
        [-31, -4],
        [-70, 0],
        [-47, 6],
        [-29, 22],
        [-22, 33],
        [-27, 24],
        [-53, 27],
        [-35, 47],
        [-30, 37],
        [-16, 45],
        [-10, 49],
        [-17, 31],
        [-34, 2],
        [-31, -4],
        [-28, 5],
        [-31, 1],
        [-45, 20],
        [-36, 34],
        [-50, 28],
        [-29, 32],
        [-40, 58],
        [-28, 41],
        [-17, 36],
        [-23, 27],
        [-25, 27],
        [-70, 38],
        [-17, -10],
        [-21, -7],
        [-14, 9],
        [-14, 21],
        [-18, 25],
        [-34, 20],
        [-23, 14],
        [-16, 8],
        [-29, -14],
        [-16, -8],
        [-26, -20],
        [-20, -27],
        [-14, -23],
        [4, -18],
        [4, -14],
        [12, -22],
        [4, -18],
        [35, -25],
        [9, -10],
        [-2, -13],
        [-11, -11],
        [-30, -4],
        [-41, -10],
        [-39, -5],
        [-45, 2],
        [-75, -19],
        [-17, -11],
        [-17, -15],
        [-14, -32],
        [-17, -16],
        [-15, -4],
        [-12, -4],
        [-19, 8],
        [-15, 8],
        [-23, 59],
        [0, 29],
        [4, 71],
        [14, 26],
        [33, 22],
        [16, 24],
        [32, 29],
        [12, 21],
        [2, 26],
        [-14, 17],
        [-31, 8],
        [-25, -7],
        [-35, -28],
        [-23, -24],
        [-29, -14],
        [-44, -16],
        [-26, 16],
        [-100, 16],
        [-37, 2],
        [-26, 16],
        [-15, 41],
        [-20, 61],
        [-38, 43],
        [-35, 12],
        [-54, 24],
        [-53, 38],
        [-34, -7],
        [-23, -17],
        [2, -22],
        [-19, -30],
        [-30, -21],
        [-30, -14],
        [-84, -26],
        [-34, -18],
        [-18, -22],
        [-37, -30],
        [-5, -4],
        [-63, -28],
        [-66, -2],
        [-70, 30],
        [-48, 24],
        [-31, 17],
        [-21, 37],
        [-27, 20],
        [-44, -8],
        [-21, -29],
        [-15, -39],
        [-34, -28],
        [-36, -25],
        [-40, -5],
        [-44, 42],
        [-25, 25],
        [-36, 34],
        [-16, 27],
        [-2, 45],
        [-28, 30],
        [-29, 49],
        [-4, 27],
        [-50, 50],
        [-23, 2],
        [-14, -16],
        [-10, -35],
        [-38, -21],
        [-33, -6],
        [-27, -2],
        [-19, 10],
        [-25, 44],
        [-19, 75],
        [-22, 38],
        [-42, 37],
        [-41, 8],
        [-56, 8],
        [-69, 12],
        [-33, 15],
        [-8, 29],
        [3, 18],
        [9, 25],
        [25, 28],
        [25, 18],
        [26, 8],
        [31, -12],
        [25, -10],
        [18, -4],
        [33, 2],
        [10, 2],
        [4, 4],
        [4, 14],
        [-6, 14],
        [-12, 25],
        [-21, 54],
        [-10, 60],
        [-27, 70],
        [-51, -5],
        [-32, 8],
        [-48, 25],
        [-56, 2],
        [-34, 9],
        [-62, 12],
        [-73, -1],
        [-90, -8],
        [-99, -28],
        [-74, -1],
        [-33, 16],
        [-15, 64],
        [8, 43],
        [37, 14],
        [13, 0],
        [20, 20],
        [17, 37],
        [-14, 51],
        [-38, 32],
        [-38, 7],
        [-67, 4],
        [-28, -31],
        [-32, -42],
        [-52, -52],
        [-81, -64],
        [-58, -34],
        [-44, -41],
        [-27, 4],
        [-24, 25],
        [-23, 48],
        [-19, 56],
        [-6, 31],
        [-33, 38],
        [-8, 11],
        [-57, -3],
        [-6, 26],
        [-4, 26],
        [-10, 18],
        [-7, 16],
        [-2, 14],
        [-2, 16],
        [-9, 22],
        [-15, 21],
        [-10, 16],
        [-28, 37],
        [-20, 20],
        [-19, 27],
        [-15, 23],
        [-8, 18],
        [-9, 15],
        [-9, 10],
        [-13, 12],
        [-7, 12],
        [-7, 12],
        [-30, 20],
        [-19, 21],
        [-17, 22],
        [-21, 8],
        [-25, 11],
        [-17, 15],
        [-20, 26],
        [-27, 18],
        [-18, 22],
        [-19, 20],
        [-31, 20],
        [-28, 14],
        [-20, 11],
        [-13, 3],
        [-39, 39],
        [-39, 50],
        [-60, 34],
        [-20, 45],
        [-22, 30],
        [-38, 43],
        [-80, 38],
        [-28, 38],
        [-50, 68],
        [-72, 36],
        [-61, 27],
        [-54, 46],
        [-50, 71],
        [-28, 59],
        [-8, 68],
        [8, 46],
        [-8, 71],
        [-10, 71],
        [-22, 43],
        [-18, 48],
        [3, 30],
        [0, 52],
        [9, 50],
        [2, 10],
        [10, 32],
        [41, 20],
        [42, 3],
        [41, 6],
        [24, 16],
        [29, 24],
        [38, 12],
        [40, 19],
        [48, 38],
        [32, 28],
        [34, 22],
        [43, 20],
        [31, 14],
        [42, 20],
        [17, 18],
        [27, 15],
        [22, 19],
        [6, 39],
        [-2, 32],
        [2, 39],
        [-24, 64],
        [-25, 69],
        [-16, 62],
        [-5, 44],
        [-19, 8],
        [-11, 21],
        [-10, 46],
        [-4, 77],
        [-6, 109],
        [-9, 61],
        [-8, 64],
        [9, 46],
        [28, 35],
        [34, 51],
        [36, 26],
        [36, 4],
        [34, 31],
        [35, 28],
        [31, 19],
        [43, 26],
        [38, 8],
        [6, 26],
        [11, 31],
        [19, 59],
        [9, 45],
        [-12, 36],
        [-13, 56],
        [-28, 51],
        [-17, 58],
        [-29, 22],
        [-65, 97],
        [-68, 90],
        [-50, 48],
        [-60, 85],
        [-14, 66],
        [-50, 69],
        [-51, 73],
        [-19, 52],
        [12, 32],
        [20, 36],
        [24, 14],
        [19, 29],
        [28, 4],
        [41, 22],
        [32, -3],
        [39, 8],
        [39, 18],
        [29, 43],
        [38, 4],
        [24, 26],
        [19, 12],
        [31, 43],
        [11, 70],
        [-17, 74],
        [-18, 76],
        [-23, 72],
        [-3, 84],
        [-4, 101],
        [19, 44],
        [11, 29],
        [9, 31],
        [26, 12],
        [19, 19],
        [-6, 26],
        [16, 35],
        [41, 5],
        [17, 20],
        [14, 26],
        [46, 62],
        [54, 37],
        [74, 13],
        [-4, 66],
        [-24, 99],
        [0, 108],
        [-10, 75],
        [-52, 67],
        [-61, 67],
        [-50, 68],
        [-29, 46],
        [-49, 69],
        [-23, 39],
        [-66, 81],
        [-5, 46],
        [21, 47],
        [36, 31],
        [46, 40],
        [63, 12],
        [21, 19],
        [31, 17],
        [31, 9],
        [48, 23],
        [54, 55],
        [25, 46],
        [8, 64],
        [-18, 43],
        [-33, 44],
        [-23, 44],
        [-27, 60],
        [-17, 40],
        [-8, 89],
        [8, 171],
        [-6, 139],
        [32, 113],
        [18, 111],
        [17, 101],
        [10, 73],
        [-25, 64],
        [-73, 56],
        [-49, 14],
        [-107, 35],
        [-147, -10],
        [-114, -31],
        [-46, 0],
        [-84, -2],
        [-100, 41],
        [-17, 59],
        [13, 71],
        [67, 116],
        [89, 81],
        [59, 42],
        [-15, 94],
        [-58, 62],
        [-40, 55],
        [-98, 88],
        [-60, 78],
        [-173, 169],
        [-45, 106],
        [-4, 71],
        [-8, 116],
        [-4, 62],
        [-16, 92],
        [-20, 63],
        [-4, 59],
        [17, 84],
        [25, 65],
        [46, 76],
        [61, 46],
        [71, 24],
        [57, 35],
        [29, 48],
        [-14, 33],
        [-38, 43],
        [-49, 35],
        [-52, 76],
        [-12, 41],
        [20, 60],
        [-1, 95],
        [9, 49],
        [60, 66],
        [24, 36],
        [28, 55],
        [20, 43],
        [-21, 69],
        [-106, 77],
        [-122, 73],
        [-48, -14],
        [-72, 8],
        [-78, 44],
        [-60, 42],
        [-85, 75],
        [-75, 46],
        [-43, 16],
        [-43, -12],
        [-50, -7],
        [-88, 9],
        [-62, 25],
        [-27, 30],
        [-43, 32],
        [-59, 56],
        [-46, 21],
        [-25, 36],
        [-40, 62],
        [-23, 51],
        [-12, 18],
        [-23, 18],
        [-17, 16],
        [-20, 10],
        [-35, -2],
        [-29, -8],
        [-24, -8],
        [-6, -34],
        [-8, -21],
        [30, -92],
        [67, -41],
        [15, -27],
        [0, -22],
        [-22, -19],
        [-23, -16],
        [-19, -12],
        [-16, -16],
        [-22, -12],
        [-47, -20],
        [-20, 25],
        [-28, 17],
        [-39, 10],
        [-50, -2],
        [-58, -10],
        [-48, -13],
        [-28, 1],
        [-26, -4],
        [-14, -4],
        [-23, -14],
        [-31, -28],
        [-48, -15],
        [-39, 1],
        [-50, 0],
        [-65, 34],
        [-25, 62],
        [-10, 61],
        [-14, 33],
        [-19, 52],
        [-51, 34],
        [-69, 16],
        [-54, -9],
        [-39, -9],
        [-39, -5],
        [-56, 2],
        [-97, 0],
        [-125, 2],
        [-40, 26],
        [-46, 31],
        [-56, 62],
        [-34, 62],
        [-38, 75],
        [-20, 43],
        [-16, 47],
        [-15, 34],
        [-27, 45],
        [-7, 45],
        [-43, 61],
        [-27, 62],
        [8, 46],
        [15, 61],
        [10, 55],
        [5, 51],
        [-26, 46],
        [-27, 15],
        [-30, 15],
        [-35, 14],
        [-38, 15],
        [-33, 27],
        [-37, 35],
        [-6, 28],
        [-4, 39],
        [23, 33],
        [24, 26],
        [36, 38],
        [58, 33],
        [24, 28],
        [36, 21],
        [43, 13],
        [28, 20],
        [42, 34],
        [26, 9],
        [28, 32],
        [23, 32],
        [18, 23],
        [3, 18],
        [0, 13],
        [-3, 17],
        [-14, 14],
        [-18, 6],
        [-12, 4],
        [-23, -5],
        [-28, 2],
        [-28, -16],
        [-32, -18],
        [-54, -45],
        [-9, -15],
        [-12, -16],
        [-4, -18],
        [-16, -18],
        [-22, -10],
        [-25, 6],
        [-34, 0],
        [-42, 15],
        [-58, 38],
        [-79, 28],
        [-61, 25],
        [-39, 12],
        [-67, 11],
        [-25, 6],
        [-18, 13],
        [-9, 5],
        [-14, 3],
        [-6, 11],
        [0, 18],
        [-2, 22],
        [12, 43],
        [12, 35],
        [16, 29],
        [32, 21],
        [47, 9],
        [45, 2],
        [41, 6],
        [62, -2],
        [53, -2],
        [24, -16],
        [18, -13],
        [40, -12],
        [25, 17],
        [6, 24],
        [10, 36],
        [-11, 49],
        [-12, 59],
        [-12, 38],
        [-4, 85],
        [0, 68],
        [4, 45],
        [-19, 70],
        [3, 61],
        [-7, 62],
        [-10, 43],
        [-17, 47],
        [-52, 81],
        [-65, 37],
        [-66, 44],
        [-65, 24],
        [-47, 28],
        [-65, 0],
        [-54, 18],
        [-24, 26],
        [6, 48],
        [9, 31],
        [34, 59],
        [51, 51],
        [28, 28],
        [-8, 50],
        [-30, 51],
        [-33, 41],
        [-33, 57],
        [-60, 45],
        [-50, 49],
        [0, 53],
        [15, 36],
        [31, 63],
        [35, 58],
        [45, 63],
        [72, 65],
        [89, 69],
        [100, 67],
        [21, 31],
        [49, 20],
        [46, 29],
        [3, 28],
        [-24, 22],
        [-40, 41],
        [-53, 19],
        [-73, -3],
        [-73, -27],
        [-65, -26],
        [-71, -36],
        [-22, -16],
        [-53, -20],
        [-50, 0],
        [-32, 1],
        [-31, 13],
        [-29, 26],
        [-9, 43],
        [-34, 67],
        [8, 73],
        [15, 86],
        [-11, 65],
        [-16, 92],
        [-8, 59],
        [-19, 65],
        [-39, 36],
        [-102, 59],
        [-59, 16],
        [-64, -6],
        [-59, -3],
        [-52, -19],
        [-47, -22],
        [-54, -1],
        [-39, -2],
        [-32, 1],
        [-29, 14],
        [-42, 26],
        [-19, 37],
        [-13, 35],
        [6, 44],
        [11, 45],
        [48, 38],
        [49, 15],
        [49, 35],
        [46, 61],
        [25, 74],
        [-14, 59],
        [-21, 48],
        [28, 127],
        [11, 48],
        [10, 79],
        [-6, 92],
        [-6, 44],
        [-9, 31],
        [-15, 29],
        [-24, 12],
        [-33, 16],
        [-48, 16],
        [-32, 8],
        [-39, 9],
        [-29, 21],
        [3, 22],
        [3, 22],
        [9, 14],
        [-4, 28],
        [-36, 32],
        [-114, 69],
        [-14, 12],
      ],
      [
        [230411, 68331],
        [-63, 61],
        [-51, 36],
        [-49, 29],
        [-57, 38],
        [-57, 39],
        [-46, 38],
        [-58, 18],
        [-69, 4],
        [-54, 6],
        [-34, 30],
        [-49, 38],
        [-39, 5],
        [-53, 17],
        [-58, 8],
        [-21, 18],
        [-8, 16],
        [-16, 25],
        [-3, 38],
        [6, 63],
        [8, 36],
        [18, 36],
        [18, 17],
        [24, 10],
        [20, 15],
        [36, 8],
        [35, -1],
        [26, -13],
        [24, -19],
        [17, -18],
        [39, -24],
        [29, -7],
        [44, -10],
        [44, -12],
        [62, -7],
        [10, 0],
        [275, 73],
        [50, 32],
        [44, 31],
        [15, 26],
        [7, 22],
        [-2, 20],
        [-18, 28],
        [-54, 29],
        [-39, 1],
        [-31, 14],
        [-31, 14],
        [-28, 15],
        [-20, 24],
        [-52, 66],
        [-27, 33],
        [-38, 52],
        [-21, 69],
        [11, 43],
        [13, 40],
        [27, 51],
        [22, 41],
        [20, 41],
        [37, 25],
        [23, 30],
        [45, 41],
        [41, 38],
        [18, 33],
        [12, 38],
        [28, 55],
        [21, 18],
        [35, 33],
        [40, 24],
        [43, 9],
        [19, 6],
        [23, 0],
        [34, -10],
        [26, -8],
        [40, -31],
        [24, -13],
        [29, -4],
        [33, 17],
        [11, 26],
        [8, 38],
        [-2, 44],
        [-2, 49],
        [-3, 56],
        [1, 40],
        [-3, 36],
        [7, 61],
        [14, 41],
        [14, 46],
        [22, 25],
        [22, 26],
        [27, 11],
        [14, 16],
        [7, 12],
        [8, 23],
        [8, 31],
        [12, 40],
        [-2, 31],
        [8, 32],
        [25, 53],
        [19, 21],
        [0, 16],
        [-12, 38],
        [-12, 51],
        [-18, 44],
        [-29, 32],
        [-42, 65],
        [10, 37],
        [16, 37],
        [19, 28],
        [34, 25],
        [38, 13],
        [26, 18],
        [28, 7],
        [68, 15],
        [21, 6],
        [60, 21],
        [42, 19],
        [34, 20],
        [21, 31],
        [18, 46],
        [24, 69],
        [26, 58],
        [8, 65],
        [27, 80],
        [25, 64],
        [31, 43],
        [31, 67],
        [18, 39],
        [2, 33],
        [-10, 26],
        [-17, 24],
        [-47, 43],
        [-44, 19],
        [-42, 16],
        [-26, 6],
        [-21, 8],
        [-14, 44],
        [-9, 41],
        [-14, 49],
        [-21, 37],
        [-30, 15],
        [-28, 8],
        [-42, 5],
        [-58, 39],
        [-41, 6],
        [-71, -10],
        [-78, -8],
        [-59, -16],
        [-61, 5],
        [-56, 16],
        [-94, 40],
        [-51, 14],
        [-62, 20],
        [-52, 14],
        [-112, -6],
        [-54, -24],
        [-62, -19],
        [-66, 6],
        [-40, 16],
        [-22, 29],
        [-31, 36],
        [-33, 28],
        [-65, 34],
        [-38, 0],
        [-57, 10],
        [-42, 0],
        [-40, 12],
        [-25, 5],
        [-54, 68],
        [-22, 22],
        [-2, 26],
        [-26, 54],
        [-12, 38],
        [-19, 48],
        [-2, 43],
        [0, 37],
        [2, 40],
        [30, 33],
        [36, 42],
        [33, 48],
        [27, 46],
        [11, 33],
        [9, 40],
        [8, 45],
        [-23, 45],
        [-52, 44],
        [-44, 24],
        [-57, 24],
        [-51, 16],
        [-106, 50],
        [-29, 32],
        [-47, 24],
        [-45, 13],
        [-68, 44],
        [-40, 19],
        [-41, 27],
        [-38, 21],
        [-28, 38],
        [5, 28],
        [-8, 35],
        [-5, 19],
        [5, 36],
        [3, 25],
        [10, 39],
        [22, 30],
        [29, 26],
        [36, 22],
        [22, 14],
        [22, 10],
        [10, 10],
        [9, 16],
        [14, 2],
        [24, 4],
        [33, 44],
        [20, 35],
        [46, 58],
        [11, 12],
        [56, 9],
        [41, 15],
        [17, 3],
        [8, 22],
        [25, -9],
        [41, -6],
        [26, 0],
        [17, 10],
        [9, 18],
        [16, 28],
        [25, 24],
        [0, 26],
        [0, 33],
        [-15, 51],
        [-18, 41],
        [2, 26],
        [12, 28],
        [8, 24],
        [9, 36],
        [16, 20],
        [22, 28],
        [36, 13],
        [25, 11],
        [50, 11],
        [97, 54],
        [15, 13],
        [14, 24],
        [16, 23],
        [7, 41],
        [-27, 47],
        [-40, 36],
        [-43, 12],
        [-26, 33],
        [-23, 47],
        [-33, 88],
        [-26, 97],
        [6, 40],
        [22, 74],
        [6, 30],
        [8, 39],
        [29, 58],
        [6, 30],
        [19, 36],
        [51, 51],
        [27, 32],
        [23, 26],
        [37, 32],
        [20, 27],
        [20, 29],
        [3, 8],
        [8, 25],
        [-8, 27],
        [-21, 29],
        [-21, 25],
        [-26, 26],
        [-44, 36],
        [-55, 39],
        [-43, 35],
        [-34, 27],
        [-13, 20],
        [-1, 34],
        [-11, 50],
        [2, 26],
        [-21, 35],
        [-25, 26],
        [-26, 15],
        [-29, 27],
        [-16, 22],
        [-27, 11],
        [-38, 4],
        [-19, -6],
        [-28, 6],
        [-48, 4],
        [-28, 11],
        [-32, 0],
        [-20, -13],
        [-29, -13],
        [-33, 20],
        [-29, 16],
        [-25, 34],
        [-8, 30],
        [-47, 33],
        [-30, 12],
        [-44, 19],
        [-39, 18],
        [-35, 11],
        [-32, 5],
        [-23, 25],
        [-10, 28],
        [-2, 49],
        [-2, 33],
        [-4, 37],
        [-4, 48],
        [-25, 42],
        [-40, 25],
        [-41, 16],
        [-43, 0],
        [-35, 2],
        [-16, 14],
        [-23, 47],
        [-25, 50],
        [-39, 38],
        [-52, 22],
        [-79, 27],
        [-59, 20],
        [-51, 33],
        [4, 27],
        [12, 28],
        [12, 39],
        [-16, 49],
        [-29, 29],
        [-45, 37],
        [-42, 46],
        [-24, 35],
        [-9, 42],
        [3, 42],
        [-15, 66],
        [-13, 10],
        [-23, 7],
        [-21, 7],
        [-46, 13],
        [-43, 4],
        [-28, 0],
        [-25, 2],
        [-47, 6],
        [-22, 8],
        [-44, 15],
        [-30, 21],
        [-17, 20],
        [-12, 20],
        [-11, 15],
        [-16, 0],
        [-19, -1],
        [-21, 7],
        [-44, -3],
        [-50, -12],
        [-26, 11],
        [-18, 30],
        [-3, 16],
        [0, 13],
        [1, 36],
        [4, 123],
        [-2, 110],
        [16, 80],
        [0, 35],
        [12, 29],
        [19, 40],
        [21, 36],
        [31, 53],
        [16, 44],
        [36, 61],
        [17, 47],
        [33, 60],
        [18, 27],
        [6, 19],
        [5, 12],
        [-17, 21],
        [-12, 2],
        [-16, 8],
        [-7, 16],
        [-2, 17],
        [6, 17],
        [-2, 25],
        [-2, 49],
        [-5, 34],
        [2, 37],
        [-8, 36],
        [7, 36],
        [1, 44],
        [5, 56],
        [10, 80],
        [15, 30],
        [0, 29],
        [2, 21],
        [4, 14],
        [8, 23],
        [-4, 29],
        [-4, 26],
        [-6, 14],
        [-13, 25],
        [-2, 13],
        [-7, 8],
        [-10, 4],
        [-16, 4],
        [-19, 0],
        [-19, 10],
        [-24, -4],
        [-26, 6],
        [-15, 12],
        [-11, 12],
        [-7, 36],
        [-8, 27],
        [3, 37],
        [-5, 25],
        [-2, 22],
        [15, 25],
        [10, 33],
        [16, 21],
        [2, 28],
        [16, 37],
        [6, 27],
        [-2, 25],
        [-19, 27],
        [-8, 24],
        [-4, 32],
        [-8, 26],
        [-13, 33],
        [-17, 31],
        [-20, 35],
        [-20, 24],
        [-22, 13],
        [-31, 36],
        [-35, 30],
        [-28, 19],
        [-22, 24],
        [-31, 28],
        [-17, 24],
        [-16, 21],
        [-11, 23],
        [-13, 8],
        [-28, 14],
        [-33, 10],
        [-33, 14],
        [-26, 16],
        [-33, 16],
        [-31, 18],
        [-27, 20],
        [-59, 57],
        [-25, 40],
        [-5, 42],
        [-3, 40],
        [-6, 28],
        [3, 20],
        [26, 29],
        [28, 21],
        [20, 40],
        [6, 29],
        [-17, 36],
        [-17, 41],
        [-22, 22],
        [-16, 29],
        [-10, 31],
        [4, 34],
        [9, 27],
        [19, 56],
        [31, 23],
        [26, 37],
        [14, 27],
        [7, 30],
        [-4, 36],
        [-4, 20],
        [-24, 13],
        [-22, 17],
        [-30, 18],
        [-5, 32],
        [2, 17],
        [-4, 22],
        [2, 22],
        [11, 26],
        [8, 25],
        [-8, 26],
        [-13, 21],
        [-17, 33],
        [-42, 59],
        [-18, 21],
        [-16, 4],
        [-17, 0],
        [-29, -11],
        [-24, -5],
        [-22, 1],
        [-16, 6],
        [-23, 18],
        [-11, 17],
        [9, 16],
        [11, 16],
        [10, 21],
        [-2, 32],
        [-8, 31],
        [-10, 26],
        [-3, 26],
        [-12, 24],
        [-13, 4],
        [-25, -8],
        [-19, -16],
        [-19, 8],
        [-22, 14],
        [-12, 11],
        [-17, 11],
        [-20, 33],
        [-29, 52],
        [-50, 87],
        [-15, 17],
        [-13, 7],
        [-15, -1],
        [-24, -5],
        [-22, -5],
        [-18, 1],
        [-14, 23],
        [-4, 12],
        [-8, 25],
        [-6, 26],
        [-10, 30],
        [-9, 23],
        [-17, 19],
        [-16, 22],
        [-17, 8],
        [-38, 18],
        [-32, 25],
        [-26, 4],
        [-26, 0],
        [-19, 13],
        [-16, 15],
        [-20, 6],
        [-36, -6],
        [-11, 19],
        [-15, 18],
        [-11, 11],
        [-18, 15],
        [-19, 9],
        [-19, 0],
        [-19, -2],
        [-27, 4],
        [-16, 20],
        [-2, 12],
        [8, 16],
        [14, 15],
        [22, 27],
        [12, 25],
        [14, 35],
        [9, 30],
        [6, 56],
        [13, 36],
        [-20, 34],
        [-13, 30],
        [-17, 26],
        [-15, 26],
        [-27, 11],
        [-34, 18],
        [-33, 18],
        [-16, 8],
        [-22, 24],
        [-144, 157],
        [-23, 4],
        [-24, -2],
        [-15, -13],
        [-15, -17],
        [-16, -14],
        [-28, -6],
        [-50, 8],
        [-23, 0],
        [-27, 8],
        [-13, 12],
        [-20, 26],
        [-9, 21],
        [-16, 28],
        [0, 24],
        [-8, 12],
        [-18, 13],
        [-8, -2],
      ],
      [
        [225658, 82454],
        [44, 26],
        [17, 62],
        [30, 38],
        [37, 2],
        [10, 21],
        [10, 35],
        [23, 20],
        [-11, 33],
        [-28, 40],
        [2, 43],
        [43, 46],
        [47, 20],
        [25, 37],
        [-17, 47],
        [9, 44],
        [-39, 54],
        [-83, 153],
        [31, 22],
        [-12, 39],
        [-10, 28],
        [-11, 26],
        [13, 32],
        [4, 35],
        [4, 23],
        [-55, 46],
        [1, 17],
        [37, 57],
        [-24, 46],
        [7, 26],
        [-64, 52],
        [-8, 45],
        [-10, 62],
        [22, 78],
        [21, 53],
        [-2, 76],
        [17, 36],
        [20, 34],
        [50, 44],
        [26, 46],
        [-6, 85],
        [34, 4],
        [24, 25],
        [13, 38],
        [0, 60],
        [-26, 53],
        [-18, 54],
        [-32, 56],
        [-56, 123],
        [-7, 133],
        [22, 68],
        [2, 52],
        [-4, 46],
        [-15, 28],
        [-21, 25],
        [-28, 39],
        [-52, 42],
        [-42, 63],
        [-39, 86],
        [-44, 82],
        [-2, 60],
        [-20, 69],
        [-12, 68],
        [12, 89],
        [29, 97],
        [7, 130],
        [32, 135],
        [76, 59],
        [66, 46],
        [29, 61],
        [83, 61],
        [75, 68],
        [55, 78],
        [9, 39],
        [-29, 19],
        [18, 71],
        [-67, 22],
        [-20, 4],
        [-27, 43],
        [-27, 39],
        [-47, 46],
        [-4, 8],
        [-20, 35],
        [-25, 36],
        [-22, 26],
        [-31, 25],
        [-17, 21],
        [-28, 28],
        [-29, 17],
        [-25, 18],
        [-1, 24],
        [16, 7],
        [4, 13],
        [-10, 18],
        [-21, 12],
        [-27, 14],
        [257, 111],
        [990, 592],
        [1085, 317],
        [1312, 1131],
        [400, 1735],
        [-29, 712],
        [10, 64],
        [15, 331],
        [244, 922],
        [-66, 636],
        [-39, 387],
        [-55, 250],
        [-574, 570],
        [344, 1310],
        [1319, 735],
        [359, -560],
        [102, 78],
        [84, 113],
        [42, 40],
        [-335, 902],
        [392, 1843],
        [47, 372],
        [583, 4641],
        [-100, 518],
        [2461, 1222],
        [5040, 2497],
      ],
      [
        [239427, 108335],
        [6175, -2751],
        [-221, -964],
        [1620, 268],
        [1138, -616],
        [3143, -3159],
        [447, 152],
        [1047, 26],
        [293, -6],
        [1099, 69],
        [706, 42],
        [1, 189],
        [6, 634],
        [354, 35],
        [250, -543],
        [1015, 321],
        [380, 121],
        [57, -755],
        [2, -70],
        [9, -109],
        [1, -100],
        [0, -109],
        [436, -512],
        [44, -34],
        [16, -24],
        [23, -30],
        [21, -14],
        [19, -20],
        [26, -17],
        [33, -8],
        [1, 0],
        [35, -3],
        [49, 0],
        [47, 3],
        [26, -3],
        [42, -31],
        [33, -27],
        [42, 15],
        [36, -53],
        [20, -20],
        [348, -331],
        [-126, -72],
        [-24, -87],
        [126, -169],
        [1169, -687],
        [-642, -1589],
        [18, -639],
        [37, -2],
        [789, -1829],
        [215, -105],
        [440, -293],
        [-20, -74],
        [-2318, -4519],
        [-163, -126],
        [589, -4422],
        [43, -322],
        [-636, 259],
        [-223, -24],
        [-10, -186],
        [-7, -106],
        [27, -91],
        [62, -61],
        [44, -34],
        [54, -22],
        [122, -4],
        [509, -370],
        [272, -265],
        [63, -546],
        [-173, -212],
        [-76, -139],
        [-32, -841],
        [-540, -167],
        [8, -218],
        [-15, -33],
        [-89, -75],
        [-73, -174],
        [138, -581],
        [107, -44],
        [986, 206],
        [423, -353],
        [171, -30],
        [250, -298],
        [25, 16],
        [55, 36],
        [74, 48],
        [43, 55],
        [8, 38],
        [8, 90],
        [-8, 55],
        [-43, 65],
        [39, 62],
        [20, 77],
        [10, 95],
        [4, 44],
        [65, 27],
        [40, 41],
        [44, 44],
        [30, 56],
        [-12, 37],
        [-12, 44],
        [-17, 56],
        [-20, 54],
        [-57, 36],
        [2, 35],
        [-19, 72],
        [9, 42],
        [4, 59],
        [10, 31],
        [34, 27],
        [44, 10],
        [111, 79],
        [34, 12],
        [73, 12],
        [43, 28],
        [84, 7],
        [77, 17],
        [44, 27],
        [67, -19],
        [49, 12],
        [108, -22],
        [83, 41],
        [54, 50],
        [50, 8],
        [28, 24],
        [39, 4],
        [59, 30],
        [27, 18],
        [98, -21],
        [55, 1],
        [58, 58],
        [60, 12],
        [20, -8],
        [47, -35],
        [90, -16],
        [63, 29],
        [13, 95],
        [-5, 45],
        [-30, 48],
        [-8, 51],
        [12, 44],
        [23, 38],
        [76, -18],
        [46, -39],
        [94, 27],
        [121, -71],
        [156, -50],
        [62, -24],
        [7, -57],
        [-9, -75],
        [7, -108],
        [10, -80],
        [10, -67],
        [49, -17],
        [30, 62],
        [55, 40],
        [52, 34],
        [93, 44],
        [46, 6],
        [32, -2],
        [27, -14],
        [22, -40],
        [-7, -40],
        [-52, -26],
        [-30, -3],
        [-71, -10],
        [-69, -36],
        [-92, -71],
        [81, -53],
        [115, -18],
        [202, -49],
        [85, -39],
        [56, -38],
        [46, -42],
        [24, -46],
        [0, -49],
        [-26, -60],
        [-43, -44],
        [-44, -22],
        [-39, -61],
        [-30, -116],
        [-12, -64],
        [-15, -91],
        [-16, -88],
        [-33, -57],
        [-71, -72],
        [-12, -95],
        [10, -67],
        [34, -52],
        [63, -59],
        [68, -31],
        [73, -15],
        [39, 7],
        [65, -23],
        [41, 21],
        [47, -4],
        [50, -11],
        [35, -22],
        [-21, -86],
        [19, -42],
        [-29, -56],
        [-16, -60],
        [36, -47],
        [63, -18],
        [70, -92],
        [40, -55],
        [2, -67],
        [16, -57],
        [55, -16],
        [60, -16],
        [66, -24],
        [46, -15],
        [54, -21],
        [49, -8],
        [41, -10],
        [61, -16],
        [42, -4],
        [53, -14],
        [69, -28],
        [104, -57],
        [90, -18],
        [34, -94],
        [74, -96],
        [58, -61],
        [89, -33],
        [62, -95],
        [-7, -122],
        [69, -40],
        [63, 29],
        [65, 0],
        [59, 12],
        [73, 5],
        [96, -9],
        [95, 57],
        [59, 67],
        [72, 31],
        [89, 33],
        [16, 24],
        [-11, 58],
        [4, 59],
        [42, 60],
        [69, 36],
        [56, -2],
        [45, -17],
        [51, 9],
        [48, 55],
        [49, 49],
        [51, 7],
        [33, -3],
        [34, 17],
        [27, 19],
        [36, 6],
        [30, 25],
        [7, 43],
        [11, 30],
        [16, 38],
        [38, 22],
        [55, 45],
        [46, 49],
        [41, 44],
        [43, 35],
        [62, 10],
        [41, 45],
        [20, 91],
        [19, 96],
        [-29, 86],
        [-16, 62],
        [22, 31],
        [-37, 109],
        [13, 84],
        [11, 103],
        [23, 57],
        [9, 55],
        [-17, 82],
        [-10, 80],
        [-4, 52],
        [-12, 29],
        [-39, 50],
        [-13, 52],
        [-25, 44],
        [12, 65],
        [28, 50],
        [51, 76],
        [19, 98],
        [16, 93],
        [2265, -1209],
        [2535, -1272],
        [67, -58],
        [3709, -1941],
        [104, -54],
        [1359, 799],
        [4764, 1694],
        [1601, 283],
        [1563, 280],
        [-688, -3364],
        [1383, -997],
        [980, -139],
        [-553, -5005],
        [1368, -499],
      ],
      [
        [247734, 203365],
        [1238, 1034],
        [787, 487],
        [1337, -1230],
        [-9, -12],
        [-24, -21],
        [-25, -21],
        [-33, -33],
        [-36, -45],
        [-21, -13],
        [-16, 1],
        [-12, 14],
        [-13, 8],
        [-16, 0],
        [-28, -9],
        [-56, -27],
        [-38, -9],
        [-10, -6],
        [0, -12],
        [27, -31],
        [20, -10],
        [27, -10],
        [20, -4],
        [17, -12],
        [21, -20],
        [54, -38],
        [44, -54],
        [18, -21],
        [18, -22],
        [11, -14],
        [8, -12],
        [16, -18],
        [38, -22],
        [32, -15],
        [23, -8],
        [35, -10],
        [26, -17],
        [20, -2],
        [4, -4],
        [-1, -6],
        [-25, -12],
        [-42, -20],
        [-28, -18],
        [-65, -18],
        [-20, -5],
        [-3, -9],
        [-1, -19],
        [44, -46],
        [35, -20],
        [27, -4],
        [5, -8],
        [-1, -8],
        [-22, -24],
        [-36, -34],
        [-16, -8],
        [-16, 0],
        [-4, -8],
        [6, -11],
        [14, -22],
        [14, -6],
        [29, 2],
        [32, 2],
        [12, -4],
        [12, -16],
        [19, -12],
        [28, 0],
        [21, 12],
        [32, 8],
        [16, 6],
        [42, -10],
        [27, 28],
        [0, 8],
        [27, 12],
        [37, 2],
        [-6, -20],
        [4, -2],
        [53, 4],
        [2, -2],
        [20, -20],
        [22, 6],
        [44, -48],
        [10, -34],
        [19, -58],
        [-17, -42],
        [19, -24],
        [16, -25],
        [10, -28],
        [1, -17],
        [-1, -22],
        [4, -50],
        [15, -23],
        [20, -28],
        [30, -36],
        [32, -36],
        [22, -27],
        [19, -33],
        [13, -11],
        [68, -57],
        [74, -57],
        [40, -48],
        [10, -35],
        [17, -35],
        [28, -41],
        [24, -35],
        [6, -31],
        [8, -18],
        [21, -34],
        [24, -28],
        [16, -17],
        [18, -31],
        [8, -30],
        [-24, -24],
        [-22, -19],
        [-20, -3],
        [-24, -2],
        [-23, -14],
        [-22, -2],
        [-6, -26],
        [-18, -41],
        [-21, -19],
        [-29, -5],
        [-2, -15],
        [26, -21],
        [1, -28],
        [9, -18],
        [16, -14],
        [39, -20],
        [1, -8],
        [-18, -21],
        [-10, -26],
        [8, -28],
        [8, -24],
        [2, -22],
        [12, -20],
        [30, -25],
        [14, -19],
        [11, -14],
        [0, -12],
        [-15, -6],
        [-34, -17],
        [-24, -19],
        [-6, -26],
        [4, -19],
        [11, -13],
        [21, -16],
        [23, -19],
        [13, -11],
        [4, -13],
        [-1, -5],
        [-9, -2],
        [-14, 7],
        [-13, -1],
        [-28, -8],
        [-27, -10],
        [-33, -29],
        [-13, -9],
        [6, -69],
        [1, -3],
        [3, -23],
        [3, -20],
        [4, -26],
        [4, -41],
        [9, -36],
        [0, -16],
        [7, -20],
        [3, -21],
        [22, -57],
        [20, -10],
        [14, -14],
        [13, -15],
        [5, -9],
        [2, -14],
        [10, -30],
        [6, -18],
        [4, -11],
        [3, -9],
        [0, -7],
        [-1, -10],
        [1, -9],
        [4, -14],
        [6, -19],
        [8, -10],
        [14, -20],
        [21, -18],
        [5, -8],
        [0, -8],
        [0, -11],
        [6, -20],
        [2, -9],
        [0, -5],
        [-3, -8],
        [-5, -18],
        [-4, -19],
        [-6, -10],
        [0, -11],
        [0, -12],
        [1, -5],
        [-5, -5],
        [-5, -6],
        [-4, -16],
        [-2, -24],
        [-1, -20],
        [1, -20],
        [-1, -17],
        [-2, -12],
        [-2, -15],
        [2, -13],
        [0, -27],
        [2, -10],
        [5, -19],
        [4, -23],
        [3, -14],
        [1, -28],
        [5, -20],
        [8, -16],
        [10, -16],
        [7, -16],
        [7, -15],
        [7, -9],
        [4, -12],
        [3, -7],
        [3, -14],
        [5, -12],
        [8, -14],
        [2, -10],
        [-7, -17],
        [-11, -18],
        [3, -15],
        [8, -17],
        [24, -17],
        [8, -17],
        [-2, -15],
        [-8, -8],
        [-9, -7],
        [-4, -3],
        [-46, -25],
        [-16, -13],
        [-3, -9],
        [0, -7],
        [9, -5],
        [22, -10],
        [11, -15],
        [23, -35],
        [29, -51],
        [19, -26],
        [28, -21],
        [7, -14],
        [12, -28],
        [19, -10],
        [36, -19],
        [41, -14],
        [21, -9],
        [31, -2],
        [9, -8],
        [0, -8],
        [-4, -12],
        [-11, -10],
        [2, -10],
        [6, -9],
        [11, -5],
        [61, 1],
        [22, -1],
        [11, -3],
        [15, -6],
        [-4, -9],
        [-10, -13],
        [-14, -27],
        [2, -20],
        [6, -14],
        [30, -8],
        [118, 2],
        [17, -5],
        [8, -19],
        [8, -39],
        [2, -20],
        [2, -4],
        [19, -8],
        [23, 6],
        [11, 2],
        [12, 2],
        [71, -16],
        [23, 8],
        [30, 12],
        [33, -14],
        [16, -25],
        [14, -36],
        [48, -34],
        [45, -20],
        [191, -28],
        [146, 18],
        [93, 6],
        [76, 14],
        [96, 31],
        [97, -91],
        [6, -71],
        [322, -48],
        [88, 18],
        [44, 99],
        [275, 771],
        [-28, 45],
        [9, 69],
        [-118, 218],
        [173, 28],
        [64, 189],
        [-73, 155],
        [-319, 120],
        [-2, 111],
        [217, 584],
        [113, 50],
        [97, -101],
        [414, -52],
        [158, 107],
        [141, 99],
        [330, 155],
        [197, 12],
        [579, 406],
        [41, 45],
        [154, 122],
        [52, -8],
        [2, 1],
        [82, 45],
        [13, -31],
        [6, 1],
        [28, -7],
        [55, 4],
        [23, 1],
        [16, 3],
        [-3, 12],
        [40, 4],
        [46, -4],
        [29, 9],
        [24, 22],
        [27, 37],
        [42, 18],
        [55, 0],
        [43, -1],
        [37, -7],
        [36, 10],
        [34, 19],
        [20, 16],
        [16, 11],
        [15, 10],
        [19, 14],
        [16, 10],
        [22, 14],
        [50, 22],
        [37, 13],
        [14, 4],
        [10, 1],
        [9, 0],
        [13, -3],
        [17, -6],
        [20, -7],
        [13, -2],
        [12, 4],
        [12, 7],
        [5, 13],
        [4, 15],
        [3, 7],
        [6, 2],
        [4, 1],
        [5, -2],
        [7, -4],
        [11, -5],
        [13, -2],
        [15, 0],
        [26, 2],
        [21, 0],
        [23, -2],
        [32, -10],
        [21, -11],
        [26, -13],
        [8, -6],
        [11, -6],
        [15, -8],
        [18, -12],
        [87, -52],
        [85, -58],
        [21, -10],
        [19, -6],
        [20, -11],
        [14, -12],
        [22, -19],
        [39, -19],
        [11, -6],
        [16, -3],
        [18, -6],
        [12, -5],
        [12, -9],
        [13, -9],
        [8, -8],
        [18, -13],
        [28, -26],
        [15, -19],
        [21, -16],
        [9, -9],
        [13, -10],
        [26, -22],
        [9, -9],
        [10, -10],
        [5, -4],
        [16, -16],
        [-2, -18],
        [16, 10],
        [10, 10],
        [3, 7],
        [19, 11],
        [2, 7],
        [7, 16],
        [6, 15],
        [4, 3],
        [3, 0],
        [7, -2],
        [5, 0],
        [6, 2],
        [12, 9],
        [12, 6],
        [6, 0],
        [6, 0],
        [6, -4],
        [6, -7],
        [8, -5],
        [7, 0],
        [6, 0],
        [11, 13],
        [6, 13],
        [5, 8],
        [4, 6],
        [6, 8],
        [6, 17],
        [6, 10],
        [8, 4],
        [8, 3],
        [12, 4],
        [11, 3],
        [10, 7],
        [8, 28],
        [6, 12],
        [4, 9],
        [4, 6],
        [7, 7],
        [6, 4],
        [6, 4],
        [8, 6],
        [8, 6],
        [13, 6],
        [13, 6],
        [12, 4],
        [32, 6],
        [9, -4],
        [0, 7],
        [30, 6],
        [47, -49],
        [41, -49],
        [0, -1],
        [-10, -31],
        [14, -65],
        [21, -9],
        [57, -69],
        [-3, -14],
        [-37, -14],
        [-17, -25],
        [-7, -14],
        [-8, -8],
        [-8, -29],
        [-14, -34],
        [0, -24],
        [-4, -29],
        [80, -106],
        [70, -38],
        [113, -28],
        [76, -8],
        [41, -6],
        [80, -77],
        [46, -94],
        [75, -97],
        [108, -90],
        [89, -23],
        [132, -4],
        [95, -12],
        [131, -33],
        [90, -23],
        [90, -21],
        [79, -18],
        [69, 19],
        [55, 25],
        [35, 21],
        [53, 12],
        [96, -146],
        [84, -102],
        [82, -104],
        [84, -66],
        [131, -57],
        [87, -33],
        [64, -99],
        [95, -57],
        [79, -20],
        [63, 12],
        [99, 14],
        [98, -54],
        [130, -23],
        [115, -13],
        [82, 4],
        [64, 10],
        [100, -31],
        [135, 12],
        [128, -3],
        [88, 36],
        [83, 20],
        [90, 6],
        [61, 16],
        [55, 32],
        [393, -1275],
        [1739, -2685],
        [915, -614],
        [702, -4501],
        [563, -188],
        [-554, -80],
        [-170, -63],
        [-30, -131],
        [116, -147],
        [15, -33],
        [172, -204],
        [-182, 54],
        [-793, -1266],
        [597, -324],
        [187, -270],
        [91, -133],
        [15, -248],
        [28, -441],
        [697, 237],
        [455, -36],
        [65, -4],
        [152, -11],
        [179, -14],
        [120, -9],
        [67, 68],
        [143, 151],
        [162, 168],
        [200, 211],
        [1419, -2160],
        [1170, -154],
        [1773, -255],
        [-704, -1480],
        [-1666, -47],
        [-961, -1398],
        [-2101, 824],
        [-329, -351],
        [154, -642],
        [98, -415],
        [150, -618],
        [58, -239],
        [-116, -212],
        [-55, -103],
        [-27, -49],
        [-282, 197],
        [-104, -168],
        [-4, -6],
        [-102, -165],
        [-99, -160],
        [-110, -176],
        [-93, -152],
        [-108, -173],
        [-249, 139],
        [-18, 12],
        [-5, 4],
        [-124, 87],
        [-204, -338],
        [-6, -11],
        [-92, 55],
        [-38, 23],
        [-182, 110],
        [-97, 56],
        [-121, 74],
        [-172, -279],
        [-154, -248],
        [189, -113],
        [-49, -78],
        [-18, -30],
        [-88, -137],
        [150, -86],
        [-97, -36],
        [-280, -104],
        [-15, -5],
        [-33, -12],
        [34, -25],
        [97, -69],
        [184, -130],
        [32, -22],
        [-106, -129],
        [215, -139],
        [-109, -179],
        [-106, -176],
        [-48, -78],
        [-49, -82],
        [-7, -12],
        [-90, -149],
        [-2, -4],
        [-103, -169],
        [-55, -89],
        [132, -79],
        [-50, -79],
        [-215, -339],
        [137, -73],
        [-97, -163],
        [-100, -169],
        [133, -80],
        [-27, -42],
        [-73, -127],
        [-94, -169],
        [-136, 77],
        [-275, 157],
        [-105, -159],
        [-97, -166],
        [-100, -175],
        [130, -76],
        [8, -4],
        [121, -71],
        [132, -76],
        [12, -7],
        [129, -74],
        [124, -73],
        [21, -11],
        [14, -8],
        [173, -99],
        [-24, -39],
        [-21, -39],
        [-116, -202],
        [-60, -102],
        [-39, -70],
        [-39, -69],
        [-61, -107],
        [-24, -40],
        [-8, -14],
        [-19, -35],
        [-2, 2],
        [-79, 72],
        [-37, -5],
        [-38, -14],
        [-73, -34],
        [-92, -13],
        [-33, -57],
        [-128, 100],
        [-105, -180],
        [-94, -165],
        [-68, 42],
        [-273, -429],
        [-73, 162],
        [-543, -1382],
        [-91, -51],
        [-803, -470],
        [-4, -19],
        [-6, -29],
        [2, -50],
        [-2, -34],
        [4, -57],
        [-6, -25],
        [-15, -20],
        [-10, -33],
        [25, -2],
        [16, 2],
        [14, 6],
        [25, -26],
        [37, -16],
        [14, -14],
        [-6, -17],
        [-43, -25],
        [-34, -61],
        [-63, -73],
        [-1, -42],
        [17, -44],
        [4, -28],
        [-2, -24],
        [-9, -67],
        [-11, -35],
        [-29, -32],
        [-24, -54],
        [-50, -39],
        [-25, -53],
        [-21, -51],
        [-23, -39],
        [-37, -17],
        [-21, -12],
        [-59, -27],
        [-14, 0],
        [-28, -2],
        [0, -36],
        [-59, -52],
        [-19, -115],
        [24, -36],
        [12, -70],
        [-8, -55],
        [-9, -52],
        [-2, -50],
        [2, -60],
        [7, -50],
        [-4, -81],
        [28, -58],
        [33, -61],
        [-6, -57],
        [39, -81],
        [61, -71],
        [3168, 1471],
        [528, -810],
        [168, -256],
        [94, -143],
        [54, -81],
        [442, -690],
        [-4319, -554],
        [-1825, -1001],
        [-4, 0],
        [-567, -153],
        [-931, -14],
        [18, -47],
        [-138, -9],
        [193, -207],
        [23, 10],
        [1066, -2813],
        [494, -1836],
        [-3228, -923],
        [1, -2],
        [-7, 0],
        [-509, -144],
        [18, -30],
        [8, -3],
        [47, 3],
        [23, -116],
        [-4, -8],
        [6, -36],
        [-20, -32],
        [-13, -9],
        [30, -80],
        [10, -37],
        [16, -32],
        [24, -38],
        [30, -42],
        [11, -15],
        [-2, -11],
        [2, -32],
        [27, -21],
        [34, -2],
        [38, -14],
        [48, 3],
        [30, -5],
        [20, -14],
        [53, -45],
        [-6, -28],
        [28, -2],
        [30, 30],
        [11, -5],
        [18, -2],
        [27, -11],
        [20, -14],
        [26, -46],
        [-4, -43],
        [0, -51],
        [73, 2],
        [-2, 7],
        [18, -4],
        [13, -24],
        [24, -20],
        [13, -6],
        [24, -38],
        [45, 6],
        [54, -22],
        [21, -29],
        [-11, -26],
        [7, -14],
        [8, -7],
        [14, -10],
        [11, -13],
        [20, -18],
        [17, -13],
        [16, -8],
        [25, -5],
        [25, -4],
        [27, -19],
        [11, -15],
        [7, -18],
        [-5, -17],
        [-11, -21],
        [-4, -20],
        [2, -28],
        [6, -14],
        [21, -10],
        [17, -6],
        [12, -12],
        [8, -16],
        [6, -15],
        [9, -16],
        [0, -10],
        [18, -32],
        [28, -22],
        [22, -17],
        [8, 0],
        [-12, -34],
        [23, -37],
        [-21, 6],
        [-24, 28],
        [-59, 72],
        [-20, 4],
        [-21, 2],
        [-33, 10],
        [-12, 0],
        [-35, 6],
        [-48, -2],
        [-40, -8],
        [-70, -10],
        [-39, -2],
        [-52, 4],
        [-33, -10],
        [-36, -14],
        [-35, -28],
        [-24, -16],
        [-30, -30],
        [-30, -31],
        [-31, -21],
        [-24, -10],
        [-37, -11],
        [-45, 6],
        [-38, 6],
        [-41, 7],
        [-31, 6],
        [-28, 1],
        [-18, -13],
        [-15, -18],
        [-26, -1],
        [-58, 32],
        [-39, 42],
        [-108, 97],
        [-24, 30],
        [-41, 49],
        [-26, 47],
        [-62, 35],
        [-52, -13],
        [-25, 17],
        [-32, 8],
        [-22, -6],
        [-25, -8],
        [-48, -11],
        [-24, 23],
        [-48, 28],
        [-61, 2],
        [-53, -22],
        [-46, 14],
        [-81, 12],
        [-62, 12],
        [-70, 18],
        [-58, 17],
        [-46, 2],
        [-33, -18],
        [-50, -22],
        [-37, -18],
        [-62, 9],
        [-156, 47],
        [-56, -33],
        [-24, -42],
        [18, -89],
        [45, -123],
        [50, -82],
        [32, -78],
        [7, -61],
        [-5, -62],
        [-5, -51],
        [-10, -38],
        [-21, -41],
        [30, -69],
        [31, -71],
        [35, -54],
        [46, -46],
        [35, -48],
        [24, -46],
        [-20, -35],
        [-54, -47],
        [-51, -12],
        [-20, -5],
        [-22, -13],
        [0, -27],
        [60, -15],
        [40, 0],
        [31, -2],
        [30, -3],
        [35, -12],
        [11, -37],
        [3, -51],
        [-2, -81],
        [33, -80],
        [27, -66],
        [11, -65],
        [-26, -15],
        [11, -10],
        [-25, -29],
        [-29, -2],
        [2, -16],
        [-26, -18],
        [12, -27],
        [32, -36],
        [63, -29],
        [166, -71],
        [65, -14],
        [33, 31],
        [44, 35],
        [55, -6],
        [58, -12],
        [81, -30],
        [52, -58],
        [50, -61],
        [2, -49],
        [-2, -27],
        [0, 0],
        [6, -47],
        [2, -28],
        [0, -27],
        [10, -20],
        [22, -42],
        [0, -34],
        [2, -36],
        [-2, -21],
        [3, -33],
        [2, -44],
        [3, -28],
        [12, -29],
        [19, -12],
        [23, -7],
        [53, 6],
        [64, -11],
        [68, -30],
        [31, -38],
        [25, -36],
        [34, -53],
        [27, -46],
        [22, -28],
        [22, -20],
        [34, -24],
        [60, -40],
        [49, -28],
        [45, -38],
        [49, -34],
        [40, -17],
        [38, -7],
        [37, -5],
        [27, -7],
        [31, -16],
        [19, -18],
        [33, -49],
        [16, -44],
        [29, -40],
        [16, -40],
        [34, -42],
        [31, -44],
        [12, -65],
        [8, -26],
        [13, -39],
        [4, -37],
        [3, -43],
        [15, -47],
        [3, -50],
        [2, -45],
        [6, -18],
        [0, -39],
        [0, -11],
        [-8, -24],
        [-7, -18],
        [-21, -4],
        [-16, -6],
        [-28, -8],
        [-29, -17],
        [-31, -19],
        [-14, -20],
        [-26, -21],
        [8, -43],
        [24, -45],
        [-35, -23],
        [-22, -15],
        [-13, -12],
        [-22, -7],
        [-27, -15],
        [-32, -24],
        [-22, -38],
        [-16, -44],
        [-7, -27],
        [-17, -28],
        [-10, -20],
        [-2, -37],
        [-22, -45],
        [0, -25],
        [7, -28],
        [11, -32],
        [14, -9],
        [2, -20],
        [12, -15],
        [12, -16],
        [29, -20],
        [39, -21],
        [540, 328],
        [14, -442],
        [3744, 44],
        [-126, -1201],
        [-1433, -711],
        [-263, -1443],
        [-366, -1615],
        [-476, -166],
        [204, -140],
        [-72, -59],
        [-76, -51],
        [-25, -39],
        [-38, -19],
        [-55, -2],
        [-32, 19],
        [-13, 49],
        [0, 63],
        [0, 71],
        [-25, 37],
        [-60, 50],
        [-38, -2],
        [-45, 34],
        [-63, 17],
        [-116, -2],
        [-70, -62],
        [-26, -57],
        [-45, -21],
        [-38, 6],
        [-26, 33],
        [-10, 40],
        [-6, 45],
        [6, 23],
        [48, 58],
        [26, 34],
        [29, 72],
        [12, 82],
        [7, 77],
        [23, 79],
        [32, 103],
        [-16, 30],
        [-19, 10],
        [-28, 14],
        [-40, -2],
        [-39, -14],
        [-37, -34],
        [-163, -65],
        [-41, -33],
        [-53, -59],
        [-3, -65],
        [8, -54],
        [30, -83],
        [-14, -59],
        [-46, -19],
        [-83, -60],
        [-58, -22],
        [-31, 10],
        [-63, 14],
        [-14, -39],
        [-55, 16],
        [-73, 27],
        [-31, -8],
        [-58, -40],
        [-26, -76],
        [6, -143],
        [-54, -277],
        [-111, 36],
        [-96, 95],
        [-435, -414],
        [242, 1458],
        [-1976, -1382],
        [-384, 2269],
        [-235, 83],
      ],
      [
        [254055, 153875],
        [-904, 316],
        [-25, 1531],
        [-156, -162],
        [-3704, -2688],
        [-832, 160],
        [-106, 20],
        [1119, -1154],
        [-2617, 1427],
        [-693, 134],
        [-24, 132],
        [-38, 51],
        [6, 26],
        [-99, 120],
        [-328, 104],
        [-125, -119],
        [-1245, -1924],
        [-4, 0],
        [-1435, 246],
        [-422, 77],
        [-154, -220],
        [-39, -134],
        [-862, 604],
        [-596, -529],
        [-505, 166],
        [-92, 38],
        [-164, -427],
        [-422, 159],
        [-211, 255],
        [-326, 194],
        [29, 170],
        [-1016, 303],
        [-695, -260],
        [-236, -690],
        [-1593, -174],
        [-465, 1291],
        [-1904, -2015],
        [-796, -345],
      ],
      [
        [232376, 150558],
        [-1023, 1515],
        [-872, 1086],
        [502, -84],
        [756, 135],
        [-361, 663],
        [834, 58],
        [9, 1],
        [341, 14],
        [291, 116],
        [-1, 126],
        [-2, 123],
        [-428, -43],
        [71, 39],
        [36, 14],
        [12, 17],
        [-2, 25],
        [7, 24],
        [26, 41],
        [29, 12],
        [71, 17],
        [24, 4],
        [28, 12],
        [22, 3],
        [17, 4],
        [26, 16],
        [25, 3],
        [26, -1],
        [37, 9],
        [43, 61],
        [40, 49],
        [14, 25],
        [12, 37],
        [6, 30],
        [11, 49],
        [10, 9],
        [6, 12],
        [-10, 32],
        [-8, 32],
        [-10, 48],
        [4, 22],
        [22, 55],
        [4, 46],
        [-12, 46],
        [36, 33],
        [0, 20],
        [30, 28],
        [11, -2],
        [10, 8],
        [19, 12],
        [54, 23],
        [68, 1],
        [19, 29],
        [83, 10],
        [43, 12],
        [40, 30],
        [45, 33],
        [35, 35],
        [1, 18],
        [-6, 33],
        [-18, 71],
        [-7, 38],
        [-6, 19],
        [10, 27],
        [23, 34],
        [19, 25],
        [10, 25],
        [4, 27],
        [-7, 27],
        [-13, 34],
        [-6, 16],
        [-12, 23],
        [-20, 50],
        [-18, 58],
        [-4, 49],
        [4, 33],
        [11, 30],
        [27, 33],
        [28, 22],
        [22, 0],
        [29, -12],
        [20, 16],
        [0, 74],
        [16, 36],
        [9, 28],
        [0, 40],
        [-3, 36],
        [-5, 36],
        [-5, 16],
        [-8, 8],
        [-1, 43],
        [26, 42],
        [21, 26],
        [28, 14],
        [19, 14],
        [-1, 10],
        [33, 39],
        [73, 40],
        [28, 83],
        [23, 34],
        [8, 51],
        [-10, 56],
        [-2, 39],
        [-18, 57],
        [-7, 51],
        [11, 53],
        [8, 23],
        [0, 2],
        [6, 18],
        [26, 28],
        [50, 24],
        [940, 1989],
        [469, 1108],
        [23, 55],
        [155, 367],
        [11, 23],
        [73, 179],
        [-693, 24],
        [-173, 2751],
        [-1166, -49],
        [-658, -60],
        [-1895, 6],
        [-20, 2104],
        [-7, 791],
        [-1268, 561],
        [22, -976],
        [-1033, 368],
        [-384, 137],
        [-8326, 2968],
        [-983, 2421],
        [-317, -6],
        [-17, 22],
        [-11, 8],
        [-23, 8],
        [-18, 12],
        [-18, 11],
        [-14, 4],
        [-20, 17],
        [-17, 11],
        [-12, 13],
        [-9, 12],
        [-37, 15],
        [-43, 14],
        [-47, 16],
        [-38, 2],
        [-44, 24],
        [-99, 48],
        [-70, 48],
        [-141, -19],
        [-50, -93],
        [-72, -52],
        [-82, -1],
        [-39, -19],
        [-13, -4],
        [-51, -13],
        [-61, 5],
        [-68, -29],
        [-57, -54],
        [-27, -42],
        [-33, -42],
        [0, -238],
        [-82, 45],
        [-79, -10],
        [-2, 6],
        [-5, 4],
        [0, 10],
        [0, 8],
        [-1, 12],
        [-1, 5],
        [-5, 16],
        [4, 7],
        [-1, 7],
        [-4, 6],
        [-5, 7],
        [-8, 8],
        [-32, 21],
        [-16, 15],
        [-25, 19],
        [-12, 3],
        [-55, 35],
        [-7, -80],
        [-60, -24],
        [-31, -71],
        [-60, -11],
        [6, -120],
        [-67, 17],
        [-42, -43],
        [5, -61],
        [-66, 3],
        [29, 90],
        [-10, 19],
        [-2, 6],
        [-2, 9],
        [0, 15],
        [0, 18],
        [-6, 5],
        [-7, 0],
        [-8, -1],
        [-17, -10],
        [-55, -8],
        [-51, -15],
        [-87, -68],
        [-75, -60],
        [-109, 8],
        [-21, 2],
        [-1, 0],
        [1, 4],
        [25, 105],
        [4, 13],
        [0, 2],
        [-24, 75],
        [-2, 6],
        [0, 2],
        [-1, 2],
        [0, 2],
        [-113, 113],
        [-127, -35],
        [76, -102],
        [-75, -46],
        [9, -27],
        [-35, -70],
        [-96, -110],
        [-39, -55],
        [-18, -30],
        [-42, -51],
        [-4, -18],
        [-16, -35],
        [-18, -21],
        [-28, -20],
        [-27, -5],
        [-34, -1],
        [-37, -1],
        [-28, 3],
        [-15, 2],
        [-7, 0],
        [-2, -4],
        [2, -5],
        [-5, -6],
        [-13, -4],
        [-26, -4],
        [-8, 2],
        [-9, 0],
        [-28, -2],
        [-13, -2],
        [-5, -2],
        [-7, -18],
        [-9, -8],
        [-33, -16],
        [-13, 4],
        [-12, 0],
        [-11, -2],
        [-13, -10],
        [-4, -8],
        [-9, -21],
        [-10, -11],
        [-10, -3],
        [-15, -6],
        [-30, -24],
        [-22, -14],
        [-8, -7],
        [-18, -33],
        [-24, -29],
        [-25, -13],
        [-18, -13],
        [-17, -2],
        [-16, 4],
        [-8, -1],
        [-6, -5],
        [-1, -5],
        [1, -6],
        [2, -18],
        [-8, -11],
        [-5, -11],
        [-10, -11],
        [-20, -13],
        [-9, -2],
        [-8, 2],
        [-42, 17],
        [-18, 4],
        [-28, -2],
        [-4, 5],
        [-2, 5],
        [-10, 13],
        [-9, 0],
        [-10, -4],
        [-10, -10],
        [-6, -2],
        [-26, -22],
        [-84, -28],
        [-10, -7],
        [0, -10],
        [4, -15],
        [-2, -10],
        [-2, -6],
        [-18, -13],
        [-36, -20],
        [-13, -8],
        [-48, 2],
        [-27, 7],
        [-28, 9],
        [-25, 8],
        [-19, -1],
        [-26, -11],
        [-20, -19],
        [-13, -24],
        [1, -21],
        [1, -20],
        [10, -48],
        [-1, -28],
        [-11, -28],
        [-21, -52],
        [-17, -33],
        [-29, -30],
        [-31, -36],
        [-54, -56],
        [-37, -49],
        [-34, -43],
        [-20, -8],
        [-25, -12],
        [-27, -10],
        [-42, 3],
        [-26, -1],
        [-23, 1],
        [-42, 11],
        [-6, 10],
        [-10, 0],
        [-14, 0],
        [-13, -8],
        [-32, -4],
        [-14, 0],
        [-17, 4],
        [-18, 4],
        [-16, -2],
        [-19, -6],
        [-10, -13],
        [-1, -12],
        [2, -13],
        [8, -25],
        [7, -40],
        [9, -18],
        [3, -16],
        [0, -12],
        [-20, -17],
        [-3, -9],
        [0, -12],
        [-1, -21],
        [-2, -10],
        [-2, -10],
        [3, -9],
        [6, -15],
        [9, -20],
        [37, -43],
        [19, -14],
        [10, -10],
        [9, -16],
        [16, -20],
        [5, -9],
        [-3, -15],
        [-10, -30],
        [-6, -21],
        [0, -23],
        [2, -15],
        [14, -34],
        [11, -30],
        [4, -18],
        [4, -36],
        [15, -24],
        [8, -19],
        [-2, -13],
        [-6, -11],
        [-12, -24],
        [0, -14],
        [2, -10],
        [14, -17],
        [4, -46],
        [-4, -27],
        [-8, -24],
        [-23, -42],
        [-5, -35],
        [15, -11],
        [29, -12],
        [25, -8],
        [34, -31],
        [15, -24],
        [1, -16],
        [6, -24],
        [8, -15],
        [20, -23],
        [20, -18],
        [6, -14],
        [13, -23],
        [25, -26],
        [22, -34],
        [0, -65],
        [-6, -12],
        [-12, -13],
        [-10, -3],
        [-1, -7],
        [-1, -9],
        [-5, -17],
        [-21, -28],
        [-7, -15],
        [-10, -15],
        [3, -24],
        [-3, -16],
        [-14, -10],
        [-9, -3],
        [-8, -3],
        [-17, -33],
        [-6, -30],
        [-11, -18],
        [-13, -10],
        [-23, -22],
        [-43, -24],
        [-36, -36],
        [-3, -21],
        [-1, -22],
        [2, -19],
        [11, -15],
        [21, -22],
        [10, -3],
        [22, -1],
        [8, -9],
        [1, -12],
        [2, -10],
        [15, -15],
        [7, -8],
        [9, -21],
        [-3, -20],
        [-7, -22],
        [-15, -32],
        [-10, -3],
        [-5, -3],
        [-2, -8],
        [-16, -12],
        [-10, -6],
        [-23, 0],
        [-26, 2],
        [-25, -1],
        [-14, -2],
        [-6, -11],
        [0, -11],
        [6, -7],
        [2, -17],
        [6, -8],
        [15, -18],
        [9, -28],
        [-3, -12],
        [-1, -13],
        [-2, -10],
        [0, -8],
        [-1, -6],
        [12, -5],
        [17, -6],
        [16, -19],
        [18, -30],
        [18, -26],
        [0, -21],
        [-12, -18],
        [-20, -36],
        [-3, -30],
        [-5, -27],
        [-10, -10],
        [-32, 0],
        [-18, -8],
        [-23, -27],
        [-11, -11],
        [-4, -8],
        [-11, 0],
        [-10, -14],
        [-17, -4],
        [-9, 6],
        [-10, 9],
        [-8, 10],
        [-2, 9],
        [4, 5],
        [6, 4],
        [4, 13],
        [-2, 7],
        [-6, 6],
        [-10, 0],
        [-14, -1],
        [-12, -13],
        [-18, -20],
        [-8, -11],
        [-21, -11],
        [-26, -18],
        [-11, -13],
        [-6, -35],
        [6, -36],
        [0, -24],
        [2, -15],
        [6, -22],
        [-5, -16],
        [-2, -15],
        [0, -15],
        [0, -12],
        [-9, -22],
        [-2, -19],
        [4, -29],
        [-4, -9],
        [-12, -11],
        [-15, -16],
        [-4, -11],
        [-6, -11],
        [-15, -16],
        [-1, -11],
        [2, -15],
        [7, -8],
        [7, -8],
        [5, -10],
        [1, -18],
        [8, -11],
        [13, -23],
        [4, -20],
        [8, -26],
        [9, -16],
        [2, -26],
        [2, -11],
        [13, -13],
        [1, -32],
        [5, -15],
        [9, -12],
        [8, -10],
        [-1, -12],
        [6, -14],
        [5, -13],
        [32, -50],
        [25, -29],
        [10, -19],
        [19, -33],
        [11, -11],
        [14, -13],
        [14, -9],
        [31, -21],
        [14, -11],
        [8, -13],
        [10, -19],
        [5, -22],
        [15, -33],
        [2, -23],
        [-4, -13],
        [2, -9],
        [-6, -18],
        [-2, -3],
        [-17, 4],
        [-3, 4],
        [-2, 9],
        [-8, 14],
        [-12, 9],
        [-20, 8],
        [-14, 5],
        [-19, -1],
        [-19, 4],
        [-13, 8],
        [-18, 6],
        [-35, 3],
        [-13, 1],
        [-13, -6],
        [-16, -5],
        [-23, -5],
        [-14, -10],
        [-24, -7],
        [-7, 0],
        [-13, 6],
        [-8, 2],
        [-4, -7],
        [-5, 0],
        [-20, 0],
        [-17, 2],
        [-25, 10],
        [-9, 6],
        [-5, 10],
        [-7, 5],
        [-7, 1],
        [-40, -6],
        [-30, -16],
        [-20, -40],
        [0, -35],
        [-2, -18],
        [-4, -29],
        [0, -18],
        [8, -13],
        [4, -8],
        [6, -31],
        [16, -11],
        [6, 1],
        [6, -8],
        [12, -8],
        [9, -12],
        [8, -18],
        [11, -18],
        [5, -14],
        [9, -6],
        [5, -10],
        [12, -20],
        [7, -21],
        [1, -13],
        [8, -14],
        [2, -14],
        [2, -15],
        [2, -14],
        [10, -17],
        [8, -28],
        [-6, -23],
        [-12, -16],
        [-6, -8],
        [2, -6],
        [4, -6],
        [4, -16],
        [-4, -30],
        [-6, -18],
        [-8, -8],
        [-19, -8],
        [-17, -5],
        [-12, -14],
        [-4, -24],
        [-25, -28],
        [-22, -8],
        [-25, -10],
        [-9, -25],
        [-21, -13],
        [-19, -16],
        [-14, -1],
        [-24, 16],
        [-26, -1],
        [-17, 7],
        [-18, 3],
        [-20, 5],
        [-7, 7],
        [-10, 7],
        [-3, 3],
        [-9, -7],
        [-10, -20],
        [-16, -1],
        [-10, 1],
        [-21, 1],
        [-28, -13],
        [-14, -3],
        [-21, -13],
        [-32, -5],
        [-27, -4],
        [-30, -9],
        [-12, -1],
        [-13, 3],
        [-9, 8],
        [-7, 2],
        [-5, 1],
        [-8, 0],
        [-2, -6],
        [4, -5],
        [11, -7],
        [3, -9],
        [6, -17],
        [16, -23],
        [20, -20],
        [18, -13],
        [6, -22],
        [4, -17],
        [7, -7],
        [12, -8],
        [10, -2],
        [11, 1],
        [4, 5],
        [6, 9],
        [5, -1],
        [4, -7],
        [-2, -12],
        [-5, -9],
        [-10, -12],
        [0, -12],
        [3, -12],
        [10, -14],
        [12, -14],
        [19, -11],
        [15, -4],
        [5, -10],
        [4, -17],
        [2, -17],
        [-2, -16],
        [-14, -30],
        [-16, -42],
        [-3, -19],
        [4, -11],
        [4, -12],
        [-2, -14],
        [-2, -6],
        [1, -7],
        [-1, -1],
        [-9, -9],
        [-5, 0],
        [-4, 2],
        [-4, 4],
        [-2, 6],
        [0, 7],
        [-1, 10],
        [-7, 9],
        [-9, 12],
        [-16, 16],
        [-5, 10],
        [-10, 17],
        [-9, 6],
        [-8, 4],
        [-10, 8],
        [-20, 16],
        [-39, 16],
        [-25, 6],
        [-23, 3],
        [-27, -4],
        [-22, 0],
        [-4, 14],
        [-4, 10],
        [-9, 14],
        [-8, 14],
        [-10, 17],
        [-8, 7],
        [-16, 6],
        [-19, 2],
        [-21, -2],
        [-15, -9],
        [-16, -10],
        [-14, 0],
        [-15, 1],
        [-17, -1],
        [-22, -5],
        [-11, 0],
        [-11, 1],
        [0, 6],
        [-4, 3],
        [-6, -5],
        [-4, -5],
        [-20, -4],
        [-16, -12],
        [-10, -9],
        [-8, 9],
        [-8, 11],
        [-5, 8],
        [-2, 9],
        [-2, 7],
        [-3, 7],
        [-5, 4],
        [-10, 0],
        [-8, -4],
        [-12, -10],
        [-8, -18],
        [-12, -27],
        [-9, -31],
        [-11, -19],
        [-10, -6],
        [-6, 2],
        [-7, 6],
        [-3, 0],
        [-6, 0],
        [-4, -2],
        [-5, -4],
        [-6, -6],
        [-4, -8],
        [-9, 2],
        [-5, 0],
        [-2, -2],
        [-6, -12],
        [-16, -14],
        [-6, 0],
        [-4, 2],
        [0, 2],
        [-1, 4],
        [-2, 0],
        [-6, -2],
        [-2, -4],
        [0, -6],
        [-6, -3],
        [-12, -2],
        [-7, 2],
        [-10, 3],
        [-8, -5],
        [-2, -7],
        [-5, -18],
        [-2, -17],
        [0, -4],
        [5, -19],
        [4, -16],
        [2, -8],
        [17, -13],
        [13, -9],
        [30, -25],
        [6, -2],
        [8, -5],
        [4, -3],
        [2, -5],
        [-4, -9],
        [-2, -8],
        [0, -5],
        [4, -7],
        [4, -10],
        [2, -38],
        [0, -12],
        [3, -6],
        [5, -8],
        [4, -6],
        [-1, -4],
        [-2, -3],
        [0, -4],
        [-7, -5],
        [-8, -8],
        [0, -3],
        [-4, -4],
        [-6, -6],
        [-8, -6],
        [-6, -5],
        [-2, -6],
        [-1, -7],
        [1, -6],
        [4, -7],
        [4, -6],
        [6, -7],
        [6, -7],
        [4, -6],
        [2, -6],
        [0, -9],
        [2, -2],
        [-4, -8],
        [0, -6],
        [-2, -4],
        [-4, -4],
        [-8, -6],
        [-6, -8],
        [-2, -4],
        [-3, -4],
        [-1, -8],
        [-1, -4],
        [-3, -3],
        [-9, -5],
        [-3, -3],
        [-3, -5],
        [1, -8],
        [-1, -6],
        [2, -4],
        [3, -4],
        [2, -6],
        [14, -5],
        [24, -5],
        [6, -4],
        [5, 0],
        [14, -2],
        [16, 4],
        [4, -1],
        [4, -3],
        [8, -11],
        [18, -21],
        [12, -10],
        [12, -10],
        [7, -2],
        [9, -4],
        [8, -2],
        [10, -5],
        [6, -7],
        [0, -11],
        [0, -6],
        [-10, -2],
        [-8, 0],
        [-4, 2],
        [-8, 0],
        [-9, 0],
        [-8, -2],
        [-7, 0],
        [-8, -5],
        [-6, 0],
        [-8, 0],
        [-10, 3],
        [-9, 4],
        [-7, 4],
        [-12, 4],
        [-11, 2],
        [-12, 0],
        [-4, -3],
        [-2, -5],
        [0, -6],
        [-4, -7],
        [-6, -2],
        [-8, 0],
        [-13, 1],
        [-6, -3],
        [-7, -4],
        [-13, -9],
        [-10, -15],
        [-9, -14],
        [-6, -8],
        [-5, -4],
        [-4, -8],
        [0, -8],
        [0, -4],
        [4, -8],
        [1, -4],
        [-1, -7],
        [0, -7],
        [0, -13],
        [0, -2],
        [-8, -2],
        [-8, 0],
        [-4, 1],
        [-4, 3],
        [-11, 6],
        [-8, 4],
        [-11, 3],
        [-5, 1],
        [-11, -1],
        [-15, -1],
        [-1, 1],
        [-16, 2],
        [-6, 4],
        [-6, 4],
        [-4, 10],
        [-6, 6],
        [-8, 2],
        [-11, -2],
        [-17, -6],
        [-12, -6],
        [-6, 0],
        [-11, 2],
        [-5, 0],
        [-9, -4],
        [-10, -6],
        [-4, 2],
        [-6, 6],
        [-2, 6],
        [-2, 8],
        [-2, 8],
        [-5, 6],
        [-6, 10],
        [-2, 4],
        [-7, 0],
        [-6, 2],
        [-17, 6],
        [-10, 6],
        [-11, 7],
        [-8, 8],
        [-4, 6],
        [0, 10],
        [-2, 6],
        [-6, 6],
        [-10, 8],
        [-7, 6],
        [-3, 5],
        [-5, 18],
        [-6, 12],
        [-8, 4],
        [-6, 4],
        [-6, 0],
        [-5, -2],
        [-14, -4],
        [-13, -6],
        [-6, -6],
        [-4, -1],
        [-10, 1],
        [-10, 0],
        [-7, -2],
        [-5, -2],
        [-3, 10],
        [-5, 4],
        [-12, 8],
        [-8, 2],
        [-9, 0],
        [-6, -2],
        [-10, -2],
        [-10, 2],
        [-10, 0],
        [-7, -2],
        [-4, -6],
        [-3, -4],
        [-1, -5],
        [-2, -7],
        [-6, -11],
        [0, -5],
        [2, -12],
        [0, -4],
        [0, -5],
        [-4, -7],
        [-6, -5],
        [-2, -7],
        [0, -1],
        [2, -5],
        [0, -5],
        [-4, -10],
        [-4, -2],
        [-8, -5],
        [-1, -2],
        [-1, -3],
        [-7, -8],
        [-2, -7],
        [-1, -10],
        [0, -4],
        [6, -8],
        [4, -10],
        [6, -13],
        [0, -15],
        [-2, -22],
        [-5, -20],
        [-11, -15],
        [-11, -4],
        [-14, 0],
        [-18, 4],
        [-8, 0],
        [-17, -12],
        [-16, -16],
        [0, -8],
        [-11, -14],
        [-13, -20],
        [-9, -16],
        [-6, -22],
        [-111, -27],
        [-7, 9],
        [-9, 8],
        [-5, 13],
        [-10, 6],
        [-8, -3],
        [-4, -6],
        [-9, 0],
        [-6, 5],
        [-5, 6],
        [-2, 10],
        [-3, 7],
        [-13, 0],
        [-12, 0],
        [-5, 6],
        [-1, 4],
        [-2, 18],
        [-21, 12],
        [-22, 18],
        [-7, 2],
        [-20, 0],
        [-9, 4],
        [-18, 19],
        [-11, 4],
        [-2, 4],
        [-5, 10],
        [0, 11],
        [-4, 8],
        [-10, -6],
        [0, -10],
        [0, -5],
        [0, -37],
        [-2, -12],
        [-8, -6],
        [-9, -2],
        [-5, -4],
        [-1, -18],
        [-2, -14],
        [-7, -13],
        [-8, -14],
        [-5, -10],
        [-12, 0],
        [-28, 10],
        [-28, 2],
        [-17, -1],
        [-6, -7],
        [-20, -12],
        [-16, 3],
        [-12, 9],
        [-11, 6],
        [-37, -7],
        [-40, -21],
        [-12, -16],
        [-3, 1],
        [-8, 6],
        [-3, 7],
        [3, 8],
        [0, 12],
        [2, 13],
        [-2, 24],
        [0, 20],
        [-3, 8],
        [-9, 8],
        [-3, 10],
        [2, 20],
        [1, 12],
        [-1, 10],
        [-7, 15],
        [-14, 25],
        [-14, 4],
        [-12, 7],
        [-5, 6],
        [-9, 10],
        [-6, 4],
        [0, 2],
        [-16, 12],
        [-19, 12],
        [-9, 11],
        [-2, 0],
        [-15, -5],
        [-13, -6],
        [-18, -2],
        [-19, -4],
        [-15, 4],
        [-5, 2],
        [-10, 8],
        [-8, 2],
        [-16, -4],
        [-6, 2],
        [-20, 2],
        [-22, 0],
        [-14, -2],
        [-21, -20],
        [-16, -12],
        [-5, -8],
        [-8, -13],
        [-10, -15],
        [-7, -36],
        [-6, -17],
        [-5, -6],
        [-8, -2],
        [-7, 2],
        [-5, 4],
        [-10, 7],
        [-8, 8],
        [-5, 3],
        [-9, 5],
        [-1, 2],
        [-4, 6],
        [-5, 7],
        [-6, 3],
        [-8, 0],
        [-10, 2],
        [-9, 6],
        [-6, 2],
        [-15, 4],
        [-16, 3],
        [-3, 3],
        [-2, 4],
        [-4, 13],
        [-1, 4],
        [-4, 9],
        [-4, 6],
        [-10, 6],
        [-7, 8],
        [-6, 12],
        [-6, 13],
        [-4, 11],
        [-6, 5],
        [-7, 4],
        [-3, 6],
        [-3, 7],
        [0, 6],
        [2, 8],
        [5, 24],
        [2, 8],
        [0, 5],
        [-2, 3],
        [-6, 6],
        [-4, 8],
        [-7, 20],
        [-7, 24],
        [-3, 16],
        [-7, 13],
        [-14, 11],
        [-30, 14],
        [-10, 5],
        [-9, 5],
        [-8, 8],
        [-6, 6],
        [-9, 6],
        [-9, 8],
        [-14, 12],
        [-5, 4],
        [-11, 4],
        [-14, 4],
        [-8, 2],
        [-10, 7],
        [-9, 6],
        [-2, 2],
        [-9, 8],
        [-10, 6],
        [-8, 3],
        [-9, 2],
        [-8, 6],
        [-6, 8],
        [-6, 9],
        [-9, 15],
        [-8, 6],
        [-12, 3],
        [-12, 1],
        [-15, 2],
        [-18, 4],
        [-13, 3],
        [-12, 6],
        [-7, 6],
        [-2, 4],
        [-2, 6],
        [-4, 16],
        [2, 8],
        [-6, 8],
        [-6, 4],
        [-10, 0],
        [-8, -2],
        [-11, -6],
        [-11, -10],
        [-5, -4],
        [-7, -2],
        [-9, 2],
        [-8, 2],
        [-10, 0],
        [-19, 0],
        [-9, 4],
        [-8, 4],
        [-9, 6],
        [-6, 4],
        [-6, 10],
        [-2, 4],
        [-5, 2],
        [-5, -2],
        [-10, -4],
        [-9, -2],
        [-10, -2],
        [-11, 2],
        [-12, 4],
        [-22, 11],
        [-56, -6],
        [-97, 12],
        [-67, 10],
        [-64, 12],
        [-24, 18],
        [-278, -1288],
        [-2238, 536],
        [-825, -429],
        [-1754, -899],
        [-4234, 750],
        [-1021, -3760],
        [-2, -3],
        [-22, -87],
        [-2, -9],
        [-4, -14],
        [-20, -70],
        [0, -3],
        [-1, -2],
      ],
      [
        [199338, 160216],
        [-368, 340],
        [1, 144],
        [-33, 2],
        [-62, 12],
        [-25, 22],
        [-88, 0],
        [-44, 3],
        [-48, 4],
        [-75, -12],
        [-93, 7],
        [-91, -5],
        [-56, 10],
        [-94, -6],
        [-42, -2],
        [-69, -8],
        [-103, -23],
        [-86, 8],
        [-26, -2],
        [-56, 9],
        [-73, 2],
        [-33, -2],
        [-73, 12],
        [-39, 12],
        [-97, 21],
        [-30, -9],
        [-37, -22],
        [-41, -21],
        [-43, -6],
        [-39, 8],
        [-51, 17],
        [-52, 29],
        [-57, 40],
        [-21, 4],
        [-55, -4],
        [-43, -2],
        [-63, 15],
        [-36, 30],
        [-40, 42],
        [-26, 54],
        [-31, 54],
        [-33, 36],
        [-31, 33],
        [-21, 33],
        [-35, 31],
        [-41, 47],
        [-54, 38],
        [-59, 43],
        [-70, 44],
        [-35, 13],
        [-55, 9],
        [-48, -51],
        [-39, 13],
        [-43, 11],
        [-17, 11],
        [-43, 21],
        [-53, 36],
        [-22, 33],
        [-30, 43],
        [-29, 64],
        [-47, 56],
        [-48, 43],
        [-53, 52],
        [-59, 54],
        [-65, 40],
        [-101, 92],
        [-3, 8],
        [-38, 19],
        [-44, 27],
        [-52, 69],
        [-68, 40],
        [-55, 18],
        [-60, 10],
        [-75, 27],
        [-42, 27],
        [-21, 26],
        [-35, 19],
        [-73, -29],
        [0, -26],
        [4, -43],
        [-9, -35],
        [-19, -38],
        [-42, -77],
        [-41, -17],
        [-89, -27],
        [-90, -2],
        [-55, -7],
        [-52, -18],
        [-71, -15],
        [-56, -29],
        [-27, -41],
        [-23, -45],
        [-20, -52],
        [-19, -34],
        [0, -70],
        [-4, -100],
        [-63, -66],
        [-13, -44],
        [-41, -59],
        [8, -46],
        [-10, -64],
        [16, -77],
        [9, -80],
        [30, -52],
        [28, -42],
        [49, 0],
        [28, -50],
        [11, -116],
        [-4, -84],
        [2, -57],
        [-4, -4],
        [-9, -4],
        [-4, -8],
        [-16, 4],
        [-17, -12],
        [-3, -23],
        [0, -32],
        [-10, -13],
        [-10, -5],
        [-13, -16],
        [-19, -19],
        [-19, -15],
        [-11, -24],
        [-5, -14],
        [-6, -2],
        [-13, 5],
        [-14, -4],
        [-5, -7],
        [-3, -22],
        [2, -53],
        [-12, -11],
        [-20, -1],
        [-18, 12],
        [-12, 0],
        [-14, -15],
        [-14, -12],
        [-40, -10],
        [-13, -10],
        [-7, -18],
        [-10, -8],
        [-27, 7],
        [-30, 0],
        [-14, -5],
        [-32, -16],
        [-38, -13],
        [-17, -7],
        [-8, -8],
        [-12, 6],
        [-8, -14],
        [-8, -10],
        [-22, 15],
        [-10, -15],
        [-6, -13],
        [-16, 5],
        [-18, 5],
        [-28, 8],
        [-24, -1],
        [-20, 13],
        [-27, -13],
        [-46, 22],
        [-64, -2],
        [-19, -20],
        [-32, 20],
        [-14, -14],
        [-22, 12],
        [-39, 16],
        [-74, -2],
        [-29, 84],
        [-25, 33],
        [-63, 15],
        [-69, 11],
        [-46, 15],
        [-21, 3],
        [-6, 1],
        [-105, 14],
        [-43, -10],
        [-4, -1],
        [-3, -1],
        [-48, -1],
        [-3, -2],
        [-4, -4],
        [-15, -17],
        [-18, -1],
        [-32, -21],
        [-8, -6],
        [-21, -8],
        [-17, -8],
        [-10, -4],
        [-4, 0],
        [-43, -1],
        [-58, 19],
        [-38, 29],
        [-19, 16],
        [-31, 21],
        [-21, 18],
        [0, 11],
        [5, 13],
        [-16, 27],
        [-23, 16],
        [-16, -1],
        [-11, -15],
        [-13, 0],
        [-8, -10],
        [-12, -7],
        [-24, 4],
        [-36, 15],
        [-21, 9],
        [-19, 5],
        [-21, -7],
        [-43, -1],
        [-35, -13],
        [-31, -6],
        [-14, -8],
        [-16, -36],
        [-7, -16],
        [-30, -7],
        [-30, 29],
        [-2, 26],
        [6, 35],
        [-18, 20],
        [-24, 2],
        [-13, -21],
        [2, -16],
        [-5, -8],
        [-16, -16],
        [-28, 8],
        [-10, 3],
        [-12, -2],
        [-6, -9],
        [7, -13],
        [6, -11],
        [2, -46],
        [-9, -18],
        [-19, -12],
        [-52, -1],
        [-40, 30],
        [-24, 6],
        [-12, -4],
        [-40, -2],
        [-18, 23],
        [-16, 33],
        [-13, 23],
        [-16, 9],
        [-31, 6],
        [-16, -3],
        [-14, -14],
        [-14, -6],
        [-15, -6],
        [-18, -5],
        [-27, -24],
        [-18, -11],
        [-25, -25],
        [-25, -17],
        [-41, -1],
        [-55, 15],
        [-31, 30],
        [-12, 26],
        [-14, 24],
        [-23, 15],
        [-14, -16],
        [-12, -14],
        [-34, -11],
        [-42, 25],
        [-24, 20],
        [-1, 21],
        [-20, 30],
        [-15, 18],
        [-35, -2],
        [-33, -14],
        [-12, -19],
        [0, -25],
        [13, -20],
        [-7, -27],
        [-16, -13],
        [-42, -2],
        [-67, 32],
        [-34, 27],
        [-28, 13],
        [-38, 8],
        [-28, -20],
        [-12, -35],
        [-15, -37],
        [-25, -19],
        [-30, -12],
        [-59, 16],
        [-43, 49],
        [-13, 27],
        [-16, 14],
        [-20, 0],
        [-25, -31],
        [-15, -14],
        [-21, -8],
        [-20, -2],
        [-16, 11],
        [-11, 22],
        [-1, 19],
        [-8, 54],
        [-1, 21],
        [-26, 12],
        [-19, -12],
        [-20, -15],
        [-21, -12],
        [-18, -11],
        [-12, -12],
        [-11, -17],
        [-13, -17],
        [-19, -9],
        [-34, -5],
        [-35, 13],
        [-18, 14],
        [-21, 23],
        [-29, 16],
        [-34, -8],
        [-22, -21],
        [-16, -19],
        [-26, -16],
        [-18, -1],
        [-10, 14],
        [-4, 16],
        [-1, 13],
        [4, 16],
        [-7, 11],
        [-11, 12],
        [-17, -2],
        [-12, -8],
        [-21, -9],
        [-11, 1],
        [-11, 4],
        [-2, 6],
        [-7, 14],
        [-11, 9],
        [-12, 6],
        [-10, 0],
        [-8, -8],
        [-10, -13],
        [-10, -16],
        [-11, -12],
        [-6, -10],
        [-13, -8],
        [-13, 3],
        [-117, 37],
        [-42, -2],
        [-50, -40],
        [-23, -19],
        [1, -26],
        [-16, -27],
        [-8, -5],
        [-6, -12],
        [-4, -12],
        [-7, -9],
        [-12, -14],
        [-58, -2],
        [-14, 6],
        [-12, 8],
        [-12, 0],
        [-4, -11],
        [-13, 4],
        [0, -12],
        [9, -11],
        [12, -22],
        [16, -26],
        [9, -12],
        [13, -16],
        [4, -15],
        [-11, -10],
        [-14, -9],
        [-38, 3],
        [-18, 9],
        [-12, 12],
        [-26, 16],
        [-10, 8],
        [3, 33],
        [-3, 2],
        [-4, 7],
        [-20, 23],
        [-13, 16],
        [-13, 5],
        [-17, -7],
        [-8, -11],
        [-6, -11],
        [-16, -14],
        [-11, -6],
        [-10, -4],
        [-22, -9],
        [-15, -1],
        [-13, 8],
        [-18, 4],
        [-11, -4],
        [-5, -14],
        [2, -39],
        [-15, -31],
        [-21, -17],
        [-18, -8],
        [-19, -1],
        [-32, -6],
        [-12, 7],
        [-8, 10],
        [0, 10],
        [4, 14],
        [12, 28],
        [0, 12],
        [-9, 20],
        [-33, 13],
        [-26, 8],
        [-8, 12],
        [-21, 26],
        [-11, 18],
        [-11, 16],
        [0, 19],
        [15, 21],
        [-6, 16],
        [-8, 13],
        [-1, 16],
        [10, 10],
        [6, 6],
        [12, 17],
        [7, 15],
        [-1, 18],
        [-2, 11],
        [-8, 8],
        [-10, 4],
        [-25, 8],
        [-34, 29],
        [-16, 29],
        [-1, 30],
        [11, 36],
        [-6, 33],
        [0, 14],
        [-17, 35],
        [-25, 6],
        [-19, -1],
        [-26, -11],
        [-22, -16],
        [-25, -18],
        [-21, -1],
        [-8, 8],
        [-34, -1],
        [-16, 13],
        [-14, 4],
        [-10, 0],
        [-5, -11],
        [-6, -8],
        [-10, 0],
        [-25, 3],
        [-19, 12],
        [-27, 3],
        [-19, 0],
        [-17, 4],
        [-24, -8],
        [-27, -7],
        [-31, -14],
        [-33, -23],
        [-32, -16],
        [-30, -18],
        [-27, -18],
        [-41, -27],
        [-13, -21],
        [-24, -32],
        [-13, -26],
        [-19, -23],
        [-16, -10],
        [-1434, 2245],
        [-854, -833],
        [-2241, -1469],
        [-1071, -658],
        [-663, -1563],
        [-1865, -520],
        [-26, -10],
        [4, 26],
        [14, 19],
        [20, 17],
        [20, 25],
        [13, 28],
        [37, 30],
        [29, 10],
        [23, 6],
        [9, 6],
        [68, 47],
        [14, 4],
        [16, -2],
        [5, 6],
        [17, 19],
        [9, 3],
        [28, 3],
        [0, 4],
        [-9, 17],
        [0, 8],
        [13, 40],
        [19, 26],
        [-2, 25],
        [10, 15],
        [25, 14],
        [21, 4],
        [184, 136],
        [-15, 53],
        [-5, 61],
        [4, 45],
        [8, 39],
        [15, 50],
        [38, 51],
        [6, 23],
        [12, 17],
        [8, 21],
        [0, 21],
        [-10, 19],
        [2, 18],
        [6, 28],
        [2, 28],
        [13, 14],
        [16, 6],
        [4, 10],
        [0, 22],
        [14, 5],
        [4, 18],
        [12, 5],
        [4, -1],
        [2, 9],
        [-1, 27],
        [5, 4],
        [12, 14],
        [2, 26],
        [0, 15],
        [-14, 41],
        [0, 41],
        [6, 11],
        [10, 33],
        [8, 99],
        [48, 49],
        [34, 27],
        [24, 1],
        [28, 27],
        [53, 53],
        [35, 30],
        [11, 40],
        [18, 61],
        [14, 26],
        [41, 82],
        [17, 38],
        [8, 39],
        [-2, 64],
        [-9, 32],
        [-10, 14],
        [-38, 18],
        [-89, 45],
        [-57, 34],
        [-17, 26],
        [-3, 43],
        [2, 38],
        [15, 29],
        [23, 41],
        [13, 8],
        [32, 21],
        [20, 11],
        [22, 6],
        [30, 4],
        [17, -2],
        [11, -12],
        [9, -20],
        [23, -14],
        [27, -10],
        [43, 4],
        [26, 8],
        [19, 2],
        [11, -6],
        [16, -10],
        [10, 0],
        [2, 18],
        [7, 21],
        [19, 34],
        [9, 30],
        [12, 44],
        [4, 26],
        [2, 34],
        [2, 29],
        [-6, 29],
        [-14, 7],
        [-13, 32],
        [-4, 45],
        [2, 18],
        [8, 16],
        [7, 20],
        [-17, 31],
        [-33, 27],
        [1, 5],
        [1, 6],
        [1, 5],
        [2, 6],
        [0, 5],
        [1, 6],
        [1, 6],
        [0, 6],
        [0, 5],
        [0, 6],
        [0, 1],
        [0, 2],
        [0, 2],
        [-1, 1],
        [0, 1],
        [-1, 2],
        [0, 1],
        [0, 1],
        [0, 1],
        [-1, 2],
        [-1, 1],
        [0, 1],
        [-1, 1],
        [0, 1],
        [-1, 2],
        [-1, 1],
        [0, 1],
        [-1, 1],
        [-1, 1],
        [-1, 2],
        [-11, 11],
        [-11, 12],
        [-12, 11],
        [-20, 20],
        [-18, 20],
        [-46, 51],
        [-1, 2],
        [-1, 2],
        [-2, 2],
        [-2, 2],
        [0, 1],
        [0, 2],
        [-2, 0],
        [0, 2],
        [0, 1],
        [-2, 1],
        [0, 2],
        [0, 1],
        [0, 1],
        [0, 1],
        [-2, 1],
        [0, 2],
        [-4, 34],
        [-7, 37],
        [0, 14],
        [0, 14],
        [0, 1],
        [0, 2],
        [0, 2],
        [0, 2],
        [0, 2],
        [0, 2],
        [0, 1],
        [0, 1],
        [2, 2],
        [0, 1],
        [0, 1],
        [3, 2],
        [0, 0],
        [0, 1],
        [2, 2],
        [6, 6],
        [6, 5],
        [7, 5],
        [6, 4],
        [7, 5],
        [7, 4],
        [9, 6],
        [11, 5],
        [10, 5],
        [10, 5],
        [9, 4],
        [6, 2],
        [4, 1],
        [4, 2],
        [6, 1],
        [4, 1],
        [4, 2],
        [5, 0],
        [13, 1],
        [12, 2],
        [12, 1],
        [13, 0],
        [6, 1],
        [5, -1],
        [7, 0],
        [6, -1],
        [6, 0],
        [6, -1],
        [46, -6],
        [57, -11],
        [28, -6],
        [13, -2],
        [43, -9],
        [6, -1],
        [8, -1],
        [5, 0],
        [6, -1],
        [6, -1],
        [4, 0],
        [2, 0],
        [7, 0],
        [1, 1],
        [1, 0],
        [2, 1],
        [2, 0],
        [0, 1],
        [1, 1],
        [1, 0],
        [0, 1],
        [1, 1],
        [1, 1],
        [1, 1],
        [1, 1],
        [0, 2],
        [12, 21],
        [0, 1],
        [22, 46],
        [0, 2],
        [2, 1],
        [0, 2],
        [0, 1],
        [2, 2],
        [0, 3],
        [0, 2],
        [0, 3],
        [0, 2],
        [2, 2],
        [0, 3],
        [0, 2],
        [0, 2],
        [0, 3],
        [0, 3],
        [0, 2],
        [0, 2],
        [-2, 3],
        [-2, 12],
        [0, 13],
        [-2, 13],
        [0, 12],
        [0, 14],
        [2, 53],
        [4, 54],
        [2, 46],
        [0, 45],
        [2, 15],
        [-2, 17],
        [0, 6],
        [0, 6],
        [0, 6],
        [-2, 3],
        [0, 2],
        [0, 4],
        [0, 2],
        [-2, 3],
        [0, 2],
        [-2, 3],
        [0, 2],
        [-2, 2],
        [0, 3],
        [-2, 2],
        [0, 2],
        [-2, 2],
        [-2, 2],
        [-2, 2],
        [0, 2],
        [-2, 2],
        [-1, 2],
        [-9, 9],
        [-8, 10],
        [-8, 10],
        [-8, 11],
        [-7, 10],
        [-7, 11],
        [-6, 11],
        [-6, 12],
        [-18, 35],
        [-18, 39],
        [-2, 3],
        [0, 3],
        [-1, 4],
        [-2, 2],
        [-1, 4],
        [0, 3],
        [-2, 3],
        [0, 3],
        [0, 4],
        [-1, 3],
        [0, 3],
        [0, 4],
        [0, 31],
        [0, 30],
        [1, 18],
        [1, 18],
        [2, 18],
        [3, 19],
        [4, 17],
        [4, 18],
        [0, 5],
        [2, 5],
        [2, 5],
        [2, 5],
        [2, 4],
        [2, 5],
        [2, 5],
        [2, 4],
        [4, 5],
        [2, 4],
        [2, 4],
        [2, 2],
        [2, 0],
        [0, 2],
        [0, 0],
        [1, 2],
        [1, 0],
        [1, 2],
        [1, 0],
        [1, 0],
        [2, 2],
        [0, 0],
        [2, 0],
        [1, 2],
        [1, 0],
        [1, 0],
        [1, 2],
        [2, 0],
        [1, 0],
        [1, 0],
        [2, 0],
        [1, 2],
        [3, 0],
        [3, 0],
        [4, 0],
        [4, 2],
        [4, 0],
        [1, 0],
        [1, 0],
        [2, 0],
        [2, -2],
        [1, 0],
        [1, 0],
        [2, 0],
        [1, 0],
        [19, -4],
        [18, -6],
        [23, -6],
        [22, -8],
        [45, -15],
        [65, -23],
        [16, -6],
        [13, -6],
        [15, -7],
        [13, -6],
        [30, -13],
        [31, -12],
        [3, -2],
        [3, 0],
        [4, -3],
        [4, 0],
        [3, 0],
        [3, -2],
        [4, 0],
        [4, 0],
        [3, 0],
        [5, 0],
        [6, 0],
        [6, 0],
        [6, 0],
        [6, 0],
        [6, 2],
        [5, 0],
        [2, 0],
        [2, 3],
        [3, 0],
        [3, 0],
        [2, 2],
        [2, 0],
        [2, 1],
        [3, 1],
        [2, 1],
        [2, 1],
        [2, 1],
        [2, 1],
        [2, 2],
        [2, 2],
        [2, 1],
        [2, 1],
        [2, 2],
        [2, 2],
        [2, 2],
        [1, 2],
        [2, 2],
        [1, 1],
        [2, 2],
        [1, 2],
        [1, 3],
        [2, 2],
        [1, 2],
        [1, 2],
        [1, 3],
        [1, 2],
        [2, 4],
        [1, 4],
        [1, 4],
        [1, 5],
        [2, 3],
        [0, 4],
        [1, 5],
        [0, 5],
        [0, 4],
        [0, 3],
        [0, 2],
        [0, 4],
        [0, 2],
        [0, 4],
        [0, 2],
        [0, 2],
        [0, 4],
        [-1, 2],
        [0, 4],
        [-1, 2],
        [-6, 21],
        [-8, 22],
        [-12, 32],
        [-12, 32],
        [-11, 23],
        [-11, 23],
        [-12, 23],
        [-12, 23],
        [-4, 7],
        [-4, 7],
        [-2, 7],
        [-3, 7],
        [-2, 7],
        [-3, 7],
        [-2, 8],
        [-1, 4],
        [-1, 4],
        [-1, 6],
        [-1, 4],
        [-16, 105],
        [-9, 68],
        [-6, 65],
        [-2, 16],
        [0, 16],
        [0, 16],
        [0, 14],
        [1, 4],
        [0, 4],
        [1, 5],
        [0, 4],
        [2, 5],
        [0, 4],
        [2, 5],
        [1, 4],
        [1, 4],
        [1, 3],
        [2, 5],
        [2, 4],
        [2, 3],
        [2, 4],
        [2, 4],
        [10, 14],
        [9, 13],
        [9, 12],
        [10, 14],
        [10, 12],
        [10, 12],
        [11, 12],
        [12, 10],
        [21, 20],
        [22, 21],
        [24, 19],
        [25, 20],
        [7, 5],
        [6, 4],
        [7, 4],
        [7, 4],
        [7, 4],
        [8, 4],
        [7, 4],
        [7, 4],
        [8, 2],
        [8, 4],
        [8, 2],
        [7, 2],
        [4, 2],
        [3, 0],
        [3, 2],
        [4, 2],
        [3, 0],
        [3, 2],
        [3, 2],
        [4, 2],
        [3, 2],
        [3, 2],
        [3, 2],
        [3, 2],
        [3, 2],
        [3, 2],
        [2, 4],
        [3, 2],
        [3, 2],
        [2, 3],
        [2, 4],
        [3, 3],
        [3, 4],
        [2, 4],
        [2, 4],
        [2, 4],
        [2, 3],
        [2, 4],
        [2, 4],
        [2, 5],
        [2, 4],
        [2, 12],
        [4, 10],
        [2, 12],
        [5, 11],
        [2, 10],
        [0, 10],
        [2, 11],
        [6, 82],
        [1, 29],
        [1, 26],
        [0, 21],
        [-1, 21],
        [-1, 21],
        [-2, 37],
        [-1, 38],
        [0, 13],
        [1, 12],
        [1, 10],
        [1, 12],
        [2, 12],
        [2, 11],
        [3, 16],
        [4, 15],
        [4, 16],
        [4, 14],
        [5, 16],
        [2, 5],
        [2, 5],
        [3, 5],
        [3, 5],
        [2, 6],
        [4, 5],
        [2, 5],
        [4, 6],
        [4, 5],
        [3, 4],
        [4, 5],
        [4, 4],
        [4, 5],
        [4, 3],
        [4, 4],
        [5, 4],
        [4, 4],
        [5, 4],
        [5, 3],
        [3, 3],
        [6, 3],
        [6, 3],
        [4, 3],
        [6, 2],
        [6, 2],
        [4, 2],
        [7, 3],
        [6, 2],
        [6, 1],
        [7, 2],
        [6, 1],
        [7, 1],
        [7, 1],
        [7, 0],
        [7, 0],
        [5, 2],
        [6, 0],
        [4, 0],
        [6, 2],
        [6, 0],
        [6, 2],
        [4, 0],
        [5, 2],
        [5, 2],
        [5, 2],
        [10, 4],
        [9, 4],
        [9, 4],
        [2, 2],
        [3, 2],
        [2, 0],
        [2, 2],
        [3, 1],
        [1, 2],
        [2, 1],
        [2, 1],
        [1, 1],
        [1, 2],
        [1, 1],
        [2, 2],
        [1, 1],
        [0, 1],
        [2, 2],
        [0, 1],
        [2, 2],
        [0, 2],
        [2, 2],
        [0, 1],
        [2, 2],
        [4, 7],
        [4, 8],
        [2, 8],
        [4, 8],
        [2, 8],
        [4, 8],
        [2, 9],
        [2, 8],
        [1, 8],
        [1, 8],
        [3, 16],
        [4, 16],
        [2, 18],
        [0, 0],
        [0, 2],
        [0, 2],
        [0, 0],
        [0, 2],
        [0, 2],
        [0, 2],
        [0, 0],
        [-1, 2],
        [0, 2],
        [-1, 1],
        [0, 1],
        [0, 1],
        [0, 2],
        [-1, 1],
        [0, 1],
        [-1, 1],
        [0, 1],
        [-1, 2],
        [0, 1],
        [-1, 1],
        [0, 1],
        [-2, 1],
        [0, 1],
        [-1, 1],
        [-1, 1],
        [0, 1],
        [-3, 3],
        [-4, 4],
        [-2, 4],
        [-4, 2],
        [-4, 3],
        [-2, 4],
        [-6, 2],
        [-6, 4],
        [-6, 2],
        [-6, 3],
        [-1, 1],
        [-1, 0],
        [-2, 0],
        [-1, 1],
        [-1, 0],
        [-2, 1],
        [-1, 1],
        [-1, 0],
        [-2, 1],
        [-1, 1],
        [-1, 1],
        [-2, 1],
        [-1, 1],
        [-1, 1],
        [-4, 4],
        [-4, 4],
        [-3, 3],
        [-4, 5],
        [-4, 5],
        [-2, 3],
        [-4, 3],
        [-2, 4],
        [-2, 4],
        [-3, 4],
        [-5, 10],
        [-5, 10],
        [-24, 47],
        [-4, 8],
        [-3, 10],
        [-4, 10],
        [-3, 10],
        [-2, 5],
        [-1, 5],
        [-3, 4],
        [-2, 5],
        [-2, 4],
        [-3, 4],
        [0, 2],
        [-1, 1],
        [-1, 1],
        [0, 1],
        [-1, 1],
        [-1, 1],
        [-1, 0],
        [-1, 2],
        [-1, 0],
        [-1, 2],
        [-1, 0],
        [-1, 2],
        [-1, 0],
        [-1, 0],
        [-2, 2],
        [-1, 0],
        [-1, 2],
        [-1, 0],
        [-1, 0],
        [-1, 0],
        [-1, 0],
        [-1, 0],
        [-2, 2],
        [-2, 0],
        [-1, 0],
        [-2, 0],
        [-2, -2],
        [-2, 0],
        [-2, 0],
        [-2, 0],
        [-2, 0],
        [-2, -2],
        [-8, -2],
        [-8, -2],
        [-8, -4],
        [-6, -1],
        [-4, -2],
        [-5, -3],
        [-5, -3],
        [-5, -2],
        [-5, -3],
        [-4, -2],
        [-4, -2],
        [-5, -2],
        [-5, -2],
        [-2, 0],
        [-2, -1],
        [-1, -1],
        [-3, 0],
        [-2, 0],
        [-2, 0],
        [-2, -1],
        [-2, 0],
        [-2, 0],
        [-2, -1],
        [-5, 0],
        [-4, 0],
        [-5, 1],
        [-4, 0],
        [-4, 1],
        [-5, 0],
        [-4, 1],
        [-3, 1],
        [-2, 0],
        [-2, 0],
        [-3, 1],
        [-2, 1],
        [-2, 1],
        [-2, 1],
        [-3, 1],
        [-2, 1],
        [-2, 1],
        [-2, 1],
        [-2, 1],
        [-2, 1],
        [0, 1],
        [-2, 1],
        [0, 1],
        [-2, 1],
        [0, 1],
        [0, 2],
        [-2, 1],
        [0, 1],
        [0, 2],
        [0, 1],
        [-2, 2],
        [0, 0],
        [0, 2],
        [0, 2],
        [0, 0],
        [0, 2],
        [0, 2],
        [0, 2],
        [0, 0],
        [0, 3],
        [0, 5],
        [0, 6],
        [2, 5],
        [0, 7],
        [2, 6],
        [2, 6],
        [4, 14],
        [4, 14],
        [4, 14],
        [7, 14],
        [5, 13],
        [4, 10],
        [4, 10],
        [4, 12],
        [4, 10],
        [3, 10],
        [2, 11],
        [12, 56],
        [1, 1],
        [0, 1],
        [0, 2],
        [0, 1],
        [0, 1],
        [0, 2],
        [0, 1],
        [-2, 63],
        [-3, 105],
        [0, 1],
        [0, 1],
        [0, 1],
        [-1, 2],
        [0, 1],
        [0, 1],
        [-1, 2],
        [0, 1],
        [0, 1],
        [-1, 1],
        [0, 1],
        [-1, 2],
        [0, 1],
        [-1, 1],
        [-1, 2],
        [-2, 1],
        [0, 2],
        [-1, 0],
        [-2, 1],
        [-2, 1],
        [0, 1],
        [-2, 0],
        [-2, 1],
        [-2, 1],
        [-1, 1],
        [-2, 0],
        [-2, 1],
        [-2, 0],
        [-4, 2],
        [-4, 0],
        [-4, 1],
        [-5, 1],
        [-20, 2],
        [-18, 2],
        [-3, 1],
        [-3, 0],
        [-2, 0],
        [-3, 0],
        [-47, -1],
        [-24, -1],
        [0, 1],
        [-2, 0],
        [-2, 3],
        [0, 2],
        [-1, 2],
        [-2, 3],
        [-1, 3],
        [-1, 2],
        [-2, 7],
        [-3, 7],
        [-2, 7],
        [0, 2],
        [0, 1],
        [0, 1],
        [-1, 2],
        [-1, 19],
        [-1, 46],
        [0, 0],
        [0, 2],
        [-1, 0],
        [0, 2],
        [-2, 2],
        [-2, 2],
        [-2, 2],
        [-1, 2],
        [-2, 2],
        [-2, 0],
        [-5, 6],
        [-5, 4],
        [-2, 2],
        [-2, 2],
        [-2, 0],
        [-4, 4],
        [-5, 2],
        [-4, 2],
        [-11, 8],
        [-12, 6],
        [-10, 6],
        [-10, 7],
        [-8, 7],
        [-2, 1],
        [-2, 1],
        [-1, 1],
        [-1, 2],
        [-1, 1],
        [-1, 1],
        [-2, 2],
        [-1, 2],
        [-1, 0],
        [0, 1],
        [-1, 1],
        [0, 1],
        [-1, 1],
        [-1, 5],
        [-1, 6],
        [-2, 4],
        [0, 5],
        [-2, 7],
        [0, 7],
        [-1, 6],
        [0, 7],
        [-1, 2],
        [1, 2],
        [0, 2],
        [0, 2],
        [0, 2],
        [1, 2],
        [0, 2],
        [1, 6],
        [1, 5],
        [2, 6],
        [2, 4],
        [1, 4],
        [5, 14],
        [6, 12],
        [5, 12],
        [11, 22],
        [2, 3],
        [2, 3],
        [4, 7],
        [4, 7],
        [4, 7],
        [16, 22],
        [16, 21],
        [17, 28],
        [17, 29],
        [3, 6],
        [3, 6],
        [3, 6],
        [2, 6],
        [2, 3],
        [0, 3],
        [2, 4],
        [2, 3],
        [0, 3],
        [0, 4],
        [2, 3],
        [0, 3],
        [0, 3],
        [2, 4],
        [0, 3],
        [0, 3],
        [0, 3],
        [0, 3],
        [-2, 45],
        [0, 18],
        [0, 1],
        [-2, 1],
        [-7, 6],
        [-7, 5],
        [-7, 7],
        [-3, 2],
        [-2, 1],
        [-3, 2],
        [-3, 1],
        [-3, 1],
        [-3, 2],
        [-3, 1],
        [-3, 1],
        [-3, 1],
        [-3, 1],
        [-3, 1],
        [-3, 1],
        [-3, 0],
        [-4, 0],
        [-2, 1],
        [-5, 0],
        [-3, 0],
        [-2, 0],
        [-4, 0],
        [-4, 0],
        [-2, 0],
        [-4, -1],
        [-2, 0],
        [-4, -1],
        [-2, 0],
        [-2, -1],
        [-2, 0],
        [-2, 0],
        [-2, 0],
        [-2, 0],
        [-2, 0],
        [-2, 0],
        [-2, 0],
        [-2, 0],
        [-2, 1],
        [-2, 0],
        [-2, 1],
        [-2, 0],
        [-2, 0],
        [-2, 1],
        [-2, 1],
        [-2, 1],
        [-2, 1],
        [-2, 0],
        [-2, 2],
        [-2, 1],
        [-2, 1],
        [-2, 1],
        [-1, 1],
        [-2, 1],
        [-1, 2],
        [-2, 1],
        [-1, 1],
        [-2, 2],
        [-4, 4],
        [-3, 4],
        [-4, 4],
        [-3, 4],
        [-4, 4],
        [-1, 6],
        [-4, 4],
        [-2, 4],
        [-4, 4],
        [-4, 6],
        [-4, 4],
        [-2, 2],
        [-13, 14],
        [-14, 12],
        [-6, 6],
        [-7, 6],
        [-6, 4],
        [-4, 2],
        [-4, 4],
        [-5, 2],
        [-4, 3],
        [-5, 2],
        [-5, 2],
        [-5, 2],
        [-3, 2],
        [-6, 2],
        [-4, 2],
        [-4, 1],
        [-4, 1],
        [-4, 1],
        [-4, 1],
        [-4, 0],
        [-4, 1],
        [-4, 1],
        [-4, 0],
        [-5, 0],
        [-7, 0],
        [-7, 0],
        [-7, 0],
        [-8, -1],
        [-8, 0],
        [-8, -1],
        [-12, 1],
        [-12, 1],
        [-13, 1],
        [-6, 1],
        [-7, 0],
        [-7, 1],
        [-7, 2],
        [-2, 0],
        [-2, 1],
        [-2, 0],
        [-1, 1],
        [-2, 0],
        [-2, 1],
        [-1, 1],
        [-2, 1],
        [-1, 1],
        [-3, 1],
        [-2, 1],
        [-2, 1],
        [-6, 5],
        [-6, 5],
        [-6, 5],
        [-5, 5],
        [-6, 5],
        [-5, 6],
        [-5, 5],
        [-4, 6],
        [-5, 6],
        [-4, 6],
        [-4, 6],
        [-4, 6],
        [-4, 6],
        [-4, 7],
        [-2, 2],
        [0, 3],
        [-2, 2],
        [-2, 3],
        [0, 3],
        [-2, 3],
        [0, 3],
        [0, 3],
        [-2, 3],
        [0, 3],
        [0, 3],
        [0, 3],
        [-2, 9],
        [0, 10],
        [0, 24],
        [0, 26],
        [2, 24],
        [0, 4],
        [0, 2],
        [2, 3],
        [0, 2],
        [0, 4],
        [2, 2],
        [0, 2],
        [0, 2],
        [2, 2],
        [0, 1],
        [2, 1],
        [0, 2],
        [2, 1],
        [0, 1],
        [2, 1],
        [0, 1],
        [2, 1],
        [2, 2],
        [2, 2],
        [0, 1],
        [2, 1],
        [0, 1],
        [0, 1],
        [2, 2],
        [0, 2],
        [2, 1],
        [0, 3],
        [2, 4],
        [2, 3],
        [0, 4],
        [1, 4],
        [1, 5],
        [1, 7],
        [2, 6],
        [0, 6],
        [2, 5],
        [0, 6],
        [0, 6],
        [0, 8],
        [0, 6],
        [0, 4],
        [0, 6],
        [-1, 6],
        [-1, 6],
        [-1, 6],
        [-1, 4],
        [0, 3],
        [-2, 2],
        [0, 4],
        [-1, 2],
        [0, 2],
        [-2, 2],
        [0, 2],
        [-2, 2],
        [0, 0],
        [-2, 0],
        [0, 2],
        [-2, 0],
        [0, 0],
        [-2, 1],
        [-2, 1],
        [-2, 0],
        [-2, 0],
        [-4, 1],
        [-4, 1],
        [-2, 0],
        [-4, 0],
        [-5, 0],
        [-5, 0],
        [-6, 0],
        [-1, 0],
        [-2, 0],
        [-2, 0],
        [-2, -1],
        [-2, 0],
        [-1, 0],
        [-2, -1],
        [-1, 0],
        [-2, -1],
        [-1, -1],
        [-1, 0],
        [-1, 0],
        [-2, -2],
        [-1, 0],
        [-1, -2],
        [-1, 0],
        [-1, -2],
        [-1, 0],
        [-1, 0],
        [-1, 0],
        [-1, -2],
        [-1, 0],
        [-2, 0],
        [-1, 0],
        [-20, 0],
        [-34, -2],
        [-4, 0],
        [-3, 0],
        [-2, 0],
        [-4, 0],
        [-2, 0],
        [-4, 2],
        [-3, 0],
        [-3, 0],
        [-2, 2],
        [-4, 0],
        [-2, 2],
        [-4, 0],
        [-2, 2],
        [-3, 0],
        [-1, 2],
        [-1, 0],
        [-2, 0],
        [-1, 1],
        [-1, 1],
        [-2, 1],
        [0, 1],
        [-2, 1],
        [-1, 1],
        [-1, 1],
        [-1, 1],
        [-1, 1],
        [-1, 1],
        [-1, 1],
        [-1, 1],
        [-1, 1],
        [0, 2],
        [-1, 1],
        [-1, 1],
        [0, 2],
        [-3, 6],
        [-2, 5],
        [-16, 41],
        [-8, 21],
        [-8, 24],
        [-6, 22],
        [-4, 11],
        [-4, 12],
        [-4, 12],
        [-5, 11],
        [-1, 2],
        [-2, 2],
        [0, 2],
        [-2, 3],
        [-1, 2],
        [-2, 2],
        [-1, 2],
        [-2, 2],
        [-2, 2],
        [-1, 2],
        [-2, 2],
        [-2, 2],
        [-2, 1],
        [-2, 2],
        [-2, 1],
        [-2, 2],
        [-2, 1],
        [-12, 8],
        [-13, 8],
        [-12, 7],
        [-14, 6],
        [-14, 7],
        [-13, 5],
        [-14, 5],
        [-13, 4],
        [-11, 4],
        [-12, 3],
        [-14, 3],
        [-11, 2],
        [-13, 2],
        [-12, 2],
        [-10, 2],
        [-9, 1],
        [-10, 2],
        [-9, 2],
        [-10, 2],
        [-11, 4],
        [-8, 2],
        [-9, 4],
        [-23, 9],
        [-21, 10],
        [-22, 12],
        [-3, 2],
        [-3, 2],
        [-3, 2],
        [-3, 2],
        [-3, 2],
        [-3, 2],
        [-3, 3],
        [-2, 2],
        [-5, 4],
        [-4, 5],
        [-4, 3],
        [-4, 4],
        [-4, 6],
        [-2, 4],
        [-4, 6],
        [-12, 18],
        [-13, 18],
        [-14, 19],
        [-15, 17],
        [-37, 44],
        [-38, 41],
        [-39, 42],
        [-41, 39],
        [-44, 38],
        [-43, 37],
        [-19, 17],
        [-20, 17],
        [-18, 18],
        [-19, 18],
        [-18, 20],
        [-16, 20],
        [-16, 20],
        [-17, 19],
        [-15, 23],
        [-8, 13],
        [-7, 13],
        [-6, 10],
        [-6, 10],
        [-2, 2],
        [-2, 4],
        [0, 2],
        [-2, 4],
        [0, 3],
        [-2, 2],
        [0, 4],
        [-2, 4],
        [0, 2],
        [0, 4],
        [-2, 4],
        [0, 2],
        [0, 4],
        [0, 2],
        [0, 4],
        [0, 4],
        [0, 4],
        [0, 2],
        [2, 4],
        [0, 2],
        [-2, 4],
        [0, 2],
        [0, 4],
        [0, 2],
        [0, 2],
        [0, 4],
        [-2, 2],
        [0, 4],
        [-2, 2],
        [0, 4],
        [-2, 2],
        [0, 4],
        [-2, 1],
        [-1, 3],
        [-1, 3],
        [-4, 8],
        [-6, 9],
        [-5, 8],
        [-6, 8],
        [-5, 7],
        [-19, 22],
        [-18, 22],
        [-20, 20],
        [-33, 32],
        [-31, 31],
        [-13, 12],
        [-15, 13],
        [-14, 12],
        [-7, 5],
        [-8, 5],
        [-6, 4],
        [-8, 4],
        [-8, 6],
        [-8, 4],
        [-8, 4],
        [-8, 4],
        [-9, 2],
        [-9, 4],
        [-10, 3],
        [-10, 3],
        [-10, 5],
        [-11, 5],
        [-10, 5],
        [-10, 5],
        [-8, 5],
        [-10, 7],
        [-8, 6],
        [-8, 6],
        [-8, 6],
        [-7, 6],
        [-8, 7],
        [-6, 7],
        [-3, 3],
        [-2, 2],
        [-2, 2],
        [-4, 3],
        [-2, 2],
        [-4, 2],
        [-2, 2],
        [-4, 2],
        [-6, 2],
        [-4, 2],
        [-5, 2],
        [-14, 6],
        [-15, 6],
        [-8, 4],
        [-9, 2],
        [-8, 3],
        [-9, 4],
        [-9, 2],
        [-2, 0],
        [0, 0],
        [-2, 0],
        [0, 0],
        [-2, 0],
        [-2, -2],
        [-2, 0],
        [0, 0],
        [-2, -2],
        [-2, 0],
        [-2, 0],
        [-8, -7],
        [-6, -6],
        [-12, -6],
        [-12, -8],
        [0, -2],
        [-2, -2],
        [-1, -4],
        [-1, -4],
        [-10, -34],
        [-7, -23],
        [-4, -14],
        [-1, -3],
        [-1, -4],
        [0, -3],
        [-1, -3],
        [-1, -2],
        [0, -6],
        [-1, -6],
        [0, -6],
        [0, -6],
        [0, -4],
        [0, -2],
        [1, -3],
        [0, -3],
        [0, -3],
        [0, -1],
        [1, -2],
        [1, -2],
        [0, -1],
        [0, -1],
        [1, -1],
        [0, -1],
        [1, -1],
        [1, -2],
        [1, -3],
        [0, -2],
        [2, -1],
        [1, -1],
        [1, -2],
        [1, -2],
        [1, -1],
        [1, -1],
        [1, -1],
        [1, -1],
        [1, -1],
        [2, -1],
        [0, -1],
        [2, 0],
        [0, -1],
        [1, -1],
        [1, -2],
        [1, 0],
        [0, -1],
        [1, -1],
        [1, 0],
        [0, -2],
        [1, 0],
        [1, -1],
        [0, -1],
        [0, -1],
        [1, -1],
        [0, -1],
        [1, -1],
        [0, -2],
        [0, -2],
        [1, -1],
        [0, -1],
        [0, -3],
        [0, -2],
        [0, -4],
        [-1, -2],
        [0, -2],
        [0, -3],
        [0, -2],
        [-1, -2],
        [-1, -2],
        [0, -2],
        [-1, -3],
        [-1, -1],
        [0, -1],
        [0, -1],
        [-1, -2],
        [-1, 0],
        [0, -1],
        [-2, -1],
        [-1, -2],
        [-1, -1],
        [-1, 0],
        [-1, -2],
        [-1, 0],
        [-1, -1],
        [-2, -1],
        [-1, 0],
        [-1, 0],
        [-3, -2],
        [-2, 0],
        [-1, -1],
        [-1, 0],
        [-1, -1],
        [-1, 0],
        [-2, 0],
        [-2, 0],
        [-1, 0],
        [-1, 0],
        [-2, -1],
        [-1, 0],
        [-2, -1],
        [0, 0],
        [-2, 0],
        [-2, -1],
        [0, -1],
        [-2, 0],
        [0, 0],
        [-2, -2],
        [-2, 0],
        [0, 0],
        [-2, -2],
        [0, 0],
        [-8, -6],
        [-8, -6],
        [-6, -6],
        [-6, -6],
        [-6, -7],
        [-6, -6],
        [-1, -1],
        [-1, -1],
        [-1, -1],
        [-1, -1],
        [0, -1],
        [-1, -1],
        [0, -1],
        [-1, -1],
        [0, -1],
        [0, -1],
        [0, -1],
        [-1, -1],
        [0, -3],
        [-1, -3],
        [0, -3],
        [0, -3],
        [-1, -3],
        [0, -3],
        [0, -3],
        [0, -3],
        [1, -6],
        [0, -6],
        [0, -4],
        [1, -4],
        [0, -2],
        [1, -3],
        [1, -4],
        [1, -2],
        [0, -2],
        [1, -2],
        [1, -1],
        [0, -2],
        [1, -2],
        [1, 0],
        [1, -2],
        [1, -2],
        [0, -2],
        [2, 0],
        [0, -2],
        [2, -2],
        [1, 0],
        [1, -2],
        [2, -2],
        [0, 0],
        [2, -2],
        [1, 0],
        [1, 0],
        [1, 0],
        [4, -2],
        [7, -2],
        [8, -2],
        [4, -2],
        [2, -2],
        [0, 0],
        [0, -2],
        [0, 0],
        [0, -2],
        [0, 0],
        [-2, -2],
        [-2, -2],
        [0, -2],
        [-2, 0],
        [0, -2],
        [-6, -4],
        [-4, -4],
        [-19, -16],
        [-17, -16],
        [-16, -15],
        [-1, -2],
        [-2, -1],
        [-3, -2],
        [-1, -2],
        [-1, -2],
        [-2, -2],
        [0, -1],
        [-1, -1],
        [-1, -1],
        [0, -1],
        [-1, -2],
        [-1, -2],
        [0, -1],
        [-1, -2],
        [0, -1],
        [-1, -2],
        [0, -1],
        [0, -2],
        [-1, -5],
        [-1, -5],
        [0, -3],
        [0, -2],
        [0, -2],
        [0, -4],
        [0, -3],
        [0, -3],
        [0, -5],
        [0, -3],
        [0, -2],
        [0, -4],
        [0, -2],
        [0, -5],
        [0, -4],
        [0, -8],
        [-2, -6],
        [0, -2],
        [0, -4],
        [-1, -2],
        [-1, -4],
        [0, -2],
        [-1, -4],
        [-1, -2],
        [-1, -2],
        [0, 0],
        [0, -2],
        [-2, -1],
        [-2, -2],
        [-1, -3],
        [-2, -2],
        [-1, -1],
        [0, -1],
        [-1, -1],
        [-1, -1],
        [-1, -1],
        [-1, 0],
        [-1, -1],
        [-1, -1],
        [-1, -1],
        [-1, 0],
        [-1, -1],
        [-2, -1],
        [-3, -2],
        [-2, -1],
        [-3, -1],
        [-2, -1],
        [-2, -1],
        [-4, -1],
        [0, -1],
        [-2, 0],
        [-2, 0],
        [0, 0],
        [-2, -1],
        [-2, 0],
        [0, 0],
        [-2, 0],
        [-2, -1],
        [0, 0],
        [-2, 0],
        [-2, 1],
        [-2, 0],
        [-2, 0],
        [-2, 0],
        [0, 1],
        [-2, 0],
        [-1, 0],
        [-1, 0],
        [-1, 1],
        [-1, 1],
        [-1, 0],
        [-1, 1],
        [-1, 1],
        [-1, 0],
        [-1, 1],
        [-1, 1],
        [-1, 2],
        [-1, 1],
        [0, 1],
        [-1, 1],
        [-1, 1],
        [0, 1],
        [-1, 1],
        [-1, 1],
        [0, 2],
        [-1, 0],
        [-1, 2],
        [-1, 2],
        [-1, 0],
        [-1, 1],
        [-1, 1],
        [-1, 1],
        [-1, 1],
        [-1, 0],
        [-1, 1],
        [-1, 0],
        [-1, 0],
        [-2, 2],
        [-1, 0],
        [-1, 0],
        [-2, 2],
        [-1, 0],
        [-1, 0],
        [-2, 2],
        [-1, 0],
        [-2, 0],
        [-2, 0],
        [-1, 0],
        [-1, 0],
        [-2, 0],
        [-2, 0],
        [-1, 0],
        [-2, 0],
        [-1, 0],
        [-2, 0],
        [-2, 0],
        [-1, 0],
        [-2, 0],
        [-1, 0],
        [-2, 0],
        [-1, 0],
        [0, 0],
        [-2, -2],
        [-2, 0],
        [0, 0],
        [-2, 0],
        [-2, 0],
        [0, 0],
        [-2, 0],
        [-2, 2],
        [0, 0],
        [-2, 0],
        [-2, 0],
        [0, 0],
        [-2, 0],
        [-2, 2],
        [0, 0],
        [-2, 0],
        [-2, 0],
        [0, 2],
        [-2, 0],
        [0, 0],
        [-2, 2],
        [-2, 0],
        [0, 2],
        [-2, 0],
        [-1, 2],
        [-1, 0],
        [-1, 2],
        [-2, 2],
        [-1, 0],
        [-1, 0],
        [-1, 2],
        [0, 2],
        [-2, 2],
        [0, 0],
        [-1, 2],
        [-2, 0],
        [-1, 2],
        [-1, 0],
        [0, 2],
        [-1, 2],
        [-1, 0],
        [-1, 0],
        [-1, 2],
        [-1, 0],
        [-1, 2],
        [-2, 0],
        [0, 2],
        [-2, 0],
        [-1, 0],
        [-1, 2],
        [-6, 2],
        [-5, 2],
        [-5, 3],
        [-6, 2],
        [-5, 2],
        [-6, 2],
        [-6, 2],
        [-3, 1],
        [-4, 0],
        [-2, 1],
        [-4, 1],
        [-4, 0],
        [-2, 0],
        [-4, 0],
        [-4, 0],
        [-4, 0],
        [-39, -1],
        [-37, -1],
        [0, 0],
        [-2, -1],
        [0, -1],
        [0, -1],
        [0, -1],
        [0, -1],
        [0, -2],
        [0, -1],
        [0, -1],
        [0, -1],
        [2, -1],
        [0, -1],
        [0, 0],
        [2, -2],
        [2, -2],
        [0, -2],
        [2, -2],
        [1, -2],
        [2, 0],
        [2, -2],
        [2, -2],
        [2, -2],
        [2, 0],
        [21, -14],
        [6, -4],
        [6, -4],
        [8, -4],
        [24, -14],
        [4, -2],
        [4, -2],
        [4, -1],
        [4, -2],
        [4, -1],
        [2, -2],
        [3, -2],
        [4, -2],
        [1, 0],
        [1, -1],
        [1, -1],
        [1, -1],
        [0, -1],
        [1, -2],
        [0, -1],
        [0, -1],
        [0, -1],
        [0, -1],
        [0, -1],
        [-1, -1],
        [0, -1],
        [0, -1],
        [-1, -1],
        [-1, -1],
        [0, -1],
        [-1, -1],
        [-1, -1],
        [0, -1],
        [0, -1],
        [-1, -2],
        [0, -2],
        [-1, -1],
        [0, -1],
        [0, -1],
        [0, -1],
        [1, -1],
        [0, -2],
        [0, -1],
        [1, -1],
        [0, -2],
        [1, -1],
        [1, -3],
        [2, -2],
        [1, -2],
        [1, -2],
        [2, -2],
        [2, -1],
        [1, -2],
        [2, -2],
        [1, -2],
        [2, -2],
        [2, -2],
        [2, -1],
        [1, -2],
        [2, -2],
        [1, -1],
        [2, -2],
        [1, -2],
        [2, -2],
        [0, -2],
        [2, -3],
        [4, -7],
        [3, -6],
        [3, -9],
        [2, -2],
        [0, -3],
        [2, -2],
        [0, -3],
        [1, -3],
        [1, -1],
        [0, -2],
        [0, -2],
        [0, -2],
        [0, -2],
        [1, -1],
        [0, -2],
        [0, -1],
        [0, -2],
        [0, -1],
        [-1, -2],
        [0, -2],
        [0, -2],
        [0, -2],
        [-1, -2],
        [0, -1],
        [-1, -1],
        [0, -2],
        [-1, -2],
        [-1, -1],
        [-1, -2],
        [-1, -1],
        [0, -1],
        [-1, -1],
        [-3, -5],
        [-4, -4],
        [-4, -5],
        [-5, -4],
        [-4, -4],
        [-4, -4],
        [-5, -4],
        [-5, -3],
        [-5, -4],
        [-5, -4],
        [-2, -1],
        [-1, -1],
        [-2, 0],
        [0, -2],
        [-2, 0],
        [-2, -1],
        [-2, -1],
        [-2, 0],
        [0, 0],
        [-2, 0],
        [-2, 0],
        [0, 0],
        [-2, -2],
        [-2, 0],
        [0, 0],
        [-2, 2],
        [-2, 0],
        [0, 0],
        [-2, 0],
        [-2, 0],
        [0, 0],
        [-2, 1],
        [-2, 0],
        [0, 0],
        [-2, 0],
        [-1, 0],
        [-2, 0],
        [-2, -1],
        [-1, 0],
        [-2, 0],
        [-2, -2],
        [-3, -2],
        [-3, 0],
        [-2, -2],
        [-2, -2],
        [-3, -2],
        [-3, -2],
        [-3, -2],
        [-3, -2],
        [-2, -2],
        [-2, 0],
        [-3, -2],
        [-4, -4],
        [-4, -2],
        [-23, -12],
        [-24, -12],
        [-4, 0],
        [-4, -2],
        [-3, -2],
        [-4, -2],
        [-4, 0],
        [-3, -2],
        [-4, 0],
        [-4, -2],
        [-2, 0],
        [-2, 0],
        [-1, 0],
        [-2, -2],
        [-2, 0],
        [-2, 0],
        [-2, -2],
        [-2, 0],
        [-1, -2],
        [-2, 0],
        [-2, -2],
        [-2, 0],
        [-1, -1],
        [-1, 0],
        [-1, -3],
        [-1, 0],
        [0, -1],
        [-1, -1],
        [-1, -2],
        [0, -1],
        [-1, -1],
        [-1, -1],
        [-1, -2],
        [-1, 0],
        [0, -2],
        [-1, 0],
        [-1, -2],
        [-2, -1],
        [0, -1],
        [-1, -1],
        [-1, -1],
        [-2, -1],
        [-1, -1],
        [-2, -1],
        [-2, -1],
        [0, -1],
        [-2, -1],
        [-2, -1],
        [-2, -1],
        [-2, 0],
        [-2, -1],
        [-2, 0],
        [0, -1],
        [-2, -1],
        [-2, 0],
        [0, -1],
        [-2, -1],
        [-2, 0],
        [0, -1],
        [-2, -1],
        [0, -1],
        [-2, -1],
        [-2, 0],
        [0, -1],
        [0, -1],
        [-2, -2],
        [-1, -1],
        [-2, -2],
        [-1, -1],
        [-1, -2],
        [-1, -2],
        [-2, -1],
        [0, -1],
        [-1, -1],
        [-1, -1],
        [-1, -1],
        [-1, -1],
        [-1, -1],
        [-1, -1],
        [-1, -1],
        [-3, -2],
        [-4, -3],
        [-4, -3],
        [-9, -5],
        [-9, -6],
        [-6, -4],
        [-7, -3],
        [-2, -1],
        [-1, -1],
        [-2, 0],
        [-2, 0],
        [-1, 0],
        [-1, -2],
        [0, 0],
        [-2, 0],
        [-2, 0],
        [0, 0],
        [-2, 0],
        [-2, 0],
        [0, 0],
        [-2, 0],
        [0, 0],
        [-2, 0],
        [-2, 0],
        [0, 0],
        [-2, 0],
        [0, 0],
        [-2, 0],
        [0, 0],
        [-2, 0],
        [-2, 0],
        [0, 0],
        [-7, 2],
        [-4, 1],
        [-4, 1],
        [-4, 1],
        [-5, 0],
        [-5, 1],
        [-5, 1],
        [-5, 0],
        [-5, 0],
        [-5, 0],
        [-33, -1],
        [-17, -1],
        [-10, 0],
        [-13, 0],
        [-18, -1],
        [-7, 4],
        [-6, 4],
        [-8, 4],
        [-4, 3],
        [-1, 0],
        [-1, 1],
        [-1, 0],
        [-1, 1],
        [-1, 0],
        [-2, 0],
        [0, 1],
        [-2, 0],
        [-3, 0],
        [-3, 1],
        [-2, 1],
        [-3, 0],
        [-3, 0],
        [-1, 0],
        [-2, 0],
        [-1, 0],
        [-2, 0],
        [-2, 0],
        [-1, 0],
        [-1, 1],
        [-2, 1],
        [0, 1],
        [0, 1],
        [0, 1],
        [-1, 1],
        [-1, 1],
        [0, 1],
        [-1, 1],
        [-1, 1],
        [-1, 0],
        [-1, 0],
        [-3, 1],
        [-2, 1],
        [-2, 0],
        [-2, 0],
        [-2, 0],
        [-2, 1],
        [-2, 0],
        [-2, 0],
        [-12, -1],
        [-2, 0],
        [-4, 0],
        [-3, -1],
        [-5, -1],
        [-5, -2],
        [-5, -2],
        [-4, -1],
        [-2, -1],
        [-1, 0],
        [-1, 0],
        [-4, -2],
        [-4, -1],
        [-1, -1],
        [-2, 0],
        [-1, 0],
        [-1, -1],
        [-2, 0],
        [-2, -1],
        [-2, 0],
        [-1, 0],
        [-1, 0],
        [-2, 0],
        [-1, 0],
        [-1, 0],
        [-1, 0],
        [-1, 0],
        [-1, 0],
        [-1, 1],
        [-1, 0],
        [-1, 1],
        [-2, 0],
        [-2, 0],
        [0, 1],
        [-2, 1],
        [-1, 0],
        [-1, 1],
        [-1, 1],
        [-1, 0],
        [-1, 0],
        [0, 1],
        [-2, 1],
        [-2, 0],
        [-2, 0],
        [-2, 1],
        [-2, 0],
        [-2, 1],
        [-2, 0],
        [-2, 0],
        [0, 0],
        [-2, 0],
        [-10, 0],
        [-4, -1],
        [-4, 0],
        [-3, -1],
        [-4, 0],
        [-4, -1],
        [-4, -1],
        [-3, -1],
        [-4, -1],
        [-2, -1],
        [-3, -1],
        [-3, -2],
        [-3, -1],
        [-2, -1],
        [-4, -1],
        [-3, -2],
        [-1, -1],
        [-1, -1],
        [-1, -1],
        [-1, -1],
        [-1, -2],
        [-1, -1],
        [0, -1],
        [-1, -1],
        [-1, -1],
        [-2, 0],
        [-7, 0],
        [-12, -1],
        [-2, 0],
        [-2, 1],
        [-4, 0],
        [-2, 1],
        [-4, 1],
        [-2, 1],
        [-2, 1],
        [0, 0],
        [-2, 1],
        [-2, 1],
        [0, 1],
        [-2, 0],
        [-1, 1],
        [-1, 0],
        [-1, 0],
        [-3, 0],
        [-2, 0],
        [-2, 0],
        [-2, -1],
        [-2, 0],
        [-2, -1],
        [-1, 0],
        [-2, 0],
        [-1, -1],
        [-2, -1],
        [-1, 0],
        [-1, 0],
        [0, -1],
        [-1, -1],
        [-1, 0],
        [-1, 0],
        [-1, -1],
        [0, -1],
        [-1, 0],
        [-1, -1],
        [0, -1],
        [-1, -1],
        [-1, -1],
        [0, -1],
        [-1, 0],
        [-1, 0],
        [0, -2],
        [-1, 0],
        [-1, 0],
        [0, -2],
        [-2, 0],
        [-1, -2],
        [-1, 0],
        [-1, -2],
        [-2, 0],
        [-2, -2],
        [-1, 0],
        [-2, -2],
        [-3, 0],
        [-2, -2],
        [-2, -2],
        [-2, 0],
        [-2, -2],
        [-2, -2],
        [-1, 0],
        [-1, -2],
        [-5, -6],
        [-4, -4],
        [-4, -2],
        [-2, -2],
        [-2, -4],
        [-4, -2],
        [-2, -2],
        [-4, 0],
        [-2, -2],
        [-4, -2],
        [-2, -2],
        [-3, -2],
        [-4, -2],
        [-4, 0],
        [-5, -2],
        [-4, -2],
        [-4, 0],
        [-5, -2],
        [-6, 0],
        [-4, -2],
        [-5, 0],
        [-9, 44],
        [36, 43],
        [11, 68],
        [38, 56],
        [19, 49],
        [6, 38],
        [20, 67],
        [25, 71],
        [41, 76],
        [96, 32],
        [26, 52],
        [52, 54],
        [79, 30],
        [64, 43],
        [86, 48],
        [100, 53],
        [72, 63],
        [76, 74],
        [51, 73],
        [-2, 50],
        [-18, 31],
        [-20, -4],
        [-17, -4],
        [-15, -3],
        [-13, -1],
        [-9, -1],
        [-10, -1],
        [-8, 1],
        [-6, 1],
        [-6, 0],
        [-4, 2],
        [-4, 2],
        [-3, 1],
        [-2, 3],
        [-3, 2],
        [-1, 3],
        [-2, 3],
        [-2, 3],
        [-1, 4],
        [-1, 4],
        [-2, 4],
        [-1, 3],
        [-1, 4],
        [-2, 4],
        [-2, 4],
        [-2, 3],
        [-2, 3],
        [-2, 3],
        [-3, 2],
        [-3, 2],
        [-3, 2],
        [-3, 2],
        [-4, 4],
        [-4, 2],
        [-4, 2],
        [-4, 2],
        [-4, 2],
        [-4, 2],
        [-4, 2],
        [-4, 4],
        [-4, 2],
        [-4, 2],
        [-4, 2],
        [-3, 2],
        [-3, 2],
        [-2, 2],
        [-3, 2],
        [-3, 3],
        [-2, 1],
        [-2, 2],
        [-1, 2],
        [-2, 2],
        [-1, 1],
        [-2, 2],
        [-2, 2],
        [-3, 3],
        [-3, 3],
        [-3, 3],
        [-4, 3],
        [-4, 3],
        [-6, 5],
        [-5, 4],
        [-6, 5],
        [-6, 4],
        [-6, 5],
        [-8, 4],
        [-6, 6],
        [-9, 5],
        [-8, 5],
        [-8, 5],
        [-8, 6],
        [-10, 6],
        [-9, 7],
        [-9, 6],
        [-10, 7],
        [-10, 6],
        [-9, 8],
        [-9, 4],
        [-9, 7],
        [-8, 5],
        [-6, 5],
        [-6, 4],
        [-6, 4],
        [-4, 2],
        [-4, 2],
        [-4, 2],
        [-3, 1],
        [-3, 1],
        [-3, 0],
        [-3, 0],
        [-4, 0],
        [-4, 0],
        [-5, -1],
        [-5, -1],
        [-5, -2],
        [-5, -1],
        [-6, -3],
        [-8, -2],
        [-8, -2],
        [-7, -3],
        [-6, -3],
        [-8, -3],
        [-8, -2],
        [-8, -4],
        [-5, -2],
        [-5, -3],
        [-6, -3],
        [-4, -2],
        [-5, -2],
        [-4, -2],
        [-4, -2],
        [-3, -2],
        [-3, -2],
        [-4, -1],
        [-4, -1],
        [-3, -2],
        [-3, -2],
        [-4, -1],
        [-3, -1],
        [-3, -1],
        [-3, 0],
        [-2, 0],
        [-4, 0],
        [-2, 0],
        [-2, 0],
        [-4, 1],
        [-2, 0],
        [-2, 2],
        [-4, 1],
        [-2, 1],
        [-2, 2],
        [-4, 2],
        [-2, 2],
        [-2, 2],
        [-3, 2],
        [-2, 2],
        [-2, 2],
        [-3, 2],
        [-2, 1],
        [-2, 3],
        [-2, 2],
        [-2, 2],
        [-2, 3],
        [-2, 3],
        [-2, 3],
        [-2, 3],
        [-3, 4],
        [-3, 3],
        [-3, 4],
        [-3, 4],
        [-4, 4],
        [-3, 4],
        [-3, 3],
        [-3, 5],
        [-3, 3],
        [-3, 2],
        [-3, 3],
        [-2, 3],
        [-4, 2],
        [-1, 2],
        [-4, 2],
        [-2, 2],
        [-2, 2],
        [-4, 1],
        [-2, 2],
        [-4, 1],
        [-2, 1],
        [-4, 1],
        [-4, 1],
        [-4, 0],
        [-2, 0],
        [-4, -1],
        [-4, -1],
        [-4, 0],
        [-3, -2],
        [-4, -1],
        [-4, -1],
        [-3, -1],
        [-4, -2],
        [-3, -2],
        [-3, -2],
        [-3, -2],
        [-2, -2],
        [-3, -2],
        [-3, -2],
        [-2, -2],
        [-3, -1],
        [-2, -2],
        [-3, -2],
        [-2, -2],
        [-2, -1],
        [-3, -1],
        [-2, -1],
        [-2, -2],
        [-2, 0],
        [-4, -2],
        [-2, 0],
        [-4, -2],
        [-4, 0],
        [-2, -1],
        [-4, -1],
        [-4, 0],
        [-4, 0],
        [-4, 0],
        [-5, 0],
        [-4, 0],
        [-5, 0],
        [-4, 0],
        [-5, 0],
        [-6, 1],
        [-4, 1],
        [-4, 1],
        [-4, 1],
        [-4, 2],
        [-4, 1],
        [-3, 1],
        [-3, 2],
        [-3, 1],
        [-2, 2],
        [-1, 2],
        [-2, 1],
        [-2, 1],
        [0, 1],
        [-2, 2],
        [0, 2],
        [-2, 1],
        [0, 2],
        [-2, 2],
        [0, 2],
        [-2, 3],
        [0, 2],
        [-2, 2],
        [-2, 3],
        [-2, 2],
        [0, 4],
        [-2, 2],
        [-2, 4],
        [-2, 2],
        [-2, 3],
        [-2, 3],
        [-2, 2],
        [-2, 4],
        [-2, 4],
        [-2, 2],
        [-2, 4],
        [-3, 4],
        [-2, 4],
        [-3, 6],
        [-3, 4],
        [-3, 6],
        [-4, 6],
        [-4, 6],
        [-3, 8],
        [-4, 6],
        [-3, 6],
        [-3, 7],
        [-2, 6],
        [-2, 6],
        [-2, 5],
        [-1, 5],
        [-1, 4],
        [0, 4],
        [0, 4],
        [0, 3],
        [0, 3],
        [0, 3],
        [0, 3],
        [1, 2],
        [0, 3],
        [1, 3],
        [0, 3],
        [0, 2],
        [0, 4],
        [-1, 2],
        [-1, 4],
        [0, 3],
        [-1, 4],
        [-1, 4],
        [-1, 2],
        [-1, 4],
        [-2, 2],
        [0, 4],
        [-2, 2],
        [-1, 2],
        [-1, 4],
        [-2, 2],
        [-2, 2],
        [-2, 2],
        [-2, 2],
        [-4, 4],
        [-3, 2],
        [-3, 4],
        [-5, 2],
        [-4, 2],
        [-6, 4],
        [-6, 2],
        [-7, 2],
        [-8, 2],
        [-8, 2],
        [-9, 2],
        [-8, 2],
        [-10, 2],
        [-8, 1],
        [-8, 2],
        [-7, 2],
        [-7, 1],
        [-6, 1],
        [-5, 2],
        [-4, 2],
        [-4, 1],
        [-1, 1],
        [-4, 2],
        [-2, 2],
        [-2, 2],
        [-2, 1],
        [0, 2],
        [-2, 2],
        [0, 3],
        [-2, 2],
        [0, 2],
        [-2, 3],
        [0, 2],
        [0, 2],
        [0, 3],
        [-2, 2],
        [0, 3],
        [0, 2],
        [0, 3],
        [0, 2],
        [0, 2],
        [0, 3],
        [0, 2],
        [2, 2],
        [0, 4],
        [2, 2],
        [0, 4],
        [2, 3],
        [2, 4],
        [2, 4],
        [2, 6],
        [2, 5],
        [4, 4],
        [1, 5],
        [2, 4],
        [2, 3],
        [2, 4],
        [1, 3],
        [1, 2],
        [2, 3],
        [0, 3],
        [1, 2],
        [1, 2],
        [0, 3],
        [0, 2],
        [0, 2],
        [0, 3],
        [0, 3],
        [0, 4],
        [0, 3],
        [0, 4],
        [0, 4],
        [-1, 4],
        [-1, 6],
        [0, 5],
        [-1, 5],
        [-1, 5],
        [0, 6],
        [-1, 4],
        [-1, 5],
        [-1, 4],
        [-1, 3],
        [-1, 3],
        [-1, 3],
        [0, 2],
        [-2, 2],
        [0, 3],
        [-1, 1],
        [0, 4],
        [0, 2],
        [0, 2],
        [0, 2],
        [0, 4],
        [0, 2],
        [0, 4],
        [-2, 4],
        [0, 4],
        [0, 6],
        [0, 4],
        [0, 7],
        [0, 4],
        [0, 6],
        [0, 4],
        [0, 5],
        [0, 4],
        [0, 5],
        [0, 4],
        [0, 4],
        [0, 4],
        [0, 3],
        [2, 3],
        [0, 4],
        [0, 3],
        [0, 3],
        [0, 2],
        [0, 3],
        [-2, 3],
        [0, 3],
        [0, 2],
        [0, 3],
        [0, 3],
        [-2, 3],
        [0, 3],
        [-2, 3],
        [0, 4],
        [-2, 2],
        [-2, 4],
        [-2, 2],
        [0, 2],
        [-2, 4],
        [-2, 2],
        [-2, 2],
        [-2, 2],
        [-2, 2],
        [-4, 2],
        [-2, 2],
        [-2, 2],
        [-2, 2],
        [-3, 0],
        [-2, 2],
        [-3, 0],
        [-3, 0],
        [-3, 0],
        [-3, 2],
        [-3, 0],
        [-3, 0],
        [-3, 0],
        [-4, 0],
        [-4, 0],
        [-4, 0],
        [-4, 0],
        [-5, 0],
        [-4, 0],
        [-6, 0],
        [-4, 0],
        [-5, 0],
        [-6, 2],
        [-4, 0],
        [-7, 0],
        [-4, 0],
        [-4, 0],
        [-4, 0],
        [-2, 0],
        [-4, 0],
        [-3, 0],
        [-2, 0],
        [-3, -2],
        [-4, 0],
        [-3, 0],
        [-4, -2],
        [-3, 0],
        [-4, -2],
        [-4, -2],
        [-4, 0],
        [-5, 0],
        [-4, -2],
        [-4, 0],
        [-4, 0],
        [-4, 0],
        [-4, 0],
        [-4, 0],
        [-3, 0],
        [-4, 2],
        [-4, 0],
        [-2, 2],
        [-4, 0],
        [-4, 2],
        [-2, 2],
        [-4, 2],
        [-4, 4],
        [-4, 2],
        [-3, 4],
        [-5, 2],
        [-4, 4],
        [-5, 4],
        [-5, 4],
        [-6, 4],
        [-5, 6],
        [-6, 4],
        [-5, 6],
        [-5, 4],
        [-5, 7],
        [-5, 5],
        [-5, 5],
        [-4, 5],
        [-5, 6],
        [-4, 5],
        [-6, 4],
        [-4, 5],
        [-2, 4],
        [-4, 4],
        [-4, 3],
        [-3, 3],
        [-4, 4],
        [-3, 3],
        [-4, 3],
        [-4, 3],
        [-4, 3],
        [-4, 2],
        [-4, 3],
        [-5, 3],
        [-4, 3],
        [-4, 2],
        [-4, 4],
        [-4, 2],
        [-3, 2],
        [-3, 4],
        [-4, 2],
        [-3, 2],
        [-4, 2],
        [-2, 4],
        [-4, 0],
        [-4, 2],
        [-4, 2],
        [-4, 1],
        [-4, 0],
        [-4, 1],
        [-4, 1],
        [-3, 0],
        [-4, 0],
        [-5, 1],
        [-4, 1],
        [-5, 0],
        [-5, 1],
        [-4, 0],
        [-5, 1],
        [-4, 0],
        [-4, 1],
        [-5, 1],
        [-4, 0],
        [-4, 0],
        [-4, 1],
        [-5, 0],
        [-3, 0],
        [-4, -1],
        [-2, 0],
        [-3, -1],
        [-2, -1],
        [-2, -1],
        [-1, -2],
        [-1, -2],
        [-2, -2],
        [0, -2],
        [-1, -2],
        [-1, -2],
        [0, -4],
        [0, -2],
        [0, -4],
        [0, -2],
        [0, -2],
        [0, -3],
        [1, -3],
        [1, -3],
        [0, -3],
        [1, -2],
        [1, -3],
        [0, -2],
        [2, -3],
        [0, -3],
        [2, -2],
        [1, -3],
        [1, -2],
        [2, -3],
        [1, -1],
        [1, -2],
        [1, -2],
        [3, -2],
        [0, -2],
        [1, -2],
        [1, -2],
        [1, -1],
        [0, -2],
        [1, -2],
        [2, -2],
        [0, -3],
        [0, -3],
        [1, -4],
        [0, -4],
        [0, -4],
        [1, -5],
        [-1, -4],
        [0, -5],
        [-1, -4],
        [0, -4],
        [-2, -4],
        [-1, -4],
        [-1, -2],
        [-1, -4],
        [-1, -2],
        [-3, -2],
        [-2, -2],
        [-1, -2],
        [-2, -2],
        [-2, -2],
        [-2, -2],
        [-3, -2],
        [-3, -2],
        [-2, -2],
        [-3, 0],
        [-3, -2],
        [-4, 0],
        [-3, 0],
        [-4, -2],
        [-4, 0],
        [-4, 0],
        [-6, 0],
        [-4, 0],
        [-4, 0],
        [-6, 0],
        [-4, 0],
        [-4, 0],
        [-6, 0],
        [-5, 0],
        [-5, 0],
        [-6, 0],
        [-6, -2],
        [-5, 0],
        [-6, -2],
        [-6, -2],
        [-6, -2],
        [-7, 0],
        [-6, -2],
        [-6, -2],
        [-8, -2],
        [-6, 0],
        [-8, 0],
        [-7, 0],
        [-7, 0],
        [-9, 0],
        [-8, 0],
        [-7, 0],
        [-7, 2],
        [-7, 2],
        [-7, 0],
        [-6, 2],
        [-6, 4],
        [-6, 2],
        [-6, 4],
        [-4, 4],
        [-6, 4],
        [-2, 6],
        [-4, 6],
        [-2, 8],
        [-2, 8],
        [-1, 7],
        [-1, 8],
        [0, 8],
        [0, 8],
        [0, 7],
        [2, 7],
        [1, 7],
        [2, 7],
        [1, 6],
        [2, 6],
        [0, 6],
        [2, 6],
        [2, 5],
        [0, 5],
        [0, 4],
        [0, 6],
        [2, 6],
        [-2, 7],
        [0, 8],
        [0, 8],
        [0, 9],
        [0, 11],
        [0, 11],
        [0, 11],
        [-2, 12],
        [0, 11],
        [0, 10],
        [0, 9],
        [-2, 8],
        [0, 5],
        [0, 6],
        [0, 4],
        [-2, 4],
        [0, 4],
        [-1, 2],
        [-1, 2],
        [-1, 4],
        [-1, 2],
        [-2, 2],
        [-2, 4],
        [-2, 2],
        [-2, 3],
        [-2, 4],
        [-2, 3],
        [-2, 3],
        [-2, 4],
        [-2, 4],
        [-2, 5],
        [-2, 4],
        [-2, 4],
        [-2, 5],
        [-1, 4],
        [-1, 5],
        [0, 5],
        [-1, 4],
        [-1, 5],
        [0, 4],
        [0, 5],
        [0, 5],
        [-1, 4],
        [0, 4],
        [0, 4],
        [-1, 7],
        [0, 6],
        [0, 4],
        [-1, 6],
        [-2, 6],
        [-2, 8],
        [-2, 8],
        [-2, 8],
        [-3, 8],
        [-3, 10],
        [-4, 8],
        [-4, 9],
        [-4, 9],
        [-3, 8],
        [-4, 8],
        [-4, 7],
        [-4, 6],
        [-4, 6],
        [-4, 6],
        [-4, 5],
        [-4, 6],
        [-2, 4],
        [-3, 4],
        [-3, 5],
        [-2, 3],
        [-2, 4],
        [-3, 4],
        [-2, 4],
        [-1, 5],
        [-1, 4],
        [-2, 4],
        [-1, 6],
        [-1, 4],
        [-1, 5],
        [-1, 5],
        [-1, 7],
        [-1, 6],
        [0, 8],
        [-1, 7],
        [0, 8],
        [-1, 9],
        [0, 9],
        [-1, 9],
        [-1, 9],
        [0, 9],
        [-1, 10],
        [-1, 9],
        [-2, 7],
        [0, 10],
        [-2, 7],
        [-2, 8],
        [-1, 8],
        [-2, 9],
        [-2, 7],
        [-2, 7],
        [-2, 8],
        [-2, 6],
        [-2, 6],
        [-3, 7],
        [-2, 5],
        [-3, 6],
        [-2, 5],
        [-2, 4],
        [-2, 4],
        [-2, 6],
        [-3, 4],
        [0, 2],
        [-2, 4],
        [-2, 2],
        [-2, 4],
        [0, 2],
        [-2, 2],
        [0, 0],
        [0, 2],
        [0, 2],
        [0, 0],
        [0, 2],
        [0, 2],
        [2, 0],
        [0, 2],
        [0, 0],
        [2, 2],
        [0, 2],
        [2, 2],
        [0, 0],
        [2, 2],
        [1, 2],
        [1, 2],
        [2, 2],
        [2, 2],
        [3, 2],
        [2, 2],
        [4, 4],
        [4, 4],
        [6, 4],
        [5, 6],
        [6, 5],
        [6, 6],
        [7, 6],
        [7, 5],
        [7, 6],
        [4, 7],
        [6, 5],
        [4, 4],
        [6, 5],
        [2, 4],
        [4, 4],
        [4, 4],
        [2, 3],
        [2, 3],
        [2, 4],
        [1, 3],
        [1, 3],
        [1, 3],
        [1, 3],
        [1, 3],
        [0, 3],
        [0, 2],
        [0, 4],
        [1, 4],
        [0, 4],
        [0, 2],
        [0, 4],
        [0, 4],
        [-1, 2],
        [0, 4],
        [0, 4],
        [0, 4],
        [0, 4],
        [0, 4],
        [0, 4],
        [0, 4],
        [0, 5],
        [1, 4],
        [0, 5],
        [1, 5],
        [0, 5],
        [1, 5],
        [1, 5],
        [0, 5],
        [0, 5],
        [0, 4],
        [0, 4],
        [0, 4],
        [-1, 3],
        [-1, 3],
        [-1, 4],
        [-1, 2],
        [-2, 3],
        [-1, 3],
        [-1, 2],
        [-1, 2],
        [-2, 3],
        [-2, 2],
        [-2, 2],
        [-2, 2],
        [-2, 3],
        [-2, 2],
        [-2, 3],
        [-2, 2],
        [-2, 3],
        [-2, 2],
        [-2, 3],
        [-2, 3],
        [-2, 2],
        [-4, 2],
        [-2, 3],
        [-3, 3],
        [-3, 2],
        [-5, 3],
        [-4, 3],
        [-4, 4],
        [-4, 3],
        [-3, 3],
        [-3, 3],
        [-4, 4],
        [-3, 4],
        [-3, 4],
        [-3, 3],
        [-2, 4],
        [-2, 3],
        [-3, 3],
        [-2, 2],
        [-1, 3],
        [-2, 2],
        [-1, 2],
        [-1, 3],
        [-1, 1],
        [-1, 3],
        [0, 2],
        [0, 3],
        [0, 3],
        [0, 3],
        [0, 4],
        [0, 3],
        [1, 3],
        [1, 3],
        [0, 3],
        [0, 3],
        [1, 3],
        [1, 2],
        [0, 1],
        [0, 2],
        [0, 2],
        [0, 4],
        [0, 2],
        [0, 2],
        [0, 2],
        [-1, 2],
        [-1, 4],
        [-1, 2],
        [-1, 5],
        [-2, 4],
        [-3, 4],
        [-3, 4],
        [-1, 4],
        [-4, 6],
        [-4, 4],
        [-2, 6],
        [-4, 4],
        [-4, 5],
        [-4, 4],
        [-2, 3],
        [-4, 3],
        [-2, 3],
        [-3, 2],
        [-2, 1],
        [-3, 2],
        [-2, 2],
        [-2, 1],
        [-2, 2],
        [-2, 2],
        [-1, 3],
        [-1, 2],
        [-2, 2],
        [-1, 3],
        [-1, 3],
        [0, 3],
        [-1, 2],
        [-1, 4],
        [0, 3],
        [0, 3],
        [0, 3],
        [0, 3],
        [0, 3],
        [0, 4],
        [1, 3],
        [1, 3],
        [0, 4],
        [2, 2],
        [1, 3],
        [1, 2],
        [2, 4],
        [2, 2],
        [2, 4],
        [2, 2],
        [2, 2],
        [2, 2],
        [3, 4],
        [1, 2],
        [2, 2],
        [4, 2],
        [2, 2],
        [2, 2],
        [2, 2],
        [2, 2],
        [4, 2],
        [2, 2],
        [2, 2],
        [2, 2],
        [4, 2],
        [2, 2],
        [2, 2],
        [3, 3],
        [2, 2],
        [3, 2],
        [2, 2],
        [2, 2],
        [2, 2],
        [1, 2],
        [2, 2],
        [0, 2],
        [2, 2],
        [0, 3],
        [1, 2],
        [0, 2],
        [1, 2],
        [0, 2],
        [0, 2],
        [0, 3],
        [-1, 2],
        [-1, 3],
        [0, 2],
        [-1, 3],
        [-1, 2],
        [-2, 3],
        [-2, 3],
        [-2, 3],
        [-2, 3],
        [-3, 2],
        [-3, 3],
        [-2, 2],
        [-3, 2],
        [-4, 2],
        [-2, 2],
        [-4, 1],
        [-4, 1],
        [-4, 2],
        [-2, 0],
        [-4, 2],
        [-4, 0],
        [-3, 1],
        [-3, 0],
        [-4, 1],
        [-4, 1],
        [-4, 0],
        [-4, 1],
        [-5, 1],
        [-5, 0],
        [-6, 1],
        [-5, 1],
        [-6, 0],
        [-6, 2],
        [-5, 0],
        [-5, 2],
        [-5, 1],
        [-4, 1],
        [-4, 2],
        [-2, 2],
        [-2, 1],
        [-4, 2],
        [-2, 2],
        [0, 2],
        [-2, 2],
        [0, 2],
        [-2, 2],
        [0, 2],
        [0, 2],
        [0, 3],
        [-2, 2],
        [0, 2],
        [0, 4],
        [0, 2],
        [0, 3],
        [0, 3],
        [0, 3],
        [0, 4],
        [0, 4],
        [0, 4],
        [0, 5],
        [2, 5],
        [0, 4],
        [0, 6],
        [0, 6],
        [2, 6],
        [0, 6],
        [2, 6],
        [2, 5],
        [2, 6],
        [2, 5],
        [2, 5],
        [2, 5],
        [4, 4],
        [2, 5],
        [2, 5],
        [2, 3],
        [3, 5],
        [1, 3],
        [2, 6],
        [1, 4],
        [2, 4],
        [1, 6],
        [1, 6],
        [0, 8],
        [1, 8],
        [0, 8],
        [0, 9],
        [-1, 10],
        [0, 10],
        [-2, 10],
        [-2, 10],
        [-2, 9],
        [-2, 10],
        [-3, 8],
        [-2, 9],
        [-4, 6],
        [-4, 8],
        [-4, 6],
        [-6, 6],
        [-4, 6],
        [-4, 8],
        [-4, 4],
        [-6, 6],
        [-3, 6],
        [-4, 4],
        [-4, 6],
        [-4, 4],
        [-2, 4],
        [-3, 2],
        [-2, 3],
        [-2, 3],
        [-1, 2],
        [-2, 2],
        [0, 3],
        [-1, 2],
        [-1, 2],
        [0, 1],
        [0, 2],
        [0, 2],
        [0, 2],
        [0, 2],
        [0, 3],
        [0, 2],
        [1, 2],
        [1, 2],
        [0, 2],
        [2, 2],
        [1, 2],
        [2, 2],
        [2, 2],
        [2, 2],
        [2, 3],
        [3, 2],
        [3, 2],
        [3, 2],
        [4, 2],
        [4, 3],
        [5, 2],
        [4, 3],
        [6, 3],
        [4, 4],
        [6, 5],
        [6, 4],
        [6, 3],
        [4, 6],
        [6, 4],
        [5, 2],
        [5, 4],
        [5, 4],
        [3, 2],
        [4, 4],
        [3, 2],
        [3, 2],
        [3, 1],
        [2, 2],
        [1, 1],
        [2, 1],
        [1, 2],
        [1, 1],
        [0, 1],
        [0, 2],
        [0, 1],
        [0, 1],
        [0, 2],
        [-1, 1],
        [0, 1],
        [-1, 2],
        [0, 1],
        [-1, 2],
        [-1, 1],
        [-1, 2],
        [-1, 2],
        [-2, 2],
        [-1, 1],
        [-2, 2],
        [-1, 3],
        [-2, 2],
        [-2, 2],
        [-2, 2],
        [-3, 2],
        [-2, 3],
        [-2, 2],
        [-3, 3],
        [-2, 3],
        [-3, 3],
        [-2, 3],
        [-3, 3],
        [-3, 3],
        [-2, 4],
        [-2, 4],
        [-3, 3],
        [-2, 4],
        [-2, 4],
        [-2, 4],
        [-2, 4],
        [-2, 4],
        [0, 4],
        [-2, 4],
        [-2, 3],
        [-2, 3],
        [0, 4],
        [-2, 2],
        [0, 4],
        [-2, 2],
        [0, 4],
        [-2, 2],
        [-2, 2],
        [0, 2],
        [-2, 3],
        [-4, 4],
        [-2, 3],
        [-4, 4],
        [-4, 4],
        [-5, 4],
        [-4, 5],
        [-6, 5],
        [-5, 5],
        [-5, 5],
        [-6, 5],
        [-3, 4],
        [-5, 3],
        [-3, 3],
        [-4, 3],
        [-2, 3],
        [-3, 2],
        [-3, 3],
        [-2, 2],
        [-2, 2],
        [-1, 2],
        [-4, 3],
        [-2, 2],
        [-2, 3],
        [-2, 3],
        [-2, 3],
        [-2, 3],
        [-2, 2],
        [-1, 2],
        [-1, 2],
        [-2, 4],
        [0, 2],
        [-1, 2],
        [-1, 4],
        [0, 2],
        [0, 4],
        [-1, 2],
        [0, 4],
        [0, 4],
        [-1, 2],
        [1, 4],
        [0, 2],
        [1, 4],
        [0, 2],
        [0, 4],
        [2, 2],
        [0, 2],
        [2, 2],
        [0, 2],
        [2, 2],
        [0, 2],
        [1, 2],
        [1, 2],
        [0, 2],
        [0, 2],
        [0, 4],
        [0, 2],
        [0, 2],
        [-1, 2],
        [-1, 2],
        [-1, 4],
        [-1, 3],
        [-2, 2],
        [-2, 3],
        [-1, 2],
        [-2, 3],
        [-2, 2],
        [-2, 2],
        [-2, 2],
        [-2, 2],
        [-2, 2],
        [0, 1],
        [-2, 1],
        [-2, 1],
        [-2, 1],
        [-2, 1],
        [-2, 0],
        [0, 1],
        [-2, 0],
        [-2, 0],
        [0, 0],
        [-2, -1],
        [-2, 0],
        [0, 0],
        [-2, -2],
        [-2, 0],
        [0, -2],
        [-2, -1],
        [-2, -1],
        [0, -2],
        [-2, -1],
        [0, -1],
        [0, -1],
        [-2, -1],
        [0, -2],
        [0, -2],
        [0, -1],
        [-1, -1],
        [0, -1],
        [-1, -2],
        [-1, -1],
        [-1, -1],
        [-1, -1],
        [0, -1],
        [-1, -1],
        [0, -1],
        [-2, 0],
        [0, -1],
        [-2, 1],
        [-1, 0],
        [-1, 0],
        [-2, 1],
        [-1, 1],
        [-1, 1],
        [-2, 1],
        [-1, 1],
        [-2, 1],
        [-1, 1],
        [-2, 2],
        [-2, 1],
        [-1, 2],
        [-2, 1],
        [-1, 2],
        [-2, 2],
        [0, 3],
        [-2, 2],
        [0, 2],
        [-2, 3],
        [0, 1],
        [-1, 2],
        [-1, 2],
        [-1, 2],
        [0, 2],
        [-2, 2],
        [-1, 1],
        [-1, 1],
        [-2, 1],
        [-2, 1],
        [-2, 1],
        [-2, 1],
        [-3, 1],
        [-3, 1],
        [-3, 0],
        [-4, 1],
        [-3, 0],
        [-4, 0],
        [-4, 1],
        [-4, 1],
        [-4, 0],
        [-4, 0],
        [-4, 0],
        [-4, 0],
        [-5, 0],
        [-4, 0],
        [-4, 0],
        [-5, -1],
        [-3, -1],
        [-4, 0],
        [-3, 0],
        [-4, -1],
        [-2, -1],
        [-3, -1],
        [-3, 0],
        [-3, -1],
        [-2, -1],
        [-3, -1],
        [-3, -1],
        [-3, 0],
        [-3, -1],
        [-2, -1],
        [-3, -1],
        [-3, -1],
        [-2, -1],
        [-3, -1],
        [-2, -2],
        [-2, -1],
        [-2, -1],
        [-2, -2],
        [-2, -1],
        [-2, -2],
        [-4, -1],
        [-2, -1],
        [-4, -2],
        [-2, -2],
        [-4, -1],
        [-4, -1],
        [-5, -1],
        [-4, -1],
        [-5, -1],
        [-6, -1],
        [-6, 0],
        [-7, -1],
        [-6, 0],
        [-6, 0],
        [-7, 0],
        [-6, 1],
        [-6, 0],
        [-5, 1],
        [-4, 1],
        [-4, 2],
        [-4, 2],
        [-2, 2],
        [-2, 3],
        [-4, 3],
        [-2, 3],
        [0, 3],
        [-2, 4],
        [-2, 4],
        [0, 4],
        [-2, 4],
        [0, 5],
        [0, 4],
        [2, 5],
        [0, 3],
        [2, 4],
        [0, 4],
        [2, 4],
        [2, 4],
        [2, 2],
        [4, 4],
        [2, 4],
        [2, 2],
        [2, 4],
        [0, 4],
        [2, 4],
        [2, 2],
        [2, 4],
        [0, 4],
        [2, 2],
        [0, 4],
        [0, 2],
        [0, 4],
        [1, 3],
        [0, 3],
        [0, 4],
        [0, 3],
        [1, 3],
        [1, 3],
        [0, 4],
        [1, 3],
        [1, 3],
        [0, 3],
        [2, 3],
        [0, 3],
        [1, 2],
        [1, 3],
        [0, 4],
        [1, 2],
        [0, 1],
        [0, 3],
        [0, 2],
        [-1, 2],
        [0, 1],
        [-1, 2],
        [-1, 2],
        [-2, 2],
        [-2, 3],
        [-2, 2],
        [-1, 2],
        [-2, 4],
        [-4, 2],
        [-4, 4],
        [-2, 4],
        [-4, 3],
        [-4, 4],
        [-6, 4],
        [-4, 4],
        [-3, 4],
        [-4, 2],
        [-4, 4],
        [-4, 2],
        [-3, 2],
        [-4, 2],
        [-4, 2],
        [-3, 2],
        [-3, 2],
        [-4, 1],
        [-2, 2],
        [-3, 1],
        [-2, 1],
        [-3, 1],
        [-2, 1],
        [-2, 0],
        [-2, 1],
        [-2, 1],
        [-2, 0],
        [-1, 0],
        [-2, 0],
        [-1, -1],
        [-1, 0],
        [-1, -1],
        [-1, 0],
        [-1, -1],
        [-1, -1],
        [-1, -1],
        [-1, -1],
        [0, -1],
        [-1, 0],
        [0, -1],
        [0, -1],
        [0, -2],
        [0, -2],
        [0, -1],
        [-2, -1],
        [0, 0],
        [0, -2],
        [-2, 0],
        [-2, -2],
        [0, 0],
        [-2, 0],
        [0, 0],
        [-2, 0],
        [0, 0],
        [-2, 0],
        [0, 0],
        [-2, 0],
        [0, -2],
        [-2, 0],
        [-2, 0],
        [0, 0],
        [0, -2],
        [-2, 0],
        [0, 0],
        [-2, -2],
        [0, 0],
        [-2, 0],
        [0, -1],
        [-2, -1],
        [0, -1],
        [-2, -1],
        [0, -1],
        [-2, -1],
        [-2, 0],
        [0, 0],
        [-1, 1],
        [-2, 0],
        [-1, 1],
        [-1, 0],
        [-2, 1],
        [-1, 1],
        [-2, 0],
        [-2, 2],
        [-2, 0],
        [-1, 0],
        [-2, 2],
        [-1, 0],
        [-2, 2],
        [-1, 2],
        [-1, 0],
        [-2, 2],
        [-1, 0],
        [-1, 0],
        [-1, 2],
        [-1, 0],
        [-1, 0],
        [-1, 1],
        [-2, 1],
        [-1, 0],
        [-2, 0],
        [-1, 1],
        [-1, 0],
        [-2, 0],
        [-3, 1],
        [-1, 0],
        [-2, 0],
        [-1, -1],
        [-2, 0],
        [-1, 0],
        [-1, -1],
        [-2, 0],
        [-1, -1],
        [-1, -1],
        [-2, 0],
        [-2, 0],
        [-2, -2],
        [-2, 0],
        [-2, 0],
        [-3, -2],
        [-2, 0],
        [-2, -2],
        [-2, 0],
        [-2, 0],
        [-2, -2],
        [-2, 0],
        [-2, 0],
        [-2, 0],
        [-2, 0],
        [-2, 0],
        [-2, -2],
        [-2, 0],
        [-2, 0],
        [-2, 0],
        [-2, 0],
        [-2, 0],
        [0, 0],
        [-2, 2],
        [-1, 0],
        [-2, 0],
        [-1, 2],
        [-1, 0],
        [-2, 2],
        [-1, 0],
        [-2, 2],
        [-1, 0],
        [-1, 2],
        [-2, 1],
        [-1, 1],
        [-1, 2],
        [-1, 2],
        [-1, 1],
        [-1, 2],
        [-1, 1],
        [-1, 2],
        [-1, 2],
        [0, 2],
        [0, 2],
        [0, 2],
        [0, 2],
        [0, 2],
        [0, 1],
        [0, 2],
        [1, 2],
        [1, 2],
        [0, 2],
        [2, 2],
        [0, 1],
        [2, 2],
        [0, 2],
        [2, 2],
        [1, 2],
        [1, 2],
        [1, 1],
        [1, 2],
        [2, 2],
        [1, 1],
        [1, 2],
        [2, 2],
        [2, 1],
        [2, 2],
        [2, 2],
        [2, 2],
        [2, 1],
        [2, 1],
        [2, 1],
        [0, 2],
        [2, 0],
        [2, 2],
        [2, 0],
        [0, 2],
        [2, 0],
        [0, 1],
        [2, 1],
        [0, 1],
        [0, 1],
        [2, 1],
        [0, 1],
        [0, 1],
        [2, 1],
        [0, 2],
        [0, 1],
        [0, 1],
        [0, 2],
        [0, 2],
        [0, 2],
        [-2, 2],
        [0, 3],
        [-2, 2],
        [0, 3],
        [-2, 2],
        [-2, 5],
        [0, 2],
        [-2, 4],
        [-2, 4],
        [-2, 2],
        [-2, 4],
        [0, 2],
        [-2, 2],
        [-2, 4],
        [0, 2],
        [-2, 2],
        [0, 2],
        [0, 2],
        [-1, 2],
        [0, 2],
        [0, 0],
        [-1, 2],
        [0, 2],
        [0, 2],
        [0, 2],
        [0, 2],
        [0, 2],
        [1, 2],
        [0, 2],
        [1, 0],
        [0, 2],
        [2, 2],
        [0, 2],
        [2, 0],
        [2, 2],
        [2, 2],
        [2, 2],
        [2, 1],
        [2, 2],
        [2, 1],
        [2, 2],
        [2, 2],
        [2, 1],
        [2, 2],
        [2, 2],
        [2, 2],
        [0, 2],
        [2, 2],
        [0, 1],
        [2, 2],
        [0, 2],
        [1, 1],
        [0, 2],
        [1, 1],
        [0, 2],
        [1, 2],
        [0, 2],
        [0, 2],
        [0, 2],
        [0, 2],
        [0, 1],
        [0, 2],
        [0, 2],
        [0, 2],
        [-1, 2],
        [0, 1],
        [-1, 2],
        [0, 2],
        [-1, 2],
        [0, 1],
        [-2, 2],
        [0, 2],
        [-2, 2],
        [0, 1],
        [-2, 2],
        [-2, 2],
        [-2, 2],
        [-2, 2],
        [-2, 2],
        [-4, 2],
        [-2, 3],
        [-4, 2],
        [-2, 1],
        [-4, 2],
        [-2, 2],
        [-2, 2],
        [-3, 2],
        [-1, 2],
        [-3, 0],
        [-2, 2],
        [-3, 2],
        [-2, 0],
        [-2, 2],
        [-2, 2],
        [-2, 0],
        [-2, 2],
        [-3, 2],
        [-2, 0],
        [-2, 2],
        [-2, 3],
        [-2, 2],
        [-2, 0],
        [-1, 2],
        [-2, 2],
        [-1, 2],
        [-2, 2],
        [-2, 2],
        [-1, 2],
        [-1, 2],
        [-1, 0],
        [-1, 2],
        [-1, 2],
        [-1, 2],
        [-1, 2],
        [-1, 2],
        [-2, 4],
        [-1, 2],
        [-1, 2],
        [-2, 4],
        [-2, 1],
        [-2, 3],
        [-1, 3],
        [-2, 3],
        [0, 2],
        [-3, 3],
        [0, 3],
        [-2, 2],
        [0, 2],
        [0, 2],
        [-1, 2],
        [0, 3],
        [0, 2],
        [0, 2],
        [-1, 4],
        [-1, 2],
        [0, 4],
        [-1, 3],
        [-1, 3],
        [-1, 3],
        [-1, 4],
        [0, 3],
        [-2, 3],
        [0, 3],
        [-2, 2],
        [0, 3],
        [-2, 3],
        [-1, 3],
        [-2, 3],
        [-2, 3],
        [-2, 3],
        [-3, 3],
        [-2, 4],
        [-2, 4],
        [-3, 2],
        [-2, 4],
        [-2, 2],
        [-2, 2],
        [-2, 2],
        [-2, 2],
        [0, 1],
        [-2, 1],
        [0, 2],
        [-2, 2],
        [0, 2],
        [0, 3],
        [-2, 3],
        [0, 3],
        [0, 5],
        [0, 6],
        [0, 4],
        [0, 5],
        [0, 5],
        [2, 5],
        [2, 5],
        [4, 4],
        [2, 5],
        [4, 5],
        [4, 4],
        [3, 5],
        [4, 4],
        [2, 4],
        [4, 4],
        [2, 3],
        [2, 3],
        [2, 3],
        [1, 4],
        [1, 2],
        [2, 3],
        [0, 3],
        [1, 1],
        [0, 3],
        [1, 2],
        [0, 2],
        [0, 0],
        [0, 2],
        [1, 2],
        [1, 2],
        [0, 0],
        [1, 2],
        [2, 2],
        [1, 0],
        [2, 2],
        [1, 2],
        [2, 0],
        [3, 2],
        [2, 2],
        [3, 2],
        [2, 0],
        [3, 2],
        [3, 2],
        [3, 2],
        [3, 0],
        [2, 2],
        [3, 0],
        [3, 2],
        [3, 0],
        [2, 2],
        [2, 2],
        [3, 0],
        [2, 2],
        [2, 2],
        [2, 2],
        [1, 2],
        [2, 2],
        [1, 3],
        [1, 3],
        [2, 3],
        [0, 3],
        [1, 3],
        [0, 3],
        [1, 3],
        [0, 3],
        [0, 4],
        [0, 2],
        [1, 3],
        [0, 3],
        [1, 2],
        [0, 2],
        [1, 1],
        [1, 3],
        [1, 2],
        [2, 1],
        [1, 1],
        [2, 1],
        [0, 1],
        [2, 1],
        [2, 1],
        [0, 2],
        [2, 1],
        [2, 1],
        [0, 1],
        [2, 1],
        [0, 1],
        [0, 1],
        [2, 1],
        [0, 2],
        [0, 1],
        [0, 1],
        [0, 2],
        [0, 2],
        [0, 2],
        [0, 2],
        [0, 2],
        [0, 2],
        [0, 2],
        [0, 3],
        [-2, 2],
        [0, 3],
        [0, 2],
        [0, 2],
        [-2, 2],
        [0, 4],
        [-2, 2],
        [0, 2],
        [-2, 2],
        [0, 4],
        [-2, 2],
        [0, 2],
        [-2, 2],
        [-2, 2],
        [0, 2],
        [-1, 4],
        [-2, 2],
        [-2, 4],
        [-2, 4],
        [-2, 2],
        [-3, 4],
        [-3, 4],
        [-3, 4],
        [-3, 4],
        [-3, 4],
        [-4, 4],
        [-2, 4],
        [-3, 4],
        [-3, 2],
        [-2, 3],
        [-1, 3],
        [-2, 1],
        [-2, 3],
        [-2, 3],
        [-2, 2],
        [-2, 2],
        [-2, 2],
        [-2, 2],
        [-2, 3],
        [-2, 2],
        [-1, 2],
        [-1, 2],
        [-1, 3],
        [-1, 3],
        [-1, 2],
        [-1, 3],
        [0, 3],
        [0, 2],
        [0, 3],
        [0, 3],
        [0, 3],
        [1, 3],
        [0, 2],
        [1, 2],
        [0, 2],
        [0, 2],
        [1, 3],
        [1, 1],
        [1, 2],
        [1, 2],
        [0, 2],
        [2, 1],
        [0, 2],
        [2, 2],
        [1, 1],
        [1, 2],
        [1, 1],
        [1, 1],
        [2, 1],
        [1, 1],
        [1, 1],
        [2, 0],
        [2, 0],
        [2, 2],
        [1, 0],
        [2, 0],
        [2, 0],
        [1, 2],
        [2, 0],
        [2, 0],
        [2, 0],
        [1, 0],
        [2, 0],
        [2, 2],
        [1, 0],
        [1, 0],
        [2, 2],
        [0, 0],
        [2, 2],
        [0, 2],
        [1, 2],
        [0, 0],
        [1, 2],
        [0, 4],
        [0, 2],
        [0, 1],
        [0, 3],
        [0, 3],
        [0, 3],
        [0, 3],
        [0, 3],
        [0, 3],
        [0, 3],
        [0, 4],
        [0, 3],
        [0, 3],
        [1, 3],
        [1, 4],
        [0, 3],
        [2, 3],
        [1, 3],
        [1, 2],
        [2, 3],
        [1, 2],
        [3, 2],
        [2, 2],
        [2, 1],
        [2, 2],
        [4, 1],
        [2, 1],
        [4, 1],
        [2, 0],
        [4, 1],
        [2, 1],
        [2, 1],
        [2, 1],
        [2, 1],
        [2, 1],
        [2, 2],
        [1, 1],
        [2, 1],
        [1, 2],
        [1, 1],
        [2, 2],
        [1, 1],
        [1, 2],
        [1, 2],
        [1, 2],
        [1, 2],
        [1, 3],
        [2, 2],
        [0, 3],
        [1, 3],
        [1, 2],
        [1, 3],
        [1, 2],
        [0, 2],
        [0, 2],
        [1, 2],
        [0, 2],
        [0, 3],
        [0, 2],
        [0, 2],
        [-1, 2],
        [0, 2],
        [-1, 4],
        [-1, 2],
        [-1, 4],
        [-1, 4],
        [-2, 4],
        [-2, 5],
        [-3, 6],
        [-3, 7],
        [-4, 7],
        [-5, 8],
        [-4, 8],
        [-4, 9],
        [-6, 8],
        [-4, 8],
        [-4, 7],
        [-4, 6],
        [-2, 5],
        [-2, 4],
        [-1, 4],
        [-2, 2],
        [0, 2],
        [-1, 2],
        [0, 2],
        [0, 2],
        [1, 0],
        [0, 2],
        [0, 2],
        [0, 2],
        [1, 0],
        [0, 2],
        [1, 2],
        [0, 2],
        [0, 2],
        [0, 2],
        [0, 0],
        [0, 2],
        [-1, 2],
        [-1, 2],
        [0, 2],
        [-1, 2],
        [-2, 2],
        [-1, 2],
        [-2, 2],
        [-2, 2],
        [-2, 0],
        [-3, 2],
        [-2, 2],
        [-4, 2],
        [-3, 2],
        [-3, 2],
        [-4, 3],
        [-4, 2],
        [-3, 2],
        [-4, 0],
        [-4, 2],
        [-4, 0],
        [-4, 0],
        [-4, 0],
        [-4, 0],
        [-4, -2],
        [-3, 0],
        [-3, -2],
        [-3, -2],
        [-3, -3],
        [-3, 0],
        [-2, -2],
        [-2, -2],
        [-2, 0],
        [-1, -2],
        [-1, -2],
        [-2, -2],
        [-1, 0],
        [-1, -2],
        [-1, 0],
        [-1, -2],
        [0, -2],
        [-1, 0],
        [0, -2],
        [-2, 0],
        [0, -2],
        [0, -2],
        [-2, 0],
        [0, -2],
        [-2, -2],
        [0, -2],
        [-2, 0],
        [0, -2],
        [0, -2],
        [0, 0],
        [0, -2],
        [0, -2],
        [0, 0],
        [-2, -2],
        [0, 0],
        [0, -2],
        [0, 0],
        [0, 0],
        [-2, -2],
        [0, -2],
        [-2, 0],
        [0, 0],
        [-2, 0],
        [0, -2],
        [0, 0],
        [-2, 0],
        [0, 0],
        [-2, 0],
        [0, 0],
        [-2, 0],
        [-2, 0],
        [-2, 2],
        [0, 0],
        [-2, 0],
        [-2, 2],
        [-3, 0],
        [0, 0],
        [-2, 2],
        [-2, 0],
        [-2, 2],
        [-1, 0],
        [-2, 2],
        [-2, 2],
        [-1, 0],
        [-2, 4],
        [-1, 2],
        [-1, 2],
        [0, 4],
        [-1, 2],
        [0, 4],
        [0, 4],
        [1, 4],
        [0, 4],
        [1, 2],
        [1, 5],
        [0, 2],
        [2, 4],
        [0, 2],
        [1, 2],
        [1, 2],
        [1, 2],
        [0, 2],
        [0, 2],
        [0, 2],
        [-1, 1],
        [-2, 1],
        [-1, 1],
        [-1, 0],
        [-2, 1],
        [-2, 1],
        [-2, 1],
        [-2, 1],
        [-2, 2],
        [-2, 0],
        [-3, 2],
        [-2, 2],
        [-3, 1],
        [-2, 2],
        [-3, 1],
        [-2, 2],
        [-4, 2],
        [-3, 3],
        [-4, 2],
        [-4, 2],
        [-4, 2],
        [-5, 2],
        [-5, 2],
        [-4, 2],
        [-4, 3],
        [-6, 2],
        [-4, 1],
        [-4, 2],
        [-4, 1],
        [-2, 2],
        [-2, 1],
        [-2, 1],
        [-2, 2],
        [-2, 1],
        [-2, 2],
        [-2, 1],
        [-2, 2],
        [-3, 2],
        [-2, 2],
        [-3, 3],
        [-2, 2],
        [-2, 2],
        [-2, 3],
        [-2, 2],
        [-2, 2],
        [0, 2],
        [-2, 2],
        [0, 2],
        [-1, 3],
        [0, 1],
        [-1, 1],
        [1, 2],
        [0, 2],
        [1, 2],
        [0, 2],
        [1, 2],
        [1, 0],
        [1, 2],
        [1, 0],
        [1, 2],
        [1, 0],
        [2, 2],
        [1, 0],
        [1, 2],
        [2, 0],
        [2, 0],
        [1, 0],
        [3, 0],
        [2, 2],
        [2, 0],
        [3, 0],
        [3, 0],
        [2, 0],
        [3, 0],
        [1, 0],
        [4, 0],
        [2, 0],
        [2, 0],
        [2, 2],
        [2, 0],
        [0, 0],
        [2, 0],
        [2, 2],
        [0, 2],
        [2, 0],
        [2, 2],
        [0, 2],
        [2, 2],
        [0, 2],
        [0, 2],
        [2, 2],
        [0, 2],
        [2, 1],
        [0, 2],
        [2, 0],
        [0, 1],
        [2, 1],
        [2, 0],
        [3, 0],
        [4, 0],
        [1, 12],
        [5, 18],
        [19, 2],
        [12, 22],
        [-5, 20],
        [-11, -3],
        [-9, 4],
        [-4, 27],
        [-10, 9],
        [-15, -4],
        [-20, 18],
        [-8, 10],
        [6, 13],
        [12, 16],
        [20, 14],
        [17, 4],
        [18, 7],
        [1, 14],
        [-9, 15],
        [-18, 24],
        [-13, 18],
        [4, 14],
        [9, 14],
        [18, 13],
        [6, 11],
        [11, 18],
        [22, 14],
        [27, 27],
        [2, 18],
        [-14, 34],
        [-18, 18],
        [-16, 34],
        [-23, 4],
        [10, 95],
        [-14, 26],
        [-20, 29],
        [-42, 9],
        [-13, -20],
        [-7, -23],
        [-15, -25],
        [-12, 15],
        [-19, 38],
        [-24, 34],
        [-16, 28],
        [-14, 38],
        [-10, 48],
        [-35, 63],
        [-38, 6],
        [-35, 42],
        [-4, 56],
        [-11, 53],
        [-1422, 1371],
      ],
      [
        [175151, 173942],
        [243, 48],
        [-40, 512],
        [-251, 698],
        [-212, 383],
        [0, 49],
        [3, 34],
        [55, 24],
        [-5, 40],
        [39, 33],
        [-18, 49],
        [-33, 23],
        [10, 57],
        [27, 44],
        [49, 17],
        [46, -1],
        [57, -5],
        [60, -26],
        [59, 10],
        [35, -16],
        [13, -35],
        [28, 3],
        [3, 13],
        [22, 10],
        [9, 28],
        [30, 11],
        [16, 17],
        [31, 24],
        [14, 84],
        [52, 9],
        [27, 32],
        [27, 22],
        [36, 22],
        [24, 22],
        [33, 27],
        [60, 48],
        [91, 10],
        [59, -20],
        [17, -47],
        [42, -30],
        [50, -4],
        [38, 16],
        [8, 32],
        [-2, 37],
        [3, 32],
        [-18, 14],
        [-14, 14],
        [-5, 15],
        [0, 16],
        [8, 13],
        [22, 1],
        [12, 0],
        [22, -3],
        [18, -4],
        [30, -3],
        [27, -4],
        [31, -1],
        [20, 3],
        [7, 6],
        [9, 7],
        [-7, 20],
        [-1, 24],
        [4, 12],
        [2, 11],
        [2, 21],
        [-2, 40],
        [7, 20],
        [16, 8],
        [12, 4],
        [24, 19],
        [27, 10],
        [21, 0],
        [18, 18],
        [9, 18],
        [3, 23],
        [-7, 18],
        [-1, 21],
        [-4, 23],
        [5, 15],
        [13, 6],
        [20, -10],
        [18, -7],
        [20, -8],
        [7, 0],
        [10, 7],
        [4, 14],
        [11, 8],
        [0, 23],
        [11, 4],
        [13, 6],
        [5, 10],
        [-1, 16],
        [16, 7],
        [76, -5],
        [37, 9],
        [80, 5],
        [72, -14],
        [37, -18],
        [54, -12],
        [67, 6],
        [33, 18],
        [51, 51],
        [44, 42],
        [272, -459],
        [516, -876],
        [613, -1060],
        [2268, -346],
        [981, -145],
        [454, 224],
        [11, 74],
        [145, 879],
        [129, 1136],
        [-384, 1021],
        [-49, 125],
        [117, -125],
        [2079, -2135],
        [1298, 2135],
        [614, 1065],
        [93, 120],
        [195, 318],
        [577, 73],
        [208, 801],
        [600, 1031],
        [695, 1199],
        [-175, 177],
        [1540, 1935],
        [-230, -1868],
        [-130, -1065],
        [-624, 504],
        [213, -1549],
        [410, 26],
        [1317, 355],
        [977, 1128],
        [131, 490],
        [474, 309],
        [530, 328],
        [684, -1774],
        [-631, -529],
        [-296, -337],
        [-6, -9],
        [-281, -441],
        [-147, -125],
        [-40, -34],
        [1166, -769],
        [817, -539],
        [561, -372],
        [111, -73],
        [784, -525],
        [678, -444],
        [773, 352],
        [1204, -335],
        [377, -31],
        [989, -81],
        [345, 44],
        [877, 109],
        [1270, 39],
        [-204, 498],
        [-679, 1557],
        [1305, 71],
        [202, 1663],
        [-463, -35],
        [29, 1380],
        [0, 4],
        [1089, 67],
        [142, -201],
        [966, 2],
        [783, 2],
        [0, 725],
        [-16, 7],
        [-17, 6],
        [-10, 10],
        [-11, 16],
        [-13, 2],
        [-15, 8],
        [-39, 23],
        [-39, 48],
        [-38, 74],
        [10, 59],
        [-75, 53],
        [-31, 31],
        [-99, 63],
        [-55, 74],
        [-32, 119],
        [-16, 24],
        [-7, 32],
        [-8, 75],
        [34, 28],
        [37, 25],
        [28, 14],
        [31, -2],
        [30, -17],
        [39, 2],
        [52, 9],
        [40, 15],
        [34, 20],
        [23, 19],
        [15, 15],
        [27, 9],
        [31, -4],
        [20, -15],
        [23, -5],
        [21, 0],
        [46, 5],
        [42, 11],
        [34, 16],
        [4, 457],
      ],
      [
        [205371, 183845],
        [1331, 40],
        [4312, 54],
        [3093, -80],
        [5532, 473],
        [1703, -5363],
        [5339, 4617],
        [-697, 5155],
        [0, 2],
        [-554, 789],
        [981, 2517],
        [-41, 190],
        [-1693, 632],
        [1645, -64],
        [1952, -77],
        [4325, -551],
        [958, -1000],
        [2321, -2635],
        [4284, 1334],
        [430, 628],
        [-4, 3],
        [-18, 16],
        [-14, 6],
        [-13, 2],
        [-17, 8],
        [-22, 10],
        [-14, 8],
        [-10, 12],
        [-3, 5],
        [-13, 14],
        [-22, 7],
        [-12, 16],
        [-25, 9],
        [-21, 19],
        [-18, 9],
        [-5, 0],
        [-22, 8],
        [-23, 8],
        [-24, 14],
        [-29, 10],
        [-17, 0],
        [-14, 8],
        [-22, 8],
        [-4, 12],
        [-24, 14],
        [-15, 7],
        [-20, 17],
        [-34, 36],
        [-32, 37],
        [-19, 25],
        [-16, 17],
        [-11, 16],
        [-22, 30],
        [-20, 17],
        [-20, 19],
        [-4, 10],
        [-7, 27],
        [-8, 4],
        [-18, 19],
        [-13, 22],
        [-13, 10],
        [-14, 18],
        [-9, 12],
        [-8, 19],
        [-10, 20],
        [-8, 22],
        [-9, 12],
        [-15, 25],
        [-13, 22],
        [-18, 29],
        [-25, 34],
        [-14, 13],
        [-16, 29],
        [-22, 34],
        [-12, 21],
        [-16, 23],
        [-11, 18],
        [-18, 26],
        [-9, 25],
        [-18, 18],
        [-19, 27],
        [-7, 19],
        [-5, 20],
        [-7, 14],
        [-1, 22],
        [4, 15],
        [0, 15],
        [4, 14],
        [4, 13],
        [3, 11],
        [7, 11],
        [4, 18],
        [0, 20],
        [0, 16],
        [-6, 18],
        [-8, 16],
        [2, 16],
        [1, 20],
        [2, 8],
        [-7, 11],
        [-4, 7],
        [-6, 17],
        [-4, 14],
        [-6, 14],
        [-9, 27],
        [-2, 16],
        [-4, 14],
        [-8, 31],
        [-6, 27],
        [-6, 17],
        [-9, 31],
        [-12, 33],
        [-9, 28],
        [-14, 22],
        [-19, 24],
        [-15, 22],
        [-22, 25],
        [-24, 28],
        [-26, 31],
        [-14, 13],
        [-29, 38],
        [-25, 31],
        [-27, 28],
        [-28, 22],
        [-25, 18],
        [-51, 31],
        [-23, 24],
        [-22, 21],
        [-28, 18],
        [-26, 21],
        [-18, 21],
        [-20, 30],
        [-15, 22],
        [-17, 24],
        [-19, 27],
        [-14, 31],
        [-11, 27],
        [-7, 24],
        [-10, 29],
        [-15, 38],
        [-12, 42],
        [-2, 28],
        [-4, 27],
        [0, 52],
        [-4, 22],
        [4, 24],
        [4, 16],
        [4, 34],
        [17, 76],
        [7, 41],
        [1, 41],
        [-11, 45],
        [-12, 50],
        [-18, 44],
        [-17, 46],
        [-29, 35],
        [-44, 58],
        [-33, 40],
        [-45, 34],
        [-50, 12],
        [-18, 35],
        [-13, 24],
        [-53, 86],
        [-12, 18],
        [-3, 4],
        [-41, 34],
        [-16, 40],
        [-2, 4],
        [-4, 3],
        [-61, 63],
        [-46, 54],
        [-19, 27],
        [-72, 8],
        [-40, -5],
        [-14, -5],
        [-21, -6],
        [-39, 0],
        [-74, 5],
        [-23, 1],
        [-43, 6],
        [-4, 4],
        [-24, 28],
        [-35, 22],
        [-31, 16],
        [-55, 10],
        [-21, 27],
        [-4, 27],
        [-2, 41],
        [-30, 46],
        [10, 109],
        [-22, 39],
        [-27, 74],
        [-22, 72],
        [-22, 47],
        [-6, 31],
        [39, 43],
        [57, 49],
        [40, 57],
        [48, 70],
        [25, 61],
        [40, 16],
        [131, 26],
        [44, 33],
        [20, 42],
        [-18, 74],
        [16, 38],
        [55, 44],
        [68, 23],
        [60, 12],
        [55, 2],
        [57, 9],
        [52, 23],
        [23, 31],
        [19, 23],
        [38, 26],
        [63, 31],
        [76, 39],
        [79, 5],
        [52, 24],
        [57, 73],
        [57, 74],
        [55, 51],
        [67, 24],
        [47, -2],
        [44, -9],
        [39, -21],
        [61, -8],
        [71, 13],
        [62, 27],
        [43, 45],
        [37, 53],
        [38, 46],
        [40, 40],
        [32, 36],
        [49, 10],
        [66, -11],
        [27, -43],
        [49, -32],
        [20, -74],
        [22, -87],
        [21, -9],
        [23, 19],
        [17, 27],
        [20, 98],
        [20, 54],
        [117, 72],
        [19, 6],
        [10, -14],
        [-1, -39],
        [12, -12],
        [14, 10],
        [36, 42],
        [46, 60],
        [78, 63],
        [92, -11],
        [51, -30],
        [15, -37],
        [29, 0],
        [37, 63],
        [19, 6],
        [16, -1],
        [25, -16],
        [46, -33],
        [62, -9],
        [33, 23],
        [51, -77],
        [38, -49],
        [35, -35],
        [39, -41],
        [46, -19],
        [35, -9],
        [47, 0],
        [36, 29],
        [8, 77],
        [-14, 55],
        [-5, 73],
        [19, 65],
        [19, 55],
        [46, 74],
        [58, 71],
        [53, 69],
        [32, 65],
        [18, 45],
        [8, 58],
        [-12, 54],
        [-13, 58],
        [2, 74],
        [25, 68],
        [54, 40],
        [104, 44],
        [-1173, 2845],
        [40, 315],
        [607, 4956],
        [247, 2003],
        [24, 194],
        [3199, -4086],
        [1326, -597],
        [523, -141],
        [1419, 1183],
      ],
      [
        [172616, 214571],
        [-225, 427],
        [-64, 332],
        [117, 331],
        [118, 185],
        [366, 239],
        [300, 245],
        [247, 81],
        [241, -5],
        [154, -124],
        [2, 3],
        [17, 35],
        [37, 24],
        [48, 28],
        [63, 108],
        [37, 232],
        [-11, 79],
        [-46, 90],
        [4, 105],
        [18, 97],
        [79, 205],
        [13, 115],
        [-17, 52],
        [-42, 117],
        [225, 120],
        [146, 97],
        [-14, 63],
        [-21, 106],
        [23, 50],
        [42, 39],
        [57, -5],
        [29, 101],
        [40, 246],
        [38, 55],
        [100, 33],
        [104, 69],
        [69, 46],
        [6, 48],
        [7, 89],
        [36, 57],
        [56, 74],
        [63, 73],
        [64, 73],
        [144, 162],
        [141, 163],
        [62, 64],
        [82, 143],
        [36, 88],
        [48, 47],
        [47, 36],
        [120, 133],
        [209, 158],
        [136, 132],
        [97, 34],
        [72, 59],
        [45, 87],
        [13, 64],
        [-7, 108],
        [34, 26],
        [81, 2],
        [79, 4],
        [70, 58],
        [83, 61],
        [79, 56],
        [91, 33],
        [117, 45],
        [80, 75],
        [61, 37],
        [72, -11],
        [49, -9],
        [58, 10],
        [21, 23],
        [67, 89],
        [57, 81],
        [53, 32],
        [127, 47],
        [91, 27],
        [109, 133],
        [50, 152],
        [2, 119],
        [46, 111],
        [20, 52],
        [28, 27],
        [48, 22],
        [88, 21],
        [86, 2],
        [93, 5],
        [143, 27],
        [79, 48],
        [113, -1],
        [96, 63],
        [50, 53],
        [96, 14],
        [119, -1],
        [107, 39],
        [121, 132],
        [44, 63],
        [116, 16],
        [185, 27],
        [215, 97],
        [29, 24],
        [27, 34],
        [22, 115],
        [6, 48],
        [42, 66],
        [37, 55],
        [158, 82],
        [2, 79],
        [-6, 57],
        [22, 95],
        [39, 24],
        [113, -8],
        [72, 34],
        [7, 65],
        [-57, 140],
        [-16, 71],
        [12, 55],
        [14, 20],
        [73, 48],
        [62, 67],
        [52, 68],
        [85, 22],
        [68, -22],
        [90, 26],
        [92, 116],
        [99, 108],
        [78, 79],
        [113, 84],
        [102, 57],
        [89, 85],
        [37, 50],
        [38, 87],
        [42, 74],
        [32, 67],
        [32, 34],
        [59, 40],
        [85, 12],
        [165, 28],
        [68, 33],
        [56, 91],
        [45, 107],
        [59, 18],
        [44, -22],
        [33, -4],
        [75, 34],
        [162, 59],
        [75, 31],
        [76, 32],
        [93, 19],
        [72, 0],
        [38, 32],
        [48, 46],
        [55, 13],
        [38, -25],
        [78, 33],
        [109, 90],
        [72, 24],
        [60, 22],
        [72, 39],
        [1059, 685],
        [-28, 847],
      ],
      [
        [184286, 226781],
        [7391, 3608],
        [6251, -3465],
        [2451, 5247],
        [990, -2444],
        [152, 41],
        [56, 21],
        [64, 15],
        [83, 33],
        [68, 24],
        [103, 40],
        [78, 12],
        [110, 15],
        [103, 20],
        [83, 2],
        [31, 6],
        [59, 7],
        [52, -7],
        [62, -16],
        [29, 0],
        [31, -10],
        [17, -10],
        [42, -13],
        [42, -6],
        [21, -16],
        [11, -17],
        [5, -32],
        [-1, -49],
        [-61, -237],
        [-42, -188],
        [-24, -130],
        [3, -59],
        [2, -92],
        [23, -113],
        [26, -84],
        [45, -118],
        [79, -131],
        [111, -167],
        [128, -112],
        [143, -104],
        [133, -70],
        [158, -74],
        [116, -63],
        [112, -65],
        [143, -71],
        [61, -21],
        [36, -21],
        [35, -38],
        [21, -14],
        [11, -8],
        [23, -12],
        [30, 0],
        [22, 2],
        [33, -16],
        [32, -18],
        [43, -28],
        [46, -26],
        [19, -10],
        [32, -13],
        [38, -12],
        [35, -12],
        [36, -12],
        [25, 0],
        [40, 2],
        [1483, -10],
        [98, -6],
        [107, 0],
        [-2, -186],
        [-15, -49],
        [-5, -36],
        [9, -29],
        [9, -36],
        [17, -52],
        [20, -40],
        [36, -86],
        [-8, -78],
        [16, -65],
        [24, -64],
        [27, -59],
        [7, -55],
        [3, -51],
        [-2, -57],
        [13, -51],
        [12, -40],
        [13, -40],
        [1, -42],
        [-4, -34],
        [7, -44],
        [28, -42],
        [8, -33],
        [12, -26],
        [19, -28],
        [23, -36],
        [23, -40],
        [18, -34],
        [12, -38],
        [11, -28],
        [13, -19],
        [27, -23],
        [25, -36],
        [72, -83],
        [47, -38],
        [54, -32],
        [42, -34],
        [37, -34],
        [30, -21],
        [38, -36],
        [27, -51],
        [16, -13],
        [34, -40],
        [46, -54],
        [39, -26],
        [21, -8],
        [29, -7],
        [26, -19],
        [36, -14],
        [16, -16],
        [13, -16],
        [18, -16],
        [27, -18],
        [29, -14],
        [35, -16],
        [20, 0],
        [41, 7],
        [27, 5],
        [26, 0],
        [21, -5],
        [22, -1],
        [21, 0],
        [20, -5],
        [31, -7],
        [36, -4],
        [42, -4],
        [33, 2],
        [24, 0],
        [43, -4],
        [29, 0],
        [22, 8],
        [43, 7],
        [67, 15],
        [54, -20],
        [30, -22],
        [38, -17],
        [36, -18],
        [31, -18],
        [33, -24],
        [33, -33],
        [23, -13],
        [15, -3],
        [19, -11],
        [24, -9],
        [32, -1],
        [22, -9],
        [74, -24],
        [59, -8],
        [43, -10],
        [35, 4],
        [31, 4],
        [31, -2],
        [27, -4],
        [33, 6],
        [45, 33],
        [28, 26],
        [27, 42],
        [48, 68],
        [41, 48],
        [44, 59],
        [37, 42],
        [21, 23],
        [26, 25],
        [11, 33],
        [19, 27],
        [24, 23],
        [31, 22],
        [29, 19],
        [29, 22],
        [27, 19],
        [47, 17],
        [49, -2],
        [33, -8],
        [32, -21],
        [34, -26],
        [27, -30],
        [14, -8],
        [4, -10],
        [16, -42],
        [25, -36],
        [19, -26],
        [17, -35],
        [9, -28],
        [28, -40],
        [23, -24],
        [9, -8],
        [0, -10],
        [-9, -7],
        [-7, -10],
        [-5, -2],
        [-11, -10],
        [-4, -8],
        [0, -6],
        [-4, -6],
        [4, -42],
        [13, -29],
        [5, -5],
        [19, -16],
        [22, -9],
        [32, -2],
        [16, 7],
        [34, 18],
        [19, -2],
        [13, -3],
        [4, 10],
        [6, 7],
        [8, 6],
        [12, -2],
        [14, -1],
        [9, -3],
        [11, -6],
        [14, 0],
        [16, -2],
        [18, -2],
        [17, -7],
        [25, -14],
        [10, -2],
        [15, -6],
        [23, -3],
        [38, -16],
        [10, -1],
        [10, 0],
        [17, 2],
        [3, -4],
        [1, -6],
        [1, -2],
        [1, -4],
        [1, -6],
        [4, -4],
        [23, -17],
        [17, -12],
        [19, -5],
        [10, -4],
        [10, 2],
        [10, 1],
        [7, 1],
        [11, 0],
        [11, 2],
        [8, 2],
        [6, 2],
        [7, 7],
        [10, 7],
        [12, 16],
        [6, 10],
        [15, 27],
        [5, 24],
        [29, 36],
        [20, 30],
        [0, 10],
        [0, 12],
        [1, 8],
        [-5, 10],
        [-6, 8],
        [-4, 8],
        [-4, 8],
        [-3, 5],
        [-3, 8],
        [-2, 5],
        [-3, 6],
        [-2, 5],
        [-1, 7],
        [3, 7],
        [18, 16],
        [13, 2],
        [20, 5],
        [25, 9],
        [6, 12],
        [18, 4],
        [17, 6],
        [14, 8],
        [12, 12],
        [2, 12],
        [4, 16],
        [15, 13],
        [17, 14],
        [26, 14],
        [8, 14],
        [8, 20],
        [14, 27],
        [46, 64],
        [15, 9],
        [-2, 20],
        [48, 25],
        [36, 20],
        [19, 12],
        [29, 25],
        [34, 12],
        [62, 6],
        [45, 12],
        [32, 9],
        [26, 0],
        [25, 3],
        [19, 1],
        [25, 12],
        [24, 11],
        [-5, 30],
        [2, 24],
        [17, 20],
        [10, 26],
        [14, 23],
        [14, 17],
        [-12, 16],
        [-2, 23],
        [-8, 11],
        [-6, 16],
        [-12, 21],
        [2, 32],
        [21, 8],
        [27, 3],
        [14, 31],
        [1, 44],
        [29, 18],
        [44, 0],
        [57, 20],
        [35, 17],
        [34, -10],
        [39, 10],
        [44, -14],
        [70, -95],
        [14, -11],
        [15, -10],
        [21, 2],
        [14, 10],
        [14, 4],
        [9, 4],
        [10, 6],
        [9, 5],
        [6, 8],
        [6, 6],
        [8, 8],
        [10, 6],
        [21, 2],
        [45, -8],
        [17, -6],
        [24, -2],
        [31, -8],
        [46, -2],
        [32, -6],
        [25, -1],
        [23, -2],
        [31, 7],
        [32, 16],
        [26, 20],
        [40, 11],
        [18, 6],
        [45, 31],
        [76, 12],
        [40, -2],
        [24, 3],
        [37, -8],
        [42, 0],
        [36, -6],
        [22, 1],
        [16, 8],
        [15, -1],
        [33, 3],
        [60, 6],
        [66, 6],
        [30, 0],
        [40, 4],
        [29, 2],
        [29, 5],
        [54, 3],
        [37, 16],
        [43, 12],
        [34, 4],
        [31, 0],
        [33, 2],
        [35, 9],
        [50, 12],
        [16, 4],
        [36, 4],
        [36, 10],
        [33, 10],
        [37, 7],
        [37, 8],
        [25, 13],
        [-2, 51],
        [28, 23],
        [18, 32],
        [19, 21],
        [19, 19],
        [14, 16],
        [10, 10],
        [49, 46],
        [23, 15],
        [39, 9],
        [30, 14],
        [28, 8],
        [20, 5],
        [27, -2],
        [22, -9],
        [27, -21],
        [23, -11],
        [22, -14],
        [15, -26],
        [23, -33],
        [17, -18],
        [65, -2],
        [23, -27],
        [30, -16],
        [26, -4],
        [21, -10],
        [17, 14],
        [36, 2],
        [36, -12],
        [33, -6],
        [17, 22],
        [5, 30],
        [34, 32],
        [38, 27],
        [26, 5],
        [44, 30],
        [10, 30],
        [6, 27],
        [27, 40],
        [38, 34],
        [61, 8],
        [53, -8],
        [47, -18],
        [38, -12],
        [16, -17],
        [4, -21],
        [-9, -22],
        [-1, -21],
        [0, -10],
        [0, -10],
        [-6, -22],
        [2, -20],
        [9, -16],
        [10, -15],
        [12, -2],
        [18, 5],
        [14, 7],
        [16, 7],
        [14, 9],
        [16, 3],
        [19, 1],
        [13, 4],
        [2, 10],
        [0, 13],
        [-11, 8],
        [-4, 14],
        [-4, 13],
        [1, 25],
        [3, 24],
        [6, 11],
        [17, 12],
        [29, 6],
        [24, 8],
        [38, 4],
        [33, 2],
        [23, -8],
        [25, -7],
        [21, -8],
        [22, -10],
        [9, -13],
        [5, -22],
        [1, -13],
        [-1, -11],
        [-5, -17],
        [-6, -14],
        [-7, -6],
        [-6, -33],
        [6, -10],
        [2, -10],
        [6, -10],
        [8, -3],
        [8, -5],
        [13, -12],
        [9, -17],
        [6, -7],
        [0, -11],
        [6, -10],
        [3, -15],
        [9, -13],
        [31, -11],
        [20, -9],
        [16, -4],
        [25, -8],
        [41, -15],
        [29, -17],
        [7, -22],
        [0, -20],
        [0, -8],
        [-2, -11],
        [-3, -12],
        [2, -10],
        [-2, -6],
        [0, -9],
        [-2, -10],
        [2, -17],
        [23, -24],
        [16, -28],
        [6, -20],
        [10, -10],
        [8, -14],
        [16, -11],
        [22, -8],
        [24, -3],
        [23, -1],
        [25, -11],
        [16, -2],
        [11, -2],
        [19, -5],
        [11, 11],
        [6, 8],
        [34, 8],
        [14, 0],
        [15, -6],
        [10, -6],
        [8, -5],
        [10, -5],
        [6, -9],
        [11, -2],
        [13, -6],
        [15, -6],
        [8, -9],
        [11, -9],
        [8, -4],
        [13, -29],
        [22, -27],
        [8, -56],
        [14, -36],
        [17, -38],
        [10, -30],
        [29, -37],
        [22, -19],
        [47, -19],
        [20, -8],
        [18, 0],
        [26, -2],
        [15, 8],
        [15, 6],
        [19, 9],
        [11, 18],
        [10, 18],
        [6, 21],
        [-12, 6],
        [-23, 1],
        [-35, -1],
        [-11, 11],
        [-5, 16],
        [-5, 14],
        [20, 38],
        [20, 18],
        [12, 24],
        [-3, 24],
        [-9, 25],
        [-13, 26],
        [-2, 24],
        [-3, 27],
        [8, 22],
        [19, 15],
        [32, 8],
        [21, -11],
        [34, -13],
        [34, -15],
        [29, -13],
        [33, -29],
        [31, -43],
        [30, -29],
        [60, -70],
        [48, -61],
        [33, -32],
        [38, -11],
        [30, 5],
        [25, 5],
        [26, 7],
        [28, 1],
        [25, -25],
        [23, -38],
        [15, -14],
        [12, 12],
        [10, 20],
        [10, 25],
        [27, 54],
        [33, 38],
        [38, 30],
        [63, 35],
        [69, 28],
        [12, 11],
        [8, 11],
        [-10, 23],
        [-24, 12],
        [-30, 30],
        [-13, 23],
        [-24, 52],
        [-8, 20],
        [0, 35],
        [6, 24],
        [6, 22],
        [47, 31],
        [57, -2],
        [57, -21],
        [48, -18],
        [44, -18],
        [5, -11],
        [30, -11],
        [25, -25],
        [7, -28],
        [-8, -19],
        [-10, -35],
        [-24, -51],
        [-12, -17],
        [-4, -24],
        [-9, -13],
        [-3, -20],
        [14, -21],
        [12, -15],
        [10, -10],
        [13, -12],
        [9, -10],
        [10, -2],
        [10, -6],
        [8, -6],
        [15, -14],
        [21, -12],
        [12, -10],
        [5, -11],
        [12, -20],
        [18, -34],
        [34, -46],
        [47, -38],
        [61, -36],
        [67, -28],
        [41, -8],
        [28, -6],
        [32, -11],
        [11, -23],
        [-1, -26],
        [-22, -30],
        [-35, -42],
        [-25, -36],
        [8, -27],
        [-4, -20],
        [42, -68],
        [19, -38],
        [5, -45],
        [10, -34],
        [14, 2],
        [12, -4],
        [17, -7],
        [7, -3],
        [12, 0],
        [10, -5],
        [16, -8],
        [16, -5],
        [25, -6],
        [18, -12],
        [35, -8],
        [21, -6],
        [27, -21],
        [13, -8],
        [16, -18],
        [17, -18],
        [41, -40],
        [40, -13],
        [24, 9],
        [22, -4],
        [26, -2],
        [27, 0],
        [20, -3],
        [16, -12],
        [46, -8],
        [42, -18],
        [45, -17],
        [37, 15],
        [37, 10],
        [17, 8],
        [9, 14],
        [14, 17],
        [13, 35],
        [13, 28],
        [14, 27],
        [14, 12],
        [20, 9],
        [24, 12],
        [22, 10],
        [20, 2],
        [9, 17],
        [12, 13],
        [9, 4],
        [10, 16],
        [2, 23],
        [-8, 20],
        [-20, 12],
        [-19, 4],
        [-54, -6],
        [-49, -31],
        [-96, -50],
        [-42, -7],
        [-39, 34],
        [-48, 50],
        [-42, 42],
        [-6, 60],
        [57, 49],
        [31, 32],
        [77, -18],
        [88, -27],
        [79, -12],
        [60, -9],
        [31, 50],
        [22, 51],
        [59, 51],
        [40, 41],
        [30, 30],
        [32, 40],
        [18, 16],
        [44, 12],
        [30, 11],
        [40, 8],
        [16, -16],
        [15, -16],
        [27, -16],
        [29, -7],
        [50, 6],
        [55, 5],
        [129, -51],
        [0, 63],
        [34, -1],
        [15, -7],
        [11, -8],
        [17, -11],
        [16, -16],
        [23, -24],
        [3, -18],
        [9, -36],
        [7, -36],
        [7, -39],
        [2, -32],
        [0, -27],
        [-19, -14],
        [-13, -84],
        [-19, -62],
        [-14, -11],
        [-7, -30],
        [7, -16],
        [22, -17],
        [13, -9],
        [17, -8],
        [29, -4],
        [33, 2],
        [18, 8],
        [15, 10],
        [14, 4],
        [12, 2],
        [17, 16],
        [15, 4],
        [18, 3],
        [15, -7],
        [12, -21],
        [3, -16],
        [3, -19],
        [-4, -23],
        [-4, -22],
        [-1, -30],
        [2, -15],
        [5, -13],
        [4, -15],
        [4, -20],
        [9, -25],
        [20, -27],
        [20, -11],
        [17, -8],
        [17, -5],
        [21, -1],
        [36, 6],
        [25, 12],
        [25, 14],
        [10, 4],
        [17, 18],
        [5, 2],
        [7, 13],
        [0, 8],
        [-4, 14],
        [0, 10],
        [0, 9],
        [6, 12],
        [11, 13],
        [9, 13],
        [2, 10],
        [11, 14],
        [6, 11],
        [12, 11],
        [23, 21],
        [25, 19],
        [28, 13],
        [12, 7],
        [21, 22],
        [10, 11],
        [37, -23],
        [8, -2],
        [2705, -816],
        [1856, -1014],
        [1348, -910],
        [450, -303],
        [-143, 285],
        [381, 43],
        [1080, 1009],
        [24, -33],
        [13, -36],
        [19, -34],
        [30, -30],
        [58, -29],
        [47, -30],
        [26, -16],
        [38, -25],
        [28, -40],
        [22, -48],
        [11, -56],
        [27, -123],
        [23, -69],
        [27, -34],
        [35, -28],
        [45, -8],
        [105, -35],
        [51, -38],
        [66, -70],
        [73, -58],
        [64, -37],
        [110, -77],
        [80, -51],
        [42, -37],
        [40, -29],
        [50, -35],
        [69, -46],
        [42, -32],
        [34, -43],
        [8, -32],
        [31, -64],
        [29, -59],
        [12, -29],
        [25, -41],
        [29, -36],
        [24, -44],
        [55, -83],
        [23, -24],
        [49, -50],
        [33, -16],
        [31, -9],
        [19, -13],
        [15, -19],
        [8, -35],
        [0, -53],
        [2, -37],
        [15, -36],
        [18, -44],
        [5, -27],
        [2, -30],
        [-21, -22],
        [-24, -34],
        [-11, -21],
        [-4, -44],
        [0, -28],
        [-3, -29],
        [9, -30],
        [13, -14],
        [39, -34],
        [10, -18],
        [12, -47],
        [29, -46],
        [38, -42],
        [14, -45],
        [10, -28],
        [6, -17],
        [0, -13],
        [0, -13],
        [-8, -28],
        [-15, -23],
        [-18, -23],
        [0, -12],
        [6, -24],
        [1, -29],
        [3, -18],
        [-5, -18],
        [-8, -13],
        [-6, -7],
        [-12, -14],
        [-20, -18],
        [-17, -16],
        [-6, -14],
        [-6, -24],
        [8, -33],
        [-10, -62],
        [-8, -41],
        [-7, -39],
        [-4, -36],
        [-4, -32],
        [-11, -42],
        [-9, -60],
        [-4, -47],
        [6, -44],
        [9, -34],
        [5, -24],
        [12, -24],
        [4, -35],
        [11, -34],
        [12, -27],
        [11, -22],
        [2, -19],
        [7, -23],
        [4, -13],
        [8, -26],
        [3, -25],
        [8, -20],
        [6, -20],
        [5, -17],
        [4, -15],
        [12, -46],
        [8, -64],
        [1, -42],
        [-2, -67],
        [-7, -48],
        [-12, -43],
        [1, -29],
        [7, -35],
        [13, -48],
        [6, -25],
        [-2, -31],
        [-11, -38],
        [-1, -19],
        [-1, -12],
        [-4, -32],
        [2, -28],
        [7, -27],
        [10, -16],
        [8, -19],
        [8, -13],
        [4, -20],
        [2, -34],
        [-4, -26],
        [-8, -19],
        [-6, -20],
        [-8, -40],
        [-13, -65],
        [-8, -36],
        [2, -29],
        [2, -30],
        [0, -28],
        [-1, -23],
        [1, -41],
        [6, -59],
        [4, -34],
        [4, -100],
        [3, -55],
        [2, -50],
        [2, -31],
        [-2, -21],
        [4, -27],
        [0, -32],
        [0, -27],
        [2, -38],
        [10, -20],
        [4, -21],
        [11, -28],
        [0, -20],
        [12, -18],
        [9, 2],
        [12, 2],
        [13, -3],
        [6, -9],
        [6, -16],
        [5, -16],
        [10, -19],
        [8, -11],
        [11, -6],
        [12, -16],
        [14, -8],
        [8, -8],
        [14, -7],
        [24, 0],
        [41, 3],
        [19, -26],
        [35, -20],
        [10, -24],
        [4, -17],
        [-4, -15],
        [0, -16],
        [6, -7],
        [6, 1],
        [11, 6],
        [1, -8],
        [1, -19],
        [8, -25],
        [29, -18],
        [9, -14],
        [13, -21],
        [24, -10],
        [15, -12],
        [14, -11],
        [14, -8],
        [11, -15],
        [22, -21],
        [5, -2],
        [4, -9],
        [-2, -8],
        [1, -8],
        [6, -4],
        [5, -2],
        [9, 2],
        [6, 4],
        [4, 4],
        [4, 2],
        [4, -4],
        [4, -6],
        [4, -8],
        [8, -8],
        [27, -36],
        [13, -18],
        [14, -17],
        [9, -11],
        [19, -12],
        [16, -17],
        [21, -12],
        [15, -12],
        [16, -9],
        [17, -16],
        [20, -14],
        [18, -15],
        [18, -13],
        [35, -19],
        [39, -7],
        [39, 0],
        [45, -12],
        [54, -27],
        [67, -18],
        [37, -10],
        [19, 0],
        [23, -4],
        [33, -7],
        [35, -18],
        [11, -18],
        [12, -26],
        [21, -54],
        [24, -54],
        [16, -40],
        [17, -32],
        [15, -36],
        [15, -32],
        [11, -31],
        [22, -45],
        [12, -26],
        [21, -45],
        [11, -25],
        [40, 5],
        [37, 8],
        [44, -1],
        [41, 3],
        [74, -13],
        [28, -10],
        [25, -6],
        [39, -19],
        [59, -40],
        [47, -43],
        [52, -41],
        [117, -85],
        [76, -122],
        [25, -135],
        [15, -105],
        [-6, -99],
        [22, -92],
        [11, -75],
        [15, -42],
        [8, -52],
        [3, -39],
        [4, -31],
        [18, -37],
        [6, -20],
        [7, -32],
        [0, -29],
        [4, -27],
        [2, -23],
        [6, -33],
        [12, -24],
        [15, -47],
        [4, -35],
        [-8, -33],
        [-2, -27],
        [1, -12],
        [37, -47],
        [43, -2],
        [42, 19],
        [21, 16],
        [12, 13],
        [24, 16],
        [25, 11],
        [27, 16],
        [24, 34],
        [14, 16],
        [22, 59],
        [45, 16],
        [32, -5],
        [63, -49],
        [39, -25],
        [90, -89],
        [46, -48],
        [80, -58],
        [53, 8],
        [43, -2],
        [27, -29],
        [54, -55],
        [64, -24],
        [61, -19],
        [105, -36],
        [24, -10],
        [16, -2],
        [12, -7],
        [23, -25],
        [15, -14],
        [26, -22],
        [23, -20],
        [26, -10],
        [20, 4],
        [27, -2],
        [22, 8],
        [23, 12],
        [13, 8],
        [20, 8],
        [22, 10],
        [24, 4],
        [27, 4],
        [30, -10],
        [32, 8],
        [26, 19],
        [17, 21],
        [26, 17],
        [18, 31],
        [25, 31],
        [23, 29],
        [24, 17],
        [17, 19],
        [17, 9],
        [18, 7],
        [21, 4],
        [33, 0],
        [16, 0],
        [20, -4],
        [20, -7],
        [24, -23],
        [22, -26],
        [142, -776],
        [2213, 1088],
        [506, -1034],
        [598, 413],
        [2069, 1436],
        [1617, 1301],
        [1336, -1822],
        [655, 101],
        [34, -12],
        [24, -16],
        [25, -22],
        [24, -27],
        [24, -30],
        [16, -16],
        [18, -22],
        [30, -26],
        [25, -24],
        [27, -25],
        [32, -32],
        [42, -20],
        [32, -14],
        [33, 4],
        [25, 17],
        [31, -3],
        [24, -19],
        [27, -7],
        [23, 10],
        [16, 8],
        [15, 12],
        [17, 11],
        [27, 10],
        [23, -1],
        [28, -10],
        [29, -5],
        [27, -9],
        [25, -8],
        [26, -1],
        [35, -16],
        [31, -15],
        [28, -23],
        [12, -18],
        [8, -12],
        [6, -16],
        [16, -16],
        [16, -28],
        [12, -26],
        [5, -29],
        [2, -12],
        [0, -31],
        [2, -34],
        [6, -21],
        [15, -14],
        [16, -6],
        [18, -2],
        [28, -2],
        [35, 6],
        [28, 6],
        [21, 0],
        [23, -4],
        [15, -12],
        [0, -26],
        [13, -25],
        [34, -24],
        [40, -29],
        [37, -41],
        [26, -29],
        [29, -27],
        [17, -23],
        [7, -22],
        [-16, -31],
        [-8, -31],
        [8, -29],
        [19, -33],
        [16, -34],
        [-4, -36],
        [-16, -24],
        [-4, -33],
        [16, -33],
        [44, -14],
        [30, -35],
        [25, -46],
        [27, -32],
        [24, -24],
        [24, -25],
        [14, -22],
        [8, -30],
        [-4, -26],
        [-6, -34],
        [-6, -29],
        [-6, -34],
        [2, -28],
        [5, -28],
        [23, -18],
        [20, -18],
        [39, -11],
        [35, -12],
        [35, -12],
        [23, -22],
        [4, -32],
        [2, -21],
        [9, -22],
        [21, -11],
        [22, -7],
        [28, -13],
        [26, -13],
        [17, -17],
        [13, -17],
        [11, -18],
        [6, -16],
        [5, -33],
        [14, -22],
        [-6, -15],
        [-16, -10],
        [-22, -4],
        [-22, -6],
        [-26, -2],
        [-64, -11],
        [-43, -10],
        [-37, -13],
        [-39, 4],
        [-33, -7],
        [-30, -25],
        [-35, -24],
        [-43, -18],
        [-42, -18],
        [-30, -14],
        [-26, -5],
        [-33, -38],
        [-31, -17],
        [-52, -17],
        [-74, -21],
        [-58, -31],
        [-45, -12],
        [-35, -18],
        [-23, -11],
        [-36, -19],
        [-23, -19],
        [-32, -34],
        [-8, -17],
        [-12, -18],
        [-8, -21],
        [-6, -17],
        [-22, -15],
        [-14, -26],
        [-10, -32],
        [2, -28],
        [18, -26],
        [24, -20],
        [24, -9],
        [32, -1],
        [33, 4],
        [35, 1],
        [35, -11],
        [16, -21],
        [10, -37],
        [7, -23],
        [15, -16],
        [27, -25],
        [27, -14],
        [44, -24],
        [37, -12],
        [30, -5],
        [23, -18],
        [36, -9],
        [45, 4],
        [45, 4],
        [52, -10],
        [37, -18],
        [53, -38],
        [32, -30],
        [30, -26],
        [38, -31],
        [22, -26],
        [18, -10],
        [11, -32],
        [3, -24],
        [9, -15],
        [13, -7],
        [21, 1],
        [16, 3],
        [20, 3],
        [15, 5],
        [19, 3],
        [23, 6],
        [31, 0],
        [24, -15],
        [22, -28],
        [33, -29],
        [30, -24],
        [25, -12],
        [51, 0],
        [39, 4],
        [43, -8],
        [39, -23],
        [25, -22],
        [20, -5],
        [16, -5],
        [14, -3],
        [20, 5],
        [28, 15],
        [25, 17],
        [25, 17],
        [45, 8],
        [52, 2],
        [46, -15],
        [33, -20],
        [26, -4],
        [27, -5],
        [19, -18],
        [16, -30],
        [4, -22],
        [9, -13],
        [15, -6],
        [21, -6],
        [20, 7],
        [29, 4],
        [26, 2],
        [30, -13],
        [27, -9],
        [18, -1],
        [35, 1],
        [34, -6],
        [33, 8],
        [34, -4],
        [57, -21],
        [39, -6],
        [30, -2],
        [32, 1],
        [21, 5],
        [16, -121],
        [80, -128],
        [14, -73],
        [132, -175],
        [-879, -5521],
        [3261, -3508],
      ],
      [
        [205371, 183845],
        [-2, 208],
        [-1579, -16],
        [-1560, -17],
        [754, 1239],
        [-395, 909],
        [-29, 5],
        [-1410, 232],
        [-57, 326],
        [-395, -2],
        [-1, -587],
        [-4, -1443],
        [-13, -10],
        [-1628, -1354],
        [-488, 294],
        [-583, 351],
        [-216, 135],
        [-180, 441],
        [-298, 723],
        [-261, 636],
      ],
      [
        [197026, 185915],
        [141, 276],
        [-32, 88],
        [-412, 963],
        [-592, 1387],
        [438, 181],
        [397, 164],
        [116, 50],
        [231, 96],
        [629, 262],
        [8, 2],
        [176, 74],
        [432, 186],
        [680, 289],
        [147, 63],
        [21, 8],
        [308, 47],
        [-789, 730],
        [292, 296],
        [-77, -4],
        [-155, -8],
        [-641, -34],
        [-298, -17],
        [-722, -39],
        [-218, 875],
        [-31, 36],
        [1076, 4],
        [53, 0],
        [1562, 6],
        [-17, -24],
        [700, -1100],
        [542, 350],
        [-2, 876],
        [-2, 367],
        [769, 2],
        [280, 774],
        [66, 179],
        [232, 664],
        [-128, 52],
        [-90, 110],
        [-129, 54],
        [-78, 94],
        [-111, 67],
        [-26, 197],
        [96, 93],
        [149, 80],
        [71, 170],
        [-137, 17],
        [-107, 100],
        [-46, 64],
        [-32, 118],
        [-10, 259],
        [-90, 235],
        [-2, 194],
        [13, 18],
        [-80, 93],
        [-12, 54],
        [-22, 243],
        [-29, -26],
        [-183, -48],
        [-56, -46],
        [-183, -22],
        [-55, 47],
        [71, 135],
        [-57, 53],
        [-41, 237],
        [-248, 91],
        [-251, -74],
        [-64, 131],
        [-52, 109],
        [-48, 214],
        [61, 195],
        [-245, 70],
        [-155, -76],
        [-191, 98],
        [-24, 142],
        [-77, 233],
        [112, 115],
        [52, 206],
        [-139, 133],
        [-3, 127],
        [-283, 37],
        [-373, -142],
        [-155, 2],
        [-223, 62],
        [-341, 27],
        [-196, -18],
        [-122, -102],
        [-356, 125],
        [-350, 58],
        [-253, -8],
        [-310, 9],
        [-256, -121],
        [-8, 2],
        [-180, 10],
        [-318, -42],
        [-226, -147],
        [-304, 109],
        [-219, -190],
        [-187, -152],
        [59, -232],
        [-94, -250],
        [-184, -99],
        [-250, 75],
        [-258, 49],
        [-221, 120],
        [-291, -29],
        [-125, -203],
        [-203, 49],
        [-99, 78],
        [-63, 99],
        [-88, -65],
        [-76, -57],
        [-77, -152],
        [-129, -133],
        [10, -69],
        [-97, -29],
        [-71, -6],
        [-153, 104],
        [-218, 232],
        [-298, -145],
        [-182, 15],
        [-51, 157],
        [-51, 126],
        [-381, 77],
        [-294, -84],
        [-111, -374],
        [-273, -30],
        [-546, 106],
        [-290, 211],
        [-199, 108],
        [-189, 60],
        [-134, 75],
        [-243, 92],
        [-207, 217],
        [-232, 331],
        [-338, 503],
        [-248, 133],
        [-347, 54],
        [-286, -59],
        [-256, 69],
        [-6, 4],
        [-232, 123],
        [-5, 4],
        [-416, 47],
        [-274, 120],
        [-134, 57],
        [-246, 114],
        [-31, 236],
        [-84, 180],
        [-37, 224],
        [-62, 251],
        [-68, 285],
        [-258, 295],
        [-356, 153],
        [-184, 56],
        [-94, 148],
        [-70, 112],
        [-379, 83],
        [-152, 210],
        [-178, -78],
        [-314, 169],
        [-248, 8],
        [-282, 16],
        [-343, 224],
        [-284, 64],
        [-71, 15],
        [-185, 134],
        [-17, 24],
        [-30, 4],
        [-58, -12],
        [-39, -33],
        [-41, -39],
        [-29, -11],
        [-35, -20],
        [-72, 5],
        [-37, 6],
        [-30, 23],
        [-68, 49],
        [-70, 37],
        [-16, 27],
        [-69, 59],
        [-80, 64],
        [-87, 48],
        [-89, 24],
        [-55, 4],
        [-16, 9],
        [-50, 30],
        [-38, 22],
        [-49, 10],
        [-49, -7],
        [-65, -25],
        [-26, 0],
        [-48, 29],
        [0, 23],
        [-11, 31],
        [-18, 18],
        [-107, 94],
        [-15, 9],
        [-19, 20],
        [-17, 28],
        [-6, 10],
        [0, 10],
        [-15, 6],
        [-20, 0],
        [-20, 6],
        [-21, 14],
        [-20, 14],
        [-39, 35],
        [-20, 34],
        [-28, 36],
        [-45, 34],
        [-51, 18],
        [-73, -10],
        [-34, -20],
        [-43, -34],
        [-37, -15],
        [0, -25],
        [-43, -5],
        [-25, 10],
        [-11, 14],
        [24, 37],
        [5, 41],
        [-9, 47],
        [2, 42],
        [44, 55],
        [29, 55],
        [25, 59],
        [10, 42],
        [-8, 30],
        [-43, 32],
        [-24, -2],
        [-24, 23],
        [-43, 8],
        [-41, -8],
        [-49, -15],
        [-115, -27],
        [-139, -3],
        [-42, -32],
        [-37, -56],
        [-37, -57],
        [-28, -17],
        [-31, 4],
        [-47, 62],
        [-64, 126],
        [-24, 35],
        [-83, 51],
        [-73, 7],
        [-76, 13],
        [-49, 26],
        [-14, 35],
        [-2, 48],
        [-14, 41],
        [-11, 45],
        [-38, 38],
        [-56, 52],
        [-106, 13],
        [-29, -1],
        [-27, -1],
        [-94, -24],
        [-37, -39],
        [-38, -44],
        [-21, -63],
        [6, -43],
        [9, -36],
        [27, -58],
        [1, -56],
        [-8, -52],
        [-10, -14],
        [-32, -49],
        [-62, -26],
        [-57, 13],
        [-74, -23],
        [-45, -54],
        [-2, -22],
        [0, -20],
        [-9, -18],
        [-54, -38],
        [-44, -48],
        [-69, -71],
        [-38, -60],
        [-36, -29],
        [-44, -13],
        [-24, 13],
        [-29, 6],
        [-14, 22],
        [-13, 35],
        [-26, 34],
        [-96, 76],
        [-59, 33],
        [-68, 18],
        [-112, 2],
        [-63, 11],
        [-17, 11],
        [-27, 32],
        [-63, 28],
        [-45, 34],
        [-77, 54],
        [-25, 24],
        [-28, 39],
        [-49, 28],
        [-22, 32],
        [-43, 84],
        [-17, 97],
        [26, 87],
        [-2, 32],
        [-24, 105],
        [-52, 75],
        [-30, -2],
        [-87, 10],
        [-57, 12],
        [-71, -2],
        [-77, -12],
        [-50, -11],
        [-36, -10],
        [-21, -30],
        [-25, -8],
        [-35, -10],
        [-52, 10],
        [-50, 25],
        [-66, 28],
        [-54, 28],
        [-67, 26],
        [-74, 22],
        [-51, 32],
        [-39, 34],
        [-9, 5],
        [-49, 31],
        [-69, 19],
        [-65, -2],
        [-38, -20],
        [-56, -29],
        [-51, -26],
        [-89, -30],
        [-72, 3],
        [-14, 3],
        [-32, 37],
        [-42, 51],
        [-39, 11],
        [-53, -5],
        [-42, -20],
        [-41, -29],
        [-101, -42],
        [-67, -11],
        [-84, -18],
        [-72, -21],
        [-70, 1],
        [-114, 30],
        [-87, 30],
        [-40, 29],
        [-38, 15],
        [-35, -4],
        [-28, -23],
        [-13, -21],
        [-41, -123],
        [-22, -26],
        [-17, -10],
        [-33, -6],
        [-90, 2],
        [-96, 2],
        [-60, 4],
        [-24, 16],
        [-14, 59],
        [-38, 38],
        [-38, 43],
        [-34, 9],
        [-68, -23],
        [-67, -37],
        [-50, -11],
        [-39, -21],
        [-84, -50],
        [-48, -57],
        [-31, -22],
        [-40, -8],
        [-80, 20],
        [-121, -63],
        [-22, -30],
        [-16, -18],
        [-29, -6],
        [-22, -14],
        [-20, -29],
        [-21, -16],
        [-27, -5],
        [-107, -23],
        [-28, 9],
        [-26, 12],
        [-28, 13],
        [-39, 37],
        [-41, 34],
        [-33, 22],
        [-52, 16],
        [-38, 16],
        [-33, 18],
        [-32, 29],
        [-85, 58],
        [-50, 4],
        [-36, -2],
        [-44, -18],
        [-59, -50],
        [-18, -27],
        [-30, -18],
        [-151, -5],
        [-49, -18],
        [-36, -2],
        [-57, 11],
        [-51, 10],
        [-81, 12],
        [-57, 16],
        [-68, 29],
        [-34, 32],
        [-50, 30],
        [-55, 21],
        [-80, -3],
        [-40, -11],
        [-54, -27],
        [-38, -22],
        [-43, -2],
        [-35, 14],
        [-30, 32],
        [-33, 39],
        [-24, 42],
        [-17, 59],
        [-37, 53],
        [-34, 9],
        [-137, 16],
        [-75, -37],
        [-80, -64],
        [-107, -80],
        [-65, -27],
        [19, 21],
        [-4, 41],
      ],
      [
        [171250, 203935],
        [15, 140],
        [-150, 173],
        [-81, 83],
        [-93, 76],
        [49, 95],
        [245, 219],
        [-32, 209],
        [-106, 66],
        [-81, 22],
        [64, 148],
        [8, 259],
        [50, 232],
        [-31, 137],
        [-115, 117],
        [-106, 47],
        [92, 151],
        [34, 208],
        [-258, 193],
        [-185, 159],
        [-255, 258],
        [82, 214],
        [148, 115],
        [249, 201],
        [167, 373],
        [182, 148],
        [32, 346],
        [55, 186],
        [232, 126],
        [130, 118],
        [-31, 177],
        [7, 228],
        [97, 218],
        [317, 187],
        [30, 238],
        [142, 139],
        [36, 232],
        [112, 73],
        [395, 95],
        [199, 145],
        [207, 411],
        [-14, 342],
        [87, 68],
        [72, 125],
        [-235, 151],
        [-63, 126],
        [4, 55],
        [108, 266],
        [-136, 272],
        [144, 455],
        [-214, 691],
        [-230, 488],
        [61, 282],
        [-54, 273],
        [-16, 80],
      ],
      [
        [197026, 185915],
        [-883, -1448],
        [-1970, 3153],
        [-700, 682],
        [-1137, 1119],
        [-65, 45],
        [65, 23],
        [33, 10],
        [2849, 926],
        [-343, -96],
        [-3381, -608],
        [-499, -89],
        [-1079, -195],
        [1258, -319],
        [-27, -1336],
        [203, -714],
        [-1556, -1160],
        [-31, 19],
        [-17, 10],
        [-9, 12],
        [-11, 20],
        [-19, 31],
        [-17, 39],
        [-25, 26],
        [-42, 16],
        [-45, 13],
        [-33, 28],
        [-68, 71],
        [-43, 75],
        [-34, 53],
        [-28, 24],
        [-24, 12],
        [-28, -5],
        [-46, -30],
        [-31, -19],
        [-35, -5],
        [-39, -4],
        [-26, -4],
        [-33, -1],
        [-39, 1],
        [-25, 0],
        [-27, 7],
        [-29, 9],
        [-14, 4],
        [-28, 1],
        [-31, 0],
        [-52, 17],
        [-10, -12],
        [-444, -363],
        [-41, -32],
        [-144, -111],
        [-793, 861],
        [-1174, 418],
        [1672, 1230],
        [-2854, 1197],
        [-40, -85],
        [-1531, -709],
        [-2414, -101],
        [-760, -32],
        [-652, -15],
        [-599, -15],
        [-539, -13],
        [-262, -5],
        [-405, -10],
        [-82, -1],
        [-5, -4],
        [-13, -11],
        [-31, -4],
        [-29, 9],
        [-35, 3],
        [-23, -9],
        [-16, -8],
        [-15, -1],
        [-31, -9],
        [-28, -31],
        [-23, -14],
        [-19, -10],
        [-26, -6],
        [-25, -17],
        [-42, -22],
        [-36, -4],
        [-40, 14],
        [-27, 10],
        [-21, 2],
        [-12, 0],
        [-9, 6],
        [-16, 0],
        [-11, -6],
        [-11, -4],
        [-17, -2],
        [-3, -8],
        [-2, -8],
        [-3, -6],
        [-9, 0],
        [-7, 0],
        [-2, -14],
        [-2, -8],
        [-7, 0],
        [-8, 4],
        [-4, 8],
        [-28, 2],
        [-12, 4],
        [-22, 0],
        [-63, 18],
        [-15, 12],
        [-9, 16],
        [4, 13],
        [-13, -5],
        [-9, -1],
        [-5, 10],
        [0, 10],
        [-12, 3],
        [-29, 9],
        [-9, 11],
        [-10, 10],
        [-19, 8],
        [-24, -3],
        [-8, -7],
        [-8, 1],
        [-7, 9],
        [-10, 3],
        [-9, 4],
        [-22, 0],
        [-175, 30],
        [-6, 2],
        [-10, 0],
        [-16, -6],
        [-19, -7],
        [-17, 0],
        [-23, -4],
        [-34, -4],
        [-30, 1],
        [-26, 1],
        [-15, -5],
        [-13, -2],
        [-14, -19],
        [-12, 0],
        [-16, -3],
        [-12, 1],
        [-17, 4],
        [-12, 9],
        [-17, 14],
        [0, 16],
        [9, 24],
        [1, 15],
        [-6, 10],
        [-13, 5],
        [-17, 1],
        [-16, -3],
        [-24, -2],
        [-14, -17],
        [-22, -13],
        [-5, -20],
        [-4, -20],
        [-25, -12],
        [-4, -29],
        [21, -25],
        [20, -21],
        [9, -14],
        [7, -12],
        [-5, -26],
        [-5, -38],
        [-33, -29],
        [-24, -11],
        [-22, -5],
        [-4, -11],
        [6, -25],
        [-6, -16],
        [-18, -12],
        [-15, -2],
        [-12, 10],
        [-16, 20],
        [-12, 18],
        [-14, 13],
        [-31, 2],
        [-27, -4],
        [-26, 2],
        [-44, 7],
        [-31, 3],
        [-20, -5],
        [-14, -5],
        [-20, -4],
        [-6, -7],
        [-4, -16],
        [-23, -18],
        [-15, -6],
        [-16, 4],
        [-23, 0],
        [-9, -14],
        [-6, -14],
        [-15, -29],
        [-11, -15],
        [-8, -10],
        [-6, -7],
        [-7, -2],
        [-16, 0],
        [-15, 2],
        [-10, 7],
        [-10, 10],
        [-14, 11],
        [-15, 8],
        [-11, 1],
        [-8, -2],
        [-8, -5],
        [-3, -9],
        [-8, -21],
        [-14, -15],
        [-6, -20],
        [-6, -37],
        [4, -56],
        [0, -19],
        [8, -32],
        [2, -22],
        [-4, -15],
        [-6, -15],
        [-21, -11],
        [-21, -9],
        [-22, 0],
        [-18, 0],
        [-14, 1],
        [-22, -1],
        [-16, -11],
        [-4, -13],
        [4, -13],
        [5, -8],
        [10, -16],
        [4, -12],
        [-2, -18],
        [-17, -6],
        [-19, -8],
        [-27, -4],
        [-23, -2],
        [-22, -6],
        [-29, -6],
        [-23, -9],
        [-36, -8],
        [-38, 1],
        [-18, 3],
        [-19, 9],
        [-16, 6],
        [-22, 10],
        [-17, -2],
        [-2, -11],
        [-4, -16],
        [7, -23],
        [2, -16],
        [-2, -11],
        [-7, -11],
        [-14, -5],
        [-23, 0],
        [-12, 7],
        [-21, 20],
        [-24, 10],
        [-28, -2],
        [-18, -14],
        [-11, -10],
        [-12, -8],
        [-10, 0],
        [-12, 2],
        [-16, -21],
        [-15, -18],
        [8, -19],
        [14, -29],
        [29, -17],
        [23, -17],
        [17, -19],
        [1, -19],
        [-4, -6],
        [-10, -7],
        [-13, -2],
        [-16, 0],
        [-31, -24],
        [-28, -29],
        [-31, -26],
        [-12, -12],
        [-23, -12],
        [-8, -25],
        [15, -39],
        [16, -34],
        [16, -23],
        [-3, -18],
        [-19, -18],
        [-21, -14],
        [-22, -4],
        [-17, -2],
        [-16, 0],
        [-21, 2],
        [-22, -6],
        [-23, -17],
        [-16, -6],
        [-37, -14],
        [-54, -18],
        [-49, -30],
        [-10, -14],
        [-7, -12],
        [-8, -10],
        [-6, -20],
        [1, -62],
        [1, -20],
        [-22, -32],
        [-15, -12],
        [-13, -16],
        [-6, -10],
        [-13, -4],
        [-15, -4],
        [-15, -3],
        [-24, 1],
        [-56, 16],
        [-50, 12],
        [-42, 28],
        [-61, 20],
        [-41, -10],
        [-48, -28],
        [-19, -4],
        [-22, 4],
        [-21, 8],
        [-18, 12],
        [-12, 14],
        [-4, 15],
        [-28, 64],
        [-2, 18],
        [4, 25],
        [6, 10],
        [5, 8],
        [0, 12],
        [0, 20],
        [2, 21],
        [-9, 12],
        [-13, 26],
        [-9, 4],
        [-18, 6],
        [-22, 10],
        [-21, 10],
        [-27, 2],
        [-18, 0],
        [-19, 3],
        [-22, -3],
        [-19, -2],
        [-19, 0],
        [-11, 2],
        [-16, 13],
        [-3, 7],
        [3, 15],
        [4, 12],
        [2, 9],
        [2, 8],
        [5, 6],
        [5, 10],
        [5, 14],
        [-13, 12],
        [-21, 20],
        [-27, 13],
        [-19, 4],
        [-17, 2],
        [-17, -6],
        [-15, -6],
        [-13, -13],
        [-13, -8],
        [-9, -8],
        [-10, -6],
        [-12, 0],
        [-7, 4],
        [-16, 12],
        [-11, 15],
        [-7, 12],
        [-6, 6],
        [-10, 4],
        [-13, 8],
        [-15, 8],
        [-24, 4],
        [-42, 0],
        [-36, 6],
        [-44, 2],
        [-28, 6],
        [-27, 1],
        [-14, -7],
        [-15, -12],
        [-16, -8],
        [-21, -2],
        [-29, -12],
        [-42, 0],
        [-27, 4],
        [-27, 4],
        [-37, 14],
        [-47, 13],
        [-30, 6],
        [-35, -2],
        [-16, -6],
        [-23, -7],
        [-30, -4],
        [-50, 9],
        [-13, 4],
        [-14, 15],
        [4, 22],
        [3, 17],
        [-2, 17],
        [-5, 16],
        [-27, 16],
        [-31, 10],
        [-26, 8],
        [-17, -2],
        [-27, 10],
        [-33, 18],
        [-26, 24],
        [-13, 12],
        [-17, 9],
        [-5, 6],
        [-16, 7],
        [-24, 14],
        [-18, 10],
        [-22, 8],
        [-29, 9],
        [-27, 7],
        [-16, 8],
        [-15, 7],
        [-11, 6],
        [-20, 2],
        [-27, -7],
        [-24, -14],
        [-18, -12],
        [-4, -10],
        [-1, -18],
        [-4, -12],
        [-7, -6],
        [-20, -4],
        [-17, -2],
        [-15, 1],
        [-22, 2],
        [-12, 1],
        [-10, -4],
        [-15, 0],
        [-15, -2],
        [-5, -15],
        [-15, -25],
        [-11, -1],
        [-16, -3],
        [-16, 5],
        [-18, 5],
        [-15, 1],
        [-11, 0],
        [-12, -6],
        [-18, -12],
        [-12, -7],
        [-17, -15],
        [-18, -17],
        [-17, -20],
        [-11, -19],
        [-12, -14],
        [-2, -16],
        [-10, -25],
        [-14, -9],
        [-15, -4],
        [-32, -11],
        [-32, -20],
        [-20, -17],
        [-16, -16],
        [-11, -22],
        [-2, -25],
        [-5, -19],
        [-3, -20],
        [0, -22],
        [-5, -12],
        [-16, -12],
        [-13, -16],
        [-18, -16],
        [-9, -20],
        [-5, -15],
        [-12, -16],
        [-17, -17],
        [-19, -24],
        [-27, -28],
        [-14, -8],
        [-11, -9],
        [-19, -9],
        [-18, -5],
        [-22, -2],
        [-25, -8],
        [-31, -5],
        [-29, -15],
        [-10, -6],
        [-8, -11],
        [-3, -6],
        [-3, -3],
        [-1, 0],
        [-8, -8],
        [-9, -8],
        [-14, -10],
        [-10, 0],
        [-12, 0],
        [-17, 6],
        [-10, 0],
        [-8, 2],
        [-10, 0],
        [-11, 4],
        [-14, 2],
        [-23, 6],
        [-14, 4],
        [-14, 7],
        [-2, 26],
        [10, 21],
        [2, 16],
        [2, 15],
        [-2, 13],
        [-16, 11],
        [-17, 2],
        [-20, 0],
        [-21, -6],
        [-16, -10],
        [-9, -13],
        [-6, -21],
        [-6, -25],
        [-8, -48],
        [-10, -50],
        [4, -43],
        [12, -34],
        [14, -26],
        [8, -30],
        [0, -14],
        [0, -8],
        [-2, -4],
        [-6, -2],
        [-8, -3],
        [-12, -8],
        [-10, -4],
        [-17, -5],
        [-20, -8],
        [-20, -11],
        [-9, -22],
        [-6, -17],
        [2, -18],
        [-6, -11],
        [-8, -7],
        [-6, -7],
        [-7, -13],
        [-10, -9],
        [-16, -12],
        [-15, -10],
        [-11, -8],
        [-16, -7],
        [-22, -9],
        [-22, -8],
        [-25, -13],
        [-35, -12],
        [-43, -18],
        [-29, -23],
        [-31, -27],
        [-22, -23],
        [-27, -20],
        [-20, -10],
        [-31, -12],
        [-32, -10],
        [-30, -6],
        [-39, -6],
        [-27, -10],
        [-20, -8],
        [-4, -20],
        [3, -25],
        [3, -27],
        [2, -19],
        [-2, -15],
        [-7, -4],
        [-15, -11],
        [-23, -14],
        [-30, -10],
        [-24, 0],
        [-17, 2],
        [-30, 4],
        [-14, 0],
        [-23, 0],
        [-19, -7],
        [-17, -5],
        [-39, -21],
        [-28, -30],
        [-6, -26],
        [-2, -23],
        [-6, -18],
        [10, -18],
        [8, -8],
        [2, -27],
        [-2, -34],
        [-10, -31],
        [-12, -23],
        [-11, -26],
        [-5, -28],
        [-3, -17],
        [-3, -16],
        [-7, -16],
        [-7, -12],
        [-7, -8],
        [-5, -8],
        [-5, -7],
        [-6, -8],
        [-7, -12],
        [-10, -9],
        [-4, -10],
        [-4, -20],
        [-6, -15],
        [-10, -16],
        [-11, -14],
        [-13, -17],
        [-12, -15],
        [-9, -12],
        [-7, -10],
        [-15, -10],
        [-10, -16],
        [-10, -23],
        [-2, -6],
        [0, -1],
        [-1, -14],
        [-3, -6],
        [3, -8],
        [-4, -8],
        [-14, -9],
        [-10, -10],
        [-8, -8],
        [-20, -4],
        [-17, 4],
        [-41, 16],
        [-27, 17],
        [-18, 13],
        [-17, 7],
        [-27, 3],
        [-22, 0],
        [-30, 2],
        [-21, -1],
        [-27, -7],
        [-23, -5],
        [-36, -11],
        [-23, -10],
        [-10, -14],
        [-3, -10],
        [-8, -16],
        [0, -16],
        [4, -26],
        [2, -13],
        [-10, -8],
        [-14, -5],
        [-22, -8],
        [-19, -8],
        [-15, -6],
        [-16, -10],
        [-17, -8],
        [-31, -13],
        [-20, -4],
        [-19, -6],
        [-18, -12],
        [-11, -2],
        [-15, -8],
        [-15, -6],
        [-26, -8],
        [-43, -6],
        [-34, -10],
        [-37, -24],
        [-15, -24],
        [-12, -28],
        [-9, -31],
        [-3, -23],
        [-6, -21],
        [-4, -16],
        [-8, -9],
        [-21, -3],
        [-15, 3],
        [-15, 8],
        [-22, -3],
        [-14, -11],
        [-12, -9],
        [0, -21],
        [4, -10],
        [-6, -12],
        [-8, -23],
        [-4, -16],
        [-2, -22],
        [-4, -18],
        [-3, -15],
        [-1, -14],
        [0, -11],
        [4, -10],
        [0, -12],
        [-1, -16],
        [-2, -8],
        [-2, -12],
        [-3, -13],
        [-4, -8],
        [-10, -5],
        [-15, -8],
        [-10, -5],
        [-9, -7],
        [-7, -13],
        [0, -21],
        [11, -31],
        [16, -28],
        [14, -20],
        [12, -23],
        [4, -21],
        [-4, -19],
        [-12, -18],
        [-19, -15],
        [-29, -18],
        [-22, -14],
      ],
      [
        [169031, 184669],
        [-1326, 794],
        [-277, 163],
        [-1074, 630],
        [-75, -187],
        [-440, 35],
        [-1288, -637],
        [-16, -6],
        [-2993, -1487],
        [-1200, -73],
        [-882, -520],
        [19, 96],
        [-242, 355],
        [-482, 710],
        [-764, 1647],
        [19, 23],
        [7, 17],
        [7, 15],
        [5, 12],
        [8, 17],
        [3, 7],
        [3, 7],
        [2, 5],
        [4, 4],
        [2, 4],
        [2, 4],
        [4, 4],
        [4, 3],
        [5, 3],
        [6, 3],
        [4, 2],
        [6, 3],
        [5, 2],
        [6, 2],
        [6, 1],
        [8, 1],
        [7, 0],
        [7, 0],
        [8, 0],
        [8, -2],
        [7, -2],
        [8, -2],
        [8, -3],
        [6, -2],
        [8, -4],
        [6, -2],
        [4, -3],
        [5, -2],
        [4, -3],
        [4, -2],
        [4, -2],
        [4, -2],
        [2, -1],
        [4, -2],
        [3, 0],
        [3, -1],
        [4, 0],
        [3, 0],
        [4, 1],
        [4, 0],
        [4, 1],
        [3, 2],
        [3, 2],
        [4, 2],
        [2, 3],
        [4, 2],
        [2, 3],
        [3, 3],
        [2, 3],
        [2, 3],
        [1, 3],
        [2, 3],
        [0, 3],
        [1, 3],
        [1, 4],
        [0, 4],
        [0, 5],
        [0, 5],
        [-1, 7],
        [-1, 6],
        [0, 8],
        [-2, 6],
        [0, 8],
        [0, 8],
        [0, 8],
        [0, 6],
        [0, 8],
        [1, 8],
        [1, 6],
        [2, 6],
        [2, 6],
        [3, 5],
        [3, 6],
        [4, 6],
        [2, 5],
        [4, 5],
        [4, 5],
        [4, 4],
        [4, 5],
        [6, 3],
        [4, 3],
        [6, 3],
        [3, 3],
        [5, 1],
        [5, 1],
        [5, 1],
        [5, 1],
        [4, 0],
        [6, 0],
        [4, 0],
        [4, -1],
        [5, -1],
        [4, 0],
        [4, -2],
        [5, -2],
        [4, -2],
        [3, -4],
        [6, -4],
        [4, -4],
        [4, -5],
        [4, -6],
        [4, -6],
        [6, -7],
        [4, -6],
        [3, -5],
        [3, -6],
        [3, -4],
        [4, -4],
        [2, -4],
        [3, -2],
        [3, -4],
        [2, -2],
        [2, -2],
        [3, -2],
        [4, -2],
        [2, -2],
        [3, -2],
        [2, -2],
        [4, -2],
        [4, -2],
        [4, 0],
        [5, -2],
        [5, -2],
        [6, 0],
        [4, -2],
        [6, 0],
        [6, -2],
        [6, 0],
        [6, -2],
        [6, 0],
        [5, 0],
        [5, 0],
        [5, -2],
        [4, 0],
        [4, 0],
        [4, 0],
        [3, 0],
        [3, 0],
        [3, 2],
        [2, 0],
        [3, 2],
        [3, 0],
        [2, 2],
        [2, 2],
        [2, 0],
        [3, 2],
        [2, 2],
        [3, 2],
        [2, 2],
        [2, 2],
        [2, 4],
        [2, 2],
        [2, 2],
        [2, 2],
        [0, 4],
        [2, 2],
        [2, 4],
        [2, 4],
        [2, 4],
        [2, 4],
        [0, 5],
        [2, 7],
        [4, 7],
        [2, 9],
        [2, 8],
        [2, 9],
        [2, 10],
        [2, 9],
        [1, 8],
        [2, 9],
        [1, 8],
        [1, 6],
        [0, 6],
        [1, 6],
        [0, 6],
        [-1, 4],
        [0, 4],
        [0, 4],
        [-2, 4],
        [0, 4],
        [-2, 2],
        [0, 3],
        [-1, 2],
        [-2, 3],
        [-2, 2],
        [0, 3],
        [-2, 2],
        [-2, 2],
        [-4, 3],
        [0, 2],
        [-2, 2],
        [-2, 2],
        [-2, 2],
        [0, 2],
        [0, 3],
        [-2, 3],
        [0, 3],
        [0, 4],
        [0, 4],
        [2, 4],
        [0, 4],
        [2, 5],
        [2, 6],
        [2, 5],
        [2, 5],
        [4, 5],
        [4, 5],
        [3, 4],
        [4, 4],
        [4, 2],
        [6, 3],
        [5, 1],
        [6, 2],
        [6, 0],
        [6, 1],
        [7, 0],
        [6, 0],
        [7, 0],
        [13, -1],
        [8, 0],
        [8, 0],
        [6, 1],
        [8, 0],
        [8, 1],
        [8, 0],
        [9, 1],
        [8, 1],
        [8, 2],
        [8, 2],
        [7, 1],
        [8, 2],
        [6, 2],
        [6, 1],
        [6, 3],
        [4, 3],
        [4, 3],
        [6, 5],
        [2, 3],
        [4, 4],
        [3, 5],
        [4, 4],
        [3, 5],
        [3, 6],
        [3, 5],
        [3, 5],
        [3, 6],
        [2, 6],
        [6, 11],
        [8, 22],
        [3, 5],
        [2, 5],
        [1, 4],
        [2, 2],
        [3, 8],
        [0, 2],
        [2, 2],
        [1, 2],
        [1, 2],
        [1, 2],
        [1, 2],
        [2, 2],
        [2, 2],
        [1, 2],
        [2, 2],
        [1, 2],
        [1, 0],
        [2, 2],
        [2, 2],
        [2, 0],
        [1, 2],
        [1, 0],
        [2, 2],
        [1, 2],
        [1, 2],
        [1, 2],
        [1, 4],
        [1, 2],
        [1, 4],
        [0, 3],
        [1, 4],
        [1, 4],
        [0, 5],
        [0, 4],
        [1, 5],
        [0, 5],
        [0, 5],
        [0, 9],
        [0, 5],
        [1, 5],
        [0, 4],
        [0, 5],
        [0, 6],
        [1, 5],
        [1, 5],
        [1, 5],
        [1, 5],
        [2, 8],
        [2, 6],
        [2, 6],
        [2, 8],
        [4, 6],
        [2, 8],
        [4, 8],
        [4, 6],
        [4, 6],
        [4, 6],
        [4, 5],
        [4, 5],
        [5, 3],
        [4, 4],
        [6, 3],
        [5, 3],
        [5, 2],
        [6, 1],
        [6, 1],
        [6, 2],
        [6, 0],
        [7, 1],
        [6, 1],
        [6, 0],
        [7, 1],
        [8, 0],
        [6, 0],
        [6, 1],
        [6, 1],
        [7, 0],
        [6, 0],
        [7, 1],
        [7, -1],
        [7, 0],
        [8, -1],
        [8, -1],
        [8, -2],
        [8, -1],
        [8, -2],
        [10, -2],
        [8, -2],
        [8, -2],
        [9, -2],
        [9, -2],
        [16, -3],
        [8, -1],
        [8, -1],
        [9, -2],
        [6, -2],
        [6, -2],
        [4, -2],
        [6, -2],
        [4, -2],
        [4, -2],
        [4, -4],
        [4, -2],
        [2, -2],
        [3, -2],
        [3, -2],
        [3, -2],
        [2, -2],
        [2, -2],
        [2, -4],
        [1, -2],
        [1, -2],
        [1, -4],
        [1, -4],
        [0, -4],
        [0, -4],
        [0, -4],
        [0, -4],
        [0, -6],
        [-2, -6],
        [0, -6],
        [-2, -7],
        [-2, -7],
        [-2, -7],
        [-2, -7],
        [-2, -7],
        [-2, -7],
        [-2, -6],
        [-2, -6],
        [-1, -6],
        [-2, -6],
        [0, -5],
        [-2, -4],
        [-2, -5],
        [-2, -7],
        [-2, -6],
        [0, -2],
        [-2, -4],
        [0, -2],
        [-2, -4],
        [0, -2],
        [-2, -2],
        [-4, -8],
        [0, -4],
        [-2, -4],
        [0, -2],
        [-2, -4],
        [0, -2],
        [-2, -4],
        [0, -4],
        [0, -2],
        [0, -4],
        [-2, -2],
        [0, -4],
        [2, -4],
        [0, -3],
        [0, -3],
        [2, -3],
        [2, -4],
        [0, -3],
        [2, -3],
        [2, -4],
        [2, -2],
        [2, -3],
        [2, -2],
        [2, -2],
        [2, -2],
        [2, -2],
        [2, -1],
        [2, -2],
        [3, -2],
        [2, -1],
        [4, -2],
        [4, -3],
        [4, -2],
        [4, -2],
        [4, -2],
        [5, -2],
        [4, -2],
        [4, -2],
        [4, -2],
        [4, -2],
        [4, -1],
        [4, -2],
        [3, -2],
        [4, 0],
        [3, -1],
        [4, -1],
        [4, 0],
        [4, -1],
        [4, 0],
        [4, 0],
        [4, 0],
        [4, 0],
        [2, 0],
        [7, 1],
        [4, 0],
        [2, 0],
        [3, 0],
        [3, 0],
        [3, 0],
        [2, -1],
        [3, 0],
        [2, -1],
        [3, 0],
        [3, -1],
        [2, -1],
        [3, -1],
        [2, -1],
        [2, -1],
        [2, -1],
        [2, -1],
        [5, -2],
        [2, -1],
        [3, -1],
        [2, -2],
        [2, -1],
        [2, 0],
        [2, -1],
        [2, 0],
        [2, -1],
        [3, 0],
        [0, 0],
        [2, 0],
        [2, 0],
        [4, 0],
        [2, 1],
        [2, 0],
        [2, -1],
        [2, 0],
        [2, 0],
        [2, 0],
        [2, 0],
        [2, -1],
        [2, -1],
        [2, -1],
        [2, -1],
        [2, -1],
        [2, -1],
        [3, -1],
        [2, -1],
        [3, -1],
        [2, -2],
        [3, -2],
        [2, 0],
        [2, -1],
        [2, -2],
        [2, -1],
        [2, -1],
        [2, -2],
        [0, -2],
        [2, -2],
        [0, -1],
        [2, -1],
        [2, -1],
        [1, -1],
        [2, 0],
        [2, -1],
        [3, 0],
        [3, 0],
        [4, 0],
        [4, 0],
        [4, 1],
        [4, 1],
        [5, 1],
        [5, 2],
        [5, 1],
        [5, 2],
        [5, 2],
        [6, 2],
        [6, 2],
        [4, 1],
        [6, 1],
        [6, 2],
        [4, 2],
        [6, 1],
        [4, 1],
        [5, 2],
        [4, 2],
        [5, 2],
        [4, 3],
        [3, 3],
        [3, 3],
        [2, 3],
        [2, 3],
        [2, 3],
        [2, 3],
        [2, 2],
        [1, 0],
        [2, 3],
        [2, 2],
        [3, 2],
        [3, 2],
        [2, 1],
        [1, 1],
        [2, 0],
        [1, 1],
        [3, 1],
        [3, 1],
        [3, 1],
        [3, 0],
        [3, 0],
        [3, 0],
        [4, 0],
        [2, 0],
        [4, -1],
        [4, -1],
        [4, -1],
        [6, -1],
        [4, -2],
        [4, -2],
        [5, -2],
        [5, -2],
        [1, -1],
        [4, -1],
        [4, -3],
        [4, -2],
        [4, -2],
        [4, -2],
        [7, -4],
        [4, -1],
        [4, -2],
        [3, -2],
        [3, -3],
        [4, -1],
        [3, -1],
        [3, -1],
        [4, -1],
        [2, 0],
        [4, -1],
        [4, 1],
        [6, 0],
        [4, 1],
        [4, 1],
        [2, 1],
        [2, 1],
        [2, 0],
        [5, 3],
        [4, 2],
        [3, 1],
        [2, 1],
        [4, 2],
        [4, 2],
        [4, 2],
        [3, 2],
        [3, 2],
        [2, 2],
        [2, 1],
        [1, 2],
        [2, 2],
        [1, 1],
        [1, 3],
        [2, 3],
        [0, 2],
        [1, 2],
        [1, 3],
        [0, 1],
        [0, 2],
        [0, 2],
        [0, 3],
        [-1, 2],
        [-1, 3],
        [0, 3],
        [-1, 4],
        [-1, 0],
        [-1, 4],
        [-2, 3],
        [-2, 6],
        [-3, 5],
        [-4, 6],
        [-5, 8],
        [-4, 8],
        [-6, 6],
        [-5, 8],
        [-4, 8],
        [-7, 8],
        [-12, 16],
        [-2, 4],
        [-2, 4],
        [-4, 4],
        [0, 2],
        [-2, 3],
        [-2, 2],
        [-2, 3],
        [0, 3],
        [0, 2],
        [-2, 5],
        [0, 3],
        [-2, 3],
        [0, 2],
        [-2, 3],
        [-1, 2],
        [-1, 2],
        [-2, 2],
        [-3, 5],
        [-2, 2],
        [-2, 3],
        [-1, 3],
        [-2, 3],
        [-2, 3],
        [-6, 9],
        [-2, 4],
        [-2, 4],
        [-1, 3],
        [-2, 4],
        [-5, 6],
        [-2, 3],
        [-2, 4],
        [-2, 4],
        [-2, 2],
        [-1, 4],
        [-2, 2],
        [-1, 4],
        [-1, 2],
        [-2, 2],
        [0, 4],
        [-1, 2],
        [-1, 2],
        [0, 4],
        [0, 2],
        [-1, 2],
        [0, 4],
        [0, 2],
        [0, 2],
        [1, 2],
        [0, 4],
        [0, 2],
        [2, 2],
        [0, 2],
        [2, 2],
        [0, 2],
        [2, 0],
        [2, 2],
        [1, 2],
        [2, 1],
        [2, 1],
        [2, 2],
        [3, 1],
        [2, 1],
        [2, 0],
        [3, 1],
        [2, 1],
        [3, 0],
        [3, 0],
        [3, 1],
        [3, 0],
        [3, -1],
        [3, 0],
        [3, 0],
        [3, -1],
        [3, -1],
        [3, -1],
        [2, -1],
        [2, -2],
        [2, -2],
        [4, -2],
        [2, -2],
        [4, -2],
        [4, -2],
        [4, -2],
        [4, -2],
        [5, -2],
        [3, -2],
        [4, -4],
        [11, -6],
        [4, -2],
        [3, -2],
        [4, -2],
        [3, 0],
        [3, -2],
        [3, 0],
        [4, 0],
        [3, 0],
        [3, 2],
        [4, 0],
        [3, 2],
        [3, 2],
        [4, 2],
        [6, 4],
        [2, 2],
        [4, 0],
        [2, 2],
        [2, 2],
        [4, 2],
        [2, 0],
        [2, 2],
        [2, 4],
        [2, 2],
        [2, 2],
        [0, 2],
        [2, 3],
        [2, 3],
        [0, 3],
        [2, 5],
        [1, 1],
        [0, 2],
        [1, 2],
        [1, 1],
        [0, 1],
        [1, 1],
        [1, 1],
        [0, 1],
        [1, 1],
        [2, 2],
        [1, 0],
        [1, 2],
        [1, 1],
        [2, 1],
        [1, 2],
        [1, 1],
        [2, 2],
        [0, 2],
        [2, 3],
        [1, 4],
        [1, 2],
        [1, 3],
        [1, 3],
        [0, 3],
        [0, 2],
        [1, 4],
        [0, 4],
        [1, 9],
        [0, 4],
        [0, 6],
        [1, 6],
        [1, 7],
        [0, 7],
        [1, 6],
        [1, 7],
        [1, 7],
        [1, 6],
        [1, 6],
        [1, 6],
        [0, 5],
        [1, 4],
        [0, 4],
        [2, 4],
        [0, 2],
        [1, 4],
        [1, 2],
        [1, 2],
        [1, 3],
        [2, 2],
        [1, 2],
        [2, 2],
        [2, 2],
        [2, 2],
        [3, 3],
        [2, 2],
        [3, 3],
        [3, 3],
        [4, 2],
        [2, 3],
        [4, 3],
        [4, 2],
        [4, 3],
        [4, 2],
        [4, 1],
        [5, 2],
        [4, 1],
        [4, 1],
        [4, 1],
        [4, 1],
        [3, 1],
        [4, 0],
        [4, 0],
        [4, 2],
        [3, 0],
        [4, 0],
        [3, 0],
        [4, 0],
        [4, 0],
        [5, 0],
        [4, 0],
        [14, -2],
        [4, 0],
        [6, 0],
        [4, 0],
        [6, -1],
        [8, 0],
        [6, 0],
        [3, 0],
        [4, 0],
        [5, -1],
        [4, 0],
        [4, -1],
        [3, -1],
        [4, -1],
        [4, -1],
        [4, -2],
        [3, -2],
        [5, -2],
        [5, -2],
        [4, -1],
        [6, -2],
        [5, -2],
        [6, -2],
        [25, -9],
        [16, -6],
        [6, -2],
        [6, -2],
        [4, -2],
        [6, -2],
        [3, -1],
        [5, -1],
        [4, -2],
        [4, -1],
        [4, -1],
        [3, 0],
        [4, -1],
        [3, 0],
        [3, -1],
        [3, 0],
        [3, -1],
        [3, 0],
        [2, 0],
        [2, 0],
        [3, 1],
        [3, 0],
        [2, 1],
        [2, 0],
        [2, 1],
        [3, 0],
        [2, 1],
        [3, 1],
        [2, 2],
        [0, 0],
        [2, 2],
        [2, 1],
        [2, 1],
        [0, 2],
        [2, 1],
        [0, 2],
        [2, 1],
        [0, 2],
        [0, 2],
        [0, 1],
        [0, 2],
        [0, 2],
        [0, 3],
        [0, 2],
        [0, 3],
        [0, 2],
        [-2, 3],
        [0, 3],
        [-2, 3],
        [0, 3],
        [-2, 3],
        [-2, 5],
        [-2, 3],
        [-1, 2],
        [-2, 4],
        [-3, 2],
        [-2, 2],
        [-4, 4],
        [-3, 2],
        [-5, 4],
        [-4, 4],
        [-6, 4],
        [-7, 6],
        [-8, 6],
        [-9, 7],
        [-9, 8],
        [-9, 7],
        [-10, 9],
        [-10, 8],
        [-7, 8],
        [-8, 8],
        [-7, 7],
        [-6, 6],
        [-5, 6],
        [-4, 5],
        [-2, 6],
        [-3, 3],
        [-2, 6],
        [-2, 4],
        [-2, 4],
        [-2, 4],
        [-4, 10],
        [-2, 4],
        [-3, 6],
        [-3, 5],
        [-2, 8],
        [-4, 6],
        [-3, 6],
        [-2, 8],
        [-4, 8],
        [-4, 9],
        [-4, 9],
        [-2, 9],
        [-2, 10],
        [-2, 11],
        [-1, 11],
        [-1, 11],
        [0, 12],
        [0, 10],
        [1, 12],
        [1, 10],
        [2, 10],
        [2, 9],
        [2, 10],
        [2, 8],
        [4, 8],
        [2, 6],
        [2, 7],
        [2, 6],
        [3, 6],
        [2, 5],
        [2, 4],
        [2, 6],
        [2, 4],
        [2, 4],
        [2, 3],
        [2, 4],
        [2, 4],
        [2, 3],
        [2, 3],
        [2, 3],
        [3, 3],
        [2, 2],
        [2, 2],
        [2, 4],
        [1, 4],
        [2, 2],
        [1, 4],
        [2, 4],
        [1, 2],
        [1, 4],
        [0, 3],
        [0, 3],
        [0, 4],
        [0, 3],
        [-1, 3],
        [-1, 3],
        [-2, 3],
        [-2, 3],
        [-2, 3],
        [-3, 3],
        [-3, 3],
        [-4, 3],
        [-4, 3],
        [-4, 2],
        [-5, 4],
        [-5, 2],
        [-5, 4],
        [-5, 2],
        [-6, 4],
        [-7, 3],
        [-6, 1],
        [-7, 3],
        [-5, 2],
        [-8, 3],
        [-6, 2],
        [-8, 2],
        [-6, 1],
        [-10, 4],
        [-6, 1],
        [-6, 1],
        [-5, 2],
        [-5, 2],
        [-4, 2],
        [-5, 2],
        [-4, 2],
        [-3, 2],
        [-4, 2],
        [-3, 2],
        [-4, 4],
        [-4, 4],
        [-3, 4],
        [-3, 4],
        [-3, 6],
        [-4, 6],
        [-5, 6],
        [-4, 6],
        [-4, 8],
        [-4, 6],
        [-4, 8],
        [-2, 8],
        [-2, 6],
        [-2, 7],
        [0, 7],
        [0, 7],
        [0, 7],
        [0, 8],
        [0, 8],
        [0, 8],
        [0, 10],
        [2, 10],
        [2, 9],
        [2, 10],
        [0, 10],
        [2, 10],
        [6, 27],
        [0, 8],
        [2, 8],
        [2, 8],
        [2, 8],
        [5, 7],
        [4, 8],
        [4, 8],
        [5, 9],
        [6, 8],
        [7, 9],
        [7, 9],
        [8, 9],
        [7, 8],
        [8, 6],
        [6, 6],
        [7, 6],
        [5, 4],
        [6, 3],
        [4, 4],
        [6, 2],
        [4, 2],
        [4, 1],
        [4, 1],
        [6, 2],
        [7, 2],
        [4, 1],
        [4, 2],
        [4, 1],
        [4, 1],
        [2, 2],
        [4, 1],
        [2, 1],
        [2, 2],
        [3, 2],
        [2, 2],
        [1, 1],
        [2, 2],
        [2, 2],
        [1, 2],
        [2, 2],
        [2, 3],
        [2, 3],
        [2, 2],
        [1, 4],
        [2, 3],
        [2, 4],
        [2, 3],
        [3, 5],
        [2, 4],
        [2, 4],
        [1, 4],
        [2, 4],
        [1, 4],
        [1, 4],
        [1, 6],
        [1, 4],
        [0, 4],
        [0, 2],
        [-1, 4],
        [-1, 2],
        [0, 4],
        [-1, 2],
        [-1, 4],
        [0, 2],
        [-2, 2],
        [-1, 4],
        [-2, 2],
        [-2, 4],
        [-4, 4],
        [-4, 5],
        [-4, 4],
        [-5, 6],
        [-6, 6],
        [-6, 6],
        [-6, 7],
        [-6, 6],
        [-6, 5],
        [-6, 6],
        [-4, 5],
        [-5, 4],
        [-8, 8],
        [-4, 3],
        [-2, 3],
        [-4, 4],
        [-4, 4],
        [-4, 3],
        [-2, 4],
        [-4, 4],
        [-2, 4],
        [-4, 4],
        [-2, 4],
        [-3, 4],
        [-3, 4],
        [-1, 4],
        [-1, 4],
        [-2, 4],
        [0, 2],
        [0, 4],
        [0, 2],
        [0, 4],
        [0, 2],
        [1, 4],
        [1, 2],
        [0, 4],
        [2, 4],
        [1, 3],
        [1, 5],
        [3, 5],
        [2, 6],
        [3, 8],
        [2, 7],
        [10, 24],
        [4, 7],
        [2, 8],
        [4, 6],
        [2, 7],
        [2, 5],
        [2, 5],
        [2, 9],
        [2, 2],
        [2, 4],
        [0, 3],
        [2, 3],
        [1, 4],
        [4, 7],
        [1, 4],
        [2, 4],
        [2, 4],
        [1, 4],
        [2, 4],
        [2, 5],
        [1, 5],
        [1, 5],
        [2, 6],
        [1, 4],
        [1, 5],
        [4, 15],
        [2, 7],
        [0, 4],
        [2, 5],
        [2, 4],
        [0, 4],
        [2, 4],
        [2, 4],
        [2, 2],
        [2, 4],
        [3, 2],
        [2, 4],
        [4, 2],
        [3, 4],
        [3, 2],
        [4, 2],
        [3, 2],
        [4, 2],
        [4, 2],
        [4, 2],
        [4, 2],
        [5, 0],
        [4, 2],
        [5, 2],
        [8, 2],
        [3, 2],
        [4, 0],
        [4, 2],
        [6, 2],
        [4, 0],
        [4, 4],
        [4, 2],
        [4, 2],
        [3, 2],
        [3, 4],
        [3, 3],
        [4, 4],
        [2, 3],
        [3, 5],
        [2, 4],
        [1, 4],
        [1, 5],
        [1, 4],
        [0, 5],
        [0, 4],
        [0, 6],
        [-2, 4],
        [-1, 6],
        [-1, 4],
        [-2, 5],
        [-3, 4],
        [-2, 4],
        [-3, 4],
        [-2, 2],
        [-2, 4],
        [-2, 2],
        [-3, 2],
        [-2, 2],
        [-2, 3],
        [-4, 4],
        [-2, 2],
        [-4, 2],
        [-2, 2],
        [-2, 4],
        [-4, 2],
        [-4, 6],
        [-4, 2],
        [-2, 4],
        [-4, 2],
        [-4, 4],
        [-3, 4],
        [-4, 4],
        [-4, 4],
        [-5, 6],
        [-3, 6],
        [-4, 4],
        [-4, 8],
        [-3, 7],
        [-4, 8],
        [-2, 8],
        [-4, 9],
        [-2, 8],
        [-2, 9],
        [-1, 8],
        [-1, 8],
        [0, 7],
        [0, 7],
        [0, 5],
        [2, 6],
        [1, 6],
        [2, 6],
        [2, 4],
        [3, 4],
        [2, 4],
        [3, 4],
        [3, 2],
        [3, 3],
        [4, 2],
        [3, 2],
        [3, 1],
        [4, 1],
        [3, 1],
        [3, 0],
        [3, 0],
        [4, -1],
        [3, 0],
        [3, -2],
        [4, -1],
        [4, -2],
        [4, -2],
        [4, 0],
        [25, -8],
        [27, -16],
        [42, -18],
        [101, 121],
        [-54, 206],
        [561, 160],
        [-4, 19],
        [-9, 44],
        [-9, 15],
        [-7, 11],
        [-10, 16],
        [-12, 9],
        [-25, 13],
        [-46, -2],
        [-17, 6],
        [-12, 0],
        [-7, 3],
        [-15, 4],
        [-20, 7],
        [-13, -1],
        [-10, 3],
        [-10, 5],
        [-22, -4],
        [-23, -10],
        [-12, -4],
        [-29, -1],
        [-38, 13],
        [-16, 14],
        [-7, 18],
        [4, 25],
        [3, 14],
        [9, 10],
        [-2, 23],
        [4, 10],
        [-7, 19],
        [-18, 9],
        [-19, -4],
        [-32, -9],
        [-25, -9],
        [-28, -12],
        [-29, 12],
        [-4, 0],
        [-5, 20],
        [5, 10],
        [0, 7],
        [-15, 18],
        [5, 11],
        [12, 0],
        [22, 14],
        [33, 36],
        [7, 10],
        [6, 30],
        [-2, 49],
        [-11, 13],
        [-31, 25],
        [-12, -10],
        [-14, -9],
        [-13, -13],
        [-17, -21],
        [-22, -19],
        [-21, -10],
        [-24, -17],
        [-24, -24],
        [-9, -4],
        [-34, -6],
        [-9, 0],
        [-4, 4],
        [-4, 8],
        [-2, 10],
        [-2, 6],
        [-8, 14],
        [-26, 20],
        [-27, 13],
        [-44, 11],
        [-10, 4],
        [-15, -1],
        [-10, 6],
        [-10, 0],
        [-2, -5],
        [0, -8],
        [2, -8],
        [0, -10],
        [-6, -8],
        [-12, -7],
        [-15, -6],
        [-19, -1],
        [-8, -6],
        [-12, -14],
        [-13, -4],
        [-28, -2],
        [-16, 4],
        [-8, 8],
        [-1, 24],
        [14, 34],
        [9, 12],
        [9, 17],
        [9, 18],
        [8, 13],
        [29, 25],
        [7, 2],
        [4, 4],
        [3, 7],
        [9, 9],
        [12, 6],
        [14, 9],
        [13, 25],
        [0, 23],
        [-3, 7],
        [-9, 6],
        [-14, 12],
        [-6, 8],
        [-3, 10],
        [-10, 6],
        [-8, 10],
        [0, 7],
        [9, 5],
        [3, 3],
        [-1, 24],
        [7, 6],
        [8, 4],
        [8, 12],
        [13, 36],
        [-2, 6],
        [-1, 30],
        [-11, 14],
        [-5, 12],
        [5, 9],
        [-8, 34],
        [-7, 22],
        [-27, 30],
        [-74, -4],
        [-45, -25],
        [-31, -15],
        [-30, 8],
        [-46, 11],
        [-49, 29],
        [-16, 8],
        [-19, 18],
        [-25, 14],
        [-30, -1],
        [-38, 15],
        [-41, 16],
        [-19, 16],
        [-27, 33],
        [-11, 69],
        [-53, 34],
        [-56, 11],
        [-47, -13],
        [-31, -2],
        [-23, 32],
        [-1, 50],
        [59, 63],
        [18, 50],
        [-6, 18],
        [-29, 4],
        [-29, 6],
        [-34, -4],
        [0, -27],
        [-28, -31],
        [-30, -3],
        [-28, 4],
        [-39, 15],
        [-31, 72],
        [-24, 91],
        [-41, 54],
        [-83, 53],
        [-67, 33],
        [-71, 32],
        [-86, -16],
        [-57, -33],
        [-92, 4],
        [-30, 41],
        [-24, 43],
        [-74, 13],
        [-55, -36],
        [-45, 8],
        [35, 135],
        [-439, 993],
        [-3358, 2179],
        [-617, 1638],
        [280, 112],
        [271, -163],
        [275, -12],
        [497, 393],
        [361, -76],
        [189, -117],
        [460, 103],
        [51, 127],
        [290, 153],
        [365, 60],
        [255, 56],
        [147, 163],
        [30, 90],
        [10, 72],
        [2, 99],
        [-26, 152],
        [-72, 109],
        [-99, 79],
        [-90, 66],
        [-56, 42],
        [-63, 129],
        [-92, 148],
        [84, 722],
        [298, 171],
        [215, -39],
        [204, 45],
        [83, 26],
        [224, 137],
        [320, 196],
        [477, -68],
        [243, -135],
        [28, -119],
        [76, -111],
        [91, -76],
        [109, -44],
        [169, -43],
        [394, -113],
        [229, 89],
        [-54, 36],
        [-671, 343],
        [-244, 808],
        [3491, 3509],
        [1866, 1398],
        [2625, -1567],
        [4060, 892],
      ],
      [
        [286563, 70266],
        [-164, 5730],
        [1420, -6],
        [2314, 113],
        [1414, 70],
        [50, 937],
        [1, 24],
        [19, 640],
        [749, -277],
        [45, 28],
        [460, -391],
        [542, -427],
        [976, -826],
        [622, -205],
        [377, 368],
        [102, 100],
        [825, 785],
        [-273, 205],
        [-376, 281],
        [551, 435],
        [240, 242],
        [-1127, 1118],
        [-67, 67],
        [4475, 2745],
        [579, -447],
        [1070, -827],
        [244, 453],
        [325, 349],
        [76, 243],
        [388, 854],
        [1936, 3511],
        [259, -323],
        [78, -256],
        [-562, -1392],
        [600, -165],
        [1245, 30],
        [343, 37],
        [-1, 354],
        [233, 18],
        [1375, -351],
        [1172, 297],
        [-81, 640],
        [-869, 117],
        [-214, -23],
        [-29, 169],
        [-84, -74],
        [-493, -168],
        [-437, 41],
        [-584, -86],
        [-353, 642],
        [-323, 673],
        [920, -152],
        [63, 195],
        [88, 274],
        [-278, 1025],
        [109, -4],
        [142, -38],
        [33, 26],
        [6, 6],
        [10, -5],
        [10, 1],
        [24, -2],
        [3, -11],
        [-6, -5],
        [0, -5],
        [19, 4],
        [12, -3],
        [6, 0],
        [9, 0],
        [10, 11],
        [12, 6],
        [6, -3],
        [12, -4],
        [6, 2],
        [7, 3],
        [7, -2],
        [6, 7],
        [6, 3],
        [8, 3],
        [8, 6],
        [16, 14],
        [6, 12],
        [18, -5],
        [11, 6],
        [15, 2],
        [7, 10],
        [9, 4],
        [10, 2],
        [9, 2],
        [14, 0],
        [12, 2],
        [10, 2],
        [8, 8],
        [10, 6],
        [8, 4],
        [11, -6],
        [12, -4],
        [9, -8],
        [3, -18],
        [8, -15],
        [11, -12],
        [16, 16],
        [14, 35],
        [12, -8],
        [18, -12],
        [31, -10],
        [18, 4],
        [62, 0],
        [57, 28],
        [17, -12],
        [47, 8],
        [33, 6],
        [20, 10],
        [8, 18],
        [33, 12],
        [25, -1],
        [20, -15],
        [27, -2],
        [12, 6],
        [13, 4],
        [12, 4],
        [9, 7],
        [32, 22],
        [10, 10],
        [21, 6],
        [12, -3],
        [16, -10],
        [10, -5],
        [3, -10],
        [8, -24],
        [15, -19],
        [22, -12],
        [18, -10],
        [19, -14],
        [17, -11],
        [14, -16],
        [2, -15],
        [0, -22],
        [-10, -9],
        [-6, -13],
        [10, -13],
        [14, -9],
        [20, -5],
        [23, 12],
        [20, 15],
        [12, 5],
        [20, 3],
        [25, -2],
        [4, -8],
        [10, -2],
        [4, -3],
        [4, -6],
        [0, -6],
        [0, -7],
        [2, -5],
        [14, -10],
        [11, -11],
        [14, -9],
        [6, -12],
        [4, -14],
        [-1, -8],
        [-4, -7],
        [-1, -7],
        [-1, -7],
        [-1, -6],
        [-2, -9],
        [0, -7],
        [3, -4],
        [7, -7],
        [7, -4],
        [10, -4],
        [12, 0],
        [10, 0],
        [8, 6],
        [8, 6],
        [6, 5],
        [8, 2],
        [9, -2],
        [9, -5],
        [3, -10],
        [1, -4],
        [0, -6],
        [-6, -8],
        [-6, -6],
        [-2, -10],
        [1, -6],
        [3, -3],
        [4, -5],
        [1, -11],
        [0, -5],
        [-1, -4],
        [4, -2],
        [4, -1],
        [5, -4],
        [7, -5],
        [9, -2],
        [12, 1],
        [6, 3],
        [6, 2],
        [10, 2],
        [8, 2],
        [8, 0],
        [7, 2],
        [4, 0],
        [3, -2],
        [4, -7],
        [3, -4],
        [4, -7],
        [18, -23],
        [11, -9],
        [10, -8],
        [10, 2],
        [10, -2],
        [4, 0],
        [15, 9],
        [9, 7],
        [5, -1],
        [3, -6],
        [6, -11],
        [0, -7],
        [-11, -22],
        [-6, -22],
        [-13, -8],
        [0, -19],
        [7, -13],
        [8, -4],
        [13, 0],
        [14, -1],
        [7, 6],
        [12, -6],
        [10, 6],
        [8, -3],
        [10, -8],
        [18, -4],
        [9, -4],
        [8, -15],
        [12, -24],
        [9, -17],
        [10, -15],
        [12, -7],
        [20, 3],
        [15, 9],
        [11, -3],
        [16, 13],
        [6, 11],
        [11, 6],
        [18, -5],
        [18, -10],
        [31, -17],
        [12, 2],
        [12, 5],
        [15, 0],
        [16, 4],
        [15, 6],
        [15, -2],
        [18, -13],
        [24, -12],
        [11, -3],
        [24, 15],
        [17, 17],
        [10, 8],
        [16, 3],
        [36, 1],
        [13, 4],
        [16, -1],
        [8, -3],
        [14, 3],
        [18, -5],
        [7, 2],
        [3, 8],
        [5, 13],
        [4, 15],
        [10, 4],
        [12, -13],
        [4, -13],
        [-1, -16],
        [4, -4],
        [6, -14],
        [10, -15],
        [14, -7],
        [14, -2],
        [-12, -36],
        [-21, -30],
        [43, -308],
        [2248, 1312],
        [-62, 119],
        [-200, 781],
        [-32, 7],
        [-42, -5],
        [-35, 24],
        [-6, 42],
        [6, 47],
        [-4, 30],
        [-8, 36],
        [-14, 10],
        [-12, 10],
        [-21, 4],
        [-30, 9],
        [-21, 2],
        [-24, 10],
        [-23, 8],
        [-22, 6],
        [-16, 12],
        [-6, 43],
        [-8, 17],
        [-8, 18],
        [-2, 30],
        [-8, 14],
        [-16, 15],
        [-15, 12],
        [-25, 11],
        [-26, 9],
        [-12, 4],
        [-25, 7],
        [-35, 19],
        [-29, 16],
        [-16, 2],
        [-17, -3],
        [-10, 21],
        [-16, 20],
        [-6, 53],
        [39, 38],
        [12, 26],
        [22, 31],
        [49, 31],
        [-6, 31],
        [-18, 8],
        [-51, -19],
        [-33, 12],
        [-14, -8],
        [-24, -3],
        [-11, 11],
        [-8, 27],
        [-7, 14],
        [-9, 12],
        [-18, -4],
        [-34, -28],
        [-15, -27],
        [-9, -25],
        [-24, -12],
        [-14, -13],
        [-12, 1],
        [-8, 8],
        [-18, 4],
        [-31, 3],
        [-14, -2],
        [-10, -5],
        [-4, -16],
        [-18, -2],
        [-19, 8],
        [-17, 20],
        [-12, 16],
        [-8, 34],
        [-6, 16],
        [-8, 12],
        [-16, 4],
        [-12, -14],
        [-9, -14],
        [-12, -2],
        [-15, 12],
        [-17, -2],
        [-14, -10],
        [-10, -10],
        [-8, -10],
        [-16, -2],
        [-27, 18],
        [-8, 0],
        [-19, 4],
        [-8, 8],
        [-20, 0],
        [-18, 10],
        [-23, -2],
        [-29, 4],
        [-13, 8],
        [-17, 2],
        [-26, 24],
        [-2, 29],
        [4, 14],
        [2, 12],
        [-42, 14],
        [-28, 19],
        [-76, 19],
        [-47, 6],
        [-36, -4],
        [-20, 23],
        [-22, 12],
        [-11, 24],
        [-9, 11],
        [-21, -1],
        [-18, -12],
        [-35, -14],
        [-43, -23],
        [-35, -79],
        [-45, -48],
        [-25, -20],
        [-43, -18],
        [-78, -79],
        [-16, -9],
        [-12, -9],
        [-27, -6],
        [-24, 1],
        [-26, 4],
        [-28, 0],
        [-27, 2],
        [-15, -7],
        [-30, -8],
        [-44, 14],
        [-19, -5],
        [-26, -5],
        [-8, -2],
        [-21, -2],
        [-22, -6],
        [-17, -4],
        [-16, -2],
        [-10, -2],
        [-18, -2],
        [-23, 6],
        [-43, 14],
        [-44, -4],
        [-30, -12],
        [-15, -10],
        [-11, -2],
        [-13, 6],
        [-26, -14],
        [-10, -12],
        [-10, -8],
        [-2, -14],
        [-18, -6],
        [-15, 0],
        [-20, 0],
        [-15, 5],
        [-24, 7],
        [-14, -2],
        [-15, -6],
        [-12, -12],
        [3, -14],
        [2, -13],
        [-16, -2],
        [-19, -28],
        [-4, -12],
        [-12, -5],
        [-6, -6],
        [-10, -6],
        [-12, -3],
        [-12, -5],
        [-11, -14],
        [-7, -10],
        [-6, -6],
        [-11, -7],
        [-13, -9],
        [-18, 14],
        [-14, -9],
        [-11, -4],
        [-20, -3],
        [-12, -1],
        [-11, -2],
        [-14, -6],
        [-11, -10],
        [-10, -5],
        [-16, -10],
        [-10, -4],
        [-10, -9],
        [-13, -1],
        [-9, -4],
        [-8, -8],
        [-14, 0],
        [-14, -2],
        [-16, -10],
        [-23, -4],
        [-18, -8],
        [-17, -6],
        [-17, 0],
        [-13, -2],
        [-13, -12],
        [-3, -19],
        [-14, -20],
        [-6, 10],
        [-14, 0],
        [-11, -2],
        [-10, -17],
        [-4, -15],
        [-4, -10],
        [-26, -5],
        [-21, -27],
        [-12, 4],
        [-12, 0],
        [-11, 1],
        [-9, -1],
        [-12, -6],
        [-15, -4],
        [-11, 0],
        [-7, -10],
        [-10, -10],
        [-12, -4],
        [-4, -4],
        [-12, 4],
        [-16, 0],
        [-13, -2],
        [0, -16],
        [-4, -4],
        [-12, 2],
        [-14, 2],
        [-15, -8],
        [-17, 12],
        [-21, 4],
        [-20, -10],
        [-10, 2],
        [-21, 6],
        [-22, -4],
        [-14, -2],
        [-27, -2],
        [-29, 6],
        [-31, 12],
        [-25, 18],
        [-22, 6],
        [-125, 74],
        [-5, 239],
        [-1425, 1384],
        [-624, -94],
        [-398, -646],
        [-725, 434],
        [-820, 299],
        [1410, 1067],
        [-13, 268],
        [-1606, 851],
        [129, 766],
        [214, 1225],
        [587, -479],
        [427, -41],
        [682, -593],
        [14, -3],
        [1889, -447],
        [7, 313],
        [8, 30],
        [6, 26],
        [31, 115],
        [50, 224],
        [868, -29],
        [1531, -53],
        [1695, 272],
        [95, 449],
        [1381, -978],
        [1889, 4],
        [219, -404],
        [1487, 493],
        [1534, -840],
        [489, 716],
        [104, -500],
        [-4, -28],
        [-2, -26],
        [-2, -20],
        [-2, -24],
        [-4, -17],
        [0, -24],
        [-2, -16],
        [-4, -16],
        [-2, -25],
        [0, -14],
        [2, -16],
        [-3, -20],
        [0, -14],
        [-3, -20],
        [-30, -52],
        [-60, -248],
        [14, -50],
        [14, -22],
        [5, -25],
        [10, -9],
        [13, -25],
        [19, -17],
        [5, -14],
        [14, -14],
        [12, -17],
        [24, -13],
        [9, -27],
        [52, -27],
        [24, -24],
        [28, -12],
        [15, -4],
        [26, -10],
        [13, -21],
        [13, -16],
        [17, -10],
        [29, -20],
        [1, -6],
        [14, -14],
        [16, -22],
        [13, -15],
        [18, -14],
        [13, -22],
        [32, -32],
        [8, -23],
        [17, -17],
        [17, -17],
        [35, -42],
        [26, -36],
        [24, -38],
        [24, -15],
        [20, -44],
        [14, -20],
        [14, -27],
        [17, -34],
        [17, -24],
        [8, -20],
        [3, -16],
        [4, -24],
        [8, -18],
        [-4, -18],
        [-2, -15],
        [-4, -15],
        [-2, -17],
        [-5, -16],
        [-2, -12],
        [-2, -11],
        [8, -10],
        [1, -10],
        [-3, -11],
        [10, -6],
        [17, 2],
        [12, -5],
        [22, 3],
        [16, 3],
        [22, -3],
        [12, -7],
        [14, -8],
        [8, -3],
        [4, -5],
        [0, -5],
        [8, -4],
        [12, -4],
        [11, 2],
        [13, 0],
        [6, -7],
        [2, -6],
        [9, 2],
        [5, 0],
        [3, -2],
        [0, -8],
        [8, -2],
        [4, 0],
        [4, -4],
        [4, -4],
        [6, 0],
        [4, -4],
        [10, -4],
        [6, 2],
        [5, -4],
        [8, 0],
        [7, -6],
        [0, -6],
        [8, -6],
        [5, 0],
        [2, 6],
        [4, 0],
        [4, -4],
        [2, -2],
        [3, -4],
        [6, -6],
        [7, -4],
        [3, -10],
        [8, -6],
        [10, -15],
        [4, -8],
        [7, -12],
        [8, -4],
        [11, -3],
        [8, 4],
        [8, 0],
        [4, 0],
        [6, -2],
        [6, 1],
        [7, -1],
        [6, 3],
        [8, 3],
        [13, 1],
        [10, -3],
        [12, -3],
        [12, -1],
        [8, -2],
        [12, -2],
        [8, 4],
        [5, 0],
        [3, -7],
        [6, -3],
        [9, -19],
        [12, -9],
        [4, -12],
        [7, -7],
        [11, 0],
        [8, -2],
        [14, -2],
        [7, 8],
        [7, 7],
        [8, 4],
        [5, -1],
        [4, -2],
        [8, 1],
        [7, 1],
        [9, 3],
        [8, 0],
        [9, -3],
        [10, -3],
        [14, 1],
        [8, 9],
        [9, 2],
        [10, -8],
        [9, -2],
        [19, 11],
        [16, -6],
        [16, 10],
        [8, 4],
        [8, -6],
        [4, -17],
        [11, -9],
        [50, 36],
        [37, 4],
        [4, 1],
        [21, 4],
        [19, -11],
        [23, -12],
        [16, -32],
        [25, -28],
        [34, -40],
        [31, -43],
        [19, -39],
        [10, -25],
        [12, -30],
        [8, -25],
        [6, -26],
        [2, -29],
        [0, -22],
        [0, -23],
        [-10, -47],
        [-18, -59],
        [-42, -50],
        [-34, -37],
        [-31, -37],
        [-28, -38],
        [-15, -40],
        [5, -36],
        [44, -124],
        [66, -155],
        [14, -29],
        [51, -66],
        [79, -83],
        [22, -29],
        [16, -31],
        [-2, -30],
        [-30, -24],
        [-41, -27],
        [-48, -28],
        [-30, -31],
        [-29, -32],
        [-26, -46],
        [-15, -26],
        [-10, -20],
        [-4, -19],
        [-2, -47],
        [4, -25],
        [0, -18],
        [-4, -15],
        [0, -23],
        [2, -16],
        [10, -17],
        [75, -103],
        [13, -32],
        [10, -25],
        [8, -31],
        [4, -29],
        [-1, -22],
        [-11, -19],
        [-12, -14],
        [-14, -11],
        [-16, -11],
        [-13, -15],
        [-22, -21],
        [-19, -25],
        [-14, -32],
        [-12, -27],
        [-7, -34],
        [-2, -33],
        [13, -28],
        [28, -47],
        [23, -37],
        [12, -20],
        [3, -23],
        [-2, -26],
        [-7, -22],
        [-11, -13],
        [-18, -14],
        [-16, -2],
        [-21, 4],
        [-30, 9],
        [-95, 38],
        [-46, 16],
        [-22, 6],
        [-20, 0],
        [-25, -2],
        [-29, -6],
        [-45, -10],
        [-44, -16],
        [-28, -4],
        [-14, 0],
        [-10, -2],
        [-8, -4],
        [-2, -8],
        [-3, -26],
        [-4, -7],
        [-9, -4],
        [-9, -2],
        [-15, -2],
        [-13, -12],
        [-4, -16],
        [2, -17],
        [11, -13],
        [10, -13],
        [1, -14],
        [-3, -12],
        [-2, -12],
        [0, -7],
        [4, -5],
        [9, -7],
        [8, -6],
        [7, -5],
        [5, -5],
        [2, -6],
        [3, -8],
        [0, -10],
        [0, -10],
        [2, -10],
        [10, -10],
        [8, -8],
        [10, -12],
        [4, -13],
        [6, -15],
        [7, -17],
        [4, -17],
        [7, -9],
        [7, -5],
        [8, -10],
        [7, -6],
        [0, -8],
        [-1, -10],
        [-2, -10],
        [1, -6],
        [6, -11],
        [8, -4],
        [8, 0],
        [10, 4],
        [8, 0],
        [9, -6],
        [7, -10],
        [6, -8],
        [5, -10],
        [4, -7],
        [6, -7],
        [11, -6],
        [10, -4],
        [10, -3],
        [7, -3],
        [8, -6],
        [6, -9],
        [2, -7],
        [0, -10],
        [-2, -7],
        [-6, -6],
        [-8, -4],
        [-7, -1],
        [-11, -2],
        [-9, -3],
        [-11, -4],
        [-2, -5],
        [-1, -6],
        [3, -6],
        [6, -12],
        [6, -5],
        [8, -6],
        [8, -2],
        [10, -2],
        [12, -1],
        [8, -2],
        [8, 0],
        [6, -4],
        [4, -5],
        [5, -8],
        [3, -9],
        [2, -11],
        [3, -12],
        [3, -15],
        [2, -21],
        [1, -9],
        [0, -14],
        [2, -12],
        [1, -13],
        [3, -6],
        [7, -6],
        [12, -9],
        [10, -6],
        [10, -6],
        [10, 0],
        [8, 0],
        [8, 0],
        [8, -2],
        [6, -5],
        [6, -5],
        [5, -2],
        [3, -4],
        [-1, -4],
        [-9, -2],
        [-12, -5],
        [-6, -6],
        [-6, -4],
        [-4, -4],
        [-2, -4],
        [-6, -8],
        [-6, -2],
        [-8, -2],
        [-20, -8],
        [-22, -6],
        [-12, -4],
        [-4, -2],
        [-6, -4],
        [-8, -2],
        [-12, 0],
        [-12, 2],
        [-8, 2],
        [-2, 2],
        [-5, 2],
        [-2, 8],
        [-4, 4],
        [-10, 0],
        [-7, -2],
        [-5, -2],
        [-5, 0],
        [-5, 0],
        [-6, 0],
        [-7, 2],
        [-5, -2],
        [-2, -6],
        [-2, -6],
        [-6, -10],
        [-2, -8],
        [0, -6],
        [2, -6],
        [4, -6],
        [2, -6],
        [-2, -6],
        [-4, -6],
        [-6, -3],
        [-10, 0],
        [-4, 2],
        [-6, -1],
        [-6, -3],
        [-8, -2],
        [-10, -1],
        [-11, -1],
        [-8, -2],
        [-9, -2],
        [-4, -4],
        [0, -5],
        [2, -7],
        [4, -5],
        [3, -7],
        [3, -9],
        [4, -9],
        [1, -8],
        [-1, -8],
        [-2, -4],
        [-6, -4],
        [-10, -2],
        [-28, -8],
        [-15, -4],
        [-5, -2],
        [-2, -8],
        [3, -8],
        [1, -16],
        [1, -17],
        [-3, -14],
        [-4, -18],
        [-5, -8],
        [-3, -6],
        [-6, -5],
        [-10, -5],
        [-10, -1],
        [-2, -2],
        [-1, -3],
        [-1, -5],
        [1, -8],
        [3, -6],
        [1, -8],
        [-1, -6],
        [-1, -5],
        [-4, -6],
        [-5, -4],
        [-3, -4],
        [-2, -5],
        [0, -6],
        [0, -8],
        [0, -5],
        [-4, -8],
        [0, -5],
        [0, -3],
        [2, -4],
        [2, -8],
        [0, -5],
        [-2, -3],
        [-2, -2],
        [-6, -2],
        [-2, -4],
        [-2, -3],
        [-4, -1],
        [-4, 0],
        [-6, 0],
        [-6, -2],
        [-5, -2],
        [-2, -3],
        [0, -4],
        [2, -6],
        [0, -6],
        [-1, -6],
        [-3, -4],
        [-1, -4],
        [0, -4],
        [0, -8],
        [3, -4],
        [3, -4],
        [5, -4],
        [1, -7],
        [4, -6],
        [-4, -6],
        [0, -5],
        [6, -6],
        [2, -4],
        [-2, -4],
        [0, -4],
        [-2, -2],
        [-4, -1],
        [-6, 0],
        [-5, -2],
        [-4, -2],
        [0, -2],
        [-2, -1],
        [29, -1970],
        [491, -56],
        [238, -19],
        [415, -24],
        [32, 44],
        [345, 35],
        [483, 44],
        [618, 93],
        [-59, -133],
        [-282, -624],
        [-123, -271],
        [-712, -1375],
        [-389, -760],
        [-616, -1448],
        [-185, -1203],
        [-210, -228],
        [-339, 3736],
        [-1365, 363],
        [-688, 211],
        [-1124, 538],
        [-578, 252],
        [-57, 14],
        [-123, -10],
        [-357, 159],
        [28, -139],
        [2, -4],
        [4, -24],
        [6, -28],
        [2, -10],
        [8, -39],
        [17, 0],
        [2, 0],
        [2, 6],
        [6, 39],
        [2, 10],
        [4, 32],
        [21, -2],
        [6, -2],
        [37, -4],
        [9, -122],
        [-101, -14],
        [-4, -3],
        [-3, -4],
        [-21, -27],
        [-3, -4],
        [-15, -21],
        [9, -19],
        [59, -135],
        [11, -23],
        [99, -220],
        [1929, -515],
        [323, -338],
        [-129, -2013],
        [396, -1449],
        [80, -103],
        [39, -138],
        [1778, -550],
        [602, -1349],
        [-145, -342],
        [-744, -287],
        [-600, -206],
        [-1169, -1293],
        [366, -941],
        [-938, -715],
        [193, -35],
        [840, -146],
        [-33, -1303],
        [544, -277],
        [-555, -12],
        [-1719, -35],
        [-355, -33],
        [355, -441],
        [976, -1083],
        [859, 0],
        [1196, 310],
        [-327, -665],
        [-22, -99],
        [79, -302],
        [14, -153],
        [4, -34],
        [11, -33],
        [8, -15],
        [168, -212],
        [15, -21],
        [7, -18],
        [29, -68],
        [122, -305],
        [19, -44],
        [1, -9],
        [2, -84],
        [2, -85],
        [-1, -167],
        [1, -137],
        [-1, -137],
        [2, -143],
        [0, -33],
        [-62, -218],
        [-5, -20],
        [-19, -69],
        [-14, -49],
        [7, -190],
        [6, -108],
        [2, -60],
        [5, -182],
        [10, -158],
        [-6, -50],
        [-19, -46],
        [-36, -40],
        [-75, -65],
        [-76, -62],
        [-20, -18],
        [-20, -34],
        [-8, -30],
        [0, -47],
        [0, -88],
        [0, -60],
        [0, -32],
        [-8, -25],
        [-12, -23],
        [-41, -54],
        [-43, -53],
        [-33, -42],
        [-29, -36],
        [-21, -24],
        [-12, -22],
        [-10, -28],
        [-2, -38],
        [2, -41],
        [-2, -23],
        [-2, -18],
        [-21, -33],
        [-26, -38],
        [-38, -56],
        [-63, -88],
        [-22, -38],
        [-11, -37],
        [-7, -52],
        [-5, -54],
        [-11, -90],
        [-16, -124],
        [-2, -32],
        [-4, -19],
        [-10, -30],
        [-8, -14],
        [-25, -25],
        [-36, -36],
        [-57, -53],
        [-46, -43],
        [-40, -41],
        [-16, -22],
        [-8, -31],
        [1, -16],
        [11, -34],
        [35, -46],
        [96, -126],
        [51, -68],
        [14, -18],
        [12, -29],
        [2, -30],
        [-4, -28],
        [-9, -25],
        [-29, -33],
        [-61, -40],
        [-42, -27],
        [-78, -60],
        [-65, -50],
        [-78, -60],
        [-8, -7],
        [-10, -5],
        [-19, -1],
        [-27, -6],
        [-33, -6],
        [-26, -12],
        [-29, -20],
        [-11, -12],
        [-8, -10],
        [-8, -11],
        [-16, -47],
        [-19, -58],
        [-30, -86],
        [-19, -57],
        [-4, -16],
        [-7, -10],
        [-5, -18],
        [-12, -27],
        [-13, -17],
        [-23, -14],
        [-43, -20],
        [-61, -26],
        [-89, -40],
        [-88, -38],
        [-40, -16],
        [-30, -9],
        [-141, -31],
        [-56, -10],
        [-55, -10],
        [-192, 28],
        [-42, 6],
        [-79, 9],
        [-22, -3],
        [-185, -43],
        [-31, -7],
        [-26, -7],
        [-44, -10],
        [-30, -1],
        [-23, 7],
        [-16, 6],
        [-21, 21],
        [-31, 33],
        [-46, 51],
        [-22, 25],
        [-26, 19],
        [-31, 6],
        [-23, -9],
        [-24, -15],
        [-18, -39],
        [-7, -30],
        [-8, -33],
        [-12, -18],
        [-25, -26],
        [-39, -49],
        [-22, -22],
        [-54, -32],
        [-66, -36],
        [-44, -27],
        [-27, -20],
        [-5, -22],
        [-12, -38],
        [-23, -30],
        [-68, -25],
        [-484, -2352],
        [-4, -22],
        [-6, -30],
        [-44, -86],
        [-24, -11],
        [-35, -21],
        [-10, -10],
        [-12, -9],
        [-11, -13],
        [-1, -12],
        [3, -10],
        [4, -9],
        [14, -7],
        [16, -8],
        [16, -11],
        [18, -23],
        [8, -16],
        [0, -16],
        [0, -18],
        [-8, -24],
        [-6, -17],
        [4, -12],
        [6, -9],
        [16, -12],
        [5, -2],
        [9, 0],
        [9, 0],
        [7, 0],
        [8, 0],
        [8, 0],
        [6, -3],
        [10, -13],
        [0, -17],
        [-13, -22],
        [-14, -18],
        [-16, -14],
        [-19, -12],
        [-15, -15],
        [-3, -16],
        [-4, -18],
        [-10, -19],
        [-31, -24],
        [-35, -25],
        [-25, -14],
        [-16, -2],
        [-18, 7],
        [-19, 22],
        [-27, 8],
        [-34, -15],
        [-16, -28],
        [-27, -25],
        [-12, -1],
        [-20, -6],
        [-26, -6],
        [-15, -14],
        [-2, -12],
        [8, -14],
        [15, -10],
        [14, -6],
        [15, -10],
        [9, -16],
        [2, -31],
        [-13, -15],
        [-21, -22],
        [-33, -22],
        [-32, -13],
        [-64, 11],
        [-10, -2],
        [-20, 4],
        [-13, 1],
        [-21, 5],
        [-19, 4],
        [-32, 8],
        [-27, 0],
        [-17, -15],
        [-6, -20],
        [-7, -20],
        [-7, -21],
        [-6, -14],
        [-4, -8],
        [-8, -8],
        [-15, -5],
        [-20, -4],
        [-18, -11],
        [-4, -9],
        [-1, -12],
        [0, -14],
        [13, -17],
        [26, -30],
        [0, -23],
        [-8, -13],
        [-8, -11],
        [-14, -15],
        [-3, -17],
        [4, -26],
        [16, -32],
        [8, -9],
        [12, -7],
        [14, -9],
        [12, -9],
        [14, -35],
        [7, -42],
        [2, -53],
        [5, -142],
        [1, -18],
        [3, -13],
        [5, -11],
        [20, -25],
        [19, -19],
        [16, -16],
        [9, -6],
        [4, -8],
        [2, -6],
        [3, -5],
        [1, -6],
        [-1, -8],
        [-7, -11],
        [-7, -5],
        [-10, -4],
        [-10, -1],
        [-12, 5],
        [-12, 11],
        [-16, 4],
        [-12, 0],
        [-15, -5],
        [-15, 0],
        [-10, 0],
        [-15, 11],
        [-20, 16],
        [-7, 10],
        [-6, 28],
        [-2, 26],
        [-4, 13],
        [-7, 10],
        [-10, 6],
        [-16, 0],
        [-16, -3],
        [-12, -16],
        [-19, -27],
        [-13, -23],
        [-20, -14],
        [-26, -2],
        [-21, 0],
        [-16, 4],
        [-14, 2],
        [-15, -2],
        [-17, 0],
        [-12, -2],
        [-10, -15],
        [-8, -18],
        [-8, -13],
        [-6, -21],
        [-3, -18],
        [7, -27],
        [24, -53],
        [24, -56],
        [21, -50],
        [4, -8],
        [0, -10],
        [-2, -15],
        [-6, -11],
        [-4, -11],
        [-2, -13],
        [2, -17],
        [0, -24],
        [-4, -14],
        [-9, -9],
        [-10, -8],
        [-20, 0],
        [-18, -4],
        [-11, -8],
        [-12, -13],
        [-17, -21],
        [-16, -22],
        [-35, -21],
        [-15, -10],
        [-10, -14],
        [-2, -14],
        [0, -34],
        [6, -32],
        [10, -31],
        [21, -44],
        [7, -26],
        [11, -32],
        [2, -23],
        [-16, -29],
        [-14, -24],
        [-31, -48],
        [-2, -13],
        [0, -17],
        [10, -8],
        [18, 1],
        [20, 1],
        [31, 4],
        [18, -7],
        [23, -24],
        [8, -7],
        [10, -5],
        [8, 1],
        [14, -1],
        [10, -12],
        [3, -9],
        [1, -14],
        [-7, -16],
        [-5, -24],
        [0, -12],
        [6, -9],
        [11, -8],
        [26, -12],
        [38, -17],
        [20, -11],
        [14, -17],
        [13, -25],
        [-2, -20],
        [-6, -16],
        [-20, -54],
        [-15, -40],
        [-9, -58],
        [-2, -79],
        [7, -58],
        [8, -34],
        [4, -38],
        [-10, -28],
        [-13, -47],
        [-4, -19],
        [-11, -28],
        [-13, -20],
        [-9, -9],
        [-22, -19],
        [-33, -32],
        [-49, -60],
        [-16, -25],
        [-6, -24],
        [1, -30],
        [10, -29],
        [19, -43],
        [14, -57],
        [2, -28],
        [-6, -28],
        [-41, -50],
        [-50, -51],
        [-18, -18],
        [-15, -3],
        [-18, -4],
        [-12, -9],
        [-3, -14],
        [3, -14],
        [6, -28],
        [0, -18],
        [1, -10],
        [-5, -8],
        [-5, -10],
        [-14, -10],
        [-18, -10],
        [-12, -13],
        [-4, -23],
        [-8, -105],
        [8, -112],
        [14, -70],
        [17, -30],
        [18, -31],
        [34, -33],
        [25, -19],
        [18, 1],
        [10, 8],
        [28, 26],
        [12, 10],
        [29, 34],
        [10, 12],
        [11, 14],
        [14, 17],
        [14, 19],
        [13, 12],
        [11, 14],
        [12, 6],
        [12, 6],
        [12, 4],
        [12, 0],
        [11, -2],
        [8, -8],
        [6, -12],
        [0, -14],
        [-8, -14],
        [-6, -9],
        [-15, -10],
        [-11, -6],
        [-18, -8],
        [-20, -10],
        [-17, -15],
        [-12, -21],
        [-8, -25],
        [-14, -39],
        [-6, -28],
        [-3, -48],
        [4, -30],
        [13, -28],
        [38, -31],
        [13, -17],
        [22, -18],
        [17, -25],
        [27, -93],
        [4, -32],
        [-4, -38],
        [-4, -22],
        [2, -32],
        [0, -15],
        [30, -99],
        [41, -138],
        [5, -20],
        [-9, -70],
        [0, -21],
        [15, -29],
        [18, -18],
        [10, -19],
        [19, -42],
        [12, -38],
        [18, -30],
        [19, -19],
        [27, -9],
        [39, -4],
        [24, -17],
        [17, -15],
        [19, -14],
        [20, -8],
        [20, -19],
        [6, -22],
        [-4, -16],
        [-16, -19],
        [-8, -20],
        [21, -28],
        [26, -19],
        [-3, -2],
        [81, -53],
        [16, -51],
        [35, -102],
        [33, -24],
        [50, -4],
        [53, -11],
        [49, -36],
        [50, -52],
        [49, -76],
        [51, -83],
        [49, -97],
        [49, -92],
        [107, -112],
        [82, -120],
        [96, -39],
        [95, -40],
        [69, -52],
        [18, -25],
        [6, -28],
        [31, -26],
        [24, -77],
        [33, -44],
        [13, -24],
        [41, -27],
        [16, -32],
        [37, -16],
        [5, -36],
        [54, -11],
        [26, 2],
        [24, -7],
        [31, -26],
        [43, -53],
        [22, -10],
        [47, -2],
        [28, -29],
        [35, -49],
        [63, -67],
        [51, -41],
        [68, -36],
        [147, 2],
        [34, 11],
        [30, 1],
        [27, -6],
        [35, -28],
        [33, -12],
        [35, 8],
        [44, 20],
        [20, 14],
        [10, 0],
        [20, -16],
        [64, -8],
        [56, -16],
        [47, 6],
        [60, 24],
        [42, -16],
        [58, -16],
        [55, -36],
        [22, -29],
        [28, -56],
        [18, -36],
        [20, -89],
        [26, -75],
        [51, -40],
        [71, -11],
        [40, 10],
        [33, 14],
        [33, 0],
        [30, -11],
        [39, -19],
        [32, -1],
        [30, 4],
        [17, 24],
        [24, 28],
        [25, 10],
        [35, 0],
        [55, -5],
        [38, -35],
        [46, 0],
        [43, -1],
        [25, 5],
        [-2, 33],
        [18, 36],
        [19, 23],
        [41, 16],
        [45, -19],
        [29, -4],
        [18, -29],
        [27, 4],
        [19, 19],
        [20, 9],
        [-2, 18],
        [2, 12],
        [2, 5],
        [27, 0],
        [9, 5],
        [20, 0],
        [2, 15],
        [24, 6],
        [23, 8],
        [30, 2],
        [39, 27],
        [18, 16],
        [15, 18],
        [15, 29],
        [-2, 27],
        [2, 41],
        [-6, 46],
        [38, 18],
        [12, 24],
        [17, 38],
        [62, 4],
        [16, 19],
        [95, 134],
        [31, 44],
        [18, 41],
        [27, 9],
        [26, 23],
        [19, 2],
        [24, 1],
        [21, 1],
        [25, 0],
        [13, 11],
        [16, 24],
        [59, 26],
        [43, 4],
        [42, 10],
        [45, 10],
        [61, 13],
        [60, 7],
        [29, 13],
        [2, 31],
        [10, 61],
        [-3, 48],
        [22, 52],
        [6, 73],
        [28, 50],
        [13, 10],
        [28, 8],
        [6, 10],
        [-6, 34],
        [4, 14],
        [32, -4],
        [58, -8],
        [34, -22],
        [46, 126],
        [32, 98],
        [31, 93],
        [31, 34],
        [21, -8],
        [24, 43],
        [107, 37],
        [112, 20],
        [60, 38],
        [62, 8],
        [38, 6],
        [38, 2],
        [44, 1],
        [25, 0],
        [26, 1],
        [30, 1],
        [43, -5],
        [47, 3],
        [53, 3],
        [28, 19],
        [21, 25],
        [38, 17],
        [12, 24],
        [8, 26],
        [10, 27],
        [10, 23],
        [10, 23],
        [14, 20],
        [31, 24],
        [14, 7],
        [16, 7],
        [29, 13],
        [22, 2],
        [22, 0],
        [23, -13],
        [18, -20],
        [2, -19],
        [7, -16],
        [4, -25],
        [-2, -37],
        [0, -16],
        [-5, -18],
        [-8, -20],
        [-10, -36],
        [10, -61],
        [11, -50],
        [18, -54],
        [23, -39],
        [21, -20],
        [28, -21],
        [41, -8],
        [11, -8],
        [14, -8],
        [12, -9],
        [2, -16],
        [2, -20],
        [-6, -13],
        [-16, -18],
        [-10, -18],
        [-4, -20],
        [7, -25],
        [4, -16],
        [9, -23],
        [18, -22],
        [12, -16],
        [12, -15],
        [9, -16],
        [16, -20],
        [18, -12],
        [16, -4],
        [14, 4],
        [11, 10],
        [15, 14],
        [20, 18],
        [15, 2],
        [15, -8],
        [14, -4],
        [19, -10],
        [18, -6],
        [25, -6],
        [23, -6],
        [10, -2],
        [6, -2],
        [7, 0],
        [6, 2],
        [8, 10],
        [8, 14],
        [4, 4],
        [8, 10],
        [8, 10],
        [10, 5],
        [14, -4],
        [7, -5],
        [11, -16],
        [7, -12],
        [16, -8],
        [16, -4],
        [12, 6],
        [11, 2],
        [7, 8],
        [11, 10],
        [17, 8],
        [14, 6],
        [12, -2],
        [18, -8],
        [15, -12],
        [21, -20],
        [3, -26],
        [-8, -23],
        [-7, -27],
        [-4, -38],
        [22, -23],
        [29, -10],
        [28, 3],
        [14, 0],
        [14, 1],
        [11, 6],
        [19, 10],
        [32, 0],
        [10, -19],
        [0, -25],
        [-10, -8],
        [-10, -14],
        [-12, -15],
        [-10, -11],
        [-10, -10],
        [-26, -3],
        [-20, -15],
        [-4, -20],
        [4, -18],
        [12, -14],
        [18, -13],
        [11, -17],
        [14, -27],
        [9, -18],
        [26, -1],
        [16, 5],
        [13, 15],
        [20, 8],
        [20, 4],
        [28, -6],
        [27, -5],
        [8, -4],
        [12, -13],
        [16, -15],
        [11, -8],
        [17, -4],
        [20, -4],
        [18, -8],
        [16, -16],
        [20, -24],
        [18, -28],
        [26, -19],
        [21, -9],
        [16, -2],
        [22, -11],
        [31, -14],
        [11, -13],
        [2, -29],
        [-21, -47],
        [-6, -28],
        [10, -40],
        [11, -42],
        [6, -25],
        [-2, -31],
        [-2, -39],
        [6, -34],
        [14, -32],
        [6, -22],
        [12, -17],
        [32, -7],
        [27, 2],
        [22, -13],
        [4, -14],
        [8, -16],
        [19, -12],
        [20, 2],
        [18, 12],
        [21, 17],
        [26, 18],
        [31, 10],
        [31, 3],
        [31, -15],
        [25, -8],
        [32, 10],
        [19, 11],
        [6, 12],
        [8, 37],
        [13, 26],
        [11, 24],
        [20, 14],
        [27, 14],
        [16, 17],
        [15, 17],
        [7, 34],
        [3, 24],
        [5, 17],
        [19, 18],
        [23, 12],
        [19, 11],
        [30, 5],
        [35, 1],
        [20, -2],
        [25, -11],
        [35, -11],
        [35, -19],
        [38, 0],
        [18, 9],
        [26, 18],
        [20, 12],
        [31, 12],
        [23, -3],
        [34, 22],
        [40, 13],
        [47, 6],
        [59, -2],
        [20, -41],
        [29, -48],
        [40, -30],
        [15, -19],
        [19, -29],
        [4, -29],
        [-3, -28],
        [-2, -38],
        [31, -14],
        [40, 2],
        [49, 14],
        [26, 22],
        [43, 18],
        [21, 2],
        [16, -16],
        [24, -4],
        [18, -4],
        [23, 0],
        [16, 10],
        [9, 16],
        [1, 16],
        [7, 23],
        [13, 34],
        [4, 29],
        [18, 29],
        [21, 15],
        [47, 0],
        [13, 9],
        [17, 10],
        [25, 2],
        [28, 24],
        [24, 17],
        [33, -1],
        [12, -5],
        [10, -8],
        [11, -10],
        [11, -3],
        [18, -4],
        [22, -5],
        [20, -6],
        [26, -22],
        [21, -21],
        [24, -24],
        [22, -16],
        [31, 16],
        [28, 18],
        [20, 12],
        [27, 2],
        [30, 6],
        [17, 13],
        [8, 21],
        [6, 28],
        [1, 23],
        [8, 24],
        [9, 18],
        [20, 13],
        [25, 4],
        [26, -2],
        [19, -10],
        [24, -13],
        [12, -2],
        [14, 6],
        [12, 13],
        [18, 17],
        [7, 15],
        [7, 15],
        [15, 27],
        [14, 6],
        [17, 1],
        [24, -9],
        [6, -4],
        [8, -10],
        [5, -8],
        [12, -12],
        [13, -8],
        [19, -13],
        [32, -9],
        [6, -6],
        [6, -19],
        [8, -14],
        [11, -18],
        [21, -12],
        [11, -2],
        [19, -4],
        [16, -5],
        [18, -8],
        [15, -9],
        [18, -10],
        [13, -5],
        [10, 0],
        [7, -8],
        [8, -11],
        [10, -12],
        [12, -5],
        [12, -6],
        [19, -6],
        [34, -6],
        [13, 2],
        [12, 8],
        [6, 6],
        [11, 5],
        [10, 10],
        [16, 10],
        [10, 8],
        [12, 1],
        [10, 5],
        [10, 3],
        [4, -4],
        [7, 7],
        [16, 0],
        [20, -1],
        [10, 0],
        [10, -9],
        [9, -2],
        [18, 2],
        [7, -5],
        [14, -5],
        [14, 2],
        [4, 5],
        [4, 8],
        [6, 9],
        [8, 5],
        [9, -6],
        [6, 0],
        [8, 3],
        [13, 2],
        [13, -2],
        [12, 2],
        [20, 14],
        [12, 8],
        [14, 17],
        [11, 8],
        [15, 9],
        [13, 1],
        [19, -4],
        [22, -4],
        [33, 4],
        [13, 9],
        [17, 8],
        [16, 12],
        [16, 7],
        [10, 9],
        [24, 9],
        [8, 12],
        [6, 29],
        [10, 11],
        [3, 15],
        [2, 15],
        [10, 14],
        [9, 10],
        [8, 10],
        [8, 14],
        [9, 12],
        [4, 6],
        [4, 9],
        [4, 5],
        [0, 6],
        [0, 7],
        [4, 2],
        [5, 3],
        [6, 1],
        [6, 1],
        [6, 6],
        [13, -4],
        [13, 3],
        [25, -8],
        [35, 1],
        [16, 2],
        [10, 4],
        [38, 17],
        [12, 5],
        [9, 10],
        [8, 15],
        [6, 10],
        [-2, 32],
        [2, 16],
        [8, 6],
        [14, 0],
        [10, -5],
        [10, -8],
        [17, -7],
        [4, 6],
        [21, 10],
        [211, -2350],
      ],
      [
        [325991, 52300],
        [-6, -1693],
        [-32, -2873],
        [-5, -429],
        [-17, -1486],
        [-18, -2016],
        [-2, -80],
        [-12, -1169],
        [49, -41],
        [17, -58],
        [56, -5],
        [39, -28],
        [28, 3],
        [14, -10],
        [35, -22],
        [24, -10],
        [25, -6],
        [4, -37],
        [23, -22],
        [85, -23],
        [22, -26],
        [-2, -34],
        [4, -40],
        [26, -40],
        [32, -12],
        [35, -27],
        [45, -35],
        [50, -18],
        [37, 1],
        [17, 14],
        [3, -24],
        [9, -77],
        [-53, -33],
        [-13, -11],
        [-38, -94],
        [-43, -29],
        [-6, -14],
        [2, -40],
        [-33, 0],
        [-4, -8],
        [0, -22],
        [-15, -15],
        [-5, -4],
        [-22, -18],
        [13, -20],
        [-7, -18],
        [-16, -9],
        [-34, -163],
        [-17, -18],
        [6, -21],
        [-19, -25],
        [-24, -30],
        [-16, -49],
        [0, -42],
        [31, -50],
        [7, -13],
        [-10, -10],
        [15, -27],
        [10, -41],
        [15, -36],
        [-28, -54],
        [-5, -29],
        [0, -5],
        [-12, -41],
        [-1, -4],
        [1, -34],
        [11, -21],
        [0, -22],
        [17, -12],
        [13, -18],
        [6, -14],
        [-15, -26],
        [0, -13],
        [8, -15],
        [2, -3],
        [3, -18],
        [-9, -6],
        [-13, -6],
        [0, -6],
        [23, 4],
        [5, -38],
        [-5, -2],
        [8, -48],
        [3, -6],
        [1, -5],
        [1, 0],
        [18, -34],
        [6, -10],
        [9, 8],
        [55, -70],
        [4, -59],
        [-16, -12],
        [1, -6],
        [19, -29],
        [35, -6],
        [1, -27],
        [13, -48],
        [-1, -8],
        [8, -13],
        [11, -18],
        [0, -18],
        [-11, -12],
        [0, -12],
        [10, -8],
        [-6, -19],
        [-10, -9],
        [-15, 10],
        [-14, -12],
        [0, -23],
        [6, -9],
        [-14, -12],
        [-8, -19],
        [4, -6],
        [-21, -21],
        [-18, -17],
        [-5, -6],
        [-14, -17],
        [-29, -63],
        [59, -58],
        [-13, -27],
        [0, -12],
        [-8, -14],
        [-1, -26],
        [25, -18],
        [19, -77],
        [47, -18],
        [53, -16],
        [44, -7],
        [27, 0],
        [26, 0],
        [12, 0],
        [68, 0],
        [34, 2],
        [117, 1],
        [65, -16],
        [42, -52],
        [41, -34],
        [11, -28],
        [12, -19],
        [6, -20],
        [1, -25],
        [10, -11],
        [1, 0],
        [11, -13],
        [32, -6],
        [33, 0],
        [12, -37],
        [-3, -19],
        [11, -32],
        [-12, -51],
        [-25, -54],
        [-26, -12],
        [8, -7],
        [-24, -21],
        [-8, -20],
        [-16, -75],
        [0, -35],
        [10, -25],
        [-5, -27],
        [0, -21],
        [-5, -24],
        [8, -68],
        [2, -99],
        [20, -41],
        [4, -8],
        [4, -21],
        [6, 2],
        [0, -36],
        [5, -10],
        [24, -13],
        [28, -15],
        [17, -23],
        [6, -41],
        [6, -35],
        [22, -29],
        [39, -32],
        [18, -12],
        [8, -24],
        [4, -11],
        [8, -12],
        [18, -10],
        [6, -16],
        [0, -18],
        [13, -17],
        [12, 0],
        [21, -1],
        [10, -9],
        [29, -23],
        [35, -2],
        [28, 10],
        [19, 0],
        [27, -8],
        [16, -24],
        [6, -4],
        [23, 6],
        [11, 12],
        [31, 0],
        [34, 24],
        [68, -8],
        [24, 2],
        [12, 12],
        [12, 14],
        [14, 21],
        [16, -2],
        [0, -14],
        [9, -19],
        [4, 0],
        [24, -8],
        [22, -16],
        [24, -22],
        [21, -4],
        [6, 10],
        [-6, 24],
        [3, 12],
        [12, 6],
        [22, -10],
        [10, -4],
        [15, -6],
        [16, 0],
        [14, -4],
        [12, -12],
        [-5, -14],
        [-2, -16],
        [5, -16],
        [6, -16],
        [28, -2],
        [25, 0],
        [24, -44],
        [31, -21],
        [-3, -20],
        [3, -22],
        [22, 12],
        [15, 6],
        [12, 6],
        [9, 15],
        [0, 19],
        [8, 11],
        [14, -24],
        [8, -17],
        [8, -17],
        [11, -17],
        [10, -14],
        [9, -16],
        [8, -13],
        [8, -6],
        [12, 7],
        [8, 2],
        [8, -3],
        [3, -14],
        [-1, -14],
        [-1, -15],
        [11, -2],
        [23, -9],
        [13, -14],
        [9, -15],
        [1, -14],
        [-6, -15],
        [-1, -11],
        [4, -11],
        [20, -6],
        [-2, -15],
        [0, -9],
        [-15, -3],
        [-15, -8],
        [-11, -8],
        [-9, -8],
        [-8, -14],
        [0, -8],
        [4, -14],
        [4, -10],
        [-4, -6],
        [-6, -11],
        [-10, -15],
        [-11, -19],
        [-20, -23],
        [-6, -21],
        [-11, -16],
        [-16, -12],
        [-9, -28],
        [-1, -18],
        [3, -25],
        [17, -39],
        [25, -16],
        [-4, -14],
        [22, -13],
        [20, -4],
        [19, 4],
        [23, 11],
        [31, 4],
        [15, -7],
        [9, -11],
        [8, -10],
        [10, -6],
        [5, -14],
        [8, -18],
        [-10, -32],
        [8, -47],
        [1, -46],
        [7, -14],
        [5, -21],
        [6, -58],
        [2, -20],
        [-4, -14],
        [0, -12],
        [6, -16],
        [6, -15],
        [16, -20],
        [21, -14],
        [20, -11],
        [17, -10],
        [25, -5],
        [30, -6],
        [59, 4],
        [0, 14],
        [44, 16],
        [18, 4],
        [24, -8],
        [20, 2],
        [21, 6],
        [18, 1],
        [20, -3],
        [21, -4],
        [20, -4],
        [30, -19],
        [31, -12],
        [46, 0],
        [39, -15],
        [14, -4],
        [9, -9],
        [20, -9],
        [18, -11],
        [18, -5],
        [19, 0],
        [16, 16],
        [15, 18],
        [15, 45],
        [18, 22],
        [13, 8],
        [14, 27],
        [36, 24],
        [22, 27],
        [44, 27],
        [42, 30],
        [52, -2],
        [46, 23],
        [29, 9],
        [20, 9],
        [27, 0],
        [21, -10],
        [24, -25],
        [31, -38],
        [25, -2],
        [20, -9],
        [17, -14],
        [11, -16],
        [12, -9],
        [20, -11],
        [21, -13],
        [14, -10],
        [12, -13],
        [4, -19],
        [-14, -16],
        [-4, -29],
        [-20, -17],
        [-24, -7],
        [-24, -2],
        [-23, 5],
        [-18, -8],
        [-50, -38],
        [-13, -9],
        [-15, -8],
        [-14, -18],
        [-12, -20],
        [-8, -20],
        [-8, -14],
        [1, -17],
        [-3, -22],
        [-12, -43],
        [-10, -43],
        [-8, -20],
        [-6, -26],
        [-19, -22],
        [-6, -19],
        [-8, -29],
        [-2, -34],
        [6, -33],
        [4, -29],
        [23, -37],
        [17, -22],
        [17, -28],
        [21, -24],
        [27, -23],
        [27, -26],
        [25, -13],
        [23, -18],
        [21, -10],
        [10, -16],
        [8, -21],
        [11, -27],
        [10, -19],
        [14, -14],
        [14, -12],
        [7, -13],
        [1, -25],
        [4, -31],
        [2, -27],
        [12, -43],
        [23, -55],
        [33, -58],
        [32, -23],
        [26, -12],
        [21, -6],
        [33, -20],
        [35, -20],
        [33, -20],
        [19, -13],
        [16, -20],
        [12, -12],
        [10, -14],
        [19, -32],
        [8, -18],
        [8, -28],
        [-4, -36],
        [2, -23],
        [22, -45],
        [1, -73],
        [-23, -46],
        [-16, -33],
        [-23, -48],
        [-33, -26],
        [-16, -21],
        [-18, -34],
        [-15, -46],
        [6, -45],
        [29, -64],
        [21, -24],
        [31, -30],
        [24, -23],
        [0, -20],
        [4, -20],
        [2, -39],
        [6, -41],
        [2, -28],
        [11, -37],
        [11, -37],
        [1, -22],
        [-19, -29],
        [-36, -40],
        [-27, -27],
        [-6, -32],
        [2, -25],
        [1, -46],
        [19, -8],
        [15, -11],
        [0, -30],
        [-17, -47],
        [-9, -23],
        [-1, -44],
        [12, -73],
        [22, -71],
        [32, -104],
        [13, -58],
        [7, -77],
        [6, -63],
        [5, -22],
        [12, -50],
        [17, -97],
        [3, -26],
        [-6, -36],
        [-22, -45],
        [-24, -43],
        [-34, -22],
        [-49, -8],
        [-16, 2],
        [-17, 3],
        [-21, 6],
        [-12, -2],
        [-14, -1],
        [-18, 8],
        [-22, 13],
        [-21, 8],
        [-14, 15],
        [-24, 7],
        [-29, 17],
        [-27, 7],
        [-32, 4],
        [-28, 0],
        [-21, -6],
        [-22, -10],
        [-32, -6],
        [-30, -1],
        [-20, -6],
        [-11, -5],
        [-12, 0],
        [-17, -2],
        [-6, -16],
        [-12, -19],
        [-7, -26],
        [1, -39],
        [0, -32],
        [-2, -34],
        [-16, -49],
        [-10, -34],
        [-4, -26],
        [0, -18],
        [9, -18],
        [5, -26],
        [16, -39],
        [12, -24],
        [12, -25],
        [14, -37],
        [18, -28],
        [29, -29],
        [13, -11],
        [16, -10],
        [14, -13],
        [20, -22],
        [24, -24],
        [31, -30],
        [28, -23],
        [16, -19],
        [17, -21],
        [18, -22],
        [31, -32],
        [12, -20],
        [10, -18],
        [12, -11],
        [17, -13],
        [22, 1],
        [12, -6],
        [22, -17],
        [21, -12],
        [18, -11],
        [6, -14],
        [10, -14],
        [13, -29],
        [6, -18],
        [8, -19],
        [11, -24],
        [16, -32],
        [12, -32],
        [6, -41],
        [4, -35],
        [2, -32],
        [15, -63],
        [6, -53],
        [25, -79],
        [19, -47],
        [20, -16],
        [18, -9],
        [16, 11],
        [13, 11],
        [24, -2],
        [21, -12],
        [10, -14],
        [4, -35],
        [-2, -38],
        [-6, -39],
        [-11, -15],
        [-25, -24],
        [-30, -34],
        [-8, -19],
        [-2, -32],
        [-2, -28],
        [-12, -24],
        [-24, -22],
        [-15, 0],
        [-24, 2],
        [-21, -36],
        [-17, -31],
        [-16, -31],
        [-8, -28],
        [-17, -33],
        [-2, -33],
        [-6, -27],
        [-14, -25],
        [-19, -17],
        [-18, -23],
        [-11, -28],
        [-8, -29],
        [-14, -29],
        [-16, -39],
        [-12, -28],
        [-5, -30],
        [2, -43],
        [-1, -27],
        [4, -17],
        [10, -28],
        [2, -35],
        [12, -18],
        [14, -16],
        [15, -21],
        [12, -23],
        [4, -23],
        [4, -27],
        [10, -18],
        [19, -46],
        [29, -42],
        [20, -30],
        [27, -33],
        [26, -34],
        [16, -41],
        [14, -45],
        [10, -35],
        [-3, -25],
        [-22, -28],
        [-27, -12],
        [-46, 0],
        [-24, -11],
        [-24, -14],
        [-31, -14],
        [-21, -7],
        [-36, -17],
        [-28, -11],
        [-27, -7],
        [-18, -11],
        [-10, -12],
        [-6, -22],
        [-4, -22],
        [8, -22],
        [6, -12],
        [8, -10],
        [16, -4],
        [22, -8],
        [14, 7],
        [17, 3],
        [12, -6],
        [26, -10],
        [21, -9],
        [43, -30],
        [27, -24],
        [26, -24],
        [26, -4],
        [25, 20],
        [32, 14],
        [26, 6],
        [37, -10],
        [37, -20],
        [29, -8],
        [21, -24],
        [16, -33],
        [37, -30],
        [59, -35],
        [56, -28],
        [49, -17],
        [55, -7],
        [8, 8],
        [32, -7],
        [28, 9],
        [22, 14],
        [58, -2],
        [20, 9],
        [16, 12],
        [24, 7],
        [26, -9],
        [19, -15],
        [15, -23],
        [14, -38],
        [17, -40],
        [20, -68],
        [4, -36],
        [-4, -56],
        [-6, -38],
        [-4, -25],
        [-2, -17],
        [-10, -17],
        [-10, -18],
        [-32, -19],
        [-21, -13],
        [-10, -6],
        [-47, -35],
        [-49, -27],
        [-66, -3],
        [-27, -11],
        [-35, -25],
        [-22, -27],
        [-9, -36],
        [-21, -17],
        [-12, -37],
        [-5, -47],
        [14, -56],
        [25, -44],
        [18, -31],
        [27, -36],
        [28, -18],
        [30, -6],
        [23, -14],
        [4, -2],
        [-4, -22],
        [-2, -4],
        [-6, -11],
        [0, -17],
        [12, -37],
        [26, -87],
        [8, -14],
        [5, -9],
        [3, -21],
        [1, -12],
        [3, -36],
        [9, -25],
        [14, -12],
        [14, 3],
        [3, 2],
        [5, 2],
        [14, 11],
        [21, 31],
        [10, 28],
        [0, 0],
        [9, 31],
        [19, 15],
        [45, 8],
        [50, -21],
        [28, -19],
        [32, -20],
        [22, -34],
        [12, -39],
        [6, -52],
        [8, -63],
        [20, -31],
        [12, -39],
        [2, -46],
        [-5, -38],
        [-2, -36],
        [12, -14],
        [8, -17],
        [-39, -43],
        [-4, -4],
        [-38, -42],
        [-36, -44],
        [-43, -42],
        [-17, -23],
        [-10, -20],
        [-2, -23],
        [20, -30],
        [28, -42],
        [60, -53],
        [35, -46],
        [27, -30],
        [23, -34],
        [8, -22],
        [9, -9],
        [26, 5],
        [19, -11],
        [22, 0],
        [18, 7],
        [32, -7],
        [33, -6],
        [28, 7],
        [33, -3],
        [32, 6],
        [23, 5],
        [29, 13],
        [25, 2],
        [35, -20],
        [67, -49],
        [44, -39],
        [47, -22],
        [32, -41],
        [38, -65],
        [20, -50],
        [35, -39],
        [17, -54],
        [-5, -105],
        [-20, -115],
        [-35, -85],
        [-64, -55],
        [-65, -27],
        [-92, -41],
        [-64, -27],
        [-109, -12],
        [-82, -11],
        [-58, -9],
        [-46, -12],
        [-28, -22],
        [-14, -35],
        [-12, -40],
        [2, -24],
        [-21, -12],
        [-34, 6],
        [-26, -7],
        [-14, -8],
        [-17, -7],
        [-29, -8],
        [-34, -6],
        [-41, -39],
        [-32, -11],
        [-20, 16],
        [-53, 22],
        [-8, 48],
        [-39, 20],
        [-20, -28],
        [-23, 7],
        [10, 47],
        [-7, 24],
        [-24, -12],
        [-31, -6],
        [-18, 38],
        [-8, 29],
        [-29, 31],
        [-29, 21],
        [-2, 25],
        [-29, 12],
        [-30, 15],
        [-9, 8],
        [-6, 20],
        [-2, 17],
        [-17, 8],
        [-16, -6],
        [-15, 8],
        [-6, 14],
        [-4, 25],
        [-4, 18],
        [-6, 21],
        [5, 20],
        [-21, 10],
        [-29, 7],
        [-25, 5],
        [5, 19],
        [6, 29],
        [-11, 20],
        [-21, 14],
        [-40, 16],
        [-29, 10],
        [-35, -2],
        [-30, 9],
        [-20, 11],
        [-23, 9],
        [-24, 5],
        [-20, -5],
        [-22, -20],
        [-16, -13],
        [-37, -14],
        [-33, -14],
        [-42, 2],
        [-9, -6],
        [-30, -26],
        [-13, -2],
        [-12, -3],
        [-22, -21],
        [-15, -10],
        [-14, -22],
        [-6, -30],
        [-12, -19],
        [-13, -8],
        [-18, -10],
        [-18, -12],
        [-14, -56],
        [-15, -11],
        [-39, -7],
        [-33, -11],
        [-30, -16],
        [-33, -15],
        [-43, -2],
        [-20, 3],
        [-28, -17],
        [-21, -18],
        [-32, -15],
        [-37, -3],
        [-28, -10],
        [-27, -11],
        [-22, 3],
        [-44, 12],
        [-34, 0],
        [-26, 0],
        [-23, 3],
        [-49, 43],
        [-23, 24],
        [-24, 1],
        [-20, -10],
        [-11, -5],
        [-13, 2],
        [-22, 0],
        [-18, 2],
        [-33, -5],
        [-17, 3],
        [-11, 23],
        [-24, 8],
        [-24, 1],
        [-27, -4],
        [-37, 13],
        [-40, 5],
        [-67, -3],
        [-69, -17],
        [-17, 5],
        [-23, 20],
        [-38, 16],
        [-34, 10],
        [-20, 31],
        [-11, 24],
        [-10, 14],
        [-26, 13],
        [-25, 11],
        [-33, 18],
        [-43, -2],
        [-45, -8],
        [-13, 6],
        [-32, 45],
        [-49, 52],
        [-37, 37],
        [-41, 12],
        [-54, 8],
        [-51, -21],
        [-50, 9],
        [-33, -19],
        [-20, -20],
        [-37, 6],
        [-18, -2],
        [-39, -70],
        [-16, -73],
        [-13, -16],
        [-23, -12],
        [-27, -6],
        [-32, -14],
        [-22, -24],
        [-11, -31],
        [-5, -19],
        [-27, -1],
        [-33, 15],
        [-44, 7],
        [-37, -33],
        [-36, -26],
        [-33, -24],
        [-25, -16],
        [-23, -19],
        [-41, -14],
        [-37, -18],
        [-43, -14],
        [-47, -12],
        [-21, -8],
        [-33, -8],
        [-37, -18],
        [-41, -4],
        [-55, -25],
        [-64, -37],
        [-47, -17],
        [-24, -1],
        [-37, -5],
        [-37, -7],
        [-62, -10],
        [-69, -9],
        [-46, 0],
        [-32, -6],
        [-21, -4],
        [-32, -8],
        [-26, -4],
        [-33, -8],
        [-16, -2],
        [-49, 0],
        [-29, 0],
        [-30, 6],
        [-34, -2],
        [-41, 31],
        [-31, -3],
        [-37, 15],
        [-25, 0],
        [-31, 5],
        [-57, -1],
        [-65, 34],
        [-62, -6],
        [-54, -7],
        [-43, -9],
        [-54, -12],
        [-28, -29],
        [-39, -8],
        [-34, 0],
        [-19, -14],
        [-18, -10],
        [-18, -6],
        [-23, 2],
        [-36, 4],
        [-27, 24],
        [-28, -6],
        [-17, 8],
        [-20, -2],
        [-30, -6],
        [-36, 6],
        [-30, -6],
        [-15, -24],
        [-39, -14],
        [-32, 6],
        [-10, 8],
        [-9, 6],
        [-6, 6],
        [8, 24],
        [-19, 20],
        [-37, 17],
        [-8, 9],
        [-11, 24],
        [-59, 21],
        [-22, -1],
        [-35, -15],
        [-27, 13],
        [-17, 17],
        [-18, 10],
        [-6, 28],
        [-6, 26],
        [10, 13],
        [12, 54],
        [15, 20],
        [10, 22],
        [-6, 26],
        [-15, 10],
        [-34, 15],
        [-31, 15],
        [-27, 29],
        [-10, 33],
        [2, 28],
        [-16, 14],
        [-23, 11],
        [-9, 14],
        [-2, 18],
        [-5, 22],
        [-17, 17],
        [-48, 57],
        [-20, 20],
        [-6, 23],
        [4, 33],
        [-4, 40],
        [-14, 40],
        [-21, 39],
        [-28, 16],
        [-27, 7],
        [-31, 13],
        [-58, 13],
        [-65, -9],
        [-23, 23],
        [-24, 29],
        [-28, 9],
        [-24, 1],
        [-16, 24],
        [-29, 10],
        [-24, 30],
        [-13, 38],
        [-31, 53],
        [-24, 28],
        [-30, 27],
        [-14, 27],
        [-20, 44],
        [-23, 14],
        [-49, 2],
        [-39, 6],
        [-22, 17],
        [-34, -2],
        [-46, 28],
        [-58, 17],
        [-36, -19],
        [-67, 14],
        [-2, 15],
        [-42, 22],
        [-90, 41],
        [-69, 41],
        [-47, 22],
        [-25, -14],
        [-20, -32],
        [-21, -22],
        [-23, -42],
        [-19, -18],
        [-25, -12],
        [-54, -21],
        [-42, -5],
        [-14, 5],
        [-16, 8],
        [-47, 41],
        [-40, 0],
        [-22, 32],
        [-14, 27],
        [-97, -23],
        [-37, 16],
        [-37, 27],
        [-61, -28],
        [-42, 2],
        [-45, 38],
        [-37, -9],
        [-51, -16],
        [-79, -33],
        [-79, 3],
        [-45, -19],
        [-6, -17],
        [-4, -18],
        [-20, -14],
        [-10, -17],
        [-12, -14],
        [-29, -16],
        [-22, -16],
        [-10, -37],
        [-6, -32],
        [-6, -27],
        [-1, -22],
        [29, -24],
        [39, -24],
        [-2, -18],
        [40, -22],
        [32, -40],
        [29, -32],
        [37, -43],
        [12, -52],
        [-14, -47],
        [2, -59],
        [-6, -25],
        [8, -57],
        [-6, -52],
        [-2, -51],
        [-31, -41],
        [-64, -23],
        [-3, -24],
        [-3, -22],
        [-23, -26],
        [-16, -37],
        [11, -36],
        [15, -36],
        [2, -40],
        [-83, -74],
        [-57, -73],
        [-46, -88],
        [-101, -34],
        [-53, -41],
        [-12, -42],
        [2, -48],
        [16, -41],
        [11, -27],
        [-25, -16],
        [-26, -15],
        [18, -57],
        [8, -38],
        [-2, -28],
        [-48, -12],
        [-51, -18],
        [-65, -30],
        [-57, -20],
        [-30, -23],
        [-14, -32],
        [-4, -22],
        [1, -16],
        [-1, -16],
        [-58, -32],
        [-35, 8],
        [-50, 10],
        [-45, 1],
        [-55, 15],
        [-26, -6],
        [-43, -6],
        [-43, -3],
        [-32, -9],
        [-28, 3],
        [-33, 5],
        [-28, 1],
        [-21, -21],
        [-17, -26],
        [-19, -21],
        [-41, -18],
        [-20, -14],
        [-22, -11],
        [-36, -4],
        [-34, -4],
        [-27, 12],
        [-33, 9],
        [-30, -9],
        [-29, -6],
        [-23, -2],
        [-22, -6],
        [-37, -18],
        [-26, -17],
        [-30, -23],
        [-37, -37],
        [-22, -47],
        [-56, -64],
        [-34, -35],
        [-42, -48],
        [-30, -45],
        [-31, -39],
        [-25, -40],
        [-4, -30],
        [-16, -23],
        [-35, -24],
        [-24, -35],
        [-16, -29],
        [-18, -24],
        [-10, -22],
        [-14, -23],
        [-32, -24],
        [-40, -11],
        [-42, -3],
        [-37, 2],
        [-28, 3],
        [-46, 1],
        [-24, -9],
        [-35, -8],
        [-29, -22],
        [-21, -14],
        [-31, -24],
        [-22, 4],
        [-22, -6],
        [-20, -14],
        [-20, -17],
        [-21, -10],
        [-14, -2],
        [-10, -5],
        [-78, -333],
        [-32, -234],
        [-36, -91],
        [-2, -36],
        [2, -45],
        [1, -25],
        [-6, -47],
        [-10, -33],
        [-16, -33],
        [-10, -25],
        [2, -33],
        [8, -58],
        [3, -53],
        [14, -37],
        [5, -24],
        [2, -17],
        [32, -40],
        [9, -24],
        [4, -26],
        [-2, -14],
        [-8, -26],
        [-4, -14],
        [20, 16],
        [43, 10],
        [29, 8],
        [34, 10],
        [25, 2],
        [33, -4],
        [35, -14],
        [36, -10],
        [34, -8],
        [36, -3],
        [23, 0],
        [-48, -18],
        [-12, -24],
        [-2, -16],
        [-10, -14],
        [-8, -10],
        [-28, -44],
        [-27, -35],
        [-28, -19],
        [-19, -27],
        [-12, -47],
        [-13, -30],
        [-23, -28],
        [-17, -29],
        [-24, -21],
        [-22, -14],
        [-25, -2],
        [-24, 2],
        [-21, 2],
        [-29, -8],
        [-43, -17],
        [-29, -14],
        [-37, -32],
        [-24, -29],
        [-10, -28],
        [-2, -29],
        [10, -20],
        [6, -17],
        [14, -15],
        [2, -17],
        [-8, -39],
        [0, -25],
        [-22, -5],
        [-21, -5],
        [-33, -17],
        [-30, -15],
        [-34, -19],
        [-18, -12],
        [-31, -31],
        [-33, -30],
        [-12, -24],
        [-18, -25],
        [-18, -33],
        [-12, -25],
        [-15, -30],
        [-25, -22],
        [-25, -18],
        [-35, -18],
        [-28, -25],
        [-5, -36],
        [-5, -32],
        [1, -22],
        [-6, -32],
        [-22, -26],
        [-7, -29],
        [-19, -23],
        [0, -31],
        [1, -40],
        [-9, -38],
        [-6, -41],
        [-39, -44],
        [-10, -43],
        [4, -42],
        [8, -28],
        [8, -50],
        [2, -20],
        [8, -39],
        [9, -41],
        [18, -52],
        [9, -56],
        [16, -49],
        [21, -39],
        [23, -42],
        [21, -51],
        [32, -71],
        [22, -31],
        [18, -29],
        [20, -21],
        [34, -15],
        [39, -23],
        [10, -20],
        [4, -12],
        [-2, -25],
        [-2, -12],
        [-14, -42],
        [2, -63],
        [-12, -52],
        [-16, -61],
        [-19, -61],
        [-27, -47],
        [-23, -36],
        [-26, -29],
        [-23, -48],
        [-26, -40],
        [-41, -35],
        [-41, -30],
        [-1, -48],
        [-29, -58],
        [-18, -21],
        [-2, -29],
        [27, -45],
        [16, -22],
        [9, -42],
        [-3, -37],
        [-26, -41],
        [-39, -36],
        [-60, -36],
        [-56, -25],
        [-48, -20],
        [-56, -20],
        [-32, -10],
        [-46, -4],
        [-68, -25],
        [-53, -22],
        [-23, -17],
        [-27, -42],
        [-25, -39],
        [-12, -57],
        [-6, -56],
        [-6, -41],
        [-6, -29],
        [-2, -25],
        [10, -28],
        [4, -26],
        [12, -26],
        [12, -24],
        [26, -36],
        [16, -33],
        [21, -24],
        [25, -14],
        [26, -26],
        [6, -12],
        [57, -30],
        [39, -50],
        [54, -49],
        [37, -43],
        [36, -31],
        [23, -36],
        [23, -41],
        [19, -29],
        [9, -15],
        [20, -41],
        [0, -39],
        [-5, -24],
        [-11, -28],
        [-15, -32],
        [-19, -28],
        [-4, -27],
        [-2, -25],
        [-7, -4],
        [-20, -14],
        [-8, -2],
        [-29, -7],
        [-5, -1],
        [-8, -3],
        [-20, -5],
        [-56, -3],
        [-59, 7],
        [-42, -15],
        [-34, -2],
        [-62, -15],
        [-34, -24],
        [-41, -26],
        [-43, -20],
        [-29, -34],
        [0, -28],
        [15, -27],
        [-11, -65],
        [-4, -24],
        [-22, -68],
        [6, -46],
        [14, -30],
        [27, 5],
        [34, 4],
        [19, 5],
        [20, -7],
        [22, 4],
        [35, 2],
        [42, -1],
        [18, 22],
        [76, 46],
        [52, 19],
        [43, 11],
        [54, -6],
        [40, -12],
        [86, -51],
        [20, -45],
        [7, -41],
        [37, -45],
        [45, -34],
        [17, -26],
        [19, -19],
        [14, -13],
        [36, -22],
        [44, -6],
        [46, -20],
        [14, -27],
        [16, 6],
        [12, -11],
        [36, 2],
        [42, -25],
        [23, -18],
        [44, -25],
        [35, -55],
        [30, -41],
        [74, -61],
        [42, -31],
        [17, -30],
        [20, -31],
        [-26, -35],
        [-22, -46],
        [-33, -61],
        [-33, -58],
        [-33, -26],
        [-37, -34],
        [-47, -34],
        [-23, -32],
        [-16, -44],
        [0, -36],
        [6, -36],
        [8, -40],
        [8, -35],
        [-8, -46],
        [-15, -20],
        [-23, -18],
        [-38, -14],
        [-24, -16],
        [-36, -22],
        [-31, -18],
        [-36, -19],
        [-40, -17],
        [-48, -11],
        [-38, -7],
        [-24, -10],
        [-14, -21],
        [-38, -28],
        [-69, -39],
        [-52, -38],
        [-35, -21],
        [-40, -38],
        [-9, -23],
        [6, -36],
        [10, -51],
        [19, -39],
        [18, -44],
        [25, -46],
        [14, -58],
        [17, -35],
        [17, 1],
        [23, 6],
        [26, 4],
        [21, -6],
        [18, -9],
        [18, -12],
        [17, -13],
        [36, -26],
        [21, -17],
        [21, -8],
        [42, -9],
        [27, -1],
        [15, -1],
        [35, 0],
        [0, -1],
        [9, -30],
        [5, -28],
        [17, -29],
        [-7, -14],
        [-16, 20],
        [-9, -51],
        [-7, -26],
        [-1, -27],
        [10, -30],
        [11, -16],
        [23, -34],
        [25, -34],
        [10, -24],
        [28, -51],
        [-8, -43],
        [12, -64],
        [28, -48],
        [6, -42],
        [11, -50],
        [70, -95],
        [42, 0],
        [39, 0],
        [51, -24],
        [35, -14],
        [20, -27],
        [32, -14],
        [30, -8],
        [35, -19],
        [32, -17],
        [38, -30],
        [28, -28],
        [25, -18],
        [23, -16],
        [41, -32],
        [38, -42],
        [36, -44],
        [40, -49],
        [40, -38],
        [37, -42],
        [39, -66],
        [42, -61],
        [17, -62],
        [-13, -112],
        [-13, -92],
        [-35, -135],
        [-17, -83],
        [-6, -60],
        [14, -40],
        [0, -51],
        [0, -29],
        [-37, -9],
        [-37, 12],
        [-47, 27],
        [-43, -16],
        [-57, 46],
        [-41, 37],
        [-48, 23],
        [-37, 3],
        [-39, -3],
        [-48, 5],
        [-29, 17],
        [-62, 28],
        [-43, 14],
        [-41, -8],
        [-70, -19],
        [-75, -41],
        [-47, -37],
        [-36, -49],
        [-21, -68],
        [-23, -40],
        [-35, -50],
        [-35, -18],
        [-32, -20],
        [-29, -20],
        [-24, -22],
        [-18, -24],
        [-13, -23],
        [-11, -27],
        [-3, -35],
        [5, -42],
        [12, -27],
        [28, -25],
        [20, -30],
        [4, -16],
        [-6, -22],
        [-10, -30],
        [-19, -44],
        [-16, -43],
        [-17, -44],
        [-35, -49],
        [-43, -50],
        [-50, -57],
        [-3, -3],
        [-46, -47],
        [-39, -56],
        [-47, -54],
        [-40, -59],
        [-15, -76],
        [0, -81],
        [5, -52],
        [-3, -60],
        [-21, -70],
        [-26, -25],
        [-46, -33],
        [-36, -49],
        [-25, -28],
        [-18, -32],
        [-13, -28],
        [-33, -34],
        [-26, -32],
        [-25, -37],
        [-32, -35],
        [-16, -26],
        [-11, -27],
        [0, -32],
        [-17, -60],
        [7, -74],
        [3, -42],
        [8, -39],
        [11, -46],
        [8, -48],
        [9, -53],
        [1, -40],
        [0, -26],
        [-3, -19],
        [-30, 14],
        [-30, 19],
        [-46, 12],
        [-37, 11],
        [-51, 16],
        [-43, -5],
        [-34, 14],
        [-26, 8],
        [-51, 19],
        [-45, 8],
        [-46, 11],
        [-38, 9],
        [-30, 8],
        [-26, 10],
        [-36, 14],
        [-34, 24],
        [-34, 14],
        [-46, 34],
        [-44, 26],
        [-39, 33],
        [-34, 22],
        [-38, 18],
        [-38, 4],
        [-25, 4],
        [-28, 0],
        [-38, 0],
        [-38, -2],
        [-36, -16],
        [-43, -31],
        [-20, -16],
        [-16, -11],
        [-45, -40],
        [-31, -35],
        [-46, -30],
        [-22, -26],
        [-23, -27],
        [-30, -9],
        [-33, -10],
        [-31, -25],
        [-20, -53],
        [-32, -70],
        [-24, -61],
        [-19, -60],
        [-10, -62],
        [-7, -28],
        [-5, -62],
        [-7, -55],
        [194, -74],
        [-29, -106],
        [-137, -119],
        [-45, -6],
        [-38, -131],
        [-88, 30],
        [-344, -378],
        [-126, 107],
        [-51, -45],
        [-72, 60],
        [-25, 2],
        [-8, 9],
        [-12, -7],
        [193, -292],
        [0, -3],
        [24, -24],
        [6, -10],
        [39, -11],
        [69, 8],
        [44, 7],
        [48, -31],
        [4, -45],
        [-46, -127],
        [-78, -196],
        [3, -8],
        [0, -5],
        [13, -50],
        [51, -375],
        [21, -155],
        [318, -704],
        [712, -1008],
        [415, -1270],
        [-116, -490],
        [-34, -141],
        [-19, -82],
        [-10, -41],
        [-84, -89],
        [-56, -58],
        [-14, -17],
        [-33, -35],
        [-18, -19],
        [-75, -76],
        [-26, -26],
        [-21, -22],
        [-416, -402],
        [6, -10],
        [-2, -18],
        [10, -21],
        [-41, -33],
        [0, -3],
        [0, -3],
        [-74, -35],
        [-34, 41],
        [-95, -39],
        [-22, -14],
        [-20, -26],
        [-20, -65],
        [30, -40],
        [-31, -125],
        [43, -26],
        [-30, -111],
        [-8, -4],
        [-2, -36],
        [-25, -50],
        [-131, -38],
        [41, -102],
        [6, -63],
        [-52, -20],
        [-47, 8],
        [-14, -48],
        [-6, -104],
        [-173, -37],
        [43, -92],
        [83, -253],
        [-175, -138],
        [-51, 41],
        [-93, -36],
        [-63, 25],
        [17, 34],
        [-87, 22],
        [0, -12],
        [-66, -53],
        [-47, -3],
        [0, 263],
        [-80, -1],
        [29, -87],
        [-62, -53],
        [23, -83],
        [82, -141],
        [-93, -172],
        [-36, 23],
        [-163, -192],
        [-175, 159],
        [-75, -124],
        [154, -126],
        [-2, 0],
        [-313, -46],
        [9, -66],
        [-92, -13],
        [-10, 28],
        [-30, -2],
        [-56, -144],
        [-64, -52],
        [18, 113],
        [-89, -173],
        [-183, -350],
        [-143, 80],
        [-1258, 715],
        [-1521, -616],
        [-55, -23],
        [-26, -11],
        [-20, -8],
        [-4, -2],
        [-57, -24],
        [-2, -1],
        [-2, -1],
        [-35, -15],
        [-1459, -623],
        [-553, -252],
        [-821, -331],
        [-868, -417],
        [-66, -22],
        [-205, -66],
        [-717, -235],
        [-1170, -384],
        [-78, 5],
        [-9, -27],
        [-7, -31],
        [-12, -36],
        [-6, -27],
        [9, -64],
        [1, -4],
        [11, -27],
        [12, -32],
        [34, -38],
        [5, -6],
        [54, -12],
        [22, -6],
        [25, -26],
        [99, 54],
        [20, 11],
        [7, 4],
        [20, -11],
        [41, -26],
        [51, -30],
        [44, -45],
        [7, -14],
        [14, -28],
        [9, -18],
        [16, -56],
        [-9, -125],
        [-1, -2],
        [-56, -109],
        [-61, -51],
        [-8, -6],
        [-61, -47],
        [-34, 0],
        [-75, -1],
        [-64, -22],
        [-60, -51],
        [-17, -67],
        [5, -78],
        [23, -31],
        [37, -12],
        [16, 14],
        [2, 17],
        [1, 9],
        [31, 23],
        [44, -2],
        [50, -82],
        [27, -45],
        [3, -30],
        [4, -34],
        [9, -29],
        [40, -50],
        [48, -43],
        [45, -61],
        [41, -76],
        [51, -58],
        [53, -28],
        [78, -22],
        [71, 20],
        [26, 6],
        [123, -2],
        [29, -4],
        [0, -30],
        [0, -31],
        [0, -15],
        [-13, -14],
        [-14, -2],
        [-18, -4],
        [-20, -5],
        [-18, -9],
        [-24, -31],
        [-9, -20],
        [-1, -6],
        [-10, -6],
        [-13, -12],
        [-4, -18],
        [-3, -12],
        [-7, -6],
        [-12, -2],
        [-45, -9],
        [-12, 31],
        [-21, 26],
        [-11, 16],
        [-10, 16],
        [-29, 20],
        [-63, 27],
        [-37, 8],
        [-37, 4],
        [-20, -3],
        [-5, -2],
        [-33, -9],
        [-21, 0],
        [-18, 5],
        [-22, -1],
        [-1, 0],
        [-2, 0],
        [-28, -3],
        [-31, -5],
        [-3, -1],
        [-17, -7],
        [-8, -3],
        [-15, -5],
        [-13, -1],
        [-4, 0],
        [-3, 0],
        [-7, 2],
        [-12, 7],
        [-24, 5],
        [-29, 0],
        [-17, -1],
        [-18, 0],
        [-22, -9],
        [-15, -10],
        [-23, -8],
        [-16, -6],
        [-58, -28],
        [-88, -81],
        [-67, -73],
        [-34, -48],
        [-2, -7],
        [4, -8],
        [3, -5],
        [-3, -9],
        [-6, -7],
        [-4, -2],
        [-6, -10],
        [-12, -13],
        [-8, -8],
        [-11, -2],
        [-10, 0],
        [-6, -2],
        [-5, 0],
        [-15, -4],
        [-17, 2],
        [-4, 0],
        [-6, 0],
        [-19, -2],
        [-17, -4],
        [-16, -4],
        [-17, -6],
        [-10, 0],
        [-14, -2],
        [-24, -2],
        [-15, 2],
        [-24, 6],
        [-16, 4],
        [-15, -2],
        [-12, -2],
        [-17, -4],
        [-9, -2],
        [-10, -4],
        [-14, -2],
        [-6, 0],
        [-5, 0],
        [-10, 0],
        [-14, -5],
        [-13, -8],
        [-14, -11],
        [-8, -9],
        [-4, -4],
        [-4, -6],
        [-6, -1],
        [-10, 1],
        [-8, 5],
        [-13, 16],
        [-13, 17],
        [-17, 15],
        [-14, 10],
        [-12, 2],
        [-10, 4],
        [-8, 6],
        [2, 13],
        [8, 10],
        [6, 12],
        [-4, 10],
        [-4, 9],
        [-4, 8],
        [-8, 5],
        [-6, 8],
        [-39, 23],
        [-13, 21],
        [-8, 15],
        [-3, 7],
        [-3, 6],
        [-6, 12],
        [-10, 10],
        [-6, 9],
        [-8, 11],
        [-17, 28],
        [-25, 27],
        [-8, 9],
        [-5, 16],
        [-8, 8],
        [-10, 14],
        [-8, 16],
        [-12, 21],
        [-19, 23],
        [-18, 15],
        [-16, 14],
        [-2, 6],
        [-3, 6],
        [-8, 10],
        [-6, 4],
        [-8, 10],
        [0, 4],
        [-2, 8],
        [-2, 8],
        [-2, 6],
        [-4, 10],
        [0, 4],
        [-8, 10],
        [-2, 7],
        [0, 4],
        [-8, 8],
        [-14, 15],
        [-1, 3],
        [-4, 10],
        [-7, 9],
        [-13, 0],
        [-9, 2],
        [-6, 2],
        [-8, 3],
        [-11, 6],
        [-14, 9],
        [-12, 17],
        [-23, 31],
        [-21, 24],
        [-27, 52],
        [-9, 18],
        [-11, 8],
        [-22, 10],
        [-7, 4],
        [-8, 2],
        [-2, 2],
        [-4, 5],
        [-4, 4],
        [-2, 3],
        [-6, 2],
        [-5, 1],
        [-3, 2],
        [-5, 2],
        [-4, 11],
        [-6, 29],
        [1, 23],
        [-3, 23],
        [-9, 10],
        [-30, 28],
        [-24, 24],
        [-3, 4],
        [-4, 6],
        [-12, 21],
        [-7, 12],
        [0, 9],
        [3, 9],
        [0, 12],
        [-2, 9],
        [-6, 2],
        [-10, 1],
        [-15, -2],
        [-44, -1],
        [-2, 0],
        [-25, -1],
        [-22, -2],
        [-8, -2],
        [-18, -4],
        [-21, -2],
        [-1, 0],
        [-8, -4],
        [-10, 2],
        [-5, 2],
        [-6, 1],
        [-14, 1],
        [-7, -2],
        [-25, -4],
        [-10, 2],
        [-8, 7],
        [-8, 6],
        [-2, 1],
        [-7, 1],
        [-10, 2],
        [-12, 2],
        [-11, 2],
        [-7, 0],
        [-12, 3],
        [-13, 2],
        [-16, 8],
        [-10, 8],
        [-17, -2],
        [-17, 4],
        [-23, 8],
        [-20, 4],
        [-23, 6],
        [-26, 2],
        [-14, 2],
        [-14, 2],
        [-13, 7],
        [-15, 10],
        [-9, 8],
        [-7, 6],
        [-28, 17],
        [-9, 7],
        [-18, 17],
        [-15, 15],
        [-5, 7],
        [-3, 3],
        [-11, 7],
        [-10, 10],
        [-12, 10],
        [-10, 12],
        [-10, 11],
        [-13, 10],
        [-18, 8],
        [-18, 0],
        [-13, -6],
        [-4, -2],
        [-8, -6],
        [-14, -5],
        [-2, -1],
        [-16, -5],
        [-10, -2],
        [-4, -1],
        [-16, 4],
        [-24, 10],
        [-17, 11],
        [-18, 9],
        [-17, 5],
        [-24, 1],
        [-13, -1],
        [-12, -3],
        [-20, -1],
        [-28, 7],
        [-10, 7],
        [-32, 25],
        [-7, 8],
        [-7, 5],
        [-16, 19],
        [-8, 12],
        [-22, 26],
        [-24, 34],
        [-46, 58],
        [-5, 18],
        [-4, 29],
        [-12, 35],
        [-6, 24],
        [-12, 37],
        [-17, 54],
        [-10, 17],
        [-5, 6],
        [-7, 8],
        [-13, 10],
        [-8, 18],
        [-12, 35],
        [-18, 24],
        [-34, 16],
        [-49, 35],
        [-18, 7],
        [-20, 11],
        [-16, 19],
        [-5, 7],
        [-15, 16],
        [-18, 18],
        [-32, 38],
        [-9, 6],
        [-24, 20],
        [-24, 15],
        [-30, 16],
        [-35, 9],
        [-35, 11],
        [-18, 6],
        [-19, 6],
        [-22, 10],
        [-26, 15],
        [-4, 3],
        [-15, 12],
        [-11, 6],
        [-3, 2],
        [-12, 13],
        [-4, 9],
        [-6, 8],
        [0, 12],
        [-4, 11],
        [-6, 8],
        [0, 10],
        [-14, 31],
        [-10, 22],
        [-4, 10],
        [-5, 10],
        [-14, 24],
        [-6, 15],
        [-4, 10],
        [0, 9],
        [-1, 9],
        [-3, 16],
        [0, 23],
        [0, 20],
        [-2, 37],
        [-5, 28],
        [-5, 9],
        [0, 11],
        [-2, 9],
        [-9, 9],
        [-20, 32],
        [-19, 40],
        [-4, 9],
        [-3, 40],
        [-3, 23],
        [-5, 5],
        [-4, 4],
        [-6, 9],
        [-8, 9],
        [-6, 23],
        [-7, 25],
        [-2, 5],
        [0, 26],
        [15, 29],
        [18, 26],
        [3, 20],
        [2, 10],
        [-1, 37],
        [-10, 42],
        [-8, 11],
        [-16, 23],
        [-20, 18],
        [-1, 2],
        [-24, 2],
        [-8, -6],
        [-4, -6],
        [-15, -13],
        [-12, -4],
        [-34, -9],
        [-26, -15],
        [-8, -3],
        [-8, -3],
        [-44, -31],
        [-11, -19],
        [-19, -16],
        [-33, -12],
        [-28, -4],
        [-14, -12],
        [-10, -18],
        [-5, -14],
        [-10, -17],
        [-14, -10],
        [-24, -6],
        [-6, 1],
        [-22, 5],
        [-8, 8],
        [-14, 14],
        [-5, 11],
        [-3, 10],
        [0, 36],
        [4, 16],
        [7, 34],
        [-19, 59],
        [0, 42],
        [2, 58],
        [-2, 52],
        [-13, 34],
        [-3, 4],
        [-2, 3],
        [-6, 8],
        [0, 2],
        [-2, 24],
        [-4, 23],
        [-2, 42],
        [-8, 26],
        [-4, 8],
        [-15, 8],
        [-38, 22],
        [-46, 33],
        [-8, 5],
        [-11, 8],
        [-16, 14],
        [-31, 7],
        [-30, 2],
        [-41, 2],
        [-64, 2],
        [-32, 12],
        [-26, -2],
        [-28, -6],
        [-10, 4],
        [-9, 2],
        [-23, 10],
        [-26, -14],
        [-26, -6],
        [-14, -4],
        [-10, -3],
        [-18, -8],
        [-14, -2],
        [-15, -1],
        [-24, -6],
        [-13, -3],
        [-5, -2],
        [-18, -4],
        [-16, -3],
        [-5, -1],
        [-32, -11],
        [-41, -11],
        [-42, -6],
        [-26, 1],
        [-15, -3],
        [-4, 0],
        [-22, -3],
        [-23, 5],
        [-17, 5],
        [-9, 3],
        [-24, 13],
        [-5, 3],
        [-18, 9],
        [-17, 18],
        [-8, 8],
        [-8, 0],
        [-5, 0],
        [-7, -2],
        [-6, -2],
        [-7, -3],
        [-7, -1],
        [-8, -1],
        [-12, 7],
        [-28, 18],
        [-25, 20],
        [-27, 24],
        [-36, 36],
        [-25, 31],
        [-25, 15],
        [-25, 13],
        [-4, 3],
        [-23, 13],
        [-18, 15],
        [-4, 3],
        [-4, 4],
        [-12, 7],
        [-23, 11],
        [-17, 18],
        [-15, 20],
        [-19, 18],
        [-18, 12],
        [-33, 18],
        [-18, 16],
        [-26, 24],
        [-24, 34],
        [-8, 29],
        [-6, 33],
        [-2, 8],
        [-9, 17],
        [-4, 8],
        [-38, 58],
        [-17, 39],
        [-4, 16],
        [-5, 13],
        [0, 20],
        [11, 36],
        [4, 29],
        [-4, 28],
        [-13, 25],
        [-12, 16],
        [-13, 10],
        [-33, 8],
        [-20, 3],
        [-18, 0],
        [-16, -3],
        [-11, -3],
        [-26, -3],
        [-23, -2],
        [-15, 3],
        [-13, 14],
        [-6, 19],
        [6, 25],
        [1, 3],
        [1, 4],
        [4, 9],
        [2, 2],
        [12, 24],
        [0, 18],
        [0, 2],
        [0, 8],
        [-1, 12],
        [-3, 6],
        [-5, 12],
        [-5, 22],
        [-3, 26],
        [-1, 18],
        [4, 17],
        [-5, 20],
        [-12, 22],
        [-11, 17],
        [-12, 12],
        [-6, 4],
        [-4, 10],
        [-8, 18],
        [-11, 24],
        [-8, 22],
        [-14, 17],
        [-17, 20],
        [-26, -3],
        [-33, -15],
        [-17, -16],
        [-9, -4],
        [-8, -2],
        [-28, -5],
        [-6, -2],
        [-10, 3],
        [-2, 0],
        [-15, 5],
        [-6, 3],
        [-3, 3],
        [-5, 3],
        [-12, 2],
        [-13, 0],
        [-20, -6],
        [-26, -8],
        [-9, -4],
        [-4, -2],
        [-2, -2],
        [-4, -4],
        [-5, -2],
        [-6, 0],
        [-10, 4],
        [-6, 5],
        [-7, 10],
        [-4, 11],
        [0, 8],
        [11, 8],
        [0, 13],
        [-7, 19],
        [-3, 25],
        [-7, 34],
        [-6, 17],
        [-16, 18],
        [-18, 22],
        [-5, 17],
        [1, 9],
        [0, 6],
        [4, 9],
        [6, 16],
        [34, 76],
        [-1, 26],
        [-1, 18],
        [12, 10],
        [9, 30],
        [3, 22],
        [2, 17],
        [-4, 51],
        [-4, 44],
        [-6, 36],
        [-7, 17],
        [-9, 16],
        [-12, 18],
        [-6, 11],
        [-2, 7],
        [-4, 4],
        [-4, 10],
        [-10, 11],
        [-2, 11],
        [-2, 9],
        [-1, 5],
        [-6, 8],
        [-4, 7],
        [-2, 2],
        [-8, 12],
        [-4, 6],
        [-2, 8],
        [0, 2],
        [0, 4],
        [0, 6],
        [7, 10],
        [-1, 20],
        [4, 10],
        [4, 15],
        [12, 19],
        [21, 13],
        [14, 17],
        [4, 6],
        [4, 18],
        [0, 19],
        [0, 18],
        [-6, 14],
        [-6, 9],
        [-17, 12],
        [-24, 7],
        [-34, 4],
        [-21, 6],
        [-12, 9],
        [-8, 6],
        [-6, 7],
        [0, 16],
        [3, 13],
        [2, 6],
        [3, 28],
        [-8, 34],
        [8, 29],
        [-22, 32],
        [-18, 38],
        [-6, 10],
        [-15, 26],
        [-17, 30],
        [-7, 8],
        [-17, 23],
        [-16, 3],
        [-14, 1],
        [-14, 3],
        [-23, 5],
        [-18, 12],
        [-15, 18],
        [0, 20],
        [11, 9],
        [7, 7],
        [25, 18],
        [12, 9],
        [17, 26],
        [10, 24],
        [22, 31],
        [8, 24],
        [0, 27],
        [-1, 18],
        [-1, 20],
        [-3, 15],
        [-4, 20],
        [-3, 29],
        [-2, 39],
        [-4, 10],
        [-2, 7],
        [-12, 12],
        [-10, 13],
        [-5, 6],
        [-12, 16],
        [-28, 29],
        [-25, 25],
        [-21, 11],
        [-18, -7],
        [-17, -6],
        [-14, -7],
        [-19, 3],
        [-12, 4],
        [-20, 8],
        [-17, 15],
        [-7, 6],
        [-24, 16],
        [-5, 9],
        [-7, 11],
        [-13, 24],
        [-6, 10],
        [-10, 11],
        [-8, 10],
        [-6, 17],
        [0, 17],
        [2, 13],
        [4, 32],
        [0, 10],
        [-2, 10],
        [-4, 15],
        [-4, 18],
        [-4, 18],
        [-8, 18],
        [-11, 19],
        [-15, 15],
        [-5, 4],
        [-11, 10],
        [-4, 2],
        [-14, 10],
        [-12, 6],
        [0, 0],
        [-12, 7],
        [-12, 12],
        [-8, 20],
        [-2, 16],
        [-5, 16],
        [-4, 4],
        [-4, 4],
        [-13, 4],
        [-8, 2],
        [-25, 8],
        [-8, 18],
        [0, 19],
        [8, 17],
        [6, 24],
        [0, 23],
        [8, 27],
        [19, 34],
        [29, 35],
        [7, 21],
        [6, 22],
        [28, 42],
        [2, 17],
        [-2, 17],
        [-4, 14],
        [-16, 12],
        [-11, 9],
        [-12, 14],
        [-1, 14],
        [3, 16],
        [2, 16],
        [9, 32],
        [20, 40],
        [49, 59],
        [8, 10],
        [2, 2],
        [6, 14],
        [0, 13],
        [-1, 4],
        [-2, 7],
        [-1, 11],
        [-2, 7],
        [6, 14],
        [13, 12],
        [22, 28],
        [2, 8],
        [2, 12],
        [-4, 18],
        [-2, 22],
        [-6, 28],
        [-6, 16],
        [-4, 13],
        [-7, 38],
        [-2, 28],
        [-6, 16],
        [-6, 20],
        [-2, 7],
        [-6, 16],
        [1, 24],
        [9, 32],
        [5, 20],
        [3, 14],
        [7, 27],
        [-2, 0],
        [-2211, 193],
        [-843, -66],
        [-63, -5],
        [-142, -12],
        [2, 28],
        [101, 2373],
        [2, 42],
        [-8, 16],
        [-7, 10],
        [-9, 17],
        [-8, 11],
        [-2, 1],
        [-2, 8],
        [0, 12],
        [0, 8],
        [-26, 1564],
        [2, 14],
        [16, 14],
        [23, 7],
        [16, 20],
        [-7, 42],
        [-17, 31],
        [-40, 18],
        [-43, 29],
        [-7, 16],
        [-8, 15],
        [2, 30],
        [18, 16],
        [2, 18],
        [-3, 35],
        [-26, 12],
        [8, 24],
        [5, 3],
        [18, 13],
        [-2, 18],
        [0, 15],
        [-23, 25],
        [-20, 8],
        [-18, 12],
        [-6, 24],
        [-4, 28],
        [4, 10],
        [4, 9],
        [10, 12],
        [6, 16],
        [4, 14],
        [-2, 10],
        [-2, 9],
        [-10, 20],
        [-2, 15],
        [0, 19],
        [-10, 7],
        [-7, 5],
        [-2, 13],
        [-8, 6],
        [-2, 1],
        [-5, 2],
        [0, 5],
        [0, 4],
        [9, 5],
        [4, 3],
        [4, 1],
        [11, 1],
        [24, 3],
        [16, 8],
        [3, 7],
        [3, 6],
        [0, 22],
        [-16, 18],
        [-6, 14],
        [-31, 38],
        [-38, 16],
        [-5, 18],
        [0, 1],
        [16, 22],
        [25, 12],
        [25, 8],
        [10, 26],
        [-18, 18],
        [-17, 13],
        [1, 12],
        [3, 16],
        [2, 13],
        [4, 15],
        [-14, 34],
        [-4, 6],
        [-4, 22],
        [6, 25],
        [19, 15],
        [24, 16],
        [8, 14],
        [-6, 17],
        [-18, 16],
        [-18, 24],
        [-3, 26],
        [-43, 24],
        [-38, 8],
        [-38, 12],
        [-36, 20],
        [-4, 13],
        [-7, 22],
        [5, 22],
        [5, 20],
        [19, 40],
        [-5, 30],
        [-13, 45],
        [-4, 35],
        [-10, 24],
        [-14, 5],
        [-14, 6],
        [-17, 25],
        [-4, 13],
        [-19, 1],
        [-19, 1],
        [-10, 2],
        [-2, 0],
        [-10, 12],
        [-16, 2],
        [-20, -8],
        [-20, 16],
        [-16, 0],
        [-19, 8],
        [-17, 6],
        [-21, 23],
        [-2, 33],
        [-6, 23],
        [-19, 15],
        [-14, 33],
        [8, 16],
        [16, 18],
        [21, 23],
        [27, 20],
        [14, 17],
        [-10, 23],
        [-25, 13],
        [-25, 16],
        [-6, 21],
        [-16, 26],
        [-23, 26],
        [-34, 37],
        [-22, 44],
        [-11, 15],
        [-16, 13],
        [-9, 19],
        [-4, 21],
        [-10, 15],
        [-13, 2],
        [-14, 22],
        [-8, 26],
        [-12, 30],
        [-9, 29],
        [0, 2],
        [-6, 39],
        [6, 19],
        [4, 14],
        [-1, 32],
        [-3, 33],
        [0, 2],
        [-14, 38],
        [-26, 23],
        [-15, 22],
        [-19, 16],
        [-4, 24],
        [19, 33],
        [6, 26],
        [0, 36],
        [-6, 36],
        [-35, 42],
        [-33, 32],
        [-31, 22],
        [-11, 30],
        [-16, 29],
        [-22, 26],
        [-30, -15],
        [-36, -38],
        [-38, -28],
        [-14, -2],
        [-16, 10],
        [-23, -4],
        [-20, -14],
        [-18, -17],
        [-25, -23],
        [-36, -3],
        [-17, -35],
        [-24, -26],
        [-24, -27],
        [-20, -14],
        [-26, -21],
        [-29, -11],
        [-23, -2],
        [-24, -6],
        [-35, -16],
        [-52, -22],
        [-39, -29],
        [-35, -19],
        [-30, -14],
        [-19, -20],
        [-23, -16],
        [-43, -10],
        [-55, -12],
        [-57, -16],
        [-48, -17],
        [-29, -11],
        [-20, -4],
        [-24, -10],
        [-24, -8],
        [-60, 28],
        [-45, 27],
        [-47, 0],
        [-26, -9],
        [-43, -6],
        [-26, 1],
        [-23, -13],
        [-32, -28],
        [-32, -6],
        [-37, 2],
        [-26, -6],
        [-39, -11],
        [-27, -12],
        [-27, -14],
        [-27, -9],
        [-25, -9],
        [-26, -12],
        [-74, -4],
        [-33, -1],
        [-52, -13],
        [-51, -6],
        [-56, -26],
        [-31, -10],
        [-16, 6],
        [-28, -16],
        [-21, -20],
        [-29, -18],
        [-24, -2],
        [-16, 10],
        [-21, 0],
        [-25, -10],
        [-25, -4],
        [-34, -1],
        [-40, 7],
        [-19, 32],
        [-25, 30],
        [-18, 6],
        [-40, -2],
        [-39, -14],
        [-12, -24],
        [-27, -29],
        [-24, -5],
        [-11, -2],
        [-27, -9],
        [-33, -8],
        [-27, 10],
        [-19, 23],
        [-10, 26],
        [-14, 20],
        [-24, 24],
        [-14, 14],
        [-34, 13],
        [-38, -3],
        [-45, -8],
        [-29, -4],
        [-61, -10],
        [-17, -2],
        [-24, -14],
        [-40, 0],
        [-22, 35],
        [-42, 98],
        [-22, 62],
        [-8, 45],
        [-2, 48],
        [-8, 46],
        [-14, 30],
        [-17, 21],
        [-33, 21],
        [-45, 48],
        [-3, 43],
        [17, 29],
        [28, 34],
        [8, 33],
        [-45, 54],
        [-9, 55],
        [-11, 43],
        [-32, 106],
        [-27, 22],
        [-26, -16],
        [-11, -24],
        [-20, -28],
        [-48, -36],
        [-23, -18],
        [-39, -6],
        [-45, -10],
        [-2, -10],
        [0, -36],
        [-5, -58],
        [-15, -48],
        [-46, -63],
        [-51, -51],
        [0, -21],
        [4, -49],
        [-8, -28],
        [-42, -18],
        [-35, -29],
        [-42, -28],
        [-10, -25],
        [-27, -45],
        [-28, -27],
        [-37, -13],
        [-33, -6],
        [-27, -5],
        [-44, -6],
        [-22, -2],
        [-58, 6],
        [-34, -6],
        [-66, -14],
        [-49, 14],
        [-40, 4],
        [-32, -10],
        [-45, -28],
        [-60, 10],
        [-76, 51],
        [-51, 30],
        [-76, 43],
        [-31, 72],
        [-18, 18],
        [-48, 15],
        [-68, 46],
        [-81, 36],
        [-89, 48],
        [-84, 2],
        [-37, 22],
        [-58, 30],
        [-39, 40],
        [-37, 18],
        [-17, 5],
        [-34, -6],
        [-33, -2],
        [-35, -5],
        [-45, 10],
        [-45, 24],
        [-57, 23],
        [-59, 15],
        [-71, 31],
        [-57, 34],
        [-28, 35],
        [-42, 31],
        [-58, 30],
        [-34, 12],
        [-20, 30],
        [-24, 8],
        [-12, 19],
        [-17, 17],
        [-18, 2],
        [-15, 17],
        [-26, 48],
        [-23, 79],
        [-45, 94],
        [-18, 79],
        [-10, 34],
        [0, 41],
        [-16, 35],
        [-18, 29],
        [-20, 20],
        [-24, 20],
        [-28, 14],
        [-26, 26],
        [-18, 9],
        [-15, 31],
        [-4, 23],
        [-16, 36],
        [-1, 24],
        [-7, 15],
        [-24, 19],
        [-2, 18],
        [-4, 24],
        [-14, 19],
        [-14, 17],
        [-14, -2],
        [-23, 22],
        [-20, -9],
        [-32, -1],
        [-17, 20],
        [-32, 24],
        [-29, 20],
        [-25, -2],
        [-42, -2],
        [-32, -14],
        [-14, 2],
        [-12, 12],
        [-47, 32],
        [-59, 47],
        [-37, 27],
        [-14, 11],
        [-8, -1],
        [-2, -4],
        [1, -9],
        [-8, 0],
        [-5, 4],
        [-12, 11],
        [-16, 19],
        [-8, 15],
        [-11, 27],
        [-2, 22],
        [9, 21],
        [22, 30],
        [25, 24],
        [18, 17],
        [13, 9],
        [10, 24],
        [6, 37],
        [15, 59],
        [20, 30],
        [53, 28],
        [13, 16],
        [-4, 18],
        [-7, 17],
        [-2, 20],
        [11, 34],
        [8, 46],
        [-8, 8],
        [-13, -6],
        [-20, 0],
        [-13, 12],
        [-10, 24],
        [-4, 17],
        [-7, 5],
        [-14, -1],
        [-41, 7],
        [-18, 6],
        [-6, 5],
        [-19, 30],
        [-26, 50],
        [-7, 15],
        [-2, 16],
        [0, 1],
        [7, 35],
        [2, 33],
        [-5, 42],
        [-6, 27],
        [0, 29],
        [0, 11],
        [2, 8],
        [-2, 9],
        [-14, 11],
        [-11, 15],
        [-10, 16],
        [-10, 16],
        [-19, 18],
        [-26, 23],
        [-22, 11],
        [-15, 5],
        [-12, 0],
        [-10, 1],
        [-6, 6],
        [-2, 10],
        [2, 13],
        [4, 13],
        [8, 13],
        [13, 12],
        [11, 14],
        [9, 18],
        [4, 24],
        [-4, 22],
        [-6, 16],
        [-13, 13],
        [-20, 11],
        [-19, 13],
        [-31, 21],
        [-11, 10],
        [-20, 15],
        [-8, 22],
        [6, 26],
        [19, 16],
        [30, 11],
        [11, 9],
        [10, 12],
        [9, 14],
        [8, 14],
        [8, 14],
        [2, 12],
        [-2, 10],
        [-8, 17],
        [-7, 14],
        [-8, 14],
        [-6, 12],
        [-4, 13],
        [2, 12],
        [3, 17],
        [7, 16],
        [17, 14],
        [10, 11],
        [5, 10],
        [10, 5],
        [8, -2],
        [10, -4],
        [10, -2],
        [8, 7],
        [4, 10],
        [12, 21],
        [10, 35],
        [7, 25],
        [8, 20],
        [11, 25],
        [12, 21],
        [2, 9],
        [0, 9],
        [-5, 22],
        [-3, 34],
        [-6, 32],
        [3, 17],
        [15, 27],
        [10, 15],
        [0, 11],
        [4, 18],
        [2, 31],
        [-12, 32],
        [-8, 22],
        [-11, 64],
        [0, 19],
        [19, 16],
        [15, 28],
        [8, 23],
        [7, 49],
        [-59, 67],
        [-9, 22],
        [-12, 42],
        [-8, 41],
        [0, 23],
        [10, 24],
        [13, 17],
        [8, 7],
        [4, 16],
        [4, 18],
        [6, 34],
        [9, 23],
        [6, 23],
        [0, 19],
        [-8, 20],
        [-29, 47],
        [-25, 61],
        [-5, 14],
        [3, 14],
        [10, 23],
        [13, 29],
        [18, 38],
        [21, 33],
        [15, 19],
        [4, 18],
        [0, 34],
        [-7, 53],
        [0, 29],
        [-10, 29],
        [-6, 30],
        [-2, 18],
        [14, 18],
        [13, 14],
        [22, 16],
        [54, 36],
        [14, 21],
        [10, 17],
        [0, 16],
        [-6, 18],
        [-22, 19],
        [-40, 21],
        [-34, 25],
        [-33, 31],
        [-21, 31],
        [-6, 28],
        [-2, 54],
        [0, 18],
        [-13, 18],
        [-22, 10],
        [-20, 1],
        [-31, 2],
        [-39, 13],
        [-10, 20],
        [10, 26],
        [-13, 44],
        [7, 31],
        [5, 26],
        [6, 12],
        [8, 10],
        [20, 2],
        [25, 16],
        [14, 22],
        [-2, 18],
        [-12, 30],
        [-10, 13],
        [-23, 10],
        [-17, 8],
        [-7, 6],
        [-3, 10],
        [1, 20],
        [-5, 22],
        [-12, 35],
        [-8, 23],
        [-14, 16],
        [-24, 12],
        [-35, 2],
        [-49, 9],
        [-49, 27],
        [-66, 29],
        [-31, 20],
        [-8, 14],
        [-16, 25],
        [-9, 18],
        [-20, 20],
        [-68, 37],
        [-14, 8],
        [-13, 5],
        [-24, 4],
        [-23, 8],
        [-45, 22],
        [-64, 45],
        [-11, 10],
        [-18, 6],
        [-19, -2],
        [-30, -10],
        [-37, -12],
        [-29, -2],
        [-25, -2],
        [-37, -10],
        [-22, 2],
        [-8, 6],
        [-15, 20],
        [-11, 20],
        [-27, 22],
        [-25, 9],
        [-28, 8],
        [-23, -2],
        [-31, -10],
        [-42, -17],
        [-34, -6],
        [-28, 0],
        [-71, 20],
        [-24, 3],
        [-17, 2],
        [-24, -10],
        [-32, 1],
        [-18, 0],
        [-22, -1],
        [-18, -1],
        [-19, 0],
        [-19, 10],
        [-19, 0],
        [-18, 7],
        [-20, 10],
        [-17, 6],
        [-20, 2],
        [-19, 0],
        [-18, -5],
        [-18, -5],
        [-20, 0],
        [-18, -5],
        [-19, 2],
        [-8, 0],
        [-8, -18],
        [-8, -18],
        [-16, -18],
        [-20, -16],
        [-11, -20],
        [0, -18],
        [8, -18],
        [4, -29],
        [-2, -38],
        [13, -26],
        [8, -18],
        [12, -18],
        [18, -15],
        [27, -19],
        [36, -19],
        [4, -20],
        [10, -18],
        [10, -19],
        [9, -30],
        [-1, -27],
        [-12, -19],
        [-4, -18],
        [-4, -2],
        [-10, -24],
        [-24, -18],
        [-20, -33],
        [-4, -24],
        [-16, -8],
        [-7, -27],
        [-56, 14],
        [-19, 3],
        [-77, 0],
        [-18, -3],
        [-19, -4],
        [-20, -10],
        [-12, -18],
        [-8, -21],
        [-27, -14],
        [-10, -10],
        [-18, -8],
        [-28, 0],
        [-19, -13],
        [-26, -19],
        [-18, -17],
        [-15, 5],
        [-23, -16],
        [-8, -38],
        [-8, -44],
        [14, -50],
        [2, -20],
        [2, -17],
        [0, -18],
        [-16, -20],
        [-18, -4],
        [-20, -2],
        [-17, -2],
        [-23, -2],
        [-18, -2],
        [-17, -8],
        [-20, -2],
        [-20, -5],
        [-19, 0],
        [-18, -4],
        [-19, -2],
        [-20, 2],
        [-18, 9],
        [-2, 8],
        [-1, 16],
        [-3, 28],
        [-18, 20],
        [-11, 12],
        [-22, 9],
        [-16, 19],
        [32, 36],
        [32, 19],
        [14, 18],
        [-6, 30],
        [0, 26],
        [-4, 19],
        [-15, 19],
        [-18, 18],
        [-15, 20],
        [-12, 16],
        [-22, 18],
        [-22, 10],
        [-20, 10],
        [-20, 6],
        [-18, 11],
        [-20, 6],
        [-22, 9],
        [-21, -2],
        [-37, 1],
        [-19, 2],
        [-17, -2],
        [-19, 0],
        [-33, -4],
        [-14, -13],
        [-11, -10],
        [-18, -11],
        [-20, -14],
        [-20, 10],
        [-19, -2],
        [-33, 3],
        [-12, 9],
        [-25, 3],
        [-40, -13],
        [-20, 4],
        [-20, 2],
        [-2, 2],
        [-16, 8],
        [-19, 5],
        [-18, 15],
        [-19, 6],
        [-18, 2],
        [-35, 25],
        [-21, -8],
        [-18, -22],
        [-10, -12],
        [-17, -2],
        [-28, 0],
        [-19, 3],
        [-27, -1],
        [-29, 17],
        [-32, 19],
        [-45, 19],
        [-58, 24],
        [-10, 24],
        [-21, 20],
        [-23, 24],
        [-46, 48],
        [-46, 30],
        [-33, 27],
        [-22, 21],
        [-22, 34],
        [-27, 26],
        [-65, 54],
        [-47, -8],
        [-59, -16],
        [-71, 13],
        [-28, 23],
        [-18, 26],
        [-1, 30],
        [9, 29],
        [4, 32],
        [-8, 39],
        [-16, 24],
        [-9, 34],
        [1, 32],
        [10, 17],
        [48, 42],
        [6, 23],
        [-3, 2],
        [-1130, -188],
        [-6, -63],
        [-242, -2627],
        [-6, -64],
        [-6060, -6795],
        [-12, -3],
        [-1682, -437],
        [-1213, 5806],
        [-861, 1017],
        [-2140, 2523],
        [-1008, 1188],
        [246, 1464],
        [389, 367],
        [297, 278],
        [4686, 1520],
        [4730, 1529],
        [75, 24],
        [686, 221],
        [-1252, 543],
        [-8, 37],
        [-38, 58],
        [-10, 8],
        [-9, 7],
        [-8, 11],
        [-5, 7],
        [-15, 3],
        [-24, 2],
        [-8, 5],
        [-17, 29],
        [-11, 14],
        [-12, 17],
        [-2, 49],
        [2, 20],
        [8, 33],
        [9, 36],
        [2, 27],
        [-2, 15],
        [3, 17],
        [9, 13],
        [29, 36],
        [16, 28],
        [12, 107],
        [12, 52],
        [-2, 45],
        [-1, 29],
        [-19, 39],
        [-16, 23],
        [-2, 17],
        [8, 50],
        [14, 149],
        [4, 19],
        [8, 22],
        [12, 26],
        [7, 10],
        [14, 18],
        [52, 62],
        [8, 7],
        [6, 16],
        [7, 20],
        [3, 19],
        [4, 19],
        [12, 36],
        [0, 10],
        [-3, 14],
        [-5, 9],
        [-4, 5],
        [-2, 14],
        [-3, 22],
        [1, 18],
        [0, 15],
        [3, 18],
        [23, 66],
        [11, 48],
        [15, 69],
        [2, 11],
        [0, 15],
        [0, 11],
        [0, 13],
        [-4, 15],
        [-17, 49],
        [-10, 26],
        [-6, 22],
        [-3, 15],
        [-10, 16],
        [-21, 47],
        [-7, 8],
        [-2, 3],
        [-8, 2],
        [-8, 4],
        [-8, 9],
        [-7, 13],
        [-8, 25],
        [-2, 26],
        [3, 51],
        [-1, 29],
        [0, 11],
        [2, 9],
        [4, 17],
        [44, 124],
        [9, 21],
        [10, 17],
        [13, 13],
        [11, 13],
        [20, 32],
        [16, 34],
        [0, 4],
        [-2, 6],
        [0, 6],
        [0, 10],
        [0, 8],
        [8, 19],
        [18, 58],
        [4, 10],
        [11, 14],
        [14, 15],
        [10, 19],
        [4, 22],
        [0, 12],
        [-2, 12],
        [-1, 13],
        [3, 13],
        [11, 21],
        [16, 35],
        [7, 33],
        [0, 30],
        [-6, 14],
        [-14, 14],
        [-6, 15],
        [-4, 19],
        [-4, 23],
        [-6, 17],
        [-19, 26],
        [-32, 35],
        [-31, 27],
        [-12, 3],
        [-10, -1],
        [-12, -1],
        [-23, 2],
        [-10, 6],
        [-14, 13],
        [-8, 14],
        [-15, 45],
        [0, 32],
        [2, 29],
        [-3, 16],
        [0, 26],
        [7, 32],
        [9, 31],
        [6, 18],
        [14, 25],
        [20, 33],
        [10, 11],
        [9, 3],
        [16, 8],
        [6, 12],
        [15, 35],
        [16, 27],
        [4, 7],
        [10, 10],
        [16, 12],
        [12, 14],
        [5, 8],
        [0, 10],
        [3, 10],
        [6, 8],
        [11, 8],
        [20, 4],
        [17, -2],
        [22, -8],
        [31, -6],
        [28, 0],
        [37, 12],
        [36, 28],
        [34, 34],
        [31, 55],
        [22, 36],
        [5, 13],
        [0, 13],
        [-3, 10],
        [-4, 18],
        [-4, 28],
        [0, 17],
        [4, 9],
        [10, 12],
        [1, 12],
        [-1, 15],
        [-8, 10],
        [-18, 9],
        [-36, 14],
        [-32, 13],
        [-31, 2],
        [-51, -3],
        [-59, 6],
        [-45, 6],
        [-23, 7],
        [-16, 13],
        [-17, 25],
        [-15, 60],
        [-4, 47],
        [0, 17],
        [4, 15],
        [12, 11],
        [16, 6],
        [30, 6],
        [31, 11],
        [31, 26],
        [20, 27],
        [22, 25],
        [16, 18],
        [5, 19],
        [4, 29],
        [4, 37],
        [1, 21],
        [-1, 22],
        [-4, 22],
        [-12, 22],
        [-23, 18],
        [-14, 6],
        [-18, 0],
        [-25, 2],
        [-22, 8],
        [-25, 11],
        [-40, 29],
        [-20, 20],
        [-10, 22],
        [-4, 27],
        [2, 22],
        [0, 38],
        [0, 30],
        [-2, 16],
        [-3, 16],
        [-13, 21],
        [-15, 16],
        [-23, 30],
        [-32, 59],
        [-16, 13],
        [-20, 9],
        [-31, 16],
        [-36, 40],
        [-52, 58],
        [-73, 63],
        [-25, 29],
        [-3, 11],
        [-5, 29],
        [-11, 42],
        [-37, 61],
        [-18, 30],
        [-47, 29],
        [-23, 27],
        [-43, 19],
        [-68, 30],
        [-54, 31],
        [-79, 42],
        [-40, 20],
        [-26, 2],
        [-24, 6],
        [-25, 12],
        [-66, 46],
        [-47, 33],
        [-18, 15],
        [-7, 17],
        [-16, 24],
        [-18, 24],
        [-91, 55],
        [-12, 11],
        [-188, 59],
        [-88, 0],
        [-111, -54],
        [-42, -87],
        [-85, -187],
        [-27, -74],
        [-24, -59],
        [-35, -127],
        [-36, -102],
        [-28, -54],
        [-53, -2],
        [-47, 30],
        [-203, 176],
        [-189, 126],
        [-97, 44],
        [-105, 3],
        [-49, -28],
        [-46, -60],
        [-12, -48],
        [-22, -85],
        [-36, -72],
        [-36, -80],
        [-42, -41],
        [-87, -94],
        [-59, -38],
        [-58, -3],
        [-118, 37],
        [-80, 63],
        [-50, 11],
        [-88, -5],
        [-38, 28],
        [-60, 99],
        [-5, 42],
        [-25, 53],
        [-58, 52],
        [-68, 25],
        [-40, -6],
        [-50, 3],
        [-49, 44],
        [-25, 21],
        [-8, 30],
        [-7, 49],
        [-7, 68],
        [-6, 28],
        [2, 33],
        [8, 38],
        [-16, 26],
        [-74, 46],
        [-64, 25],
        [-71, 5],
        [-77, -4],
        [-55, 2],
        [-37, 9],
        [-29, 20],
        [-27, 45],
        [-42, 68],
        [-38, 74],
        [-10, 38],
        [10, 26],
        [-14, 41],
        [-46, 78],
        [-33, 46],
        [-53, 38],
        [-69, 41],
        [-73, 23],
        [-47, -6],
        [-40, 9],
        [-37, 30],
        [-67, 60],
        [-40, 46],
        [-9, 37],
        [-16, 65],
        [-26, 45],
        [-18, 18],
        [-9, 23],
        [2, 52],
        [21, 43],
        [8, 44],
        [5, 50],
        [35, 59],
        [44, 104],
        [7, 58],
        [14, 79],
        [-18, 60],
        [-61, 102],
        [-19, 41],
        [-46, 20],
        [-20, 22],
        [-6, 25],
        [-4, 16],
        [2, 72],
        [-18, 15],
        [-2, 13],
        [-2, 12],
        [18, 39],
        [2, 2],
        [57, 77],
        [34, 26],
        [28, 21],
        [12, 27],
        [18, 33],
        [3, 48],
        [-9, 59],
        [-2, 35],
        [-34, 118],
        [0, 40],
        [22, 141],
        [4, 101],
        [-4, 85],
        [-3, 104],
        [7, 255],
        [-9, 130],
        [-17, 112],
        [4, 76],
        [-68, 43],
        [-10, 31],
        [3, 27],
        [34, 61],
        [35, 1],
        [20, 27],
        [51, 44],
        [15, 109],
        [12, 42],
        [-2, 46],
        [-39, 49],
        [-25, 34],
        [-8, 42],
        [-2, 7],
        [2, 3],
        [20, 36],
        [-1, 63],
        [2, 79],
        [10, 66],
        [-6, 72],
        [-33, 67],
        [-18, 45],
        [-20, 64],
        [-39, 35],
        [-56, 14],
        [-43, 0],
        [-84, -10],
        [-43, 0],
        [-66, 55],
        [-47, 45],
        [-65, 83],
        [-57, 68],
        [-37, 87],
        [-66, 75],
        [-53, 63],
        [-28, 46],
        [-1, 2],
        [-10, 34],
        [-10, 30],
        [-22, 25],
        [-139, 82],
        [-98, 72],
        [-34, 39],
        [-15, 45],
        [-11, 46],
        [-6, 49],
        [2, 33],
        [-6, 41],
        [10, 22],
        [20, 11],
        [55, 0],
        [55, -24],
        [28, -11],
        [11, -25],
        [29, -26],
        [54, 0],
        [49, 28],
        [39, 45],
        [9, 9],
        [0, 52],
        [-9, 45],
        [-3, 16],
        [-18, 36],
        [-39, 55],
        [-16, 32],
        [-45, 82],
        [-48, 46],
        [-56, 45],
        [-30, 31],
        [-43, 53],
        [-16, 62],
        [-32, 96],
        [-39, 49],
        [-65, 72],
        [-63, 71],
        [-50, 61],
        [-37, 50],
        [-21, 60],
        [7, 57],
        [16, 65],
        [14, 72],
        [-31, 32],
        [1, 42],
        [0, 10],
        [21, 22],
        [1, 1],
        [65, 73],
        [0, 25],
        [0, 4],
        [6, 6],
        [46, 40],
        [76, 47],
        [62, 47],
        [46, 48],
        [32, 53],
        [8, 47],
        [-2, 90],
        [-38, 175],
        [-11, 57],
        [9, 72],
        [22, 62],
        [26, 74],
        [41, 59],
        [45, 43],
        [50, 60],
        [35, 26],
        [23, 26],
        [12, 33],
        [8, 60],
        [4, 82],
        [8, 48],
        [19, 28],
        [15, 22],
        [54, 59],
        [66, 70],
        [21, 37],
        [0, 1],
        [14, 24],
        [22, 79],
        [-20, 71],
        [-20, 48],
        [-32, 23],
        [-23, 28],
        [3, 23],
        [1, 10],
        [2, 19],
        [4, 32],
        [9, 31],
        [9, 33],
        [-2, 28],
        [-15, 21],
        [-22, 20],
        [-64, 28],
        [-24, 4],
        [-31, 15],
        [-8, 11],
        [-27, 21],
        [-27, 25],
        [-29, 12],
        [-52, 19],
        [-22, 19],
        [-33, 49],
        [-26, 48],
        [-30, 66],
        [-16, 18],
        [-6, 7],
        [-4, 25],
        [-3, 34],
        [2, 22],
        [-18, 43],
        [-36, 54],
        [-72, 62],
        [-20, 24],
        [-14, 42],
        [-42, 64],
        [-13, 59],
        [-4, 56],
        [7, 36],
        [17, 51],
        [34, 39],
        [33, 55],
        [27, 38],
        [47, 53],
        [65, 64],
        [64, 64],
        [45, 53],
        [-9, 2],
      ],
      [
        [225658, 82454],
        [-8, 0],
        [-22, -8],
        [-43, 43],
        [-40, 188],
        [-28, 18],
        [-49, -1],
        [-54, -15],
        [-112, 88],
        [-48, 53],
        [-55, 64],
        [14, 82],
        [-72, 10],
        [-128, 1],
        [-80, 67],
        [-44, 117],
        [-266, 1361],
        [-527, -140],
        [-289, -76],
        [-803, -190],
        [-475, -112],
        [9, -447],
        [0, -5],
        [9, -443],
        [2, -411],
        [-521, 906],
        [-1898, -459],
        [-515, -2521],
        [-899, 2129],
        [-107, 251],
        [-8, 127],
        [-723, 4383],
        [-364, 1889],
        [623, 2085],
        [39, 739],
        [601, 711],
        [4, 4],
        [2, 86],
        [0, 43],
        [0, 22],
        [-282, 133],
        [-766, 425],
        [7, 300],
        [56, 48],
        [16, 51],
        [23, 56],
        [17, 24],
        [22, 79],
        [27, 58],
        [37, 55],
        [-11, 11],
        [-39, 40],
        [-45, 72],
        [-67, 30],
        [-30, 22],
        [-29, 59],
        [-114, 8],
        [-61, 5],
        [-33, 2],
      ],
      [
        [217511, 94571],
        [-38, 32],
        [-52, 59],
        [-44, 101],
        [-39, 74],
        [7, 72],
        [59, 40],
        [89, 57],
        [31, 23],
        [40, 57],
        [41, 75],
        [22, 74],
        [-9, 156],
        [-44, 68],
        [-42, 66],
        [-42, 74],
        [-23, 67],
        [-30, 47],
        [-30, 42],
        [-23, 40],
        [-19, 45],
        [-30, 28],
        [51, 70],
        [23, 57],
        [6, 78],
        [-12, 108],
        [-23, 63],
        [-29, 76],
        [-47, 71],
        [-40, 63],
        [-35, 57],
        [-13, 65],
        [-15, 71],
        [-6, 60],
        [-12, 38],
        [-11, 40],
        [-444, -217],
        [-775, 1885],
      ],
      [
        [215953, 98453],
        [-4, 8],
        [-575, 1399],
        [214, 2075],
        [255, 2455],
        [132, -60],
        [4100, -1878],
        [118, -68],
        [64, 0],
        [929, -221],
        [153, -5],
        [41, 30],
        [8, 21],
        [0, 21],
        [7, 33],
        [9, 32],
        [18, 24],
        [31, 23],
        [3, 24],
        [-10, 16],
        [-10, 16],
        [-22, 19],
        [-28, 6],
        [-28, -9],
        [-38, 32],
        [-18, 26],
        [-5, 19],
        [-2, 38],
        [9, 10],
        [29, 2],
        [29, 4],
        [35, 8],
        [25, 1],
        [11, 1],
        [8, 17],
        [5, 31],
        [6, 48],
        [-16, 18],
        [-8, 4],
        [-8, 13],
        [4, 16],
        [4, 12],
        [5, 10],
        [-2, 8],
        [-13, 8],
        [-2, 13],
        [0, 10],
        [-2, 11],
        [14, 5],
        [17, 3],
        [12, 14],
        [5, 14],
        [7, 24],
        [15, -19],
        [14, -8],
        [8, -11],
        [11, -5],
        [5, -11],
        [-3, -12],
        [17, 3],
        [18, 16],
        [11, 17],
        [4, 18],
        [-4, 25],
        [1, 20],
        [-3, 18],
        [25, 24],
        [-10, 25],
        [-7, 20],
        [-5, 23],
        [-14, 22],
        [-10, 17],
        [-8, 20],
        [-22, 15],
        [-17, 17],
        [-11, 11],
        [-16, 14],
        [-37, 19],
        [7, 13],
        [23, 17],
        [13, 22],
        [13, 16],
        [12, 22],
        [18, 8],
        [8, 26],
        [19, 17],
        [18, 17],
        [20, 6],
        [28, 28],
        [12, 2],
        [10, -8],
        [6, -8],
        [18, 2],
        [2, 18],
        [10, 13],
        [15, 4],
        [8, 4],
        [11, 6],
        [16, 6],
        [8, 12],
        [5, 19],
        [-11, 12],
        [-7, 11],
        [-3, 13],
        [-3, 14],
        [-10, 9],
        [-7, 10],
        [0, 14],
        [1, 12],
        [2, 8],
        [9, 10],
        [12, 11],
        [15, 13],
        [14, 19],
        [-4, 30],
        [4, 33],
        [10, 43],
        [2, 24],
        [18, 28],
        [-2, 48],
        [12, 33],
        [-11, 35],
        [-17, 42],
        [-12, 11],
        [-17, 10],
        [-6, 38],
        [6, 28],
        [-21, 26],
        [-28, 16],
        [-19, 12],
        [-29, 0],
        [-21, 3],
        [-30, -2],
        [-20, 13],
        [-16, 13],
        [-4, 17],
        [12, 27],
        [-6, 23],
        [-8, 29],
        [-12, 11],
        [-14, 10],
        [-28, 0],
        [-34, -8],
        [-34, -22],
        [-8, 15],
        [-28, 55],
        [-33, 83],
        [-21, 70],
        [-16, 41],
        [14, 45],
        [20, 41],
        [28, 34],
        [-16, 88],
        [39, 100],
        [-29, 47],
        [-16, 40],
        [-85, 130],
        [-144, 171],
        [-245, 102],
        [-187, 157],
        [-64, 57],
        [-164, 179],
        [-77, 181],
        [-81, 271],
        [-1136, 741],
        [-2813, 275],
        [591, 611],
        [6, 5],
        [1687, 1747],
        [4, 94],
        [-19, 120],
        [-18, 16],
        [-45, 49],
        [-60, 47],
        [-94, 131],
        [-43, 115],
        [-7, 155],
        [37, 107],
        [2, 5],
        [19, 83],
        [-2, 19],
        [-60, 74],
        [-93, 58],
        [-97, 28],
        [-56, 11],
        [-22, -17],
        [-33, -2],
        [-39, -24],
        [-33, 6],
        [-44, -2],
        [-38, 10],
        [-45, -8],
        [-50, -34],
        [-14, -17],
        [-14, -35],
        [-16, -8],
        [-18, -5],
        [-17, 2],
        [-16, -1],
        [-32, -3],
        [-23, 8],
        [-24, 17],
        [-25, 4],
        [-26, 10],
        [-25, 5],
        [-25, 6],
        [-16, 11],
        [-24, 8],
        [-20, 8],
        [-31, -4],
        [-24, 0],
        [-18, 4],
        [-17, 8],
        [-12, 14],
        [-4, 20],
        [2, 16],
        [-2, 15],
        [-6, 16],
        [-10, 13],
        [-11, 3],
        [-19, 0],
        [-12, -1],
        [-16, -2],
        [-11, 1],
        [-14, -5],
        [-14, -1],
        [-10, 0],
        [-13, -1],
        [-19, 2],
        [-11, 6],
        [-12, 14],
        [-11, 22],
        [0, 26],
        [4, 28],
        [0, 17],
        [-6, 7],
        [-6, 8],
        [-12, 12],
        [-15, -1],
        [-16, -3],
        [-15, -9],
        [-8, -10],
        [-8, -13],
        [-18, -5],
        [-15, -6],
        [-15, 5],
        [-24, 16],
        [-24, 24],
        [-27, 27],
        [-22, 18],
        [-12, 28],
        [-17, 21],
        [-25, 14],
        [-23, 17],
        [-33, 27],
        [-2, 27],
        [14, 23],
        [9, 14],
        [0, 12],
        [-5, 14],
        [-14, 10],
        [-16, 5],
        [-15, 6],
        [-17, 7],
        [-16, 5],
        [-16, 5],
        [-21, 9],
        [-14, 19],
        [-7, 20],
        [0, 22],
        [4, 21],
        [9, 21],
        [6, 16],
        [6, 14],
        [6, 19],
        [-6, 13],
        [-16, 6],
        [-18, 6],
        [-13, 0],
        [-13, -2],
        [-14, 6],
        [-16, 6],
        [-6, 8],
        [-12, 14],
        [-6, 17],
        [-4, 26],
        [-5, 21],
        [-3, 16],
        [-5, 17],
        [-6, 18],
        [-2, 18],
        [-3, 18],
        [2, 21],
        [-2, 15],
        [-2, 15],
        [-6, 20],
        [-5, 11],
        [-7, 14],
        [-15, 17],
        [-18, 14],
        [-25, 0],
        [-25, 2],
        [-31, -6],
        [-25, -12],
        [-21, -34],
        [-14, -21],
        [-14, -17],
        [-4, -17],
        [-15, -18],
        [-8, -16],
        [-11, -6],
        [-6, -2],
        [-12, 4],
        [-15, 2],
        [-10, 6],
        [-2, 10],
        [-4, 10],
        [-10, 32],
        [6, 23],
        [4, 21],
        [14, 23],
        [4, 18],
        [0, 21],
        [0, 14],
        [-4, 10],
        [-18, 3],
        [-16, 6],
        [-20, -1],
        [-15, -12],
        [-7, -15],
        [0, -15],
        [-10, -19],
        [-8, -21],
        [-10, -43],
        [-6, -36],
        [-4, -27],
        [-12, -22],
        [-21, -12],
        [-20, -4],
        [-19, 6],
        [-23, 10],
        [-17, 28],
        [-4, 39],
        [6, 25],
        [-1, 29],
        [-5, 22],
        [-15, 22],
        [-7, 13],
        [-10, 9],
        [-14, 5],
        [-13, 0],
        [-10, 1],
        [-10, 3],
        [-7, 5],
        [-17, 8],
        [-17, 12],
        [-27, 11],
        [-25, 8],
        [-16, 4],
        [-33, 12],
        [-19, 7],
        [-28, -1],
        [-18, -1],
        [-16, -3],
        [-22, -3],
        [-26, -5],
        [-24, -8],
        [-15, -2],
        [-19, 1],
        [-26, 9],
        [-20, 6],
        [-12, 14],
        [-8, 6],
        [-11, 15],
        [-8, 15],
        [-8, 20],
        [-8, 28],
        [-13, 6],
        [-8, 9],
        [-21, 6],
        [-19, 4],
        [-16, -8],
        [-20, -6],
        [-15, -5],
        [-21, 16],
        [-15, 15],
        [-6, 24],
        [-5, 16],
        [-7, 51],
        [-9, 70],
        [-9, 46],
        [0, 64],
        [17, 22],
        [23, 13],
        [24, 7],
        [11, 7],
        [12, 12],
        [12, 10],
        [-8, 29],
        [-19, 27],
        [-30, 36],
        [-27, 38],
        [-39, 36],
        [-27, 25],
        [-24, 24],
        [-23, 17],
        [-20, 13],
        [-21, 6],
        [-16, 0],
        [-14, -2],
        [-17, -2],
        [-14, -2],
        [-13, -2],
        [-11, 4],
        [-14, 4],
        [-10, 2],
        [-17, 12],
        [-10, 8],
        [-3, 24],
        [-6, 16],
        [-2, 18],
        [0, 15],
        [-4, 20],
        [-5, 23],
        [-9, 29],
        [-10, 21],
        [-6, 20],
        [-4, 20],
        [-4, 23],
        [2, 27],
        [0, 24],
        [-11, 18],
        [-6, 10],
        [-4, 10],
        [-10, 6],
        [-13, 9],
        [-13, 9],
        [-13, 1],
        [-13, -2],
        [-8, -10],
        [-12, -8],
        [-16, -5],
        [-20, -4],
        [-25, 0],
        [-24, 7],
        [-24, 6],
        [-22, 0],
        [-25, 0],
        [-30, 6],
        [-25, 15],
        [-18, 9],
        [-24, 10],
        [-24, 2],
        [-21, 4],
        [-20, 6],
        [-11, 22],
        [-2, 24],
        [0, 32],
        [-9, 33],
        [-19, 18],
        [-36, 27],
        [-46, 39],
        [-67, 72],
        [-30, 44],
        [2, 38],
        [-12, 24],
        [-19, 19],
        [-57, 23],
        [-33, 38],
        [6, 43],
        [-13, 53],
        [-17, 21],
        [-7, 19],
        [-13, 15],
        [-16, 10],
        [-20, 6],
        [-15, -2],
        [-19, -6],
        [-14, -6],
        [-18, -8],
        [-18, -2],
        [-24, 0],
        [-18, -8],
        [-12, -14],
        [-17, -38],
        [-6, -60],
        [-20, -35],
        [-30, -32],
        [-63, -13],
        [-94, 14],
        [-80, 47],
        [-33, 51],
        [-29, 34],
        [-16, 32],
        [-28, 34],
        [-16, 10],
        [-12, 2],
        [-15, -2],
        [-27, -8],
        [-34, -36],
        [-44, -15],
        [-42, 22],
        [-46, 49],
        [-15, 33],
        [-33, 105],
        [-46, 21],
        [-26, 8],
        [-25, 6],
        [-24, -12],
        [-2, -51],
        [-38, -33],
        [-38, -30],
        [-80, -25],
        [-51, 58],
        [-11, 60],
        [-22, 44],
        [-33, 61],
        [-19, 44],
        [4, 22],
        [13, 25],
        [26, 27],
        [12, 31],
        [-9, 34],
        [-12, 35],
        [0, 24],
        [2, 15],
        [14, 13],
        [13, 11],
        [14, 18],
        [10, 13],
        [12, 30],
        [4, 23],
        [0, 32],
        [2, 19],
        [8, 27],
        [9, 20],
        [31, 23],
        [15, 15],
        [12, 10],
        [15, 19],
        [13, 28],
        [-17, 28],
        [-52, -10],
        [-38, -4],
        [-44, -2],
        [-42, 44],
        [-5, 44],
        [-14, 66],
        [2, 46],
        [-8, 46],
        [-20, -4],
        [-25, 7],
        [-23, 4],
        [-24, 25],
        [-23, 25],
        [-23, 35],
        [11, 14],
        [8, 6],
        [19, 5],
        [26, 14],
        [7, 19],
        [23, 94],
        [-14, 91],
        [-7, 15],
        [-9, 15],
        [-10, 20],
        [-26, 41],
        [-24, 32],
        [-30, 55],
        [-2, 20],
        [-17, 7],
        [-28, 6],
        [-27, 1],
        [-21, 3],
        [-17, 4],
        [-18, 3],
        [-45, 23],
        [-43, 19],
        [-12, 8],
        [-17, 34],
        [-16, 65],
        [-22, 104],
        [-24, 104],
        [1, 49],
        [17, 40],
        [23, 13],
        [34, 17],
        [58, 11],
        [38, 4],
        [30, 58],
        [18, 43],
        [16, 42],
        [28, 16],
        [35, -2],
        [39, -26],
        [42, -10],
        [47, -2],
        [19, 34],
        [-5, 35],
        [0, 44],
        [8, 33],
        [7, 37],
        [-10, 27],
        [-52, 40],
        [-8, 34],
        [0, 25],
        [6, 34],
        [6, 29],
        [20, 14],
        [-26, 38],
        [-14, 14],
        [-30, 26],
        [-21, 20],
        [-4, 24],
        [10, 22],
        [13, 23],
        [23, 16],
        [29, 40],
        [23, 39],
        [19, 50],
        [12, 25],
        [-18, 27],
        [-6, 14],
        [-11, 8],
        [-21, 19],
        [-29, 21],
        [-5, 24],
        [6, 19],
        [12, 14],
        [22, 14],
        [39, 4],
        [30, 8],
        [26, 38],
        [12, 16],
        [17, 23],
        [22, 1],
        [23, 1],
        [20, -9],
        [35, -17],
        [43, -13],
        [48, -14],
        [38, 61],
        [12, 44],
        [13, 20],
        [30, 14],
        [22, 26],
        [4, 10],
        [2, 20],
        [6, 34],
        [6, 22],
        [9, 30],
        [-12, 30],
        [-21, 21],
        [-26, 30],
        [-6, 16],
        [0, 16],
        [8, 26],
        [-4, 30],
        [-18, 30],
        [-17, 44],
        [-10, 47],
        [7, 26],
        [14, 15],
        [30, 6],
        [48, 8],
        [32, 16],
        [10, 13],
        [-1, 21],
        [-15, 19],
        [-10, 17],
        [3, 27],
        [18, 28],
        [21, 26],
        [40, 12],
        [56, 10],
        [63, 8],
        [56, 22],
        [17, 23],
        [-15, 23],
        [-26, 0],
        [-2, 1],
        [-6, 15],
        [-5, 10],
        [-1, 6],
        [-1, 11],
        [-1, 10],
        [0, 4],
        [-2, 24],
        [-13, 24],
        [-2, 4],
        [-27, 66],
        [0, 22],
        [2, 14],
        [24, 13],
        [19, 26],
        [13, 37],
        [24, 32],
        [42, 34],
        [-8, 31],
        [-6, 19],
        [-22, 30],
        [-12, 14],
        [8, 19],
        [13, 16],
        [11, 20],
        [-11, 49],
        [2, 106],
        [-6, 94],
        [-9, 30],
        [-33, 26],
        [-38, 15],
        [-65, -12],
        [-87, -21],
        [-47, 4],
        [-50, 14],
        [-49, -16],
        [-58, -5],
        [-25, 11],
        [-26, 15],
        [-23, 25],
        [-14, 14],
        [-13, 12],
        [-10, 0],
        [-10, 5],
        [-8, 4],
        [-6, 1],
        [-7, 5],
        [-9, 6],
        [-10, 5],
        [-9, 8],
        [-12, 7],
        [-9, 8],
        [-6, 10],
        [-4, 14],
        [-5, 18],
        [0, 20],
        [5, 22],
        [2, 23],
        [2, 25],
        [-21, 6],
        [-15, 7],
        [-33, 2],
        [-19, -3],
        [-9, 13],
        [-14, 6],
        [-14, 6],
        [0, 8],
        [-2, 20],
        [-6, 15],
        [-10, 8],
        [-9, 11],
        [-30, 18],
        [-34, 14],
        [-17, 2],
        [-23, 6],
        [-6, 8],
        [-6, 19],
        [0, 19],
        [2, 26],
        [10, 23],
        [14, 15],
        [15, 11],
        [9, 16],
        [4, 21],
        [14, 18],
        [8, 28],
        [-1, 27],
        [-11, 21],
        [-12, 25],
        [-10, 17],
        [-2, 17],
        [-11, 12],
        [7, 20],
        [16, 14],
        [36, 21],
        [16, 4],
        [18, 4],
        [6, 8],
        [5, 21],
        [8, 16],
        [4, 15],
        [16, 4],
        [8, 15],
        [4, 11],
        [6, 26],
        [1, 25],
        [-4, 22],
        [-23, 21],
        [-23, 20],
        [-37, 6],
        [-23, 8],
        [-24, -2],
        [-9, 2],
        [-15, 8],
        [-15, 14],
        [-10, 11],
        [-1, 27],
        [6, 24],
        [12, 17],
        [13, 15],
        [8, 20],
        [-7, 19],
        [-16, 14],
        [-16, 20],
        [0, 14],
        [10, 25],
        [14, 13],
        [4, 31],
        [11, 43],
        [6, 25],
        [3, 23],
        [8, 19],
        [-4, 18],
        [-9, 19],
        [-18, 10],
        [-14, 6],
        [-3, 21],
        [2, 30],
        [2, 33],
        [2, 29],
        [15, 16],
        [19, 4],
        [12, 14],
        [21, 4],
        [24, 0],
        [13, 6],
        [7, 10],
        [7, 6],
        [6, 8],
        [-1, 16],
        [-12, 10],
        [-16, 4],
        [-16, 6],
        [-9, 10],
        [-18, 12],
        [-22, 10],
        [-16, 7],
        [-13, 15],
        [1, 9],
        [2, 12],
        [28, 10],
        [12, 6],
        [10, 6],
        [8, 8],
        [-2, 42],
        [-6, 56],
        [2, 46],
        [2, 39],
        [-12, 23],
        [-33, 24],
        [-26, 14],
        [-8, 31],
        [25, 14],
        [23, 19],
        [17, 18],
        [10, 15],
        [0, 20],
        [-6, 24],
        [0, 18],
        [-24, 12],
        [-20, 14],
        [-22, 6],
        [-21, 2],
        [-16, -2],
        [-12, 7],
        [-8, 6],
        [-12, 12],
        [-10, 7],
        [-11, 8],
        [-11, 6],
        [-9, 14],
        [-9, 14],
        [-21, 19],
        [-7, 26],
        [10, 36],
        [10, 24],
        [15, 11],
        [1, 25],
        [-7, 26],
        [-8, 22],
        [-18, 17],
        [-20, 10],
        [-16, 9],
        [-11, 19],
        [-4, 23],
        [-3, 33],
        [1, 34],
        [0, 24],
        [-17, 9],
        [-23, 18],
        [-21, 20],
        [-10, 22],
        [-10, 23],
        [-18, 6],
        [-22, 8],
        [-16, 13],
        [-3, 13],
        [-2, 35],
        [-5, 12],
        [-7, 11],
        [-22, 4],
        [-16, 0],
        [-15, 2],
        [-10, 9],
        [3, 15],
        [6, 14],
        [7, 22],
        [4, 13],
        [4, 16],
        [-3, 12],
        [-8, 9],
        [-3, 17],
        [-7, 13],
        [-10, 9],
        [-11, 8],
        [-5, 14],
        [-2, 18],
        [-14, 26],
        [0, 17],
        [-6, 16],
        [-8, 13],
        [-11, 17],
        [-2, 24],
        [-21, 18],
        [-13, 2],
        [-10, 0],
        [-12, -4],
        [-14, 2],
        [-20, -3],
        [-17, -2],
        [-15, -2],
        [-7, 3],
        [-36, 30],
        [-51, 63],
        [-4, 16],
        [-8, 14],
        [-13, 13],
        [-12, 11],
        [-17, 9],
        [-23, 8],
        [-19, 16],
        [-24, 6],
        [-22, -1],
        [-14, 3],
        [-8, 12],
        [-4, 18],
        [7, 23],
        [1, 29],
        [1, 20],
        [-11, 13],
        [-19, 16],
        [-12, 28],
        [-2, 37],
        [-11, 30],
        [-19, 33],
        [-22, 42],
        [-17, 48],
        [-35, 90],
        [-16, 36],
        [-9, 24],
        [-5, 21],
        [-2, 24],
        [1, 28],
        [-4, 23],
        [-16, 13],
        [-20, 2],
        [-18, 3],
        [-18, 3],
        [-12, 6],
        [-14, 7],
        [-13, 13],
        [-14, 15],
        [-7, 22],
        [-12, 28],
        [-8, 29],
        [0, 23],
        [0, 23],
        [-13, 1],
        [-19, 0],
        [-21, -4],
        [-21, -3],
        [-11, 5],
        [-2, 11],
        [2, 12],
        [1, 18],
        [-2, 18],
        [-5, 17],
        [-20, 4],
        [-7, 6],
        [-4, 9],
        [-8, 8],
        [-20, 10],
        [-5, 14],
        [-4, 14],
        [-3, 21],
        [-12, 22],
        [-5, 28],
        [0, 27],
        [-13, 12],
        [-17, 4],
        [-15, 7],
        [-25, 2],
        [-13, 4],
        [-19, -2],
        [-9, -4],
        [-10, 12],
        [-11, 18],
        [-6, 23],
        [4, 24],
        [14, 26],
        [16, 15],
        [6, 24],
        [6, 23],
        [14, 19],
        [9, 18],
        [-5, 20],
        [-12, 21],
        [-10, 19],
        [-8, 26],
        [4, 32],
        [12, 20],
        [26, 34],
        [21, 17],
        [14, 13],
        [4, 16],
        [-1, 23],
        [-13, 17],
        [-14, 15],
        [-24, 6],
        [-38, 12],
        [-39, 10],
        [-27, 12],
        [-41, 26],
        [-43, 30],
        [-45, 39],
        [-53, 71],
        [-15, 34],
        [-22, 31],
        [-28, 17],
        [-24, 11],
        [-17, 27],
        [-1, 40],
        [1, 38],
        [0, 53],
        [4, 26],
        [-8, 23],
        [-20, 31],
        [-9, 12],
        [-12, 19],
        [-7, 22],
        [2, 32],
        [4, 26],
        [-6, 27],
        [-24, 16],
        [-30, 13],
        [-19, 15],
        [-13, 28],
        [4, 28],
        [16, 28],
        [20, 23],
        [14, 25],
        [5, 24],
        [0, 32],
        [-12, 33],
        [-15, 33],
        [-21, 42],
        [-19, 35],
        [-1, 36],
        [-1, 51],
        [-27, 33],
        [-20, 22],
        [-16, 22],
        [-14, 19],
        [-14, 28],
        [-22, 20],
        [-17, 7],
        [-23, 14],
        [-51, 40],
        [-32, 13],
        [-24, 6],
        [-19, 12],
        [-31, 36],
        [-75, 112],
        [-87, 121],
        [-10, 8],
        [-12, 34],
        [-17, 85],
        [27, 127],
        [-7, 54],
        [13, 61],
        [19, 64],
        [-25, 49],
        [-7, 66],
        [26, 70],
        [-1491, -40],
        [-120, -4],
        [-84, 1962],
        [-44, 288],
        [0, 15],
        [-10, 21],
        [0, 19],
        [7, 19],
        [-7, 33],
        [-5, 17],
        [12, 35],
        [-11, 15],
        [-1, 18],
        [-12, 15],
        [-16, 31],
        [-5, 33],
        [1, 46],
        [8, 15],
        [-2, 21],
        [0, 33],
        [-6, 17],
        [-14, 14],
        [0, 12],
        [0, 22],
        [9, 16],
        [-9, 9],
        [-8, 11],
        [-12, 10],
        [-4, 9],
        [-12, 13],
        [-9, 20],
        [-1, 32],
        [-4, 10],
        [0, 19],
        [2, 23],
        [6, 17],
        [0, 3],
        [-2, 17],
        [-5, 2],
        [-1, 22],
        [2, 16],
        [-19, 4],
        [-6, 20],
        [-12, -2],
        [0, 20],
        [-1, 18],
        [9, 27],
        [-10, 28],
        [-16, 22],
        [-8, 32],
        [-2, 13],
        [11, 21],
        [6, 22],
        [5, 39],
        [-6, 22],
        [-4, 21],
        [6, 30],
        [-17, 16],
        [-18, 10],
        [-20, 6],
        [-12, 15],
        [-1, 21],
        [10, 26],
        [-23, 38],
        [-31, 28],
        [-28, 23],
        [-22, 26],
        [-24, 2],
        [-28, 8],
        [-34, 18],
        [-35, -8],
        [-39, 14],
        [-32, 2],
        [-35, 2],
        [-30, 16],
        [-14, 14],
        [-9, 5],
        [-10, 14],
        [-11, 16],
        [-15, 19],
        [-10, 15],
        [-6, 18],
        [-16, 16],
        [-4, 16],
        [-13, 18],
        [-18, 7],
        [-17, -2],
        [-19, -6],
        [-25, 1],
        [-27, 17],
        [-20, 22],
        [-23, 24],
        [-12, 25],
        [-6, 30],
        [-17, 10],
        [-25, 7],
        [-28, 3],
        [-18, 18],
        [14, 22],
        [-13, 23],
        [-5, 21],
        [-6, 19],
        [-24, 26],
        [-24, 18],
        [-4, 17],
        [-25, 28],
        [-22, 38],
        [-16, 27],
        [-6, 17],
        [2, 33],
        [-10, 37],
        [0, 31],
        [8, 26],
        [15, 13],
        [11, 35],
        [-8, 4],
        [-38, 25],
        [-12, 34],
        [-15, 14],
        [-42, 18],
        [-11, 18],
        [-20, 26],
        [-24, 30],
        [-27, 12],
        [-28, 17],
        [-1603, 1483],
        [-2107, 1948],
      ],
      [
        [203548, 133112],
        [-129, 226],
        [-368, 1954],
        [-446, 3422],
        [-215, 1644],
        [-1048, 1090],
        [-1094, 965],
        [1579, 691],
        [424, 21],
        [-561, 686],
        [361, 958],
        [951, 374],
        [1151, 451],
        [-576, 733],
      ],
      [
        [203577, 146327],
        [18, 4],
        [16, 5],
        [27, 6],
        [26, 5],
        [1, -12],
        [46, 16],
        [29, 10],
        [-5, 28],
        [33, 18],
        [43, 30],
        [28, 22],
        [31, 17],
        [24, 12],
        [54, -9],
        [72, -1],
        [48, -1],
        [36, -11],
        [35, -27],
        [26, -30],
        [27, -19],
        [23, -33],
        [11, -43],
        [4, -32],
        [26, -26],
        [39, -17],
        [31, -12],
        [35, -14],
        [70, -23],
        [54, 11],
        [34, 38],
        [33, 7],
        [40, -15],
        [100, -101],
        [57, -66],
        [53, -54],
        [47, -51],
        [28, -30],
        [9, -31],
        [10, -33],
        [42, -16],
        [58, 2],
        [64, 8],
        [42, 6],
        [74, 4],
        [58, 11],
        [58, 2],
        [-4, 26],
        [36, 8],
        [60, -7],
        [36, 9],
        [40, -27],
        [33, -34],
        [35, -31],
        [28, -11],
        [59, -32],
        [16, 29],
        [7, 28],
        [13, 44],
        [20, 38],
        [21, 27],
        [25, 6],
        [5, 35],
        [16, 34],
        [27, 25],
        [31, 13],
        [29, 17],
        [47, 16],
        [61, -14],
        [88, -54],
        [43, -27],
        [41, -16],
        [43, -2],
        [40, 12],
        [29, -20],
        [40, 2],
        [36, -17],
        [41, 2],
        [62, -18],
        [25, -19],
        [71, -8],
        [103, 0],
        [131, 6],
        [39, 16],
        [38, 15],
        [37, -2],
        [8, -33],
        [14, -49],
        [18, -33],
        [47, -54],
        [41, -46],
        [14, -17],
        [44, -12],
        [46, -36],
        [66, -61],
        [40, -44],
        [24, -24],
        [11, -18],
        [-5, -11],
        [38, -18],
        [38, -13],
        [14, 15],
        [12, 16],
        [-2, 31],
        [16, 32],
        [21, 51],
        [27, 28],
        [44, 38],
        [25, 30],
        [40, 34],
        [53, 10],
        [37, -23],
        [23, -17],
        [28, -16],
        [28, -24],
        [36, -38],
        [35, -15],
        [41, -22],
        [31, 0],
        [34, 30],
        [39, 32],
        [53, 15],
        [34, 12],
        [49, 10],
        [65, 6],
        [45, -2],
        [42, -6],
        [52, -23],
        [37, -25],
        [38, -12],
        [51, -26],
        [576, 64],
        [1677, 800],
        [1399, -2152],
        [-102, -182],
        [201, -72],
        [471, -167],
        [87, -38],
        [306, -107],
        [26, -7],
        [13, 18],
        [189, 119],
        [624, 275],
        [-14, 33],
        [136, 217],
        [7, 240],
        [141, 581],
        [-251, 1945],
        [-700, 447],
        [18, 31],
        [56, 28],
        [50, -9],
        [56, -41],
        [45, -34],
        [39, -16],
        [63, -10],
        [50, 13],
        [58, 7],
        [61, 40],
        [28, 38],
        [28, 43],
        [22, 33],
        [8, 40],
        [12, 30],
        [19, 58],
        [12, 50],
        [7, 57],
        [19, 10],
        [56, -2],
        [43, -16],
        [63, -39],
        [37, -65],
        [31, -61],
        [30, -42],
        [23, -39],
        [27, -53],
        [25, -22],
        [40, -22],
        [22, 16],
        [26, 11],
        [36, -10],
        [37, -20],
        [29, -37],
        [43, -24],
        [52, 2],
        [84, -6],
        [53, 8],
        [38, 0],
        [48, 4],
        [68, 20],
        [44, 48],
        [74, 35],
        [58, 52],
        [37, 40],
        [43, 13],
        [44, 11],
        [54, 7],
        [45, 6],
        [29, -7],
        [40, -13],
        [31, -6],
        [36, 2],
        [46, 6],
        [29, -21],
        [27, -45],
        [13, -99],
        [3, -43],
        [8, -60],
        [9, -43],
        [22, -30],
        [20, -14],
        [58, -50],
        [12, -55],
        [5, -50],
        [22, -36],
        [21, -22],
        [51, -30],
        [63, 18],
        [51, 19],
        [61, 49],
        [41, 26],
        [41, 17],
        [33, -19],
        [83, -69],
        [29, -17],
        [38, -12],
        [38, -5],
        [25, 15],
        [16, 34],
        [24, 62],
        [29, 45],
        [27, 16],
        [43, 6],
        [42, -6],
        [52, -37],
        [33, -33],
        [20, -23],
        [30, -14],
        [55, -4],
        [52, -13],
        [44, 1],
        [54, -21],
        [39, -21],
        [56, 17],
        [46, 49],
        [57, 32],
        [40, 12],
        [46, 0],
        [72, 5],
        [51, 30],
        [-9, 50],
        [33, 28],
        [59, -10],
        [44, -8],
        [55, 26],
        [30, 22],
        [83, -5],
        [60, -15],
        [62, -34],
        [69, -42],
        [51, -33],
        [33, -21],
        [44, -9],
        [75, 26],
        [119, 20],
        [60, -27],
        [69, 16],
        [62, -1],
        [634, -375],
        [339, 240],
        [510, -449],
        [884, 724],
        [379, -264],
        [937, 665],
        [32, -15],
        [23, -16],
        [-2, -30],
        [1, -31],
        [7, -28],
        [12, -22],
        [17, -16],
        [3, -4],
        [2, -1],
        [26, -10],
        [12, -5],
        [59, -10],
        [16, 0],
        [25, 0],
        [43, 27],
        [76, 51],
        [12, 8],
        [17, 10],
        [42, 31],
        [61, 44],
        [22, 10],
        [12, 22],
        [6, 18],
        [-22, 77],
        [-24, 43],
        [12, 53],
        [14, 37],
        [12, 30],
        [4, 38],
        [-5, 58],
        [101, 99],
        [89, 90],
        [68, 91],
        [-25, 45],
        [-88, 322],
        [301, 295],
        [2201, 99],
        [4277, 539],
        [97, -1006],
        [70, -1229],
        [1868, -116],
        [-125, 2483],
        [1353, 590],
      ],
      [
        [254055, 153875],
        [5, -43],
        [8, -24],
        [12, -27],
        [5, -38],
        [-8, -16],
        [-38, 2],
        [-64, -1],
        [-16, -10],
        [-13, -18],
        [14, -32],
        [42, -37],
        [59, -42],
        [17, -72],
        [-15, -83],
        [-35, -52],
        [-78, -9],
        [-54, 27],
        [-31, 4],
        [-20, -16],
        [4, -21],
        [23, -62],
        [32, -33],
        [8, -54],
        [1, -67],
        [7, -46],
        [11, -46],
        [-12, -43],
        [-35, -30],
        [-28, 9],
        [-28, 32],
        [-40, 36],
        [-84, 64],
        [-48, 14],
        [-73, 4],
        [-47, 16],
        [-15, 47],
        [-13, 35],
        [-38, 16],
        [-45, -8],
        [-28, -45],
        [-16, -85],
        [3, -66],
        [47, -71],
        [-28, -28],
        [-45, 10],
        [-24, -9],
        [1, -29],
        [13, -58],
        [-25, -27],
        [-10, -34],
        [31, -21],
        [29, -2],
        [2, -33],
        [-31, -29],
        [-8, -86],
        [-23, -35],
        [-51, 11],
        [-29, 33],
        [-74, -6],
        [-69, -29],
        [-12, -65],
        [13, -86],
        [-42, -69],
        [-61, -59],
        [-82, -43],
        [-78, -55],
        [-24, -43],
        [-13, -56],
        [-19, -53],
        [-3, -56],
        [6, -13],
        [16, -6],
        [20, 4],
        [18, -7],
        [2, -30],
        [-33, -81],
        [-23, -55],
        [-6, -50],
        [-23, -15],
        [-28, -6],
        [-29, -18],
        [-7, -32],
        [-21, -38],
        [-19, -30],
        [-36, -32],
        [-30, -8],
        [-15, -9],
        [-9, -17],
        [-3, -15],
        [-2, -20],
        [20, -47],
        [-17, -126],
        [-38, -75],
        [-84, -46],
        [-74, -6],
        [-76, -33],
        [-82, -48],
        [-58, -26],
        [-58, -12],
        [-61, -8],
        [-33, -42],
        [0, -103],
        [-2, -59],
        [-15, -34],
        [-25, -9],
        [-12, -16],
        [-3, -34],
        [1, -43],
        [-5, -27],
        [-30, -34],
        [-21, -15],
        [-28, -42],
        [-18, -28],
        [-18, -17],
        [-50, -72],
        [-8, -87],
        [-5, -88],
        [-29, -79],
        [-35, -61],
        [-44, -32],
        [-54, -46],
        [-22, -70],
        [-35, -141],
        [-30, -134],
        [-15, -122],
        [-18, -97],
        [-16, -72],
        [-54, -53],
        [-66, -15],
        [-88, -12],
        [-47, -44],
        [-28, -87],
        [4, -79],
        [0, -87],
        [-11, -91],
        [-41, -83],
        [-73, -37],
        [-93, -38],
        [-95, -12],
        [-78, -32],
        [-92, -30],
        [-81, -38],
        [-78, -16],
        [-61, 8],
        [-62, 17],
        [-68, -4],
        [-617, 35],
        [1431, -2248],
        [-88, -564],
        [-2199, -125],
        [-1823, -24],
        [-247, 3],
        [8, -92],
        [-258, 122],
        [-1336, 138],
        [-6, 0],
        [-448, 4],
        [-909, -187],
        [558, -303],
        [317, 32],
        [905, -634],
        [1255, -815],
        [125, -756],
        [80, -488],
        [128, -767],
        [62, -58],
        [54, -45],
        [48, -73],
        [47, -28],
        [101, -11],
        [38, 14],
        [64, -16],
        [103, -44],
        [74, -52],
        [55, -19],
        [51, -10],
        [62, -32],
        [38, -28],
        [67, -33],
        [3, -18],
        [12, -9],
        [15, -5],
        [15, 0],
        [15, -10],
        [10, -13],
        [22, -17],
        [18, -25],
        [31, -23],
        [21, -17],
        [12, -34],
        [14, -26],
        [13, -21],
        [18, -21],
        [18, -18],
        [32, -17],
        [45, -24],
        [29, -14],
        [20, -50],
        [-2, -46],
        [40, -35],
        [130, -90],
        [27, -19],
        [86, -24],
        [48, -8],
        [28, 17],
        [24, 20],
        [15, -1],
        [44, -44],
        [-4, -20],
        [17, -17],
        [23, -13],
        [42, 26],
        [20, 2],
        [88, -105],
        [-5, -8],
        [-38, -12],
        [-61, 2],
        [-8, 1],
        [-15, -24],
        [-21, -15],
        [-30, -3],
        [-75, -54],
        [-32, -22],
        [-24, -22],
        [-11, -27],
        [-17, -31],
        [-6, -30],
        [6, -30],
        [19, -33],
        [39, -73],
        [8, -8],
        [5, -24],
        [16, -26],
        [31, -41],
        [3, -16],
        [28, -22],
        [18, -48],
        [53, -33],
        [44, -41],
        [30, -13],
        [56, -56],
        [40, -61],
        [6, -30],
        [-11, -89],
        [-8, -58],
        [-35, -59],
        [-27, -35],
        [-34, -43],
        [-90, -98],
        [-50, -63],
        [-63, -98],
        [-30, -72],
        [-12, -39],
        [-6, -64],
        [-9, -73],
        [-16, -21],
        [-19, -28],
        [-4, -61],
        [25, -67],
        [-11, -60],
        [-10, -46],
        [6, -45],
        [-27, -56],
        [3, -36],
        [18, -33],
        [9, -36],
        [-3, -36],
        [-10, -25],
        [-24, -7],
        [-18, -7],
        [-2, -12],
        [-2, -34],
        [-2, -36],
        [0, -43],
        [-10, -54],
        [-33, -35],
        [-28, -48],
        [-14, -26],
        [-21, -30],
        [-12, -60],
        [-1, -23],
        [18, -22],
        [26, -21],
        [16, -19],
        [6, -13],
        [1, -21],
        [-4, -19],
        [-31, -20],
        [-10, -18],
        [-33, -70],
        [-23, -57],
        [-6, -24],
        [-9, -46],
        [1, -103],
        [14, -101],
        [-1, -34],
        [-9, 0],
        [-42, -2],
        [-5, -23],
        [-28, 0],
        [-48, -22],
        [-13, -1],
        [-30, -56],
        [-6, -27],
        [8, -54],
        [6, -31],
        [6, -48],
        [8, -44],
        [5, -22],
        [-21, -16],
        [-32, -10],
        [-16, -19],
        [-14, -16],
        [-13, -22],
        [-44, 12],
        [-30, 6],
        [-18, 0],
        [-34, 28],
        [-12, 0],
        [-7, -14],
        [-21, -25],
        [-19, -24],
        [-49, 16],
        [-26, 1],
        [-20, 16],
        [-15, 4],
        [-18, -8],
        [-2, -21],
        [-10, -15],
        [-14, -15],
        [-16, 2],
        [-24, 11],
        [-20, -7],
        [3, -22],
        [-43, -39],
        [-18, -9],
        [-17, -1],
        [-38, -16],
        [-25, -29],
        [-28, -49],
        [-37, -37],
        [-54, -54],
        [-30, -32],
        [-4, -31],
        [-6, -23],
        [-18, -19],
        [-26, -10],
        [-37, -34],
        [10, -22],
        [-11, -40],
        [27, -32],
        [-42, -52],
        [-6, -19],
        [-24, -22],
        [-24, 7],
        [-30, -34],
        [-28, -50],
        [-24, -24],
        [-9, -25],
        [-35, -32],
        [-34, -9],
        [-18, -10],
        [-15, -43],
        [-26, -54],
        [-25, -13],
        [-9, -26],
        [-11, -18],
        [-39, -11],
        [-28, -45],
        [-6, -55],
        [-11, -35],
        [-26, -18],
        [-17, 10],
        [-12, 4],
        [-16, 0],
        [-6, -16],
        [0, -20],
        [-19, -22],
        [-5, -40],
        [-39, -20],
        [-24, -16],
        [-31, -10],
        [-14, 12],
        [0, 13],
        [-8, 3],
        [-5, -8],
        [-8, -12],
        [-10, -6],
        [-22, 10],
        [-6, 8],
        [-41, 8],
        [-28, -16],
        [-12, -27],
        [-38, -38],
        [-32, -28],
        [-35, -15],
        [-29, -36],
        [-32, -39],
        [-28, -37],
        [-32, 8],
        [-22, 5],
        [-24, 7],
        [-9, 2],
        [-12, 2],
        [-16, 6],
        [-4, -2],
        [-50, 13],
        [-9, 1],
        [-29, -6],
        [-12, 13],
        [-4, 21],
        [-6, 27],
        [-44, -4],
        [-11, -18],
        [9, -24],
        [0, -18],
        [2, -17],
        [-20, -4],
        [-20, 13],
        [-27, 10],
        [-38, -7],
        [-28, -8],
        [-15, -26],
        [5, -75],
        [-30, -8],
        [11, -28],
        [-13, -32],
        [-2, -21],
        [-8, -16],
        [22, -14],
        [7, -22],
        [-9, -12],
        [-28, -10],
        [-6, -20],
        [4, -28],
        [4, -31],
        [55, -72],
        [74, -24],
        [70, -30],
        [25, -13],
        [52, -19],
        [25, -16],
        [34, -32],
        [43, -40],
        [76, -56],
        [130, -88],
        [201, -132],
        [105, -63],
        [67, -29],
        [161, -25],
        [46, 0],
        [59, 12],
        [21, 6],
        [27, 26],
        [16, 32],
        [2, 34],
        [39, 60],
        [70, 94],
        [47, 63],
        [17, 2],
        [41, -2],
        [126, -30],
        [40, -16],
        [24, -2],
        [50, 14],
        [98, 44],
        [36, 8],
        [56, 11],
        [46, 7],
        [36, 9],
        [55, 26],
        [16, 8],
        [46, 13],
        [68, 20],
        [200, 55],
        [69, 42],
        [68, 66],
        [27, 5],
        [6, 2],
        [88, 11],
        [101, 15],
        [54, 7],
        [96, -8],
        [40, -1],
        [60, 18],
        [28, 1],
        [102, -5],
        [99, 2],
        [55, 10],
        [112, 53],
        [30, 12],
        [75, 28],
        [23, 6],
        [15, 0],
        [16, 2],
        [10, 0],
        [35, -4],
        [8, -4],
        [3, -2],
        [2, 0],
        [3, -2],
        [7, -2],
        [0, -2],
        [3, -6],
        [16, -32],
        [10, -16],
        [2, 0],
        [23, -34],
        [18, -19],
        [18, -19],
        [15, -18],
        [41, -54],
        [12, -16],
        [8, -11],
        [2, -2],
        [27, -29],
        [5, -4],
        [6, -3],
        [16, -9],
        [26, -14],
        [54, -7],
        [12, -2],
        [23, -4],
        [50, 17],
        [15, 4],
        [6, 1],
        [27, 13],
        [20, 9],
        [11, 5],
        [4, 2],
        [33, 17],
        [3, 2],
        [5, 2],
        [9, 5],
        [6, 3],
        [10, 3],
        [18, 19],
        [2, 1],
        [11, 11],
        [5, 5],
        [4, 3],
        [3, 4],
        [13, 12],
        [2, 2],
        [5, 6],
        [3, 0],
        [11, 0],
        [7, 8],
        [2, 12],
        [10, 5],
        [19, 11],
        [17, 10],
        [6, 3],
        [14, 8],
        [15, 11],
        [30, 10],
        [17, -7],
        [4, -5],
        [18, -15],
        [13, -14],
        [12, -14],
        [13, -13],
        [14, -12],
        [13, -10],
        [3, -2],
        [15, -15],
        [18, -19],
        [13, -9],
        [8, 2],
        [23, -13],
        [30, -40],
        [2, -2],
        [12, -30],
        [26, -35],
        [27, -41],
        [10, -17],
        [8, -4],
        [20, 9],
        [16, -6],
        [26, -38],
        [21, -56],
        [12, -38],
        [23, -6],
        [6, -2],
        [14, -4],
        [2, -4],
        [5, -6],
        [13, -17],
        [2, -2],
        [2, -8],
        [7, -18],
        [1, -6],
        [0, -2],
        [2, -10],
        [28, -24],
        [1, -1],
        [12, -20],
        [6, -8],
        [12, -16],
        [7, -7],
        [2, -2],
        [6, -7],
        [14, -11],
        [4, -4],
        [4, -4],
        [26, -15],
        [4, -2],
        [10, -11],
        [2, -2],
        [3, -5],
        [20, -31],
        [2, -3],
        [1, -1],
        [39, -26],
        [32, -22],
        [30, -15],
        [30, 4],
        [18, -16],
        [22, -12],
        [32, 4],
        [14, -20],
        [50, -16],
        [18, -13],
        [2, -11],
        [2, -17],
        [-13, -8],
        [-10, -14],
        [5, -27],
        [19, -37],
        [28, -6],
        [22, -12],
        [18, -12],
        [19, -50],
        [-2, -36],
        [-1, -34],
        [40, -37],
        [27, 6],
        [21, 0],
        [27, -18],
        [21, -14],
        [38, 5],
        [37, -2],
        [21, -6],
        [9, -19],
        [3, -17],
        [-19, -24],
        [0, -14],
        [20, -9],
        [12, 11],
        [6, 20],
        [18, 6],
        [24, -2],
        [35, 43],
        [15, 36],
        [32, 17],
        [56, 6],
        [46, -7],
        [40, -11],
        [31, -10],
        [4, -14],
        [-4, -26],
        [-10, -30],
        [-3, -38],
        [19, -23],
        [8, -17],
        [2, -20],
        [4, -22],
        [2, -19],
        [8, -16],
        [8, -20],
        [32, -72],
        [25, -57],
        [-8, 0],
        [1, -12],
        [5, -4],
        [12, -4],
        [4, -10],
        [-8, -3],
        [-10, -2],
        [-3, -8],
        [1, -11],
        [8, -11],
        [4, -5],
        [2, -12],
        [-2, -5],
        [-4, -4],
        [0, -5],
        [12, -8],
        [-2, -10],
        [-10, -30],
        [6, -6],
        [12, 6],
        [10, -43],
        [2, -10],
        [-8, -3],
        [-6, -9],
        [6, -9],
        [10, -10],
        [14, 1],
        [14, -2],
        [5, -2],
        [-4, -13],
        [-3, -10],
        [-4, -10],
        [-16, -2],
        [-4, 0],
        [0, -10],
        [3, -9],
        [7, -2],
        [1, -8],
        [-3, -6],
        [-10, -2],
        [-5, -2],
        [-3, -8],
        [5, -10],
        [6, -8],
        [5, -8],
        [-2, -9],
        [-18, -16],
        [-10, -5],
        [-6, -12],
        [-2, -28],
        [14, -43],
        [0, -23],
        [8, -10],
        [-20, -24],
        [-18, -16],
        [-7, -13],
        [6, -17],
        [15, -10],
        [6, -41],
        [-4, -45],
        [-6, -45],
        [-4, -36],
        [-3, -25],
        [13, -13],
        [25, -8],
        [7, -6],
        [-5, -14],
        [-5, -13],
        [18, -17],
        [29, -31],
        [33, -24],
        [14, -9],
        [0, -16],
        [0, -8],
        [11, -5],
        [8, 6],
        [8, -2],
        [5, -8],
        [6, -14],
        [26, 0],
        [113, -77],
        [23, 16],
        [16, 2],
        [15, -14],
        [23, -29],
        [14, -10],
        [12, -1],
        [11, -12],
        [8, -9],
        [8, -7],
        [24, -23],
        [30, -34],
        [21, -27],
        [18, -7],
        [14, -6],
        [8, -6],
        [2, -24],
        [14, -14],
        [10, -6],
        [6, -2],
        [10, -11],
        [-11, -24],
        [-6, -14],
        [-4, -18],
        [11, -12],
        [16, -12],
        [13, 0],
        [29, -27],
        [14, -25],
        [16, -44],
        [4, -7],
        [43, -17],
        [28, -12],
        [19, -4],
        [22, -7],
        [12, 17],
        [12, 19],
        [11, 14],
        [16, 3],
        [18, -9],
        [11, -4],
        [16, -2],
        [33, 6],
        [17, 4],
        [59, 65],
        [28, 42],
        [7, 90],
        [15, 119],
        [56, 96],
        [69, 69],
        [108, 45],
        [136, 14],
        [139, -12],
        [522, -197],
        [2588, -984],
        [919, -350],
        [1551, -571],
        [417, -227],
        [-105, -170],
        [885, -396],
        [24, 123],
        [62, -33],
        [-6, -30],
        [-84, -606],
        [-508, -2603],
        [-4, -25],
        [-270, -1288],
        [-482, 74],
        [-1041, -591],
        [-309, -163],
        [-2009, -465],
        [-10, -334],
        [-1605, 785],
        [-187, 70],
        [-1307, -207],
        [64, -542],
        [-1028, 458],
        [-1121, -1425],
        [-579, 598],
        [-2231, -1683],
        [1538, 367],
        [-650, -1319],
        [85, -308],
        [-7, 0],
        [-10, 2],
        [-26, 3],
        [-18, -2],
        [-18, -8],
        [-14, -10],
        [-15, -9],
        [-14, -16],
        [-6, -16],
        [-14, -36],
        [-11, -17],
        [-21, -8],
        [-29, -1],
        [-24, 1],
        [-19, 1],
        [-34, 1],
        [-32, -7],
        [-26, -7],
        [-19, -6],
        [-17, 3],
        [-20, 7],
        [-18, 8],
        [-22, 8],
        [-37, 0],
        [-24, 5],
        [-18, 6],
        [-21, 6],
        [-17, 2],
        [-10, -2],
        [-15, -14],
        [-12, -15],
        [-9, -8],
        [-31, -5],
        [-23, 7],
        [-20, 10],
        [-9, 11],
        [-12, 6],
        [-10, -4],
        [-12, -25],
        [-10, -24],
        [-7, -22],
        [-2, -16],
        [-1, -10],
        [-12, -6],
        [-13, -4],
        [-10, -12],
        [-13, -14],
        [-3, -15],
        [-13, -9],
        [-21, -13],
        [-11, -8],
        [-1, -20],
        [-9, -18],
        [-14, -9],
        [-35, -7],
        [-14, -6],
        [-10, -11],
        [-12, -24],
        [-3, -27],
        [1, -21],
        [-3, -17],
        [-9, -17],
        [-16, -24],
        [-14, -6],
        [-17, 2],
        [-23, 8],
        [-17, 10],
        [-12, 0],
        [-9, -18],
        [-27, -59],
        [-13, -38],
        [-8, -13],
        [-19, -23],
        [-15, -18],
        [-35, -14],
        [-37, -11],
        [-33, -5],
        [-14, -16],
        [-9, -32],
        [-4, -22],
        [9, -22],
        [6, -20],
        [-5, -21],
        [-5, -19],
        [-24, -9],
        [-8, 5],
        [-13, 3],
        [-17, -11],
        [-16, -8],
        [-17, -19],
        [-41, -44],
        [-41, -44],
        [-42, -41],
        [-35, -1],
        [-31, 31],
        [-13, 51],
        [-27, 45],
        [-38, -1],
        [-26, -26],
        [-39, -20],
        [-40, 0],
        [-47, 6],
        [-17, -18],
        [-25, -24],
        [-26, -33],
        [-29, -2],
        [-26, 27],
        [-48, 38],
        [-44, 20],
        [-41, 0],
        [-38, -8],
        [-19, -32],
        [2, -58],
        [-19, -23],
        [-14, -4],
        [-18, 38],
        [7, 35],
        [-12, 20],
        [-38, 20],
        [-28, 22],
        [-11, 11],
        [-21, -35],
        [-20, -14],
        [-31, 0],
        [-41, 4],
        [-18, 8],
        [-24, 4],
        [-38, 4],
        [-24, -18],
        [-22, -28],
        [-24, -20],
        [-18, -22],
        [-28, -33],
        [-11, -26],
        [7, -26],
        [3, -29],
        [2, -19],
        [-12, -24],
        [-36, -18],
        [0, -17],
        [11, -25],
        [10, -22],
        [10, -6],
        [6, -24],
        [-2, -21],
        [-1, -6],
        [1, -19],
        [7, -16],
        [0, -22],
        [-8, -20],
        [-13, 0],
        [-21, 10],
        [-12, -4],
        [-16, -10],
        [-19, -11],
        [-17, -10],
        [-16, -20],
        [-16, -3],
        [-16, -1],
        [-10, -15],
        [-9, -14],
        [-22, -29],
        [-23, -28],
        [-16, -16],
        [-35, -4],
        [-54, 0],
        [-35, 2],
        [-26, -4],
        [-27, -18],
        [-34, -14],
        [-54, -50],
        [-26, -25],
        [-22, -31],
        [-3, -30],
        [-3, -35],
        [-5, -15],
        [-4, -27],
        [-7, -22],
        [-10, -9],
        [-35, 9],
        [-28, 14],
        [-21, 16],
        [-17, 9],
        [-16, 10],
        [-17, -1],
        [-9, -18],
        [0, -22],
        [1, -27],
        [-1, -21],
        [-4, -24],
        [-5, -5],
        [-11, -12],
        [-22, 0],
        [-27, 6],
        [-19, 9],
        [-21, -8],
        [-22, -7],
        [-10, -17],
        [-4, -36],
        [-6, -40],
        [-8, -46],
        [-14, 17],
        [-20, -19],
        [-18, -29],
        [-14, -20],
        [9, -30],
        [-6, -33],
        [-11, -20],
        [11, -20],
        [1, -25],
        [14, -35],
        [16, -5],
        [36, 2],
        [22, 14],
        [21, 6],
        [7, -9],
        [11, -12],
        [20, -17],
        [24, -30],
        [4, -37],
        [-8, -34],
        [-17, -26],
        [-21, -23],
        [-27, -28],
        [-24, -37],
        [-10, -35],
        [0, -31],
        [-29, -34],
        [-28, -24],
        [-37, -31],
        [-17, -25],
        [-6, -13],
        [-1, -37],
        [1, -32],
        [-13, -27],
        [-75, -2],
        [-33, -6],
        [-35, -22],
        [-30, -18],
        [11, -53],
        [3, -44],
        [-3, -24],
        [-25, -28],
        [-26, -40],
        [-26, -54],
        [-14, -36],
        [-18, -29],
        [-14, -23],
        [-22, -13],
        [-26, -7],
        [-29, -29],
        [-26, -16],
        [-20, -16],
        [-31, -10],
        [-18, -9],
        [-14, -27],
        [-19, -10],
        [-18, -12],
        [-9, -24],
        [-6, -28],
        [-2, -21],
        [13, -16],
        [54, 2],
        [35, -4],
        [25, -10],
        [10, -2],
        [-79, -417],
        [-169, -1179],
        [-48, -83],
        [-135, -478],
        [-329, 89],
        [-12, -184],
        [-9, -130],
        [-11, -2],
        [-7, -10],
        [-19, -29],
        [-13, -27],
        [-23, -31],
        [-46, -36],
        [-21, -19],
        [-42, -6],
        [-35, 6],
        [-39, 29],
        [-26, -1],
        [-26, -12],
        [-35, -24],
        [-21, -17],
        [-2, -17],
        [-11, -9],
        [-6, 13],
        [-14, -6],
        [-24, -26],
        [-91, -22],
        [-78, -17],
        [-95, -1],
        [-88, 57],
        [-91, 34],
        [-78, 11],
        [-52, -2],
        [-34, 22],
        [-46, 45],
        [-38, 22],
        [-45, 1],
        [-31, -17],
        [-4, -4],
        [-10, -23],
        [-22, -19],
        [-35, -20],
        [-34, -5],
        [-11, -13],
        [-32, -19],
        [-28, -2],
        [-18, -26],
        [-41, -21],
        [-34, -40],
        [-28, -48],
        [-8, -25],
        [-16, -13],
        [-38, -11],
        [-16, -16],
        [-9, -36],
        [-7, -32],
        [-35, -46],
        [-24, -13],
        [-10, -41],
        [-15, -44],
        [-22, -69],
        [-15, -33],
        [-13, -25],
        [-47, -25],
        [-28, -26],
        [-17, -43],
        [-1, -12],
        [-1, -24],
        [-36, -34],
        [-25, 10],
        [-39, 4],
        [-34, 4],
        [-43, 8],
        [-37, 22],
        [-36, 8],
        [-29, -18],
        [-38, -14],
        [-33, -2],
        [-44, -10],
        [-29, -35],
        [-20, -34],
        [-22, -37],
        [-33, -70],
        [-34, -60],
        [-41, -55],
        [-18, -47],
        [-11, -38],
        [-21, -52],
        [-29, -23],
        [-25, -35],
        [-25, -31],
        [-43, -38],
        [-22, -30],
        [-33, -41],
        [-36, -28],
        [-64, -18],
        [-37, -2],
        [-32, -5],
        [-20, -29],
        [-12, -44],
        [-3, -45],
        [-6, -56],
        [-11, -18],
        [-2, -33],
        [-4, -32],
        [-13, -40],
        [-18, -52],
        [-5, -28],
        [-14, -22],
        [-44, -37],
        [-49, -50],
        [-43, -48],
        [-55, -36],
        [-34, -51],
        [-37, -31],
        [-35, -25],
        [-52, -14],
        [-54, -11],
        [-49, -20],
        [-41, -16],
        [-17, -25],
        [-22, -18],
        [-24, -33],
        [-62, -25],
        [-68, -9],
        [-21, -27],
        [-28, -33],
        [-25, -36],
        [5, -31],
        [1, -44],
        [25, -51],
        [36, -33],
        [40, -27],
        [22, -50],
        [5, -50],
        [10, -69],
        [1, -50],
        [-7, -32],
        [-39, -6],
        [-46, 26],
        [-54, 44],
        [-32, 52],
        [-45, 36],
        [-81, -4],
        [-38, 29],
        [-37, 14],
        [-62, 6],
        [-52, -4],
        [-44, 0],
        [-51, 8],
        [-68, 4],
        [-67, -2],
        [-50, 4],
        [-46, 12],
        [-34, 10],
        [-21, -8],
        [-3, -14],
        [-13, 2],
        [-19, -10],
        [-13, -31],
        [-26, -33],
        [-41, -33],
        [-19, -38],
        [-9, -34],
        [-17, -38],
        [-13, -40],
        [-12, -20],
        [-10, -19],
        [-14, -19],
        [-23, -10],
        [-6, -17],
        [-27, -2],
        [141, -916],
        [13, -339],
        [-138, -2780],
      ],
      [
        [203577, 146327],
        [-185, 233],
        [-6, 143],
        [-16, 26],
        [-20, 20],
        [-25, 78],
        [-50, 76],
        [-50, 118],
        [-13, 85],
        [-14, 58],
        [-85, 32],
        [-72, 20],
        [-55, -2],
        [-103, 31],
        [-33, 29],
        [-52, 38],
        [-104, 133],
        [-5, 63],
        [2, 35],
        [8, 45],
        [14, 22],
        [14, 20],
        [11, 35],
        [-6, 16],
        [-1, 18],
        [-8, 15],
        [-8, 23],
        [6, 12],
        [-7, 29],
        [3, 18],
        [-10, 26],
        [-7, 26],
        [11, 14],
        [-29, 34],
        [-23, 56],
        [-37, 17],
        [-55, -2],
        [-11, -9],
        [-27, -9],
        [-30, -13],
        [-58, -2],
        [-45, -14],
        [-26, -6],
        [-62, -9],
        [-10, -11],
        [-12, -6],
        [-32, 0],
        [-40, 14],
        [-44, -13],
        [-51, -15],
        [-28, 0],
        [-40, 9],
        [514, 1404],
        [-1995, 1550],
        [228, 369],
        [-298, 2192],
        [-1567, 2579],
        [4734, 3504],
        [-4458, 254],
        [74, 277],
        [14, 49],
        [2, 8],
        [2, 11],
        [2, 6],
        [2, 2],
        [22, 86],
        [1, 4],
        [3, 10],
        [4, 16],
        [3, 12],
      ],
      [
        [151501, 221475],
        [2337, -573],
        [1887, -457],
        [224, -49],
        [964, 36],
        [530, -102],
        [130, -25],
        [146, -29],
        [-193, -20],
        [-144, -16],
        [82, -252],
        [1492, -4547],
        [679, -10],
        [2779, 112],
        [4514, 786],
        [2119, -212],
        [493, -52],
        [-198, 1078],
        [321, -664],
        [18, -15],
        [85, -66],
        [4, -357],
        [1043, -113],
        [-1167, 1129],
        [-440, 426],
        [431, -264],
        [948, -584],
        [57, 13],
        [23, 29],
        [24, 25],
        [54, 4],
        [78, -21],
        [99, -79],
        [64, -96],
        [46, -159],
        [46, -122],
        [-7, -136],
        [-5, -41],
        [1, -11],
        [-4, -33],
        [9, -64],
        [-2, -52],
        [27, -77],
        [20, -39],
        [2, -29],
        [37, -40],
        [31, -56],
        [30, -48],
        [37, -40],
        [50, -60],
        [43, -63],
        [8, -39],
        [-2, -21],
        [30, -74],
        [16, -66],
        [23, -41],
        [45, -55],
        [46, -37],
        [52, -42],
        [92, -50],
        [16, -16],
        [62, -43],
        [64, -20],
        [82, -33],
        [90, -17],
        [89, 22],
        [67, 44],
        [62, 10],
        [26, -12],
        [42, -29],
        [10, -20],
        [35, -15],
        [27, -23],
        [32, -37],
        [20, -28],
        [22, -57],
        [13, -15],
        [31, -30],
        [27, -14],
        [37, -40],
        [10, -22],
        [21, -14],
        [7, -9],
        [7, -19],
        [62, -7],
      ],
      [
        [169031, 184669],
        [8, -4],
        [1903, -1128],
        [-271, -629],
        [-130, -806],
        [-85, -545],
        [1270, 66],
        [247, 19],
        [233, 15],
        [-293, -670],
        [-39, -410],
        [-88, -190],
        [-41, -181],
        [-2, -276],
        [371, -858],
        [-388, -117],
        [-667, -152],
        [-335, -733],
        [648, -1722],
        [644, -1710],
        [958, -615],
        [395, -110],
        [108, -31],
        [88, -120],
        [805, 23],
        [11, 2],
        [770, 155],
      ],
      [
        [203548, 133112],
        [-1079, -343],
        [-223, 179],
        [-211, 169],
        [-1076, 864],
        [-4605, 1532],
        [-3646, -913],
        [-358, -254],
        [-98, -58],
        [-68, -46],
        [-481, -461],
        [-127, -257],
        [-106, -446],
        [-21, -88],
        [0, -2],
        [-175, -734],
        [-35, -143],
        [-63, -489],
        [-224, -334],
        [-182, -265],
        [-235, -221],
        [-282, -149],
        [-431, -142],
        [-359, -84],
        [-181, -41],
        [-1230, -323],
        [-423, -133],
        [-1204, -403],
        [-163, -29],
        [-91, -13],
        [-245, -37],
        [-644, -121],
        [-172, -29],
        [-432, -72],
        [-230, -47],
        [-269, -67],
        [-238, -67],
        [-2390, 869],
      ],
      [
        [181551, 129914],
        [-16, 6],
        [-29, 10],
        [-4, 2],
        [-495, -277],
        [-673, 543],
        [-326, 505],
        [-51, 457],
        [-3207, 4637],
        [153, 751],
        [-12, 24],
        [-720, 1259],
        [-388, 341],
        [1998, 1499],
        [30, 58],
        [19, 40],
        [-13, 238],
        [66, 8],
        [-102, 268],
        [32, 211],
        [21, 112],
        [5, 138],
        [98, 53],
        [12, 89],
        [3, 19],
        [2, 15],
        [0, 2],
        [0, 1],
        [2, 7],
        [32, 29],
        [4, 3],
        [20, 18],
        [10, 6],
        [18, 18],
        [7, 6],
        [132, 114],
        [24, 159],
        [154, 421],
        [31, 145],
        [-35, 204],
        [-219, 27],
        [-33, 4],
        [-46, 15],
        [-53, 59],
        [-15, -2],
        [-25, -3],
        [-17, 2],
        [-14, 2],
        [-6, 9],
        [-5, 6],
        [-4, 8],
        [0, 5],
        [4, 4],
        [3, 2],
        [6, -3],
        [5, -2],
        [6, -1],
        [1, 4],
        [-2, 25],
        [-5, 22],
        [-7, 16],
        [-13, 12],
        [-4, -4],
        [-10, -14],
        [-8, -4],
        [-7, 6],
        [-14, 0],
        [-20, 2],
        [-11, -2],
        [-14, -12],
        [-9, -9],
        [-12, 8],
        [-6, 17],
        [-2, 8],
        [4, 12],
        [-4, 8],
        [-7, 15],
        [-15, 12],
        [-10, 10],
        [-17, 10],
        [-14, 3],
        [-11, -3],
        [-12, -6],
        [-12, 5],
        [-13, 10],
        [-2, 6],
        [-7, 1],
        [-11, 2],
        [-10, 6],
        [-11, 9],
        [-14, 14],
        [-20, -3],
        [-18, -11],
        [-22, 12],
        [-13, 3],
        [-18, 7],
        [-2, 5],
        [-3, 15],
        [-4, 5],
        [-13, 10],
        [-17, 20],
        [-11, 4],
        [-4, 12],
        [-4, 15],
        [-12, 2],
        [-16, 25],
        [-4, 7],
        [-4, 11],
        [-4, 12],
        [0, 11],
        [-8, 22],
        [-4, 11],
        [-3, 6],
        [-6, 4],
        [-22, 8],
        [-3, 8],
        [-8, 15],
        [-8, 8],
        [-10, 8],
        [-16, 5],
        [-5, 10],
        [-1, 8],
        [7, 9],
        [-1, 8],
        [-6, 2],
        [-19, 2],
        [-24, 0],
        [-34, 0],
        [-21, 10],
        [-20, -2],
        [-18, 2],
        [-12, 8],
        [0, 12],
        [-9, 12],
        [-4, 22],
        [-10, 8],
        [-8, 11],
        [0, 15],
        [2, 15],
        [2, 28],
        [-12, 20],
        [-18, 14],
        [-9, 22],
        [-6, 20],
        [0, 18],
        [-10, 16],
        [-11, 16],
        [-2, 19],
        [1, 17],
        [6, 18],
        [4, 16],
        [-3, 17],
        [-12, 17],
        [-19, 27],
        [-22, 17],
        [-17, 11],
        [-18, 6],
        [-25, -13],
        [-15, 24],
        [-40, 65],
        [-35, 23],
        [-3, 34],
        [-22, 23],
        [-67, 12],
        [-56, 40],
        [-23, 18],
        [-6, 35],
        [-24, 14],
        [-33, 8],
        [-29, -23],
        [-49, -7],
        [-35, -30],
        [-59, -25],
        [-32, 8],
        [-20, -12],
        [-28, 2],
        [-22, 6],
        [-13, 18],
        [-15, 14],
        [-8, 62],
        [-15, 14],
        [-15, 23],
        [-12, 8],
        [-32, 13],
        [4, 60],
        [-23, 29],
        [-24, -55],
        [-23, 0],
        [-28, -6],
        [-30, -17],
        [-33, -4],
        [0, -15],
        [-12, -25],
        [-4, -8],
        [-2, -9],
        [8, -26],
        [-8, -12],
        [-12, 1],
        [-14, 6],
        [-8, 4],
        [-10, -1],
        [-6, 1],
        [-6, 3],
        [-5, -7],
        [-1, -6],
        [3, -7],
        [5, -11],
        [3, -6],
        [1, -10],
        [-15, -11],
        [7, -10],
        [3, -16],
        [-6, -16],
        [-13, -12],
        [-24, 4],
        [-6, 0],
        [-36, 2],
        [-11, 2],
        [-13, 2],
        [-8, 2],
        [-5, -4],
        [-4, -4],
        [0, -4],
        [-2, -4],
        [0, -6],
        [-2, -2],
        [4, -6],
        [4, -10],
        [8, -5],
        [7, -7],
        [0, -14],
        [6, -8],
        [0, -9],
        [-1, -13],
        [-5, -16],
        [-4, -15],
        [-6, -14],
        [-5, -18],
        [9, -14],
        [13, -15],
        [-1, -18],
        [-12, -9],
        [0, -13],
        [20, -21],
        [7, -17],
        [-19, -15],
        [-4, -21],
        [-13, -5],
        [-14, 11],
        [-12, 10],
        [-10, 0],
        [-8, 0],
        [-6, -2],
        [-7, -1],
        [-6, -4],
        [-3, -7],
        [2, -7],
        [7, -7],
        [6, -7],
        [9, -11],
        [6, -6],
        [2, -7],
        [5, -14],
        [-3, -15],
        [-9, -11],
        [3, -12],
        [10, -6],
        [8, -6],
        [2, -10],
        [-2, -12],
        [-11, -4],
        [-3, -8],
        [-4, -12],
        [-8, -19],
        [0, -10],
        [-11, -4],
        [-12, -5],
        [-4, -10],
        [-2, -13],
        [-6, -12],
        [-595, 978],
        [-763, 132],
        [-152, 27],
        [-42, 53],
        [-118, 147],
        [-167, 219],
        [461, 1228],
        [-17, 10],
        [-195, 140],
        [-384, 190],
        [-14, 0],
        [-328, 21],
        [-227, -34],
        [-248, -54],
        [-884, 1720],
        [-190, 370],
        [-234, 456],
        [-126, 304],
        [-925, 1793],
        [-32, 160],
        [-4, 15],
        [-300, 1509],
        [-626, 1656],
        [-419, 1115],
        [-78, 87],
        [-265, 250],
        [-225, 119],
        [-255, 278],
        [-3502, 3795],
        [-515, 559],
        [-541, 163],
        [-194, 633],
        [-4012, 4339],
        [-298, 307],
        [-121, 80],
        [-1125, 147],
      ],
      [
        [158199, 165666],
        [-170, 22],
        [-877, 113],
        [-1010, -964],
        [-703, 466],
        [-465, 920],
        [7, 37],
        [-37, 20],
        [-485, 281],
        [208, 220],
        [-51, 565],
        [-151, 467],
        [-274, -38],
        [-36, 71],
        [1413, 478],
        [91, 31],
        [-357, 324],
        [69, 66],
        [71, 67],
        [-56, 105],
        [-6, 12],
        [-180, 354],
        [-728, 563],
        [-189, -42],
        [-6, -2],
        [-97, -21],
        [-404, 421],
        [-28, 30],
        [-934, 971],
        [-6, 16],
        [-3, 5],
        [-1690, 1244],
        [-14, -14],
        [-149, -144],
        [-1103, -1066],
        [-242, 1154],
        [-10, 80],
        [419, 349],
        [-1253, 2262],
        [-22, 41],
        [-301, 546],
        [-4, 4],
        [-3, 8],
        [-582, 1048],
        [-241, 436],
        [-81, 128],
        [-41, 41],
        [-43, 42],
        [-31, 39],
        [-8, 112],
        [0, 103],
        [-14, 54],
        [-37, 134],
        [-13, 123],
        [-26, 142],
        [-252, 432],
        [-25, 99],
        [-13, 116],
        [17, 52],
        [47, 82],
        [51, 50],
        [80, 24],
        [-237, 327],
        [-33, 13],
        [-2972, 1182],
        [-4, 1],
        [-192, 75],
        [-663, 265],
        [138, 4008],
        [138, 3992],
        [28, 817],
        [3, 95],
        [-56, 61],
        [-107, 38],
        [-90, 18],
        [-4, 20],
        [-11, 51],
        [-439, 820],
        [-768, 1524],
        [828, 52],
        [37, 27],
        [12, 5],
        [98, 36],
        [62, 24],
        [1, 27],
        [14, 43],
        [69, 57],
        [14, 58],
        [-6, 13],
        [-27, 15],
        [-26, 58],
        [-37, 33],
        [0, 18],
        [19, 45],
        [40, 51],
        [465, 566],
        [31, -11],
        [28, 3],
        [41, 36],
        [39, 50],
        [12, 33],
        [-25, 23],
        [-56, 16],
        [-56, 8],
        [-45, 19],
        [-103, 87],
        [-35, 37],
        [-37, 35],
        [-161, 111],
        [-63, 46],
        [-37, 38],
        [-33, 35],
        [-49, 26],
        [-43, 0],
        [-36, 8],
        [-23, 24],
        [-43, 28],
        [-245, 178],
        [-29, 26],
        [-29, 27],
        [-80, 53],
        [-30, 15],
        [-22, -12],
        [-38, 10],
        [-14, 10],
        [-9, 28],
        [-58, 38],
        [-52, 36],
        [-55, 34],
        [-132, 67],
        [-11, 6],
        [-38, 14],
      ],
      [
        [141979, 194562],
        [-45, 17],
        [-105, 47],
        [-237, 108],
        [-53, -7],
        [-39, -9],
        [-69, 18],
        [-20, 36],
        [-18, 25],
        [-35, 20],
        [-2575, 3858],
        [-2, 4],
        [-479, 718],
        [2243, -348],
        [-1992, 5055],
        [-16, 43],
        [-378, 960],
        [1560, 1317],
        [1247, 189],
        [34, 16],
        [1, 3],
        [3, 11],
        [20, 14],
        [14, 10],
        [24, 6],
        [28, 4],
        [49, 14],
        [28, 2],
        [27, 6],
        [23, 4],
        [17, 4],
        [13, 7],
        [14, 8],
        [19, 8],
        [15, 14],
        [11, 11],
        [14, 2],
        [9, 8],
        [11, 5],
        [6, 12],
        [-7, 19],
        [1, 9],
        [-10, 14],
        [-14, 15],
        [-10, 9],
        [-15, 9],
        [-8, 11],
        [-20, 7],
        [-16, 9],
        [-14, 6],
        [-10, 6],
        [-8, 9],
        [-13, 13],
        [-4, 19],
        [1, 21],
        [9, 27],
        [13, 18],
        [14, 15],
        [18, 6],
        [15, 5],
        [14, 0],
        [151, 21],
        [55, 17],
        [30, 28],
        [5, 42],
        [-16, 25],
        [-19, 15],
        [-12, 19],
        [-12, 10],
        [-6, 16],
        [2, 22],
        [14, 10],
        [24, 2],
        [25, 10],
        [10, 9],
        [2, 16],
        [0, 27],
        [-2, 13],
        [-3, 15],
        [-3, 14],
        [-6, 17],
        [-8, 16],
        [-4, 16],
        [-9, 15],
        [-2, 16],
        [-6, 15],
        [-2, 18],
        [2, 17],
        [-8, 30],
        [-4, 14],
        [2, 16],
        [0, 14],
        [-2, 15],
        [-2, 22],
        [-10, 28],
        [-3, 16],
        [-7, 24],
        [6, 34],
        [2, 11],
        [6, 19],
        [51, 33],
        [57, 12],
        [47, -4],
        [64, -6],
        [68, 10],
        [28, 19],
        [24, 14],
        [15, 23],
        [17, 7],
        [1, 16],
        [-24, 18],
        [-43, 38],
        [-43, 24],
        [-28, 31],
        [-21, 36],
        [-2, 41],
        [10, 27],
        [21, 32],
        [18, 27],
        [12, 16],
        [7, 23],
        [8, 19],
        [3, 17],
        [-7, 31],
        [2, 16],
        [-10, 17],
        [-8, 15],
        [-13, 10],
        [-6, 15],
        [-11, 14],
        [-22, 19],
        [0, 13],
        [2, 21],
        [17, 24],
        [38, 18],
        [25, 13],
        [20, 11],
        [11, 11],
        [-2, 18],
        [-27, 44],
        [-24, 34],
        [-26, 27],
        [-7, 42],
        [5, 27],
        [9, 23],
        [10, 20],
        [9, 13],
        [11, 32],
        [25, 42],
        [21, 32],
        [10, 22],
        [14, 48],
        [9, 26],
        [3, 21],
        [-2, 16],
        [-12, 22],
        [-10, 30],
        [-10, 35],
        [-5, 31],
        [5, 27],
        [10, 22],
        [27, 37],
        [18, 22],
        [48, 60],
        [100, 5],
        [38, 26],
        [4, 63],
        [12, 111],
        [8, 39],
        [17, 40],
        [24, 29],
        [35, 28],
        [36, 28],
        [25, 12],
        [23, 17],
        [29, 27],
        [19, 10],
        [22, 10],
        [26, 19],
        [19, 14],
        [18, 9],
        [11, 9],
        [14, 5],
        [13, 3],
        [16, -2],
        [17, -14],
        [22, 4],
        [10, 17],
        [3, 25],
        [-5, 31],
        [-10, 47],
        [0, 36],
        [17, 25],
        [32, 25],
        [34, 20],
        [17, 142],
        [-49, 330],
        [-487, 562],
        [-917, -128],
        [-128, -25],
        [-105, 16],
        [-221, 182],
        [-138, 112],
        [-5, 17],
        [-11, 23],
        [-20, 28],
        [-28, 37],
        [-37, 39],
        [-52, 68],
        [-66, 82],
        [-30, 61],
        [-46, 60],
        [-47, 53],
        [-18, 29],
        [-11, 22],
        [4, 38],
        [14, 16],
        [15, 22],
        [23, 31],
        [26, 33],
        [24, 33],
        [22, 33],
        [-1, 28],
        [12, 36],
        [8, 31],
        [6, 12],
        [16, 8],
        [13, 18],
        [0, 24],
        [-7, 22],
        [-16, 11],
        [-13, 9],
        [-9, 7],
        [-14, 16],
        [-9, 25],
        [5, 26],
        [12, 25],
        [19, 15],
        [32, 13],
        [25, 6],
        [27, 8],
        [19, 10],
        [22, 22],
        [10, 8],
        [10, 0],
        [16, -4],
        [10, -14],
        [15, -4],
        [12, 2],
        [18, 4],
        [12, 10],
        [2, 18],
        [0, 36],
        [0, 31],
        [-2, 40],
        [-4, 28],
        [-4, 16],
        [-12, 4],
        [-20, 4],
        [-20, 4],
        [-21, 6],
        [-22, 4],
        [-17, 3],
        [-13, 11],
        [-15, 16],
        [-16, 36],
        [16, 24],
        [0, 24],
        [2, 21],
        [6, 24],
        [17, 21],
        [15, 17],
        [23, 17],
        [25, 14],
        [18, 6],
        [27, 0],
        [21, -2],
        [20, -2],
        [19, 2],
        [18, 12],
        [16, 10],
        [5, 13],
        [6, 19],
        [10, 27],
        [-10, 21],
        [8, 15],
        [14, 4],
        [12, 7],
        [21, 13],
        [8, 12],
        [0, 12],
        [-6, 10],
        [-10, 6],
        [-21, 4],
        [-24, 6],
        [-27, 3],
        [-12, 8],
        [-13, 6],
        [-14, 3],
        [-12, 0],
        [-12, -1],
        [-15, 0],
        [-22, 4],
        [-17, 4],
        [-19, 3],
        [-20, 15],
        [-6, 15],
        [-12, 12],
        [-6, 12],
        [-2, 5],
        [-2, 4],
        [2, 14],
        [2, 10],
        [6, 24],
        [10, 35],
        [8, 37],
        [-2, 65],
        [8, 55],
        [-20, 33],
        [-3, 22],
        [-29, 26],
        [-23, 24],
        [-15, 14],
        [-30, 3],
        [-34, 5],
        [-18, 2],
        [-13, 5],
        [-20, 5],
        [-6, 25],
        [-6, 22],
        [2, 26],
        [8, 23],
        [12, 18],
        [17, 11],
        [16, 16],
        [-4, 34],
        [-6, 21],
        [-9, 14],
        [-18, 21],
        [12, 28],
        [13, 28],
        [34, 11],
        [29, 4],
        [28, -6],
        [22, -29],
        [19, -14],
        [19, -19],
        [23, -18],
        [17, -18],
        [9, -14],
        [14, -5],
        [8, -5],
        [11, -2],
        [11, -3],
        [17, 9],
        [8, 1],
        [0, 19],
        [0, 18],
        [-2, 18],
        [4, 19],
        [2, 22],
        [-6, 31],
        [0, 29],
        [21, 22],
        [2, 22],
        [-5, 21],
        [-18, 13],
        [-17, 23],
        [-23, 14],
        [-11, 10],
        [-8, 5],
        [-11, 4],
        [-13, 9],
        [-12, 8],
        [-4, 16],
        [-16, 25],
        [-23, 9],
        [-12, 12],
        [-16, 7],
        [-13, 11],
        [-14, 15],
        [-11, 26],
        [3, 40],
        [8, 21],
        [18, 24],
        [15, 14],
        [14, 15],
        [23, 5],
        [26, 10],
        [21, 6],
        [14, 4],
        [10, 8],
        [5, 21],
        [-7, 16],
        [-7, 18],
        [-5, 28],
        [-9, 24],
        [-12, 25],
        [-2, 27],
        [-6, 35],
        [-8, 35],
        [-14, 33],
        [-1, 21],
        [-3, 33],
        [-4, 27],
        [28, 21],
        [14, 15],
        [17, 9],
        [18, 15],
        [23, 0],
        [23, 7],
        [34, -6],
        [39, -6],
        [27, -7],
        [30, 7],
        [19, 10],
        [17, 14],
        [9, 16],
        [3, 16],
        [-4, 14],
        [-25, 33],
        [-19, 8],
        [-10, 13],
        [-8, 22],
        [1937, 37],
        [-29, -29],
        [-6, -45],
        [14, -15],
        [12, -10],
        [16, -18],
        [-9, -24],
        [8, -28],
        [13, -13],
        [0, -17],
        [-2, -14],
        [1, -17],
        [3, -14],
        [2, -18],
        [-6, -16],
        [-11, -10],
        [-25, -13],
        [-17, -18],
        [0, -14],
        [9, -14],
        [6, -14],
        [-12, -26],
        [39, -25],
        [-14, -24],
        [-13, -15],
        [-17, -10],
        [17, -1],
        [19, -4],
        [9, -10],
        [12, -39],
        [12, -13],
        [17, -6],
        [26, 0],
        [17, 0],
        [10, 10],
        [18, 5],
        [21, 5],
        [26, 4],
        [14, 2],
        [19, -2],
        [21, 0],
        [19, -4],
        [14, -10],
        [14, -4],
        [25, 0],
        [27, 2],
        [13, 10],
        [12, 15],
        [15, 6],
        [24, 0],
        [19, -18],
        [17, -5],
        [10, -16],
        [9, -28],
        [10, -27],
        [0, -25],
        [2, -20],
        [8, -16],
        [10, -10],
        [2, 13],
        [8, 16],
        [8, 9],
        [19, 2],
        [15, -10],
        [6, -13],
        [8, -12],
        [7, -6],
        [11, -1],
        [12, -11],
        [10, -2],
        [18, -4],
        [26, 1],
        [19, 1],
        [32, 5],
        [19, 8],
        [22, 4],
        [23, 9],
        [20, 8],
        [20, 8],
        [16, 7],
        [27, 1],
        [20, -9],
        [11, -3],
        [13, -10],
        [17, 2],
        [12, 9],
        [18, 6],
        [9, 8],
        [10, 17],
        [6, 26],
        [-1, 25],
        [1, 16],
        [22, 4],
        [18, 0],
        [20, 0],
        [4, 16],
        [10, 11],
        [7, 12],
        [7, 9],
        [2, 20],
        [8, 28],
        [18, 10],
        [18, 4],
        [12, 2],
        [20, 4],
        [15, 4],
        [26, 4],
        [16, 6],
        [18, 6],
        [16, 7],
        [10, 24],
        [-8, 24],
        [-12, 12],
        [-10, 6],
        [-14, 6],
        [-9, 7],
        [-5, 9],
        [-10, 9],
        [-14, 11],
        [-11, 7],
        [-12, 7],
        [-8, 15],
        [4, 9],
        [12, 4],
        [19, 0],
        [20, -1],
        [16, 3],
        [9, 6],
        [7, 11],
        [4, 12],
        [6, 17],
        [4, 21],
        [8, 10],
        [12, 11],
        [9, 6],
        [34, 14],
        [36, 14],
        [38, 16],
        [22, 10],
        [20, 11],
        [32, 2],
        [15, 3],
        [30, 1],
        [22, 13],
        [18, 17],
        [8, 19],
        [0, 21],
        [10, 14],
        [27, 4],
        [26, -6],
        [14, -10],
        [13, -10],
        [7, 77],
        [191, -33],
        [713, 355],
        [3858, 1973],
        [117, 61],
        [174, 101],
        [3368, 1987],
        [222, 131],
        [-1306, 2151],
        [4, 30],
      ],
      [
        [271304, 272022],
        [-1075, 2639],
        [-639, 1567],
        [-1063, 2610],
        [-4979, -1953],
        [-5106, -2008],
        [-20, 23],
        [1, 26],
        [-12, 11],
        [-29, 15],
        [-25, 13],
        [-23, 8],
        [-25, 11],
        [-22, 9],
        [-23, 11],
        [-42, 24],
        [-42, 24],
        [-20, 22],
        [-37, 25],
        [-14, 13],
        [-13, 11],
        [-7, 8],
        [-10, 24],
        [-4, 14],
        [-2, 12],
        [0, 16],
        [-6, 22],
        [4, 16],
        [10, 43],
        [13, 37],
        [12, 34],
        [12, 28],
        [26, 20],
        [5, 7],
        [5, 6],
        [16, 28],
        [6, 9],
        [4, 19],
        [5, 35],
        [-5, 39],
        [-12, 36],
        [-10, 22],
        [-9, 26],
        [-15, 18],
        [-26, 43],
        [-24, 38],
        [-5, 28],
        [-6, 16],
        [4, 49],
        [9, 25],
        [10, 17],
        [19, 24],
        [19, 25],
        [12, 37],
        [1, 15],
        [-4, 33],
        [1, 18],
        [3, 48],
        [-21, 38],
        [-11, 17],
        [-17, 23],
        [-21, 25],
        [-12, 16],
        [-15, 23],
        [-14, 14],
        [-14, 12],
        [-25, 28],
        [-6, 15],
        [-26, 24],
        [-23, 16],
        [-19, 24],
        [-14, 11],
        [-16, 11],
        [-15, 20],
        [-39, 31],
        [-41, 42],
        [-59, 37],
        [-53, 26],
        [-36, 23],
        [-24, 15],
        [-41, 13],
        [-33, 10],
        [-24, 4],
        [-47, -4],
        [-19, -4],
        [-21, -18],
        [-23, -7],
        [-39, -5],
        [-22, 3],
        [-12, 4],
        [-13, 4],
        [-8, 3],
        [-11, 3],
        [-16, 12],
        [-27, 12],
        [-22, 9],
        [-33, 11],
        [-47, 21],
        [-38, 0],
        [-34, 28],
        [-48, 8],
        [-44, 14],
        [-59, -28],
        [-40, -10],
        [-25, -16],
        [-26, -20],
        [-15, -24],
        [-26, -44],
        [-23, -43],
        [-17, -31],
        [-11, -23],
        [-8, -15],
        [-4, -12],
        [-3, -19],
        [-6, -17],
        [1, -15],
        [2, -20],
        [0, -19],
        [4, -28],
        [6, -12],
        [9, -10],
        [7, -17],
        [4, -25],
        [10, -14],
        [5, -16],
        [6, -18],
        [-10, -14],
        [-7, -15],
        [-2, -12],
        [-22, -13],
        [-34, -4],
        [-45, 4],
        [-41, 20],
        [-32, 11],
        [-50, 17],
        [-60, 6],
        [-20, 16],
        [-15, 14],
        [-25, 6],
        [-20, 10],
        [-7, 2],
        [-7, 2],
        [-13, -2],
        [-14, -8],
        [-18, -6],
        [-16, -32],
        [-12, -34],
        [-24, -44],
        [-8, -24],
        [-4, -27],
        [-8, -22],
        [-4, -26],
        [-7, -15],
        [-20, -22],
        [-11, -14],
        [-26, -25],
        [-17, -9],
        [-18, -11],
        [-15, -15],
        [-14, -33],
        [-17, -42],
        [-13, -32],
        [-1, -2],
        [-5, -34],
        [-1, -24],
        [7, -8],
        [3, -16],
        [5, -13],
        [23, -22],
        [3, -2],
        [17, -22],
        [10, -12],
        [-4, -12],
        [-9, -8],
        [-12, -12],
        [-16, -25],
        [-28, 7],
        [-29, 14],
        [-22, 10],
        [-35, 6],
        [-30, -8],
        [-18, -16],
        [-19, 5],
        [-16, -6],
        [-15, -23],
        [-21, -15],
        [-27, -29],
        [-23, -15],
        [-12, -31],
        [-20, -7],
        [-23, -21],
        [-21, -26],
        [-23, -12],
        [-33, -17],
        [-25, 0],
        [-32, 24],
        [-24, 16],
        [-24, 20],
        [-13, 6],
        [-12, 7],
        [-16, 9],
        [-16, 10],
        [-28, 4],
        [-24, 12],
        [-18, 6],
        [-26, 4],
        [-19, 2],
        [-11, 0],
        [-10, -2],
        [-20, -6],
        [-23, -12],
        [-26, -21],
        [-23, -10],
        [-18, -10],
        [-15, -15],
        [-17, -20],
        [-12, -30],
        [-17, -32],
        [-12, -41],
        [-10, -43],
        [4, -50],
        [2, -64],
        [10, -45],
        [10, -32],
        [0, -22],
        [4, -22],
        [0, -12],
        [-1, -24],
        [3, -33],
        [-9, -27],
        [-4, -20],
        [-11, -9],
        [-10, -5],
        [-10, -6],
        [-37, 13],
        [-1027, 459],
        [-6, 13],
        [-6, 13],
        [-39, 99],
        [-86, 10],
        [-13, 29],
        [-56, 70],
        [-31, 36],
        [-26, 30],
        [-20, 241],
        [-12, 38],
        [-44, 15],
        [-87, 49],
        [-71, 32],
        [-61, -32],
        [-47, -62],
        [-37, -30],
        [-15, -16],
        [-111, 2],
        [-112, 48],
        [-147, 14],
        [-67, 18],
        [-67, 18],
        [-126, 114],
        [-51, 69],
        [-77, 221],
        [-18, 46],
        [16, 52],
        [25, 33],
        [25, 34],
        [44, 62],
        [18, 101],
        [8, 60],
        [25, 52],
        [1, 73],
        [29, 67],
        [73, 96],
        [51, 76],
        [30, 65],
        [19, 24],
        [19, 24],
        [52, 35],
        [55, 3],
        [48, 88],
        [6, 11],
        [82, 78],
        [51, 48],
        [63, 46],
        [34, 34],
        [35, 35],
        [34, 22],
        [50, 42],
        [-86, -1],
        [-1, 0],
        [-73, -4],
        [-146, 5],
        [-55, 66],
        [-37, 111],
        [-23, 105],
        [9, 51],
        [55, 86],
        [44, 65],
        [-16, 49],
        [-44, 43],
        [-31, 40],
        [-60, 58],
        [-67, 88],
        [-161, 249],
        [-87, 117],
        [-27, 30],
        [-3, 93],
        [-31, 100],
        [-80, 90],
        [-90, 90],
        [-76, 98],
        [-33, 28],
        [-36, 17],
        [-36, 33],
        [-34, 130],
        [-101, 5],
        [-56, -6],
        [-21, -36],
        [-62, 56],
        [-109, 112],
        [-28, 19],
        [-35, -17],
        [-29, -53],
        [-52, -105],
        [-45, -58],
        [-27, -24],
        [-27, -25],
        [-45, -26],
        [-41, -10],
        [-44, -12],
        [-96, 12],
        [-124, -22],
        [-57, -12],
        [-28, -2],
        [-122, 41],
        [-53, -27],
        [-46, -47],
        [-63, -62],
        [-60, -105],
        [1, -13],
        [10, -51],
        [-41, -12],
        [-42, -10],
        [62, -99],
        [-4, -24],
        [-38, -18],
        [-197, 99],
        [-31, -2],
        [-52, -6],
        [-204, -51],
        [-118, -60],
        [-94, -30],
        [-26, -60],
        [-10, -43],
        [-92, -97],
        [-121, -65],
        [-161, -22],
        [-78, 36],
        [-13, 8],
        [-13, 6],
        [-76, 98],
        [-60, 48],
        [-60, -12],
        [-81, -16],
        [-135, 10],
        [-291, 26],
        [-277, 46],
        [-72, 11],
        [-42, 36],
        [-40, 52],
        [-108, 24],
        [-332, 48],
        [-26, 17],
        [-48, 62],
        [-264, 183],
        [-62, 20],
        [-97, 19],
        [-88, -48],
        [-90, -26],
        [-66, 7],
        [-26, 4],
        [-89, 113],
        [-68, -79],
        [-87, -46],
        [-1, 0],
        [-61, 6],
        [-60, 7],
        [10, 78],
        [-93, 0],
        [-31, -93],
        [-38, 1],
        [-54, -2],
        [-54, -8],
        [-40, 25],
        [-96, 39],
        [8, 68],
        [-45, 47],
        [-162, -10],
        [-19, 0],
        [-18, 1],
        [-74, -20],
        [-62, -65],
        [-14, -11],
        [-10, -12],
        [-12, -14],
        [-12, -16],
        [-22, -15],
        [-26, -18],
        [-21, -10],
        [-25, -1],
        [-19, 3],
        [-17, 4],
        [-11, 7],
        [-12, 9],
        [-14, 4],
        [-8, 0],
        [-23, -6],
        [-46, -6],
        [-26, -14],
        [-23, -24],
        [-23, -19],
        [-24, -13],
        [-21, 8],
        [-46, 32],
        [-26, 30],
        [-31, 25],
        [-22, 19],
        [-12, 10],
        [-12, -5],
        [-2, -17],
        [-12, -17],
        [-18, -15],
        [-23, -17],
        [-10, -21],
        [-11, -11],
        [-36, 2],
        [-23, 1],
        [-24, 10],
        [-18, 4],
        [-31, -6],
        [-41, -3],
        [-1, -7],
        [16, -13],
        [49, -28],
        [34, -21],
        [-8, -92],
        [14, -26],
        [12, -22],
        [13, -12],
        [16, -14],
        [7, -16],
        [4, -8],
        [9, -10],
        [14, -20],
        [9, -22],
        [15, -14],
        [9, -14],
        [11, -21],
        [15, -18],
        [8, -8],
        [9, -10],
        [10, -12],
        [14, -12],
        [16, -17],
        [14, -26],
        [8, -14],
        [2, -26],
        [0, -21],
        [-4, -12],
        [-3, -6],
        [1, -6],
        [17, -16],
        [12, -19],
        [12, -17],
        [2, -11],
        [-6, -16],
        [-7, -10],
        [-1, -13],
        [8, -25],
        [-10, -18],
        [-8, -20],
        [-15, -37],
        [-2, -18],
        [0, -37],
        [11, -32],
        [0, -31],
        [10, -22],
        [12, -14],
        [8, -7],
        [6, -5],
        [12, -10],
        [13, -43],
        [6, -14],
        [7, -24],
        [-2, -23],
        [-8, -11],
        [-2, -11],
        [-2, -15],
        [-10, -11],
        [-12, -20],
        [-25, -22],
        [-43, -14],
        [-16, -4],
        [-9, -10],
        [-8, -19],
        [-17, -16],
        [-19, -8],
        [-14, 0],
        [-13, 1],
        [-23, 4],
        [-30, 17],
        [-33, 20],
        [-28, 21],
        [-12, 10],
        [-12, 10],
        [-8, 4],
        [-7, 4],
        [-3, 0],
        [-12, 0],
        [-7, 4],
        [-5, 4],
        [-10, 0],
        [-11, 10],
        [-19, 10],
        [-21, 10],
        [-9, 6],
        [-15, 8],
        [-22, 4],
        [-21, 13],
        [-15, 4],
        [-8, -1],
        [-8, -1],
        [-10, -1],
        [-7, -1],
        [-13, -2],
        [-9, -4],
        [-10, 5],
        [-11, 8],
        [-6, 7],
        [-11, 6],
        [-2, 1],
        [-3, 0],
        [-9, 3],
        [-13, -1],
        [-8, 2],
        [-10, 2],
        [-4, 4],
        [-12, 8],
        [-7, 6],
        [-15, 13],
        [-16, 19],
        [-12, 17],
        [-15, 10],
        [-17, 4],
        [-27, 5],
        [-16, 10],
        [-12, 12],
        [-14, 21],
        [-13, 44],
        [-7, 26],
        [-14, 30],
        [-12, 21],
        [2, 27],
        [0, 34],
        [-12, 24],
        [-16, 27],
        [-30, 15],
        [-26, 7],
        [-18, -6],
        [-16, -10],
        [-20, -4],
        [-11, -2],
        [-12, 0],
        [-32, -2],
        [-21, 5],
        [-8, 9],
        [-6, 13],
        [-9, 11],
        [-6, 12],
        [-1, 7],
        [4, 11],
        [1, 14],
        [-6, 14],
        [-16, 20],
        [-20, 10],
        [-20, 1],
        [-20, 0],
        [-17, -7],
        [-17, -8],
        [-22, -8],
        [-20, 0],
        [-12, 4],
        [-14, 4],
        [-12, -4],
        [-20, 19],
        [-23, 18],
        [-13, 5],
        [-5, 5],
        [-12, 8],
        [-10, 8],
        [-8, 6],
        [-2, 8],
        [2, 4],
        [4, 7],
        [-2, 6],
        [-2, 7],
        [-2, 7],
        [-2, 7],
        [-7, 8],
        [-14, 5],
        [-19, -2],
        [-5, 4],
        [-5, 2],
        [-2, 8],
        [4, 10],
        [3, 3],
        [4, 4],
        [1, 10],
        [0, 15],
        [4, 6],
        [7, 9],
        [4, 8],
        [0, 25],
        [-4, 17],
        [-7, 18],
        [-13, 8],
        [-11, 4],
        [-22, 4],
        [-6, 6],
        [-2, 6],
        [0, 8],
        [8, 14],
        [10, 9],
        [0, 14],
        [-8, 8],
        [-14, 6],
        [-18, 3],
        [-19, -2],
        [-15, 6],
        [-6, 14],
        [-7, 14],
        [-7, 15],
        [-11, 18],
        [-12, 12],
        [-19, 14],
        [-17, 4],
        [-17, 13],
        [-15, 12],
        [-7, 4],
        [-7, 4],
        [-8, 1],
        [-4, -2],
        [-4, -4],
        [-6, -7],
        [-9, 1],
        [-5, 2],
        [-5, 5],
        [-2, 5],
        [0, 4],
        [3, 7],
        [4, 10],
        [3, 9],
        [1, 20],
        [-1, 35],
        [-4, 5],
        [-6, 0],
        [-4, -5],
        [-8, -2],
        [-5, 6],
        [-10, 11],
        [-2, 17],
        [-2, 8],
        [-9, 18],
        [-12, 21],
        [-4, 24],
        [0, 16],
        [7, 4],
        [9, -6],
        [6, -6],
        [3, -2],
        [3, -4],
        [5, -5],
        [5, 1],
        [6, 2],
        [12, 8],
        [13, 14],
        [2, 4],
        [0, 8],
        [0, 6],
        [-3, 8],
        [-4, 2],
        [-6, 0],
        [-6, -2],
        [-6, -4],
        [-8, 0],
        [-8, 2],
        [-5, 6],
        [-3, 6],
        [0, 8],
        [5, 5],
        [4, 9],
        [2, 3],
        [-2, 2],
        [-4, -2],
        [-13, -2],
        [-22, -1],
        [-10, 5],
        [-4, 5],
        [-4, 7],
        [0, 11],
        [2, 11],
        [-6, 13],
        [-6, 1],
        [-5, 4],
        [0, 5],
        [2, 5],
        [3, 12],
        [5, 10],
        [13, 22],
        [20, 32],
        [6, 23],
        [6, 33],
        [0, 10],
        [9, 39],
        [-2, 28],
        [-3, 34],
        [7, 12],
        [10, 7],
        [15, 1],
        [9, 7],
        [16, 23],
        [16, 18],
        [8, 26],
        [-8, 18],
        [-16, 11],
        [-13, 4],
        [-14, 14],
        [-7, 13],
        [-8, 17],
        [-3, 21],
        [2, 10],
        [3, 15],
        [7, 26],
        [3, 20],
        [0, 7],
        [5, 8],
        [-3, 12],
        [-8, 3],
        [-2, 6],
        [5, 13],
        [7, 24],
        [8, 23],
        [-9, 22],
        [-6, 21],
        [-13, 16],
        [-2, 12],
        [3, 10],
        [5, 8],
        [8, 10],
        [10, 0],
        [5, 9],
        [0, 15],
        [-6, 21],
        [-10, 21],
        [-8, 22],
        [-5, 22],
        [-27, 2],
        [-68, 6],
        [-1218, 76],
        [-1959, 164],
        [-1010, 2075],
        [-42, 87],
        [-869, 1823],
        [-423, 884],
        [-587, 1230],
        [-1427, 3042],
        [218, -1022],
        [295, -1133],
        [629, -2427],
        [-406, -59],
        [-110, -17],
        [-1431, 399],
        [-403, 27],
        [-115, -7],
        [-5, -233],
        [33, -197],
        [200, -295],
        [-515, 499],
        [-1815, 71],
        [243, 1172],
        [-18, 5],
        [-30, 10],
        [-52, 2],
        [-22, -3],
        [-24, -19],
        [-19, 3],
        [-42, 21],
        [-44, -7],
        [-38, -21],
        [-59, 48],
        [17, 24],
        [28, -24],
        [30, 77],
        [-55, 37],
        [9, 43],
        [-7, 23],
        [-17, 23],
        [-15, 34],
        [-3, 24],
        [10, 25],
        [3, 21],
        [-10, 9],
        [-11, 13],
        [-13, 23],
        [-24, 32],
        [-19, 55],
        [-15, 41],
        [-12, 42],
        [-10, 17],
        [-23, 10],
        [-21, 13],
        [-28, 16],
        [-23, 16],
        [-23, 18],
        [-17, 37],
        [-13, 21],
        [-1, 41],
        [-1, 34],
        [-8, 7],
        [-10, 29],
        [-6, 44],
        [-12, 32],
        [-21, 24],
        [-28, 42],
        [-14, 36],
        [-16, 23],
        [-25, 18],
        [-43, 14],
        [-30, 38],
        [-24, 31],
        [-44, 42],
        [-39, 29],
        [-60, 52],
        [-34, 45],
        [-34, 41],
        [-53, 41],
        [-30, 38],
        [-21, 34],
        [-6, 22],
        [-922, -286],
        [-1491, 3002],
        [-374, -873],
        [0, 35],
        [0, 45],
        [0, 214],
        [-14, 45],
        [4, 69],
        [-4, 40],
        [6, 38],
        [-19, 20],
        [-35, 4],
        [-32, 31],
        [-43, 22],
        [-29, 8],
        [-33, 18],
        [-4, 34],
        [-10, 14],
        [-9, 40],
        [-4, 37],
        [0, 51],
        [5, 51],
        [20, 57],
        [-10, 25],
        [-21, 22],
        [-17, 52],
        [0, 54],
        [-4, 41],
        [-16, 15],
        [-12, 32],
        [-41, 21],
        [-44, 21],
        [-39, 60],
        [-44, 33],
        [-48, 56],
        [-19, 10],
        [-35, 28],
        [-41, 21],
        [-46, 21],
        [-21, 27],
        [2, 24],
        [19, 24],
        [20, 18],
        [26, 10],
        [6, 16],
        [-50, 48],
        [0, 0],
        [10, 43],
        [-22, 46],
        [-17, 50],
        [14, 31],
        [13, 46],
        [-8, 42],
        [-9, 39],
        [-29, 75],
        [-19, 17],
        [-30, 4],
        [-19, 0],
        [-25, -1],
        [-40, -1],
        [-33, 6],
        [-23, 8],
        [-25, 2],
        [-34, -6],
        [-29, -24],
        [-30, -38],
        [-17, -16],
        [-10, -12],
        [-27, -28],
        [-54, -40],
        [-40, -14],
        [-13, -5],
        [-67, -16],
        [-72, 24],
        [-305, 55],
        [-18, 32],
        [-27, 4],
        [-61, -32],
        [-28, -21],
        [-32, -23],
        [-30, -24],
        [-11, -4],
        [-10, -4],
        [-27, -4],
        [-31, -17],
        [-62, -35],
        [-36, -17],
        [-30, -6],
        [-21, -89],
        [-43, -30],
        [-52, -45],
        [-31, -26],
        [-40, 0],
        [-57, 4],
        [-21, 0],
        [-90, 11],
        [-42, -12],
        [-75, -3],
        [-98, -2],
        [-45, 4],
        [-43, 16],
        [-67, -4],
        [-81, -4],
        [-61, 4],
        [-26, -38],
        [-21, -12],
        [-29, -8],
        [-105, -40],
        [-44, -20],
        [-50, -51],
        [-71, -34],
        [-53, -40],
        [-41, -49],
        [-24, -47],
        [-10, -33],
        [-24, -79],
        [-25, -80],
        [-56, -51],
        [-46, -48],
        [-40, -3],
        [-136, 53],
        [1140, -2525],
        [-2395, 2005],
        [-3145, 3765],
        [-563, -586],
        [-1210, 161],
        [-262, 1527],
        [-205, -287],
        [-252, -341],
        [-75, -92],
        [-41, -5],
        [-61, -11],
        [-63, 80],
        [-106, 114],
        [-163, 162],
        [-298, 200],
        [-326, 144],
        [-250, 174],
        [-64, 4],
        [-47, -7],
        [-117, -19],
        [-72, 23],
        [-68, 28],
        [-59, 12],
        [-109, 6],
        [-50, 3],
        [-24, -58],
        [-77, -174],
        [-1737, 1492],
        [-167, 140],
        [-1369, 1152],
        [-208, 175],
        [-1225, 815],
        [-137, 116],
        [-62, 52],
        [-904, 768],
        [-104, 88],
        [-772, 655],
        [-1094, -1151],
        [-500, -1261],
        [-129, -281],
        [-145, -344],
        [-33, -69],
        [0, -4],
        [-376, -792],
        [-205, -380],
        [-209, -366],
        [-7, -14],
        [-597, -1050],
        [-132, 4],
        [-136, -1],
        [-268, 268],
        [-63, 69],
        [-71, 23],
        [-28, 5],
        [-147, 20],
        [-28, 66],
        [-50, 105],
        [-166, 228],
        [-215, 247],
        [-73, 82],
        [-60, 95],
        [-21, 30],
        [-64, 100],
        [-111, -6],
        [-31, -29],
        [-280, 21],
        [-13, -2],
        [-13, 0],
        [-61, -7],
        [-25, -20],
        [-81, -58],
        [-60, -33],
        [-70, -2],
        [-79, 16],
        [-65, -72],
        [-48, -35],
        [-49, -37],
        [-97, -23],
        [-75, 68],
        [-29, 27],
        [-61, -93],
        [-135, -79],
        [-3, -1],
        [-45, -38],
        [-51, -50],
        [-225, -47],
        [-115, -16],
        [-125, -38],
        [-65, -10],
        [-75, 27],
        [-59, 32],
        [-21, 25],
        [-22, 27],
        [-79, 69],
        [-77, 73],
        [-73, 18],
        [-130, -28],
        [-91, 16],
        [-45, 28],
        [-35, 0],
        [-54, -4],
        [-22, -28],
        [-20, -21],
        [-23, -22],
        [-28, -36],
        [-105, -30],
        [-116, -15],
        [-112, 3],
        [-40, -42],
        [2, -61],
        [-13, -29],
        [-18, -18],
        [14, -50],
        [9, -47],
        [-6, -32],
        [-13, -40],
        [-3, -39],
        [5, -63],
        [-20, -59],
        [-39, -31],
        [-29, -12],
        [-23, -60],
        [0, -16],
        [7, -63],
        [43, -70],
        [369, -442],
        [44, -77],
        [12, -25],
        [25, -62],
        [3, -42],
        [20, -62],
        [57, -84],
        [-8, -37],
        [-47, -34],
        [-70, -29],
        [-10, -110],
        [-2, -63],
        [-25, -79],
        [-58, -92],
        [-46, -30],
        [-99, 28],
        [-30, 78],
        [-6, 6],
        [-55, 50],
        [-20, -17],
        [-4, -2],
        [-33, -48],
        [-27, -129],
        [14, -39],
        [59, -9],
        [72, -31],
        [18, -58],
        [-7, -78],
        [-62, -47],
        [-75, -40],
        [-27, -30],
        [-8, -85],
        [4, -10],
        [91, -204],
        [29, -102],
        [52, -255],
        [727, -83],
        [76, -8],
        [342, -38],
        [251, -30],
        [85, -6],
        [70, -17],
        [537, -244],
        [62, -27],
        [22, -10],
        [85, -81],
        [80, -53],
        [85, -18],
        [105, -117],
        [139, -130],
        [62, -41],
        [42, -26],
        [47, -259],
        [8, -201],
        [6, -114],
        [12, -109],
        [-4, -91],
        [-27, -69],
        [-48, -39],
        [-20, -54],
        [11, -29],
        [11, -37],
        [-6, -71],
        [-18, -34],
        [-49, 8],
        [-87, 95],
        [-59, 29],
        [-35, 23],
        [-54, 30],
        [-42, 16],
        [-67, 62],
        [-68, 126],
        [-106, 162],
        [-56, 70],
        [-25, 18],
        [-26, 18],
        [-43, -4],
        [-43, -4],
        [-23, 20],
        [-24, 17],
        [-67, 58],
        [-68, 59],
        [-38, 1],
        [-31, -40],
        [-32, -42],
        [-71, -35],
        [-50, -6],
        [-122, -14],
        [-70, -40],
        [-19, -38],
        [-22, -32],
        [-20, -43],
        [-33, -44],
        [-16, -8],
        [-16, -10],
        [-28, 0],
        [-27, 2],
        [-28, -14],
        [-59, -38],
        [-53, -48],
        [-49, -12],
        [-37, 27],
        [-112, 79],
        [-30, 18],
        [-76, 51],
        [-79, 27],
        [-82, 37],
        [-51, 14],
        [-65, -28],
        [-89, -42],
        [-93, -1],
        [-27, 3],
        [-33, 3],
        [-26, -24],
        [-21, -30],
        [-33, -45],
        [-6, -5],
        [-54, -62],
        [-46, -48],
        [-77, -99],
        [-47, -50],
        [-67, -37],
        [-71, 3],
        [-35, 0],
        [-114, 4],
        [-117, 9],
        [-80, 0],
        [-49, -20],
        [-45, -45],
        [-48, -61],
        [-65, -81],
        [-51, -78],
        [-2, -50],
        [44, -35],
        [86, -24],
        [24, -17],
        [41, -98],
        [67, -161],
        [25, -123],
        [5, -58],
        [-13, -55],
        [4, -87],
        [-37, -37],
        [-59, -16],
        [-85, 1],
        [-34, -18],
        [-7, -10],
        [-19, -42],
        [-34, -51],
        [-4, -30],
        [-18, -31],
        [-10, -29],
        [-21, -24],
        [10, -27],
        [38, -29],
        [14, -28],
        [10, -68],
        [26, -32],
        [25, -32],
        [-13, -47],
        [-14, -42],
        [19, -42],
        [31, -13],
        [6, -24],
        [-38, -20],
        [-42, 30],
        [-16, 93],
        [-15, 73],
        [-51, 44],
        [-66, 46],
        [-2, 58],
        [-37, 57],
        [-60, 70],
        [-2, 42],
        [-38, 42],
        [-43, 26],
        [-44, 28],
        [-112, 32],
        [-69, -46],
        [-61, -49],
        [-28, -93],
        [18, -102],
        [78, -144],
        [11, -52],
        [-25, -33],
        [-70, 29],
        [-76, 90],
        [-107, 172],
        [-35, 57],
        [-29, -11],
        [-34, -42],
        [-25, -45],
        [-92, -24],
        [-44, -2],
        [-80, -87],
        [-17, -78],
        [15, -56],
        [55, -73],
        [31, -40],
        [5, -48],
        [2, -59],
        [3, -70],
        [4, -86],
        [18, -98],
        [-23, -41],
        [-67, 12],
        [-54, -5],
        [-58, -21],
        [-28, -8],
        [-28, -11],
        [-55, -6],
        [-52, -57],
        [-32, -37],
        [-199, -225],
        [-12, -18],
        [-14, -17],
        [-71, -95],
        [-49, -170],
        [-38, -34],
        [-38, -36],
        [-33, -71],
        [34, -168],
        [38, -46],
        [33, -103],
        [-14, -68],
        [-29, -23],
        [-41, -37],
        [-27, -24],
        [-24, -24],
        [-41, -42],
        [-29, -45],
        [-24, -81],
        [36, -67],
        [-61, -102],
        [-5, -79],
        [7, -105],
        [115, -51],
        [53, -85],
        [-21, -65],
        [-45, -14],
        [-61, -21],
        [-70, 0],
        [-92, -26],
        [-58, -70],
        [-29, -54],
        [15, -179],
        [55, -225],
        [19, -24],
        [19, -24],
        [21, -54],
        [-23, -59],
        [-7, -17],
        [-110, -318],
        [-20, -58],
        [-56, -158],
        [31, -152],
        [-10, -49],
        [-6, -48],
        [-51, -16],
        [-92, 61],
        [-48, 46],
        [-49, -7],
        [-28, -48],
        [-21, -68],
        [-40, -55],
        [38, -88],
        [55, -35],
        [33, -39],
        [6, -44],
        [-29, -45],
        [-33, -22],
        [-63, -9],
        [-96, 15],
        [-13, 97],
        [-15, 113],
        [-72, 46],
        [-55, -20],
        [-33, -67],
        [31, -214],
        [-4, -149],
        [-8, -131],
        [52, -98],
        [-22, -66],
        [-24, -63],
        [-20, -122],
        [0, -34],
        [0, -86],
        [12, -104],
        [10, -63],
        [22, -94],
        [0, -28],
        [1, -72],
        [-23, -52],
        [-44, -90],
        [1, -25],
        [-6, -83],
        [18, -59],
        [50, -15],
        [43, 7],
        [14, 5],
        [72, 27],
        [78, -24],
        [-17, -63],
        [4, -71],
        [-18, -104],
        [-19, -74],
        [-21, -78],
        [-22, -78],
        [19, -68],
        [9, -33],
        [2, -6],
        [61, -94],
        [21, -23],
        [82, -63],
        [10, -8],
        [0, -106],
        [-47, -109],
        [-57, -80],
        [-86, -66],
        [-56, -114],
        [40, -82],
        [-36, -158],
        [69, -100],
        [86, -166],
        [-57, -135],
        [-30, -52],
        [-190, 173],
        [-132, 121],
        [-54, -51],
        [-62, -732],
        [-20, -182],
        [-23, -252],
        [-1551, -570],
        [-733, -245],
        [-121, -48],
        [525, -265],
        [73, -35],
        [54, -26],
        [-600, -915],
        [-84, -114],
        [114, -115],
        [40, -40],
        [38, -37],
        [129, -58],
        [90, -22],
        [144, -22],
        [128, 0],
        [183, -12],
        [264, -6],
        [289, -12],
        [75, 13],
        [87, 7],
        [74, 10],
        [4, -23],
        [2, -15],
        [4, -17],
        [7, -32],
        [-4, -39],
        [-28, -61],
        [3, -110],
        [-36, -160],
        [-32, -106],
        [37, -86],
        [116, -148],
        [41, -136],
        [46, -154],
        [-37, -102],
        [-6, -93],
        [34, -83],
        [85, -54],
        [160, -263],
        [-68, -56],
        [-62, -45],
        [-54, -59],
        [-25, -79],
        [68, -90],
        [170, -207],
        [133, -142],
        [12, -123],
        [15, -149],
        [82, -65],
        [59, -8],
        [7, 0],
        [-1433, -2851],
        [51, -1204],
        [-532, -166],
        [-1521, -478],
        [-289, -2067],
        [0, -2],
        [2, -70],
        [2, -37],
        [1502, 223],
        [151, 13],
        [-716, -2159],
        [-103, 5],
        [-47, -39],
        [-7, 2],
        [-40, 10],
        [-575, 156],
        [-682, 677],
        [-37, 36],
        [-68, 67],
        [-1142, -1713],
        [-139, -216],
        [-610, -720],
        [-110, 53],
        [-661, -857],
        [-4235, -5493],
      ],
      [
        [186775, 258365],
        [-554, -719],
        [163, -646],
        [268, -1064],
        [629, -2603],
        [-2660, -1819],
        [-85, -192],
        [0, -1],
        [-23, -58],
        [-59, -144],
        [6, -69],
        [12, -26],
        [4, -10],
        [68, -88],
        [37, -15],
        [47, -43],
        [17, -30],
        [33, -81],
        [21, -76],
        [47, -123],
        [37, -34],
        [8, -6],
        [18, -79],
        [73, -53],
        [-1040, -2320],
        [220, -338],
        [163, -234],
        [677, -373],
        [-55, -49],
        [0, -45],
        [98, -1143],
        [-473, -515],
        [-55, 33],
        [-67, -33],
        [-35, -69],
        [-14, -44],
        [-18, -38],
        [-58, -12],
        [-98, 40],
        [-51, 0],
        [-36, -62],
        [-22, -47],
        [-9, -54],
        [-5, -184],
        [-5, -38],
        [1, -50],
        [-24, -54],
        [-28, -46],
        [-15, -71],
        [7, -69],
        [8, -56],
        [4, -46],
        [-28, -39],
        [-31, -43],
        [1589, -22],
        [-687, -2170],
        [-2216, -302],
        [-606, -875],
        [-1169, -354],
        [-824, -261],
        [-841, 445],
        [-792, -2651],
        [0, -16],
        [11, -685],
        [107, -6121],
        [112, -6423],
        [27, -1510],
        [1819, 1447],
        [17, 10],
        [3846, 1882],
      ],
      [
        [151501, 221475],
        [508, 121],
        [1186, 286],
        [6, 67],
        [23, 139],
        [-23, 95],
        [0, 96],
        [21, 110],
        [35, 78],
        [-104, 201],
        [-54, 106],
        [-42, 87],
        [22, 86],
        [216, 907],
        [-1544, 1139],
        [-29, -41],
        [-10, -30],
        [8, -75],
        [-16, -80],
        [-21, -71],
        [-74, -8],
        [-67, -14],
        [-84, -23],
        [-72, -45],
        [-35, -61],
        [-111, -14],
        [-124, -64],
        [-18, -43],
        [-39, -20],
        [-18, -44],
        [-22, -34],
        [-14, -23],
        [-14, -15],
        [-10, -13],
        [-16, -13],
        [-24, -11],
        [-24, -11],
        [-20, -6],
        [-19, -10],
        [-22, -18],
        [-2, -7],
        [3, -17],
        [7, -21],
        [18, -37],
        [4, -12],
        [2, -18],
        [-2, -15],
        [-14, -15],
        [-8, -13],
        [-20, -12],
        [-5, -13],
        [-5, -30],
        [-3, -21],
        [-4, -24],
        [-10, -26],
        [-8, -15],
        [-35, -16],
        [-14, -3],
        [-18, -1],
        [-31, 1],
        [-22, 1],
        [-14, 5],
        [-15, 6],
        [-16, -2],
        [-16, -6],
        [-16, -1],
        [-18, -1],
        [-16, 2],
        [-28, -2],
        [-12, 4],
        [-7, 2],
        [-17, -3],
        [-20, -9],
        [-4, -13],
        [-2, -10],
        [2, -13],
        [6, -11],
        [9, -15],
        [15, -8],
        [4, -15],
        [-2, -16],
        [-7, -23],
        [-7, -28],
        [1, -23],
        [11, -32],
        [8, -32],
        [0, -16],
        [1, -23],
        [-3, -44],
        [2, -16],
        [-5, -28],
        [-2, -26],
        [-9, -34],
        [-5, -12],
        [-7, -11],
        [-3, -7],
        [-7, -5],
        [-23, -2],
        [-18, 0],
        [-21, 3],
        [-16, 3],
        [-35, 3],
        [-14, 5],
        [-24, 2],
        [-18, 1],
        [-16, -6],
        [-22, -7],
        [-15, -5],
        [-10, -2],
        [-22, -3],
        [-15, 1],
        [-8, 5],
        [-12, 8],
        [-12, 8],
        [-9, 8],
        [-18, 20],
        [-24, 23],
        [-22, 16],
        [-27, 8],
        [-16, 0],
        [-26, -8],
        [-27, -8],
        [-16, -6],
        [-15, -10],
        [-16, -5],
        [-36, -5],
        [-24, 4],
        [-33, 14],
        [-20, 16],
        [-103, 70],
        [-169, 166],
        [-95, 40],
        [-79, 3],
        [-99, 24],
        [-118, 45],
        [-139, 20],
        [-427, -78],
        [-75, 5],
        [-72, 40],
        [-103, 89],
        [-50, 44],
        [-33, 13],
        [-25, 23],
        [-12, 13],
        [-9, 11],
        [-8, 23],
        [-8, 25],
        [-8, 43],
        [-6, 53],
        [-7, 78],
        [-10, 63],
        [8, 58],
        [6, 50],
        [19, 63],
        [-1, 32],
        [6, 38],
        [-5, 47],
        [-13, 40],
        [-24, 36],
        [-23, 35],
        [-27, 29],
        [-36, 17],
        [-48, 13],
        [-39, 5],
        [-55, 13],
        [-71, 24],
        [-77, 29],
        [-82, 30],
        [-53, 23],
        [-46, 14],
        [-53, 22],
        [-45, 16],
        [-64, 33],
        [-41, 19],
        [-23, 12],
        [-34, 26],
        [-23, 22],
        [-24, 25],
        [-17, 22],
        [-27, 34],
        [-35, 26],
        [-25, 18],
        [-16, 15],
        [-16, 21],
        [-15, 24],
        [-6, 17],
        [-1, 26],
        [6, 12],
        [6, 17],
        [16, 15],
        [14, 18],
        [23, 14],
        [6, 14],
        [26, 31],
        [15, 25],
        [12, 42],
        [11, 17],
        [6, 28],
        [-2, 43],
        [-6, 17],
        [-4, 24],
        [-5, 7],
        [-12, 5],
        [-17, 10],
        [-18, 3],
        [-17, -11],
        [-12, -29],
        [-38, 3],
        [-18, 2],
        [-17, 9],
        [-15, 15],
        [2, 11],
        [-20, 26],
        [-13, 16],
        [-7, 42],
        [16, 51],
        [16, 26],
        [4, 36],
        [-6, 33],
        [29, 22],
        [4, 24],
        [-11, 34],
        [24, 28],
        [-21, 19],
        [0, 18],
        [-4, 18],
        [8, 35],
        [-19, 71],
        [10, 22],
        [-3, 27],
        [16, 25],
        [21, 4],
        [10, 12],
        [7, 16],
        [-9, 12],
        [12, 23],
        [8, 12],
        [6, 29],
        [18, 22],
        [17, 2],
        [13, 16],
        [0, 12],
        [69, 58],
        [9, 54],
        [26, 13],
        [11, 18],
        [-10, 58],
        [-2, 31],
        [12, 18],
        [5, 17],
        [23, 30],
        [-20, 38],
        [-6, 37],
        [-15, 21],
        [-21, 13],
        [-7, 12],
        [-13, 8],
        [-4, 8],
        [-8, 2],
        [-29, 40],
        [5, 16],
        [22, 14],
        [24, -4],
        [18, 2],
        [22, -4],
        [-5, 20],
        [-12, 20],
        [-7, 16],
        [-12, 9],
        [-6, 10],
        [5, 10],
        [14, 4],
        [1, 6],
        [-7, 8],
        [-11, 0],
        [-14, -6],
        [-12, -8],
        [-23, 6],
        [-25, 2],
        [-37, -6],
        [-12, -4],
        [-4, 23],
        [-12, 15],
        [0, 21],
        [-22, 38],
        [-7, 52],
        [-24, 72],
        [6, 33],
        [28, 62],
        [53, 85],
        [60, 92],
        [15, 71],
        [26, 71],
        [60, 81],
        [88, 43],
        [27, 32],
        [32, 42],
        [30, 38],
        [-89, 55],
        [-1840, 1386],
        [-6, 4],
        [-95, 71],
        [-1365, 1027],
        [-27, 19],
        [-15, 11],
        [-210, 158],
        [-34, 25],
        [-4770, 3582],
        [-122, 44],
        [-102, 8],
        [-50, 8],
        [-13, 49],
        [-126, 90],
        [-115, 20],
        [-79, 75],
        [-58, -6],
        [-72, -9],
        [-102, -9],
        [-44, -3],
        [4, 39],
        [11, 106],
        [6, 17],
        [66, 179],
        [32, 76],
        [0, 91],
        [-70, 18],
        [-93, -40],
        [-63, -33],
        [-61, -34],
        [-95, -45],
        [-33, 12],
        [-38, 14],
        [-79, 55],
        [-122, 71],
        [-75, 41],
        [-127, 89],
        [-49, 35],
        [-110, 58],
        [-119, 72],
        [-111, 46],
        [-120, 30],
        [-83, 71],
        [-62, 45],
        [-54, 74],
        [-37, 68],
        [-39, 59],
        [-62, 79],
        [-25, 26],
        [-49, 50],
        [-52, 69],
        [-32, 66],
        [-146, 104],
        [-58, 0],
        [-35, 20],
        [-22, 12],
        [-14, 10],
        [-30, -43],
        [-13, -32],
        [-50, -57],
        [-47, -55],
        [-86, -72],
        [-18, 30],
        [37, 37],
        [-36, -5],
        [-15, -7],
        [-18, 6],
        [-6, -13],
        [-14, -7],
        [-16, 2],
        [-5, 4],
        [-6, 26],
        [-1, 7],
        [7, -2],
        [7, -11],
        [6, -4],
        [-1, 20],
        [-14, 19],
        [-20, 5],
        [0, 5],
        [24, 5],
        [15, -2],
        [4, 4],
        [-4, 6],
        [-11, 2],
        [-14, 0],
        [-20, 8],
        [-1, 9],
        [3, 22],
        [-4, 18],
        [10, 13],
        [8, 13],
        [27, 0],
        [0, 6],
        [-8, 5],
        [-1, 10],
        [12, -2],
        [5, 9],
        [-4, 13],
        [12, 28],
        [10, 22],
        [2, 16],
        [-2, 10],
        [6, 8],
        [-4, 11],
        [4, 11],
        [20, 10],
        [-10, 39],
        [-4, 18],
        [13, 24],
        [20, 2],
        [16, 15],
        [7, 2],
        [7, 6],
        [28, -4],
        [4, 2],
        [8, 16],
        [12, 17],
        [32, 21],
        [8, 14],
        [-17, 27],
        [-16, 16],
        [-3, 8],
        [5, 26],
        [-2, 10],
        [3, 14],
        [-9, 13],
        [-6, 11],
        [-33, 21],
        [124, 329],
        [0, 2],
        [-3317, 2164],
        [353, 1222],
        [13, 43],
        [197, 685],
        [55, 86],
        [62, 38],
        [45, 51],
        [59, 31],
        [90, 21],
        [106, 1],
        [16, 46],
        [-2, 48],
        [8, 34],
        [-13, 27],
        [-6, 32],
        [-12, 16],
        [-4, 31],
        [-23, 31],
        [-47, 25],
        [-37, 30],
        [8, 12],
        [2, 4],
        [-6, 93],
        [6, 64],
        [-11, 50],
        [14, 22],
        [18, 10],
        [6, 41],
        [-8, 20],
        [14, 32],
        [6, 36],
        [-8, 21],
        [4, 12],
        [6, 14],
        [8, 18],
        [19, 12],
        [2, 21],
        [4, 18],
        [30, 19],
        [18, 18],
        [-9, 37],
        [-2, 6],
        [-11, 4],
        [-2, 8],
        [8, 19],
        [-3, 15],
        [-5, 16],
        [9, 35],
        [-12, 35],
        [-27, 47],
        [-41, 81],
        [-34, 17],
        [-25, 24],
        [0, 10],
        [7, 14],
        [-5, 25],
        [14, 6],
        [1, 27],
        [11, 9],
        [33, 41],
        [-4, 18],
        [-39, 24],
        [15, 33],
        [50, 36],
        [11, 50],
        [35, 62],
        [-17, 28],
        [-26, 46],
        [-21, 46],
        [-29, 31],
        [-23, 15],
        [2, 41],
        [0, 38],
        [13, 13],
        [0, 27],
        [-20, 52],
        [1, 25],
        [10, 3],
        [6, 11],
        [-9, 33],
        [8, 15],
        [68, 19],
        [18, 14],
        [0, 35],
        [11, 22],
        [-9, 17],
        [-12, 4],
        [-6, -19],
        [-27, 6],
        [-25, 16],
        [-29, 44],
        [-1, 34],
        [11, 8],
        [22, 4],
        [10, 37],
        [-4, 24],
        [-17, 64],
        [17, 19],
        [34, 23],
        [30, 16],
        [39, 1],
        [19, 8],
        [11, 13],
        [52, 22],
        [4, 8],
        [10, 36],
        [13, 2],
        [7, 22],
        [3, 20],
        [-11, 16],
        [-20, 9],
        [-6, 5],
        [-2, 8],
        [2, 7],
        [2, 11],
        [3, 15],
        [7, 3],
        [14, -19],
        [9, -5],
        [14, 3],
        [2, 16],
        [8, 17],
        [0, 23],
        [0, 20],
        [-4, 10],
        [-4, 14],
        [-4, 10],
        [-4, 19],
        [0, 28],
        [8, 9],
        [14, 23],
        [28, 38],
        [8, 21],
        [15, 37],
        [-55, 32],
        [16, 33],
        [21, 10],
        [10, 12],
        [10, 25],
        [9, 20],
        [22, 7],
        [-1877, 3126],
        [113, 1843],
        [-1369, 968],
        [-195, 201],
        [-36, 38],
        [-55, 55],
        [-33, 33],
        [-82, 86],
        [-755, 780],
        [-50, 52],
        [-4302, 2116],
        [-1004, -199],
        [81, 307],
        [-155, -60],
        [-157, -8],
        [-186, -46],
        [-233, -102],
        [-190, -16],
        [-110, -13],
        [-78, -35],
        [-59, -57],
        [-64, -12],
        [-119, 37],
        [-143, 12],
        [-172, 14],
        [-124, -17],
        [-124, -62],
        [-75, -56],
        [-125, -148],
        [-72, -67],
        [-29, -95],
        [-34, -37],
        [-133, -167],
        [-86, -53],
        [-51, -37],
        [-67, -87],
        [-313, -184],
        [48, -72],
        [-15, -4],
        [-10, -12],
        [-12, -4],
        [-2, -10],
        [-5, -7],
        [-4, -9],
        [3, -24],
        [8, -23],
        [-56, 2],
        [-32, 2],
        [-31, 18],
        [-23, 8],
        [-23, -5],
        [-24, -5],
        [-15, -11],
        [-6, 6],
        [-27, -9],
        [-38, -22],
        [-12, -2],
        [-30, 12],
        [-6, -4],
        [1, -8],
        [-12, -2],
        [-15, -4],
        [-27, -18],
        [-17, -6],
        [-2, -8],
        [-20, 3],
        [-30, -9],
        [-23, -15],
        [-9, -8],
        [4, -16],
        [5, -12],
        [8, -8],
        [8, -6],
        [3, -9],
        [-4, -13],
        [-1, -7],
        [3, -20],
        [3, -26],
        [-5, -10],
        [-2, -8],
        [1, -17],
        [0, -29],
        [4, -7],
        [-6, -10],
        [-4, -8],
        [-11, -8],
        [-8, -10],
        [-6, -14],
        [0, -10],
        [16, -23],
        [4, -14],
        [-48, -13],
        [-61, -8],
        [-30, -14],
        [-14, -12],
        [-12, -6],
        [-26, 10],
        [-16, -6],
        [-12, -8],
        [-12, -14],
        [-6, -13],
        [-74, -36],
        [-11, 6],
        [-8, -4],
        [-4, -7],
        [4, -9],
        [18, -24],
        [-114, -107],
        [-99, -59],
        [-84, 12],
        [-62, 28],
        [-45, 7],
        [-21, 42],
        [-39, 34],
        [-11, 11],
        [-19, 9],
        [-10, -7],
        [-18, 0],
        [-10, 4],
        [-2, 7],
        [-10, 0],
        [-10, 7],
        [-11, -4],
        [-19, 4],
        [-18, 7],
        [-8, 6],
        [-20, 0],
        [-32, 30],
        [-3, 13],
        [-74, 30],
        [-33, 27],
        [-9, 13],
        [8, 12],
        [0, 8],
        [-27, 4],
        [-16, 17],
        [-25, 36],
        [-29, 0],
        [-6, 6],
        [-18, -4],
        [-18, -8],
        [-65, -3],
        [-106, -77],
        [-64, -68],
        [-42, -91],
        [-39, -77],
        [-92, 0],
        [-102, -11],
        [-68, -48],
        [-155, -122],
        [-118, -171],
        [-72, -107],
      ],
      [
        [119000, 250984],
        [-244, 201],
        [12, 30],
        [42, 20],
        [58, 38],
        [18, 59],
        [-9, 85],
        [-8, 75],
        [-26, 14],
        [-58, 4],
        [-45, 71],
        [-47, 168],
        [-105, 212],
        [-33, 68],
        [-55, 100],
        [41, 39],
        [38, 33],
        [9, 50],
        [8, 33],
        [2, 23],
        [-12, 23],
        [-10, 38],
        [6, 36],
        [16, 28],
        [14, 15],
        [19, 8],
        [0, 11],
        [-3, 27],
        [-3, 20],
        [-4, 22],
        [-9, 20],
        [-20, 20],
        [-50, 26],
        [-73, 49],
        [-13, -10],
        [-20, 8],
        [-25, 16],
        [-6, -4],
        [-6, -4],
        [-4, -2],
        [-15, -6],
        [-18, -2],
        [-22, 6],
        [-21, 0],
        [-18, 4],
        [-26, 12],
        [-27, 16],
        [-16, 2],
        [-12, 8],
        [-6, 13],
        [-6, 12],
        [-4, 12],
        [-2, 11],
        [-2, 13],
        [-10, 17],
        [-15, 2],
        [-14, 1],
        [-13, -1],
        [-14, -2],
        [-8, -3],
        [-8, -3],
        [-14, 1],
        [-5, 1],
        [-4, 15],
        [-8, 22],
        [-6, 10],
        [-4, 8],
        [-6, 6],
        [-18, 14],
        [-23, 33],
        [-8, 41],
        [2, 22],
        [-5, 27],
        [-9, 24],
        [-18, 33],
        [-12, 34],
        [-14, 37],
        [-10, 52],
        [-15, 60],
        [-8, 4],
        [-8, 6],
        [-12, 0],
        [-13, 0],
        [-22, 0],
        [-27, 4],
        [-22, -2],
        [-18, -8],
        [-22, -6],
        [-53, -8],
        [-27, -7],
        [-24, -2],
        [-10, -5],
        [-13, -6],
        [-17, -13],
        [-24, 2],
        [-21, 11],
        [-20, 11],
        [-30, -3],
        [-13, 9],
        [-6, 9],
        [-4, 12],
        [51, 31],
        [76, 57],
        [55, 53],
        [56, 72],
        [-6, 40],
        [-4, 30],
        [-1, 12],
        [-3, 20],
        [-56, 76],
        [-25, 33],
        [-25, 34],
        [-83, 125],
        [-94, 63],
        [-114, 22],
        [-81, -13],
        [-136, 92],
        [-28, 20],
        [-43, 30],
        [-6, 3],
        [-29, 21],
        [-101, 97],
        [-3, 2],
        [-27, 23],
        [-10, 53],
        [1, 30],
        [2, 26],
        [3, 30],
        [-8, 21],
        [-1, 25],
        [-10, 38],
        [-10, 24],
        [-21, 48],
        [-14, 27],
        [-20, 50],
        [-5, 35],
        [-3, 32],
        [4, 33],
        [-2, 21],
        [-11, 33],
        [-22, 14],
        [-15, 6],
        [-24, 11],
        [-32, 7],
        [-30, 10],
        [-37, 13],
        [-28, 8],
        [-41, 21],
        [-28, 7],
        [-14, 2],
        [-15, 2],
        [-30, 7],
        [-21, 19],
        [-34, 19],
        [-24, 14],
        [-29, 25],
        [-28, 23],
        [-20, 23],
        [-23, 22],
        [-31, 22],
        [-20, 20],
        [-27, 30],
        [-28, 10],
        [-27, 3],
        [-26, -1],
        [-30, 2],
        [-26, 0],
        [-31, -10],
        [-22, -9],
        [-29, -10],
        [-18, -13],
        [-24, -14],
        [-23, -12],
        [-46, -24],
        [-45, 12],
        [-51, 14],
        [-36, 16],
        [-27, 6],
        [-16, 4],
        [-24, -1],
        [-31, 29],
        [-21, 19],
        [-16, 11],
        [-20, 4],
        [-22, 0],
        [-20, -4],
        [-18, -2],
        [-21, -2],
        [-19, -5],
        [-16, -7],
        [-10, -4],
        [-18, -4],
        [-13, 4],
        [-4, 2],
        [-7, 13],
        [-7, 18],
        [-18, 16],
        [-11, 14],
        [-11, 8],
        [-28, 6],
        [-15, -2],
        [-20, -4],
        [-4, 8],
        [-6, 17],
        [0, 24],
        [-2, 13],
        [-2, 17],
        [-1, 15],
        [-2, 4],
        [-7, 11],
        [-13, 13],
        [-14, 7],
        [-16, 12],
        [-8, 11],
        [-9, 16],
        [-5, 27],
        [1, 29],
        [-2, 27],
        [-2, 20],
        [-4, 16],
        [-7, 13],
        [-20, 18],
        [-19, 7],
        [-19, 2],
        [-17, 1],
        [-17, -1],
        [-21, 2],
        [-24, -6],
        [-16, 3],
        [-19, -7],
        [-23, -19],
        [-17, -13],
        [-34, -14],
        [-23, 2],
        [-14, -14],
        [-16, 4],
        [-20, 4],
        [-14, -2],
        [-14, -2],
        [-10, -6],
        [-10, -6],
        [-12, 0],
        [-13, 0],
        [-19, 4],
        [-20, 8],
        [-19, 4],
        [-26, 8],
        [-23, 2],
        [-17, 0],
        [-21, -8],
        [-17, -10],
        [-14, -15],
        [-22, -21],
        [-27, -24],
        [-19, -9],
        [-9, -16],
        [-5, -18],
        [-3, -21],
        [-16, -11],
        [-16, -7],
        [-14, -7],
        [-15, -7],
        [-8, -15],
        [-2, -13],
        [-2, -16],
        [-2, -10],
        [-4, -11],
        [-6, -10],
        [-10, -10],
        [-18, -2],
        [-16, 7],
        [-13, 11],
        [-11, 10],
        [-16, 6],
        [-16, -3],
        [-14, -7],
        [-16, -8],
        [-10, -9],
        [-9, -5],
        [-16, -10],
        [-28, -4],
        [-23, -4],
        [-20, -10],
        [-16, -8],
        [-22, -10],
        [-33, -4],
        [-24, 8],
        [-21, 6],
        [-22, -6],
        [-38, 2],
        [-22, 4],
        [-31, -2],
        [-6, -22],
        [-26, -6],
        [-19, 0],
        [-27, -9],
        [-16, 1],
        [-18, 8],
        [-10, 12],
        [-4, 8],
        [-10, 10],
        [-16, 6],
        [-23, 2],
        [-16, -2],
        [-16, -6],
        [-8, -16],
        [-2, -6],
        [-5, -7],
        [-6, -5],
        [-8, -8],
        [-6, -2],
        [-6, -2],
        [-13, -3],
        [-18, -9],
        [-20, -7],
        [-18, 5],
        [-12, 8],
        [-16, 6],
        [-21, 11],
        [-18, 9],
        [-27, 2],
        [-18, -5],
        [-8, -11],
        [-8, -13],
        [-11, -11],
        [-12, -12],
        [-19, -10],
        [-56, -19],
        [-18, 1],
        [-8, -7],
        [-18, -14],
        [-21, -2],
        [-20, -10],
        [-28, -12],
        [-21, -12],
        [-18, -4],
        [-20, -2],
        [-18, -14],
        [-18, -8],
        [-28, -5],
        [-18, 2],
        [-18, 2],
        [-27, 2],
        [-22, 8],
        [-33, 1],
        [-15, -4],
        [-39, 4],
        [-14, -1],
        [-24, -14],
        [-19, -16],
        [-23, 9],
        [-6, -3],
        [2, -8],
        [-12, 3],
        [-12, 4],
        [-11, -4],
        [-12, 7],
        [-14, 6],
        [-14, 7],
        [-18, 7],
        [-14, -4],
        [-6, -2],
        [-6, -2],
        [-2, -2],
        [-9, -4],
        [-10, -1],
        [-15, 0],
        [-30, 0],
        [-16, 10],
        [-14, -3],
        [-13, -12],
        [-6, -24],
        [-22, -15],
        [-12, -13],
        [-12, -15],
        [-12, -10],
        [-10, -14],
        [-14, -11],
        [-14, -12],
        [-14, 3],
        [-12, -5],
        [-10, 3],
        [-11, 7],
        [-25, 7],
        [-19, 7],
        [-13, -1],
        [-10, -19],
        [-16, -16],
        [-8, -13],
        [-4, -6],
        [-9, -8],
        [-6, -10],
        [0, -18],
        [-4, -16],
        [-16, -6],
        [-21, 8],
        [-12, -2],
        [-35, -2],
        [-22, -10],
        [-18, -10],
        [-20, -10],
        [-18, -20],
        [-10, -16],
        [-8, -9],
        [-11, -10],
        [-29, -12],
        [-16, -2],
        [-14, 6],
        [-10, 0],
        [-10, 0],
        [-6, -4],
        [-7, -4],
        [-21, -17],
        [-20, -3],
        [-21, -3],
        [-12, -9],
        [-22, 0],
        [-39, -8],
        [-23, -12],
        [-14, -22],
        [-18, -43],
        [-28, -11],
        [-7, -3],
        [-7, -3],
        [-19, -14],
        [-24, -34],
        [-23, -13],
        [-27, -14],
        [-18, -10],
        [-24, -5],
        [-19, 7],
        [-9, 16],
        [-4, 24],
        [-24, 7],
        [-11, -4],
        [-17, -15],
        [-10, 3],
        [-10, 2],
        [-12, 8],
        [-12, -1],
        [-20, 3],
        [-25, 6],
        [-25, 3],
        [-23, 6],
        [-12, -1],
        [-12, 1],
        [-12, -4],
        [-13, 1],
        [-20, 5],
        [-17, 4],
        [-16, 9],
        [-6, 6],
        [-4, 5],
        [-14, 14],
        [-6, 13],
        [-13, 24],
        [-8, 20],
        [-10, 14],
        [-7, 10],
        [-13, 12],
        [-18, 6],
        [-8, 0],
        [-6, -1],
        [-6, -3],
        [-6, -3],
        [-16, -7],
        [-20, 10],
        [-11, 2],
        [-15, -10],
        [-18, 6],
        [-16, 8],
        [-15, 9],
        [-8, 10],
        [-8, 9],
        [-10, 4],
        [-22, -3],
        [-12, 5],
        [-21, 7],
        [-18, 14],
        [-10, 17],
        [-1, 19],
        [0, 10],
        [0, 10],
        [-1, 6],
        [-4, 8],
        [-4, 10],
        [-7, 12],
        [-19, 7],
        [-20, 3],
        [-26, -3],
        [-16, 11],
        [-17, 10],
        [-20, 26],
        [-40, 35],
        [-35, 33],
        [-42, 25],
        [-35, 24],
        [-48, 33],
        [-35, 34],
        [-14, 14],
        [-18, 0],
        [-11, -10],
        [-7, -14],
        [-8, -12],
        [-12, 0],
        [-13, 0],
        [-21, 8],
        [-20, 16],
        [-14, 14],
        [-21, 16],
        [-17, -2],
        [-17, -12],
        [-14, -12],
        [-25, -24],
        [-30, -2],
        [-44, -4],
        [-29, -10],
        [-32, -8],
        [-42, -11],
        [-36, 0],
        [-33, 9],
        [-38, 12],
        [-34, 12],
        [-39, 18],
        [-27, 16],
        [-20, 6],
        [-28, 8],
        [-29, 7],
        [-17, 0],
        [-19, 0],
        [-37, -5],
        [-34, -2],
        [-33, 2],
        [-40, -4],
        [-23, 2],
        [-18, 1],
        [-24, 16],
        [-27, 5],
        [-20, 15],
        [-31, 7],
        [-29, -1],
        [-25, 1],
        [-26, 2],
        [-21, 0],
        [-43, -5],
        [-32, -7],
        [-33, 7],
        [-30, -6],
        [-29, -5],
        [-44, -3],
        [-27, -11],
        [-30, -14],
        [-11, -8],
        [-27, -8],
        [-25, 2],
        [-24, -8],
        [-29, -2],
        [-29, 10],
        [-18, 6],
        [-13, 10],
        [-14, 7],
        [-36, 4],
        [-27, 16],
        [-25, 5],
        [-27, -8],
        [-14, -7],
        [-12, -6],
        [-13, -29],
        [4, -28],
        [-6, -16],
        [-20, -10],
        [-21, 6],
        [-22, 16],
        [-33, 22],
        [-21, 4],
        [-17, -2],
        [-18, -14],
        [-26, 6],
        [-31, 16],
        [-19, 10],
        [-26, 7],
        [-19, 9],
        [-21, 7],
        [-6, 4],
        [-26, 13],
        [-19, 16],
        [-20, 11],
        [-17, 12],
        [-16, 12],
        [-19, 14],
        [-13, -2],
        [-15, -2],
        [-15, -6],
        [-25, -8],
        [-18, -1],
        [-29, 7],
        [-29, 0],
        [-24, 2],
        [-24, 0],
        [-23, 8],
        [-7, 4],
        [-8, 4],
        [-15, 10],
        [-10, 8],
        [-12, 2],
        [-16, 0],
        [-17, -4],
        [-20, -12],
        [-21, -6],
        [-32, -4],
        [-37, -6],
        [-42, -4],
        [-30, 4],
        [-29, 6],
        [-31, 4],
        [-18, 2],
        [-8, 16],
        [0, 14],
        [4, 33],
        [-2, 23],
        [-6, 24],
        [-6, 20],
        [-5, 14],
        [-8, 18],
        [-8, 16],
        [-8, 19],
        [-8, 17],
        [-11, 22],
        [-9, 18],
        [-17, 23],
        [-21, 20],
        [0, 0],
        [-25, 25],
        [-39, 30],
        [-16, 4],
        [-37, 12],
        [-59, 5],
        [-42, -3],
        [-36, -8],
        [-52, -19],
        [-39, -13],
        [-39, -12],
        [-49, -11],
        [-35, -4],
        [-26, 4],
        [-28, 21],
        [-17, 26],
        [-10, 19],
        [-6, 23],
        [-6, 25],
        [-6, 27],
        [-11, 30],
        [-13, 27],
        [-15, 23],
        [-19, 20],
        [-30, 22],
        [-31, 12],
        [-41, 9],
        [-31, 7],
        [-41, -2],
        [-37, -6],
        [-26, -14],
        [-17, -13],
        [-21, -16],
        [-16, -14],
        [-9, -11],
        [-10, -16],
        [-8, -19],
        [-8, -21],
        [-2, -18],
        [0, -23],
        [0, -24],
        [-4, -28],
        [0, -25],
        [-6, -24],
        [-8, -37],
        [-7, -31],
        [-10, -34],
        [-15, -54],
        [-14, -44],
        [-16, -36],
        [-16, -31],
        [-20, -31],
        [-22, -20],
        [-29, -20],
        [-36, -15],
        [-37, -19],
        [-46, -13],
        [-43, -7],
        [-39, -6],
        [-37, -8],
        [-58, -8],
        [-51, -4],
        [-46, -15],
        [-42, -18],
        [-41, -20],
        [-58, -6],
        [-53, 8],
        [-43, 10],
        [-59, 24],
        [-43, 16],
        [-48, 24],
        [-6, 3],
        [-33, 22],
        [-6, 4],
        [-26, 17],
        [-27, 17],
        [-35, 22],
        [-50, 26],
        [-22, 20],
        [-23, 23],
        [-40, 25],
        [-31, 28],
        [-38, 17],
        [-57, 21],
        [-32, 7],
        [-27, 2],
        [-27, -7],
        [-52, -17],
        [-45, -18],
        [-32, -22],
        [-29, -36],
        [-18, -36],
        [-18, -53],
        [-16, -59],
        [-7, -70],
        [4, -77],
        [16, -44],
        [25, -52],
        [34, -50],
        [24, -41],
        [29, -51],
        [12, -40],
        [6, -42],
        [-9, -36],
        [-21, -34],
        [-49, -30],
        [-34, -8],
        [-31, -3],
        [-30, -3],
        [-71, -2],
        [-93, 2],
        [-72, -3],
        [-51, -7],
        [-52, -24],
        [-57, -49],
        [-20, -25],
        [-21, -25],
        [-24, -66],
        [-9, -106],
        [-18, -91],
        [-14, -107],
        [10, -103],
        [18, -37],
        [29, -72],
        [-2, -62],
        [-9, -43],
        [-27, -68],
        [-34, -62],
        [-31, -64],
        [-70, -62],
        [-73, -76],
        [-62, -65],
        [-44, -58],
        [-2, -4],
        [-77, -74],
        [-30, -68],
        [-1577, 162],
        [-438, 1770],
        [-15, 37],
        [-10, 46],
        [-8, 28],
        [6, 12],
        [2, 18],
        [2, 14],
        [-13, 23],
        [-5, 8],
        [-7, 24],
        [-7, 15],
        [-6, 26],
        [-9, 28],
        [1, 43],
        [-2, 23],
        [-10, 7],
        [-19, 6],
        [-26, -4],
        [-27, 0],
        [-17, 0],
        [-18, -1],
        [-32, -2],
        [-22, -5],
        [-21, -7],
        [-12, -9],
        [-26, -6],
        [-22, 4],
        [-35, 18],
        [-12, 20],
        [-21, 28],
        [-8, 22],
        [-18, 31],
        [-19, 23],
        [-10, 30],
        [0, 23],
        [5, 23],
        [-17, 12],
        [-24, 14],
        [-20, 21],
        [-22, 23],
        [-27, 14],
        [-31, 14],
        [-18, 8],
        [-18, 8],
        [-24, 10],
        [-21, 9],
        [-21, 10],
        [-14, 3],
        [-14, 4],
        [-40, 5],
        [-29, 0],
        [-24, 2],
        [-17, 6],
        [-21, 16],
        [-35, 10],
        [-19, -10],
        [-16, 7],
        [-22, 15],
        [-24, 3],
        [-23, 1],
        [-10, -1],
        [-18, -1],
        [-26, 10],
        [-6, 21],
        [-8, 11],
        [-7, 15],
        [-10, 14],
        [-4, 13],
        [-10, 18],
        [-6, 23],
        [-8, 9],
        [-6, 2],
        [-16, 19],
        [-9, 19],
        [-10, 20],
        [-6, 8],
        [-10, 15],
        [-9, 6],
        [-23, 8],
        [-18, 14],
        [-7, 16],
        [-9, 8],
        [-1, 34],
        [2, 15],
        [-8, 16],
        [-16, 15],
        [-15, 6],
        [-18, 1],
        [0, 16],
        [0, 26],
        [-6, 17],
        [-4, 19],
        [-10, 9],
        [-13, 14],
        [-5, 15],
        [-10, 26],
        [-20, 15],
        [-20, 33],
        [-12, 25],
        [-17, 31],
        [-18, 5],
        [-27, -5],
        [-29, -10],
        [-41, -7],
        [-41, -3],
        [-43, -5],
        [-50, -11],
        [-22, -12],
        [-35, -16],
        [-49, 3],
        [-50, 18],
        [-45, 15],
        [-43, 13],
        [-44, 19],
        [-31, 34],
        [-44, 60],
        [-43, 22],
        [-29, 28],
        [-20, 20],
        [-16, 23],
        [-10, 28],
        [-15, 26],
        [-27, 18],
        [-23, -18],
        [-42, -38],
        [-7, -51],
        [3, -52],
        [3, -40],
        [-11, -35],
        [-38, -3],
        [-24, 14],
        [-41, 18],
        [-24, 14],
        [-16, 0],
        [-14, 0],
        [-24, -16],
        [-27, -14],
        [-33, -4],
        [-12, 0],
        [-12, -2],
        [-44, -16],
        [-50, -9],
        [-59, -10],
        [-58, -14],
        [-65, -10],
        [-55, -7],
        [-59, -14],
        [-40, -10],
        [-56, -14],
        [-59, -13],
        [-60, -3],
        [-63, 13],
        [-52, 21],
        [-60, 42],
        [-26, 48],
        [-11, 42],
        [-386, 388],
        [-387, 387],
        [-139, 1971],
        [-1055, 1622],
        [-1638, 2429],
      ],
      [
        [95517, 263168],
        [-945, 1402],
        [-132, 193],
        [-63, 97],
        [-30, 44],
        [-37, 54],
        [-10, 15],
        [-35, 52],
        [-1838, 2724],
        [-1483, 2195],
        [-21, 29],
        [25, 27],
        [30, 38],
        [13, 36],
        [13, 29],
        [11, 44],
        [-25, 85],
        [-28, 33],
        [-1675, 1947],
        [-756, 1128],
        [756, 568],
        [74, 59],
      ],
      [
        [89361, 273967],
        [697, 550],
        [1142, 900],
        [-988, 129],
        [17, 64],
        [18, 48],
        [21, 25],
        [26, 26],
        [34, 28],
        [41, 50],
        [22, 27],
        [21, 31],
        [30, 41],
        [32, 32],
        [61, 68],
        [33, 34],
        [27, 33],
        [24, 31],
        [25, 38],
        [31, 34],
        [18, 16],
        [31, 38],
        [25, 33],
        [22, 30],
        [22, 30],
        [45, 44],
        [33, 40],
        [35, 45],
        [68, 75],
        [42, 53],
        [68, 46],
        [61, 74],
        [43, 19],
        [20, 29],
        [41, 23],
        [61, 14],
        [63, 16],
        [61, 8],
        [75, 23],
        [85, 20],
        [97, 13],
        [90, 28],
        [53, 37],
        [75, 35],
        [33, 23],
        [23, 23],
        [1, 25],
        [3, 19],
        [-3, 18],
        [-15, 24],
        [-16, 26],
        [-12, 40],
        [-8, 57],
        [15, 56],
        [15, 63],
        [15, 20],
        [31, 39],
        [17, 32],
        [0, 29],
        [0, 21],
        [2, 19],
        [0, 20],
        [-5, 41],
        [3, 71],
        [6, 31],
        [15, 28],
        [19, 25],
        [13, 17],
        [6, 14],
        [6, 14],
        [3, 31],
        [1, 37],
        [-12, 25],
        [0, 23],
        [-5, 24],
        [-4, 22],
        [-10, 24],
        [-10, 20],
        [-12, 19],
        [-23, 19],
        [-35, 8],
        [-28, 18],
        [-27, 33],
        [-41, 42],
        [-16, 38],
        [-9, 35],
        [-6, 38],
        [0, 41],
        [-5, 32],
        [1, 17],
        [0, 19],
        [-2, 15],
        [-4, 17],
        [-10, 33],
        [-15, 23],
        [-25, 32],
        [-16, 27],
        [-19, 34],
        [-9, 20],
        [-24, 35],
        [-26, 26],
        [-12, 31],
        [-2, 27],
        [-2, 22],
        [10, 20],
        [8, 22],
        [16, 21],
        [22, 28],
        [5, 20],
        [-18, 13],
        [-8, 20],
        [-19, 41],
        [-12, 43],
        [-11, 61],
        [-1, 43],
        [3, 32],
        [5, 23],
        [12, 33],
        [6, 12],
        [0, 2],
        [10, 17],
        [8, 17],
        [10, 16],
        [13, 21],
        [7, 25],
        [1, 12],
        [-3, 19],
        [-9, 7],
        [-25, 2],
        [-16, 1],
        [-18, 0],
        [-13, 2],
        [-24, 5],
        [-36, -1],
        [-22, 5],
        [-21, 13],
        [-25, 20],
        [-26, 20],
        [-20, 16],
        [-35, 25],
        [-43, 24],
        [-29, 22],
        [-39, 43],
        [-37, 28],
        [-30, 26],
        [-51, 56],
        [-46, 58],
        [-17, 25],
        [-16, 11],
        [-15, -1],
        [-20, 0],
        [-40, 17],
        [-67, 43],
        [-39, 22],
        [-30, 19],
        [-36, 19],
        [-31, 14],
        [-36, 12],
        [-46, 16],
        [-30, 22],
        [-31, 21],
        [-12, 20],
        [-6, 23],
        [-3, 17],
        [-2, 19],
        [-2, 27],
        [-1, 40],
        [-6, 17],
        [2, 28],
        [-10, 32],
        [-10, 27],
        [-12, 22],
        [-21, 35],
        [-22, 50],
        [-7, 33],
        [-4, 35],
        [-7, 21],
        [-8, 15],
        [-5, 12],
        [-20, 5],
        [-15, -8],
        [-6, -24],
        [-14, -11],
        [-27, 4],
        [-41, 14],
        [-35, 19],
        [-24, 33],
        [-6, 34],
        [-7, 37],
        [-10, 30],
        [-12, 30],
        [-27, 28],
        [-49, 2],
        [-56, -4],
        [-34, -4],
        [-33, -6],
        [-29, -4],
        [-21, 2],
        [-23, 4],
        [-14, 8],
        [-13, 6],
        [-8, 16],
        [-4, 14],
        [-2, 7],
        [-6, 15],
        [-6, 13],
        [-10, 8],
        [-14, 11],
        [-15, 16],
        [-22, 12],
        [-18, 16],
        [-13, 20],
        [-23, 53],
        [-19, 29],
        [-12, 20],
        [12, 16],
        [4, 20],
        [6, 18],
        [15, 21],
        [17, 23],
        [8, 18],
        [2, 22],
        [-2, 23],
        [0, 24],
        [-4, 32],
        [0, 32],
        [-4, 21],
        [-4, 32],
        [-13, 30],
        [-14, 28],
        [-25, 39],
        [-13, 41],
        [-7, 52],
        [-4, 64],
        [-4, 49],
        [-3, 55],
        [-7, 31],
        [-11, 34],
        [-6, 26],
        [-9, 44],
        [-10, 35],
        [-16, 19],
        [-27, 11],
        [-28, 9],
        [-38, 12],
        [-36, 8],
        [-32, 6],
        [-32, 2],
        [-33, 17],
        [-62, 36],
        [-41, 41],
        [-25, 35],
        [0, 22],
        [26, 16],
        [13, 29],
        [17, 6],
        [6, 20],
        [2, 18],
        [-4, 14],
        [-14, 30],
        [-12, 18],
        [-11, 19],
        [-13, 13],
        [-12, 13],
        [-20, 16],
        [-16, 12],
        [-26, 21],
        [-19, 14],
        [-15, 22],
        [-5, 17],
        [-5, 17],
        [-13, 30],
        [-8, 20],
        [-16, 38],
        [-6, 17],
        [-2, 12],
        [-15, 18],
        [-16, 17],
        [-13, 13],
        [-18, 12],
        [-17, 11],
        [-12, 5],
        [-18, 4],
        [-23, 4],
        [-60, 5],
        [-24, 7],
        [-17, 16],
        [-3, 22],
        [-5, 20],
        [-19, 13],
        [-30, 20],
        [-39, 23],
        [-28, 13],
        [-37, 21],
        [-23, 7],
        [-16, 19],
        [-28, 22],
        [-16, 19],
        [-27, 21],
        [-14, 19],
        [-14, 7],
        [-15, 14],
        [-18, 13],
        [-22, 24],
        [-11, 0],
        [-20, 4],
        [-33, 14],
        [-44, 45],
        [-45, 36],
        [-19, 86],
        [-6, 67],
        [11, 44],
        [16, 42],
        [22, 50],
        [8, 39],
        [4, 29],
        [8, 28],
        [5, 48],
        [5, 28],
        [8, 26],
        [11, 30],
        [8, 14],
        [8, 26],
        [17, 27],
        [-7, 26],
        [-4, 16],
        [-10, 23],
        [-20, 38],
        [-16, 25],
        [-15, 42],
        [-16, 31],
        [-26, 30],
        [-34, 5],
        [-15, 25],
        [-18, 23],
        [-21, 25],
        [-30, 28],
        [-37, 16],
        [-32, 10],
        [-33, 12],
        [-33, 16],
        [-34, 20],
        [-40, 20],
        [-32, 20],
        [-33, 31],
        [-31, 30],
        [-16, 29],
        [-16, 21],
        [-19, 14],
        [-29, 12],
        [-35, 11],
        [-43, 4],
        [-56, 10],
        [-55, 7],
        [-43, 6],
        [-60, 4],
        [-38, 15],
        [-37, 19],
        [-26, 12],
        [-24, 17],
        [-23, 19],
        [-32, 46],
        [-23, 27],
        [-24, 23],
        [-19, 21],
        [-18, 14],
        [-22, 20],
        [-20, 16],
        [-14, 10],
        [-25, 16],
        [-22, 16],
        [-14, 8],
        [-17, 13],
        [-21, 27],
        [-16, 19],
        [-12, 28],
        [-15, 34],
        [-15, 35],
        [-4, 31],
        [-5, 21],
        [-7, 30],
        [0, 45],
        [-2, 24],
        [-2, 17],
        [-1, 21],
        [-6, 20],
        [-22, 20],
        [-26, 30],
        [-24, 25],
        [-38, 22],
        [-2, 34],
        [9, 34],
        [8, 16],
        [12, 29],
        [15, 39],
        [10, 16],
        [10, 17],
        [12, 23],
        [13, 18],
        [15, 16],
        [15, 21],
        [19, 13],
        [21, 10],
        [20, 17],
        [18, 26],
        [19, 24],
        [10, 20],
        [8, 26],
        [0, 33],
        [-10, 16],
        [-20, 3],
        [-37, 0],
        [-26, 2],
        [-26, 9],
        [-19, 11],
        [-10, 19],
        [-12, 24],
        [-16, 22],
        [-23, 29],
        [-19, 21],
        [-25, 29],
        [-21, 20],
        [-27, 24],
        [-30, 21],
        [-38, 18],
        [-30, 6],
        [-36, 0],
        [-47, -18],
        [-27, 3],
        [-32, 2],
        [-51, 4],
        [-41, -1],
        [-35, 4],
        [-20, 2],
        [-16, -6],
        [-29, -10],
        [-33, -5],
        [-54, 2],
        [-26, 18],
        [-5, 37],
        [-3, 24],
        [1, 36],
        [-5, 24],
        [-4, 27],
        [7, 24],
        [9, 40],
        [4, 16],
        [8, 22],
        [13, 24],
        [11, 15],
        [4, 32],
        [0, 30],
        [-28, 21],
        [-23, 17],
        [-28, 31],
        [-26, 27],
        [-35, 13],
        [-24, 7],
        [-21, 6],
        [-22, 6],
        [-16, 3],
        [-42, 11],
        [-23, 16],
        [-24, 16],
        [-18, 14],
        [-17, 9],
        [-19, 14],
        [-14, 29],
        [-12, 19],
        [-8, 17],
        [-13, 16],
        [-11, 16],
        [-14, 17],
        [-21, 4],
        [-17, -4],
        [-22, -8],
        [-16, -17],
        [-8, -23],
        [-4, -28],
        [-6, -37],
        [-10, -22],
        [-10, -16],
        [-7, -10],
        [-8, -8],
        [-13, -8],
        [-31, 4],
        [-35, 4],
        [-22, 4],
        [-23, 6],
        [-24, 10],
        [-26, 8],
        [-13, -10],
        [-22, -16],
        [-26, -12],
        [-20, -15],
        [-24, -13],
        [-29, -10],
        [-65, 13],
        [-41, 7],
        [-32, 5],
        [-22, 19],
        [-25, 26],
        [-17, 21],
        [-18, 24],
        [-16, 32],
        [0, 23],
        [-1, 28],
        [-6, 21],
        [-10, 22],
        [-14, 16],
        [-33, 14],
        [-38, 0],
        [-28, -5],
        [-16, -9],
        [-15, -4],
        [-20, -5],
        [-21, -1],
        [-30, 0],
        [-8, 0],
        [-40, 2],
        [-23, 16],
        [-22, 21],
        [-12, 20],
        [-12, 14],
        [-17, 5],
        [-25, 0],
        [-20, -3],
        [-20, -10],
        [-11, -18],
        [-10, -22],
        [-13, -26],
        [-14, -25],
        [-16, -33],
        [-12, -31],
        [-7, -35],
        [-10, -29],
        [-12, -17],
        [-10, -26],
        [-10, -16],
        [-15, -13],
        [-20, -6],
        [-41, 17],
        [-22, 14],
        [-38, 18],
        [-25, 14],
        [-29, 16],
        [-30, 23],
        [-25, 24],
        [-15, 19],
        [-11, 30],
        [-10, 29],
        [-3, 24],
        [5, 25],
        [25, 20],
        [13, 9],
        [13, 16],
        [8, 14],
        [12, 20],
        [14, 21],
        [14, 20],
        [10, 23],
        [7, 21],
        [8, 22],
        [6, 21],
        [4, 16],
        [0, 17],
        [-6, 25],
        [0, 24],
        [-5, 34],
        [-6, 21],
        [-11, 20],
        [-9, 26],
        [-12, 17],
        [-8, 14],
        [-12, 11],
        [-27, 10],
        [-34, 2],
        [-30, 10],
        [-18, 31],
        [-8, 16],
        [-1, 28],
        [-9, 21],
        [-21, 24],
        [-23, 16],
        [-26, 21],
        [-27, 21],
        [-17, 13],
        [-23, 16],
        [-18, 9],
        [-12, 5],
        [-14, 8],
        [-15, 5],
        [-14, 8],
        [-23, 2],
        [-11, 7],
        [0, 2],
        [0, 5],
        [-11, 11],
        [-22, 24],
        [-7, 14],
        [19, 20],
        [6, 37],
        [10, 63],
        [9, 20],
        [14, 27],
        [19, 22],
        [25, 20],
        [17, 12],
        [18, 1],
        [22, -1],
        [17, -4],
        [12, 1],
        [8, 2],
        [8, 5],
        [4, 9],
        [6, 15],
        [4, 14],
        [8, 16],
        [23, -19],
        [11, -13],
        [17, -17],
        [8, -2],
        [15, -7],
        [36, 10],
        [18, 8],
        [18, 8],
        [18, 14],
        [13, 9],
        [12, 9],
        [14, 8],
        [6, 9],
        [3, 6],
        [1, 5],
        [2, 10],
        [6, 9],
        [11, 16],
        [12, -10],
        [10, -10],
        [8, -7],
        [9, -4],
        [20, 13],
        [12, 9],
        [14, 13],
        [13, -3],
        [13, -15],
        [8, -7],
        [9, -10],
        [8, -7],
        [4, -20],
        [18, -11],
        [13, -3],
        [8, 1],
        [8, 6],
        [8, 8],
        [6, 10],
        [6, 14],
        [4, 19],
        [2, 15],
        [10, 11],
        [17, 2],
        [25, -5],
        [18, -5],
        [19, -8],
        [23, -3],
        [18, -3],
        [17, -1],
        [26, -1],
        [22, -4],
        [18, -2],
        [15, 5],
        [8, 8],
        [5, 8],
        [3, 13],
        [1, 20],
        [4, 9],
        [2, 11],
        [15, 20],
        [24, -4],
        [14, -9],
        [11, -16],
        [14, -16],
        [14, -8],
        [11, -3],
        [12, -4],
        [10, 0],
        [10, 10],
        [6, 9],
        [2, 16],
        [-2, 20],
        [2, 13],
        [14, 10],
        [15, 12],
        [19, 10],
        [11, 10],
        [2, 10],
        [6, 18],
        [14, 8],
        [13, 4],
        [19, 3],
        [17, 3],
        [25, 8],
        [14, 7],
        [17, 11],
        [10, 6],
        [8, 6],
        [12, 13],
        [14, 14],
        [7, 14],
        [-8, 6],
        [3, 16],
        [10, 10],
        [16, 14],
        [21, 6],
        [14, -1],
        [12, 0],
        [16, -13],
        [3, -10],
        [4, -8],
        [4, -12],
        [4, -8],
        [10, -10],
        [16, 2],
        [10, 4],
        [10, 4],
        [7, 2],
        [4, 10],
        [8, 4],
        [8, 10],
        [10, 17],
        [10, 9],
        [13, 5],
        [15, 1],
        [16, 2],
        [17, 2],
        [10, 6],
        [6, 9],
        [0, 16],
        [0, 19],
        [2, 27],
        [10, 2],
        [13, -7],
        [9, -2],
        [4, 7],
        [6, 8],
        [5, 11],
        [6, 15],
        [1, 16],
        [4, 17],
        [5, 21],
        [4, 11],
        [1, 10],
        [0, 6],
        [2, 5],
        [-10, 13],
        [-11, 8],
        [-16, 4],
        [-29, 14],
        [-14, 16],
        [4, 29],
        [8, 17],
        [10, 13],
        [12, 3],
        [13, -3],
        [15, 2],
        [11, 7],
        [9, 10],
        [14, 6],
        [16, -8],
        [17, -6],
        [12, -7],
        [14, -6],
        [11, -3],
        [13, -4],
        [10, -1],
        [8, 0],
        [10, 4],
        [8, 10],
        [5, 14],
        [2, 14],
        [1, 12],
        [-2, 12],
        [-6, 8],
        [-10, 16],
        [-8, 26],
        [8, 17],
        [14, 19],
        [18, 10],
        [16, 3],
        [14, -2],
        [17, -4],
        [21, -1],
        [16, -2],
        [16, 5],
        [6, 18],
        [4, 11],
        [6, 15],
        [10, 12],
        [10, 4],
        [9, -2],
        [10, -6],
        [20, -12],
        [13, -10],
        [18, 6],
        [21, 10],
        [10, 6],
        [28, -8],
        [14, -3],
        [14, 3],
        [6, 2],
        [6, 4],
        [8, 6],
        [9, 4],
        [10, 6],
        [6, 4],
        [11, -3],
        [9, 2],
        [10, 2],
        [6, 6],
        [0, 10],
        [-1, 13],
        [-3, 19],
        [5, 24],
        [10, 16],
        [16, 11],
        [13, 6],
        [8, 6],
        [14, 4],
        [12, 2],
        [17, 8],
        [-3, 14],
        [-9, 21],
        [1, 24],
        [10, 14],
        [14, 2],
        [20, -2],
        [8, 1],
        [6, 2],
        [12, -1],
        [11, 8],
        [14, 3],
        [8, 8],
        [9, 5],
        [12, 5],
        [-2, 6],
        [2, 10],
        [4, 14],
        [2, 11],
        [0, 8],
        [4, 6],
        [4, 6],
        [6, 2],
        [6, 22],
        [0, 14],
        [-2, 14],
        [-2, 14],
        [-4, 19],
        [0, 14],
        [-4, 13],
        [0, 24],
        [0, 23],
        [12, 16],
        [29, -3],
        [48, 14],
        [31, 0],
        [30, -9],
        [18, -17],
        [15, -10],
        [21, -8],
        [32, 2],
        [27, 6],
        [37, 24],
        [63, 36],
        [33, 19],
        [46, -7],
        [34, 28],
        [23, 2],
        [23, 16],
        [35, 0],
        [16, -19],
        [26, -9],
        [22, -3],
        [20, 1],
        [24, 4],
        [27, 14],
        [6, 20],
        [-3, 36],
        [-11, 19],
        [2, 16],
        [74, 80],
        [2, 32],
        [12, 32],
        [2, 48],
        [-1, 61],
        [-11, 59],
        [13, 16],
        [46, -16],
        [17, -21],
        [29, -17],
        [23, 5],
        [12, 46],
        [23, 31],
        [26, 20],
        [29, 6],
        [27, 11],
        [15, 69],
        [14, 24],
        [2, 35],
        [22, 43],
        [6, 21],
        [10, 16],
        [19, 14],
        [25, -6],
        [18, -10],
        [14, -1],
        [12, 11],
        [23, 8],
        [17, 20],
        [21, 26],
        [10, 39],
        [10, 20],
        [18, 2],
        [21, 7],
        [16, 4],
        [12, 6],
        [11, 7],
        [10, 10],
        [2, 1],
        [10, 9],
        [13, 6],
        [10, 27],
        [7, 34],
        [8, 23],
        [12, 19],
        [6, 11],
        [8, 16],
        [23, 26],
        [18, 18],
        [17, 11],
        [22, 9],
        [26, 1],
        [25, 6],
        [25, 13],
        [23, 15],
        [17, 6],
        [20, 11],
        [-1, 19],
        [3, 20],
        [17, 16],
        [16, 8],
        [24, 8],
        [17, 4],
        [14, -4],
        [17, 0],
        [14, 2],
        [11, 11],
        [12, 11],
        [0, 11],
        [-8, 15],
        [-14, 12],
        [-10, 14],
        [-13, 20],
        [4, 31],
        [15, 12],
        [30, -1],
        [24, -4],
        [10, 7],
        [-4, 13],
        [-18, 13],
        [14, 33],
        [29, 15],
        [31, -4],
        [18, 9],
        [21, 16],
        [26, 18],
        [10, 30],
        [17, 121],
        [-31, 74],
        [16, 23],
        [-10, 28],
        [46, 45],
        [39, 73],
        [18, 64],
        [4, 18],
        [44, 49],
        [24, 60],
        [6, 10],
        [56, 62],
        [-8, 68],
        [-21, 42],
        [-39, 40],
        [6, 52],
        [20, 92],
        [30, 39],
        [14, 24],
        [23, 44],
        [43, 13],
      ],
      [
        [88903, 291131],
        [-17, 60],
        [-16, 40],
        [-19, 65],
        [5, 27],
        [45, 119],
        [-13, 148],
        [4, 46],
        [10, 56],
        [6, 57],
        [-5, 46],
        [-11, 38],
        [-10, 64],
        [-25, 120],
        [-21, 69],
        [-15, 90],
        [-42, 142],
        [-31, 44],
        [-96, 113],
        [-105, 73],
        [-152, 62],
        [-85, 68],
        [-141, 76],
        [-35, 55],
        [7, 39],
        [18, 36],
        [35, 33],
        [101, 124],
        [85, 194],
        [8, 86],
        [31, 142],
        [6, 258],
        [49, 400],
        [118, 171],
        [60, 84],
        [318, 462],
        [-529, 808],
        [-1446, -225],
        [669, 1916],
        [-619, 774],
      ],
      [
        [87045, 298111],
        [-2950, 3423],
        [-9, 9],
        [-582, 600],
        [-3101, -188],
        [289, 1859],
        [-23, 50],
        [-72, 42],
        [-54, 59],
        [-6, 75],
        [-12, 78],
        [18, 87],
        [15, 70],
        [16, 93],
        [-3, 76],
        [2, 62],
        [-13, 49],
        [-31, 41],
        [-55, 45],
        [-67, 38],
        [-70, 27],
        [-3, 1],
        [-69, 6],
        [-65, -29],
        [-47, -62],
        [-126, -272],
        [-175, -389],
        [-53, -61],
        [-59, -56],
        [-58, -48],
        [-96, -21],
        [-148, -10],
        [-146, 22],
        [-124, 38],
        [-100, 15],
        [-74, -2],
        [-94, -53],
        [-69, -73],
        [-77, -69],
        [-51, -40],
        [-1, -67],
        [50, -240],
        [2, -120],
        [-31, -133],
        [-67, -96],
        [-126, -69],
        [-133, -2],
        [-54, 51],
        [-70, 154],
        [-32, 221],
        [-61, 165],
        [-40, 214],
        [-14, 203],
        [-39, 110],
        [-136, 104],
        [-109, -2],
        [-86, -164],
        [-72, -66],
        [-114, -26],
        [-102, 86],
        [-152, 93],
        [-102, 122],
        [-113, 152],
        [-177, 57],
        [-33, 6],
        [-80, 12],
        [-117, 129],
        [-102, 41],
        [-93, -22],
        [-35, -92],
        [51, -127],
        [54, -231],
        [159, -358],
        [57, -219],
        [-47, -197],
        [-165, -141],
        [-217, -8],
        [-161, 48],
        [-131, 123],
        [-110, 137],
        [-58, 174],
        [-84, 172],
        [-134, 171],
        [-200, 169],
        [-184, 134],
        [-148, 160],
        [-31, 31],
        [-28, 36],
        [-2, 27],
        [-3, 21],
        [27, 88],
        [64, 109],
        [20, 60],
        [-16, 107],
        [8, 61],
        [82, 106],
        [-4, 51],
        [-23, 75],
        [-2, 62],
        [0, 54],
        [29, 90],
        [23, 50],
        [25, 78],
        [23, 16],
        [38, 13],
        [27, 25],
        [6, 29],
        [0, 22],
        [-8, 36],
        [-21, 41],
        [-1, 24],
        [2, 79],
        [7, 48],
        [-9, 36],
        [-30, 74],
        [-4, 71],
        [-11, 37],
        [-36, 34],
        [-32, 17],
        [-43, 17],
        [-44, -4],
        [-39, 8],
        [-55, 54],
        [-38, 64],
        [-8, 28],
        [4, 27],
        [8, 35],
        [9, 67],
        [8, 54],
        [5, 33],
        [5, 24],
        [1, 21],
        [-3, 16],
        [13, 14],
        [32, 25],
        [41, 32],
        [15, 36],
        [-7, 39],
        [-43, 43],
        [-50, 27],
        [-39, 8],
        [-22, 26],
        [22, 21],
        [25, 12],
        [42, 8],
        [38, 9],
        [-1, 40],
        [0, 20],
        [6, 21],
        [-9, 15],
        [-30, -3],
        [-26, -6],
        [-26, 17],
        [-18, 32],
        [0, 22],
        [5, 26],
        [6, 49],
        [6, 42],
        [16, 26],
        [0, 28],
        [-3, 55],
        [2, 52],
        [-15, 14],
        [-9, 25],
        [-27, 26],
        [-26, 65],
        [-23, 40],
        [-32, 18],
        [-57, 49],
        [-34, 41],
        [-33, 65],
        [-31, 2],
        [-22, 22],
        [8, 16],
        [23, 17],
        [-5, 10],
        [4, 17],
        [-3, 24],
        [-5, 17],
        [4, 19],
        [-2, 30],
        [-6, 45],
        [4, 42],
        [21, 38],
        [-3, 36],
        [-11, 32],
        [19, 18],
        [33, 6],
        [10, 14],
        [24, 10],
        [5, 19],
        [6, 25],
        [10, 17],
        [18, -4],
        [11, 10],
        [18, -1],
        [4, 27],
        [26, 24],
        [33, -10],
        [32, 2],
        [20, 4],
        [12, 12],
        [6, 35],
        [5, 9],
        [20, 5],
        [10, 11],
        [14, 1],
        [14, 16],
        [21, 0],
        [23, -4],
        [16, 3],
        [20, 10],
        [26, 19],
        [22, 20],
        [17, 16],
        [18, -4],
        [18, 7],
        [2, 8],
        [6, 11],
        [18, 6],
        [11, -5],
        [10, 4],
        [15, -2],
        [32, -16],
        [19, 13],
        [27, 1],
        [5, 6],
        [1, 17],
        [7, 5],
        [14, -15],
        [18, 0],
        [27, -2],
        [4, 16],
        [8, 9],
        [30, -6],
        [12, 23],
        [9, 6],
        [16, -3],
        [46, 5],
        [21, 2],
        [19, 15],
        [5, -11],
        [27, 1],
        [8, 8],
        [36, -4],
        [47, 2],
        [4, 20],
        [6, 30],
        [4, 12],
        [-12, 29],
        [-12, 29],
        [2, 28],
        [20, 27],
        [-4, 16],
        [-12, 14],
        [-23, 33],
        [-8, 35],
        [-2, 51],
        [15, 30],
        [8, 26],
        [-3, 27],
        [-11, 28],
        [-9, 25],
        [-1, 16],
        [13, 6],
        [25, -10],
        [2, -20],
        [10, -26],
        [13, -10],
        [33, -5],
        [28, -4],
        [22, -11],
        [36, -21],
        [16, 1],
        [27, -1],
        [-9, 20],
        [-7, 16],
        [-14, 5],
        [-17, 32],
        [10, 28],
        [-3, 14],
        [4, 21],
        [11, 13],
        [-3, 14],
        [-19, 14],
        [-15, 18],
        [-4, 18],
        [7, 6],
        [44, 16],
        [29, 13],
        [2, 52],
        [-12, 60],
        [-17, 10],
        [-43, 41],
        [-5, 33],
        [13, 27],
        [17, 17],
        [43, -14],
        [38, -11],
        [42, 0],
        [37, 10],
        [27, 24],
        [24, 11],
        [37, -8],
        [31, -8],
        [26, 16],
        [12, 8],
        [2, 21],
        [-10, 30],
        [-3, 46],
        [-9, 28],
        [10, 26],
        [38, 10],
        [47, 0],
        [11, -10],
        [16, 6],
        [8, 24],
        [-2, 31],
        [2, 22],
        [15, 16],
        [22, 18],
        [16, 28],
        [8, 18],
        [8, 10],
        [12, 3],
        [14, 7],
        [20, -4],
        [13, -11],
        [2, -21],
        [-10, -26],
        [-18, -11],
        [-25, -15],
        [-16, -24],
        [-2, -25],
        [11, -10],
        [22, -4],
        [14, 4],
        [36, 4],
        [34, 2],
        [39, -14],
        [27, -22],
        [18, -12],
        [9, 6],
        [12, 22],
        [2, 16],
        [10, 12],
        [18, 2],
        [24, -10],
        [18, 2],
        [9, 12],
        [-6, 25],
        [-13, 29],
        [19, 25],
        [24, 4],
        [12, 0],
        [7, 12],
        [26, 19],
        [43, 7],
        [49, -52],
        [19, -6],
        [21, -11],
        [10, -23],
        [14, -20],
        [39, -28],
        [31, -1],
        [20, 16],
        [25, 2],
        [41, -4],
        [-2, 24],
        [-14, 71],
        [-8, 70],
        [16, 13],
        [47, -7],
        [105, -9],
        [28, 45],
        [24, 11],
        [20, 15],
        [35, 19],
        [56, 2],
        [15, 13],
        [22, 34],
        [30, 14],
        [16, -8],
        [28, -16],
        [26, 7],
        [-2, 43],
        [0, 28],
        [10, 8],
        [41, -10],
        [31, -12],
        [15, -14],
        [18, 8],
        [2, 38],
        [8, 32],
        [-30, 10],
        [-17, 11],
        [-8, 17],
        [9, 61],
        [10, 26],
        [6, 15],
        [26, 42],
        [25, 39],
        [33, 29],
        [36, 25],
        [8, 15],
        [-4, 26],
        [-8, 28],
        [-4, 28],
        [8, 10],
        [24, 12],
        [16, 2],
        [9, -14],
        [15, -8],
        [13, -8],
        [22, 0],
        [40, -2],
        [15, 8],
        [31, 10],
        [52, -6],
        [6, 10],
        [13, 6],
        [28, 29],
        [10, 27],
        [-8, 17],
        [-19, 9],
        [-14, 17],
        [-25, 13],
        [-31, 11],
        [-20, 2],
        [-13, 12],
        [11, 36],
        [12, 10],
        [82, 38],
        [7, 28],
        [-2, 32],
        [15, 35],
        [-20, 15],
        [-18, 27],
        [8, 31],
        [13, 24],
        [65, 14],
        [30, 8],
        [3, 24],
        [-33, 18],
        [-29, 25],
        [-12, 30],
        [7, 26],
        [9, 24],
        [-12, 6],
        [-8, 14],
        [1, 30],
        [1, 31],
        [-22, 14],
        [-14, 18],
        [-24, 30],
        [-6, 25],
        [-12, 2],
        [-21, 32],
        [11, 12],
        [3, 14],
        [-4, 16],
        [-32, 38],
        [-27, 31],
        [2, 13],
        [-6, 9],
        [-3, 21],
        [13, 25],
        [-11, 12],
        [13, 31],
        [4, 26],
        [11, 8],
        [-3, 14],
        [-14, 13],
        [-26, 4],
        [-4, -15],
        [-21, -1],
        [-28, 6],
        [-32, 5],
        [-37, 18],
        [0, 10],
        [-40, 24],
        [-26, 16],
        [-4, 27],
        [-9, 22],
        [1, 11],
        [14, 12],
        [23, 13],
        [8, 17],
        [0, 26],
        [-22, 21],
        [-16, 22],
        [14, 12],
        [-12, 29],
        [-39, 9],
        [-29, 14],
        [-40, 22],
        [-24, 28],
        [-2, 29],
        [-2, 39],
        [-29, 23],
        [-1, 12],
        [15, 14],
        [5, 24],
        [-11, 22],
        [4, 12],
        [2, 15],
        [3, 27],
        [-15, 21],
        [4, 17],
        [5, 17],
        [-11, 36],
        [-16, 25],
        [6, 15],
        [-11, 6],
        [-10, 5],
        [-8, 16],
        [-9, 24],
        [-11, 10],
        [-22, 20],
        [-28, -2],
        [-20, 6],
        [-10, 20],
        [-29, 6],
        [-22, 35],
        [18, 19],
        [14, 17],
        [-20, 6],
        [-12, -3],
        [-21, -13],
        [-11, -5],
        [-6, 13],
        [2, 10],
        [-1, 10],
        [-19, 18],
        [-6, 12],
        [-4, 16],
        [-18, 55],
        [-11, 40],
        [-9, 30],
        [-4, 15],
        [0, 25],
        [-4, 14],
        [2, 8],
        [10, 5],
        [17, -5],
        [13, -8],
        [13, -3],
        [18, -6],
        [6, -16],
        [8, -4],
        [6, -15],
        [10, -8],
        [19, 0],
        [22, 12],
        [26, 8],
        [11, 9],
        [8, 9],
        [-14, 18],
        [-11, 19],
        [-8, 11],
        [-16, 21],
        [-10, 7],
        [-6, 10],
        [-12, 8],
        [-3, 8],
        [-12, 10],
        [0, 11],
        [2, 16],
        [-6, 14],
        [-8, 13],
        [-11, -1],
        [-5, 6],
        [-5, 13],
        [-37, 18],
        [-1, 12],
        [-7, 10],
        [3, 11],
        [-1, 12],
        [2, 14],
        [-6, 28],
        [3, 7],
        [1, 8],
        [-6, 17],
        [4, 19],
        [9, 8],
        [5, 16],
        [4, 21],
        [1, 19],
        [-21, 21],
        [-29, 30],
        [-24, 6],
        [-22, 10],
        [-19, 13],
        [-29, 13],
        [-17, 15],
        [-16, 7],
        [-13, 17],
        [-15, 38],
        [-7, 15],
        [-15, 7],
        [-51, 25],
        [-43, -1],
        [-49, -65],
        [-12, -61],
        [-11, -83],
        [-29, -38],
        [-48, -42],
        [-60, -13],
        [-47, 6],
        [-50, 73],
        [-62, 49],
        [-67, 14],
        [-73, -30],
        [-116, -3],
        [-45, 94],
        [-54, 37],
        [-26, 13],
        [-60, -16],
        [-48, -42],
        [-32, -53],
        [-20, -50],
        [-24, -81],
        [-11, -40],
        [-72, -36],
        [-92, -10],
        [-66, -14],
        [-63, -17],
        [-34, -46],
        [-69, -44],
        [-19, 0],
        [-78, -2],
        [-76, 20],
        [-119, -52],
        [-58, 24],
        [-35, 9],
        [-21, 44],
        [-39, 45],
        [-85, 72],
        [-85, 55],
        [-66, 44],
        [-51, 90],
        [-63, 88],
        [-4, 8],
        [-57, 41],
        [-66, 34],
        [-18, 50],
        [-12, 63],
        [-47, 62],
        [-64, 52],
        [-58, 28],
        [-52, 53],
        [-16, 33],
        [-27, 46],
        [-26, 36],
        [-68, 30],
        [-38, -18],
        [-18, -38],
        [-26, -37],
        [-63, -69],
        [-92, -71],
        [-28, 2],
        [-50, 16],
        [-70, 36],
        [-57, 42],
        [-24, 35],
        [-36, 18],
        [-27, -8],
        [-12, -35],
        [-22, -29],
        [-52, -34],
        [-96, -51],
        [-38, -70],
        [-29, -28],
        [-46, -43],
        [-61, -27],
        [-42, -30],
        [-48, -10],
        [-30, -20],
        [-4, -28],
        [4, -25],
        [21, -35],
        [3, -17],
        [-15, -8],
        [-36, 10],
        [-51, 11],
        [-33, -20],
        [-29, -31],
        [-8, -62],
        [8, -48],
        [19, -64],
        [6, -32],
        [-2, -48],
        [-19, -23],
        [-28, -10],
        [-35, 33],
        [-25, 8],
        [-27, -6],
        [-24, -27],
        [-1, -29],
        [10, -24],
        [34, -38],
        [-37, -55],
        [-15, -7],
        [-38, 9],
        [-29, 0],
        [-31, -30],
        [-48, -32],
        [-20, 2],
        [-43, 30],
        [-11, 0],
        [-98, -55],
        [-47, -9],
        [-27, -4],
        [-23, -14],
        [-26, -25],
        [-4, -28],
        [9, -42],
        [-31, -26],
        [-26, -8],
        [-36, 2],
        [-35, -18],
        [-32, -12],
        [-20, -18],
        [13, -51],
        [-9, -32],
        [-26, -20],
        [-6, -36],
        [-25, -47],
        [17, -34],
        [-14, -20],
        [-38, -6],
        [-12, -41],
        [-52, -40],
        [-46, -7],
        [-23, -25],
        [0, -28],
        [-30, -22],
        [-38, -15],
        [-42, 7],
        [-20, -5],
        [-18, -25],
        [-49, -49],
        [-50, -20],
        [-21, -24],
        [-18, -36],
        [4, -19],
        [-21, -28],
        [-36, -1],
        [-38, -5],
        [-50, -15],
        [-36, -26],
        [-63, 13],
        [-48, -13],
        [-70, 40],
        [-55, 19],
        [-60, 18],
        [-18, 22],
        [-11, 11],
        [-21, 24],
        [-51, 10],
        [-18, 14],
        [-2, 65],
        [34, 36],
        [12, 26],
        [-36, 43],
        [8, 32],
        [25, 31],
        [1, 15],
        [-4, 18],
        [12, 41],
        [0, 11],
        [9, 6],
        [-6, 20],
        [19, 9],
        [29, 42],
        [-3, 22],
        [-4, 47],
        [-8, 40],
        [23, 129],
        [15, 152],
        [-73, -26],
        [-47, -44],
        [-99, -7],
        [-42, -3],
        [-58, 10],
        [-35, 22],
        [-12, 17],
        [-3, 42],
        [-8, 35],
        [-156, 171],
        [-43, 28],
        [-66, 131],
        [-144, 70],
        [-108, 224],
        [-87, -68],
        [-55, -23],
        [-108, -27],
        [-167, 42],
        [-341, -84],
        [-57, 17],
        [-57, -25],
        [-40, -83],
        [-10, -106],
        [-24, -40],
        [-73, -22],
        [-57, -40],
        [-64, -75],
        [-55, -64],
        [-21, -143],
        [-25, -49],
        [-41, -61],
        [-24, -88],
        [-52, -62],
        [-40, -75],
        [16, -120],
        [31, -77],
        [32, -51],
        [61, -38],
        [69, -63],
        [23, -54],
        [-10, -181],
        [23, -188],
        [-68, -28],
        [-37, -79],
        [-73, -75],
        [-53, 5],
        [-44, 33],
        [-70, 63],
        [-38, -12],
        [-31, -52],
        [-78, -76],
        [-132, -60],
        [-74, -9],
        [-37, 5],
        [-66, 38],
        [-43, 63],
        [-69, 91],
        [-108, 95],
        [-26, 44],
        [-26, 24],
        [-11, 32],
        [-6, 71],
        [-30, 57],
        [-52, 86],
        [-85, 81],
        [-100, 34],
        [-53, 43],
        [-45, 46],
        [-64, 37],
        [-65, 72],
        [-136, 266],
        [-16, 14],
        [-1331, 30],
        [-2350, -642],
        [-12, 56],
        [11, 51],
        [-17, 72],
        [-74, 114],
        [-90, 93],
        [-70, 66],
        [-73, 37],
        [-38, 4],
        [-53, -14],
        [-21, -33],
        [-83, 7],
        [-87, 21],
        [-107, 47],
      ],
      [
        [63282, 312207],
        [-52, 24],
        [-84, 50],
        [-55, 53],
        [-60, 57],
        [-80, 34],
        [-107, 32],
        [-162, 41],
        [-76, 35],
        [-87, 26],
        [-66, -9],
        [-70, -5],
        [-90, 28],
        [-67, 36],
        [-50, 26],
        [-71, 44],
        [-41, 10],
        [-35, 13],
        [-52, 35],
        [-50, 25],
        [-97, -12],
        [-39, 4],
        [-27, -11],
        [-72, 0],
        [-72, -4],
        [-25, -8],
        [-85, -47],
        [-58, -21],
        [-23, 7],
        [-46, 4],
        [-38, -35],
        [-36, -34],
        [-34, -11],
        [-45, -2],
        [-25, 6],
        [-73, 40],
        [-53, 46],
        [-61, 39],
        [-30, 51],
        [-6, 64],
        [-2, 109],
        [-25, 81],
        [-8, 76],
        [-27, 40],
        [-81, 75],
        [-70, 67],
        [-31, 44],
        [-35, 56],
        [-43, 8],
        [-14, 22],
        [-10, 40],
        [-21, 15],
        [-73, -13],
        [-90, -81],
        [-19, -29],
        [-26, -62],
        [-43, -36],
        [-35, -41],
        [-37, -22],
        [-37, -80],
      ],
      [
        [60255, 313107],
        [-5, -12],
        [-10, -19],
        [17, -79],
        [10, -116],
        [-29, -36],
        [-55, -17],
        [-39, 7],
        [-28, 50],
        [-34, 94],
        [-42, 178],
        [-23, 104],
        [-23, 55],
        [-39, 65],
        [-32, 79],
        [-22, 3],
        [-26, -2],
        [-16, -24],
        [-2, -24],
        [-9, -8],
        [-30, -16],
        [-9, -5],
        [-10, -2],
        [-13, 2],
        [-28, 7],
        [-6, -2],
        [-12, 9],
        [-13, 2],
        [-16, 6],
        [-19, 13],
        [-23, 16],
        [-22, 0],
        [-27, -17],
        [-19, -43],
        [-15, -11],
        [-3, -12],
        [-12, -4],
        [-33, -18],
        [-74, -8],
        [-76, -26],
        [-79, 8],
        [-20, -7],
        [-24, -25],
        [-37, -33],
        [-39, -48],
        [-16, -16],
        [-5, 0],
        [-4, -2],
        [4, -10],
        [-7, -12],
        [0, -7],
        [-4, -22],
        [-6, -26],
        [1, -16],
        [13, -15],
        [6, -7],
        [13, -16],
        [30, -41],
        [4, -26],
        [-7, -11],
        [-28, -8],
        [-62, -8],
        [-62, -5],
        [-36, -5],
        [-24, -7],
        [-22, -9],
        [-13, -8],
        [-23, -16],
        [-6, -12],
        [-15, 0],
        [2, -21],
        [12, -12],
        [35, -17],
        [74, -16],
        [100, -24],
        [80, -30],
        [52, -49],
        [38, -67],
        [16, -51],
        [12, -97],
        [2, -42],
        [8, -45],
        [22, -75],
        [14, -24],
        [12, -20],
        [10, -32],
        [10, -38],
        [10, -21],
        [1, -24],
        [4, -48],
        [-7, -74],
        [-6, -31],
        [-4, -9],
        [-29, -63],
        [-26, -21],
        [-17, -14],
        [-14, -12],
        [-13, -12],
        [-2, -8],
        [-9, -4],
        [-8, -12],
        [-11, 0],
        [-9, -5],
        [-20, -15],
        [-26, -19],
        [-18, -18],
        [-23, 3],
        [-11, 7],
        [-28, 33],
        [-14, 14],
        [-16, 6],
        [-22, 0],
        [-40, -11],
        [-23, -14],
        [-23, -4],
        [-24, -12],
        [-33, -17],
        [-24, -13],
        [-20, -8],
        [-23, -5],
        [-22, 3],
        [-31, -4],
        [-30, -6],
        [-21, -18],
        [-27, -26],
        [-35, -22],
        [-18, -12],
        [-18, -18],
        [-17, -2],
        [-24, -2],
        [-25, 9],
        [-24, 4],
        [-24, -14],
        [-15, -51],
        [-11, -55],
        [3, -51],
        [-7, -43],
        [-16, -16],
        [-28, -12],
        [-30, -4],
        [-29, -21],
        [-21, -9],
        [-6, -11],
        [-17, 0],
        [-14, -5],
        [-22, -1],
        [-22, -22],
        [-16, -12],
        [-12, -21],
        [-2, -23],
        [13, -32],
        [34, -49],
        [12, -22],
        [11, -45],
        [0, -32],
        [-11, -36],
        [-14, -26],
        [-19, -4],
        [-14, -11],
        [-14, -7],
        [-10, -10],
        [-24, 8],
        [-27, 28],
        [-29, 34],
        [-7, 31],
        [-14, 14],
        [-8, 31],
        [-4, 21],
        [-6, 20],
        [2, 11],
        [-6, 8],
        [-21, 12],
        [-19, -3],
        [-5, -14],
        [14, -11],
        [2, -18],
        [-7, -4],
        [-1, -17],
        [-11, -5],
        [-18, -8],
        [-14, -16],
        [2, -19],
        [14, -29],
        [14, -33],
        [-9, -21],
        [-19, -18],
        [-10, -6],
        [-2, -8],
        [-12, -4],
        [-6, -7],
        [-27, -7],
        [-10, -20],
        [-9, -8],
        [1, -13],
        [7, -4],
        [14, -14],
        [40, -15],
        [30, 0],
        [18, -3],
        [10, -26],
        [0, -61],
        [11, -37],
        [14, -30],
        [27, -45],
        [8, -8],
        [10, -24],
        [10, -11],
        [2, -14],
        [-2, -26],
        [8, -8],
        [-2, -8],
        [5, -7],
        [20, -53],
        [11, -18],
        [11, -3],
        [26, -1],
        [-6, -25],
        [-58, -81],
        [-24, -31],
        [-35, -50],
        [-20, -63],
        [-7, -32],
        [22, -55],
        [-2, -20],
        [13, -15],
        [22, -29],
        [11, -27],
        [3, -20],
        [9, -20],
        [14, -49],
        [15, -76],
        [-1, -28],
      ],
      [
        [58256, 309948],
        [-318, 124],
        [-2729, 530],
        [-115, 84],
        [-170, 125],
        [-271, 201],
        [-711, 625],
        [208, 772],
        [392, 1456],
        [-2456, -606],
        [-3, 21],
        [-239, 1758],
        [571, 888],
        [-18, 218],
        [-54, 633],
        [-162, 1958],
        [-91, 323],
        [-136, 484],
        [-434, 1541],
        [-680, 184],
        [-598, 804],
        [-756, 659],
        [-160, -115],
        [-125, -62],
        [-46, -21],
        [-153, -11],
        [-66, 25],
        [-23, 55],
        [6, 42],
        [31, 54],
        [28, 39],
        [97, 75],
        [141, 165],
        [46, 92],
        [21, 58],
        [12, 57],
        [-6, 73],
        [-35, 157],
        [-78, 145],
        [-248, -82],
        [24, 173],
        [-9, 184],
        [-152, 411],
        [-28, 99],
        [-79, 291],
        [-124, 326],
        [-104, 226],
        [-83, 177],
        [-16, 86],
        [0, 58],
        [16, 24],
        [24, 22],
        [25, 26],
        [10, 39],
        [-3, 51],
        [-4, 50],
        [4, 33],
        [22, 31],
        [39, 31],
        [84, 72],
        [52, 98],
        [6, 125],
        [4, 149],
        [-32, 105],
        [-48, 106],
        [-195, 258],
        [-114, 48],
        [1053, 1174],
        [1344, 2155],
        [2136, 1924],
        [-1722, 3209],
        [-7, 12],
        [-36, 63],
        [-589, 1046],
        [54, 1159],
        [2, 65],
        [0, 6],
        [2, 8],
        [28, 609],
        [-350, 1172],
        [-1631, 2290],
        [-115, 154],
        [35, 14],
        [3, 2],
        [2, 1],
        [56, 30],
        [436, 239],
        [-170, 552],
        [80, 1534],
        [21, 393],
        [77, 1496],
        [2, 24],
        [28, 541],
        [-50, 127],
        [-127, 325],
        [-739, 351],
        [-572, 272],
        [-852, 404],
        [-1394, 473],
        [-627, 1461],
        [-1046, 789],
        [-17, 52],
        [-845, 2323],
        [-24, 80],
        [8, 595],
        [97, 402],
        [41, 210],
        [69, 309],
        [87, 354],
        [-40, 26],
        [-651, 571],
        [-40, 6],
        [-45, 36],
        [-29, 49],
        [-14, 65],
        [-136, 1167],
        [-497, 199],
        [418, 625],
        [-1139, 605],
        [-2, 677],
        [-1, 362],
        [-871, -497],
        [-42, 0],
        [-53, 18],
        [-24, 29],
        [-22, 42],
        [-5, 98],
        [-12, 63],
        [-10, 38],
        [-17, 26],
        [-62, 83],
        [-78, 83],
        [-57, 286],
        [-7, 112],
        [-69, 60],
        [-86, 61],
        [-51, 12],
        [-26, -19],
        [-517, -381],
        [-123, 100],
        [-865, 712],
        [-1873, 14],
        [-864, 6],
        [-1129, 12],
        [-211, 363],
        [-142, 254],
        [-360, 593],
        [-502, 850],
        [-317, 555],
        [137, 397],
        [218, 572],
        [251, 711],
        [369, -97],
        [626, 224],
        [513, 176],
        [181, 419],
        [305, 385],
        [333, 394],
        [229, 512],
        [-2199, 766],
        [-628, 217],
        [-302, 1131],
        [-21, 1326],
        [-275, 671],
        [-47, 1327],
        [-75, 1326],
        [-1472, 898],
        [-828, 1233],
        [-908, 418],
        [-221, 100],
        [-601, -19],
        [-846, 1038],
        [-27, 33],
        [-653, 802],
        [-814, 580],
        [-147, 105],
        [-288, 988],
        [-154, 1152],
        [-8, 59],
        [-144, 827],
        [-3, 19],
        [-114, 266],
        [-127, 324],
        [-117, 359],
        [-25, 77],
        [-25, 77],
        [-69, 173],
        [-40, 36],
        [3, 47],
        [5, 35],
        [18, 28],
        [-7, 55],
        [7, 70],
        [-30, 43],
        [-28, 5],
        [-18, 13],
        [-5, 28],
        [-47, 82],
        [-13, 34],
        [0, 28],
        [11, 26],
        [14, 18],
        [19, 4],
        [19, 2],
        [32, -2],
        [16, 12],
        [16, -4],
        [27, 33],
        [26, 36],
        [-4, 14],
        [-12, 4],
        [-25, 0],
        [-20, 6],
        [-24, 26],
        [-8, 34],
        [2, 37],
        [-16, 14],
        [-11, 14],
        [-12, 11],
        [-20, 0],
        [-20, 34],
        [-35, 4],
        [-11, 29],
        [-11, 41],
        [-37, 22],
        [0, 23],
        [9, 40],
        [38, 20],
        [16, 26],
        [21, 26],
        [37, 18],
        [-35, 4],
        [-35, 21],
        [-27, 1],
        [-32, 20],
        [-20, 30],
        [0, 33],
        [0, 34],
        [-16, 25],
        [-7, 25],
        [2, 31],
        [-24, 17],
        [-31, 28],
        [-23, 42],
        [-25, 13],
        [-18, 19],
        [0, 61],
        [-19, 28],
        [-23, 41],
        [-2, 30],
        [18, 25],
        [-12, 83],
        [-40, 60],
        [-37, 81],
        [-13, 22],
        [-40, 29],
        [-12, 20],
        [-44, 84],
        [-21, 40],
        [-10, 41],
        [7, 41],
        [-1, 31],
        [20, 33],
        [-3, 9],
        [-44, 27],
        [-31, 33],
        [-13, 40],
        [10, 17],
        [-3, 14],
        [-27, 17],
        [-39, 21],
        [-12, 14],
        [-8, 31],
        [8, 17],
        [10, 50],
        [9, 18],
        [-1, 12],
        [-10, 17],
        [-2, 20],
        [6, 38],
        [-18, 8],
        [-13, 28],
        [-5, 28],
        [-18, 19],
        [-22, 47],
        [5, 30],
        [7, 70],
        [17, 67],
        [-23, 28],
        [-147, -61],
        [25, 35],
        [-34, 42],
        [-28, 59],
        [-20, 22],
        [-11, 20],
        [-6, 12],
        [-11, 0],
        [-13, -4],
        [-25, 22],
        [-13, 16],
        [-15, 24],
        [-5, 27],
        [-14, 18],
        [-16, 29],
        [-11, 41],
        [4, 47],
        [-4, 36],
        [-11, 36],
        [-20, 26],
        [-11, 18],
        [-6, 27],
        [3, 20],
        [14, 13],
        [18, 8],
        [26, 3],
        [10, 13],
        [-9, 51],
        [6, 91],
        [4, 17],
        [8, 36],
        [1, 35],
        [-8, 40],
        [-23, 30],
        [1, 38],
        [0, 37],
        [25, 41],
        [44, 1],
        [34, 9],
        [20, 26],
        [-6, 33],
        [-25, 38],
        [-13, 59],
        [-16, 33],
        [-35, 20],
        [-21, 6],
        [-21, 24],
        [-26, 27],
        [-22, 0],
        [-36, 17],
        [-48, 20],
        [-114, 214],
        [23, 86],
        [50, 30],
        [-34, 48],
        [30, 34],
        [28, 95],
        [30, 145],
        [0, 263],
        [41, 272],
        [43, 208],
        [29, 140],
        [183, 872],
        [8, 30],
        [10, 50],
        [234, 1108],
        [-2, 4],
        [-284, 2164],
        [-14, 108],
        [-18, 135],
        [-127, 968],
        [-8, 27],
        [-193, 822],
        [-109, 459],
        [-38, 135],
        [-5, 77],
        [74, 39],
        [212, 57],
        [88, -24],
        [159, -98],
        [77, -64],
        [153, -85],
        [120, -150],
        [66, -31],
        [68, 0],
        [-15, 74],
        [-25, 57],
        [-17, 94],
        [-15, 112],
        [-45, 53],
        [-48, 46],
        [-52, 62],
        [0, 50],
        [-16, 23],
        [-8, 36],
        [4, 25],
        [-2, 50],
        [-25, 50],
        [-35, 54],
        [-3, 69],
        [-27, 32],
        [-59, 14],
        [-31, -24],
        [-71, 20],
        [-45, 20],
        [-69, 89],
        [-68, 42],
        [-19, 42],
        [-31, 47],
        [22, 73],
        [40, 31],
        [25, 20],
        [64, 19],
        [48, -18],
        [39, 19],
        [13, -20],
        [63, -74],
        [71, -96],
        [205, 63],
        [65, 13],
        [37, -38],
        [87, -200],
        [66, -133],
        [49, -28],
        [37, -11],
        [44, -14],
        [24, -12],
        [17, -16],
        [20, -29],
        [3, -30],
        [21, -15],
        [8, 4],
        [27, -4],
        [14, -8],
        [18, -20],
        [22, 0],
        [19, 36],
        [15, 43],
        [1, 47],
        [0, 65],
        [5, 33],
        [14, 28],
        [12, 42],
        [18, 11],
        [30, 12],
        [22, -3],
        [31, -12],
        [34, -32],
        [23, 0],
        [31, 4],
        [32, 12],
        [28, 26],
        [19, 5],
        [22, -2],
        [14, -14],
        [34, -35],
        [18, -37],
        [17, -95],
        [-45, -87],
        [-22, -10],
        [-8, -9],
        [-16, -16],
        [-17, -10],
        [-16, -26],
        [-10, -33],
        [0, -27],
        [0, -43],
        [1, -58],
        [10, -33],
        [25, -46],
        [7, -44],
        [28, -38],
        [17, -29],
        [13, -22],
        [17, -13],
        [23, -18],
        [21, -20],
        [24, -20],
        [37, -16],
        [20, -14],
        [70, -35],
        [24, -45],
        [28, -53],
        [10, 38],
        [10, 35],
        [13, 19],
        [17, 23],
        [40, 37],
        [19, 20],
        [16, 13],
        [40, 24],
        [35, 4],
        [15, 15],
        [31, 27],
        [30, 23],
        [19, 27],
        [17, 16],
        [29, 23],
        [23, 14],
        [13, 14],
        [16, 26],
        [24, 11],
        [31, 8],
        [20, 1],
        [34, -18],
        [42, -20],
        [23, -9],
        [20, 11],
        [-1, 24],
        [-4, 19],
        [-4, 15],
        [6, 20],
        [21, 20],
        [40, 10],
        [27, 2],
        [21, 4],
        [16, 10],
        [3, 13],
        [-14, 19],
        [-7, 19],
        [9, 24],
        [19, 30],
        [26, 42],
        [36, 31],
        [34, 10],
        [37, 21],
        [73, 39],
        [27, -4],
        [93, -26],
        [61, -20],
        [79, -56],
        [48, -53],
        [26, -76],
        [20, -33],
        [54, -58],
        [7, -11],
        [13, -20],
        [9, -13],
        [20, -20],
        [28, -21],
        [44, -85],
        [16, -33],
        [36, -40],
        [77, -91],
        [79, -88],
        [81, -53],
        [48, -11],
        [36, 1],
        [76, -16],
        [71, -7],
        [28, -10],
        [12, -14],
        [0, -29],
        [14, -46],
        [30, -35],
        [56, -35],
        [102, -30],
        [109, -43],
        [73, -65],
        [86, -141],
        [56, -159],
        [51, -84],
        [82, -25],
        [78, 4],
        [66, 22],
        [54, 57],
        [27, 105],
        [11, 92],
        [30, 81],
        [85, 46],
        [61, 0],
        [59, 20],
        [73, 26],
        [22, 47],
        [-7, 98],
        [-6, 108],
        [-5, 94],
        [-34, 109],
        [-8, 88],
        [-19, 62],
        [6, 55],
        [11, 23],
        [1, 38],
        [0, 32],
        [59, 53],
        [38, 66],
        [22, 73],
        [6, 88],
        [13, 33],
        [-30, 13],
        [-124, 80],
        [-142, 151],
        [-2, 3],
        [-47, 127],
        [-66, 38],
        [-63, 107],
        [-52, 52],
        [-31, 131],
        [-12, 56],
        [24, 130],
        [10, 43],
        [-9, 21],
        [-35, 18],
        [-24, 52],
        [-2, 26],
        [14, 33],
        [-2, 37],
        [-17, 61],
        [21, 38],
        [13, 24],
        [42, 50],
        [43, 37],
        [25, 14],
        [38, 2],
        [67, -4],
        [54, -4],
        [45, -6],
        [61, -8],
        [31, -21],
        [46, -34],
        [27, -42],
        [30, -46],
        [6, -34],
        [-50, -56],
        [-39, -75],
        [2, -47],
        [23, -58],
        [208, -147],
        [155, -112],
        [17, -33],
        [-16, -49],
        [-90, -77],
        [-79, -43],
        [-11, -55],
        [116, -360],
        [41, -91],
        [47, -45],
        [43, -8],
        [66, 2],
        [26, -18],
        [111, -40],
        [176, -75],
        [142, -74],
        [92, -89],
        [24, -40],
        [55, -155],
        [120, -179],
        [105, -78],
        [145, -75],
        [217, -125],
        [355, 16],
        [146, 1],
        [137, -31],
        [93, -20],
        [33, -8],
        [73, -16],
        [171, -59],
        [176, -38],
        [187, -5],
        [26, -1],
        [76, -3],
        [91, 2],
        [131, 9],
        [63, 0],
        [69, -9],
        [85, -13],
        [50, 8],
        [53, 3],
        [51, -27],
        [44, -37],
        [15, -21],
        [34, -45],
        [85, -124],
        [61, -67],
        [109, -190],
        [22, -27],
        [54, -3],
        [435, 451],
        [37, 37],
        [25, 48],
        [26, 35],
        [21, 4],
        [21, -14],
        [32, -7],
        [183, -2],
        [58, 7],
        [32, 14],
        [117, 66],
        [90, 46],
        [313, -42],
        [67, -8],
        [64, -26],
        [38, -6],
        [65, 17],
        [134, 9],
        [86, 10],
        [99, 34],
        [399, 127],
        [161, 87],
        [70, -15],
        [74, -64],
        [79, -67],
        [64, -60],
        [36, -22],
        [20, -12],
        [19, -8],
        [30, -14],
        [83, -22],
        [88, -67],
        [44, -79],
        [98, -86],
        [149, -33],
        [186, -10],
        [140, 28],
        [146, -134],
        [72, -127],
        [121, -89],
        [88, 103],
        [56, 208],
        [118, 209],
        [29, 10],
        [38, -18],
        [27, -14],
        [32, -25],
        [183, -155],
        [10, -9],
        [122, -101],
        [68, -50],
        [30, -22],
        [19, -13],
        [51, -8],
        [36, 21],
        [54, 51],
        [29, 59],
        [49, 97],
        [111, 214],
        [101, 192],
        [45, 45],
        [43, 31],
        [27, 20],
        [8, 6],
        [72, 36],
        [127, 13],
        [14, 2],
        [232, -85],
        [210, -79],
        [281, -55],
        [1673, -544],
        [-358, 867],
        [48, 36],
        [2294, 241],
        [531, 55],
        [1895, 901],
        [399, 194],
        [1566, 988],
        [82, 46],
        [71, 0],
        [35, -14],
        [69, -15],
        [75, 0],
        [161, 6],
        [88, 1],
        [95, -5],
        [71, -11],
        [60, -21],
        [38, -31],
        [34, -55],
        [27, -96],
        [33, -52],
        [77, -59],
        [95, -10],
        [72, 22],
        [138, 70],
        [325, -264],
        [52, 57],
        [326, 366],
        [213, -231],
        [496, -4],
        [189, -445],
        [360, 977],
        [-43, 1935],
        [1546, 2],
        [475, 822],
        [3250, -1970],
        [930, 380],
        [9, 4],
        [995, 731],
        [-120, 1928],
        [-5, 95],
        [988, -284],
        [266, -340],
        [1333, 919],
        [6, 5],
        [-573, 371],
        [-1636, 3404],
        [-6, 12],
        [119, 889],
        [308, 648],
        [278, 343],
        [-519, 31],
        [-303, 47],
        [-117, 145],
        [-23, 66],
        [-43, 67],
        [55, 130],
        [37, 79],
        [128, 155],
        [6, 57],
        [11, 46],
        [31, 55],
        [22, 39],
        [7, 62],
        [3, 81],
        [4, 36],
        [19, 18],
        [28, 32],
        [30, 45],
        [17, 9],
        [31, 33],
        [0, 92],
        [16, 208],
        [11, 56],
        [-90, 206],
        [10, 92],
        [39, 119],
        [88, 93],
        [86, 83],
        [76, -15],
        [36, 12],
        [-5, 47],
        [17, 30],
        [43, 10],
        [82, 137],
        [0, 73],
        [66, 65],
        [45, 24],
        [15, 33],
        [-25, 78],
        [-37, 90],
        [-34, 38],
        [-14, 66],
        [18, 25],
        [-69, 101],
        [-20, 36],
        [0, 25],
        [4, 533],
        [-137, 11],
        [-175, -11],
        [-131, -41],
        [-150, -43],
        [-102, -31],
        [-271, -39],
        [-530, 2208],
        [35, 1180],
        [-1256, 1409],
        [-26, 61],
        [-94, 230],
        [-129, 344],
        [-159, 93],
        [-96, 89],
        [-99, 80],
        [-36, 75],
        [-152, 1362],
        [-973, 1318],
        [73, 1662],
        [-305, 573],
        [5, 3364],
        [0, 44],
        [2, 1480],
        [0, 68],
        [-2, 0],
        [-14, 2],
        [-1074, 243],
        [-127, 15],
        [-194, 37],
        [-874, 383],
        [-277, 600],
        [-302, 33],
        [-815, 351],
        [-139, 1980],
        [570, -190],
        [292, 178],
        [211, 177],
        [234, 195],
        [37, 401],
        [-360, 374],
        [-1745, -167],
        [-494, 1268],
        [-84, 160],
        [-867, 1614],
        [188, 567],
        [-96, 99],
        [-125, 154],
        [-333, 573],
        [-47, 41],
        [-421, 217],
        [-124, 50],
        [-399, 165],
        [-53, 23],
        [-46, 37],
        [-28, 12],
        [-33, 9],
        [-31, 7],
        [-36, 14],
        [-27, 23],
        [-13, 18],
        [-5, 33],
        [10, 27],
        [4, 22],
        [15, 15],
        [21, 16],
        [33, 23],
        [24, 23],
        [9, 37],
        [-5, 41],
        [-4, 31],
        [-8, 24],
        [-14, 12],
        [-27, 4],
        [-25, -6],
        [-9, -15],
        [-12, -20],
        [-20, -10],
        [-27, -7],
        [-20, -8],
        [-19, 0],
        [-11, 9],
        [-17, 12],
        [-14, 9],
        [-11, 14],
        [-10, 24],
        [7, 21],
        [69, 62],
        [17, 15],
        [24, 24],
        [12, 9],
        [17, 18],
        [24, 14],
        [15, 4],
        [16, 6],
        [11, 18],
        [14, 27],
        [6, 30],
        [-4, 31],
        [-2, 77],
        [-2, 26],
        [0, 37],
        [2, 33],
        [2, 47],
        [0, 23],
        [4, 27],
        [12, 43],
        [4, 14],
        [10, 28],
        [14, 22],
        [12, 21],
        [9, 15],
        [7, 10],
        [1, 13],
        [-12, 16],
        [-12, 20],
        [-6, 28],
        [-15, 48],
        [-16, 33],
        [-10, 28],
        [-6, 44],
        [-10, 10],
        [-28, 2],
        [-26, 5],
        [-25, 14],
        [-24, 4],
        [-23, 25],
        [-13, 25],
        [-14, 25],
        [-3, 37],
        [-5, 15],
        [8, 13],
        [16, 12],
        [17, 9],
        [23, -8],
        [8, -12],
        [19, -9],
        [35, 0],
        [30, 19],
        [29, 22],
        [6, 23],
        [0, 32],
        [0, 29],
        [9, 31],
        [19, 18],
        [-2, 32],
        [1, 27],
        [13, 26],
        [-1, 23],
        [10, 33],
        [0, 41],
        [-5, 20],
        [6, 33],
        [16, 37],
        [10, 29],
        [9, 40],
        [2, 26],
        [14, 42],
        [11, 18],
        [0, 27],
        [4, 30],
        [20, 94],
        [117, 480],
        [43, 214],
        [200, 251],
        [-20, 326],
        [-270, 1481],
        [-329, 1811],
        [-33, -17],
        [-101, -139],
        [-202, 937],
        [-60, 281],
        [180, 133],
        [-253, 1398],
        [-322, 1767],
        [-177, 974],
        [-54, 295],
        [146, 8],
        [374, -14],
        [176, 37],
        [-115, 416],
        [241, 63],
        [85, 262],
        [15, 103],
        [-50, 208],
        [-22, 49],
        [-20, 26],
        [-38, 11],
        [-696, -68],
        [-289, -42],
        [-130, 719],
        [195, 109],
        [22, 22],
        [1101, 1054],
        [601, 899],
        [-91, 487],
        [-587, 941],
        [-1196, 1514],
        [-769, -469],
        [-248, -163],
        [-45, 111],
        [28, 141],
        [20, 175],
        [4, 113],
        [0, 120],
        [-23, 118],
        [-63, 153],
        [-87, 165],
        [-26, 78],
        [-46, 48],
        [-136, 602],
        [-156, 696],
        [868, 49],
        [273, 1128],
        [-182, 216],
        [-277, 328],
        [98, 973],
        [-608, 702],
        [-396, -11],
        [-73, 9],
        [-68, 41],
        [-48, 44],
        [-57, 55],
        [-26, 58],
        [16, 71],
        [37, 35],
        [93, 17],
        [51, 14],
        [90, -18],
        [182, 254],
        [263, -183],
        [345, 189],
        [97, 40],
        [91, -109],
        [665, 326],
        [23, 379],
        [2973, -110],
        [772, 2669],
        [-2095, 6746],
        [7, 109],
        [-239, 1964],
        [-724, 1355],
        [82, 412],
        [1448, 78],
        [292, 1126],
        [284, 16],
        [526, 28],
        [576, 33],
        [76, 0],
        [105, 12],
        [196, 41],
        [228, 37],
        [238, 49],
        [290, 56],
        [302, 51],
        [113, 94],
        [92, 61],
        [268, 171],
        [630, 445],
        [61, 44],
        [-25, 35],
        [-55, 59],
        [-263, 125],
        [-373, 112],
        [-209, 76],
        [-153, 15],
        [-162, 25],
        [-163, 59],
        [-52, 33],
        [-47, 59],
        [-794, 2302],
        [1483, 924],
        [-1311, 1718],
        [1136, 323],
        [-320, 1439],
        [8, 93],
        [13, 140],
        [81, 911],
        [-638, 1460],
        [189, 65],
        [2081, 675],
        [-1662, 2099],
        [-688, 1338],
        [-174, 276],
        [4115, 103],
        [-13, 716],
        [2779, 598],
        [433, -74],
        [28, 140],
        [120, 619],
        [90, 107],
        [8, 9],
        [47, 55],
        [67, 80],
        [-389, 2989],
        [-464, 26],
        [-3271, 39],
        [-366, 53],
        [-677, 170],
        [-338, 147],
        [-245, 164],
        [-91, 78],
        [-40, 248],
        [-128, 536],
        [-220, 778],
        [14, 90],
        [45, 68],
        [1229, 803],
        [403, 71],
        [72, 133],
        [-894, 2074],
        [367, 355],
        [15, 15],
        [49, 49],
        [-10, 711],
        [-264, 952],
        [22, 1465],
        [-254, 1278],
        [-321, 58],
        [-32, 67],
        [-7, 46],
        [11, 26],
        [1, 4],
        [10, 22],
        [37, 42],
        [381, 385],
        [377, 378],
        [31, 363],
        [59, 577],
        [17, 160],
        [92, 671],
        [1, 6],
        [70, 513],
        [31, 229],
        [228, 1670],
        [-227, 919],
        [-3, 10],
        [-154, 624],
        [-98, 399],
        [0, 19],
        [12, 2079],
        [-227, 12],
        [230, 490],
        [0, 1],
        [176, 370],
        [-367, 8923],
        [-94, 2364],
        [-69, 1793],
        [2113, -812],
        [155, -44],
        [28, -268],
        [534, -262],
        [80, -37],
        [13, -173],
        [120, -26],
        [234, -70],
        [12, -16],
        [124, -195],
        [90, -6],
        [19, 12],
        [59, -6],
        [144, 13],
        [581, -219],
        [518, 1126],
        [-24, 27],
        [-97, 108],
        [-1337, 1512],
        [-95, 362],
        [-258, 943],
        [-212, -12],
        [-316, 664],
        [-616, 44],
        [-133, 10],
        [-113, 8],
        [-161, 12],
        [-62, 4],
        [-522, 38],
        [-74, 6],
        [-919, 67],
        [137, 2301],
        [-36, 59],
        [-861, 1361],
        [-159, 254],
        [-725, 1136],
        [1931, 1130],
        [239, 129],
        [601, 1962],
        [-3308, 96],
        [-225, 7],
        [-70, 10],
        [-81, 27],
        [-82, 63],
        [473, 145],
        [-175, 1991],
        [-92, 1068],
        [-35, 385],
        [0, 2],
        [-322, 289],
        [-354, 318],
        [-72, 84],
        [-37, 186],
        [-192, 1469],
        [-594, -154],
        [-1804, 1251],
        [-25, 17],
        [-647, 449],
        [38, 742],
        [10, 196],
        [-1848, 103],
        [-338, -587],
        [-1653, 373],
        [-33, 8],
        [-2557, 584],
        [-224, 267],
        [-316, 11],
        [-550, 557],
        [-115, 42],
        [-35, 13],
        [-422, 155],
        [-654, 271],
        [-354, 127],
        [-35, 12],
        [-127, 69],
        [-22, 81],
        [-58, 799],
        [0, 6],
        [540, 2886],
        [129, 556],
        [-1237, 1996],
        [-1982, 1340],
        [-1812, -163],
        [287, 881],
        [506, 1571],
        [5, 181],
        [326, 5352],
        [17, 301],
        [-69, 365],
        [-512, 2742],
        [5942, -139],
        [2519, -91],
        [-2, 97],
        [-10, 1293],
        [-8, 952],
        [-4, 529],
        [-7, 968],
        [-4, 511],
        [-4, 500],
        [-4, 513],
        [-1, 141],
        [-2, 279],
        [-8, 941],
        [1786, 21],
        [686, 6],
        [1017, 10],
        [459, 6],
        [439, 4],
        [432, 4],
        [374, 4],
        [405, 4],
        [379, 4],
        [411, 5],
        [997, 9],
        [-2, 58],
        [-3, 372],
        [-7, 810],
        [-22, 613],
        [-1502, 10],
        [-861, -9],
        [-1847, 7],
        [153, 190],
        [60, 62],
        [103, 70],
        [170, 179],
        [47, 49],
        [22, 32],
        [106, 160],
        [89, 128],
        [14, 15],
        [21, 8],
        [67, 22],
        [25, 10],
        [80, 43],
        [97, 56],
        [90, 59],
        [63, 31],
        [61, 32],
        [35, 31],
        [44, 16],
        [49, 30],
        [-53, 0],
        [-61, 21],
        [-24, 2],
        [-48, 20],
        [-52, 31],
        [-50, 24],
        [-23, 23],
        [-55, 58],
        [-48, 52],
        [-42, 41],
        [-69, 52],
        [-111, 72],
        [-54, 63],
        [-123, 134],
        [-91, 106],
        [-59, 89],
        [-45, 71],
        [-61, 117],
        [-72, 85],
        [-60, 55],
        [-71, 58],
        [-61, 27],
        [-59, 19],
        [-86, 7],
        [-67, 15],
        [-65, 8],
        [-49, 7],
        [-66, 16],
        [-117, 25],
        [-212, 45],
        [-44, 9],
        [-38, 20],
        [-52, 42],
        [-55, 20],
        [-19, 31],
        [-19, 42],
        [15, 43],
        [3, 53],
        [-4, 95],
        [24, 59],
        [-7, 98],
        [-11, 73],
        [-6, 58],
        [-16, 49],
        [-14, 26],
        [-17, 23],
        [-37, 29],
        [-30, 68],
        [-31, 83],
        [-17, 42],
        [-15, 41],
        [4, 70],
        [21, 72],
        [-29, 40],
        [-14, 73],
        [-30, 81],
        [27, 42],
        [-33, 100],
        [-11, 52],
        [-4, 52],
        [-4, 75],
        [3, 98],
        [-1, 40],
        [3, 49],
        [9, 37],
        [13, 46],
        [2, 48],
        [8, 38],
        [-2908, 1141],
        [-92, 35],
        [-67, 26],
        [-34, 14],
        [-813, 317],
        [-763, 677],
        [658, 2253],
        [1854, 1577],
        [-2678, 143],
        [-765, 1591],
        [-2450, -1100],
        [-49, 7],
        [-118, 39],
        [-141, 133],
        [-57, 82],
        [-7, 31],
        [-20, 82],
        [23, 353],
        [275, 449],
        [195, 315],
        [22, 30],
        [41, 16],
        [261, 145],
        [147, 103],
        [218, 158],
        [211, 159],
        [151, 108],
        [117, 215],
        [920, 4],
        [36, 0],
        [2822, 12],
        [91, 0],
        [449, 740],
        [1109, 1825],
        [2, 3],
        [2231, 3668],
        [3897, 51],
        [127, 1],
        [1459, 18],
        [3730, -10],
        [1945, 3],
        [34, 0],
        [4496, 5],
        [402, 0],
        [28, 0],
        [4096, -3],
        [2863, -20],
        [27, 0],
        [731, -5],
        [1530, 3],
        [727, 15],
        [233, 21],
        [1561, 6],
        [5959, -22],
        [1, 0],
        [21, 6491],
        [0, 33],
        [6, 1231],
        [2, 854],
        [6, 2089],
        [1, 187],
        [0, 39],
        [1, 58],
        [0, 149],
        [10, 2832],
        [1, 315],
        [11, 2915],
        [0, 55],
        [-60, 3748],
        [0, 4056],
        [12, 486],
        [-6, 4534],
        [4312, 0],
        [156, 0],
        [1693, 15],
        [4099, 33],
        [2428, -74],
        [123, -2],
        [58, 0],
        [408, 0],
        [221, 2],
        [2440, 8],
        [2071, -16],
        [717, -4],
        [796, 2],
        [2177, 6],
        [67, 2],
        [2312, 6],
        [2808, 0],
        [2950, -12],
        [74, 0],
        [44, 0],
        [1059, 8],
        [2416, 16],
        [29, 0],
        [394, 6],
        [265, 0],
        [138, 0],
        [76, 0],
        [61, 2],
        [14, 0],
        [140, -2],
        [32, 0],
        [77, 0],
        [48, 0],
        [83, 0],
        [64, 0],
        [64, 2],
        [14, 0],
        [53, -2],
        [24, 0],
        [42, 0],
        [61, 0],
        [58, 0],
        [35, 2],
        [43, -2],
        [39, 0],
        [109, 0],
        [226, 0],
        [203, 0],
        [68, 0],
        [142, 0],
        [70, 0],
        [207, 0],
        [127, 0],
        [2, 0],
        [69, 0],
        [461, 2],
        [659, -4],
        [938, 2],
        [75, 2],
        [0, 0],
        [4418, 14],
        [5643, -6],
        [2920, 5],
        [76, 0],
        [644, 2],
        [1198, -9],
        [527, 6],
        [1625, 3],
        [3021, -13],
        [4608, 2],
        [37, 0],
        [318, 0],
        [4300, 4],
        [4132, 2],
        [2569, 5],
        [502, -4],
        [1152, -9],
        [4108, 6],
        [2447, 0],
        [10, 0],
        [3547, -2],
        [1770, 5],
        [2474, 5],
        [1360, 3],
        [2262, 2],
        [926, 1],
        [49, 0],
        [3112, -4],
        [1158, -3],
        [59, 0],
        [26, 0],
        [10, 0],
        [527, -1],
        [33, 0],
        [82, 0],
        [51, 0],
        [10, 0],
        [64, 0],
        [129, -1],
        [14, 0],
        [820, -2],
        [40, 0],
        [308, 0],
        [56, 0],
        [28, 0],
        [67, 0],
        [117, -1],
        [17, 0],
        [34, 0],
        [1818, -4],
        [-9, -101],
        [15, -46],
        [184, -198],
        [1, -2],
        [58, -59],
        [41, -74],
        [32, -41],
        [50, -59],
        [61, -50],
        [79, -58],
        [80, -72],
        [63, -24],
        [119, -24],
        [76, -14],
        [46, -33],
        [85, -108],
        [30, -63],
        [7, -65],
        [9, -70],
        [4, -43],
        [8, -59],
        [23, -66],
        [19, -52],
        [8, -19],
        [57, -91],
        [8, -7],
        [19, -12],
        [10, -9],
        [74, 3],
        [59, 6],
        [44, -20],
        [178, -162],
        [87, -34],
        [141, -117],
        [111, -90],
        [111, -71],
        [70, -75],
        [92, -81],
        [27, -20],
        [64, -49],
        [74, -77],
        [38, -25],
        [46, -29],
        [89, -33],
        [46, -18],
        [39, 0],
        [69, -1],
        [20, 0],
        [131, 17],
        [46, 12],
        [96, 26],
        [248, 59],
        [238, 72],
        [80, 56],
        [74, 82],
        [73, 223],
        [30, 98],
        [72, 97],
        [97, 72],
        [104, 53],
        [83, 33],
        [185, 77],
        [37, 14],
        [111, 30],
        [102, 52],
        [159, 40],
        [35, 6],
        [65, 10],
        [29, -6],
        [26, -6],
        [16, -4],
        [271, -179],
        [53, -36],
        [54, -34],
        [283, -188],
        [236, -145],
        [110, -42],
        [44, -17],
        [37, -14],
        [130, -32],
        [70, -16],
        [367, -39],
        [230, -35],
        [224, -78],
        [145, -79],
        [52, -28],
        [478, -278],
        [360, -213],
        [306, -182],
        [564, -324],
        [292, -180],
        [82, -84],
        [79, -97],
        [45, -78],
        [15, -61],
        [55, -196],
        [73, -266],
        [9, -69],
        [89, -265],
        [123, -201],
        [149, -138],
        [427, -298],
        [268, -201],
        [203, -154],
        [214, -146],
        [90, -72],
        [48, -74],
        [44, -95],
        [257, -571],
        [285, -704],
        [122, -300],
        [170, -392],
        [77, -178],
        [95, -135],
        [72, -47],
        [77, -80],
        [72, -145],
        [39, -75],
        [66, -104],
        [169, -267],
        [58, -82],
        [37, -50],
        [38, -53],
        [46, -65],
        [72, -106],
        [41, -70],
        [199, -239],
        [242, -324],
        [175, -230],
        [26, -34],
        [67, -87],
        [104, -179],
        [98, -169],
        [112, -165],
        [15, -43],
        [4, -54],
        [18, -570],
        [1, -59],
        [2, -42],
        [24, -61],
        [460, -819],
        [38, -67],
        [253, -453],
        [90, -174],
        [33, -99],
        [33, -92],
        [404, -1383],
        [33, -92],
        [23, -32],
        [46, -41],
        [1083, -600],
        [752, -481],
        [119, -117],
        [29, -29],
        [105, -156],
        [62, -146],
        [404, -1380],
        [65, -219],
        [35, -76],
        [39, -55],
        [36, -45],
        [470, -481],
        [101, -103],
        [127, -190],
        [2, -33],
        [241, -1116],
        [21, -90],
        [38, -80],
        [66, -96],
        [126, -178],
        [478, -580],
        [245, -193],
        [174, -117],
        [154, -53],
        [231, -69],
        [731, -194],
        [71, -19],
        [163, -43],
        [134, -58],
        [171, -76],
        [142, -117],
        [109, -94],
        [108, -114],
        [379, -488],
        [253, -306],
        [137, -102],
        [1479, -787],
        [123, -45],
        [132, -13],
        [831, -30],
        [118, -4],
        [150, -18],
        [136, -61],
        [92, -55],
        [1355, -1357],
        [162, -101],
        [130, -90],
        [140, -28],
        [38, -4],
        [140, -11],
        [3220, -266],
        [145, -12],
        [18, -1],
        [715, -56],
        [168, -9],
        [79, -11],
        [83, -33],
        [175, -142],
        [344, -289],
        [814, -693],
        [58, -40],
        [11, -25],
        [576, -516],
        [78, -36],
        [93, -17],
        [8, 0],
        [819, -45],
        [65, -33],
        [45, -36],
        [480, -713],
        [29, -88],
        [-21, -82],
        [-115, -601],
        [-24, -92],
        [14, -60],
        [447, -1074],
        [140, -303],
        [19, -49],
        [100, -110],
        [176, -191],
        [38, -33],
        [65, -28],
        [70, -6],
        [493, -31],
        [61, -7],
        [555, 54],
        [47, -2],
        [204, -14],
        [52, -25],
        [22, -29],
        [32, -87],
        [42, -42],
        [171, -215],
        [29, -44],
        [301, -680],
        [4, -9],
        [84, -189],
        [36, -53],
        [172, -119],
        [52, -8],
        [44, 0],
        [118, 13],
        [226, 25],
        [313, 34],
        [234, 25],
        [41, 2],
        [33, 2],
        [53, -16],
        [279, -106],
        [27, -15],
        [158, -201],
        [255, -326],
        [36, -46],
        [73, -91],
        [179, -229],
        [43, -47],
        [31, -35],
        [67, -37],
        [49, -25],
        [108, -76],
        [48, -61],
        [27, -84],
        [52, -170],
        [35, -86],
        [26, -79],
        [583, -751],
        [215, -300],
        [87, -124],
        [43, -68],
        [1132, -1140],
        [119, -173],
        [121, -163],
        [336, -421],
        [180, -225],
        [662, -827],
        [69, -70],
        [85, -48],
        [510, -165],
        [53, -46],
        [23, -34],
        [196, -444],
        [11, -73],
        [-4, -42],
        [-47, -271],
        [-14, -68],
        [16, -81],
        [26, -57],
        [57, -102],
        [180, -297],
        [19, -65],
        [86, -405],
        [25, -94],
        [88, -100],
        [67, -50],
        [20, -17],
        [121, -24],
        [127, -13],
        [236, -25],
        [136, 8],
        [206, 15],
        [301, 21],
        [474, 33],
        [104, -4],
        [105, -44],
        [57, -40],
        [1275, -958],
        [62, -64],
        [69, -104],
        [22, -73],
        [16, -56],
        [-1, -191],
        [36, -83],
        [74, -66],
        [405, -263],
        [12, -4],
        [59, -22],
        [1117, -404],
        [685, -257],
        [384, -118],
        [344, -108],
        [168, -78],
        [83, -50],
        [80, -53],
        [137, -19],
        [112, -47],
        [79, -31],
        [513, -204],
        [56, -47],
        [25, -41],
        [15, -37],
        [231, -942],
        [42, -60],
        [90, -39],
        [60, -14],
        [596, 48],
        [95, 5],
        [71, -8],
        [33, -12],
        [1199, -830],
        [127, -78],
        [89, -89],
        [65, -105],
        [151, -244],
        [112, -184],
        [32, -90],
        [75, -351],
        [37, -157],
        [54, -111],
        [62, -74],
        [56, -19],
        [194, -121],
        [132, -82],
        [118, -117],
        [60, -83],
        [35, -89],
        [317, -1348],
        [17, -154],
        [-7, -148],
        [-41, -131],
        [-41, -69],
        [-11, -52],
        [3, -49],
        [138, -363],
        [52, -59],
        [58, -51],
        [142, -23],
        [135, -10],
        [79, -34],
        [108, -107],
        [54, -90],
        [8, -75],
        [-104, -322],
        [-4, -66],
        [20, -36],
        [223, -330],
        [104, -206],
        [3, -64],
        [57, -90],
        [206, -270],
        [179, -249],
        [107, -79],
        [90, -31],
        [139, -35],
        [553, -207],
        [105, 0],
        [125, 48],
        [87, 26],
        [97, -38],
        [88, -15],
        [65, 0],
        [67, -31],
        [263, -308],
        [60, -80],
        [53, -42],
        [247, -103],
        [45, -30],
        [20, -47],
        [29, -82],
        [68, -68],
        [80, -55],
        [64, -95],
        [44, -101],
        [14, -52],
        [16, -145],
        [21, -59],
        [5, -13],
        [27, -8],
        [27, -8],
        [63, 52],
        [52, 34],
        [307, -18],
        [102, 24],
        [92, 41],
        [95, 52],
        [68, 0],
        [16, -18],
        [41, -42],
        [67, -49],
        [37, -51],
        [55, -132],
        [65, -78],
        [45, -30],
        [18, -39],
        [25, -73],
        [6, -17],
        [10, -6],
        [15, -10],
        [111, -151],
        [4, -24],
        [8, -40],
        [3, -49],
        [-25, -28],
        [-27, 30],
        [-8, 6],
        [-40, -18],
        [-37, -10],
        [-44, -33],
        [13, -34],
        [-11, -30],
        [-47, -91],
        [-33, -62],
        [-33, -43],
        [-15, -28],
        [69, -32],
        [48, -18],
        [55, -59],
        [63, 8],
        [14, 6],
        [29, 14],
        [56, -30],
        [21, -16],
        [77, -56],
        [6, -6],
        [145, -152],
        [52, -75],
        [10, -23],
        [14, -38],
        [11, -26],
        [-17, -33],
        [-55, 30],
        [-74, 30],
        [-62, -9],
        [-4, 0],
        [-8, -45],
        [30, -35],
        [48, -4],
        [38, -56],
        [37, -32],
        [82, -4],
        [41, 45],
        [23, 34],
        [52, 10],
        [147, -93],
        [92, 6],
        [73, -48],
        [72, -40],
        [22, -17],
        [66, -50],
        [27, -48],
        [13, -22],
        [6, -9],
        [33, -67],
        [47, -61],
        [12, -57],
        [4, -20],
        [33, -22],
        [59, 12],
        [69, 16],
        [5, -2],
        [94, -18],
        [28, -10],
        [41, -20],
        [22, -52],
        [-16, -47],
        [-12, -62],
        [48, -25],
        [27, 0],
        [13, 0],
        [82, -64],
        [38, -36],
        [26, -184],
        [-3, -73],
        [17, -51],
        [55, -24],
        [19, 17],
        [7, 7],
        [11, 39],
        [44, 28],
        [42, -14],
        [26, -8],
        [36, -23],
        [126, 15],
        [67, -4],
        [14, -2],
        [66, -11],
        [56, -22],
        [85, -12],
        [147, 22],
        [82, 5],
        [65, -38],
        [19, -67],
        [0, -111],
        [-19, -42],
        [-8, -44],
        [-44, -31],
        [-57, -2],
        [-47, -14],
        [-16, -48],
        [30, -40],
        [23, -89],
        [38, -63],
        [45, -25],
        [61, 23],
        [14, 13],
        [29, 29],
        [46, 25],
        [54, 36],
        [23, 66],
        [39, 41],
        [62, 6],
        [45, -41],
        [39, -33],
        [24, -23],
        [21, -20],
        [10, -57],
        [-45, -34],
        [-6, -33],
        [45, -150],
        [72, -117],
        [85, -170],
        [53, -53],
        [76, -2],
        [59, 14],
        [12, 3],
        [58, -15],
        [46, -32],
        [75, -24],
        [90, 8],
        [44, -38],
        [47, -59],
        [37, -12],
        [154, -26],
        [53, -52],
        [125, -155],
        [27, -24],
        [24, -57],
        [75, -33],
        [24, 15],
        [543, -54],
        [151, -113],
        [33, -89],
        [-1, -76],
        [27, -69],
        [30, -89],
        [64, -49],
        [26, -61],
        [-18, -31],
        [-47, -28],
        [-31, -28],
        [0, -29],
        [10, -59],
        [-6, -40],
        [50, -12],
        [116, 38],
        [49, 10],
        [47, 18],
        [101, 87],
        [56, 25],
        [38, 33],
        [53, 20],
        [44, -45],
        [46, -51],
        [87, -39],
        [71, -50],
        [20, -55],
        [-23, -70],
        [-11, -66],
        [51, -50],
        [28, -40],
        [-24, -56],
        [-25, -29],
        [-17, -42],
        [-42, -32],
        [-35, -16],
        [-130, -99],
        [-42, -30],
        [-20, -32],
        [58, -45],
        [74, -42],
        [58, -98],
        [67, -49],
        [95, -2],
        [78, -28],
        [111, 14],
        [78, 22],
        [71, -24],
        [57, -68],
        [44, -74],
        [-20, -50],
        [-35, -22],
        [-43, -51],
        [-64, -26],
        [-56, -40],
        [14, -38],
        [8, -45],
        [-12, -57],
        [23, -58],
        [44, -71],
        [-13, -39],
        [-94, -129],
        [-23, -19],
        [16, -30],
        [58, -70],
        [-20, -33],
        [24, -50],
        [-8, -42],
        [3, -50],
        [9, -37],
        [-11, -24],
        [-5, -50],
        [-45, -14],
        [-53, 3],
        [-62, -35],
        [-91, 2],
        [-49, -31],
        [-103, -163],
        [-22, -53],
        [6, -13],
        [22, -42],
        [14, -29],
        [202, -142],
        [104, -37],
        [77, 19],
        [78, 30],
        [64, 14],
        [65, 41],
        [58, 33],
        [77, 4],
        [65, 38],
        [43, 33],
        [24, -6],
        [24, -41],
        [59, -90],
        [45, -58],
        [63, 6],
        [33, 73],
        [20, 9],
        [25, -16],
        [133, -73],
        [93, -5],
        [107, -87],
        [45, -28],
        [56, -42],
        [66, -2],
        [44, 12],
        [156, -48],
        [163, -25],
        [99, 34],
        [290, 169],
        [53, 14],
        [37, -36],
        [75, -211],
        [34, -51],
        [47, -24],
        [104, -37],
        [120, -109],
        [71, -51],
        [27, -40],
        [-2, -127],
        [-7, -66],
        [-32, -65],
        [-1, -68],
        [31, -51],
        [55, -55],
        [55, -13],
        [54, 47],
        [214, 190],
        [33, 44],
        [76, 49],
        [88, 21],
        [57, 8],
        [55, -12],
        [49, -41],
        [47, 8],
        [66, 14],
        [54, -16],
        [-3, -59],
        [45, -51],
        [12, -47],
        [7, -71],
        [26, -33],
        [2, -62],
        [-7, -72],
        [43, -47],
        [72, -16],
        [128, 18],
        [46, -49],
        [72, -34],
        [67, -4],
        [52, -34],
        [61, -17],
        [54, -36],
        [4, -41],
        [-71, -184],
        [-42, -50],
        [-19, -61],
        [40, -36],
        [88, -41],
        [45, -6],
        [16, 51],
        [47, 63],
        [122, 119],
        [31, 17],
        [45, -32],
        [61, -32],
        [62, -4],
        [11, 42],
        [46, 43],
        [45, 11],
        [58, -44],
        [21, -42],
        [-9, -50],
        [-20, -40],
        [-1, -32],
        [-7, -33],
        [-13, -32],
        [13, -131],
        [41, -79],
        [52, -54],
        [52, -36],
        [12, -83],
        [0, -34],
        [-30, -47],
        [-25, -34],
        [-31, -104],
        [-16, -76],
        [-31, -55],
        [-24, -44],
        [8, -46],
        [27, -30],
        [41, -47],
        [71, -34],
        [73, -6],
        [27, 40],
        [32, 65],
        [48, 28],
        [80, -8],
        [48, 8],
        [15, 70],
        [8, 67],
        [29, 63],
        [22, 49],
        [36, 28],
        [27, -16],
        [-15, -39],
        [8, -43],
        [51, -28],
        [25, -14],
        [-8, -32],
        [-40, -73],
        [-15, -92],
        [22, -84],
        [85, -50],
        [82, -8],
        [12, 82],
        [13, 31],
        [29, 8],
        [8, 2],
        [50, 61],
        [39, 52],
        [14, 53],
        [44, 98],
        [64, 107],
        [46, 80],
        [10, 54],
        [-16, 61],
        [0, 102],
        [-6, 77],
        [14, 80],
        [66, 76],
        [33, 7],
        [331, 68],
        [78, 10],
        [99, -37],
        [76, -56],
        [5, -4],
        [17, -63],
        [0, -30],
        [2, -36],
        [-4, -72],
        [18, -48],
        [10, -82],
        [5, -57],
        [76, -70],
        [63, -9],
        [57, 29],
        [46, 14],
        [35, 12],
        [71, -22],
        [14, -4],
        [61, -22],
        [141, -124],
        [34, -38],
        [6, -75],
        [-6, -61],
        [24, -60],
        [42, -44],
        [48, -31],
        [10, -18],
        [6, -19],
        [23, -83],
        [8, -53],
        [30, -60],
        [32, -62],
        [40, -14],
        [38, 45],
        [37, 41],
        [54, 20],
        [45, 28],
        [40, 27],
        [90, 3],
        [128, -32],
        [45, -20],
        [19, -14],
        [28, -20],
        [5, -10],
        [18, -33],
        [13, -18],
        [16, -21],
        [4, -45],
        [2, -24],
        [4, -59],
        [-14, -88],
        [24, -70],
        [36, -62],
        [112, -141],
        [50, -35],
        [22, -14],
        [81, -47],
        [36, -34],
        [50, -78],
        [46, -51],
        [26, -45],
        [106, -37],
        [55, 41],
        [27, 28],
        [93, 10],
        [65, 48],
        [56, 74],
        [39, 52],
        [35, 53],
        [146, 76],
        [138, 21],
        [63, -37],
        [49, 14],
        [27, 41],
        [34, 54],
        [67, 42],
        [90, 2],
        [77, 4],
        [36, 29],
        [20, 42],
        [45, 14],
        [53, -29],
        [46, -2],
        [44, -21],
        [45, 5],
        [68, 13],
        [73, 0],
        [93, 56],
        [72, -11],
        [51, -44],
        [10, -54],
        [-32, -116],
        [34, -62],
        [72, -20],
        [55, 22],
        [36, 23],
        [28, 26],
        [99, 43],
        [155, 117],
        [113, 110],
        [39, 50],
        [68, 47],
        [72, -14],
        [67, 20],
        [42, -45],
        [66, -96],
        [7, -51],
        [-20, -57],
        [66, -117],
        [62, -35],
        [67, -33],
        [10, -52],
        [-46, -140],
        [0, -149],
        [-148, -90],
        [-72, -15],
        [-72, 15],
        [-37, 16],
        [-39, 14],
        [-21, -26],
        [-8, -17],
        [-21, -26],
        [-11, -51],
        [-21, -39],
        [-15, -38],
        [-38, -62],
        [-29, -58],
        [-4, -33],
        [21, -99],
        [35, -54],
        [55, -43],
        [72, -22],
        [34, -30],
        [-12, -30],
        [0, -30],
        [51, -6],
        [97, -2],
        [17, -42],
        [22, -29],
        [138, -36],
        [53, 38],
        [75, 12],
        [57, 6],
        [59, 50],
        [22, 59],
        [1, 79],
        [40, 40],
        [173, 114],
        [94, 17],
        [58, -29],
        [125, 34],
        [10, 47],
        [132, 106],
        [25, 39],
        [22, 48],
        [43, 37],
        [56, -75],
        [55, -32],
        [44, -30],
        [64, -175],
        [40, -74],
        [265, -118],
        [65, -14],
        [23, -74],
        [0, -36],
        [10, -34],
        [60, -59],
        [-12, -42],
        [-19, -28],
        [-4, -141],
        [6, -69],
        [118, -61],
        [44, -17],
        [25, -42],
        [41, -31],
        [6, -11],
        [28, -39],
        [29, -84],
        [25, -61],
        [24, -73],
        [62, -63],
        [66, -61],
        [42, -66],
        [73, -38],
        [53, -2],
        [57, 37],
        [41, 60],
        [23, 61],
        [33, 76],
        [47, 27],
        [44, 54],
        [36, 34],
        [24, 64],
        [22, 59],
        [32, 42],
        [19, 86],
        [-5, 92],
        [5, 59],
        [35, 38],
        [65, 18],
        [64, -6],
        [41, -40],
        [18, -214],
        [23, -32],
        [18, -59],
        [-49, -67],
        [41, -82],
        [52, -64],
        [92, -52],
        [86, -16],
        [81, 25],
        [47, 29],
        [71, -34],
        [77, -69],
        [-33, -50],
        [-4, -50],
        [-17, -41],
        [-3, -124],
        [-60, -350],
        [-32, -40],
        [-63, -53],
        [-45, -40],
        [-56, -191],
        [-18, -72],
        [-20, -73],
        [15, -54],
        [56, -37],
        [57, 39],
        [83, 21],
        [59, 20],
        [19, 32],
        [97, -8],
        [63, -30],
        [27, -33],
        [34, -30],
        [127, -51],
        [55, 31],
        [96, 22],
        [68, 33],
        [25, 40],
        [57, 30],
        [81, 46],
        [88, 27],
        [76, -4],
        [97, -121],
        [32, -35],
        [44, 12],
        [36, 11],
        [57, -31],
        [50, -40],
        [48, 0],
        [41, -12],
        [56, 2],
        [41, -24],
        [88, -14],
        [71, -20],
        [55, -6],
        [51, -2],
        [37, 2],
        [27, -20],
        [19, -31],
        [14, -44],
        [43, -62],
        [86, -32],
        [60, 14],
        [232, 116],
        [75, -6],
        [45, 25],
        [38, 6],
        [53, -23],
        [27, -32],
        [-25, -31],
        [-49, -19],
        [-16, -49],
        [-33, -43],
        [-24, -21],
        [-20, -79],
        [1, -89],
        [37, -56],
        [94, -28],
        [107, -8],
        [47, 18],
        [6, 62],
        [25, 63],
        [46, 57],
        [55, 3],
        [42, -47],
        [27, -31],
        [62, -45],
        [53, -43],
        [0, -31],
        [-47, -75],
        [-19, -59],
        [9, -33],
        [54, -5],
        [73, -18],
        [8, -37],
        [-32, -28],
        [-27, -19],
        [-9, -39],
        [-4, -28],
        [-13, -49],
        [-30, -41],
        [-8, -99],
        [-2, -48],
        [-10, -53],
        [14, -45],
        [38, -36],
        [61, -53],
        [37, -62],
        [53, -36],
        [62, -11],
        [27, 39],
        [0, 42],
        [-7, 16],
        [6, 39],
        [37, 7],
        [42, -23],
        [9, -45],
        [4, -28],
        [120, -76],
        [29, -34],
        [-5, -41],
        [-16, -21],
        [6, -41],
        [12, -49],
        [-5, -51],
        [-27, -41],
        [-58, -27],
        [-26, -32],
        [-15, -42],
        [27, -23],
        [13, -10],
        [170, -58],
        [69, -10],
        [37, 0],
        [57, -62],
        [11, -41],
        [31, -43],
        [19, -43],
        [2, -48],
        [-14, -58],
        [-6, -42],
        [26, -38],
        [63, -30],
        [77, -19],
        [45, 5],
        [26, 42],
        [26, 24],
        [87, 9],
        [89, 8],
        [56, -11],
        [55, -40],
        [66, -32],
        [70, -33],
        [42, -43],
        [-23, -130],
        [-16, -69],
        [-16, -64],
        [32, -51],
        [52, -28],
        [54, 20],
        [64, -6],
        [35, -4],
        [59, -16],
        [39, -51],
        [55, -20],
        [68, -35],
        [24, -47],
        [-12, -46],
        [-17, -43],
        [44, -25],
        [34, -47],
        [3, -51],
        [-47, -48],
        [-77, -14],
        [-55, -18],
        [-20, -55],
        [-1, -44],
        [48, -20],
        [46, 14],
        [12, -26],
        [-14, -29],
        [17, -27],
        [86, -43],
        [72, 11],
        [65, 37],
        [42, 65],
        [36, 34],
        [75, 12],
        [62, -18],
        [58, 8],
        [33, 10],
        [73, -6],
        [94, 20],
        [16, 60],
        [25, 39],
        [42, -16],
        [-10, -64],
        [12, -59],
        [6, -52],
        [151, -154],
        [74, 8],
        [74, 3],
        [35, -20],
        [-7, -76],
        [33, -50],
        [26, -42],
        [16, -70],
        [-24, -77],
        [-48, -120],
        [-37, -72],
        [-8, -52],
        [8, -141],
        [34, -83],
        [53, -44],
        [99, 12],
        [45, 42],
        [-24, 29],
        [28, 46],
        [64, 17],
        [78, -16],
        [45, -29],
        [47, -119],
        [31, -15],
        [50, -67],
        [-38, -67],
        [-7, -50],
        [35, -33],
        [87, -25],
        [88, 2],
        [47, 29],
        [80, 0],
        [59, 12],
        [52, -18],
        [14, -41],
        [-29, -68],
        [7, -34],
        [73, -4],
        [66, 16],
        [10, 61],
        [-4, 86],
        [29, 42],
        [31, 41],
        [-12, 64],
        [-138, 181],
        [4, 63],
        [58, 38],
        [71, -26],
        [73, -63],
        [64, -13],
        [22, 16],
        [22, 33],
        [157, 39],
        [195, -107],
        [52, -66],
        [163, -282],
        [69, -63],
        [63, -40],
        [68, -4],
        [78, -16],
        [35, -41],
        [38, -26],
        [24, 35],
        [15, 72],
        [48, 50],
        [114, 10],
        [101, -7],
        [72, 6],
        [23, 44],
        [34, 84],
        [46, 58],
        [59, 37],
        [107, -41],
        [25, -68],
        [73, -29],
        [27, -17],
        [76, -10],
        [38, 39],
        [24, 51],
        [43, 18],
        [136, 50],
        [77, 61],
        [55, 35],
        [41, -16],
        [63, -61],
        [41, -75],
        [23, -55],
        [45, -28],
        [49, -37],
        [35, -24],
        [35, -58],
        [-7, -49],
        [-8, -53],
        [17, -56],
        [23, -68],
        [26, -78],
        [15, -61],
        [-9, -50],
        [-16, -49],
        [-6, -57],
        [14, -20],
        [56, -55],
        [31, -29],
        [36, -35],
        [6, -6],
        [176, -29],
        [36, -7],
        [64, 6],
        [25, -29],
        [20, -45],
        [63, -22],
        [67, -51],
        [-29, -29],
        [-19, -20],
        [-29, -28],
        [-21, -30],
        [14, -91],
        [63, -28],
        [44, 4],
        [26, -18],
        [40, -76],
        [31, -25],
        [201, -14],
        [13, 0],
        [51, -24],
        [25, -43],
        [-16, -42],
        [-27, -42],
        [11, -46],
        [7, -44],
        [-14, -51],
        [-7, -36],
        [13, -26],
        [25, -23],
        [60, -111],
        [-32, -31],
        [-34, -12],
        [-13, -42],
        [23, -57],
        [6, -58],
        [0, -73],
        [-8, -65],
        [-4, -52],
        [18, -41],
        [30, -98],
        [13, -60],
        [-4, -138],
        [9, -43],
        [28, -52],
        [-2, -63],
        [-25, -92],
        [2, -30],
        [2, -116],
        [19, -100],
        [0, -60],
        [-5, -72],
        [11, -15],
        [26, -36],
        [44, -25],
        [13, -19],
        [2, -100],
        [-2, -67],
        [28, -54],
        [2, -23],
        [49, -25],
        [79, -26],
        [24, -32],
        [34, -84],
        [-10, -68],
        [-32, -54],
        [-35, -24],
        [-25, -21],
        [27, -14],
        [41, -28],
        [5, -32],
        [-23, -111],
        [2, -51],
        [57, -43],
        [39, -50],
        [77, -169],
        [63, -37],
        [53, -5],
        [57, -58],
        [-19, -62],
        [-30, -49],
        [0, -34],
        [39, -47],
        [66, -63],
        [20, -58],
        [90, -97],
        [69, -40],
        [114, -54],
        [108, -47],
        [87, 2],
        [85, 47],
        [106, 32],
        [88, 20],
        [67, 45],
        [67, 15],
        [134, -68],
        [80, -12],
        [47, -12],
        [41, -63],
        [11, -46],
        [2, -49],
        [51, -53],
        [35, -25],
        [23, -19],
        [36, -50],
        [87, -30],
        [174, 40],
        [54, -18],
        [55, -45],
        [78, -40],
        [64, 16],
        [59, 31],
        [3, 2],
        [182, 7],
        [62, 40],
        [121, 112],
        [35, 3],
        [20, -30],
        [31, -44],
        [23, -121],
        [-7, -100],
        [-6, -77],
        [15, -42],
        [37, -22],
        [209, -74],
        [74, 46],
        [23, 63],
        [19, 92],
        [15, 73],
        [87, 133],
        [67, 25],
        [48, 6],
        [58, -33],
        [67, -49],
        [45, -17],
        [30, -79],
        [-7, -62],
        [25, -52],
        [6, -32],
        [-10, -76],
        [12, -86],
        [55, -35],
        [53, 14],
        [62, 11],
        [-2, -41],
        [13, -22],
        [-33, -18],
        [-3, -32],
        [31, -58],
        [3, -20],
        [-17, -31],
        [-31, -38],
        [-4, -78],
        [-16, -59],
        [-3, -53],
        [-24, -32],
        [-29, -18],
        [-23, -14],
        [-10, -38],
        [27, -40],
        [29, -71],
        [24, -51],
        [42, -26],
        [16, -20],
        [38, -61],
        [42, -15],
        [36, -14],
        [63, 24],
        [163, 32],
        [134, -18],
        [88, -33],
        [44, -45],
        [78, -115],
        [20, -80],
        [8, -142],
        [7, -71],
        [14, -51],
        [31, -46],
        [78, -37],
        [31, -36],
        [50, -70],
        [65, -49],
        [49, -42],
        [43, -82],
        [45, -32],
        [46, -29],
        [47, -35],
        [12, -38],
        [-14, -50],
        [21, -32],
        [-3, -50],
        [164, -286],
        [25, -84],
        [27, -81],
        [14, -76],
        [-8, -83],
        [-49, -53],
        [-64, -74],
        [-32, -46],
        [-12, -72],
        [2, -23],
        [4, -48],
        [57, -54],
        [13, -11],
        [68, -26],
        [85, 1],
        [57, 14],
        [35, -33],
        [16, -64],
        [-6, -44],
        [-30, 17],
        [-40, 17],
        [-20, -41],
        [43, -44],
        [54, -4],
        [55, 5],
        [59, -32],
        [52, -63],
        [-10, -43],
        [-32, -104],
        [23, -44],
        [30, 0],
        [36, 47],
        [35, 21],
        [44, -15],
        [2, -74],
        [18, -62],
        [-12, -51],
        [-55, -57],
        [-15, -60],
        [-62, -57],
        [-41, -28],
        [-12, -10],
        [-17, -51],
        [48, -104],
        [32, -66],
        [5, -75],
        [14, -82],
        [95, -76],
        [100, -35],
        [109, -23],
        [146, -50],
        [27, -76],
        [36, -30],
        [36, -53],
        [-12, -42],
        [-9, -129],
        [-3, -124],
        [2, -62],
        [-45, -67],
        [-65, 10],
        [-38, 68],
        [-11, 47],
        [-30, 32],
        [-101, -56],
        [-28, -50],
        [51, -43],
        [46, -4],
        [34, -28],
        [-11, -32],
        [26, -8],
        [70, -27],
        [47, -22],
        [27, -48],
        [-17, -63],
        [-24, 16],
        [-53, 12],
        [-69, -14],
        [-68, -34],
        [-32, -62],
        [-18, -56],
        [54, -41],
        [58, -42],
        [75, -33],
        [104, 9],
        [34, 42],
        [44, 32],
        [34, -8],
        [2, -52],
        [-20, -91],
        [92, -179],
        [28, -56],
        [12, -45],
        [30, -22],
        [12, -8],
        [45, 48],
        [63, 32],
        [31, 54],
        [12, 51],
        [54, 10],
        [15, -51],
        [-1, -50],
        [23, -50],
        [50, -67],
        [-3, -43],
        [-33, -133],
        [-24, -62],
        [-33, -203],
        [47, -64],
        [36, -35],
        [3, -38],
        [-23, -100],
        [-36, -116],
        [-43, -115],
        [-16, -42],
        [0, -45],
        [57, -25],
        [28, -12],
        [110, -46],
        [65, -6],
        [71, 24],
        [77, 7],
        [52, -35],
        [-6, -52],
        [-6, -117],
        [-26, -98],
        [-25, -95],
        [-6, -33],
        [13, -60],
        [18, -71],
        [0, -40],
        [-42, -48],
        [-57, 5],
        [-34, -15],
        [-74, -95],
        [-45, -80],
        [-23, -71],
        [-20, -63],
        [9, -6],
        [10, -6],
        [27, -17],
        [56, -8],
        [43, -44],
        [4, -40],
        [0, -104],
        [-10, -131],
        [4, -46],
        [15, -26],
        [28, -45],
        [14, -22],
        [83, -132],
        [83, -191],
        [4, -89],
        [-10, -75],
        [-14, -60],
        [-53, -30],
        [-45, -24],
        [-25, -33],
        [-54, -212],
        [-30, -80],
        [-12, -69],
        [81, -177],
        [8, -18],
        [16, -60],
        [40, -32],
        [82, -42],
        [73, -62],
        [24, -61],
        [5, -70],
        [-43, -113],
        [-28, -66],
        [8, -66],
        [8, -53],
        [-24, -50],
        [-76, -48],
        [-40, -43],
        [-35, -83],
        [-3, -5],
        [16, -60],
        [64, -2],
        [86, 13],
        [87, -15],
        [68, -41],
        [77, -12],
        [92, -18],
        [12, -8],
        [22, -13],
        [91, -155],
        [-3, -53],
        [-34, -88],
        [-6, -71],
        [61, -105],
        [-11, -35],
        [-70, -112],
        [-54, -52],
        [-24, -30],
        [-22, -56],
        [-6, -13],
        [-12, -44],
        [-16, -70],
        [52, -32],
        [55, 12],
        [40, -29],
        [102, -54],
        [6, -9],
        [35, -43],
        [2, -45],
        [-6, -49],
        [6, -55],
        [48, -52],
        [8, -8],
        [74, -6],
        [57, 2],
        [47, -41],
        [19, -51],
        [30, -40],
        [83, -2],
        [54, 22],
        [8, 39],
        [7, 75],
        [23, 43],
        [40, 4],
        [54, -66],
        [-8, -58],
        [-20, -53],
        [-14, -18],
        [-25, -33],
        [7, -53],
        [24, -62],
        [40, -113],
        [-11, -61],
        [-49, -18],
        [-72, 17],
        [-75, -5],
        [-53, -60],
        [-35, -44],
        [-62, -27],
        [-73, -30],
        [-42, -41],
        [-23, -31],
        [-47, -29],
        [-28, -46],
        [-25, -62],
        [3, -4],
        [36, -59],
        [59, -303],
        [21, -52],
        [60, -50],
        [14, -58],
        [-27, -61],
        [-51, -108],
        [-17, -99],
        [-20, -76],
        [-41, -81],
        [-59, -71],
        [-56, -66],
        [-14, -47],
        [-17, -59],
        [45, -55],
        [204, -208],
        [57, -61],
        [72, -40],
        [182, -51],
        [84, -40],
        [64, -82],
        [93, -157],
        [64, -74],
        [110, -40],
        [37, -18],
        [38, -19],
        [77, -53],
        [45, -20],
        [33, -17],
        [81, -47],
        [36, -61],
        [31, -60],
        [52, -18],
        [137, -2],
        [144, -42],
        [79, 3],
        [182, 28],
        [152, 46],
        [131, 21],
        [82, 27],
        [93, 3],
        [76, 28],
        [90, 25],
        [8, 2],
        [54, -39],
        [26, -77],
        [-26, -80],
        [-84, -53],
        [-67, -63],
        [-36, -125],
        [-7, -21],
        [21, -59],
        [46, -37],
        [53, -34],
        [78, -56],
        [113, 9],
        [120, 33],
        [24, 0],
        [51, 1],
        [8, -62],
        [20, -97],
        [13, -100],
        [-15, -77],
        [-62, -29],
        [-67, -38],
        [-39, -71],
        [-12, -176],
        [2, -101],
        [-6, -90],
        [-39, -61],
        [-80, -24],
        [-277, -56],
        [-66, -11],
        [-44, -46],
        [8, -80],
        [44, -35],
        [27, -23],
        [5, -9],
        [20, -40],
        [24, -68],
        [40, -27],
        [37, 13],
        [5, -3],
        [66, -30],
        [53, -91],
        [71, -61],
        [79, -26],
        [70, -33],
        [103, -48],
        [108, -109],
        [-29, -192],
        [-26, -118],
        [-17, -72],
        [-18, -60],
        [-16, -63],
        [25, -59],
        [81, 5],
        [29, 9],
        [58, 15],
        [119, -4],
        [131, -67],
        [117, -59],
        [122, -28],
        [123, -12],
        [67, -3],
        [116, -146],
        [73, -100],
        [79, -44],
        [90, -22],
        [28, -123],
        [-18, -62],
        [43, -70],
        [56, -5],
        [51, 3],
        [25, -28],
        [-13, -71],
        [-5, -106],
        [66, -93],
        [50, -29],
        [40, -22],
        [44, -4],
        [65, -4],
        [93, -18],
        [114, -91],
        [85, -76],
        [48, -96],
        [82, -71],
        [57, -73],
        [21, -77],
        [2, -73],
        [-47, -66],
        [-65, -39],
        [-57, -53],
        [-12, -116],
        [36, -39],
        [55, 13],
        [5, 2],
        [60, 29],
        [47, 7],
        [77, -12],
        [53, -26],
        [88, -40],
        [48, 27],
        [87, 13],
        [63, 42],
        [68, 22],
        [51, 53],
        [53, 51],
        [56, 32],
        [36, -27],
        [-40, -31],
        [-44, -23],
        [-11, -31],
        [0, -30],
        [-3, -49],
        [64, -24],
        [34, -6],
        [86, -31],
        [71, -63],
        [85, -52],
        [23, -97],
        [20, -140],
        [32, -130],
        [51, -147],
        [-12, -141],
        [10, -120],
        [4, -109],
        [47, -54],
        [31, -286],
        [-11, -82],
        [-28, -65],
        [-66, -145],
        [-22, -52],
        [-56, -80],
        [-66, -46],
        [-50, -33],
        [-15, -38],
        [71, -26],
        [9, 0],
        [53, 8],
        [68, -2],
        [15, -32],
        [-22, -43],
        [-14, -22],
        [-24, -36],
        [42, -41],
        [83, -12],
        [54, -6],
        [43, 30],
        [-2, 71],
        [-42, 41],
        [13, 43],
        [57, -1],
        [16, -60],
        [0, -50],
        [56, -30],
        [56, -14],
        [35, 35],
        [35, 71],
        [59, 14],
        [54, 6],
        [39, -46],
        [-21, -47],
        [19, -53],
        [34, 10],
        [42, 60],
        [40, 27],
        [12, 68],
        [53, 11],
        [16, -62],
        [-27, -84],
        [-32, -46],
        [-10, -94],
        [-6, -118],
        [-88, -145],
        [-53, -63],
        [-36, -79],
        [53, -86],
        [50, -58],
        [88, -40],
        [116, -1],
        [86, -33],
        [89, -38],
        [84, -17],
        [105, -5],
        [49, -22],
        [29, -56],
        [64, -99],
        [41, -44],
        [45, -18],
        [24, -10],
        [45, 34],
        [-6, 38],
        [-5, 38],
        [-54, 41],
        [-19, 42],
        [37, 52],
        [-28, 72],
        [20, 52],
        [54, -3],
        [94, 13],
        [87, -34],
        [59, -66],
        [35, -40],
        [55, -26],
        [38, -18],
        [59, -42],
        [34, -99],
        [17, -32],
        [43, -77],
        [49, -45],
        [30, -25],
        [102, -23],
        [53, -59],
        [11, -58],
        [-28, -57],
        [-4, -4],
        [-4, -34],
        [38, -26],
        [86, -124],
        [115, -77],
        [82, -19],
        [32, -33],
        [0, -62],
        [33, -65],
        [57, -65],
        [30, -60],
        [76, -65],
        [70, -67],
        [25, -71],
        [16, -72],
        [75, -72],
        [159, -83],
        [111, -52],
        [96, -30],
        [28, -54],
        [-34, -243],
        [-51, -237],
        [-21, -57],
        [-113, -79],
        [-57, -44],
        [-23, -70],
        [150, -255],
        [55, -69],
        [76, -47],
        [168, -225],
        [72, -94],
        [16, -43],
        [-9, -51],
        [-141, -204],
        [0, -37],
        [36, -50],
        [55, -25],
        [97, -45],
        [70, -58],
        [26, -44],
        [28, -328],
        [19, -60],
        [44, -21],
        [98, -43],
        [46, -66],
        [20, -112],
        [-12, -106],
        [-33, -71],
        [-2, -66],
        [111, -119],
        [73, -12],
        [46, -43],
        [27, -112],
        [77, -189],
        [158, -204],
        [5, -6],
        [36, -32],
        [52, -46],
        [33, -63],
        [-10, -66],
        [-36, -89],
        [0, -73],
        [34, -71],
        [9, -21],
        [38, -91],
        [-14, -83],
        [0, -96],
        [-29, -99],
        [-16, -27],
        [-37, -61],
        [-18, -79],
        [51, -311],
        [-2, -109],
        [-18, -58],
        [-23, -75],
        [-21, -60],
        [-33, -93],
        [-33, -74],
        [23, -76],
        [18, -8],
        [63, -32],
        [4, -3],
        [59, -49],
        [-15, -69],
        [-71, -53],
        [-73, -22],
        [-7, -8],
        [-33, -37],
        [25, -50],
        [20, -17],
        [63, -57],
        [-13, -41],
        [-38, -9],
        [-8, -2],
        [-14, -34],
        [50, -64],
        [85, 6],
        [61, 12],
        [45, -23],
        [4, -52],
        [-16, -54],
        [-8, -5],
        [-33, -19],
        [-4, -64],
        [-6, -42],
        [-52, -9],
        [-96, 2],
        [-44, -37],
        [35, -73],
        [15, -40],
        [-17, -81],
        [-27, -25],
        [-50, 45],
        [-54, 35],
        [-47, -33],
        [-8, -106],
        [-35, -61],
        [-47, -22],
        [-27, -4],
        [-21, -2],
        [-2, -42],
        [-41, -32],
        [-55, 22],
        [-6, 2],
        [-39, 4],
        [25, -72],
        [43, -87],
        [8, -260],
        [-42, -116],
        [13, -99],
        [102, -160],
        [16, -76],
        [3, -21],
        [-29, -77],
        [-14, -24],
        [-29, -51],
        [-28, -48],
        [28, -66],
        [56, -35],
        [24, 35],
        [15, 36],
        [47, 2],
        [55, -14],
        [73, -8],
        [40, -73],
        [-10, -54],
        [-35, 35],
        [-32, 16],
        [-26, -55],
        [-20, -42],
        [8, -66],
        [22, -88],
        [-7, -45],
        [3, -47],
        [75, 6],
        [24, 12],
        [60, -12],
        [87, -16],
        [85, -25],
        [34, -120],
        [5, -86],
        [-41, -94],
        [-70, -40],
        [-96, 14],
        [-84, 23],
        [-24, 68],
        [26, 21],
        [-28, 30],
        [-31, 40],
        [-46, -45],
        [-2, -74],
        [-26, -32],
        [-2, -78],
        [-5, -58],
        [-89, -115],
        [-4, -8],
        [-26, -54],
        [68, -70],
        [47, -52],
        [11, -74],
        [-3, -121],
        [7, -48],
        [64, -20],
        [71, -12],
        [63, -32],
        [50, 16],
        [8, 64],
        [39, 22],
        [39, 42],
        [19, 79],
        [6, 51],
        [48, 36],
        [40, -42],
        [4, -83],
        [-32, -87],
        [-34, -78],
        [22, -88],
        [7, -36],
        [-12, -36],
        [-8, -21],
        [-39, -117],
        [-45, -34],
        [-108, -31],
        [-23, -14],
        [-29, -17],
        [-9, -69],
        [39, -41],
        [16, -36],
        [0, -104],
        [47, -46],
        [44, 32],
        [35, 30],
        [-25, 20],
        [-39, 12],
        [29, 48],
        [64, -9],
        [24, -63],
        [22, -30],
        [7, -9],
        [37, -19],
        [-32, -40],
        [-30, -28],
        [-12, -31],
        [-16, -32],
        [8, -12],
        [17, -27],
        [7, -42],
        [-18, -35],
        [-208, -185],
        [-45, -62],
        [-19, -27],
        [1, -99],
        [16, -18],
        [29, -28],
        [72, 2],
        [66, 44],
        [58, 29],
        [-33, -76],
        [-28, -60],
        [-32, -60],
        [-71, 16],
        [-106, 13],
        [-91, 7],
        [-24, -20],
        [-25, -19],
        [9, -107],
        [53, -63],
        [24, -6],
        [41, -12],
        [32, -18],
        [-46, -28],
        [-88, -11],
        [-33, -24],
        [-17, -13],
        [-8, -41],
        [-9, -10],
        [-196, -233],
        [-92, -7],
        [-124, -4],
        [-108, -5],
        [-25, -12],
        [-49, -25],
        [4, -64],
        [37, -81],
        [22, -46],
        [15, -30],
        [21, -49],
        [-4, -44],
        [-60, -14],
        [-61, -18],
        [-32, -57],
        [33, -125],
        [14, -53],
        [-5, -43],
        [-48, -36],
        [-30, -23],
        [-21, -62],
        [-15, -44],
        [-25, -53],
        [-22, -74],
        [357, -469],
        [103, -83],
        [81, -84],
        [63, -98],
        [51, -52],
        [13, -13],
        [41, -52],
        [6, -75],
        [-41, -27],
        [-43, 23],
        [-52, 37],
        [-48, -12],
        [-60, -48],
        [-66, -21],
        [-46, -16],
        [7, -61],
        [10, -51],
        [-39, -61],
        [-37, -67],
        [-40, -87],
        [-26, -95],
        [4, -15],
        [21, -53],
        [-25, -76],
        [-12, -18],
        [-43, -66],
        [-16, -79],
        [40, -145],
        [52, -74],
        [111, -45],
        [71, -43],
        [146, -55],
        [132, 2],
        [94, -20],
        [25, -66],
        [66, -73],
        [86, -73],
        [49, -67],
        [-22, -55],
        [-15, -62],
        [37, -88],
        [4, -12],
        [19, -49],
        [-27, -62],
        [-38, -35],
        [-6, -45],
        [-31, -32],
        [-52, 1],
        [-62, -15],
        [-35, -36],
        [0, -46],
        [19, -119],
        [-51, -159],
        [34, -59],
        [62, -13],
        [45, 60],
        [64, 35],
        [52, -16],
        [27, -42],
        [13, -54],
        [-55, -10],
        [-19, -32],
        [9, -4],
        [2, -20],
        [16, -17],
        [11, -12],
        [50, 6],
        [21, -14],
        [8, -55],
        [55, -53],
        [30, -142],
        [-24, -53],
        [-20, -48],
        [-129, -51],
        [-103, 20],
        [-128, 1],
        [-45, -24],
        [-30, -85],
        [199, -88],
        [121, -51],
        [141, 10],
        [106, 9],
        [8, -33],
        [-21, -52],
        [-26, -105],
        [25, -103],
        [-27, -51],
        [-64, -39],
        [-30, -31],
        [-7, -7],
        [-23, -67],
        [-26, -76],
        [10, -50],
        [14, -51],
        [-38, -47],
        [-62, -35],
        [-27, -44],
        [-31, -73],
        [-51, -65],
        [-54, -37],
        [-49, -30],
        [31, -44],
        [35, 9],
        [15, -28],
        [83, -39],
        [146, -35],
        [138, 29],
        [136, 122],
        [112, 79],
        [75, 24],
        [53, -59],
        [20, -84],
        [-16, -56],
        [-78, -41],
        [-9, -3],
        [-38, -44],
        [-11, -37],
        [-45, -70],
        [-45, 4],
        [-54, 2],
        [-57, -50],
        [55, -36],
        [47, -20],
        [32, -34],
        [51, -2],
        [32, -23],
        [-18, -44],
        [-4, -56],
        [-34, -42],
        [-33, -100],
        [14, -197],
        [-28, -117],
        [-65, -226],
        [-16, -66],
        [82, -17],
        [98, 47],
        [73, 28],
        [43, -32],
        [-36, -42],
        [62, -29],
        [72, 19],
        [103, -8],
        [96, 32],
        [74, 24],
        [47, -62],
        [7, -57],
        [-24, -55],
        [-50, -78],
        [0, -63],
        [24, -60],
        [-24, -20],
        [-16, -14],
        [-62, 56],
        [-87, 44],
        [-66, -40],
        [11, -43],
        [37, -5],
        [17, -38],
        [-71, -22],
        [-26, -41],
        [0, -44],
        [-49, -60],
        [-51, -73],
        [-17, -54],
        [62, -69],
        [71, -49],
        [23, -88],
        [-27, -53],
        [14, -42],
        [27, -23],
        [-8, -51],
        [-4, -78],
        [-29, -51],
        [-72, -9],
        [-43, 60],
        [-46, 60],
        [-43, 2],
        [-27, -68],
        [62, -41],
        [-2, -41],
        [-71, -119],
        [-13, -54],
        [60, -64],
        [87, -49],
        [56, -22],
        [13, -59],
        [-17, -77],
        [-53, -52],
        [-61, -11],
        [-36, 40],
        [-30, 50],
        [-45, 2],
        [12, -50],
        [14, -62],
        [-13, -56],
        [47, -54],
        [80, -5],
        [43, -17],
        [2, -62],
        [44, -31],
        [46, -8],
        [-14, -49],
        [-49, -49],
        [-9, -176],
        [-2, -71],
        [34, -64],
        [83, -92],
        [35, -51],
        [10, -58],
        [23, -42],
        [33, -49],
        [0, -42],
        [-35, -95],
        [0, -61],
        [156, -146],
        [88, 12],
        [97, 38],
        [70, 22],
        [88, -41],
        [108, -65],
        [93, -64],
        [13, -79],
        [-29, -64],
        [-17, -62],
        [10, -37],
        [-12, -122],
        [-6, -81],
        [47, -75],
        [99, -39],
        [86, 19],
        [52, 82],
        [-15, 68],
        [-49, 66],
        [20, 44],
        [85, 16],
        [86, -37],
        [60, 3],
        [44, 42],
        [65, 35],
        [77, -6],
        [25, -47],
        [6, -168],
        [-39, -55],
        [-88, 0],
        [-48, -8],
        [-26, -5],
        [-6, -12],
        [-22, -46],
        [19, -53],
        [13, -40],
        [-33, -42],
        [-17, -42],
        [76, -199],
        [0, -79],
        [-36, -89],
        [0, -87],
        [30, -66],
        [15, -11],
        [74, -60],
        [60, -3],
        [103, 55],
        [32, 45],
        [-1, 62],
        [34, 27],
        [41, -5],
        [42, -6],
        [52, -46],
        [-3, -50],
        [-42, -25],
        [-35, -51],
        [-10, -80],
        [71, -43],
        [9, -42],
        [48, -57],
        [52, -44],
        [68, -52],
        [35, -20],
        [78, -52],
        [-14, -28],
        [55, -136],
        [2, -42],
        [-37, -74],
        [27, -75],
        [85, -34],
        [72, -24],
        [54, -80],
        [20, -39],
        [-6, -43],
        [51, -66],
        [28, -34],
        [59, -5],
        [70, 36],
        [60, 18],
        [57, -47],
        [15, -56],
        [55, -47],
        [116, -55],
        [59, -77],
        [71, -131],
        [19, -61],
        [2, -73],
        [5, -29],
        [64, -94],
        [33, -133],
        [-9, -127],
        [-23, -133],
        [-24, -91],
        [3, -62],
        [21, -95],
        [24, -69],
        [70, -104],
        [90, -65],
        [82, -20],
        [42, 29],
        [76, -7],
        [83, -59],
        [44, -22],
        [26, -19],
        [-11, -42],
        [12, -51],
        [16, -51],
        [-27, -75],
        [-72, -44],
        [-79, -45],
        [-35, -84],
        [67, -85],
        [55, -22],
        [110, 1],
        [-2, 45],
        [-46, -4],
        [-6, 45],
        [58, -19],
        [60, -41],
        [61, -19],
        [-8, 37],
        [-22, 66],
        [40, 42],
        [90, 44],
        [67, 55],
        [41, 38],
        [35, -21],
        [63, -7],
        [19, -40],
        [-6, -95],
        [57, -28],
        [18, -30],
        [37, -42],
        [75, -22],
        [-8, -45],
        [18, -59],
        [46, -41],
        [34, -37],
        [-36, -30],
        [-13, -32],
        [-15, -40],
        [-14, -23],
        [-2, -61],
        [-149, -166],
        [-127, -50],
        [-105, -4],
        [-74, -23],
        [-59, 17],
        [-65, -13],
        [-13, -74],
        [-7, -68],
        [36, -39],
        [70, -48],
        [106, -22],
        [77, 19],
        [92, -41],
        [137, -120],
        [60, 18],
        [59, -21],
        [33, 8],
        [-10, 24],
        [69, 14],
        [6, -72],
        [-14, -74],
        [-14, -67],
        [-38, -56],
        [-1, -71],
        [-31, -81],
        [-24, -70],
        [29, -102],
        [73, -22],
        [41, 42],
        [36, 15],
        [22, -28],
        [23, -54],
        [-5, -47],
        [52, -73],
        [93, -35],
        [55, 10],
        [6, 45],
        [24, 31],
        [60, -24],
        [79, -66],
        [38, -58],
        [9, -95],
        [94, -233],
        [56, -41],
        [112, -131],
        [38, -88],
        [94, -74],
        [67, 54],
        [44, 34],
        [-4, 40],
        [14, 38],
        [4, 39],
        [-51, 15],
        [-35, -23],
        [-45, 15],
        [6, 62],
        [38, 21],
        [19, 43],
        [52, 18],
        [56, -63],
        [44, -89],
        [32, -26],
        [-9, -62],
        [45, -47],
        [171, -176],
        [35, -96],
        [-4, -72],
        [-63, -55],
        [-79, -23],
        [-93, -5],
        [-43, -42],
        [-15, -59],
        [35, -36],
        [9, -51],
        [18, -55],
        [72, -13],
        [80, 1],
        [72, -12],
        [86, 13],
        [99, -7],
        [118, -80],
        [-8, -49],
        [-42, -43],
        [-12, -65],
        [38, -45],
        [81, -34],
        [53, -61],
        [-2, -52],
        [35, -84],
        [36, -22],
        [22, -34],
        [-32, -25],
        [-6, -32],
        [14, -99],
        [-22, -46],
        [-6, -56],
        [10, -54],
        [48, -22],
        [137, -28],
        [55, 8],
        [36, -38],
        [4, -108],
        [33, 2],
        [72, -49],
        [46, -27],
        [64, -22],
        [33, -49],
        [4, -47],
        [72, -162],
        [131, -150],
        [92, -140],
        [-20, -73],
        [-62, -72],
        [-69, -62],
        [-36, -50],
        [22, -32],
        [67, -24],
        [58, -51],
        [0, -60],
        [-10, -66],
        [23, -66],
        [43, -21],
        [44, 4],
        [27, -2],
        [-42, -70],
        [-79, -22],
        [-56, -18],
        [14, -38],
        [37, -46],
        [-35, -19],
        [-14, -46],
        [-35, -62],
        [-64, -13],
        [-45, 38],
        [-37, -25],
        [21, -40],
        [-30, -66],
        [-15, -94],
        [22, -83],
        [32, -62],
        [63, -37],
        [58, -24],
        [75, -30],
        [155, -105],
        [48, -54],
        [53, -11],
        [34, 12],
        [55, -26],
        [45, -64],
        [60, -20],
        [70, -28],
        [19, -31],
        [68, -162],
        [55, -35],
        [39, 17],
        [60, 22],
        [92, -47],
        [23, -58],
        [46, -14],
        [45, 29],
        [42, -12],
        [-10, -35],
        [-34, -52],
        [-1, -36],
        [-10, -32],
        [-56, -16],
        [-173, -17],
        [-20, -18],
        [-18, -31],
        [-64, 18],
        [-154, 0],
        [-60, -10],
        [-55, -63],
        [-8, -62],
        [34, -57],
        [118, -2],
        [67, 10],
        [57, -12],
        [2, -43],
        [-36, -118],
        [11, -60],
        [118, -37],
        [54, 11],
        [72, 20],
        [61, -10],
        [64, -15],
        [54, -24],
        [-9, -78],
        [11, -31],
        [14, -88],
        [-12, -57],
        [-63, -51],
        [-75, -42],
        [-31, -50],
        [-19, -130],
        [48, -31],
        [123, -86],
        [21, -33],
        [-9, -60],
        [-63, -33],
        [-62, -28],
        [-29, -59],
        [-22, -58],
        [139, -61],
        [43, 11],
        [54, 54],
        [46, 22],
        [47, -10],
        [66, -18],
        [62, -51],
        [-6, -42],
        [-76, -50],
        [-64, -42],
        [0, -32],
        [74, -2],
        [50, -26],
        [6, -25],
        [49, -127],
        [9, -53],
        [-60, -29],
        [-47, -24],
        [-21, -59],
        [24, -56],
        [126, -219],
        [22, -52],
        [-8, -41],
        [-94, -155],
        [-39, -62],
        [8, -67],
        [54, -52],
        [12, -51],
        [32, -60],
        [67, -44],
        [313, -177],
        [136, -53],
        [107, -10],
        [90, -32],
        [65, -41],
        [45, -56],
        [5, -101],
        [-59, -84],
        [-72, -62],
        [-358, -150],
        [-71, 7],
        [-75, 12],
        [-92, -35],
        [-80, -89],
        [-35, -93],
        [13, -60],
        [70, -6],
        [24, -32],
        [239, -162],
        [92, -151],
        [102, -130],
        [21, -93],
        [-20, -119],
        [-31, -87],
        [-19, -75],
        [16, -41],
        [102, -39],
        [65, 2],
        [33, 45],
        [-16, 57],
        [-22, 68],
        [48, 51],
        [62, 20],
        [53, 29],
        [70, -13],
        [51, -41],
        [13, -61],
        [6, -63],
        [47, -24],
        [55, 11],
        [51, 6],
        [14, -50],
        [30, -54],
        [33, -50],
        [4, -6],
        [2, -4],
        [-2, -59],
        [-28, -167],
        [20, -171],
        [51, -51],
        [84, -30],
        [37, -44],
        [181, -248],
        [104, -34],
        [50, -44],
        [12, -29],
        [-36, -44],
        [13, -54],
        [-3, -35],
        [-64, -45],
        [-12, -51],
        [63, -106],
        [92, -26],
        [79, -2],
        [69, -22],
        [68, 0],
        [27, -39],
        [55, -38],
        [59, -66],
        [-1, -50],
        [-70, -17],
        [-54, 1],
        [-52, -35],
        [16, -63],
        [-48, -26],
        [-72, -10],
        [-60, 7],
        [-23, -39],
        [46, -46],
        [56, -35],
        [12, -45],
        [26, -37],
        [45, -80],
        [83, -73],
        [96, -90],
        [52, -78],
        [49, -74],
        [68, -4],
        [76, 54],
        [33, 76],
        [-57, 55],
        [-28, 75],
        [42, 84],
        [75, -9],
        [21, -18],
        [71, -6],
        [69, 37],
        [87, 67],
        [94, 37],
        [84, 16],
        [82, -16],
        [25, -47],
        [-37, -56],
        [3, -113],
        [36, -63],
        [56, -41],
        [39, -36],
        [49, 4],
        [65, 10],
        [49, -4],
        [57, -2],
        [82, -18],
        [100, -6],
        [51, 1],
        [8, -72],
        [-8, -95],
        [25, -83],
        [73, -92],
        [110, -46],
        [40, -12],
        [118, 25],
        [129, 17],
        [115, 7],
        [22, -5],
        [11, -2],
        [43, -8],
        [25, -42],
        [-39, -71],
        [4, -52],
        [35, -74],
        [72, -60],
        [30, -128],
        [13, -130],
        [5, -89],
        [49, -41],
        [73, 42],
        [88, 6],
        [139, 26],
        [90, -6],
        [81, -50],
        [6, -80],
        [-4, -89],
        [-33, -43],
        [-51, -84],
        [-26, -104],
        [0, -12],
        [-4, -88],
        [46, -75],
        [54, -24],
        [60, 51],
        [64, 10],
        [90, -60],
        [115, -47],
        [254, -14],
        [61, -123],
        [179, -129],
        [327, -207],
        [526, -340],
        [478, -316],
        [322, -195],
        [198, -111],
        [423, -274],
        [627, -402],
        [405, -269],
        [127, -125],
        [29, -75],
        [-13, -40],
        [-14, -44],
        [-38, -85],
        [22, -36],
        [33, -55],
        [41, -42],
        [0, -12],
        [-1, -60],
        [52, -106],
        [8, -18],
        [18, -44],
        [29, -75],
        [10, -25],
        [7, -129],
        [-35, -76],
        [3, -10],
        [3, -15],
        [18, -69],
        [7, -27],
        [6, -28],
        [0, -2],
        [3, -12],
        [42, -91],
        [47, -16],
        [37, 14],
        [14, 6],
        [66, 51],
        [60, -8],
        [43, -7],
        [110, 11],
        [95, 26],
        [40, -24],
        [10, -6],
        [35, -24],
        [1, -2],
        [40, -95],
        [0, -110],
        [-1, -72],
        [-32, -86],
        [-49, -85],
        [-21, -36],
        [-20, -34],
        [-19, -108],
        [58, -97],
        [157, -72],
        [54, -3],
        [25, -1],
        [66, -2],
        [32, 18],
        [95, 57],
        [18, 11],
        [30, 16],
        [35, 11],
        [44, 12],
        [0, 1],
        [72, 32],
        [86, -3],
        [52, -21],
        [142, -61],
        [59, -61],
        [8, -31],
        [32, -94],
        [23, -82],
        [78, -37],
        [160, -35],
        [48, -32],
        [96, -76],
        [115, -24],
        [78, 69],
        [52, 101],
        [7, 70],
        [-37, 63],
        [35, 42],
        [116, 11],
        [95, -57],
        [81, -93],
        [58, -146],
        [0, -66],
        [-60, -133],
        [-32, -105],
        [26, -74],
        [-2, -55],
        [20, -107],
        [58, -34],
        [113, -5],
        [104, 52],
        [99, -9],
        [102, -16],
        [93, 6],
        [148, -48],
        [107, -42],
        [84, -106],
        [23, -114],
        [-12, -111],
        [15, -91],
        [78, -32],
        [85, -42],
        [98, 7],
        [47, 25],
        [67, 110],
        [36, 33],
        [323, 71],
        [90, -47],
        [77, -60],
        [104, 27],
        [85, 201],
        [-16, 97],
        [-46, 72],
        [13, 61],
        [163, 201],
        [89, 51],
        [100, -5],
        [129, -46],
        [112, -103],
        [33, -106],
        [-31, -166],
        [0, -100],
        [30, -68],
        [83, -19],
        [46, 8],
        [253, 55],
        [129, 6],
        [256, -6],
        [221, -27],
        [115, -63],
        [43, -70],
        [-3, -75],
        [15, -29],
        [7, -13],
        [12, -24],
        [252, -41],
        [71, -8],
        [161, -71],
        [115, -19],
        [296, -38],
        [150, -24],
        [235, -52],
        [82, -57],
        [85, -47],
        [140, -20],
        [75, 14],
        [94, -12],
        [98, -76],
        [58, -87],
        [-2, -53],
        [-51, -42],
        [-21, -35],
        [78, -169],
        [47, -38],
        [217, -6],
        [94, -10],
        [74, 6],
        [149, -73],
        [91, -44],
        [207, -130],
        [110, -152],
        [4, -7],
        [138, -100],
        [128, -73],
        [66, -20],
        [46, -14],
        [56, 26],
        [72, -38],
        [142, -168],
        [71, -119],
        [15, -120],
        [-27, -140],
        [-21, -123],
        [11, -40],
        [39, -135],
        [39, -153],
        [57, -153],
        [50, -54],
        [101, -5],
        [88, 63],
        [99, 45],
        [243, 102],
        [143, 62],
        [168, 69],
        [94, 76],
        [65, 26],
        [103, -40],
        [43, -85],
        [37, -59],
        [89, -31],
        [66, -50],
        [16, -68],
        [-22, -69],
        [-80, -127],
        [-25, -77],
        [19, -180],
        [-23, -107],
        [-31, -123],
        [-52, -102],
        [-12, -52],
        [-12, -159],
        [-21, -162],
        [-20, -119],
        [-56, -78],
        [-110, -73],
        [-87, -46],
        [-14, -30],
        [-27, -55],
        [35, -81],
        [90, -81],
        [62, -49],
        [100, -103],
        [91, -109],
        [134, -116],
        [211, -144],
        [331, -183],
        [162, -73],
        [181, -125],
        [57, -107],
        [31, -115],
        [10, -84],
        [31, -103],
        [113, -71],
        [69, -68],
        [37, -52],
        [28, -39],
        [19, -26],
        [42, -68],
        [37, -18],
        [28, -13],
        [25, -13],
        [39, -18],
        [80, -30],
        [37, -14],
        [94, -72],
        [44, -37],
        [35, -71],
        [12, -25],
        [3, -34],
        [13, -194],
        [9, -105],
        [26, -120],
        [-4, -294],
        [21, -115],
        [70, -67],
        [100, -62],
        [128, -46],
        [90, -14],
        [45, -50],
        [41, -117],
        [79, -93],
        [126, -114],
        [99, -103],
        [68, -119],
        [14, -80],
        [-20, -63],
        [-72, -43],
        [-42, -42],
        [3, -37],
        [29, -57],
        [10, -51],
        [74, -65],
        [66, -61],
        [114, -72],
        [94, -59],
        [103, 4],
        [117, 15],
        [88, 70],
        [75, 66],
        [53, 0],
        [115, -47],
        [76, -179],
        [13, -127],
        [57, -95],
        [29, -21],
        [170, 0],
        [57, 50],
        [77, 45],
        [70, -42],
        [27, -63],
        [33, -70],
        [8, -80],
        [-16, -107],
        [-14, -80],
        [56, -79],
        [86, -23],
        [103, 65],
        [121, 36],
        [73, 141],
        [42, 64],
        [71, -38],
        [43, -106],
        [22, -65],
        [117, -29],
        [57, -28],
        [51, -23],
        [54, -42],
        [141, -2],
        [80, 50],
        [100, 42],
        [81, -59],
        [50, -97],
        [13, -57],
        [-4, -236],
        [-2, -114],
        [34, -74],
        [119, -63],
        [88, 8],
        [94, 63],
        [65, 66],
        [99, 18],
        [87, 42],
        [157, 21],
        [133, -27],
        [169, -109],
        [132, -164],
        [72, -101],
        [93, -49],
        [111, -68],
        [3, -111],
        [5, -117],
        [13, -82],
        [82, -28],
        [107, -7],
        [51, -31],
        [41, -43],
        [53, -5],
        [103, -16],
        [106, -161],
        [-77, -112],
        [-40, -139],
        [82, -50],
        [93, -82],
        [96, -66],
        [69, -55],
        [165, -206],
        [78, -45],
        [39, -24],
        [106, -39],
        [129, -38],
        [111, 40],
        [100, 78],
        [66, 2],
        [113, -98],
        [91, -77],
        [57, -64],
        [78, -66],
        [95, -47],
        [121, -48],
        [108, -50],
        [111, -72],
        [98, -29],
        [94, -24],
        [83, -48],
        [-12, -81],
        [-14, -87],
        [-5, -69],
        [6, -83],
        [119, -141],
        [92, -52],
        [216, -152],
        [133, -87],
        [92, -51],
        [169, -80],
        [225, -164],
        [95, -85],
        [122, -65],
        [141, -55],
        [110, -59],
        [168, -106],
        [75, -22],
        [161, -60],
        [245, -118],
        [111, -55],
        [119, 4],
        [132, -18],
        [165, -87],
        [113, -65],
        [117, -47],
        [54, -34],
        [124, -29],
        [126, -29],
        [87, -51],
        [72, -64],
        [73, -19],
        [146, 6],
        [208, -28],
        [195, -66],
        [226, -113],
        [105, -42],
        [72, -57],
        [45, -38],
        [43, -33],
        [460, -198],
        [143, -29],
        [211, 36],
        [83, 134],
        [68, 70],
        [209, -89],
        [214, 14],
        [201, -78],
        [193, -47],
        [152, 39],
        [233, -157],
        [301, 14],
        [334, -157],
        [172, 0],
        [116, 36],
        [199, 0],
        [291, 54],
        [141, -54],
        [82, -71],
        [217, -144],
        [0, -284],
        [39, -74],
        [272, -34],
        [94, 22],
        [107, 37],
        [107, 38],
        [228, 60],
        [207, 68],
        [126, -6],
        [293, -272],
        [329, -282],
        [81, 4],
        [105, 64],
        [68, 75],
        [12, 175],
        [154, 78],
        [202, 12],
        [298, -100],
        [108, -48],
        [136, -141],
        [67, -33],
        [199, 101],
        [181, -162],
        [175, 40],
        [140, 76],
        [140, 26],
        [12, 2],
        [319, -99],
        [137, -31],
        [254, 0],
        [95, -51],
        [306, -54],
        [33, -29],
        [69, -262],
        [85, -58],
        [254, -73],
        [148, -73],
        [102, -82],
        [85, 1],
        [229, 69],
        [19, 6],
        [14, 5],
        [218, 91],
        [220, 144],
        [72, -38],
        [199, -42],
        [78, -115],
        [48, -113],
        [-95, -195],
        [26, -61],
        [77, -53],
        [44, -82],
        [24, -174],
        [246, -86],
        [101, -57],
        [179, -13],
        [85, 42],
        [78, 82],
        [188, 116],
        [221, 185],
        [248, 28],
        [79, -25],
        [62, -153],
        [326, -487],
        [28, -194],
        [64, -231],
        [6, -106],
        [-32, -201],
        [-54, -86],
        [-230, -14],
        [-37, -53],
        [-19, -144],
        [8, -185],
        [36, -313],
        [-7, -21],
        [-45, -151],
        [-12, -156],
        [47, -72],
        [184, -200],
        [48, -143],
        [64, -81],
        [207, 35],
        [206, 1],
        [113, 218],
        [-31, 159],
        [8, 47],
        [282, 304],
        [93, 57],
        [104, 30],
        [137, -33],
        [63, -128],
        [112, -108],
        [65, -113],
        [-41, -138],
        [-150, -141],
        [31, -189],
        [62, -46],
        [140, -21],
        [294, 15],
        [311, 143],
        [72, 14],
        [114, -191],
        [-22, -114],
        [-132, -162],
        [65, -108],
        [-15, -190],
        [167, -364],
        [184, -220],
        [418, -279],
        [44, -104],
        [41, -181],
        [62, -43],
        [117, -36],
        [91, -86],
        [184, -318],
        [142, -303],
        [47, -49],
        [97, -20],
        [72, 35],
        [83, 213],
        [56, 33],
        [74, -11],
        [137, 11],
        [110, -47],
        [127, 34],
        [148, 0],
        [64, -77],
        [137, -289],
        [128, -118],
        [155, -21],
        [333, 51],
        [121, 9],
        [58, -34],
        [177, -103],
        [160, -10],
        [187, -90],
        [178, -32],
        [153, -47],
        [110, -13],
        [127, 21],
        [171, -77],
        [64, -33],
        [28, -28],
        [26, -22],
        [33, -27],
        [89, -8],
        [43, 13],
        [37, 4],
        [76, -13],
        [92, -9],
        [58, -23],
        [46, -22],
        [44, -34],
        [29, -63],
        [21, -46],
        [24, -54],
        [27, -56],
        [31, -33],
        [20, -39],
        [25, -54],
        [18, -43],
        [11, -25],
        [14, -28],
        [42, -41],
        [26, -14],
        [35, -16],
        [19, -46],
        [-4, -41],
        [-15, -33],
        [-4, -33],
        [2, -39],
        [2, -32],
        [18, -47],
        [31, -41],
        [41, -25],
        [72, 5],
        [62, 8],
        [44, 33],
        [65, 57],
        [106, 67],
        [79, 40],
        [104, 44],
        [87, 26],
        [73, 4],
        [66, -26],
        [70, -44],
        [78, -48],
        [52, -34],
        [64, -15],
        [96, 32],
        [56, 53],
        [104, 133],
        [99, 72],
        [101, 23],
        [101, 4],
        [124, -9],
        [133, -15],
        [111, -1],
        [98, 27],
        [133, 58],
        [125, 67],
        [42, 14],
        [53, -6],
        [79, -36],
        [55, -56],
        [53, -69],
        [26, -37],
        [54, -73],
        [71, -67],
        [86, -43],
        [59, -22],
        [90, -30],
        [53, -11],
        [33, -23],
        [7, -51],
        [12, -45],
        [19, -59],
        [56, -72],
        [78, -65],
        [65, -62],
        [84, -73],
        [76, -58],
        [48, -43],
        [74, -21],
        [83, -8],
        [137, 3],
        [111, -9],
        [120, -8],
        [28, 5],
        [64, 10],
        [101, 14],
        [111, 30],
        [48, 17],
        [101, 37],
        [76, 39],
        [78, 45],
        [57, 38],
        [83, 30],
        [116, -12],
        [65, -14],
        [76, 14],
        [102, 46],
        [127, 43],
        [98, 12],
        [101, 2],
        [165, 22],
        [109, 78],
        [54, 44],
        [42, 39],
        [22, 37],
        [34, 25],
        [55, -11],
        [57, -39],
        [45, -42],
        [37, -41],
        [36, -43],
        [35, -53],
        [16, -52],
        [-4, -56],
        [-23, -51],
        [-37, -34],
        [-37, -42],
        [-25, -49],
        [-14, -50],
        [-2, -68],
        [10, -53],
        [18, -50],
        [13, -63],
        [14, -44],
        [24, -54],
        [27, -43],
        [48, -51],
        [45, -31],
        [43, -14],
        [83, -2],
        [81, 37],
        [48, 27],
        [59, 36],
        [54, 3],
        [82, -21],
        [71, 6],
        [54, 19],
        [64, 0],
        [25, -21],
        [33, -32],
        [40, -44],
        [43, -23],
        [181, -65],
        [171, -65],
        [94, -60],
        [86, -45],
        [126, -81],
        [55, -23],
        [35, -41],
        [60, -145],
        [6, -110],
        [4, -95],
        [-2, -106],
        [4, -112],
        [0, -76],
        [-2, -76],
        [-10, -63],
        [-20, -45],
        [-30, -46],
        [-22, -41],
        [-15, -45],
        [0, -52],
        [21, -52],
        [45, -36],
        [109, 8],
        [104, 2],
        [102, -6],
        [94, 6],
        [101, -10],
        [103, -18],
        [64, -32],
        [58, -45],
        [76, -40],
        [88, -18],
        [91, 8],
        [96, 20],
        [87, 10],
        [87, -14],
        [66, -26],
        [54, -37],
        [35, -70],
        [8, -74],
        [-12, -71],
        [-25, -36],
        [-46, -30],
        [-55, -32],
        [-34, -19],
        [-37, -44],
        [-25, -56],
        [-24, -52],
        [-5, -62],
        [13, -67],
        [28, -54],
        [66, -52],
        [72, -11],
        [92, 5],
        [66, 46],
        [83, 39],
        [80, 17],
        [118, 17],
        [64, -25],
        [47, -107],
        [60, -149],
        [69, -124],
        [56, -78],
        [64, -77],
        [62, -73],
        [46, -74],
        [70, -95],
        [52, -78],
        [80, -79],
        [111, -84],
        [97, -43],
        [80, -43],
        [87, -44],
        [64, -49],
        [35, -52],
        [27, -72],
        [53, -75],
        [74, -53],
        [78, -25],
        [85, -34],
        [65, -50],
        [31, -64],
        [6, -141],
        [-16, -94],
        [-3, -91],
        [-16, -95],
        [-37, -107],
        [-46, -96],
        [-26, -63],
        [-37, -68],
        [-14, -28],
        [-32, -69],
        [-17, -38],
        [7, -51],
        [24, -55],
        [22, -45],
        [45, -55],
        [48, -65],
        [55, -31],
        [61, -4],
        [100, 28],
        [63, 8],
        [68, -20],
        [31, -11],
        [63, -22],
        [60, -7],
        [57, 32],
        [72, 123],
        [16, 46],
        [-4, 99],
        [-2, 30],
        [0, 53],
        [6, 26],
        [27, 27],
        [113, 12],
        [67, -9],
        [96, -14],
        [104, 9],
        [113, 11],
        [77, 12],
        [65, 2],
        [33, -7],
        [0, -31],
        [-22, -36],
        [-5, -55],
        [2, -67],
        [5, -73],
        [5, -68],
        [3, -87],
        [20, -80],
        [82, -73],
        [96, -110],
        [68, -86],
        [87, -52],
        [108, -53],
        [97, -56],
        [127, -34],
        [119, -24],
        [76, -8],
        [65, -8],
        [30, -24],
        [14, -31],
        [-15, -32],
        [-12, -33],
        [-3, -42],
        [20, -32],
        [51, -44],
        [68, -73],
        [66, -95],
        [43, -61],
        [32, -59],
        [9, -71],
        [-32, -65],
        [-26, -41],
        [-38, -30],
        [-48, -21],
        [-53, -24],
        [-34, -36],
        [-5, -31],
        [13, -46],
        [50, -46],
        [83, -40],
        [79, -40],
        [77, -24],
        [47, -4],
        [85, 12],
        [106, 28],
        [83, -16],
        [99, 10],
        [68, 36],
        [70, 12],
        [82, -14],
        [66, -36],
        [13, -38],
        [-4, -54],
        [-9, -36],
        [-7, -33],
        [1, -34],
        [15, -42],
        [28, -22],
        [152, -39],
        [236, 23],
        [127, 29],
        [89, 28],
        [74, 19],
        [60, -2],
        [22, -49],
        [-6, -38],
        [5, -56],
        [26, -67],
        [20, -32],
        [4, -55],
        [2, -90],
        [18, -54],
        [45, -65],
        [71, -41],
        [100, -14],
        [83, 29],
        [54, 17],
        [79, 18],
        [82, 22],
        [44, 36],
        [42, 56],
        [34, 44],
        [46, 31],
        [99, -16],
        [125, -95],
        [54, -78],
        [26, -95],
        [9, -89],
        [0, -51],
        [-9, -128],
        [-11, -156],
        [13, -55],
        [26, -43],
        [51, -47],
        [37, 6],
        [36, 41],
        [14, 31],
        [17, 33],
        [56, 26],
        [69, -23],
        [89, -4],
        [129, -2],
        [43, 9],
        [95, 4],
        [120, -30],
        [107, -36],
        [147, -53],
        [140, -61],
        [81, -49],
        [132, -55],
        [108, -24],
        [107, -21],
        [125, -13],
        [99, 14],
        [72, 58],
        [66, 71],
        [77, 154],
        [36, 74],
        [63, 102],
        [36, 63],
        [74, 83],
        [36, 90],
        [23, 76],
        [0, 126],
        [26, 119],
        [13, 67],
        [28, 118],
        [32, 66],
        [16, 45],
        [14, 42],
        [-25, 83],
        [-6, 96],
        [-1, 55],
        [25, 51],
        [33, 33],
        [23, 32],
        [24, 46],
        [14, 32],
        [26, 44],
        [23, 24],
        [51, 6],
        [47, -42],
        [72, -61],
        [90, -48],
        [64, -16],
        [78, 6],
        [64, 4],
        [59, 13],
        [64, -7],
        [51, -13],
        [109, -44],
        [89, -3],
        [110, -34],
        [7, -12],
        [140, -122],
        [26, -39],
        [18, -44],
        [24, -151],
        [-6, -83],
        [-14, -73],
        [2, -77],
        [-25, -102],
        [-22, -40],
        [-60, -80],
        [-15, -13],
        [-51, -26],
        [-29, -26],
        [-32, -21],
        [-103, -53],
        [-59, -15],
        [-33, -6],
        [-40, -17],
        [-48, -5],
        [-64, -2],
        [-45, 3],
        [-61, 13],
        [-46, 16],
        [-71, 6],
        [-38, -1],
        [-37, -3],
        [-24, -11],
        [-14, -25],
        [3, -32],
        [17, -44],
        [14, -32],
        [20, -34],
        [10, -28],
        [16, -110],
        [24, -64],
        [33, -73],
        [43, -62],
        [27, -36],
        [113, -110],
        [35, -31],
        [54, -26],
        [51, -25],
        [61, -16],
        [86, -30],
        [48, -13],
        [81, -11],
        [55, -15],
        [65, -7],
        [63, 2],
        [61, 9],
        [63, 21],
        [69, 38],
        [61, 46],
        [108, 87],
        [101, 95],
        [18, 26],
        [31, 26],
        [42, 53],
        [52, 50],
        [48, 53],
        [21, 36],
        [36, 42],
        [22, 39],
        [25, 26],
        [29, 19],
        [43, 15],
        [98, 2],
        [94, -13],
        [91, -27],
        [47, -21],
        [43, -28],
        [63, -80],
        [6, -56],
        [1, -29],
        [-3, -30],
        [-11, -56],
        [-28, -79],
        [-80, -152],
        [-139, -201],
        [-36, -21],
        [-30, -28],
        [-111, -69],
        [-76, -57],
        [-44, -50],
        [-10, -16],
        [-2, -19],
        [4, -18],
        [2, -5],
        [38, -101],
        [32, -59],
        [44, -39],
        [17, -28],
        [56, -47],
        [16, -21],
        [31, -9],
        [35, -20],
        [34, -56],
        [24, -18],
        [69, -28],
        [154, -15],
        [2, 1],
        [-42, -41],
        [-4, -68],
        [-26, -43],
        [-30, -37],
        [-38, 6],
        [-2996, -5403],
        [-815, -897],
        [-2027, -2508],
        [-2, -21],
        [-4, -16],
        [-20, -155],
        [10, -4],
        [10, -10],
        [8, -17],
        [9, -27],
        [16, -27],
        [25, -50],
        [93, -168],
        [10, -22],
        [7, -24],
        [7, -24],
        [4, -19],
        [0, -17],
        [0, -20],
        [2, -12],
        [24, -24],
        [12, -13],
        [3, -14],
        [1, -19],
        [10, -19],
        [11, -8],
        [6, -16],
        [9, -24],
        [10, -26],
        [6, -28],
        [1, -34],
        [0, -2],
        [1, -23],
        [-3, -20],
        [5, -20],
        [12, -26],
        [10, -29],
        [14, -26],
        [14, -35],
        [10, -16],
        [8, -15],
        [6, -33],
        [11, -29],
        [4, -21],
        [-4, -14],
        [2, -10],
        [23, -25],
        [18, -44],
        [24, -40],
        [14, -34],
        [10, -24],
        [-1, -25],
        [10, -40],
        [15, -47],
        [18, -33],
        [5, -27],
        [1, -19],
        [2, -20],
        [9, -28],
        [2, -32],
        [8, -28],
        [16, -30],
        [8, -23],
        [1, -28],
        [0, -22],
        [9, -20],
        [0, -39],
        [3, -15],
        [4, -23],
        [0, -21],
        [0, -26],
        [2, -10],
        [13, -12],
        [10, -12],
        [0, -21],
        [-6, -12],
        [-6, -8],
        [1, -13],
        [-16, -36],
        [-10, -24],
        [-13, -18],
        [-16, -56],
        [-4, -20],
        [-2, -23],
        [4, -38],
        [0, -18],
        [-6, -20],
        [-8, -17],
        [-4, -17],
        [-1, -15],
        [-9, -16],
        [-6, -17],
        [-11, -13],
        [-10, -15],
        [-4, -28],
        [-4, -16],
        [-18, -18],
        [-37, -13],
        [-35, -9],
        [-11, -10],
        [-6, -29],
        [-7, -20],
        [0, -28],
        [-8, -22],
        [-18, -21],
        [-20, -19],
        [-8, -23],
        [-3, -18],
        [-13, -12],
        [-18, -2],
        [-6, -4],
        [-1, -18],
        [-15, -38],
        [-18, -27],
        [-18, 3],
        [-26, 30],
        [-37, 24],
        [-52, -1],
        [-57, 5],
        [-43, 18],
        [-18, 2],
        [-15, -16],
        [-337, 760],
        [-836, -1312],
        [-502, -541],
        [-1420, -2374],
        [-725, -1211],
        [192, -192],
        [-3169, -6116],
        [-325, 250],
        [-10, -18],
        [-626, -1025],
        [-629, -1071],
        [-141, -230],
        [-914, -1493],
        [-702, 1448],
        [-249, 511],
        [-341, -466],
        [-24, -35],
        [-212, -289],
        [-889, 713],
        [-1217, -2756],
        [16, -5],
        [557, -184],
        [919, -303],
        [-413, -783],
        [-148, -280],
        [-1403, 406],
        [-3, -5],
        [-51, 16],
        [-799, -1778],
        [-288, -643],
        [-358, -795],
        [285, -158],
        [21, -1212],
        [-1198, -2361],
        [-1858, -3667],
        [-172, -341],
        [-1236, -2439],
        [-2, -4],
        [-809, -1601],
        [-73, -131],
        [-727, -1323],
        [-1337, -2439],
        [-326, 146],
        [-1346, -2753],
        [-56, -114],
        [-195, -401],
        [-48, -99],
        [-197, -403],
        [-2, -3],
        [-1896, -3879],
        [-1, -2],
        [-108, -220],
        [-437, -881],
        [-1432, -2938],
        [-1, -12],
        [-423, -863],
        [308, -165],
        [98, -42],
        [-30, -53],
        [-504, -918],
        [-406, -740],
        [-408, -748],
        [-229, -402],
        [-26, -53],
        [-163, -335],
        [-548, -1416],
        [-14, -35],
        [-910, -2349],
        [-827, -2143],
        [514, -157],
        [0, -1],
        [168, -50],
        [2345, -718],
        [-411, -1273],
        [-63, -194],
        [-464, -1435],
        [-2958, 898],
        [-70, 22],
        [42, 135],
        [89, 272],
        [254, 764],
        [-295, 90],
        [-289, 89],
        [-281, 85],
        [-291, 89],
        [-40, 12],
        [160, -922],
        [107, -614],
        [452, -2601],
        [-142, 0],
        [-8, -2167],
        [-879, -1407],
        [146, -62],
        [224, -91],
        [348, -135],
        [70, -34],
        [50, -47],
        [156, -195],
        [2663, 0],
        [-119, -107],
        [-1152, -1048],
        [-1, -2],
        [-30, -27],
        [-2, -1],
        [-847, -772],
        [2981, -3449],
        [388, -450],
        [-961, 93],
        [444, -1825],
        [-372, -2617],
        [760, -1098],
        [-868, -68],
        [78, -340],
        [770, -3385],
        [911, 425],
        [532, -2332],
        [15, -64],
        [330, -1446],
        [2, -12],
        [-41, -1125],
        [-56, -1545],
        [-22, -611],
        [-16, -542],
        [-97, -3189],
        [-9, -299],
        [-144, 50],
        [-174, 17],
        [-249, -2616],
        [-436, -4621],
        [-134, -1398],
        [1778, -568],
        [21, -6],
        [14, -4],
        [920, -296],
        [35, -13],
        [9, -151],
        [-9, -109],
        [2, -48],
        [23, -169],
        [23, -198],
        [17, -96],
        [11, -45],
        [-4, -72],
        [18, -64],
        [2, -81],
        [17, -109],
        [-47, -105],
        [20, -92],
        [12, -93],
        [29, -46],
        [58, -64],
        [25, -44],
        [29, -147],
        [22, -71],
        [56, -50],
        [19, -35],
        [12, -36],
        [8, -65],
        [22, -156],
        [14, -108],
        [2, -49],
        [6, -25],
        [27, -69],
        [27, -34],
        [32, -42],
        [37, -73],
        [12, -46],
        [43, -114],
        [15, -66],
        [17, -141],
        [16, -72],
        [26, -67],
        [27, -143],
        [27, -66],
        [22, -69],
        [-2, -32],
        [-20, -24],
        [4, -21],
        [59, -287],
        [101, 65],
        [539, 351],
        [679, -2384],
        [0, -21],
        [-1, -14],
        [-60, -5891],
        [296, -672],
        [127, -287],
        [563, -1281],
        [2, -2],
        [44, -31],
        [147, -7],
        [283, -18],
        [122, -48],
        [83, -38],
        [56, -63],
        [51, -27],
        [20, -6],
        [21, 0],
        [18, -22],
        [68, -43],
        [58, -33],
        [82, -49],
        [52, -18],
        [18, -6],
        [18, -4],
        [17, -14],
        [47, -21],
        [41, -24],
        [14, -12],
        [22, -8],
        [25, -4],
        [87, -26],
        [200, -56],
        [85, -26],
        [42, -28],
        [87, -91],
        [7, -16],
        [13, -12],
        [8, -31],
        [18, -29],
        [33, -30],
        [18, -30],
        [9, -13],
        [19, -62],
        [20, -23],
        [38, -173],
        [6, -80],
        [13, -32],
        [1, -8],
        [6, -50],
        [-4, -27],
        [12, -32],
        [11, -24],
        [5, -28],
        [15, -87],
        [28, -202],
        [16, -114],
        [21, -92],
        [4, -85],
        [-12, -106],
        [-4, -50],
        [18, -135],
        [-6, -35],
        [5, -45],
        [3, -25],
        [29, -160],
        [3, -68],
        [15, -38],
        [16, -54],
        [6, -50],
        [22, -28],
        [14, -104],
        [76, -248],
        [43, -172],
        [-1, -155],
        [-15, -74],
        [2, -47],
        [26, -66],
        [2, -24],
        [-14, -84],
        [-5, -89],
        [70, -403],
        [0, -40],
        [23, -46],
        [23, -3],
        [33, -32],
        [2, -21],
        [41, -60],
        [93, -117],
        [-104, -50],
        [-73, 40],
        [-67, 24],
        [-35, 2],
        [-27, -4],
        [-38, -25],
        [-82, -35],
        [-143, -61],
        [-55, -10],
        [-118, -65],
        [-967, -430],
        [-64, -25],
        [-65, -18],
        [-580, -254],
        [-279, -1830],
        [-11, -51],
        [-835, -616],
        [-1052, -776],
        [-1084, -800],
        [-80, -59],
        [-1115, -822],
        [-5, -3],
        [5, -5],
        [33, -5],
        [962, 88],
        [-991, -2042],
        [16, -607],
        [260, -210],
        [307, -95],
        [22, -8],
        [665, -728],
        [205, -123],
        [174, -111],
        [171, -111],
        [505, -617],
        [611, -743],
        [891, -631],
        [313, -305],
        [333, -324],
        [583, -65],
        [510, -117],
        [44, -26],
        [5, -4],
        [75, -30],
        [368, -195],
        [207, -1314],
        [1517, -2404],
        [75, -120],
        [357, -1559],
        [31, -137],
        [20, -113],
        [25, -66],
        [49, -100],
        [8, -35],
        [105, -462],
        [841, -287],
        [31, -70],
        [110, -260],
        [16, -38],
      ],
      [
        [355237, 292449],
        [-8595, 1648],
        [-1432, 276],
        [0, -245],
        [-145, 44],
        [-180, 53],
        [-174, 52],
        [-731, 151],
        [-1193, 0],
        [-1687, -146],
        [-298, 85],
        [-717, -5],
        [-463, -2],
        [-2607, -18],
        [-4, 1518],
        [-40, 46],
        [-28, 34],
        [-362, -34],
        [-2000, -177],
        [-425, -1311],
        [-84, -307],
        [-11, -36],
        [-255, -443],
        [-693, 345],
        [-1014, 221],
        [-3677, 795],
        [-1030, 223],
        [-2132, 458],
        [-992, 95],
        [-1720, 145],
        [8, 142],
        [-3, 6],
        [-293, 388],
        [-1142, 1557],
        [-29, 32],
        [4, 44],
        [0, 33],
        [-2, 7],
        [0, 48],
        [10, 39],
        [-364, 726],
        [-266, 530],
        [-47, 53],
        [-21, 14],
        [-26, 22],
        [-40, 34],
        [-24, 20],
        [-43, 88],
        [-20, 77],
        [-49, 66],
        [-52, 23],
        [-15, 60],
        [-38, 55],
        [-35, 20],
        [-31, 9],
        [-42, -17],
        [-14, 36],
        [-28, 14],
        [-45, -26],
        [-29, 20],
        [-12, 28],
        [-27, 41],
        [-10, 35],
        [-5, 30],
        [-36, 21],
        [-19, 46],
        [-13, 26],
        [-76, -56],
        [-10, -24],
        [-48, -26],
        [-39, -30],
        [-54, -36],
        [-74, -55],
        [-127, -112],
        [-76, -61],
        [-42, -43],
        [40, -119],
        [12, -58],
        [12, -131],
        [-54, -164],
        [-116, -217],
        [-56, -62],
        [-68, -57],
        [-83, -85],
        [-117, -118],
        [-39, -13],
        [-42, -12],
        [-54, -26],
        [-145, -99],
        [-93, -34],
        [115, -18],
        [24, -22],
        [20, -20],
        [10, -14],
        [51, -6],
        [115, 2],
        [121, 11],
        [84, -41],
        [9, -31],
        [-10, -30],
        [-65, 0],
        [-36, 0],
        [-19, 1],
        [-69, 0],
        [-27, 16],
        [-47, 29],
        [-70, -9],
        [-4, -11],
        [-11, -25],
        [2, -39],
        [-30, -36],
        [-33, -25],
        [-16, -34],
        [-10, -109],
        [-22, -18],
        [-39, 38],
        [-27, -26],
        [11, -49],
        [-39, -26],
        [-55, 24],
        [-58, -43],
        [-50, 11],
        [-105, -32],
        [15, -78],
        [-93, -39],
        [-202, -61],
        [-146, -55],
        [-176, -70],
        [-264, -213],
        [-32, -91],
        [-43, -73],
        [-42, -34],
        [4, -28],
        [32, -12],
        [57, -6],
        [51, -14],
        [-10, -32],
        [23, -42],
        [53, -73],
        [33, -34],
        [16, -34],
        [34, -36],
        [64, -60],
        [11, -2],
        [30, -5],
        [116, 0],
        [70, -8],
        [35, -27],
        [-24, -25],
        [-18, -18],
        [-28, -28],
        [-9, -10],
        [-16, -195],
        [132, -190],
        [32, -55],
        [58, -86],
        [-1, -10],
        [-22, -185],
        [4, -149],
        [18, -189],
        [23, -136],
        [52, -84],
        [19, -38],
        [-732, -573],
        [-228, -176],
        [15, -31],
        [41, -17],
        [69, 0],
        [81, -46],
        [65, -120],
        [41, -49],
        [44, -33],
        [49, 0],
        [98, 2],
        [81, -41],
        [69, -24],
        [116, 0],
        [31, 4],
        [18, -48],
        [32, -24],
        [20, -26],
        [43, -44],
        [63, -42],
        [57, -16],
        [49, -33],
        [4, -43],
        [9, -30],
        [27, -11],
        [18, -34],
        [35, -52],
        [72, -42],
        [24, -67],
        [32, -46],
        [49, -44],
        [26, -68],
        [63, -133],
        [50, -110],
        [8, -70],
        [14, -69],
        [44, -62],
        [43, -32],
        [12, -74],
        [55, -63],
        [10, -68],
        [-8, -64],
        [54, -79],
        [27, -175],
        [35, -33],
        [47, -51],
        [-11, -45],
        [37, -83],
        [-14, -29],
        [-10, -32],
        [58, -39],
        [8, -24],
        [-643, -499],
        [-407, -469],
        [-180, -221],
        [-23, -27],
        [-6, -16],
        [-16, -36],
        [40, -51],
        [58, -90],
        [9, -70],
        [0, -99],
        [-22, -71],
        [-67, -83],
        [-127, -194],
        [-3, -5],
        [-93, -143],
        [-96, -188],
        [-644, -1383],
        [-10, -65],
        [-52, -30],
        [-20, -31],
        [-372, -748],
        [-37, -77],
        [-206, -68],
        [-252, -121],
        [-339, -132],
        [-170, -71],
        [-322, -151],
        [-163, -66],
        [-145, -61],
        [-284, -91],
        [-340, -118],
        [-324, -96],
        [-28, -10],
        [-211, -71],
        [-66, -50],
        [-386, -326],
        [-181, -187],
        [-111, -50],
        [-78, -43],
        [-117, -71],
        [-235, -51],
        [-55, -13],
        [-100, -81],
        [-29, -12],
        [-123, -75],
        [-331, -210],
        [-141, -77],
        [-153, -117],
        [-366, -266],
        [-476, -322],
        [-108, -85],
        [-22, -2],
        [-76, 0],
        [-89, -59],
        [-67, -41],
        [-69, -47],
        [-83, -57],
        [-45, -41],
        [-100, -74],
        [-63, -60],
        [-34, -116],
        [-26, -28],
        [-66, -71],
        [-10, -11],
        [-78, -112],
        [-36, -63],
        [-75, -129],
        [-48, -197],
        [-43, -179],
        [-86, -237],
        [-74, -177],
        [-36, -100],
        [-114, -147],
        [-54, -53],
        [-79, -251],
        [-81, -200],
        [-26, -61],
        [-30, -67],
        [-23, -148],
        [13, -169],
        [-9, -90],
        [-67, -188],
        [-20, -109],
        [-14, -160],
        [-17, -117],
        [-61, -132],
        [-51, -234],
        [-34, -145],
        [-155, -384],
        [-127, -281],
        [-169, -438],
        [-179, -414],
        [-58, -137],
        [-121, -276],
        [-48, -63],
        [-91, -82],
        [-42, -40],
        [-9, -63],
        [15, -55],
        [-94, -283],
        [-217, -440],
        [-105, -188],
        [-25, -42],
        [-28, -73],
        [-14, -24],
        [-44, -10],
        [-23, -52],
        [-36, -99],
        [-76, -106],
        [-65, -60],
        [-60, -36],
        [-25, -79],
        [-91, -300],
        [-124, -285],
        [-41, -138],
        [-22, -73],
        [-22, -56],
        [-2, -11],
        [-14, -58],
        [-41, -111],
        [-54, -83],
        [-54, -98],
        [-82, -119],
        [-52, -100],
        [-36, -69],
        [-31, -167],
        [-39, -107],
        [-100, 12],
        [-164, -18],
        [-163, -63],
        [-14, -56],
        [43, -172],
        [25, -141],
        [45, -141],
        [9, -83],
        [-5, -34],
        [-16, -68],
        [4, -116],
        [12, -156],
        [-6, -51],
        [-11, -67],
        [38, -64],
        [62, -93],
        [176, -245],
        [59, -200],
        [24, -256],
        [13, -221],
        [-17, -282],
        [-32, -189],
        [-116, -248],
        [-81, -302],
        [-84, -187],
        [-12, -38],
        [-2, -2],
        [-6, -13],
        [-120, -133],
        [-1035, -1120],
        [-1392, -1520],
        [-1483, -1617],
        [-507, -556],
        [-1199, 2670],
        [-1622, -776],
        [-12, 12],
        [-12, 12],
        [-49, 51],
        [-79, 46],
        [-114, 30],
        [-63, -6],
        [-45, 37],
        [-69, 115],
        [-18, 43],
        [-14, 31],
        [35, 77],
        [12, 22],
        [19, 30],
        [-8, 38],
        [-52, 16],
        [-16, 46],
        [-15, 25],
        [-316, 139],
        [-91, 32],
        [-77, 67],
        [-37, 69],
        [-9, 17],
        [-55, 57],
        [-18, 45],
        [-4, 7],
        [-40, 98],
        [-133, 144],
        [-56, 18],
        [-34, 39],
        [-41, 21],
        [-49, 13],
        [-27, 38],
        [-73, 93],
        [-81, 26],
        [-79, -49],
        [-65, -20],
        [-37, 14],
        [-48, 19],
        [-45, 30],
        [-39, -13],
        [-51, -11],
        [-41, -31],
        [-56, -3],
        [-24, 63],
        [-4, 100],
        [-12, 41],
        [-22, 53],
        [-62, 60],
        [-21, 62],
        [-31, 35],
        [19, 42],
        [8, 68],
        [-79, -12],
        [-46, 20],
        [-23, 36],
        [-27, 61],
        [23, 70],
        [1, 31],
        [-1, 54],
        [-24, 59],
        [-34, 41],
        [-25, 86],
        [-32, 44],
        [-33, 28],
        [6, 49],
        [-53, 24],
        [-10, 46],
        [-2, 29],
        [4, 32],
        [-44, 59],
        [-62, 30],
        [-44, -33],
        [-62, -9],
        [-103, 43],
        [-22, 32],
        [-10, 8],
        [-15, 2],
        [-16, -4],
        [-15, 0],
        [-6, 0],
        [-12, 11],
        [-15, 14],
        [-15, 8],
        [-14, 8],
        [-16, 2],
        [-18, 8],
        [-4, 4],
        [0, 11],
        [0, 24],
        [-6, 17],
        [-5, 14],
        [-5, 18],
        [-6, 16],
        [-18, 19],
        [-16, 21],
        [-10, 23],
        [-18, 15],
        [-14, 12],
        [-11, 20],
        [0, 16],
        [5, 10],
        [8, 8],
        [6, 12],
        [6, 17],
        [2, 25],
        [8, 20],
        [10, 11],
        [20, 9],
        [17, 11],
        [14, 12],
        [25, 14],
        [16, 8],
        [12, 8],
        [17, 12],
        [10, 6],
        [12, 8],
        [7, 8],
        [4, 6],
        [-6, 9],
        [-6, 11],
        [-20, 15],
        [-16, 10],
        [-24, 11],
        [-24, 10],
        [-16, 3],
        [-8, 5],
        [-20, 3],
        [-14, 14],
        [-20, 12],
        [-12, 4],
        [-9, 2],
        [-27, 4],
        [-8, 7],
        [-19, 15],
        [-12, 8],
        [-24, 17],
        [-8, 2],
        [-18, 4],
        [-13, 0],
        [-7, 6],
        [-10, 23],
        [-6, 15],
        [-4, 17],
        [0, 8],
        [10, 12],
        [12, 7],
        [23, 11],
        [2, 6],
        [0, 5],
        [-5, 13],
        [-8, 12],
        [-1, 8],
        [-5, 3],
        [-16, 2],
        [-14, -7],
        [-14, -5],
        [-8, 1],
        [-12, 11],
        [-16, 20],
        [-4, 15],
        [-13, 16],
        [-8, 8],
        [-12, 24],
        [-6, 15],
        [-6, 8],
        [-14, 11],
        [-10, 5],
        [-7, 23],
        [1, 13],
        [2, 11],
        [0, 13],
        [-4, 14],
        [-11, 16],
        [-14, 16],
        [-14, 23],
        [-16, 19],
        [-10, 17],
        [-5, 13],
        [-9, 16],
        [3, 10],
        [13, 16],
        [12, 12],
        [10, 10],
        [4, 13],
        [2, 9],
        [-4, 11],
        [-5, 9],
        [-10, 11],
        [-6, 4],
        [-12, 7],
        [-60, 13],
        [-22, 5],
        [-16, 4],
        [-10, -5],
        [-5, -5],
        [-7, -2],
        [-8, 5],
        [-12, 7],
        [-12, 6],
        [-23, 2],
        [-29, 0],
        [-17, 1],
        [-16, 0],
        [-12, 4],
        [-14, 6],
        [-7, 8],
        [-6, 8],
        [8, 14],
        [9, 6],
        [2, 2],
        [2, 6],
        [-6, 8],
        [-11, 12],
        [-11, 6],
        [-22, 11],
        [-24, 11],
        [-12, 2],
        [-15, 4],
        [-23, -3],
        [-8, 0],
        [-13, 8],
        [-16, 14],
        [-8, 5],
        [-12, 2],
        [-8, 0],
        [-8, -1],
        [-4, 7],
        [-13, 19],
        [-8, 16],
        [0, 14],
        [4, 12],
        [-4, 16],
        [-12, 9],
        [-17, -6],
        [-13, -5],
        [-5, -12],
        [-10, -6],
        [-10, -2],
        [-8, 0],
        [-4, 2],
        [-8, 8],
        [-7, 10],
        [-2, 7],
        [-4, 17],
        [-2, 15],
        [4, 15],
        [17, 21],
        [10, 13],
        [4, 10],
        [4, 8],
        [2, 4],
        [0, 5],
        [-2, 6],
        [0, 11],
        [-4, 6],
        [-4, 10],
        [-4, 0],
        [-5, -3],
        [-8, -6],
        [-6, -8],
        [-6, -3],
        [-14, 11],
        [-10, 5],
        [-12, 11],
        [-10, 4],
        [-12, 11],
        [-11, 16],
        [-43, 38],
        [-27, 16],
        [-80, 101],
        [-33, 34],
        [-141, 148],
        [-35, 43],
        [-15, 17],
        [-90, 113],
        [-75, 88],
        [-53, 61],
        [-27, 27],
        [-65, 61],
        [-65, 72],
        [-36, 32],
        [-58, 72],
        [-40, 43],
        [-40, 41],
        [-6, 7],
        [-13, 26],
        [-18, 24],
        [-10, 12],
        [-9, 14],
        [-18, 21],
        [-19, 24],
        [-28, 17],
        [-31, 21],
        [-35, 10],
        [-23, 8],
        [-20, 12],
        [-31, 16],
        [-22, 18],
        [-31, 9],
        [-13, 13],
        [-21, 15],
        [-8, 13],
        [-18, 6],
        [-33, 26],
        [-13, 30],
        [-6, 27],
        [-6, 24],
        [-4, 27],
        [-4, 22],
        [0, 16],
        [-4, 16],
        [-4, 10],
        [-8, 29],
        [-10, 35],
        [-8, 43],
        [-7, 40],
        [-2, 34],
        [-3, 17],
        [1, 35],
        [2, 36],
        [-1, 48],
        [-8, 12],
        [-15, 19],
        [-6, 16],
        [-13, 14],
        [-6, 16],
        [-3, 16],
        [0, 8],
        [0, 8],
        [-4, 14],
        [-12, 11],
        [-14, 7],
        [-17, 3],
        [-16, 8],
        [-3, 6],
        [-9, 23],
        [-5, 15],
        [-3, 10],
        [-10, 15],
        [-11, 7],
        [-6, 6],
        [-22, 4],
        [-13, 2],
        [-18, 4],
        [-13, 0],
        [-6, -4],
        [-13, -12],
        [-6, -13],
        [-12, -10],
        [-4, -3],
        [-8, -5],
        [-34, 9],
        [-36, 17],
        [-20, 13],
        [-25, 14],
        [-16, 8],
        [-9, 4],
        [-17, 4],
        [-23, 0],
        [-20, 0],
        [-12, 2],
        [-20, 18],
        [-8, 22],
        [-3, 19],
        [-9, 13],
        [-2, 8],
        [-8, 15],
        [-18, 1],
        [-16, -3],
        [-20, -2],
        [-25, 4],
        [-21, 14],
        [-31, 28],
        [-49, 69],
        [-52, 48],
        [-25, 32],
        [-17, 18],
        [-11, 23],
        [-6, 21],
        [-5, 23],
        [-10, 26],
        [1, 24],
        [-5, 24],
        [1, 18],
        [-5, 9],
        [-14, 7],
        [-7, 2],
        [-7, 1],
        [-12, 11],
        [-2, 9],
        [0, 10],
        [4, 7],
        [6, 10],
        [6, 8],
        [0, 11],
        [-2, 20],
        [-8, 22],
        [-18, 12],
        [-13, 21],
        [-16, 26],
        [-25, 34],
        [-35, 34],
        [-41, 29],
        [-56, 40],
        [-20, 22],
        [-26, 2],
        [-9, 16],
        [-24, 6],
        [-4, 0],
        [-25, 7],
        [-15, 8],
        [-16, 4],
        [-23, 6],
        [-16, 0],
        [-33, 0],
        [-14, -6],
        [-22, -35],
        [-11, 0],
        [-12, 14],
        [-3, 13],
        [-1, 8],
        [-7, 14],
        [-2, 4],
        [-12, 4],
        [-19, 0],
        [-24, -8],
        [-24, -10],
        [-24, -14],
        [-26, -23],
        [-16, -10],
        [-12, -5],
        [-17, -4],
        [-28, -3],
        [-16, 7],
        [-28, 9],
        [-6, 8],
        [0, 12],
        [2, 15],
        [-6, 18],
        [-13, 12],
        [-12, 16],
        [-8, 5],
        [-3, 11],
        [1, 14],
        [8, 17],
        [18, 13],
        [25, 10],
        [24, 20],
        [2, 6],
        [5, 4],
        [-23, 8],
        [-32, 4],
        [-19, 4],
        [-32, 9],
        [-26, 10],
        [-12, 12],
        [-21, 15],
        [-15, 23],
        [-64, 87],
        [-42, 61],
        [-53, 62],
        [-19, 28],
        [-92, 97],
        [-24, 42],
        [-33, 32],
        [-25, 31],
        [-27, 34],
        [-31, 22],
        [-24, 17],
        [-26, 22],
        [-15, 30],
        [0, 1],
        [-30, 30],
        [-11, 9],
        [-491, -268],
        [-321, -174],
        [-486, 291],
        [-500, 161],
        [-887, 800],
        [-207, -46],
        [-275, 118],
        [-632, 190],
        [-2647, -191],
        [-182, -35],
        [-97, -150],
        [-147, 31],
        [1, 83],
        [1, 49],
        [-100, 30],
        [-268, -14],
        [-75, -60],
        [-61, -5],
        [-57, 21],
        [-62, -13],
        [-13, 9],
        [-78, -44],
        [-196, 253],
        [-38, -46],
        [-98, -114],
        [-1426, 297],
        [-596, -301],
        [-599, -778],
        [-867, -423],
        [-276, -253],
        [-65, -155],
        [-157, -134],
        [85, -228],
        [-115, 23],
        [-16, -35],
        [-11, -24],
        [-8, -23],
        [-6, -11],
        [-8, -12],
        [-8, -23],
        [-2, -18],
        [0, -34],
        [-4, -12],
        [-6, -2],
        [-4, -6],
        [-6, 4],
        [-5, 6],
        [-10, 10],
        [-7, 2],
        [-12, 6],
        [-10, 0],
        [-15, -2],
        [-25, -12],
        [-28, -36],
        [-8, -26],
        [-5, -13],
        [-7, -31],
        [-23, -35],
        [-8, -18],
        [-2, -22],
        [4, -13],
        [6, -8],
        [4, -21],
        [10, -15],
        [4, -14],
        [-4, -11],
        [2, -23],
        [4, -17],
        [5, -9],
        [8, -8],
        [-4, -8],
        [-6, -11],
        [-10, -8],
        [-15, -3],
        [-3, -1],
        [-15, 3],
        [-14, 6],
        [-20, 7],
        [-20, 0],
        [-26, -3],
        [-34, -9],
        [-16, -2],
        [-39, 0],
        [-18, 4],
        [-8, 5],
        [-6, 9],
        [-12, 9],
        [-18, 3],
        [-15, 3],
        [-15, 2],
        [-16, 5],
        [-16, 8],
        [-19, 12],
        [-21, 15],
        [-12, 6],
        [-25, 5],
        [-15, 0],
        [-20, 5],
        [-22, 6],
        [-25, 15],
        [-24, 13],
        [-26, 5],
        [-24, 5],
        [-22, 3],
        [-9, 0],
        [-25, 7],
        [-14, 3],
        [-18, 11],
        [-10, 5],
        [-18, 5],
        [-15, 4],
        [-16, 7],
        [-9, 8],
        [-21, 12],
        [-4, 8],
        [-8, 22],
        [-14, 18],
        [-8, 15],
        [-10, 11],
        [-5, 6],
        [-11, 8],
        [-13, 5],
        [-13, -3],
        [-4, -10],
        [-6, -10],
        [-5, -13],
        [-11, -17],
        [-10, -13],
        [-12, -7],
        [-12, -3],
        [-16, 0],
        [-17, 10],
        [-16, 15],
        [-14, 14],
        [-39, 29],
        [-26, 4],
        [-28, 30],
        [-12, 4],
        [-7, -6],
        [-15, -4],
        [-8, -2],
        [-17, 0],
        [-8, 14],
        [-17, 14],
        [-8, 12],
        [-17, 0],
        [-18, -12],
        [-8, -14],
        [-2, -10],
        [-2, -10],
        [-2, -12],
        [-8, -13],
        [-4, -11],
        [-16, -14],
        [-5, -9],
        [-12, -8],
        [-14, -9],
        [-15, -11],
        [-20, -8],
        [-11, -8],
        [-16, -10],
        [-15, -38],
        [-25, -58],
        [-24, -42],
        [-16, -25],
        [-24, -33],
        [-40, -35],
        [-27, -15],
        [-30, -22],
        [-33, -10],
        [-15, -8],
        [-10, -6],
        [-4, -6],
        [-8, -15],
        [1, -6],
        [2, -10],
        [9, -20],
        [28, -17],
        [19, -19],
        [23, -20],
        [17, -12],
        [13, -8],
        [13, -8],
        [13, -15],
        [39, -32],
        [16, -24],
        [10, -12],
        [18, -6],
        [10, -9],
        [13, -5],
        [16, -5],
        [11, -4],
        [21, 5],
        [12, 8],
        [18, 23],
        [33, 17],
        [41, 34],
        [16, 0],
        [24, 19],
        [24, 10],
        [23, 10],
        [26, 4],
        [17, 2],
        [9, 0],
        [9, -2],
        [70, 2],
        [85, -18],
        [48, -29],
        [54, -53],
        [36, -44],
        [-105, -141],
        [-31, -91],
        [14, -17],
        [14, -26],
        [26, -35],
        [16, -66],
        [-14, -94],
        [-100, -49],
        [-82, -59],
        [-8, -6],
        [-6, -8],
        [-7, -15],
        [0, -52],
        [-9, -25],
        [-5, -31],
        [-10, -18],
        [-8, -14],
        [-17, -19],
        [-12, -11],
        [-17, -5],
        [-10, -8],
        [-17, -9],
        [-28, -12],
        [-12, -13],
        [6, -22],
        [3, -16],
        [2, -16],
        [-3, -9],
        [-4, -25],
        [-21, -7],
        [-22, 0],
        [-25, 25],
        [-4, 26],
        [-6, 10],
        [-4, 7],
        [-8, 7],
        [-6, 4],
        [-13, 9],
        [-29, -1],
        [-19, -15],
        [-19, -23],
        [5, -18],
        [20, -23],
        [27, -6],
        [3, -11],
        [-3, -11],
        [-6, -12],
        [-6, -19],
        [-23, -5],
        [-30, 5],
        [-23, 15],
        [-18, 5],
        [-14, 9],
        [-15, 9],
        [-15, 9],
        [-12, 11],
        [-10, 16],
        [-29, 38],
        [-18, 21],
        [-25, 30],
        [-33, 28],
        [-34, 20],
        [-20, 12],
        [-10, 8],
        [-24, 12],
        [-19, 4],
        [-25, 16],
        [-22, 20],
        [-18, 9],
        [-25, 4],
        [-43, 11],
        [-16, 8],
        [-38, -4],
        [-17, -5],
        [-30, -1],
        [-37, -3],
        [-24, -6],
        [-18, -1],
        [-31, 0],
        [-34, 1],
        [-21, -6],
        [-29, -15],
        [-25, -14],
        [-36, -18],
        [-14, -44],
        [-14, -11],
        [-26, -9],
        [-24, 62],
        [-10, 18],
        [-4, 40],
        [-4, 26],
        [4, 25],
        [6, 7],
        [8, 15],
        [7, 4],
        [-4, 12],
        [-7, 10],
        [-22, -4],
        [-8, 10],
        [-15, -2],
        [-26, -4],
        [-31, -33],
        [-20, -9],
        [-21, -17],
        [-30, -34],
        [-28, -14],
        [-25, -14],
        [-17, -8],
        [-20, -14],
        [-26, -4],
        [-32, -4],
        [-18, 0],
        [-49, 2],
        [-14, 6],
        [-16, 2],
        [-7, 6],
        [-13, 12],
        [-6, 23],
        [1, 17],
        [-2, 16],
        [-8, 15],
        [-28, 26],
        [-21, 10],
        [-24, 14],
        [-29, 14],
        [-18, 12],
        [-22, 24],
        [-34, 41],
        [-32, 34],
        [-16, 16],
        [-34, 9],
        [-15, 3],
        [-28, 1],
        [-14, -12],
        [-8, -6],
        [-8, -9],
        [-7, -12],
        [-24, 1],
        [-24, 5],
        [-25, 0],
        [-18, -3],
        [-24, -6],
        [-17, -11],
        [-41, -4],
        [-17, -5],
        [-21, -1],
        [-14, 0],
        [-12, 5],
        [-8, 1],
        [-8, 0],
        [-13, -4],
        [-12, -7],
        [-14, -10],
        [-7, -9],
        [-16, -8],
        [-15, -2],
        [-6, -2],
        [-8, -3],
        [-12, -14],
        [-3, -3],
        [-2, -17],
        [-7, -16],
        [-5, -10],
        [-4, -2],
        [-9, -8],
        [-4, -2],
        [-18, -6],
        [-14, 4],
        [-6, 6],
        [-2, 14],
        [-2, 14],
        [4, 12],
        [4, 6],
        [0, 15],
        [-4, 1],
        [-6, 1],
        [-10, -8],
        [0, -6],
        [-2, -13],
        [0, -6],
        [0, -6],
        [-6, -4],
        [-9, -28],
        [-88, -161],
        [-73, -81],
        [-133, -119],
        [-49, -16],
        [-73, -21],
        [-85, 40],
        [-53, 7],
        [-49, -18],
        [-31, -35],
        [-19, -39],
        [-33, -10],
        [-13, -21],
        [-19, -34],
        [-21, -4],
        [-140, 138],
        [6, -83],
        [-14, -8],
        [-17, -41],
        [-59, -63],
        [-80, -48],
        [-164, -27],
        [-19, -55],
        [-87, -70],
        [-115, -43],
        [-20, -108],
        [-176, -211],
        [-76, 45],
        [-4, 0],
        [-62, 7],
        [-72, -66],
        [-30, -47],
        [-13, -67],
        [-55, -29],
        [-30, -15],
        [-85, 59],
        [-95, 26],
        [-113, 8],
        [-76, -32],
        [-104, -77],
        [-187, -68],
        [-131, -8],
        [-66, -24],
        [-50, -44],
        [-105, -155],
        [-55, -21],
        [-168, 28],
        [-37, -115],
        [-36, -219],
        [-49, -78],
        [-102, -95],
        [-26, -190],
      ],
      [
        [367187, 195725],
        [29, -20],
        [5, -3],
        [30, -24],
        [24, -24],
        [14, -22],
        [21, -36],
        [66, -157],
        [36, -109],
        [10, -26],
        [12, -19],
        [17, -37],
        [55, -99],
        [35, -85],
        [8, -17],
        [9, -10],
        [2, -12],
        [6, -8],
        [6, -8],
        [6, -7],
        [2, -10],
        [13, -12],
        [6, -24],
        [3, -22],
        [3, -9],
        [2, -16],
        [8, -27],
        [7, -18],
        [7, -10],
        [11, -11],
        [2, -6],
        [1, -6],
        [-7, -10],
        [-6, -12],
        [-4, -26],
        [8, -11],
        [0, -14],
        [0, -15],
        [1, -12],
        [3, -10],
        [2, -5],
        [0, -6],
        [-2, -15],
        [2, -11],
        [6, -11],
        [-1, -13],
        [1, -9],
        [-3, -10],
        [1, -14],
        [0, -9],
        [0, -11],
        [-2, -13],
        [-2, -13],
        [0, -10],
        [4, -5],
        [4, -6],
        [8, -6],
        [8, -10],
        [6, -8],
        [4, -16],
        [6, -19],
        [9, -16],
        [28, -22],
        [19, -37],
        [7, -67],
        [0, -14],
        [6, -10],
        [30, -17],
        [29, -12],
        [7, -3],
        [15, -4],
        [21, -11],
        [44, -27],
        [36, -28],
        [62, -51],
        [57, -46],
        [22, -15],
        [15, -6],
        [18, -2],
        [28, 2],
        [29, 2],
        [69, 30],
        [30, 12],
        [15, 18],
        [20, 22],
        [16, 10],
        [26, 4],
        [39, -4],
        [90, -26],
        [39, -12],
        [60, -27],
        [83, -37],
        [62, -35],
        [48, -20],
        [65, -23],
        [53, -25],
        [34, -14],
        [49, -22],
        [23, -16],
        [20, -2],
        [24, 6],
        [48, 6],
        [58, 6],
        [54, -2],
        [5, 0],
        [12, -8],
        [10, -6],
        [10, -16],
        [23, -42],
        [19, -37],
        [13, -16],
        [16, -16],
        [12, -16],
        [6, -9],
        [14, -23],
        [19, -80],
        [12, -23],
        [9, -22],
        [17, -30],
        [63, -84],
        [17, -28],
        [18, -31],
        [11, -21],
        [2, -32],
        [7, -12],
        [7, -8],
        [16, -6],
        [51, -4],
        [33, -2],
        [20, -2],
        [21, -8],
        [11, -8],
        [9, -15],
        [7, -12],
        [0, -13],
        [-2, -18],
        [-46, -67],
        [-8, -18],
        [0, -15],
        [4, -10],
        [9, -13],
        [20, -19],
        [17, -12],
        [29, -13],
        [54, -10],
        [61, -14],
        [26, -8],
        [14, -4],
        [38, -14],
        [24, -14],
        [12, -11],
        [12, -15],
        [15, -31],
        [14, -40],
        [8, -26],
        [2, -24],
        [-2, -16],
        [-6, -19],
        [-2, -20],
        [4, -12],
        [12, -13],
        [24, -10],
        [106, -17],
        [26, -8],
        [33, -14],
        [69, -37],
        [30, -21],
        [37, -27],
        [118, -93],
        [26, -39],
        [20, -17],
        [47, -16],
        [29, -6],
        [22, -4],
        [18, -4],
        [16, -10],
        [19, -14],
        [29, -38],
        [13, -23],
        [17, -39],
        [6, -21],
        [4, -26],
        [0, -40],
        [4, -54],
        [4, -26],
        [8, -21],
        [4, -20],
        [0, -17],
        [-4, -18],
        [-24, -34],
        [-13, -19],
        [-9, -18],
        [-7, -18],
        [-15, -84],
        [0, -1],
        [-7, -44],
        [-5, -38],
        [1, -23],
        [3, -17],
        [7, -15],
        [7, -9],
        [21, -23],
        [27, -25],
        [30, -42],
        [3, -4],
        [26, -43],
        [20, -39],
        [8, -28],
        [10, -35],
        [8, -31],
        [-2, -41],
        [0, -22],
        [4, -18],
        [4, -13],
        [9, -23],
        [59, -108],
        [28, -57],
        [52, -70],
        [37, -46],
        [29, -26],
        [20, -14],
        [53, -52],
        [34, -41],
        [24, -24],
        [3, -3],
        [18, -22],
        [20, -17],
        [17, -14],
        [31, -29],
        [23, -23],
        [18, -16],
        [22, -25],
        [12, -23],
        [4, -22],
        [-2, -48],
        [2, -18],
        [4, -18],
        [13, -14],
        [11, -8],
        [14, -7],
        [16, 0],
        [19, 1],
        [14, 14],
        [26, 37],
        [10, 10],
        [9, 3],
        [7, -3],
        [13, -6],
        [21, -15],
        [64, -57],
        [38, -44],
        [48, -56],
        [90, -31],
        [117, 3],
        [157, 92],
        [36, 28],
        [23, 12],
        [19, 6],
        [16, 0],
        [15, -2],
        [14, -6],
        [14, -10],
        [12, -14],
        [9, -16],
        [9, -14],
        [47, -65],
        [38, -42],
        [11, -20],
        [8, -24],
        [5, -19],
        [8, -9],
        [29, -18],
        [9, -3],
        [18, -4],
        [31, -11],
        [14, -5],
        [49, -14],
        [46, -20],
        [38, -14],
        [23, -6],
        [21, -7],
        [16, -8],
        [5, -10],
        [0, -2],
        [1, -28],
        [-1, -34],
        [-3, -24],
        [-6, -20],
        [0, 0],
        [-12, -31],
        [-8, -38],
        [2, -33],
        [6, -23],
        [23, -50],
        [24, -30],
        [26, -30],
        [36, -27],
        [29, -22],
        [31, -25],
        [26, -28],
        [40, -40],
        [39, -33],
        [43, -40],
        [45, -35],
        [42, -29],
        [69, -46],
        [6, -4],
        [30, -21],
        [37, -30],
        [28, -26],
        [6, -17],
        [-1, -25],
        [-7, -26],
        [-13, -34],
        [-6, -25],
        [3, -18],
        [11, -15],
        [18, -16],
        [10, -6],
        [21, 1],
        [22, 5],
        [35, 15],
        [36, 19],
        [39, 13],
        [19, 4],
        [18, 3],
        [18, 0],
        [24, -5],
        [66, -19],
        [25, -8],
        [29, -6],
        [18, -8],
        [14, -11],
        [11, -15],
        [47, -81],
        [23, -46],
        [25, -64],
        [9, -34],
        [11, -49],
        [6, -16],
        [8, -16],
        [16, -14],
        [18, -9],
        [4, -2],
        [16, -7],
        [20, -8],
        [20, -17],
        [14, -9],
        [12, -14],
        [10, -20],
        [8, -19],
        [10, -19],
        [4, -14],
        [4, -32],
        [0, -4],
        [7, -72],
        [-1, -65],
        [-5, -18],
        [-11, -18],
        [-16, -18],
        [-12, -16],
        [-4, -8],
        [-8, -24],
        [-1, -24],
        [7, -21],
        [8, -11],
        [16, -17],
        [2, -3],
        [8, -9],
        [23, -18],
        [44, -29],
        [9, -12],
        [6, -14],
        [8, -16],
        [6, -12],
        [2, -45],
        [-8, -34],
        [-4, -16],
        [0, -24],
        [4, -13],
        [10, -18],
        [7, -11],
        [2, -10],
        [-2, -22],
        [-7, -12],
        [-10, -15],
        [-20, -18],
        [-15, -20],
        [-6, -14],
        [-1, -15],
        [4, -13],
        [7, -8],
        [13, -9],
        [22, -11],
        [40, -16],
        [27, -12],
        [32, -24],
        [46, -32],
        [10, -14],
        [6, -13],
        [2, -17],
        [-1, -43],
        [-7, -23],
        [-2, -8],
        [6, -8],
        [14, -10],
        [22, -14],
        [38, -12],
        [10, -7],
        [3, -8],
        [0, -11],
        [-4, -10],
        [-7, -11],
        [-16, -9],
        [-24, -9],
        [-20, -10],
        [-13, -12],
        [-12, -14],
        [-5, -6],
        [-3, -8],
        [1, -6],
        [7, -14],
        [27, -22],
        [47, -34],
        [32, -14],
        [62, -37],
        [31, -16],
        [35, -23],
        [21, -16],
        [31, -9],
        [19, -8],
        [22, -13],
        [22, -15],
        [19, -21],
        [4, -3],
        [33, -37],
        [17, -37],
        [14, -20],
        [8, -14],
        [23, -20],
        [14, -16],
        [13, -17],
        [12, -20],
        [13, -20],
        [15, -14],
        [27, -19],
        [60, -39],
        [1, 0],
        [24, -22],
        [18, -14],
        [12, -12],
        [10, -18],
        [10, -24],
        [13, -38],
        [17, -46],
        [11, -60],
        [0, -21],
        [-1, -30],
        [-6, -18],
        [-4, -10],
        [-3, -14],
        [0, -8],
        [7, -17],
        [9, -5],
        [23, -11],
        [37, 1],
        [2, 0],
        [48, -5],
        [35, -10],
        [34, -17],
        [62, -57],
        [26, -32],
        [8, -10],
        [11, -13],
        [36, -32],
        [20, -36],
        [8, -33],
        [4, -14],
        [0, -3],
        [6, -23],
        [2, -5],
        [2, -7],
        [13, -54],
        [14, -52],
        [28, -73],
        [19, -62],
        [24, -49],
        [2, -6],
        [4, -9],
        [8, -13],
        [31, -61],
        [74, -137],
        [20, -56],
        [1, -4],
        [5, -16],
        [4, -57],
        [4, -61],
        [16, -123],
        [20, -56],
        [31, -50],
        [33, -88],
        [23, -57],
        [66, -64],
        [6, -7],
        [52, -52],
        [46, -53],
        [5, -6],
        [49, -48],
        [26, -34],
        [65, -66],
        [108, -184],
        [92, -158],
        [27, -64],
        [39, -64],
        [55, -81],
        [35, -52],
        [46, -41],
        [39, -26],
        [72, -24],
        [34, -8],
        [33, -8],
        [32, -5],
        [32, -16],
        [41, -20],
        [51, -16],
        [47, -13],
        [19, -5],
        [27, -4],
        [16, -3],
        [12, 0],
        [19, 3],
        [16, 6],
        [42, 15],
        [101, 102],
        [155, 107],
        [31, 11],
        [51, 4],
        [35, -3],
        [44, -14],
        [48, -21],
        [49, -37],
        [52, -45],
        [88, -97],
        [20, -36],
        [5, -16],
        [6, -26],
        [2, -45],
        [-8, -29],
        [-21, -29],
        [-12, -14],
        [-12, -12],
        [-10, -13],
        [-5, -11],
        [-5, -8],
        [-1, -13],
        [2, -40],
        [5, -20],
        [10, -46],
        [47, -80],
        [47, -53],
        [40, -48],
        [37, -32],
        [33, -15],
        [54, -35],
        [34, -20],
        [33, -22],
        [45, -28],
        [33, -22],
        [26, -15],
        [28, -19],
        [26, -14],
        [4, 0],
        [8, -2],
        [11, -2],
        [18, -4],
        [2, -2],
        [22, -4],
        [4, 0],
        [45, 0],
        [49, -2],
        [11, 0],
        [17, -4],
        [24, -8],
        [19, -8],
        [17, -15],
        [22, -21],
        [30, -25],
        [35, -23],
        [35, -10],
        [21, -2],
        [58, 21],
        [30, 10],
        [30, -2],
        [58, -13],
        [4, 0],
        [2, -2],
        [37, -12],
        [24, -17],
        [19, -20],
        [9, -34],
        [16, -25],
        [10, -29],
        [24, -38],
        [40, -37],
        [48, -50],
        [20, -29],
        [11, -26],
        [12, -27],
        [17, -25],
        [29, -18],
        [27, -6],
        [71, -16],
        [32, -13],
        [110, -105],
        [43, -43],
        [46, -58],
        [29, -15],
        [49, -5],
        [107, -12],
        [35, -6],
        [21, -7],
        [27, -11],
        [28, -17],
        [21, -17],
        [46, -19],
        [34, -10],
        [38, -2],
        [51, 4],
        [78, -2],
        [46, 4],
        [22, -2],
        [15, -4],
        [41, -11],
        [131, -57],
        [112, -62],
        [78, -45],
        [69, -45],
        [66, -43],
        [44, -44],
        [26, -52],
        [12, -58],
        [2, -63],
        [2, -58],
        [-4, -59],
        [-4, -21],
        [-6, -38],
        [1, -29],
        [3, -20],
        [18, -40],
        [21, -43],
        [23, -30],
        [29, -31],
        [36, -36],
        [31, -26],
        [39, -30],
        [37, -14],
        [38, -14],
        [41, -10],
        [46, -8],
        [72, -18],
        [41, -8],
        [48, -24],
        [6, -5],
        [38, -27],
        [37, -35],
        [108, -107],
        [22, -20],
        [14, -14],
        [18, -15],
        [81, -58],
        [26, -21],
        [25, -16],
        [21, -8],
        [10, -2],
        [6, -1],
        [7, 0],
        [17, 6],
        [11, 5],
        [17, 9],
        [17, 15],
        [33, 23],
        [46, 35],
        [21, 15],
        [19, 8],
        [10, 3],
        [12, 0],
        [10, -3],
        [29, -16],
        [13, -15],
        [26, -29],
        [14, -23],
        [24, -42],
        [11, -24],
        [4, -22],
        [6, -17],
        [31, -50],
        [15, -26],
        [11, -11],
        [16, -4],
        [26, -2],
        [59, 2],
        [67, -2],
        [54, -4],
        [44, -8],
        [92, -23],
        [33, -10],
        [70, -26],
        [55, -18],
        [35, -30],
        [27, -31],
        [27, -46],
        [4, -18],
        [6, -23],
        [7, -28],
        [4, -24],
        [-2, -39],
        [-5, -35],
        [-11, -34],
        [-15, -15],
        [-44, -18],
        [-49, -10],
        [-33, -6],
        [-39, -4],
        [-36, 2],
        [-30, 8],
        [-22, 8],
        [-17, 10],
        [-15, 18],
        [-14, 18],
        [-7, 22],
        [-13, 25],
        [-14, 16],
        [-20, 10],
        [-39, 10],
        [-38, -2],
        [-17, -8],
        [-20, -10],
        [-19, -23],
        [-13, -17],
        [-6, -25],
        [-3, -74],
        [2, -30],
        [5, -22],
        [5, -16],
        [29, -106],
        [8, -33],
        [10, -32],
        [2, -22],
        [-4, -24],
        [-8, -11],
        [-8, -10],
        [-12, -7],
        [-20, -10],
        [-75, -9],
        [-1, 0],
        [-27, -2],
        [-36, -7],
        [-32, -12],
        [-28, -15],
        [-38, -27],
        [-24, -26],
        [-30, -39],
        [-11, -18],
        [0, -21],
        [3, -15],
        [13, -21],
        [15, -15],
        [55, -53],
        [33, -28],
        [38, -30],
        [46, -38],
        [37, -28],
        [28, -36],
        [17, -28],
        [14, -28],
        [5, -22],
        [4, -14],
        [2, -24],
        [-14, -20],
        [-27, -18],
        [-81, -23],
        [-19, -5],
        [-2, 0],
        [-32, -9],
        [-80, -26],
        [-58, -28],
        [-45, -34],
        [-37, -41],
        [-29, -33],
        [-20, -24],
        [-36, -42],
        [-15, -23],
        [-14, -24],
        [-11, -15],
        [-10, -12],
        [2, -14],
        [7, -12],
        [6, -10],
        [15, -8],
        [23, -10],
        [31, -6],
        [58, -1],
        [45, -9],
        [49, -12],
        [45, -11],
        [27, -11],
        [1, -1],
        [1, 0],
        [11, -4],
        [46, -16],
        [85, -38],
        [14, -8],
        [10, -6],
        [17, -16],
        [40, -44],
        [29, -43],
        [16, -32],
        [9, -24],
        [31, -51],
        [34, -52],
        [4, -15],
        [2, -5],
        [0, -17],
        [-4, -13],
        [-11, -15],
        [-12, -10],
        [-32, -4],
        [-53, 2],
        [-34, 0],
        [-26, -7],
        [-22, -10],
        [-16, -8],
        [-48, -21],
        [-6, -2],
        [-10, -4],
        [-15, -8],
        [-25, -19],
        [-25, -24],
        [-18, -18],
        [-14, -23],
        [-18, -37],
        [-18, -36],
        [-5, -18],
        [-4, -21],
        [-2, -84],
        [2, -46],
        [4, -12],
        [79, -120],
        [42, -79],
        [17, -22],
        [41, -62],
        [43, -68],
        [63, -78],
        [50, -47],
        [13, -18],
        [35, -37],
        [33, -38],
        [28, -29],
        [69, -42],
        [9, -4],
        [44, -38],
        [50, -38],
        [37, -39],
        [4, -4],
        [45, -34],
        [66, -45],
        [59, -52],
        [50, -38],
        [140, -88],
        [57, -21],
        [36, -22],
        [30, -16],
        [9, -7],
        [53, -42],
        [39, -43],
        [36, -37],
        [30, -38],
        [59, -65],
        [51, -45],
        [15, -14],
        [9, -9],
        [13, -11],
        [22, -23],
        [8, -6],
        [11, -11],
        [38, -36],
        [1, -1],
        [2, -2],
        [19, -30],
        [12, -14],
        [14, -16],
        [33, -34],
        [10, -9],
        [25, -27],
        [25, -21],
        [16, -14],
        [2, -2],
        [0, -2],
        [4, -12],
        [2, -12],
        [2, -36],
        [-4, -27],
        [-10, -33],
        [-21, -31],
        [-15, -19],
        [-29, -13],
        [-3, -2],
        [-2, 0],
        [-2, -4],
        [-18, -12],
        [-19, -22],
        [-8, -16],
        [0, -18],
        [12, -36],
        [23, -29],
        [27, -27],
        [2, -1],
        [0, -1],
        [3, -1],
        [7, -5],
        [7, -4],
        [12, -8],
        [23, -11],
        [1, -1],
        [33, -20],
        [25, -21],
        [10, -19],
        [5, -36],
        [1, -33],
        [-5, -33],
        [-9, -34],
        [-29, -64],
        [-12, -27],
        [0, -22],
        [0, -25],
        [8, -29],
        [20, -43],
        [54, -90],
        [0, -14],
        [-13, -38],
        [-17, -19],
        [-11, -9],
        [-22, -17],
        [-44, -29],
        [-35, -18],
        [-36, -17],
        [-26, -14],
        [-18, -17],
        [-47, -54],
        [-15, -19],
        [-19, -29],
        [-36, -105],
        [-43, -134],
        [-9, -25],
        [-12, -91],
        [-6, -35],
        [-14, -33],
        [-15, -35],
        [-18, -58],
        [-4, -47],
        [-5, -16],
        [-11, -10],
        [-5, -8],
        [-8, -4],
        [-11, 0],
        [-46, 6],
        [-33, 0],
        [-65, -2],
        [-75, -10],
        [-34, -12],
        [-29, -17],
        [-26, -25],
        [-26, -40],
        [-17, -30],
        [-9, -21],
        [-5, -38],
        [2, -20],
        [6, -24],
        [0, -6],
        [4, -24],
        [15, -25],
        [2, -8],
        [0, -9],
        [-7, -11],
        [-23, -30],
        [9, -10],
        [160, -146],
        [2125, -1949],
        [4, -3],
        [3681, -3383],
        [1507, -1383],
        [2553, -2348],
        [14, -10],
        [11, -6],
        [10, -5],
        [6, -4],
        [6, -3],
        [3, -1],
        [2, -2],
        [3, -1],
        [2, -1],
        [2, -1],
        [2, -1],
        [2, -1],
        [3, -1],
        [2, -2],
        [2, -2],
        [2, -1],
        [3, -4],
        [3, -2],
        [2, -2],
        [2, -3],
        [3, -2],
        [2, -4],
        [3, -2],
        [3, -3],
        [2, -2],
        [3, -4],
        [3, -2],
        [2, -3],
        [3, -3],
        [3, -2],
        [2, -3],
        [3, -2],
        [2, -4],
        [4, -2],
        [3, -4],
        [2, -3],
        [4, -3],
        [2, -3],
        [4, -3],
        [2, -3],
        [4, -3],
        [2, -3],
        [2, -2],
        [4, -3],
        [2, -2],
        [2, -2],
        [1, -2],
        [2, -3],
        [2, -2],
        [2, -2],
        [1, -2],
        [1, -2],
        [2, -2],
        [1, -2],
        [1, -3],
        [2, -2],
        [1, -2],
        [1, -3],
        [2, -3],
        [1, -3],
        [1, -2],
        [2, -3],
        [1, -3],
        [3, -3],
        [1, -3],
        [2, -2],
        [1, -3],
        [2, -2],
        [2, -3],
        [1, -2],
        [2, -3],
        [2, -2],
        [1, -3],
        [2, -2],
        [2, -3],
        [2, -1],
        [1, -3],
        [2, -2],
        [1, -3],
        [2, -2],
        [2, -2],
        [2, -2],
        [1, -2],
        [1, -2],
        [2, -2],
        [2, -3],
        [1, -2],
        [2, -2],
        [1, -3],
        [2, -2],
        [2, -2],
        [2, -2],
        [2, -2],
        [0, -1],
        [2, -2],
        [4, -2],
        [2, -4],
        [2, 0],
        [2, -2],
        [2, -2],
        [2, -2],
        [2, -2],
        [2, -2],
        [4, 0],
        [1, -2],
        [3, -2],
        [3, -2],
        [2, 0],
        [3, -2],
        [1, 0],
        [3, -2],
        [3, 0],
        [4, -2],
        [5, -2],
        [4, 0],
        [5, -2],
        [5, -2],
        [5, -2],
        [5, 0],
        [6, -2],
        [5, -2],
        [5, -2],
        [6, -2],
        [4, -2],
        [6, -4],
        [6, -1],
        [4, -2],
        [5, -3],
        [5, -2],
        [5, -2],
        [4, -3],
        [7, -3],
        [4, -2],
        [5, -3],
        [5, -2],
        [5, -3],
        [4, -3],
        [6, -2],
        [4, -3],
        [6, -3],
        [5, -2],
        [3, -3],
        [6, -3],
        [6, -3],
        [6, -2],
        [4, -3],
        [6, -3],
        [5, -2],
        [6, -3],
        [5, -2],
        [5, -2],
        [6, -3],
        [4, -2],
        [5, -2],
        [4, -1],
        [4, -2],
        [4, -2],
        [4, -1],
        [3, -1],
        [4, -2],
        [3, -1],
        [4, -2],
        [3, -2],
        [3, 0],
        [4, -2],
        [4, -2],
        [4, -2],
        [4, -2],
        [4, 0],
        [2, -2],
        [4, -2],
        [4, 0],
        [2, -2],
        [3, 0],
        [5, -2],
        [3, 0],
        [3, -2],
        [4, 0],
        [3, -3],
        [3, 0],
        [4, -2],
        [3, 0],
        [4, -2],
        [4, 0],
        [3, -2],
        [4, 0],
        [3, -2],
        [4, 0],
        [4, 0],
        [5, -2],
        [5, 0],
        [6, -2],
        [8, 0],
        [8, 0],
        [8, -2],
        [10, 0],
        [11, 0],
        [10, -2],
        [11, 0],
        [12, -2],
        [11, 0],
        [12, -2],
        [12, 0],
        [11, -2],
        [12, 0],
        [12, -2],
        [11, -2],
        [12, -2],
        [12, 0],
        [12, -2],
        [12, -2],
        [12, -2],
        [11, -2],
        [12, -2],
        [10, -2],
        [8, -2],
        [9, 0],
        [6, -2],
        [6, -2],
        [5, 0],
        [1, 0],
        [3, -2],
        [2, 0],
        [2, 0],
        [2, -2],
        [3, 0],
        [3, -2],
        [2, 0],
        [2, -2],
        [2, 0],
        [4, -2],
        [2, 0],
        [3, -2],
        [1, -1],
        [3, -1],
        [2, -1],
        [2, -1],
        [2, -1],
        [4, -1],
        [2, -1],
        [2, -1],
        [4, 0],
        [4, -2],
        [2, 0],
        [4, -2],
        [4, 0],
        [3, -2],
        [4, 0],
        [4, -2],
        [3, 0],
        [4, -2],
        [3, 0],
        [4, -1],
        [4, -1],
        [3, 0],
        [3, -1],
        [3, 0],
        [4, -1],
        [3, 0],
        [3, -1],
        [4, -1],
        [2, 0],
        [4, 0],
        [3, -1],
        [3, 0],
        [2, -1],
        [4, 0],
        [4, 0],
        [4, 0],
        [2, 0],
        [4, 0],
        [6, 1],
        [4, 1],
        [6, 0],
        [5, 2],
        [6, 2],
        [6, 2],
        [7, 3],
        [7, 3],
        [7, 3],
        [9, 2],
        [7, 3],
        [7, 3],
        [6, 1],
        [8, 2],
        [6, 2],
        [6, 2],
        [6, 2],
        [6, 2],
        [5, 2],
        [5, 2],
        [5, 0],
        [5, 2],
        [5, 2],
        [4, 0],
        [4, 2],
        [4, 2],
        [5, 0],
        [4, 2],
        [3, 0],
        [4, 0],
        [4, 2],
        [4, 0],
        [3, 0],
        [2, 0],
        [4, 0],
        [4, 0],
        [4, 0],
        [4, 0],
        [2, 0],
        [4, 0],
        [4, 0],
        [2, 0],
        [4, 0],
        [3, 0],
        [3, 0],
        [3, 0],
        [4, 0],
        [3, -2],
        [3, 0],
        [3, 0],
        [3, 0],
        [3, -2],
        [5, 0],
        [2, -2],
        [4, 0],
        [4, -2],
        [4, -2],
        [4, 0],
        [3, -2],
        [4, -4],
        [4, -2],
        [4, -2],
        [5, -2],
        [4, -4],
        [5, -2],
        [4, -3],
        [5, -3],
        [5, -3],
        [4, -3],
        [4, -3],
        [4, -3],
        [6, -2],
        [4, -2],
        [4, -2],
        [6, -2],
        [4, -2],
        [4, -2],
        [5, -1],
        [5, -2],
        [5, -1],
        [5, -1],
        [5, -1],
        [5, -1],
        [5, -2],
        [5, 0],
        [6, -2],
        [3, 0],
        [3, -1],
        [6, -1],
        [6, -1],
        [6, -1],
        [8, -1],
        [8, 0],
        [9, -2],
        [9, 0],
        [9, 0],
        [10, -1],
        [4, 0],
        [6, -1],
        [10, 0],
        [10, -1],
        [10, -1],
        [10, 0],
        [10, -2],
        [10, -1],
        [8, -1],
        [10, -1],
        [9, -1],
        [8, -2],
        [9, -1],
        [8, -1],
        [8, -1],
        [7, 0],
        [5, -1],
        [8, -1],
        [6, -2],
        [9, -1],
        [6, -1],
        [5, -2],
        [7, -2],
        [7, -2],
        [6, -2],
        [7, -2],
        [6, -3],
        [7, -2],
        [7, -4],
        [7, -2],
        [6, -4],
        [7, -2],
        [6, -4],
        [8, -4],
        [6, -4],
        [8, -3],
        [7, -5],
        [6, -4],
        [8, -4],
        [7, -6],
        [8, -4],
        [8, -6],
        [8, -5],
        [9, -7],
        [7, -6],
        [11, -7],
        [10, -7],
        [10, -8],
        [9, -7],
        [10, -8],
        [9, -7],
        [9, -8],
        [9, -5],
        [8, -5],
        [6, -6],
        [7, -4],
        [5, -6],
        [5, -4],
        [6, -2],
        [4, -4],
        [4, -2],
        [4, -2],
        [4, -2],
        [4, -2],
        [4, -3],
        [4, -2],
        [6, -3],
        [4, -2],
        [8, -4],
        [7, -3],
        [8, -4],
        [9, -4],
        [10, -5],
        [11, -5],
        [10, -6],
        [11, -6],
        [9, -6],
        [10, -5],
        [10, -6],
        [10, -6],
        [10, -6],
        [9, -6],
        [9, -5],
        [8, -6],
        [8, -4],
        [6, -6],
        [7, -4],
        [5, -4],
        [6, -4],
        [6, -4],
        [4, -4],
        [6, -2],
        [4, -4],
        [6, -2],
        [4, -2],
        [4, -2],
        [1, 0],
        [5, -2],
        [5, -2],
        [6, -2],
        [6, -2],
        [5, -2],
        [5, 0],
        [6, -2],
        [6, -2],
        [5, 0],
        [6, -2],
        [5, 0],
        [6, -2],
        [6, -2],
        [4, 0],
        [6, -2],
        [6, -2],
        [5, 0],
        [5, -2],
        [5, -2],
        [6, -2],
        [4, -2],
        [6, -2],
        [5, -2],
        [4, -2],
        [6, -3],
        [4, -3],
        [5, -2],
        [5, -3],
        [5, -3],
        [4, -3],
        [3, -4],
        [6, -4],
        [4, -4],
        [6, -4],
        [4, -5],
        [6, -7],
        [5, -6],
        [7, -7],
        [7, -8],
        [8, -8],
        [8, -9],
        [8, -8],
        [8, -8],
        [8, -10],
        [7, -8],
        [7, -8],
        [8, -7],
        [8, -7],
        [8, -7],
        [7, -6],
        [8, -6],
        [7, -5],
        [7, -6],
        [7, -6],
        [7, -5],
        [7, -4],
        [7, -5],
        [7, -5],
        [7, -4],
        [6, -3],
        [6, -4],
        [7, -3],
        [6, -3],
        [6, -4],
        [5, -2],
        [7, -2],
        [8, -2],
        [6, -2],
        [6, -2],
        [6, -1],
        [7, -1],
        [7, -2],
        [8, 0],
        [8, -2],
        [9, 0],
        [9, -2],
        [11, 0],
        [11, 0],
        [12, -2],
        [12, 0],
        [13, 0],
        [13, -2],
        [13, 0],
        [13, 0],
        [11, 0],
        [12, 0],
        [12, 0],
        [10, 0],
        [9, 0],
        [8, 0],
        [9, 0],
        [8, 0],
        [6, 0],
        [7, 0],
        [6, 2],
        [5, 0],
        [6, 2],
        [4, 0],
        [4, 2],
        [4, 2],
        [4, 2],
        [4, 2],
        [4, 2],
        [4, 3],
        [2, 3],
        [4, 5],
        [4, 4],
        [3, 5],
        [4, 5],
        [4, 6],
        [4, 6],
        [4, 6],
        [4, 7],
        [4, 6],
        [3, 6],
        [3, 5],
        [3, 5],
        [2, 3],
        [3, 4],
        [2, 2],
        [2, 1],
        [1, 2],
        [2, 0],
        [2, 1],
        [1, 1],
        [2, 0],
        [1, 0],
        [3, 0],
        [2, -1],
        [3, 0],
        [2, -1],
        [3, 0],
        [2, -1],
        [4, -1],
        [4, -1],
        [4, -1],
        [6, -1],
        [6, -2],
        [6, -3],
        [7, -3],
        [10, -3],
        [10, -4],
        [11, -4],
        [13, -5],
        [12, -5],
        [13, -5],
        [12, -5],
        [12, -5],
        [11, -5],
        [10, -5],
        [9, -3],
        [9, -4],
        [6, -3],
        [2, -1],
        [7, -3],
        [7, -4],
        [5, -3],
        [6, -3],
        [4, -3],
        [5, -2],
        [5, -2],
        [4, -2],
        [4, -2],
        [3, -2],
        [3, -2],
        [4, -2],
        [4, -2],
        [4, -2],
        [2, 0],
        [4, -2],
        [4, -2],
        [2, 0],
        [4, -2],
        [2, 0],
        [3, -2],
        [4, -1],
        [3, -1],
        [3, 0],
        [4, -2],
        [3, 0],
        [3, -1],
        [4, 0],
        [3, 0],
        [3, -1],
        [4, 0],
        [4, 0],
        [4, 0],
        [5, 1],
        [5, 0],
        [6, 1],
        [6, 1],
        [7, 2],
        [8, 2],
        [8, 1],
        [6, 2],
        [8, 4],
        [8, 2],
        [7, 2],
        [6, 2],
        [6, 2],
        [5, 2],
        [5, 2],
        [5, 0],
        [5, 2],
        [4, 2],
        [5, 3],
        [5, 2],
        [4, 3],
        [6, 2],
        [6, 4],
        [6, 3],
        [8, 3],
        [7, 4],
        [8, 5],
        [10, 4],
        [10, 6],
        [11, 5],
        [11, 6],
        [10, 5],
        [9, 5],
        [10, 6],
        [8, 4],
        [9, 4],
        [6, 4],
        [5, 3],
        [5, 2],
        [5, 3],
        [3, 2],
        [3, 2],
        [3, 1],
        [3, 2],
        [3, 1],
        [4, 2],
        [3, 1],
        [3, 1],
        [3, 1],
        [3, 1],
        [4, 0],
        [3, 1],
        [3, 1],
        [3, 0],
        [3, 0],
        [2, 1],
        [4, 0],
        [4, 0],
        [2, 0],
        [4, 0],
        [2, 0],
        [4, 0],
        [4, 0],
        [4, -1],
        [3, 0],
        [6, -2],
        [6, 0],
        [7, -2],
        [8, -2],
        [8, -2],
        [8, -2],
        [9, -2],
        [8, -3],
        [9, -2],
        [8, -2],
        [7, -2],
        [8, -2],
        [6, -2],
        [6, -2],
        [5, -1],
        [6, -1],
        [5, -2],
        [5, -1],
        [5, -1],
        [4, 0],
        [4, -1],
        [5, -1],
        [4, 0],
        [4, 0],
        [4, 0],
        [4, 0],
        [4, 0],
        [3, 0],
        [3, 0],
        [4, 0],
        [3, 0],
        [3, 0],
        [4, 1],
        [3, 0],
        [3, 0],
        [3, 1],
        [3, 0],
        [2, 0],
        [4, 0],
        [2, 0],
        [4, 0],
        [2, -1],
        [4, 0],
        [2, -1],
        [2, 0],
        [4, 0],
        [2, -1],
        [2, 0],
        [4, 0],
        [1, -1],
        [2, -1],
        [3, 0],
        [2, -1],
        [2, -1],
        [2, 0],
        [2, -2],
        [2, 0],
        [3, -2],
        [2, 0],
        [2, -2],
        [2, -2],
        [2, -1],
        [2, -2],
        [2, -3],
        [3, -3],
        [3, -3],
        [3, -3],
        [4, -5],
        [3, -5],
        [4, -4],
        [2, -5],
        [4, -4],
        [2, -7],
        [3, -3],
        [2, -4],
        [2, -4],
        [1, -4],
        [2, -4],
        [2, -4],
        [2, -6],
        [2, -4],
        [4, -7],
        [2, -7],
        [4, -8],
        [2, -8],
        [4, -10],
        [4, -10],
        [4, -10],
        [3, -10],
        [4, -10],
        [4, -8],
        [4, -10],
        [4, -10],
        [4, -8],
        [4, -8],
        [4, -8],
        [4, -6],
        [4, -9],
        [4, -4],
        [4, -4],
        [4, -4],
        [4, -4],
        [4, -4],
        [4, -2],
        [3, -3],
        [4, -2],
        [4, -3],
        [6, -3],
        [4, -2],
        [4, -2],
        [6, -3],
        [4, -3],
        [5, -3],
        [6, -3],
        [5, -3],
        [5, -4],
        [6, -3],
        [6, -4],
        [6, -4],
        [6, -3],
        [6, -4],
        [6, -4],
        [5, -3],
        [5, -4],
        [6, -3],
        [6, -4],
        [6, -3],
        [6, -3],
        [4, -3],
        [5, -2],
        [6, -3],
        [4, -2],
        [6, -2],
        [4, -2],
        [6, -2],
        [5, -2],
        [6, -2],
        [6, -2],
        [6, -2],
        [7, -4],
        [6, -2],
        [7, -4],
        [6, -4],
        [6, -2],
        [2, -2],
        [6, -2],
        [6, -4],
        [5, -4],
        [5, -2],
        [5, -4],
        [4, -3],
        [4, -3],
        [4, -3],
        [4, -5],
        [3, -2],
        [3, -4],
        [2, -2],
        [4, -3],
        [2, -4],
        [4, -4],
        [4, -5],
        [4, -5],
        [5, -7],
        [5, -8],
        [6, -8],
        [6, -9],
        [8, -10],
        [8, -10],
        [8, -10],
        [7, -11],
        [8, -9],
        [8, -9],
        [8, -10],
        [8, -9],
        [9, -9],
        [8, -9],
        [9, -9],
        [10, -9],
        [11, -9],
        [10, -8],
        [11, -9],
        [13, -8],
        [12, -8],
        [10, -8],
        [11, -8],
        [10, -6],
        [9, -8],
        [8, -4],
        [8, -6],
        [5, -4],
        [5, -4],
        [4, -4],
        [4, -3],
        [4, -4],
        [2, -2],
        [2, -4],
        [2, -2],
        [0, -4],
        [2, -2],
        [0, -3],
        [0, -2],
        [2, -3],
        [0, -3],
        [0, -2],
        [0, -2],
        [0, -2],
        [0, -2],
        [0, -3],
        [0, -2],
        [2, -2],
        [0, -1],
        [0, -2],
        [2, -1],
        [2, -2],
        [2, -2],
        [2, -1],
        [1, -1],
        [2, -1],
        [3, -2],
        [3, 0],
        [4, -2],
        [4, 0],
        [5, -1],
        [5, -1],
        [5, 0],
        [5, 0],
        [5, -1],
        [6, 0],
        [6, 1],
        [6, 0],
        [6, 0],
        [6, 1],
        [7, 1],
        [6, 1],
        [8, 1],
        [6, 2],
        [7, 1],
        [7, 2],
        [7, 2],
        [8, 2],
        [8, 2],
        [9, 2],
        [9, 2],
        [9, 3],
        [10, 3],
        [10, 2],
        [10, 3],
        [9, 2],
        [10, 3],
        [9, 3],
        [8, 2],
        [8, 2],
        [6, 3],
        [7, 2],
        [5, 2],
        [5, 2],
        [4, 3],
        [6, 2],
        [4, 2],
        [4, 2],
        [4, 2],
        [4, 2],
        [4, 2],
        [4, 2],
        [4, 0],
        [3, 2],
        [5, 2],
        [5, 2],
        [5, 2],
        [5, 0],
        [6, 2],
        [5, 0],
        [6, 2],
        [5, 0],
        [5, 0],
        [5, 2],
        [4, 0],
        [5, 0],
        [4, 0],
        [4, 0],
        [4, 0],
        [4, 0],
        [4, 0],
        [2, 0],
        [4, 0],
        [4, 0],
        [2, 0],
        [2, 0],
        [3, -2],
        [3, 0],
        [3, 0],
        [4, -2],
        [4, 0],
        [3, -2],
        [3, -2],
        [3, -2],
        [4, -2],
        [4, -2],
        [3, -2],
        [4, -2],
        [3, -1],
        [4, -3],
        [3, -3],
        [4, -2],
        [4, -3],
        [3, -3],
        [4, -2],
        [3, -3],
        [3, -3],
        [4, -3],
        [3, -3],
        [3, -3],
        [4, -4],
        [3, -2],
        [3, -3],
        [2, -4],
        [3, -4],
        [3, -3],
        [2, -4],
        [2, -4],
        [4, -4],
        [2, -5],
        [2, -5],
        [4, -5],
        [4, -8],
        [4, -6],
        [2, -6],
        [4, -8],
        [3, -8],
        [4, -6],
        [4, -6],
        [3, -6],
        [3, -6],
        [4, -6],
        [2, -4],
        [3, -4],
        [3, -4],
        [2, -4],
        [3, -4],
        [2, -4],
        [2, -3],
        [3, -3],
        [3, -3],
        [0, -1],
        [3, -3],
        [3, -3],
        [2, -3],
        [3, -3],
        [3, -3],
        [3, -3],
        [2, -4],
        [3, -4],
        [2, -3],
        [2, -3],
        [2, -4],
        [4, -3],
        [2, -4],
        [2, -3],
        [2, -4],
        [2, -3],
        [0, -3],
        [2, -4],
        [2, -3],
        [2, -3],
        [2, -3],
        [4, -4],
        [2, -4],
        [2, -4],
        [3, -4],
        [2, -2],
        [4, -3],
        [3, -4],
        [4, -4],
        [3, -3],
        [3, -3],
        [4, -3],
        [3, -3],
        [4, -3],
        [3, -3],
        [3, -3],
        [4, -2],
        [4, -2],
        [4, -3],
        [5, -2],
        [5, -3],
        [5, -3],
        [5, -2],
        [6, -4],
        [6, -3],
        [2, -1],
        [6, -3],
        [6, -4],
        [8, -5],
        [9, -5],
        [8, -5],
        [9, -5],
        [8, -5],
        [9, -5],
        [9, -6],
        [7, -4],
        [7, -6],
        [8, -5],
        [8, -4],
        [8, -6],
        [8, -4],
        [9, -6],
        [8, -4],
        [8, -6],
        [8, -6],
        [8, -5],
        [9, -6],
        [8, -7],
        [7, -5],
        [8, -5],
        [8, -5],
        [6, -5],
        [8, -6],
        [5, -4],
        [7, -5],
        [6, -4],
        [5, -4],
        [5, -2],
        [5, -4],
        [5, -2],
        [4, -2],
        [5, -2],
        [5, -1],
        [4, -2],
        [5, -1],
        [5, -2],
        [8, -2],
        [8, -1],
        [8, -2],
        [9, -2],
        [7, -2],
        [8, -1],
        [8, -2],
        [8, -2],
        [7, 0],
        [7, 0],
        [6, -2],
        [5, 0],
        [5, 0],
        [5, 0],
        [4, 0],
        [4, 0],
        [3, 0],
        [4, 0],
        [3, 0],
        [3, 0],
        [3, 0],
        [2, 2],
        [3, 0],
        [3, 0],
        [3, 2],
        [2, 0],
        [4, 0],
        [4, 2],
        [2, 1],
        [4, 2],
        [4, 1],
        [4, 2],
        [4, 3],
        [3, 2],
        [4, 3],
        [4, 3],
        [4, 3],
        [4, 3],
        [4, 3],
        [4, 4],
        [4, 4],
        [4, 3],
        [4, 4],
        [4, 3],
        [4, 4],
        [3, 4],
        [5, 4],
        [4, 4],
        [3, 4],
        [3, 5],
        [3, 4],
        [3, 7],
        [2, 5],
        [4, 4],
        [2, 6],
        [2, 6],
        [4, 6],
        [2, 4],
        [2, 6],
        [2, 6],
        [0, 6],
        [2, 5],
        [2, 6],
        [2, 6],
        [0, 5],
        [2, 4],
        [0, 5],
        [2, 5],
        [0, 3],
        [1, 5],
        [0, 4],
        [0, 3],
        [1, 4],
        [0, 3],
        [0, 4],
        [0, 4],
        [0, 2],
        [-1, 4],
        [0, 2],
        [0, 3],
        [0, 3],
        [-1, 3],
        [0, 2],
        [0, 2],
        [0, 3],
        [0, 2],
        [-2, 2],
        [0, 2],
        [0, 3],
        [-2, 3],
        [0, 2],
        [-2, 2],
        [0, 3],
        [0, 2],
        [-2, 2],
        [0, 2],
        [-2, 4],
        [0, 2],
        [0, 3],
        [-2, 2],
        [0, 3],
        [-2, 2],
        [0, 2],
        [-2, 2],
        [0, 2],
        [-2, 2],
        [-2, 1],
        [-2, 2],
        [0, 2],
        [-2, 1],
        [-2, 1],
        [-2, 2],
        [-2, 1],
        [0, 2],
        [-2, 1],
        [-1, 2],
        [-2, 2],
        [-1, 1],
        [-1, 2],
        [-1, 2],
        [-1, 2],
        [0, 2],
        [0, 2],
        [0, 2],
        [0, 2],
        [0, 2],
        [0, 2],
        [1, 1],
        [1, 2],
        [0, 2],
        [1, 2],
        [1, 2],
        [1, 2],
        [1, 1],
        [1, 2],
        [2, 2],
        [0, 2],
        [2, 1],
        [2, 2],
        [2, 2],
        [0, 1],
        [2, 2],
        [2, 2],
        [2, 1],
        [2, 2],
        [2, 1],
        [2, 1],
        [4, 2],
        [2, 1],
        [2, 1],
        [4, 2],
        [1, 0],
        [4, 2],
        [2, 0],
        [4, 1],
        [3, 1],
        [3, 0],
        [3, 0],
        [3, 0],
        [4, 0],
        [2, 2],
        [3, 0],
        [4, -2],
        [3, 0],
        [3, 0],
        [4, 0],
        [5, -2],
        [5, -1],
        [5, -1],
        [5, -2],
        [6, -2],
        [8, -3],
        [6, -2],
        [8, -4],
        [8, -4],
        [9, -4],
        [8, -4],
        [9, -5],
        [9, -6],
        [10, -5],
        [9, -6],
        [8, -5],
        [7, -5],
        [8, -6],
        [8, -4],
        [6, -5],
        [5, -4],
        [5, -4],
        [5, -3],
        [4, -4],
        [5, -3],
        [4, -5],
        [3, -4],
        [3, -4],
        [4, -3],
        [3, -3],
        [3, -4],
        [3, -4],
        [3, -4],
        [2, -4],
        [3, -4],
        [3, -4],
        [2, -4],
        [3, -3],
        [2, -4],
        [2, -4],
        [2, -3],
        [1, -4],
        [2, -3],
        [0, -3],
        [2, -4],
        [2, -2],
        [0, -4],
        [2, -3],
        [0, -3],
        [2, -2],
        [0, -3],
        [2, -3],
        [2, -3],
        [0, -2],
        [2, -3],
        [2, -3],
        [0, -2],
        [2, -2],
        [2, -3],
        [2, -2],
        [2, -2],
        [4, -2],
        [2, -2],
        [1, -2],
        [2, -1],
        [3, -2],
        [3, -2],
        [2, -2],
        [3, 0],
        [3, -2],
        [2, 0],
        [3, -2],
        [3, 0],
        [3, -2],
        [4, 0],
        [4, 0],
        [3, -2],
        [4, 0],
        [4, 0],
        [4, 0],
        [4, 0],
        [3, 0],
        [3, 0],
        [4, 0],
        [3, 0],
        [3, 2],
        [4, 0],
        [2, 0],
        [4, 2],
        [4, 0],
        [4, 2],
        [4, 0],
        [4, 2],
        [4, 2],
        [3, 2],
        [4, 0],
        [4, 2],
        [3, 1],
        [4, 0],
        [3, 2],
        [3, 0],
        [3, 1],
        [3, 1],
        [3, 0],
        [3, 1],
        [4, 0],
        [3, 1],
        [3, 0],
        [4, 0],
        [3, 0],
        [4, 0],
        [3, 0],
        [4, 0],
        [3, 0],
        [4, 0],
        [4, 0],
        [4, 0],
        [4, 0],
        [4, 0],
        [4, 0],
        [3, -1],
        [4, -1],
        [5, 0],
        [4, 0],
        [4, -1],
        [4, -1],
        [4, 0],
        [5, -2],
        [6, 0],
        [3, -1],
        [4, 0],
        [4, 0],
        [4, -2],
        [4, 0],
        [4, -2],
        [4, 0],
        [3, -2],
        [2, 0],
        [4, -2],
        [2, 0],
        [2, -2],
        [3, -2],
        [2, 0],
        [3, -2],
        [2, -2],
        [2, 0],
        [3, -2],
        [3, -2],
        [3, 0],
        [3, -2],
        [3, -2],
        [3, -2],
        [2, -2],
        [4, 0],
        [4, -2],
        [2, -2],
        [4, -2],
        [2, -2],
        [2, 0],
        [2, -2],
        [2, -2],
        [0, 0],
        [4, -2],
        [2, -3],
        [3, -2],
        [2, -3],
        [3, -3],
        [3, -3],
        [2, -3],
        [2, -2],
        [2, -3],
        [3, -2],
        [2, -2],
        [1, -1],
        [2, -2],
        [2, 0],
        [1, -1],
        [2, -1],
        [2, 0],
        [1, 0],
        [1, 0],
        [2, 0],
        [1, 0],
        [1, 0],
        [2, 0],
        [1, 0],
        [1, 1],
        [2, 0],
        [1, 1],
        [2, 0],
        [1, 2],
        [2, 0],
        [2, 2],
        [1, 0],
        [2, 2],
        [2, 2],
        [1, 1],
        [2, 2],
        [2, 1],
        [2, 3],
        [2, 3],
        [2, 3],
        [2, 3],
        [2, 3],
        [2, 4],
        [4, 4],
        [2, 4],
        [5, 6],
        [4, 6],
        [4, 6],
        [6, 6],
        [4, 8],
        [7, 7],
        [6, 8],
        [8, 9],
        [7, 8],
        [7, 9],
        [8, 8],
        [7, 7],
        [6, 8],
        [6, 6],
        [2, 2],
        [2, 3],
        [6, 5],
        [4, 5],
        [6, 4],
        [4, 4],
        [4, 3],
        [4, 3],
        [5, 3],
        [4, 4],
        [5, 3],
        [5, 2],
        [6, 4],
        [5, 2],
        [5, 2],
        [5, 5],
        [6, 1],
        [5, 2],
        [5, 2],
        [5, 2],
        [5, 1],
        [6, 2],
        [5, 1],
        [6, 1],
        [4, 1],
        [4, 1],
        [4, 0],
        [5, 1],
        [4, 1],
        [4, 0],
        [4, 0],
        [4, 0],
        [5, -1],
        [4, -1],
        [4, 0],
        [5, -1],
        [4, -1],
        [5, 0],
        [4, -2],
        [4, 0],
        [4, -1],
        [4, -1],
        [4, 0],
        [4, -1],
        [2, 0],
        [4, 0],
        [4, -1],
        [4, -1],
        [4, 0],
        [2, -1],
        [4, -1],
        [4, -1],
        [4, -1],
        [3, 0],
        [3, -1],
        [3, 0],
        [4, 0],
        [4, 0],
        [3, -3],
        [4, 0],
        [3, 0],
        [4, 3],
        [3, 0],
        [4, 0],
        [4, 1],
        [4, 0],
        [4, 2],
        [5, 2],
        [4, 2],
        [7, 2],
        [6, 3],
        [6, 4],
        [6, 4],
        [8, 4],
        [7, 4],
        [7, 5],
        [8, 6],
        [10, 5],
        [9, 6],
        [9, 5],
        [10, 6],
        [10, 5],
        [10, 6],
        [10, 5],
        [10, 6],
        [10, 5],
        [10, 6],
        [10, 4],
        [10, 4],
        [10, 6],
        [10, 4],
        [10, 4],
        [9, 4],
        [9, 4],
        [9, 4],
        [7, 2],
        [7, 4],
        [8, 2],
        [6, 2],
        [8, 2],
        [5, 2],
        [7, 2],
        [6, 2],
        [6, 2],
        [6, 2],
        [6, 2],
        [6, 2],
        [6, 2],
        [6, 0],
        [6, 2],
        [5, 2],
        [5, 0],
        [6, 2],
        [6, 2],
        [6, 0],
        [6, 2],
        [8, 0],
        [7, 0],
        [11, 1],
        [10, 0],
        [13, 0],
        [14, 1],
        [14, 0],
        [14, 0],
        [14, 1],
        [14, 0],
        [13, 0],
        [11, -1],
        [10, 0],
        [8, 0],
        [6, -1],
        [5, 0],
        [3, 0],
        [4, -1],
        [2, 0],
        [2, 0],
        [2, 0],
        [2, -2],
        [2, 0],
        [2, -2],
        [2, 0],
        [2, -2],
        [2, -2],
        [4, 0],
        [2, -2],
        [2, -2],
        [2, -2],
        [2, -2],
        [3, -2],
        [3, 0],
        [2, -2],
        [3, -2],
        [2, -2],
        [3, -2],
        [2, -2],
        [2, -2],
        [2, -2],
        [2, -2],
        [3, -4],
        [2, -2],
        [2, -2],
        [2, -2],
        [2, -4],
        [2, -2],
        [2, -4],
        [2, -4],
        [2, -4],
        [1, -2],
        [1, -4],
        [1, -4],
        [1, -4],
        [0, -4],
        [1, -5],
        [1, -4],
        [0, -4],
        [0, -5],
        [0, -4],
        [0, -4],
        [-1, -5],
        [0, -5],
        [-1, -4],
        [0, -4],
        [0, -5],
        [-1, -5],
        [-1, -5],
        [0, -5],
        [-2, -6],
        [0, -6],
        [-2, -7],
        [-1, -6],
        [-1, -8],
        [-2, -9],
        [-2, -9],
        [-2, -10],
        [-2, -10],
        [-3, -11],
        [-2, -12],
        [-2, -11],
        [-3, -12],
        [-2, -12],
        [-3, -12],
        [-2, -11],
        [-2, -12],
        [-2, -10],
        [-1, -10],
        [-2, -10],
        [-1, -11],
        [-1, -9],
        [-1, -8],
        [-1, -7],
        [-1, -7],
        [0, -6],
        [0, -6],
        [0, -5],
        [0, -5],
        [0, -4],
        [0, -4],
        [0, -3],
        [0, -3],
        [1, -3],
        [1, -2],
        [0, -2],
        [0, -2],
        [1, -2],
        [1, -2],
        [1, -2],
        [1, -2],
        [1, -2],
        [1, -2],
        [1, -2],
        [1, -2],
        [2, 0],
        [2, -2],
        [2, -2],
        [2, -2],
        [2, 0],
        [2, -2],
        [2, -2],
        [2, 0],
        [3, -2],
        [2, -2],
        [2, 0],
        [3, -2],
        [3, -2],
        [2, 0],
        [3, -2],
        [3, -2],
        [3, 0],
        [3, -2],
        [3, 0],
        [4, -2],
        [3, 0],
        [3, -2],
        [3, 0],
        [3, 0],
        [2, -2],
        [2, 0],
        [2, 0],
        [1, 0],
        [1, 0],
        [0, -2],
        [1, 0],
        [1, 0],
        [2, 0],
        [2, 0],
        [2, 0],
        [3, 0],
        [2, 0],
        [3, -2],
        [4, 0],
        [4, 0],
        [4, 0],
        [4, 0],
        [4, 0],
        [6, 0],
        [4, 0],
        [5, 0],
        [6, 0],
        [6, 0],
        [5, 0],
        [6, 2],
        [6, 0],
        [6, 2],
        [5, 0],
        [6, 2],
        [5, 0],
        [6, 2],
        [4, 2],
        [5, 0],
        [4, 2],
        [4, 2],
        [6, 2],
        [6, 2],
        [6, 2],
        [9, 2],
        [9, 2],
        [11, 4],
        [11, 2],
        [12, 4],
        [13, 2],
        [11, 4],
        [14, 2],
        [12, 4],
        [9, 2],
        [11, 2],
        [10, 4],
        [9, 2],
        [9, 2],
        [9, 2],
        [7, 3],
        [7, 2],
        [6, 2],
        [8, 3],
        [6, 2],
        [6, 2],
        [6, 3],
        [6, 3],
        [6, 2],
        [7, 3],
        [5, 2],
        [7, 3],
        [7, 2],
        [6, 3],
        [7, 2],
        [6, 2],
        [5, 2],
        [6, 2],
        [6, 2],
        [6, 1],
        [6, 1],
        [6, 1],
        [5, 2],
        [6, 0],
        [5, 2],
        [5, 0],
        [6, 2],
        [5, 0],
        [6, 2],
        [6, 0],
        [6, 1],
        [5, 0],
        [6, 1],
        [4, 0],
        [4, -1],
        [4, -1],
        [4, 0],
        [2, -1],
        [4, -1],
        [4, -2],
        [2, -1],
        [4, -1],
        [2, -2],
        [2, -1],
        [4, -2],
        [2, -2],
        [1, -3],
        [3, -2],
        [2, -3],
        [3, -2],
        [2, -3],
        [2, -3],
        [2, -3],
        [2, -3],
        [2, -3],
        [2, -4],
        [2, -3],
        [2, -4],
        [1, -4],
        [2, -4],
        [2, -5],
        [2, -4],
        [1, -4],
        [1, -4],
        [2, -4],
        [1, -4],
        [1, -4],
        [2, -4],
        [0, -4],
        [1, -6],
        [1, -2],
        [1, -4],
        [0, -4],
        [1, -4],
        [0, -2],
        [1, -2],
        [0, -2],
        [1, -2],
        [0, -4],
        [0, -2],
        [0, -2],
        [0, -2],
        [1, -4],
        [0, -2],
        [0, -4],
        [1, -2],
        [0, -3],
        [0, -4],
        [0, -4],
        [1, -3],
        [0, -5],
        [0, -5],
        [1, -4],
        [0, -4],
        [0, -4],
        [0, -4],
        [0, -4],
        [0, -5],
        [0, -4],
        [0, -4],
        [0, -4],
        [0, -4],
        [-1, -6],
        [0, -5],
        [-1, -6],
        [0, -5],
        [-1, -8],
        [0, -10],
        [-1, -8],
        [0, -8],
        [-1, -9],
        [-1, -9],
        [0, -8],
        [-1, -8],
        [0, -7],
        [-1, -6],
        [0, -6],
        [0, -6],
        [0, -4],
        [0, -5],
        [0, -5],
        [0, -3],
        [0, -4],
        [1, -3],
        [1, -3],
        [0, -4],
        [1, -3],
        [1, -3],
        [0, -4],
        [2, -2],
        [1, -3],
        [1, -3],
        [2, -2],
        [1, -4],
        [1, -2],
        [2, -4],
        [2, -2],
        [2, -2],
        [2, -4],
        [2, -2],
        [3, -2],
        [2, -3],
        [4, -2],
        [3, -3],
        [4, -4],
        [1, -1],
        [3, -3],
        [5, -4],
        [5, -4],
        [5, -5],
        [8, -5],
        [6, -5],
        [6, -6],
        [8, -5],
        [7, -6],
        [7, -6],
        [8, -5],
        [7, -6],
        [7, -6],
        [7, -5],
        [8, -6],
        [8, -6],
        [7, -6],
        [7, -6],
        [8, -7],
        [8, -4],
        [8, -6],
        [7, -6],
        [7, -6],
        [7, -4],
        [8, -4],
        [6, -4],
        [7, -4],
        [6, -4],
        [6, -4],
        [6, -4],
        [5, -2],
        [6, -3],
        [3, -2],
        [6, -2],
        [4, -2],
        [4, -2],
        [6, -1],
        [5, -2],
        [4, -2],
        [4, -2],
        [5, -2],
        [5, -2],
        [5, -3],
        [6, -2],
        [5, -2],
        [6, -3],
        [5, -3],
        [5, -2],
        [5, -3],
        [5, -2],
        [4, -3],
        [5, -1],
        [3, -3],
        [4, -3],
        [6, -2],
        [6, -3],
        [6, -3],
        [6, -4],
        [7, -3],
        [8, -4],
        [8, -4],
        [9, -5],
        [9, -4],
        [9, -4],
        [9, -6],
        [9, -4],
        [8, -4],
        [11, -6],
        [8, -6],
        [9, -4],
        [8, -7],
        [9, -6],
        [9, -5],
        [9, -5],
        [8, -7],
        [10, -6],
        [8, -6],
        [10, -6],
        [8, -7],
        [12, -6],
        [9, -7],
        [11, -7],
        [11, -7],
        [13, -7],
        [12, -7],
        [13, -7],
        [15, -8],
        [14, -7],
        [14, -8],
        [14, -8],
        [15, -8],
        [16, -8],
        [15, -9],
        [16, -8],
        [14, -9],
        [14, -9],
        [12, -7],
        [12, -8],
        [11, -8],
        [9, -7],
        [10, -6],
        [8, -7],
        [7, -6],
        [6, -5],
        [7, -6],
        [5, -6],
        [6, -4],
        [4, -4],
        [6, -6],
        [6, -2],
        [6, -4],
        [7, -4],
        [8, -4],
        [9, -2],
        [10, -4],
        [10, -2],
        [11, -2],
        [10, -2],
        [9, -2],
        [10, -2],
        [8, -2],
        [8, 0],
        [5, -2],
        [5, 0],
        [4, -2],
        [4, -2],
        [3, 0],
        [3, 0],
        [4, -2],
        [3, -2],
        [3, -2],
        [3, -2],
        [4, -2],
        [3, -3],
        [3, -3],
        [4, -2],
        [4, -3],
        [3, -2],
        [4, -3],
        [4, -3],
        [4, -2],
        [5, -2],
        [4, -3],
        [6, -2],
        [8, -3],
        [6, -3],
        [8, -2],
        [9, -3],
        [9, -2],
        [8, -4],
        [9, -2],
        [9, -1],
        [8, -2],
        [7, -1],
        [7, -1],
        [6, -1],
        [8, -1],
        [6, 0],
        [8, 0],
        [5, 0],
        [9, 0],
        [4, 0],
        [5, 0],
        [8, 0],
        [10, 0],
        [9, 1],
        [9, 0],
        [10, 1],
        [9, 0],
        [8, 0],
        [9, 1],
        [7, 0],
        [6, 0],
        [8, 0],
        [6, 0],
        [6, 0],
        [6, 0],
        [5, -1],
        [6, 0],
        [5, 0],
        [3, 0],
        [2, 0],
        [5, 0],
        [6, 0],
        [4, 0],
        [6, -1],
        [4, 1],
        [4, 0],
        [5, 0],
        [4, 0],
        [4, 1],
        [3, 1],
        [5, 0],
        [6, 1],
        [4, 1],
        [4, 1],
        [4, 0],
        [4, 2],
        [4, 0],
        [5, 1],
        [4, 2],
        [4, 0],
        [4, 1],
        [4, 0],
        [3, 0],
        [3, -1],
        [3, 0],
        [3, 0],
        [3, -2],
        [2, -1],
        [2, 0],
        [2, 0],
        [1, 0],
        [1, -1],
        [2, 0],
        [0, -1],
        [2, 0],
        [1, 0],
        [1, -1],
        [2, 0],
        [2, -1],
        [2, -1],
        [2, -1],
        [3, -1],
        [4, -2],
        [3, -1],
        [6, -1],
        [4, -2],
        [6, -2],
        [8, -2],
        [6, -2],
        [7, -2],
        [7, -1],
        [7, -3],
        [7, -2],
        [8, -3],
        [6, -2],
        [8, -2],
        [6, -4],
        [7, -2],
        [6, -2],
        [6, -2],
        [6, -2],
        [6, -2],
        [4, -2],
        [6, 0],
        [4, 0],
        [4, -2],
        [4, 0],
        [4, 0],
        [4, 0],
        [3, 0],
        [4, 0],
        [3, 2],
        [2, 0],
        [3, 0],
        [3, 2],
        [2, 0],
        [2, 2],
        [1, 2],
        [2, 0],
        [1, 2],
        [2, 2],
        [1, 0],
        [1, 2],
        [1, 2],
        [1, 0],
        [2, 2],
        [2, 2],
        [1, 2],
        [2, 2],
        [1, 2],
        [2, 2],
        [1, 3],
        [2, 2],
        [2, 4],
        [1, 3],
        [1, 3],
        [1, 4],
        [0, 3],
        [2, 3],
        [0, 4],
        [2, 2],
        [0, 2],
        [0, 2],
        [0, 1],
        [0, 1],
        [0, 1],
        [0, 1],
        [2, 0],
        [0, 1],
        [0, 1],
        [0, 1],
        [0, 2],
        [0, 1],
        [0, 1],
        [0, 2],
        [0, 0],
        [0, 2],
        [0, 2],
        [-2, 1],
        [0, 3],
        [0, 2],
        [0, 2],
        [-2, 3],
        [0, 2],
        [0, 3],
        [0, 3],
        [0, 3],
        [0, 3],
        [0, 2],
        [0, 2],
        [0, 4],
        [0, 2],
        [0, 4],
        [0, 2],
        [0, 2],
        [2, 2],
        [0, 2],
        [2, 2],
        [0, 2],
        [2, 2],
        [2, 2],
        [2, 2],
        [2, 2],
        [2, 2],
        [4, 2],
        [2, 2],
        [4, 2],
        [2, 0],
        [4, 2],
        [2, 2],
        [3, 2],
        [3, 0],
        [3, 2],
        [2, 2],
        [4, 0],
        [2, 0],
        [3, 0],
        [3, 0],
        [3, 0],
        [3, 0],
        [3, 0],
        [3, 0],
        [3, -2],
        [4, 0],
        [4, -2],
        [5, -2],
        [4, -4],
        [4, -2],
        [4, -2],
        [4, -4],
        [4, -2],
        [4, -2],
        [4, -4],
        [2, -2],
        [2, -2],
        [2, 0],
        [2, -2],
        [0, 0],
        [2, 0],
        [0, -2],
        [2, -2],
        [2, 0],
        [2, -2],
        [2, -4],
        [3, -2],
        [3, -4],
        [4, -2],
        [3, -4],
        [4, -4],
        [4, -4],
        [4, -4],
        [3, -3],
        [3, -4],
        [3, -3],
        [3, -3],
        [3, -4],
        [2, -4],
        [4, -3],
        [3, -4],
        [3, -4],
        [2, -1],
        [2, -3],
        [4, -5],
        [4, -3],
        [4, -4],
        [4, -4],
        [3, -4],
        [4, -2],
        [4, -3],
        [2, -2],
        [3, -2],
        [3, -1],
        [1, -1],
        [2, -2],
        [2, 0],
        [2, -1],
        [2, -1],
        [1, 0],
        [2, 0],
        [0, 0],
        [2, 0],
        [2, 0],
        [0, 0],
        [2, 0],
        [2, 0],
        [2, 0],
        [2, 0],
        [0, 0],
        [2, 0],
        [2, 0],
        [2, 0],
        [2, 1],
        [4, 1],
        [2, 0],
        [2, 1],
        [2, 1],
        [2, 0],
        [3, 2],
        [2, 0],
        [3, 2],
        [3, 0],
        [3, 2],
        [2, 1],
        [2, 1],
        [3, 1],
        [3, 2],
        [2, 1],
        [3, 1],
        [3, 2],
        [3, 2],
        [3, 1],
        [4, 1],
        [3, 2],
        [4, 1],
        [4, 1],
        [4, 2],
        [4, 1],
        [4, 2],
        [6, 1],
        [4, 2],
        [6, 2],
        [6, 2],
        [8, 1],
        [7, 2],
        [8, 2],
        [9, 3],
        [9, 2],
        [10, 2],
        [11, 3],
        [11, 3],
        [13, 4],
        [12, 4],
        [14, 4],
        [14, 5],
        [15, 5],
        [14, 6],
        [15, 4],
        [13, 4],
        [14, 6],
        [13, 4],
        [12, 4],
        [12, 4],
        [11, 4],
        [11, 2],
        [9, 4],
        [8, 2],
        [10, 0],
        [6, 2],
        [9, 2],
        [8, 2],
        [5, 2],
        [6, 2],
        [5, 2],
        [5, 0],
        [5, 2],
        [6, 0],
        [5, 2],
        [5, 2],
        [5, 0],
        [5, 0],
        [5, 2],
        [5, 0],
        [4, 2],
        [6, 0],
        [4, 2],
        [4, 0],
        [4, 2],
        [6, 0],
        [4, 2],
        [4, 0],
        [3, 0],
        [4, 2],
        [3, 0],
        [4, 0],
        [3, 0],
        [3, 2],
        [3, 0],
        [3, 0],
        [2, 0],
        [3, 0],
        [3, 0],
        [2, 0],
        [2, 0],
        [3, 0],
        [2, 0],
        [2, 0],
        [3, 0],
        [2, 0],
        [2, 0],
        [2, -2],
        [2, 0],
        [2, 0],
        [3, 0],
        [2, -2],
        [2, 0],
        [2, 0],
        [2, -2],
        [2, 0],
        [2, -2],
        [3, 0],
        [2, -2],
        [4, 0],
        [2, -2],
        [2, -2],
        [3, -2],
        [3, -2],
        [2, -2],
        [2, -2],
        [3, -2],
        [2, -2],
        [1, -2],
        [2, -2],
        [2, -2],
        [2, -2],
        [2, -2],
        [0, -4],
        [2, -2],
        [0, -4],
        [2, -2],
        [0, -4],
        [2, -6],
        [0, -4],
        [0, -6],
        [2, -4],
        [0, -5],
        [0, -6],
        [0, -5],
        [0, -6],
        [-2, -5],
        [0, -6],
        [-2, -5],
        [0, -5],
        [-2, -5],
        [0, -6],
        [-2, -6],
        [-2, -4],
        [-2, -6],
        [0, -4],
        [-2, -5],
        [0, -6],
        [-2, -4],
        [-1, -6],
        [-1, -4],
        [-1, -6],
        [-2, -6],
        [-1, -6],
        [-1, -8],
        [-1, -4],
        [-1, -6],
        [-1, -6],
        [-2, -6],
        [0, -5],
        [-1, -4],
        [-1, -5],
        [-1, -4],
        [-1, -3],
        [0, -3],
        [-1, -4],
        [-1, -2],
        [0, -4],
        [0, -2],
        [-1, -3],
        [-1, -2],
        [0, -3],
        [0, -3],
        [-2, -2],
        [-1, -3],
        [0, -3],
        [-1, -3],
        [-1, -2],
        [0, -3],
        [0, -3],
        [-1, -3],
        [-1, -3],
        [0, -3],
        [0, -4],
        [-1, -3],
        [0, -4],
        [0, -4],
        [0, -3],
        [0, -4],
        [0, -3],
        [0, -3],
        [0, -4],
        [0, -3],
        [0, -4],
        [0, -3],
        [1, -4],
        [0, -4],
        [0, -4],
        [0, -4],
        [1, -5],
        [1, -4],
        [0, -5],
        [1, -5],
        [1, -5],
        [1, -5],
        [2, -6],
        [2, -5],
        [2, -5],
        [2, -6],
        [3, -5],
        [2, -6],
        [4, -5],
        [2, -5],
        [3, -5],
        [2, -4],
        [4, -4],
        [2, -4],
        [4, -4],
        [2, -2],
        [2, -2],
        [2, -4],
        [2, -2],
        [2, -2],
        [0, 0],
        [2, -2],
        [0, -2],
        [2, 0],
        [0, 0],
        [2, -2],
        [0, 0],
        [2, -2],
        [2, -2],
        [3, -2],
        [4, -5],
        [4, -2],
        [5, -4],
        [5, -4],
        [5, -2],
        [5, -4],
        [5, -2],
        [5, -3],
        [5, -3],
        [5, -2],
        [5, -2],
        [4, -1],
        [5, -2],
        [3, 0],
        [6, -2],
        [4, 0],
        [6, 0],
        [4, 0],
        [6, 0],
        [4, 0],
        [4, 1],
        [5, 1],
        [4, 0],
        [4, 2],
        [4, 0],
        [5, 1],
        [4, 2],
        [5, 2],
        [6, 3],
        [6, 3],
        [6, 4],
        [7, 4],
        [7, 6],
        [8, 7],
        [8, 6],
        [10, 10],
        [11, 8],
        [12, 11],
        [12, 12],
        [13, 14],
        [14, 14],
        [14, 15],
        [14, 16],
        [12, 14],
        [13, 15],
        [12, 12],
        [10, 10],
        [9, 9],
        [7, 7],
        [6, 5],
        [4, 4],
        [3, 3],
        [2, 1],
        [3, 1],
        [2, 1],
        [2, 0],
        [2, 0],
        [2, 0],
        [2, 0],
        [2, -1],
        [2, -1],
        [4, -1],
        [2, -1],
        [2, -2],
        [4, -2],
        [2, -2],
        [4, -3],
        [3, -3],
        [4, -4],
        [4, -4],
        [4, -4],
        [5, -4],
        [5, -5],
        [5, -4],
        [6, -5],
        [5, -5],
        [5, -6],
        [6, -5],
        [5, -5],
        [4, -5],
        [5, -5],
        [4, -5],
        [6, -6],
        [6, -7],
        [6, -8],
        [8, -9],
        [9, -10],
        [10, -12],
        [12, -13],
        [11, -13],
        [13, -14],
        [11, -17],
        [12, -14],
        [12, -12],
        [10, -12],
        [8, -10],
        [8, -10],
        [8, -7],
        [6, -7],
        [6, -5],
        [4, -4],
        [5, -4],
        [3, -3],
        [3, -2],
        [4, -2],
        [2, -2],
        [3, 0],
        [2, -2],
        [3, 0],
        [2, 0],
        [2, 0],
        [3, 0],
        [2, -1],
        [2, 0],
        [3, -1],
        [3, 0],
        [4, -1],
        [4, -1],
        [5, -2],
        [5, -2],
        [6, -2],
        [7, -4],
        [6, -4],
        [8, -4],
        [6, -4],
        [6, -4],
        [6, -4],
        [6, -4],
        [5, -4],
        [4, -4],
        [4, -4],
        [3, -6],
        [4, -4],
        [3, -4],
        [3, -4],
        [3, -4],
        [3, -7],
        [2, -4],
        [2, -4],
        [4, -4],
        [2, -4],
        [3, -6],
        [3, -4],
        [2, -5],
        [4, -6],
        [4, -5],
        [4, -5],
        [4, -5],
        [4, -6],
        [6, -6],
        [4, -6],
        [3, -6],
        [5, -6],
        [5, -7],
        [4, -7],
        [4, -6],
        [4, -6],
        [4, -6],
        [4, -7],
        [3, -6],
        [4, -6],
        [4, -7],
        [3, -6],
        [3, -5],
        [4, -5],
        [3, -5],
        [3, -4],
        [4, -4],
        [3, -4],
        [4, -4],
        [4, -3],
        [4, -3],
        [4, -2],
        [6, -2],
        [4, -3],
        [6, -2],
        [4, -2],
        [7, -3],
        [6, -3],
        [6, -3],
        [7, -3],
        [8, -3],
        [8, -4],
        [9, -3],
        [8, -4],
        [9, -4],
        [8, -4],
        [10, -4],
        [8, -2],
        [7, -4],
        [7, -4],
        [7, -2],
        [6, -4],
        [5, -2],
        [5, -2],
        [5, -2],
        [5, -2],
        [5, -2],
        [5, -2],
        [6, -2],
        [5, -1],
        [5, -1],
        [6, -2],
        [6, -1],
        [4, -2],
        [6, -1],
        [6, -2],
        [3, -1],
        [5, -2],
        [5, -2],
        [4, -2],
        [5, -1],
        [4, -3],
        [5, -2],
        [5, -2],
        [6, -3],
        [6, -2],
        [6, -4],
        [7, -3],
        [6, -3],
        [7, -3],
        [6, -4],
        [7, -4],
        [5, -3],
        [6, -3],
        [5, -4],
        [6, -3],
        [4, -2],
        [6, -4],
        [4, -3],
        [6, -3],
        [4, -3],
        [4, -2],
        [5, -3],
        [4, -2],
        [6, -5],
        [5, -4],
        [4, -2],
        [5, -4],
        [5, -2],
        [5, -4],
        [6, -4],
        [5, -4],
        [5, -2],
        [5, -2],
        [5, -4],
        [4, -2],
        [6, -2],
        [4, -2],
        [4, -2],
        [4, 0],
        [4, -2],
        [4, 0],
        [3, -2],
        [4, 0],
        [4, 0],
        [3, 0],
        [3, 0],
        [3, 0],
        [3, 2],
        [3, 0],
        [3, 0],
        [3, 2],
        [3, 2],
        [3, 0],
        [4, 2],
        [2, 2],
        [4, 2],
        [2, 2],
        [3, 2],
        [2, 2],
        [2, 2],
        [2, 2],
        [2, 2],
        [2, 4],
        [2, 2],
        [1, 2],
        [2, 4],
        [0, 4],
        [2, 2],
        [2, 4],
        [2, 5],
        [0, 2],
        [2, 3],
        [2, 3],
        [0, 4],
        [2, 2],
        [2, 3],
        [2, 3],
        [2, 2],
        [2, 1],
        [2, 2],
        [2, 2],
        [2, 2],
        [4, 2],
        [3, 1],
        [4, 1],
        [5, 2],
        [4, 1],
        [4, 1],
        [4, 1],
        [3, 1],
        [4, 0],
        [2, 1],
        [2, 1],
        [1, 0],
        [1, 0],
        [2, 0],
        [1, 1],
        [2, 0],
        [2, 0],
        [3, 1],
        [2, 1],
        [4, 1],
        [4, 1],
        [4, 1],
        [4, 1],
        [4, 1],
        [4, 1],
        [6, 1],
        [4, 1],
        [4, 1],
        [6, 1],
        [4, 0],
        [4, 1],
        [5, 1],
        [4, 0],
        [4, 1],
        [5, 0],
        [4, 0],
        [4, 0],
        [5, -1],
        [5, 0],
        [5, -1],
        [5, -1],
        [6, -1],
        [5, -1],
        [6, -2],
        [5, -2],
        [6, -2],
        [6, -2],
        [6, -2],
        [4, -2],
        [4, -2],
        [4, -2],
        [4, -3],
        [3, -2],
        [3, -2],
        [3, -2],
        [3, -3],
        [2, -2],
        [4, -3],
        [3, -3],
        [3, -2],
        [3, -4],
        [4, -2],
        [4, -4],
        [4, -3],
        [4, -3],
        [4, -5],
        [4, -4],
        [3, -6],
        [4, -4],
        [3, -4],
        [4, -4],
        [4, -4],
        [2, -2],
        [4, -2],
        [2, -4],
        [2, -2],
        [2, -2],
        [4, -2],
        [2, -4],
        [4, -2],
        [5, -4],
        [5, -4],
        [6, -6],
        [7, -6],
        [6, -6],
        [7, -6],
        [8, -4],
        [7, -6],
        [7, -5],
        [6, -4],
        [6, -4],
        [5, -3],
        [6, -3],
        [4, -3],
        [5, -2],
        [5, -2],
        [4, -2],
        [3, -2],
        [2, -3],
        [4, -2],
        [2, -2],
        [2, -3],
        [4, -3],
        [2, -2],
        [2, -3],
        [2, -3],
        [2, -3],
        [2, -3],
        [2, -4],
        [2, -3],
        [2, -4],
        [4, -3],
        [1, -3],
        [2, -4],
        [3, -2],
        [2, -5],
        [3, -4],
        [2, -2],
        [2, -4],
        [2, -2],
        [2, -2],
        [2, -2],
        [1, -4],
        [1, -2],
        [1, -2],
        [2, -2],
        [0, -2],
        [1, -2],
        [1, -3],
        [0, -3],
        [0, -4],
        [0, -3],
        [1, -4],
        [0, -4],
        [0, -4],
        [1, -4],
        [0, -3],
        [0, -5],
        [0, -4],
        [0, -4],
        [1, -4],
        [1, -4],
        [0, -5],
        [2, -5],
        [1, -4],
        [1, -5],
        [2, -6],
        [2, -4],
        [2, -5],
        [2, -6],
        [2, -5],
        [2, -5],
        [4, -5],
        [2, -5],
        [3, -4],
        [4, -6],
        [4, -4],
        [3, -3],
        [4, -5],
        [6, -4],
        [6, -4],
        [6, -5],
        [6, -4],
        [5, -4],
        [8, -4],
        [6, -4],
        [7, -3],
        [6, -4],
        [7, -2],
        [6, -3],
        [6, -2],
        [6, -2],
        [5, -1],
        [6, -2],
        [5, -1],
        [6, -2],
        [6, -2],
        [6, -2],
        [8, -2],
        [7, -3],
        [8, -3],
        [8, -2],
        [7, -3],
        [8, -3],
        [8, -3],
        [8, -3],
        [7, -3],
        [7, -3],
        [6, -2],
        [6, -4],
        [6, -2],
        [6, -4],
        [6, -4],
        [5, -4],
        [6, -2],
        [4, -4],
        [5, -4],
        [5, -4],
        [0, -2],
        [3, -4],
        [4, -4],
        [4, -4],
        [5, -4],
        [2, -4],
        [4, -4],
        [2, -4],
        [3, -4],
        [2, -4],
        [2, -4],
        [2, -3],
        [1, -4],
        [2, -3],
        [1, -4],
        [0, -3],
        [1, -4],
        [1, -4],
        [0, -5],
        [0, -5],
        [0, -4],
        [0, -5],
        [0, -6],
        [0, -6],
        [0, -5],
        [-1, -6],
        [0, -6],
        [0, -6],
        [-1, -5],
        [0, -5],
        [0, -6],
        [1, -6],
        [0, -6],
        [0, -6],
        [1, -6],
        [0, -6],
        [0, -8],
        [1, -8],
        [1, -8],
        [0, -8],
        [1, -9],
        [1, -9],
        [1, -9],
        [0, -8],
        [2, -9],
        [0, -8],
        [2, -8],
        [2, -8],
        [2, -8],
        [2, -7],
        [2, -7],
        [2, -7],
        [4, -6],
        [2, -7],
        [4, -7],
        [4, -7],
        [4, -7],
        [3, -7],
        [5, -6],
        [4, -8],
        [5, -7],
        [5, -7],
        [5, -8],
        [5, -8],
        [6, -8],
        [5, -8],
        [6, -8],
        [6, -10],
        [6, -11],
        [5, -10],
        [6, -8],
        [8, -10],
        [6, -10],
        [4, -9],
        [6, -8],
        [4, -8],
        [4, -6],
        [3, -6],
        [3, -6],
        [3, -4],
        [2, -4],
        [2, -3],
        [2, -3],
        [1, -3],
        [2, -3],
        [2, -2],
        [2, -2],
        [3, -2],
        [2, -2],
        [2, -2],
        [3, -2],
        [2, -2],
        [3, -2],
        [2, -2],
        [4, -2],
        [2, -1],
        [4, 0],
        [2, -2],
        [3, -2],
        [4, 0],
        [2, -2],
        [4, 0],
        [4, 0],
        [4, 0],
        [4, 0],
        [5, 0],
        [5, 0],
        [7, 0],
        [7, 0],
        [8, 2],
        [8, 0],
        [8, 0],
        [9, 0],
        [10, 2],
        [8, 0],
        [9, 0],
        [8, 0],
        [7, 0],
        [7, -2],
        [7, 0],
        [7, 0],
        [6, -2],
        [6, 0],
        [7, -2],
        [8, -2],
        [6, 0],
        [7, -2],
        [8, -2],
        [6, 0],
        [7, -2],
        [8, -2],
        [6, 0],
        [8, -2],
        [6, 0],
        [7, -2],
        [5, 0],
        [6, -2],
        [6, -2],
        [4, 0],
        [4, -2],
        [4, 0],
        [4, 0],
        [2, -2],
        [3, 0],
        [2, 0],
        [2, 0],
        [2, -2],
        [2, 0],
        [2, 0],
        [2, -2],
        [1, 0],
        [2, 0],
        [2, -2],
        [2, 0],
        [2, 0],
        [2, -2],
        [3, 0],
        [3, -2],
        [2, 0],
        [3, -2],
        [3, 0],
        [3, -2],
        [3, 0],
        [4, -2],
        [3, 0],
        [3, -3],
        [3, 0],
        [4, -2],
        [3, 0],
        [4, -2],
        [2, -2],
        [5, 0],
        [4, -2],
        [2, 0],
        [4, -2],
        [2, 0],
        [4, 0],
        [2, -2],
        [3, 0],
        [3, -2],
        [3, 0],
        [2, 0],
        [3, 0],
        [3, -2],
        [2, 0],
        [3, 0],
        [2, 0],
        [2, -2],
        [3, 0],
        [3, 0],
        [3, -2],
        [3, 0],
        [2, -2],
        [4, 0],
        [3, -2],
        [3, 0],
        [4, -2],
        [3, 0],
        [3, -2],
        [4, -1],
        [3, -1],
        [3, -1],
        [4, -2],
        [4, -2],
        [2, -1],
        [4, -1],
        [4, -2],
        [2, -2],
        [4, -2],
        [2, -1],
        [4, -2],
        [1, -1],
        [3, -2],
        [3, -2],
        [2, -1],
        [2, -2],
        [3, -3],
        [3, -2],
        [2, -2],
        [3, -3],
        [3, -2],
        [3, -3],
        [3, -3],
        [3, -3],
        [3, -3],
        [3, -3],
        [4, -3],
        [2, -3],
        [4, -3],
        [2, -2],
        [3, -4],
        [3, -2],
        [2, -3],
        [2, -3],
        [2, -1],
        [2, -3],
        [3, -2],
        [0, -2],
        [2, -2],
        [2, -1],
        [2, -2],
        [0, -2],
        [2, -1],
        [0, -2],
        [2, -2],
        [2, -2],
        [0, -2],
        [2, -4],
        [0, -2],
        [2, -1],
        [2, -3],
        [2, -2],
        [0, -3],
        [2, -3],
        [2, -2],
        [2, -3],
        [0, -3],
        [2, -3],
        [2, -2],
        [1, -4],
        [2, -3],
        [2, -3],
        [2, -3],
        [2, -4],
        [2, -3],
        [2, -4],
        [1, -3],
        [2, -3],
        [1, -4],
        [2, -3],
        [2, -2],
        [1, -3],
        [1, -3],
        [1, -3],
        [1, -2],
        [1, -3],
        [0, -2],
        [1, -2],
        [1, -2],
        [0, -2],
        [0, -2],
        [1, -2],
        [1, -2],
        [0, -2],
        [1, -3],
        [1, -2],
        [1, -3],
        [1, -3],
        [0, -3],
        [2, -3],
        [0, -3],
        [2, -2],
        [0, -4],
        [1, -2],
        [1, -2],
        [0, -4],
        [1, -2],
        [1, -4],
        [0, -2],
        [1, -4],
        [1, -2],
        [0, -4],
        [1, -2],
        [1, -2],
        [1, -4],
        [1, -2],
        [1, -2],
        [1, -4],
        [2, -2],
        [1, -4],
        [1, -2],
        [2, -4],
        [1, -3],
        [2, -2],
        [1, -4],
        [2, -3],
        [1, -3],
        [2, -3],
        [2, -3],
        [1, -3],
        [1, -3],
        [2, -3],
        [2, -4],
        [1, -2],
        [1, -4],
        [2, -3],
        [1, -3],
        [1, -3],
        [2, -3],
        [1, -2],
        [1, -2],
        [1, -2],
        [1, -3],
        [1, -2],
        [1, -1],
        [1, -1],
        [1, -2],
        [2, -2],
        [0, -2],
        [1, -2],
        [2, 0],
        [1, -2],
        [1, -2],
        [2, 0],
        [2, -2],
        [1, -2],
        [2, -2],
        [0, -2],
        [2, -2],
        [2, -2],
        [2, 0],
        [2, -2],
        [2, -2],
        [2, -2],
        [2, -2],
        [2, -2],
        [2, -2],
        [2, 0],
        [2, -2],
        [2, -2],
        [2, -2],
        [2, 0],
        [0, -2],
        [2, -2],
        [1, 0],
        [2, -2],
        [1, 0],
        [1, -2],
        [2, 0],
        [1, -2],
        [1, 0],
        [1, -2],
        [1, 0],
        [1, -2],
        [1, 0],
        [2, -2],
        [2, -2],
        [1, 0],
        [1, -2],
        [2, -2],
        [2, 0],
        [1, -2],
        [3, -2],
        [2, -2],
        [2, -2],
        [2, -2],
        [3, -2],
        [3, -4],
        [2, -2],
        [4, -3],
        [4, -3],
        [3, -3],
        [5, -3],
        [3, -4],
        [5, -4],
        [4, -3],
        [6, -4],
        [4, -3],
        [4, -3],
        [6, -3],
        [4, -3],
        [4, -2],
        [3, -2],
        [2, -1],
        [2, -2],
        [2, 0],
        [1, -1],
        [1, -1],
        [2, 0],
        [2, -1],
        [2, -1],
        [1, 0],
        [2, 0],
        [3, -1],
        [2, -1],
        [1, 0],
        [2, -1],
        [5, -1],
        [1, 0],
        [1, 0],
        [2, -1],
        [2, 0],
        [3, -1],
        [4, 0],
        [4, -1],
        [4, -1],
        [5, 0],
        [6, -1],
        [5, -1],
        [6, -1],
        [8, -1],
        [6, -1],
        [6, -2],
        [5, 0],
        [6, -2],
        [6, -1],
        [7, -1],
        [6, -2],
        [6, -1],
        [6, 0],
        [6, -1],
        [6, -1],
        [5, 0],
        [6, 0],
        [5, 0],
        [5, 0],
        [6, 0],
        [4, 0],
        [4, 0],
        [4, 0],
        [4, 1],
        [4, 0],
        [4, 0],
        [3, 1],
        [4, 0],
        [4, 0],
        [4, 0],
        [3, 0],
        [3, 0],
        [3, 0],
        [4, 0],
        [3, 0],
        [3, 0],
        [3, 0],
        [3, 1],
        [3, 0],
        [3, 0],
        [3, 2],
        [3, 0],
        [3, 0],
        [2, 0],
        [4, 0],
        [3, 0],
        [2, 0],
        [4, 0],
        [2, 0],
        [4, -2],
        [4, 0],
        [4, -1],
        [2, 0],
        [4, 0],
        [4, -1],
        [3, -1],
        [3, 0],
        [5, 0],
        [3, -1],
        [4, 0],
        [4, 0],
        [4, -1],
        [3, 0],
        [4, 0],
        [3, 0],
        [3, 0],
        [3, 0],
        [2, 0],
        [2, 0],
        [1, 0],
        [2, 0],
        [1, 0],
        [1, -1],
        [1, -1],
        [1, 0],
        [2, -1],
        [2, -1],
        [3, -1],
        [5, -1],
        [4, -1],
        [8, -2],
        [8, -2],
        [12, -2],
        [13, -2],
        [14, -2],
        [17, -2],
        [17, -2],
        [17, -2],
        [18, -2],
        [18, 0],
        [16, -2],
        [14, -2],
        [14, 0],
        [12, -2],
        [12, 0],
        [11, 0],
        [10, -2],
        [9, 0],
        [9, -2],
        [10, 0],
        [7, 0],
        [10, -2],
        [8, -2],
        [9, 0],
        [8, -2],
        [8, 0],
        [8, -2],
        [8, -1],
        [7, -1],
        [8, -1],
        [6, -2],
        [6, -1],
        [6, -1],
        [5, -1],
        [4, -1],
        [4, -1],
        [3, -1],
        [3, 0],
        [2, -1],
        [2, -1],
        [2, 0],
        [1, -1],
        [1, 0],
        [1, -1],
        [1, 0],
        [1, -1],
        [1, 0],
        [1, -1],
        [2, -1],
        [1, -1],
        [1, 0],
        [1, 0],
        [1, -1],
        [2, -1],
        [0, -1],
        [1, 0],
        [1, -1],
        [2, -1],
        [2, -1],
        [1, -1],
        [1, 0],
        [2, -1],
        [0, -1],
        [2, 0],
        [1, -2],
        [1, 0],
        [1, -1],
        [1, -1],
        [2, 0],
        [0, -1],
        [2, -1],
        [1, -1],
        [0, -1],
        [2, 0],
        [1, -1],
        [1, -1],
        [1, -1],
        [1, 0],
        [2, -2],
        [1, -1],
        [2, -1],
        [0, -2],
        [2, 0],
        [2, -2],
        [0, -1],
        [2, -1],
        [2, -1],
        [0, -1],
        [2, -2],
        [2, 0],
        [0, -2],
        [2, -1],
        [2, -1],
        [0, -1],
        [2, -1],
        [0, -1],
        [2, 0],
        [0, -2],
        [2, -1],
        [0, -1],
        [2, -1],
        [0, -1],
        [2, 0],
        [0, -1],
        [2, -1],
        [0, -1],
        [0, -1],
        [2, 0],
        [0, -2],
        [1, 0],
        [1, -1],
        [1, -1],
        [1, -1],
        [1, -2],
        [1, -1],
        [1, -2],
        [1, -2],
        [7, 73],
        [84, 891],
        [111, 1188],
        [1488, 2586],
        [5016, 8706],
        [1434, 2488],
        [2565, 4439],
        [728, 1262],
        [111, 191],
        [86, -181],
        [166, -202],
        [76, -101],
        [132, -166],
        [116, -148],
        [181, -236],
        [69, -85],
        [141, -181],
        [60, -77],
        [16, -13],
        [8, -21],
        [18, -18],
        [13, -30],
        [0, -12],
        [-11, -18],
        [-16, -10],
        [-14, -16],
        [-22, -26],
        [-6, -17],
        [11, -25],
        [10, -25],
        [0, -27],
        [-10, -20],
        [-4, -15],
        [-11, -13],
        [0, -33],
        [-4, -18],
        [12, -44],
        [10, -30],
        [16, -21],
        [10, -21],
        [6, -25],
        [0, -34],
        [14, -28],
        [13, -11],
        [0, -14],
        [17, -9],
        [0, -18],
        [-7, -8],
        [7, -18],
        [16, -6],
        [10, -18],
        [4, -41],
        [3, -21],
        [10, -14],
        [2, -54],
        [8, -23],
        [0, -12],
        [10, -12],
        [-6, -22],
        [-6, -23],
        [0, -29],
        [16, -30],
        [-4, -8],
        [7, -22],
        [7, -21],
        [13, -17],
        [17, -51],
        [14, -30],
        [0, -13],
        [7, -27],
        [0, -11],
        [3, -17],
        [4, -12],
        [9, -21],
        [0, -13],
        [10, -6],
        [7, -6],
        [7, 0],
        [380, 2],
        [873, -1301],
        [-411, -277],
        [104, -308],
        [-22, -58],
        [-541, -1337],
        [-235, 0],
        [-227, 2],
        [-786, 4],
        [-265, 2],
        [-345, 2],
        [0, -171],
        [0, -396],
        [-2, -293],
        [0, -356],
        [0, -384],
        [-2, -808],
        [2247, -919],
        [4359, -1787],
        [53, -2395],
        [67, -164],
        [934, -2268],
        [932, -3290],
        [844, -2990],
        [310, -1094],
        [201, -652],
        [1085, -6488],
        [121, -1077],
        [4, -38],
        [25, -222],
        [38, -342],
        [489, -4350],
        [2, -8],
        [238, -2115],
        [-441, -3057],
        [-4, -30],
        [175, 2],
        [301, 16],
        [8, -48],
        [374, 97],
        [2, -66],
        [5, -66],
        [-2, -47],
        [22, -191],
        [-150, -52],
        [-34, -65],
        [-66, -188],
        [-19, -30],
        [-23, -32],
        [-32, -65],
        [0, -2],
        [-11, -20],
        [0, -23],
        [-18, -40],
        [-15, -48],
        [0, -32],
        [-28, -43],
        [-13, -21],
        [-11, -45],
        [-14, -29],
        [0, -8],
        [-15, -4],
        [-5, -17],
        [-14, -15],
        [-19, -8],
        [-39, -9],
        [-32, -21],
        [-40, 8],
        [-17, -6],
        [-20, -6],
        [-24, -12],
        [-23, -10],
        [-17, 0],
        [-17, 2],
        [-196, -34],
        [-181, -27],
        [-35, -10],
        [-46, -22],
        [-29, -8],
        [-6, 0],
        [0, 17],
        [-361, -44],
        [-171, -31],
        [0, 6],
        [-458, -10],
        [2, -26],
        [-737, -21],
        [-6, -72],
        [-24, -150],
        [-104, -148],
        [-30, -210],
        [-242, 66],
        [-115, -171],
        [-329, -338],
        [-2, -60],
        [-1972, 73],
        [-741, 89],
        [-2, 0],
        [-15, 1],
        [-37, 2],
        [-38, 1],
        [-60, 2],
        [-54, 3],
        [-53, 2],
        [-54, 2],
        [-115, 4],
        [-112, 5],
        [-503, 19],
        [-342, 13],
        [-392, 15],
        [-2, 0],
        [-44, -385],
        [-4, -6],
        [-21, -27],
        [-90, -108],
        [-145, -197],
        [-21, -26],
        [-180, -132],
        [-236, -107],
        [-199, -73],
        [-154, -59],
        [-150, -44],
        [-135, -38],
        [-303, -48],
        [-273, -28],
        [-221, -2],
        [-180, -41],
        [-270, -112],
        [-144, -21],
        [-128, -91],
        [-100, 37],
        [-154, -146],
        [-74, -6],
        [-56, -27],
        [-57, -61],
        [-58, -79],
        [-26, -120],
        [-26, -29],
        [-178, -26],
        [-71, -5],
        [-126, -23],
        [-19, 9],
        [-129, -16],
        [-61, -8],
        [-58, -8],
        [-50, -14],
        [-251, -10],
        [-99, -8],
        [-92, -34],
        [-15, -3],
        [-282, -58],
        [-4, -6],
        [-20, 0],
        [-43, -14],
        [-3, -76],
        [-767, -57],
        [-3, -127],
        [-50, -24],
        [-253, 11],
        [-298, 247],
        [-344, 26],
        [-473, -191],
        [-19, 2],
        [-2, 40],
        [-107, -22],
        [-6, 2],
        [-404, 24],
        [-451, 93],
        [-839, -109],
        [-53, 56],
        [-78, -2],
        [-63, -7],
        [-46, 11],
        [-73, 20],
        [-21, 23],
        [-14, 50],
        [-81, 66],
        [-28, 65],
        [-7, 40],
        [-33, -2],
        [-30, 19],
        [-16, 8],
        [-21, -39],
        [-21, 19],
        [-14, 15],
        [-12, -23],
        [-14, 17],
        [-29, 14],
        [-25, 22],
        [-8, 9],
        [-8, 14],
        [-16, 21],
        [-18, 20],
        [-15, 18],
        [-8, 18],
        [-9, 42],
        [-25, 36],
        [-36, 29],
        [-12, 15],
        [-1, 18],
        [16, 19],
        [32, 14],
        [20, 23],
        [10, 17],
        [-4, 24],
        [-18, 20],
        [-16, 20],
        [-27, 12],
        [-23, 7],
        [-39, 27],
        [-44, 9],
        [-20, 3],
        [-12, 16],
        [-6, 19],
        [-20, 11],
        [-19, -7],
        [-22, -11],
        [-30, 46],
        [-33, 12],
        [-9, 22],
        [-2, 10],
        [-54, 31],
        [-19, 10],
        [-11, 4],
        [-8, 4],
        [-10, 6],
        [-17, 6],
        [-71, 2],
        [-8, 16],
        [-8, 21],
        [-6, 18],
        [-9, 20],
        [-9, 9],
        [-14, 8],
        [-22, 7],
        [-19, 34],
        [-18, 14],
        [-12, 2],
        [-12, -2],
        [-9, -10],
        [-12, -4],
        [-7, 2],
        [-6, 6],
        [0, 8],
        [-3, 14],
        [-13, 0],
        [-12, 10],
        [-6, 10],
        [-6, 8],
        [-46, 28],
        [-23, 17],
        [-14, 13],
        [-12, 17],
        [-27, 24],
        [-17, 11],
        [-22, 9],
        [-32, 18],
        [-21, 18],
        [-6, 17],
        [-11, 16],
        [12, 15],
        [-14, 35],
        [-7, 19],
        [-4, 17],
        [-8, 9],
        [12, 11],
        [-1, 14],
        [-7, 20],
        [9, 39],
        [32, 36],
        [4, 43],
        [-29, 23],
        [-89, 150],
        [-145, 89],
        [-336, 145],
        [-43, -7],
        [-22, 3],
        [-88, -30],
        [-41, -22],
        [-94, -117],
        [-56, -95],
        [-105, -135],
        [-90, -99],
        [-95, -6],
        [-77, -4],
        [-46, -8],
        [-53, -59],
        [-108, -86],
        [-129, -78],
        [-165, -102],
        [-245, -273],
        [-270, 28],
        [-118, -82],
        [-116, -98],
        [-99, -45],
        [-167, -30],
        [-187, -20],
        [-166, -35],
        [-11, -2],
        [-61, -37],
        [-142, 361],
        [-414, 301],
        [-319, 232],
        [-414, 1420],
        [-80, 334],
        [-77, -49],
        [-77, 66],
        [-136, -113],
        [-98, 89],
        [-18, 59],
        [-90, 86],
        [-58, 66],
        [-21, 44],
        [-39, 46],
        [-74, 104],
        [32, 17],
        [73, -20],
        [61, -5],
        [32, -5],
        [16, 35],
        [30, 18],
        [32, 34],
        [11, 115],
        [-45, 18],
        [8, 32],
        [23, 40],
        [-59, 40],
        [-57, 29],
        [-57, 43],
        [-42, 17],
        [-30, 44],
        [-29, 53],
        [-22, 58],
        [-24, 46],
        [-46, 38],
        [-49, 89],
        [-30, 50],
        [-46, 53],
        [-24, 41],
        [-35, 53],
        [-37, 54],
        [-27, 36],
        [-15, 47],
        [-17, 33],
        [-64, 26],
        [-41, 36],
        [-29, 42],
        [-20, 53],
        [-13, 55],
        [-72, 64],
        [-90, -132],
        [-33, 8],
        [-41, 19],
        [-27, 29],
        [2, 53],
        [-21, 30],
        [-20, 21],
        [-30, 16],
        [-36, 19],
        [-123, 109],
        [-34, 25],
        [-206, 201],
        [-364, 261],
        [-26, 18],
        [-18, -16],
        [-11, -19],
        [-34, -47],
        [-14, -24],
        [-13, -16],
        [-14, -13],
        [-20, -16],
        [-24, -10],
        [2, -21],
        [6, -25],
        [6, -17],
        [4, -11],
        [13, -20],
        [14, -28],
        [8, -23],
        [3, -28],
        [6, -20],
        [8, -18],
        [-1, -13],
        [7, -17],
        [19, -20],
        [12, -20],
        [3, -20],
        [9, -24],
        [17, -7],
        [25, -18],
        [31, -13],
        [24, -19],
        [20, -34],
        [6, -36],
        [-4, -30],
        [-15, -28],
        [-16, -10],
        [-21, -6],
        [-19, -4],
        [-37, 3],
        [-43, 6],
        [-49, -2],
        [-38, -7],
        [-28, -15],
        [-8, -12],
        [-2, -16],
        [-3, -25],
        [-8, -25],
        [4, -25],
        [-2, -20],
        [3, -20],
        [5, -44],
        [-11, -41],
        [-7, -23],
        [-6, -20],
        [0, -31],
        [-1, -23],
        [8, -20],
        [3, -28],
        [3, -42],
        [-7, -36],
        [6, -38],
        [11, -32],
        [2, -21],
        [1, -24],
        [-12, -48],
        [-9, -20],
        [-12, -15],
        [-25, -16],
        [-50, -13],
        [-30, -11],
        [-26, -8],
        [-16, -18],
        [-16, -12],
        [-8, -21],
        [-22, -25],
        [-11, -14],
        [-24, -9],
        [-36, -15],
        [-27, -29],
        [-23, -29],
        [-12, -19],
        [-16, -20],
        [-7, -24],
        [-18, -22],
        [-17, -16],
        [-10, -20],
        [-1, -38],
        [1, -26],
        [15, -24],
        [7, -17],
        [1, -38],
        [-2, -24],
        [-2, -32],
        [1, -34],
        [4, -22],
        [4, -14],
        [-4, -24],
        [18, -17],
        [17, -29],
        [9, -42],
        [22, -28],
        [4, -40],
        [10, -33],
        [-77, 7],
        [-4086, 1943],
        [0, -4],
        [-21, -14],
        [-975, -1613],
        [-516, 297],
        [-170, 97],
        [-237, 138],
        [-248, 144],
        [-896, 510],
        [-40, 25],
        [-717, 459],
        [-46, 28],
        [-659, 421],
        [-2, 2],
        [-154, 98],
        [-78, -122],
        [-120, -188],
        [-67, -104],
        [-70, -109],
        [-87, -136],
        [-79, -125],
        [-68, -105],
        [-127, -187],
        [-62, -91],
        [-134, -197],
        [-43, -65],
        [-139, -201],
        [-297, -438],
        [-2, -2],
        [-46, -69],
        [-123, -178],
        [-33, -49],
        [-148, -214],
        [-85, -124],
        [-166, -227],
        [-769, 896],
        [-682, -2297],
        [-1227, 911],
        [-299, 283],
        [-260, 199],
        [-232, 127],
        [-32, 19],
        [-327, 171],
        [-156, 82],
        [-20, -9],
        [-25, -24],
        [-10, -17],
        [-26, 18],
        [-26, 17],
        [-20, 12],
        [-34, 5],
        [-83, -29],
        [-8, 3],
        [-102, -31],
        [-51, -17],
        [55, -42],
        [-194, 77],
        [-199, -27],
        [-88, -18],
        [-275, 35],
        [-20, 6],
        [-244, 206],
        [-28, 36],
        [-27, 25],
        [-19, 34],
        [-30, 51],
        [-12, 26],
        [1, 26],
        [19, 45],
        [-32, 11],
        [-53, 23],
        [-40, 8],
        [-45, 6],
        [-115, -23],
        [-80, -17],
        [-68, -9],
        [-79, -3],
        [-46, 4],
        [-58, -37],
        [-141, -50],
        [-4, -47],
        [-86, -69],
        [-9, 4],
        [-144, -226],
        [-58, -119],
        [-93, -150],
        [-6, -81],
        [-1, -205],
        [-330, 226],
        [-4, -10],
        [-71, 7],
        [-65, 6],
        [-775, 77],
        [-20, -207],
        [-5, -1],
        [-301, -15],
        [-307, -8],
        [-310, -15],
        [-34, -239],
        [-306, -7],
        [36, 232],
        [-308, -14],
        [26, 230],
        [-270, -16],
        [-160, -6],
        [8, 246],
        [-185, -8],
        [-18, 236],
        [205, 10],
        [0, 5],
        [-20, 232],
        [0, 3],
        [-2, 100],
        [-249, -18],
        [-16, 10],
        [-14, 14],
        [-24, 29],
        [-35, 43],
        [-19, 15],
        [-16, 8],
        [-31, 4],
        [-17, 10],
        [-14, 15],
        [-8, 15],
        [-10, 22],
        [-7, 19],
        [-10, 26],
        [-4, 13],
        [-12, 11],
        [-20, 7],
        [-19, 16],
        [-26, 16],
        [-7, 23],
        [5, 13],
        [10, 22],
        [-3, 23],
        [-12, 17],
        [-22, 16],
        [-29, 64],
        [-20, 32],
        [-13, 25],
        [-21, 23],
        [-32, 33],
        [-7, 14],
        [3, 32],
        [-20, 14],
        [-15, -6],
        [-27, -6],
        [-36, 23],
        [-30, 17],
        [-27, 24],
        [-32, 16],
        [-65, 30],
        [-29, -36],
        [-14, 8],
        [-18, 12],
        [-32, 13],
        [-68, 27],
        [-26, -16],
        [-73, 30],
        [-116, -113],
        [-38, -58],
        [-83, -22],
        [-16, -62],
        [-55, -42],
        [-96, -47],
        [-29, -58],
        [-16, 2],
        [-58, -47],
        [-19, -32],
        [-15, -34],
        [13, -24],
        [12, -41],
        [-16, -36],
        [-15, -23],
        [-11, -14],
        [-16, -3],
        [-22, 13],
        [-14, -7],
        [0, -19],
        [6, -30],
        [17, -28],
        [0, -4],
        [-6, -12],
        [-9, -3],
        [-8, 0],
        [-6, 5],
        [-6, 10],
        [-12, 3],
        [-8, -9],
        [-7, -21],
        [9, -32],
        [-5, -22],
        [-15, -18],
        [-17, -17],
        [-26, -13],
        [-18, 1],
        [-27, 4],
        [-24, 8],
        [-16, -13],
        [-17, -19],
        [-8, -19],
        [-16, -5],
        [-25, 5],
        [-40, 12],
        [-23, -5],
        [-9, -14],
        [-27, -24],
        [-13, -18],
        [-11, -10],
        [-27, -2],
        [-26, 12],
        [-27, 12],
        [-35, 8],
        [-18, -4],
        [-7, -18],
        [2, -37],
        [-14, -22],
        [-19, -3],
        [-10, -19],
        [0, -32],
        [-2, -18],
        [-8, -12],
        [-10, -8],
        [-13, -7],
        [-12, 0],
        [-16, 0],
        [-13, 22],
        [-10, 38],
        [-10, 8],
        [-15, -5],
        [-34, -11],
        [-19, -17],
        [10, -22],
        [-8, -15],
        [-11, -5],
        [-22, -6],
        [-26, -19],
        [-23, -8],
        [-13, 5],
        [-1, 19],
        [-33, -9],
        [-25, -1],
        [-39, -9],
        [-45, 22],
        [-15, -14],
        [-6, -21],
        [-8, -12],
        [-24, -3],
        [-24, 6],
        [-22, -7],
        [-11, 20],
        [-2, 25],
        [0, 20],
        [-14, 7],
        [-17, -10],
        [-13, -24],
        [4, -14],
        [6, -10],
        [6, -17],
        [1, -11],
        [-8, -5],
        [-11, -7],
        [-19, -6],
        [-25, 4],
        [-10, 0],
        [-8, -6],
        [0, -12],
        [-6, -8],
        [-16, -7],
        [-16, 13],
        [-11, 14],
        [-9, 8],
        [-13, 0],
        [-14, -10],
        [-18, -2],
        [-8, 19],
        [-13, 3],
        [-7, -10],
        [-6, -14],
        [-5, -14],
        [-4, -9],
        [-9, -4],
        [-11, 19],
        [-10, 20],
        [-13, 12],
        [-24, 0],
        [-45, 1],
        [-22, 14],
        [-22, 8],
        [-22, -14],
        [-31, -13],
        [-21, -12],
        [-28, 2],
        [-25, 10],
        [-23, 15],
        [-12, 27],
        [-8, 25],
        [-6, 33],
        [-5, 28],
        [-18, 17],
        [-4, 3],
        [-2, 1],
        [-31, 7],
        [-14, -2],
        [-25, -13],
        [-24, -8],
        [-26, 3],
        [-22, 2],
        [-29, 3],
        [-25, -5],
        [-12, -11],
        [-10, -17],
        [6, -18],
        [-6, -20],
        [-8, -14],
        [-21, -11],
        [-92, 1],
        [-107, -4],
        [-41, 8],
        [-35, 27],
        [-21, 48],
        [-10, 22],
        [-16, -13],
        [-10, -13],
        [-17, -15],
        [-29, -13],
        [-35, 6],
        [-32, 12],
        [-26, 19],
        [-14, 27],
        [0, 18],
        [-12, 30],
        [-30, 1],
        [-54, -15],
        [-31, 14],
        [-19, 19],
        [-24, 22],
        [-8, 40],
        [1, 32],
        [-14, 18],
        [-14, -2],
        [-16, -34],
        [-3, -58],
        [-9, -25],
        [-21, -4],
        [-14, 5],
        [-35, 56],
        [-12, 37],
        [0, 23],
        [2, 23],
        [-6, 12],
        [-19, -2],
        [-13, -23],
        [-4, -26],
        [-5, -30],
        [-1, -14],
        [-13, -6],
        [-16, 8],
        [-14, 12],
        [-9, 31],
        [-8, 25],
        [-8, 24],
        [-12, 21],
        [-28, 20],
        [-21, 6],
        [13, -34],
        [5, -28],
        [-16, -24],
        [-12, -30],
        [-50, -35],
        [-16, -28],
        [-20, -24],
        [-86, -26],
        [-45, -25],
        [-34, -29],
        [-72, -81],
        [-54, -79],
        [-43, -27],
        [-63, -19],
        [-94, -8],
        [-54, -3],
        [-88, 15],
        [19, -36],
        [-19, -45],
        [-37, -14],
        [-81, -30],
        [-96, 10],
        [-281, 100],
        [-215, -20],
        [-245, -24],
        [-1438, -145],
        [-1574, -159],
        [-87, 302],
        [-41, 42],
        [-38, 38],
        [-319, 229],
        [-353, 46],
        [84, -165],
        [6, -37],
        [-56, -63],
        [-82, -41],
        [-57, -6],
        [-43, 31],
        [-36, 43],
        [-75, -33],
        [-43, 74],
        [-80, -16],
        [-32, -49],
        [13, -72],
        [-82, 28],
        [-146, 23],
        [-47, -51],
        [14, -43],
        [62, -8],
        [5, -20],
        [-9, -22],
        [-18, -8],
        [-19, 0],
        [-18, 4],
        [-33, 6],
        [-32, 18],
        [-33, 30],
        [-24, 32],
        [-20, 64],
        [-12, 16],
        [-21, 13],
        [-12, 0],
        [-13, -6],
        [-16, -10],
        [-16, -4],
        [-17, -2],
        [-14, 0],
        [-14, 1],
        [-11, -4],
        [-6, -4],
        [-5, -10],
        [0, -17],
        [-6, -5],
        [-10, -2],
        [-28, 22],
        [-12, 19],
        [-12, 16],
        [-7, 16],
        [-8, 12],
        [-17, 10],
        [-12, 10],
        [-31, 18],
        [-15, 7],
        [-18, 7],
        [-27, 13],
        [-4, 0],
        [-18, 11],
        [-27, 0],
        [-13, -6],
        [-2, -3],
        [-9, -52],
        [0, -13],
        [2, -14],
        [-8, -16],
        [-3, -31],
        [0, -13],
        [-9, -11],
        [-20, -15],
        [1, -29],
        [8, -10],
        [-6, -4],
        [0, -6],
        [8, -4],
        [-6, -32],
        [27, -23],
        [-2, -15],
        [-3, -37],
        [-16, 6],
        [-26, 11],
        [-10, -7],
        [-12, -9],
        [-2, -3],
        [-15, -50],
        [-36, -13],
        [-9, -19],
        [0, -34],
        [34, -24],
        [15, 0],
        [13, -10],
        [8, -14],
        [20, -10],
        [16, -18],
        [12, -29],
        [0, -7],
        [5, -9],
        [-13, -33],
        [-26, 0],
        [-26, -9],
        [-34, -1],
        [-25, -8],
        [-17, -15],
        [2, -56],
        [5, -10],
        [8, -14],
        [7, -12],
        [-9, -56],
        [-9, -31],
        [-12, -34],
        [21, -26],
        [11, -11],
        [13, -39],
        [-18, -27],
        [-21, -13],
        [-26, -12],
        [-18, -5],
        [-25, -5],
        [-18, 2],
        [-44, -6],
        [-18, -3],
        [-42, -17],
        [-4, -5],
        [-6, -26],
        [0, -77],
        [-10, -41],
        [0, -6],
        [-60, -50],
        [-43, -18],
        [-35, 0],
        [-41, -8],
        [-22, -10],
        [-19, -20],
        [0, -18],
        [7, -25],
        [10, -22],
        [6, -17],
        [-8, -15],
        [-36, -28],
        [-34, -21],
        [-7, -19],
        [4, -16],
        [35, -37],
        [14, -14],
        [18, -25],
        [16, -13],
        [6, -12],
        [10, -19],
        [0, -23],
        [-8, -31],
        [-12, -36],
        [0, -106],
        [6, -16],
        [12, -9],
        [15, -31],
        [-4, -39],
        [-55, -42],
        [-66, -36],
        [20, -151],
        [105, -127],
        [33, -138],
        [-1, -107],
        [-15, -91],
        [105, -127],
        [20, -48],
        [12, -11],
        [0, -7],
        [4, -51],
        [40, -43],
        [-30, -29],
        [-46, -1],
        [-85, -36],
        [-17, -21],
        [6, -43],
        [26, -66],
        [-11, -43],
        [101, -103],
        [36, -21],
        [0, -15],
        [-14, -94],
        [16, -32],
        [4, -61],
        [-89, -72],
        [-71, -84],
        [-37, -73],
        [5, -64],
        [-81, -42],
        [15, -26],
        [11, -21],
        [10, -17],
        [12, -29],
        [14, -11],
        [18, -8],
        [16, -11],
        [11, -18],
        [3, -6],
        [4, -17],
        [-4, -12],
        [-7, -8],
        [-16, -4],
        [-13, -12],
        [0, -18],
        [13, -32],
        [7, -22],
        [7, -27],
        [-49, -30],
        [-10, -58],
        [-19, -32],
        [-12, -38],
        [-7, -49],
        [2, -47],
        [-16, -26],
        [-6, -29],
        [14, -24],
        [8, -28],
        [-9, -11],
        [-35, -15],
        [-20, -19],
        [-4, -32],
        [2, -24],
        [7, -38],
        [-33, -28],
        [0, -27],
        [20, -45],
        [23, -22],
        [-3, -29],
        [-14, -18],
        [-56, -1],
        [-52, -35],
        [-27, -45],
        [-13, -16],
        [-81, -96],
        [-59, -103],
        [-19, -28],
        [-17, -86],
        [-8, -81],
        [6, -50],
        [-53, -30],
        [-35, -35],
        [-18, -53],
        [-7, -41],
        [9, -14],
        [22, -41],
        [39, -75],
        [-5, -27],
        [-26, -38],
        [-22, -27],
        [-37, -6],
        [-195, -314],
        [-64, 53],
        [-48, -71],
        [-357, -159],
        [89, -101],
        [14, -38],
        [-2, -54],
        [-12, -73],
        [-14, -68],
        [-39, -67],
        [-42, -33],
        [-57, -2],
        [-35, -2],
        [-44, -23],
        [-39, -50],
        [-47, -14],
        [-66, -18],
        [-41, -14],
        [-20, -15],
        [-24, -16],
        [-15, -14],
        [-22, -24],
        [-27, -34],
        [-20, -18],
        [-33, -14],
        [-5, -8],
        [-25, -38],
        [-52, -15],
        [-31, -67],
        [-11, -46],
        [-18, -26],
        [-36, -42],
        [-39, -52],
        [7, -24],
        [-35, -30],
        [-33, -11],
        [-34, -50],
        [-8, -50],
        [8, -10],
        [-3, -7],
        [-22, -32],
        [-19, -12],
        [-18, -7],
        [-22, -7],
        [-34, 0],
        [-20, 0],
        [-15, -12],
        [-16, -10],
        [-13, -8],
        [-16, -4],
        [-11, 2],
        [-11, 12],
        [-17, 4],
        [-35, 6],
        [-31, -2],
        [-25, 2],
        [-12, -8],
        [-12, -12],
        [-12, 0],
        [-14, 6],
        [-51, 35],
        [-28, 15],
        [-15, 4],
        [-27, -5],
        [-15, 10],
        [-20, 21],
        [-25, 14],
        [-19, 16],
        [-22, 3],
        [-30, -16],
        [-20, -14],
        [-11, -18],
        [-14, -11],
        [-20, -12],
        [-26, -18],
        [-30, -8],
        [-26, -8],
        [-40, -10],
        [-40, 0],
        [-27, 6],
        [-34, 30],
        [-22, 13],
        [-17, -2],
        [-19, -8],
        [-30, -19],
        [-32, -24],
        [-25, -33],
        [-24, -13],
        [-26, -12],
        [-60, -3],
        [-31, 2],
        [-23, -14],
        [-21, -4],
        [-28, -10],
        [-21, -9],
        [-20, -10],
        [-17, 5],
        [-15, 4],
        [-15, -1],
        [-10, -15],
        [-2, -48],
        [-12, -57],
        [-7, -26],
        [-17, -27],
        [-21, -24],
        [-25, -15],
        [-6, -9],
        [-2, -23],
        [3, -28],
        [0, -37],
        [1, -20],
        [-1, -12],
        [-4, -15],
        [-24, -25],
        [-13, -13],
        [-2, -17],
        [12, -21],
        [13, -20],
        [4, -11],
        [-19, -15],
        [-28, -15],
        [-12, -12],
        [-1, -5],
        [29, -52],
        [27, -13],
        [33, -16],
        [11, -10],
        [11, -22],
        [8, -21],
        [-22, -27],
        [-17, -45],
        [-3, -50],
        [-4, -36],
        [-7, -43],
        [-15, -48],
        [2, -42],
        [11, -40],
        [28, -43],
        [23, -50],
        [10, -28],
        [-2, -25],
        [-10, -40],
        [-24, -20],
        [-24, -24],
        [-17, -14],
        [-58, -18],
        [-54, -4],
        [-81, -15],
        [-61, -15],
        [-24, -21],
        [-33, -8],
        [-22, -10],
        [-11, -8],
        [-22, -2],
        [-16, -10],
        [-21, -20],
        [-16, -7],
        [-13, -1],
        [-22, 2],
        [-15, -10],
        [-22, -1],
        [-13, 11],
        [-15, 8],
        [-34, -2],
        [-40, 5],
        [-24, 1],
        [-22, 10],
        [-27, 2],
        [-19, -11],
        [-32, -19],
        [-23, -14],
        [-24, -32],
        [-32, -25],
        [-38, -21],
        [-39, -14],
        [-60, -3],
        [-37, 1],
        [-47, 4],
        [-39, -4],
        [-23, -6],
        [-34, -11],
        [-29, -19],
        [-10, -15],
        [1, -20],
        [15, -14],
        [17, -24],
        [7, -46],
        [-3, -35],
        [-14, -44],
        [3, -39],
        [-7, -17],
        [-19, -6],
        [-19, -2],
        [-4, -15],
        [-8, -17],
        [-9, -13],
        [-20, -9],
        [-20, 3],
        [-24, 0],
        [-16, -8],
        [-4, -15],
        [4, -9],
        [-6, -11],
        [-6, -16],
        [-13, -29],
        [-17, -15],
        [-11, -21],
        [17, -17],
        [13, -11],
        [9, -4],
        [6, -53],
        [-80, -14],
        [-88, 52],
        [-64, -22],
        [-82, 10],
        [-61, 42],
        [1, -50],
        [-100, -96],
        [-140, 54],
        [-113, 73],
        [-74, 0],
        [-83, 20],
        [-95, 10],
        [-37, -6],
        [-10, -2],
        [-23, -4],
        [-79, 46],
        [-137, 141],
        [-80, 16],
        [-63, 15],
        [-33, 6],
        [-48, 96],
        [-24, 10],
        [-31, -2],
        [-15, -8],
        [-8, -22],
        [-16, -7],
        [-39, -11],
        [-71, -28],
        [-27, -59],
        [-7, -10],
        [-31, -21],
        [-8, 5],
        [-8, -6],
        [-36, 18],
        [-8, -5],
        [-47, -26],
        [-54, -54],
        [-219, -17],
        [-392, 90],
        [-454, -133],
        [-102, -83],
        [-27, -10],
        [-107, -37],
        [-587, -77],
        [0, -295],
        [57, -339],
        [-26, -93],
        [-15, -56],
        [-22, -79],
        [-10, -52],
        [-6, -68],
        [-5, -59],
        [7, -28],
        [75, -6],
        [-4, -60],
        [-4, -53],
        [2, -41],
        [14, -24],
        [6, -12],
        [-6, -52],
        [-4, -34],
        [50, -111],
        [61, -139],
        [-50, -85],
        [36, -49],
        [66, -18],
        [-39, -104],
        [45, -83],
        [40, 16],
        [53, -26],
        [10, 10],
        [6, -32],
        [-29, -37],
        [-9, -77],
        [9, -40],
        [33, -26],
        [53, -79],
        [21, 7],
        [9, -23],
        [1, -38],
        [4, -28],
        [17, -26],
        [21, -14],
        [-6, -19],
        [-11, -22],
        [-14, -16],
        [-18, -21],
        [26, -31],
        [37, -2],
        [38, -18],
        [17, -37],
        [3, -37],
        [-13, -33],
        [3, -19],
        [-5, -15],
        [5, -19],
        [18, -42],
        [3, -36],
        [21, -48],
        [32, -71],
        [58, -58],
        [35, -28],
        [37, -37],
        [0, -22],
        [-10, -24],
        [-13, -10],
        [-36, -13],
        [-27, -13],
        [-8, -29],
        [-5, -20],
        [-1, -6],
        [-3, -15],
        [-10, -29],
        [-1, -2],
        [-2, -4],
        [0, -1],
        [-2, -2],
        [-3, -4],
        [-47, -57],
        [-29, -62],
        [-25, -46],
        [-22, -66],
        [-12, -57],
        [-6, -53],
        [-42, -33],
        [-39, -81],
        [-33, -78],
        [-2, -35],
        [0, -16],
        [2, -44],
        [-22, -50],
        [-14, -65],
        [26, -57],
        [34, -32],
        [7, -59],
        [8, -38],
        [11, -31],
        [-7, -19],
        [-13, -28],
        [-14, -16],
        [12, -37],
        [13, -19],
        [-12, -32],
        [-47, 3],
        [-11, -30],
        [-13, -42],
        [-3, -66],
        [-5, -62],
        [-13, -35],
        [-18, -45],
        [4, -29],
        [-2, -30],
        [-18, -43],
        [-2, -33],
        [15, -35],
        [12, -18],
        [5, -20],
        [-22, -14],
        [-36, 6],
        [-20, -42],
        [4, -46],
        [28, -26],
        [0, -35],
        [-6, -7],
        [-3, -6],
        [-9, -15],
        [-12, -19],
        [-14, -21],
        [-26, -28],
        [1, -23],
        [14, -29],
        [31, -17],
        [-13, -43],
        [-8, -30],
        [-2, -26],
        [-14, -59],
        [47, -5],
        [26, -25],
        [16, -27],
        [21, -20],
        [32, -21],
        [16, -26],
        [-2, -42],
        [-18, -60],
        [4, -67],
        [32, -66],
        [31, -34],
        [19, -46],
        [20, -40],
        [48, -18],
        [26, -12],
        [0, -18],
        [-12, -20],
        [-20, -24],
        [26, -13],
        [30, -28],
        [38, -28],
        [8, -29],
        [-6, -29],
        [2, -24],
        [-1, -29],
        [-32, -37],
        [-6, -46],
        [-9, -29],
        [11, -26],
        [7, -16],
        [8, -22],
        [0, -22],
        [-4, -14],
        [-8, -18],
        [-38, 2],
        [-8, -65],
        [-16, -12],
        [-27, -21],
        [-13, -3],
        [-11, -15],
        [-18, -15],
        [-26, -2],
        [-31, -33],
        [-10, -32],
        [-10, -26],
        [1, -18],
        [-62, -43],
        [15, -59],
        [-137, -198],
        [-204, -113],
        [-109, -53],
        [-195, -68],
        [-126, -49],
        [-288, -93],
        [87, -75],
        [-1621, -1823],
        [-1004, -2250],
        [-862, -480],
        [-1139, 1955],
        [-227, 400],
        [-143, 252],
        [-116, -72],
        [-165, -94],
        [-308, -181],
        [-422, -248],
        [-12, -8],
        [-13, -6],
        [-108, -65],
        [-4, -2],
        [-229, -133],
        [-172, -101],
        [-168, -103],
        [-437, -258],
        [-409, -367],
        [-549, -492],
        [-2160, -1900],
        [-889, -782],
        [-2324, -1855],
        [0, -1],
        [-134, 74],
        [-649, -699],
        [-64, -414],
        [-122, -795],
        [-1171, 134],
        [-674, 200],
        [-1, 0],
        [-290, -1586],
        [-1518, 253],
        [-1, 0],
        [927, -823],
        [12, -11],
        [429, -381],
        [737, -1559],
        [-28, -44],
        [78, -49],
        [0, 0],
        [222, 372],
        [964, -317],
        [-87, -269],
        [-174, -538],
        [0, -2],
        [-43, 15],
        [0, -111],
        [-114, -717],
        [-114, -705],
        [-237, -1485],
        [-2, -4],
        [-1062, -1703],
        [-315, -509],
        [207, -805],
        [125, -106],
        [934, -805],
        [37, -680],
        [10, -197],
        [26, -494],
        [16, -249],
        [809, -933],
        [105, -165],
        [13, -35],
        [7, -3],
        [-81, -62],
        [-86, -154],
        [-72, -137],
        [-83, -48],
        [-60, -58],
        [14, -59],
        [17, -87],
        [33, -112],
        [38, -81],
        [19, -141],
        [2, -115],
        [-90, -94],
        [-54, -44],
        [-61, -58],
        [-113, -54],
        [-55, 0],
        [-1, 0],
        [-44, 29],
        [-85, -43],
        [-68, -32],
        [-60, -60],
        [-39, -26],
        [-33, -1],
        [-82, -82],
        [-14, -7],
        [-1, 0],
        [-56, 29],
        [-28, 6],
        [-1, 0],
        [-32, -16],
        [-4, -49],
        [8, -65],
        [-21, -52],
        [-73, -19],
        [-21, -82],
        [-52, -41],
        [-121, -96],
        [-21, -22],
        [-8, -8],
        [0, 0],
        [-16, -15],
        [-5, -5],
        [-8, -8],
        [-8, -8],
        [0, -1],
        [-20, -43],
        [-2, -2],
        [-4, -32],
        [0, -4],
        [0, -2],
        [-6, -7],
        [-27, -32],
        [-4, -3],
        [-1, -1],
        [-26, -13],
        [-15, -7],
        [-2, -1],
        [-2, -2],
        [-26, -13],
        [-2, 0],
        [-4, -2],
        [-2, -4],
        [-1, 0],
        [-28, -33],
        [-2, -2],
        [-2, -2],
        [0, 0],
        [-6, -6],
        [0, 0],
        [-1, -4],
        [-2, -2],
        [-4, -6],
        [-20, -32],
        [21, -24],
        [3, -3],
        [2, -1],
        [1, -21],
        [2, -9],
        [0, -5],
        [0, -4],
        [-10, -12],
        [-15, -16],
        [-14, -10],
        [-2, -2],
        [-8, -6],
        [-12, -8],
        [-2, -2],
        [-2, -2],
        [-3, -2],
        [-5, -2],
        [-2, -2],
        [-35, -24],
        [-8, -5],
        [-4, -2],
        [-51, -9],
        [-29, -5],
        [-14, -2],
        [-1, -1],
        [-5, -9],
        [-21, -37],
        [-33, -6],
        [-6, -1],
        [-17, -1],
        [-47, -1],
        [-41, -1],
        [-21, 0],
        [-1, 0],
        [0, -3],
        [-2, -10],
        [-2, 0],
        [4, -4],
        [-33, -142],
        [-7, -12],
        [-14, -83],
        [-2, -3],
        [-2, -8],
        [-161, -219],
        [-42, -55],
        [-8, -11],
        [-28, -38],
        [-5, 0],
        [-14, -15],
        [-15, 3],
        [0, 1],
        [-4, -3],
        [-4, -6],
        [-91, -162],
        [-10, -18],
        [-185, -226],
        [-121, -190],
        [487, -1651],
        [832, -1779],
        [0, -2],
        [-4, -17],
        [-12, -35],
        [-7, -71],
        [-7, -58],
        [-12, -69],
        [-39, -182],
        [-42, -217],
        [-86, -417],
        [0, -17],
        [6, -30],
        [-16, -9],
        [-57, -37],
        [-61, -34],
        [-28, -14],
        [0, -2],
        [-174, -105],
        [-41, -76],
        [-43, -55],
        [216, -12],
        [2111, -103],
        [1753, -89],
        [-2, -8],
        [-121, -670],
        [-38, -205],
        [-2, -11],
        [-10, -56],
        [-111, -670],
        [-150, -913],
        [-41, -238],
        [-28, -163],
        [-20, -117],
        [-82, -113],
        [-91, -55],
        [-89, -62],
        [-7, -52],
        [-45, -83],
        [-52, -76],
        [-118, -65],
        [-58, -40],
        [-39, -60],
        [-25, -66],
        [-67, -104],
        [-113, -94],
        [-311, -279],
        [-486, 202],
        [-759, 632],
        [-344, 283],
        [-753, 649],
        [-214, -97],
        [-179, -80],
        [-10, -5],
        [-484, -210],
        [-226, -88],
        [-84, -35],
        [-4, -1],
        [-506, -212],
        [-9, -4],
        [-3, 0],
        [-27, -11],
        [3, -6],
        [42, -94],
        [18, -41],
        [128, -299],
        [55, -127],
        [-46, -26],
        [-224, -92],
        [-79, -476],
        [-172, -1044],
        [-23, -138],
        [-10, -59],
        [-8, -48],
        [-269, 210],
        [-66, 51],
        [-5, 4],
        [-146, 111],
        [-159, 120],
        [-152, 117],
        [-137, 104],
        [-84, 65],
        [-221, 71],
        [-1, -45],
        [-4, -123],
        [-140, 38],
        [-120, -82],
        [206, -196],
        [-12, -18],
        [-3, -5],
        [-32, -47],
        [-35, -53],
        [92, -82],
        [40, -37],
        [45, -41],
        [2, -2],
        [45, -41],
        [41, -37],
        [42, -38],
        [52, -47],
        [49, -45],
        [48, -45],
        [0, -4],
        [84, -157],
        [59, -48],
        [48, -24],
        [39, -100],
        [66, -67],
        [139, 2],
        [37, 1],
        [-28, -92],
        [-30, -96],
        [-13, -44],
        [-5, -15],
        [0, -2],
        [66, -67],
        [-4, -24],
        [-29, -7],
        [-176, -33],
        [-135, -25],
        [-116, -21],
        [-201, -36],
        [-157, -29],
        [-191, -36],
        [-172, -32],
        [-3, -1],
        [-13, -3],
        [-158, -28],
        [-93, 342],
        [-38, 138],
        [46, 135],
        [63, 189],
        [-165, 19],
        [-48, 6],
        [-94, 10],
        [-38, 6],
        [-191, 21],
        [-33, 8],
        [-2, -5],
        [-28, -48],
        [0, -2],
        [6, -72],
        [2, -9],
        [4, -32],
        [6, -28],
        [3, -35],
        [4, -18],
        [3, -21],
        [10, -17],
        [16, -17],
        [7, -16],
        [10, -12],
        [11, -27],
        [-1, -25],
        [0, -23],
        [14, -86],
        [14, -56],
        [9, -48],
        [5, -43],
        [4, -66],
        [-1, -15],
        [-2, -40],
        [-1, -93],
        [2, -40],
        [22, -26],
        [32, -25],
        [20, -13],
        [27, -9],
        [37, -64],
        [-4, -12],
        [4, -22],
        [7, -17],
        [9, -25],
        [27, -20],
        [23, -71],
        [22, -154],
        [2, -149],
        [-1, -65],
        [-30, -21],
        [-28, -9],
        [-56, -3],
        [-37, -37],
        [4, -53],
        [-38, -36],
        [-2, -4],
        [-33, -40],
        [-37, -10],
        [-62, -20],
        [-17, -12],
        [-22, -45],
        [-10, -13],
        [-16, -31],
        [-19, -18],
        [-12, -4],
        [-13, -15],
        [-8, -35],
        [-12, -19],
        [-24, -22],
        [-28, -16],
        [26, -22],
        [-55, -64],
        [-30, -35],
        [-58, -51],
        [-76, -54],
        [-78, -44],
        [-55, -68],
        [-37, -44],
        [-41, -29],
        [-37, 5],
        [-23, 2],
        [-42, -6],
        [-51, -17],
        [-41, -14],
        [-38, -31],
        [-11, -20],
        [-7, -16],
        [-21, -30],
        [-26, -9],
        [-28, -22],
        [-12, -25],
        [-31, -12],
        [-43, -32],
        [-39, -31],
        [-55, -38],
        [-46, -45],
        [-12, -13],
        [-31, -5],
        [-25, -4],
        [-9, -1],
        [-45, -2],
        [-3, 0],
        [-24, 2],
        [-25, 1],
        [-13, -11],
        [-12, -9],
        [-33, -31],
        [-4, -3],
        [-22, -20],
        [-26, -22],
        [-1, -2],
        [0, -2],
        [-2, -30],
        [0, -7],
        [-1, -18],
        [-1, -13],
        [-20, -19],
        [-21, -18],
        [-6, -3],
        [-21, -7],
        [-2, -1],
        [-4, 0],
        [-5, -2],
        [-22, -4],
        [-8, -2],
        [-12, -2],
        [-16, -18],
        [6, -17],
        [1, -5],
        [-14, -14],
        [-18, -5],
        [-13, -13],
        [-12, -19],
        [-14, -18],
        [-7, -16],
        [-15, -28],
        [-5, -31],
        [-14, -33],
        [-10, -33],
        [-16, -13],
        [-22, -3],
        [-17, -10],
        [-21, -16],
        [-14, -20],
        [-7, -26],
        [-6, -8],
        [-5, -7],
        [-5, 5],
        [-7, 6],
        [-12, 12],
        [-21, 12],
        [-1, 0],
        [-7, 4],
        [-31, 12],
        [-31, 8],
        [-24, -2],
        [-27, -14],
        [-20, -6],
        [-45, -11],
        [-14, -5],
        [-6, -12],
        [8, -10],
        [12, -4],
        [-10, -18],
        [-12, -23],
        [-43, 16],
        [-28, 8],
        [-33, 13],
        [-18, 3],
        [-21, 2],
        [-14, -5],
        [-16, -12],
        [-17, -18],
        [10, -14],
        [13, -10],
        [0, -12],
        [-6, -14],
        [-9, -16],
        [-14, -27],
        [-10, -26],
        [10, -24],
        [-15, -27],
        [-8, -12],
        [-30, -16],
        [-10, -33],
        [-32, -63],
        [-22, -15],
        [-53, 14],
        [-9, -20],
        [-8, -38],
        [10, -22],
        [-18, -15],
        [-25, 7],
        [-25, -12],
        [-8, -25],
        [-31, -61],
        [-26, -23],
        [-11, -32],
        [-30, -10],
        [-19, -3],
        [-39, -16],
        [-24, -1],
        [-39, -7],
        [-17, 2],
        [-10, -19],
        [-14, -14],
        [-41, 6],
        [-18, -6],
        [-10, -22],
        [-6, -21],
        [-6, -21],
        [-12, -21],
        [-13, 5],
        [-10, 11],
        [-4, 11],
        [-12, 2],
        [-8, 0],
        [-8, -7],
        [-11, -10],
        [-11, -15],
        [-7, -8],
        [-10, -5],
        [-11, -4],
        [-8, -2],
        [-10, -5],
        [-4, -21],
        [-4, -14],
        [-10, -10],
        [-12, 0],
        [-21, 10],
        [-24, 21],
        [-28, 17],
        [-30, 8],
        [-23, -1],
        [-22, -5],
        [-17, -7],
        [-20, -21],
        [-21, -30],
        [-36, -26],
        [-18, -17],
        [-12, -1],
        [-14, 6],
        [-14, 3],
        [-17, -2],
        [-20, -17],
        [-15, -15],
        [-10, -21],
        [-10, -22],
        [-2, -21],
        [0, -33],
        [-24, -22],
        [-34, -9],
        [-9, 20],
        [2, 16],
        [-2, 11],
        [-10, 8],
        [-20, 2],
        [-13, -10],
        [-10, -11],
        [-10, -13],
        [0, -15],
        [12, -41],
        [-10, -12],
        [-28, 1],
        [-28, -1],
        [-19, -10],
        [-16, -17],
        [-49, -4],
        [-13, 18],
        [-22, -1],
        [-16, -9],
        [-16, -19],
        [-15, -17],
        [-26, -4],
        [-20, 10],
        [-14, 11],
        [-12, 2],
        [-14, -9],
        [-4, -15],
        [4, -24],
        [4, -22],
        [-18, -16],
        [-25, -8],
        [-21, 0],
        [-14, -2],
        [-2, -14],
        [10, -40],
        [-16, -22],
        [6, -15],
        [-20, -18],
        [-21, 4],
        [-49, 15],
        [-19, 17],
        [-19, -5],
        [-9, -10],
        [-8, -27],
        [26, -20],
        [-12, -21],
        [-26, -1],
        [-16, 9],
        [-28, 8],
        [-17, -10],
        [-18, -27],
        [-16, -22],
        [-15, -11],
        [-15, -1],
        [-9, -16],
        [-13, -15],
        [-11, -21],
        [-14, 0],
        [-20, 5],
        [-13, -6],
        [-9, -12],
        [-7, -12],
        [-6, -21],
        [15, -18],
        [-3, -17],
        [-55, -12],
        [-10, 12],
        [-13, 25],
        [-10, 12],
        [-13, -10],
        [-10, -12],
        [-9, -12],
        [-1, -1],
        [-17, -6],
        [-22, 1],
        [-14, -11],
        [-2, -20],
        [-18, -19],
        [-37, 9],
        [-21, -13],
        [-15, -13],
        [-19, -10],
        [-25, -5],
        [-23, 2],
        [-31, 27],
        [-15, -1],
        [-6, -4],
        [-3, -19],
        [0, -29],
        [-2, -33],
        [-46, 16],
        [-21, -12],
        [-21, -12],
        [-10, -30],
        [-12, -28],
        [-40, -46],
        [-27, -24],
        [-41, -30],
        [-36, -31],
        [-37, 7],
        [-22, -11],
        [-2, -38],
        [-41, -30],
        [-35, -3],
        [-41, -1],
        [-24, -12],
        [-7, -22],
        [2, -46],
        [6, -23],
        [-1259, -890],
        [-916, -758],
        [-800, -659],
        [-812, -651],
        [-53, -3],
        [64, -183],
        [-565, -1499],
        [-64, -170],
        [-361, -961],
        [-329, -1517],
        [-585, -963],
        [-230, -376],
        [-106, -790],
        [-346, -775],
        [-151, -12],
        [-29, 12],
        [-95, -263],
        [-68, -422],
        [-159, -973],
        [-19, -120],
        [8, -7],
        [69, -60],
        [50, -75],
        [17, -55],
        [-10, -56],
        [16, -85],
        [-28, -73],
        [-19, -74],
        [23, -45],
        [-1, -48],
        [-14, -62],
        [-17, -70],
        [-45, -45],
        [-32, -68],
        [-8, -47],
        [-2, -38],
        [-5, -49],
        [10, -90],
        [13, -69],
        [32, -52],
        [16, -70],
        [12, -94],
        [5, -52],
        [-3, -77],
        [-22, -63],
        [-4, -63],
        [-12, -67],
        [-8, -50],
        [-43, -41],
        [-47, -48],
        [-4, -37],
        [-12, -74],
        [-12, -42],
        [-15, -67],
        [-1, -120],
        [20, -78],
        [-95, -118],
        [-10, -52],
        [-27, -83],
        [-37, -84],
        [-22, -106],
        [-32, -36],
        [-12, -95],
        [24, -75],
        [-26, -63],
        [-7, -64],
        [3, -62],
        [-12, -51],
        [-8, -62],
        [-20, -91],
        [13, -116],
        [-4, -183],
        [-96, -1344],
        [-50, -349],
        [-20, -181],
        [-2, -28],
        [-50, -466],
        [-34, -309],
        [-48, -447],
        [-25, -215],
        [-57, -822],
        [-33, -471],
        [-14, -218],
        [-60, -1022],
        [-21, -344],
        [-566, -757],
        [-194, -258],
        [-47, -64],
        [-757, -1019],
        [-723, -987],
        [-378, -507],
      ],
      [
        [355237, 292449],
        [1056, -247],
        [845, -80],
        [625, -58],
        [887, -1959],
        [428, 219],
        [2, -59],
        [605, -223],
        [1162, -431],
        [7443, -2755],
        [4453, -1653],
        [2583, -960],
        [708, -3202],
        [1663, -7523],
        [465, -2110],
        [487, -2211],
        [8, -35],
        [164, -747],
        [0, -1],
        [53, -233],
        [3331, -4955],
        [130, -191],
        [-1185, -2027],
        [-952, -1632],
        [-2187, -3749],
        [-1220, -2094],
        [44, -3179],
        [43, -3237],
        [6, -444],
        [3, -191],
        [0, -6],
        [17, -1266],
        [4, -252],
        [42, -3215],
        [4, -318],
        [10, -710],
        [11, -780],
        [0, -2],
        [8, -633],
        [13, -808],
        [6, -438],
        [9, -696],
        [9, -685],
        [6, -420],
        [0, -2],
        [6, -442],
        [13, -1084],
        [2, -26],
        [74, -176],
        [4, -12],
        [4, -12],
        [4, -27],
        [8, -56],
        [10, -70],
        [0, -4],
        [10, -76],
        [8, -53],
        [12, -49],
        [29, -71],
        [11, -23],
        [25, -45],
        [22, -32],
        [16, -20],
        [44, -46],
        [55, -60],
        [41, -43],
        [59, -63],
        [65, -68],
        [31, -34],
        [29, -29],
        [10, -11],
        [8, -12],
        [9, -18],
        [6, -20],
        [5, -17],
        [8, -37],
        [31, -256],
        [270, -473],
        [541, -439],
        [80, -210],
        [64, -164],
        [97, -296],
        [1, -2],
        [5, -14],
        [6, -41],
        [0, -1],
        [14, -99],
        [-12, -426],
        [-8, -14],
        [-27, -78],
        [0, -19],
        [-48, -129],
        [-71, -52],
        [-14, -11],
        [-35, -26],
        [-24, -19],
        [-19, -30],
        [-17, -49],
        [0, -6],
        [2, -51],
        [13, -48],
        [2, -20],
        [100, -6],
        [-32, -118],
        [-6, -23],
        [-77, -208],
        [-12, -37],
        [-1, -359],
        [13, -173],
        [-4, -31],
        [-21, -69],
        [-22, -20],
        [-19, -16],
        [-30, -27],
        [-51, -45],
        [-12, -77],
        [-26, -183],
        [-2, -1],
        [-45, -319],
        [3, -22],
        [0, -6],
        [0, 0],
        [1, -6],
        [0, -2],
        [0, -2],
        [0, -2],
        [1, -2],
        [0, -6],
        [4, -42],
        [1, -4],
        [1, -4],
        [0, -6],
        [1, 0],
        [-1, -66],
        [2, -7],
        [1, -4],
        [1, -2],
        [0, 0],
        [2, -6],
        [6, -270],
        [2, -62],
        [2, -89],
        [2, -75],
        [-4, -70],
        [-3, -43],
        [-4, -15],
        [-154, -489],
        [-21, -67],
        [-179, -577],
        [-9, -30],
        [-84, -272],
        [-1, 0],
        [-11, -32],
        [-69, -195],
        [-99, -279],
        [-3, -7],
        [-90, -254],
        [-39, -72],
        [-6, -10],
        [-25, -41],
        [-4, -5],
        [-61, -87],
        [-14, -17],
        [-23, -21],
        [-12, -11],
        [-34, -22],
        [-15, -6],
        [-182, -69],
        [-108, -48],
        [-52, -24],
        [-95, -44],
        [-18, -8],
        [-5, -2],
        [-17, -9],
        [-33, -20],
        [-25, -14],
        [-12, -6],
        [-40, -36],
        [-8, -8],
        [-12, -13],
        [-14, -20],
        [-6, -11],
        [-5, -7],
        [-13, -28],
        [-19, -34],
        [-13, -21],
        [8, -4],
        [1, -2],
        [315, -231],
        [2, -2],
        [229, -178],
        [76, -60],
        [67, -52],
        [132, -49],
        [-3, -18],
        [-42, -72],
        [-10, -17],
        [0, -30],
        [4, -22],
        [-59, -32],
        [-65, -34],
        [-246, -73],
        [-341, -103],
        [-45, -31],
        [-76, -52],
        [-80, -52],
        [22, -26],
        [153, -187],
        [98, -122],
        [84, -93],
        [-83, -34],
        [-14, -6],
        [-20, -6],
        [-10, -2],
        [-7, -2],
        [-10, -2],
        [-8, -2],
        [-9, -2],
        [-9, -2],
        [-9, -4],
        [-9, -2],
        [-9, -2],
        [-9, -2],
        [-9, -2],
        [-10, -4],
        [-11, -2],
        [-12, -5],
        [-11, -3],
        [-7, -4],
        [-9, -3],
        [-8, -4],
        [-9, -3],
        [-8, -4],
        [-9, -3],
        [-9, -4],
        [-7, -4],
        [-10, -4],
        [-8, -3],
        [-8, -4],
        [-8, -3],
        [-9, -4],
        [-9, -4],
        [-7, -3],
        [-1, 0],
        [-9, -4],
        [-8, -3],
        [-9, -4],
        [-9, -5],
        [-9, -5],
        [-8, -4],
        [-9, -3],
        [-8, -7],
        [-7, -4],
        [-9, -4],
        [-8, -4],
        [-8, -4],
        [-8, -6],
        [-8, -4],
        [-7, -5],
        [-8, -6],
        [-7, -6],
        [-6, -5],
        [-8, -6],
        [-8, -6],
        [-6, -5],
        [-7, -6],
        [-11, -8],
        [-8, -6],
        [-7, -6],
        [-7, -6],
        [-7, -6],
        [-7, -6],
        [-7, -5],
        [-7, -6],
        [-8, -6],
        [-8, -7],
        [-6, -10],
        [-4, -8],
        [-3, -8],
        [-4, -8],
        [-3, -9],
        [-2, -9],
        [-4, -8],
        [-4, -9],
        [-4, -8],
        [-2, -9],
        [-4, -8],
        [-4, -11],
        [-4, -10],
        [-2, -8],
        [-2, -8],
        [-2, -10],
        [-2, -8],
        [-2, -8],
        [-3, -10],
        [-3, -8],
        [-2, -10],
        [-2, -8],
        [-3, -8],
        [-3, -9],
        [-2, -9],
        [-2, -10],
        [-3, -11],
        [-3, -12],
        [-1, -9],
        [-2, -9],
        [-2, -9],
        [-2, -9],
        [-2, -8],
        [-1, -10],
        [-2, -8],
        [-1, -10],
        [-2, -8],
        [-2, -8],
        [-2, -9],
        [-1, -10],
        [-2, -8],
        [-2, -9],
        [-1, -9],
        [-2, -10],
        [-2, -9],
        [-2, -11],
        [-2, -9],
        [-1, -8],
        [-2, -8],
        [-2, -10],
        [-2, -8],
        [0, -9],
        [-2, -9],
        [-2, -9],
        [-2, -9],
        [-2, -9],
        [-2, -9],
        [-2, -9],
        [-2, -9],
        [-2, -9],
        [-2, -7],
        [0, -10],
        [-2, -11],
        [-2, -8],
        [-2, -8],
        [-2, -10],
        [-1, -8],
        [-1, -10],
        [-3, -12],
        [-3, -8],
        [-2, -9],
        [-2, -9],
        [-2, -9],
        [-3, -8],
        [-2, -10],
        [-3, -8],
        [-2, -9],
        [-2, -8],
        [-3, -8],
        [-2, -10],
        [-2, -8],
        [-2, -10],
        [-4, -9],
        [-2, -10],
        [-3, -8],
        [-2, -9],
        [-2, -8],
        [-3, -12],
        [-3, -12],
        [-2, -10],
        [-1, -9],
        [-1, -9],
        [-2, -8],
        [-2, -10],
        [-1, -9],
        [-1, -8],
        [-2, -8],
        [-1, -14],
        [-2, -9],
        [-2, -9],
        [-2, -10],
        [-2, -9],
        [-2, -11],
        [-4, -8],
        [-2, -9],
        [-4, -9],
        [-4, -12],
        [-4, -9],
        [-4, -7],
        [-4, -8],
        [-5, -8],
        [-6, -12],
        [-5, -8],
        [-5, -8],
        [-5, -7],
        [-4, -8],
        [-5, -8],
        [-9, -15],
        [-5, -7],
        [-4, -8],
        [-4, -10],
        [-4, -8],
        [-3, -8],
        [-8, -14],
        [-6, -6],
        [-4, -8],
        [-6, -8],
        [-4, -8],
        [-5, -8],
        [-5, -8],
        [-5, -6],
        [-5, -8],
        [-5, -8],
        [-9, -11],
        [-5, -7],
        [-5, -8],
        [-6, -7],
        [-6, -7],
        [-5, -8],
        [-5, -7],
        [-5, -8],
        [-6, -8],
        [-6, -8],
        [-4, -7],
        [-6, -8],
        [-6, -7],
        [-4, -6],
        [-10, -15],
        [-6, -7],
        [-5, -8],
        [-6, -7],
        [-5, -8],
        [-5, -7],
        [-6, -7],
        [-5, -7],
        [-6, -8],
        [-5, -7],
        [-5, -8],
        [-6, -7],
        [-4, -8],
        [-6, -7],
        [-6, -8],
        [-10, -14],
        [-5, -7],
        [-5, -8],
        [-6, -7],
        [-6, -8],
        [-5, -7],
        [-6, -8],
        [-7, -9],
        [-9, -11],
        [-7, -7],
        [-6, -6],
        [-5, -7],
        [-8, -7],
        [-6, -6],
        [-7, -7],
        [-6, -6],
        [-6, -6],
        [-6, -8],
        [-6, -6],
        [-8, -6],
        [-6, -6],
        [-6, -8],
        [-6, -6],
        [-6, -6],
        [-7, -6],
        [-7, -6],
        [-7, -9],
        [-6, -6],
        [-8, -5],
        [-6, -6],
        [-7, -7],
        [-7, -6],
        [-7, -6],
        [-7, -6],
        [-6, -7],
        [-8, -6],
        [-6, -6],
        [-6, -6],
        [-10, -7],
        [-9, -7],
        [-8, -4],
        [-8, -5],
        [-8, -4],
        [-8, -6],
        [-8, -4],
        [-7, -4],
        [-8, -6],
        [-8, -4],
        [-8, -4],
        [-8, -4],
        [-8, -5],
        [-8, -4],
        [-8, -5],
        [-8, -5],
        [-8, -5],
        [-8, -4],
        [-8, -5],
        [-9, -5],
        [-8, -4],
        [-8, -6],
        [-8, -4],
        [-7, -5],
        [-8, -5],
        [-8, -4],
        [-8, -5],
        [-8, -4],
        [-8, -5],
        [-8, -5],
        [-8, -5],
        [-9, -4],
        [-10, -8],
        [-6, -5],
        [-8, -6],
        [-6, -5],
        [-7, -6],
        [-7, -6],
        [-7, -6],
        [-7, -6],
        [-7, -6],
        [-8, -6],
        [-7, -6],
        [-7, -5],
        [-8, -6],
        [-6, -6],
        [-8, -6],
        [-8, -6],
        [-6, -6],
        [-10, -8],
        [-7, -6],
        [-7, -6],
        [-7, -6],
        [-7, -8],
        [-7, -6],
        [-7, -4],
        [-7, -6],
        [-7, -6],
        [-6, -6],
        [-8, -8],
        [-7, -6],
        [-7, -4],
        [-7, -6],
        [-6, -6],
        [-8, -6],
        [-6, -6],
        [-8, -7],
        [-8, -8],
        [-10, -9],
        [-6, -7],
        [-7, -6],
        [-6, -8],
        [-6, -6],
        [-6, -7],
        [-7, -7],
        [-6, -7],
        [-6, -7],
        [-6, -7],
        [-5, -6],
        [-6, -7],
        [-8, -8],
        [-6, -6],
        [-6, -8],
        [-6, -8],
        [-6, -8],
        [-6, -6],
        [-6, -8],
        [-6, -7],
        [-5, -7],
        [-6, -7],
        [-5, -8],
        [-6, -7],
        [-5, -7],
        [-5, -11],
        [-3, -9],
        [-2, -9],
        [-3, -8],
        [-2, -9],
        [-2, -9],
        [-2, -7],
        [-6, -16],
        [-2, -9],
        [-2, -9],
        [-2, -9],
        [-2, -9],
        [-2, -11],
        [-2, -13],
        [0, -9],
        [0, -9],
        [0, -10],
        [0, -7],
        [-2, -10],
        [2, -8],
        [0, -10],
        [2, -10],
        [2, -8],
        [2, -9],
        [0, -9],
        [2, -9],
        [2, -8],
        [2, -11],
        [2, -9],
        [2, -14],
        [2, -12],
        [4, -8],
        [2, -10],
        [1, -8],
        [2, -8],
        [2, -10],
        [3, -8],
        [2, -10],
        [3, -8],
        [2, -8],
        [2, -9],
        [2, -9],
        [2, -8],
        [3, -10],
        [2, -8],
        [3, -10],
        [2, -9],
        [2, -9],
        [2, -8],
        [3, -10],
        [2, -8],
        [2, -9],
        [2, -8],
        [2, -9],
        [3, -9],
        [2, -8],
        [3, -9],
        [2, -9],
        [3, -12],
        [3, -8],
        [3, -9],
        [3, -9],
        [2, -8],
        [4, -9],
        [4, -8],
        [2, -9],
        [4, -8],
        [2, -10],
        [4, -8],
        [4, -8],
        [2, -8],
        [3, -9],
        [4, -8],
        [3, -9],
        [3, -8],
        [3, -9],
        [3, -8],
        [6, -14],
        [2, -8],
        [4, -9],
        [2, -8],
        [3, -8],
        [3, -10],
        [3, -8],
        [3, -8],
        [3, -9],
        [2, -10],
        [2, -10],
        [1, -8],
        [2, -9],
        [1, -9],
        [1, -9],
        [1, -10],
        [1, -11],
        [0, -8],
        [1, -9],
        [1, -13],
        [-1, -10],
        [-1, -8],
        [-1, -18],
        [-2, -8],
        [-3, -9],
        [-2, -9],
        [-3, -11],
        [-6, -10],
        [-6, -7],
        [-7, -7],
        [-6, -6],
        [-6, -8],
        [-7, -5],
        [-8, -6],
        [-8, -4],
        [-8, -4],
        [-10, -3],
        [-9, -4],
        [-10, -2],
        [-10, 0],
        [-9, -1],
        [-9, -1],
        [-10, 0],
        [-11, 0],
        [-10, 1],
        [-10, 1],
        [-8, 2],
        [-9, 2],
        [-10, 1],
        [-10, 2],
        [-10, 1],
        [-9, 3],
        [-9, 2],
        [-9, 2],
        [-9, 2],
        [-10, 2],
        [-8, 2],
        [-10, 2],
        [-8, 3],
        [-14, 4],
        [-12, 3],
        [-9, 3],
        [-8, 4],
        [-9, 3],
        [-9, 3],
        [-9, 3],
        [-8, 4],
        [-8, 3],
        [-9, 3],
        [-10, 4],
        [-8, 3],
        [-9, 2],
        [-13, 7],
        [-12, 6],
        [-8, 4],
        [-8, 5],
        [-8, 4],
        [-8, 3],
        [-8, 6],
        [-8, 4],
        [-8, 4],
        [-8, 6],
        [-8, 4],
        [-8, 4],
        [-8, 4],
        [-9, 4],
        [-10, 7],
        [-11, 6],
        [-8, 6],
        [-7, 5],
        [-8, 6],
        [-7, 5],
        [-8, 5],
        [-8, 5],
        [-8, 6],
        [-6, 6],
        [-8, 5],
        [-12, 9],
        [-8, 5],
        [-8, 4],
        [-8, 4],
        [-8, 6],
        [-8, 4],
        [-8, 6],
        [-8, 4],
        [-8, 6],
        [-8, 5],
        [-6, 4],
        [-8, 6],
        [-8, 4],
        [-8, 4],
        [-8, 6],
        [-8, 4],
        [-9, 6],
        [-8, 4],
        [-7, 4],
        [-11, 6],
        [-8, 5],
        [-10, 3],
        [-8, 4],
        [-8, 4],
        [-8, 3],
        [-9, 4],
        [-8, 4],
        [-9, 4],
        [-9, 3],
        [-8, 4],
        [-11, 4],
        [-12, 5],
        [-10, 3],
        [-8, 3],
        [-8, 3],
        [-9, 3],
        [-9, 3],
        [-5, 1],
        [-11, 4],
        [-9, 2],
        [-9, 3],
        [-9, 2],
        [-8, 3],
        [-10, 3],
        [-8, 2],
        [-9, 2],
        [-13, 4],
        [-10, 2],
        [-8, 2],
        [-9, 2],
        [-10, 2],
        [-9, 2],
        [-8, 2],
        [-10, 2],
        [-12, 2],
        [-10, 0],
        [-9, 2],
        [-9, 0],
        [-56, 8],
        [-58, -2],
        [-89, -12],
        [-61, -6],
        [-50, -13],
        [-57, -16],
        [-41, -14],
        [-14, -5],
        [-29, -18],
        [-6, -4],
        [-7, -5],
        [-10, -7],
        [-35, -28],
        [-16, -16],
        [-3, -2],
        [-4, -8],
        [-39, -81],
        [-8, -17],
        [-16, -33],
        [-2, -14],
        [-2, -19],
        [1, -50],
        [5, -49],
        [2, -6],
        [8, -16],
        [26, -36],
        [51, -75],
        [84, -130],
        [78, -97],
        [45, -70],
        [48, -94],
        [25, -74],
        [9, -65],
        [-8, -54],
        [-29, -60],
        [-57, -56],
        [-202, -108],
        [-141, -33],
        [-195, -46],
        [-11, 2],
        [-9, -2],
        [-9, 0],
        [-10, -2],
        [-9, -2],
        [-8, 0],
        [-12, -2],
        [-10, 2],
        [-8, 0],
        [-11, 2],
        [-14, 0],
        [-9, 2],
        [-10, 2],
        [-9, 2],
        [-8, 0],
        [-10, 2],
        [-16, 4],
        [-8, 0],
        [-9, 2],
        [-9, 0],
        [-10, 2],
        [-4, 0],
        [-5, 0],
        [-9, 2],
        [-13, 0],
        [-9, 2],
        [-10, 2],
        [-8, 0],
        [-9, 2],
        [-10, 2],
        [-10, 2],
        [-27, 9],
        [-41, 19],
        [-109, 24],
        [-119, -27],
        [-91, -49],
        [-51, -56],
        [-24, -58],
        [-13, -59],
        [-4, -50],
        [30, -79],
        [70, -66],
        [97, -59],
        [198, -23],
        [6, -2],
        [14, -4],
        [73, -36],
        [57, -48],
        [21, -44],
        [9, -40],
        [7, -51],
        [-21, -32],
        [-55, -20],
        [-77, -12],
        [-30, -3],
        [-116, -13],
        [-12, 1],
        [-12, 1],
        [-12, 1],
        [-9, 0],
        [-9, 0],
        [-9, 0],
        [-10, 0],
        [-9, 0],
        [-10, 0],
        [-8, 0],
        [-10, 0],
        [-8, 0],
        [-10, 0],
        [-13, 0],
        [-13, -1],
        [-8, -2],
        [-10, -1],
        [-9, -2],
        [-8, 1],
        [-12, -2],
        [-6, -2],
        [-9, -2],
        [-11, -1],
        [-8, -2],
        [-8, -2],
        [-9, -1],
        [-13, -2],
        [-7, -2],
        [-9, -5],
        [-6, -3],
        [-12, -3],
        [-8, -5],
        [-9, -5],
        [-7, -8],
        [-8, -5],
        [-7, -5],
        [-8, -4],
        [-8, -5],
        [-10, -6],
        [-7, -3],
        [-5, -9],
        [-6, -6],
        [-6, -5],
        [-6, -7],
        [-6, -8],
        [-4, -8],
        [-7, -10],
        [-5, -11],
        [-5, -12],
        [-3, -8],
        [-1, -11],
        [-2, -9],
        [-2, -9],
        [-2, -9],
        [-2, -9],
        [-2, -8],
        [-2, -10],
        [-2, -8],
        [-4, -16],
        [-1, -9],
        [-1, -10],
        [0, -10],
        [-2, -8],
        [0, -9],
        [-2, -8],
        [0, -10],
        [-2, -9],
        [0, -9],
        [-1, -9],
        [-1, -9],
        [-1, -9],
        [-1, -8],
        [-1, -10],
        [-2, -16],
        [0, -8],
        [0, -10],
        [0, -8],
        [0, -9],
        [0, -10],
        [0, -9],
        [0, -9],
        [0, -10],
        [0, -9],
        [0, -9],
        [0, -9],
        [0, -9],
        [0, -9],
        [0, -9],
        [0, -9],
        [0, -8],
        [0, -11],
        [0, -10],
        [0, -9],
        [0, -9],
        [0, -9],
        [-1, -9],
        [0, -9],
        [0, -10],
        [0, -9],
        [0, -9],
        [0, -10],
        [0, -9],
        [0, -8],
        [0, -10],
        [0, -8],
        [0, -10],
        [-1, -14],
        [0, -9],
        [-2, -8],
        [-1, -8],
        [-3, -9],
        [0, -8],
        [-1, -7],
        [0, -1],
        [-6, -45],
        [-5, -34],
        [-12, -32],
        [-24, -55],
        [-27, -41],
        [-42, -44],
        [-45, -26],
        [-42, -18],
        [-62, -19],
        [-53, -10],
        [-63, 6],
        [-50, 4],
        [-64, 4],
        [-60, -6],
        [-38, -17],
        [-25, -26],
        [-17, -44],
        [-6, -45],
        [4, -30],
        [18, -36],
        [28, -28],
        [54, -45],
        [54, -44],
        [67, -75],
        [39, -60],
        [50, -83],
        [4, -11],
        [21, -70],
        [-6, -86],
        [-19, -58],
        [-19, -57],
        [-42, -77],
        [-42, -77],
        [-49, -46],
        [-55, -26],
        [-61, -12],
        [-61, 0],
        [-107, 12],
        [-8, 0],
        [-71, 6],
        [-70, 4],
        [-78, -2],
        [-79, -2],
        [-65, -6],
        [-69, -26],
        [-57, -27],
        [-48, -41],
        [-44, -45],
        [-43, -45],
        [-49, -85],
        [-29, -67],
        [-23, -91],
        [0, -7],
        [2, -12],
        [0, -2],
        [7, -58],
        [4, -30],
        [14, -66],
        [13, -68],
        [26, -91],
        [16, -104],
        [-2, -65],
        [0, -25],
        [0, -7],
        [0, -20],
        [-8, -100],
        [-19, -84],
        [-7, -30],
        [-28, -71],
        [-28, -71],
        [-22, -51],
        [-3, -8],
        [-27, -60],
        [-47, -91],
        [-6, -16],
        [-12, -22],
        [-49, -58],
        [-49, -48],
        [-51, -44],
        [-7, -6],
        [-63, -49],
        [-52, -39],
        [-10, -11],
        [-72, -47],
        [-72, -48],
        [-94, -57],
        [-50, -35],
        [-20, -12],
        [-7, -7],
        [-32, -30],
        [-2, -3],
        [-21, -20],
        [-12, -12],
        [-4, -3],
        [-6, -7],
        [-7, -7],
        [-32, -32],
        [-9, -9],
        [-2, 0],
        [-31, -35],
        [-8, -8],
        [-17, -17],
        [-16, -19],
        [-14, -13],
        [-4, -6],
        [-8, -8],
        [-10, -12],
        [-17, -17],
        [-6, -7],
        [-5, -5],
        [-3, -4],
        [-54, -30],
        [-2, 0],
        [-2, -1],
        [-2, -1],
        [-31, -14],
        [-3, -1],
        [-99, -39],
        [-66, -28],
        [-59, -30],
        [-60, -30],
        [-129, -54],
        [-70, -21],
        [-18, -6],
        [-6, 0],
        [-46, -13],
        [-6, -2],
        [-9, -3],
        [-80, -24],
        [-5, -2],
        [-22, -6],
        [-103, -11],
        [-62, -20],
        [-6, -2],
        [-46, -15],
        [-17, -11],
        [-67, -42],
        [-56, -24],
        [-76, -21],
        [-79, -22],
        [-74, -22],
        [-85, -30],
        [-57, -20],
        [-2, 0],
        [-23, -16],
        [-24, -14],
        [-21, -11],
        [-15, -10],
        [-14, -19],
        [10, -10],
        [27, -24],
        [19, -15],
        [425, -464],
        [66, -74],
        [16, 11],
        [12, 8],
        [24, 16],
        [23, -27],
        [1, -2],
        [3, -3],
        [2, -3],
        [-20, -16],
        [0, -2],
        [2, -1],
        [1, -2],
        [1, -3],
        [2, -2],
        [9, -14],
        [20, 11],
        [13, -15],
        [1, -4],
        [23, -30],
        [8, -4],
        [2, -2],
        [74, -151],
        [432, -473],
        [-8, -3],
        [-5, -19],
        [-35, -18],
        [-6, -4],
        [10, -14],
        [8, 8],
        [10, 6],
        [16, 12],
        [6, 6],
        [91, -99],
        [69, -74],
        [1, 0],
        [6, -6],
        [0, -2],
        [5, -2],
        [0, -2],
        [1, 0],
        [0, 0],
        [1, 0],
        [6, -6],
        [3, -5],
        [5, -5],
        [1, -1],
        [6, -6],
        [3, -4],
        [1, -1],
        [7, -8],
        [23, -24],
        [17, -19],
        [14, -15],
        [8, -7],
        [6, -7],
        [4, -5],
        [6, -7],
        [25, -25],
        [19, -21],
        [11, -11],
        [3, -3],
        [0, -1],
        [4, -5],
        [69, -73],
        [658, -700],
        [1364, -1450],
        [460, -247],
        [16, -8],
        [190, -175],
        [1196, -1086],
        [425, -385],
        [499, -1069],
        [1335, -1211],
        [19, -7],
        [981, -360],
        [115, -42],
        [597, -12],
        [225, -841],
        [0, -4],
        [2, -2],
        [2, -8],
        [2, -6],
        [0, -5],
        [0, -15],
        [2, -56],
        [0, -49],
        [2, -114],
        [0, -120],
        [0, 0],
        [2, -61],
        [0, -18],
        [0, -52],
        [0, -8],
        [0, -42],
        [2, -43],
        [0, -38],
        [0, -8],
        [0, -6],
        [0, -43],
        [0, -12],
        [2, -187],
        [14, -192],
        [15, -469],
        [0, -2],
        [2, -74],
        [0, -16],
        [2, -48],
        [0, -10],
        [1, -17],
        [0, -3],
        [1, -11],
        [0, -11],
        [0, -3],
        [0, -5],
        [-1, 0],
        [-11, 2],
        [-37, 5],
        [-25, -1],
        [-93, -21],
        [-32, -15],
        [-7, -6],
        [-13, -12],
        [-49, -8],
        [-38, -2],
        [-38, 8],
        [-40, 14],
        [-135, 50],
        [-111, 40],
        [-84, 25],
        [-52, 17],
        [-22, 11],
        [-13, 3],
        [-16, 0],
        [-40, 0],
        [-16, 0],
        [-12, 7],
        [-2, 3],
        [-43, 53],
        [-62, 90],
        [-128, 211],
        [-48, 70],
        [-66, 112],
        [-37, 38],
        [-8, 21],
        [0, 17],
        [2, 20],
        [8, 30],
        [6, 38],
        [-3, 26],
        [-18, 38],
        [-14, 25],
        [-6, 8],
        [-106, 122],
        [-45, 44],
        [-45, 30],
        [-11, 11],
        [-29, 68],
        [-44, 83],
        [-29, 55],
        [-30, 45],
        [-45, 34],
        [-45, 29],
        [-26, 20],
        [-8, 6],
        [-57, 19],
        [-22, 4],
        [-35, 6],
        [-60, 0],
        [-37, 0],
        [-35, 7],
        [-27, 1],
        [-26, -4],
        [-17, -12],
        [-9, -11],
        [-6, -19],
        [-3, -22],
        [2, -16],
        [7, -30],
        [3, -32],
        [-4, -23],
        [-6, -12],
        [-16, -15],
        [-1, -1],
        [-15, -10],
        [-18, -8],
        [-34, -7],
        [-20, 0],
        [-92, 6],
        [-165, 18],
        [-232, 13],
        [-66, 27],
        [-147, 132],
        [-67, 58],
        [-35, 27],
        [-158, 103],
        [-69, 39],
        [-65, 34],
        [-14, 10],
        [-15, 2],
        [-13, -2],
        [-23, -8],
        [-91, -32],
        [-41, -10],
        [-60, -16],
        [-13, -5],
        [-12, -7],
        [-15, -9],
        [-56, -42],
        [-53, -8],
        [-31, 0],
        [-47, 10],
        [-68, 33],
        [-80, 38],
        [-60, 44],
        [-68, 22],
        [-56, 24],
        [-84, 36],
        [-71, 21],
        [-45, 10],
        [-12, 0],
        [-12, -6],
        [-17, -11],
        [-32, -28],
        [-12, -30],
        [-14, -36],
        [0, -2],
        [-14, -37],
        [-12, -18],
        [-30, -13],
        [-13, -3],
        [-13, -2],
        [-42, 1],
        [-39, 1],
        [-27, -4],
        [-19, -5],
        [-19, -6],
        [-18, -5],
        [-26, -10],
        [-25, -4],
        [-1, 0],
        [-25, -8],
        [-42, -12],
        [-3, 0],
        [-36, -10],
        [-11, -4],
        [-10, -3],
        [-26, -12],
        [-32, -18],
        [-10, -9],
        [-18, -32],
        [-10, -14],
        [-12, -6],
        [-18, 0],
        [-15, -1],
        [-9, -5],
        [-37, 11],
        [-18, -2],
        [-4, 0],
        [-14, 3],
        [-4, 9],
        [0, 11],
        [-12, 9],
        [-15, 7],
        [-11, 3],
        [-19, -4],
        [-15, -7],
        [-20, -10],
        [-20, -22],
        [-10, -8],
        [-45, -45],
        [-4, -5],
        [-65, -66],
        [-18, -26],
        [-16, -35],
        [-22, -15],
        [-6, -7],
        [-11, -12],
        [-42, -32],
        [-64, -28],
        [-40, 0],
        [-101, -12],
        [-43, -6],
        [-25, -10],
        [-34, -6],
        [-24, -4],
        [-10, -6],
        [-5, -2],
        [-35, -29],
        [-98, -96],
        [-35, -27],
        [-21, -13],
        [-22, -9],
        [-20, -2],
        [-27, -2],
        [-26, 3],
        [-58, 16],
        [-23, 4],
        [-24, -2],
        [-25, -5],
        [-16, -5],
        [-86, -44],
        [-59, -26],
        [-20, -6],
        [-70, -16],
        [-18, -12],
        [-24, -16],
        [-27, -12],
        [-25, -5],
        [-23, -1],
        [-38, 4],
        [-21, 0],
        [-49, -12],
        [-26, -11],
        [-41, -29],
        [-48, -53],
        [-10, -18],
        [-11, -18],
        [-16, -18],
        [-10, -14],
        [-15, -18],
        [-20, -19],
        [-15, -9],
        [-24, -7],
        [-44, -6],
        [-56, -3],
        [-78, -13],
        [-32, -2],
        [-41, -12],
        [-46, -18],
        [-70, -43],
        [-73, -35],
        [-57, -23],
        [-63, -27],
        [-20, -4],
        [-2, -2],
        [-10, -6],
        [-2, -12],
        [3, -15],
        [9, -14],
        [16, -14],
        [8, -13],
        [13, -14],
        [8, -10],
        [-1, -12],
        [-15, -14],
        [-19, -12],
        [-30, -10],
        [-44, 2],
        [-42, -2],
        [-53, 2],
        [-53, 12],
        [-24, 8],
        [-15, 4],
        [-15, -4],
        [-13, -8],
        [-11, -14],
        [-2, -18],
        [1, -16],
        [4, -21],
        [3, -11],
        [6, -15],
        [58, -118],
        [17, -37],
        [4, -34],
        [-3, -47],
        [-1, -7],
        [-3, -31],
        [-8, -49],
        [-8, -32],
        [-2, -10],
        [-8, -26],
        [-12, -23],
        [-13, -27],
        [-6, -28],
        [-5, -31],
        [1, -25],
        [-6, -29],
        [-1, -4],
        [-9, -41],
        [-16, -37],
        [-29, -51],
        [-23, -39],
        [-15, -20],
        [-37, -44],
        [-14, -21],
        [-24, -42],
        [-10, -22],
        [-22, -42],
        [-11, -32],
        [-13, -26],
        [-6, -21],
        [-12, -63],
        [10, -163],
        [-6, -78],
        [-8, -60],
        [0, -101],
        [-4, -36],
        [-28, -48],
        [-22, -36],
        [-12, -12],
        [-17, -12],
        [-33, -6],
        [-26, -11],
        [-30, -10],
        [-13, -12],
        [-4, -16],
        [0, -51],
        [-6, -19],
        [-13, -22],
        [-10, -22],
        [-2, -72],
        [-4, -15],
        [-22, -48],
        [-46, -60],
        [-91, -93],
        [-35, -27],
        [-80, -64],
        [-34, -40],
        [-20, -27],
        [-29, -49],
        [-20, -15],
        [-16, -18],
        [-20, -22],
        [-33, -37],
        [-51, -35],
        [-56, -47],
        [-17, -22],
        [-16, -47],
        [-22, -51],
        [-26, -67],
        [-1, -3],
        [-9, -30],
        [-7, -27],
        [-7, -10],
        [-11, -9],
        [-11, -1],
        [-20, 1],
        [-14, 1],
        [-122, 0],
        [-91, -21],
        [-38, -18],
        [-39, -27],
        [-29, -24],
        [-15, -54],
        [1, -46],
        [14, -40],
        [42, -44],
        [12, -8],
        [143, -94],
        [63, -42],
        [69, -43],
        [88, -74],
        [20, -24],
        [13, -21],
        [8, -36],
        [-2, -35],
        [-9, -35],
        [-49, -84],
        [-40, -42],
        [-36, -30],
        [-25, -22],
        [-29, -30],
        [-22, -26],
        [-18, -32],
        [-15, -28],
        [-8, -34],
        [-40, -89],
        [-25, -46],
        [-38, -57],
        [-20, -41],
        [-10, -13],
        [-29, -34],
        [-37, -30],
        [-75, -39],
        [-46, -21],
        [-34, -28],
        [-25, -24],
        [-31, -18],
        [-8, -4],
        [-47, -19],
        [-26, -10],
        [-27, -16],
        [-18, -8],
        [-28, -2],
        [-21, 0],
        [-39, 10],
        [-18, 0],
        [-9, 2],
        [-45, 2],
        [-21, -2],
        [-20, -4],
        [-12, -8],
        [-11, -8],
        [-18, -21],
        [-20, -36],
        [-19, -66],
        [-4, -20],
        [-2, -33],
        [0, -42],
        [-4, -32],
        [-6, -63],
        [2, -38],
        [6, -30],
        [-2, -30],
        [0, -21],
        [0, -27],
        [0, -19],
        [-4, -12],
        [-2, -20],
        [-4, -21],
        [-2, -12],
        [-2, -18],
        [-2, -10],
        [2, -11],
        [-2, -25],
        [4, -31],
        [4, -8],
        [2, -10],
        [2, -12],
        [4, -10],
        [0, -11],
        [0, -7],
        [-2, -10],
        [2, -15],
        [-4, -13],
        [0, -12],
        [-2, -14],
        [-10, -16],
        [-17, -24],
        [-13, -21],
        [-20, -23],
        [-11, -26],
        [-1, -12],
        [11, -34],
        [7, -21],
        [5, -30],
        [5, -36],
        [-8, -29],
        [-2, -28],
        [-6, -15],
        [-4, -12],
        [-13, -20],
        [-20, -23],
        [-18, -24],
        [-39, -25],
        [-17, -7],
        [-8, -6],
        [-8, -2],
        [-2, -2],
        [-8, -6],
        [-23, -18],
        [-7, -4],
        [-16, -14],
        [-25, -22],
        [-20, -11],
        [-21, -15],
        [-33, -13],
        [-32, -1],
        [-19, 2],
        [-19, 10],
        [-36, 28],
        [-40, 26],
        [-36, 18],
        [-28, 6],
        [-38, 0],
        [-39, -6],
        [-25, -10],
        [-25, -10],
        [-19, -10],
        [-27, -24],
        [-34, -36],
        [-28, -27],
        [-25, -38],
        [-4, -24],
        [-4, -16],
        [2, -15],
        [8, -21],
        [16, -47],
        [23, -62],
        [29, -59],
        [31, -60],
        [29, -57],
        [16, -46],
        [1, -30],
        [-2, -22],
        [-6, -19],
        [-12, -25],
        [-14, -19],
        [-16, -14],
        [-16, -12],
        [-52, -39],
        [-41, -35],
        [-38, -51],
        [-15, -25],
        [-7, -41],
        [14, -46],
        [27, -25],
        [27, -18],
        [103, -59],
        [66, -33],
        [40, -17],
        [32, -15],
        [7, -4],
      ],
      [
        [30596, 270211],
        [271, -44],
        [106, -17],
        [16, -2],
        [145, -24],
        [9, -2],
        [14, -3],
        [261, -43],
        [1, 0],
        [769, 799],
        [162, 170],
        [54, 55],
        [267, 279],
        [6, 5],
        [54, 57],
        [146, 154],
        [16, 16],
        [167, 175],
        [50, 53],
        [-58, 343],
        [1629, -947],
        [148, -85],
        [317, 434],
        [984, 1337],
        [-975, 987],
        [350, 299],
        [209, 171],
        [217, 170],
        [100, 78],
        [50, 33],
        [107, 79],
        [100, 79],
        [312, 233],
        [25, 22],
        [57, 41],
        [142, 108],
        [45, 28],
        [128, 39],
        [99, 57],
        [116, 57],
        [66, 34],
        [114, 63],
        [135, 76],
        [-2, 289],
        [-46, 47],
        [-127, 92],
        [-30, 50],
        [-30, 44],
        [-64, 67],
        [-94, 108],
        [-114, 117],
        [-95, 166],
        [-58, -6],
        [-138, -50],
        [-26, -20],
        [-78, -113],
        [-271, -258],
        [-1137, -12],
        [-808, -14],
        [-1638, -39],
        [141, 74],
        [599, 244],
        [704, 353],
        [-3, 17],
        [1126, 4088],
        [2490, 760],
        [6, 2],
        [495, 151],
        [391, 136],
        [743, 255],
        [67, -38],
        [57, 5],
        [34, 30],
        [88, -38],
        [153, -62],
        [170, -81],
        [77, -67],
        [16, -39],
        [14, -43],
        [481, -24],
        [105, 113],
        [49, 74],
        [65, 50],
        [99, 45],
        [171, 31],
        [85, 1],
        [58, 37],
        [9, 16],
        [6, 2],
        [6, 4],
        [4, 5],
        [2, 6],
        [0, 11],
        [-2, 16],
        [-2, 8],
        [0, 12],
        [-2, 9],
        [-7, 22],
        [-5, 10],
        [-9, 7],
        [-10, 6],
        [-9, 7],
        [-1, 4],
        [1, 8],
        [2, 6],
        [4, 7],
        [3, 2],
        [2, 2],
        [2, 0],
        [-1, 5],
        [2, 4],
        [5, 1],
        [6, 6],
        [0, 5],
        [1, 6],
        [-2, 7],
        [2, 5],
        [5, 6],
        [7, 2],
        [8, -2],
        [2, -6],
        [4, -1],
        [4, 0],
        [4, 1],
        [14, -5],
        [10, -4],
        [-8, 152],
        [-1, 289],
        [408, 140],
        [408, 140],
        [4, 2],
        [60, 20],
        [33, 14],
        [187, 67],
        [177, 64],
        [63, 22],
        [809, 271],
        [466, 159],
        [19, 0],
        [4, 0],
        [122, -4],
        [124, -6],
        [174, 2],
        [533, 2],
        [369, 2],
        [33, 10],
        [78, -2],
        [9, -440],
        [454, -2],
        [5, 0],
        [682, 0],
        [606, 0],
        [218, 0],
        [0, 43],
        [4, 808],
        [0, 347],
        [2, 225],
        [2, 281],
        [-26, 256],
        [-10, 662],
        [1, 515],
        [17, 593],
        [274, 250],
        [8, 6],
        [42, 38],
        [401, 355],
        [42, 76],
        [48, 85],
        [42, 46],
        [77, 119],
        [14, 34],
      ],
      [
        [48291, 287958],
        [22, 50],
        [36, 79],
        [43, 114],
        [9, 53],
        [4, 67],
        [21, 73],
        [44, 73],
        [45, 78],
        [63, 66],
        [44, 50],
        [39, 32],
        [0, 9],
        [13, 4],
        [636, 185],
        [383, 111],
        [6, 2],
        [5, 2],
        [125, 37],
        [520, 154],
        [-205, 200],
        [229, 59],
        [7, 4],
        [-41, 48],
        [-9, 69],
        [-30, 112],
        [-17, 77],
        [-23, 140],
        [-24, 23],
        [-235, 200],
        [42, 78],
        [93, 213],
        [34, 98],
        [33, 94],
        [5, 19],
        [82, 214],
        [9, 13],
        [-19, 369],
        [106, 367],
        [86, 395],
        [659, 242],
        [-1, 5],
        [-1, 11],
        [-10, 91],
        [4, 62],
        [10, 39],
        [26, 44],
        [34, 28],
        [22, 13],
        [6, 4],
        [83, 28],
        [127, 5],
        [3, 0],
        [546, 15],
        [75, 2],
        [108, 2],
        [10, 58],
        [34, 86],
        [51, 43],
        [19, 88],
        [30, 91],
        [46, 226],
        [-2, 108],
        [29, 187],
        [20, 181],
        [-23, 185],
        [-10, 73],
        [-24, 106],
        [-36, 67],
        [-10, 41],
        [81, 78],
        [42, 50],
        [40, 78],
        [62, 124],
        [51, 134],
        [13, 129],
        [755, -10],
        [23, 5],
        [24, 13],
        [27, 14],
        [24, 6],
        [27, 26],
        [24, 31],
        [35, 55],
        [23, 53],
        [19, 47],
        [13, 56],
        [1, 62],
        [4, 256],
        [0, 52],
        [-27, 147],
        [-4, 4],
        [-10, 17],
        [-6, 9],
        [-3, 13],
        [3, 20],
        [4, 26],
        [4, 25],
        [4, 26],
        [3, 20],
        [5, 20],
        [5, 13],
        [14, 20],
        [16, 22],
        [11, 18],
        [6, 14],
        [10, 11],
        [6, 13],
        [0, 15],
        [-4, 9],
        [-8, 10],
        [-10, 3],
        [-4, 1],
        [-9, 2],
        [0, 15],
        [122, 82],
        [-99, 232],
        [-18, 42],
        [-137, 329],
        [-49, 185],
        [162, 113],
        [188, 131],
        [134, -203],
        [262, -404],
        [26, -38],
        [222, -339],
        [48, 14],
        [47, 4],
        [63, 20],
        [175, 43],
        [92, 35],
        [68, 6],
        [37, -4],
        [53, -14],
        [81, -12],
        [140, 74],
        [19, 38],
        [16, 33],
        [2, 33],
        [2, 29],
        [2, 38],
        [-2, 61],
        [14, 64],
        [28, 68],
        [39, 77],
        [89, 79],
        [135, 85],
        [134, 92],
        [132, 98],
        [98, 108],
        [58, 62],
        [62, 75],
        [91, 125],
        [30, 123],
        [-1, 99],
        [-25, 92],
        [-66, 67],
        [-95, 44],
        [-87, 30],
        [-62, 14],
        [-133, 2],
        [-119, -6],
        [-107, 30],
        [-145, 73],
        [-70, 56],
        [-73, 59],
        [-48, 39],
        [-80, 82],
        [-60, 75],
        [-35, 59],
        [-54, 102],
        [-24, 71],
        [-25, 84],
        [-16, 67],
        [-9, 128],
        [5, 39],
        [11, 80],
        [9, 64],
        [21, 76],
        [13, 42],
        [42, 63],
        [25, 36],
        [22, 25],
        [50, 49],
        [47, 24],
        [61, 29],
        [57, 19],
        [59, 19],
        [71, 27],
        [185, 29],
        [85, 85],
        [-2, 10],
        [0, 5],
        [4, 11],
        [0, 21],
        [-9, 14],
        [5, 23],
        [-5, 17],
        [3, 46],
        [48, 37],
        [8, 8],
        [5, 0],
        [1, 2],
        [3, 2],
        [10, 0],
        [4, 4],
        [6, 4],
        [9, 2],
        [6, 2],
        [8, 6],
        [6, 6],
        [11, 22],
        [8, 9],
        [7, 6],
        [8, 1],
        [7, -1],
        [6, 4],
        [10, 11],
        [13, 11],
        [15, 10],
        [4, 3],
        [10, 0],
        [4, 1],
        [4, 4],
        [0, 9],
        [1, 8],
        [-5, 4],
        [-2, 9],
        [-4, 14],
        [0, 10],
        [-2, 12],
        [0, 10],
        [8, 10],
        [2, 9],
        [2, 6],
        [11, 9],
        [13, 4],
        [13, 2],
        [18, -4],
        [11, 0],
        [12, -1],
        [10, -1],
        [10, 2],
        [12, 5],
        [20, 12],
        [16, 9],
        [15, 7],
        [22, 16],
        [12, 12],
        [14, 20],
        [18, 33],
        [5, 4],
        [15, 1],
        [5, 8],
        [10, 5],
        [3, 6],
        [16, 4],
        [-1, 9],
        [-3, 9],
        [-1, 14],
        [-3, 10],
        [8, 4],
        [7, 18],
        [7, 4],
        [7, 16],
        [10, 2],
        [4, 4],
        [12, 8],
        [23, 12],
        [16, 17],
        [3, 11],
        [15, 12],
        [11, 8],
        [11, 8],
        [8, 6],
        [6, 5],
        [2, 9],
        [4, 3],
        [6, 2],
        [5, 14],
        [7, 8],
        [6, 10],
        [4, 10],
        [5, 6],
        [1, 10],
        [4, 12],
        [7, 13],
        [2, 13],
        [1, 21],
        [3, 15],
        [10, 19],
        [7, 24],
        [8, 36],
        [56, 16],
        [650, 2240],
        [33, 116],
        [125, 37],
        [1, -2],
        [7, -4],
        [9, -6],
        [10, -3],
        [10, -6],
        [8, -4],
        [5, -4],
        [-1, -6],
        [-4, -4],
        [-10, -2],
        [-8, -2],
        [-12, 2],
        [-5, -4],
        [-5, -4],
        [-2, -6],
        [1, -4],
        [1, -4],
        [2, -8],
        [6, -6],
        [7, -3],
        [10, 0],
        [8, -2],
        [5, 4],
        [2, 5],
        [1, 6],
        [-1, 8],
        [4, 4],
        [1, 6],
        [4, 4],
        [4, 2],
        [6, 2],
        [8, 4],
        [6, 4],
        [6, 6],
        [4, 2],
        [8, 6],
        [7, 9],
        [1, 8],
        [5, 2],
        [8, 6],
        [4, 3],
        [3, 4],
        [2, 8],
        [2, 4],
        [0, 7],
        [-3, 11],
        [1, 8],
        [0, 10],
        [-2, 5],
        [-8, 6],
        [-5, 9],
        [0, 6],
        [2, 4],
        [7, 0],
        [9, -2],
        [15, -2],
        [1540, 2927],
        [429, 813],
        [1132, 2146],
        [35, 68],
        [1436, 200],
        [17, 2],
        [5, 2],
        [897, 125],
        [5, 1],
        [3, 0],
        [278, 38],
        [-343, 51],
        [-4182, 602],
        [-24, 4],
        [-104, 14],
        [-182, 73],
      ],
      [
        [250556, 49341],
        [-1284, -668],
        [-48, -344],
        [0, -38],
        [13, -21],
        [16, -6],
        [13, -5],
        [6, 1],
        [25, 2],
        [24, -9],
        [-3, -17],
        [-1, -12],
        [5, -12],
        [0, -36],
        [-11, -28],
        [-18, -23],
        [-4, -27],
        [-7, -18],
        [-7, -13],
        [-3, -8],
        [-6, -16],
        [-1, -23],
        [9, -38],
        [15, -33],
        [14, -19],
        [19, -12],
        [26, -14],
        [24, -8],
        [11, -12],
        [2, -18],
        [-2, -21],
        [-11, -15],
        [-13, -5],
        [-10, -15],
        [-2, -21],
        [8, -12],
        [6, -12],
        [18, -10],
        [24, 4],
        [17, 8],
        [4, -4],
        [2, -4],
        [6, -20],
        [0, -2],
        [-4, -29],
        [-2, -16],
        [-4, -22],
        [-10, -23],
        [-2, 0],
        [-9, -38],
        [2, -9],
        [2, -23],
        [-2, -19],
        [-22, -22],
        [-19, -16],
        [-8, -7],
        [-6, -31],
        [5, -10],
        [7, -16],
        [13, -27],
        [2, -17],
        [-3, -18],
        [-10, -13],
        [-18, -22],
        [-12, -25],
        [-5, -20],
        [4, -25],
        [14, -20],
        [3, -4],
        [7, -12],
        [0, -17],
        [-6, -11],
        [0, -6],
        [-2, -10],
        [2, -4],
        [2, -5],
        [9, -2],
        [10, -2],
        [0, -4],
        [3, -11],
        [-2, -13],
        [-1, -6],
        [-4, -17],
        [-2, -18],
        [7, -11],
        [-1, -15],
        [-19, -68],
        [-6, -22],
        [-10, -32],
        [-5, -30],
        [7, -21],
        [29, -48],
        [1, -8],
        [3, -12],
        [0, -26],
        [2, -9],
        [2, -10],
        [8, -5],
        [7, -5],
        [10, 1],
        [13, 0],
        [5, -4],
        [11, -6],
        [7, -6],
        [7, -6],
        [23, -57],
        [1, -39],
        [-6, -46],
        [-12, -16],
        [-11, -12],
        [-10, -15],
        [-13, -25],
        [-11, -22],
        [-6, -11],
        [-4, -4],
        [-4, -9],
        [-23, -23],
        [-6, -30],
        [9, -34],
        [12, -21],
        [24, -15],
        [25, -10],
        [16, -5],
        [9, -17],
        [0, -6],
        [0, -17],
        [-5, -14],
        [-7, -6],
        [-13, -12],
        [-4, -6],
        [-19, -13],
        [-12, -9],
        [-4, -3],
        [-18, -14],
        [-19, -13],
        [-14, -3],
        [-14, 0],
        [-19, -1],
        [-23, -8],
        [-16, -21],
        [-6, -27],
        [12, -26],
        [46, -67],
        [10, -21],
        [17, -21],
        [14, -28],
        [1, -57],
        [-5, -30],
        [-1, -10],
        [-1, -52],
        [-4, -18],
        [7, -13],
        [0, -6],
        [2, -32],
        [-6, -38],
        [-1, -27],
        [10, -41],
        [17, -46],
        [11, -41],
        [0, -12],
        [0, -18],
        [8, -28],
        [8, -15],
        [12, -11],
        [10, -2],
        [19, 2],
        [17, -1],
        [19, -5],
        [26, -13],
        [0, -11],
        [-4, -8],
        [-6, -11],
        [-2, -14],
        [-4, -12],
        [-8, -6],
        [-7, -6],
        [-1, -12],
        [1, -11],
        [0, -7],
        [1, -23],
        [6, -10],
        [0, -1],
        [6, -6],
        [2, -7],
        [0, -5],
        [0, -1],
        [-2, -7],
        [2, -10],
        [18, -20],
        [9, -30],
        [-39, 1],
        [-354, 5],
        [-20, 0],
        [-1048, 16],
        [-1280, -3110],
        [-2214, -938],
        [-752, -320],
        [271, -1384],
        [49, -240],
        [-126, -35],
        [-16, -4],
        [-8, -2],
        [-8, -3],
        [4, -9],
        [24, 3],
        [1491, -2984],
        [-6, -11],
        [183, -356],
        [-255, -177],
        [-548, -1465],
        [12, -45],
        [26, -38],
        [41, -26],
        [340, -190],
        [6, -25],
        [25, -36],
        [5, -6],
        [10, -16],
        [121, -82],
        [4, -4],
        [5, -18],
        [-3, -8],
        [-2, -11],
        [-2, -4],
        [-4, -8],
        [-15, -18],
        [-11, -6],
        [-4, -12],
        [-2, -6],
        [4, -8],
        [2, -3],
        [0, -8],
        [-3, -8],
        [-21, -9],
        [-26, 6],
        [-4, 0],
        [-35, 12],
        [-13, 0],
        [-2, -3],
        [-4, -3],
        [-6, -18],
        [13, -18],
        [6, -24],
        [4, -11],
        [2, -5],
        [4, -19],
        [2, -14],
        [0, -24],
        [-6, -18],
        [-42, -30],
        [-50, -35],
        [-28, -26],
        [-8, -11],
        [-2, -10],
        [-4, -9],
        [2, -18],
        [0, -6],
        [0, -8],
        [-8, -55],
        [-4, -10],
        [-2, -4],
        [-10, -32],
        [0, -23],
        [0, -25],
        [0, -18],
        [3, -8],
        [-6, -53],
        [-15, 2],
        [-76, 8],
        [-21, 2],
        [-22, 2],
        [-3, -2],
        [-5, 0],
        [-30, -6],
        [-23, -10],
        [-16, -7],
        [-9, -5],
        [-36, -18],
        [-22, -9],
        [-29, -13],
        [-12, -7],
        [-24, -12],
        [-22, -18],
        [-12, -9],
        [-38, -20],
        [-16, -10],
        [-18, -13],
        [-6, -4],
        [-23, -21],
        [-13, -15],
        [-4, -7],
        [-9, -26],
        [0, -16],
        [3, -12],
        [4, -10],
        [8, -9],
        [8, -8],
        [12, -8],
        [12, -6],
        [17, -10],
        [12, -6],
        [16, -12],
        [2, -20],
        [-3, -17],
        [-2, -18],
        [0, -10],
        [2, -15],
        [5, -32],
        [1, -2],
        [5, -20],
        [-2, -17],
        [-1, -8],
        [-9, -13],
        [-13, -6],
        [-14, -4],
        [-2, 0],
        [-12, -9],
        [-10, -9],
        [-18, -22],
        [-13, -29],
        [-5, -14],
        [-7, -13],
        [-12, -26],
        [-10, -7],
        [-21, -8],
        [-10, -11],
        [0, -23],
        [2, -14],
        [2, -18],
        [14, -28],
        [16, -9],
        [10, 8],
        [5, 9],
        [5, 10],
        [8, 16],
        [21, 2],
        [19, 2],
        [2, -2],
        [0, -12],
        [-10, -36],
        [-4, -14],
        [-2, -5],
        [-5, -6],
        [-6, -7],
        [-52, -39],
        [-27, -2],
        [-18, -2],
        [-12, -12],
        [-2, -18],
        [8, -24],
        [20, -30],
        [8, -20],
        [8, -24],
        [15, -18],
        [1, -5],
        [13, -39],
        [-2, -37],
        [-1, -7],
        [-5, -18],
        [-9, -23],
        [-10, -7],
        [-10, -6],
        [-2, -2],
        [-6, -8],
        [-1, -12],
        [-3, -4],
        [-1, -2],
        [-9, -4],
        [-12, 2],
        [-10, -7],
        [-10, -7],
        [-49, -14],
        [-2, -1],
        [-4, -5],
        [-6, -3],
        [-6, -2],
        [-10, 4],
        [-18, 15],
        [-9, 11],
        [-17, 19],
        [-25, 30],
        [-23, 18],
        [-49, 18],
        [-18, 12],
        [-19, 0],
        [-11, -13],
        [-2, -8],
        [-4, -10],
        [-2, -33],
        [-4, -46],
        [16, -47],
        [19, -60],
        [13, -66],
        [3, -31],
        [-4, -19],
        [-14, -21],
        [-29, -26],
        [-23, -22],
        [-10, -18],
        [-20, -33],
        [-13, -28],
        [-9, -19],
        [-37, -42],
        [-7, -10],
        [-18, -18],
        [-7, -29],
        [9, -15],
        [8, -7],
        [8, -4],
        [13, -2],
        [8, -2],
        [23, 0],
        [27, -4],
        [42, -50],
        [16, -35],
        [0, -24],
        [-8, -14],
        [-4, -4],
        [-2, 0],
        [-28, -6],
        [-48, -7],
        [-54, -6],
        [-37, -6],
        [-6, -19],
        [-6, -17],
        [12, -12],
        [16, -10],
        [28, -10],
        [8, -4],
        [25, -15],
        [10, -20],
        [0, -19],
        [0, -50],
        [1, -55],
        [1, -16],
        [-2, -10],
        [-2, -8],
        [-2, -2],
        [0, -4],
        [-95, 28],
        [-22, 8],
        [-31, -1],
        [-36, 6],
        [-32, 0],
        [-28, 0],
        [-8, -2],
        [-17, -4],
        [-24, -13],
        [-6, -4],
        [0, -12],
        [0, -8],
        [-44, -72],
        [-39, 14],
        [-8, 5],
        [-5, 11],
        [-30, 12],
        [-4, -2],
        [-12, 6],
        [-2, -10],
        [-18, -12],
        [-6, -29],
        [-6, -68],
        [-6, -30],
        [-5, -48],
        [0, -25],
        [0, -32],
        [-33, -13],
        [-9, -4],
        [-18, 13],
        [-12, 6],
        [-25, 6],
        [-8, 0],
        [-13, 0],
        [-16, 6],
        [-12, -21],
        [-29, -21],
        [-24, -49],
        [-12, -36],
        [-6, -30],
        [6, -10],
        [6, -15],
        [11, -6],
        [20, -12],
        [14, -6],
        [10, -5],
        [0, -18],
        [-13, -24],
        [-23, -45],
        [-6, -8],
        [-18, -57],
        [-6, -29],
        [0, -12],
        [1, -152],
        [-8, -17],
        [-4, -13],
        [-12, -11],
        [-12, 0],
        [-6, 0],
        [-12, 6],
        [-36, 24],
        [-30, 5],
        [-31, -6],
        [-25, -15],
        [-26, -16],
        [-62, -26],
        [-40, -15],
        [5, -19],
        [4, -24],
        [1, -8],
        [3, -27],
        [-18, -50],
        [-5, -34],
        [3, -30],
        [12, -26],
        [17, -11],
        [8, 3],
        [10, 3],
        [10, 10],
        [8, 8],
        [12, 24],
        [18, 18],
        [13, 0],
        [11, 0],
        [24, -6],
        [17, -17],
        [4, -19],
        [1, -8],
        [2, -22],
        [-12, -30],
        [-8, -16],
        [-16, -33],
        [-9, -11],
        [-10, -13],
        [-121, -64],
        [18, -63],
        [1, -4],
        [-2, -7],
        [-8, -25],
        [-19, -24],
        [-29, -18],
        [-16, 0],
        [-27, 0],
        [-30, 0],
        [-9, -2],
        [-2, -2],
        [-12, -2],
        [-18, -6],
        [-43, -31],
        [-24, -18],
        [0, -12],
        [6, -13],
        [12, -8],
        [4, -3],
        [7, -10],
        [1, -2],
        [1, -1],
        [1, -7],
        [2, -14],
        [0, -2],
        [-16, -49],
        [-6, -8],
        [-2, -3],
        [-8, -12],
        [-44, -37],
        [-1, -2],
        [-26, -22],
        [-27, -22],
        [0, -2],
        [-20, -8],
        [-16, -6],
        [-10, -5],
        [-26, -6],
        [-23, 6],
        [-1, 0],
        [-14, 0],
        [-16, 0],
        [-24, -6],
        [-4, -5],
        [-2, -2],
        [-2, -4],
        [-2, -1],
        [6, -18],
        [9, -18],
        [13, -18],
        [32, -25],
        [17, -12],
        [14, -14],
        [18, -16],
        [15, -15],
        [8, -9],
        [18, -36],
        [12, -42],
        [-4, -43],
        [-2, -4],
        [-8, -16],
        [-10, -22],
        [-18, -36],
        [-18, -30],
        [-17, -40],
        [-10, -33],
        [-6, -5],
        [-12, -10],
        [-9, -9],
        [-10, -7],
        [-9, -5],
        [-23, -19],
        [-12, -24],
        [-6, -41],
        [-4, -21],
        [-13, -77],
        [-8, -34],
        [-4, -25],
        [-5, -16],
        [-2, -3],
        [-9, -3],
        [-20, -8],
        [-26, 0],
        [-23, 6],
        [-3, 5],
        [-3, 4],
        [0, 2],
        [-10, 17],
        [-13, 37],
        [-11, 53],
        [-5, 28],
        [-16, 27],
        [-12, 9],
        [-14, 10],
        [-6, 3],
        [-3, 0],
        [-19, 7],
        [-33, 4],
        [-14, 0],
        [-14, -2],
        [-21, -6],
        [-9, -10],
        [-12, -22],
        [-3, -21],
        [-1, -7],
        [2, -5],
        [8, -15],
        [36, -25],
        [6, -6],
        [4, -6],
        [25, -28],
        [7, -12],
        [9, -15],
        [237, -941],
        [327, 23],
        [-73, -1327],
        [-343, -670],
        [-21, -70],
        [-108, -269],
        [569, -2038],
        [134, -572],
        [683, -1857],
        [149, -404],
        [2109, 524],
        [17, -136],
        [27, -6],
        [54, -13],
        [39, -122],
        [6, -40],
        [25, -87],
        [42, -130],
        [10, -102],
        [0, -50],
        [0, -93],
        [-51, -60],
        [-225, -38],
        [-76, -142],
        [-5, 0],
        [-12, 0],
        [-33, -37],
        [-32, -65],
        [-52, -43],
        [-33, -12],
        [-31, -12],
        [-3, -2],
        [-2, 2],
        [-52, -87],
        [0, -2],
        [0, -3],
        [-41, -108],
        [-30, -133],
        [-13, -26],
        [-60, -91],
        [-39, -50],
        [-18, -24],
        [-32, -19],
        [-13, -34],
        [16, -116],
        [58, -178],
        [11, -47],
        [8, -34],
        [10, -20],
        [10, -26],
        [28, -30],
        [27, -26],
        [94, -32],
        [77, -7],
        [32, 13],
        [30, 24],
        [65, 10],
        [90, 2],
        [81, -8],
        [80, 4],
        [147, 26],
        [113, 16],
        [101, 22],
        [186, 17],
        [92, 8],
        [17, -1],
        [16, 0],
        [1, 0],
        [41, -1],
        [37, -19],
        [6, -28],
        [8, -32],
        [40, -85],
        [2, -30],
        [4, -57],
        [-11, -60],
        [-4, -19],
        [-22, -77],
        [-5, -53],
        [33, -149],
        [30, -127],
        [35, -99],
        [9, -153],
        [20, -85],
        [0, -56],
        [-26, -39],
        [-56, -14],
        [-42, -12],
        [-29, -7],
        [-62, -49],
        [-52, -71],
        [-58, -77],
        [-65, -60],
        [-30, -58],
        [0, -19],
        [-2, -41],
        [-20, -100],
        [-16, -33],
        [-32, -48],
        [-10, -67],
        [13, -66],
        [46, -67],
        [59, -57],
        [24, -16],
        [2, 0],
        [57, -39],
        [35, -49],
        [444, -241],
        [177, -90],
        [58, -55],
        [82, -67],
        [61, -44],
        [33, -59],
        [58, -139],
        [42, -201],
        [-14, -78],
        [-30, -86],
        [-22, -117],
        [13, -108],
        [21, -109],
        [4, -87],
        [-8, -153],
        [-24, -173],
        [-33, -46],
        [-19, -74],
        [0, -81],
        [27, -35],
        [28, -37],
        [19, -37],
        [14, -75],
        [17, -59],
        [48, -41],
        [46, -40],
        [8, -27],
        [6, -18],
        [-13, -31],
        [-14, -33],
        [-9, -9],
        [-49, -43],
        [-7, -8],
        [-27, -42],
        [-10, -16],
        [-11, -55],
        [-6, -28],
        [34, -66],
        [2, -5],
        [6, -15],
        [13, -35],
        [19, -50],
        [54, -79],
        [4, -7],
        [10, -13],
        [22, -29],
        [16, -22],
        [7, -64],
        [-11, -70],
        [-1, -9],
        [-2, -11],
        [-6, -66],
        [-5, -49],
        [-3, -41],
        [-19, -101],
        [-2, -7],
        [-7, -19],
        [-11, -30],
        [-1, -2],
        [0, -1],
        [-19, -44],
        [-19, -46],
        [-6, -24],
        [-23, -97],
        [2, -28],
        [0, -14],
        [0, -8],
        [0, -2],
        [3, -8],
        [6, -20],
        [2, -6],
        [4, -15],
        [2, -7],
        [14, -54],
        [-21, -53],
        [-4, -5],
        [-10, -10],
        [-27, -26],
        [-44, -42],
        [-14, -39],
        [-7, -22],
        [-2, -4],
        [-19, -52],
        [-27, -70],
        [-19, -39],
        [-40, -79],
        [-7, -6],
        [-40, -40],
        [-81, -20],
        [-78, -8],
        [-34, -35],
        [-5, -4],
        [-1, -2],
        [0, -4],
        [-11, -33],
        [15, -47],
        [23, -18],
        [12, -10],
        [0, 0],
        [15, -14],
        [14, -10],
        [36, -39],
        [17, -17],
        [22, -43],
        [17, -34],
        [4, -28],
        [7, -29],
        [-17, -33],
        [-11, -23],
        [-51, -53],
        [-6, -6],
        [-4, -4],
        [-8, -9],
        [-4, -5],
        [-4, -3],
        [-10, -9],
        [-16, -17],
        [-14, -16],
        [-9, -9],
        [-15, -9],
        [-56, -40],
        [-115, -41],
        [-159, -62],
        [-73, -22],
        [-1, -2],
        [-73, -2],
        [-30, 0],
        [-19, 0],
        [-22, -4],
        [-29, -8],
        [-13, -2],
        [-57, -44],
        [-16, -34],
        [-6, -15],
        [-2, -2],
        [-25, -38],
        [-53, -34],
        [-38, -42],
        [-15, -55],
        [-14, -52],
        [-30, -48],
        [-4, -6],
        [-25, -69],
        [-14, -34],
        [-2, -8],
        [-2, -16],
        [-13, -56],
        [-29, -42],
        [-12, -18],
        [-6, -7],
        [-6, -10],
        [-48, -43],
        [-10, -25],
        [-23, -28],
        [-30, -2],
        [-28, 39],
        [-6, 8],
        [-19, 21],
        [4, 23],
        [3, 11],
        [-1, 7],
        [-3, 22],
        [-14, 17],
        [-28, 0],
        [-17, -5],
        [-8, -4],
        [-8, -8],
        [-9, -8],
        [-16, -24],
        [-9, -36],
        [-9, -43],
        [-9, -28],
        [-8, -24],
        [0, -2],
        [-42, -74],
        [-2, -2],
        [-81, -93],
        [-8, -6],
        [-34, 0],
        [-99, 0],
        [-107, 10],
        [-3, 5],
        [-26, 0],
        [-15, -3],
        [-4, -4],
        [-11, -3],
        [-15, -10],
        [-8, -13],
        [-2, -30],
        [-9, -26],
        [-15, -21],
        [-121, -72],
        [-20, 19],
        [-3, 4],
        [-13, 86],
        [0, 5],
        [-2, 9],
        [7, 9],
        [-5, 14],
        [-14, 25],
        [-44, 11],
        [-47, 4],
        [-81, -36],
        [-33, -8],
        [-12, -3],
        [-8, 6],
        [-41, 82],
        [-4, 16],
        [-4, 12],
        [-5, 23],
        [11, 34],
        [-9, 18],
        [-12, 8],
        [-113, 42],
        [-8, 8],
        [-6, 4],
        [0, 2],
        [7, 45],
        [35, 19],
        [13, 13],
        [1, 13],
        [2, 13],
        [-1, 10],
        [-1, 14],
        [-7, 19],
        [-8, 24],
        [-3, 17],
        [1, 8],
        [0, 8],
        [19, 139],
        [-70, 33],
        [-14, 43],
        [-34, 40],
        [-4, 4],
        [-8, 7],
        [-38, 27],
        [-14, 22],
        [0, 57],
        [-6, 8],
        [-6, 12],
        [-27, -2],
        [-44, -15],
        [-79, 9],
        [-27, 9],
        [-10, 6],
        [-19, 11],
        [-18, 30],
        [0, 1],
        [-2, 2],
        [-14, 7],
        [-38, 21],
        [-23, -2],
        [-6, 3],
        [-12, 5],
        [-37, 12],
        [-44, 12],
        [-64, 4],
        [-46, 4],
        [-29, 16],
        [-42, 39],
        [-3, 106],
        [9, 38],
        [-8, 66],
        [-24, 9],
        [-24, 4],
        [-26, -8],
        [-1, -1],
        [-41, -25],
        [-40, 15],
        [-14, 36],
        [-8, 8],
        [-33, 12],
        [-24, -2],
        [-17, -1],
        [-42, 8],
        [-50, 13],
        [-30, 16],
        [-20, 9],
        [-41, 19],
        [-34, -2],
        [-47, -1],
        [-19, 3],
        [0, 0],
        [-12, 2],
        [-23, 19],
        [-16, 12],
        [-12, 34],
        [-2, 17],
        [4, 36],
        [-21, 51],
        [-48, -89],
        [-38, -66],
        [-17, -31],
        [-54, -99],
        [-27, -48],
        [-38, -70],
        [-58, -104],
        [-44, -80],
        [-3, -4],
        [-1, -3],
        [-67, -121],
        [-49, 3],
        [-154, 9],
        [-19, -8],
        [-16, 98],
        [-64, -13],
        [-84, -18],
        [-13, 64],
        [-36, 2],
        [-3, 34],
        [-9, 28],
        [-29, 10],
        [0, 7],
        [-18, -3],
        [-15, -2],
        [-40, -10],
        [-102, 52],
        [-2, -19],
        [-17, 18],
        [-41, -5],
        [-51, -7],
        [-3, 30],
        [-170, -44],
        [-2, -1],
        [6, -15],
        [6, -21],
        [-2, 0],
        [-56, 6],
        [-58, 8],
        [2, -50],
        [-47, -20],
        [-10, 0],
        [-127, -3],
        [0, -3],
        [2, -7],
        [16, -59],
        [11, -46],
        [-41, -78],
        [-1, -4],
        [-12, 1],
        [-11, 0],
        [-22, 2],
        [-47, 5],
        [-17, 4],
        [-8, 2],
        [0, -3],
        [2, -53],
        [-18, 0],
        [-9, -2],
        [-3, 0],
        [-13, 0],
        [-62, -4],
        [-30, -14],
        [-21, 74],
        [-22, 75],
        [0, 4],
        [-17, 57],
        [-21, 74],
        [-6, 18],
        [-3, 10],
        [-18, 64],
        [-11, 37],
        [-8, 32],
        [-2, 2],
        [0, 6],
        [-43, 141],
        [-44, 155],
        [-2, 4],
        [-4, 16],
        [-37, 128],
        [-34, 118],
        [-1, 0],
        [0, 10],
        [-104, 64],
        [7, 284],
        [-107, 64],
        [-671, 172],
        [-28, -10],
        [-25, -8],
        [-148, -51],
        [-285, -53],
        [-390, 68],
        [-430, 63],
        [-158, -83],
        [16, -192],
        [-491, -110],
        [-373, 19],
        [-53, 64],
        [-60, 73],
        [-52, 28],
        [-40, 10],
        [-53, 4],
        [-148, -18],
        [-54, 8],
        [-59, 24],
        [-46, 56],
        [-36, 83],
        [-55, 86],
        [-10, 25],
        [-11, 43],
        [-14, 24],
        [-24, 27],
        [-12, 25],
        [2, 24],
        [59, 46],
        [33, 35],
        [15, 43],
        [2, 60],
        [1, 83],
        [-39, 823],
        [-300, 152],
        [-60, 189],
        [-359, 279],
        [-343, 4],
        [-110, 87],
        [-160, 126],
        [-259, 518],
        [-6, 12],
        [-315, 628],
        [34, 153],
        [18, 86],
        [-6, 12],
        [-17, 30],
        [-129, 23],
        [-63, 10],
        [-131, 0],
        [-173, 10],
        [-64, -12],
        [-26, -4],
        [-54, 11],
        [-53, 24],
        [-18, -249],
        [-45, -6],
        [30, -303],
        [31, -175],
        [25, -82],
        [19, -61],
        [6, -6],
        [16, -54],
        [8, -25],
        [37, -35],
        [73, -134],
        [-12, -2],
        [-20, -4],
        [-489, 129],
        [-59, 14],
        [-122, 30],
        [-175, 91],
        [2, -8],
        [-19, 2],
        [-21, 1],
        [10, 25],
        [-4, 11],
        [-8, 4],
        [-10, 4],
        [0, 22],
        [0, 5],
        [-19, 26],
        [-4, 5],
        [-26, 44],
        [7, 9],
        [9, 14],
        [-3, 8],
        [-6, 10],
        [-30, 10],
        [-1, 2],
        [-28, -4],
        [-25, -18],
        [-33, 4],
        [-7, -2],
        [-7, -2],
        [-20, 8],
        [-2, 6],
        [-15, 28],
        [-24, 3],
        [-4, 7],
        [-6, 14],
        [5, 26],
        [-3, 4],
        [-17, -11],
        [-45, -1],
        [-10, 19],
        [14, 19],
        [6, 8],
        [-4, 8],
        [-20, 4],
        [-12, 4],
        [-34, 23],
        [-16, 21],
        [-13, 7],
        [-26, -24],
        [-2, -56],
        [-24, -13],
        [-5, 2],
        [-12, 6],
        [-4, 14],
        [0, 2],
        [-6, 8],
        [-10, -8],
        [2, -26],
        [-11, -17],
        [-25, 12],
        [-23, 12],
        [-12, 23],
        [-28, 4],
        [-12, -11],
        [-32, -31],
        [-8, -16],
        [-15, -33],
        [-49, -29],
        [-28, -70],
        [-8, -107],
        [-22, -17],
        [-25, -79],
        [-53, -45],
        [-52, -18],
        [-54, -55],
        [-15, -37],
        [-8, -10],
        [-14, -14],
        [-32, -2],
        [-36, -34],
        [-78, -13],
        [-113, -26],
        [-74, 19],
        [-66, 50],
        [-7, -14],
        [-25, -45],
        [-190, -142],
        [-8, -33],
        [-4, -14],
        [-3, 0],
        [-28, -18],
        [-16, -16],
        [-22, -10],
        [-18, -10],
        [-9, -6],
        [-28, -4],
        [-16, -4],
        [-12, -4],
        [-29, -1],
        [-41, -6],
        [-17, -4],
        [-29, -5],
        [-23, 4],
        [-21, 4],
        [-66, 10],
        [-73, -9],
        [-43, -36],
        [-2, -2],
        [-24, -38],
        [4, -28],
        [1, -12],
        [-5, -13],
        [-5, -21],
        [-17, -25],
        [-18, -22],
        [-22, -16],
        [-28, -22],
        [-65, 4],
        [-48, 2],
        [-45, -8],
        [-46, -16],
        [-39, -8],
        [-50, 0],
        [-54, 22],
        [-72, 12],
        [-63, 2],
        [-44, -10],
        [-16, -33],
        [-30, -95],
        [-46, -171],
        [-26, -133],
        [-2, -57],
        [0, -1],
        [-1, -42],
        [2, -55],
        [3, -75],
        [20, -94],
        [16, -42],
        [22, -55],
        [8, -22],
        [16, -42],
        [34, -71],
        [44, -63],
        [35, -62],
        [5, -17],
        [13, -46],
        [52, -82],
        [20, -26],
        [47, -63],
        [19, -31],
        [58, -94],
        [30, -49],
        [1, 0],
        [18, -29],
        [23, -95],
        [51, -110],
        [6, -104],
        [35, -47],
        [11, -15],
        [10, -15],
        [12, -16],
        [14, -19],
        [26, -55],
        [6, -14],
        [11, -30],
        [6, -7],
        [13, -21],
        [20, -31],
        [28, -75],
        [17, -44],
        [17, -71],
        [3, -3],
        [8, -10],
        [6, -6],
        [4, -4],
        [0, -13],
        [-2, -12],
        [4, -11],
        [2, -9],
        [66, -105],
        [34, -33],
        [25, -87],
        [33, -30],
        [9, -27],
        [8, -24],
        [4, -25],
        [0, -2],
        [2, -14],
        [12, -26],
        [4, -46],
        [8, -32],
        [14, -14],
        [7, -8],
        [9, -7],
        [2, -4],
        [2, -4],
        [412, -828],
        [118, -381],
        [16, -197],
        [4, -47],
        [32, -135],
        [2, -139],
        [4, -199],
        [197, -995],
        [-94, -499],
        [-2, -3],
        [-95, -147],
        [-10, -23],
        [-2, -7],
        [-13, -23],
        [-15, -30],
        [-24, -21],
        [-6, -6],
        [-7, -8],
        [-13, -13],
        [-6, -6],
        [-24, -22],
        [-16, -36],
        [-13, -18],
        [-15, -24],
        [-11, -11],
        [-24, -2],
        [-18, -2],
        [-39, -7],
        [-20, -5],
        [-15, -6],
        [-45, -8],
        [-48, -9],
        [-12, 0],
        [-61, -4],
        [-55, -4],
        [-18, -20],
        [-46, 2],
        [-73, 14],
        [-56, 14],
        [-34, -4],
        [-15, -4],
        [-12, -4],
        [-42, -2],
        [-56, -5],
        [-50, 2],
        [-55, 3],
        [-1, 0],
        [-1, 0],
        [-1, -1],
        [-31, -2],
        [-13, 0],
        [-57, -6],
        [-35, -3],
        [-22, -1],
        [-22, 3],
        [-41, 30],
        [-38, 27],
        [-61, 9],
        [-84, 2],
        [-20, -13],
        [-10, -5],
        [-62, -13],
        [-38, -14],
        [-48, 2],
        [-37, 6],
        [-38, -6],
        [-20, 4],
        [-20, 3],
        [-15, 10],
        [-12, 7],
        [-28, 21],
        [-35, 6],
        [-39, 13],
        [-33, 17],
        [-58, 32],
        [-70, 83],
        [-51, 39],
        [0, 1],
        [-90, 60],
        [-49, 24],
        [-214, 112],
        [-5, 9],
        [-6, 12],
        [-6, 2],
        [-5, 2],
        [-20, 6],
        [-63, 27],
        [-49, 59],
        [-10, 34],
        [-38, 30],
        [-28, 29],
        [-11, 13],
        [-12, 14],
        [-36, 43],
        [-102, 183],
        [-70, 79],
        [-31, 62],
        [-46, 45],
        [-35, 30],
        [-18, 44],
        [-18, 14],
        [-23, 20],
        [-7, 8],
        [-8, 8],
        [-5, 5],
        [-14, 16],
        [-29, 36],
        [-10, 13],
        [-10, 11],
        [-15, 18],
        [-2, 32],
        [8, 10],
        [-10, 24],
        [-24, 24],
        [-28, 50],
        [-25, 25],
        [-17, 0],
        [-33, 28],
        [-24, 44],
        [-17, 24],
        [-7, 24],
        [-36, 70],
        [-2, 11],
        [-4, 30],
        [-8, 15],
        [-2, 6],
        [-4, 14],
        [-4, 15],
        [-17, 50],
        [-3, 32],
        [-14, 34],
        [-13, 37],
        [-17, 22],
        [-7, 9],
        [-8, 23],
        [-4, 20],
        [-2, 24],
        [-8, 17],
        [-4, 8],
        [-8, 16],
        [-12, 26],
        [-3, 7],
        [-26, 72],
        [-7, 16],
        [-2, 10],
        [3, 20],
        [-11, 25],
        [-21, 44],
        [-2, 4],
        [-14, 28],
        [-6, 34],
        [-4, 12],
        [-5, 15],
        [-14, 16],
        [-6, 5],
        [-6, 4],
        [-2, 4],
        [-7, 9],
        [-14, 23],
        [-5, 7],
        [-7, 11],
        [0, 1],
        [-19, 27],
        [-6, 26],
        [8, 5],
        [3, 1],
        [7, 7],
        [2, 2],
        [-2, 6],
        [-7, 13],
        [-63, 101],
        [-7, 18],
        [0, 24],
        [-49, 53],
        [-59, 63],
        [0, 39],
        [16, 8],
        [-31, 63],
        [-39, 109],
        [-16, 78],
        [-17, 48],
        [-15, 8],
        [-49, 21],
        [-29, 130],
        [-35, 91],
        [-10, 28],
        [-8, 25],
        [-3, 22],
        [-3, 18],
        [-6, 18],
        [-8, 23],
        [-27, 31],
        [-36, 45],
        [-19, 36],
        [-31, 72],
        [-7, 57],
        [-12, 46],
        [-10, 18],
        [-10, 18],
        [-18, 31],
        [-22, 25],
        [-19, 16],
        [-9, 12],
        [-15, 18],
        [-4, 8],
        [-10, 14],
        [-14, 40],
        [5, 14],
        [3, 13],
        [-23, 55],
        [-17, 29],
        [-23, 19],
        [6, 37],
        [-21, 61],
        [-18, 39],
        [-21, 30],
        [-5, 8],
        [-20, 58],
        [-8, 18],
        [-10, 19],
        [-15, 24],
        [-2, 0],
        [-8, 16],
        [-22, 38],
        [-13, 25],
        [-6, 13],
        [-23, 37],
        [-20, 32],
        [-18, 22],
        [-6, 8],
        [-9, 10],
        [-21, 24],
        [-32, 61],
        [-23, 46],
        [-14, 37],
        [-9, 5],
        [-14, 19],
        [-28, 26],
        [-50, 28],
        [-30, 12],
        [-37, 12],
        [-12, -6],
        [-20, -8],
        [-38, -31],
        [-16, -31],
        [-16, -24],
        [-16, -26],
        [-24, -17],
        [-16, -14],
        [-5, -10],
        [-15, -17],
        [-17, -17],
        [-136, -12],
        [-83, -7],
        [8, 36],
        [26, 71],
        [15, 58],
        [14, 64],
        [16, 73],
        [4, 35],
        [11, 38],
        [-130, 460],
        [-17, 60],
        [-1, -1],
        [-16, -8],
        [-19, -9],
        [-52, -17],
        [-56, -5],
        [-17, 6],
        [-34, 11],
        [-10, 7],
        [-58, 63],
        [-29, 30],
        [-44, 46],
        [-56, 71],
        [-12, 20],
        [-51, 44],
        [-54, 55],
        [-13, 22],
        [-8, 20],
        [-13, 34],
        [-16, 45],
        [-7, 32],
        [-4, 38],
        [-3, 29],
        [-1, 23],
        [3, 36],
        [-1, 32],
        [-12, 28],
        [2, 18],
        [3, 16],
        [2, 15],
        [1, 44],
        [-3, 22],
        [-7, 49],
        [-3, 18],
        [-4, 17],
        [-12, 36],
        [-12, 35],
        [0, 13],
        [2, 13],
        [4, 14],
        [0, 15],
        [-4, 25],
        [-2, 14],
        [-9, 43],
        [4, 37],
        [-6, 44],
        [-7, 28],
        [-21, 98],
        [-31, 91],
        [-29, 85],
        [-27, 81],
        [-8, 43],
        [-7, 15],
        [-25, 64],
        [-19, 57],
        [-17, 28],
        [-25, 34],
        [-11, 12],
        [-10, 16],
        [-11, 43],
        [-12, 20],
        [-4, 11],
        [-4, 11],
        [-12, 16],
        [-12, 32],
        [-10, 14],
        [-2, 12],
        [-6, 19],
        [-18, 45],
        [-12, 18],
        [-36, 73],
        [-23, 58],
        [-12, 24],
        [-8, 19],
        [-30, 40],
        [-10, 20],
        [-8, 20],
        [-8, 19],
        [-24, 51],
        [-12, 17],
        [-6, 10],
        [-11, 21],
        [-15, 29],
        [-8, 26],
        [-3, 14],
        [-2, 16],
        [-8, 26],
        [-14, 24],
        [-10, 9],
        [-8, 9],
        [-20, 31],
        [-25, 42],
        [-10, 19],
        [-6, 24],
        [-2, 19],
        [-6, 16],
        [-15, 17],
        [-7, 12],
        [-14, 26],
        [-40, 76],
        [-40, 78],
        [-31, 81],
        [-34, 69],
        [-23, 48],
        [-55, 90],
        [-58, 118],
        [-70, 122],
        [-58, 105],
        [-31, 70],
        [-40, 56],
        [-59, 119],
        [-63, 128],
        [-67, 120],
        [-58, 105],
        [-52, 70],
        [-67, 114],
        [-43, 84],
        [-22, 43],
        [-76, 120],
        [-39, 79],
        [-67, 106],
        [-74, 120],
        [-67, 123],
        [-61, 93],
        [-71, 112],
        [-57, 90],
        [-76, 114],
        [-54, 91],
        [-56, 102],
        [-84, 137],
        [-24, 37],
        [-69, 107],
        [-95, 147],
        [-60, 88],
        [-81, 120],
        [-56, 78],
        [-48, 67],
        [-89, 134],
        [-94, 124],
        [-49, 62],
        [-38, 48],
        [-59, 79],
        [-66, 84],
        [-121, 160],
        [-73, 98],
        [-34, 37],
        [-7, 8],
        [-29, 36],
        [-8, 23],
        [-8, 12],
        [-30, 38],
        [-21, 26],
        [-24, 38],
        [-8, 13],
        [-10, 13],
        [-34, 41],
        [-44, 49],
        [-22, 25],
        [-15, 23],
        [-9, 10],
        [-14, 8],
        [-10, 10],
        [-4, 6],
        [-2, 16],
        [-1, 9],
        [-8, 12],
        [-24, 23],
        [-10, 8],
        [-12, 7],
        [-10, 10],
        [-11, 23],
        [-2, 11],
        [-8, 12],
        [-8, 6],
        [-10, 8],
        [-16, 10],
        [-12, 16],
        [-13, 28],
        [-13, 24],
        [-14, 26],
        [-34, 33],
        [-34, 36],
        [-39, 46],
        [-51, 61],
        [-32, 39],
        [-16, 25],
        [-6, 12],
        [-10, 15],
        [-9, 10],
        [-12, 11],
        [-11, 6],
        [-12, 11],
        [-13, 17],
        [-31, 46],
        [-28, 38],
        [-16, 24],
        [-31, 43],
        [-26, 24],
        [-32, 34],
        [-10, 20],
        [-10, 15],
        [-10, 16],
        [-14, 11],
        [-16, 14],
        [-19, 27],
        [-4, 9],
        [-6, 14],
        [-5, 9],
        [-11, 10],
        [-12, 6],
        [-12, 12],
        [-10, 12],
        [-47, 59],
        [-9, 13],
        [-19, 32],
        [-43, 52],
        [-33, 42],
        [-9, 12],
        [-23, 16],
        [-22, 31],
        [-11, 17],
        [-12, 8],
        [-54, 55],
        [-35, 37],
        [-46, 57],
        [-17, 26],
        [-31, 36],
        [-44, 37],
        [-7, 9],
        [-29, 44],
        [-25, 39],
        [-31, 25],
        [-29, 28],
        [-30, 42],
        [-40, 53],
        [-19, 25],
        [-11, 12],
        [-10, 7],
        [-10, 8],
        [-17, 18],
        [-2, 7],
        [-22, 29],
        [-26, 25],
        [-25, 23],
        [-34, 34],
        [-41, 47],
        [-30, 40],
        [-17, 25],
        [-10, 13],
        [-21, 25],
        [-11, 11],
        [-14, 7],
        [-13, 8],
        [-26, 32],
        [-31, 42],
        [-31, 38],
        [-73, 81],
        [-82, 85],
        [-25, 27],
        [-21, 22],
        [-9, 15],
        [-5, 8],
        [-7, 9],
        [-18, 10],
        [-16, 8],
        [-12, 8],
        [-30, 45],
        [-21, 17],
        [-34, 30],
        [-20, 30],
        [-28, 39],
        [-9, 10],
        [-19, 18],
        [-26, 21],
        [-26, 21],
        [-7, 8],
        [-7, 8],
        [-13, 16],
        [-24, 32],
        [-8, 13],
        [-11, 15],
        [-207, 233],
        [-78, 84],
        [-105, 97],
        [-2, 2],
        [-176, 180],
        [-212, 229],
        [-466, 472],
        [-463, 488],
        [-443, 458],
        [-200, 195],
        [-178, 162],
        [-201, 198],
        [-254, 260],
        [-445, 413],
        [-175, 163],
        [-394, 379],
        [-203, 187],
        [-528, 471],
        [-394, 335],
        [-351, 300],
        [-151, 106],
        [-13, 14],
        [-204, 169],
        [-130, 85],
        [-81, 65],
        [-93, 85],
        [-93, 68],
        [-244, 171],
        [-270, 212],
        [-47, 41],
        [-181, 130],
        [-250, 171],
        [-52, 34],
        [-37, 27],
        [-106, 71],
        [-87, 68],
        [-271, 187],
        [-141, 93],
        [-8, 5],
        [-1, 0],
        [-59, 43],
        [-33, 23],
        [-47, 35],
        [-15, 10],
        [-35, 24],
        [-24, 17],
        [-64, 38],
        [-27, 17],
        [-96, 67],
        [-90, 62],
        [-68, 48],
        [-4, 2],
        [-148, 106],
        [-145, 104],
        [-273, 172],
        [-494, 318],
        [-120, 99],
        [-41, 36],
        [-51, 24],
        [-17, -6],
        [-173, -57],
        [1, 0],
        [0, -2],
        [-2, -1],
        [-11, -8],
        [-4, -2],
        [-5, -2],
        [-57, -21],
        [-25, -10],
        [-23, -8],
        [-25, -6],
        [-70, -18],
        [-2, -2],
        [-4, 0],
        [-3, 2],
        [-3, 2],
        [-2, 2],
        [0, 2],
        [0, 2],
        [1, 4],
        [2, 2],
        [0, 4],
        [17, 28],
        [-7, 12],
        [-3, 5],
        [-14, 14],
        [-28, 22],
        [-37, 52],
        [-65, 74],
        [-15, 17],
        [-41, 46],
        [-44, 59],
        [-8, 10],
        [-28, 43],
        [-57, 55],
        [-13, -19],
        [-15, 13],
        [11, 31],
        [-27, 36],
        [-129, 191],
        [-45, 91],
        [-39, 55],
        [-265, 414],
        [-121, 177],
        [-56, 63],
        [-100, 148],
        [-74, 91],
        [-170, 238],
        [-64, 67],
        [-321, 426],
        [-122, 171],
        [-65, 68],
        [-209, 255],
        [-87, 110],
        [-98, 133],
        [-295, 362],
        [-184, 236],
        [-75, 110],
        [-259, 317],
        [-164, 208],
        [-253, 307],
        [-248, 310],
        [-210, 268],
        [-185, 212],
        [-95, 133],
        [-256, 316],
        [-281, 340],
        [-323, 388],
        [-211, 252],
        [-18, 12],
        [-203, 236],
        [-35, 60],
        [-393, 452],
        [-128, 148],
        [-67, 78],
        [-465, 570],
        [-213, 255],
        [-110, 114],
        [-50, 58],
        [-119, 112],
        [-195, 183],
        [-146, 181],
        [-50, 65],
        [-119, 143],
        [-178, 201],
        [-109, 141],
        [-111, 141],
        [-40, 49],
        [-75, 85],
        [-74, 75],
        [-85, 104],
        [-74, 78],
        [-52, 61],
        [-83, 93],
        [-83, 76],
        [-80, 91],
        [-63, 65],
        [-51, 64],
        [-30, 45],
        [-34, 38],
        [-52, 61],
        [-60, 60],
        [-51, 60],
        [-15, 12],
        [-20, 24],
        [-10, 15],
        [-27, 28],
        [-8, 9],
        [-15, 14],
        [-20, 13],
        [-27, 23],
        [-27, 23],
        [-65, 75],
        [-12, 14],
        [-11, 11],
        [-18, 15],
        [-14, 15],
        [-18, 18],
        [-33, 35],
        [-49, 41],
        [-63, 69],
        [-85, 96],
        [-108, 118],
        [-46, 46],
        [-132, 138],
        [-38, 43],
        [-100, 107],
        [-157, 165],
        [-143, 152],
        [-41, 48],
        [-85, 85],
        [-56, 59],
        [-56, 63],
        [-70, 82],
        [-100, 96],
        [-81, 75],
        [-74, 74],
        [-81, 79],
        [-69, 78],
        [-66, 57],
        [-63, 66],
        [-57, 52],
        [-126, 127],
        [-125, 129],
        [-128, 135],
        [-22, 24],
        [-121, 112],
        [-134, 131],
        [-90, 92],
        [-95, 77],
        [-67, 66],
        [-65, 62],
        [-57, 63],
        [-84, 69],
        [-113, 127],
        [-159, 141],
        [-85, 70],
        [-97, 102],
        [-119, 116],
        [-137, 120],
        [-207, 219],
        [-169, 164],
        [-185, 169],
        [-48, 40],
        [-78, 73],
        [-68, 54],
      ],
      [
        [197033, 48295],
        [-101, 77],
        [-36, 31],
        [-86, 77],
        [-374, 299],
        [-86, 52],
        [-72, 65],
        [-89, 72],
        [-138, 104],
        [-338, 255],
        [-643, 471],
        [-18, -1],
        [-18, 6],
        [-13, 24],
        [-14, 25],
        [-53, 55],
        [-16, 2],
        [-25, 6],
        [-25, 24],
        [-30, 42],
        [-52, 71],
        [-61, 65],
        [-77, 77],
        [-72, 76],
        [-94, 122],
        [-143, 188],
        [-69, 74],
        [-60, 80],
        [-604, 675],
        [-30, 18],
        [-26, 29],
        [-103, 104],
        [-6, 5],
        [-257, 282],
        [-279, 261],
        [-396, 397],
        [-31, 18],
        [-46, 44],
        [-43, 42],
        [-45, 42],
        [-15, 15],
        [-40, 36],
        [-12, 11],
        [-45, 36],
        [-72, 67],
        [-52, 47],
        [-14, 14],
        [-27, 24],
        [-36, 48],
        [-48, 44],
        [-46, 41],
        [-42, 38],
        [-43, 39],
        [-45, 41],
        [-44, 39],
        [-49, 44],
        [-43, 40],
        [-48, 42],
        [-59, 53],
        [-50, 45],
        [-48, 45],
        [-53, 46],
        [-50, 33],
        [-5, 4],
        [-50, 43],
        [-47, 42],
        [-49, 44],
        [-52, 46],
        [-1, 1],
        [-50, 44],
        [-54, 47],
        [-53, 48],
        [-34, 29],
        [-14, 12],
        [-42, 37],
        [-61, 67],
        [-49, 41],
        [-48, 42],
        [-46, 40],
        [-45, 40],
        [-46, 39],
        [-24, 21],
        [-76, 55],
        [-55, 23],
        [-220, 161],
        [-110, 109],
        [-111, 83],
        [-160, 131],
        [-128, 121],
        [-63, 69],
        [-71, 53],
        [-158, 140],
        [-50, 43],
        [-116, 102],
        [-135, 99],
        [-91, 88],
        [-60, 53],
        [-154, 123],
        [-174, 132],
        [-83, 61],
        [-99, 61],
        [-38, 25],
        [-44, 16],
        [-7, 4],
        [-12, 8],
        [-7, 5],
        [-33, 16],
        [-14, 3],
        [-12, 3],
        [-15, 5],
        [-5, 2],
        [-22, 9],
        [-22, 10],
        [-23, 4],
        [-47, 16],
        [-12, 5],
        [-11, 5],
        [-20, 9],
        [-10, 2],
        [-11, 1],
        [-24, 15],
        [-4, 2],
        [-18, 9],
        [-6, 6],
        [-4, 4],
        [-8, 7],
        [-16, 11],
        [-4, 3],
        [-4, 2],
        [-23, 10],
        [-4, 1],
        [-8, 2],
        [-37, 13],
        [-26, 13],
        [-17, 6],
        [-62, 18],
        [-16, 3],
        [-31, 3],
        [-29, 3],
        [-63, -4],
        [-41, -7],
        [-26, -6],
        [-20, -4],
        [-7, -4],
        [-17, -4],
        [-54, -10],
        [-18, -12],
        [-5, -1],
        [-5, -2],
        [-4, -2],
        [-5, -3],
        [-3, -3],
        [-11, -5],
        [-21, -34],
        [-2, -4],
        [-2, -9],
        [-4, -15],
        [-11, -36],
        [-12, -29],
        [-4, -10],
        [-3, -9],
        [-1, -11],
        [-1, -3],
        [0, -4],
        [0, -5],
        [-1, -5],
        [-1, -9],
        [-4, -14],
        [-2, -5],
        [-7, -35],
        [-5, -14],
        [-8, -14],
        [3, -8],
        [8, -10],
        [13, -3],
        [6, 13],
        [16, 12],
        [-2, 8],
        [0, 2],
        [5, 6],
        [9, -4],
        [2, -4],
        [0, -2],
        [0, -8],
        [0, -12],
        [-2, -10],
        [4, -11],
        [16, -7],
        [12, -8],
        [2, -7],
        [7, -18],
        [-1, -27],
        [-2, -5],
        [0, -11],
        [-18, -29],
        [-22, -28],
        [-27, -34],
        [-7, -8],
        [-31, -28],
        [-21, -15],
        [-13, -8],
        [-6, -4],
        [-15, -4],
        [-18, 6],
        [-3, 2],
        [-18, 2],
        [-12, 13],
        [-6, 9],
        [-10, 19],
        [-8, 7],
        [0, 1],
        [-18, 1],
        [-12, -2],
        [-27, -14],
        [-39, -20],
        [-45, -24],
        [-3, -1],
        [-16, -8],
        [-15, -5],
        [-2, 0],
        [-2, -1],
        [-8, -1],
        [-2, 0],
        [-4, 0],
        [-14, 3],
        [-3, 2],
        [-8, 6],
        [-3, 5],
        [8, 12],
        [9, -2],
        [5, 9],
        [0, 3],
        [4, 3],
        [2, 2],
        [0, 2],
        [0, 2],
        [4, 3],
        [6, 2],
        [4, 0],
        [-12, 8],
        [-107, 56],
        [0, 0],
        [-2, -2],
        [-4, -1],
        [-18, -1],
        [-70, 1],
        [-59, 1],
        [-44, 3],
        [-4, 1],
        [-10, -1],
        [-10, -1],
        [-2, -2],
        [-13, -12],
        [-4, -3],
        [-3, -16],
        [-1, -7],
        [0, -26],
        [-2, -7],
        [-8, -19],
        [-2, -24],
        [-10, -12],
        [0, -1],
        [4, -13],
        [0, -1],
        [-8, -10],
        [-3, 4],
        [-8, 14],
        [-21, -20],
        [2, -6],
        [3, -8],
        [-5, -5],
        [-29, -31],
        [-4, 2],
        [0, 0],
        [0, 2],
        [0, 7],
        [-2, 4],
        [19, 26],
        [2, 3],
        [-4, -1],
        [-11, -5],
        [-11, -4],
        [-31, -7],
        [-13, -4],
        [-34, -4],
        [-2, -1],
        [-22, -6],
        [-6, 6],
        [-10, 3],
        [-2, -3],
        [-10, -16],
        [-12, -26],
        [-8, -6],
        [-1, -2],
        [-1, 0],
        [-3, -2],
        [-2, -2],
        [-2, 0],
        [-2, 0],
        [-6, 4],
        [-2, 2],
        [-23, 6],
        [-39, 14],
        [-23, 22],
        [-15, 32],
        [13, 48],
        [31, 32],
        [54, 15],
        [6, 11],
        [21, 46],
        [0, 19],
        [-4, 1],
        [-1, 3],
        [-1, 2],
        [4, 9],
        [2, 4],
        [12, 17],
        [15, 12],
        [2, 22],
        [10, 17],
        [18, 17],
        [15, 16],
        [0, 1],
        [2, 5],
        [6, 5],
        [2, 2],
        [8, 11],
        [-12, 14],
        [4, 10],
        [15, 4],
        [5, 18],
        [3, 13],
        [3, 18],
        [-3, 22],
        [-4, 14],
        [-8, 9],
        [-1, 2],
        [-2, 3],
        [-4, 6],
        [0, 15],
        [11, 7],
        [21, 4],
        [10, 0],
        [10, 2],
        [28, 3],
        [8, 11],
        [10, 12],
        [4, -2],
        [9, -2],
        [2, 4],
        [1, 0],
        [3, 20],
        [17, 67],
        [2, 9],
        [0, 9],
        [-2, 10],
        [-2, 5],
        [-5, 14],
        [-18, 6],
        [0, 6],
        [-2, 7],
        [-4, 8],
        [9, 10],
        [-3, 4],
        [-1, 2],
        [-1, 1],
        [0, 1],
        [-4, 6],
        [-1, 1],
        [-18, 10],
        [-14, 4],
        [-5, 1],
        [-4, 1],
        [-8, -2],
        [-2, 5],
        [-5, 4],
        [-1, 9],
        [-1, 7],
        [-6, 0],
        [-7, 1],
        [-8, -2],
        [-6, -2],
        [-5, 0],
        [-4, 4],
        [0, 1],
        [3, 4],
        [-4, 2],
        [-5, -2],
        [-4, -5],
        [-4, -6],
        [-12, -3],
        [-6, 1],
        [-6, 6],
        [-4, 5],
        [-5, 2],
        [-8, 4],
        [-2, 4],
        [-1, 6],
        [0, 2],
        [3, 2],
        [1, 4],
        [0, 4],
        [1, 4],
        [0, 4],
        [-4, 0],
        [-3, 0],
        [-3, 6],
        [-7, 6],
        [-2, 4],
        [-3, 6],
        [0, 0],
        [3, 0],
        [5, 0],
        [3, 2],
        [0, 0],
        [-1, 6],
        [-1, 0],
        [1, 0],
        [1, 2],
        [0, 2],
        [-3, 0],
        [-4, 2],
        [0, 2],
        [0, 2],
        [-4, 4],
        [-1, 2],
        [-4, 0],
        [-1, 2],
        [-5, -2],
        [-2, 2],
        [-3, 2],
        [-1, 5],
        [0, 1],
        [0, 2],
        [-4, 3],
        [-2, 1],
        [-2, 3],
        [0, 3],
        [3, 4],
        [4, 10],
        [10, 6],
        [4, 10],
        [1, 2],
        [3, 9],
        [0, 2],
        [0, 11],
        [-3, 11],
        [5, 6],
        [2, 2],
        [-2, 2],
        [-4, 2],
        [-2, 2],
        [1, 2],
        [3, 4],
        [3, 2],
        [3, 4],
        [3, -2],
        [1, 4],
        [0, 0],
        [1, 8],
        [1, 4],
        [0, 4],
        [0, 0],
        [0, 4],
        [0, 2],
        [-2, 4],
        [2, 3],
        [2, 2],
        [0, 3],
        [0, 1],
        [-2, 4],
        [-2, 3],
        [-5, 5],
        [-7, 7],
        [-3, 3],
        [3, 3],
        [2, 5],
        [-2, 3],
        [0, 4],
        [4, 3],
        [2, 1],
        [-3, 9],
        [-1, 10],
        [-3, 7],
        [-2, 1],
        [-2, 3],
        [-1, 8],
        [0, 1],
        [-18, 2],
        [-1, -2],
        [-7, -1],
        [-2, 0],
        [-4, 1],
        [-2, 0],
        [-6, 16],
        [0, 2],
        [0, 0],
        [0, 2],
        [2, 7],
        [0, 2],
        [14, 34],
        [2, 4],
        [5, 9],
        [19, 38],
        [7, 13],
        [1, 2],
        [3, 2],
        [3, 0],
        [12, 6],
        [10, 4],
        [19, 12],
        [10, 14],
        [2, 4],
        [6, 8],
        [2, 27],
        [0, 4],
        [0, 5],
        [0, 7],
        [-6, 12],
        [-2, 13],
        [-2, 5],
        [0, 22],
        [-14, 34],
        [-2, 12],
        [-22, 43],
        [-5, 11],
        [-7, 10],
        [-5, 4],
        [-2, 3],
        [-1, 1],
        [-4, 2],
        [-16, 6],
        [-6, -7],
        [-5, -3],
        [-8, 1],
        [-2, 0],
        [-8, -1],
        [-4, -1],
        [-4, 0],
        [-5, 1],
        [-6, 2],
        [-3, 2],
        [0, 4],
        [0, 1],
        [-8, -2],
        [0, 4],
        [5, 5],
        [2, 3],
        [2, 4],
        [1, 4],
        [1, 3],
        [0, 2],
        [0, 4],
        [1, 2],
        [1, 2],
        [-1, 0],
        [-2, 4],
        [-6, 3],
        [-3, 0],
        [-4, 2],
        [-3, -1],
        [-4, -1],
        [-4, -2],
        [-3, 1],
        [-2, 1],
        [-1, 1],
        [-2, 1],
        [1, 1],
        [1, 3],
        [1, 4],
        [-5, -2],
        [-4, 2],
        [-1, 4],
        [3, 2],
        [5, 2],
        [-4, 4],
        [-25, 0],
        [-2, 7],
        [-2, -3],
        [-2, 2],
        [-4, -2],
        [-2, 1],
        [-4, 1],
        [0, 4],
        [0, 1],
        [2, 2],
        [-2, 2],
        [-3, 2],
        [2, 2],
        [3, 1],
        [1, 2],
        [0, 1],
        [-3, 2],
        [0, 2],
        [-2, 2],
        [-1, 3],
        [1, 3],
        [2, 2],
        [0, 1],
        [0, 3],
        [-4, 8],
        [-6, 2],
        [-2, 1],
        [-2, 5],
        [-1, 0],
        [2, 4],
        [3, 7],
        [-2, 17],
        [-8, 6],
        [-4, -3],
        [-6, 3],
        [-2, 7],
        [-4, 5],
        [-2, 1],
        [-2, 2],
        [0, 0],
        [-2, 2],
        [-2, 4],
        [0, 0],
        [0, 2],
        [0, 2],
        [0, 2],
        [0, 6],
        [0, 2],
        [-2, 6],
        [0, 2],
        [2, 10],
        [6, 8],
        [8, 8],
        [4, 6],
        [8, 1],
        [2, 1],
        [7, 1],
        [0, 7],
        [-19, 11],
        [-14, 5],
        [-6, 16],
        [2, 19],
        [6, 15],
        [14, 14],
        [2, 6],
        [4, 9],
        [4, 8],
        [4, 22],
        [6, 8],
        [12, 12],
        [12, 10],
        [4, 1],
        [6, 5],
        [2, 2],
        [2, 2],
        [7, 16],
        [1, 13],
        [-1, 3],
        [0, 2],
        [0, 2],
        [0, 3],
        [0, 6],
        [2, 2],
        [5, 5],
        [2, 2],
        [14, 6],
        [5, 1],
        [7, -1],
        [1, -2],
        [1, -1],
        [-1, -2],
        [-7, -9],
        [-6, -7],
        [-5, -4],
        [-1, -2],
        [-1, -2],
        [-1, -2],
        [0, -3],
        [1, -2],
        [1, 0],
        [16, -2],
        [2, 0],
        [0, 1],
        [1, 5],
        [2, 3],
        [2, 3],
        [4, 9],
        [3, 4],
        [2, 1],
        [4, 7],
        [-4, 78],
        [-4, 10],
        [-2, 6],
        [1, 5],
        [0, 4],
        [-1, 1],
        [-4, 3],
        [0, 1],
        [5, 3],
        [1, 0],
        [4, 2],
        [4, 6],
        [2, 3],
        [2, 3],
        [-2, 3],
        [-2, 4],
        [-2, 2],
        [-6, 1],
        [-1, 1],
        [-11, 0],
        [3, 11],
        [8, 0],
        [1, 0],
        [-1, 4],
        [1, 8],
        [2, 2],
        [0, 2],
        [-2, 0],
        [-3, 2],
        [-5, 2],
        [-2, 4],
        [-1, 2],
        [-5, -2],
        [-1, -2],
        [-5, -4],
        [-1, 0],
        [-1, 0],
        [-7, 6],
        [-1, 2],
        [-1, 4],
        [0, 2],
        [3, 15],
        [2, 6],
        [2, 2],
        [2, 1],
        [2, 0],
        [1, 0],
        [0, -2],
        [37, 18],
        [20, 9],
        [-4, -27],
        [10, -5],
        [9, -2],
        [7, -2],
        [10, 1],
        [10, -1],
        [12, 6],
        [15, 4],
        [10, 7],
        [-2, 4],
        [4, 6],
        [2, 8],
        [0, 12],
        [0, 8],
        [0, 1],
        [10, 5],
        [0, 2],
        [5, 7],
        [5, 2],
        [5, 2],
        [3, 4],
        [3, 2],
        [4, 2],
        [5, 2],
        [2, -4],
        [2, -6],
        [6, 2],
        [0, -2],
        [-4, -5],
        [4, -7],
        [1, -5],
        [2, -7],
        [-4, -3],
        [1, -2],
        [1, -2],
        [3, -6],
        [6, -2],
        [0, -5],
        [2, -4],
        [2, -3],
        [2, -2],
        [0, -4],
        [-5, -6],
        [-1, -17],
        [0, -11],
        [2, -14],
        [9, -10],
        [17, -6],
        [6, 0],
        [23, 8],
        [15, 4],
        [10, 4],
        [23, 14],
        [26, 17],
        [23, 33],
        [38, 53],
        [18, 32],
        [11, 28],
        [12, 36],
        [8, 30],
        [4, 21],
        [9, 36],
        [7, 25],
        [3, 12],
        [3, 24],
        [3, 36],
        [-2, 33],
        [-6, 58],
        [-1, 13],
        [-9, 35],
        [-15, 48],
        [-25, 67],
        [-11, 33],
        [-12, 31],
        [-1, 4],
        [-3, 8],
        [-16, 44],
        [-15, 28],
        [-15, 45],
        [-4, 4],
        [-4, 7],
        [-4, 5],
        [-8, 11],
        [-31, 49],
        [-14, 27],
        [-24, 35],
        [-42, 44],
        [-36, 43],
        [-38, 45],
        [-26, 33],
        [-5, 6],
        [-10, 12],
        [-4, 2],
        [-40, 40],
        [-33, 29],
        [-10, 8],
        [-32, 45],
        [-28, 25],
        [-35, 36],
        [-45, 27],
        [-36, 33],
        [-35, 31],
        [-41, 36],
        [-17, 15],
        [-57, 48],
        [-21, 14],
        [-10, 6],
        [-12, 12],
        [-10, 8],
        [-5, 8],
        [-22, 18],
        [-29, 22],
        [-38, 25],
        [-120, 99],
        [-95, 77],
        [-99, 75],
        [-57, 33],
        [-36, 20],
        [-42, 12],
        [-22, 6],
        [-14, 4],
        [-17, 6],
        [-13, -2],
        [-4, -4],
        [-1, 0],
        [0, -2],
        [-7, -8],
        [-10, 0],
        [-2, 0],
        [2, 4],
        [2, 6],
        [0, 0],
        [0, 0],
        [4, 10],
        [-4, 0],
        [-4, 2],
        [-4, 2],
        [-5, 0],
        [-6, -2],
        [-6, 0],
        [-6, -4],
        [0, 0],
        [0, 4],
        [0, 2],
        [-2, 5],
        [-22, -13],
        [-23, 0],
        [-1, 0],
        [-1, 0],
        [-5, 19],
        [0, 4],
        [0, 2],
        [0, 2],
        [0, 4],
        [3, 6],
        [0, 4],
        [-17, 24],
        [-8, 9],
        [-14, 10],
        [-10, 8],
        [-18, 15],
        [-47, 28],
        [-68, 28],
        [-39, 12],
        [-4, 2],
        [-24, 13],
        [-12, 4],
        [-36, 15],
        [-28, 13],
        [-15, 6],
        [-12, 6],
        [-18, 3],
        [-36, 21],
        [-13, -5],
        [-2, 2],
        [5, 5],
        [-12, 30],
        [-18, 19],
        [-4, 5],
        [-30, 21],
        [-3, 9],
        [-8, 19],
        [-20, 41],
        [-4, 8],
        [-4, 12],
        [-24, 97],
        [-4, 37],
        [-4, 21],
        [-12, 56],
        [-8, 22],
        [-16, 62],
        [0, 7],
        [-8, 15],
        [-1, 8],
        [-7, 23],
        [3, 15],
        [-24, 59],
        [-17, 42],
        [-16, 36],
        [-10, 18],
        [-38, 66],
        [-20, 22],
        [-15, 22],
        [-1, 4],
        [-9, 13],
        [-4, 5],
        [-2, 4],
        [-2, 2],
        [-4, 5],
        [-2, 6],
        [-4, 7],
        [-7, 5],
        [-7, 9],
        [-4, 5],
        [-3, 3],
        [-7, 5],
        [-10, 14],
        [-15, 16],
        [-4, 12],
        [-4, 10],
        [-22, 29],
        [-23, 22],
        [-32, 31],
        [-21, 18],
        [-41, 34],
        [-39, 24],
        [-12, 13],
        [-4, 2],
        [-7, 4],
        [-4, 6],
        [-8, 0],
        [-3, -2],
        [0, -3],
        [0, -3],
        [-2, -2],
        [-5, 0],
        [-3, 0],
        [-2, 1],
        [-5, 3],
        [-4, 2],
        [-3, 3],
        [-16, 15],
        [-2, 3],
        [-2, 4],
        [0, 2],
        [-8, 5],
        [-4, 10],
        [-10, 5],
        [-9, 10],
        [-1, 3],
        [-1, 2],
        [-2, 4],
        [-5, 8],
        [-9, 4],
        [-8, 2],
        [-10, 10],
        [-6, 10],
        [-11, 10],
        [-10, 14],
        [-12, 12],
        [-10, 12],
        [-9, 18],
        [-11, 11],
        [7, 17],
        [1, 5],
        [-6, 10],
        [0, 6],
        [5, 7],
        [-2, 13],
        [-4, 24],
        [-1, 1],
        [-6, 7],
        [-5, 8],
        [-8, 12],
        [-5, 13],
        [-2, 8],
        [-4, -1],
        [-11, 3],
        [-3, 11],
        [0, 1],
        [8, 5],
        [4, 3],
        [3, 7],
        [3, 2],
        [1, 5],
        [1, 3],
        [-6, 14],
        [0, 1],
        [-2, 23],
        [0, 1],
        [-2, 30],
        [2, 20],
        [-10, 45],
        [-3, 42],
        [0, 6],
        [-2, 2],
        [-2, 2],
        [-2, 2],
        [-16, 2],
        [-4, 2],
        [-12, -6],
        [-8, 14],
        [-8, 2],
        [-16, 3],
        [-2, 1],
        [-1, 1],
        [0, 1],
        [-1, 4],
        [-5, 15],
        [0, 1],
        [0, 17],
        [-5, 16],
        [0, 9],
        [0, 1],
        [0, 2],
        [1, 1],
        [3, 7],
        [4, 1],
        [5, 1],
        [2, 0],
        [3, 1],
        [4, 1],
        [4, 0],
        [4, 0],
        [13, -7],
        [1, 55],
        [0, 0],
        [-12, 63],
        [-1, -3],
        [-7, -4],
        [-4, -3],
        [-6, 0],
        [-4, 5],
        [-1, 2],
        [0, 5],
        [0, 1],
        [0, 9],
        [18, 20],
        [18, 13],
        [11, 9],
        [2, 0],
        [0, 1],
        [16, 7],
        [13, -1],
        [16, -3],
        [24, 2],
        [9, 15],
        [8, 32],
        [4, 24],
        [0, 10],
        [1, 31],
        [-1, 1],
        [-5, 21],
        [-6, 8],
        [-1, 2],
        [-1, 6],
        [-1, 8],
        [-11, 19],
        [-8, 23],
        [-5, 12],
        [-2, 30],
        [-5, 16],
        [-8, 10],
        [-2, 8],
        [-2, 8],
        [-4, 8],
        [0, 6],
        [-3, 6],
        [-2, 13],
        [-4, 6],
        [-4, 6],
        [-4, 8],
        [-2, 10],
        [-4, 19],
        [-15, 20],
        [-7, 21],
        [-8, 22],
        [-6, 25],
        [-12, 17],
        [-15, 28],
        [-10, 29],
        [-17, 27],
        [-6, 14],
        [-10, 12],
        [-2, 8],
        [-2, 8],
        [-1, 5],
        [-4, 6],
        [-4, 6],
        [-4, 6],
        [-3, 8],
        [-3, 5],
        [-3, 7],
        [-3, 6],
        [-1, 4],
        [-6, 6],
        [-4, 12],
        [-4, 8],
        [-8, 12],
        [-6, 14],
        [0, 2],
        [-11, 20],
        [-5, 6],
        [-7, 10],
        [-8, 16],
        [-8, 13],
        [-2, 2],
        [-35, 41],
        [-45, 69],
        [-45, 70],
        [-14, 35],
        [-31, 44],
        [-79, 89],
        [-7, 8],
        [-15, 20],
        [-10, 14],
        [-10, 10],
        [-10, 11],
        [-15, 20],
        [-17, 24],
        [-13, 20],
        [-13, 10],
        [-16, 14],
        [-13, 16],
        [-23, 42],
        [-35, 45],
        [-27, 36],
        [-4, 6],
        [-14, 9],
        [-19, 13],
        [-16, 19],
        [-44, 48],
        [-67, 71],
        [-46, 49],
        [-36, 41],
        [-31, 28],
        [-32, 25],
        [-35, 41],
        [-27, 27],
        [-26, 31],
        [-19, 23],
        [-28, 32],
        [-12, 9],
        [-20, 17],
        [-8, 23],
        [-9, 10],
        [-36, 42],
        [-29, 25],
        [-8, 8],
        [-6, 4],
        [-8, 6],
        [-7, 4],
        [-16, 12],
        [-39, 36],
        [-31, 11],
        [-15, 12],
        [-20, 46],
        [-15, 40],
        [-21, 20],
        [-40, 37],
        [-33, 18],
        [-11, 4],
        [-9, 2],
        [-7, -1],
        [-7, -3],
        [-2, -5],
        [-11, -3],
        [-12, 21],
        [-11, 3],
        [-4, -5],
        [-6, -6],
        [2, -2],
        [-6, -9],
        [-2, -5],
        [-2, -3],
        [-2, 0],
        [-2, -2],
        [-4, -1],
        [0, 0],
        [-2, 4],
        [4, 7],
        [-2, 1],
        [-7, 1],
        [-3, 2],
        [-2, 4],
        [-1, 1],
        [1, 0],
        [2, 2],
        [3, 4],
        [5, 5],
        [0, 3],
        [-6, 0],
        [0, 1],
        [3, 12],
        [0, 0],
        [-2, 0],
        [-2, 0],
        [-2, -2],
        [-1, -2],
        [-12, -13],
        [-10, 9],
        [6, 12],
        [-4, 10],
        [0, 10],
        [-4, 15],
        [-13, 33],
        [-15, -2],
        [-4, 0],
        [-2, 1],
        [0, 8],
        [0, 1],
        [9, 18],
        [2, 31],
        [1, 5],
        [7, 8],
        [1, 0],
        [2, 0],
        [0, 0],
        [0, -2],
        [-1, -2],
        [2, -4],
        [3, -2],
        [1, 0],
        [7, 2],
        [0, 0],
        [2, 2],
        [5, 8],
        [7, 12],
        [0, 10],
        [3, 20],
        [7, 11],
        [8, 4],
        [2, 17],
        [-2, 44],
        [-15, 36],
        [1, 6],
        [1, 5],
        [0, 4],
        [0, 4],
        [-1, 2],
        [-2, 6],
        [-2, 2],
        [-2, 2],
        [-12, -29],
        [0, -2],
        [0, -2],
        [-2, -4],
        [-2, 0],
        [-3, 0],
        [-2, 2],
        [0, 2],
        [-1, 2],
        [-1, 2],
        [-2, 11],
        [5, 49],
        [11, -1],
        [0, -25],
        [11, 0],
        [10, 5],
        [0, 2],
        [2, 3],
        [1, 3],
        [13, -8],
        [20, -18],
        [4, -4],
        [5, -19],
        [1, -4],
        [1, -6],
        [5, -20],
        [5, -2],
        [3, 2],
        [5, 6],
        [3, 2],
        [12, 4],
        [2, 2],
        [8, 0],
        [4, 0],
        [2, 0],
        [2, 2],
        [1, 0],
        [1, 0],
        [7, 0],
        [1, 2],
        [4, 2],
        [2, 0],
        [0, 0],
        [8, 4],
        [6, 0],
        [2, 0],
        [12, -4],
        [2, 2],
        [4, 0],
        [3, -2],
        [1, 0],
        [2, -2],
        [2, -4],
        [3, 0],
        [1, -4],
        [1, -2],
        [0, -2],
        [2, -2],
        [4, -4],
        [11, -6],
        [13, -8],
        [11, -2],
        [10, 0],
        [6, 0],
        [8, 2],
        [7, -4],
        [6, -6],
        [7, -4],
        [8, -9],
        [10, -10],
        [6, -2],
        [4, -2],
        [9, 0],
        [2, 2],
        [5, 2],
        [2, 2],
        [14, 2],
        [12, -6],
        [14, 4],
        [15, 0],
        [8, 2],
        [25, 8],
        [9, 5],
        [14, 6],
        [2, 2],
        [13, 6],
        [2, 0],
        [14, 14],
        [7, 6],
        [8, 8],
        [8, 6],
        [12, 10],
        [8, 8],
        [6, 9],
        [1, 0],
        [1, 2],
        [8, 2],
        [13, 0],
        [11, -4],
        [14, -2],
        [21, -4],
        [14, 4],
        [5, 2],
        [25, 12],
        [2, 2],
        [38, 61],
        [26, 35],
        [12, 24],
        [33, 38],
        [44, 34],
        [23, 52],
        [19, 50],
        [10, 32],
        [14, 41],
        [8, 32],
        [2, 16],
        [7, 31],
        [10, 36],
        [8, 44],
        [3, 22],
        [-1, 10],
        [0, 2],
        [-7, 83],
        [-10, 116],
        [-3, 41],
        [-8, 26],
        [-5, 27],
        [-2, 23],
        [0, 35],
        [4, 24],
        [-1, 26],
        [-29, 133],
        [-1, 2],
        [-8, 19],
        [-25, 65],
        [-10, 30],
        [-56, 117],
        [-11, 19],
        [-10, 20],
        [-39, 59],
        [-2, 4],
        [-31, 51],
        [-2, 4],
        [-19, 28],
        [-31, 46],
        [-16, 25],
        [-34, 67],
        [-87, 117],
        [-112, 99],
        [-29, 29],
        [-18, 9],
        [-12, 11],
        [-24, 32],
        [-4, 6],
        [-18, 20],
        [-8, 8],
        [-22, 32],
        [-14, 27],
        [-28, 48],
        [-16, 31],
        [-43, 89],
        [-25, 51],
        [-10, 23],
        [-22, 49],
        [-7, 16],
        [-2, 6],
        [-12, 25],
        [-14, 32],
        [-19, 39],
        [-13, 23],
        [-24, 27],
        [-16, 21],
        [-58, 70],
        [-12, 13],
        [0, 2],
        [-2, 0],
        [-6, 4],
        [-26, 25],
        [-31, 37],
        [-19, 14],
        [-9, 11],
        [-16, 20],
        [-9, 12],
        [-18, 23],
        [-26, 28],
        [-17, 19],
        [-171, 182],
        [-25, 27],
        [-11, 36],
        [-25, 87],
        [-37, 67],
        [-6, 16],
        [-10, 40],
        [-8, 12],
        [-50, 80],
        [-44, 69],
        [-31, 32],
        [-14, 17],
        [-45, 41],
        [-28, 28],
        [-104, 118],
        [-29, 37],
        [-53, 70],
        [-85, 137],
        [-18, 18],
        [-12, 12],
        [-16, 18],
        [-23, 27],
        [-16, 22],
        [-12, 17],
        [-8, 16],
        [-14, 26],
        [-25, 44],
        [-3, 6],
        [-26, 51],
        [-40, 82],
        [-14, 30],
        [-34, 60],
        [-8, 13],
        [-19, 33],
        [-29, 47],
        [-25, 38],
        [-8, 8],
        [-15, 18],
        [-19, 25],
        [-38, 62],
        [-14, 22],
        [-16, 28],
        [-2, 5],
        [-18, 22],
        [-8, 12],
        [-42, 56],
        [-30, 43],
        [-35, 44],
        [-3, 4],
        [-10, 14],
        [-14, 23],
        [-13, 24],
        [-12, 22],
        [-30, 53],
        [-19, 24],
        [-12, 17],
        [-6, 14],
        [-19, 31],
        [-28, 42],
        [-37, 53],
        [-38, 37],
        [-21, 43],
        [-23, 26],
        [-22, 37],
        [-51, 71],
        [-26, 34],
        [-50, 62],
        [-58, 73],
        [-22, 26],
        [-16, 16],
        [-18, 22],
        [-10, 18],
        [-32, 38],
        [-31, 29],
        [-82, 94],
        [-22, 31],
        [-39, 47],
        [-29, 36],
        [-15, 17],
        [-20, 24],
        [-20, 19],
        [-13, 14],
        [-18, 23],
        [-74, 83],
        [-18, 20],
        [-37, 43],
        [-39, 45],
        [-38, 48],
        [-44, 50],
        [-44, 43],
        [-22, 26],
        [-32, 39],
        [-38, 42],
        [-41, 43],
        [-35, 41],
        [-23, 25],
        [-7, 12],
        [-18, 18],
        [-21, 22],
        [-35, 30],
        [-34, 40],
        [-36, 37],
        [-33, 32],
        [-34, 33],
        [-24, 29],
        [-59, 65],
        [-33, 33],
        [-31, 32],
        [-35, 38],
        [-31, 34],
        [-30, 33],
        [-42, 43],
        [-21, 26],
        [-28, 31],
        [-46, 42],
        [-65, 62],
        [-51, 50],
        [-56, 52],
        [-74, 67],
        [-46, 34],
        [-44, 42],
        [-33, 39],
        [-74, 76],
        [-43, 42],
        [-47, 47],
        [-38, 35],
        [-30, 33],
        [-30, 32],
        [-29, 31],
        [-25, 24],
        [-22, 20],
        [-25, 22],
        [-42, 44],
        [-12, 14],
        [-22, 23],
        [-22, 18],
        [-77, 84],
        [-126, 136],
        [-208, 183],
        [-380, 338],
        [-129, 112],
        [-25, 22],
        [-97, 65],
        [-96, 80],
        [-12, 8],
        [-56, 38],
        [-2, 1],
        [-9, 4],
        [-8, 2],
        [-11, 2],
        [-8, 2],
        [-7, 4],
        [-25, 24],
        [-41, 45],
        [-16, 22],
        [-81, 86],
        [-4, 5],
        [-41, 43],
        [-12, 10],
        [-27, 21],
        [-38, 24],
        [-25, 20],
        [-121, 64],
        [-9, 44],
        [-9, 17],
        [-20, 23],
        [-12, 15],
        [-8, 12],
        [-19, 26],
        [-11, 10],
        [-11, 10],
        [-9, 7],
        [-16, 16],
        [-13, 17],
        [-24, 32],
        [-14, 26],
        [-9, 18],
        [-3, 4],
        [-9, 16],
        [-7, 9],
        [-5, 7],
        [-3, 5],
        [-5, 6],
        [-4, 3],
        [-6, 3],
        [-9, 10],
        [-4, 5],
        [-4, 6],
        [-6, 9],
        [-14, 22],
        [-8, 15],
        [-8, 12],
        [-17, 14],
        [-26, 25],
        [-10, 16],
        [-6, 7],
        [-16, 16],
        [-10, 9],
        [-16, 15],
        [-9, 7],
        [-13, 11],
        [-92, 93],
        [-130, 123],
        [-147, 116],
        [-154, 143],
        [-164, 179],
        [-74, 70],
        [-124, 117],
        [-10, 8],
        [-20, 19],
        [-213, 200],
      ],
      [
        [174746, 75341],
        [-64, 60],
        [-62, 61],
        [-5, 4],
        [-4, 6],
        [-15, 17],
        [-17, 14],
        [-14, 11],
        [-22, 26],
        [-21, 28],
        [-11, 15],
        [-21, 18],
        [-15, 14],
        [-20, 12],
        [-12, 8],
        [-8, -2],
        [-2, 0],
        [-4, 0],
        [-3, 0],
        [-3, 2],
        [-4, 2],
        [-2, 2],
        [-2, 0],
        [-5, 4],
        [-4, 1],
        [-9, 2],
        [-3, 1],
        [-2, 0],
        [-8, -4],
        [-13, -4],
        [-10, -4],
        [-8, -2],
        [-14, -8],
        [-8, -6],
        [-18, -6],
        [-20, -4],
        [-10, 2],
        [-14, 4],
        [-35, 16],
        [-6, 4],
        [-6, 4],
        [-10, 12],
        [-12, 24],
        [-5, 14],
        [0, 1],
        [-35, 43],
        [-8, 6],
        [-8, 13],
        [-2, 4],
        [-10, 12],
        [-19, 30],
        [-7, 4],
        [-5, 4],
        [-9, 10],
        [-4, 19],
        [-2, 13],
        [-3, 21],
        [-26, 54],
        [-12, 38],
        [-13, 47],
        [5, 20],
        [8, 18],
        [8, 16],
        [15, 36],
        [-3, 7],
        [0, 3],
        [0, 2],
        [1, 4],
        [0, 55],
        [-5, 0],
        [-6, 8],
        [-4, 4],
        [0, 2],
        [0, 2],
        [0, 2],
        [0, 0],
        [-4, 16],
        [-12, 10],
        [-7, 4],
        [-8, 2],
        [-7, 3],
        [-4, 5],
        [-6, 15],
        [0, 2],
        [0, 6],
        [0, 2],
        [0, 1],
        [2, 6],
        [17, 41],
        [1, 4],
        [10, 22],
        [14, 43],
        [4, 40],
        [12, 36],
        [17, 25],
        [26, 19],
        [44, 30],
        [19, 12],
        [24, 12],
        [11, 5],
        [13, 4],
        [7, 2],
        [7, 2],
        [11, 2],
        [2, 2],
        [2, 6],
        [2, 4],
        [0, 0],
        [0, 6],
        [0, 4],
        [0, 6],
        [0, 24],
        [-6, 25],
        [0, 4],
        [-10, 13],
        [-3, 2],
        [-7, 4],
        [-2, 8],
        [1, 7],
        [3, 17],
        [1, 5],
        [2, 6],
        [1, 8],
        [1, 17],
        [-2, 19],
        [-1, 8],
        [-1, 10],
        [-3, 10],
        [-12, 32],
        [-6, 14],
        [-1, 3],
        [-15, 32],
        [-26, 43],
        [-37, 49],
        [-4, 5],
        [-20, 30],
        [-19, 25],
        [-37, 46],
        [-46, 45],
        [-36, 35],
        [-24, 31],
        [-13, 6],
        [-39, 36],
        [-30, 22],
        [-24, 36],
        [-22, 17],
        [-2, 2],
        [-4, 3],
        [-2, 4],
        [0, 2],
        [0, 3],
        [0, 1],
        [4, 11],
        [-2, 6],
        [-6, 8],
        [-5, 6],
        [-11, 8],
        [-24, 21],
        [-26, 29],
        [-23, 24],
        [-18, 19],
        [-16, 18],
        [-38, 36],
        [-33, 32],
        [-38, 39],
        [-26, 27],
        [-20, 15],
        [-50, 41],
        [-16, 21],
        [-9, 14],
        [-2, 5],
        [-7, 9],
        [-10, 7],
        [-4, 3],
        [-12, 5],
        [-18, 8],
        [-14, 14],
        [-57, 52],
        [-14, 11],
        [-8, 6],
        [-12, 7],
        [-9, 6],
        [-11, 11],
        [-12, 13],
        [-5, 7],
        [-6, 9],
        [-15, 20],
        [-8, 4],
        [-6, 6],
        [-7, 0],
        [-10, 6],
        [-10, 6],
        [-12, 10],
        [-14, 23],
        [-11, 13],
        [-23, 16],
        [-19, 19],
        [-22, 26],
        [-22, 29],
        [-25, 25],
        [-3, 2],
        [-28, 12],
        [-34, 36],
        [-31, 15],
        [-25, 20],
        [-17, 21],
        [-16, 16],
        [-9, 2],
        [-9, 2],
        [-22, 7],
        [-8, 4],
        [-9, 4],
        [-29, 31],
        [-10, 14],
        [-6, 8],
        [0, 4],
        [-66, 39],
        [-4, 3],
        [-19, 0],
        [-12, 6],
        [-8, 8],
        [-7, 8],
        [-3, 4],
        [-2, 4],
        [-2, 4],
        [-12, 18],
        [-24, 22],
        [-7, 4],
        [-18, 12],
        [-8, 5],
        [-37, 25],
        [-13, 14],
        [-36, 31],
        [-25, 20],
        [-26, 22],
        [-37, 38],
        [-48, 43],
        [-25, 24],
        [-6, 6],
        [-11, 6],
        [-7, 4],
        [-39, 27],
        [-10, 3],
        [-35, 29],
        [-22, 20],
        [-29, 28],
        [-37, 37],
        [-35, 27],
        [-39, 46],
        [-21, 28],
        [-3, 6],
        [-9, 10],
        [-26, 22],
        [-28, 23],
        [-20, 12],
        [-19, 13],
        [-55, 39],
        [-37, 30],
        [-8, 4],
        [-8, 6],
        [-15, 6],
        [-8, 6],
        [-20, 18],
        [-17, 19],
        [-21, 25],
        [-32, 41],
        [-16, 23],
        [-5, 10],
        [-4, 4],
        [-7, 7],
        [-61, 27],
        [-11, 9],
        [-7, 6],
        [-46, 39],
        [-22, 37],
        [-16, 24],
        [-25, 33],
        [-21, 26],
        [-71, 90],
        [-156, 123],
        [-58, 47],
        [-36, 25],
        [-52, 37],
        [-8, 1],
        [-10, 5],
        [-10, -2],
        [-15, 0],
        [-12, 2],
        [-22, 4],
        [-8, 2],
        [-22, 10],
        [-6, 2],
        [-24, 10],
        [-9, 2],
        [-57, 22],
        [-41, 22],
        [-36, 22],
        [-18, 15],
        [-19, 23],
        [-10, 19],
        [-5, 32],
        [-2, 41],
        [0, 9],
        [0, 13],
        [8, 47],
        [6, 35],
        [-2, 17],
        [-2, 6],
        [-6, 13],
        [-13, 24],
        [-34, 33],
        [-22, 21],
        [-10, 8],
        [-7, 8],
        [-6, 8],
        [-4, 8],
        [-2, 2],
        [-2, 8],
        [-4, 11],
        [-4, 14],
        [-2, 7],
        [-2, 8],
        [0, 6],
        [0, 11],
        [-2, 15],
        [-4, 36],
        [-6, 25],
        [-17, 42],
        [-1, 2],
        [-2, 5],
        [-11, 17],
        [-9, 8],
        [-7, 6],
        [-9, 5],
        [-8, 4],
        [-4, 2],
        [-6, 5],
        [-14, 20],
        [-1, 4],
        [-5, 18],
        [0, 2],
        [2, 21],
        [6, 15],
        [4, 6],
        [20, 25],
        [2, 2],
        [4, 2],
        [6, 2],
        [12, 3],
        [2, 0],
        [9, 0],
        [10, -5],
        [5, -3],
        [2, 0],
        [4, 1],
        [30, 49],
        [6, 64],
        [0, 37],
        [-12, 36],
        [-2, 6],
        [0, 2],
        [-12, 30],
        [-25, 44],
        [-35, 63],
        [-14, 26],
        [-4, 12],
        [-8, 25],
        [-2, 15],
        [-7, 21],
        [-7, 17],
        [-1, 2],
        [-5, 9],
        [-8, 13],
        [0, 1],
        [-45, 49],
        [-16, 19],
        [-17, 11],
        [-17, 12],
        [-10, 7],
        [-21, 29],
        [-4, 6],
        [-17, 26],
        [-26, 23],
        [-29, 25],
        [-23, 18],
        [-11, 6],
        [-12, 5],
        [-14, 1],
        [-4, 1],
        [-4, 2],
        [-27, 6],
        [-6, 8],
        [-3, 6],
        [-2, 5],
        [-13, 37],
        [-10, 32],
        [-5, 13],
        [-32, 84],
        [-54, 70],
        [-17, 36],
        [-24, 42],
        [-31, 56],
        [-47, 70],
        [-29, 43],
        [-226, 236],
        [-18, 20],
        [-310, 275],
        [-364, 279],
        [-104, 80],
        [-505, 394],
        [-282, 200],
        [-117, 102],
        [-104, 80],
        [-29, 9],
        [-25, 26],
        [-43, 24],
        [-16, 14],
        [-221, 133],
        [-946, 595],
        [-284, 167],
        [-301, 125],
        [-190, 63],
        [-70, 36],
        [-93, 50],
        [-20, 16],
        [-11, 29],
        [-6, 12],
        [-74, 133],
        [-51, 99],
        [-16, 44],
        [-62, 117],
        [-44, 100],
        [-155, 171],
        [-193, 159],
        [-249, 193],
        [-171, 127],
        [-34, 14],
        [-86, 33],
        [-4, -3],
        [0, -6],
        [-2, -8],
        [0, -2],
        [-2, -2],
        [-6, -2],
        [-29, -8],
        [-9, 0],
        [-13, 2],
        [-13, 8],
        [-13, 10],
        [0, 4],
        [-2, 2],
        [-16, 18],
        [-9, 8],
        [-4, 2],
        [-4, -1],
        [-2, -3],
        [2, -5],
        [0, -17],
        [-20, -12],
        [-2, -2],
        [-2, 0],
        [-2, 2],
        [-16, 14],
        [-3, 8],
        [-1, 3],
        [2, 10],
        [1, 2],
        [3, 3],
        [16, 12],
        [8, 4],
        [12, 1],
        [10, 16],
        [0, 4],
        [2, 3],
        [0, 1],
        [0, 4],
        [-2, 5],
        [-2, 3],
        [-2, 2],
        [-6, 6],
        [-6, 2],
        [-2, 0],
        [-4, 0],
        [-4, -2],
        [-2, -2],
        [-3, -1],
        [-4, 1],
        [-9, 2],
        [-3, 2],
        [0, 4],
        [2, 18],
        [19, 30],
        [22, 20],
        [4, 2],
        [5, 3],
        [4, 4],
        [2, 2],
        [0, 2],
        [0, 3],
        [0, 6],
        [-8, 21],
        [-25, 38],
        [-8, 11],
        [-8, 7],
        [-2, 1],
        [-3, 0],
        [-7, -5],
        [-5, 1],
        [-22, 11],
        [-1, 0],
        [-18, 16],
        [-18, 10],
        [-15, 12],
        [-1, 29],
        [-1, 14],
        [-11, 2],
        [-39, 6],
        [-28, -3],
        [-19, -13],
        [-17, 17],
        [-18, 22],
        [1, 12],
        [0, 12],
        [6, 23],
        [0, 73],
        [-63, 71],
        [-221, 176],
        [-143, 101],
        [-365, 225],
        [-39, 22],
        [-72, 10],
        [-20, -20],
        [-16, -51],
        [-8, -9],
        [-5, -5],
        [-2, -1],
        [-2, -1],
        [-4, 0],
        [-3, 1],
        [-6, 4],
        [-2, 2],
        [0, 5],
        [0, 2],
        [0, 4],
        [-66, 28],
        [-30, 14],
        [-13, 17],
        [-29, 40],
        [-12, 2],
        [-14, 15],
        [0, 19],
        [0, 4],
        [-4, 1],
        [-14, 1],
        [-36, 37],
        [-14, 19],
        [4, 7],
        [15, 11],
        [8, 6],
        [10, 4],
        [4, 2],
        [5, 4],
        [7, 9],
        [1, 1],
        [1, 3],
        [0, 7],
        [0, 5],
        [-4, 16],
        [-16, 15],
        [-23, 7],
        [-37, -5],
        [-28, 3],
        [-13, 2],
        [-6, 0],
        [-37, 39],
        [-6, 6],
        [-24, 18],
        [-2, 4],
        [2, 8],
        [0, 2],
        [1, 2],
        [8, 15],
        [7, 9],
        [18, 15],
        [6, 1],
        [14, 11],
        [-71, 90],
        [-8, 0],
        [-4, 14],
        [10, 7],
        [-13, 99],
        [-2, 18],
        [-8, 63],
        [74, 66],
        [8, 2],
        [12, 12],
        [6, 2],
        [57, 24],
        [5, 2],
        [4, 1],
        [19, 3],
        [12, -2],
        [32, -7],
        [4, -3],
        [26, 5],
        [34, -3],
        [18, 5],
        [9, 1],
        [4, 1],
        [5, 0],
        [21, -2],
        [22, -6],
        [10, -1],
        [4, 0],
        [4, 2],
        [23, 36],
        [13, 20],
        [31, 81],
        [32, 164],
        [1, 17],
        [3, 50],
        [0, 19],
        [0, 14],
        [0, 4],
        [-17, 23],
        [-5, -3],
        [-8, -2],
        [-1, 0],
        [-2, 2],
        [-1, 4],
        [0, 4],
        [-2, 18],
        [-1, 13],
        [-13, 30],
        [-3, 8],
        [0, 1],
        [-3, 1],
        [-2, 0],
        [-1, 2],
        [0, 2],
        [1, 8],
        [7, 10],
        [4, 6],
        [8, 6],
        [3, 2],
        [5, 2],
        [5, 2],
        [6, 0],
        [4, 0],
        [4, 2],
        [50, 26],
        [24, -18],
        [9, -22],
        [12, -20],
        [4, -22],
        [1, -45],
        [25, -20],
        [56, -8],
        [13, 0],
        [13, 2],
        [14, 4],
        [16, 6],
        [18, 2],
        [16, -1],
        [23, -4],
        [20, 5],
        [63, 37],
        [1, 1],
        [8, 10],
        [32, 49],
        [32, 44],
        [55, 123],
        [36, 113],
        [1, 11],
        [26, 242],
        [-7, 8],
        [-6, 13],
        [0, 54],
        [1, 62],
        [0, 77],
        [-11, 100],
        [-14, 80],
        [-4, 23],
        [-25, 96],
        [-38, 85],
        [-68, 132],
        [-12, 25],
        [-52, 110],
        [-64, 116],
        [-37, 58],
        [-32, 53],
        [-66, 113],
        [-71, 96],
        [-66, 100],
        [-65, 104],
        [-50, 64],
        [-27, 21],
        [-42, 46],
        [-20, 25],
        [-78, 116],
        [-69, 64],
        [-106, 99],
        [-34, 21],
        [-52, 61],
        [-49, 61],
        [-43, 57],
        [-103, 152],
        [-125, 170],
        [-123, 162],
        [-117, 127],
        [-156, 146],
        [-135, 146],
        [-128, 125],
        [-102, 111],
        [-89, 88],
        [-189, 220],
        [-185, 194],
        [-65, 57],
        [-154, 166],
        [-163, 141],
        [-65, 63],
        [-12, 12],
        [-77, 56],
        [-43, 36],
        [2, 33],
        [4, 5],
        [14, 16],
        [18, 19],
        [55, 40],
        [69, 54],
        [13, 99],
        [18, 102],
        [6, 24],
        [8, 31],
        [-2, 25],
        [0, 6],
        [2, 23],
        [0, 18],
        [-2, 17],
        [0, 16],
        [0, 7],
        [2, 24],
        [4, 39],
        [22, 38],
        [8, 85],
        [-46, 142],
        [-16, 62],
        [-19, 34],
        [-22, 54],
        [-59, 85],
        [-85, 111],
        [-80, 86],
        [-66, 90],
        [-57, 65],
        [-78, 90],
        [-112, 124],
        [-92, 85],
        [-106, 113],
        [-60, 72],
        [-51, 56],
        [-24, 37],
        [-32, 45],
        [-45, 70],
        [-74, 105],
        [-39, 41],
      ],
      [
        [159688, 95428],
        [-29, 29],
        [-34, 43],
        [-93, 126],
        [-70, 91],
        [-51, 61],
        [-99, 151],
        [-228, 282],
        [-93, 107],
        [-115, 112],
        [-182, 174],
        [-172, 172],
        [-60, 49],
        [-17, 33],
        [10, 57],
        [-10, 53],
        [-37, 92],
        [-42, 76],
        [-29, 71],
        [11, 60],
        [62, 70],
        [1, 94],
        [0, 34],
        [-9, 48],
        [-12, 73],
        [-13, 64],
        [-31, 91],
        [-7, 20],
        [-4, 10],
        [-61, 131],
        [-16, 34],
        [0, 20],
        [2, 123],
        [1, 83],
        [1, 49],
        [-4, 35],
        [-21, 55],
        [7, 64],
        [-11, 94],
        [-2, 33],
        [0, 2],
        [-2, 36],
        [-22, 176],
        [-57, 209],
        [-37, 227],
        [-62, 228],
        [-76, 183],
        [-79, 177],
        [-147, 194],
        [-625, 661],
        [-855, 847],
        [-133, 133],
        [-175, 182],
        [-169, 193],
        [-57, 64],
        [-97, 109],
        [-51, 54],
        [-196, 197],
        [-136, 139],
        [-277, 278],
        [-328, 348],
        [-159, 167],
        [-144, 153],
        [-494, 481],
        [-204, 201],
        [-124, 133],
        [-57, 46],
        [-88, 78],
        [-394, 376],
        [-38, 31],
        [-811, 804],
        [-149, 166],
        [-249, 295],
        [-396, 393],
        [-52, 58],
        [-97, 77],
        [-93, 100],
        [-141, 141],
        [-204, 207],
        [-204, 186],
        [-118, 119],
        [-216, 188],
        [-80, 67],
        [-156, 133],
        [-99, 93],
        [-130, 108],
        [-61, 67],
        [-131, 93],
        [-173, 167],
        [-438, 420],
        [-193, 167],
        [-173, 167],
        [-445, 399],
        [-166, 149],
        [-271, 246],
        [-162, 134],
        [-194, 157],
        [-289, 251],
        [-98, 87],
        [-93, 86],
        [-167, 126],
        [-315, 302],
        [-364, 294],
        [-754, 639],
        [-533, 456],
        [-680, 579],
        [-82, 72],
      ],
      [
        [143971, 112988],
        [-212, 184],
        [-136, 116],
        [-104, 63],
        [-111, 93],
        [-88, 63],
        [-146, 119],
        [-261, 199],
        [-150, 123],
        [-76, 88],
        [-77, 56],
        [-221, 180],
        [-183, 152],
        [-182, 155],
        [-107, 89],
        [-215, 172],
        [-216, 154],
        [-149, 129],
        [-153, 114],
        [-230, 174],
        [-142, 99],
        [-231, 176],
        [-108, 63],
        [-226, 158],
        [-278, 187],
        [-50, 18],
        [-43, 10],
        [-248, 145],
        [-140, 124],
        [-10, 8],
        [-16, 12],
        [-10, 6],
        [-32, 40],
        [-10, 6],
        [-19, 10],
        [-15, 10],
        [-22, 17],
        [-29, 19],
        [-16, 10],
        [-10, 5],
        [-11, 7],
        [-42, 31],
        [-4, 6],
        [-19, 18],
        [-20, 17],
        [-8, 7],
        [-16, 9],
        [-18, 11],
        [-57, 40],
        [-33, 23],
        [-29, 23],
        [-22, 18],
        [-7, 7],
        [-3, 6],
        [-2, 3],
        [-14, 13],
        [-10, 17],
        [-8, 11],
        [-6, 3],
        [-10, 4],
        [-17, 16],
        [-23, 23],
        [-7, 8],
        [-5, 6],
        [-14, 22],
        [-22, 20],
        [-6, 4],
        [-23, 17],
        [-38, 25],
        [-16, 24],
        [-47, 69],
        [-37, 21],
        [-35, 55],
        [-22, 34],
        [-56, 132],
        [0, 10],
        [2, 4],
        [2, 10],
        [1, 4],
        [4, 10],
        [3, 18],
        [14, 27],
        [28, 27],
        [4, 1],
        [6, 0],
        [4, 0],
        [2, -2],
        [19, -7],
        [3, -17],
        [3, -17],
        [14, -34],
        [17, -60],
        [4, -34],
        [32, -60],
        [10, -16],
        [29, -14],
        [40, 7],
        [39, 11],
        [30, 32],
        [27, 36],
        [17, 23],
        [32, 45],
        [19, 33],
        [29, 41],
        [18, 24],
        [13, 12],
        [-206, 196],
        [-37, 33],
        [-58, 4],
        [-75, 35],
        [-128, 70],
        [-189, 112],
        [-753, 753],
        [-27, 9],
        [-49, 19],
        [-14, 5],
        [-25, 11],
        [-32, 23],
        [-31, 17],
        [-11, 4],
        [-7, 0],
        [-26, 22],
        [-10, 6],
        [-25, 10],
        [-54, 24],
        [-41, 24],
        [-49, 25],
        [-53, 8],
        [-24, 16],
        [-24, 12],
        [-8, 8],
        [-29, 12],
        [-24, 10],
        [-26, 18],
        [-25, 16],
        [-24, 13],
        [-31, 14],
        [-26, 9],
        [-30, 16],
        [-52, 17],
        [-42, 20],
        [-104, 55],
        [-42, 33],
        [-19, 11],
        [-24, 13],
        [-37, 9],
        [-45, 21],
        [-42, 24],
        [-64, 49],
        [-32, 27],
        [-52, 34],
        [-88, 51],
        [-87, 57],
        [-74, 53],
        [-60, 40],
        [-116, 78],
        [-67, 46],
        [-41, 30],
        [-69, 44],
        [-63, 45],
        [-82, 55],
        [-82, 50],
        [-95, 66],
        [-66, 48],
        [-50, 29],
        [-29, 16],
        [-109, 73],
        [-77, 49],
        [-116, 94],
        [-72, 42],
        [-109, 68],
        [-12, 6],
        [-136, 91],
        [-131, 88],
        [-140, 98],
        [-74, 51],
        [-35, 28],
        [-60, 38],
        [-111, 72],
        [-28, 24],
        [-28, 18],
        [-48, 28],
        [-16, 11],
        [-8, 9],
        [-12, 9],
        [-15, 10],
        [-22, 9],
        [-8, 4],
        [-10, 6],
        [-6, 5],
        [-10, 7],
        [-44, 42],
        [-40, 34],
        [-28, 16],
        [-98, 69],
        [-92, 58],
        [-32, 38],
        [-93, 56],
        [-65, 44],
        [-29, 27],
        [-43, 25],
        [-50, 35],
        [-124, 89],
        [-108, 78],
        [-82, 54],
        [-66, 52],
        [-16, 11],
        [-110, 65],
        [-120, 89],
        [-130, 87],
        [-121, 90],
        [-88, 61],
        [-67, 48],
        [-85, 47],
        [-174, 124],
        [-68, 54],
        [-72, 44],
        [-178, 130],
        [-62, 37],
        [-238, 160],
        [-291, 189],
        [-101, 65],
        [-156, 102],
        [-128, 78],
        [-108, 74],
        [-122, 78],
        [-84, 56],
        [-116, 78],
        [-119, 74],
        [-102, 68],
        [-112, 68],
        [-57, 51],
        [-22, 14],
        [-27, 18],
        [-80, 47],
        [-25, 16],
        [-52, 35],
        [-56, 33],
        [-57, 35],
        [-64, 37],
        [-89, 59],
        [-67, 44],
        [-38, 26],
        [-26, 17],
        [-37, 23],
        [-15, 7],
        [-17, 7],
        [-28, 17],
        [-27, 18],
        [-57, 38],
        [-105, 66],
        [-84, 54],
        [-35, 22],
        [-42, 27],
        [-42, 27],
        [-111, 71],
        [-42, 26],
        [-195, 119],
        [-123, 75],
        [-258, 158],
        [-33, 21],
        [-249, 152],
        [-460, 280],
        [-435, 256],
        [-18, 16],
        [-53, 30],
        [-71, 49],
        [-71, 40],
        [-45, 29],
        [-37, 22],
        [-87, 54],
        [-108, 68],
        [-130, 84],
        [-135, 92],
        [-34, 31],
        [-17, 16],
        [-33, 28],
        [-89, 63],
        [-23, 17],
        [-166, 128],
        [0, 2],
        [-16, 14],
        [-55, 48],
        [-23, 19],
        [-18, 17],
        [-36, 34],
        [-37, 37],
        [-27, 25],
        [-44, 48],
        [-23, 21],
        [-10, 10],
        [-74, 70],
        [-173, 159],
        [-24, 36],
        [-31, 63],
        [-24, 55],
        [-19, 38],
        [-12, 37],
        [-10, 38],
        [-2, 13],
        [0, 24],
        [2, 15],
        [2, 14],
        [2, 16],
        [8, 20],
        [10, 10],
        [28, 19],
        [-100, 94],
      ],
      [
        [125029, 127264],
        [-17, 0],
        [-55, 12],
        [-16, 6],
        [-64, 30],
        [-35, 22],
        [-74, 45],
        [-6, 9],
        [-10, 14],
        [-22, 27],
        [-24, 33],
        [-9, 16],
        [-27, 39],
        [-31, 74],
        [-47, 69],
        [-99, 90],
        [-525, 450],
        [-27, 25],
        [-77, 59],
        [-351, 274],
        [-760, 597],
        [-47, 39],
        [-104, 79],
        [-41, 41],
        [-15, 15],
        [-14, 8],
        [-41, 27],
        [-91, 69],
        [-90, 61],
        [-55, 46],
        [-85, 66],
        [-6, 3],
        [-53, 42],
        [-5, 12],
        [-8, 0],
        [-34, -12],
        [-4, 0],
        [-2, 0],
        [-2, 1],
        [-4, 5],
        [0, 4],
        [0, 8],
        [24, 8],
        [20, 20],
        [-38, 30],
        [-9, -18],
        [-8, -32],
        [-4, -3],
        [-4, -1],
        [-2, 0],
        [-4, 3],
        [-1, 1],
        [-2, 9],
        [-1, 37],
        [26, 18],
        [-1, 2],
        [-9, 25],
        [-20, 18],
        [-32, 34],
        [-96, 78],
        [-110, 106],
        [-89, 53],
        [-222, 160],
        [-123, 72],
        [-357, 281],
        [-60, 46],
        [-452, 335],
        [-1069, 786],
        [-669, 475],
        [-104, 73],
        [-498, 361],
        [-416, 300],
        [-126, 78],
        [-115, 90],
        [-687, 466],
        [-1201, 859],
        [-707, 511],
        [-1088, 767],
        [-553, 391],
        [-372, 263],
        [-1592, 1099],
        [-57, 34],
        [-93, 66],
        [-135, 96],
        [-343, 233],
        [-430, 290],
        [-212, 135],
        [-183, 124],
        [-46, 31],
        [-389, 246],
        [-147, 94],
        [-129, 84],
        [-305, 202],
        [-136, 98],
        [-97, 52],
        [-139, 93],
        [-189, 123],
        [-300, 194],
        [-218, 149],
        [-44, 24],
        [-352, 189],
        [-58, 36],
        [-129, 95],
        [-181, 109],
        [-119, 90],
        [-86, 43],
        [-189, 117],
        [-196, 123],
        [-182, 112],
        [-158, 105],
        [-61, 31],
        [-146, 78],
        [-126, 79],
        [-117, 71],
        [-91, 48],
        [-162, 95],
        [-178, 107],
        [-234, 142],
        [-27, 16],
        [-651, 430],
        [-87, 46],
        [-261, 130],
        [-121, 58],
        [-134, 82],
        [-80, 52],
        [-130, 70],
        [-213, 107],
        [-25, 14],
        [-119, 60],
        [-124, 67],
        [-149, 70],
        [-104, 45],
        [-90, 39],
        [-59, 28],
        [-113, 53],
        [-82, 32],
        [-80, 44],
        [-101, 36],
        [-59, 27],
        [-40, 18],
        [-60, 24],
        [-36, 13],
        [-14, 6],
        [-11, 7],
        [-18, 12],
        [-20, 15],
        [-15, 10],
        [-22, 14],
        [-13, 8],
        [-18, 10],
        [-42, 31],
        [-10, 4],
        [-19, 6],
        [-13, 5],
        [-23, 10],
        [-23, 11],
        [-57, 28],
        [-41, 18],
        [-21, 12],
        [-79, 38],
        [-65, 31],
        [-37, 24],
        [-67, 35],
        [-94, 35],
        [-52, 26],
        [-55, 34],
        [-33, 23],
        [-27, 20],
        [-31, 23],
        [-15, 10],
        [-16, 9],
        [-18, 11],
        [-27, 5],
        [-35, 23],
        [-48, 11],
        [-132, 76],
        [-21, 18],
        [-7, 6],
        [-12, 8],
        [-9, 8],
        [-7, 6],
        [-20, 15],
        [-17, 13],
        [-12, 7],
        [-6, 6],
        [-15, 14],
        [-6, 6],
        [-43, 33],
        [-16, 8],
        [-65, 26],
        [-49, 20],
        [-47, 18],
        [-35, 28],
        [-34, 24],
        [-10, 7],
        [-6, 7],
        [-34, 25],
        [-19, 14],
        [-16, 11],
        [-26, 24],
        [-5, 5],
        [-7, 10],
        [-7, 9],
        [-16, 13],
        [-10, 10],
        [-11, 8],
        [-14, 12],
        [-12, 38],
        [-16, 41],
        [-12, 49],
        [-9, 25],
        [11, 88],
        [-2, 11],
        [0, 8],
        [2, 18],
        [3, 12],
        [3, 10],
        [12, 33],
        [4, 9],
        [6, 7],
        [18, 34],
        [8, 16],
        [4, 10],
        [3, 14],
        [12, 37],
        [10, 26],
        [18, 53],
        [5, 11],
        [14, 22],
        [23, 24],
        [20, 40],
        [35, 43],
        [31, 35],
        [59, 50],
        [43, 32],
        [46, 13],
        [8, 1],
        [10, 1],
        [11, 2],
        [31, 11],
        [68, 23],
      ],
      [
        [100633, 144976],
        [-10, 12],
        [-365, 384],
      ],
      [
        [100258, 145372],
        [-232, -21],
        [-69, -21],
        [-28, -20],
        [-28, 119],
        [-13, 260],
        [-63, 172],
        [-26, 306],
        [-21, 371],
        [-24, 24],
        [-26, 32],
        [-32, 35],
        [-13, 14],
        [-38, 29],
        [-25, 25],
        [-27, 37],
        [-30, 43],
        [-150, 204],
        [-53, 67],
        [-107, 104],
        [-87, 83],
        [-23, 19],
        [-154, 135],
        [-56, 44],
        [-61, 49],
        [-162, 122],
        [-91, 67],
        [-20, 18],
        [-159, 100],
        [-93, 63],
        [-43, 27],
        [-209, 136],
        [-143, 94],
        [-99, 54],
        [-81, 48],
        [-61, 29],
        [-45, 26],
        [-43, 32],
        [-22, 12],
        [-136, 80],
        [-55, 34],
        [-84, 46],
        [-58, 32],
        [-35, 22],
        [-84, 45],
        [-59, 41],
        [-98, 57],
        [-60, 30],
        [-48, 28],
        [-90, 48],
        [-31, 17],
        [-53, 22],
        [-61, 46],
        [-54, 32],
        [-62, 51],
        [-13, 12],
        [-52, 38],
        [-51, 30],
        [-47, 34],
        [-61, 43],
        [-73, 45],
        [-68, 43],
        [-44, 25],
        [-98, 52],
        [-53, 30],
        [-48, 29],
        [-61, 41],
        [-15, 24],
        [-20, 17],
        [-28, 20],
        [-32, 22],
        [-50, 38],
        [-110, 60],
        [-53, 26],
        [-43, 28],
        [-38, 26],
        [-28, 22],
        [-42, 29],
        [-75, 52],
        [-48, 34],
        [-40, 28],
        [-29, 13],
        [-25, 19],
        [-15, 12],
        [-38, 25],
        [-47, 26],
        [-39, 27],
        [-71, 45],
        [-48, 32],
        [-47, 21],
        [-75, 48],
        [-88, 55],
        [-68, 46],
        [-47, 31],
        [-73, 46],
        [-100, 66],
        [-54, 40],
        [-76, 50],
        [-61, 31],
        [-26, 16],
        [-79, 49],
        [-111, 75],
        [-71, 43],
        [-62, 40],
        [-112, 80],
        [-77, 43],
        [-53, 34],
        [-37, 27],
        [-23, 18],
        [-75, 38],
        [-68, 50],
        [-76, 52],
        [-105, 71],
        [-110, 74],
        [-68, 47],
        [-78, 51],
        [-42, 33],
        [-39, 20],
        [-98, 66],
        [-211, 151],
        [-161, 116],
        [-103, 66],
        [-35, 34],
        [-133, 94],
        [-50, 35],
        [-145, 93],
        [-106, 63],
        [-49, 11],
        [-84, 48],
        [-475, 352],
        [-371, 276],
        [-399, 321],
        [-247, 203],
        [-113, 114],
        [-93, 92],
        [-150, 163],
        [-138, 141],
        [-102, 103],
        [-85, 86],
        [-71, 65],
        [-34, 34],
        [-34, 27],
        [-30, 40],
        [-40, 40],
        [-29, 44],
        [-34, 38],
        [-51, 60],
        [-39, 36],
        [-77, 92],
        [-59, 86],
        [-66, 91],
        [-53, 83],
        [-37, 50],
        [-25, 35],
        [-8, 16],
        [-20, 28],
        [-16, 17],
        [-19, 22],
        [-15, 22],
        [-47, 78],
        [-57, 77],
        [-41, 65],
        [-37, 56],
        [-2, 2],
        [-4, 8],
        [-8, 20],
        [-4, 9],
        [-1, 13],
        [-12, 22],
        [-28, 54],
        [-26, 36],
        [-14, 15],
        [-30, 40],
        [-21, 32],
        [-20, 33],
        [-13, 24],
        [-16, 20],
        [-9, 35],
        [-25, 27],
        [-41, 61],
        [-47, 105],
        [-43, 69],
        [-44, 101],
        [-55, 109],
        [-26, 56],
        [-22, 69],
        [-33, 116],
        [-16, 106],
        [-6, 67],
        [-13, 73],
        [-10, 210],
        [2, 128],
        [-2, 128],
        [-13, 59],
        [-33, 152],
        [2, 144],
        [8, 114],
        [4, 98],
        [30, 151],
        [16, 41],
        [6, 156],
        [8, 101],
        [7, 178],
        [6, 304],
        [1, 21],
        [0, 25],
        [0, 24],
        [3, 34],
        [1, 72],
        [-4, 57],
        [-8, 51],
        [-14, 48],
        [-4, 39],
        [0, 20],
        [2, 12],
        [3, 13],
        [-1, 21],
        [-6, 40],
        [-4, 22],
        [-12, 48],
        [-21, 46],
        [-11, 69],
        [-24, 71],
        [-52, 78],
        [-22, 47],
        [-67, 123],
        [-73, 134],
        [-79, 136],
        [-31, 47],
        [-80, 119],
        [-76, 109],
        [-67, 136],
        [-71, 105],
        [-147, 192],
        [-85, 110],
        [-46, 65],
        [-84, 106],
        [-117, 133],
        [-106, 120],
        [-94, 103],
        [-34, 45],
        [-100, 110],
        [-85, 97],
        [-102, 99],
        [-105, 105],
        [-47, 47],
        [-128, 118],
        [-121, 98],
        [-25, 19],
        [-85, 75],
        [-64, 49],
        [-30, 31],
        [-57, 44],
        [-99, 87],
        [-129, 98],
        [-32, 41],
        [-98, 77],
        [-48, 38],
        [-22, 27],
        [-34, 30],
        [-55, 31],
        [-29, 31],
        [-17, 26],
        [-22, 28],
        [-10, 8],
        [-22, 22],
        [-11, 13],
        [-8, 11],
        [-9, 19],
        [-42, 44],
        [-42, 70],
        [-9, 12],
        [-20, 16],
        [-15, 17],
        [-13, 18],
        [-12, 31],
        [-2, 7],
        [-8, 27],
        [-4, 28],
        [-2, 18],
        [-7, 51],
        [13, 25],
        [50, 22],
        [43, 9],
        [-12, 20],
        [-1227, 1955],
        [-51, 95],
        [-20, -2],
        [-26, -4],
        [-25, -2],
        [-22, 0],
        [-15, 2],
        [-10, 2],
        [-7, 2],
        [-44, 14],
        [-26, 6],
        [-12, 4],
        [-173, 29],
        [-185, 67],
        [-216, 89],
        [-1, 0],
        [-67, 24],
        [-128, 45],
        [-130, 72],
        [-51, 27],
        [-1, 1],
        [-107, 53],
        [-77, 53],
        [-12, 8],
        [-128, 103],
        [-75, 95],
        [-49, 68],
        [-28, 27],
        [-48, 48],
        [-43, 73],
        [-37, 64],
        [-21, 62],
        [-22, 45],
        [-26, 124],
        [-11, 55],
        [-19, 86],
        [-15, 85],
        [-11, 59],
        [-37, 95],
        [-18, 64],
        [-15, 63],
        [-16, 75],
        [-12, 61],
        [-5, 39],
        [-25, 102],
        [-8, 56],
        [-14, 59],
        [-12, 33],
        [-21, 32],
        [-9, 21],
        [-22, 25],
        [-35, 83],
        [-40, 61],
        [-52, 94],
        [-30, 57],
        [-52, 91],
        [-27, 47],
        [-43, 101],
        [-55, 119],
        [-39, 91],
        [-62, 137],
        [-168, 343],
        [-103, 183],
        [-6, 19],
        [-12, 28],
        [-6, 16],
        [6, 58],
        [-247, 421],
        [-135, 234],
        [-49, 82],
        [-32, 54],
        [-343, 594],
        [-158, 273],
        [-74, 102],
        [-15, 26],
        [-30, 77],
        [-127, 230],
        [-149, 244],
        [-96, 200],
        [-86, 154],
        [-291, 536],
        [-35, 68],
        [-271, 416],
        [-80, 144],
        [-126, 251],
        [-43, 82],
        [-178, 320],
        [-44, 70],
        [-84, 141],
        [-106, 180],
        [-68, 127],
        [-21, 37],
        [-176, 282],
        [-79, 144],
        [-86, 180],
        [-159, 236],
        [-28, 26],
        [-119, 167],
        [-59, 96],
        [-58, 97],
        [-27, 44],
        [-158, 267],
        [-89, 136],
        [-157, 271],
        [-68, 113],
        [-46, 70],
        [-75, 131],
        [-93, 175],
        [-69, 131],
        [-102, 205],
        [-55, 109],
        [-56, 127],
        [-37, 77],
        [-6, 26],
        [-2, 13],
        [1, 21],
        [-4, 24],
        [-83, 147],
        [-33, 56],
        [-44, 79],
        [-37, 70],
        [-46, 69],
        [-38, 63],
        [-226, 351],
        [-105, 175],
        [-160, 248],
        [-125, 181],
        [-56, 88],
        [-184, 243],
        [-85, 119],
        [-87, 114],
        [-25, 31],
        [-282, 368],
        [-92, 117],
        [-37, 55],
        [-51, 82],
        [-87, 105],
        [-120, 129],
        [-98, 102],
        [-90, 112],
        [-154, 172],
        [-36, 44],
        [-101, 100],
        [-141, 143],
        [-155, 158],
        [-82, 87],
        [-113, 108],
        [-120, 109],
        [-129, 134],
        [-52, 43],
        [-122, 106],
        [-111, 105],
        [-106, 98],
        [-65, 71],
        [-122, 111],
        [-118, 108],
        [-165, 154],
        [-89, 76],
        [-127, 107],
        [-146, 124],
        [-140, 118],
        [-94, 78],
        [-57, 39],
        [-132, 85],
        [-101, 70],
        [-57, 44],
        [-92, 71],
        [-66, 51],
        [-78, 67],
        [-73, 43],
        [-209, 135],
        [-181, 107],
        [-61, 57],
        [-111, 68],
        [-125, 76],
        [-204, 119],
        [-168, 100],
        [-110, 61],
        [-76, 42],
        [-19, 10],
        [-36, 19],
        [-42, 24],
        [-53, 35],
        [-23, 10],
        [-53, 21],
        [-70, 33],
        [-29, 15],
        [-39, 22],
        [-54, 31],
        [-80, 44],
        [-38, 37],
        [-56, 59],
        [-24, 30],
        [-6, 6],
        [-14, 10],
        [-16, 18],
        [-30, 40],
        [-32, 57],
        [-20, 48],
        [0, 3],
        [-5, 16],
        [-17, 42],
        [-28, 62],
        [-9, 15],
        [-6, 6],
        [-9, 9],
        [-19, 18],
        [-13, 18],
        [-12, 19],
        [-5, 8],
        [-14, 16],
        [-8, 5],
        [-10, 8],
        [-30, 21],
        [-8, 5],
        [-21, 12],
        [-39, 21],
        [-6, 4],
        [-11, 4],
        [-11, 4],
        [-9, 4],
        [-10, 4],
        [-57, 22],
        [-37, 16],
        [-42, 12],
        [-38, 16],
        [-74, 26],
        [-90, 30],
        [-25, 9],
        [-31, 16],
        [-22, 18],
        [-33, 44],
        [-26, 104],
        [-13, 28],
        [-18, 56],
        [0, 39],
        [4, 34],
        [7, 29],
        [10, 51],
        [18, 49],
        [43, 81],
        [45, 50],
        [36, 37],
        [26, 30],
        [39, 38],
        [35, 30],
        [34, 29],
        [16, 12],
        [34, 26],
        [16, 13],
        [9, 7],
        [24, 18],
        [29, 18],
        [12, 6],
        [34, 20],
        [26, 10],
        [3, 2],
        [29, 8],
        [40, 12],
        [8, 5],
        [4, 1],
        [-1194, 2475],
        [-32, 68],
        [-99, 207],
        [-88, 42],
        [-58, 46],
        [43, 127],
        [-1322, 952],
        [-21, 16],
        [-276, 199],
        [-61, 42],
        [-36, -55],
        [-37, -16],
        [-15, -9],
        [-62, -54],
        [-18, -9],
        [-22, -1],
        [-20, 1],
        [-34, 8],
        [-26, 17],
        [-34, 43],
        [-22, 18],
        [-11, 8],
        [-8, 11],
        [-10, 17],
        [-8, 18],
        [-23, 28],
        [-22, 38],
        [-27, 78],
        [-18, 34],
        [-29, 49],
        [-5, 8],
        [-6, 8],
        [-26, 39],
        [-7, 10],
        [-8, 12],
        [-12, 19],
        [-4, 8],
        [-12, 20],
        [-29, 65],
        [-12, 21],
        [-24, 43],
        [-37, 65],
        [-29, 48],
        [-48, 85],
        [-80, 131],
        [-57, 70],
        [-306, 433],
        [-279, 338],
        [-66, 81],
        [-11, 13],
        [-61, 75],
        [-22, 25],
        [-337, 422],
        [-75, 92],
        [-182, 230],
        [-83, 100],
        [-21, 32],
        [-270, 346],
        [-56, 111],
        [-116, 111],
        [-356, 473],
        [-552, 536],
        [-388, 333],
        [-1322, 908],
        [-91, 47],
        [-139, 79],
        [-1198, 570],
        [-16, -36],
        [-10, 2],
        [20, 40],
        [-45, 110],
        [-26, -71],
        [1, -7],
        [-8, 3],
        [-5, 8],
        [33, 81],
        [-36, 17],
        [-34, 28],
        [-91, 70],
        [-64, 28],
        [-64, 30],
        [-104, 61],
        [-95, 36],
        [-96, 33],
        [-107, 51],
        [-56, 26],
        [-65, 24],
        [-77, 19],
        [-79, 38],
        [-446, 208],
        [-141, 56],
        [-177, 66],
        [-228, 60],
        [-150, 39],
        [-78, 31],
        [-56, 27],
        [-82, 18],
        [-45, 30],
        [-47, 46],
        [-13, 3],
        [9, 23],
        [10, 32],
        [-7, 2],
        [-65, 35],
        [-350, 254],
        [-56, 35],
        [-4, 2],
        [-8, 6],
        [-12, 6],
        [-13, 5],
        [-9, 4],
        [-17, 5],
        [-34, 26],
        [-31, 14],
        [-15, 3],
        [-78, 27],
        [-45, 14],
        [-84, 38],
        [-78, 32],
        [-44, 30],
        [-85, 34],
        [-138, 54],
        [-158, 71],
        [-98, 42],
        [-378, 176],
        [-325, 137],
        [-877, 358],
        [-158, 54],
        [-189, 56],
        [-138, 54],
        [-102, 35],
        [-36, 20],
        [-19, 16],
        [-34, 15],
        [-101, 36],
        [-82, 30],
        [-96, 41],
        [-63, 31],
        [-93, 37],
        [-61, 20],
        [-127, 50],
        [-78, 28],
        [-97, 36],
        [-96, 35],
        [-106, 42],
        [-192, 72],
        [-129, 48],
        [-81, 23],
        [-65, 36],
        [-75, 23],
        [-67, 30],
        [-145, 57],
        [-186, 59],
        [-111, 43],
        [-92, 35],
        [-129, 46],
        [-123, 43],
        [-126, 46],
        [-98, 29],
        [-54, 22],
        [-65, 22],
        [-98, 32],
        [-53, 24],
        [-73, 30],
        [-115, 43],
        [-94, 34],
        [-83, 32],
        [-165, 54],
        [-145, 44],
        [-139, 47],
        [-97, 28],
        [-155, 51],
        [-167, 58],
        [-177, 55],
        [-63, 24],
        [-69, 16],
        [-156, 42],
        [-197, 62],
        [-148, 45],
        [-287, 83],
        [-82, 23],
        [-282, 73],
        [-140, 45],
        [-136, 29],
        [-15, 5],
        [-273, 71],
        [-138, 32],
        [-255, 50],
        [-279, 63],
        [-207, 42],
        [-128, 31],
        [-308, 57],
        [-276, 58],
        [-198, 36],
        [-133, 21],
        [-331, 51],
        [-199, 18],
        [-199, 2],
        [-56, 2],
        [-53, 3],
        [-35, 4],
        [-47, 9],
        [-79, 3],
        [-33, 0],
        [-36, 0],
        [-36, -7],
        [-52, 0],
        [-30, -5],
        [-28, -3],
        [-23, -2],
        [-18, 0],
        [-17, 4],
        [-15, 5],
        [-15, 12],
        [-9, 7],
        [-13, 7],
        [-25, 6],
        [-12, 1],
        [-18, 2],
        [-28, 11],
        [-13, 5],
        [-11, 8],
        [-15, 7],
        [-26, 14],
        [-21, 10],
        [-67, 28],
        [-7, 0],
        [-24, 12],
        [-67, 61],
        [-10, 18],
        [-39, 46],
        [-10, 75],
        [0, 17],
        [4, 17],
        [18, 27],
        [17, 16],
        [24, 28],
        [-2118, 54],
        [-824, 249],
        [-117, 35],
        [-28, 5],
        [-39, 20],
        [-40, 14],
        [-105, 73],
        [-39, 23],
        [-80, 37],
        [-289, 131],
        [-133, 54],
        [-451, 171],
        [-157, 81],
        [-85, 26],
        [-299, 133],
        [-337, 203],
        [-191, 86],
        [-626, 353],
        [-604, 324],
        [-161, 66],
        [-145, 57],
        [-364, 187],
        [-258, 129],
        [-134, 83],
        [-554, 242],
        [-686, 274],
        [-858, 314],
        [-231, 49],
        [-440, 131],
        [-153, 63],
        [-349, 99],
        [-574, 135],
        [-1067, 223],
        [-97, 8],
        [-114, 33],
        [-310, 56],
        [-763, 113],
        [-273, 46],
        [-88, 0],
        [-113, 4],
        [-212, 30],
        [-480, 70],
        [-148, 24],
        [-39, 10],
        [-6, 2],
        [-158, 15],
        [-160, 15],
        [-164, 18],
        [-141, 11],
        [-260, 15],
        [-187, 15],
        [-141, 20],
        [-200, 31],
        [-41, -14],
        [-31, 12],
        [-52, 47],
        [-51, 34],
        [-32, 21],
        [-28, 12],
        [-41, 15],
        [-49, 46],
        [-8, 19],
        [-4, 28],
        [8, 13],
        [12, 8],
        [-61, 90],
        [-7, 17],
        [-29, 58],
        [-497, 1001],
        [-68, 117],
        [-43, 71],
        [-15, -29],
        [-41, -10],
        [-73, 14],
        [-13, 8],
        [-14, 6],
        [-6, 0],
        [-9, 2],
        [-22, 0],
        [-58, -2],
        [-60, 0],
        [-55, 6],
        [-18, 13],
        [-29, 14],
        [-27, 16],
        [-28, 23],
        [-22, 22],
        [-22, 27],
        [-23, 27],
        [-26, 25],
        [-81, 81],
        [-57, 61],
        [-65, 71],
        [-53, 44],
        [-108, 96],
        [-54, 53],
        [-2, 2],
        [-41, 27],
        [-83, 66],
        [-35, 32],
        [-7, 9],
        [-4, 7],
        [-8, 17],
        [-25, 39],
        [-28, 41],
        [-28, 44],
        [-37, 52],
        [-22, 31],
        [-19, 24],
        [-36, 50],
        [-80, 88],
        [-123, 141],
        [-64, 88],
        [-29, 31],
        [-63, 74],
        [-94, 88],
        [-34, 34],
        [-17, 16],
        [-43, 39],
        [-20, 14],
        [-38, 27],
        [-49, 34],
        [-24, 18],
        [-46, 31],
        [-83, 60],
        [-74, 40],
        [-68, 28],
        [-69, 36],
        [-56, 22],
        [-48, 24],
        [-39, 25],
        [-99, 29],
        [-2, 1],
        [-28, 13],
        [-22, 9],
        [-3, 0],
        [-5, 0],
        [-9, -4],
        [-26, -3],
        [-28, 27],
        [-2, 4],
        [-6, 8],
        [-2, 5],
        [0, 8],
        [2, 12],
        [0, 2],
        [-2, 8],
        [19, 33],
        [5, 24],
        [20, -2],
        [26, 24],
        [4, 52],
        [1, 42],
        [-7, 43],
        [-30, 78],
        [-6, 6],
        [-38, 24],
        [-6, 10],
        [2, 10],
        [20, 10],
        [0, 13],
        [-2, 18],
        [-6, 14],
        [0, 26],
        [-16, 29],
        [-17, 25],
        [-10, 17],
        [-17, 27],
        [-26, 30],
        [-26, 28],
        [-24, 26],
        [-16, 28],
        [-18, 30],
        [-12, 32],
        [-13, 81],
        [-18, 69],
        [-28, 83],
        [-43, 88],
        [-75, 132],
        [-25, 45],
        [-109, 142],
        [-112, 145],
        [-105, 110],
        [-85, 93],
        [-67, 78],
        [-197, 201],
        [-185, 166],
        [-88, 86],
        [-67, 101],
        [-98, 97],
        [-98, 127],
        [-227, 246],
        [-119, 118],
        [-145, 139],
        [-65, 78],
        [-80, 54],
        [-61, 29],
        [-43, 103],
        [-24, 80],
        [-6, 20],
        [-11, 35],
        [-2046, 800],
        [-582, 318],
        [-14, 13],
        [-17, 34],
        [-9, 16],
        [-3, 8],
        [-26, 44],
        [-13, 47],
        [-7, 55],
        [-6, 72],
        [-8, 36],
        [-10, 40],
        [-20, 62],
        [-21, 53],
        [-32, 67],
        [-38, 71],
        [-46, 72],
        [-52, 91],
        [-36, 90],
        [-70, 99],
        [-69, 107],
        [-18, 29],
        [-145, 239],
        [-37, 65],
        [-42, 66],
        [-48, 81],
        [-79, 109],
        [-63, 86],
        [-70, 86],
        [-110, 138],
        [-43, 53],
        [-89, 97],
        [-73, 100],
        [-31, 33],
        [-76, 70],
        [-124, 147],
        [-101, 95],
        [-32, 34],
        [-83, 74],
        [-48, 44],
        [-92, 82],
        [-112, 93],
        [-27, 19],
        [-120, 96],
        [-81, 66],
        [-70, 49],
        [-58, 58],
        [-94, 90],
        [-122, 110],
        [-114, 94],
        [-100, 85],
        [-112, 80],
        [-136, 107],
        [-133, 91],
        [-134, 91],
        [-140, 86],
        [-96, 59],
        [-172, 85],
        [-229, 107],
        [-150, 70],
        [-179, 72],
        [-163, 65],
        [-157, 56],
        [-91, 32],
        [-85, 33],
        [-166, 58],
        [-179, 81],
        [-85, 36],
        [-72, 25],
        [-86, 33],
        [-185, 69],
        [-295, 88],
        [-63, 15],
        [-121, 30],
        [-110, 38],
        [-232, 63],
        [-95, 19],
        [-119, 41],
        [-209, 66],
        [-134, 41],
        [-128, 27],
        [-116, 37],
        [-126, 34],
        [-72, 6],
        [-77, 6],
        [-57, 1],
        [-55, 14],
        [-96, 24],
        [-123, 25],
        [-86, 14],
        [-119, 24],
        [-64, 12],
        [-184, 30],
        [-188, 28],
        [-137, 10],
        [-133, 2],
        [-129, 14],
        [-137, 14],
        [-130, 4],
        [-102, 4],
        [-55, 0],
        [-204, 13],
        [-169, 11],
        [-170, 12],
        [-64, 4],
        [-93, 5],
        [-191, 0],
        [-135, -1],
        [-65, -9],
        [-28, 0],
        [-75, -1],
        [-70, -4],
        [-76, -2],
        [-163, -16],
        [-101, -8],
        [-39, -8],
        [-111, -14],
        [-128, -14],
        [-81, -11],
        [-70, -11],
        [-91, -17],
        [-24, -4],
        [-63, -11],
        [-101, -25],
        [-25, -7],
        [-54, -16],
        [-126, -37],
        [-10, -2],
        [-52, -2],
        [-74, -18],
        [-131, -38],
        [-86, -22],
        [-105, -26],
        [-105, -32],
        [-46, -12],
        [-29, -3],
        [-58, -13],
        [-83, -20],
        [-52, -7],
        [-74, -18],
        [-67, -11],
        [-85, -16],
        [-133, -24],
        [-96, -10],
        [-54, -2],
        [-92, -6],
        [-31, -2],
        [-91, -9],
        [-50, -5],
        [-35, 5],
        [-36, 8],
        [-30, 9],
        [-35, 8],
        [-30, 6],
        [-52, 4],
        [-33, 0],
        [-76, -4],
        [-71, -6],
        [-53, -8],
        [-45, -10],
        [-46, -15],
        [-22, -15],
        [-27, -9],
        [-47, -12],
        [-70, -11],
        [-38, -5],
        [-50, 1],
        [-49, -27],
        [-56, -16],
        [-40, 2],
        [-51, 6],
        [-31, 10],
        [-27, 14],
        [-21, 19],
        [-45, 9],
        [-42, -5],
        [-25, -5],
        [-7, 8],
        [-3, 8],
        [1, 5],
        [12, 58],
        [38, 53],
        [6, 5],
        [20, 9],
        [12, 3],
        [12, 4],
        [2, 0],
        [48, 37],
        [123, 89],
        [35, 17],
        [59, 766],
        [25, 605],
        [6, 122],
        [12, 295],
        [-123, 499],
        [-6, 3],
        [-8, -11],
        [-10, -1],
        [-10, 1],
        [-16, 2],
        [-15, 7],
        [-18, 10],
        [-24, 13],
        [-12, -2],
        [-12, -11],
        [-24, -4],
        [-26, 4],
        [-33, 13],
        [-19, 14],
        [-20, 23],
        [-13, 22],
        [-8, 31],
        [1, 12],
        [0, 20],
        [-2, 22],
        [-14, 13],
        [-13, 40],
        [0, 9],
        [-4, 10],
        [-9, 13],
        [-4, 7],
        [-50, 82],
        [-17, 25],
        [-11, 31],
        [-6, 35],
        [-6, 11],
        [-17, 38],
        [-20, 74],
        [-15, 138],
        [-10, 138],
        [11, 250],
        [-5, 27],
        [-2, 64],
        [-6, 77],
        [0, 59],
        [-2, 88],
        [-16, 155],
        [-10, 77],
        [-8, 52],
        [-3, 24],
        [-4, 19],
        [-9, 33],
        [-7, 20],
        [-11, 46],
        [-4, 46],
        [-10, 68],
        [-11, 76],
        [-14, 132],
        [-20, 99],
        [-16, 87],
        [-3, 53],
        [-16, 99],
        [-18, 118],
        [-11, 110],
        [-12, 126],
        [-7, 66],
        [-7, 64],
        [-6, 52],
        [0, 29],
        [-1, 20],
        [-5, 28],
        [-7, 26],
        [-8, 21],
        [-7, 22],
        [-8, 37],
        [3, 19],
        [-6, 89],
        [-3, 30],
        [-6, 46],
        [-3, 37],
        [-5, 46],
        [-9, 42],
        [-8, 75],
        [-4, 32],
        [-14, 33],
        [-12, 60],
        [-14, 84],
        [-13, 80],
        [-16, 125],
        [-13, 126],
        [-19, 31],
        [-23, 85],
        [-11, 60],
        [-13, 79],
        [-22, 114],
        [-31, 104],
        [-24, 126],
        [-18, 79],
        [-20, 102],
        [-30, 105],
        [-36, 168],
        [-10, 34],
        [-25, 88],
        [-23, 91],
        [-20, 73],
        [-16, 41],
        [-23, 92],
        [-12, 26],
        [-8, 16],
        [-20, 21],
        [-9, 20],
        [-15, 36],
        [-14, 34],
        [-16, 48],
        [-32, 85],
        [-73, 168],
        [-59, 126],
        [-53, 133],
        [-35, 81],
        [-37, 99],
        [-16, 53],
        [-22, 64],
        [-39, 128],
        [-16, 59],
        [-25, 113],
        [-35, 131],
        [-23, 89],
        [-26, 62],
        [-39, 78],
        [-39, 81],
        [-33, 66],
        [-41, 80],
        [-23, 50],
        [-7, 27],
        [-11, 28],
        [-27, 62],
        [-14, 35],
        [-14, 34],
        [-22, 33],
        [-18, 31],
        [-13, 31],
        [-9, 61],
        [-6, 16],
        [-8, 11],
        [-17, 6],
        [-10, 10],
        [-5, 9],
        [-19, 52],
        [-11, 24],
        [-3, 12],
        [-12, 40],
        [-32, 77],
        [-20, 50],
        [-10, 28],
        [-4, 10],
        [-6, 8],
        [-8, 12],
        [-8, 16],
        [-14, 37],
        [-4, 17],
        [0, 11],
        [0, 14],
        [0, 17],
        [-15, 19],
        [-9, 52],
        [-11, 23],
        [-10, 14],
        [-6, 23],
        [-40, 22],
        [-34, 26],
        [-15, 38],
        [-8, 22],
        [-10, 77],
        [20, 80],
        [-2, 40],
        [6, 35],
        [4, 18],
        [5, 17],
        [14, 26],
        [31, 214],
        [174, 454],
        [35, 208],
        [13, 152],
        [7, 41],
        [2, 25],
        [0, 23],
        [2, 11],
        [7, 49],
        [9, 47],
        [8, 36],
        [16, 51],
        [4, 12],
        [16, 62],
        [14, 64],
        [8, 36],
        [2, 13],
        [4, 24],
        [0, 18],
        [11, 40],
        [2, 8],
        [3, 8],
        [3, 12],
        [6, 30],
        [5, 43],
        [2, 19],
        [4, 37],
        [2, 41],
        [10, 45],
        [6, 23],
        [-6, 17],
        [4, 12],
        [2, 16],
        [19, 54],
        [5, 36],
        [1, 12],
        [2, 20],
        [6, 25],
        [7, 37],
        [8, 19],
        [6, 20],
        [1, 6],
        [0, 8],
        [1, 10],
        [15, 84],
        [12, 61],
        [6, 31],
        [8, 28],
        [6, 25],
        [5, 31],
        [7, 41],
        [3, 22],
        [2, 19],
        [3, 21],
        [4, 16],
        [2, 7],
        [3, 6],
        [5, 14],
        [10, 38],
        [15, 70],
        [2, 10],
        [3, 25],
        [3, 25],
        [7, 33],
        [4, 20],
        [10, 43],
        [6, 20],
        [0, 36],
        [0, 16],
        [2, 16],
        [8, 65],
        [2, 14],
        [2, 16],
        [2, 10],
        [8, 63],
        [5, 74],
        [4, 26],
        [6, 30],
        [1, 15],
        [-1, 23],
        [-2, 15],
        [-1, 15],
        [5, 53],
        [2, 9],
        [2, 10],
        [4, 28],
        [-14, 46],
        [1, 26],
        [0, 17],
        [-1, 14],
        [-2, 42],
        [0, 50],
        [1, 40],
        [-2, 84],
        [-2, 13],
        [-1, 16],
        [0, 28],
        [3, 45],
        [-1, 51],
        [-3, 46],
        [-2, 48],
        [-2, 69],
        [0, 38],
        [-15, 16],
        [-7, 13],
        [-2, 6],
        [-4, 13],
        [16, 50],
        [-3, 23],
        [-7, 33],
        [0, 11],
        [-8, 85],
        [-2, 6],
        [-14, 58],
        [-8, 45],
        [-5, 30],
        [-2, 10],
        [1, 12],
        [-1, 14],
        [-21, 16],
        [-5, 30],
        [-8, 47],
        [0, 5],
        [-1, 58],
        [-17, 13],
        [-11, 75],
        [-2, 44],
        [-2, 5],
        [-2, 6],
        [-2, 19],
        [-4, 43],
        [2, 43],
        [0, 36],
        [-2, 21],
        [-2, 8],
        [-2, 9],
        [-2, 13],
        [2, 37],
        [2, 40],
        [4, 70],
        [-28, 21],
        [-2, 20],
        [-2, 6],
        [6, 20],
        [6, 11],
        [-2, 6],
        [-4, 13],
        [-1, 6],
        [-2, 29],
        [0, 14],
        [0, 6],
        [0, 8],
        [3, 20],
        [5, 26],
        [0, 51],
        [0, 64],
        [-8, 18],
        [0, 6],
        [-2, 20],
        [-1, 44],
        [5, 9],
        [-3, 6],
        [0, 3],
        [-10, 58],
        [-2, 14],
        [-4, 31],
        [-2, 11],
        [-22, 78],
        [-11, 23],
        [-16, 39],
        [-25, 81],
        [-13, 41],
        [-14, 35],
        [-24, 47],
        [-26, 47],
        [-25, 46],
        [-15, 25],
        [-18, 42],
        [-37, 67],
        [-17, 28],
        [-18, 26],
        [-15, 36],
        [-21, 36],
        [-22, 34],
        [-10, 21],
        [-3, 13],
        [-2, 11],
        [-17, 34],
        [-14, 27],
        [-12, 18],
        [-10, 19],
        [0, 1],
        [-6, 27],
        [-11, 29],
        [-19, 47],
        [-37, 26],
        [-42, 4],
        [-19, 22],
        [-17, 30],
        [-30, 60],
        [-9, 23],
        [-23, 82],
        [-9, 40],
        [-115, 546],
        [-4, 25],
        [-5, 20],
        [-16, 57],
        [-28, 42],
        [-13, 66],
        [-6, 24],
        [-6, 17],
        [-12, 30],
        [-30, 69],
        [-6, 9],
        [-4, 10],
        [-10, 30],
        [-11, 55],
        [-2, 11],
        [0, 10],
        [0, 18],
        [-1, 30],
        [-2, 12],
        [-3, 10],
        [-6, 13],
        [-5, 14],
        [-4, 13],
        [-4, 12],
        [-2, 7],
        [0, 17],
        [-6, 10],
        [-7, 15],
        [-2, 11],
        [-5, 11],
        [-3, 8],
        [-6, 8],
        [-6, 8],
        [-6, 10],
        [-25, 33],
        [-8, 10],
        [-2, 17],
        [-33, 75],
        [-13, 29],
        [-9, 55],
        [-9, 56],
        [-5, 10],
        [-4, 10],
        [-10, 32],
        [-5, 20],
        [-6, 17],
        [0, 14],
        [-18, 26],
        [-2, 8],
        [-5, 28],
        [-2, 12],
        [-4, 8],
        [-4, 9],
        [-5, 17],
        [-10, 43],
        [-13, 42],
        [-4, 6],
        [-6, 10],
        [-5, 8],
        [-8, 16],
        [-7, 19],
        [-4, 67],
        [-4, 19],
        [-6, 25],
        [0, 28],
        [0, 11],
        [0, 19],
        [-2, 26],
        [-6, 44],
        [-9, 36],
        [-6, 27],
        [-2, 18],
        [-1, 9],
        [-1, 19],
        [-2, 8],
        [-7, 8],
        [-4, 8],
        [-3, 12],
        [-5, 18],
        [-1, 19],
        [2, 54],
        [0, 10],
        [3, 14],
        [4, 6],
        [11, 8],
        [-6, 47],
        [0, 9],
        [1, 11],
        [1, 9],
        [4, 11],
        [9, 31],
        [3, 16],
        [0, 12],
        [0, 43],
        [0, 43],
        [-1, 75],
        [8, 49],
        [6, 36],
        [2, 41],
        [4, 54],
        [0, 14],
        [4, 36],
        [8, 28],
        [-2, 16],
        [-2, 14],
        [-2, 13],
        [-4, 51],
        [33, 63],
        [87, 213],
        [-1, 30],
        [4, 19],
        [3, 11],
        [2, 6],
        [3, 8],
        [4, 9],
        [1, 8],
        [1, 10],
        [-2, 14],
        [-5, 11],
        [0, 10],
        [0, 10],
        [3, 32],
        [3, 8],
        [2, 2],
        [5, 8],
        [10, 41],
        [0, 7],
        [0, 8],
        [0, 6],
        [9, 54],
        [2, 9],
        [7, 18],
        [8, 66],
        [0, 18],
        [6, 48],
        [6, 26],
        [6, 46],
        [0, 17],
        [4, 13],
        [4, 20],
        [4, 11],
        [5, 12],
        [4, 18],
        [3, 14],
        [2, 10],
        [0, 24],
        [4, 26],
        [8, 29],
        [4, 17],
        [13, 45],
        [16, 66],
        [18, 81],
        [4, 33],
        [6, 30],
        [4, 21],
        [17, 55],
        [4, 23],
        [16, 68],
        [13, 38],
        [6, 38],
        [32, 141],
        [6, 28],
        [5, 24],
        [7, 46],
        [3, 41],
        [11, 50],
        [12, 31],
        [8, 33],
        [6, 42],
        [12, 38],
        [10, 26],
        [12, 32],
        [13, 37],
        [5, 42],
        [9, 40],
        [11, 24],
        [10, 41],
        [19, 89],
        [9, 36],
        [15, 56],
        [15, 57],
        [7, 32],
        [2, 8],
        [0, 8],
        [-1, 9],
        [1, 5],
        [6, 28],
        [12, 29],
        [4, 8],
        [4, 5],
        [68, 201],
        [7, 33],
        [4, 15],
        [25, 50],
        [17, 34],
        [-5, 14],
        [30, 66],
        [3, 25],
        [0, 12],
        [0, 13],
        [4, 15],
        [11, 32],
        [9, 31],
        [12, 33],
        [22, 62],
        [14, 37],
        [24, 56],
        [26, 49],
        [7, 15],
        [13, 36],
        [20, 44],
        [17, 60],
        [14, 29],
        [27, 66],
        [20, 58],
        [17, 30],
        [35, 62],
        [100, 251],
        [61, 153],
        [7, 10],
        [7, 19],
        [4, 15],
        [4, 26],
        [6, 18],
        [8, 28],
        [31, 44],
        [15, 34],
        [32, 74],
        [4, 31],
        [12, 39],
        [29, 69],
        [16, 50],
        [14, 36],
        [22, 49],
        [33, 74],
        [9, 21],
        [10, 17],
        [10, 31],
        [12, 28],
        [17, 14],
        [8, 22],
        [9, 22],
        [11, 14],
        [19, 30],
        [10, 21],
        [28, 53],
        [13, 24],
        [-6, 24],
        [9, 30],
        [10, 30],
        [28, 44],
        [0, 24],
        [10, 24],
        [6, 12],
        [2, 5],
        [18, 42],
        [18, 50],
        [15, 40],
        [25, 42],
        [29, 46],
        [30, 56],
        [10, 25],
        [7, 24],
        [6, 22],
        [15, 31],
        [12, 26],
        [12, 31],
        [15, 39],
        [17, 30],
        [9, 16],
        [10, 19],
        [17, 51],
        [19, 48],
        [12, 29],
        [58, 121],
        [26, 48],
        [18, 29],
        [21, 34],
        [12, 20],
        [6, 16],
        [0, 7],
        [2, 10],
        [6, 21],
        [10, 21],
        [27, 40],
        [26, 41],
        [20, 42],
        [23, 34],
        [28, 55],
        [3, 6],
        [16, 49],
        [8, 25],
        [2, 22],
        [0, 4],
        [2, 10],
        [8, 14],
        [7, 10],
        [12, 4],
        [22, -20],
        [4, -6],
        [0, -8],
        [0, -10],
        [0, -8],
        [2, -2],
        [6, -6],
        [14, -10],
        [8, -4],
        [14, 14],
        [-3, 8],
        [-2, 48],
        [0, 15],
        [-2, 41],
        [5, 17],
        [6, 14],
        [49, 121],
        [24, 49],
        [13, 39],
        [27, 44],
        [6, 11],
        [4, 17],
        [0, 10],
        [3, 16],
        [7, 10],
        [11, 12],
        [11, 14],
        [27, 51],
        [9, 24],
        [37, 58],
        [46, 72],
        [18, 28],
        [26, 39],
        [29, 60],
        [11, 22],
        [23, 37],
        [29, 46],
        [10, 18],
        [11, 25],
        [10, 22],
        [6, 16],
        [9, 8],
        [21, 14],
        [10, 20],
        [6, 20],
        [23, 40],
        [16, 33],
        [31, 59],
        [69, 129],
        [47, 77],
        [34, 55],
        [10, 19],
        [6, 12],
        [4, 28],
        [6, 16],
        [19, 31],
        [14, 13],
        [9, 16],
        [4, 6],
        [8, 0],
        [14, 22],
        [-2, 12],
        [9, 9],
        [13, 16],
        [2, 7],
        [10, 2],
        [2, 11],
        [0, 3],
        [0, 5],
        [2, 7],
        [4, 13],
        [2, 6],
        [23, 31],
        [14, 6],
        [10, 10],
        [12, 11],
        [18, 30],
        [-2, 12],
        [6, 16],
        [4, 9],
        [12, 3],
        [8, 4],
        [12, 22],
        [-3, 12],
        [46, 76],
        [11, 15],
        [18, 15],
        [10, 9],
        [6, 4],
        [26, 14],
        [0, 2],
        [14, 6],
        [12, -6],
        [5, -8],
        [1, -3],
        [4, -7],
        [12, -11],
        [40, -11],
        [17, 0],
        [25, 12],
        [18, 16],
        [58, 65],
        [23, 38],
        [21, 40],
        [60, 82],
        [15, 28],
        [45, 67],
        [35, 55],
        [33, 50],
        [5, 8],
        [18, 28],
        [13, 36],
        [36, 41],
        [26, 41],
        [31, 32],
        [10, 17],
        [39, 35],
        [26, 31],
        [37, 58],
        [49, 69],
        [56, 84],
        [65, 87],
        [32, 63],
        [6, 15],
        [18, 17],
        [31, 17],
        [30, 12],
        [38, 63],
        [52, 24],
        [55, 35],
        [42, 20],
        [21, 30],
        [-10, 18],
        [-3, 14],
        [2, 16],
        [4, 22],
        [18, 15],
        [32, 55],
        [13, 35],
        [22, 33],
        [22, 42],
        [26, 70],
        [12, 21],
        [37, 58],
        [16, 36],
        [16, 37],
        [16, 29],
        [30, 52],
        [27, 43],
        [30, 56],
        [40, 64],
        [30, 54],
        [66, 105],
        [67, 100],
        [48, 77],
        [65, 105],
        [48, 86],
        [44, 69],
        [32, 45],
        [37, 66],
        [63, 90],
        [42, 73],
        [36, 64],
        [42, 59],
        [26, 44],
        [25, 55],
        [68, 108],
        [98, 169],
        [48, 70],
        [36, 56],
        [27, 54],
        [31, 41],
        [48, 80],
        [46, 83],
        [31, 39],
        [12, 26],
        [38, 66],
        [8, 18],
        [806, 1381],
        [520, 910],
        [335, 587],
        [438, 852],
        [256, 583],
        [62, 139],
        [21, 50],
        [20, 46],
        [131, 294],
        [13, 34],
        [100, 228],
        [99, 222],
        [197, 657],
        [2, 4],
        [0, 4],
        [47, 272],
        [17, 103],
        [40, 232],
        [50, 287],
        [4, 44],
        [7, 76],
        [5, 74],
        [2, 29],
        [-1, 73],
        [6, 36],
        [3, 14],
        [5, 24],
        [3, 12],
        [4, 10],
        [7, 18],
        [7, 20],
        [3, 32],
        [-4, 33],
        [-3, 36],
        [1, 20],
        [6, 64],
        [7, 44],
        [10, 71],
        [12, 43],
        [20, 57],
        [10, 42],
        [2, 41],
        [4, 23],
        [6, 22],
        [8, 33],
        [7, 66],
        [1, 37],
        [1, 28],
        [0, 38],
        [-3, 95],
        [2, 75],
        [-4, 28],
        [-3, 20],
        [-1, 32],
        [5, 35],
        [19, 39],
        [38, 106],
        [39, 113],
        [34, 80],
        [27, 59],
        [32, 54],
        [40, 52],
        [29, 30],
        [0, 3],
        [4, 3],
        [85, 68],
        [97, 75],
        [2, 2],
        [113, 90],
        [209, 241],
        [74, 96],
        [112, 134],
        [65, 70],
        [30, 33],
        [54, 52],
        [61, 53],
        [93, 78],
        [0, 1],
        [612, 577],
        [548, 615],
        [-398, 517],
        [655, -260],
        [8, -3],
        [0, 4],
        [3, 2],
        [7, 2],
        [6, -1],
        [6, -1],
        [7, -4],
        [5, 0],
        [4, 2],
        [7, 0],
        [4, 0],
        [2, -1],
        [283, 232],
        [507, 326],
        [551, 334],
        [584, 343],
        [17, 54],
        [7, 22],
        [16, 37],
        [8, 18],
        [10, 23],
        [10, 27],
        [3, 14],
        [2, 5],
        [7, 27],
        [4, 17],
        [3, 21],
        [8, 20],
        [15, 36],
        [8, 21],
        [8, 23],
        [7, 11],
        [14, 13],
        [13, 15],
        [14, 40],
        [15, 26],
        [16, 22],
        [26, 25],
        [39, 31],
        [36, 16],
        [17, 5],
        [19, 8],
        [14, 2],
        [9, -8],
        [33, -19],
        [4, 1],
        [13, 1],
        [16, -1],
        [7, -2],
        [8, 4],
        [6, 0],
        [20, -10],
        [11, -11],
        [16, -8],
        [24, -6],
        [28, -3],
        [26, -5],
        [27, 1],
        [22, -4],
        [13, -7],
        [11, -13],
        [17, -4],
        [21, -4],
        [14, 8],
        [25, -2],
        [19, 10],
        [19, 17],
        [8, 19],
        [11, 38],
        [8, 16],
        [1, 11],
        [2, 14],
        [5, 5],
        [5, 0],
        [4, 2],
        [0, 8],
        [-2, 8],
        [-4, 11],
        [2, 9],
        [0, 4],
        [4, 4],
        [8, -2],
        [12, -5],
        [16, -6],
        [13, -5],
        [17, -7],
        [8, -2],
        [12, -4],
        [15, -9],
        [18, -10],
        [18, -14],
        [13, -7],
        [16, -17],
        [8, -9],
        [6, -6],
        [10, -5],
        [1, -2],
        [4, -9],
        [4, -6],
        [8, -6],
        [4, -5],
        [2, -13],
        [2, -5],
        [7, -7],
        [5, -6],
        [4, -8],
        [6, -7],
        [10, -4],
        [21, -4],
        [24, -7],
        [35, -6],
        [23, -4],
        [19, -2],
        [23, -6],
        [22, -2],
        [12, -6],
        [10, -6],
        [8, -2],
        [16, 0],
        [10, -4],
        [6, -2],
        [8, -2],
        [11, -6],
        [6, -4],
        [9, -4],
        [24, 4],
        [16, -2],
        [11, 0],
        [9, 8],
        [6, 8],
        [1, 4],
        [5, -4],
        [5, -10],
        [6, -6],
        [9, -6],
        [6, -8],
        [6, -4],
        [5, -14],
        [2, -11],
        [6, -10],
        [2, -13],
        [2, -12],
        [8, -7],
        [2, -3],
        [2, -11],
        [2, -7],
        [6, -7],
        [7, -10],
        [10, -10],
        [13, -12],
        [9, -6],
        [7, -4],
        [3, -4],
        [6, -8],
        [10, -10],
        [7, -7],
        [8, -3],
        [14, -3],
        [7, -4],
        [5, 0],
        [6, 0],
        [7, -5],
        [3, -6],
        [2, -7],
        [0, -10],
        [-1, -17],
        [2, -13],
        [3, -12],
        [4, -5],
        [2, -8],
        [3, -5],
        [5, -7],
        [6, -10],
        [6, -4],
        [6, -2],
        [4, -2],
        [5, -7],
        [2, -5],
        [0, -8],
        [2, -7],
        [6, -11],
        [0, -11],
        [4, -8],
        [6, -16],
        [2, -6],
        [0, -12],
        [2, -12],
        [4, -10],
        [-2, -4],
        [0, -16],
        [0, -2],
        [0, -3],
        [0, -21],
        [0, -13],
        [0, -9],
        [0, -9],
        [4, -8],
        [0, -7],
        [0, -3],
        [-4, 0],
        [-2, 8],
        [0, 8],
        [-6, 8],
        [0, 6],
        [-2, 8],
        [-8, 3],
        [-8, 6],
        [-6, 2],
        [-9, -4],
        [-8, -3],
        [-12, -6],
        [-6, -2],
        [-6, -3],
        [-6, -5],
        [-7, -11],
        [-6, -6],
        [4, -4],
        [5, -4],
        [-3, -7],
        [0, -1],
        [-1, -3],
        [4, 0],
        [6, -5],
        [12, -2],
        [15, -2],
        [15, -2],
        [17, -2],
        [10, -4],
        [15, -9],
        [19, -2],
        [11, 0],
        [1, -2],
        [2, 0],
        [4, -2],
        [4, -4],
        [1, -10],
        [10, -8],
        [6, -8],
        [7, -12],
        [10, -13],
        [6, -3],
        [6, -10],
        [9, -21],
        [11, -14],
        [7, -6],
        [10, -8],
        [3, -7],
        [4, -14],
        [6, -12],
        [6, -11],
        [9, -17],
        [7, -8],
        [24, -17],
        [3, -2],
        [2, -2],
        [7, -17],
        [12, -17],
        [14, -21],
        [12, -14],
        [14, -8],
        [9, -8],
        [12, -10],
        [17, -9],
        [10, -9],
        [10, -7],
        [17, -6],
        [13, -2],
        [14, -4],
        [17, 0],
        [16, -1],
        [10, 2],
        [4, -8],
        [10, -3],
        [10, -3],
        [4, -13],
        [4, -15],
        [13, -23],
        [10, -14],
        [9, -14],
        [6, -8],
        [4, -12],
        [4, -14],
        [6, -13],
        [11, -11],
        [5, -8],
        [6, -19],
        [7, -15],
        [12, -19],
        [7, -18],
        [4, -16],
        [6, -13],
        [15, -27],
        [10, -25],
        [17, -28],
        [15, -22],
        [20, -19],
        [12, -15],
        [8, -13],
        [7, -13],
        [10, -19],
        [6, -11],
        [11, -12],
        [11, -13],
        [16, -16],
        [6, -6],
        [6, -6],
        [12, -8],
        [17, -8],
        [19, -8],
        [19, -9],
        [20, -6],
        [23, -8],
        [23, -2],
        [23, -2],
        [17, -2],
        [0, -10],
        [-2, -9],
        [-8, -14],
        [-7, -11],
        [-11, -20],
        [-8, -20],
        [-6, -20],
        [-4, -16],
        [0, -24],
        [4, -26],
        [4, -29],
        [4, -7],
        [4, -17],
        [9, -19],
        [8, -15],
        [9, -21],
        [13, -19],
        [13, -24],
        [13, -18],
        [24, -30],
        [14, -16],
        [6, -6],
        [6, -6],
        [10, -6],
        [7, -10],
        [13, -8],
        [8, -9],
        [7, -13],
        [13, -15],
        [14, -9],
        [17, -22],
        [10, -6],
        [22, -13],
        [26, -10],
        [18, -6],
        [22, -6],
        [23, -4],
        [14, -2],
        [14, -2],
        [35, -4],
        [24, -10],
        [24, 2],
        [9, -2],
        [11, 0],
        [15, -8],
        [14, -8],
        [17, -3],
        [4, -13],
        [9, -18],
        [6, -30],
        [7, -12],
        [11, -15],
        [7, -25],
        [10, -11],
        [19, -17],
        [17, -13],
        [9, -16],
        [0, -18],
        [4, -2],
        [2, -5],
        [4, -20],
        [6, -12],
        [10, -10],
        [13, -6],
        [22, -8],
        [25, -6],
        [34, -8],
        [28, 0],
        [14, 2],
        [30, 6],
        [39, 4],
        [38, 0],
        [28, -2],
        [26, 0],
        [39, 0],
        [27, -2],
        [27, -10],
        [34, -16],
        [23, -15],
        [25, -21],
        [22, -17],
        [34, 62],
        [54, 43],
        [76, 14],
        [64, -4],
        [65, -6],
        [80, -20],
        [81, -20],
        [191, -67],
        [74, -26],
        [93, -28],
        [68, -40],
        [67, -25],
        [101, -35],
        [86, -39],
        [99, -34],
        [99, -27],
        [37, -26],
        [6, -55],
        [0, -28],
        [-4, -16],
        [-2, -20],
        [2, -13],
        [4, -8],
        [6, -8],
        [2, -1],
        [4, -5],
        [5, -5],
        [12, -10],
        [10, -10],
        [4, -2],
        [24, -17],
        [17, -16],
        [14, -10],
        [12, -2],
        [12, -8],
        [15, -6],
        [17, -4],
        [21, -4],
        [20, -2],
        [24, -2],
        [14, 0],
        [12, 4],
        [16, 4],
        [26, 8],
        [22, 6],
        [18, 10],
        [3, 2],
        [11, 8],
        [7, 6],
        [7, 6],
        [13, 9],
        [9, 2],
        [11, 0],
        [14, 4],
        [11, 0],
        [8, 0],
        [4, 0],
        [1, 2],
        [1, 2],
        [3, 4],
        [3, 2],
        [9, 2],
        [6, 0],
        [2, -2],
        [-6, -6],
        [-1, -6],
        [4, -13],
        [5, -8],
        [12, -8],
        [18, -12],
        [29, -16],
        [23, -14],
        [17, -13],
        [7, -9],
        [10, -4],
        [18, 2],
        [10, 6],
        [32, 23],
        [35, 7],
        [28, 12],
        [71, 53],
        [43, 6],
        [41, 20],
        [21, 35],
        [21, 61],
        [21, 113],
        [20, 68],
        [25, 11],
        [1019, 557],
        [20, 11],
        [145, 79],
        [129, -8],
        [0, -35],
        [83, -9],
        [71, 140],
        [34, 71],
        [56, 126],
        [4, 32],
        [16, 147],
        [17, 28],
        [8, 15],
        [17, 14],
        [2, 2],
        [3, 3],
        [93, 77],
        [17, 20],
        [2, 2],
        [26, 28],
        [40, 44],
        [48, 48],
        [27, 34],
        [19, 19],
        [35, 29],
        [24, 18],
        [23, 2],
        [4, 14],
        [4, 28],
        [-4, 89],
        [-19, 151],
        [-2, 47],
        [0, 19],
        [27, 77],
        [20, 56],
        [55, 167],
        [31, 80],
        [27, 28],
        [28, 17],
        [45, -3],
        [60, -4],
        [18, 6],
        [33, 14],
        [48, 24],
        [5, 13],
        [2, 36],
        [6, 81],
        [20, 56],
        [17, 56],
        [30, 32],
        [38, 37],
        [36, 37],
        [27, 25],
        [16, 25],
        [17, 68],
        [20, 54],
        [54, 127],
        [4, 129],
        [17, 52],
        [24, 67],
        [52, 98],
        [48, 61],
        [66, 31],
        [66, 31],
        [36, 25],
        [19, 11],
        [9, 9],
        [8, 9],
        [13, 27],
        [4, 18],
        [2, 27],
        [16, 21],
        [16, 24],
        [9, 17],
        [99, 75],
        [13, 10],
        [72, 57],
        [46, 34],
        [22, 16],
        [194, 151],
        [312, 240],
        [31, 22],
        [7, 6],
        [3, 2],
        [17, 8],
        [185, 143],
        [97, 75],
        [40, 30],
        [126, 95],
        [60, 46],
        [34, 25],
        [79, 61],
        [2, 2],
        [1, 1],
        [-1, 1],
        [488, 374],
        [1129, 866],
        [383, 295],
        [210, 167],
        [276, 210],
        [3, 0],
        [1, 0],
        [14, 6],
        [129, -159],
        [13, -2],
        [18, 1],
        [36, -6],
        [12, -2],
        [579, -90],
        [14, -4],
        [722, -113],
        [36, -6],
        [1364, -216],
        [38, -6],
        [5, 0],
        [2, -1],
        [1, 0],
        [2, -1],
        [2, 0],
        [1, 0],
        [1, 0],
        [239, -39],
        [32, -5],
        [235, -37],
      ],
      [
        [66653, 187814],
        [-2, -2],
        [-4, 0],
        [-2, -2],
        [-2, -2],
        [2, -4],
        [3, 0],
        [3, 0],
        [9, -20],
        [4, -10],
        [-4, -7],
        [4, -8],
        [5, -17],
        [5, -6],
        [2, -6],
        [1, -6],
        [6, -4],
        [5, -6],
        [2, -6],
        [8, 2],
        [8, -4],
        [14, -3],
        [14, 2],
        [11, 7],
        [8, 12],
        [8, 8],
        [6, 7],
        [6, 7],
        [2, 3],
        [5, -2],
        [7, 0],
        [6, 2],
        [4, 1],
        [10, 3],
        [5, -1],
        [6, -1],
        [5, -4],
        [3, -2],
        [11, 0],
        [2, 5],
        [-1, 2],
        [7, 8],
        [8, 3],
        [10, 1],
        [10, -1],
        [4, 4],
        [5, -2],
        [5, -3],
        [3, -6],
        [6, -4],
        [4, -1],
        [7, 0],
        [4, -2],
        [3, -4],
        [7, -5],
        [4, -1],
        [9, 0],
        [14, 1],
        [8, -1],
        [6, -1],
        [6, -4],
        [4, -1],
        [2, 2],
        [2, 1],
        [5, 0],
        [5, 1],
        [3, 3],
        [-2, 3],
        [-3, 5],
        [0, 5],
        [3, 2],
        [1, -4],
        [4, 2],
        [8, -5],
        [3, -2],
        [9, 1],
        [5, 9],
        [5, 18],
        [5, 14],
        [10, 34],
        [4, 14],
        [3, 10],
        [8, 6],
        [10, 2],
        [6, 6],
        [8, 4],
        [2, 3],
        [8, -1],
        [7, -2],
        [23, -10],
        [3, -10],
        [9, -6],
        [9, -12],
        [1, -8],
        [9, 4],
        [14, 12],
        [30, 45],
        [17, 25],
        [22, 40],
        [31, 49],
        [27, 45],
        [39, 52],
        [27, 25],
        [23, 21],
        [0, 0],
        [16, 15],
        [35, -87],
        [-19, -28],
        [-32, -41],
        [-37, -46],
        [-26, -39],
        [-33, -37],
        [-28, -39],
        [-32, -46],
        [-27, -45],
        [-35, -77],
        [-60, -92],
        [-61, -90],
        [-60, -47],
        [-127, -80],
        [-110, -69],
        [-88, -38],
        [-62, -58],
        [-67, 6],
        [-50, 42],
        [-5, -2],
        [-69, 67],
        [-77, 116],
        [-82, 50],
        [-10, 9],
        [-21, 38],
        [-21, 13],
        [-73, 115],
        [-60, 90],
        [-67, 54],
        [-23, 32],
        [-7, 47],
        [-9, 27],
        [-12, 22],
        [-7, 25],
        [-19, 24],
        [-6, 61],
        [-2, 46],
        [-4, 47],
        [2, 40],
        [0, 27],
        [-2, 29],
        [10, 30],
        [37, 35],
        [22, 35],
        [24, 63],
        [18, 28],
        [20, 20],
        [23, 9],
        [21, -1],
        [22, 11],
        [23, 3],
        [4, -32],
        [-15, -10],
        [-4, -18],
        [-2, -14],
        [-14, -6],
        [-26, -6],
        [-34, -16],
        [2, -14],
        [15, -5],
        [40, 4],
        [26, 0],
        [24, 6],
        [17, 8],
        [53, 7],
        [3, -20],
        [-13, -22],
        [17, -18],
        [16, -19],
        [20, -12],
        [9, -14],
        [2, -16],
        [6, -18],
        [10, -18],
        [10, -21],
        [-3, -17],
        [-1, -19],
        [17, -7],
        [13, 1],
        [15, 4],
        [15, -7],
        [8, -16],
        [-2, -17],
        [-13, -13],
        [-16, -31],
        [-2, -12],
        [2, -12],
        [-6, -15],
        [-11, -16],
        [-11, -6],
        [-18, 0],
        [-22, 2],
        [-12, 3],
        [-26, 5],
        [-14, 12],
        [-36, 25],
        [-35, 18],
        [-29, 18],
        [-22, 15],
        [-10, 26],
        [-8, 23],
        [1, 27],
        [8, 26],
        [9, 17],
        [10, 21],
        [-13, 12],
        [-29, 4],
        [-16, -18],
        [-12, -12],
        [-10, -14],
        [-4, -17],
        [-2, -19],
        [2, -25],
        [2, -25],
        [16, -24],
        [15, -14],
        [13, -11],
        [15, -11],
        [23, -21],
        [10, -10],
        [10, -9],
        [9, -12],
        [6, -7],
        [6, -11],
        [-2, -12],
        [14, -14],
        [21, -24],
        [0, -20],
        [4, -16],
        [4, -16],
        [6, -15],
        [9, -18],
        [6, -10],
        [14, 6],
        [15, 2],
        [14, 6],
        [16, -2],
        [12, 4],
        [11, 6],
        [11, -4],
        [25, 0],
        [6, -2],
        [7, -12],
        [2, -12],
        [-6, -10],
        [-9, -6],
        [0, -14],
        [-4, -4],
        [-10, 0],
        [5, -12],
        [9, -6],
        [6, -4],
        [-8, -4],
        [-5, 1],
        [-4, -3],
        [-1, -5],
        [2, -8],
        [3, -3],
        [5, -3],
        [5, -2],
        [6, 0],
        [4, 4],
        [6, -3],
        [2, -2],
        [8, 0],
        [7, -1],
        [4, 2],
        [0, 5],
        [-2, 3],
        [0, 6],
        [7, 8],
        [-5, 11],
        [-2, 6],
        [37, 6],
        [45, 80],
        [36, 70],
        [3, 63],
        [21, 23],
        [24, 26],
        [6, 40],
        [111, 145],
        [52, 47],
        [45, 59],
        [23, 41],
        [12, 30],
        [22, 35],
        [18, 25],
        [21, 25],
        [23, 16],
        [22, 2],
        [10, -6],
        [12, -36],
        [14, -40],
        [13, -25],
        [4, -24],
        [-3, -20],
        [-14, -36],
        [-20, -24],
        [-34, -6],
        [-18, -10],
        [-13, -10],
        [-17, -25],
        [-48, -84],
        [-23, -35],
        [-15, -25],
        [-22, -28],
        [-15, -31],
        [-15, -31],
        [0, -48],
        [0, -24],
        [2, -19],
        [11, -22],
        [14, -17],
        [8, -11],
        [2, -10],
        [-4, -4],
        [-8, -5],
        [-9, -3],
        [-8, -6],
        [-3, -8],
        [-3, -4],
        [-4, -2],
        [-8, 0],
        [-4, -2],
        [1, -6],
        [-2, -2],
        [-1, -4],
        [1, -6],
        [3, -4],
        [2, -6],
      ],
      [
        [65898, 188573],
        [27, -34],
        [30, 56],
        [27, 25],
        [29, -54],
        [-12, -63],
        [30, -17],
        [-8, -40],
        [-37, -42],
        [-31, -35],
        [-35, -35],
        [-26, -55],
        [-25, -54],
        [-15, -89],
        [-38, -77],
        [-28, -37],
        [48, 2],
        [21, -39],
        [-7, -34],
        [29, -13],
        [41, 13],
        [28, -65],
        [9, -52],
        [18, -42],
        [85, -70],
        [68, -104],
        [54, -85],
        [81, -87],
        [56, -27],
        [77, -116],
        [122, -108],
        [-70, -3],
        [-106, 87],
        [-109, 138],
        [-114, 152],
        [-138, 138],
        [-183, 149],
        [-144, 86],
        [-75, 17],
        [-28, 84],
        [64, 128],
        [16, 68],
        [-20, 84],
        [6, 91],
        [45, 106],
        [0, 116],
        [-19, 80],
        [-46, 73],
        [-71, 79],
        [-40, 34],
        [-40, 72],
        [19, 105],
        [113, 104],
        [119, 122],
        [75, 81],
        [5, -82],
        [11, -87],
        [-26, -50],
        [42, -33],
        [60, -102],
        [-7, -64],
        [21, -83],
        [11, -82],
        [-20, -89],
        [4, -41],
        [45, -8],
        [7, -20],
        [-23, -17],
        [-2, -55],
      ],
      [
        [66142, 188842],
        [-14, -65],
        [-6, -50],
        [16, -36],
        [-12, -28],
        [-15, -15],
        [-37, -18],
        [-13, -36],
        [17, -51],
        [13, -22],
        [4, -24],
        [-6, -26],
        [-21, 0],
        [-16, 19],
        [-6, 30],
        [-14, 28],
        [3, 34],
        [-16, 21],
        [-12, 19],
        [-8, 23],
        [-6, 20],
        [8, 28],
        [4, 12],
        [0, 36],
        [0, 37],
        [-4, 17],
        [-6, 15],
        [-11, 0],
        [-14, -9],
        [-18, -18],
        [-14, -21],
        [-10, -28],
        [-10, -27],
        [-12, -18],
        [-22, 6],
        [-4, 14],
        [5, 28],
        [1, 33],
        [8, 29],
        [10, 51],
        [10, 75],
        [-14, 72],
        [-57, 95],
        [-31, 45],
        [19, 44],
        [-35, 52],
        [-9, 83],
        [5, 88],
        [-3, 53],
        [54, 65],
        [40, -45],
        [-67, -110],
        [-2, -29],
        [-2, -51],
        [0, -4],
        [64, -54],
        [20, -10],
        [46, -18],
        [37, -18],
        [-1, -3],
        [49, -45],
        [13, -13],
        [22, -44],
        [7, -60],
        [-6, -64],
        [7, -6],
        [50, -23],
        [41, -24],
        [17, -25],
        [-6, -14],
        [-30, -20],
      ],
      [
        [184202, 59579],
        [44, -23],
        [2, -1],
        [7, 0],
        [14, 3],
        [12, 1],
        [5, 0],
        [12, -4],
        [6, -4],
        [3, -3],
        [2, -4],
        [2, -3],
        [1, -3],
        [12, -2],
        [10, -9],
        [1, -16],
        [-12, -13],
        [-18, -21],
        [-12, -8],
        [0, -4],
        [0, -4],
        [4, -13],
        [1, -2],
        [5, -7],
        [9, -39],
        [3, -13],
        [0, -1],
        [5, -19],
        [3, -6],
        [1, -2],
        [2, -16],
        [2, -40],
        [32, -85],
        [10, -26],
        [17, -30],
        [4, -8],
        [1, -4],
        [1, -6],
        [0, -13],
        [-3, -15],
        [-2, -11],
        [-3, -11],
        [-3, -8],
        [-2, -5],
        [-4, -10],
        [-6, -6],
        [-4, -5],
        [-6, -5],
        [-6, -2],
        [-2, -4],
        [-9, -12],
        [-9, -12],
        [-3, -6],
        [-2, -2],
        [-1, -4],
        [-2, -5],
        [-4, -15],
        [-2, -6],
        [-7, -29],
        [1, -4],
        [2, -6],
        [4, -8],
        [-6, -1],
        [-7, -1],
        [-20, -2],
        [-1, 3],
        [-2, 5],
        [-17, 25],
        [-30, 22],
        [-10, 1],
        [0, 24],
        [2, 15],
        [6, 8],
        [3, 2],
        [2, 4],
        [1, 2],
        [-2, 12],
        [-1, 4],
        [-5, 8],
        [-9, 15],
        [-4, 5],
        [-3, 2],
        [-34, 30],
        [-26, -8],
        [-2, -2],
        [-2, -1],
        [-8, -6],
        [-4, 0],
        [-8, -1],
        [-14, 0],
        [-2, 1],
        [-1, 2],
        [0, 3],
        [1, 2],
        [1, 3],
        [4, 3],
        [4, 3],
        [15, 24],
        [-3, 6],
        [3, 14],
        [12, 4],
        [-17, 14],
        [-21, 10],
        [-2, 2],
        [-3, 2],
        [-8, -6],
        [-5, 2],
        [5, 8],
        [-7, 4],
        [-6, 12],
        [-2, 0],
        [-19, -2],
        [-8, -4],
        [-4, -10],
        [-23, 2],
        [-19, 4],
        [-38, 4],
        [-8, 4],
        [-6, 0],
        [-2, -2],
        [-2, 0],
        [-8, 13],
        [-1, 7],
        [6, 8],
        [7, 11],
        [-2, 5],
        [-19, 7],
        [-13, -1],
        [-4, -8],
        [-11, 5],
        [-15, 9],
        [-27, 43],
        [0, 2],
        [-33, 41],
        [2, 52],
        [33, 30],
        [25, 29],
        [7, 6],
        [-1, 46],
        [6, 9],
        [14, 21],
        [29, 32],
        [1, 0],
        [6, 14],
        [6, 19],
        [27, 30],
        [13, 9],
        [28, 6],
        [2, 1],
        [8, 7],
        [32, 24],
        [8, 5],
        [2, 0],
        [9, 3],
        [21, 2],
        [5, 0],
        [6, 0],
        [8, -2],
        [5, -4],
        [23, -16],
        [4, -4],
        [4, -4],
        [4, -4],
        [10, -25],
        [3, -16],
        [5, -20],
        [3, -13],
        [2, -6],
        [4, -6],
        [0, -2],
      ],
      [
        [183599, 60981],
        [7, -1],
        [5, 2],
        [6, -1],
        [6, -2],
        [2, -2],
        [4, -3],
        [2, -8],
        [8, -9],
        [8, 4],
        [8, -4],
        [4, -25],
        [12, -22],
        [9, -10],
        [11, 2],
        [3, 9],
        [3, 3],
        [8, 0],
        [4, -1],
        [4, -1],
        [7, -14],
        [3, -18],
        [2, -22],
        [11, -16],
        [8, -12],
        [4, -12],
        [-6, -21],
        [-10, -17],
        [-3, -22],
        [-2, -14],
        [0, -18],
        [-2, -26],
        [-8, -22],
        [-18, -37],
        [-14, -14],
        [-8, -6],
        [-7, -10],
        [-6, -10],
        [-2, -14],
        [-4, -15],
        [4, -12],
        [14, -4],
        [21, -3],
        [2, -2],
        [2, -1],
        [2, -2],
        [-1, -4],
        [1, -6],
        [-2, -7],
        [-2, -9],
        [-5, -8],
        [-16, -2],
        [-16, 4],
        [-9, -12],
        [-4, -13],
        [-10, -10],
        [-12, -11],
        [-20, -4],
        [-18, -8],
        [-13, -6],
        [-14, -4],
        [-19, -2],
        [-26, 4],
        [-11, 4],
        [-12, -4],
        [-19, 0],
        [-25, 10],
        [-31, 12],
        [-45, -12],
        [-25, -12],
        [-18, -6],
        [-9, 6],
        [23, 46],
        [13, 38],
        [-11, 32],
        [-2, 21],
        [-12, 14],
        [-16, 4],
        [-16, -2],
        [0, 48],
        [8, 51],
        [2, 33],
        [8, 21],
        [5, 6],
        [4, 4],
        [5, 0],
        [2, 5],
        [6, 7],
        [10, 2],
        [7, 8],
        [5, 20],
        [3, 14],
        [-12, 7],
        [-5, 5],
        [-6, 2],
        [-2, 2],
        [-2, 5],
        [0, 5],
        [-2, 7],
        [0, 10],
        [8, 13],
        [9, 4],
        [9, 6],
        [8, 4],
        [16, 31],
        [13, 5],
        [18, 2],
        [7, 4],
        [9, 2],
        [6, 2],
        [8, 0],
        [14, 1],
        [11, 3],
        [7, 5],
        [6, 8],
        [10, 2],
        [10, 9],
        [9, 2],
        [10, -5],
        [5, 9],
        [17, 7],
        [8, 1],
        [4, -1],
        [4, -3],
        [5, 3],
        [7, 3],
        [7, 8],
        [11, -1],
        [6, -6],
      ],
      [
        [184202, 58622],
        [-35, -18],
        [-19, -2],
        [-18, 2],
        [-18, -18],
        [-23, -15],
        [18, 29],
        [20, 22],
        [26, 38],
        [47, 105],
        [2, 18],
        [0, 19],
        [2, 11],
        [7, 8],
        [9, 13],
        [13, 10],
        [12, 15],
        [18, 15],
        [2, 1],
        [0, 3],
        [6, 5],
        [4, 5],
        [4, 5],
        [7, 9],
        [6, 4],
        [9, 3],
        [4, 3],
        [2, 3],
        [0, 3],
        [-1, 4],
        [-6, 3],
        [-5, 6],
        [23, 0],
        [5, -15],
        [6, -10],
        [6, -15],
        [14, -24],
        [7, -33],
        [0, -36],
        [-4, -33],
        [-18, -45],
        [-46, -44],
        [-35, -27],
        [-34, -11],
        [-17, -16],
      ],
      [
        [188013, 55762],
        [12, 0],
        [16, 0],
        [11, 0],
        [9, -6],
        [6, -6],
        [6, -24],
        [-12, -4],
        [-1, -8],
        [-4, -13],
        [-11, -10],
        [-6, -11],
        [-14, -12],
        [-8, -15],
        [-6, -14],
        [-8, -1],
        [-3, 6],
        [4, 17],
        [-5, 30],
        [-2, 14],
        [-2, 12],
        [-11, 8],
        [-11, 6],
        [-3, 11],
        [3, 10],
        [6, 8],
        [6, 2],
        [6, 2],
        [8, -2],
        [14, 0],
      ],
      [
        [185775, 56090],
        [4, -3],
        [7, 1],
        [6, -1],
        [6, -2],
        [3, -2],
        [2, -2],
        [5, 0],
        [5, 0],
        [5, 0],
        [5, -1],
        [2, -1],
        [2, -3],
        [1, -3],
        [0, -3],
        [0, -3],
        [0, -3],
        [-1, -5],
        [0, -6],
        [0, -10],
        [0, -6],
        [1, -4],
        [-3, -6],
        [-2, -4],
        [-4, -6],
        [-3, -5],
        [-4, -2],
        [-3, -3],
        [-4, -1],
        [-2, -1],
        [-5, -3],
        [-4, -7],
        [-7, 2],
        [-2, 7],
        [1, 6],
        [7, 9],
        [6, 8],
        [-5, 4],
        [-9, -4],
        [-8, -7],
        [-10, 0],
        [-13, -6],
        [-4, -6],
        [-4, -4],
        [-4, -5],
        [-7, -2],
        [-4, 6],
        [-2, 8],
        [6, 8],
        [2, 8],
        [7, 6],
        [6, 6],
        [-4, 6],
        [-6, -2],
        [-3, 4],
        [-1, 4],
        [0, 6],
        [3, 3],
        [3, 2],
        [5, 0],
        [6, 1],
        [3, 0],
        [2, 1],
        [1, 0],
        [2, 1],
        [0, 2],
        [0, 3],
        [0, 4],
        [4, 2],
        [5, 4],
        [3, 3],
        [1, 4],
        [1, 3],
      ],
      [
        [186016, 56201],
        [-8, -6],
        [-9, 3],
        [-3, 5],
        [-2, 4],
        [-2, 3],
        [-4, 6],
        [-10, 7],
        [-5, 15],
        [6, 7],
        [3, 6],
        [-2, 6],
        [5, 5],
        [3, 0],
        [4, 1],
        [6, -1],
        [7, -5],
        [5, -2],
        [12, -3],
        [7, -5],
        [2, -8],
        [-1, -6],
        [-5, -13],
        [-1, -6],
        [-6, -8],
        [0, -1],
        [-2, -4],
      ],
      [
        [187447, 55280],
        [-5, -1],
        [-6, 1],
        [-4, 2],
        [-2, 4],
        [-2, 6],
        [0, 2],
        [2, 4],
        [1, 2],
        [2, 0],
        [2, 0],
        [2, 0],
        [3, 0],
        [1, 0],
        [4, -2],
        [2, -2],
        [2, -2],
        [1, -1],
        [1, -2],
        [0, -4],
        [0, -2],
        [0, -4],
        [-4, -1],
      ],
      [
        [215953, 98453],
        [-1510, 1002],
        [-5689, 3771],
        [-4342, -6202],
        [-1308, -1873],
        [2738, -2784],
        [-3568, -1411],
        [-375, -2951],
        [-1492, 960],
        [-44, -21],
        [-25, -13],
        [-29, -16],
        [-24, -6],
        [-23, -12],
        [-14, -14],
        [-13, -20],
        [-9, -35],
        [-2, -34],
        [9, -27],
        [19, -20],
        [33, -11],
        [29, -4],
        [24, -10],
        [7, -14],
        [-10, -12],
        [-16, -7],
        [-32, -1],
        [-37, -14],
        [-48, -19],
        [-25, -17],
        [-23, -25],
        [-9, -25],
        [10, -27],
        [17, -12],
        [31, 4],
        [20, 16],
        [17, 25],
        [26, 12],
        [28, -4],
        [27, -10],
        [15, -28],
        [11, -26],
        [0, -18],
        [-25, -34],
        [-15, -20],
        [-14, -10],
        [-25, -20],
        [-30, -23],
        [-9, -5],
        [-2, -10],
        [7, -19],
        [3, -15],
        [-2, -11],
        [-5, -8],
        [-7, -6],
        [-25, -4],
        [-31, 0],
        [-29, 0],
        [-30, 2],
        [-31, 0],
        [-34, -20],
        [-1, -38],
        [18, -28],
        [18, -7],
        [24, -6],
        [22, -7],
        [22, -14],
        [6, -21],
        [-9, -18],
        [-19, -8],
        [-8, -4],
        [-21, -2],
        [-24, 2],
        [-22, 12],
        [-9, 6],
        [-18, 10],
        [-22, 4],
        [-12, -9],
        [-6, -17],
        [7, -32],
        [21, -21],
        [14, -12],
        [25, -7],
        [20, -1],
        [25, 0],
        [18, 3],
        [20, -8],
        [9, -6],
        [0, -11],
        [-13, -21],
        [-18, -20],
        [-16, -21],
        [-20, -16],
        [-21, -5],
        [-35, 3],
        [-43, 10],
        [-44, 9],
        [-14, 16],
        [-17, 10],
        [-17, -1],
        [-15, -13],
        [-5, -20],
        [14, -39],
        [25, -31],
        [9, -26],
        [12, -24],
        [6, -25],
        [21, -21],
        [27, -4],
        [18, -4],
        [21, -9],
        [35, -25],
        [17, -15],
        [5, -18],
        [-2, -22],
        [-9, -32],
        [-4, -13],
        [-11, -24],
        [-17, -13],
        [-36, -6],
        [-26, -6],
        [-22, -16],
        [-17, -18],
        [-18, -27],
        [-16, -15],
        [-12, -18],
        [-5, -18],
        [-7, -17],
        [-7, -15],
        [-4, -8],
        [-14, -5],
        [-13, 2],
        [-12, 5],
        [-10, 3],
        [-16, 1],
        [-22, -1],
        [-19, -2],
        [-18, 7],
        [-18, 20],
        [-11, 16],
        [-18, 15],
        [-23, 7],
        [-24, 7],
        [-28, 10],
        [-21, 8],
        [-18, 14],
        [-8, 14],
        [-5, 8],
        [-4, 1],
        [-13, 6],
        [-26, -1],
        [-29, -7],
        [-13, -4],
        [-14, -3],
        [-13, -2],
        [-25, 1],
        [-9, -2],
        [-12, -3],
        [-13, -2],
        [-8, 1],
        [-20, 0],
        [-4, -8],
        [0, -7],
        [0, -6],
        [4, -7],
        [2, -8],
        [-3, -5],
        [-6, -9],
        [-3, -12],
        [-1, -11],
        [-1, -16],
        [-6, -14],
        [-6, -8],
        [-3, -6],
        [-4, -7],
        [-8, -6],
        [-9, -1],
        [-10, -4],
        [-12, -6],
        [-10, -6],
        [-11, -10],
        [-18, -12],
        [-13, -10],
        [-11, -9],
        [-21, -23],
        [-15, -19],
        [-21, -14],
        [-21, -7],
        [-33, 5],
        [-47, 14],
        [-51, 25],
        [-40, 11],
        [-28, 4],
        [-24, -12],
        [-17, -22],
        [-13, -31],
        [-23, -45],
        [-46, -87],
        [-17, -37],
        [-7, -27],
        [-6, -30],
        [19, -14],
        [23, -6],
        [16, -10],
        [16, -15],
        [8, -16],
        [2, -11],
        [-4, -12],
        [-18, -19],
        [-19, -21],
        [-22, -12],
        [-34, -16],
        [-44, -15],
        [-33, -21],
        [-31, -24],
        [-27, -16],
        [-23, -22],
        [-20, -28],
        [-6, -23],
        [4, -27],
        [14, -21],
        [10, -14],
        [10, -18],
        [-3, -24],
        [-3, -27],
        [-2, -28],
        [9, -33],
        [15, -59],
        [4, -23],
        [2, -12],
        [2, -19],
        [-2, -11],
        [-8, -7],
        [-14, -7],
        [-24, -12],
        [-17, -8],
        [-14, -6],
        [-18, -12],
        [-13, -11],
        [-12, -8],
        [-17, -12],
        [-19, -15],
        [-21, -9],
        [-24, 16],
        [-2, 24],
        [4, 17],
        [2, 20],
        [4, 24],
        [4, 19],
        [4, 24],
        [4, 17],
        [-8, 16],
        [-26, 10],
        [-25, 10],
        [-10, 7],
        [-20, 9],
        [-14, -7],
        [-8, -15],
        [-4, -18],
        [-2, -23],
        [-7, -35],
        [-3, -24],
        [-1, -34],
        [3, -51],
        [12, -31],
        [12, -33],
        [11, -40],
        [3, -27],
        [-10, -27],
        [-6, -19],
        [-8, -21],
        [-6, -11],
        [-9, -9],
        [-11, -8],
        [-24, -10],
        [-19, -4],
        [-16, 0],
        [-22, 2],
        [-27, 10],
        [-17, 17],
        [-9, 19],
        [-5, 26],
        [-7, 25],
        [-10, 19],
        [-15, 6],
        [-15, 0],
        [-18, -2],
        [-13, -2],
        [-14, -2],
        [-25, -9],
        [-29, -10],
        [-18, -6],
        [-17, -1],
        [-29, 7],
        [-14, 23],
        [6, 24],
        [16, 22],
        [26, 29],
        [12, 12],
        [4, 10],
        [-10, 17],
        [-17, 34],
        [-19, 72],
        [-12, 53],
        [-9, 34],
        [-3, 23],
        [-9, 17],
        [-7, 2],
        [-22, -5],
        [-6, -9],
        [-5, -11],
        [-5, -11],
        [-14, -8],
        [-16, -6],
        [-14, -9],
        [-12, -13],
        [-7, -15],
        [-2, -17],
        [-4, -19],
        [-12, -19],
        [-18, -16],
        [-17, -10],
        [-12, -8],
        [-16, -17],
        [-10, -12],
        [-3, -10],
        [-16, -11],
        [-16, -3],
        [-19, -2],
        [-13, -12],
        [-11, -18],
        [9, -31],
        [13, -25],
        [9, -16],
        [5, -20],
        [-5, -7],
        [-4, -4],
        [-8, -5],
        [-16, 1],
        [-23, -3],
        [-15, -14],
        [-15, -17],
        [-4, -21],
        [10, -9],
        [26, -5],
        [17, -1],
        [21, -2],
        [19, -7],
        [14, -11],
        [2, -7],
        [0, -8],
        [-8, -6],
        [-11, -8],
        [-24, -14],
        [-19, -4],
        [-19, -5],
        [-20, -3],
        [-31, -5],
        [-40, 1],
        [-44, -7],
        [-10, -6],
        [-10, -19],
        [-3, -22],
        [21, -4],
        [11, 2],
        [14, -2],
        [13, -2],
        [17, -13],
        [4, -12],
        [1, -12],
        [-8, -47],
        [2, -40],
        [11, -16],
        [1, -36],
        [-1, -32],
        [-3, -23],
        [-4, -24],
        [-7, -30],
        [-19, -27],
        [-15, -9],
        [-23, -8],
        [-31, 2],
        [-28, 4],
        [-22, 7],
        [-14, 6],
        [-16, 21],
        [0, 20],
        [12, 31],
        [10, 18],
        [4, 20],
        [3, 20],
        [0, 16],
        [0, 17],
        [-3, 20],
        [-14, 6],
        [-24, -6],
        [-22, -15],
        [-15, -12],
        [-25, -16],
        [-27, -20],
        [-22, -20],
        [-24, -26],
        [-9, -29],
        [-4, -41],
        [2, -33],
        [2, -46],
        [5, -44],
        [6, -47],
        [28, -70],
        [14, -27],
        [21, -24],
        [16, -20],
        [9, -14],
        [5, -14],
        [3, -12],
        [-6, -11],
        [-9, -8],
        [-14, -1],
        [-31, 4],
        [-36, 15],
        [-25, 9],
        [-29, 14],
        [-9, 4],
        [-20, 8],
        [-12, 2],
        [-8, 2],
        [-20, -2],
        [-20, -8],
        [-23, -20],
        [-15, -6],
        [-9, -4],
        [-8, -3],
        [-11, -5],
        [-19, -7],
        [-21, -7],
        [-17, -5],
        [-24, -5],
        [-18, -4],
        [-24, 0],
        [-20, -7],
        [-35, -16],
        [-16, -19],
        [-11, -15],
        [-22, -28],
        [-14, -20],
        [4, -21],
        [12, -20],
        [6, -11],
        [13, -7],
        [14, -1],
        [11, -1],
        [15, 2],
        [16, 0],
        [11, 0],
        [9, -5],
        [5, -1],
        [3, -4],
        [2, -7],
        [-2, -10],
        [-1, -14],
        [-6, -15],
        [-5, -13],
        [-4, -14],
        [-4, -19],
        [-10, -29],
        [-18, -33],
        [-8, -12],
        [-16, 0],
        [-31, 6],
        [-18, -8],
        [-33, -12],
        [-37, -2],
        [-23, 4],
        [-11, 14],
        [-20, 20],
        [-28, 19],
        [-28, 22],
        [-20, 12],
        [-20, -2],
        [-12, -10],
        [-5, -16],
        [-8, -27],
        [-6, -26],
        [5, -28],
        [11, -23],
        [1, -19],
        [0, -8],
        [-3, -9],
        [-7, -11],
        [-13, -4],
        [-16, -12],
        [-5, -22],
        [-4, -17],
        [-6, -12],
        [-11, -13],
        [-14, -14],
        [-8, -13],
        [-2, -7],
        [4, -10],
        [27, -9],
        [27, -12],
        [18, -15],
        [21, -19],
        [14, -20],
        [21, -17],
        [10, -14],
        [7, -21],
        [0, -8],
        [-2, -5],
        [-7, -4],
        [-16, -1],
        [-11, -1],
        [-20, 5],
        [-20, 10],
        [-15, 17],
        [-17, 13],
        [-29, 23],
        [-25, 7],
        [-10, -8],
        [1, -63],
        [5, -53],
        [1, -32],
        [8, -45],
        [2, -37],
        [4, -29],
        [4, -42],
        [0, -35],
        [-2, -11],
        [-6, -14],
        [-13, -12],
        [-11, -11],
        [-17, -3],
        [-24, -5],
        [-21, -3],
        [-14, -19],
        [-10, -22],
        [-16, -16],
        [-25, -13],
        [-19, -9],
        [-13, -4],
        [-21, 0],
        [-22, 4],
        [-24, 11],
        [-28, 11],
        [-12, -7],
        [-19, -10],
        [-12, -10],
        [-12, -11],
        [-7, -9],
        [-9, -10],
        [-12, -22],
        [-11, -33],
        [-2, -30],
        [1, -29],
        [3, -2],
        [21, -19],
        [28, -24],
        [20, -16],
        [2, -14],
        [-2, -14],
        [-6, -8],
        [-30, -5],
        [-27, 7],
        [-13, 2],
        [-22, 12],
        [-22, 24],
        [-17, 20],
        [-23, 15],
        [-28, 22],
        [-15, 15],
        [-20, 14],
        [-13, 7],
        [-20, 7],
        [-11, -5],
        [-8, -13],
        [-8, -12],
        [-9, -15],
        [-7, -16],
        [0, -7],
        [-2, -6],
        [-6, -8],
        [-10, -14],
        [-17, -14],
        [-13, -4],
        [-24, -6],
        [-16, -8],
        [-14, -6],
        [-19, -9],
        [-11, -8],
        [-12, -12],
        [-2, -13],
        [10, -19],
        [11, -9],
        [10, -7],
        [15, 0],
        [12, 1],
        [8, -4],
        [10, -5],
        [3, -3],
        [1, -3],
        [-3, -9],
        [-3, -8],
        [-16, -11],
        [-23, -16],
        [-43, -23],
        [-61, -25],
        [-46, -22],
        [-35, -4],
        [-30, -5],
        [-21, 11],
        [-16, 13],
        [-3, 13],
        [-2, 10],
        [-10, 10],
        [-19, 2],
        [-18, -4],
        [-14, -12],
        [-12, -12],
        [-10, -13],
        [-14, -12],
        [-16, -4],
        [-15, 9],
        [-14, 36],
        [2, 26],
        [-1, 29],
        [-4, 29],
        [-13, 19],
        [-14, 17],
        [-21, 6],
        [-19, 5],
        [-18, -1],
        [-26, -7],
        [-19, -11],
        [-23, -11],
        [-21, -13],
        [-16, -11],
        [-11, -11],
        [-12, -10],
        [-10, -8],
        [-22, -26],
        [-28, -33],
        [-20, -24],
        [-13, -11],
        [-25, 1],
        [-27, 16],
        [-23, 16],
        [-10, 15],
        [-6, 22],
        [0, 26],
        [5, 19],
        [0, 18],
        [-4, 16],
        [-4, 13],
        [-5, 14],
        [-16, 8],
        [-21, 4],
        [-22, -12],
        [-19, -7],
        [-25, -13],
        [-16, -6],
        [-14, -7],
        [-17, -9],
        [-12, -10],
        [-9, -8],
        [-15, -1],
        [-10, 12],
        [-6, 17],
        [-1, 22],
        [-3, 20],
        [3, 39],
        [3, 26],
        [-13, 14],
        [-8, 15],
        [-8, 5],
        [-19, 8],
        [-16, 3],
        [-19, 1],
        [-20, -16],
        [-9, -11],
        [-8, -21],
        [-7, -12],
        [-6, -10],
        [-16, -12],
        [-18, -17],
        [-16, -8],
        [-10, -8],
        [-12, -5],
        [-17, -9],
        [-9, -6],
        [-8, -5],
        [-10, -3],
        [-10, -5],
        [-13, -2],
        [0, 2],
        [-11, 7],
        [-10, 10],
        [-2, 1],
        [-24, 14],
        [-28, 7],
        [-18, -6],
        [-20, -11],
        [-15, -13],
        [-32, -21],
        [-18, -17],
        [-20, -11],
        [-10, -15],
        [-12, -18],
        [-12, -10],
        [-20, -1],
        [-27, 7],
        [-27, 6],
        [-17, 8],
        [-16, 10],
        [-19, 17],
        [-21, 30],
        [-28, 30],
        [-26, 48],
        [-15, 28],
        [-13, 23],
        [-10, 6],
        [-14, 7],
        [-10, 3],
        [-14, 1],
        [-19, -3],
        [-15, -6],
        [-23, -8],
        [-23, 1],
        [-23, 2],
        [-33, 6],
        [-17, 27],
        [-24, 30],
        [-16, 35],
        [-14, 50],
        [-5, 52],
        [-4, 40],
        [4, 25],
        [5, 32],
        [0, 27],
        [3, 27],
        [16, 34],
        [20, 29],
        [28, 8],
        [26, 17],
        [27, 13],
        [16, 16],
        [12, 17],
        [4, 11],
        [-6, 18],
        [-19, 26],
        [-42, 62],
        [-32, 39],
        [-30, 30],
        [-30, 22],
        [-22, 8],
        [-25, 4],
        [-25, -4],
        [-27, -8],
        [-18, -2],
        [-22, -10],
        [-18, -14],
        [-14, -6],
        [-24, -4],
        [-26, 32],
        [-24, 28],
        [-19, 5],
        [-17, -2],
        [-15, -7],
        [-14, -10],
        [-16, -16],
        [-12, -10],
        [-18, -8],
        [-21, -10],
        [-17, -3],
        [-20, -2],
        [-29, 10],
        [-40, 23],
        [-31, 15],
        [-45, 11],
        [-29, 13],
        [-24, 3],
        [-25, -2],
        [-12, -13],
        [-10, -15],
        [-12, -16],
        [-18, -18],
        [-44, 4],
        [-36, 4],
        [-36, 2],
        [-41, 20],
        [-29, 14],
        [-30, 5],
        [-29, 5],
        [-46, 15],
        [-23, 20],
        [-38, 30],
        [-44, 31],
        [-32, 21],
        [-31, 20],
        [-25, 10],
        [-15, -2],
        [-2, -20],
        [-15, -29],
        [-16, -29],
        [-10, -21],
        [-12, -13],
        [-26, -14],
        [-20, -7],
        [-28, 2],
        [-17, 28],
        [-11, 27],
        [-19, 31],
        [-15, 25],
        [-27, 48],
        [-19, 31],
        [-21, 28],
        [-20, 30],
        [-24, 43],
        [-21, 54],
        [-8, 41],
        [-8, 42],
        [-4, 33],
        [-8, 36],
        [-12, 38],
        [-22, 39],
        [-38, 54],
        [-36, 36],
        [-36, -4],
        [-32, 2],
        [-49, 0],
        [-77, 14],
        [-36, 16],
        [-28, 32],
        [-10, 36],
        [8, 35],
        [28, 36],
        [6, 13],
        [5, 19],
        [1, 21],
        [-4, 19],
        [-10, 27],
        [-20, 41],
        [-32, 38],
        [-26, 10],
        [-33, -2],
        [-49, 2],
        [-26, 1],
        [-25, 4],
        [-35, 19],
        [-20, 24],
        [-26, 34],
        [-26, 45],
        [-12, 22],
        [-13, 20],
        [-18, 30],
        [-18, 24],
        [-27, 33],
        [-37, 9],
        [-45, 1],
        [-56, -24],
        [-38, -15],
        [-39, -14],
        [-33, 12],
        [-18, 19],
        [6, 39],
        [1, 28],
        [-6, 26],
        [-25, 52],
        [-39, 87],
        [-29, 43],
        [-33, 11],
        [-45, -2],
        [-71, -8],
        [-45, 5],
        [-41, 22],
        [-34, 48],
        [-17, 29],
        [-29, 41],
        [-12, 6],
        [-3, 0],
        [-24, -10],
        [-25, -16],
        [-31, -27],
        [-37, -30],
        [-58, -16],
        [-37, -1],
        [-27, 13],
        [-105, 46],
        [-46, 23],
        [-41, 24],
        [-25, 19],
        [-15, 6],
        [-8, -8],
        [-18, -16],
        [-18, -13],
        [-21, -16],
        [-23, -23],
        [-8, -16],
        [-10, -26],
        [-5, -24],
        [4, -27],
        [-6, -18],
        [-6, -7],
        [-11, -10],
        [-39, 12],
        [-1017, 2589],
        [-7, 14],
        [-17, 36],
        [-417, 221],
        [-1003, 532],
        [-196, 102],
        [-2, 1],
        [-8, 5],
        [-36, 19],
        [-10, 5],
        [-220, 116],
        [-1676, 267],
        [-87, 13],
        [-153, 25],
        [-66, 11],
        [-71, 10],
        [-73, 12],
        [-72, 13],
        [-247, 4],
        [-103, 7],
        [-272, 22],
        [-281, 22],
        [-327, -310],
        [-327, -310],
        [-381, 14],
        [-343, 13],
        [-332, 14],
        [-1481, 57],
        [-6, 0],
        [-172, 7],
        [-520, -1530],
        [186, -264],
        [-34, -22],
        [-135, -246],
        [136, -645],
        [29, -145],
        [54, -255],
        [135, -419],
        [303, -935],
        [-2164, -232],
        [-901, -114],
        [-244, -31],
        [-60, -2],
        [-297, -30],
        [-304, -32],
        [-896, -97],
        [-38, -409],
        [-63, -667],
        [-10, -99],
        [-6, -51],
        [-98, -955],
        [-65, -641],
        [-16, -152],
        [-51, -503],
        [-8, -77],
        [-45, -447],
        [-36, -333],
        [-2, -32],
        [-18, -81],
        [-26, -125],
        [-54, -260],
        [-18, -86],
        [-116, -627],
        [-6, -30],
        [-44, -215],
        [-9, -60],
        [-27, -153],
        [-13, -75],
        [-9, -46],
        [-24, -122],
        [-32, -177],
        [-23, -139],
        [-8, -37],
        [-61, -337],
        [-12, -65],
        [-15, -65],
        [-53, -275],
        [-22, -122],
        [-15, -74],
        [-7, -39],
        [-26, -97],
        [-9, -85],
        [-103, -809],
        [-11, -85],
        [-35, -281],
        [-51, -407],
        [-1, -8],
        [-9, -177],
      ],
      [
        [159688, 95428],
        [19, 13],
        [55, 6],
        [184, 26],
        [609, 78],
        [53, 4],
        [34, 3],
        [199, 28],
        [455, 64],
        [472, 61],
        [226, 32],
        [85, 12],
        [83, 13],
        [89, 9],
        [92, 12],
        [46, 3],
        [47, 4],
        [94, 7],
        [108, 17],
        [59, 11],
        [63, 8],
        [113, 15],
        [103, 14],
        [121, 18],
        [181, 22],
        [100, 13],
        [99, 14],
        [231, 32],
        [221, 29],
        [179, 21],
        [170, 22],
        [255, 32],
        [253, 33],
        [239, 33],
        [174, 20],
        [258, 32],
        [471, 60],
        [104, 14],
        [244, 33],
        [286, 38],
        [4, 0],
        [266, 35],
        [10, 2],
        [261, 36],
        [120, 17],
        [38, 229],
        [29, 165],
        [15, 85],
        [49, 280],
        [-50, 15],
        [-37, 12],
        [-77, 41],
        [-7, 2],
        [-1, -3],
        [-130, 61],
        [-6, 4],
        [53, 315],
        [19, 115],
        [22, 124],
        [245, 1486],
        [353, 83],
        [-3, 23],
        [-58, 286],
        [-75, 411],
        [-107, 542],
        [129, 111],
        [382, 334],
        [138, 119],
        [5, 5],
        [222, 193],
        [5, 4],
        [221, 191],
        [146, 128],
        [263, 227],
        [385, 334],
        [333, 290],
        [286, 247],
        [549, 476],
        [32, 29],
        [94, 121],
        [117, 185],
        [25, 42],
        [4, 6],
        [42, 79],
        [6, 10],
        [11, 18],
        [167, 276],
        [68, 114],
        [41, 91],
        [25, 55],
        [329, 738],
        [-11, 34],
        [-21, 72],
        [-1, 1],
        [-54, 175],
        [-1144, 1692],
        [-379, 82],
        [-183, -165],
        [-3, -2],
        [-206, -185],
        [-15, -15],
        [-7, 10],
        [-35, 43],
        [-22, 23],
        [-12, 22],
        [-23, 47],
        [-31, 85],
        [-59, 177],
        [-58, 155],
        [-57, 166],
        [-26, 66],
        [-15, 47],
        [-13, 34],
        [-29, 40],
        [-38, 27],
        [-39, 15],
        [-47, 6],
        [-48, -5],
        [-110, -17],
        [-6, 36],
        [-2, 18],
        [1, 11],
        [0, 12],
        [0, 8],
        [0, 10],
        [-4, 16],
        [-5, 15],
        [-8, 11],
        [-6, 4],
        [-4, 5],
        [-6, 3],
        [-4, 3],
        [-5, 4],
        [-17, 11],
        [-10, 13],
        [-3, 22],
        [2, 24],
        [3, 18],
        [0, 14],
        [0, 20],
        [2, 14],
        [4, 23],
        [7, 12],
        [4, 15],
        [8, 12],
        [11, 7],
        [12, 11],
        [6, 12],
        [12, 13],
        [9, 14],
        [3, 10],
        [9, 8],
        [11, 10],
        [21, 20],
        [13, 13],
        [16, 11],
        [18, 2],
        [14, -2],
        [19, -7],
        [24, -7],
        [15, -2],
        [10, -2],
        [27, -14],
        [25, -7],
        [28, -5],
        [6, -3],
        [5, -9],
        [8, -16],
        [22, -20],
        [24, -18],
        [21, -16],
        [17, -17],
        [16, -14],
        [14, -22],
        [9, -22],
        [10, -14],
        [10, -8],
        [8, -8],
        [3, -12],
        [-2, -8],
        [-7, -17],
        [2, -35],
        [8, -15],
        [8, -25],
        [7, -19],
        [7, -18],
        [8, -14],
        [9, -13],
        [17, -12],
        [22, -13],
        [35, -20],
        [20, -10],
        [16, -17],
        [6, -7],
        [0, -11],
        [-4, -8],
        [-8, -8],
        [-4, -6],
        [2, -10],
        [9, -13],
        [15, -20],
        [20, -12],
        [30, 6],
        [24, 9],
        [28, 13],
        [27, 8],
        [18, 8],
        [16, 10],
        [24, 19],
        [15, 13],
        [22, 18],
        [24, 9],
        [14, 7],
        [18, 9],
        [17, 16],
        [7, 15],
        [4, 7],
        [-2, 7],
        [-1, 7],
        [-1, 11],
        [5, 12],
        [17, 6],
        [48, 11],
        [42, 5],
        [45, -3],
        [38, -11],
        [13, -2],
        [9, -12],
        [11, -21],
        [20, -23],
        [24, -32],
        [25, -17],
        [25, -2],
        [16, 9],
        [13, 24],
        [28, 12],
        [34, 4],
        [49, 15],
        [25, 16],
        [33, 38],
        [9, 47],
        [3, 45],
        [12, 36],
        [-4, 57],
        [-8, 108],
        [30, 112],
        [24, 159],
        [7, 48],
        [-9, 36],
        [-6, 61],
        [16, 46],
        [17, 36],
        [-23, 73],
        [-2, 79],
        [20, 48],
        [12, 64],
        [9, 63],
        [6, 26],
        [5, 36],
        [9, 46],
        [4, 47],
        [10, 45],
        [19, 85],
        [8, 72],
        [0, 127],
        [-4, 48],
        [8, 31],
        [29, 19],
        [12, 94],
        [30, 83],
        [8, 80],
        [9, 99],
        [10, 28],
        [26, 32],
        [11, 24],
        [-5, 16],
        [-2, 25],
        [1, 9],
        [15, 10],
        [0, 67],
        [14, 50],
        [10, 15],
        [25, 64],
        [2, 30],
        [-10, 10],
        [0, 10],
        [18, 11],
        [35, 41],
        [22, 24],
        [20, 39],
        [18, 12],
        [31, 24],
        [4, 13],
        [55, 122],
        [10, 94],
        [21, 70],
        [-37, 30],
        [-14, 61],
        [22, 53],
        [41, 29],
        [45, 192],
        [-6, 73],
        [48, 123],
        [73, 98],
        [40, -2],
        [47, 35],
        [45, 105],
        [73, 60],
        [0, 38],
        [10, 44],
        [-8, 14],
        [-87, 62],
        [-60, 51],
        [-50, 44],
        [-10, 43],
        [-41, 69],
        [-36, 22],
        [-5, 32],
        [15, 31],
        [6, 92],
        [40, 97],
        [19, 50],
        [14, 54],
        [12, 75],
        [25, 34],
        [3, 57],
        [67, 20],
        [52, 28],
        [30, 10],
        [23, -4],
        [70, -16],
        [18, -2],
        [15, -12],
        [45, -2],
        [128, 53],
        [233, 241],
        [54, 39],
        [18, 31],
        [10, 84],
        [113, 201],
        [58, 56],
        [166, 113],
        [193, 63],
        [123, 189],
        [2, 39],
        [12, 28],
        [5, 54],
        [-16, 71],
        [-46, 86],
        [-60, 60],
        [-64, 50],
        [-7, 45],
        [-51, 91],
        [-24, 67],
        [-18, 143],
        [36, 46],
        [57, 39],
        [97, 5],
        [83, 47],
        [17, 49],
        [15, 36],
        [2, 49],
        [20, 43],
        [7, 45],
        [33, 90],
        [-20, 41],
        [-12, 85],
        [2, 74],
        [-10, 65],
        [14, 54],
        [-22, 72],
        [7, 43],
        [-50, 56],
        [-29, 19],
        [-35, 52],
        [-41, 124],
        [-35, 169],
        [-16, 40],
        [-19, 71],
        [-64, 197],
        [-100, 129],
        [-72, 20],
        [-8, 28],
        [4, 13],
        [-66, 48],
        [-64, 32],
        [-149, 46],
        [-78, 27],
        [-22, 25],
        [-7, 23],
        [-129, 64],
        [-120, 41],
        [-92, 25],
        [-61, 4],
        [-32, 21],
        [-87, 260],
        [-29, 159],
        [-64, 63],
        [-178, 254],
        [3, 32],
        [54, 107],
        [20, 62],
        [37, 41],
        [22, 66],
        [32, 74],
        [14, 97],
        [-17, 59],
        [7, 124],
        [-20, 60],
        [11, 21],
        [-10, 132],
        [-41, 119],
        [-34, 30],
        [-46, 18],
        [-16, 23],
        [-14, 16],
        [-57, 58],
        [-24, 38],
        [-218, 46],
        [-197, 32],
        [-277, 44],
        [-164, -29],
        [61, 214],
        [-83, 96],
        [32, 120],
        [-46, 78],
        [130, 0],
        [39, -94],
        [178, -42],
        [40, 41],
        [-113, 124],
        [-6, 99],
        [185, 57],
        [20, 2],
        [52, -90],
        [42, -31],
        [254, 64],
        [131, 30],
        [119, 8],
        [14, 26],
        [70, 41],
        [69, -50],
        [64, -15],
        [14, 11],
        [81, 97],
        [-87, 114],
        [11, 10],
        [-5, 21],
        [50, 28],
        [39, 43],
        [26, 19],
        [40, 21],
        [45, -4],
        [35, -7],
        [21, 21],
        [-2, 14],
        [31, 40],
        [47, 12],
        [53, -59],
        [16, -1],
        [2, 31],
        [14, 36],
        [13, 44],
        [8, 30],
        [52, -20],
        [40, -42],
        [35, -23],
        [17, -52],
        [22, -34],
        [28, -3],
        [29, -45],
        [34, -14],
        [-41, 137],
        [23, 44],
        [20, 12],
        [31, 2],
        [-3, 22],
        [-28, 20],
        [-39, 2],
        [-2, 53],
        [-50, 28],
        [-22, 60],
        [-42, 34],
        [-50, 10],
        [-8, 13],
        [-54, 67],
        [52, 39],
        [77, 101],
        [31, 45],
        [33, 19],
        [54, 11],
        [197, -93],
        [283, -503],
        [201, -70],
        [306, 33],
        [122, 123],
        [46, 133],
        [-69, 86],
        [-361, 273],
        [-99, 199],
        [-9, 188],
        [87, 111],
        [123, 44],
        [29, 20],
        [52, 4],
        [91, 37],
        [9, 17],
        [-13, 24],
        [-8, 38],
        [46, 57],
        [3, 42],
        [18, 27],
        [36, 38],
        [74, 42],
        [80, 71],
        [45, 14],
        [51, -18],
        [129, -116],
        [166, -131],
        [52, -17],
        [50, 2],
        [75, -22],
        [37, 39],
        [11, 59],
        [61, 66],
        [31, 84],
        [43, 68],
        [-11, 36],
        [-32, 53],
        [-27, 14],
        [-107, 165],
        [-42, 144],
        [24, 89],
        [0, 31],
        [44, 27],
        [71, 2],
        [113, 44],
        [79, 55],
        [46, 55],
        [14, 44],
        [-40, 84],
        [-18, 87],
        [-31, 70],
        [-8, 45],
        [4, 10],
        [45, 50],
        [60, 35],
        [94, 21],
        [59, -16],
        [45, 0],
        [21, 13],
        [37, 48],
        [41, 32],
        [28, 14],
        [138, 211],
        [25, 77],
        [35, 104],
        [9, 48],
        [-5, 26],
        [-12, 46],
        [-13, 39],
        [-24, 48],
        [-5, 26],
        [9, 78],
        [20, 70],
        [-12, 62],
        [18, 53],
        [19, 24],
        [13, 4],
        [1, 19],
        [9, 10],
        [21, 19],
        [18, 16],
        [22, -8],
        [32, 4],
        [14, 20],
        [0, 24],
        [-5, 19],
        [-5, 19],
        [-23, 33],
        [-8, 54],
        [8, 42],
        [-5, 37],
        [-14, 21],
        [-80, 33],
        [-19, 20],
        [-12, 40],
        [-2, 19],
        [6, 13],
        [6, 11],
        [15, 20],
        [27, 8],
        [36, 7],
        [42, 8],
        [73, 20],
        [28, 16],
        [32, 21],
        [35, 4],
        [37, 13],
        [88, 21],
        [54, 0],
        [61, 19],
        [92, 74],
        [122, 29],
        [83, 51],
        [50, 9],
        [58, 49],
        [26, 43],
        [17, 48],
        [17, 30],
        [3, 17],
        [2, 12],
        [2, 12],
        [-4, 29],
        [-18, 35],
        [-18, 56],
        [-1, 45],
        [-13, 37],
        [-18, 39],
        [-22, 16],
        [-31, 5],
        [-64, -27],
        [-77, 14],
        [-45, 26],
        [-54, 74],
        [-3, 51],
        [17, 53],
        [1, 26],
        [40, 6],
        [35, -2],
        [98, 6],
        [38, 36],
        [31, 19],
        [26, 33],
        [8, 12],
      ],
      [
        [175515, 124941],
        [26, 35],
        [106, 107],
        [34, 66],
        [21, 56],
        [-10, 40],
        [-32, 30],
        [-39, 8],
        [-43, -2],
        [-37, -29],
        [-34, -17],
        [-23, -28],
        [-48, -11],
        [-86, 1],
        [-34, 6],
        [-22, 19],
        [-53, 23],
        [-30, 6],
        [-28, -7],
        [-13, 17],
        [-2, 28],
        [19, 62],
        [12, 21],
        [10, 31],
        [-8, 67],
        [2, 43],
        [-14, 25],
        [-80, 55],
        [-49, 66],
        [-8, 47],
        [18, 46],
        [27, 4],
        [22, -13],
        [22, -11],
        [16, 15],
        [-13, 102],
        [29, 42],
        [66, 4],
        [25, 47],
        [-3, 64],
        [3, 34],
        [21, 19],
        [64, 13],
        [49, 19],
        [64, 41],
        [65, 14],
        [22, 31],
        [-8, 49],
        [-34, 74],
        [-10, 31],
        [21, 33],
        [62, 28],
        [38, 2],
        [53, -14],
        [33, -33],
        [55, -7],
        [34, -21],
        [31, -8],
        [25, 17],
        [45, 14],
        [24, 12],
        [70, -11],
        [27, -26],
        [14, -29],
        [21, -6],
        [16, 2],
        [28, -6],
        [49, -24],
        [31, 8],
        [33, -23],
        [21, -4],
        [31, 5],
        [36, -9],
        [43, -44],
        [53, -69],
        [63, -46],
        [94, -36],
        [183, -14],
        [76, -44],
        [113, -35],
        [108, -72],
        [58, -38],
        [31, 0],
        [32, 10],
        [201, 4],
        [78, -14],
        [71, -31],
        [80, -27],
        [34, -12],
        [86, -125],
        [106, -84],
        [89, -33],
        [74, -8],
        [76, 20],
        [204, 76],
        [33, -2],
        [18, -10],
        [38, -127],
        [18, -22],
        [32, 4],
        [48, 50],
        [59, 52],
        [82, 52],
        [54, 21],
        [187, 26],
        [32, -5],
        [36, -24],
        [9, -46],
        [8, -93],
        [-8, -45],
        [18, -15],
        [57, -14],
        [58, -45],
        [21, -14],
        [18, 3],
        [10, 13],
        [-6, 49],
        [-26, 45],
        [-10, 25],
        [2, 27],
        [16, 14],
        [41, 15],
        [59, -4],
        [25, -17],
        [22, -46],
        [15, 3],
        [18, 39],
        [7, 24],
        [35, 8],
        [43, 1],
        [65, -30],
        [33, -32],
        [5, -31],
        [30, -16],
        [54, -2],
        [54, 6],
        [86, 53],
        [56, 4],
        [91, -61],
        [27, -11],
        [36, 9],
        [19, 8],
        [16, 14],
        [2, 20],
        [-27, 69],
        [-5, 23],
        [24, 19],
        [62, 2],
        [25, 45],
        [28, 12],
        [36, 1],
        [22, 28],
        [28, 43],
        [57, -16],
        [65, -63],
        [28, -1],
        [52, 11],
        [36, -13],
        [41, -36],
        [38, -46],
        [36, -66],
        [-9, -24],
        [-5, -34],
        [13, -15],
        [19, -6],
        [19, 0],
        [21, 16],
        [22, 45],
        [26, 52],
        [9, 29],
        [-19, 34],
        [-5, 49],
        [28, 21],
        [40, 5],
        [80, -27],
        [75, -16],
        [28, -26],
        [19, -38],
        [32, -27],
        [37, -4],
        [45, 4],
        [31, -17],
        [43, -14],
        [29, 6],
        [38, 19],
        [17, 26],
        [9, 32],
        [34, 48],
        [21, 61],
        [20, 41],
        [43, 0],
        [27, -18],
        [8, -49],
        [-6, -83],
        [31, -44],
        [38, -30],
        [40, -17],
        [29, -37],
        [29, -16],
        [25, 6],
        [18, 24],
        [18, 56],
        [6, 42],
        [11, 55],
        [36, 32],
        [32, 9],
        [20, 2],
        [18, 30],
        [13, 22],
        [1, 52],
        [14, 29],
        [20, 7],
        [51, -16],
        [60, -14],
        [38, 10],
        [23, 8],
        [17, 14],
        [8, 23],
        [-3, 24],
        [-11, 12],
        [-29, 8],
        [-33, 0],
        [-23, 14],
        [-24, 38],
        [7, 36],
        [21, 31],
        [21, 46],
        [31, 7],
        [36, -9],
        [101, -26],
        [29, -6],
        [22, 4],
        [23, 44],
        [31, 27],
        [36, 13],
        [28, -9],
        [22, -4],
        [17, 23],
        [-2, 38],
        [7, 24],
        [27, 11],
        [104, -20],
        [26, 19],
        [12, 27],
        [9, 25],
        [22, 10],
        [36, -10],
        [42, -38],
        [44, 41],
        [2, 19],
        [-10, 24],
        [5, 45],
        [72, 62],
        [71, 28],
        [40, 8],
        [61, -34],
        [31, -18],
        [60, -6],
        [45, -5],
        [11, 17],
        [-5, 29],
        [-32, 17],
        [-13, 24],
        [-4, 12],
        [10, 2],
        [15, -4],
        [12, 0],
        [17, -10],
        [9, -10],
        [12, -8],
        [11, -16],
        [47, -17],
        [24, 1],
        [18, 9],
        [12, 17],
        [-2, 32],
        [9, 67],
        [1365, -129],
        [-40, 2036],
        [56, 78],
        [-2809, 1413],
      ],
      [
        [141979, 194562],
        [12, -20],
        [-1301, -38],
        [-2161, 1182],
        [-4432, 0],
        [1247, -3062],
        [1336, -5146],
        [-1862, 328],
        [-3, 0],
        [-3329, 584],
        [-212, -92],
        [-214, -93],
        [413, 367],
        [413, 368],
        [-778, 1325],
        [-436, 1308],
        [-920, -32],
        [-1464, -123],
        [-1037, -998],
        [729, -715],
        [-149, -251],
        [821, -661],
        [669, 49],
        [-370, -506],
        [804, -61],
        [407, 494],
        [85, 103],
        [-273, -725],
        [-2, -4],
        [-340, -227],
        [-76, -1027],
        [368, -1216],
        [955, -765],
        [93, -51],
        [-112, -124],
        [77, 6],
        [54, -91],
        [-36, -32],
        [-57, 45],
        [-38, -24],
        [-32, -201],
        [-100, -197],
        [16, -150],
        [70, -64],
        [-33, -59],
        [-23, 58],
        [-34, 16],
        [-120, -2],
        [-53, -33],
        [-18, -146],
        [67, -48],
        [18, -74],
        [-10, -73],
        [-63, -20],
        [10, 126],
        [-91, 28],
        [-53, 55],
        [-250, -35],
        [100, -99],
        [-176, 22],
        [-2, -169],
        [-138, -143],
        [-29, -24],
        [-104, 322],
        [2, 66],
        [-31, 17],
        [-71, -154],
        [-38, 120],
        [38, 60],
        [5, 112],
        [-47, -5],
        [-46, -4],
        [-55, -25],
        [-57, -26],
        [22, 58],
        [83, 84],
        [-93, 115],
        [-60, -167],
        [-46, 171],
        [-59, -125],
        [50, -25],
        [-38, -45],
        [-41, 30],
        [-57, 103],
        [-131, -50],
        [52, -79],
        [-24, -39],
        [15, -70],
        [-13, -9],
        [-12, -10],
        [0, 0],
        [77, -154],
        [-75, -6],
        [-40, 51],
        [-20, 8],
        [-22, -25],
        [-36, -1974],
        [-1543, 668],
        [-1505, 474],
        [-255, 303],
        [-1268, 610],
        [-14, 8],
        [-192, 126],
        [-192, 126],
        [-6, 4],
        [-4, 3],
        [-49, 33],
        [-119, 102],
        [-2, 2],
        [-102, 88],
        [-403, 251],
        [-58, 46],
        [-10, 6],
        [-10, 23],
        [-35, 70],
        [-5, 10],
        [-143, 283],
        [-20, 40],
        [-101, 51],
        [-10, 5],
        [-30, 16],
        [-109, 55],
        [-126, 62],
        [-6, 3],
        [-207, 105],
        [-60, 30],
        [-162, 82],
        [-3, 0],
        [-20, 10],
        [-205, -44],
        [-115, -24],
        [-1222, 30],
        [-1816, -80],
        [-204, -10],
        [-18, 0],
      ],
      [
        [118695, 185297],
        [179, 219],
        [540, 807],
        [81, 217],
        [-572, 1286],
        [-100, 229],
        [-245, 331],
        [-716, 971],
        [-14, 787],
        [-627, 1076],
        [-450, 448],
        [-565, 6],
        [-360, -69],
        [-580, -110],
        [-438, 328],
        [-364, 247],
        [-270, 184],
        [-190, 134],
        [-176, 123],
        [-294, -59],
        [-238, -302],
        [-320, -33],
        [-247, -30],
        [-413, -47],
        [-4, 0],
        [-1, 0],
        [-2, -1],
        [-3, 0],
        [-4, -1],
        [-2, 0],
        [-21, -1],
        [-4, -1],
        [-36, -4],
        [12, -70],
        [10, -22],
        [10, -65],
        [6, -82],
        [-5, -62],
        [-11, -41],
        [-12, -43],
        [-43, -26],
        [-46, -9],
        [-161, 7],
        [-123, 23],
        [-77, 24],
        [-3, 28],
        [-6, 0],
        [-3, 0],
        [-15, 0],
        [-3, 0],
        [-3, 0],
        [-8, 0],
        [-2, -4],
        [-3, -4],
        [-2, -4],
        [-6, -10],
        [-12, -21],
        [-14, -15],
        [-10, -12],
        [-6, -1],
        [-3, -1],
        [-2, -1],
        [-10, -3],
        [-17, -3],
        [-1, 0],
        [-14, -2],
        [-179, -29],
        [-134, -21],
        [-119, -20],
        [-27, 20],
        [-158, -16],
        [-24, 64],
        [-86, -66],
        [-165, -117],
        [-35, -52],
        [-20, -36],
        [22, -132],
        [-26, -9],
        [-39, 2],
        [-54, 29],
        [-37, 22],
        [-36, 6],
        [-57, 19],
        [-40, 25],
        [-19, 29],
        [-8, 26],
        [-41, 0],
        [-145, 60],
        [-3, 4],
        [-1, 11],
        [3, 3],
        [-9, 8],
        [-50, 45],
        [-13, 10],
        [-21, 11],
        [-38, 46],
        [-37, 47],
        [-10, 17],
        [-17, 24],
        [-14, 5],
        [-55, 14],
        [-34, 8],
        [-56, 16],
        [-26, 16],
        [-43, 19],
        [-16, 3],
        [-62, 5],
        [-35, 17],
        [-23, 11],
        [-28, 32],
        [-8, 13],
        [-13, 7],
        [-30, 12],
        [-21, 6],
        [-1, -14],
        [-5, -5],
        [-103, -19],
        [-10, -55],
        [-2, -4],
        [0, -50],
        [4, -54],
        [-63, -83],
        [-26, -20],
        [-16, -12],
        [-12, -4],
        [-157, -6],
        [-41, 183],
        [-91, 34],
        [-54, 65],
        [-78, 99],
        [-104, 33],
        [-459, 650],
        [138, 645],
        [-67, 56],
        [-68, 52],
        [-12, 10],
        [-54, 74],
        [-10, 16],
        [-12, -4],
        [-121, -30],
        [-60, -15],
        [-11, 21],
        [-8, 32],
        [-4, 18],
        [-36, 2],
        [-63, 22],
        [166, 171],
        [-38, 32],
        [-82, 35],
        [-24, 68],
        [-28, 59],
        [-38, 29],
        [1, 43],
        [-33, 11],
        [-20, 86],
        [-11, 46],
        [-10, 51],
        [-39, 38],
        [-8, 20],
        [-54, 33],
        [-104, -30],
        [-7, 10],
        [-138, 197],
        [59, 16],
        [20, 6],
        [-32, 107],
        [-124, 46],
        [-41, 90],
        [-6, 20],
        [-52, 79],
        [-210, 406],
        [-9, 284],
        [-1184, -77],
        [-2, 0],
        [-18, -1],
        [-2, -1],
        [-4, 0],
        [-2, 0],
        [-10, -1],
        [-2, 0],
        [-2, 0],
        [-10, -1],
        [-3, 0],
        [-1, 0],
        [-7, -1],
        [-2, 0],
        [-3, 0],
        [-7, 0],
        [-28, -2],
        [-2, 0],
        [-3, 0],
        [-8, -1],
        [-2, 0],
        [-4, -1],
        [-8, 0],
        [-2, 0],
        [-30, -2],
        [-6, 0],
        [-313, -21],
        [-197, -14],
        [-205, 127],
        [-47, 984],
        [11, 1399],
        [-702, -799],
        [-8, 79],
        [-23, 43],
        [-43, 24],
        [39, 135],
        [-10, 32],
        [19, 114],
        [-25, 62],
        [15, 11],
        [44, 33],
        [4, 69],
        [94, 108],
        [68, 49],
        [37, 32],
        [1, 8],
        [2, 24],
        [-1, 8],
        [1, 68],
        [-9, 6],
        [16, 37],
        [-32, 38],
        [-56, 39],
        [-44, -4],
        [-24, -75],
        [-22, -24],
        [-16, 23],
        [-13, 4],
        [-61, -14],
        [-21, 19],
        [-19, 13],
        [-119, -10],
        [-3, -19],
        [16, -25],
        [6, -38],
        [45, -54],
        [-31, -20],
        [7, 18],
        [-25, 53],
        [-21, 33],
        [-52, -18],
        [-10, -5],
        [-14, -17],
        [18, -36],
        [43, -37],
        [-24, -3],
        [-11, -42],
        [31, -28],
        [10, -23],
        [-59, -28],
        [-4, -6],
        [-2, -14],
        [15, -19],
        [11, -1],
        [-10, -65],
        [-42, -14],
        [-52, -36],
        [-20, -42],
        [-25, -7],
        [-13, 15],
        [-7, 4],
        [-24, 2],
        [-22, -6],
        [-12, -17],
        [-90, -1],
        [-10, 5],
        [-20, 2],
        [-22, -10],
        [4, -28],
        [-86, -4],
        [-30, 8],
        [-83, -41],
        [-12, 12],
        [-17, -20],
        [-105, -12],
        [-43, -31],
        [-54, -51],
        [-116, -77],
        [-51, -52],
        [-27, -14],
        [-26, -7],
        [-31, 6],
        [-33, -14],
        [-29, -13],
        [-27, -8],
        [-35, -4],
        [-24, -4],
        [-39, 6],
        [-35, 6],
        [-46, 8],
        [-41, 6],
        [-51, -6],
        [-56, -10],
        [-71, -18],
        [-43, -10],
        [-61, 10],
        [-38, -2],
        [-63, -4],
        [-47, 14],
        [-74, 20],
        [-54, 16],
        [174, 220],
        [134, 167],
        [95, 119],
        [95, 120],
        [1, 2],
        [41, 59],
        [8, 2],
        [74, 94],
        [111, 136],
        [115, 145],
        [109, 133],
        [4, 4],
        [2, 3],
        [2, 2],
        [32, 44],
        [202, 260],
        [5, 4],
        [28, 34],
        [50, 61],
        [26, 38],
        [63, 92],
        [73, 102],
        [104, 152],
        [118, 119],
        [178, 228],
        [64, 85],
        [4, 7],
        [162, 211],
        [44, 68],
        [8, 6],
        [151, 192],
        [345, -306],
        [-60, 340],
        [42, 40],
        [146, -10],
        [94, 26],
        [95, 55],
        [24, 64],
        [11, 30],
        [-12, 38],
        [-31, 41],
        [-38, 45],
        [-18, 30],
        [3, 17],
        [10, 17],
        [25, 20],
        [75, 30],
        [28, 24],
        [11, 14],
        [-6, 28],
        [-17, 16],
        [-29, 29],
        [-28, 50],
        [-22, 34],
        [-30, 63],
        [-8, 41],
        [16, 28],
        [48, 12],
        [39, -2],
        [25, -29],
        [14, -57],
        [42, 6],
        [30, 36],
        [149, 26],
        [77, 42],
        [2, 69],
        [-16, 94],
        [14, 61],
        [10, 18],
        [16, 14],
        [20, 15],
        [23, 2],
        [49, 7],
        [56, 16],
        [54, 6],
        [71, -4],
        [38, -11],
        [35, -12],
        [65, -39],
        [35, -8],
        [22, -2],
        [18, 8],
        [12, 12],
        [38, 50],
        [62, 78],
        [63, 57],
        [32, 13],
        [4, 1],
        [6, 2],
        [27, 9],
        [4, 2],
        [6, 3],
        [39, 29],
        [63, 34],
        [57, 12],
        [28, -8],
        [16, -4],
        [28, -10],
        [23, 6],
        [7, 18],
        [-2, 22],
        [-2, 34],
        [-28, 61],
        [-20, 35],
        [-4, 37],
        [-8, 42],
        [-10, 60],
        [2, 48],
        [12, 34],
        [38, 68],
        [37, 39],
        [43, 26],
        [19, 28],
        [9, 27],
        [2, 30],
        [-3, 38],
        [16, 33],
        [30, 15],
        [34, -2],
        [28, -6],
        [28, -15],
        [20, 0],
        [11, 21],
        [17, 18],
        [14, 2],
        [18, -6],
        [21, -20],
        [8, -23],
        [23, -10],
        [28, 6],
        [36, 26],
        [37, 32],
        [18, 12],
        [26, 17],
        [36, -1],
        [52, -1],
        [33, 1],
        [38, -6],
        [45, 0],
        [35, 21],
        [26, 21],
        [26, 18],
        [29, 35],
        [36, 20],
        [22, -4],
        [51, 17],
        [39, -8],
        [58, -3],
        [28, 57],
        [16, 48],
        [28, 32],
        [8, 16],
        [14, 16],
        [24, -4],
        [11, -14],
        [21, -46],
        [25, -30],
        [21, 7],
        [5, -1],
        [5, 4],
        [17, 8],
        [8, 54],
        [-1, 8],
        [-6, 55],
        [8, 46],
        [37, 24],
        [39, 16],
        [27, 17],
        [-10, 23],
        [-54, 27],
        [-24, 18],
        [-17, 16],
        [-4, 12],
        [10, 18],
        [19, 22],
        [26, 18],
        [20, 0],
        [34, -29],
        [31, -29],
        [26, -25],
        [11, -10],
        [16, -6],
        [4, 11],
        [6, 22],
        [7, 23],
        [10, 36],
        [20, 24],
        [16, 19],
        [13, -23],
        [24, -43],
        [13, -23],
        [48, -10],
        [68, 17],
        [2, 3],
        [-34, 9],
        [31, 99],
        [-67, 36],
        [-43, 45],
        [-28, -17],
        [-10, -22],
        [-23, -18],
        [-22, -2],
        [-12, 12],
        [-8, 34],
        [20, 49],
        [0, 9],
        [4, 95],
        [8, 21],
        [18, 3],
        [45, -1],
        [92, -10],
        [27, -4],
        [3, -9],
        [26, 14],
        [-8, 38],
        [-11, 46],
        [-8, 50],
        [15, 24],
        [48, 15],
        [29, 11],
        [12, 21],
        [-30, 32],
        [4, 30],
        [14, 45],
        [13, 48],
        [1, 14],
        [0, 33],
        [14, 69],
        [65, 53],
        [48, 13],
        [-2, 13],
        [12, -9],
        [10, 4],
        [58, 28],
        [-5, 76],
        [-1, 77],
        [17, 46],
        [14, 54],
        [0, 2],
        [0, 1],
        [-2, 3],
        [-8, 47],
        [-18, 46],
        [6, 10],
        [-6, 27],
        [11, 26],
        [21, 8],
        [12, -4],
        [4, 6],
        [6, -2],
        [22, -19],
        [26, -24],
        [24, -16],
        [23, -2],
        [18, 15],
        [19, 27],
        [9, 50],
        [22, 54],
        [24, 10],
        [27, -3],
        [35, -3],
        [35, 4],
        [33, 5],
        [14, 30],
        [39, 55],
        [41, 47],
        [37, 34],
        [44, 15],
        [67, 21],
        [59, -25],
        [71, -25],
        [80, 37],
        [34, 45],
        [23, 34],
        [24, 24],
        [37, 11],
        [38, 19],
        [37, 12],
        [4, 41],
        [-2, 14],
        [1, 24],
        [-78, 22],
        [-41, 2],
        [-49, -53],
        [-8, -6],
        [-46, 49],
        [-64, 16],
        [-28, -6],
        [-45, 11],
        [-25, 36],
        [-3, 10],
        [-25, 73],
        [-43, 71],
        [-143, 176],
        [-198, 193],
        [-62, 191],
        [-147, 219],
        [-21, 22],
        [-34, 6],
        [-9, 15],
        [8, 31],
        [-8, 17],
        [-36, 0],
        [-19, 6],
        [-19, 10],
        [-13, 15],
        [4, 18],
        [11, 8],
        [4, 2],
        [2, 2],
        [0, 4],
        [-25, 28],
        [-38, 23],
        [-23, 31],
        [-35, 38],
        [-4, 8],
        [604, 1068],
        [-91, 150],
        [2078, 339],
        [368, 58],
        [-4, 10],
        [-92, 212],
        [-3, 8],
        [-54, 122],
        [-109, 249],
        [-61, 139],
        [-135, 311],
        [-12, 28],
        [-105, 240],
        [-63, 145],
        [-7, 16],
        [-98, 223],
        [-288, 662],
        [423, -163],
        [21, -5],
        [236, -45],
        [29, -3],
        [139, 25],
        [0, 5],
        [30, 101],
        [-20, 48],
        [4, 5],
        [14, 34],
        [4, 6],
        [23, 10],
        [29, -2],
        [27, 10],
        [119, 38],
        [4, 1],
        [0, 9],
        [-19, 133],
        [7, 13],
        [61, 26],
        [25, -39],
        [17, 7],
        [60, 50],
        [17, 47],
        [8, 2],
        [25, 7],
        [14, -16],
        [49, 32],
        [6, -4],
        [28, 49],
        [50, 51],
        [23, 72],
        [-11, 155],
        [-10, 171],
        [16, 77],
        [3, 53],
        [0, 46],
        [-12, 67],
        [-65, 297],
        [-24, 87],
        [-15, 61],
        [33, 107],
        [14, 45],
        [-6, 70],
        [20, 57],
        [-8, 68],
        [29, 24],
        [47, 6],
        [58, 5],
        [32, 6],
        [-6, 100],
        [5, 26],
        [-24, 101],
        [-19, 98],
        [-2, 77],
        [38, 73],
        [19, 111],
        [34, 72],
        [37, 42],
        [25, 289],
        [52, 28],
        [-2, 11],
        [-95, 77],
        [-49, 72],
        [-60, 21],
        [-50, 61],
        [-14, 48],
        [-39, 65],
        [-28, 32],
        [-6, 109],
        [42, 79],
        [23, 84],
        [29, 113],
        [18, 81],
        [17, 50],
        [23, 20],
        [-4, 42],
        [-32, 86],
        [-16, 82],
        [-36, 18],
        [59, 30],
        [-23, 17],
        [-31, 76],
        [-14, 25],
        [16, 68],
        [13, 22],
        [-4, 22],
        [-23, 37],
        [-6, 39],
        [-4, 12],
        [9, 14],
        [92, 71],
        [4, 3],
        [47, 35],
        [10, 8],
        [28, 22],
        [84, 63],
        [10, 8],
        [35, 26],
        [4, 4],
        [39, 27],
        [217, 149],
        [88, 59],
        [341, 282],
        [216, 166],
        [677, 513],
        [71, 312],
        [726, 590],
        [253, 189],
        [200, 165],
        [38, -32],
        [14, -47],
        [20, -29],
        [23, -35],
        [19, -20],
        [31, -22],
        [24, -15],
        [17, 8],
        [14, 18],
        [15, 29],
        [12, 32],
        [12, 23],
        [16, 53],
        [-8, 37],
        [-22, 26],
        [-18, 32],
        [-14, 36],
        [3, 27],
        [11, 28],
        [32, 35],
        [39, 24],
        [56, 41],
        [33, 17],
        [42, 11],
        [60, 6],
        [50, 7],
        [33, 16],
        [18, 13],
        [6, 23],
        [-2, 27],
        [-8, 29],
        [-20, 67],
        [-50, 95],
        [-29, 86],
        [-4, 57],
        [16, 35],
        [37, 34],
        [36, 19],
        [32, 2],
        [68, 4],
        [26, 9],
        [12, 14],
        [2, 19],
        [-14, 30],
        [-20, 22],
        [-51, 59],
        [-53, 37],
        [-49, 59],
        [-28, 54],
        [-31, 47],
        [-33, 27],
        [-50, 28],
        [-66, 26],
        [-52, 21],
        [-40, 30],
        [-28, 51],
        [-40, 75],
        [-27, 52],
        [-24, 26],
        [-46, 10],
        [-47, 2],
        [-47, 7],
        [-40, 13],
        [-41, 24],
        [-14, 24],
        [-2, 6],
        [2, 5],
        [4, 6],
        [14, 2],
        [50, 10],
        [31, 16],
        [45, 26],
        [19, 24],
        [40, 18],
        [33, 7],
        [54, -2],
        [44, 15],
        [21, 11],
        [15, 29],
        [0, 15],
        [-4, 14],
        [-6, 24],
        [4, 13],
        [4, 26],
        [0, 22],
        [-6, 12],
        [-19, 20],
        [-33, 40],
        [-33, 40],
        [-27, 39],
        [-10, 16],
        [0, 16],
        [10, 10],
        [13, 8],
        [25, 11],
        [18, 9],
        [60, 28],
        [84, 37],
        [29, 17],
        [10, 15],
        [1, 28],
        [-26, 63],
        [-25, 63],
        [-14, 38],
        [8, 15],
        [24, 34],
        [20, 28],
        [29, 44],
        [44, 88],
        [16, 34],
        [-4, 26],
        [-11, 27],
        [-27, 31],
        [-33, 22],
        [-30, 18],
        [-24, 14],
        [-10, 16],
        [0, 19],
        [6, 14],
        [21, 14],
        [42, 32],
        [55, 30],
        [51, 20],
        [40, 8],
        [37, 22],
        [22, 27],
        [6, 36],
        [-10, 28],
        [2, 24],
        [10, 19],
        [24, 9],
        [39, 5],
        [39, -1],
        [64, 13],
        [53, 10],
        [28, 15],
        [17, 15],
        [8, 18],
        [7, 21],
        [-6, 30],
        [-25, 43],
        [-43, 53],
        [-43, 21],
        [-50, 26],
        [-37, 37],
        [-23, 35],
        [-13, 44],
        [-3, 48],
        [2, 55],
        [10, 35],
        [3, 29],
        [-8, 28],
        [-17, 14],
        [-28, 5],
        [-60, -6],
        [-49, 4],
        [-25, 18],
        [-18, 37],
        [-31, 72],
        [-34, 65],
        [-17, 59],
        [-3, 49],
        [-10, 29],
        [-23, 32],
        [-30, 40],
        [-25, 47],
        [2, 40],
        [18, 48],
        [35, 85],
        [3, 66],
        [-29, 135],
        [-23, 56],
        [-10, 46],
        [-4, 55],
        [8, 16],
        [18, 24],
        [-6, 19],
        [8, 41],
        [46, 40],
        [66, 39],
        [26, 5],
        [22, -3],
        [17, -6],
        [70, -67],
        [52, -20],
        [34, 8],
        [17, 18],
        [4, 26],
        [-9, 23],
        [-26, 31],
        [-66, 86],
        [-10, 35],
        [10, 34],
        [30, 25],
        [58, 27],
        [36, 20],
        [32, 1],
        [20, 20],
        [23, 49],
        [23, 44],
        [27, 36],
        [58, 42],
        [58, 24],
        [56, 7],
        [52, -5],
        [24, 112],
        [22, 59],
        [24, 44],
        [28, 56],
        [9, 65],
        [6, 33],
        [26, 49],
        [-1094, -2],
        [-2525, 226],
        [-1363, 5888],
        [327, 2752],
      ],
      [
        [111177, 231494],
        [2598, 1868],
        [472, 3317],
        [-449, 3537],
        [4347, 2561],
        [1511, -102],
        [1202, 1334],
        [-84, 352],
        [-265, 315],
        [2, 341],
        [-113, 207],
        [-567, 105],
        [-223, 391],
        [-450, 333],
        [118, 471],
        [-4, 174],
        [-175, 101],
        [-349, -168],
        [-255, 198],
        [-462, -49],
        [-63, 427],
        [-127, 86],
        [-456, -186],
        [26, 36],
        [-10, 58],
        [-15, 35],
        [-26, 20],
        [-20, 26],
        [4, 33],
        [22, 21],
        [19, 23],
        [20, 20],
        [16, 17],
        [21, 23],
        [0, 17],
        [12, 20],
        [-2, 30],
        [14, 12],
        [28, 2],
        [28, 2],
        [26, 22],
        [12, 26],
        [-7, 32],
        [-18, 50],
        [19, 13],
        [26, 16],
        [14, 31],
        [26, 69],
        [-16, 85],
        [73, 31],
        [84, 38],
        [85, 40],
        [120, 60],
        [51, 8],
        [28, 21],
        [18, 50],
        [8, 65],
        [127, 90],
        [41, 14],
        [74, -39],
        [37, 25],
        [34, 65],
        [109, 137],
        [58, 53],
        [51, 22],
        [45, 8],
        [26, 13],
        [13, 14],
        [27, 3],
        [27, -7],
        [52, -21],
        [43, -12],
        [14, 0],
        [15, 0],
        [9, 0],
        [21, 12],
        [15, 43],
        [13, 18],
        [11, 6],
        [56, -10],
        [47, -14],
        [349, 366],
        [131, 254],
        [-19, 93],
        [-48, 30],
        [-64, 8],
        [-251, -61],
        [-384, 13],
        [-248, 159],
        [-22, 282],
        [190, 81],
        [212, 327],
        [53, 362],
        [65, 491],
      ],
      [
        [230411, 68331],
        [-1269, -1997],
        [-4917, -422],
        [-1908, -156],
        [54, -141],
        [576, -1341],
        [-4855, 1601],
        [-820, -680],
        [-576, -3598],
        [231, -333],
        [109, -156],
        [82, -118],
        [-164, -70],
        [-31, -131],
        [-17, -45],
        [4, -135],
        [1, -85],
        [-6, -43],
        [10, -66],
        [8, -43],
        [6, -30],
        [61, -51],
        [62, -40],
        [69, -39],
        [57, -64],
        [74, -105],
        [93, -119],
        [50, -77],
        [21, -51],
        [7, -40],
        [-2, -90],
        [-147, -28],
        [-116, -24],
        [-126, -29],
        [-48, -10],
        [-45, -10],
        [-8, -2],
        [-33, -7],
        [-357, -77],
        [-207, -45],
        [-218, -49],
        [25, -156],
        [1, -9],
        [73, -445],
        [34, -222],
        [157, -983],
        [69, -439],
        [315, -52],
        [13, -82],
        [57, -362],
        [897, -220],
        [-232, -791],
        [416, -1068],
        [134, -346],
        [148, -381],
        [7, -15],
        [74, -190],
        [1, -4],
        [113, -291],
        [18, -45],
        [111, -286],
        [2, -50],
        [4, -100],
        [8, -165],
        [7, -163],
        [5, -123],
        [30, -704],
        [-1335, -90],
        [-584, -651],
        [-65, -72],
        [-232, -259],
        [-269, -296],
        [-18, -20],
        [-38, -45],
        [-797, -887],
        [5, 73],
        [-7, 92],
        [74, 122],
        [-31, -6],
        [-204, 92],
        [12, 29],
        [26, 35],
        [22, 57],
        [13, 36],
        [23, 35],
        [31, 32],
        [17, 25],
        [-27, 74],
        [-14, 32],
        [-37, 7],
        [-61, -5],
        [-34, -1],
        [-26, 3],
        [-26, 8],
        [-33, 22],
        [-33, 31],
        [-91, 211],
        [-85, 220],
        [-19, 59],
        [-23, 37],
        [-16, 6],
        [-23, 2],
        [-21, 8],
        [-28, 3],
        [-31, 8],
        [-27, 2],
        [-29, 6],
        [-36, 10],
        [-60, 4],
        [-39, 10],
        [-4, 36],
        [16, 27],
        [13, 27],
        [27, 20],
        [29, 7],
        [28, 6],
        [18, 4],
        [21, 9],
        [8, 9],
        [3, 8],
        [-10, 18],
        [-14, 28],
        [-11, 16],
        [-11, 17],
        [-24, 49],
        [-12, 38],
        [-25, 31],
        [-42, 69],
        [-35, 175],
        [-5, 15],
        [-62, 188],
        [-22, 62],
        [-2, 8],
        [-33, 56],
        [-3, 4],
        [-17, 31],
        [-72, 38],
        [-10, -109],
        [-72, -62],
        [-4, -93],
        [-36, -31],
        [134, -202],
        [51, -19],
        [6, -2],
        [-44, -69],
        [-18, -26],
        [-25, -178],
        [-96, -11],
        [-236, -104],
        [-45, -17],
        [-31, 0],
        [-50, -11],
        [-90, 15],
        [-77, -13],
        [-50, 4],
        [-70, -1],
        [-61, 19],
        [-33, 4],
        [-29, -12],
        [-127, -84],
        [-13, -12],
        [-22, -4],
        [-22, 2],
        [-24, 2],
        [-20, 2],
        [-20, 2],
        [-10, 0],
        [-13, -4],
        [-20, -16],
        [-185, -140],
        [-86, -65],
        [-6, -4],
        [-41, -30],
        [-2, 4],
        [-5, 8],
        [-1, 2],
        [-1, 1],
        [-2, 2],
        [-23, 31],
        [-6, 0],
        [-4, 0],
        [-93, -4],
        [-4, -1],
        [-18, -1],
        [-32, -59],
        [-4, -7],
        [-34, -4],
        [-2, 0],
        [-27, -2],
        [-7, -2],
        [-6, -1],
        [-69, -13],
        [-12, 0],
        [-19, -33],
        [-9, -18],
        [-2, -3],
        [-3, -9],
        [-1, -1],
        [0, -2],
        [-14, -38],
        [-1, -4],
        [-37, -105],
        [-12, -6],
        [-20, -10],
        [-27, -12],
        [-17, -12],
        [-9, -8],
        [-165, 163],
        [-136, 133],
        [-42, 38],
        [-8, -8],
        [-124, 125],
        [12, 8],
        [-79, 79],
        [-67, 64],
        [-15, 14],
        [-106, 103],
        [-109, 102],
        [-107, 84],
        [-41, 26],
        [0, 1],
        [-33, 20],
        [-20, 11],
        [-11, 6],
        [-35, 18],
        [-30, 17],
        [0, 0],
        [-2, 2],
        [-36, 18],
        [0, 2],
        [-52, 28],
        [-11, 4],
        [-27, 15],
        [-1, 1],
        [-40, 21],
        [-1, 0],
        [-25, 15],
        [-29, 15],
        [11, 7],
        [-239, 136],
        [-8, -16],
        [-5, -12],
        [-50, -105],
        [-55, -79],
        [-130, -191],
        [-98, -140],
        [-98, -139],
        [0, 0],
        [-87, 51],
        [-62, 41],
        [-20, 17],
        [-19, 19],
        [-34, 15],
        [-72, 33],
        [-41, 18],
        [-33, 14],
        [-101, 65],
        [-55, 36],
        [-103, 65],
        [-182, 119],
        [-13, 8],
        [-12, 32],
        [-29, 14],
        [-61, 65],
        [-6, -5],
        [-71, -37],
        [-18, -6],
        [-18, -11],
        [-29, -16],
        [-20, -6],
        [-21, -4],
        [-82, 47],
        [-48, 50],
        [-98, -56],
        [-33, -16],
        [-17, 44],
        [-59, 45],
        [-102, -61],
        [30, -26],
        [62, -285],
        [-205, -42],
        [-85, -58],
        [-100, -55],
        [-69, -66],
        [-63, 59],
        [-91, -286],
        [13, -90],
        [96, -59],
        [26, -75],
        [-48, -68],
        [-64, 62],
        [-201, 180],
        [-73, 72],
        [-389, 349],
        [-85, 73],
        [-118, 100],
        [-312, -532],
        [-103, -178],
        [-107, -184],
        [-73, -128],
        [117, -118],
        [114, -118],
        [3, -3],
        [2, -2],
        [2, -2],
        [94, -96],
        [39, -42],
        [-129, -210],
        [-5, -8],
        [-69, -107],
        [-109, -170],
        [-38, -57],
        [-44, -69],
        [-59, -93],
        [-134, -207],
        [-127, 135],
        [-202, 202],
        [-125, 124],
        [-49, 49],
        [-85, 87],
        [-4, 3],
        [-98, 102],
        [-48, 41],
        [-113, 118],
        [-64, 66],
        [-220, 210],
        [-89, 89],
        [-128, 121],
        [-5, 6],
        [-117, 111],
        [-67, 66],
      ],
      [
        [204894, 50329],
        [92, 133],
        [133, 218],
        [68, 108],
        [16, 25],
        [104, 167],
        [74, 120],
        [97, 149],
        [88, 137],
        [603, 1176],
        [26, 89],
        [46, 123],
        [50, 40],
        [40, 122],
        [-3, 49],
        [66, 100],
        [-41, 66],
        [22, 122],
        [49, 20],
        [57, 42],
        [62, 59],
        [11, 80],
        [68, 112],
        [10, 14],
        [109, 47],
        [43, 9],
        [45, 28],
        [11, 27],
        [33, 12],
        [-11, 34],
        [-6, 25],
        [-5, 20],
        [-3, 16],
        [8, 36],
        [22, 25],
        [43, 42],
        [30, 27],
        [10, 20],
        [29, 28],
        [67, 80],
        [10, 20],
        [-30, 27],
        [1, 20],
        [-4, 2],
        [-5, 3],
        [-3, 1],
        [-8, 0],
        [-12, 2],
        [-6, 2],
        [-8, 1],
        [-16, -5],
        [-22, -4],
        [0, 3],
        [-37, 52],
        [-185, 130],
        [9, 24],
        [60, 13],
        [6, 50],
        [0, 4],
        [-49, 20],
        [-28, 22],
        [-55, 16],
        [-35, 6],
        [-41, 27],
        [-1, -2],
        [-56, -106],
        [-67, -5],
        [-20, -1],
        [6, 41],
        [-31, 58],
        [-30, 23],
        [-18, -27],
        [-37, -4],
        [-29, -4],
        [-13, 22],
        [-6, 17],
        [-27, 49],
        [-14, -3],
        [-101, -19],
        [-17, -8],
        [-20, -16],
        [-28, -36],
        [-20, -12],
        [-46, 16],
        [-33, 6],
        [-38, 9],
        [-28, 24],
        [-17, 3],
        [-15, -4],
        [-26, -12],
        [-6, -8],
        [-20, -36],
        [-32, -16],
        [-23, -8],
        [-21, 10],
        [-25, 10],
        [-24, 14],
        [-28, 14],
        [-23, 4],
        [-23, -4],
        [-24, -4],
        [-24, -2],
        [-18, -6],
        [-41, -10],
        [-25, 6],
        [-21, 18],
        [-8, 19],
        [0, 24],
        [19, 17],
        [15, 13],
        [8, 8],
        [-4, 12],
        [-5, 16],
        [-11, 18],
        [-10, 25],
        [3, 25],
        [2, 14],
        [-13, 0],
        [-17, -7],
        [-10, -21],
        [-10, -24],
        [-32, -38],
        [-31, -18],
        [-38, 0],
        [-18, 16],
        [-43, 24],
        [-49, 50],
        [-31, 33],
        [-44, 41],
        [-46, 34],
        [-13, 3],
        [-9, 3],
        [-48, -3],
        [-12, -3],
        [-2, -1],
        [-46, 33],
        [-36, 12],
        [-28, -6],
        [-29, -11],
        [-34, -6],
        [-45, -5],
        [-67, -8],
        [-20, 19],
        [-15, 18],
        [-37, 7],
        [-29, 31],
        [-12, 16],
        [-2, 50],
        [-11, 3],
        [-67, 78],
        [-47, 91],
        [-115, 243],
        [-2, 13],
        [-7, 56],
        [-2, 34],
        [-7, 36],
        [-6, 52],
        [-3, 34],
        [1, 29],
        [2, 30],
        [2, 34],
        [2, 21],
        [6, 37],
        [2, 20],
        [-1, 18],
        [-3, 28],
        [-4, 27],
        [-6, 17],
        [-8, 36],
        [-6, 28],
        [-13, 43],
        [-5, 3],
        [161, -36],
        [12, -10],
        [32, -10],
        [11, 24],
        [-1, 5],
        [-181, 140],
        [6, 7],
        [-29, 28],
        [-81, 61],
        [-106, 84],
        [-217, 166],
        [-30, 15],
        [-27, 12],
        [-22, 6],
        [-30, 9],
        [-34, 4],
        [-39, 0],
        [-62, -3],
        [-227, -3],
        [-151, -5],
        [-146, -4],
        [-193, -5],
        [-179, -4],
        [-324, -7],
        [-203, -3],
        [-46, -1],
        [-39, 0],
        [-46, -1],
        [-41, -1],
        [-47, -2],
        [-44, -2],
        [-120, -1],
        [-259, -6],
        [-91, -1],
        [-56, -3],
        [-158, -1],
        [-95, -5],
        [-125, 0],
        [-227, -5],
        [-16, 0],
        [-12, 0],
        [0, 4],
        [20, 126],
        [-127, -25],
        [-17, -10],
        [-153, -22],
        [-7, 0],
        [46, 278],
        [15, 0],
        [0, 32],
        [0, 14],
        [-1, 20],
        [1, 4],
        [1, 4],
        [6, 23],
        [0, 4],
        [2, 1],
        [0, 2],
        [4, 31],
        [2, 14],
        [0, 6],
        [0, 2],
        [0, 6],
        [0, 2],
        [2, 0],
        [0, 4],
        [0, 6],
        [2, 16],
        [0, 6],
        [0, 2],
        [-2, 21],
        [0, 1],
        [-30, -2],
        [0, 3],
        [0, 2],
        [0, 3],
        [-2, 23],
        [0, 1],
        [0, 12],
        [-33, 16],
        [-35, 17],
        [-15, 6],
        [-19, 8],
        [-4, 1],
        [-6, 3],
        [-19, 3],
        [-9, 1],
        [-37, 2],
        [-30, 2],
        [-2, 0],
        [-6, 0],
        [-12, 0],
        [-3, 0],
        [-39, 1],
        [-7, 0],
        [-2, 0],
        [-5, 0],
        [-6, 0],
        [-3, 0],
        [-25, -1],
        [-22, -5],
        [-7, -1],
        [0, 2],
        [24, 24],
        [17, 14],
        [-3, 3],
        [16, 14],
        [56, 45],
        [89, 71],
        [52, 43],
        [23, 18],
        [186, 106],
        [203, 127],
        [38, 7],
        [27, 0],
        [89, -12],
        [33, 0],
        [16, 5],
        [13, 6],
        [136, 72],
        [25, 14],
        [81, -10],
        [71, -13],
        [10, -6],
        [20, 110],
        [1, 16],
        [2, 2],
        [0, 2],
        [2, 18],
        [28, 161],
        [10, 64],
        [206, 6],
        [14, 0],
        [91, 4],
        [67, 2],
        [48, 6],
        [214, 5],
        [5, 0],
        [357, 11],
        [358, 17],
        [162, 4],
        [53, -2],
        [11, -8],
        [-39, 270],
        [-33, 255],
        [-13, 110],
        [-5, 61],
        [-1, 6],
        [-1, 5],
        [-2, 9],
        [-20, 127],
        [-15, 100],
        [-32, 192],
        [-37, 238],
        [-5, 20],
        [-16, 128],
        [-3, 18],
        [-191, 1199],
        [-181, 1138],
        [-4, 17],
        [-338, 2126],
        [-647, 435],
        [-37, 1118],
        [-130, -40],
        [-114, 4],
        [-91, 54],
        [-63, -26],
        [-71, 16],
        [-90, 10],
        [-48, 51],
        [-62, 27],
        [-109, 35],
        [-41, -11],
        [-24, -16],
        [-18, -14],
        [-15, -11],
        [-17, -4],
        [-18, 7],
        [-11, 14],
        [-13, 14],
        [-20, 12],
        [-25, 12],
        [-10, 2],
        [-30, 8],
        [-26, 8],
        [-30, 18],
        [-36, 9],
        [-42, -9],
        [-58, -2],
        [-47, 21],
        [-42, 14],
        [-52, 6],
        [-41, -2],
        [-35, -12],
        [-32, -12],
        [-20, 6],
        [-16, 4],
        [-16, 16],
        [-18, 10],
        [-10, 0],
        [-10, 2],
        [-17, -2],
        [-18, 15],
        [-19, 34],
        [-10, 41],
        [-9, 14],
        [-25, 30],
        [-11, 19],
        [-18, 22],
        [-19, 26],
        [-13, 21],
        [-25, 10],
        [-24, 10],
        [-55, -10],
        [-36, -8],
        [-15, -21],
        [-14, -18],
        [-19, -20],
        [-24, -22],
        [-12, -3],
        [-16, 2],
        [-15, 6],
        [-21, 10],
        [-13, 20],
        [-14, 34],
        [-24, 30],
        [-23, 12],
        [-24, 3],
        [-24, -2],
        [-16, 0],
        [-22, 13],
        [-10, 35],
        [5, 27],
        [13, 17],
        [8, 8],
        [7, 10],
        [4, 16],
        [-21, 32],
        [-22, 18],
        [-17, 23],
        [-19, 23],
        [-2, 21],
        [8, 20],
        [15, 34],
        [17, 14],
        [25, 19],
        [11, 26],
        [-5, 25],
        [-24, 14],
        [-2, 20],
        [-12, 12],
        [-4, 74],
        [-17, 10],
        [-8, 7],
        [-14, 15],
        [-13, 28],
        [-9, 25],
        [2, 23],
        [0, 38],
        [1, 9],
        [0, 7],
        [-275, -96],
        [-10, 23],
        [-11, 50],
        [-13, 24],
        [-29, 14],
        [-45, 18],
        [-43, 6],
        [-17, 18],
        [-37, 47],
        [-40, 44],
        [-46, 38],
        [-31, 9],
        [-21, 4],
        [-14, -3],
        [-15, 444],
        [-376, -47],
        [-287, -70],
        [17, 62],
        [19, 31],
        [16, 21],
        [36, 40],
        [62, 51],
        [47, 43],
        [61, 36],
        [49, 18],
        [61, 5],
        [37, 0],
        [32, -3],
        [50, -3],
        [43, 3],
        [72, 5],
        [52, 17],
        [82, 9],
        [37, 14],
        [40, 10],
        [40, 16],
        [14, 34],
        [3, 41],
        [-8, 21],
        [-10, 23],
        [-16, 28],
        [-15, 20],
        [-22, 17],
        [-15, 19],
        [-13, 24],
        [-24, 21],
        [-18, 11],
        [-12, 18],
        [-16, 23],
        [-19, 28],
        [-49, 38],
        [-31, 21],
        [-27, 14],
        [-30, 14],
        [-29, 11],
        [-27, 0],
        [-15, 4],
        [-36, 24],
        [-31, 24],
        [-35, 34],
        [-6, 32],
        [9, 48],
        [15, 21],
        [15, 24],
        [16, 17],
        [17, 16],
        [19, 12],
        [19, 16],
        [24, 10],
        [74, 32],
        [38, 7],
        [46, 15],
        [35, 19],
        [20, 9],
        [20, 23],
        [48, 22],
        [53, 20],
        [76, 8],
        [81, 0],
        [62, 4],
        [71, 0],
        [61, 2],
        [123, 4],
        [170, 2],
        [97, -42],
        [60, -2],
        [70, 12],
        [55, 14],
        [95, 23],
        [76, 11],
        [63, -2],
        [32, -7],
        [28, -5],
        [35, 38],
        [19, 32],
        [8, 43],
        [-6, 55],
        [-13, 61],
        [-23, 53],
        [-27, 59],
        [-16, 27],
        [-26, 33],
        [-34, 86],
        [-20, 53],
        [-2, 51],
        [37, 80],
        [8, 66],
        [13, 69],
        [3, 60],
        [-13, 88],
        [-32, 56],
        [-27, 29],
        [-31, 33],
        [-26, 28],
        [-33, 35],
        [-42, 24],
        [-62, 41],
        [-25, 20],
        [-30, 41],
        [-33, 56],
        [-66, 47],
        [-38, 33],
        [-22, 52],
        [-21, 46],
        [-30, 21],
        [-35, 26],
        [-34, 14],
        [-53, 28],
        [-32, 49],
        [-26, 42],
        [-28, 54],
        [-4, 23],
        [6, 38],
        [7, 26],
        [10, 29],
        [14, 15],
        [15, 13],
        [20, -5],
        [33, -5],
        [28, -6],
        [36, 0],
        [50, 2],
        [40, 2],
        [48, 1],
        [49, 9],
        [85, 40],
        [54, 12],
        [47, 8],
        [50, 4],
        [43, 3],
        [26, 11],
        [27, 22],
        [31, 18],
        [31, 29],
        [47, 40],
        [35, 54],
        [23, 30],
        [32, 49],
        [29, 27],
        [28, 30],
        [25, 32],
        [6, 28],
        [-19, 24],
        [-29, 21],
        [-14, 54],
        [-18, 69],
        [-32, 72],
        [13, 114],
        [-17, 31],
        [-16, 22],
        [-6, 33],
        [-5, 23],
        [-23, 25],
        [-28, 22],
        [-30, 32],
        [-30, 39],
        [-29, 66],
        [0, 65],
        [0, 54],
        [-25, 43],
        [-8, 48],
        [-2, 46],
        [9, 75],
        [18, 83],
        [-13, 60],
        [-33, 56],
        [-17, 76],
        [-25, 61],
        [-44, 83],
        [-30, 74],
        [-25, 87],
        [-22, 55],
        [-38, 52],
        [-36, 61],
        [-27, 49],
        [-50, 54],
        [-143, 77],
        [-222, 67],
        [-78, 15],
        [-238, 53],
        [-105, 27],
        [-92, 28],
        [-32, 20],
        [-27, 19],
        [-28, 13],
        [-48, 24],
        [-36, 39],
        [-32, 51],
        [-17, 91],
        [-24, 65],
        [-46, 116],
        [-31, 69],
        [-15, 92],
        [-9, 35],
        [18, 34],
        [31, 36],
        [27, 36],
        [27, 59],
        [31, 32],
        [20, 52],
        [25, 28],
        [26, 38],
        [27, 19],
        [24, 16],
        [26, 18],
        [20, 14],
        [41, 14],
        [39, 7],
        [43, 1],
        [55, -30],
        [56, -33],
        [28, -11],
        [30, -9],
        [29, -8],
        [44, 3],
        [49, 4],
        [52, 17],
        [25, 9],
        [49, 18],
        [41, 4],
        [15, 6],
        [23, 6],
        [52, -2],
        [56, -10],
        [53, 2],
        [38, -2],
        [50, -10],
        [31, -24],
        [48, -8],
        [37, 7],
        [36, 7],
        [24, 14],
        [17, 12],
        [25, 20],
        [16, 14],
        [23, 11],
        [34, 28],
        [24, 21],
        [33, 20],
        [60, 16],
        [39, 4],
        [18, 25],
        [-3, 38],
        [-2, 29],
        [0, 26],
        [5, 31],
        [8, 28],
        [6, 23],
        [4, 36],
        [3, 21],
        [18, 32],
        [4, 26],
        [16, 21],
        [18, 30],
        [19, 33],
        [15, 28],
        [17, 22],
        [10, 36],
        [5, 21],
        [4, 32],
        [-7, 38],
        [-17, 18],
        [-34, 30],
        [-22, 7],
        [-32, 21],
        [-23, 20],
        [-31, 21],
        [-35, 32],
        [-38, 55],
        [-14, 28],
        [-10, 41],
        [3, 54],
        [8, 51],
        [9, 33],
        [2, 22],
        [20, 47],
        [34, 29],
        [39, 23],
        [36, 4],
        [34, -4],
        [25, -4],
        [21, -6],
        [15, 2],
        [23, 4],
        [37, 4],
        [59, -32],
        [44, -28],
        [25, -25],
        [37, -8],
        [47, -24],
        [41, -8],
        [53, 28],
        [28, 17],
        [37, 2],
        [28, 25],
        [17, 34],
        [1, 35],
        [7, 34],
        [7, 18],
        [3, 16],
        [-21, 44],
        [-10, 65],
        [-2, 25],
        [4, 20],
        [-10, 25],
        [-2, 31],
        [-23, 25],
        [-37, 33],
        [-41, 23],
        [-14, 17],
        [-30, 0],
        [-34, 16],
        [-40, 23],
        [-21, 35],
        [-10, 38],
        [-10, 55],
        [-8, 25],
        [-6, 22],
        [-6, 62],
        [-4, 48],
        [0, 61],
        [38, 39],
        [26, 23],
        [15, 22],
        [16, 34],
        [33, -8],
        [73, -2],
        [89, 2],
        [46, -4],
        [52, 4],
        [60, 2],
        [22, -4],
        [27, 16],
        [13, 16],
        [7, 18],
        [3, 14],
        [0, 27],
        [-23, 20],
        [-10, 17],
        [-8, 17],
        [-12, 24],
        [-8, 20],
        [-21, 32],
        [-17, 37],
        [-25, 43],
        [-8, 15],
        [-4, 20],
        [-6, 20],
        [-4, 40],
        [0, 35],
        [2, 21],
        [-2, 24],
        [6, 35],
        [6, 35],
        [0, 32],
        [-10, 22],
        [12, 36],
        [10, 36],
        [-12, 57],
        [0, 4],
        [-12, 24],
        [-13, 26],
        [-18, 33],
        [-1, 18],
        [8, 17],
        [8, 18],
        [7, 42],
        [31, 32],
        [-6, 65],
        [-25, 58],
        [4, 38],
        [25, 49],
        [70, 53],
        [29, 32],
        [8, 31],
        [21, 71],
        [15, 42],
        [3, 19],
        [-3, 14],
        [-5, 16],
        [-1, 22],
        [1, 24],
        [-10, 50],
        [-12, 37],
        [-9, 42],
        [-12, 72],
        [-10, 67],
        [6, 87],
        [-6, 61],
        [-4, 29],
        [-14, 24],
        [-11, 24],
        [0, 50],
        [10, 20],
        [9, 19],
        [10, 17],
        [10, 19],
        [0, 14],
        [17, 9],
        [24, 11],
        [26, 17],
        [28, 22],
        [20, 24],
        [14, 33],
        [19, 43],
        [5, 24],
        [18, 8],
        [30, 10],
        [25, 8],
        [39, 7],
        [36, 3],
        [44, 13],
        [62, 24],
        [20, 17],
        [10, 15],
        [11, 20],
        [4, 22],
        [9, 18],
        [10, 32],
        [25, 57],
        [208, 285],
        [19, 0],
        [4, -2],
        [1, 0],
        [2, 0],
        [4, -2],
        [5, -2],
        [1, -2],
        [16, -6],
        [12, -13],
        [23, -17],
        [33, -1],
        [18, 24],
        [14, 19],
        [-4, 34],
        [-14, 28],
        [-2, 50],
        [-9, 43],
        [-1, 24],
        [-9, 16],
        [-11, 49],
        [-6, 23],
        [-8, 32],
        [8, 37],
        [-7, 64],
        [-10, 56],
        [-2, 47],
        [9, 42],
        [-10, 54],
        [-7, 51],
        [-1, 74],
        [-6, 38],
        [-18, 24],
        [-8, 36],
        [-16, 36],
        [-32, 41],
        [-22, 16],
        [-23, 11],
        [-27, 9],
        [-17, 8],
        [-19, 13],
        [-39, 25],
        [-24, 6],
        [-38, 16],
        [-29, 29],
        [-29, 26],
        [-21, 22],
        [-9, 28],
        [-12, 35],
        [-5, 60],
        [-11, 48],
        [-14, 42],
        [-17, 20],
        [-31, 50],
        [-5, 34],
        [-12, 62],
        [-1, 31],
        [6, 26],
        [19, 27],
        [16, 36],
        [30, 56],
        [23, 65],
        [23, 60],
        [11, 14],
        [12, 12],
        [12, 6],
        [12, 7],
        [16, 7],
        [20, 3],
        [26, 10],
        [34, 5],
        [61, -2],
        [78, -16],
        [82, 6],
        [49, 8],
        [37, 9],
        [29, 11],
        [8, 3],
        [43, 14],
        [48, 26],
        [35, 16],
        [34, 30],
        [18, 32],
        [1, 26],
        [4, 21],
        [10, 18],
        [17, 8],
        [6, 24],
        [-6, 34],
        [-20, 42],
        [-5, 52],
        [-13, 32],
        [-16, 34],
        [-4, 44],
        [12, 30],
        [43, 18],
        [21, 19],
        [27, 28],
        [20, 17],
        [25, 26],
        [27, 23],
        [20, 28],
        [66, 36],
        [41, 67],
        [23, 37],
        [10, 27],
        [23, 26],
        [16, 12],
        [18, 2],
        [17, 3],
        [20, 2],
        [13, -5],
        [20, -2],
        [16, -1],
        [32, -5],
        [40, -17],
        [52, -32],
        [64, -31],
        [55, -12],
        [33, -7],
        [18, -6],
        [16, 0],
        [3, -2],
        [12, -6],
        [4, -1],
        [8, -1],
        [9, -8],
        [10, -11],
        [4, -13],
        [4, -24],
        [20, -66],
        [16, -24],
        [57, -79],
        [60, -69],
        [44, -45],
        [53, -25],
        [125, -23],
        [62, -6],
        [42, -11],
        [38, -14],
        [30, -5],
        [26, -3],
        [37, 3],
        [33, -11],
        [23, -8],
        [27, -17],
        [36, -29],
        [43, -45],
        [24, -32],
        [22, -14],
        [32, -21],
        [42, -23],
        [28, -6],
        [35, 4],
        [43, 6],
        [43, 4],
        [23, 9],
        [13, 13],
        [12, 16],
        [21, 28],
        [20, 34],
        [30, 41],
        [26, 45],
        [24, 27],
        [22, 30],
        [8, 11],
        [21, 35],
        [18, 41],
        [12, 40],
        [14, 27],
        [17, 11],
        [27, 30],
        [27, 23],
        [39, 34],
        [20, 18],
        [13, 26],
        [2, 18],
        [-12, 31],
        [-27, 28],
        [-35, 22],
        [-29, 11],
        [-39, 14],
        [-28, 29],
        [-17, 21],
        [-15, 13],
        [-30, 12],
        [-12, 14],
        [-40, 20],
        [-24, 26],
        [-40, 52],
        [-47, 38],
        [-20, 30],
        [-17, 21],
        [-29, 32],
        [-40, 25],
        [-16, 17],
        [-15, 31],
        [-22, 23],
        [-113, 164],
        [121, 258],
        [29, 278],
        [97, 92],
        [124, 42],
        [134, 7],
        [121, -44],
        [729, -207],
        [614, -261],
        [121, -110],
        [-26, -429],
        [121, -59],
        [176, 47],
        [142, 286],
        [258, 247],
        [150, 88],
        [28, -14],
        [44, 22],
        [40, 23],
        [32, 20],
        [23, 10],
        [14, 22],
        [2, 20],
        [0, 13],
        [-2, 13],
        [-2, 15],
        [-2, 7],
        [-2, 11],
        [-2, 21],
        [0, 17],
        [-11, 30],
        [-21, 43],
        [0, 38],
        [-8, 35],
        [-18, 21],
        [-21, 9],
        [-42, 4],
        [-31, 1],
        [-45, 11],
        [-36, 3],
        [-45, 9],
        [-47, 9],
        [-32, 12],
        [-25, 8],
        [-23, 7],
        [-24, 12],
        [-28, 40],
        [-8, 22],
        [-14, 24],
        [-4, 15],
        [-3, 13],
        [-4, 13],
        [4, 21],
        [2, 12],
        [2, 12],
        [1, 14],
        [4, 20],
        [5, 12],
        [1, 21],
        [3, 21],
        [5, 31],
        [14, 20],
        [26, 34],
        [4, 36],
        [12, 28],
        [21, 43],
        [0, 36],
        [4, 28],
        [9, 16],
        [8, 10],
        [4, 14],
        [-8, 8],
        [-12, 5],
        [-1, 2],
        [-17, 22],
        [-18, 30],
        [-23, 43],
        [-15, 27],
        [-10, 45],
        [-8, 24],
        [7, 38],
        [3, 27],
        [2, 24],
        [3, 18],
        [6, 20],
        [7, 28],
        [14, 33],
        [6, 10],
        [4, 17],
        [2, 35],
        [16, 22],
        [11, 22],
        [8, 16],
        [15, 4],
        [15, 0],
        [20, 5],
        [24, 11],
        [37, 9],
        [23, 11],
        [5, 31],
        [6, 29],
        [0, 17],
        [2, 11],
        [13, 4],
        [16, 4],
        [11, 6],
        [27, 4],
        [14, -8],
        [28, -26],
        [36, -24],
        [39, -22],
        [31, -17],
        [30, -14],
        [25, -7],
        [20, -7],
        [37, -24],
        [83, -65],
        [11, -8],
        [13, -9],
        [18, -11],
        [17, -8],
        [41, -14],
        [9, -1],
        [32, -1],
        [41, -7],
        [69, 2],
        [64, -2],
        [44, 4],
        [62, 6],
        [43, 6],
        [42, 7],
        [16, 5],
        [24, 15],
        [24, 22],
        [23, 24],
        [27, 33],
        [37, 40],
        [33, 22],
        [31, 25],
        [15, 29],
        [19, 76],
        [39, 48],
        [25, 20],
        [25, -4],
        [42, -12],
        [23, 0],
        [32, 0],
        [19, 2],
        [12, 8],
        [16, 6],
        [21, 12],
        [30, 19],
        [17, 42],
        [9, 49],
        [-8, 52],
        [-15, 60],
        [-31, 42],
        [-37, 40],
        [-33, 71],
        [-35, 20],
        [-30, 28],
        [-40, 53],
        [-77, 50],
        [-38, 28],
        [-48, 43],
        [-18, 25],
        [-21, 27],
        [-26, 16],
        [-15, 34],
        [-15, 33],
        [-31, 41],
        [-24, 39],
        [-36, 58],
        [-25, 69],
        [-2, 38],
        [12, 57],
        [13, 42],
        [16, 50],
        [13, 23],
        [27, 44],
        [2, 3],
        [31, 39],
        [20, 27],
        [18, 2],
        [18, -6],
        [23, -31],
        [18, -26],
        [13, -1],
        [22, -10],
        [17, -9],
        [13, -8],
        [6, -6],
        [5, -11],
        [14, -36],
        [6, -44],
        [8, -27],
        [19, -39],
        [17, -19],
        [26, -38],
        [11, -59],
        [24, -74],
        [50, -65],
        [32, -7],
        [29, -13],
        [84, -20],
        [63, -17],
        [66, -30],
        [31, -14],
        [32, -25],
        [36, -28],
        [36, -7],
        [73, 1],
        [14, 6],
        [12, 19],
        [19, 21],
        [39, 35],
        [18, 50],
        [14, 43],
        [16, 28],
        [29, 19],
        [36, 15],
        [61, 10],
        [81, -4],
        [55, -19],
        [15, -4],
        [14, -14],
        [2, -16],
        [6, -13],
        [20, -18],
        [27, -18],
        [33, -11],
        [39, -23],
        [44, -14],
        [37, -54],
        [27, -45],
        [20, -28],
        [44, -38],
        [41, -22],
        [23, -14],
        [23, -8],
        [64, 0],
        [46, 6],
        [55, 8],
        [30, 19],
        [37, 23],
        [47, 55],
        [34, 57],
        [22, 55],
        [6, 25],
        [4, 19],
        [0, 23],
        [-4, 15],
        [-16, 35],
        [-25, 29],
        [-22, 42],
        [-36, 44],
        [-48, 62],
        [-44, 67],
        [-39, 44],
        [-27, 34],
        [-30, 67],
        [-30, 49],
        [-8, 19],
        [-22, 28],
        [-13, 37],
        [-11, 37],
        [-13, 38],
        [-12, 32],
        [-13, 44],
        [-17, 41],
        [13, 74],
        [38, 58],
        [19, 29],
        [29, 38],
        [20, 37],
        [2, 34],
        [8, 30],
        [12, 18],
        [17, 11],
        [18, 7],
        [15, 10],
        [21, 5],
        [32, 5],
        [33, -1],
        [42, 9],
        [15, 7],
        [11, 15],
        [6, 11],
        [4, 22],
        [7, 20],
        [3, 32],
        [-4, 51],
        [4, 27],
        [0, 30],
        [-13, 32],
        [-4, 19],
        [-12, 12],
        [-11, 12],
        [-20, 22],
        [-19, 19],
        [-25, 25],
        [-5, 28],
        [-21, 45],
        [-36, 39],
        [-5, 10],
        [-7, 14],
        [-17, 10],
        [-35, 23],
        [-46, 12],
        [-37, 8],
        [-37, 10],
        [-33, 10],
        [-34, 11],
        [-33, 26],
        [-17, 39],
        [-4, 54],
        [6, 48],
        [21, 44],
        [55, 65],
        [26, 36],
        [35, 40],
        [42, 53],
        [35, 40],
        [31, 40],
        [38, 32],
        [21, 43],
        [13, 33],
        [2, 26],
        [6, 22],
        [0, 26],
        [6, 38],
        [5, 16],
        [4, 10],
        [6, 10],
        [9, 12],
        [9, 22],
        [7, 18],
        [12, 8],
        [18, -2],
        [37, 2],
        [43, 6],
        [52, 14],
        [52, 19],
        [69, -6],
        [43, -5],
        [53, -10],
        [40, -18],
        [67, -32],
        [34, -30],
        [22, -23],
        [24, -18],
        [22, -4],
        [37, -21],
        [55, -36],
        [31, -28],
        [26, -29],
        [7, -16],
        [19, -12],
        [14, -10],
        [10, -10],
        [14, -10],
        [14, -9],
        [13, -2],
        [14, 4],
        [10, 10],
        [9, 9],
        [14, 12],
        [18, 16],
        [12, 15],
        [3, 18],
        [5, 17],
        [5, 20],
        [6, 22],
        [19, 14],
        [11, 11],
        [14, 11],
        [8, 6],
        [6, 9],
        [16, 16],
        [23, 14],
        [26, 14],
        [9, 10],
        [16, 14],
        [17, 14],
        [3, 16],
        [4, 9],
        [0, 11],
        [2, 11],
        [1, 5],
        [7, 7],
        [14, 4],
        [18, 6],
        [18, 8],
        [17, 7],
        [10, -2],
        [13, 0],
        [10, 3],
        [11, 10],
        [12, 6],
        [11, 11],
        [11, 13],
        [10, 8],
        [9, 20],
        [19, 26],
        [18, 10],
        [15, 3],
        [10, -3],
        [17, -12],
        [25, -14],
        [29, -12],
        [21, -14],
        [15, -20],
        [22, -23],
        [27, -27],
        [16, -12],
        [13, -17],
        [26, -28],
        [3, -4],
        [54, -38],
        [32, -12],
        [36, 0],
        [41, 2],
        [26, 6],
        [14, 8],
        [29, 14],
        [26, 24],
        [22, 33],
        [17, 16],
        [6, 18],
        [12, 31],
        [6, 25],
        [-2, 22],
        [-10, 21],
        [-14, 43],
        [-25, 30],
        [-31, 11],
        [-32, 4],
        [-54, -6],
        [-50, -6],
        [-34, -4],
        [-27, 5],
        [-30, 5],
        [-31, 31],
        [-11, 20],
        [-18, 26],
        [-4, 30],
        [-8, 27],
        [-9, 22],
        [-16, 43],
        [0, 39],
        [6, 32],
        [4, 18],
        [15, 25],
        [12, 28],
        [19, 18],
        [17, 14],
        [13, 11],
        [18, 5],
        [35, 14],
        [38, 13],
        [45, 16],
        [42, 19],
        [24, 18],
        [32, 24],
        [14, 17],
        [8, 30],
        [0, 37],
        [-8, 38],
        [-9, 39],
        [-14, 52],
        [-27, 74],
        [-3, 34],
        [6, 19],
        [-1, 23],
        [-3, 31],
        [-8, 28],
        [-16, 27],
        [-15, 23],
        [-20, 23],
        [-19, 29],
        [-36, 24],
        [-53, 20],
        [-41, 0],
        [-24, -3],
        [-77, -6],
        [-77, -15],
        [-25, -6],
        [-17, -6],
        [-11, 2],
        [-16, -4],
        [-13, 0],
        [-14, 2],
        [-11, 8],
        [-5, 7],
        [-4, 7],
        [-11, 26],
        [-15, 31],
        [-16, 35],
        [-20, 49],
        [-9, 39],
        [1, 58],
        [20, 71],
        [10, 27],
        [25, 34],
        [35, 37],
        [21, 14],
        [8, 22],
        [14, 15],
        [52, 27],
        [40, 16],
        [35, 13],
        [35, 8],
        [41, 10],
        [47, 4],
        [53, 6],
        [50, 10],
        [37, 12],
        [26, 12],
        [23, 4],
        [19, 6],
        [37, -2],
        [35, 1],
        [34, 7],
        [35, 0],
        [13, -13],
        [36, -25],
        [13, -22],
        [24, -36],
        [44, -34],
        [26, -9],
        [48, -32],
        [72, -34],
        [53, -20],
        [32, -11],
        [22, -4],
        [26, -3],
        [25, -4],
        [27, -2],
        [44, -9],
        [15, 2],
        [11, 9],
        [14, 22],
        [20, 29],
        [35, 50],
        [18, 62],
        [23, 26],
        [20, 26],
        [20, 23],
        [16, 29],
        [13, 27],
        [14, 38],
        [10, 34],
        [4, 30],
        [-2, 19],
        [2, 15],
        [8, 36],
        [-4, 44],
        [-6, 47],
        [-2, 57],
        [-24, 56],
        [-17, 42],
        [-16, 43],
        [-10, 26],
        [-4, 30],
        [-18, 34],
        [-12, 10],
        [-3, 16],
        [1, 9],
        [12, 15],
        [10, 8],
        [13, 11],
        [15, 16],
        [13, 16],
        [5, 2],
        [13, 1],
        [11, 5],
        [21, 16],
        [19, 12],
        [43, 39],
        [67, 80],
        [60, 69],
        [31, 25],
        [21, 26],
        [17, 25],
        [8, 14],
        [10, 22],
        [11, 15],
        [8, 14],
        [2, 18],
        [4, 18],
        [0, 30],
        [0, 41],
        [6, 39],
        [2, 28],
        [18, 17],
        [15, 27],
        [15, 17],
        [10, 7],
        [2, 7],
        [-2, 10],
        [-7, 14],
        [-8, 18],
        [-25, 20],
        [-30, 12],
        [-32, 12],
        [-29, 2],
        [-18, -8],
        [-44, 6],
        [-64, -2],
        [-44, 6],
        [-62, 29],
        [-31, 27],
        [-42, 45],
        [-36, 20],
        [-29, 43],
        [-28, 44],
        [-14, 17],
        [-13, 24],
        [-14, 18],
        [-23, 28],
        [-40, 31],
        [-27, 44],
        [-8, 37],
        [-5, 75],
        [-9, 12],
        [-4, 14],
        [-10, 18],
        [-12, 16],
        [-10, 8],
        [-7, 8],
        [-10, 16],
        [-3, 15],
        [-2, 10],
        [1, 45],
        [18, 35],
        [21, 33],
        [16, 17],
        [17, 15],
        [41, 41],
        [30, 19],
        [40, 19],
        [33, 24],
        [37, 26],
        [28, 11],
        [25, 10],
        [29, 18],
        [23, 11],
        [18, 10],
        [20, 7],
        [23, 2],
        [17, -2],
        [46, -1],
        [32, -6],
        [20, -6],
        [16, -3],
        [4, -13],
        [11, -26],
        [10, -30],
        [13, -36],
        [5, -11],
        [7, -13],
        [11, -25],
        [12, -19],
        [23, -10],
        [27, -14],
        [26, -9],
        [25, -6],
        [12, -9],
        [19, -6],
        [22, -2],
        [26, 6],
        [17, 4],
        [14, 6],
        [8, 8],
        [26, 15],
        [20, 13],
        [24, 9],
        [17, 11],
        [18, 14],
        [18, 25],
        [12, 31],
        [15, 23],
        [10, 21],
        [19, 23],
        [12, 19],
        [30, 43],
        [24, 26],
        [24, 16],
        [32, 14],
        [26, 28],
        [26, 16],
        [37, 13],
        [31, 2],
        [35, 13],
        [12, 14],
        [-2, 21],
        [0, 13],
        [0, 26],
        [-4, 26],
        [-6, 19],
        [0, 16],
        [-10, 14],
        [-4, 17],
        [-10, 14],
        [-3, 3],
        [-24, 28],
        [-10, 9],
        [-2, 1],
        [-5, 15],
        [-3, 20],
        [-7, 21],
        [-5, 26],
        [-1, 14],
        [-1, 16],
        [-6, 14],
        [0, 11],
        [-8, 15],
        [-8, 9],
        [-11, 10],
        [-10, 13],
        [-3, 15],
        [-1, 20],
        [6, 26],
        [9, 18],
        [12, 37],
        [2, 30],
        [8, 49],
        [12, 27],
        [28, 54],
        [10, 60],
        [7, 58],
        [15, 46],
        [23, 48],
        [-25, 137],
        [-5, 36],
        [-5, 26],
        [-4, 33],
        [-46, 45],
        [-22, 20],
        [-42, 22],
        [-29, 21],
        [-21, 15],
        [-19, 12],
        [-13, 9],
        [-17, 12],
        [-24, 18],
        [-12, 16],
        [-16, 16],
        [-14, 14],
        [-10, 12],
        [-12, 9],
        [-16, 7],
        [-10, 11],
        [-6, 10],
        [-11, 9],
        [-7, 14],
        [-10, 20],
        [-6, 11],
        [-4, 10],
        [-4, 10],
        [-5, 10],
        [-17, 32],
        [-7, 31],
        [-7, 23],
        [-1, 17],
        [-4, 12],
        [-2, 17],
        [-5, 10],
        [-3, 9],
        [-3, 17],
        [-2, 19],
        [-8, 25],
        [-9, 28],
        [-8, 28],
        [2, 20],
        [12, 17],
        [11, 16],
        [9, 18],
        [10, 16],
        [13, 15],
        [10, 10],
        [8, 13],
        [10, 10],
        [12, 14],
        [12, 16],
        [13, 11],
        [20, 15],
        [17, 13],
        [13, 10],
        [17, 12],
        [21, 11],
        [26, 8],
        [21, 7],
        [21, 7],
        [28, 3],
        [17, 9],
        [9, 2],
        [9, 6],
        [6, 2],
        [7, 2],
        [7, 6],
        [7, 4],
        [5, 5],
        [9, 4],
        [8, 7],
        [12, 4],
        [11, 8],
        [11, 9],
        [14, 8],
        [17, 4],
        [13, 2],
        [15, 4],
        [12, 4],
        [10, 8],
        [13, 3],
        [11, 6],
        [22, 2],
        [19, 4],
        [21, 5],
        [15, -4],
        [22, -4],
        [29, -1],
        [32, -1],
        [24, 3],
        [20, 7],
        [14, 6],
        [15, 8],
        [13, 8],
        [11, 4],
        [8, 4],
        [9, 2],
        [8, 2],
        [10, 0],
        [22, -8],
        [25, -12],
        [30, -17],
        [26, -22],
        [19, -21],
        [13, -12],
        [8, -12],
        [20, -17],
        [9, -12],
        [6, -10],
        [16, -21],
        [8, -16],
        [10, -12],
        [9, -18],
        [9, -13],
        [12, -18],
        [25, -4],
        [21, -4],
        [29, -5],
        [22, -5],
        [10, -4],
        [15, -4],
        [26, -12],
        [16, 0],
        [12, 0],
        [14, 2],
        [10, 0],
        [15, -4],
        [10, -8],
        [6, -6],
        [7, -10],
        [6, -5],
        [7, -4],
        [3, 2],
        [13, 1],
        [13, 1],
        [12, 2],
        [6, 4],
        [2, 4],
        [1, 9],
        [5, 4],
        [12, 14],
        [25, 24],
        [17, 8],
        [68, 10],
        [13, 23],
        [6, 16],
        [5, 10],
        [7, 12],
        [10, 10],
        [12, 9],
        [8, 12],
        [8, 10],
        [3, 11],
        [14, 18],
        [17, 21],
        [20, 32],
        [19, 35],
        [10, 18],
        [14, 18],
        [9, 20],
        [12, 33],
        [13, 29],
        [4, 77],
        [0, 66],
        [1, 52],
        [8, 28],
        [8, 27],
        [15, 37],
        [14, 16],
        [14, 14],
        [17, 14],
        [18, 10],
        [16, 10],
        [17, 10],
        [19, 7],
        [17, 13],
        [10, 10],
        [10, 11],
        [10, 11],
        [15, 11],
        [16, 12],
        [13, 10],
        [19, 6],
        [18, 4],
        [21, 8],
        [26, 12],
        [33, 10],
        [32, 6],
        [36, 8],
        [26, 10],
        [25, 0],
        [19, 4],
        [14, 12],
        [11, 24],
        [14, 71],
        [3, 19],
        [7, 34],
        [6, 20],
        [7, 33],
        [7, 28],
        [-2, 20],
        [0, 20],
        [0, 25],
        [2, 8],
        [6, 9],
        [4, 9],
        [8, 8],
        [13, 15],
        [14, 14],
        [17, 10],
        [26, 14],
        [13, 9],
        [26, 2],
        [16, 2],
        [22, 2],
        [14, 2],
        [16, 0],
        [24, 4],
        [13, 2],
        [16, 0],
        [23, -8],
        [12, -10],
        [14, -21],
        [22, -4],
        [26, -6],
        [35, -6],
        [18, -2],
        [14, 0],
        [10, 4],
        [13, 10],
        [16, 12],
        [17, 6],
        [17, 9],
        [19, 2],
        [26, -7],
        [43, -16],
        [38, -24],
        [36, -35],
        [30, -31],
        [32, -34],
        [28, -22],
        [27, -24],
        [37, -37],
        [45, -39],
        [37, -24],
        [40, -34],
        [40, -33],
        [14, -26],
        [20, -20],
        [-2, -32],
        [23, -20],
        [21, -35],
        [29, -40],
        [40, -42],
        [132, -38],
        [110, 8],
        [71, 12],
        [63, 10],
        [41, 4],
        [36, 4],
        [34, 2],
        [35, -4],
        [63, 16],
        [101, 31],
        [67, 25],
        [60, 25],
        [38, 14],
        [103, 112],
        [33, 17],
        [29, -9],
        [286, -102],
        [53, -55],
        [72, -82],
        [74, -42],
        [37, -30],
        [49, -40],
        [56, -9],
        [38, 3],
        [37, 27],
        [40, 32],
        [18, 19],
        [17, 34],
        [2, 24],
        [-8, 34],
        [17, 43],
        [18, 30],
        [24, 22],
        [25, 14],
        [20, 4],
        [41, 4],
        [23, 27],
        [13, 27],
        [10, 26],
        [10, 16],
      ],
      [
        [175515, 124941],
        [-3601, 578],
        [-634, 49],
        [-2081, 489],
        [-180, -142],
        [-219, -312],
        [-30, -40],
        [10, -38],
        [20, -17],
        [10, -23],
        [11, -21],
        [-13, -16],
        [-17, 0],
        [-33, 4],
        [-18, -12],
        [-12, -35],
        [11, -37],
        [8, -25],
        [4, -34],
        [23, -70],
        [1, -21],
        [-5, -25],
        [-6, -28],
        [-21, -22],
        [-45, -18],
        [-26, -18],
        [-10, -25],
        [9, -14],
        [15, -42],
        [-4, -73],
        [-20, -28],
        [-7, 4],
        [-8, -3],
        [-6, -11],
        [-2, -10],
        [-6, -3],
        [-16, -4],
        [-18, 1],
        [-27, 22],
        [-10, 22],
        [-25, 11],
        [-58, -33],
        [-29, -24],
        [-11, 6],
        [-9, 1],
        [-8, -7],
        [2, -10],
        [-2, -10],
        [-131, -103],
        [19, 214],
        [-12, 83],
        [-31, 88],
        [-79, 72],
        [-49, 30],
        [-45, 8],
        [-117, -32],
        [-142, -11],
        [-135, 57],
        [-69, 68],
        [-25, 72],
        [-10, 62],
        [-8, 38],
        [4, 42],
        [47, 73],
        [10, 49],
        [-31, 39],
        [-42, 21],
        [-37, 3],
        [-39, -9],
        [-59, -31],
        [-40, -30],
        [-118, -122],
        [-66, -9],
        [-73, -65],
        [-47, 90],
        [-73, 171],
        [-63, 152],
        [-16, 30],
        [-6, 11],
        [-39, 58],
        [16, 218],
        [2, 22],
        [0, 1],
        [0, 5],
        [-33, 1],
        [5, 13],
        [12, 36],
        [-2, 0],
        [-6, 2],
        [-50, 17],
        [-2, 44],
        [-2, 25],
        [-6, 81],
        [-10, 143],
        [-10, 195],
        [-6, 50],
        [-16, 30],
        [-73, 84],
        [-125, 145],
        [-34, 25],
        [-233, 2],
        [-85, 28],
        [-50, 22],
        [-40, 49],
        [-28, 20],
        [-43, 34],
        [-33, 26],
        [2, 55],
        [11, 52],
        [21, 54],
        [35, 36],
        [6, 15],
        [27, 75],
        [37, 96],
        [7, 27],
        [4, 16],
        [4, 14],
        [-4, 0],
        [-55, 32],
        [-1, 4],
        [-3, 18],
        [-1, 2],
        [-1, 6],
        [-9, 46],
        [-5, 0],
        [-6, 0],
        [-36, -8],
        [-23, 38],
        [-199, -199],
        [-22, -60],
        [-151, 5],
        [-59, 12],
        [-54, 31],
        [-32, 61],
        [-46, 85],
        [-31, 51],
        [-59, 20],
        [-33, 22],
        [-11, 29],
        [-25, 19],
        [-42, 12],
        [-44, 10],
        [-48, 1],
        [-49, 17],
        [-14, 21],
        [2, 28],
        [12, 44],
        [6, 26],
        [-2, 22],
        [-7, 10],
        [-13, 6],
        [-22, 0],
        [-44, -6],
        [-90, -8],
        [-49, 10],
        [-28, 39],
        [-6, 44],
        [7, 58],
        [32, 51],
        [18, 41],
        [2, 37],
        [14, 25],
        [7, 30],
        [11, 44],
        [3, 32],
        [25, 31],
        [56, 27],
        [33, 25],
        [21, 56],
        [-10, 36],
        [-18, 28],
        [-30, 43],
        [-59, 89],
        [-49, 101],
        [-42, 80],
        [-10, 34],
        [-6, 43],
        [-11, 26],
        [-44, 58],
        [-38, 75],
        [0, 37],
        [-14, 30],
        [-84, -26],
        [-819, 312],
        [-3258, -1236],
        [-2465, 828],
        [-164, 198],
        [-1489, -525],
      ],
      [
        [156517, 128932],
        [-1605, 1184],
        [-598, 442],
        [550, 1634],
        [-1177, 2185],
        [-2082, 664],
        [-1445, 1764],
        [-10, 13],
        [-2, 0],
        [-2, 4],
        [-2, 3],
        [-2, 2],
        [-9, 10],
        [-4, 5],
        [-25, 30],
        [-2, 3],
        [-4, 5],
        [-10, 12],
        [-2, 2],
        [-25, 32],
        [-53, 61],
        [24, 34],
        [21, 46],
        [8, 30],
        [-8, 27],
        [-33, 30],
        [-40, 18],
        [-21, 8],
        [0, 11],
        [-5, 102],
        [7, 15],
        [45, 40],
        [-2, 32],
        [-15, 23],
        [-10, 14],
        [-3, 16],
        [17, 30],
        [27, 31],
        [14, 29],
        [16, 71],
        [13, 40],
        [6, 34],
        [5, 42],
        [11, 64],
        [-7, 66],
        [-11, 25],
        [-29, 82],
        [-14, 30],
        [-20, 20],
        [-24, 16],
        [-55, 36],
        [-48, 25],
        [-27, 17],
        [-41, 15],
        [-16, 3],
        [-15, 3],
        [-40, 6],
        [-28, 10],
        [-20, 22],
        [-13, 26],
        [-30, 58],
        [-27, 221],
        [-13, 19],
        [-21, 9],
        [-18, -7],
        [-12, 0],
        [-9, 8],
        [0, 24],
        [-8, 16],
        [-30, 33],
        [-14, 74],
        [-23, 229],
        [-1, 40],
        [-8, 26],
        [-14, 8],
        [-20, -12],
        [-17, -5],
        [-18, 2],
        [-15, 10],
        [-13, 16],
        [-13, 34],
        [-2, 34],
        [-24, 28],
        [-14, 13],
        [-14, 13],
        [-35, 27],
        [-24, 29],
        [0, 31],
        [21, 40],
        [3, 27],
        [0, 3],
        [-3, 5],
        [-4, 5],
        [-8, 14],
        [-20, 15],
        [-6, 0],
        [-1, 0],
        [-21, 2],
        [-4, 0],
        [-2, 1],
        [-14, 0],
        [-2, 0],
        [-3, 0],
        [-7, 0],
        [-13, 1],
        [-27, 22],
        [-2, 6],
        [-9, 34],
        [-1, 19],
        [-1, 27],
        [-2, 27],
        [0, 12],
        [-4, -2],
        [-817, -333],
        [-36, 246],
        [-19, 109],
        [0, 6],
        [-87, 470],
        [-115, 546],
        [-41, 213],
        [-2, 190],
        [4, 219],
        [9, 282],
        [-6, 252],
        [-20, 355],
        [-258, 509],
        [-6, 13],
        [8, 25],
        [1, 25],
        [10, 34],
        [12, 21],
        [12, 25],
        [39, 49],
        [79, 68],
        [22, 9],
        [53, 5],
        [39, 4],
        [128, 21],
        [140, 21],
        [106, 20],
        [81, 35],
        [122, 55],
        [26, 7],
        [65, 2],
        [24, 18],
        [38, 26],
        [30, 12],
        [36, 1],
        [70, -7],
        [442, -72],
        [60, -22],
        [55, -22],
        [36, -8],
        [16, 4],
        [17, 2],
        [36, 14],
        [38, 16],
        [65, 29],
        [37, 7],
        [46, -4],
        [27, -14],
        [13, -4],
        [13, -6],
        [27, 15],
        [13, 17],
        [23, 27],
        [-2, 8],
        [-8, 167],
        [-51, 83],
        [55, 84],
        [6, 57],
        [-16, 42],
        [540, 152],
        [466, 88],
        [428, 85],
        [177, 110],
        [255, 162],
        [117, 102],
        [1540, 288],
        [-588, 2373],
        [-1376, 330],
        [-320, 79],
        [-374, 83],
        [-227, 78],
        [-123, 36],
        [-14, 2],
        [-92, 20],
        [-118, 26],
        [-200, 56],
        [-150, 28],
        [1, 21],
        [-3, 26],
        [-3, 19],
        [0, 15],
        [-1, 28],
        [-18, 43],
        [-6, 25],
        [-6, 26],
        [-6, 22],
        [-16, 39],
        [-11, 25],
        [-4, 25],
        [3, 16],
        [1, 39],
        [8, 29],
        [2, 15],
        [-6, 27],
        [-2, 18],
        [23, 28],
        [18, 22],
        [8, 16],
        [6, 16],
        [17, 14],
        [6, 16],
        [-2, 28],
        [-2, 29],
        [10, 15],
        [14, 19],
        [9, 8],
        [14, 6],
        [13, 2],
        [14, 4],
        [6, 15],
        [0, 9],
        [-8, 26],
        [-4, 3],
        [-14, 19],
        [2, 8],
        [8, 12],
        [31, 34],
        [28, 0],
        [53, 2],
        [13, 0],
        [14, 0],
        [15, 6],
        [25, 23],
        [34, 22],
        [44, 29],
        [18, 4],
        [17, 4],
        [10, 8],
        [8, 4],
        [13, 4],
        [10, 4],
        [12, 4],
        [12, 4],
        [7, 6],
        [7, 6],
        [3, 6],
        [2, 7],
        [2, 6],
        [9, 18],
        [23, 43],
        [11, 24],
        [2, 76],
        [-2, 39],
        [22, 132],
        [2, 67],
        [-12, 62],
        [6, 35],
        [-14, 48],
        [-10, 24],
        [-7, 12],
        [-7, 10],
        [-7, 12],
        [-6, 5],
        [-10, 6],
        [-4, 7],
        [0, 8],
        [-3, 7],
        [-2, 19],
        [-6, 19],
        [-5, 18],
        [-5, 18],
        [-6, 33],
        [-6, 24],
        [-4, 18],
        [-4, 13],
        [-10, 33],
        [-5, 18],
        [-5, 18],
        [-8, 26],
        [-9, 36],
        [-9, 37],
        [-8, 12],
        [-12, 22],
        [-27, 52],
        [-23, 50],
        [-10, 18],
        [-18, 27],
        [-6, 11],
        [-9, 30],
        [-9, 30],
        [-5, 11],
        [-14, 22],
        [-13, 22],
        [-23, 34],
        [-25, 41],
        [-17, 31],
        [-8, 23],
        [-1, 16],
        [1, 18],
        [-3, 16],
        [-4, 17],
        [-4, 13],
        [3, 19],
        [3, 22],
        [15, 54],
        [-2, 17],
        [-4, 16],
        [-5, 21],
        [-11, 30],
        [-15, 23],
        [-11, 14],
        [-12, 16],
        [-10, 14],
        [-17, 27],
        [-5, 24],
        [-7, 36],
        [-12, 38],
        [-7, 43],
        [-4, 8],
        [-13, 23],
        [-8, 30],
        [-10, 33],
        [-18, 52],
        [-12, 35],
        [-10, 19],
        [-12, 18],
        [-50, 30],
        [-46, 27],
        [-30, 35],
        [-10, 18],
        [-9, 16],
        [-40, 66],
        [-24, 40],
        [-7, 9],
        [-4, 8],
        [-8, 7],
        [-13, 7],
        [-15, 7],
        [-24, 9],
        [-29, 10],
        [-20, 10],
        [-20, 12],
        [-18, 16],
        [-20, 22],
        [-6, 26],
        [-32, 44],
        [-22, 30],
        [-24, 26],
        [-18, 20],
        [-12, 18],
        [-9, 17],
        [-7, 24],
        [-26, 99],
        [-60, 56],
        [-20, 94],
        [-10, 38],
        [-7, 18],
        [-10, 19],
        [-5, 51],
        [-2, 20],
        [-17, 62],
        [-9, 28],
        [-17, 37],
        [-27, 58],
        [-9, 38],
        [-11, 38],
        [5, 25],
        [-4, 29],
        [-4, 31],
        [-2, 14],
        [-3, 30],
        [-3, 21],
        [-4, 15],
        [-17, 64],
        [0, 44],
        [-8, 19],
        [-4, 23],
        [-4, 28],
        [-4, 23],
        [-2, 22],
        [0, 14],
        [-1, 19],
        [-2, 24],
        [-1, 21],
        [-16, 38],
        [-7, 33],
        [-9, 38],
        [-5, 18],
        [-6, 19],
        [-9, 8],
        [-11, 9],
        [-8, 9],
        [-10, 9],
        [-19, 27],
        [-10, 55],
        [-6, 38],
        [-4, 14],
        [-22, 44],
        [-8, 17],
        [-8, 18],
        [1, 29],
        [3, 35],
        [4, 72],
        [-10, 18],
        [-13, 25],
        [-12, 22],
        [-5, 11],
        [-6, 13],
        [-6, 11],
        [-6, 22],
        [-4, 22],
        [-4, 30],
        [-6, 25],
        [-2, 13],
        [-2, 10],
        [-6, 6],
        [-6, 9],
        [-2, 14],
        [0, 7],
        [-2, 11],
        [-4, 11],
        [-12, 27],
        [-15, 32],
        [-13, 32],
        [-3, 20],
        [-4, 29],
        [2, 31],
        [4, 39],
        [-4, 52],
        [-4, 31],
        [-6, 53],
        [-38, 53],
        [15, 15],
        [7, 16],
        [16, 12],
        [24, -4],
        [10, -7],
        [7, 14],
        [8, 18],
        [9, 14],
        [8, 14],
        [-7, 32],
        [-22, 12],
        [3, 26],
        [94, 64],
        [31, 11],
        [99, 13],
        [96, 25],
        [24, -8],
        [31, 8],
        [12, 14],
        [13, 20],
        [14, 37],
        [30, 68],
        [22, 37],
        [22, 27],
        [42, 19],
        [40, 0],
        [54, -3],
        [36, 13],
        [55, 1],
        [26, 15],
        [14, 18],
        [7, 14],
        [-1, 16],
        [-14, 30],
        [0, 8],
        [-3, 47],
        [5, 14],
        [11, 14],
        [12, 10],
        [16, 8],
        [23, 4],
        [18, 4],
        [6, 4],
        [19, 15],
        [18, 14],
        [13, 11],
        [38, 34],
        [9, 9],
        [9, 10],
        [9, 9],
        [11, 11],
        [17, 41],
        [4, 12],
        [0, 17],
        [-2, 6],
        [-8, 8],
        [-7, 4],
        [-6, 4],
        [-11, 1],
        [-14, -13],
        [-4, -16],
        [-9, -57],
        [-6, -11],
        [-14, -12],
        [-30, -12],
        [-42, -22],
        [-47, 11],
        [-19, 7],
        [-6, 25],
        [15, 45],
        [27, 19],
        [24, 5],
        [29, 15],
        [47, 52],
        [28, 45],
        [4, 4],
        [4, 3],
        [13, 9],
        [62, -46],
        [12, -30],
        [14, -25],
        [23, -17],
        [31, 3],
        [38, -18],
        [12, -16],
        [14, -11],
        [36, -1],
        [19, -16],
        [19, -41],
        [23, -26],
        [20, -57],
        [0, -18],
        [-7, -33],
        [2, -14],
        [7, -12],
        [30, -37],
        [14, -25],
        [9, -42],
        [13, -24],
        [31, -39],
        [24, -42],
        [28, -33],
        [7, -21],
        [-7, -33],
        [-16, -25],
        [-27, -22],
        [-7, -9],
        [0, -20],
        [6, -13],
        [12, -4],
        [48, -2],
        [30, -17],
        [66, -12],
        [-8, 103],
        [-15, 155],
        [-16, 197],
        [-393, 512],
        [-772, 999],
        [-302, 394],
        [1484, 1900],
        [116, 156],
        [117, 158],
        [16, 52],
        [13, 12],
        [6, 16],
        [4, 22],
        [-2, 16],
        [-14, 47],
        [4, 19],
        [8, 10],
        [14, 11],
        [21, 6],
        [22, 1],
        [22, -3],
        [35, -11],
        [203, -79],
        [47, -15],
        [20, -1],
        [36, 7],
        [20, 11],
        [22, 29],
        [10, 26],
        [8, 31],
        [4, 18],
        [0, 27],
        [-14, 31],
        [-2, 13],
        [0, 28],
        [6, 26],
        [18, 29],
        [34, 42],
        [32, 36],
        [15, 30],
        [46, 58],
        [26, 30],
        [47, 49],
        [46, 36],
        [20, 10],
        [10, 8],
        [10, 16],
        [10, 17],
        [31, 66],
        [5, 8],
        [10, 8],
        [12, 3],
        [45, 8],
        [14, 2],
        [31, 2],
        [53, 3],
        [46, -5],
        [176, -48],
        [21, -2],
        [27, 0],
        [31, -10],
        [30, 3],
        [159, 64],
        [38, 20],
        [17, 2],
        [39, -2],
        [39, -12],
        [29, -13],
        [33, -17],
        [67, -43],
        [21, -24],
        [41, -31],
        [47, -20],
        [48, 0],
        [14, -4],
        [10, -15],
        [26, -62],
        [35, -24],
        [52, -25],
        [42, -16],
        [42, -6],
        [51, 2],
        [47, 9],
        [24, 0],
        [41, 4],
        [18, 17],
        [8, 15],
        [7, 22],
        [12, 30],
        [12, 22],
        [2, 20],
        [6, 22],
        [12, 16],
        [6, 5],
        [8, 5],
        [22, 1],
        [18, -2],
        [14, -8],
        [15, -7],
        [16, -7],
        [31, -6],
        [47, -1],
        [54, 10],
        [25, 8],
        [30, 13],
        [28, 19],
        [11, 12],
        [11, 16],
        [4, 10],
        [-1, 10],
        [2, 30],
        [-4, 30],
        [-8, 19],
        [-19, 15],
        [-29, 12],
        [-16, 8],
        [-30, 17],
        [-18, 12],
        [-22, 19],
        [-8, 20],
        [0, 20],
        [2, 18],
        [12, 25],
        [28, 32],
        [25, 18],
        [15, 22],
        [9, 26],
        [0, 67],
        [-5, 10],
        [-8, 30],
        [2, 18],
        [21, 17],
        [43, 17],
        [36, 10],
        [79, 18],
        [116, 10],
        [69, 0],
        [60, 4],
        [44, 6],
        [15, 8],
        [29, 15],
        [51, 39],
        [78, 59],
        [41, 20],
        [70, 26],
        [68, 28],
        [40, 9],
        [34, -7],
        [35, -14],
        [26, -26],
        [33, -26],
        [47, -14],
        [48, 10],
        [40, 18],
        [15, 16],
        [13, 18],
        [22, 41],
        [28, 13],
        [27, 1],
        [28, -5],
        [32, -21],
        [14, -23],
        [5, -22],
        [13, -16],
        [16, -2],
        [12, 4],
        [9, 12],
        [9, 16],
        [2, 24],
        [-2, 11],
        [-10, 9],
        [-16, 8],
        [-26, 6],
        [-6, 5],
        [-5, 9],
        [0, 12],
        [4, 10],
        [9, 6],
        [5, 7],
        [6, 6],
        [15, 17],
        [10, 18],
        [16, 24],
        [14, 28],
        [4, 20],
        [6, 28],
        [14, 47],
        [2, 23],
        [-4, 24],
        [-14, 41],
        [-8, 16],
        [-6, 28],
        [4, 17],
        [8, 7],
        [12, 3],
        [13, 0],
        [14, -6],
        [21, -10],
        [15, -13],
        [4, -14],
        [0, -14],
        [8, -22],
        [13, -12],
        [12, -12],
        [-24, 674],
        [-3, 775],
        [1211, 113],
        [1213, 113],
        [2037, 1947],
        [161, 823],
        [-918, 1135],
      ],
      [
        [204894, 50329],
        [-275, -434],
        [-271, -391],
        [-47, -77],
        [-6, 74],
        [-10, 43],
        [-44, 6],
        [-42, 5],
        [-26, 5],
        [-43, 6],
        [-30, 3],
        [-74, 13],
        [-49, 8],
        [-15, 2],
        [-68, -50],
        [-12, 0],
        [-8, -6],
        [-10, -6],
        [-12, -1],
        [-12, 5],
        [-10, 6],
        [-16, 8],
        [-24, 5],
        [-24, -2],
        [-21, -1],
        [-22, 15],
        [-17, 4],
        [-11, -8],
        [-4, -12],
        [-2, -10],
        [-6, -25],
        [-6, -4],
        [-13, -2],
        [-2, 0],
        [-56, 61],
        [-11, 13],
        [-16, 18],
        [-74, 72],
        [-98, 84],
        [-124, 103],
        [-73, 60],
        [-31, 25],
        [-145, 123],
        [-218, 184],
        [-93, 78],
        [-44, 44],
        [-37, 43],
        [-65, 87],
        [-150, 205],
        [-103, 138],
        [-32, 45],
        [-78, 98],
        [-67, 93],
        [-99, 134],
        [-35, 47],
        [-311, -244],
        [-95, 77],
        [2, 0],
        [0, 1],
        [73, 58],
        [-29, 39],
        [1, 28],
        [-37, -2],
        [-55, 34],
        [-32, -26],
        [-17, -16],
        [-51, -6],
        [-8, 41],
        [47, 73],
        [-45, 2],
        [-16, 45],
        [-38, -8],
        [-37, 80],
        [-70, -37],
        [-33, 4],
        [-22, 157],
        [26, 36],
        [-15, 50],
        [32, 87],
        [-15, 69],
        [-124, -25],
        [-15, -2],
        [-1, 0],
        [18, -118],
        [-13, -11],
        [-20, 3],
        [-10, -7],
        [-2, 0],
        [8, -26],
        [0, -12],
        [-10, -6],
        [-18, 0],
        [0, 0],
        [-8, -10],
        [-2, -20],
        [-6, -4],
        [-13, -1],
        [-13, 5],
        [-15, -16],
        [-8, -28],
        [0, -1],
        [-15, -16],
        [-1, -1],
        [-9, -15],
        [2, -4],
        [0, -1],
        [-10, -5],
        [-4, -6],
        [6, -31],
        [6, -12],
        [-4, -11],
        [-8, -20],
        [4, -18],
        [13, -6],
        [2, 2],
        [12, 14],
        [15, -31],
        [16, -4],
        [42, -128],
        [-8, -33],
        [-6, -31],
        [-14, -39],
        [1, -24],
        [9, -18],
        [24, -10],
        [30, -2],
        [33, -17],
        [10, -18],
        [2, -44],
        [-13, -29],
        [-19, -32],
        [-1, -31],
        [8, -35],
        [25, -12],
        [26, 4],
        [30, 25],
        [0, 1],
        [16, 17],
        [14, 10],
        [20, -2],
        [17, -6],
        [9, -10],
        [-2, -16],
        [-11, -15],
        [0, 0],
        [0, -1],
        [-11, -10],
        [-8, -5],
        [-5, -12],
        [26, -13],
        [23, -27],
        [19, -16],
        [8, -42],
        [13, -55],
        [-18, -35],
        [0, -1],
        [0, -1],
        [-961, -855],
        [-1024, 298],
        [-1, 0],
        [-163, -870],
        [0, -2],
        [-287, -57],
        [-90, 627],
        [-373, 180],
        [-598, -112],
        [-448, 265],
        [-130, -127],
        [-303, -300],
        [-1, -1],
        [684, -611],
        [-199, -258],
        [-235, -308],
        [-137, -176],
        [-31, -46],
      ],
      [
        [89361, 273967],
        [-924, 322],
        [-313, -253],
        [339, -3941],
        [-1405, -1440],
        [356, -2005],
        [-49, -50],
        [-465, -480],
        [-4, -5],
        [-858, -1153],
        [-1995, -318],
        [-286, 129],
        [-136, -29],
        [-341, 106],
        [-850, -910],
        [-124, 47],
        [-123, 45],
        [-242, 3],
        [-91, 62],
        [-137, 67],
        [-118, -22],
        [-92, -94],
        [-48, -17],
        [-48, -17],
        [-91, 57],
        [-93, 59],
        [-192, -8],
        [-173, -63],
        [-269, 63],
        [-54, 8],
        [-27, 0],
        [-107, 1],
        [-88, -50],
        [-52, -2],
        [-133, 44],
        [-109, 45],
        [-146, 53],
        [-112, -10],
        [-39, -31],
        [-38, -31],
        [-33, -131],
        [-92, -139],
        [-5, -147],
        [92, -197],
        [-2, -161],
        [52, -77],
        [11, -22],
        [39, -129],
        [-666, -171],
        [-131, 123],
        [-123, 93],
        [-24, 12],
        [-24, 7],
        [-46, 58],
        [-13, 28],
        [-34, 34],
        [-25, 32],
        [-29, 20],
        [-38, 133],
        [-22, 41],
        [-122, 175],
        [-71, -59],
        [-90, -57],
        [-72, -34],
        [-50, -13],
        [-61, -8],
        [-63, 6],
        [-56, 1],
        [-80, 7],
        [-49, 14],
        [-209, 68],
        [-62, 33],
        [-604, 344],
        [-289, 120],
        [-64, 32],
        [-88, 46],
        [-44, 53],
        [-80, 19],
        [-46, 21],
        [-77, 20],
        [-163, 40],
        [-234, 131],
        [-109, 244],
        [-14, 344],
        [-80, 197],
        [-46, 172],
        [44, 238],
        [904, -155],
        [237, 693],
        [109, 489],
        [88, 560],
        [183, 62],
        [241, 466],
        [-7, 224],
        [330, 924],
        [-1126, 24],
        [-591, -668],
        [-374, 914],
        [-561, 144],
        [-2038, 330],
        [-1, -109],
        [-2, -565],
        [23, -406],
        [-22, -358],
        [-592, 209],
      ],
      [
        [72493, 268488],
        [-232, 82],
        [-450, 150],
        [-185, 72],
        [-99, 4],
        [-166, 39],
        [-651, 143],
        [-83, 808],
        [-36, 345],
        [-12, 111],
        [-96, 741],
        [0, 4],
        [5, 103],
        [13, 306],
        [6, 179],
        [-84, 376],
        [-40, 180],
        [0, 4],
        [-31, 117],
        [-19, 74],
        [-43, 49],
        [-14, 126],
        [-66, 395],
        [-71, 551],
        [617, 42],
        [747, 74],
        [854, 475],
        [859, 472],
        [-2265, -289],
        [-483, 1312],
        [-539, 571],
        [-9, 129],
        [-14, 80],
        [-67, 245],
        [-273, 183],
        [-333, 1],
        [-109, 64],
        [-649, -250],
        [-74, -595],
        [-1078, -15],
        [-162, 456],
        [-158, 316],
        [-126, 40],
        [-126, 40],
        [-46, -216],
        [-17, -208],
        [2, -259],
        [-2, -31],
        [-21, -73],
        [7, -44],
        [-10, -18],
        [-15, -11],
        [-66, -4],
        [-44, 1],
        [-23, -21],
        [-11, -9],
        [-43, -28],
        [-58, -9],
        [-58, 5],
        [-36, 7],
        [-132, -91],
        [-733, 1059],
        [-385, -532],
        [-310, 672],
        [-14, 27],
        [-197, 394],
        [-185, 399],
        [-10, 47],
        [-25, -1],
        [-10, 0],
        [-33, 23],
        [-40, 8],
        [-32, 11],
        [-25, 32],
        [-28, 89],
        [-48, 70],
        [-42, 16],
        [-4, 2],
        [-14, 6],
        [-47, 12],
        [-20, 6],
        [-35, 3],
        [-34, 3],
        [-98, -28],
        [-97, -30],
        [-31, 12],
        [-30, 14],
        [-87, 33],
        [-67, 39],
        [-45, 31],
        [-28, 39],
        [56, 205],
        [19, 48],
        [0, 43],
        [-18, 69],
        [-40, 92],
        [-20, 57],
        [-22, 34],
        [-26, 18],
        [-36, 15],
        [-53, 18],
        [-7, 2],
        [-33, 6],
        [-24, 5],
        [-22, 11],
        [14, 76],
        [37, 10],
        [22, 7],
        [8, 2],
        [-22, 298],
        [-6, 88],
        [-70, 93],
        [-18, 64],
        [-85, 136],
        [-22, -1],
        [-14, -20],
        [-64, 8],
        [-145, -31],
        [-7, -15],
        [-7, 1],
        [-7, 2],
        [-357, 111],
        [-104, -51],
        [-51, 63],
        [-133, 164],
        [-5, -4],
        [-69, -16],
        [-103, -58],
        [-41, -22],
        [-46, -23],
        [-38, -11],
        [-79, -15],
        [-48, 0],
        [-45, 8],
        [-30, 27],
        [-88, 54],
        [-8, -9],
        [-15, -21],
        [-10, -24],
        [-16, -4],
        [-25, -23],
        [-20, -14],
        [-15, -17],
        [-21, -31],
        [-28, 1],
        [-25, 12],
        [-29, 25],
        [-24, 38],
        [-43, 17],
        [-31, -10],
        [-23, -2],
        [-12, -3],
        [-45, -12],
        [-45, -36],
        [-40, -8],
        [-28, 28],
        [-38, 7],
        [-44, 20],
        [-40, 34],
        [-48, 46],
        [-39, 19],
        [-58, 26],
        [-79, 23],
        [-63, -2],
        [-65, 12],
        [-20, 17],
        [233, 189],
        [232, 216],
        [40, 88],
        [39, 203],
        [14, -16],
        [14, -7],
        [18, 1],
        [118, 80],
        [6, 4],
        [6, 5],
        [17, 10],
        [18, 10],
        [41, 22],
        [76, 47],
        [5, 0],
        [8, -4],
        [7, 6],
        [172, 99],
        [114, 30],
        [109, 20],
        [55, 10],
        [17, 2],
        [31, 14],
        [8, 2],
        [7, 3],
        [21, 24],
        [9, 14],
        [10, 18],
        [9, 33],
        [255, 574],
        [188, 221],
        [187, 223],
        [-149, 389],
        [-22, 27],
        [-8, 7],
        [-94, 62],
        [8, 10],
        [7, 11],
        [12, 30],
        [-29, 54],
        [-52, 103],
        [-4, 10],
        [13, 24],
        [1, 12],
        [-22, 36],
        [-19, 33],
        [-13, 24],
        [-30, 74],
        [-115, 181],
        [-8, 18],
        [-2, 5],
        [33, -15],
        [354, -3],
        [242, -5],
        [48, -2],
        [104, -2],
        [116, 114],
        [244, 228],
        [15, 8],
        [147, 73],
        [-3, 5],
        [-1, 30],
        [4, 145],
        [4, 65],
        [42, 90],
        [87, 88],
        [262, 191],
        [24, 10],
        [146, 22],
        [0, -4],
        [11, -22],
        [74, -95],
        [39, -38],
        [12, -8],
        [16, -65],
        [81, -43],
        [29, -45],
        [135, 100],
        [68, 114],
        [289, 372],
        [101, 177],
        [284, 398],
        [289, 95],
        [31, 24],
        [-121, 97],
        [-50, 90],
        [-914, 1625],
        [-5, 10],
        [-695, 9],
        [-269, -3],
        [-130, 9],
        [-131, 9],
        [-228, 8],
        [-182, 14],
        [-221, 10],
        [-120, 6],
        [39, -522],
        [-25, -4],
        [-2, 0],
        [-16, 0],
        [-37, -92],
        [-3, -12],
        [-7, -12],
        [-215, -219],
        [-47, -90],
        [-22, -84],
        [-16, -162],
        [-31, -75],
        [-35, -38],
        [-33, -39],
        [-148, -145],
        [-78, -94],
        [-26, -107],
        [5, -128],
        [13, -39],
        [-24, -4],
        [-66, -21],
        [-67, -21],
        [-58, 5],
        [-25, -60],
        [-23, 0],
        [-14, 0],
        [-17, 0],
        [-1102, -290],
        [96, -526],
        [-5, -6],
        [-100, 19],
        [-175, -229],
        [-16, -20],
        [-16, -20],
        [-48, 6],
        [-49, 8],
        [-254, 32],
        [-306, 18],
        [-99, 17],
        [-312, 21],
        [-98, 24],
        [-31, 21],
        [-9, 12],
        [-10, 12],
        [-254, 299],
        [-265, 244],
        [-44, 14],
        [-40, -4],
        [-54, -46],
        [-41, -31],
        [-43, -6],
        [-51, 16],
        [-36, 28],
        [-43, 62],
        [-71, 32],
        [-52, 2],
        [-12, -62],
        [4, -113],
        [17, -50],
        [92, -51],
        [38, -23],
        [16, -29],
        [6, -21],
        [5, -30],
        [5, -38],
        [19, -28],
        [8, -22],
        [6, -21],
        [-10, -32],
        [-46, 2],
        [-43, 20],
        [-49, 12],
        [-51, -25],
        [-7, 44],
        [-50, 9],
        [-56, 15],
        [-37, 32],
        [-58, -67],
        [-33, 39],
        [-31, 40],
        [-69, 88],
        [-97, -4],
        [-33, 35],
        [-15, 28],
        [-14, 57],
        [-32, -22],
        [-91, -86],
        [-49, 48],
        [-50, 88],
        [-42, 43],
        [-13, 60],
        [-20, 28],
        [65, 82],
        [33, 5],
        [47, 27],
        [22, 20],
        [10, 26],
        [-26, 28],
        [-4, 62],
        [-26, 33],
        [-39, -16],
        [-29, -19],
        [-28, -18],
        [-21, -22],
        [-9, -23],
        [32, -63],
        [-22, -37],
        [-25, -35],
        [-48, -25],
        [-56, 42],
        [-46, 39],
        [-30, 48],
        [-41, 24],
        [46, 8],
        [21, 11],
        [14, 2],
        [14, 3],
        [20, 26],
        [21, 41],
        [16, 8],
        [15, 10],
        [24, 14],
        [8, 20],
        [-8, 29],
        [-12, 23],
        [-14, 18],
        [32, 8],
        [33, 11],
        [34, 20],
        [-6, 37],
        [-38, 25],
        [1, 36],
        [26, 23],
        [21, 24],
        [-4, 29],
        [6, 32],
        [12, 27],
        [53, -25],
        [9, 32],
        [17, 24],
        [9, 28],
        [-4, 32],
        [-20, 25],
        [13, 32],
        [31, 40],
        [-28, 49],
        [-5, 27],
        [-14, 30],
        [-11, 30],
        [-14, 18],
        [-17, 23],
        [-7, 55],
        [-30, 49],
        [-40, 53],
        [-57, 50],
        [-74, 43],
        [-12, 6],
        [-93, -22],
        [-71, -34],
        [-58, -24],
        [-77, -27],
        [-34, -19],
        [-54, -36],
        [-43, -27],
        [-47, -40],
        [-88, -58],
        [-29, -40],
        [-23, -45],
        [4, -63],
        [36, -54],
        [29, -21],
        [28, -17],
        [20, -37],
        [-10, -14],
        [-10, -14],
        [-18, -16],
        [-21, -27],
        [8, -82],
        [-26, -31],
        [-18, -60],
        [-38, -38],
        [-18, -74],
        [-1, -47],
        [-43, -32],
        [-12, -28],
        [-10, -44],
        [-12, -20],
        [-33, -24],
        [-22, -31],
        [-18, -40],
        [3, -41],
        [38, -21],
        [22, 49],
        [26, 55],
        [41, 40],
        [28, -1],
        [27, -1],
        [49, -20],
        [36, -36],
        [42, 2],
        [33, -12],
        [33, -9],
        [37, 0],
        [34, 19],
        [24, 4],
        [21, 12],
        [25, -13],
        [42, 15],
        [30, -2],
        [16, -19],
        [12, -12],
        [16, -8],
        [46, -16],
        [26, -17],
        [49, -5],
        [34, -38],
        [46, -42],
        [7, -32],
        [12, -25],
        [0, -28],
        [16, -33],
        [-30, -28],
        [-37, -11],
        [0, -32],
        [-14, -59],
        [14, -65],
        [20, -25],
        [21, -16],
        [12, -21],
        [25, -12],
        [36, 3],
        [44, 35],
        [37, -4],
        [12, -37],
        [4, -27],
        [10, -38],
        [12, -40],
        [4, -28],
        [3, -32],
        [20, -32],
        [8, -25],
        [-25, -36],
        [-34, -32],
        [-37, -32],
        [-32, -40],
        [-2, -25],
        [-24, -39],
        [-30, -6],
        [-24, -36],
        [28, -29],
        [8, -69],
        [-2, -56],
        [8, -81],
        [14, -57],
        [12, -36],
        [12, -28],
        [-26, -12],
        [-20, -16],
        [-25, -32],
        [23, -29],
        [22, -50],
        [18, -20],
        [12, -52],
        [21, -33],
        [16, -49],
        [20, -28],
        [-18, -32],
        [-29, -43],
        [7, -45],
        [-13, -65],
        [16, -59],
        [35, -65],
        [27, -23],
        [17, -27],
        [7, -24],
        [12, -28],
        [-95, 31],
        [-534, 181],
        [-5, -458],
        [-2506, -1165],
        [-119, 55],
        [-62, 27],
        [-43, 10],
        [-51, -1],
        [-24, -26],
        [19, -35],
        [-1, -29],
        [-23, -17],
        [-32, -6],
        [-50, 8],
        [-27, 12],
        [-14, 0],
        [-14, 0],
        [-32, -8],
        [-31, -6],
        [-30, 2],
        [-35, -2],
        [-38, 2],
        [-42, 2],
        [-28, 4],
        [-37, 22],
        [-47, 51],
        [-33, 46],
        [-38, 72],
        [3, 57],
        [-39, -29],
        [-38, 4],
        [-39, 7],
        [-32, 0],
        [-31, 22],
        [-55, 58],
        [-28, -27],
        [-6, -35],
        [26, -37],
        [26, -28],
        [32, -28],
        [28, -26],
        [16, -37],
        [2, -46],
        [-8, -24],
        [-21, -26],
        [-24, -16],
        [-35, 22],
        [-20, 36],
        [-8, 30],
        [-10, 29],
        [-11, 20],
        [-16, 20],
        [-15, 21],
        [-27, 23],
        [-27, 32],
        [-47, -9],
        [-45, -55],
        [-28, -8],
        [-20, 6],
        [-19, 6],
        [-29, 18],
        [-7, 48],
        [-16, 48],
        [-27, 36],
        [-31, 31],
        [-49, 35],
        [-24, 54],
        [-29, 34],
        [-31, 18],
        [-33, -16],
        [-25, -24],
        [-47, -6],
        [-24, 28],
        [18, 42],
        [43, 1],
        [37, 8],
        [34, 10],
        [75, 58],
        [-11, 67],
        [-25, 85],
        [-50, -1],
        [-2, -59],
        [-16, -13],
        [-23, 1],
        [-19, -2],
        [-24, 4],
        [-31, 2],
        [-27, 0],
        [-21, 0],
        [-20, 3],
        [-27, -15],
        [-26, -10],
        [-48, -32],
        [-30, -4],
        [-33, -11],
        [-11, -23],
        [-12, -18],
        [-15, -24],
        [-30, -9],
        [-32, 11],
        [-28, 4],
        [-17, 24],
        [-56, 34],
        [-19, 28],
        [10, 8],
        [7, 10],
        [20, -2],
        [19, -3],
        [39, -3],
        [54, 19],
        [13, 59],
        [31, 27],
        [20, 110],
        [13, 28],
        [20, 38],
        [14, 60],
        [12, 48],
        [-10, 38],
        [-22, 29],
        [-22, 35],
        [-13, 19],
        [-19, 13],
        [-3, 36],
        [-6, 51],
        [43, 71],
        [36, 49],
        [36, 35],
        [-2, 36],
        [-66, 23],
        [-29, 43],
        [14, 50],
        [29, 51],
        [6, 24],
        [-277, 92],
        [-75, -63],
        [-145, 78],
        [64, 79],
        [-211, 52],
        [-177, 126],
        [-26, 127],
        [-141, -127],
        [-80, 155],
        [81, 30],
        [276, 103],
        [65, 88],
        [6, 8],
        [14, 166],
        [-221, 131],
        [-29, -101],
        [47, -209],
        [-150, -43],
        [-124, 87],
        [-29, 98],
        [98, 137],
        [-31, 315],
        [-10, 13],
        [-9, 12],
        [-45, -58],
        [-51, 39],
        [-263, 187],
        [-107, 45],
        [-143, 32],
        [-34, -28],
        [-301, 103],
        [-46, 94],
        [66, 235],
        [171, 153],
        [-11, 127],
        [29, 87],
        [-4, 9],
        [226, 113],
        [-1, 4],
        [1, 4],
        [0, 4],
        [-114, 84],
        [-46, 6],
        [-78, 55],
        [-7, 11],
        [-12, 15],
        [-3, 49],
        [-44, 87],
        [-33, 27],
        [-33, 26],
        [-16, 12],
        [-55, 10],
        [-40, -33],
        [-26, -2],
        [-25, 10],
        [-86, 108],
        [-43, 100],
        [176, 118],
        [125, 65],
        [123, 41],
        [-40, 115],
        [68, 64],
        [4, 223],
        [2, 11],
        [254, -56],
        [104, 0],
        [105, 0],
        [3, 0],
        [3, 0],
        [4, 0],
        [175, 81],
        [17, 6],
        [75, -4],
        [10, 10],
        [24, 60],
        [-10, 16],
        [-50, 70],
        [7, 14],
        [55, 153],
        [-6, 8],
        [-87, 130],
        [-11, 13],
        [-2, 4],
        [-30, 45],
        [-110, 101],
        [-18, 12],
        [-111, 36],
        [-14, 5],
        [-36, -17],
        [-148, 1],
        [-213, 61],
        [-33, 4],
        [-52, 2],
        [-69, -56],
        [-677, 197],
        [-695, 202],
        [-514, 149],
      ],
      [
        [156517, 128932],
        [-43, -702],
        [-310, 99],
        [-80, -771],
        [-34, -386],
        [-245, -365],
        [-73, -264],
        [50, -561],
        [-220, -408],
        [-71, -23],
        [-69, -24],
        [-198, -120],
        [-190, 256],
        [-30, 2],
        [-31, -101],
        [-45, -49],
        [-21, -92],
        [25, -22],
        [44, 26],
        [24, -16],
        [60, -104],
        [12, -68],
        [-6, -73],
        [207, -367],
        [-18, -124],
        [68, 14],
        [127, -60],
        [82, -73],
        [47, -96],
        [16, -147],
        [52, -127],
        [-2, -41],
        [57, -308],
        [-22, -54],
        [-120, -130],
        [-48, -54],
        [-97, -127],
        [-28, -18],
        [-46, 12],
        [-76, -30],
        [-142, -91],
        [-72, -82],
        [-45, -68],
        [-10, -82],
        [-33, -58],
        [-51, -70],
        [-29, -117],
        [-48, -160],
        [0, -223],
        [16, -140],
        [189, -377],
        [-4, -88],
        [-12, -64],
        [-19, -94],
        [-49, -67],
        [-34, -21],
        [-115, -22],
        [-28, -10],
        [-26, -39],
        [-12, -31],
        [-23, -42],
        [-9, -57],
        [-2, -68],
        [4, -23],
        [10, -20],
        [24, -25],
        [-2, -28],
        [-12, -31],
        [-22, -22],
        [-21, -15],
        [-9, -51],
        [3, -80],
        [7, -99],
        [16, -45],
        [-289, -116],
        [-8, 12],
        [-26, 8],
        [-68, 16],
        [-68, 15],
        [-89, 31],
        [-78, 54],
        [-46, 57],
        [-5, 64],
        [19, 59],
        [124, 112],
        [52, 102],
        [31, 110],
        [-53, -9],
        [-47, -8],
        [-140, -22],
        [-98, -18],
        [-379, -65],
        [-110, -19],
        [-124, -20],
        [-73, -12],
        [-41, -7],
        [-150, -26],
        [-152, -26],
        [-19, -4],
        [-151, -26],
        [-151, -24],
        [-61, -12],
        [-517, -87],
        [-44, -10],
        [-82, 46],
        [-361, 149],
        [-177, 72],
        [-178, 74],
        [-1, 17],
        [0, 1],
        [2, 55],
        [1, 49],
        [0, 4],
        [0, 119],
        [-132, -94],
        [-79, -50],
        [-29, -21],
        [-64, -41],
        [-43, -33],
        [-65, -45],
        [-176, -119],
        [-148, -102],
        [-270, -10],
        [-22, 0],
        [-142, -6],
        [-5, 0],
        [-142, -6],
        [-154, -6],
        [-201, -6],
        [-86, 151],
        [-4, 7],
        [-19, 35],
        [-109, -27],
        [-100, -25],
        [-22, -6],
        [-103, -27],
        [35, -126],
        [-52, -2],
        [-51, -2],
        [-70, -2],
        [-16, -1],
        [-89, -3],
        [-76, -3],
        [-13, 0],
        [-92, -4],
        [-93, -3],
        [-74, -3],
        [2, -2],
        [-24, 4],
        [-96, 17],
        [-11, -46],
        [-34, -139],
        [-20, -86],
        [-14, -46],
        [-25, -84],
        [-9, -33],
        [-37, -130],
        [-15, -53],
        [-52, -178],
        [8, -10],
        [28, -39],
        [14, -21],
        [13, -20],
        [28, -41],
        [28, -40],
        [22, -31],
        [-2, -1],
        [101, -144],
        [95, -136],
        [78, -115],
        [28, -44],
        [18, -28],
        [20, -27],
        [73, -99],
        [4, -6],
        [66, -93],
        [46, -62],
        [25, -36],
        [19, -25],
        [70, -98],
        [74, -103],
        [-29, -24],
        [-205, -178],
        [-200, -175],
        [-146, -127],
        [-313, -272],
        [-28, -24],
        [604, -917],
        [17, -21],
        [617, -935],
        [116, -175],
        [29, -47],
        [-21, -8],
        [-271, 4],
        [3, -6],
        [1, -2],
        [20, -46],
        [9, -17],
        [33, -60],
        [40, -80],
        [9, -17],
        [21, -45],
        [16, -29],
        [28, -14],
        [18, 6],
        [15, -14],
        [21, -20],
        [45, -47],
        [11, -5],
        [5, -4],
        [61, -58],
        [40, -38],
        [45, 30],
        [40, 26],
        [10, 7],
        [62, 45],
        [15, -25],
        [72, -112],
        [114, -169],
        [0, -37],
        [263, -448],
        [-19, -2],
        [-19, 0],
        [-106, -2],
        [-109, 0],
        [-2, 0],
        [-45, 0],
        [-80, 0],
        [-52, 0],
        [-75, 0],
        [-21, 0],
        [-22, 0],
        [-73, -2],
        [-121, 0],
        [-121, 0],
        [-125, -2],
        [-121, 0],
        [-120, -2],
        [-119, -2],
        [-119, 2],
        [-4, 0],
        [-122, 0],
        [-52, 0],
        [-342, -62],
        [-109, -84],
        [-197, -63],
        [-179, -116],
        [-205, 138],
        [-238, 91],
        [-50, -21],
        [-112, -234],
        [199, -142],
        [36, -7],
        [126, -85],
        [20, -14],
        [-20, -128],
        [-20, -147],
        [53, 21],
        [24, -10],
        [-5, -46],
        [-23, -16],
        [-92, -90],
        [-7, -2],
        [-19, -5],
        [-37, -27],
        [-3, -82],
        [7, -97],
        [0, -2],
        [16, -61],
        [32, -54],
        [30, -28],
        [60, -30],
        [41, -24],
        [42, -35],
        [48, -32],
        [16, -20],
        [6, -26],
        [0, -33],
        [-5, -37],
        [-8, -45],
        [-3, -33],
        [-2, -37],
        [0, -29],
        [10, -25],
        [26, -9],
        [17, -18],
        [4, -26],
        [-37, -7],
        [-106, 59],
        [-75, 36],
        [-65, 33],
        [-43, 33],
        [-39, -22],
        [-34, -41],
        [-38, -3],
        [-35, 34],
        [-41, 30],
        [-41, 12],
        [-27, 15],
        [-47, 61],
        [-47, 84],
        [-59, 75],
        [-16, 28],
        [-14, 8],
        [-14, 8],
        [-35, 2],
        [-35, 10],
        [-42, 10],
        [-30, 11],
        [-43, 28],
        [-51, 25],
        [-21, 14],
        [-20, 13],
        [-38, 38],
        [-16, 27],
        [-29, 52],
        [-38, 37],
        [-43, 24],
        [-49, 14],
        [-83, 33],
        [-98, 65],
        [-68, 42],
        [-48, 41],
        [-48, 46],
        [-23, 30],
        [-2, 22],
        [3, 16],
        [11, 14],
        [1, 25],
        [-15, 22],
        [-12, 12],
        [0, 10],
        [7, 12],
        [5, 12],
        [-7, 14],
        [-8, 4],
        [-11, 19],
        [-12, 35],
        [-2, 12],
        [2, 12],
        [10, 9],
        [0, 16],
        [-16, 11],
        [-18, 8],
        [-32, 14],
        [-28, 10],
        [-22, 9],
        [-10, 8],
        [-18, 4],
        [-5, 0],
        [-5, 0],
        [-5, -3],
        [-10, -2],
        [-9, 1],
        [-9, 12],
        [0, 14],
        [5, 3],
        [12, 9],
        [0, 8],
        [-19, 19],
        [-69, 65],
        [-39, 39],
        [-6, 10],
        [-2, 11],
        [-10, 13],
        [-11, 5],
        [-10, 9],
        [-4, 7],
        [-2, 22],
        [-21, 53],
        [-33, 49],
        [-17, 26],
        [-16, 28],
        [-30, 47],
        [-18, 25],
        [-11, 25],
        [-22, 20],
        [-17, 8],
        [-20, 16],
        [-23, 16],
        [-18, 16],
        [-19, 17],
        [-66, 35],
        [-29, 18],
        [-28, 15],
        [-34, 8],
        [-34, 8],
        [-25, -2],
        [-40, -4],
        [-43, -4],
        [-17, -8],
        [-10, 0],
        [-24, -2],
        [-45, 0],
        [-43, 0],
        [-60, 2],
        [-30, 4],
        [-31, 4],
        [-43, 8],
        [-21, 8],
        [-16, 14],
        [-22, 10],
        [-24, 12],
        [-17, 13],
        [-21, 15],
        [-43, 24],
        [-24, 8],
        [-22, 5],
        [-17, 9],
        [-39, 20],
        [-26, 5],
        [-28, 6],
        [-13, 12],
        [-20, 17],
        [-11, 6],
        [-76, 19],
        [-34, 13],
        [-17, 8],
        [-19, 7],
        [-15, 4],
        [-19, 4],
        [-9, 13],
        [-12, 10],
        [-22, 8],
        [-24, 0],
        [-17, 9],
        [-6, 4],
        [-6, 6],
        [-30, 35],
        [-14, 29],
        [-21, 24],
        [-13, 7],
        [-19, 3],
        [-19, 6],
        [-22, 18],
        [-26, 32],
        [-31, 29],
        [-30, 20],
        [-24, 32],
        [-20, 35],
        [-28, 47],
        [-6, 15],
        [-16, 13],
        [-20, 7],
        [-29, 7],
        [-14, 3],
        [-33, -2],
        [-24, -2],
        [-26, 4],
        [-21, 13],
        [-15, 17],
        [-30, 27],
        [-12, 18],
        [-16, 12],
        [-16, 8],
        [-16, 2],
        [-27, 1],
        [-27, 5],
        [-19, 8],
        [-6, 17],
        [-10, 7],
        [-16, 10],
        [-6, 16],
        [-6, 23],
        [-9, 14],
        [-4, 14],
        [-7, 32],
        [-11, 17],
        [-15, 23],
        [-12, 30],
        [-8, 35],
        [-4, 119],
        [0, 78],
        [-3, 97],
        [-35, 149],
        [-9, 22],
        [-9, 27],
        [-7, 48],
        [-14, 37],
        [-18, 30],
        [-10, 33],
        [-18, 23],
        [-21, 9],
        [-31, -2],
        [-26, 7],
        [-30, 3],
        [-7, 2],
        [-14, 2],
        [-18, 2],
        [-20, -2],
        [-13, -10],
        [-20, -15],
        [-18, -11],
        [-15, -21],
        [-10, -17],
        [-10, -19],
        [-16, -14],
        [-10, -6],
        [-18, -2],
        [-26, 4],
        [-21, 2],
        [-6, 1],
        [-6, 3],
        [-8, 4],
        [-15, 2],
        [-41, 0],
        [-60, -8],
        [-34, -1],
        [-33, -3],
        [-21, 2],
        [-14, 1],
        [-10, 8],
        [-20, 10],
        [-12, 3],
        [-20, 11],
        [-22, 12],
        [-19, 25],
        [-21, 16],
        [-30, 13],
        [-25, 16],
        [-20, 2],
        [-15, 0],
        [-24, 0],
        [-24, -2],
        [-15, -8],
        [-15, -12],
        [-19, -13],
        [-22, -23],
        [-14, -14],
        [-13, -8],
        [-18, -6],
        [-26, -10],
        [-19, -7],
        [-23, 1],
        [-28, 10],
        [-16, 4],
        [-38, 5],
        [-18, 6],
        [-22, 10],
        [-24, 5],
        [-18, 11],
        [-19, 18],
        [-12, 16],
        [0, 1],
        [-15, 16],
        [-20, 12],
        [-10, 8],
        [-21, 18],
        [-20, 18],
        [-35, 31],
        [-49, 23],
        [-24, 13],
        [-30, 14],
        [-4, 7],
        [-2, 16],
        [0, 33],
        [0, 16],
        [-2, 16],
        [-5, 8],
        [-12, 1],
        [-12, -2],
        [-12, -3],
        [-27, -18],
        [-10, 0],
        [-20, 1],
        [-16, 10],
        [-26, 19],
        [-33, 38],
        [-24, 24],
        [-28, 26],
        [-19, 21],
        [-17, 13],
        [-20, 6],
        [-16, 15],
        [-16, 15],
        [-15, 18],
        [-9, 22],
        [-17, 14],
        [-22, 14],
        [-14, 19],
        [-34, 32],
        [-44, 42],
        [-33, 20],
        [-35, 14],
        [-39, 10],
        [-31, 8],
        [-34, 0],
        [-39, 0],
        [-18, 0],
        [-42, 2],
        [-32, -6],
        [-30, -8],
        [-8, -4],
        [-8, -4],
        [-12, -18],
        [-5, -12],
        [-3, -20],
        [6, -27],
        [6, -29],
        [2, -39],
        [-4, -64],
        [2, -34],
        [0, -28],
        [2, -41],
        [10, -26],
        [16, -5],
        [25, 0],
        [18, 9],
        [17, 17],
        [18, 12],
        [16, 2],
        [43, -11],
        [34, -18],
        [49, -33],
        [31, -28],
        [36, -30],
        [32, -29],
        [14, -24],
        [29, -51],
        [22, -31],
        [27, -40],
        [22, -24],
        [17, -13],
        [28, -15],
        [26, -13],
        [18, -3],
        [11, 2],
        [13, 17],
        [11, 10],
        [15, -1],
        [16, -4],
        [7, 0],
        [7, 0],
        [6, -2],
        [14, -4],
        [25, -5],
        [38, -10],
        [20, -13],
        [41, -37],
        [31, -34],
        [30, -36],
        [39, -26],
        [28, -28],
        [36, -20],
        [39, -12],
        [39, 4],
        [21, -2],
        [22, -4],
        [19, -12],
        [6, -16],
        [16, -19],
        [28, -28],
        [30, -30],
        [24, -26],
        [15, -24],
        [11, -29],
        [9, -19],
        [5, -20],
        [4, -20],
        [11, -52],
        [11, -31],
        [12, -25],
        [15, -17],
        [19, -5],
        [18, 0],
        [18, 1],
        [15, -4],
        [16, -11],
        [14, -16],
        [2, -18],
        [4, -9],
        [10, -2],
        [15, -5],
        [11, -13],
        [57, -25],
        [30, -7],
        [36, -1],
        [34, 0],
        [29, 3],
        [12, 1],
        [9, 4],
        [13, -2],
        [10, -10],
        [45, -23],
        [10, -18],
        [14, -10],
        [11, -22],
        [2, -18],
        [9, -22],
        [11, -19],
        [17, -12],
        [16, -8],
        [8, -18],
        [4, -28],
        [12, -36],
        [6, -11],
        [9, -33],
        [6, -68],
        [2, -36],
        [9, -30],
        [5, -19],
        [5, -8],
        [12, -3],
        [15, 3],
        [12, 2],
        [22, 4],
        [46, 4],
        [48, -4],
        [49, -9],
        [65, -24],
        [63, -25],
        [85, -30],
        [65, -28],
        [65, -32],
        [34, -18],
        [11, -7],
        [31, -15],
        [6, -4],
        [16, -12],
        [14, -15],
        [30, -31],
        [19, -29],
        [5, -15],
        [2, -8],
        [14, -5],
        [16, -4],
        [13, -17],
        [2, -7],
        [8, -8],
        [21, -11],
        [31, -12],
        [18, -10],
        [18, -25],
        [12, -16],
        [14, -8],
        [4, -7],
        [7, -12],
        [5, -10],
        [14, -7],
        [20, -24],
        [10, -14],
        [7, -27],
        [6, -14],
        [2, -7],
        [0, -10],
        [12, -20],
        [8, -18],
        [8, -19],
        [17, -30],
        [12, -14],
        [13, -16],
        [9, -8],
        [13, -37],
        [21, -80],
        [9, -13],
        [23, -13],
        [28, 3],
        [6, 5],
        [7, 4],
        [4, 16],
        [0, 3],
        [5, 3],
        [4, 0],
        [4, -1],
        [5, -10],
        [14, -12],
        [14, -3],
        [14, -5],
        [21, -11],
        [17, -10],
        [16, -8],
        [28, -8],
        [99, -64],
        [53, -36],
        [39, -39],
        [4, -12],
        [2, -13],
        [9, -6],
        [18, -8],
        [14, -10],
        [11, -6],
        [10, -30],
        [11, -19],
        [0, -16],
        [-7, -20],
        [-14, -31],
        [-14, -31],
        [-5, -18],
        [2, -14],
        [7, -15],
        [27, -53],
        [8, -17],
        [9, -8],
        [7, -11],
        [8, -58],
        [6, -44],
        [6, -31],
        [2, -44],
        [4, -63],
        [2, -58],
        [-2, -86],
        [0, -14],
        [0, -2],
        [-4, -18],
        [-6, -6],
        [-8, -6],
        [-6, -5],
        [-14, -2],
        [-19, 0],
        [-15, 7],
        [-8, 7],
        [-7, 8],
        [-36, 61],
        [4, -21],
        [9, -15],
        [0, -15],
        [8, -17],
        [6, -8],
        [6, -5],
        [3, -6],
        [3, -6],
        [6, -5],
        [1, -5],
        [-4, -4],
        [0, -12],
        [4, -1],
        [4, -2],
        [19, -14],
        [3, -8],
        [5, -9],
        [10, -12],
        [12, -11],
        [12, -11],
        [12, -5],
        [10, -10],
        [7, -8],
        [12, -10],
        [14, -10],
        [12, -12],
        [14, -10],
        [11, -13],
        [30, -26],
        [0, -2],
        [6, -3],
        [4, -2],
        [4, -3],
        [2, -6],
        [4, -4],
        [2, -4],
        [6, -2],
        [3, -1],
        [2, -5],
        [4, -2],
        [1, -2],
        [9, -9],
        [8, -7],
        [2, -4],
        [8, -8],
        [3, -8],
        [8, -8],
        [7, -4],
        [2, -6],
        [4, -6],
        [3, -4],
        [4, -2],
        [2, 0],
        [6, -4],
        [2, -2],
        [6, -4],
        [2, -2],
        [2, -2],
        [0, -2],
        [6, -6],
        [2, -6],
        [7, -6],
        [5, -5],
        [3, -4],
        [4, -5],
        [2, -5],
        [0, -4],
        [1, -8],
        [1, -5],
        [1, -2],
        [3, 0],
        [4, 0],
        [4, -2],
        [3, -2],
        [-2, -5],
        [-5, -2],
        [-2, -1],
        [-2, -3],
        [0, -3],
        [2, -2],
        [2, 0],
        [3, -1],
        [4, 0],
        [5, 0],
        [5, -1],
        [1, -2],
        [3, -5],
        [0, -3],
        [3, -3],
        [2, -2],
        [2, -2],
        [2, -2],
        [2, -1],
        [2, -3],
        [4, -2],
        [2, -2],
        [4, -2],
        [2, -2],
        [0, -3],
        [0, -3],
        [0, -3],
        [-2, -4],
        [0, -3],
        [-4, -4],
        [-2, -4],
        [0, -2],
        [-2, -4],
        [-3, -2],
        [-3, -2],
        [-2, -3],
        [-4, -6],
        [-2, -4],
        [-2, -4],
        [-3, -4],
        [-2, -3],
        [-1, -4],
        [0, -5],
        [2, -4],
        [0, -4],
        [-2, -2],
        [-2, -2],
        [-2, 0],
        [-2, 0],
        [-3, 0],
        [-2, 0],
        [-4, -2],
        [-3, -2],
        [-2, -4],
        [-5, -7],
        [-4, -6],
        [-1, -7],
        [-2, -4],
        [-2, -4],
        [-1, 0],
        [-1, 0],
        [-5, 0],
        [-4, 0],
        [0, -3],
        [-2, 0],
        [-4, -4],
        [-4, -6],
        [-4, -4],
        [-6, -6],
        [-6, -8],
        [-2, -6],
        [-4, -2],
        [-4, -2],
        [-5, -2],
        [-1, -4],
        [-3, -4],
        [-3, -3],
        [-3, -3],
        [-2, -3],
        [-6, -3],
        [-3, -4],
        [-5, -4],
        [-6, -3],
        [-2, -2],
        [-5, -3],
        [-5, -6],
        [-9, -6],
        [-3, -6],
        [-3, -6],
        [-6, -8],
        [-4, -4],
        [-8, -7],
        [-4, -4],
        [-4, -1],
        [-6, 1],
        [-6, -3],
        [-2, 0],
        [-4, -6],
        [-3, -6],
        [-2, 0],
        [-7, -2],
        [-8, -6],
        [-8, 2],
        [-2, 2],
        [-6, 4],
        [-4, 0],
        [-6, 0],
        [-7, -2],
        [-2, 0],
        [-4, 0],
        [-2, 2],
        [-2, 2],
        [-2, 4],
        [-4, 2],
        [-1, 2],
        [-2, 2],
        [-2, 2],
        [-3, 3],
        [-2, 3],
        [-1, 2],
        [-3, 2],
        [-1, 3],
        [-2, 2],
        [-4, -1],
        [-4, -1],
        [-2, 2],
        [-4, 3],
        [-2, 1],
        [-4, 1],
        [-2, 2],
        [-6, 1],
        [-6, 0],
        [-8, 1],
        [-4, 3],
        [-3, 3],
        [-1, 2],
        [-2, 2],
        [-2, 2],
        [-2, 1],
        [-5, 0],
        [-3, -4],
        [-5, -4],
        [-4, 0],
        [-5, 1],
        [-4, -2],
        [-1, -2],
        [0, -4],
        [-4, -6],
        [-6, -5],
        [-5, -5],
        [-8, -6],
        [-11, -4],
        [-4, -4],
        [-6, -4],
        [-4, -4],
        [-6, -4],
        [-5, -4],
        [-5, 0],
        [-5, 0],
        [-7, 4],
        [-3, -2],
        [-2, -4],
        [-6, 0],
        [-5, 2],
        [-6, 0],
        [-4, -4],
        [-3, -10],
        [-7, -10],
        [-16, 0],
        [-6, -17],
        [14, 2],
        [15, -4],
        [1, 4],
        [6, 4],
        [21, 2],
        [15, 4],
        [12, 2],
        [14, 5],
        [15, 2],
        [31, 0],
        [10, -2],
        [8, -19],
        [5, -14],
        [-4, -22],
        [1, -10],
        [3, -25],
        [-12, -39],
        [-98, -209],
        [-216, 184],
        [-24, -5],
        [-30, -1],
      ],
      [
        [125029, 127264],
        [4, 2],
        [5, -2],
        [41, -10],
        [28, -12],
        [31, -18],
        [45, -27],
        [34, -14],
        [49, -11],
        [40, -7],
        [24, 20],
        [29, 21],
        [13, 14],
        [3, 8],
        [7, 5],
        [12, 10],
        [12, 13],
        [17, 18],
        [16, 18],
        [9, 2],
        [17, -2],
        [178, -60],
        [6, -5],
        [31, -13],
        [18, -6],
        [27, -10],
        [29, -11],
        [26, -9],
        [16, -13],
        [18, -8],
        [71, -26],
        [49, -35],
        [117, -80],
        [29, -24],
        [55, -50],
        [95, -101],
        [45, -21],
        [85, -41],
        [66, -57],
        [75, -99],
        [10, -37],
        [27, -22],
        [52, -45],
        [81, -38],
        [31, -24],
        [34, -14],
        [30, -32],
        [45, -26],
        [43, -32],
        [23, -30],
        [101, -47],
        [104, -41],
        [91, -36],
        [44, -26],
        [48, -48],
        [29, -22],
        [32, -12],
        [24, 5],
        [9, 24],
        [111, -35],
        [28, -16],
        [34, -31],
        [64, -36],
        [12, 20],
        [41, 5],
        [10, -13],
        [42, -53],
        [41, -46],
        [19, -12],
        [32, -4],
        [16, -20],
        [12, -10],
        [9, 8],
        [15, 8],
        [14, 6],
        [15, 8],
        [4, 11],
        [0, 16],
        [12, 0],
        [34, 3],
        [21, 12],
        [10, -2],
        [29, 7],
        [28, -3],
        [47, 6],
        [42, 9],
        [35, 15],
        [41, 19],
        [26, 16],
        [29, 22],
        [60, 4],
        [23, -30],
        [4, -17],
        [16, -7],
        [18, -8],
        [27, -3],
        [27, -1],
        [14, 2],
        [6, 11],
        [13, 21],
        [24, 4],
        [25, 6],
        [27, 6],
        [18, 8],
        [16, -6],
        [14, 4],
        [23, 0],
        [23, 9],
        [13, -3],
        [30, 3],
        [13, 4],
        [20, 3],
        [22, 3],
        [5, 8],
        [16, 4],
        [10, 6],
        [9, 6],
        [16, 20],
        [25, 0],
        [14, -13],
        [13, -7],
        [13, -7],
        [16, 2],
        [26, 0],
        [15, -2],
        [21, -9],
        [11, -1],
        [15, 3],
        [36, -17],
        [31, -24],
        [7, -4],
        [23, -2],
        [12, 0],
        [16, -14],
        [12, -2],
        [14, -7],
        [3, -3],
        [5, -6],
        [12, -10],
        [9, -6],
        [31, -11],
        [16, -2],
        [19, -6],
        [14, 4],
        [17, -6],
        [7, -8],
        [20, -15],
        [12, -6],
        [35, -35],
        [28, -22],
        [41, -16],
        [22, -2],
        [16, -13],
        [17, -11],
        [49, -40],
        [24, -25],
        [26, -24],
        [24, -20],
        [16, -18],
        [31, -16],
        [20, -9],
        [23, -4],
        [25, -26],
        [34, -29],
        [36, -20],
        [17, -19],
        [19, -22],
        [31, -17],
        [8, -13],
        [27, -41],
        [55, -47],
        [46, -21],
        [20, -23],
        [33, -13],
        [22, -1],
        [33, -12],
        [13, -11],
        [39, -25],
        [50, -12],
        [43, 0],
        [26, 6],
        [12, 4],
        [23, 15],
        [11, 13],
        [5, 18],
        [-2, 22],
        [-11, 24],
        [-20, 35],
        [-22, 24],
        [-35, 32],
        [-36, 26],
        [-44, 35],
        [-16, 10],
        [-38, 24],
        [-31, 21],
        [-26, 16],
        [-50, 40],
        [-27, 28],
        [-27, 36],
        [-19, 40],
        [-11, 31],
        [-10, 40],
        [-9, 77],
        [-1, 30],
        [13, 62],
        [24, 37],
        [6, 10],
        [-5, 16],
        [-15, 44],
        [-7, 27],
        [-9, 48],
        [7, 54],
        [39, 106],
        [30, 41],
        [17, 32],
        [6, 34],
        [18, 33],
        [5, 34],
        [-3, 12],
        [-3, 13],
        [33, -1],
        [36, 6],
        [81, 24],
        [8, 11],
        [10, 49],
        [36, 34],
        [75, 60],
        [29, 21],
        [12, 4],
        [25, 13],
        [22, 2],
        [56, 2],
        [33, 7],
        [26, 6],
        [12, -7],
        [68, -40],
        [11, 2],
        [30, -14],
        [34, -36],
        [24, -54],
        [12, -15],
        [16, 4],
        [17, -4],
        [19, 3],
        [27, -2],
        [19, -4],
        [34, -10],
        [12, -3],
        [27, -24],
        [31, -34],
        [30, -31],
        [56, -83],
        [29, -37],
        [26, -74],
        [2, -38],
        [4, -72],
        [25, -70],
        [-8, -23],
        [33, -58],
        [22, -19],
        [22, -5],
        [2, -55],
        [-16, -5],
        [-12, -12],
        [-2, -28],
        [14, -13],
        [26, 7],
        [94, -27],
        [119, -19],
        [45, -14],
        [22, -22],
        [19, -52],
        [21, -73],
        [17, -72],
        [46, -116],
        [29, -46],
        [37, -20],
        [26, -12],
        [37, 6],
        [33, 4],
        [25, 2],
        [23, -8],
        [35, -22],
        [53, -55],
        [51, -47],
        [89, -71],
        [43, -19],
        [57, 39],
        [50, 4],
        [57, 12],
        [55, 2],
        [60, 20],
        [70, 16],
        [30, 10],
        [17, -17],
        [86, -33],
        [21, -8],
        [110, -78],
        [59, -6],
        [30, -6],
        [37, -2],
        [17, 14],
        [46, -5],
        [17, 6],
        [30, -19],
        [44, -1],
        [17, 16],
        [1, 18],
        [-12, 27],
        [-24, 26],
        [-29, 45],
        [-5, 10],
        [-26, 51],
        [-9, 47],
        [8, 26],
        [17, 35],
        [16, 17],
        [12, 12],
        [2, 10],
        [-15, 26],
        [-23, 20],
        [-18, 14],
        [-9, 7],
        [-24, 46],
        [6, 23],
        [34, 24],
        [55, 0],
        [18, 16],
        [0, 39],
        [6, 35],
        [17, 55],
        [20, 20],
        [26, 38],
        [11, 36],
        [3, 55],
        [-3, 22],
        [-16, 25],
        [-13, 44],
        [-17, 72],
        [-8, 252],
        [-20, 28],
        [-2, 28],
        [31, 18],
        [32, 18],
        [15, 21],
        [58, 25],
        [37, -6],
        [30, -10],
        [21, -5],
        [20, -7],
        [6, 1],
        [29, 2],
        [26, 21],
        [41, 30],
        [24, 2],
        [49, 5],
        [37, 23],
        [6, 32],
        [11, 49],
        [3, 20],
        [6, 38],
        [-8, 24],
        [97, -5],
        [53, -3],
        [16, 59],
        [8, 28],
        [21, -4],
        [81, -14],
        [79, 220],
        [38, 112],
        [12, 6],
        [22, -2],
        [142, 276],
        [31, 61],
        [84, 159],
        [154, 154],
        [194, 193],
        [32, 29],
        [158, 161],
        [131, 129],
        [64, 67],
        [33, 51],
        [4, 10],
        [7, 19],
        [8, 21],
        [6, 12],
        [6, 6],
        [8, 7],
        [6, 4],
        [8, 3],
        [12, 3],
        [36, 10],
        [15, 8],
        [142, 141],
        [69, 72],
        [5, 5],
        [58, 171],
        [41, 116],
        [41, 120],
        [38, 108],
        [23, 61],
        [12, 32],
        [14, 37],
        [-3, 6],
        [-27, 103],
        [-59, 62],
        [-212, 198],
        [84, 199],
        [98, 115],
        [19, 22],
        [59, 56],
        [14, 5],
        [49, -97],
        [2, -6],
        [8, 1],
        [133, -15],
        [66, -14],
        [89, -14],
        [12, 38],
        [25, -7],
        [-14, -51],
        [65, -27],
        [90, -37],
        [60, -26],
        [19, -7],
        [156, -62],
        [-38, -209],
        [221, -84],
        [26, -8],
        [39, 0],
        [16, -10],
        [10, -15],
        [61, -20],
        [20, -122],
        [614, 385],
        [41, 16],
        [19, 23],
        [12, 38],
        [24, 189],
        [53, 459],
        [-61, 361],
        [-28, 194],
        [0, 17],
        [16, 26],
        [209, 253],
        [107, 127],
        [22, 21],
        [156, 35],
        [58, 14],
        [14, 19],
        [58, 193],
        [27, 22],
        [8, 32],
        [35, 103],
        [3, 8],
        [17, 48],
        [158, 175],
        [11, 21],
        [3, 26],
        [-6, 34],
        [-66, 156],
        [-43, 127],
        [15, 242],
        [-468, 688],
        [-215, 319],
        [-124, 179],
        [-124, 186],
        [-157, 227],
        [-105, 157],
        [-166, 230],
        [-127, 147],
        [-299, 320],
        [-239, -158],
        [-226, -149],
        [-534, -366],
        [-318, -219],
        [-239, -165],
        [-234, -134],
        [-141, -79],
        [-274, -155],
        [-256, -150],
        [-181, -99],
        [-181, 46],
        [-14, 0],
        [-32, -33],
        [-63, -50],
        [-94, -80],
        [-103, -84],
        [-183, -173],
        [-35, -28],
        [-20, -3],
        [-112, -21],
        [-209, -37],
        [-161, -29],
        [-128, -22],
        [-18, -14],
        [-55, -19],
        [-106, -33],
        [-5, 10],
        [-32, 76],
        [180, 72],
        [-16, 36],
        [15, 8],
        [11, 3],
        [26, -4],
        [14, 2],
        [19, 4],
        [14, 10],
        [25, 16],
        [16, 11],
        [61, -4],
        [22, -2],
        [24, 4],
        [46, 21],
        [44, 22],
        [41, 35],
        [7, 20],
        [9, 4],
        [135, 24],
        [-91, 79],
        [-16, 14],
        [-53, 42],
        [4, 4],
        [87, 83],
        [112, 67],
        [33, 20],
        [75, 38],
        [12, 4],
        [23, -18],
        [18, 8],
        [24, 22],
        [20, 39],
        [10, 25],
        [-75, 67],
        [-93, 77],
        [-4, 4],
        [-18, 16],
        [-5, 3],
        [-90, 81],
        [-27, -15],
        [-8, -5],
        [-9, 13],
        [-30, 43],
        [-44, 56],
        [-22, -4],
        [-58, -13],
        [-40, -40],
        [-70, -59],
        [-12, 5],
        [-28, -1],
        [-61, -17],
        [-43, -7],
        [-38, -4],
        [-8, 7],
        [-8, 5],
        [-18, -1],
        [-29, -11],
        [-22, -17],
        [-101, -80],
        [66, -80],
        [37, -46],
        [-95, -110],
        [-38, -40],
        [-50, -52],
        [-4, 4],
        [-137, 119],
        [-245, 217],
        [-20, 9],
        [-67, 22],
        [-136, 16],
        [-99, 9],
        [19, 22],
        [14, 57],
        [10, 48],
        [14, 29],
        [30, 37],
        [66, 30],
        [51, 29],
        [32, 28],
        [0, 8],
        [37, 94],
        [44, 87],
        [24, 102],
        [39, 69],
        [19, 19],
        [54, 18],
        [-61, 67],
        [11, 61],
        [-5, 16],
        [11, 35],
        [16, 11],
        [25, 5],
        [8, 27],
        [-37, 51],
        [16, 53],
        [33, 116],
        [16, 59],
        [18, 63],
        [13, 47],
        [8, 15],
        [9, 15],
        [31, 25],
        [94, 81],
        [38, 84],
        [9, 32],
        [40, 88],
        [-21, 4],
        [-82, 36],
        [-13, 4],
        [-6, 1],
        [-20, 1],
        [-114, -6],
        [-71, -4],
        [-179, -14],
        [-43, 6],
        [-54, 4],
        [-38, 6],
        [-86, 4],
        [-33, 2],
        [-40, -8],
        [-106, 89],
        [-10, 8],
        [-19, 0],
        [-27, 156],
        [0, 8],
        [3, 5],
        [7, 4],
        [54, 24],
        [68, 31],
        [119, 53],
        [-103, 83],
        [193, 112],
        [77, 45],
        [132, 67],
        [99, 55],
        [29, 24],
        [24, 12],
        [24, 3],
        [69, 40],
        [165, 94],
        [437, 244],
        [219, 123],
        [-277, 466],
        [27, 7],
        [490, 119],
        [103, 25],
        [52, 20],
        [186, 42],
        [189, 47],
        [304, 70],
        [179, 42],
        [-284, 303],
        [-199, 213],
        [-512, 551],
        [-463, 476],
        [-294, 299],
        [-177, 175],
        [-302, 310],
        [-387, 391],
        [-556, 562],
        [-143, 147],
        [2, 112],
        [2, 46],
        [-10, 36],
        [-4, 32],
        [10, 169],
        [10, 259],
        [0, 20],
        [5, 127],
        [8, 214],
        [12, 283],
        [4, 16],
        [4, 15],
        [7, 10],
        [8, 13],
        [8, 9],
        [12, 9],
        [-14, 23],
        [-106, 153],
        [-7, 7],
        [-19, 2],
        [-45, 0],
        [-65, 2],
        [-91, 0],
        [-16, 4],
        [-11, 4],
        [-4, 4],
        [-4, 8],
        [-6, 6],
        [-53, 36],
        [-37, 24],
        [-70, 43],
        [-3, 3],
        [-38, 25],
        [-29, 4],
        [-56, 0],
        [-210, -2],
        [-207, 18],
        [-128, 8],
        [-53, 8],
        [-79, 4],
        [-33, 8],
        [-92, -10],
        [-14, -6],
        [-226, 280],
        [-27, 34],
        [-50, 64],
        [-75, 96],
        [-12, -4],
        [-11, -2],
        [-20, -8],
        [-32, 0],
        [-28, -2],
        [-19, -3],
        [-13, -2],
        [-19, -8],
        [-17, -12],
        [-28, -40],
        [-29, -36],
        [-37, -49],
        [-20, -38],
        [-46, -60],
        [-28, -43],
        [-23, -37],
        [-65, -92],
        [-18, -26],
        [-2, -2],
        [-10, -16],
        [-22, -32],
        [-25, -39],
        [-8, -19],
        [-10, -39],
        [-10, -54],
        [-17, -68],
        [-13, -72],
        [-17, -71],
        [-22, -71],
        [-4, -13],
        [-8, -21],
        [-23, -17],
        [-34, -15],
        [-62, -25],
        [-27, -12],
        [-18, 0],
        [-11, -2],
        [-12, -9],
        [-10, -12],
        [-25, -12],
        [-40, -16],
        [-49, -17],
        [-6, -2],
        [-39, -11],
        [-18, -14],
        [-28, -10],
        [-26, -9],
        [-28, -16],
        [-16, -5],
        [-18, -6],
        [-21, -20],
        [-9, -18],
        [-22, -27],
        [-5, -7],
        [-24, -33],
        [-17, -13],
        [-48, -32],
        [-52, -32],
        [-39, -21],
        [-12, -8],
        [-12, 2],
        [-38, 25],
        [-79, 40],
        [-10, 3],
        [-11, 4],
        [-56, 41],
        [-16, 8],
        [-28, 9],
        [-25, 6],
        [-20, -2],
        [-21, -4],
        [-39, -12],
        [-15, -12],
        [-19, -16],
        [-30, -7],
        [-31, -7],
        [-32, -9],
        [-25, -18],
        [-26, -19],
        [-33, -6],
        [-42, -8],
        [-18, -12],
        [-22, -11],
        [-23, -3],
        [-52, -20],
        [-27, -11],
        [-98, -39],
        [-55, -24],
        [-60, -20],
        [-126, -48],
        [-71, -32],
        [-37, -11],
        [-49, -20],
        [-91, -32],
        [-30, -10],
        [-47, -20],
        [-71, -29],
        [-35, -14],
        [-34, -15],
        [-32, -18],
        [-24, -21],
        [0, -21],
        [0, -38],
        [-1, -36],
        [1, -36],
        [39, -80],
        [-171, -69],
        [33, -69],
        [120, -280],
        [14, -3],
        [179, 73],
        [11, -4],
        [14, -4],
        [28, -2],
        [38, -6],
        [59, -4],
        [-27, -17],
        [-30, -4],
        [-20, -4],
        [-14, -7],
        [-12, -7],
        [-14, -9],
        [-17, -19],
        [-16, -21],
        [-21, -29],
        [-26, -34],
        [-22, -29],
        [-17, -17],
        [-19, -12],
        [27, -4],
        [14, -2],
        [17, -6],
        [10, -8],
        [16, -18],
        [24, -28],
        [44, -57],
        [-4, -4],
        [-15, -7],
        [-10, -2],
        [-15, -6],
        [-15, -8],
        [-55, -24],
        [-57, -22],
        [-10, -6],
        [-4, -8],
        [-24, -14],
        [-21, -15],
        [-14, -13],
        [-15, -11],
        [-10, -12],
        [-4, -6],
        [2, -9],
        [43, -69],
        [22, -23],
        [-4, -16],
        [-259, 149],
        [-248, 150],
        [-415, -64],
        [-94, -50],
        [-49, -28],
        [-64, -3],
        [-32, 28],
        [-31, 12],
        [-39, -2],
        [-42, 0],
        [-29, -9],
        [-20, -1],
        [-39, -16],
        [-26, -1],
        [-19, 4],
        [-10, -8],
        [-11, -25],
        [-9, -25],
        [-24, -6],
        [-18, -24],
        [-6, -6],
        [-48, 4],
        [-14, -2],
        [-20, -2],
        [-10, 8],
        [-55, 4],
        [-30, 4],
        [-21, 2],
        [-11, 0],
        [-31, -4],
        [-17, -6],
        [-14, -4],
        [-14, -2],
        [-2, -2],
        [-29, -6],
        [-23, -8],
        [-8, -4],
        [-9, 4],
        [-8, 10],
        [-2, 0],
        [-10, 4],
        [-12, -6],
        [-18, -20],
        [-29, -22],
        [-12, -8],
        [-29, -20],
        [-27, -19],
        [-15, -13],
        [-11, -13],
        [-26, -28],
        [-14, -14],
        [-5, -4],
        [-16, -18],
        [-6, 0],
        [-24, -2],
        [-18, -3],
        [-17, 5],
        [-19, 8],
        [-29, 16],
        [-17, 6],
        [-20, 0],
        [-13, 4],
        [-17, 0],
        [-6, 0],
        [-11, -8],
        [-18, -12],
        [-8, -9],
        [-14, -17],
        [-5, -7],
        [-17, -21],
        [-15, -31],
        [0, -8],
        [26, -29],
        [0, -16],
        [-14, -5],
        [-11, 7],
        [-9, -15],
        [4, -25],
        [2, -20],
        [-11, -4],
        [-9, -12],
        [9, -15],
        [8, -11],
        [0, -6],
        [0, -23],
        [-8, -2],
        [-4, -6],
        [-5, -12],
        [3, -8],
        [5, -17],
        [-1, -4],
        [2, -8],
        [-6, -3],
        [-11, -8],
        [-6, -9],
        [-8, 2],
        [-10, -1],
        [-3, -3],
        [-5, -4],
        [-4, -10],
        [-7, -3],
        [-10, 4],
        [-8, -2],
        [-13, -8],
        [-16, 0],
        [-14, 0],
        [-8, 5],
        [-10, -1],
        [-4, -5],
        [-2, -1],
        [-16, -3],
        [-12, 1],
        [-13, 4],
        [-9, 2],
        [-11, -1],
        [-16, -5],
        [-13, -8],
        [-8, -8],
        [-16, -8],
        [-14, -2],
        [-12, -2],
        [-5, -6],
        [-16, -6],
        [-7, -2],
        [-8, -8],
        [-5, -12],
        [-2, -9],
        [-1, -10],
        [4, -10],
        [-8, -19],
        [-8, -25],
        [-4, -14],
        [-4, -14],
        [-10, -7],
        [-10, -6],
        [-17, -15],
        [-16, -4],
        [-9, -5],
        [-15, -14],
        [-16, -10],
        [-12, -10],
        [-25, -12],
        [-18, 2],
        [-8, 1],
        [-15, 3],
        [-18, -5],
        [-42, 10],
        [-17, -4],
        [-9, -6],
        [-45, -43],
        [-18, -21],
        [0, -4],
        [10, -20],
        [4, -6],
        [0, -17],
        [-32, 7],
        [-21, 4],
        [-239, 38],
        [21, -183],
        [41, -348],
        [-117, 9],
        [-48, 5],
        [-28, 5],
        [-41, -5],
        [-32, 6],
        [-38, 0],
        [-123, 15],
        [-46, 1],
        [-42, -2],
        [-13, -6],
        [33, -101],
        [-14, -18],
        [-39, 4],
        [-6, -2],
        [4, -42],
        [5, -25],
        [-5, -21],
        [-4, -83],
        [-42, 0],
        [-32, 9],
        [-45, -3],
        [-32, 17],
        [-22, 11],
        [-46, -27],
        [-40, -10],
        [-19, -24],
        [-10, -11],
        [2, -6],
        [16, -50],
        [-12, -17],
        [-17, -17],
        [6, -35],
        [-10, -23],
        [-30, -29],
        [-25, -20],
        [-33, -59],
        [-1, -2],
        [-17, -100],
        [0, -12],
        [2, -23],
        [8, -31],
        [15, -44],
        [0, -2],
        [0, -1],
        [2, -17],
        [3, -27],
        [3, -20],
        [8, -23],
        [8, -18],
        [4, -10],
        [12, -12],
        [12, -16],
        [17, -20],
        [-3, -8],
        [-1, -15],
        [-1, -7],
        [0, -12],
        [7, -25],
        [4, -13],
        [4, -9],
        [5, -10],
        [5, -24],
        [5, -12],
        [-2, -18],
        [0, -12],
        [0, -13],
        [4, -21],
        [0, -6],
        [3, -14],
        [6, -28],
        [1, -1],
        [4, -13],
        [6, -17],
        [7, -17],
        [4, -15],
        [0, -17],
        [2, -12],
        [4, -17],
        [0, -15],
        [-8, -16],
        [0, -29],
        [-4, -6],
        [-2, -8],
        [-5, -7],
        [-2, -2],
        [0, -3],
        [-2, -13],
        [2, -12],
        [0, -4],
        [2, -8],
        [-2, -15],
        [0, -10],
        [0, -11],
        [0, -2],
        [-2, -9],
        [2, -12],
        [0, -6],
        [4, -12],
        [0, -6],
        [5, -4],
        [8, -4],
        [10, 2],
        [0, -4],
        [-6, -6],
        [-10, -5],
        [-4, -6],
        [2, -8],
        [-5, -9],
        [-2, -13],
        [-2, -6],
        [0, -2],
        [2, 0],
        [2, -10],
        [-2, -5],
        [-2, -2],
        [0, -12],
        [2, -4],
        [7, -7],
        [0, -6],
        [-2, -9],
        [0, -7],
        [-3, -2],
        [-2, -2],
        [-2, -8],
        [0, -10],
        [7, -7],
        [0, -2],
        [8, -9],
        [6, -6],
        [0, -7],
        [-2, -8],
        [-6, -11],
        [-6, -7],
        [0, -2],
        [0, -15],
        [2, -8],
        [2, -1],
        [0, -2],
        [0, -16],
        [2, -3],
        [6, -8],
        [6, -20],
        [-2, -6],
        [-6, -6],
        [-6, -9],
        [-7, -11],
        [-20, -16],
        [-8, -4],
        [-8, -12],
        [-7, -13],
        [-4, -7],
        [-10, -17],
        [-6, -10],
        [-11, -14],
        [-2, -4],
        [-8, -20],
        [-4, -4],
        [-6, -20],
        [-4, -13],
        [2, -1],
        [2, -8],
        [12, -16],
        [-6, -13],
        [-2, -39],
        [-4, -25],
        [-2, -8],
        [2, -13],
        [4, -25],
        [6, -42],
        [2, -2],
        [6, -13],
        [6, -12],
        [8, -16],
        [17, -35],
        [11, -19],
        [6, -6],
        [4, -5],
        [10, -6],
        [4, 6],
        [8, 5],
        [7, -1],
        [12, -7],
        [16, -22],
        [22, -7],
        [31, -1],
        [7, 6],
        [4, 4],
        [4, 0],
        [4, 5],
        [8, 3],
        [4, 2],
        [-2, 3],
        [8, 3],
        [9, 14],
        [9, -9],
        [-12, -22],
        [-8, -10],
        [-2, -8],
        [-4, -8],
        [-4, -14],
        [-8, -10],
        [-4, -8],
        [-4, 0],
        [-6, 2],
        [-4, 0],
        [-4, -2],
        [-4, -4],
        [-2, -4],
        [0, -6],
        [3, -4],
        [6, -6],
        [2, -2],
        [-1, -6],
        [-18, -18],
        [-3, -1],
        [-4, -1],
        [-6, -5],
        [-2, -6],
        [0, -6],
        [3, -4],
        [1, -2],
        [-1, -7],
        [-5, -2],
        [-7, -14],
        [-7, -2],
        [-3, -4],
        [-8, -10],
        [-8, -9],
        [-6, 0],
        [-8, -4],
        [-5, -8],
        [0, -10],
        [-4, -6],
        [-6, -4],
        [-6, -6],
        [-10, -18],
        [-9, -8],
        [-13, -13],
        [-4, -5],
        [-1, -1],
        [-2, -7],
        [1, -13],
        [-4, -1],
        [-7, -10],
        [-13, 9],
        [-12, 3],
        [-12, 4],
        [-7, -3],
        [-5, -2],
        [-14, -12],
        [-18, -4],
        [-14, -5],
        [-13, -5],
        [-14, -2],
        [-16, -6],
        [-12, 0],
        [-9, -2],
        [-17, -15],
        [-22, -4],
        [-8, -3],
        [-8, -4],
        [-14, -7],
        [-24, -10],
        [-13, 2],
        [-6, -3],
        [-26, -19],
        [-9, -13],
        [-17, 1],
        [-4, 0],
        [-4, -4],
        [0, -2],
        [-3, -9],
        [-4, -11],
        [-12, -5],
        [-4, -9],
        [-16, 10],
        [-8, -2],
        [-14, -8],
        [-7, -8],
        [-14, 1],
        [-21, -8],
        [-18, -8],
        [-8, -8],
        [-20, -6],
        [-8, -6],
        [-17, 2],
        [-18, -8],
        [-14, 0],
        [-2, 4],
        [-6, 4],
        [-2, 4],
        [-8, 8],
        [-14, 4],
        [-8, 0],
        [-2, 0],
        [-8, -2],
        [-6, 9],
        [-7, 5],
        [-4, 0],
        [-2, -1],
        [-8, -2],
        [-10, -7],
        [-6, -12],
        [-5, 8],
        [-14, 4],
        [-8, -2],
        [-4, 0],
        [-16, -2],
        [-22, -4],
        [-17, -6],
        [-4, -2],
        [-3, -2],
        [-7, -6],
        [-8, -6],
        [-4, -4],
        [-10, 8],
        [-12, 6],
        [0, 0],
        [-25, 0],
        [-22, -14],
        [0, -4],
        [-2, -4],
        [-7, -8],
        [-4, -16],
        [-7, 1],
        [-25, -7],
        [-12, -5],
        [-6, -5],
        [-9, -13],
        [-17, -10],
        [-17, -13],
        [-8, -4],
        [-20, -10],
        [-4, -2],
        [-8, -6],
        [-5, -4],
        [-2, 0],
        [-10, -6],
        [-10, -4],
        [0, -4],
        [0, -2],
        [0, -6],
        [-6, 0],
        [-4, -2],
        [-4, 0],
        [0, -2],
        [-7, -11],
        [-4, 2],
        [-1, 0],
        [-10, -2],
        [-7, -6],
        [-8, 0],
        [-8, 0],
        [-6, -2],
        [-3, -6],
        [-27, 6],
        [-2, 2],
        [-2, 2],
        [-6, 0],
        [-8, -2],
        [-4, -4],
        [0, -2],
        [-1, -6],
        [-9, 0],
        [-11, -2],
        [-4, -4],
        [-3, -2],
        [-3, -26],
        [2, -5],
        [0, -4],
        [-4, 0],
        [-16, -9],
        [-3, -5],
        [-9, -9],
        [-5, -16],
        [-16, 0],
        [-10, 1],
        [-7, -3],
        [-24, -17],
        [-14, -9],
        [-8, -10],
        [-16, 2],
        [-8, -4],
        [-18, -8],
        [-14, -10],
        [-9, -1],
        [-3, 0],
        [-9, -2],
        [-7, -1],
        [-1, -2],
        [-4, -5],
        [-6, 3],
        [-17, 3],
        [-4, 3],
        [-6, 3],
        [-6, 1],
        [-4, -2],
        [-2, -1],
        [-4, -3],
        [-6, 5],
        [-7, -1],
        [-5, 3],
        [-2, 1],
        [-5, 0],
        [-1, 0],
        [-5, -1],
        [-8, 2],
        [-8, -3],
        [-2, -3],
        [-10, -3],
        [-3, -3],
        [-5, 2],
        [0, 1],
        [-6, -1],
        [-1, -1],
        [-5, -5],
        [-2, -4],
        [-14, -1],
        [-8, -3],
        [-10, -5],
        [-8, -4],
        [-8, -1],
        [-7, -2],
        [-4, -4],
        [-4, -5],
        [-10, 12],
        [-4, 7],
        [-5, 3],
        [-2, 2],
        [-6, 0],
        [-3, -3],
        [-3, -5],
        [-4, 1],
        [-8, -2],
        [-8, -4],
        [-2, 6],
        [-15, 12],
        [-6, 8],
        [-4, 2],
        [-6, 3],
        [-6, -1],
        [-6, -2],
        [-7, -4],
        [-6, 1],
        [-9, -5],
        [-12, -10],
        [-2, -11],
        [-2, -5],
        [-2, -9],
        [-9, -10],
        [-5, -6],
        [-3, -7],
        [-7, -2],
        [-1, 3],
        [-2, 2],
        [-6, 2],
        [-12, -3],
        [-12, -7],
        [-16, -4],
        [-4, -2],
        [-13, -9],
        [-10, -5],
        [-6, 6],
        [-6, 4],
        [-4, 2],
        [-21, -3],
        [-12, -2],
        [-5, -12],
        [0, -3],
        [0, -4],
        [-6, -8],
        [-2, -6],
        [-3, -10],
        [-4, -2],
        [-2, -6],
        [0, -12],
        [-9, -7],
        [-8, -12],
        [-2, -9],
        [-9, -4],
        [-10, -1],
        [-10, -2],
        [-14, 0],
        [-6, -1],
        [-2, -4],
        [-2, -11],
        [0, -3],
        [2, -4],
        [-6, -19],
        [-8, -10],
        [4, -12],
        [-2, -10],
        [-6, -4],
        [-12, -2],
        [-10, -8],
        [-3, -2],
        [-8, -4],
        [-1, -6],
        [1, -6],
        [4, -4],
        [2, -4],
        [12, -10],
        [-8, -13],
        [-12, -23],
        [-11, -10],
        [-1, -1],
        [-6, -17],
        [-5, -25],
        [-8, -24],
        [-2, -13],
        [0, -1],
        [6, -10],
        [-2, -21],
        [-8, -15],
        [-8, -7],
        [-5, -12],
        [-2, -2],
        [-8, -4],
        [-6, -3],
        [-2, -2],
        [2, -9],
        [2, -9],
        [2, -1],
        [19, -17],
        [36, -6],
        [11, 6],
        [8, 4],
        [6, 2],
        [8, -4],
        [-5, -6],
        [4, -6],
        [-2, -8],
        [-7, -11],
        [-5, -6],
        [-1, -6],
        [3, -15],
        [-5, -13],
        [-2, -13],
        [-2, -15],
        [-6, -13],
        [-8, -6],
        [-19, -10],
        [-10, -4],
        [-11, 0],
        [-4, -2],
        [-8, 6],
        [-3, 0],
        [-7, 6],
        [-7, 4],
        [-10, 8],
        [-8, 11],
        [-8, 2],
        [-11, 5],
        [-8, 3],
        [-4, -3],
        [-4, -7],
        [0, -5],
        [2, -6],
        [4, -6],
        [-12, 0],
        [-6, 2],
        [-8, 0],
        [-6, -2],
        [-6, -6],
        [-2, -4],
        [5, -8],
        [11, -8],
        [4, -26],
        [-2, -9],
        [-4, -6],
        [-4, -3],
        [0, -7],
        [6, -23],
        [2, -11],
        [2, -2],
        [4, -2],
        [4, 0],
        [4, 0],
        [10, 2],
        [10, -1],
        [7, -2],
        [5, -6],
        [22, -13],
        [28, -13],
        [34, -9],
        [9, -2],
        [7, -2],
        [6, 0],
        [4, 0],
        [8, 0],
        [14, 6],
        [10, 8],
        [7, 0],
        [2, 0],
        [6, 4],
        [4, 4],
        [2, 4],
        [10, 7],
        [6, 6],
        [6, 8],
        [14, 7],
        [7, 4],
        [5, 6],
        [2, 5],
        [2, 6],
        [-1, 6],
        [-3, 7],
        [-4, 4],
        [-1, 6],
        [8, 4],
        [1, 2],
        [5, 15],
        [14, 14],
        [1, 6],
        [28, 24],
        [2, 2],
        [2, 4],
        [2, 0],
        [12, 0],
        [19, 9],
        [8, 5],
        [7, 4],
        [12, -1],
        [11, 3],
        [5, 0],
        [8, -1],
        [4, 0],
        [8, -11],
        [4, -6],
        [5, -8],
        [7, -6],
        [9, -4],
        [9, -2],
        [13, 4],
        [6, 4],
        [5, -2],
        [12, 4],
        [5, 2],
        [4, 4],
        [4, 4],
        [0, 8],
        [-2, 8],
        [-2, 8],
        [0, 1],
        [16, 16],
        [8, 3],
        [2, 1],
        [17, 15],
        [8, 13],
        [4, 12],
        [7, -2],
        [9, -2],
        [50, 6],
        [39, 21],
        [6, 7],
        [7, 4],
        [25, 15],
        [1, 6],
        [-1, 7],
        [3, 2],
        [5, 0],
        [4, 1],
        [8, 4],
        [22, -3],
        [8, 4],
        [6, 6],
        [4, 8],
        [9, 4],
        [12, 7],
        [24, 30],
        [3, 16],
        [3, 8],
        [2, 4],
        [3, 10],
        [24, 37],
        [8, 20],
        [13, 4],
        [11, 11],
        [12, 21],
        [42, 46],
        [40, 16],
        [55, 24],
        [73, 0],
        [141, 21],
        [49, 17],
        [33, -4],
        [11, -9],
        [7, -8],
        [5, -5],
        [14, -7],
        [4, -2],
        [2, -7],
        [0, -2],
        [4, -4],
        [16, 4],
        [14, -4],
        [10, -10],
        [4, -4],
        [9, -6],
        [3, -4],
        [5, -2],
        [7, 2],
        [6, 6],
        [5, 4],
        [7, 0],
        [7, -2],
        [6, -2],
        [4, 0],
        [6, 6],
        [10, 2],
        [10, 4],
        [1, 6],
        [6, 0],
        [8, -10],
        [7, -4],
        [7, -8],
        [0, -12],
        [0, -16],
        [-2, -12],
        [-5, -2],
        [-4, -8],
        [5, -10],
        [-5, -9],
        [1, -9],
        [3, -5],
        [-5, -1],
        [-6, -2],
        [-4, -7],
        [1, -7],
        [-6, -5],
        [-2, -6],
        [2, -7],
        [4, -5],
        [5, -1],
        [6, -1],
        [7, 2],
        [5, -4],
        [1, -8],
        [1, -6],
        [17, -14],
        [-6, -18],
        [5, -15],
        [8, -12],
        [13, -21],
        [-10, -11],
        [-43, -40],
        [-29, -33],
        [-12, -15],
        [-14, -33],
        [0, -18],
        [-12, -40],
        [1, -20],
        [-7, -103],
        [8, -24],
        [6, -12],
        [4, -8],
        [8, -6],
        [2, -20],
        [-6, -16],
        [0, -12],
        [-4, -34],
        [-6, -8],
        [0, -12],
        [6, -10],
        [10, -11],
        [-2, -13],
        [-2, -16],
        [4, -20],
        [2, -7],
        [18, -37],
        [7, -11],
        [-5, -24],
        [0, -14],
        [5, -6],
        [-13, -41],
        [0, -40],
        [-2, -42],
        [2, -20],
        [0, -50],
        [-8, -42],
        [-2, -26],
        [0, -12],
        [0, -5],
        [-4, -5],
        [0, -7],
        [-2, -7],
        [-2, -9],
        [-9, -7],
        [-4, -6],
        [-4, -7],
        [1, -12],
        [6, -9],
        [10, -8],
        [12, -22],
        [4, -8],
        [12, -13],
        [-6, -9],
        [-8, 2],
        [-8, -1],
        [-4, -3],
        [-6, -8],
        [-3, -6],
        [3, -6],
        [-5, -6],
        [-4, -2],
        [-3, -6],
        [0, -17],
        [-6, -3],
        [-5, -7],
        [0, -8],
        [0, -22],
        [-5, -25],
        [-2, -6],
        [-10, 7],
        [-8, 1],
        [-11, -1],
        [-6, -3],
        [-6, 3],
        [-10, 8],
        [-10, 4],
        [-8, -1],
        [-11, -2],
        [-9, -3],
        [-6, -4],
        [-9, 5],
        [-16, 11],
        [-5, 1],
        [-6, -1],
        [-4, -2],
        [-6, -4],
        [-10, -2],
        [-4, -6],
        [0, -5],
        [-4, -3],
        [-8, 0],
        [-2, 7],
        [-2, 3],
        [-6, 2],
        [-5, 0],
        [-9, -2],
        [-2, -1],
        [-3, -3],
        [-7, 2],
        [4, 8],
        [-1, 5],
        [-1, 3],
        [1, 6],
        [-1, 4],
        [-3, 4],
        [-6, 1],
        [-6, 1],
        [1, 3],
        [0, 4],
        [-4, 6],
        [-3, 2],
        [-2, 0],
        [-2, -1],
        [-3, -3],
        [-7, 0],
        [-2, 2],
        [2, 7],
        [0, 5],
        [-8, 8],
        [-4, 4],
        [-6, 2],
        [-4, 4],
        [-4, 2],
        [-9, 6],
        [-8, 2],
        [-4, 0],
        [-4, -2],
        [-4, 2],
        [-4, -2],
        [-4, -4],
        [-3, -4],
        [-1, -6],
        [-2, -22],
        [3, -4],
        [3, -7],
        [10, -4],
        [-6, -5],
        [-6, -3],
        [-2, -2],
        [-4, 7],
        [-10, 1],
        [-7, 6],
        [-6, 1],
        [-7, -3],
        [-6, -4],
        [-3, -6],
        [0, -6],
        [2, -7],
        [4, -13],
        [0, -7],
        [-4, -4],
        [-2, -2],
        [0, -4],
        [-7, 1],
        [-2, -1],
        [-17, -9],
        [-14, -10],
        [-4, 2],
        [-4, -2],
        [-2, -6],
        [-2, -4],
        [-2, -4],
        [-2, -2],
        [-4, 2],
        [-4, 0],
        [-11, -6],
        [-8, -2],
        [-18, -6],
        [-13, -2],
        [-6, -2],
        [-4, -4],
        [-18, -6],
        [-4, -2],
        [-6, 6],
        [-6, 4],
        [-9, 0],
        [-12, -4],
        [-8, -4],
        [-2, -4],
        [-10, 12],
        [-20, 10],
        [-16, 6],
        [-10, 0],
        [-16, 0],
        [-4, -4],
        [-4, -2],
        [-3, 2],
        [-6, 0],
        [-5, -4],
        [-11, 0],
        [-2, 8],
        [-6, 6],
        [-31, 8],
        [-10, -2],
        [-13, 4],
        [-6, -2],
        [-9, 6],
        [-12, 2],
        [-19, 0],
        [-7, -4],
        [-9, 4],
        [-10, 6],
        [-6, 6],
        [-8, 3],
        [-9, 0],
        [-3, -2],
        [-5, 4],
        [-7, 9],
        [-9, 7],
        [-8, 3],
        [-7, 6],
        [-4, 14],
        [-5, 10],
        [-5, 6],
        [-4, 4],
        [-4, 1],
        [-4, -1],
        [-6, 4],
        [-10, 4],
        [-10, -1],
        [-4, -3],
        [-3, -4],
        [-8, -4],
        [-8, -5],
        [-8, -3],
        [-6, 2],
        [-4, 0],
        [-7, 4],
        [-9, 2],
        [-14, 3],
        [-9, 0],
        [-3, 9],
        [-6, 8],
        [-11, 5],
        [-12, 0],
        [-2, 6],
        [-8, 2],
        [-8, 0],
        [-4, 6],
        [-12, 8],
        [-2, 6],
        [-5, 8],
        [-11, 8],
        [-17, 16],
        [-5, 10],
        [-5, 2],
        [-5, 3],
        [-4, 3],
        [-4, 3],
        [-4, 10],
        [-4, 6],
        [-8, 1],
        [0, 10],
        [-4, 4],
        [2, 8],
        [-2, 8],
        [-4, 7],
        [-10, 2],
        [3, 11],
        [7, 12],
        [2, 6],
        [-2, 7],
        [8, 3],
        [4, 2],
        [10, 2],
        [9, 8],
        [6, 8],
        [3, 4],
        [3, 11],
        [-3, 11],
        [-8, 11],
        [-10, 4],
        [-12, -1],
        [-24, -1],
        [-9, -3],
        [-10, -6],
        [-24, 2],
        [-4, 13],
        [-15, 21],
        [-28, 8],
        [-17, 4],
        [-19, 0],
        [-24, -8],
        [-6, -3],
        [-8, -5],
        [-6, -4],
        [-4, -9],
        [-6, -4],
        [-15, 4],
        [-7, 0],
        [-10, 0],
        [-6, -2],
        [-4, 2],
        [-13, 8],
        [-16, 7],
        [-14, 3],
        [-20, 0],
        [-11, -3],
        [-7, -3],
        [-8, -5],
        [-5, 6],
        [-10, 1],
        [-12, -2],
        [-4, -1],
        [0, 6],
        [3, 8],
        [2, 16],
        [-2, 8],
        [1, 4],
        [9, 8],
        [0, 10],
        [-2, 17],
        [-9, 21],
        [-7, 4],
        [-14, 3],
        [-9, 2],
        [-8, 1],
        [-10, -3],
        [-11, -3],
        [-16, 2],
        [-8, 0],
        [-9, -3],
        [-14, -5],
        [-13, 1],
        [-11, -4],
        [-14, -2],
        [-5, -5],
        [-12, -9],
        [-20, 7],
        [-12, 3],
        [-2, 11],
        [-4, 14],
        [-3, 4],
        [-4, 5],
        [-6, 11],
        [-7, 3],
        [-6, 2],
        [-8, -2],
        [-7, -5],
        [-8, 7],
        [-10, 4],
        [-8, 6],
        [-4, 8],
        [-6, 3],
        [-30, 5],
        [-16, 0],
        [-6, -1],
        [-10, 3],
        [-12, 8],
        [-4, 4],
        [-4, 6],
        [0, 10],
        [-6, 18],
        [-10, 24],
        [-7, 7],
        [-9, 15],
        [-8, 5],
        [-5, -3],
        [-9, -4],
        [-6, -1],
        [-8, -10],
        [-7, -8],
        [-7, -15],
        [-4, 2],
        [-9, 6],
        [-6, 5],
        [-8, 3],
        [-8, 2],
        [-9, 1],
        [-16, 23],
        [-8, 11],
        [-12, 21],
        [-6, 8],
        [-9, 6],
        [-8, 1],
        [-10, 4],
        [-6, 6],
        [-12, 7],
        [-8, 7],
        [-14, 26],
        [-4, 8],
        [-6, 2],
        [-7, 1],
        [-7, 2],
        [-6, 8],
        [-4, 6],
        [-5, 5],
        [-4, 3],
        [-5, 3],
        [-5, 0],
        [-6, 2],
        [-16, 13],
        [-15, 14],
        [-12, 16],
        [-4, 5],
        [-6, 8],
        [-5, 4],
        [-7, 12],
        [-2, 4],
        [-4, 4],
        [-15, 4],
        [-9, 6],
        [-10, 16],
        [-16, 19],
        [-2, 6],
        [-6, 15],
        [-7, 21],
        [-4, 8],
        [-6, 7],
        [-26, 17],
        [-11, 6],
        [-7, 12],
        [-17, 14],
        [-15, 2],
        [-8, 6],
        [-14, 10],
        [-18, 20],
        [-6, 12],
        [-10, 4],
        [-9, -1],
        [-5, 5],
        [-12, 13],
        [-1, 6],
        [-9, 11],
        [-4, 3],
        [-13, 1],
        [-10, -5],
        [-4, -5],
        [-20, 0],
        [-7, 0],
        [-7, 3],
        [-10, 1],
        [-3, 6],
        [-12, 13],
        [-10, 6],
        [-11, 1],
        [-35, 4],
        [-32, 4],
        [-21, -1],
        [-33, 15],
        [-18, 4],
        [-24, 2],
        [-21, 18],
        [4, 6],
        [5, 2],
        [3, 8],
        [-1, 13],
        [-3, 11],
        [-6, 8],
        [-17, 10],
        [-8, 7],
        [-6, 0],
        [-11, -3],
        [-8, -5],
        [-10, 2],
        [-23, 10],
        [-5, 1],
        [-7, 5],
        [-5, 3],
        [-9, 3],
        [-12, 15],
        [-13, 12],
        [-8, 4],
        [-5, 10],
        [-4, 10],
        [-4, 6],
        [2, 7],
        [0, 9],
        [2, 17],
        [-14, 34],
        [0, 8],
        [-4, 8],
        [4, 0],
        [4, 2],
        [8, 0],
        [8, 4],
        [12, 10],
        [5, 22],
        [0, 4],
        [-3, 8],
        [-10, 6],
        [-18, 16],
        [0, 6],
        [-2, 9],
        [2, 5],
        [4, 9],
        [0, 10],
        [-4, 9],
        [-4, 6],
        [-4, 8],
        [2, 12],
        [4, 19],
        [0, 8],
        [-6, 4],
        [-18, 4],
        [-6, 8],
        [-12, 12],
        [-1, 15],
        [2, 5],
        [-1, 11],
        [8, 23],
        [12, 8],
        [3, 6],
        [1, 6],
        [4, 8],
        [0, 9],
        [8, 5],
        [6, 17],
        [-2, 5],
        [-6, 6],
        [-10, 10],
        [-6, -2],
        [-7, -2],
        [-8, -2],
        [-8, 2],
        [-8, -2],
        [-7, -6],
        [-5, -8],
        [-5, -8],
        [-7, -4],
        [-7, -2],
        [-6, -3],
        [-4, -4],
        [-4, -8],
        [-4, -11],
        [-4, -14],
        [-7, -7],
        [1, -6],
        [-4, -7],
        [0, -3],
        [3, -9],
        [3, -5],
        [6, -3],
        [8, -10],
        [4, -5],
        [0, -9],
        [-4, -4],
        [2, -4],
        [4, -8],
        [-8, -4],
        [0, -8],
        [0, -6],
        [2, -7],
        [4, -3],
        [2, -7],
        [-8, -4],
        [-2, -4],
        [-8, 4],
        [-11, -2],
        [1, -6],
        [-3, -3],
        [-6, 2],
        [-10, 3],
        [-13, -2],
        [-5, -3],
        [-10, -10],
        [-10, 12],
        [-8, 4],
        [-24, -1],
        [-19, -4],
        [-26, -9],
        [-27, -9],
        [-10, -1],
        [-6, -3],
        [-8, -18],
        [-8, -20],
        [-15, 2],
        [-10, -6],
        [-10, 4],
        [-6, -2],
        [-12, -2],
        [-10, 2],
        [-12, 6],
        [-8, 5],
        [-8, 1],
        [-8, 2],
        [-9, 6],
        [-4, 2],
        [-5, -2],
        [-9, 0],
        [-6, 3],
        [-12, 13],
        [-13, 20],
        [-2, 6],
        [0, 9],
        [2, 13],
        [2, 6],
        [2, 7],
        [4, 2],
        [1, 8],
        [-3, 18],
        [-3, 2],
        [-3, 2],
        [-12, 4],
        [-4, 5],
        [-2, 10],
        [0, 9],
        [-8, 3],
        [-11, 4],
        [-3, 0],
        [-2, -3],
        [-6, 1],
        [-6, -1],
        [-4, -6],
        [-10, 2],
        [-14, 1],
        [-15, 1],
        [-13, 1],
        [-5, -4],
        [-6, -3],
        [-3, 3],
        [-5, 6],
        [-9, 16],
        [-6, 1],
        [-8, 6],
        [-6, 1],
        [-4, -5],
        [-12, 4],
        [-16, 6],
        [-17, 14],
        [-20, 12],
        [-18, 11],
        [-24, 19],
        [-18, 10],
        [-2, 12],
        [-13, 21],
        [1, 47],
        [1, 32],
        [6, 4],
        [7, 6],
        [6, 6],
        [10, 10],
        [8, 11],
        [0, 10],
        [-4, 6],
        [-5, 4],
        [-10, -2],
        [-12, 6],
        [-10, 0],
        [-6, 6],
        [-8, 5],
        [-4, 0],
        [-6, -4],
        [-1, -7],
        [-6, 0],
        [-8, 0],
        [-4, 6],
        [-4, 5],
        [-4, 0],
        [-2, -5],
        [-12, 3],
        [-16, 12],
        [-5, 15],
        [-11, 6],
        [-14, 10],
        [-6, 5],
        [-7, 2],
        [-8, -2],
        [-8, -2],
        [-10, -2],
        [-12, 14],
        [-4, 10],
        [-2, 11],
        [-4, 16],
        [-13, 10],
        [-3, 4],
        [-13, 16],
        [-6, 38],
        [-5, 11],
        [-6, 21],
        [-6, 17],
        [-10, 14],
        [-4, 4],
        [0, 8],
        [2, 6],
        [-6, 10],
        [-6, 9],
        [-2, 3],
        [-8, 2],
        [-4, -1],
        [-6, 0],
        [-6, 5],
        [-45, 15],
        [-14, 6],
        [-12, -2],
        [-21, 0],
        [-6, 3],
        [-8, 5],
        [0, 6],
        [-2, 4],
        [-2, 1],
        [0, -1],
        [-4, -2],
        [-10, -6],
        [-6, -3],
        [-16, -6],
        [-7, -4],
        [-18, -2],
        [-5, -2],
        [-8, -3],
        [-8, -6],
        [-8, -4],
        [-7, -7],
        [-12, -14],
        [-3, -2],
        [-13, -8],
        [-14, -4],
        [-5, -2],
        [-5, -4],
        [-3, -9],
        [-3, -8],
        [1, -9],
        [-4, -10],
        [-7, -9],
        [-6, -5],
        [-8, -12],
        [-6, -8],
        [-2, -4],
        [0, -6],
        [2, -5],
        [4, -2],
        [9, -1],
        [15, -5],
        [9, -6],
        [5, -8],
        [11, -4],
        [10, -4],
        [7, -8],
        [16, -26],
        [17, -20],
        [14, -17],
        [0, -9],
        [2, -6],
        [5, -4],
        [6, 0],
        [26, -30],
        [6, -12],
        [1, -6],
        [6, -31],
        [4, -10],
        [34, -34],
        [17, -11],
        [10, -22],
        [11, -9],
        [26, -22],
        [24, -16],
        [6, -2],
        [12, -6],
        [10, -10],
        [0, -4],
        [0, -4],
        [2, 0],
        [6, 3],
        [4, -2],
        [14, -18],
        [15, -20],
        [5, -4],
        [22, -9],
        [10, -11],
        [34, -20],
        [16, -21],
        [7, -8],
        [15, -10],
        [21, -18],
        [12, -12],
        [28, -26],
        [8, -8],
        [13, -11],
        [28, -30],
        [13, -14],
        [14, -8],
        [22, -16],
        [6, -6],
        [15, -24],
        [23, -33],
        [11, -12],
        [15, -15],
        [13, -1],
        [12, 3],
        [29, -4],
        [35, -5],
        [24, -9],
        [14, -7],
        [9, 1],
        [23, -16],
        [10, -11],
        [60, -26],
        [2, -3],
        [4, -3],
        [6, -2],
        [4, 1],
        [6, -2],
        [35, -17],
        [8, -6],
        [8, -3],
        [42, -17],
        [22, -7],
        [44, -22],
        [10, -5],
        [6, -6],
        [18, -10],
        [12, -14],
        [6, -6],
        [11, -12],
        [10, -20],
        [6, -8],
        [4, 0],
        [11, -28],
        [2, -5],
        [3, -4],
        [6, -3],
        [1, -4],
        [-2, -6],
        [2, -3],
        [2, -2],
        [11, -11],
        [14, -26],
        [12, -22],
        [6, -19],
        [2, -2],
        [15, -29],
        [16, -9],
        [3, -2],
        [9, -1],
        [9, -7],
        [22, -11],
        [8, -2],
        [26, 0],
        [21, 0],
        [18, -6],
        [6, -1],
        [6, -2],
        [12, -2],
        [12, -9],
        [4, -11],
        [4, -8],
        [13, -12],
        [12, -39],
        [21, -40],
        [16, -9],
        [6, -7],
        [3, -5],
        [10, -11],
        [9, -3],
        [21, -10],
        [6, -4],
        [16, -12],
        [31, -32],
        [17, -14],
        [25, -24],
        [12, -11],
        [10, -14],
        [16, -22],
        [10, -10],
        [36, -38],
        [5, -4],
        [13, -12],
        [4, -3],
        [8, -6],
        [2, -2],
        [6, -1],
        [7, -1],
        [22, -20],
        [7, -21],
        [8, -4],
        [4, -9],
        [-1, -2],
        [-1, -2],
        [2, 1],
        [4, 2],
        [6, 2],
        [1, 0],
        [2, -1],
        [28, -9],
        [36, -11],
        [26, -14],
        [4, 0],
        [12, -12],
        [14, -14],
        [25, -21],
        [9, -6],
        [18, -14],
        [10, -10],
        [4, -13],
        [4, -10],
        [0, -1],
        [3, 0],
        [10, -1],
        [8, -4],
        [4, -3],
        [12, -2],
        [6, -2],
        [2, -1],
        [10, -5],
        [17, -8],
        [2, -2],
        [6, -5],
        [4, -4],
        [4, -7],
        [11, -12],
        [6, -8],
        [20, -12],
        [15, -12],
        [13, -16],
        [4, 1],
        [4, 5],
        [8, 7],
        [10, -2],
        [2, -2],
        [8, -5],
        [4, -13],
        [32, -21],
        [17, -11],
        [13, -11],
        [12, -6],
        [10, -1],
        [4, -1],
        [6, -3],
        [2, -2],
        [2, -2],
        [2, -2],
        [3, 0],
        [7, 0],
        [15, -4],
        [21, -10],
        [5, -2],
        [-2, -4],
        [-2, -4],
        [-1, -2],
        [2, -6],
        [3, 0],
        [4, 4],
        [6, 8],
        [20, -12],
        [0, -6],
        [14, -4],
        [4, -5],
        [0, -5],
        [3, -2],
        [4, -2],
        [2, 1],
        [4, 3],
        [13, -8],
        [-1, -7],
        [3, -7],
        [4, -6],
        [6, -4],
        [6, -1],
        [2, -1],
        [9, 3],
        [33, -19],
        [17, -10],
        [8, -5],
        [2, -8],
        [-2, -8],
        [7, -8],
        [39, -12],
        [12, -4],
        [22, -10],
        [1, 0],
        [19, -12],
        [3, -2],
        [0, 0],
        [8, -16],
        [13, -2],
        [4, -2],
        [4, 0],
        [8, -6],
        [2, -2],
        [8, -8],
        [16, -3],
        [13, -5],
        [12, -11],
        [26, -27],
        [17, -4],
        [1, 1],
        [10, 2],
        [15, -5],
        [34, -7],
        [27, -7],
        [35, -11],
        [22, -16],
        [9, -12],
        [4, -6],
        [10, -9],
        [17, -16],
        [26, -37],
        [21, -42],
        [8, -18],
        [16, -10],
        [24, -14],
        [20, -5],
        [23, -8],
        [10, -12],
        [9, -4],
        [8, 0],
        [12, 4],
        [19, -16],
        [24, -25],
        [43, -40],
        [47, -50],
        [22, -33],
        [12, -1],
        [16, -11],
        [16, -18],
        [49, -40],
        [7, -4],
        [36, -25],
        [23, -18],
        [35, -28],
        [27, -21],
        [29, -18],
        [4, -3],
        [16, -15],
        [8, -4],
        [31, -25],
        [24, -25],
        [9, -10],
        [24, -19],
        [28, -23],
        [7, -7],
        [3, -8],
        [2, -6],
        [10, -14],
        [7, -10],
        [1, -2],
        [2, -2],
        [9, -10],
        [10, -10],
        [16, -12],
        [16, -11],
        [10, -3],
        [9, -4],
        [21, -13],
        [23, -12],
        [23, -46],
        [10, 0],
        [6, -2],
        [7, -10],
        [0, -22],
        [14, -10],
        [13, -16],
        [6, -15],
        [7, -15],
        [13, -13],
        [15, -13],
        [24, -31],
        [7, -8],
        [16, -13],
        [15, -11],
        [2, -15],
        [12, -19],
        [7, -12],
        [3, -9],
        [8, -13],
        [5, 0],
        [6, 1],
        [4, 4],
        [4, 1],
        [5, -3],
        [4, -5],
        [0, -8],
        [-6, -4],
        [-7, -2],
        [-8, -8],
        [0, -9],
        [0, -10],
        [15, -51],
        [14, -42],
        [12, -14],
        [0, -2],
        [18, -20],
        [6, -34],
        [4, -22],
        [3, -12],
        [5, -24],
        [15, -25],
        [9, -10],
        [2, -7],
        [16, -6],
        [6, -2],
        [10, -7],
        [14, 0],
        [21, -7],
        [27, -1],
        [17, 3],
        [10, -3],
        [12, -6],
        [32, -12],
        [21, -9],
        [17, -4],
        [8, -9],
        [6, -14],
        [12, -5],
        [16, -4],
        [10, -4],
        [13, -14],
        [4, -10],
        [15, -11],
        [10, -4],
        [11, 5],
        [10, 7],
        [12, -3],
        [6, -12],
        [2, -7],
        [14, -22],
        [-8, -12],
        [-12, 0],
        [-18, 0],
        [-20, 0],
        [-26, -6],
        [-14, -12],
        [-15, -11],
        [-12, 3],
        [-23, -11],
        [-14, -19],
        [-3, -7],
        [-1, -10],
        [-1, -6],
        [5, -7],
        [21, -17],
        [18, -13],
        [12, -13],
        [20, -14],
        [31, -28],
        [14, -10],
        [24, -2],
        [8, -6],
        [4, -8],
        [-2, -13],
        [0, -3],
        [-8, -28],
        [-6, -16],
        [-2, -10],
        [2, -14],
        [6, -6],
        [4, -8],
        [-10, 0],
        [0, -17],
        [4, -10],
        [10, -17],
        [-6, -10],
        [-2, -7],
        [-4, -12],
        [-8, 0],
        [-8, 1],
        [-17, -7],
        [-13, -14],
        [-14, -12],
        [-23, 4],
        [-14, -3],
        [-14, 6],
        [-18, 2],
        [-10, -1],
        [-11, -10],
        [-9, 1],
        [-3, -1],
        [-7, -3],
        [-11, 4],
        [-15, -3],
        [-2, 6],
        [2, 6],
        [0, 11],
        [-4, 7],
        [-4, 6],
        [-12, 12],
        [-8, 9],
        [-11, 21],
        [-9, 8],
        [-8, 4],
        [-15, 0],
        [-10, -3],
        [-6, -7],
        [-2, -7],
        [0, -8],
        [3, -7],
        [5, -6],
        [7, -4],
        [8, -6],
        [9, -4],
        [1, -8],
        [-2, -7],
        [0, -4],
        [0, -5],
        [2, -4],
        [6, -5],
        [8, -2],
        [8, 0],
        [1, 0],
        [5, -3],
        [-4, -3],
        [-2, 0],
        [-7, 0],
        [-3, 0],
        [-15, 2],
        [-1, -2],
        [-8, -2],
        [-6, 4],
        [-7, 3],
        [0, 5],
        [2, 5],
        [1, 4],
        [1, 4],
        [-1, 9],
        [-5, 6],
        [-6, 9],
        [-10, 6],
        [-12, 2],
        [-10, -2],
        [-8, -1],
        [-5, -7],
        [-1, -1],
        [-7, -10],
        [-3, 5],
        [-6, 13],
        [-6, 10],
        [-8, 4],
        [-15, 5],
        [-4, 6],
        [-3, 11],
        [-10, 7],
        [-16, 10],
        [22, 15],
        [8, 8],
        [13, 0],
        [22, 5],
        [26, 39],
        [-7, 46],
        [0, 0],
        [-7, 20],
        [-18, 26],
        [-12, 12],
        [-31, 7],
        [-93, -7],
        [-4, 0],
        [-8, 17],
        [-15, 10],
        [-14, 14],
        [-8, 15],
        [-14, 19],
        [-30, 29],
        [-15, 11],
        [-48, 37],
        [-21, 23],
        [-39, 36],
        [-18, 13],
        [-4, 3],
        [-45, 7],
        [-26, -5],
        [-32, 5],
        [-30, 12],
        [-20, -2],
        [-32, 0],
        [-8, 0],
        [-24, 0],
        [-3, 0],
        [-20, 1],
        [-31, 5],
        [-15, -2],
        [-24, -11],
        [-25, -14],
        [-13, -10],
        [-24, -7],
        [-12, -67],
        [-2, -18],
        [-10, -26],
        [-8, -29],
        [-4, -14],
        [-7, -19],
        [-4, -6],
        [-10, -6],
        [-16, -8],
        [-18, -11],
        [-15, -24],
        [-8, 0],
        [-7, -8],
        [-11, -4],
        [-10, -14],
        [-4, -6],
        [-16, -2],
        [-14, -15],
        [-12, -10],
        [-9, -2],
        [-4, -5],
        [-1, 0],
        [-9, -3],
        [-5, -11],
        [-14, -1],
        [-9, -4],
        [-7, 1],
        [-8, 0],
        [-4, 4],
        [-6, 2],
        [-9, 0],
        [-6, 1],
        [-3, -3],
        [-13, 4],
        [-8, 1],
        [-6, -5],
        [-6, 4],
        [-5, 0],
        [-10, 8],
        [-4, 0],
        [-4, -2],
        [-10, 4],
        [-12, 0],
        [-8, 4],
        [-18, 5],
        [-5, 0],
        [-6, -3],
        [-10, 2],
        [-4, -2],
        [-6, -5],
        [-2, -5],
        [-5, 2],
        [-7, 1],
        [-7, -1],
        [-2, -6],
        [-6, -6],
        [-6, 0],
        [-4, 4],
        [-2, 9],
        [-7, 5],
        [-12, 1],
        [-1, 12],
        [-3, 7],
        [-4, 4],
        [-6, 8],
        [-9, 6],
        [-8, 12],
        [-2, 10],
        [0, 4],
        [-13, 18],
        [-10, 6],
        [-12, 3],
        [-4, 4],
        [-8, 18],
        [0, 12],
        [0, 2],
        [-4, 8],
        [-8, 5],
        [-14, 4],
        [-7, 2],
        [-4, 1],
        [-2, 1],
        [-5, 9],
        [-1, 2],
        [-1, 1],
        [-18, 10],
        [-14, 8],
        [-13, 13],
        [-10, 20],
        [-4, 19],
        [-7, 9],
        [-8, 11],
        [-4, 10],
        [-2, 17],
        [-4, 2],
        [-6, 15],
        [-6, 11],
        [-6, 12],
        [-4, 5],
        [-7, 6],
        [-3, 2],
        [-9, 5],
        [-10, 6],
        [-4, 8],
        [-8, 12],
        [-11, 19],
        [-4, 17],
        [-4, 6],
        [-4, 11],
        [-6, 8],
        [-6, 17],
        [-2, 8],
        [-10, 7],
        [-6, 12],
        [-1, 18],
        [-7, 18],
        [10, 16],
        [1, 18],
        [-4, 9],
        [5, 21],
        [16, 23],
        [2, 25],
        [8, 19],
        [12, 24],
        [13, 19],
        [3, 5],
        [3, 18],
        [2, 26],
        [-14, 23],
        [-11, 21],
        [-18, 16],
        [-17, 19],
        [-10, 8],
        [-5, 1],
        [-5, 2],
        [-11, 12],
        [-2, 3],
        [-2, 7],
        [-23, 19],
        [-18, 13],
        [-12, 5],
        [-10, 4],
        [-16, 15],
        [-2, 2],
        [-2, 2],
        [-7, 6],
        [-14, 4],
        [-5, 16],
        [-14, 12],
        [-16, 25],
        [-2, 8],
        [-2, 5],
        [-16, 16],
        [-6, 16],
        [-12, 16],
        [-11, 6],
        [-18, 5],
        [-13, 10],
        [-13, 0],
        [-16, 6],
        [-20, 6],
        [-22, 2],
        [-16, 2],
        [-5, 0],
        [-9, 4],
        [-12, 4],
        [-12, 6],
        [-18, 4],
        [-57, 18],
        [-34, 15],
        [-23, 14],
        [-18, 12],
        [-7, 2],
        [-22, 29],
        [-25, 23],
        [-27, 22],
        [-16, 18],
        [-8, 3],
        [-22, 17],
        [-12, 14],
        [-2, 9],
        [-9, 12],
        [-15, 5],
        [-6, 9],
        [-10, 2],
        [-2, 8],
        [-13, 12],
        [-7, 5],
        [-4, 6],
        [0, 2],
        [-10, 34],
        [-25, 73],
        [-10, 23],
        [-30, 75],
        [-6, 28],
        [0, 2],
        [-8, 30],
        [-15, 40],
        [-11, 47],
        [-7, 8],
        [-2, 21],
        [-6, 19],
        [-33, 58],
        [-8, 2],
        [-10, 26],
        [-38, 68],
        [-4, 20],
        [-31, 46],
        [-6, 9],
        [-4, 9],
        [2, 8],
        [8, -8],
        [4, -1],
        [5, -9],
        [6, -6],
        [14, -8],
        [13, -2],
        [13, 2],
        [7, 0],
        [11, -4],
        [10, 2],
        [14, 4],
        [14, -4],
        [-2, -12],
        [2, -16],
        [2, -4],
        [3, -14],
        [12, -22],
        [0, -16],
        [0, -17],
        [4, -13],
        [12, -21],
        [13, -9],
        [5, -8],
        [11, -5],
        [8, -8],
        [16, -8],
        [5, 0],
        [4, 0],
        [6, 2],
        [7, 4],
        [5, 4],
        [7, 6],
        [8, 16],
        [3, 7],
        [5, 21],
        [7, 32],
        [1, 23],
        [1, 12],
        [4, 16],
        [2, 4],
        [4, 20],
        [0, 19],
        [2, 17],
        [-5, 8],
        [-3, 41],
        [3, 26],
        [-5, 28],
        [-15, 12],
        [-13, 5],
        [-17, 3],
        [-13, 12],
        [-9, 25],
        [-14, 19],
        [-13, 14],
        [-20, 15],
        [-23, 14],
        [-26, 20],
        [-8, 4],
        [-14, 3],
        [-12, 2],
        [-10, -2],
        [-10, -2],
        [-9, 0],
        [-9, 8],
        [-8, 11],
        [-11, 2],
        [-6, -1],
        [-16, 2],
        [-8, -5],
        [-6, -1],
        [-8, -2],
        [-10, -11],
        [-5, -13],
        [-39, 8],
        [-16, 14],
        [-16, 13],
        [-5, 4],
        [-10, 0],
        [-12, 7],
        [-17, 4],
        [-7, 8],
        [-7, 2],
        [-13, 16],
        [-14, 16],
        [-11, 28],
        [-18, 16],
        [-14, 12],
        [-16, 17],
        [-10, 11],
        [-5, 3],
        [-12, 10],
        [-9, 11],
        [-4, 1],
        [-13, 11],
        [-15, 17],
        [-14, 20],
        [-12, 8],
        [-5, 10],
        [-12, 12],
        [-11, 10],
        [-6, 20],
        [-5, 4],
        [-2, 8],
        [-4, 11],
        [-8, 2],
        [-8, 5],
        [-2, 6],
        [-6, 22],
        [-4, 16],
        [-4, 10],
        [-2, 12],
        [-2, 14],
        [-2, 7],
        [-2, 4],
        [-6, 9],
        [2, 15],
        [4, 12],
        [-2, 7],
        [-6, 3],
        [-6, -1],
        [-8, 0],
        [-8, 2],
        [-4, 7],
        [-5, 8],
        [-8, 7],
        [-4, 5],
        [-4, 2],
        [-6, 1],
        [-2, 1],
        [-1, 6],
        [-2, 3],
        [-4, 4],
        [-4, 2],
        [-4, 3],
        [-4, 1],
        [-2, 0],
        [-4, -2],
        [-2, -4],
        [0, -7],
        [0, -9],
        [-2, -2],
        [-4, -3],
        [-4, -3],
        [-4, -6],
        [-5, -8],
        [0, -7],
        [0, -5],
        [-11, 5],
        [-8, 4],
        [-8, -3],
        [-12, 6],
        [-9, -1],
        [-2, 6],
        [-13, 7],
        [-9, 2],
        [-6, -3],
        [-6, -7],
        [4, -20],
        [18, -15],
        [10, -13],
        [13, -10],
        [0, -1],
        [-2, -4],
        [-23, -9],
        [-6, -13],
        [-14, -6],
        [-8, -8],
        [-11, 1],
        [-26, -8],
        [-10, -7],
        [-10, 6],
        [-15, 1],
        [-10, -4],
        [-2, 0],
        [-20, -22],
        [-8, -14],
        [-6, -11],
        [-30, 18],
        [-24, 13],
        [-25, 9],
        [-7, -1],
        [-43, 32],
        [-18, 14],
        [-21, 7],
        [-19, 4],
        [-35, -4],
        [-13, 0],
        [-15, -2],
        [-28, -5],
        [-11, 5],
        [-6, -3],
        [-12, 10],
        [-8, 2],
        [-18, 2],
        [-17, -3],
        [-26, -4],
        [-7, 4],
        [-1, 1],
        [-8, 1],
        [-4, -2],
        [-8, -6],
        [-21, 2],
        [-2, 3],
        [-2, 4],
        [-12, 8],
        [-19, -1],
        [-11, 9],
        [-15, -3],
        [-12, -5],
        [-8, 7],
        [-15, 14],
        [-25, -3],
        [-9, 5],
        [-11, -1],
        [-5, 6],
        [-20, 14],
        [-27, -10],
        [-12, -15],
        [-16, -9],
        [-12, -1],
        [-18, -6],
        [-19, -13],
        [-11, -10],
        [-20, -25],
        [-22, -22],
        [0, -2],
        [-3, -20],
        [-2, -11],
        [1, -18],
        [-4, -4],
        [-2, -4],
        [0, -6],
        [-13, 10],
        [-9, 8],
        [-6, 7],
        [-2, 0],
        [-5, 2],
        [-6, -1],
        [-13, -9],
        [-3, -11],
        [-2, -4],
        [-8, 8],
        [-8, 7],
        [-4, 1],
        [-8, 5],
        [-6, 2],
        [-4, 4],
        [-6, 3],
        [-5, 1],
        [-2, -2],
        [-3, -5],
        [-3, -4],
        [-2, 2],
        [-11, 0],
        [-12, -14],
        [-4, 0],
        [-2, -2],
        [-4, -2],
        [-2, -4],
        [0, -6],
        [-17, 0],
        [-8, 6],
        [-4, 0],
        [-4, 0],
        [-2, -2],
        [-4, 6],
        [-4, 4],
        [-4, 4],
        [-5, 4],
        [-6, 1],
        [-6, 10],
        [-1, 5],
        [1, 4],
        [-3, 4],
        [-4, 1],
        [-2, 3],
        [-1, 0],
        [-2, -1],
        [-3, -4],
        [-3, 1],
        [-5, -1],
        [-4, -3],
        [0, -7],
        [1, -8],
        [6, -5],
        [0, -3],
        [0, -5],
        [4, -4],
        [3, -12],
        [-3, -6],
        [-3, -6],
        [-1, -8],
        [-9, -4],
        [-14, 2],
        [-8, -4],
        [-6, -4],
        [-2, -8],
        [-10, -10],
        [-8, 0],
        [-5, -2],
        [-3, 2],
        [-6, 2],
        [-15, 0],
        [-3, 4],
        [-11, 12],
        [-5, 4],
        [-15, -4],
        [-12, 6],
        [-6, -2],
        [-6, 16],
        [2, 12],
        [2, 15],
        [-2, 8],
        [-6, 13],
        [-13, 4],
        [-6, 0],
        [-6, -2],
        [-6, -9],
        [0, -3],
        [-2, -8],
        [-5, -18],
        [-6, -22],
        [-6, 0],
        [-6, 0],
        [-6, -2],
        [-4, 2],
        [-6, 6],
        [-4, 6],
        [-4, 10],
        [-4, 4],
        [-6, 4],
        [-4, 2],
        [-7, -2],
        [-2, 0],
        [-4, 2],
        [-4, 0],
        [-2, -2],
        [-4, 0],
        [-6, 4],
        [-8, 19],
        [-2, 7],
        [-4, 9],
        [-2, 14],
        [-18, 7],
        [-4, 0],
        [-5, 3],
        [-3, 1],
        [-4, -1],
        [-4, -2],
        [-5, -5],
        [-5, 1],
        [-7, 2],
        [-10, 7],
        [-4, 0],
        [-6, 8],
        [0, 13],
        [0, 15],
        [-2, 9],
        [-2, 6],
        [-2, 2],
        [-4, -1],
        [-4, -3],
        [-4, 3],
        [-1, 4],
        [-4, 3],
        [-6, -1],
        [-7, 4],
        [-11, -2],
        [-8, -9],
        [-12, -12],
        [-3, 8],
        [-3, 11],
        [-5, 4],
        [-4, 1],
        [-2, 10],
        [-8, 7],
        [-8, -4],
        [-4, 2],
        [-4, 4],
        [-4, -1],
        [-12, -8],
        [-7, 6],
        [-7, 2],
        [-4, -2],
        [-7, 7],
        [-9, 4],
        [-6, 2],
        [-5, -4],
        [-1, 7],
        [-9, 4],
        [-6, 1],
        [2, 5],
        [0, 6],
        [0, 4],
        [-4, 3],
        [-2, 2],
        [2, 3],
        [2, 5],
        [-2, 9],
        [-2, 10],
        [-2, 9],
        [-6, 3],
        [-4, 4],
        [-2, 4],
        [-6, 2],
        [-4, 2],
        [-4, 0],
        [-4, -2],
        [-4, 2],
        [-2, 4],
        [4, 2],
        [4, 4],
        [2, 2],
        [2, 4],
        [-2, 6],
        [-1, 2],
        [-4, 4],
        [-4, 2],
        [1, 6],
        [0, 8],
        [-2, 4],
        [-5, 5],
        [-6, 3],
        [-1, 8],
        [3, 6],
        [1, 9],
        [2, 5],
        [4, 10],
        [0, 7],
        [-2, 4],
        [6, 2],
        [1, 2],
        [3, 3],
        [0, 3],
        [-2, 7],
        [-5, 4],
        [-2, 4],
        [-2, 11],
        [-13, 0],
        [2, 10],
        [-4, 8],
        [-7, 0],
        [-4, 6],
        [-11, 10],
        [-6, 16],
        [2, 10],
        [-4, 14],
        [-8, 16],
        [4, 11],
        [0, 7],
        [-8, 4],
        [-10, -2],
        [-13, 24],
        [-8, 1],
        [-8, 13],
        [6, 10],
        [-2, 6],
        [15, 14],
        [-2, 9],
        [-4, 2],
        [1, 15],
        [-16, 8],
        [-9, 8],
        [-8, -3],
        [-2, 3],
        [-2, 8],
        [4, 10],
        [12, 5],
        [3, 6],
        [6, 7],
        [0, 12],
        [-3, 2],
        [3, 11],
        [0, 9],
        [10, 10],
        [1, 2],
        [0, 8],
        [-5, 8],
        [-2, 2],
        [-10, 10],
        [0, 2],
        [9, 2],
        [14, 3],
        [6, 6],
        [-6, 12],
        [-11, 7],
        [-8, 9],
        [0, 8],
        [-2, 3],
        [-3, 4],
        [-11, 8],
        [-11, 5],
        [-6, 12],
        [-4, 2],
        [-17, 4],
        [-2, 2],
        [0, -2],
        [-8, -6],
        [-6, -9],
        [-6, -8],
        [-2, -23],
        [0, -3],
        [-13, -12],
        [-6, 9],
        [-16, 15],
        [-18, 5],
        [-16, 6],
        [-7, 28],
        [-6, 50],
        [0, 23],
        [-8, 28],
        [-8, 129],
        [0, 282],
        [-14, 16],
        [-30, 30],
        [-6, 15],
        [-4, 3],
        [-9, 14],
        [-11, 22],
        [-26, 18],
        [-16, 32],
        [-6, 10],
        [-4, 14],
        [4, 13],
        [0, 6],
        [-8, 9],
        [-47, 36],
        [-10, 6],
        [-3, 12],
        [-3, 10],
        [7, 33],
        [-4, 1],
        [-10, -16],
        [-7, -6],
        [-6, -3],
        [-6, -2],
        [-6, 5],
        [-6, 12],
        [-4, 4],
        [-25, -2],
        [-13, 1],
        [-16, 1],
        [-18, 5],
        [-8, 15],
        [-22, 13],
        [-32, 9],
        [-29, 19],
        [-2, 14],
        [-2, 24],
        [-28, -10],
        [-5, 0],
        [-36, -4],
        [-53, 16],
        [-71, 24],
        [-109, 28],
        [-34, 16],
        [-8, 2],
        [-8, -4],
        [-29, -3],
        [-23, 11],
        [-19, 5],
        [-10, 2],
        [-16, -9],
        [-23, 18],
        [-32, 3],
        [-17, 10],
        [-31, 14],
        [-26, 18],
        [-13, 6],
        [-11, 12],
        [-9, 17],
        [-11, 29],
        [2, 8],
        [14, -3],
        [7, -8],
        [9, -6],
        [11, -6],
        [5, -10],
        [13, -8],
        [9, -5],
        [11, -4],
        [15, 4],
        [20, 7],
        [4, -5],
        [12, -6],
        [11, -2],
        [11, 2],
        [7, 4],
        [14, 4],
        [10, 5],
        [8, -9],
        [6, -4],
        [18, -4],
        [26, 4],
        [8, -4],
        [14, 0],
        [5, 4],
        [2, 0],
        [2, 6],
        [8, 16],
        [17, 15],
        [4, 32],
        [-1, 13],
        [21, 15],
        [13, 3],
        [6, 28],
        [-2, 9],
        [-8, 12],
        [3, 35],
        [7, 1],
        [15, 5],
        [9, 5],
        [4, 3],
        [0, 12],
        [-2, 2],
        [-6, 0],
        [-20, -1],
        [-13, -4],
        [-13, 6],
        [-15, -4],
        [-40, -13],
        [0, 0],
        [0, -1],
        [-14, -18],
        [0, -2],
        [-2, -4],
        [-7, -38],
        [-2, -24],
        [1, -17],
        [-15, -4],
        [-31, 15],
        [-28, 12],
        [-7, 18],
        [-15, 6],
        [-23, -1],
        [-27, 7],
        [-38, 19],
        [-27, 14],
        [-25, 8],
        [-25, 16],
        [-15, 13],
        [-34, 7],
        [-22, -37],
        [-28, 0],
        [-14, 10],
        [-33, 18],
        [-53, 15],
        [-83, 20],
        [-9, 12],
        [-19, 9],
        [-23, 11],
        [-33, 2],
        [-31, 0],
        [-14, 16],
        [-24, 1],
        [-33, 2],
        [-5, 8],
        [-10, 13],
        [-35, 9],
        [-22, 9],
        [-90, 2],
        [-13, 27],
        [-41, 46],
        [-27, 25],
        [-6, 5],
        [-25, 4],
        [-20, 2],
        [-49, 10],
        [-22, 5],
        [-24, 4],
        [-20, 3],
        [-37, -2],
        [-27, 5],
        [-6, 6],
        [-14, 13],
        [-12, 16],
        [-4, 19],
        [-4, 6],
        [-19, -14],
        [-50, -27],
        [-40, -27],
        [-58, -28],
        [-36, -11],
        [-55, -16],
        [-45, -16],
        [-65, -16],
        [-80, -14],
        [-44, 0],
        [-76, 0],
        [-121, -14],
        [-88, 4],
        [-77, 14],
        [-118, 30],
        [-84, 41],
        [-72, 56],
        [-65, 73],
        [-99, 81],
        [-72, 77],
        [-60, 84],
        [-86, 74],
        [-95, 111],
        [-168, 260],
        [-54, 87],
        [-8, 24],
        [-8, 34],
        [-14, 28],
        [-16, 52],
        [-10, 42],
        [-5, 24],
        [-4, 22],
        [-6, 31],
        [-4, 23],
        [1, 1],
        [-1, 6],
        [-3, 7],
        [-2, 6],
        [1, 4],
        [0, 6],
        [-1, 4],
        [-3, 4],
        [-1, 6],
        [2, 6],
        [2, 9],
        [4, 10],
        [1, 6],
        [0, 10],
        [-1, 6],
        [-3, 7],
        [-2, 4],
        [-1, 9],
        [-1, 7],
        [-6, 6],
        [-3, 21],
        [-3, 20],
        [-10, 26],
        [-3, 2],
        [-7, 2],
        [-6, 8],
        [-4, 12],
        [-2, 17],
        [-4, 28],
        [-4, 9],
        [-2, 6],
        [-5, 4],
        [-9, 15],
        [-7, 13],
        [-2, 18],
        [-4, 9],
        [-4, 12],
        [2, 19],
        [-18, 9],
        [-21, 25],
        [-20, 9],
        [-28, 19],
        [-14, 13],
        [-16, 14],
        [-12, 16],
        [-9, 18],
        [-8, 20],
        [-8, 14],
        [-6, 7],
        [-2, 7],
        [-12, 10],
        [-6, 12],
        [-17, 23],
        [-14, 12],
        [-6, 4],
        [-9, 10],
        [-10, 4],
        [-12, 10],
        [-12, 10],
        [-12, 4],
        [-3, 4],
        [-14, 4],
        [-7, 6],
        [-12, 14],
        [-8, 0],
        [-11, 0],
        [-7, 2],
        [-5, 2],
        [-6, 5],
        [-2, -1],
        [-16, -10],
        [-19, -12],
        [-26, -12],
        [-45, -18],
        [-27, -6],
        [-48, -4],
        [-45, -4],
        [-8, 2],
        [-8, 6],
        [-10, 4],
        [-18, 8],
        [-34, -6],
        [-56, -8],
        [-46, -10],
        [-45, -4],
        [-52, -2],
        [-12, 8],
        [-18, -2],
        [-15, 2],
        [-12, 4],
        [-6, 6],
        [-4, 14],
        [-9, -4],
        [-7, -2],
        [-12, 2],
        [-16, 0],
        [-18, 4],
        [-21, 10],
        [-6, 6],
        [-2, 10],
        [-10, 0],
        [-13, 0],
        [-7, 4],
        [-4, 8],
        [-3, 0],
        [-12, 0],
        [-14, -2],
        [-14, 2],
        [-16, 7],
        [-8, 0],
        [-18, 6],
        [-10, -4],
        [-38, 5],
        [-24, 5],
        [-38, 8],
        [-21, 8],
        [-5, 7],
        [-8, 16],
        [-8, 6],
        [-13, -3],
        [-12, 3],
        [-21, 8],
        [-20, 12],
        [-32, 19],
        [-11, 16],
        [-6, 6],
        [-12, 8],
        [-8, 17],
        [-6, 4],
        [-10, 8],
        [-10, 1],
        [-12, 8],
        [-16, 21],
        [-12, 3],
        [-15, 6],
        [-27, 12],
        [-10, 3],
        [-12, 11],
        [-16, 13],
        [-11, 15],
        [-10, 16],
        [-6, 5],
        [-22, 6],
        [-10, 6],
        [-13, 18],
        [-15, 9],
        [-21, 11],
        [-20, 14],
        [-12, 11],
        [-11, 12],
        [-4, 8],
        [-2, 8],
        [4, 10],
        [-2, 10],
        [-4, 20],
        [2, 5],
        [-2, 3],
        [-6, 1],
        [-10, 6],
        [-19, 7],
        [-10, 1],
        [-12, 0],
        [-10, 6],
        [-13, 6],
        [-18, 11],
        [-4, 11],
        [-4, 13],
        [-4, 2],
        [-7, 1],
        [-8, 1],
        [-8, 1],
        [-5, 4],
        [-7, 12],
        [-5, 6],
        [-16, 6],
        [-8, 0],
        [-13, -2],
        [-16, 2],
        [-18, 0],
        [-25, 4],
        [-29, 8],
        [-8, 2],
        [-14, 2],
        [-15, 6],
        [-8, 10],
        [-6, 4],
        [-8, 0],
        [-21, 6],
        [-17, 11],
        [-24, 15],
        [-18, 16],
        [-12, 5],
        [-13, 12],
        [-11, 7],
        [-13, 13],
        [-12, 14],
        [-8, 12],
        [-3, 12],
        [0, 9],
        [2, 19],
        [-1, 7],
        [-9, 5],
        [-15, 6],
        [-8, 12],
        [-13, 14],
        [-6, 15],
        [0, 13],
        [0, 14],
        [-4, 2],
        [-4, 4],
        [-6, -2],
        [-10, -2],
        [-11, 4],
        [-10, 4],
        [-6, -2],
        [-37, 0],
        [-36, 0],
        [-42, 2],
        [-25, 2],
        [-39, 8],
        [-17, 6],
        [-15, 6],
        [-8, 6],
        [-12, 10],
        [-7, -1],
        [-10, 1],
        [-10, 6],
        [-8, 12],
        [-9, 4],
        [-9, 2],
        [-7, 7],
        [-6, 12],
        [-4, 11],
        [10, 8],
        [6, 11],
        [0, 7],
        [-3, 4],
        [-9, 4],
        [-9, 2],
        [-6, 10],
        [-7, 0],
        [-9, -6],
        [-27, 26],
        [-23, 13],
        [-10, 24],
        [-8, 8],
        [-14, 29],
        [3, 6],
        [3, 8],
        [-3, 9],
        [-7, 10],
        [-11, 10],
        [-9, 14],
        [-5, 16],
        [-10, 9],
        [0, 8],
        [15, 8],
        [22, 12],
        [17, 9],
        [1, 10],
        [-4, 7],
        [-4, 2],
        [-2, -5],
        [-8, 1],
        [-9, 12],
        [-16, -1],
        [-8, -3],
        [-18, -10],
        [-11, -4],
        [-13, -10],
        [-16, 1],
        [-17, 11],
        [-24, 16],
        [-14, 18],
        [-21, 21],
        [-10, 12],
        [-4, 14],
        [2, 12],
        [-11, 0],
        [-38, 4],
        [-12, 3],
        [-13, 3],
        [-11, 9],
        [-10, 10],
        [-8, 10],
        [0, 15],
        [-10, 0],
        [-8, 5],
        [-8, 10],
        [-11, 18],
        [-11, 18],
        [-12, 16],
        [-10, 12],
        [-8, 14],
        [-10, 6],
        [-6, 0],
        [-11, -2],
        [-15, 10],
        [-9, 18],
        [-10, 9],
        [-11, 5],
        [-15, 15],
        [-12, 15],
        [-8, 9],
        [-8, 15],
        [-6, 9],
        [-4, 10],
        [-3, 16],
        [-7, 0],
        [-6, 0],
        [-15, 4],
        [-8, 9],
        [-11, 14],
        [-24, 18],
        [-6, 4],
        [-8, 3],
        [-15, 10],
        [-14, 14],
        [-10, 9],
        [-6, 10],
        [-10, 4],
        [-8, 7],
        [-11, 17],
        [-9, 13],
        [-16, 14],
        [-6, 8],
        [-10, 13],
        [-10, 14],
        [-9, 10],
        [-9, 11],
        [-11, 5],
        [-11, 9],
        [-8, 8],
        [-2, 12],
        [-4, 8],
        [-2, 2],
        [-8, 0],
        [-18, 4],
        [-19, 10],
        [-8, 6],
        [-9, 12],
        [-8, 12],
        [-4, 13],
        [-16, 0],
        [-16, 2],
        [-16, 3],
        [-16, 11],
        [-10, 11],
        [-6, 10],
        [-6, 5],
        [-12, 5],
        [-9, 1],
        [-18, 1],
        [-23, 2],
        [-24, 5],
        [-23, 9],
        [-20, 11],
        [-24, 14],
        [-20, 4],
        [-43, 38],
        [-20, 6],
        [-33, 34],
        [-32, 41],
        [-19, 13],
        [-46, 53],
        [-8, 23],
        [-30, 24],
        [-40, 12],
        [-37, 10],
        [-66, 19],
        [-83, 10],
        [-16, 12],
        [-79, 10],
        [-40, 6],
        [-26, 16],
        [-54, 6],
        [-32, -3],
        [-29, 8],
        [-76, 6],
        [-34, 10],
        [-29, 21],
        [-19, 31],
        [-82, 40],
        [-39, -8],
        [-19, 0],
        [-21, 6],
        [-20, 0],
        [-27, 14],
        [-87, 14],
        [-58, 11],
        [-78, 18],
        [-65, 12],
        [-20, 12],
        [-35, 14],
        [-26, 3],
        [-15, 17],
        [-11, 4],
        [-18, 18],
        [12, 23],
        [-11, 6],
        [-25, 0],
        [-129, 116],
        [-23, 39],
        [-46, 55],
        [-36, 77],
        [-24, 33],
        [-15, 60],
        [-10, 34],
        [-10, 4],
        [-9, 11],
        [12, 10],
        [-4, 16],
        [-45, 31],
        [-10, 32],
        [-14, 52],
        [-20, 22],
        [-7, 15],
        [-12, 10],
        [-11, 20],
        [-22, 17],
        [-10, 22],
        [2, 16],
        [-40, 55],
        [-57, 67],
        [-22, 17],
        [-37, 2],
        [-29, 12],
        [-29, 14],
        [-37, 37],
        [-18, 64],
        [-17, 5],
        [-32, 4],
        [-42, 8],
        [-26, 2],
        [-38, 13],
        [-26, 13],
        [-14, 17],
        [-13, 21],
        [0, 16],
        [-12, 7],
        [-31, 2],
        [-28, -7],
        [-12, 9],
        [-20, -4],
        [-25, 3],
        [-26, 21],
        [2, 10],
        [-27, 12],
        [-22, 8],
        [-19, 6],
        [-26, 4],
        [-12, 2],
        [-13, -4],
        [-27, -2],
        [-6, 8],
        [-8, 16],
        [0, 12],
        [-15, 10],
        [-18, -2],
        [-2, -10],
        [-8, -5],
        [-14, -3],
        [-17, -4],
        [-16, 2],
        [-8, 5],
        [-3, 9],
        [3, 15],
        [-25, 14],
        [-50, 10],
        [-8, -3],
        [-16, -9],
        [-24, -8],
        [-19, -4],
        [-11, 4],
        [-12, 12],
        [-8, 21],
        [-28, 12],
        [-44, 11],
        [-23, -5],
        [-27, -6],
        [-83, 17],
        [-19, -4],
        [-46, 6],
        [-22, 12],
        [-35, 4],
        [-17, 12],
        [-50, 22],
        [-45, 7],
        [-101, 33],
        [-12, 13],
        [-41, 6],
        [-23, 9],
        [-20, 2],
        [-15, 10],
        [-27, 10],
        [-14, 13],
        [-31, 9],
        [-22, 2],
        [-38, 11],
        [-82, 41],
        [-41, 12],
        [-41, 16],
        [-75, 26],
        [-71, 38],
        [-26, 29],
        [-7, 30],
        [-16, 31],
        [-80, 59],
        [-39, 34],
        [-59, 56],
        [-70, 72],
        [-58, 53],
        [-69, 62],
        [-63, 62],
        [-33, 34],
        [-38, 55],
        [-75, 102],
        [-24, 40],
        [-20, 38],
        [-17, 26],
        [-49, 106],
        [-28, 75],
        [-64, 175],
        [-44, 89],
        [-87, 165],
        [-29, 53],
        [-41, 63],
        [-48, 41],
        [-213, 115],
        [-80, 20],
        [-6, -10],
        [-15, -20],
        [-28, -20],
        [-79, -34],
        [-57, -17],
        [-16, 2],
        [-25, -2],
        [-48, -26],
        [-97, -105],
        [-43, -72],
        [-51, -78],
        [-17, -24],
        [-20, -33],
        [-44, -75],
        [-43, -52],
        [-7, -12],
        [-6, -16],
        [-12, -11],
        [-6, -7],
        [-8, -22],
        [-6, -6],
        [-12, -11],
        [-30, -44],
        [-10, -20],
        [-21, -42],
        [-90, -182],
        [-24, -35],
        [-28, -20],
        [-37, -15],
        [-10, -2],
        [-33, 17],
        [-22, 26],
        [-6, 44],
        [4, 28],
        [0, 18],
        [4, 23],
        [19, 25],
        [16, 12],
        [1, 7],
        [7, 9],
        [26, 17],
        [13, 7],
        [27, 12],
        [1, 5],
        [-12, 21],
        [-4, 19],
        [-10, 14],
        [-21, 22],
        [-22, 24],
        [4, 19],
        [-4, 7],
        [-10, 13],
        [1, 11],
        [-7, 10],
        [-35, 31],
        [-20, 28],
        [-8, 18],
        [0, 21],
        [5, 24],
        [-1, 18],
        [-7, 27],
        [-3, 19],
        [7, 21],
        [29, 29],
        [45, 21],
        [11, 17],
        [20, 25],
        [18, 6],
        [4, 6],
        [-4, 10],
        [-26, 47],
        [-18, 34],
        [-13, 18],
        [-15, 13],
        [-8, 2],
        [-14, -9],
        [-6, 17],
        [-2, 9],
        [4, 12],
        [16, 14],
        [38, 22],
        [63, 40],
        [72, 31],
        [60, 27],
        [13, 9],
        [16, 6],
        [19, 2],
        [2, 2],
        [0, 4],
        [0, 2],
        [-6, 0],
        [-58, -7],
        [-28, -4],
        [-28, -13],
        [-43, -17],
        [-76, -24],
        [-58, -6],
        [-58, 2],
        [-51, 8],
        [-13, 7],
        [-12, -6],
        [-48, 16],
        [-56, 30],
        [-16, 48],
        [-3, 10],
        [0, 15],
        [2, 19],
        [5, 8],
        [1, 8],
        [4, 6],
        [7, 5],
        [6, -1],
        [8, -3],
        [4, -7],
        [11, -16],
        [13, 5],
        [3, 3],
        [2, 4],
        [1, 8],
        [-3, 13],
        [-7, 15],
        [-14, 12],
        [-27, 6],
        [-10, 4],
        [-2, 4],
        [-8, 4],
        [-11, 2],
        [-8, 0],
        [-8, 9],
        [-4, 4],
        [-4, 2],
        [-1, 5],
        [1, 5],
        [6, 6],
        [2, 1],
        [26, -9],
        [5, -4],
        [6, 1],
        [6, 2],
        [7, 5],
        [10, 8],
        [6, 3],
        [4, 1],
        [4, -1],
        [6, -1],
        [10, -7],
        [17, -13],
        [11, -6],
        [6, -5],
        [8, 6],
        [6, 7],
        [20, 41],
        [45, 22],
        [27, 17],
        [31, 10],
        [9, 2],
        [8, -2],
        [12, -6],
        [10, -8],
        [12, -6],
        [8, -1],
        [7, 1],
        [0, 2],
        [8, 6],
        [30, 2],
        [7, 10],
        [-8, 20],
        [-27, 28],
        [-43, 16],
        [-95, -12],
        [-97, -32],
        [-111, -34],
        [-194, -56],
        [-105, -39],
        [-77, -34],
      ],
      [
        [100258, 145372],
        [1401, 241],
        [5561, -3559],
        [5766, -3698],
        [4994, 2579],
        [-195, 3982],
        [-22, 124],
        [63, 203],
        [95, 106],
        [10, 61],
        [-14, 65],
        [-23, 68],
        [10, 63],
        [68, 71],
        [148, 99],
        [106, 72],
        [219, 159],
        [35, 54],
        [10, 56],
        [-33, 76],
        [-124, 191],
        [-175, 149],
        [5, 362],
        [2, 293],
        [0, 774],
        [0, 109],
        [0, 18],
        [0, 503],
        [0, 102],
        [0, 4],
        [0, 4],
        [1, 0],
        [6, -2],
        [98, 0],
        [484, -8],
        [19, 10],
        [1, 19],
        [4, 297],
        [-5, 877],
        [562, -2],
        [17, 0],
        [31, 0],
        [0, 12],
        [2, 469],
        [2, 143],
        [-2, 596],
        [0, 40],
        [1, 556],
        [1, 32],
        [12, 24],
        [49, 61],
        [13, 28],
        [24, 150],
        [32, 209],
        [22, 130],
        [41, 231],
        [70, 477],
        [4, 28],
        [38, 225],
        [82, 506],
        [11, 69],
        [7, 46],
        [102, 681],
        [18, 113],
        [2, 14],
        [39, 232],
        [55, 362],
        [2, 17],
        [12, 0],
        [930, 12],
        [4, 1],
        [7, 0],
        [14, -1],
        [286, 3],
        [40, 0],
        [17, 1],
        [11, 0],
        [22, 1],
        [13, 0],
        [23, -1],
        [484, 5],
        [2, 0],
        [22, 0],
        [423, 4],
        [-67, 311],
        [-99, 440],
        [450, 1],
        [31, 572],
        [0, 98],
        [1, 108],
        [1, 168],
        [81, 3],
        [44, -2],
        [388, -5],
        [-2, 156],
        [-4, 122],
        [4, 31],
        [-3, 9],
        [1, 173],
        [-2, 337],
        [0, 17],
        [-514, 91],
        [-1, 11],
        [-134, 26],
        [-126, 25],
        [-39, 8],
        [-8, 1],
        [-49, 10],
        [-2, -3],
        [-8, -13],
        [-18, -15],
        [-4, -18],
        [-1, -3],
        [-1, -2],
        [-4, -26],
        [12, -23],
        [-39, -2],
        [-40, -2],
        [-26, 0],
        [-3, 0],
        [-5, 0],
        [-9, -1],
        [-29, 0],
        [-22, 0],
        [-14, 0],
        [-4, 0],
        [-4, 0],
        [-2, 0],
        [-2, 0],
        [-2, 0],
        [-2, 0],
        [-2, 0],
        [-2, 0],
        [-12, -1],
        [-8, 0],
        [-14, 0],
        [7, 131],
        [-136, 26],
        [-2, 14],
        [-33, 4],
        [0, 4],
        [0, 219],
        [0, 807],
        [-6, 464],
        [-11, 100],
        [7, 250],
        [6, 194],
        [6, 20],
        [-12, 0],
        [-175, 9],
        [-21, 376],
        [-2, 3],
        [-10, 15],
        [-1, 14],
        [-11, 119],
        [-1, 15],
        [0, 3],
        [-36, 20],
        [-164, 98],
        [-32, 23],
        [0, 1],
        [-50, 30],
        [-100, 87],
        [-50, 43],
        [-50, 43],
        [-48, 44],
        [-26, 22],
        [-25, 21],
        [-24, 22],
        [-26, 21],
        [0, 15],
        [-43, 36],
        [-53, 38],
        [-33, 21],
        [-9, 6],
        [-9, 5],
        [-83, 39],
        [-114, 50],
        [-6, 3],
        [-394, 167],
        [-118, 52],
        [-22, 10],
        [-57, 24],
        [-55, 23],
        [-21, 10],
        [-12, 8],
        [-23, 24],
        [-5, 10],
        [-4, 8],
        [-4, 11],
        [-2, 12],
        [-2, 22],
        [-2, 26],
        [-3, 26],
        [-1, 10],
        [0, 1],
        [0, 1],
        [1, 6],
        [1, 6],
        [1, 6],
        [0, 5],
        [-1, 7],
        [0, 1],
        [-1, 4],
        [-5, 30],
        [0, 6],
        [-4, 8],
        [-6, 10],
        [-7, 8],
        [-8, 10],
        [-6, 6],
        [-16, 12],
        [-16, 7],
        [-19, 4],
        [-16, 1],
        [-90, -8],
        [0, -2],
        [0, -6],
        [0, -8],
        [0, -100],
        [-145, -11],
        [-9, -1],
        [-46, -3],
        [-40, -4],
        [0, -260],
        [2, -218],
        [0, -75],
        [-27, 0],
        [-27, 0],
        [0, 75],
        [0, 19],
        [1, 27],
        [-1, 15],
        [0, 43],
        [0, 43],
        [-1, 45],
        [-1, 44],
        [0, 54],
        [1, 95],
        [-1, 77],
        [0, 26],
        [0, 33],
        [-1, 30],
        [-1, 16],
        [-2, 10],
        [-1, 2],
        [0, 4],
        [-7, 0],
        [-84, -10],
        [-154, -16],
        [-1, 10],
        [-6, 72],
        [0, 5],
        [0, 3],
        [-88, -9],
        [-1, 0],
        [-113, -10],
        [-11, -1],
        [-120, -12],
        [-8, 0],
        [-81, -8],
        [-92, -8],
        [-161, -16],
        [-166, -16],
        [-294, -31],
        [-41, -2],
        [-125, -10],
        [-98, -8],
        [-4, 13],
        [0, 1],
        [0, 0],
        [-4, 2],
        [-1, 4],
        [-14, 61],
        [0, 2],
        [-1, 4],
        [-2, 8],
        [-25, 90],
        [-11, 35],
        [-10, 31],
        [-19, 55],
        [-34, 102],
        [-40, 125],
        [0, 2],
        [-48, 136],
        [-27, 71],
        [-46, 114],
        [-35, 102],
        [-232, -115],
        [-14, 95],
        [-8, 50],
        [-41, 14],
        [-40, 160],
        [-43, 120],
        [-78, 3],
        [-6, 64],
        [-2, 107],
        [-26, 126],
        [-2, 98],
        [4, 51],
        [12, 76],
        [14, 53],
        [27, 69],
        [-6, 23],
        [-13, 31],
        [-4, 8],
        [-52, 99],
        [-51, -14],
        [-8, -4],
        [-26, -6],
        [-151, -47],
        [-79, -24],
        [-74, -23],
        [-62, -20],
        [-100, -29],
        [-2, 157],
        [-4, 210],
        [-175, -86],
        [-42, -8],
        [-151, -15],
        [-48, -5],
        [-193, -19],
        [-199, -24],
        [-311, -38],
        [-13, -1],
        [-144, -16],
        [-154, -16],
        [4, 16],
        [45, 307],
        [7, 38],
        [14, 89],
        [13, 80],
        [-30, 2],
        [-31, 2],
        [-2, 0],
        [-12, 1],
        [-49, 3],
        [-29, 2],
        [-39, 3],
        [-25, 2],
        [-26, 1],
        [-17, 1],
        [-14, 1],
        [-32, 3],
        [-40, 2],
        [-39, 2],
        [-39, 3],
        [-37, 2],
        [-54, 4],
        [-51, 2],
        [-8, 2],
        [-22, 0],
        [-23, 2],
        [-3, 0],
        [-3, 0],
        [-31, 2],
        [-14, 2],
        [-84, 4],
        [-18, 2],
        [-77, 5],
        [2, 15],
        [4, 21],
        [43, 242],
        [16, 88],
        [2, 10],
        [671, -64],
        [10, -2],
        [24, -2],
        [8, 0],
        [0, 0],
        [0, 9],
        [0, 4],
        [0, 3],
        [0, 42],
        [0, 4],
        [0, 2],
        [2, 45],
        [0, 2],
        [0, 4],
        [0, 44],
        [0, 2],
        [0, 2],
        [0, 92],
        [0, 6],
        [0, 3],
        [0, 3],
        [0, 2],
        [0, 30],
        [0, 17],
        [0, 2],
        [2, 162],
        [0, 13],
        [0, 37],
        [-690, 6],
        [-75, 0],
        [-1, 10],
        [-12, 103],
        [-3, 27],
        [0, 2],
        [-11, 102],
        [-15, 125],
        [-2, 29],
        [-18, 150],
        [-4, 42],
        [-148, 2],
        [-3, 0],
        [-26, 0],
        [-2, 0],
        [-99, 1],
        [-10, 0],
        [-22, 0],
        [-33, 1],
        [-61, 1],
        [-4, 0],
        [-11, 0],
        [-3, 0],
        [-28, 0],
        [-23, 1],
        [-22, 0],
        [-1, 0],
        [-13, 1],
        [-33, 0],
        [-35, 0],
        [-38, 1],
        [-108, 1],
        [0, 0],
        [-42, 1],
        [-16, 1],
        [-53, 0],
        [-18, 0],
        [26, 260],
        [8, 86],
        [27, 262],
        [13, 123],
        [0, 3],
        [2, 17],
        [0, 2],
        [15, 149],
        [16, 171],
        [0, 2],
        [4, 32],
        [2, 16],
        [6, 54],
        [0, 11],
        [2, 17],
        [2, 25],
        [24, 242],
        [1, 9],
        [1, 16],
        [11, 104],
        [-12, 5],
        [-53, 24],
        [-136, 63],
        [-58, 26],
        [-29, 14],
        [-72, 32],
        [-43, 20],
        [-31, 15],
        [-11, 4],
        [-1, 1],
        [-36, 17],
        [-313, 144],
        [-12, 4],
        [-2, 0],
        [-58, 27],
        [-111, 48],
        [-53, 23],
        [-194, 87],
        [-34, 15],
        [-2, 0],
        [-177, 79],
        [-185, 82],
        [-6, 2],
        [-132, 60],
        [-57, 23],
        [-165, 75],
        [-3, 1],
        [-50, 22],
        [-127, 56],
        [-68, 30],
        [-156, 69],
        [52, 91],
        [16, 29],
        [1, 2],
        [5, 11],
        [-129, 66],
        [-229, 114],
        [-101, 47],
        [-290, 146],
        [-259, 125],
        [-135, 66],
        [-47, 23],
        [-176, 89],
        [-22, 11],
        [-22, 11],
        [-215, 101],
        [-58, 29],
        [-79, 43],
        [-106, 48],
        [-70, 34],
        [-72, 36],
        [-172, 86],
        [-243, 160],
        [-71, 53],
        [-293, 200],
        [-34, 22],
        [-65, 44],
        [-109, 76],
        [-442, 309],
        [-162, 108],
        [-25, 17],
        [-316, 225],
        [-142, 93],
        [-134, 102],
        [-168, 129],
        [-294, 222],
        [135, 155],
        [62, 78],
        [-69, 53],
        [-25, 18],
        [-133, 102],
        [-109, 85],
        [30, 125],
        [57, 80],
        [40, 55],
        [12, 20],
        [29, -8],
        [538, -137],
        [54, -14],
        [261, -65],
        [268, -68],
        [187, -48],
        [13, 32],
        [64, 159],
        [8, 14],
        [51, 14],
        [45, 19],
        [34, 13],
        [37, 7],
        [28, 7],
        [19, 6],
        [10, 8],
        [40, -21],
        [42, -22],
        [28, -16],
        [29, -5],
        [22, -4],
        [18, 9],
        [14, 9],
        [16, 1],
        [14, -3],
        [25, -10],
        [15, -6],
        [30, -3],
        [10, -5],
        [59, 64],
        [26, 29],
        [82, 90],
        [228, -189],
        [76, 85],
        [15, 8],
        [62, 72],
        [23, 26],
        [38, 44],
        [16, -9],
        [41, 10],
        [67, 15],
        [189, 43],
        [35, 9],
        [28, 6],
        [114, 27],
        [10, 3],
        [118, 28],
        [45, 12],
        [39, 8],
        [94, 0],
        [87, 1],
        [0, -8],
        [32, -1],
        [148, 17],
        [56, -74],
        [12, -13],
        [47, -58],
        [35, -21],
        [12, -6],
        [140, -54],
        [69, -23],
        [79, 63],
        [16, 10],
        [7, -77],
        [61, 65],
        [81, 94],
        [89, 104],
        [4, 6],
        [81, 94],
        [59, 71],
        [8, 8],
        [35, 41],
        [35, 43],
        [68, 79],
        [23, 28],
        [-290, 245],
        [8, 6],
        [45, 47],
        [14, 8],
        [17, 1],
        [127, -73],
        [18, -4],
        [13, 2],
        [14, 4],
        [52, -75],
        [8, -12],
        [20, 1],
        [46, -27],
        [4, -3],
        [107, 280],
        [72, 86],
        [73, 83],
        [-6, 133],
        [-61, 29],
        [21, 289],
        [38, 75],
        [34, 65],
        [1, 80],
        [3, 136],
        [7, 20],
        [22, 32],
        [32, 32],
        [14, 4],
        [31, -2],
        [31, 0],
        [8, 6],
        [8, 24],
        [4, 26],
        [-10, 77],
        [2, 10],
        [6, 8],
        [8, 6],
        [11, 4],
        [16, -2],
        [16, -4],
        [44, -10],
        [16, 0],
        [21, 6],
        [20, 8],
        [9, 14],
        [-7, 34],
        [0, 28],
        [10, 14],
        [20, 11],
        [85, 12],
        [255, 113],
        [232, 106],
        [14, 10],
        [15, 20],
        [15, 31],
        [71, 171],
        [18, 34],
        [117, 263],
        [17, 14],
        [23, 2],
        [187, -6],
        [26, -8],
        [10, -10],
        [97, -158],
        [69, -66],
        [21, -7],
        [21, 1],
        [107, 42],
        [79, 38],
        [19, 2],
        [27, 40],
        [78, 52],
        [8, -3],
        [18, -6],
        [31, -13],
        [31, -19],
        [33, -19],
        [20, -5],
        [44, -22],
        [120, 8],
        [30, 0],
        [25, 3],
        [24, 2],
        [57, 12],
        [20, 4],
        [43, 3],
        [14, 6],
        [43, 22],
        [18, 0],
        [26, 0],
        [29, 4],
        [16, 7],
        [15, 12],
        [44, 27],
        [8, 14],
        [38, 41],
        [38, 8],
        [30, 15],
        [43, 16],
        [30, 7],
        [24, 6],
        [21, 5],
        [43, -2],
        [55, 7],
        [29, 12],
        [48, 25],
        [79, 42],
        [47, 38],
        [77, 38],
        [18, 19],
        [10, 17],
        [4, 23],
        [39, 120],
        [9, 25],
        [-1, 19],
        [-7, 40],
        [8, 19],
        [21, 31],
        [63, 114],
        [18, 26],
        [14, 10],
        [14, 11],
        [9, 3],
        [10, 3],
        [142, 68],
        [207, 40],
        [2, 15],
        [9, 78],
        [-327, 139],
        [14, 23],
        [-45, 74],
        [-61, 62],
        [-97, 130],
        [-536, -107],
        [215, 477],
        [126, 159],
        [12, 16],
        [42, 320],
        [10, 15],
        [125, 670],
        [-214, 1399],
        [2086, 2125],
        [54, 17],
        [97, 31],
        [961, 264],
        [762, 275],
        [134, 374],
        [6, 11],
        [94, 167],
        [4, 8],
        [-2, 207],
        [-6, 19],
        [-111, 342],
        [-16, 160],
        [2, 44],
        [-38, 167],
        [-6, 17],
        [-15, 71],
        [-97, 423],
        [-23, 99],
        [-78, 337],
        [95, 95],
        [215, 216],
      ],
      [
        [111177, 231494],
        [-2835, -1002],
        [-161, -88],
        [-245, -55],
        [675, -373],
        [26, -50],
        [53, -87],
        [65, -75],
        [32, -17],
        [33, -39],
        [28, -23],
        [64, -46],
        [275, -65],
        [90, -66],
        [-1, -49],
        [-549, -475],
        [-201, -81],
        [-167, 28],
        [-254, 28],
        [-156, -75],
        [-318, 17],
        [-133, -55],
        [-100, 30],
        [-111, -60],
        [-217, 16],
        [-11, 3],
        [-99, -75],
        [-77, -62],
        [-23, -105],
        [-32, -103],
        [-64, -139],
        [-40, -231],
        [-100, -154],
        [-107, -54],
        [-58, 44],
        [-294, 2],
        [-33, 6],
        [-197, 71],
        [-22, 33],
        [2, -346],
        [-133, -28],
        [-35, -6],
        [-31, -6],
        [-156, -32],
        [-108, -23],
        [-29, -6],
        [-6, -2],
        [-103, -22],
        [-104, -29],
        [-7, -3],
        [-29, -8],
        [-153, -42],
        [-34, -10],
        [-30, -9],
        [-6, -2],
        [-48, -13],
        [-26, -8],
        [-33, -9],
        [-228, -65],
        [-15, -6],
        [-33, -10],
        [-6, 8],
        [0, 0],
        [-166, -42],
        [-21, 22],
        [-44, 30],
        [-25, 56],
        [-44, 71],
        [-20, 23],
        [-45, -5],
        [-109, -46],
        [-203, -52],
        [-38, 16],
        [-76, 58],
        [-32, 17],
        [-136, 25],
        [-121, -31],
        [-61, -37],
        [-108, -152],
        [-12, 0],
        [-12, 0],
        [-24, 17],
        [-3, 2],
        [-21, 26],
        [-4, 4],
        [-5, 6],
        [-28, 34],
        [-64, 68],
        [-81, 115],
        [-50, 52],
        [-59, 26],
        [-32, 6],
        [-32, 7],
        [-55, 12],
        [-36, 20],
        [-79, 88],
        [-21, 2],
        [-20, 2],
        [-40, -8],
        [-58, -26],
        [-44, -14],
        [-18, 2],
        [-55, 48],
        [-39, 56],
        [-61, 54],
        [-53, 24],
        [-60, -1],
        [-33, -21],
        [-22, -25],
        [-8, -40],
        [-12, -69],
        [-27, -30],
        [-44, -9],
        [-66, 9],
        [117, -169],
        [-27, -62],
        [-150, -89],
        [-37, -60],
        [-29, -20],
        [-77, -87],
        [-22, -7],
        [-207, -28],
        [-14, -191],
        [203, -394],
        [-20, -22],
        [8, -21],
        [26, -6],
        [36, 16],
        [13, -10],
        [12, -50],
        [-6, -67],
        [6, -47],
        [-41, -24],
        [22, -39],
        [37, -64],
        [25, -40],
        [-1, -4],
        [31, -57],
        [6, -24],
        [8, -44],
        [-16, -23],
        [10, -26],
        [42, -33],
        [-6, -40],
        [-7, -39],
        [-113, 22],
        [-98, -110],
        [4, -39],
        [-17, -68],
        [-19, -16],
        [-2, -52],
        [-1361, 584],
        [-119, 71],
        [-148, 47],
        [-12, 5],
        [-18, -24],
        [-17, -16],
        [-4, -2],
        [-6, -4],
        [-21, -16],
        [-18, -8],
        [-20, -6],
        [-17, -7],
        [-24, -8],
        [-22, -6],
        [-18, -2],
        [-12, -4],
        [-13, -4],
        [-14, 0],
        [-18, 0],
        [-25, 2],
        [-22, 4],
        [-22, 2],
        [-29, 4],
        [-28, 10],
        [-37, 15],
        [-31, 10],
        [-16, 0],
        [-18, -2],
        [-14, -8],
        [-15, -6],
        [-19, 2],
        [-10, 8],
        [-31, -8],
        [-30, -9],
        [-11, -12],
        [-16, -30],
        [-15, -33],
        [-32, -57],
        [4, -29],
        [-12, -12],
        [-29, -26],
        [-52, -38],
        [-16, -11],
        [-2, -61],
        [-2, -27],
        [-29, -29],
        [-10, -18],
        [0, -34],
        [-10, -34],
        [-2, -42],
        [8, -21],
        [-1, -40],
        [1, -10],
        [-2, -22],
        [8, -12],
        [6, -14],
        [8, -31],
        [19, -50],
        [20, -23],
        [21, -21],
        [6, -25],
        [-12, -51],
        [1, -29],
        [-88, -57],
        [-35, 12],
        [-18, -9],
        [-12, -23],
        [-6, -54],
        [-31, -42],
        [-30, 22],
        [-52, -24],
        [-10, -4],
        [-17, -53],
        [-23, -30],
        [-13, -19],
        [-15, -9],
        [-4, 0],
        [-4, 2],
        [-36, 10],
        [-37, -26],
        [-5, -2],
        [-15, -5],
        [-25, -10],
        [-4, -1],
        [-88, -28],
        [-13, -5],
        [-37, -11],
        [-48, -16],
        [-17, -7],
        [-65, -22],
        [-11, -3],
        [-152, -53],
        [-66, -24],
        [-84, -26],
        [-12, -4],
        [-148, -52],
        [43, -185],
        [37, -158],
        [31, -122],
        [11, -45],
        [32, -127],
        [0, -10],
        [11, -50],
        [32, -135],
        [41, -189],
        [-145, 26],
        [-136, 2],
        [-136, 4],
        [-229, 2],
        [-122, -728],
        [-1140, -133],
        [-63, -36],
        [-67, -35],
        [-38, -22],
        [-157, -84],
        [-42, -22],
        [-148, -82],
        [-110, -58],
        [-124, -66],
        [-6, -4],
        [-14, -8],
        [-149, -81],
        [-6, -3],
        [-8, -4],
        [-26, -23],
        [-265, -228],
        [-25, -22],
        [-25, -22],
        [-589, -509],
        [-1447, 983],
        [-293, 198],
        [-682, 462],
        [-147, -98],
        [-101, -66],
        [6, -56],
        [5, -112],
        [0, -2],
        [12, -270],
        [51, -166],
        [2, -8],
        [15, -74],
        [10, -26],
        [56, -114],
        [56, -94],
        [57, -115],
        [4, -8],
        [51, -127],
        [30, -74],
        [29, -70],
        [31, -68],
        [50, -112],
        [18, -60],
        [-382, -264],
        [-56, -39],
        [56, -90],
        [-4, -13],
        [-138, -63],
        [3, -14],
        [-36, -8],
        [3, -8],
        [4, -8],
        [2, -4],
        [7, -18],
        [-100, -23],
        [-6, -1],
        [-5, -1],
        [-45, -11],
        [-2, 0],
        [-2, -1],
        [-2, 0],
        [-5, -17],
        [-1, -1],
        [-1, -3],
        [-13, -41],
        [0, -2],
        [-2, -2],
        [-50, -159],
        [-1, -2],
        [0, -3],
        [-2, -3],
        [-42, 0],
        [-24, 0],
        [-193, -2],
        [-34, -29],
        [-40, -28],
        [-18, -6],
        [-12, -10],
        [-20, -44],
        [-179, -45],
        [-26, -12],
        [-39, -8],
        [-30, -2],
        [-13, -3],
        [-14, -3],
        [-24, -4],
        [-24, -4],
        [-29, -6],
        [-34, -4],
        [-19, -9],
        [-53, -17],
        [-111, 0],
        [-92, -4],
        [-41, -6],
        [-74, -26],
        [-58, -14],
        [-49, -10],
        [-54, -2],
        [-4, -80],
        [3, -33],
        [-263, 173],
        [-22, 12],
        [-23, 11],
        [-19, -11],
        [-70, 38],
        [-86, -303],
        [-4, -12],
        [-4, -18],
        [-48, -168],
        [-49, -173],
        [-6, -20],
        [-20, -72],
        [-6, -18],
        [0, -2],
        [-1, -4],
        [-53, 0],
        [-264, 2],
        [-229, -2],
        [-33, 0],
        [-98, 75],
        [-5, 4],
        [-4, 2],
        [-28, 21],
        [-3, 3],
        [-21, 17],
        [-126, 95],
        [-95, 74],
        [-16, 12],
        [-216, 165],
        [-41, 32],
        [-76, 57],
        [-98, 74],
        [-79, 17],
        [-50, 12],
        [-6, 1],
        [-7, 1],
        [-229, 42],
        [-7, 2],
        [-1, 0],
        [-14, 2],
        [-2, 2],
        [-6, 0],
        [-19, 4],
        [-4, 0],
        [-12, 2],
        [-181, 36],
        [-24, -83],
        [-22, -82],
        [-5, -16],
        [-12, -35],
        [-9, -17],
        [-13, -26],
        [-1, -2],
        [-5, -10],
        [-11, -50],
        [-2, -4],
        [10, -18],
        [-12, -13],
        [-14, -12],
        [-20, -28],
        [-18, -23],
        [-61, -71],
        [-31, -45],
        [-73, -57],
        [-102, -97],
        [-24, -67],
        [-47, -157],
        [-43, -137],
        [-5, -32],
        [-55, -185],
        [32, -112],
        [-26, -308],
        [-1, -6],
        [-40, -173],
        [-51, -123],
        [-14, -12],
        [-48, -130],
        [-6, -8],
        [-41, -64],
        [-140, -198],
        [-149, -212],
        [-12, 2],
        [-116, -161],
        [3, -8],
        [-9, -63],
        [-13, -108],
        [-8, -61],
        [-7, -41],
        [-23, -174],
        [54, -57],
        [-58, -46],
        [-44, -78],
        [15, -34],
        [8, -11],
        [-42, -14],
        [12, -57],
        [63, -72],
        [22, -27],
        [-3, -44],
        [-37, -140],
        [-2, -19],
        [-15, -52],
        [-9, -38],
        [0, -9],
        [-119, -61],
        [-54, -38],
        [-78, 11],
        [-70, -38],
        [-50, -42],
        [-33, -13],
        [-13, 32],
        [-17, 23],
        [-11, 27],
        [0, 18],
        [-11, 21],
        [-115, -117],
        [-55, 2],
        [-33, 10],
        [-26, 28],
        [-62, -23],
        [-27, -65],
        [-93, 29],
        [-32, 19],
        [-180, 126],
        [-171, 125],
        [-156, -163],
        [-4, 2],
        [-12, -1],
        [-80, 73],
        [-17, -1],
        [-98, 89],
        [-122, 67],
        [-18, 0],
        [-60, 42],
        [-76, 52],
        [-6, 17],
        [-35, 31],
        [-14, 11],
        [-6, 7],
        [-7, 5],
        [-37, 44],
        [-166, 143],
        [-18, 17],
        [-17, 16],
        [-30, 12],
        [43, 78],
        [2, 4],
        [-6, 0],
        [-243, 44],
        [-341, 183],
        [-40, -6],
        [0, -8],
        [0, -92],
        [2, -272],
        [2, -316],
        [-229, -86],
        [-166, -61],
        [-86, -32],
        [-148, -56],
        [-84, -31],
        [-14, -4],
        [-35, -13],
        [-27, -10],
        [-75, -27],
        [-9, -3],
        [-161, -61],
        [-16, -6],
        [-67, -26],
        [-73, -26],
        [-14, -5],
        [-9, -4],
        [-34, -13],
        [-54, -21],
        [-66, -24],
        [-57, -21],
        [-59, -22],
        [-8, 144],
        [-6, 121],
        [-5, 120],
        [-5, 120],
        [-4, 120],
        [-3, 65],
        [-2, 57],
        [-4, 123],
        [-4, 119],
        [0, 4],
        [0, 6],
        [-7, 110],
        [0, 1],
        [-4, 64],
        [-2, 56],
        [-2, 67],
        [0, 0],
        [0, 2],
        [-22, -1],
        [-21, 0],
        [-3, 0],
        [-1, 0],
        [-21, 30],
        [-2, 2],
        [-42, 63],
        [-64, 0],
        [-9, -1],
        [-36, 0],
        [-2, 0],
        [-3, 0],
        [-49, 0],
        [-10, 0],
        [-53, -1],
        [-12, -96],
        [-1, -5],
        [-15, -1],
        [-36, -3],
        [-6, 0],
        [-3, -1],
        [-4, 0],
        [-4, -1],
        [-66, -3],
        [-3, -1],
        [-5, 0],
        [-76, -4],
        [-2, 0],
        [-2, 0],
        [-55, -3],
        [-2, 0],
        [-4, -1],
        [-56, -2],
        [-3, -1],
        [-1, 0],
        [-2, 0],
        [-60, -2],
        [-4, 0],
        [-289, -10],
        [-445, -11],
        [-62, -1],
        [-6, -1],
        [-362, -9],
        [-13, -1],
        [-124, -3],
        [-124, -3],
        [-123, -5],
        [-125, -4],
        [-11, -1],
        [-2, 11],
        [-28, -1],
        [0, 3],
        [-2, 62],
        [-1, 59],
        [-2, 61],
        [-18, 0],
        [-55, -2],
        [-39, 0],
        [-35, 0],
        [-74, 0],
        [-68, 0],
        [-6, 0],
        [-5, -188],
        [0, -3],
        [0, -10],
        [-183, 10],
        [-25, -2],
        [-27, -3],
        [-3, 5],
        [-102, 113],
        [-4, 5],
        [-41, 51],
        [-60, 56],
        [-88, 101],
        [-121, -73],
        [-93, 90],
        [-30, 29],
        [-31, 28],
        [-19, 18],
        [-93, 92],
        [-16, 14],
        [-115, 116],
        [118, 165],
        [-216, 242],
        [-62, 78],
        [-29, 34],
        [-71, 84],
        [-95, 108],
        [-67, 81],
        [-70, 84],
        [-132, 158],
        [-59, 71],
        [-56, 66],
        [-114, 138],
        [-188, 36],
        [-296, 58],
        [-331, 66],
        [-290, 64],
        [-23, 5],
        [-75, 14],
        [-71, 14],
        [-125, 24],
        [-151, 30],
        [-52, 12],
        [-38, 12],
        [13, 44],
        [-310, 54],
        [-116, 21],
        [-1, 0],
        [-44, 5],
        [-33, 4],
        [-2, 1],
        [-2, 0],
        [-1, 0],
        [-3, 1],
        [-5, 1],
        [-38, 8],
        [-4, 1],
        [-26, 5],
        [-4, 1],
        [-4, 1],
        [-20, 4],
        [-4, 1],
        [-3, 1],
        [-36, 6],
        [-10, 1],
        [-2, 0],
        [-4, 1],
        [-4, 0],
        [-24, 6],
        [-66, 14],
        [-2, 0],
        [-2, 0],
        [-91, 17],
        [-3, 1],
        [-2, 1],
        [-59, 11],
        [-1, 0],
        [-2, 0],
        [-41, 8],
        [-21, 4],
        [-44, 8],
        [-95, 17],
        [-1, 0],
        [-1, 0],
        [-3, 1],
        [-6, 0],
        [-23, 2],
        [-105, 18],
        [-82, 15],
        [-3, 1],
        [-12, 3],
        [-60, 10],
        [-134, 19],
        [-118, 18],
        [-123, 18],
        [-44, 7],
        [-45, 6],
        [-76, 66],
        [-107, 106],
        [-109, 108],
        [-109, 109],
        [-90, 90],
        [-22, 22],
        [-87, 87],
        [-78, 82],
        [-54, 14],
        [-52, 14],
        [-214, 53],
        [-134, 25],
        [-172, 33],
        [-104, 21],
        [-55, 10],
        [-156, 33],
        [-60, 10],
        [-193, 39],
        [-6, 0],
        [-22, 4],
        [-6, 2],
        [-128, 23],
        [-6, 2],
        [-131, 22],
        [-85, 16],
        [-70, 12],
        [-6, 2],
        [-33, 6],
        [-6, 2],
        [-127, 22],
        [-37, 8],
        [-379, 73],
        [-6, 0],
        [48, 255],
        [-197, 101],
        [-25, 13],
        [-316, 164],
        [-212, 110],
        [97, 136],
        [107, 151],
        [166, -95],
        [5, 9],
        [117, 200],
        [-169, 105],
        [-38, 21],
        [-41, 25],
        [-40, 25],
        [-40, 25],
        [-18, 10],
        [51, 120],
        [-5, 17],
        [-11, 37],
        [-14, 13],
        [-160, 149],
        [-137, -105],
        [-1, 274],
        [0, 4],
        [0, 30],
        [0, 49],
        [-3, 226],
        [-2, 96],
        [0, 52],
        [0, 8],
        [-3, 2],
        [-12, 13],
        [-1, 1],
        [-8, 9],
        [-2, 2],
        [0, 1],
        [-36, 39],
        [-1, 2],
        [-28, 30],
        [-10, 10],
        [12, 10],
        [16, 9],
        [27, 17],
        [-4, 16],
        [-12, 30],
        [-8, 21],
        [-1, 4],
        [-6, 15],
        [-16, 43],
        [-5, 6],
        [1, 1],
        [8, 8],
        [1, 0],
        [7, 6],
        [7, 7],
        [36, 34],
        [37, 38],
        [4, 4],
        [2, 2],
        [2, 2],
        [4, -4],
        [4, 6],
        [2, 6],
        [2, 2],
        [87, -91],
        [166, -176],
        [49, -50],
        [10, -11],
        [105, -112],
        [12, 10],
        [225, 201],
        [44, 41],
        [102, 98],
        [225, -41],
        [45, -15],
        [-24, 142],
        [-85, 260],
        [-35, 93],
        [-19, 50],
        [-40, 104],
        [-57, 138],
        [-54, 138],
        [77, 64],
        [120, 98],
        [111, 91],
        [156, 127],
        [-79, 97],
        [-17, 20],
        [-61, 77],
        [-15, 16],
        [-79, 96],
        [-81, 89],
        [-19, 22],
        [-37, 27],
        [-17, 29],
        [-13, 7],
        [-4, 3],
        [-8, 4],
        [-79, 96],
        [-59, 72],
        [-113, 135],
        [-12, 16],
        [-35, 51],
        [-17, 21],
        [-2, 1],
        [-4, 4],
        [-34, 33],
        [-8, 7],
        [-4, 3],
        [-29, 27],
        [-2, 4],
        [-1, 4],
        [-12, 31],
        [-274, 254],
        [-120, 114],
        [-5, 4],
        [-76, 18],
        [-58, 14],
        [-24, 6],
        [-25, 5],
        [-59, 15],
        [-7, 7],
        [-73, 68],
        [-11, 9],
        [-117, 109],
        [-22, 22],
        [-10, 8],
        [-12, 10],
        [-2, 4],
        [-3, 2],
        [-1, 0],
        [-28, 26],
        [-1, 2],
        [-6, 6],
        [-4, 2],
        [-2, 4],
        [-1, 0],
        [-290, 271],
        [-18, 17],
        [-66, 61],
        [-58, 54],
        [-127, 117],
        [42, 75],
        [12, 18],
        [1, 2],
        [16, 27],
        [-15, 13],
        [-52, 47],
        [-18, 17],
        [-13, 11],
        [-7, 6],
        [-2, 2],
        [-72, 67],
        [-67, 62],
        [-16, 13],
        [-6, 8],
        [-106, 96],
        [-34, -12],
        [-28, -12],
        [-22, -17],
        [-28, -4],
        [-20, -10],
        [-4, -7],
        [6, -25],
        [10, -34],
        [18, -46],
        [27, -59],
        [21, -48],
        [-7, -35],
        [-2, -9],
        [-26, -114],
        [-1, -4],
        [-12, -18],
        [-42, 50],
        [-27, 16],
        [-18, 1],
        [-7, -91],
        [-33, -93],
        [-15, -36],
        [-21, -34],
        [-28, -84],
        [-1, -13],
        [-2, -19],
        [-7, -14],
        [-86, -127],
        [-60, -92],
        [-148, -67],
        [-111, 43],
        [-56, 51],
        [-59, 70],
        [-10, 88],
        [2, 163],
        [35, 45],
        [50, 63],
        [6, 2],
        [4, 2],
        [30, 7],
        [-10, 42],
        [0, 5],
        [-18, 79],
        [0, 4],
        [-8, 91],
        [54, 80],
        [5, 28],
        [-35, 9],
        [-40, 14],
        [-6, 0],
        [-12, 2],
        [-29, 6],
        [-8, -109],
        [-12, -25],
        [-48, -100],
        [-28, -33],
        [-14, -38],
        [-2, -5],
        [-26, -1],
        [-46, -22],
        [-8, -6],
        [-8, -5],
        [-25, -27],
        [-6, -10],
        [-27, -45],
        [-3, -6],
        [3, -14],
        [-12, -12],
        [-48, 30],
        [-126, -149],
        [-35, -23],
        [-15, -17],
        [-22, -17],
        [-103, -80],
        [-27, -38],
        [-6, -7],
        [-74, -76],
        [-7, -8],
        [73, -64],
        [2, -1],
        [2, -1],
        [-42, -39],
        [-51, -40],
        [5, -6],
        [58, -38],
        [-6, -10],
        [-1, -2],
        [-15, -25],
        [-43, -127],
        [-4, -13],
        [-4, -14],
        [-41, -64],
        [21, 0],
        [-23, -45],
        [-69, -47],
        [-77, -34],
        [-95, -6],
        [36, 108],
        [0, 6],
        [0, 8],
        [0, 17],
        [0, 4],
        [-10, 118],
        [0, 4],
        [-3, 34],
        [-22, 291],
        [-4, 55],
        [-6, 68],
        [-12, 146],
        [0, 15],
        [-2, 16],
        [-10, 99],
        [-8, 108],
        [-1, 8],
        [-3, 21],
        [0, 2],
        [-9, 56],
        [-2, 110],
        [0, 8],
        [-4, 43],
        [0, 11],
        [-5, 59],
        [-8, 88],
        [-3, 26],
        [-9, 90],
        [-7, 74],
        [-3, 40],
        [-10, 107],
        [0, 6],
        [-12, 210],
        [-48, 7],
        [-267, 40],
        [-4, 0],
        [-257, 35],
        [-185, 27],
        [-23, 3],
        [-10, 1],
        [-148, 22],
        [-4, 0],
        [-26, 4],
        [-123, 17],
        [-30, 4],
        [-121, 18],
        [-139, 21],
        [-126, 17],
        [-42, 6],
        [-85, 2],
        [-82, 2],
        [-47, 2],
        [-71, 2],
        [-33, 0],
        [-93, 4],
        [-246, 6],
        [-11, 0],
        [-41, 1],
        [-21, 0],
        [-34, 1],
        [-101, 2],
        [-127, 2],
        [-74, 1],
        [-27, 0],
        [-15, 0],
        [-2, 0],
        [-127, 1],
        [-2, 0],
        [-8, 0],
        [-33, 0],
        [-60, 0],
        [-38, 0],
        [-73, 0],
        [-65, 0],
        [-50, 9],
        [-87, 15],
        [0, 9],
        [0, 55],
        [0, 4],
        [-1, 35],
        [0, 12],
        [0, 20],
        [-2, 55],
        [0, 27],
        [-3, 146],
        [-3, 98],
        [0, 26],
        [-3, 154],
        [-1, 40],
        [-3, 144],
        [-4, 175],
        [-56, 24],
        [-135, 54],
        [-8, 4],
        [-129, 54],
        [-63, 26],
        [-153, 67],
        [-28, 12],
        [-92, -22],
        [-390, 209],
        [-96, 51],
        [-4, -20],
        [-1, -9],
        [-4, -20],
        [-13, -73],
        [-8, -49],
        [-22, -127],
        [-24, -134],
        [-10, -53],
        [-16, -82],
        [-13, -72],
        [-2, -4],
        [0, -5],
        [-20, -114],
        [-4, -12],
        [0, -2],
        [-6, -16],
        [-18, -128],
        [-20, -98],
        [-13, -67],
        [-13, -63],
        [-16, -92],
        [-2, -4],
        [-14, -76],
        [-14, -73],
        [-11, -56],
        [-12, -61],
        [-18, -86],
        [-22, -110],
        [-2, -8],
        [-24, -136],
        [-18, -91],
        [-1, -6],
        [-31, -159],
        [-12, -59],
        [-6, -32],
        [-5, -30],
        [-36, -208],
        [-2, -10],
        [0, -4],
        [-14, -40],
        [-14, -84],
        [-3, -19],
        [-10, -57],
        [-17, -95],
        [-1, -4],
        [0, -2],
        [-7, -42],
        [-20, -110],
        [-8, -48],
        [-7, -42],
        [0, -3],
        [-10, -55],
        [-21, -86],
        [-190, -9],
        [-112, -4],
        [-207, -9],
        [-9, 0],
        [-33, -3],
        [-9, -52],
        [-26, -62],
        [-46, -121],
        [-54, -196],
        [-50, 1],
        [-23, 5],
        [-134, -4],
        [-110, -9],
        [-12, 0],
        [-59, -4],
        [-78, -5],
        [-69, -4],
        [-146, -6],
        [-45, -2],
        [-341, -20],
        [-9, 172],
        [-3, 63],
        [-6, 72],
        [-8, 112],
        [-122, -4],
        [-2, 0],
        [-2, 0],
        [-97, -4],
        [-1, 0],
        [-17, -2],
        [-1, 0],
        [-64, -2],
        [-161, -8],
        [32, 106],
        [-21, 1],
        [-79, -1],
        [-12, -2],
        [-135, 2],
        [-2, 1],
        [0, -40],
        [-2, 0],
        [-68, 3],
        [-103, 15],
        [-29, 2],
        [-95, -57],
        [-2, 0],
        [-2, -159],
        [-10, -254],
        [4, -227],
        [-12, 3],
        [-185, 37],
        [-102, 20],
        [-4, 2],
        [-296, 59],
        [-3, 0],
        [-177, 35],
        [-125, 27],
        [-4, 0],
        [-403, 81],
        [-136, 28],
        [-156, 31],
        [-136, 27],
        [-11, 3],
        [-109, 18],
        [-73, 13],
        [-112, 19],
        [-3, 0],
        [-53, 10],
        [-56, 9],
        [-53, 10],
        [-58, 11],
        [-61, 11],
        [-60, 9],
        [-10, 2],
        [-2, -2],
        [7, -215],
        [5, -139],
        [1, 0],
        [12, -288],
        [-109, -3],
        [-81, -3],
        [-74, -3],
        [-75, -2],
        [-71, -3],
        [-80, -2],
        [-69, -3],
        [-55, -2],
        [-40, -1],
        [2, -4],
        [10, -288],
        [4, -87],
        [7, -183],
        [-53, -2],
        [-4, 0],
        [-32, -2],
        [-36, -1],
        [-38, -1],
        [-37, -2],
        [-36, -2],
        [-31, -1],
        [-6, 5],
        [-5, 4],
        [-375, -8],
        [0, -16],
        [4, -36],
        [0, -20],
        [2, -29],
        [1, -23],
        [1, -25],
        [2, -32],
        [2, -16],
        [3, -48],
        [0, -2],
        [3, -38],
        [0, -9],
        [1, -23],
        [1, -24],
        [2, -41],
        [0, -8],
        [-8, -49],
        [2, -47],
        [1, -2],
        [2, -47],
        [3, -51],
        [8, -186],
        [-135, 42],
        [-131, 45],
        [-129, 44],
        [-11, 5],
        [-16, 5],
        [-6, -45],
        [-2, -5],
        [-27, -133],
        [-286, 18],
        [-5, 0],
        [-3, -61],
        [-12, -163],
        [-2, -44],
        [-68, 0],
        [-45, 0],
        [-94, -4],
        [-13, -6],
        [-13, -14],
        [-27, 16],
        [-26, 6],
        [-126, -2],
        [-64, -2],
        [-317, -9],
        [-386, -8],
        [-363, -5],
        [-12, 0],
        [-39, -1],
        [-6, 1],
        [-6, 0],
        [-127, 8],
        [-29, 1],
        [-34, 2],
        [-222, 4],
        [-141, 3],
        [-106, 2],
        [-419, 4],
        [-3, 0],
        [-24, 0],
        [-38, 0],
        [-6, -2],
        [-61, -3],
        [-399, 7],
        [-4, 0],
        [-6, 0],
        [-2, 0],
        [-39, -2],
        [-211, 4],
        [-11, 0],
        [-1181, 20],
        [-364, 2],
        [-557, 4],
        [-112, -2],
        [-12, 0],
        [3, -346],
        [-508, 467],
        [-150, -187],
        [-119, -104],
        [-10, -7],
        [-91, -71],
        [-74, -45],
        [-18, -12],
        [-94, -63],
        [-120, -109],
        [-53, -50],
        [-2, 1],
        [-12, 6],
        [-3, 2],
        [-1, 1],
        [-21, 12],
        [-4, 1],
        [-22, 13],
        [-71, 38],
        [-74, 42],
        [-1, 0],
        [-1, 2],
        [-50, 27],
        [-6, 3],
        [-3, 1],
        [-2, 1],
        [-73, 40],
        [-2, 1],
        [0, 1],
        [-4, 2],
        [-2, 1],
        [-24, 14],
        [-46, 25],
        [-86, 46],
        [-87, 49],
        [-10, 5],
        [-275, 152],
        [1, 5],
        [58, 93],
        [95, 161],
        [71, 113],
        [64, 107],
        [133, 216],
        [-24, 14],
        [-248, 140],
        [-3, 2],
        [-45, 26],
        [-202, 115],
        [-10, 5],
        [274, 453],
        [-496, 287],
        [-30, 19],
        [-354, 191],
        [-133, 102],
        [-19, 22],
        [-18, 20],
        [-13, 15],
        [-105, 171],
        [-46, 157],
        [-6, 36],
        [-1, 236],
        [-1, 71],
        [-1, 273],
        [0, 47],
        [-2, 333],
        [-2, 237],
        [-3, 214],
        [-1, 222],
        [0, 75],
        [0, 83],
        [-3, 68],
        [1, 51],
        [4, 26],
        [7, 47],
        [34, 189],
        [49, 279],
        [16, 87],
        [5, 36],
        [14, 81],
        [3, 44],
        [-9, 38],
        [-31, 62],
        [-57, 43],
        [-14, 8],
        [-106, 58],
        [-217, 120],
        [-48, 27],
        [-71, 42],
        [-96, 3],
        [-52, -18],
        [-283, -188],
        [-7, -4],
        [1, 408],
        [-132, -6],
        [-184, 6],
        [-11, 4],
        [-85, 2],
        [-292, 0],
        [-317, 570],
        [-25, 31],
        [-13, 15],
        [-258, 292],
        [-43, 49],
        [-114, 130],
        [-6, 6],
        [-120, 135],
        [-18, 20],
        [104, 211],
        [145, -122],
        [409, -301],
        [10, 5],
        [5, 8],
        [265, 1055],
        [161, 595],
        [22, 96],
        [56, 237],
        [21, 42],
        [11, 43],
        [-5, 4],
        [-1, 8],
        [4, 18],
        [9, 51],
        [-2, 21],
        [15, 38],
        [6, 12],
        [3, 17],
        [12, 18],
        [8, 33],
        [6, 37],
        [6, 16],
        [0, 16],
        [12, 42],
        [26, 70],
        [29, 104],
        [87, -15],
        [6, -11],
        [5, -2],
        [4, 10],
        [18, -3],
        [14, 22],
        [0, 11],
        [18, 14],
        [9, 17],
        [17, 12],
        [8, 20],
        [-1, 16],
        [9, 16],
        [-4, 22],
        [-11, 8],
        [-3, 21],
        [-13, 22],
        [4, 14],
        [-2, 6],
        [-6, 2],
        [-4, 0],
        [-41, -44],
        [-6, -1],
        [-10, 4],
        [-9, 14],
        [-1, 17],
        [1, 8],
        [10, 6],
        [7, 24],
        [-11, 37],
        [4, 10],
        [9, 5],
        [52, -8],
        [159, -19],
        [132, -17],
        [74, -4],
        [173, -22],
        [69, -8],
        [184, -19],
        [164, -18],
        [16, -5],
        [112, -153],
        [85, 17],
        [21, 4],
        [10, 3],
        [81, 12],
        [13, 4],
        [86, 14],
        [16, 4],
        [44, 8],
        [70, 10],
        [11, -2],
        [162, 20],
        [130, 14],
        [58, 7],
        [112, 16],
        [18, 3],
        [-3, 15],
        [4, 11],
        [14, 11],
        [20, 7],
        [14, 0],
        [17, -4],
        [18, 11],
        [15, 2],
        [32, -20],
        [6, -18],
        [92, 19],
        [51, 6],
        [71, 13],
        [49, 0],
        [72, 8],
        [166, 24],
        [48, 6],
        [83, 12],
        [23, 0],
        [38, 0],
        [20, 0],
        [31, 17],
        [20, 8],
        [24, 0],
        [12, 0],
        [124, 14],
        [98, 11],
        [11, 0],
        [6, 2],
        [62, 8],
        [47, 8],
        [101, 13],
        [13, 2],
        [-25, 167],
        [-3, 18],
        [-13, 97],
        [-14, 89],
        [-20, 142],
        [-6, 44],
        [-27, 197],
        [-25, 180],
        [-22, 148],
        [-4, 34],
        [-35, 245],
        [-18, 130],
        [0, 6],
        [205, 79],
        [83, 32],
        [3, 0],
        [87, 34],
        [130, 50],
        [75, 27],
        [39, 16],
        [94, 34],
        [93, 37],
        [7, 2],
        [89, 34],
        [230, 88],
        [138, 54],
        [23, 9],
        [-134, 135],
        [-134, 144],
        [-144, 151],
        [-183, 194],
        [-294, 306],
        [4, 26],
        [6, 17],
        [100, 350],
        [188, 649],
        [114, 392],
        [31, 115],
        [2604, 615],
        [0, 6],
        [6, 144],
        [4, 122],
        [4, 129],
        [4, 98],
        [6, 213],
        [2, 54],
        [2, 92],
        [2, 32],
        [1, 59],
        [2, 66],
        [1, 26],
        [3, 95],
        [3, 89],
        [3, 90],
        [0, 2],
        [2, 91],
        [2, 90],
        [1, 87],
        [2, 86],
        [1, 86],
        [1, 84],
        [0, 87],
        [1, 92],
        [0, 91],
        [1, 92],
        [0, 90],
        [0, 91],
        [8, 714],
        [4, 123],
        [-6, 0],
        [-674, 12],
        [-147, 0],
        [-644, 18],
        [-169, 2],
        [-180, 4],
        [-123, 2],
        [-145, 0],
        [-8, 0],
        [143, 837],
        [4, 32],
        [12, 86],
        [10, 62],
        [92, 257],
        [247, 635],
        [23, 56],
        [63, 159],
        [4, 13],
        [6, 17],
        [189, 503],
        [12, 34],
        [13, 35],
        [14, 38],
        [14, 34],
        [14, 36],
        [12, 36],
        [27, 73],
        [21, 54],
        [64, 856],
        [2, 15],
        [8, 40],
        [197, -291],
        [219, 463],
        [293, 691],
        [265, 577],
        [367, 735],
        [468, 869],
        [169, 318],
        [-1066, 1047],
        [15, 30],
        [83, 183],
        [69, 181],
        [1747, -29],
        [10, 1],
        [201, -21],
        [643, -68],
        [635, -68],
        [1119, -120],
        [530, -59],
        [133, -13],
        [1072, -115],
        [146, 991],
        [456, 61],
        [535, 77],
        [-164, 709],
        [-247, 1058],
        [-16, 19],
        [52, 302],
        [355, 80],
        [333, -148],
        [283, -469],
        [183, 235],
        [444, -894],
        [753, 1807],
        [626, -388],
        [169, -606],
        [300, 209],
        [509, -821],
        [-258, -550],
        [818, -514],
        [943, 52],
        [434, 940],
        [-440, 929],
        [428, 456],
        [267, 284],
        [390, 653],
        [1019, -238],
        [1662, 2703],
        [-205, 1073],
        [1353, 129],
        [553, 52],
        [426, 41],
        [5, 1],
        [1, 0],
        [510, 321],
        [2229, 1407],
        [-73, 127],
        [-528, 946],
        [91, 44],
        [80, 102],
        [22, 98],
        [32, 40],
        [-5, 61],
        [268, 441],
        [261, 139],
        [-400, 905],
        [-138, 59],
        [-42, 105],
        [-5, 249],
        [-206, -181],
        [45, 693],
        [10, 151],
        [257, 78],
        [118, 972],
        [-342, 1298],
        [765, 1571],
      ],
      [
        [115237, 294172],
        [-50, -14],
        [-43, -47],
        [-55, -15],
        [-38, -23],
        [-24, -40],
        [-10, -97],
        [-17, -26],
        [-4, -89],
        [7, -52],
        [7, -14],
        [4, -8],
        [3, -7],
        [2, -4],
        [0, -5],
        [0, -8],
        [-2, -5],
        [-2, -6],
        [-2, -8],
        [-4, -6],
        [-8, -6],
        [-9, -7],
        [-10, -4],
        [-15, -4],
        [-10, -3],
        [-8, -4],
        [-6, -8],
        [-10, -5],
        [-14, -11],
        [-21, -6],
        [-35, -4],
        [-33, 4],
        [-31, 0],
        [-14, 8],
        [-9, 16],
        [-22, 66],
        [-24, 26],
        [-21, 17],
        [-19, 12],
        [-22, 18],
        [-29, 28],
        [-22, 6],
        [-22, 7],
        [-54, 15],
        [-99, 11],
        [-96, 24],
        [-81, -2],
        [-88, 2],
        [-39, -6],
        [-42, -10],
        [-36, 2],
        [-33, -4],
        [-25, 4],
        [-23, 6],
        [-54, 22],
        [-30, 24],
        [-22, 36],
        [-29, 45],
        [-69, 68],
        [-62, 47],
        [-39, 36],
        [-39, 24],
        [-59, -2],
        [-52, 2],
        [-31, -13],
        [-4, -3],
        [-36, -42],
        [-36, -15],
        [-26, -6],
        [-18, 8],
        [-23, 11],
        [-26, 20],
        [-49, 31],
        [-43, 35],
        [-53, 40],
        [-66, 72],
        [-29, 39],
        [-30, 54],
        [-36, 90],
        [-27, 98],
        [-1, 37],
        [-4, 58],
        [12, 47],
        [3, 60],
        [22, 51],
        [18, 30],
        [33, 64],
        [19, 79],
        [16, 61],
        [10, 64],
        [2, 39],
        [-45, 6],
        [-34, 2],
        [-28, 11],
        [-18, 14],
        [-28, -5],
        [-22, -16],
        [-41, -16],
        [-40, -5],
        [-54, 68],
        [-76, 93],
        [-31, -59],
        [-36, -67],
        [0, -2],
        [-8, 2],
        [-31, 8],
        [-29, 15],
        [-23, 11],
        [-30, 12],
        [-21, 9],
        [-37, 11],
        [-89, -96],
        [-3, -4],
        [-46, -33],
        [-39, -32],
        [-49, -38],
        [-8, -6],
        [-52, -41],
        [-53, -41],
        [-20, -15],
        [-4, -1],
        [-49, -9],
        [-29, -4],
        [-12, 21],
        [-10, 19],
        [-27, 16],
        [-60, 22],
        [-32, 24],
        [-54, 34],
        [-44, 23],
        [-30, 10],
        [-31, 6],
        [-72, 5],
        [-34, -10],
        [-24, -15],
        [-24, -5],
        [-26, 0],
        [-26, 0],
        [-55, 4],
        [-86, -2],
        [-74, -21],
        [-51, -23],
        [-95, -32],
        [-74, -28],
        [-20, -12],
        [-74, -38],
        [-72, -23],
        [-49, 2],
        [-63, 35],
        [-34, 38],
        [-29, 13],
        [-25, 35],
        [-30, 40],
        [-25, 37],
        [-10, 32],
        [-17, 23],
        [-117, 108],
        [-108, 69],
        [-103, 74],
        [-56, 32],
        [-32, 12],
        [-44, 18],
        [-44, 28],
        [-44, 37],
        [-25, 22],
        [-40, 29],
        [-58, 37],
        [-134, 80],
        [-109, 82],
        [-35, 33],
        [-51, 8],
        [-37, -15],
        [-27, -21],
        [-18, -19],
        [-14, -20],
        [-15, -30],
        [8, -16],
        [17, -15],
        [6, -18],
        [2, -38],
        [-2, -19],
        [-25, -36],
        [-18, -24],
        [-18, -33],
        [-26, -48],
        [-48, -62],
        [8, -236],
        [-20, -42],
        [-108, -107],
        [-36, -33],
        [-155, -69],
        [-46, 4],
        [-40, 14],
        [-36, 44],
        [-16, 26],
        [-10, 18],
        [-10, 28],
        [-6, 18],
        [9, 30],
        [25, 19],
        [28, 10],
        [23, 7],
        [15, 12],
        [12, 15],
        [5, 17],
        [4, 27],
        [31, 30],
        [79, 63],
        [48, 60],
        [-1, 67],
        [-9, 34],
        [-46, 40],
        [-33, 31],
        [-38, 58],
        [-28, 48],
        [-28, 62],
        [-14, 44],
        [-36, 32],
        [-45, 20],
        [-40, 2],
        [-199, 8],
        [-69, -4],
        [-65, 0],
        [-40, 3],
        [-48, 3],
        [-18, 18],
        [-54, 123],
        [-26, 97],
        [-3, 54],
        [21, 29],
        [30, 8],
        [40, 8],
        [29, 66],
        [-7, 91],
        [-13, 97],
        [-40, 81],
        [-62, 55],
        [-90, 23],
        [-73, 31],
        [-79, 49],
        [-53, 13],
        [-61, 24],
        [-30, -7],
        [-14, -65],
        [0, -30],
        [5, -37],
        [6, -22],
        [5, -33],
        [-7, -42],
        [-36, -77],
        [-71, -112],
        [-85, -143],
        [-35, -70],
        [-61, -24],
        [-38, -33],
        [-38, -24],
        [-41, 5],
        [-55, 17],
        [-70, 44],
        [-58, 69],
        [-10, 109],
        [22, 44],
        [4, 40],
        [-8, 30],
        [-6, 49],
        [-20, 122],
        [-64, 165],
        [-81, 19],
        [-30, 48],
        [-49, 93],
        [-59, 94],
        [-49, 63],
        [-28, 30],
        [-30, 5],
        [-39, -8],
        [-51, -31],
        [-59, -60],
        [-65, -59],
        [-63, -110],
        [-177, -111],
        [-100, -21],
        [-85, -49],
        [-164, -122],
        [-47, -10],
        [-91, 10],
        [-35, 37],
        [-26, 34],
        [-14, 62],
        [-7, 56],
        [-56, 77],
        [-37, 77],
        [-57, 62],
        [-150, 245],
        [-74, 128],
        [-31, 65],
        [-39, 93],
        [-55, 45],
        [-33, 10],
        [-41, -2],
        [-44, -6],
        [-71, -6],
        [-95, -18],
        [-83, -14],
        [-96, -41],
        [-52, -35],
        [-35, -42],
        [-108, -58],
        [-62, -39],
        [-50, -22],
        [-50, -20],
        [-35, -12],
        [-49, -16],
        [-79, 4],
        [-61, 32],
        [-42, 36],
        [-24, 56],
        [-22, 63],
        [8, 71],
        [32, 88],
        [92, 24],
        [53, 13],
        [28, 17],
        [44, 29],
        [14, 25],
        [55, 50],
        [56, 88],
        [10, 56],
        [24, 111],
        [7, 57],
        [35, 89],
        [10, 61],
        [0, 61],
        [-16, 47],
        [-24, 36],
        [-37, 17],
        [-54, 0],
        [-74, -11],
        [-98, -24],
        [-62, -46],
        [-35, -27],
        [-23, -45],
        [-30, -59],
        [-33, -66],
        [-22, -29],
        [-25, -13],
        [-81, -19],
        [-120, -17],
        [-101, -15],
        [-84, -28],
        [-74, -26],
        [-87, 8],
        [-55, 43],
        [-43, 30],
        [-46, 42],
        [-18, 11],
        [-22, 25],
        [-59, 30],
        [-38, 6],
        [-47, -2],
        [-25, -14],
        [-32, 1],
        [-36, 0],
        [-23, -23],
        [-20, -19],
        [-32, 4],
        [-10, -13],
        [-34, -27],
        [-44, -39],
        [-58, -47],
        [-43, -29],
        [-52, -19],
        [-74, -8],
        [-25, -14],
        [-67, -48],
        [-213, -125],
        [-69, -12],
        [-108, 42],
        [-90, 64],
        [-40, 47],
        [-44, 112],
        [-7, 58],
        [30, 57],
        [35, 48],
        [63, 0],
        [45, 18],
        [10, 27],
        [4, 22],
        [4, 48],
        [-6, 34],
        [-20, 72],
        [-47, 23],
        [-24, 6],
        [-24, -4],
        [-31, -12],
        [-43, -10],
        [-53, -12],
        [-83, -25],
        [-100, -53],
        [-40, -10],
        [-61, -12],
        [-24, 10],
        [-15, 41],
        [-91, 68],
        [-106, 64],
        [-76, 46],
        [-9, 23],
        [-20, 13],
        [-32, 13],
        [-27, -4],
        [-33, -4],
        [-85, -41],
        [-94, -74],
        [-68, -53],
        [-17, -31],
        [26, -34],
        [53, -40],
        [6, -54],
        [2, -11],
        [6, -12],
        [13, -6],
        [16, 6],
        [15, -4],
        [2, -10],
        [-6, -14],
        [-8, -9],
        [-18, -14],
        [-1, -8],
        [2, -9],
        [12, -9],
        [17, -4],
        [14, -9],
        [2, -34],
        [-4, -16],
        [-23, -18],
        [-14, -12],
        [-17, -4],
        [1, -18],
        [-6, -14],
        [7, -11],
        [18, -7],
        [36, -20],
        [6, -4],
        [2, -9],
        [-6, -20],
        [-22, -34],
        [-9, -20],
        [-14, -9],
        [-13, -13],
        [2, -24],
        [-14, -9],
        [-14, -14],
        [-8, -6],
        [-4, -5],
        [0, -8],
        [8, -21],
        [-2, -24],
        [-10, -23],
        [-47, -21],
        [-36, -20],
        [-10, -17],
        [-4, -21],
        [-15, -36],
        [-14, -26],
        [2, -35],
        [16, -53],
        [-2, -12],
        [-33, -36],
        [-20, -10],
        [-9, -6],
        [0, -5],
        [13, -11],
        [2, -25],
        [-3, -22],
        [5, -26],
        [-7, -39],
        [-19, -32],
        [-39, -32],
        [-18, 1],
        [-28, -11],
        [-16, -16],
        [-20, -4],
        [-7, -7],
        [-6, -19],
        [10, -31],
        [0, -19],
        [-4, -15],
        [-56, -43],
        [-8, -18],
        [-3, -20],
        [-1, -32],
        [-4, -30],
        [-4, -40],
        [24, -29],
        [8, -10],
        [13, -20],
        [5, -6],
        [12, -25],
        [16, -18],
        [25, -16],
        [14, -16],
        [25, -17],
        [31, -14],
        [4, -13],
        [2, -17],
        [8, -17],
        [15, -9],
        [20, -2],
        [16, 5],
        [8, 7],
        [9, 3],
        [8, -5],
        [8, -21],
        [29, -40],
        [45, -39],
        [35, -23],
        [15, -1],
        [12, -14],
        [21, -50],
        [15, -21],
        [3, -56],
        [-13, -44],
        [-18, -20],
        [-32, -26],
        [-14, -23],
        [-2, -20],
        [13, -46],
        [1, -26],
        [16, -23],
        [0, -36],
        [2, -27],
        [28, -26],
        [48, -54],
        [22, -34],
        [14, -53],
        [-22, -46],
        [-20, -26],
        [-13, -43],
        [-18, -35],
        [-20, -36],
        [-11, -39],
        [-10, -60],
        [-16, -44],
        [-32, -46],
        [-29, -58],
        [-6, -37],
        [8, -50],
        [13, -41],
        [14, -32],
        [32, -57],
        [12, -16],
        [16, -9],
        [12, -11],
        [9, -26],
        [12, -53],
        [108, -182],
        [36, -28],
        [67, -38],
        [75, -24],
        [63, -15],
        [67, -38],
        [49, -65],
        [12, -47],
        [8, -40],
        [6, -66],
        [4, -71],
        [16, -48],
        [25, -45],
        [45, -72],
        [81, -120],
        [76, -126],
        [221, -183],
        [84, -105],
        [180, -378],
        [27, -79],
        [138, -98],
        [39, -34],
        [10, -68],
        [1, -26],
        [2, -93],
        [-52, -202],
        [-35, -135],
        [-27, -105],
        [-26, -106],
        [-29, -81],
        [-26, -135],
        [-28, -109],
        [-29, -97],
        [-45, -89],
        [-42, -33],
        [-58, -9],
        [-76, 15],
        [-27, 6],
        [-81, 4],
        [-83, 11],
        [-116, 38],
        [-153, 63],
        [-118, 35],
        [-91, 12],
        [-99, 10],
        [-53, -2],
        [-37, -10],
        [21, -89],
        [30, -70],
        [72, -97],
        [10, -96],
        [10, -74],
        [16, -28],
        [31, -28],
        [14, -132],
        [11, -97],
        [3, -116],
        [-5, -76],
        [-1, -127],
        [-1, -112],
        [17, -97],
        [12, -84],
        [77, -432],
        [-290, -289],
        [-77, -1396],
        [-831, -1109],
        [-2955, -63],
        [-123, -239],
        [-25, -82],
        [-8, -64],
        [-25, -54],
        [-47, -76],
        [-44, -77],
        [-14, -127],
        [6, -41],
        [13, -44],
        [-7, -44],
        [-6, -41],
        [13, -52],
        [-2, -34],
        [-8, -44],
        [-27, -76],
        [-21, -57],
        [-51, -88],
        [-2, -64],
        [-17, -40],
        [-34, -63],
        [-36, -62],
        [-42, -84],
        [-48, -51],
        [-15, -19],
        [-6, -23],
        [12, -65],
        [-1, -66],
        [-29, -119],
        [-30, -43],
        [-46, -14],
        [-45, 17],
        [-25, 27],
        [-49, 42],
        [-43, 21],
        [-32, 14],
        [-27, -6],
        [-28, -36],
        [-18, -46],
        [-8, -45],
        [20, -42],
        [29, -60],
        [-10, -75],
        [-5, -46],
        [-32, -38],
        [-7, -7],
        [-7, -48],
        [-32, -42],
        [-30, -25],
        [-40, -22],
        [-22, -22],
        [-10, -44],
        [-5, -42],
        [31, -71],
        [36, -60],
        [29, -22],
        [47, -31],
        [10, -12],
        [14, -35],
        [42, -117],
        [10, -24],
        [-160, -192],
        [271, -966],
        [-1023, -204],
        [-3138, 3305],
        [953, 1652],
        [29, 98],
        [392, 1400],
        [99, 42],
        [3396, 1889],
        [-26, 20],
        [-29, 10],
        [-33, 19],
        [-7, 16],
        [34, 31],
        [17, 6],
        [18, -6],
        [14, -2],
        [38, 7],
        [20, 24],
        [6, 33],
        [-7, 22],
        [-25, 43],
        [-16, 8],
        [-16, 0],
        [-37, -10],
        [-51, 4],
        [-31, 5],
        [-17, 29],
        [6, 28],
        [15, 36],
        [43, 70],
        [7, 31],
        [-3, 22],
        [-31, 15],
        [-31, 7],
        [-16, 8],
        [-25, 19],
        [-4, 29],
        [8, 61],
        [-4, 51],
        [-22, 24],
        [-13, 24],
        [2, 35],
        [16, 22],
        [13, 36],
        [-6, 50],
        [-6, 32],
        [-13, 44],
        [-16, 63],
        [10, 38],
        [16, 39],
        [15, 28],
        [6, 17],
        [1, 34],
        [-33, 30],
        [-39, 5],
        [-28, 6],
        [-27, 11],
        [-13, 16],
        [-11, 23],
        [0, 15],
        [5, 13],
        [18, 13],
        [29, 29],
        [13, 41],
        [8, 42],
        [6, 31],
        [14, 55],
        [-14, 34],
        [-38, 23],
        [-43, 20],
        [-16, 45],
        [-24, 60],
        [-12, 68],
        [-16, 81],
        [-28, 32],
        [-32, 34],
        [-26, 30],
        [-22, 52],
        [-37, 38],
        [-44, 2],
        [-44, -9],
        [-43, -6],
        [-29, 15],
        [-9, 31],
        [6, 32],
        [15, 16],
        [18, 5],
        [17, 4],
        [17, 15],
        [4, 10],
        [-2, 32],
        [-10, 21],
        [-24, 17],
        [-26, 26],
        [-17, 13],
        [2, 47],
        [-2, 44],
        [-28, 42],
        [-21, 27],
        [-22, 33],
        [0, 11],
        [6, 16],
        [2, 18],
        [16, 16],
        [23, 19],
        [18, 19],
        [14, 26],
        [6, 18],
        [2, 26],
        [3, 22],
        [-4, 14],
        [-24, 46],
        [-27, 31],
        [-25, 50],
        [10, 52],
        [17, 39],
        [16, 68],
        [23, 40],
        [37, 37],
        [27, 37],
        [10, 26],
        [-8, 57],
        [-50, 47],
        [-6, 27],
        [10, 21],
        [48, 8],
        [21, 6],
        [18, 15],
        [1, 33],
        [4, 33],
        [-6, 62],
        [-26, 28],
        [-12, 33],
        [2, 18],
        [12, 20],
        [6, 47],
        [-1, 18],
        [3, 28],
        [10, 14],
        [17, 6],
        [31, -1],
        [26, 1],
        [14, 7],
        [11, 18],
        [23, 47],
        [5, 41],
        [13, 24],
        [9, 16],
        [10, 8],
        [24, 2],
        [21, -8],
        [39, -22],
        [20, 0],
        [12, 12],
        [2, 59],
        [6, 26],
        [14, 16],
        [27, 46],
        [4, 49],
        [5, 45],
        [35, 65],
        [33, 61],
        [30, 37],
        [50, 38],
        [66, 28],
        [77, 8],
        [33, 18],
        [12, 34],
        [1, 32],
        [-24, 88],
        [8, 60],
        [0, 31],
        [-15, 43],
        [-21, 61],
        [-30, 72],
        [23, 79],
        [11, 54],
        [-7, 41],
        [-27, 46],
        [-27, 38],
        [-26, 19],
        [-32, 14],
        [-25, 10],
        [-49, -13],
        [-38, -19],
        [-19, -42],
        [-29, -35],
        [-25, -41],
        [-23, -40],
        [-13, -40],
        [-29, -38],
        [-41, -37],
        [-4, -10],
        [3, -14],
        [17, -6],
        [4, -20],
        [4, -32],
        [3, -18],
        [-23, -19],
        [-3, -22],
        [-3, -27],
        [-8, -16],
        [-21, -4],
        [-16, 4],
        [-19, 10],
        [-21, 2],
        [-23, -6],
        [-15, -19],
        [1, -29],
        [3, -54],
        [-35, -10],
        [-18, -20],
        [2, -28],
        [8, -48],
        [-15, -10],
        [-25, 0],
        [-28, 4],
        [-8, -9],
        [0, -16],
        [18, -28],
        [-6, -24],
        [-4, -12],
        [-8, -2],
        [-29, 6],
        [-7, 0],
        [-2, -6],
        [0, -43],
        [13, -53],
        [10, -21],
        [13, -33],
        [-6, -13],
        [-25, -18],
        [-68, -16],
        [-76, -33],
        [-16, -37],
        [-60, -64],
        [-29, -61],
        [-33, -22],
        [-34, -24],
        [-35, -21],
        [-16, -29],
        [-14, -10],
        [-20, -17],
        [-12, -9],
        [-39, -19],
        [-37, -25],
        [-36, -42],
        [-12, -14],
        [-27, 1],
        [-30, -5],
        [-25, -8],
        [-50, -3],
        [-60, 9],
        [-11, 3],
        [-21, -3],
        [-33, -7],
        [-60, -19],
        [-50, -16],
        [-29, -2],
        [-16, -2],
        [-28, 0],
        [-42, 2],
        [-16, 2],
        [-20, 1],
        [-2, 1],
        [-25, 1],
        [-36, 2],
        [-70, 25],
        [-32, 9],
        [-44, 9],
        [-63, 27],
        [-41, 22],
        [-6, 29],
        [-14, 5],
        [-11, 1],
        [-69, 4],
        [-14, 0],
        [-36, -2],
        [-94, -18],
        [-110, -26],
        [-112, -59],
        [-72, -53],
        [-51, -72],
        [-29, -87],
        [-27, -81],
        [-49, -62],
        [-55, -43],
        [-21, -52],
        [-18, -49],
        [-9, -23],
        [12, -33],
        [-28, -67],
        [-81, -18],
        [-18, 2],
        [-31, 2],
        [-31, -34],
        [-24, -10],
        [-34, -8],
        [-41, -12],
        [-24, -14],
        [-12, -15],
        [-8, -7],
        [-25, -6],
        [-36, -2],
        [-43, 6],
        [-36, 34],
        [-24, 41],
        [-9, 90],
        [-51, 115],
        [-35, 42],
        [-32, 59],
        [-36, 41],
        [-32, 46],
        [-33, 36],
        [-51, 50],
        [-27, 18],
        [-23, 22],
        [-43, 36],
        [-49, 37],
        [-66, 44],
        [-72, 46],
        [-117, 64],
        [-14, 6],
        [-2, 0],
        [-30, 13],
        [-61, 53],
        [-39, 28],
        [-91, 48],
        [-36, 31],
        [-35, 48],
        [-45, 31],
        [-67, 1],
        [-112, -5],
        [-55, -20],
        [-16, 8],
        [-26, 29],
        [-23, 34],
        [-24, 18],
        [-47, 9],
        [-37, 10],
        [-41, 9],
        [-59, 15],
        [-15, 29],
        [-21, 44],
        [-30, 48],
        [-28, 49],
        [-38, 36],
        [-39, 26],
        [-39, 13],
        [-71, -11],
        [-33, -44],
        [-20, -35],
        [-25, -59],
        [-7, -53],
        [-3, -32],
        [13, -40],
        [-2, -20],
        [-11, -38],
        [-14, -23],
        [-18, -23],
        [-12, -26],
        [-12, -17],
        [-16, -20],
        [-21, -26],
        [-21, -43],
        [-12, -38],
        [-2, -29],
        [-4, -15],
        [-21, -15],
        [-33, -4],
        [-37, -7],
        [-22, -6],
        [-24, -7],
        [-21, -8],
        [-23, 1],
        [-25, -1],
        [-25, 4],
        [-12, 11],
        [-8, 15],
        [1, 21],
        [2, 28],
        [-2, 8],
        [-5, 8],
        [-7, 6],
        [-11, 7],
        [-25, 15],
        [-46, 17],
        [-44, 14],
        [-48, 24],
        [-54, -10],
        [-50, -20],
        [-29, -6],
        [-26, -21],
        [-16, -15],
        [-36, -24],
        [-54, -29],
        [-84, -28],
        [-15, 29],
        [-8, 42],
        [18, 54],
        [27, 38],
        [5, 45],
        [-19, 38],
        [0, 32],
        [0, 6],
        [0, 4],
        [-4, 10],
        [-4, 14],
        [-5, 10],
        [-6, 18],
        [-6, 26],
        [-6, 29],
        [-8, 24],
        [-20, 7],
        [-19, -2],
        [-26, -12],
        [1, -29],
        [19, -38],
        [-3, -10],
        [-11, -1],
        [-17, 6],
        [-68, 60],
        [-45, 23],
        [-59, 16],
        [-57, 7],
        [-96, 2],
        [-66, -6],
        [-42, -29],
        [-56, -40],
        [-22, -37],
        [-33, -52],
        [-40, -67],
        [-21, -56],
        [-38, -55],
        [-26, -58],
        [-4, -68],
        [-8, -66],
        [14, -43],
        [-8, -42],
        [-4, -31],
        [-28, -38],
        [-46, -18],
        [-45, 2],
        [-69, 8],
        [-70, -4],
        [-149, -2],
        [-66, -18],
        [-60, -20],
        [-71, -12],
        [-44, 4],
        [-80, 4],
        [-61, 10],
        [-57, -14],
        [-70, -42],
        [-58, -35],
        [-47, -20],
        [-49, -32],
        [4, -48],
        [82, -76],
        [110, -30],
        [46, -25],
        [19, -23],
        [14, -52],
        [35, -27],
        [24, -24],
        [6, -17],
        [13, -39],
        [33, -33],
        [19, -15],
        [37, -10],
        [20, -6],
        [32, -20],
        [45, -24],
        [36, -23],
        [30, -27],
        [29, -36],
        [33, -47],
        [14, -44],
        [4, -46],
        [8, -16],
        [8, -16],
        [15, -28],
        [36, -33],
        [24, -44],
        [45, -28],
        [98, -50],
        [83, -15],
        [70, -21],
        [38, -10],
        [105, -27],
        [53, -8],
        [51, -25],
        [40, -35],
        [21, -125],
        [-1132, -47],
        [846, -1532],
        [-143, -1285],
        [-28, 29],
        [-25, 28],
        [-32, 35],
        [-84, 34],
        [-86, 101],
        [-61, 48],
        [-70, 35],
        [-77, 20],
        [-58, 2],
        [-85, 95],
        [-50, 48],
        [-105, 46],
        [-63, 27],
        [-80, 6],
        [-42, -8],
        [-35, 3],
        [-91, -10],
        [-49, -24],
        [-33, -18],
        [-40, -8],
        [-18, -12],
        [-8, -20],
        [-10, -38],
        [-35, -61],
        [-19, -50],
        [-45, -27],
        [-58, -22],
        [-57, 10],
        [-49, 24],
        [-46, 21],
        [-32, 12],
        [-43, 81],
      ],
      [
        [87045, 298111],
        [125, 34],
        [3770, 1036],
        [1995, 1058],
        [134, 3131],
        [4, 109],
        [85, 1966],
        [4, 87],
        [18, 438],
        [0, 6],
        [2, 77],
        [-36, 115],
        [-6, 16],
        [2, 4],
        [34, 55],
        [26, 67],
        [9, 52],
        [-5, 102],
        [4, 78],
        [-5, 33],
        [-57, 41],
        [-50, 26],
        [-33, 24],
        [-19, 17],
        [-10, 65],
        [9, 59],
        [24, 41],
        [37, 64],
        [-1, 82],
        [-1, 1],
        [-31, 48],
        [15, 28],
        [33, 15],
        [35, 8],
        [34, 8],
        [121, 47],
        [108, 1],
        [44, 18],
        [24, 48],
        [17, 6],
        [28, -4],
        [24, -10],
        [22, -24],
        [31, -30],
        [29, -44],
        [28, -53],
        [9, -18],
        [8, -8],
        [0, -2],
        [6, -16],
        [0, -1],
        [12, -16],
        [9, -13],
        [12, -8],
        [12, 2],
        [11, 10],
        [1, 8],
        [10, 14],
        [10, 16],
        [12, 4],
        [16, 0],
        [22, 0],
        [16, 2],
        [8, 6],
        [5, 10],
        [-4, 10],
        [-1, 0],
        [-16, 18],
        [-1, 2],
        [-11, 28],
        [1, 16],
        [13, 5],
        [58, -9],
        [17, 14],
        [2, 6],
        [0, 10],
        [-2, 11],
        [0, 2],
        [-6, 6],
        [-15, 0],
        [-20, 2],
        [-5, 4],
        [0, 0],
        [0, 8],
        [5, 12],
        [10, 20],
        [12, 16],
        [-6, 11],
        [4, 12],
        [6, 10],
        [17, 18],
        [6, 15],
        [0, 18],
        [0, 25],
        [-4, 4],
        [-13, 11],
        [-16, 9],
        [0, 1],
        [-6, 19],
        [2, 25],
        [-1, 8],
        [-1, 1],
        [-5, 3],
        [-8, 3],
        [-8, 7],
        [-1, 1],
        [-5, 10],
        [4, 11],
        [9, 6],
        [13, 6],
        [17, 8],
        [0, 13],
        [0, 2],
        [-8, 10],
        [0, 17],
        [4, 24],
        [0, 22],
        [-6, 17],
        [-2, 0],
        [-6, 12],
        [-21, 0],
        [-15, 2],
        [-19, 28],
        [-27, 16],
        [-18, 4],
        [-17, 14],
        [-12, 4],
        [-23, -2],
        [-33, 15],
        [-19, 12],
        [0, 1],
        [2, 28],
        [15, 25],
        [25, 36],
        [-5, 27],
        [0, 1],
        [-10, 15],
        [0, 1],
        [-10, 17],
        [0, 0],
        [-15, 11],
        [-24, 8],
        [0, 0],
        [-3, 16],
        [0, 1],
        [-12, 10],
        [0, 1],
        [3, 24],
        [-7, 21],
        [9, 22],
        [-1, 1],
        [-9, 14],
        [-4, 29],
        [-6, 12],
        [-2, 8],
        [2, 10],
        [10, 10],
        [16, 42],
        [-5, 26],
        [-1, 1],
        [-13, 18],
        [-9, 26],
        [-3, 42],
        [6, 47],
        [13, 32],
        [6, 68],
        [-7, 44],
        [-18, 41],
        [-23, 72],
        [-4, 44],
        [-14, 61],
        [22, 26],
        [-16, 42],
        [-2, 44],
        [8, 31],
        [0, 1],
        [-16, 12],
        [2, 17],
        [0, 0],
        [-16, 7],
        [0, 1],
        [4, 16],
        [-8, 11],
        [-13, 20],
        [-12, 9],
        [0, 1],
        [0, 16],
        [10, 15],
        [-4, 8],
        [-6, 11],
        [-9, 5],
        [-17, -3],
        [-9, -6],
        [0, -16],
        [-5, -2],
        [-18, 9],
        [-16, 24],
        [-15, 14],
        [-39, 10],
        [-36, 4],
        [-12, 6],
        [-7, 10],
        [-5, 13],
        [6, 17],
        [-2, 5],
        [-12, 6],
        [-7, 5],
        [-1, 1],
        [-3, 7],
        [-1, 7],
        [-2, 4],
        [-7, 5],
        [-8, 7],
        [-12, 7],
        [-4, 2],
        [0, 2],
        [-2, 6],
        [-2, 18],
        [-2, 2],
        [-4, 4],
        [0, 2],
        [0, 5],
        [0, 4],
        [0, 8],
        [0, 10],
        [6, 12],
        [2, 15],
        [0, 13],
        [-4, 9],
        [0, 1],
        [-6, 7],
        [-10, 9],
        [-10, 0],
        [-11, -1],
        [-10, 1],
        [-9, 0],
        [-6, 2],
        [0, 2],
        [-1, 2],
        [18, 4],
        [39, 24],
        [22, 14],
        [23, 20],
        [9, 16],
        [3, 26],
        [-4, 25],
        [0, 17],
        [4, 11],
        [8, 5],
        [10, 2],
        [24, 4],
        [12, 10],
        [9, 14],
        [19, 33],
        [5, 9],
        [11, 12],
        [11, 12],
        [11, 8],
        [8, 15],
        [4, 14],
        [2, 24],
        [0, 28],
        [6, 19],
        [16, 16],
        [16, 0],
        [19, -9],
        [13, 1],
        [11, 0],
        [12, 5],
        [8, 7],
        [4, 17],
        [-4, 15],
        [0, 1],
        [-10, 12],
        [-21, 15],
        [-1, 0],
        [-3, 22],
        [1, 29],
        [7, 19],
        [35, 16],
        [17, 8],
        [10, 21],
        [12, 32],
        [9, 30],
        [7, 36],
        [37, 51],
        [-6, 60],
        [0, 2],
        [-41, 63],
        [-19, 46],
        [-6, 20],
        [6, 18],
        [-3, 26],
        [10, 6],
        [10, -3],
        [1, -1],
        [2, -24],
        [7, -10],
        [8, -12],
        [1, 0],
        [-3, -16],
        [4, -18],
        [8, -8],
        [15, 2],
        [17, 2],
        [18, 10],
        [2, 6],
        [0, 0],
        [-6, 0],
        [-10, -2],
        [-13, -4],
        [-8, 0],
        [-4, 4],
        [0, 0],
        [2, 10],
        [6, 4],
        [25, 0],
        [10, 8],
        [27, 22],
        [39, 4],
        [35, 19],
        [27, 6],
        [78, 29],
        [35, 4],
        [63, 36],
        [72, 31],
        [71, 2],
        [15, 8],
        [11, 14],
        [14, 7],
        [12, -6],
        [12, -21],
        [7, -47],
        [-4, -19],
        [9, -13],
        [0, -2],
        [-1, -22],
        [5, -14],
        [5, -24],
        [1, 0],
        [25, -8],
        [30, -2],
        [19, 4],
        [8, 21],
        [14, 7],
        [18, -1],
        [12, -6],
        [8, -19],
        [0, -2],
        [12, -6],
        [10, -2],
        [2, 4],
        [3, 6],
        [6, 14],
        [8, 8],
        [9, 3],
        [14, 0],
        [6, 6],
        [10, 11],
        [14, 6],
        [7, 12],
        [-3, 11],
        [-1, 1],
        [-10, 13],
        [-12, 8],
        [0, 2],
        [-9, 30],
        [-2, 8],
        [0, 8],
        [8, 6],
        [9, 2],
        [5, -2],
        [4, -3],
        [7, -1],
        [14, -1],
        [15, 4],
        [5, 1],
        [6, 0],
        [12, -4],
        [12, 0],
        [10, 2],
        [16, -2],
        [7, 3],
        [2, 4],
        [0, 6],
        [-3, 10],
        [0, 6],
        [3, 5],
        [10, 6],
        [5, 6],
        [7, 8],
        [12, 5],
        [11, 5],
        [8, 11],
        [6, 5],
        [8, -2],
        [2, -2],
        [0, -1],
        [2, -5],
        [-2, -6],
        [-6, -6],
        [-8, -8],
        [-8, -7],
        [0, -5],
        [2, -4],
        [2, -1],
        [4, -2],
        [6, 1],
        [8, 6],
        [4, 5],
        [6, 2],
        [8, -1],
        [9, -6],
        [3, -8],
        [2, -9],
        [5, -6],
        [4, -2],
        [6, 2],
        [16, 13],
        [22, 14],
        [6, 1],
        [6, -1],
        [6, -10],
        [2, -1],
        [6, -20],
        [1, 0],
        [13, -4],
        [9, 11],
        [8, 18],
        [6, 17],
        [-2, 16],
        [2, 14],
        [-1, 17],
        [5, 6],
        [6, 6],
        [13, 12],
        [2, 6],
        [-2, 4],
        [-1, 0],
        [-8, 6],
        [-7, 8],
        [-1, 0],
        [-1, 4],
        [2, 6],
        [4, 7],
        [14, 16],
        [6, 11],
        [8, 4],
        [10, 4],
        [8, 2],
        [4, 4],
        [3, 7],
        [4, 13],
        [1, 11],
        [-6, 19],
        [-4, 9],
        [-4, 6],
        [-2, 2],
        [2, 2],
        [16, 10],
        [16, 6],
        [8, 10],
        [6, 13],
        [6, 6],
        [21, 6],
        [14, 8],
        [21, 15],
        [12, 17],
        [2, 24],
        [2, 9],
        [8, 6],
        [2, 8],
        [1, 26],
        [3, 24],
        [-8, 26],
        [18, 26],
        [6, 22],
        [21, 12],
        [16, 16],
        [5, -6],
        [0, -2],
        [-9, -27],
        [36, -17],
        [39, -27],
        [33, -35],
        [40, -23],
        [27, -11],
        [23, -6],
        [13, -16],
        [12, -29],
        [0, -1],
        [20, -29],
        [14, -5],
        [11, 10],
        [13, 27],
        [7, 1],
        [5, -1],
        [0, -1],
        [3, -23],
        [13, -13],
        [0, -1],
        [10, -21],
        [0, 0],
        [4, -2],
        [6, 2],
        [14, 26],
        [5, 32],
        [5, 3],
        [7, -4],
        [12, -28],
        [1, -1],
        [32, -25],
        [17, -1],
        [31, -24],
        [8, 0],
        [24, 10],
        [22, 24],
        [-3, 9],
        [0, 2],
        [-15, 21],
        [7, 13],
        [18, 13],
        [18, 12],
        [21, 11],
        [4, 30],
        [0, 30],
        [2, 4],
        [12, 2],
        [31, -5],
        [9, 2],
        [2, 6],
        [-3, 28],
        [-1, 1],
        [-13, 14],
        [0, 1],
        [4, 16],
        [19, 14],
        [21, 2],
        [36, -30],
        [16, 0],
        [34, -6],
        [45, 2],
        [-2, 26],
        [-3, 8],
        [5, 0],
        [6, -4],
        [6, -6],
        [1, 0],
        [6, -13],
        [1, -26],
        [-17, -19],
        [-14, -21],
        [-2, -23],
        [4, -24],
        [-14, -71],
        [10, -21],
        [0, -1],
        [11, -5],
        [20, 0],
        [25, 2],
        [19, -18],
        [12, -6],
        [12, 4],
        [12, 10],
        [22, 30],
        [13, -3],
        [15, -17],
        [18, 4],
        [27, 14],
        [20, 11],
        [1, 0],
        [-13, -79],
        [-10, -46],
        [-9, -33],
        [2, -38],
        [-12, -52],
        [-20, -31],
        [0, -1],
        [30, -11],
        [48, 25],
        [51, 22],
        [28, -2],
        [34, 0],
        [11, -12],
        [0, -1],
        [5, -13],
        [0, -2],
        [6, -4],
        [11, -2],
        [12, 1],
        [23, -21],
        [14, -9],
        [10, -1],
        [23, 8],
        [39, -10],
        [20, -13],
        [11, -61],
        [698, 585],
        [10, 0],
        [115, -12],
        [320, -33],
        [110, -12],
        [30, -3],
        [0, 42],
        [2, 118],
        [9, 456],
        [428, 364],
        [56, 47],
        [20, 17],
        [-446, 183],
        [-69, 28],
        [-9, 4],
        [27, 59],
        [23, 51],
        [163, 365],
        [38, 86],
        [4, 5],
        [57, 129],
        [15, 33],
        [19, 42],
        [0, 2],
        [-2, 2],
        [-177, 153],
        [-10, 9],
        [-16, 21],
        [-23, 22],
        [-16, 43],
        [-24, 75],
        [-14, 67],
        [-20, 27],
        [-31, 27],
        [-23, 18],
        [-16, 16],
        [-20, 24],
        [-23, 17],
        [-36, 20],
        [-48, 6],
        [-60, 4],
        [-49, 14],
        [-64, 16],
        [4, 6],
        [40, 52],
        [252, 338],
        [-28, 57],
        [-49, 98],
        [-26, 53],
        [4451, 444],
        [387, 2288],
        [132, 778],
        [-881, 2509],
        [24, -2],
        [13, -4],
        [5, -8],
        [9, -4],
        [10, 4],
        [21, 6],
        [16, 6],
        [17, 0],
        [21, -12],
        [16, -4],
        [18, 4],
        [18, 0],
        [43, -8],
        [42, -18],
        [33, -16],
        [20, -13],
        [16, -22],
        [21, -37],
        [31, -14],
        [20, -12],
        [32, -31],
        [65, -47],
        [84, -37],
        [65, -42],
        [34, -7],
        [22, 13],
        [12, 21],
        [28, 14],
        [36, 7],
        [31, 42],
        [14, 1],
        [17, -7],
        [1, -17],
        [0, -27],
        [24, -5],
        [55, 8],
        [39, 40],
        [25, 35],
        [6, 34],
        [-6, 26],
        [2, 23],
        [6, 14],
        [14, 5],
        [21, -4],
        [23, -14],
        [45, -27],
        [61, 1],
        [37, 12],
        [21, 2],
        [14, 5],
        [27, 13],
        [49, 13],
        [55, 28],
        [35, 3],
        [29, -12],
        [27, -23],
        [43, -48],
        [23, -19],
        [24, -8],
        [26, 6],
        [19, -2],
        [11, -20],
        [50, -18],
        [38, -2],
        [47, 4],
        [31, 16],
        [10, 10],
        [23, 0],
        [15, -8],
        [46, 24],
        [44, 24],
        [40, 33],
        [30, 9],
        [45, 4],
        [36, -14],
        [19, -10],
        [8, -41],
        [1, -35],
        [13, -20],
        [19, -8],
        [31, -9],
        [33, -6],
        [41, 6],
        [27, 6],
        [32, 6],
        [20, -1],
        [16, -6],
        [37, 6],
        [32, -8],
        [28, -8],
        [34, -19],
        [6, -20],
        [18, -9],
        [24, -8],
        [22, -15],
        [31, -28],
        [4, -37],
        [4, -23],
        [12, -14],
        [47, -29],
        [47, -28],
        [27, -10],
        [62, 14],
        [41, -8],
        [40, -19],
        [40, -13],
        [53, -24],
        [23, 11],
        [21, -1],
        [28, -15],
        [45, -32],
        [35, -26],
        [55, -16],
        [54, -16],
        [28, -4],
        [21, -10],
        [9, -17],
        [1, -17],
        [5, -4],
        [9, -2],
        [13, 6],
        [14, -5],
        [5, -9],
        [2, -22],
        [4, -33],
        [22, -30],
        [31, -23],
        [29, -6],
        [29, -35],
        [33, -4],
        [28, -3],
        [22, -12],
        [14, -17],
        [28, -20],
        [10, -4],
        [2, 10],
        [-2, 21],
        [2, 28],
        [7, 21],
        [14, 9],
        [13, 8],
        [44, 4],
        [25, 8],
        [18, 13],
        [16, 24],
        [38, 22],
        [37, 22],
        [37, 16],
        [60, 55],
        [79, 62],
        [37, 15],
        [33, 41],
        [12, 23],
        [15, 14],
        [59, 53],
        [18, 11],
        [22, 6],
        [43, 10],
        [26, 14],
        [36, 60],
        [23, 48],
        [23, 41],
        [5, 39],
        [23, 22],
        [38, 23],
        [55, 22],
        [34, 16],
        [34, 31],
        [45, 31],
        [35, 46],
        [14, 31],
        [16, 19],
        [28, 31],
        [29, 34],
        [21, 12],
        [16, 16],
        [6, 51],
        [0, 61],
        [49, 32],
        [47, 28],
        [23, 21],
        [19, 19],
        [14, 53],
        [-4, 51],
        [15, 30],
        [40, 26],
        [21, 16],
        [17, 29],
        [3, 33],
        [5, 44],
        [-7, 55],
        [-16, 34],
        [-20, 28],
        [-7, 8],
        [-8, 0],
        [-24, -2],
        [-31, 13],
        [-23, 24],
        [-9, 30],
        [-6, 38],
        [10, 52],
        [17, 20],
        [5, 23],
        [16, 44],
        [10, 25],
        [6, 24],
        [1, 49],
        [10, 44],
        [8, 41],
        [4, 43],
        [-6, 35],
        [0, 24],
        [14, 13],
        [21, 17],
        [12, 19],
        [6, 27],
        [-21, 50],
        [-10, 43],
        [-2, 25],
        [6, 24],
        [4, 19],
        [8, 27],
        [11, 33],
        [12, 32],
        [10, 36],
        [3, 30],
        [4, 33],
        [7, 36],
        [-9, 19],
        [-14, 18],
        [-15, 17],
        [-14, 18],
        [-13, 8],
        [-16, 20],
        [-12, 21],
        [-12, 22],
        [0, 15],
        [2, 34],
        [-7, 29],
        [-14, 19],
        [-17, 12],
        [-18, 11],
        [-15, 31],
        [-18, 44],
        [4, 12],
        [8, 12],
        [22, 13],
        [16, 8],
        [20, 4],
        [17, 5],
        [20, 4],
        [16, 9],
        [12, 2],
        [10, 2],
        [9, 4],
        [4, 9],
        [8, 6],
        [2, 11],
        [0, 9],
        [-3, 10],
        [-7, 15],
        [-4, 20],
        [-9, 26],
        [-4, 29],
        [-5, 30],
        [-13, 29],
        [-14, 19],
        [-22, 18],
        [-24, 10],
        [-57, 75],
        [-6, 27],
        [6, 34],
        [-4, 27],
        [-2, 15],
        [-2, 16],
        [-5, 19],
        [-5, 21],
        [-21, 33],
        [-13, 22],
        [-22, 28],
        [-16, 16],
        [0, 16],
        [2, 18],
        [14, 15],
        [9, 29],
        [1, 42],
        [-1, 52],
        [23, 36],
        [14, 20],
        [12, 24],
        [8, 19],
        [-1, 35],
        [1, 31],
        [4, 48],
        [10, 43],
        [8, 18],
        [17, 13],
        [33, 14],
        [43, 19],
        [22, 18],
        [13, 12],
        [7, 24],
        [15, 11],
        [29, 4],
        [18, 6],
        [16, 21],
        [16, 8],
        [8, 9],
        [7, 11],
        [11, 10],
        [9, 13],
        [16, 15],
        [8, 11],
        [10, 25],
        [18, 21],
        [11, 13],
        [2, 19],
        [12, 19],
        [3, 37],
        [12, 16],
        [9, 16],
        [9, 15],
        [8, 14],
        [4, 14],
        [-2, 21],
        [-2, 28],
        [0, 30],
        [2, 25],
        [8, 10],
        [6, 29],
        [-4, 23],
        [-16, 28],
        [2, 16],
        [10, 19],
        [2, 18],
        [-6, 28],
        [0, 29],
        [6, 32],
        [2, 49],
        [-10, 16],
        [-10, 15],
        [-16, 7],
        [-23, 3],
        [-19, 1],
        [-18, 18],
        [-40, 36],
        [-31, 40],
        [-22, 48],
        [-4, 39],
        [-2, 16],
        [-26, 38],
        [-6, 31],
        [8, 20],
        [18, 8],
        [6, 23],
        [-8, 28],
        [0, 37],
        [-14, 11],
        [-18, 49],
        [-32, 39],
        [-1, 40],
        [-9, 50],
        [3, 28],
        [13, 31],
        [-6, 22],
        [-24, 23],
        [-2, 19],
        [6, 29],
        [-6, 46],
        [-30, 29],
        [-34, 25],
        [4, 28],
        [6, 29],
        [-3, 41],
        [5, 20],
        [-4, 27],
        [3, 37],
        [12, 32],
        [19, 35],
        [12, 49],
        [16, 14],
        [17, 22],
        [10, 37],
        [20, 20],
        [23, 32],
        [2, 13],
        [32, 32],
        [20, 16],
        [20, 25],
        [9, 28],
        [6, 25],
        [10, 30],
        [10, 25],
        [2, 21],
        [16, 60],
        [-2, 22],
        [-6, 20],
        [-10, 9],
        [-14, 37],
        [-7, 29],
        [-16, 66],
        [-42, 33],
        [-18, -1],
        [-16, 7],
        [-11, 19],
        [-20, 47],
        [-11, 1],
        [-14, 6],
        [-8, 9],
        [-14, 26],
        [-4, 24],
        [-14, 13],
        [-15, 2],
        [-9, 4],
        [-4, 10],
        [8, 16],
        [8, 20],
        [12, 21],
        [16, 17],
        [4, 28],
        [10, 30],
        [23, 19],
        [22, 28],
        [18, 35],
        [4, 46],
        [21, 42],
        [0, 59],
        [-2, 26],
        [14, 31],
        [-12, 18],
        [8, 12],
        [2, 20],
        [0, 38],
        [-18, 58],
        [-4, 17],
        [-11, 30],
        [9, 28],
        [0, 18],
        [-10, 9],
        [-20, 6],
        [-21, 14],
        [-16, 16],
        [-3, 11],
        [2, 19],
        [-8, 13],
        [-16, 25],
        [-33, 52],
        [-7, 59],
        [8, 41],
        [24, 78],
        [4, 76],
        [36, 56],
        [21, 65],
        [39, 79],
        [95, 111],
        [65, 46],
        [59, 33],
        [61, 22],
        [24, 20],
        [31, 42],
        [14, 60],
        [2, 39],
        [28, 27],
        [17, 35],
        [26, 21],
        [42, 15],
        [25, -26],
        [7, -9],
        [1492, -1653],
        [8, -10],
        [848, -941],
        [3297, 3682],
      ],
      [
        [112644, 328662],
        [3838, -7102],
        [3, -5],
        [2, -5],
        [2, -4],
        [520, -963],
        [1509, -158],
        [0, -4],
        [18, -50],
        [38, -62],
        [9, -47],
        [23, -56],
        [4, -40],
        [83, -64],
        [-66, -55],
        [0, -51],
        [-2, -89],
        [27, 18],
        [43, -8],
        [4, -42],
        [61, 0],
        [48, 34],
        [49, 0],
        [47, -81],
        [87, -64],
        [39, 61],
        [22, 60],
        [19, 28],
        [45, -8],
        [12, -68],
        [24, -91],
        [34, -22],
        [51, -4],
        [37, 4],
        [45, 77],
        [150, 21],
        [14, -51],
        [-48, -43],
        [38, -77],
        [33, -49],
        [38, -25],
        [45, -29],
        [53, -28],
        [26, -8],
        [31, -10],
        [18, 1],
        [15, 2],
        [20, 18],
        [20, 41],
        [31, -106],
        [14, -61],
        [26, -40],
        [29, -30],
        [40, -32],
        [17, -42],
        [-19, -28],
        [-48, 6],
        [-38, 17],
        [-13, -60],
        [35, -60],
        [24, -35],
        [38, -55],
        [39, -24],
        [6, -22],
        [29, -42],
        [12, -40],
        [-4, -49],
        [43, -94],
        [19, -44],
        [10, -19],
        [28, 16],
        [45, 25],
        [11, 6],
        [76, 63],
        [59, 92],
        [41, 66],
        [82, -4],
        [38, -18],
        [38, -34],
        [40, -73],
        [48, -44],
        [44, -34],
        [54, -8],
        [59, -2],
        [43, 12],
        [37, 28],
        [36, 40],
        [91, 109],
        [94, 87],
        [21, 25],
        [1, 8],
        [79, -5],
        [0, -121],
        [-2, -95],
        [-18, -76],
        [53, -58],
        [29, -37],
        [44, -39],
        [52, -22],
        [26, 6],
        [32, 21],
        [41, 33],
        [4, 72],
        [1, 73],
        [34, 63],
        [55, 84],
        [20, 46],
        [28, 59],
        [39, 54],
        [47, 46],
        [47, 34],
        [78, -133],
        [91, -173],
        [41, -141],
        [92, -102],
        [40, -139],
        [147, 11],
        [161, 83],
        [151, 153],
        [134, 65],
        [139, -35],
        [203, -150],
        [263, -308],
        [253, -60],
        [93, 72],
        [151, 28],
        [156, -142],
        [-16, -218],
        [8, -91],
        [97, -228],
        [185, -316],
        [24, -291],
        [37, -146],
        [197, -89],
        [477, -590],
        [22, -167],
        [86, -97],
        [113, -10],
        [74, -100],
        [0, -83],
        [51, -80],
        [-14, -71],
        [53, -183],
        [-20, -72],
        [579, -365],
        [-1481, 66],
        [1561, -2316],
        [1243, -1663],
        [2626, -3514],
        [-7832, -4627],
        [-2111, -391],
        [-1863, -812],
        [9, -30],
        [3, -18],
        [-2, -8],
        [-4, -9],
        [-15, -7],
        [-11, -12],
        [-6, -24],
        [-9, -18],
        [-5, -17],
        [-28, -18],
        [-23, -33],
        [11, -36],
        [22, -38],
        [2, -30],
        [-16, -40],
        [-4, -27],
        [-6, -20],
        [-8, -13],
        [-20, -3],
        [-24, -27],
        [-4, -45],
        [-1, -39],
        [7, -32],
        [10, -34],
        [9, -27],
        [2, -22],
        [-8, -18],
        [-9, -25],
        [-5, -23],
        [-26, -14],
        [-28, -20],
        [-20, -26],
        [-7, -14],
        [5, -18],
        [-1, -13],
        [-6, -8],
        [-17, -16],
        [-2, -21],
        [-20, -9],
        [-12, -32],
        [-19, -13],
        [-29, -2],
        [-10, -28],
        [0, -14],
        [-7, -10],
        [-47, -15],
        [-32, -9],
        [-33, -12],
        [-14, -7],
        [-18, -5],
        [-28, -2],
        [-21, 2],
        [-16, -3],
        [-12, -8],
        [-9, -2],
        [-32, -6],
        [-15, 3],
        [-22, 11],
        [-21, -8],
        [-1, -13],
        [-7, -9],
        [-27, -29],
        [-21, -11],
        [-14, -14],
        [-12, -15],
        [-6, -33],
        [-10, -13],
        [-20, -8],
        [-21, -6],
        [-14, -2],
        [-20, -8],
        [-18, -4],
        [-20, 8],
        [-2, -12],
        [-2, -7],
        [-11, -15],
        [-10, -7],
        [-10, -10],
        [-14, -3],
        [-15, -9],
        [-14, -5],
        [-17, 0],
        [-18, 4],
        [-26, 4],
        [-22, 13],
        [-21, 14],
        [-8, -8],
        [-12, -8],
        [-6, -8],
        [-8, -2],
        [-27, 6],
        [-12, 8],
        [-22, -20],
        [-24, 14],
        [-13, 9],
        [-27, 34],
        [-40, -15],
        [-10, -65],
        [-11, -14],
        [-3, -24],
        [-18, -16],
        [4, -28],
        [-19, -11],
        [-33, -2],
        [-18, -29],
        [-4, -22],
        [-10, -16],
        [-5, -15],
        [-19, -28],
        [-6, -39],
        [-5, -43],
        [-4, -30],
        [-7, -26],
        [7, -26],
        [2, -37],
        [-15, -54],
        [-10, -50],
        [2, -25],
        [2, -29],
        [6, -28],
        [-8, -33],
        [-4, -31],
        [-3, -32],
        [-1, -10],
        [12, -14],
        [6, -18],
        [4, -20],
        [9, -19],
        [16, -8],
        [26, -11],
        [27, -17],
        [15, -18],
        [12, -32],
        [26, -30],
        [30, -34],
        [22, -27],
        [10, -30],
        [15, -19],
        [39, -19],
        [59, -28],
        [31, -23],
        [15, -10],
        [-5, -38],
        [-16, -13],
        [-23, -33],
        [-18, -7],
        [-41, -10],
        [-26, -2],
        [-25, 8],
        [-19, -10],
        [-14, -18],
        [-9, -18],
        [3, -21],
        [19, -36],
        [-3, -17],
        [-17, -29],
        [-16, -46],
        [-1, -52],
        [-11, -32],
        [-7, -64],
        [3, -26],
        [9, -18],
        [17, -15],
        [13, -2],
        [18, 11],
        [25, 5],
        [20, 3],
        [13, -2],
        [2, -2],
        [4, -30],
        [-3, -37],
        [-17, -74],
        [-23, -42],
        [-19, -12],
        [-16, -16],
        [-15, -13],
        [-18, -19],
        [-2, -20],
        [5, -14],
        [8, -22],
        [-15, -25],
        [-19, -32],
        [-14, -18],
        [-18, -11],
        [-39, 1],
        [-29, -11],
        [-31, -19],
        [-22, -19],
        [-11, -34],
        [10, -32],
        [20, -63],
        [-2, -57],
        [-6, -56],
        [21, -34],
        [34, -24],
        [10, -28],
        [20, -20],
        [14, -43],
        [-5, -23],
        [-13, -42],
        [3, -13],
        [13, -8],
        [43, -2],
        [37, -2],
        [21, -12],
        [14, -31],
        [8, -41],
        [-8, -31],
        [-60, -73],
        [-26, -47],
        [-2, -16],
        [6, -10],
        [10, -18],
        [24, -22],
        [6, -14],
        [-7, -16],
        [-19, -29],
        [-12, -25],
        [-8, -21],
        [-12, -12],
        [-10, -2],
        [-28, 8],
        [-11, -2],
        [-15, -10],
        [-15, -81],
        [-6, -15],
        [-8, -7],
        [-18, -17],
        [-23, -10],
        [-11, -18],
        [-7, -23],
        [-25, -3],
        [-26, 5],
        [-33, 16],
        [-14, 10],
        [-7, 8],
        [-17, 4],
        [-12, 1],
        [-14, -1],
        [-17, 0],
        [-9, 2],
        [-12, 0],
        [-9, 3],
        [-9, 5],
        [-7, 1],
        [-11, 2],
        [-10, -4],
        [-8, -6],
        [-5, -9],
        [-1, -10],
        [-5, -9],
        [-4, -12],
        [4, -9],
        [2, -11],
        [-4, -14],
        [-4, -10],
        [-8, -15],
        [-6, -13],
        [-8, -8],
        [-8, -10],
        [-8, -20],
        [-2, -16],
        [-2, -12],
        [-7, -14],
        [-12, -12],
        [-23, -33],
        [-11, -17],
        [-8, -13],
        [-10, -14],
        [-15, -8],
        [-16, -12],
        [-28, -46],
        [-19, -24],
        [-22, -13],
        [-25, -22],
        [-31, -39],
        [-19, -30],
        [-8, -32],
        [-2, -35],
        [0, -24],
        [2, -16],
        [-4, -22],
        [-6, -20],
        [-22, -31],
        [-4, -25],
        [-58, -69],
        [-6, -14],
        [2, -18],
        [10, -30],
        [27, -29],
        [39, -7],
        [-6, -41],
        [5, -34],
        [19, -18],
        [22, -10],
        [31, -11],
        [30, -15],
        [14, -17],
        [12, -26],
        [14, -28],
        [4, -30],
        [-1, -27],
        [-17, -42],
        [-8, -40],
        [4, -41],
        [-6, -19],
        [-8, -12],
        [-14, -11],
        [-19, -10],
        [-9, -8],
        [-19, -2],
        [-16, -10],
        [-18, -12],
        [-17, -10],
        [-13, -17],
        [-5, -21],
        [11, -17],
        [30, -19],
        [16, -8],
        [21, -11],
        [22, -9],
        [17, -16],
        [19, -11],
        [16, -16],
        [-2, -20],
        [-8, -37],
        [-10, -26],
        [-8, -30],
        [-11, -27],
        [-17, -27],
        [-14, -17],
        [-12, -10],
        [-21, -11],
        [-20, -6],
        [-18, -5],
        [-27, -11],
        [-31, -17],
        [-26, -14],
        [-17, -22],
        [-5, -33],
        [-4, -34],
        [-8, -33],
        [-8, -27],
        [-6, -37],
        [-8, -36],
        [-2, -11],
        [-7, -24],
        [-2, -38],
        [-5, -30],
        [-1, -30],
        [0, -36],
        [-16, -33],
        [-28, -26],
        [-26, -22],
        [-16, -12],
        [-12, -14],
        [-6, -18],
        [-10, -17],
        [-8, -23],
        [-4, -31],
        [2, -27],
        [4, -21],
        [4, -24],
        [12, -22],
        [0, -17],
        [-6, -14],
        [-26, -20],
        [-16, -19],
        [-12, -21],
        [-16, -27],
        [-6, -22],
        [-5, -24],
        [6, -16],
        [19, -10],
        [16, -12],
        [12, -12],
        [14, -8],
        [8, -16],
        [4, -23],
        [8, -18],
        [6, -12],
        [4, -16],
        [-4, -28],
        [-18, -13],
        [-28, 0],
        [-36, -6],
        [-35, -25],
        [-25, -17],
        [-32, -15],
        [-36, -6],
        [-47, 4],
        [-28, 0],
        [-34, -2],
        [-36, -4],
        [-27, -23],
        [-9, -17],
        [1, -39],
        [20, -30],
        [29, -35],
        [8, -10],
        [6, -10],
        [-2, -6],
        [-43, -53],
        [-8, -90],
        [9, -38],
        [0, -44],
        [-13, -59],
        [-6, -19],
        [0, -17],
        [0, -9],
      ],
      [
        [83390, 359034],
        [133, -73],
        [64, -36],
        [44, -36],
        [89, -70],
        [63, -70],
        [20, -78],
        [15, -64],
        [-13, -74],
        [-20, -55],
        [-6, -52],
        [-31, -52],
        [-15, -31],
        [-4, -42],
        [-28, -62],
        [-55, -73],
        [-29, -48],
        [-32, -48],
        [-15, -34],
        [-13, -26],
        [-16, -23],
        [-10, -22],
        [-10, -38],
        [8, -29],
        [16, -37],
        [24, -34],
        [21, -40],
        [28, -36],
        [13, -18],
        [95, -46],
        [29, -55],
        [56, -64],
        [27, -44],
        [29, -56],
        [-12, -60],
        [-2, -36],
        [-6, -20],
        [24, -35],
        [50, -47],
        [16, -38],
        [35, -63],
        [65, -120],
        [29, -119],
        [52, -84],
        [7, -27],
        [24, -37],
        [16, -35],
        [36, -107],
        [11, -29],
        [8, -12],
        [18, -2],
        [7, -2],
        [2, -14],
        [4, -8],
        [19, -21],
        [23, -23],
        [4, -18],
        [18, -26],
        [44, -67],
        [-7, -44],
        [-6, -35],
        [18, -63],
        [16, -64],
        [25, -20],
        [29, -22],
        [44, -33],
        [44, -46],
        [22, -54],
        [6, -40],
        [5, -21],
        [8, -35],
        [19, -24],
        [12, -23],
        [34, -6],
        [10, -8],
        [1, -8],
        [-3, -12],
        [-9, -12],
        [-9, -11],
        [0, -27],
        [-14, -22],
        [16, -15],
        [42, -10],
        [7, -8],
        [-1, -17],
        [-2, -9],
        [-23, -10],
        [-10, -14],
        [-1, -13],
        [11, -29],
        [-7, -34],
        [18, -41],
        [7, -33],
        [6, -37],
        [5, -35],
        [-4, -28],
        [13, -30],
        [22, -35],
        [8, -17],
        [10, -12],
        [3, -17],
        [-33, -55],
        [-23, -60],
        [-21, -32],
        [-47, -49],
        [-59, -60],
        [-39, -71],
        [-42, -59],
        [-19, -55],
        [-3, -18],
        [1, -11],
        [2, -16],
        [1, -28],
        [-31, -31],
        [0, -18],
        [21, -46],
        [-3, -27],
        [-4, -23],
        [0, -24],
        [2, -21],
        [4, -16],
        [-9, -14],
        [-1, -16],
        [27, -85],
        [10, -24],
        [-9, -16],
        [4, -4],
        [2, -8],
        [-7, -2],
        [-8, -4],
        [-4, -2],
        [2, -20],
        [2, -52],
        [5, -12],
        [-5, -14],
        [-13, -29],
        [-10, -41],
        [2, -17],
        [6, -31],
        [-10, -102],
        [-4, -71],
        [67, -50],
        [65, -9],
        [51, 3],
        [79, -7],
        [98, -20],
        [117, -37],
        [63, -93],
        [10, -139],
        [11, -92],
        [22, -80],
        [112, -98],
        [24, -36],
        [8, -23],
        [4, -21],
        [6, -18],
        [9, -28],
        [16, -27],
        [7, -22],
        [24, -23],
        [92, -75],
        [47, -12],
        [35, -4],
        [48, 0],
        [58, 2],
        [38, -43],
        [63, -38],
        [61, -48],
        [79, -24],
        [134, -36],
        [78, 4],
        [41, -8],
        [3, -1],
        [12, -2],
        [19, -4],
        [101, 41],
        [65, 20],
        [73, 0],
        [39, -6],
        [23, -26],
        [46, -21],
        [71, -39],
        [84, -27],
        [213, -32],
        [38, -14],
        [53, -29],
        [22, -5],
        [22, 2],
        [24, -11],
        [10, -12],
        [45, -59],
        [40, -42],
        [54, -9],
        [38, -12],
        [39, -34],
        [26, -54],
        [-28, -81],
        [-40, -40],
        [-49, -28],
        [-40, -67],
        [-14, -80],
        [-18, -78],
        [16, -75],
        [26, -49],
        [84, -54],
        [20, -21],
        [13, -34],
        [39, -19],
        [21, -11],
        [24, -3],
        [16, -13],
        [15, -17],
        [11, -20],
        [7, -24],
        [14, -31],
        [23, -19],
        [33, 9],
        [25, 28],
        [45, 48],
        [-5, 19],
        [3, 12],
        [6, 6],
        [35, -58],
        [18, -46],
        [6, -18],
        [-2, -32],
        [4, -42],
        [0, -14],
        [6, -13],
        [13, -6],
        [13, 2],
        [12, 4],
        [10, 2],
        [7, -6],
        [12, -29],
        [-2, -29],
        [12, -21],
        [6, -23],
        [4, -14],
        [7, -6],
        [6, 2],
        [9, 6],
        [16, 12],
        [5, 0],
        [4, 1],
        [2, -3],
        [-2, -6],
        [-1, -10],
        [8, -10],
        [6, -14],
        [1, -39],
        [-4, -22],
        [0, -20],
        [8, -17],
        [-10, -16],
        [-18, -20],
        [4, -30],
        [-5, -61],
        [14, -30],
        [14, -34],
      ],
      [
        [87603, 351280],
        [-56, -4],
        [-39, 0],
        [-76, -2],
        [-22, -22],
        [-33, -17],
        [-24, -28],
        [-19, -50],
        [-31, -46],
        [-26, -3],
        [-63, -36],
        [-331, 9],
        [-14, -58],
        [-12, -49],
        [-47, -41],
        [-25, -30],
        [-7, -54],
        [-36, -66],
        [-36, -79],
        [-46, -82],
        [-46, -65],
        [-36, -2],
        [-65, -23],
        [-50, -63],
        [-49, -57],
        [-33, -56],
        [-30, -44],
        [-25, -36],
        [-33, -31],
        [-31, -32],
        [-10, -20],
        [-3, -15],
        [7, -42],
        [-19, -7],
        [-27, 1],
        [-42, -9],
        [-47, -30],
        [-44, -39],
        [-49, -24],
        [-35, -22],
        [-11, -15],
        [-6, -14],
        [5, -20],
        [12, -22],
        [18, -22],
        [29, -26],
        [30, -54],
        [7, -22],
        [31, -61],
        [34, -14],
        [108, 0],
        [20, 8],
        [4, 28],
        [-10, 25],
        [-24, 80],
        [8, 32],
        [47, 18],
        [70, 8],
        [77, -14],
        [56, -22],
        [15, -46],
        [30, -56],
        [9, -37],
        [-2, -12],
        [-4, -10],
        [-3, -8],
        [-4, -8],
        [13, -71],
        [-21, -55],
        [-22, -38],
        [-18, -44],
        [-14, -34],
        [-4, -16],
        [6, -37],
        [-4, -22],
        [-49, -44],
        [-51, -26],
        [-18, -36],
        [-8, -54],
        [-5, -27],
        [-9, -42],
        [-17, -14],
        [-26, -2],
        [-32, -18],
        [-8, -20],
        [-11, -60],
        [-14, -36],
        [-31, -50],
        [-6, -28],
        [6, -32],
        [49, -69],
        [-1, -22],
        [-5, -27],
        [7, -24],
        [18, -37],
        [28, -53],
        [-4, -37],
        [-10, -42],
        [-14, -16],
        [-21, -11],
        [-4, -25],
        [-9, -16],
        [-16, -18],
        [-30, -10],
        [-14, -12],
        [0, -9],
        [8, -48],
        [0, -22],
        [-28, -23],
        [-14, -12],
        [-10, -1],
        [-12, -5],
        [-3, -9],
        [2, -12],
        [7, -29],
        [10, -20],
        [27, -48],
        [36, -48],
        [-9, -67],
        [-76, -85],
        [-5, -84],
        [17, -89],
        [48, -93],
        [43, -73],
        [6, -60],
        [-29, -51],
        [-48, -58],
        [-12, -32],
        [-20, -25],
        [-80, -72],
        [-36, -20],
        [-47, -23],
        [-60, -16],
        [-44, -20],
        [-39, -36],
        [-6, -34],
        [-11, -38],
        [-25, -24],
        [0, -78],
        [16, -76],
        [57, -50],
        [16, -39],
        [-2, -57],
        [53, -74],
        [-4, -76],
        [-80, -58],
        [-34, -65],
        [1, -91],
        [10, -111],
        [-15, -140],
        [-2, -17],
        [-12, -20],
        [-14, -11],
        [-20, -3],
        [-33, -16],
        [-26, -23],
        [-65, -73],
        [-31, -56],
        [-24, -48],
        [-22, -39],
        [-21, -49],
        [-8, -22],
        [8, -17],
        [2, -18],
        [-8, -13],
        [-14, -22],
        [-29, -39],
        [-16, -37],
        [-4, -39],
        [-5, -46],
        [-18, -43],
        [-18, -45],
        [1, -60],
        [17, -59],
        [-4, -73],
        [24, -77],
        [8, -39],
        [-24, -46],
        [-16, -21],
        [-21, -17],
        [-62, -30],
        [-54, -49],
        [-15, -58],
        [1, -69],
        [4, -163],
        [0, -3],
        [-240, -670],
        [0, -63],
        [4, -52],
        [13, -31],
        [21, -44],
        [16, -45],
        [39, -63],
        [2, -73],
        [-41, -98],
        [-54, -87],
        [-71, -53],
        [-25, -54],
        [-72, -39],
        [-44, -46],
        [-18, -49],
        [-17, -51],
        [-44, -63],
        [-62, -42],
        [-66, -58],
        [-79, -52],
        [-56, -30],
        [-117, -22],
        [-69, -16],
        [-69, -26],
        [-39, -49],
        [-25, -54],
        [-7, -52],
        [4, -63],
        [16, -62],
        [57, -52],
        [41, -33],
        [58, -13],
        [62, -8],
        [73, -17],
        [80, -49],
        [44, -67],
        [16, -63],
        [32, -52],
        [15, -55],
        [2, -10],
        [29, -18],
        [27, -12],
        [23, -15],
        [35, -29],
        [54, -27],
        [36, -2],
        [74, -15],
        [53, -15],
        [36, -29],
        [-22, -92],
        [-18, -69],
        [-15, -60],
        [-38, -22],
        [-27, -60],
        [37, -80],
        [26, -59],
        [7, -47],
        [-4, -26],
        [-9, -27],
        [-55, -33],
        [-75, -34],
        [-24, -14],
        [-25, -6],
        [-14, 7],
        [-31, 37],
        [-16, 30],
        [0, 33],
        [-57, 35],
        [-54, 1],
        [-27, 3],
        [-46, 2],
        [-23, -14],
        [-36, 3],
        [-67, -32],
        [-29, -20],
        [-34, -12],
        [-17, -19],
        [-24, -16],
        [-44, -25],
        [-42, -19],
        [-46, -24],
        [-37, -54],
        [-37, -6],
        [-21, -17],
        [-36, -10],
        [-24, -13],
        [-32, -2],
        [-18, -13],
        [-20, -11],
        [-24, -7],
        [-64, -25],
        [-24, -8],
        [-35, -8],
        [-22, -8],
        [-132, -78],
        [-100, -41],
        [-110, -60],
        [-103, -63],
        [-14, -81],
        [-43, -86],
        [-49, -112],
        [-31, -56],
        [-55, -103],
        [-88, -30],
        [-55, -32],
        [-31, -56],
        [11, -61],
        [38, -66],
        [84, -32],
        [83, -2],
        [75, 4],
        [33, 63],
        [54, 37],
        [54, 43],
        [78, 16],
        [79, 20],
        [94, 48],
        [138, 59],
        [4, 19],
        [8, 20],
        [10, 15],
        [58, 37],
        [80, 32],
        [49, 12],
        [43, 4],
        [58, -12],
        [98, -48],
        [31, -2],
        [71, -56],
        [65, -81],
        [29, -48],
        [2, -35],
        [-4, -69],
        [0, -41],
        [-3, -52],
        [-22, -106],
        [-53, -69],
        [-68, -99],
        [-36, -85],
        [-93, -50],
        [-60, -30],
        [-35, -24],
        [-66, -61],
        [-58, -75],
        [-18, -64],
        [-27, -50],
        [-9, -131],
        [3, -137],
        [39, -103],
        [33, -37],
        [60, -32],
        [65, -47],
        [76, -64],
        [72, -70],
        [45, -35],
        [27, -25],
        [18, -45],
        [-8, -24],
        [2, -7],
        [6, -5],
        [22, -8],
        [14, -9],
        [12, -23],
        [3, -22],
        [0, -17],
        [1, -16],
        [88, -45],
        [-12, -61],
        [10, -79],
        [-6, -129],
        [-34, -91],
        [-23, -25],
        [-7, -35],
        [29, -52],
        [41, -129],
        [-16, -81],
        [-4, -76],
        [-18, -80],
        [-13, -79],
        [18, -66],
        [-1, -37],
        [85, 1],
        [65, -11],
        [40, -54],
        [-13, -72],
        [8, -15],
        [5, -16],
        [19, -11],
        [20, -1],
        [44, 20],
        [57, 29],
        [10, 6],
        [17, 2],
        [41, -2],
        [30, -2],
        [35, -12],
        [13, -3],
        [21, 9],
        [12, -2],
        [12, -6],
        [12, -11],
        [-24, -58],
        [-23, -58],
        [-20, -74],
        [10, -60],
        [11, -19],
        [20, -14],
        [22, 10],
        [23, 66],
        [26, 51],
        [60, 43],
        [25, 1],
        [27, -21],
        [17, -8],
        [3, -11],
        [-2, -12],
        [-10, -10],
        [-29, -28],
        [-21, -36],
        [-2, -4],
        [17, -32],
        [34, -19],
        [18, -5],
        [24, -7],
        [12, -14],
        [-6, -21],
        [-32, -28],
        [-54, -18],
        [-17, -17],
        [-10, -25],
        [1, -35],
        [9, -22],
        [12, -18],
        [9, -20],
        [0, -15],
        [-13, -16],
        [-23, -14],
        [-24, -11],
        [-29, 8],
        [-30, 44],
        [-21, 48],
        [-4, 14],
        [-10, 10],
        [-15, 2],
        [-16, -3],
        [-21, -14],
        [-15, -29],
        [-6, -37],
        [2, -25],
        [7, -21],
        [25, -7],
        [24, -1],
        [21, -4],
        [17, -12],
        [7, -7],
        [-1, -20],
        [-11, -30],
        [-21, -26],
        [-26, -41],
        [0, -15],
        [4, -9],
        [8, -6],
        [15, -12],
        [26, 8],
        [25, 8],
        [30, 0],
        [29, -12],
        [21, -22],
        [8, -10],
        [4, -10],
        [2, -8],
        [-2, -12],
        [-6, -5],
        [-14, -2],
        [-20, -2],
        [-13, -7],
        [-17, -18],
        [-12, -22],
        [-55, -49],
        [-29, -44],
        [-2, -23],
        [14, -21],
        [31, -17],
        [37, -4],
        [36, 18],
        [42, 57],
        [17, 12],
        [20, 4],
        [20, -4],
        [15, -8],
        [17, -17],
        [-15, -68],
        [1, -9],
        [3, -12],
        [13, -11],
        [6, -13],
        [4, -10],
        [-9, -14],
        [-24, -23],
        [-4, -13],
        [7, -7],
        [24, -1],
        [44, 7],
        [28, -5],
        [20, -3],
        [-31, -198],
        [-22, -32],
        [-7, -61],
        [16, -45],
        [10, -24],
        [13, -14],
        [12, -6],
        [6, -4],
        [2, -5],
        [1, -9],
        [-2, -11],
        [-16, -7],
        [-34, -2],
        [-41, 3],
        [-22, -3],
        [-12, -6],
        [-7, -10],
        [1, -19],
        [15, -18],
        [30, -28],
        [12, -21],
        [8, -15],
        [8, -15],
        [0, -16],
        [-16, -13],
        [-26, -22],
        [1, -20],
        [0, -16],
        [-5, -33],
        [-3, -31],
        [0, -15],
        [-7, -14],
        [-17, -26],
        [-4, -37],
        [-2, -16],
        [6, -22],
        [-14, -29],
        [-23, -31],
        [-3, -33],
        [43, -44],
        [46, -17],
        [22, -12],
        [11, -13],
        [16, -21],
        [-6, -18],
        [-7, -16],
        [-14, -8],
        [-6, -18],
        [8, -17],
        [9, -4],
        [11, 1],
        [11, -1],
        [9, -6],
        [10, -8],
        [5, -10],
        [-4, -12],
        [-10, -5],
        [-12, -3],
        [-27, -7],
        [-18, -6],
        [-33, -19],
        [-43, -28],
        [-12, -8],
        [-11, -11],
        [-16, 0],
        [-15, 3],
        [-12, 0],
        [-14, -3],
        [-11, -8],
        [-8, -9],
        [-1, -8],
        [3, -7],
        [21, -24],
        [22, -19],
        [0, -11],
        [4, -17],
        [-3, -16],
        [-21, -27],
        [-2, -6],
        [10, -8],
        [8, -7],
        [0, -8],
        [-5, -6],
        [-28, -25],
        [-38, -27],
        [-21, -14],
        [-8, -16],
        [-8, -8],
        [-8, -2],
        [-8, 0],
        [-13, 8],
        [-10, 6],
        [-27, 10],
        [-13, 6],
        [-6, 0],
        [-4, -6],
        [-4, -6],
        [-2, -12],
        [0, -17],
        [6, -37],
        [26, -75],
        [33, -38],
        [16, -31],
        [5, -14],
        [1, -21],
        [-11, -6],
        [-14, 0],
        [-33, 6],
        [-62, 36],
        [-21, -1],
        [-24, -10],
        [-46, -3],
        [-42, -1],
        [-21, -13],
        [-22, -25],
        [-18, -18],
        [-27, -6],
        [-25, 0],
        [-20, 13],
        [-21, 1],
        [-20, -9],
        [-18, -10],
        [-18, -23],
        [-50, -1],
        [-19, -5],
        [-11, -5],
        [-16, -19],
        [-62, -29],
        [-40, -51],
        [-74, -37],
        [-71, -25],
        [-72, -27],
        [-32, -35],
        [-19, -47],
        [-58, -12],
        [-49, 4],
        [-71, 24],
        [-111, 31],
        [-58, 23],
        [-24, 19],
        [-13, 23],
        [-12, 9],
        [-16, 6],
        [-22, -5],
        [-33, -31],
        [-61, -42],
        [-57, -19],
        [-37, -20],
        [-74, -60],
        [-71, -6],
        [-29, 16],
        [-44, 5],
        [-33, -18],
        [-30, -12],
        [-47, 10],
        [-39, 13],
        [-85, -4],
        [-63, -26],
        [-30, -38],
        [-51, 9],
        [-25, -15],
        [-21, -12],
        [-14, 0],
        [-23, 12],
        [-17, 4],
        [-16, -8],
        [-15, -12],
        [-18, -11],
        [-17, -4],
        [-18, 4],
        [-7, 6],
        [-26, 4],
        [-33, -7],
        [-29, -14],
        [-30, -24],
        [-82, -88],
        [-40, -12],
        [-26, -2],
        [-24, -1],
        [-28, 11],
        [-8, 22],
        [-17, 18],
        [-20, 6],
        [-24, 0],
        [-16, -11],
        [-10, -17],
        [-24, -10],
        [-37, -10],
        [-20, -14],
        [-2, -29],
        [4, -58],
        [-1, -38],
        [-10, -20],
        [-12, -24],
        [-70, -45],
        [-86, -50],
        [-131, -53],
        [-140, -15],
        [-95, -28],
        [-14, -25],
        [-6, -27],
        [-10, -22],
        [-16, -11],
        [-20, -2],
        [-30, 1],
        [-29, -5],
        [-12, -9],
        [-31, -27],
        [-18, -15],
        [-26, -4],
        [-51, 4],
        [-25, -6],
        [-21, -12],
        [78, -536],
        [-2336, 752],
        [-922, 304],
        [-535, -506],
        [-1, -73],
        [-26, -74],
        [-43, -107],
        [14, -105],
        [20, -75],
        [8, -68],
        [15, -72],
        [-565, -1109],
        [212, -333],
        [3, -4],
        [5, -8],
        [4, -6],
        [4, -6],
        [40, -64],
        [-443, -297],
        [-4, -3],
        [-2159, -1442],
        [-866, -848],
        [640, -303],
        [8, -3],
        [8, -4],
        [109, -51],
        [5, -2],
        [855, -406],
        [228, -1090],
        [-526, -1236],
        [-1075, 660],
        [573, -2285],
        [-536, -654],
        [-11, -14],
        [-10, -59],
        [-8, -65],
        [-6, -34],
        [-2, -17],
        [-10, -62],
        [-7, -45],
        [-2, -12],
        [-2, -11],
        [-233, -1490],
        [-264, -118],
        [150, -396],
        [1381, -2257],
        [894, -1451],
        [-1092, -483],
        [-297, 83],
        [-868, -477],
        [-615, -208],
        [-108, -126],
        [-714, -850],
        [-422, -503],
        [-245, -98],
        [-3192, -1284],
        [-851, 2349],
        [-1109, -716],
        [-27, -18],
        [-2159, -1398],
        [-853, -1446],
        [-14, -25],
      ],
      [
        [60255, 313107],
        [-8, 23],
        [-42, 110],
        [147, 350],
        [256, 617],
        [-733, 304],
        [-14, 7],
        [-2, 15],
        [45, 45],
        [40, 60],
        [38, 37],
        [16, 32],
        [42, 48],
        [20, 48],
        [16, 34],
        [12, 80],
        [-48, 98],
        [-66, 120],
        [-89, 163],
        [-26, 151],
        [-38, 119],
        [19, 122],
        [25, 95],
        [82, 124],
        [101, 134],
        [115, 145],
        [-4, 20],
        [-143, 642],
        [-10, 42],
        [-65, 43],
        [-70, 49],
        [-37, 61],
        [-41, 62],
        [-47, 35],
        [-72, 17],
        [-68, 53],
        [-36, 62],
        [-15, 90],
        [22, 78],
        [-8, 34],
        [-18, 43],
        [-67, 34],
        [-59, 27],
        [-84, 55],
        [-12, 60],
        [-33, 34],
        [-65, 50],
        [-110, 62],
        [-108, 37],
        [-79, 22],
        [-97, 47],
        [-118, 132],
        [-6, 89],
        [14, 113],
        [20, 121],
        [-5, 111],
        [5, 94],
        [-6, 130],
        [14, 81],
        [36, 88],
        [31, 71],
        [14, 38],
        [33, 49],
        [65, 104],
        [35, 54],
        [25, 47],
        [17, 82],
        [6, 63],
        [-42, 82],
        [-65, 101],
        [-88, 75],
        [-71, 80],
        [-24, 81],
        [-6, 82],
        [22, 47],
        [35, 116],
        [11, 80],
        [6, 111],
        [-13, 76],
        [-8, 57],
        [8, 48],
        [24, 38],
        [50, 56],
        [-2, 37],
        [-7, 14],
        [-7, 12],
        [5, 10],
        [1, 20],
        [-18, 27],
        [-12, 25],
        [4, 27],
        [14, 22],
        [51, 50],
        [25, 69],
        [18, 69],
        [32, 47],
        [39, 32],
        [30, 44],
        [0, 33],
        [4, 26],
        [14, 26],
        [18, 27],
        [15, 19],
        [6, 12],
        [1, 18],
        [-1, 6],
        [-1, 11],
        [3, 9],
        [2, 16],
        [4, 14],
        [9, 24],
        [4, 24],
        [-6, 26],
        [-15, 25],
        [-10, 22],
        [4, 14],
        [5, 10],
        [1, 14],
        [-2, 13],
        [-6, 7],
        [-2, 7],
        [-3, 9],
        [-2, 11],
        [-1, 8],
        [1, 9],
        [5, 9],
        [-2, 12],
        [4, 6],
        [-6, 11],
        [2, 10],
        [2, 7],
        [0, 9],
        [0, 12],
        [-2, 11],
        [6, 11],
        [6, 8],
        [7, 8],
        [6, 4],
        [10, 0],
        [8, -2],
        [4, 4],
        [2, 8],
        [-2, 4],
        [4, 10],
        [4, 4],
        [4, 6],
        [0, 2],
        [5, 6],
        [8, 8],
        [10, 8],
        [13, 2],
        [88, -13],
        [36, -6],
        [19, -1],
        [16, 4],
        [13, 4],
        [12, 12],
        [14, 10],
        [14, 5],
        [14, -2],
        [12, -5],
        [14, -2],
        [11, -2],
        [10, -4],
        [14, -1],
        [20, 3],
        [24, -7],
        [19, -9],
        [15, -5],
        [23, 2],
        [37, 15],
        [23, 15],
        [18, 13],
        [14, 15],
        [13, 20],
        [17, 16],
        [3, 8],
        [3, 16],
        [7, 12],
        [13, 8],
        [4, 15],
        [7, 28],
        [42, 99],
        [26, 98],
        [26, 33],
        [8, 39],
        [0, 57],
        [-3, 93],
        [-9, 90],
        [-12, 69],
        [-32, 71],
        [-67, 58],
        [-78, 43],
        [-85, 50],
        [-39, 23],
        [-27, 34],
        [-12, 36],
        [-18, 70],
        [-9, 35],
        [9, 15],
        [0, 20],
        [-16, 17],
        [-31, 20],
        [-15, 14],
        [-16, 23],
        [-9, 29],
        [11, 39],
        [10, 60],
        [49, 101],
        [78, 68],
        [68, 51],
        [47, 42],
        [27, 43],
        [35, 76],
        [34, 111],
        [44, 79],
        [-14, 77],
        [2, 17],
        [4, 12],
        [6, 18],
        [6, 23],
        [2, 20],
        [30, 9],
        [174, 49],
        [89, 25],
        [257, 72],
        [8, 25],
        [7, 20],
        [15, 18],
        [7, 16],
        [6, 12],
        [13, 4],
        [12, 14],
        [0, 10],
        [6, 18],
        [7, 14],
        [-2, 25],
        [-5, 14],
        [-10, 13],
        [-4, 15],
        [0, 22],
        [4, 17],
        [4, 14],
        [13, 17],
        [18, 6],
        [7, 15],
        [-3, 17],
        [-5, 24],
        [2, 23],
        [2, 20],
        [10, 22],
        [11, 17],
        [4, 11],
        [-2, 12],
        [6, 23],
        [11, 14],
        [18, 14],
        [10, 8],
        [5, 14],
        [-5, 6],
        [-2, 8],
        [2, 7],
        [3, 12],
        [4, 12],
        [-3, 9],
        [-6, 8],
        [-10, 2],
        [-12, 1],
        [-13, 8],
        [-4, 8],
        [-2, 10],
        [-2, 12],
        [0, 14],
        [9, 14],
        [12, 16],
        [6, 9],
        [3, 7],
        [3, 8],
        [2, 9],
        [15, 12],
        [15, 12],
        [12, 11],
        [4, 14],
        [-2, 15],
        [-12, 12],
        [0, 14],
        [2, 11],
        [0, 14],
        [-6, 12],
        [-16, 6],
        [-14, 10],
        [-12, 17],
        [-11, 18],
        [-7, 8],
        [-7, 16],
        [-8, 10],
        [-16, 14],
        [-57, 52],
        [-63, 78],
        [-16, 27],
        [-10, 20],
        [-12, 23],
        [-11, 13],
        [-6, 13],
        [0, 16],
        [4, 11],
        [2, 12],
        [4, 14],
        [0, 16],
        [-8, 14],
        [-8, 18],
        [-2, 15],
        [-4, 10],
        [1, 17],
        [6, 25],
        [30, 41],
        [12, 29],
        [22, 34],
        [33, 34],
        [54, 34],
        [80, 28],
        [21, 4],
        [25, 0],
        [34, -8],
        [43, -10],
        [37, -12],
        [45, -18],
        [38, -16],
        [24, -27],
        [13, -33],
        [18, -19],
        [22, -49],
        [7, -24],
        [-6, -21],
        [-17, -19],
        [3, -9],
        [11, -4],
        [19, -6],
        [24, 2],
        [20, -4],
        [17, -4],
        [26, -6],
        [39, -4],
        [36, -1],
        [27, 2],
        [30, 15],
        [26, 11],
        [22, 6],
        [25, 0],
        [31, -4],
        [24, -7],
        [18, -8],
        [20, -4],
        [19, -5],
        [25, -14],
        [23, -13],
        [23, -11],
        [24, -17],
        [23, -5],
        [26, 5],
        [34, 17],
        [38, 15],
        [35, 13],
        [16, 18],
        [11, 20],
        [59, 79],
        [30, 63],
        [38, 80],
        [2, 70],
        [-35, 71],
        [-9, 62],
        [-8, 155],
        [16, 77],
        [35, 70],
        [57, 50],
        [28, 45],
        [-5, 59],
        [7, 32],
        [13, 31],
        [8, 12],
        [20, 13],
        [19, 13],
        [21, 16],
        [58, 101],
        [38, 83],
        [-12, 44],
        [-23, 4],
        [-38, 12],
        [-44, 36],
        [-37, 60],
        [33, 12],
        [31, 10],
        [451, 125],
        [617, -559],
        [34, 24],
        [13, 8],
        [26, 5],
        [18, -11],
        [28, -41],
        [23, -15],
        [30, -4],
        [48, 8],
        [42, 19],
        [35, 20],
        [33, 23],
        [23, 22],
        [49, 20],
        [49, 7],
        [31, -7],
        [48, 11],
        [26, 19],
        [36, 12],
        [34, 11],
        [41, 2],
        [30, -9],
        [7, -8],
        [1, -11],
        [-3, -15],
        [3, -15],
        [-6, -36],
        [-9, -29],
        [10, -25],
        [22, -21],
        [23, -6],
        [10, -10],
        [10, -10],
        [13, -2],
        [8, 3],
        [12, 4],
        [13, 2],
        [15, 0],
        [24, -5],
        [52, -32],
        [31, -22],
        [25, -18],
        [15, -26],
        [24, -44],
        [26, -51],
        [51, -38],
        [40, -24],
        [45, -11],
        [73, -23],
        [20, 4],
        [25, 0],
        [16, 3],
        [6, 13],
        [5, 10],
        [2, 12],
        [6, 16],
        [6, 12],
        [4, 10],
        [12, 6],
        [20, 6],
        [13, 13],
        [20, 8],
        [21, 4],
        [52, -4],
        [65, -17],
        [30, -4],
        [27, 10],
        [30, 17],
        [32, 38],
        [20, 30],
        [5, 24],
        [8, 38],
        [7, 15],
        [10, 8],
        [14, 6],
        [32, 11],
        [48, 11],
        [35, 11],
        [36, 5],
        [62, -40],
        [41, -19],
        [14, -4],
        [9, -2],
        [13, -2],
        [9, 2],
        [13, 2],
        [11, 12],
        [-8, 34],
        [-11, 39],
        [-12, 35],
        [51, 32],
        [55, 12],
        [41, 16],
        [32, 3],
        [12, -2],
        [6, 2],
        [6, 4],
        [6, 11],
        [13, 16],
        [24, 21],
        [47, 30],
        [41, 45],
        [32, 31],
        [7, 33],
        [0, 32],
        [-4, 42],
        [-17, 37],
        [-12, 39],
        [-2, 36],
        [25, 36],
        [34, 36],
        [24, 48],
        [34, 41],
        [30, 34],
        [14, 9],
        [7, 21],
        [-2, 30],
        [-27, 28],
        [-18, 30],
        [-12, 34],
        [2, 24],
        [-8, 49],
        [-22, 35],
        [-14, 47],
        [9, 72],
        [23, 45],
        [30, 39],
        [17, 43],
        [26, 36],
        [25, 10],
        [33, 3],
        [21, -6],
        [13, -15],
        [10, -8],
        [10, -6],
        [6, -4],
        [16, -10],
        [13, -4],
        [53, -9],
        [31, 9],
        [35, 16],
        [29, 14],
        [28, 29],
        [17, 26],
        [-2, 40],
        [-9, 21],
        [-12, 20],
        [-4, 12],
        [-19, 26],
        [-26, 28],
        [-30, 24],
        [-12, 19],
        [-4, 21],
        [26, 33],
        [67, 66],
        [25, 44],
        [6, 12],
        [10, 8],
        [10, 0],
        [16, 2],
        [18, -2],
        [26, 0],
        [23, -2],
        [38, 4],
        [32, 17],
        [26, 19],
        [22, 36],
        [7, 29],
        [-7, 22],
        [-18, 22],
        [-2, 26],
        [2, 30],
        [4, 18],
        [2, 9],
        [6, 8],
        [9, 5],
        [21, 8],
        [20, 10],
        [25, 14],
        [18, 26],
        [2, 15],
        [6, 19],
        [4, 10],
        [7, 5],
        [8, 2],
        [9, 0],
        [11, -2],
        [13, -12],
        [20, -20],
        [18, -25],
        [13, -16],
        [26, -12],
        [31, -6],
        [37, 0],
        [15, 9],
        [10, 20],
        [6, 19],
        [0, 38],
        [0, 26],
        [4, 14],
        [6, 6],
        [18, 4],
        [18, -10],
        [15, -10],
        [19, -9],
        [10, -2],
        [7, 3],
        [6, 8],
        [8, 20],
        [-4, 16],
        [-1, 25],
        [13, 38],
        [6, 15],
        [7, 13],
        [15, 12],
        [16, 4],
        [20, 0],
        [14, -9],
        [18, -20],
        [11, -15],
        [10, -19],
        [7, -17],
        [9, -20],
        [11, -19],
        [14, -20],
        [13, -21],
        [19, -7],
        [20, 5],
        [26, 9],
        [11, 8],
        [44, 40],
        [50, 49],
        [39, 70],
        [11, 24],
        [-2, 22],
        [-19, 96],
        [-16, 109],
        [-14, 50],
        [2, 20],
        [7, 20],
        [9, 13],
        [6, 7],
        [6, 8],
        [9, 9],
        [10, 6],
        [8, 4],
        [16, -6],
        [14, -12],
        [12, -15],
        [4, -19],
        [-2, -19],
        [3, -20],
        [0, -12],
        [8, -13],
        [16, -7],
        [19, 0],
        [20, 4],
        [16, 3],
        [12, 5],
        [18, 10],
        [11, 12],
        [4, 12],
        [-5, 25],
        [-14, 28],
        [-16, 19],
        [-12, 12],
        [-12, 8],
        [-26, 15],
        [-33, 12],
        [-43, 6],
        [-28, 4],
        [-41, 4],
        [-35, 4],
        [-10, 6],
        [-2, 10],
        [2, 14],
        [8, 8],
        [21, 6],
        [29, 2],
        [20, -6],
        [18, 0],
        [20, 6],
        [20, 7],
        [25, 9],
        [22, 8],
        [11, 2],
        [26, 6],
        [19, -8],
        [8, -9],
        [11, -3],
        [13, 1],
        [7, 1],
        [9, 5],
        [4, 10],
        [2, 7],
        [0, 10],
        [-2, 8],
        [-5, 6],
        [-7, 7],
        [-5, 6],
        [-4, 4],
        [-15, 18],
        [-21, 20],
        [-14, 16],
        [-6, 13],
        [-4, 11],
        [6, 7],
        [23, 5],
        [29, 2],
        [23, 10],
        [24, 21],
        [-6, 24],
        [-2, 10],
        [-12, 15],
        [0, 10],
        [8, 12],
        [22, 17],
        [21, 22],
        [11, 12],
        [3, 21],
        [-2, 14],
        [-13, 16],
        [-21, 20],
        [-23, 6],
        [-17, 18],
        [-6, 25],
        [8, 27],
        [11, 19],
        [12, 9],
        [16, -1],
        [13, -4],
        [12, -5],
        [4, -6],
        [2, -9],
        [0, -15],
        [1, -14],
        [1, -10],
        [5, -16],
        [6, -8],
        [12, -2],
        [8, 0],
        [12, 0],
        [10, 0],
        [8, 4],
        [97, 93],
        [20, 38],
        [16, 15],
        [34, 27],
        [68, 72],
        [25, 29],
        [47, 33],
        [22, 23],
        [13, 27],
        [3, 29],
        [2, 34],
        [4, 26],
        [8, 17],
        [7, 7],
        [14, 6],
        [18, 8],
        [31, 2],
        [19, 7],
        [10, 14],
        [9, 35],
        [-15, 62],
        [-3, 25],
        [0, 23],
        [4, 19],
        [9, 8],
        [8, 2],
        [11, -2],
        [11, -7],
        [10, -8],
        [14, -13],
        [10, -14],
        [7, -13],
        [13, -15],
        [11, -9],
        [17, 5],
        [1, 12],
        [-2, 18],
        [4, 11],
        [9, 9],
        [13, 2],
        [26, 0],
        [30, -5],
        [37, -6],
        [19, 6],
        [25, -4],
        [22, -6],
        [12, -8],
        [38, -31],
        [22, -34],
        [14, -17],
        [14, -8],
        [19, -4],
        [13, 8],
        [4, 10],
        [-2, 18],
        [-8, 16],
        [-11, 13],
        [-11, 12],
        [-7, 9],
        [-8, 10],
        [-2, 8],
        [-3, 9],
        [-1, 8],
        [1, 10],
        [8, 10],
        [15, 8],
        [21, -3],
        [14, -4],
        [25, -1],
        [6, 3],
        [4, 3],
        [2, 9],
        [0, 12],
        [0, 22],
        [6, 23],
        [6, 26],
        [9, 22],
        [10, 12],
        [21, 18],
        [26, 10],
        [27, 5],
        [14, -5],
        [11, -14],
        [15, -14],
        [8, -18],
        [17, -3],
        [15, -8],
        [12, 8],
        [20, 13],
        [19, 10],
        [12, 14],
        [11, 21],
        [4, 12],
        [0, 13],
        [-3, 15],
        [-4, 16],
        [-9, 14],
        [-7, 5],
        [-22, 5],
        [-23, 0],
        [-16, 2],
        [-19, -2],
        [-17, 0],
        [-17, 2],
        [-11, 4],
        [-8, 8],
        [-2, 8],
        [-2, 8],
        [0, 10],
        [4, 10],
        [6, 8],
        [5, 8],
        [17, 12],
        [6, 14],
        [-2, 23],
        [2, 12],
        [2, 7],
        [2, 39],
        [5, 29],
        [16, 20],
        [19, 16],
        [12, 7],
        [10, 3],
        [13, 3],
        [12, -1],
        [15, -2],
        [21, -4],
        [13, -4],
        [11, -3],
        [24, -4],
        [22, 2],
        [10, 13],
        [4, 10],
        [6, 15],
        [12, 24],
        [12, 23],
        [2, 13],
        [-8, 6],
        [-6, 4],
        [-15, 0],
        [-13, -4],
        [-19, -4],
        [-15, -17],
        [-10, 17],
        [-4, 11],
        [0, 10],
        [0, 13],
        [4, 16],
        [-2, 11],
        [-4, 17],
        [-11, 26],
        [-10, 28],
        [-24, 28],
        [-20, 19],
        [-13, 13],
        [-35, 39],
        [-7, 18],
        [2, 12],
        [5, 14],
        [10, 14],
        [14, 10],
        [21, 19],
        [15, 18],
        [11, 18],
        [13, 38],
        [25, 63],
        [6, 17],
        [6, 19],
        [-4, 21],
        [-8, 18],
        [-6, 10],
        [-6, 22],
        [-11, 14],
        [-19, 8],
        [-28, 6],
        [-19, 11],
        [-8, 15],
        [-4, 18],
        [6, 20],
        [10, 22],
        [6, 33],
        [2, 65],
        [-2, 10],
        [-14, 11],
        [-10, 5],
        [-17, 12],
        [-10, 15],
        [-8, 15],
        [4, 50],
        [4, 59],
        [1, 71],
        [1, 70],
        [-8, 38],
        [-18, 22],
        [-25, 14],
        [-43, 18],
        [-64, 26],
        [-51, 24],
        [-7, 15],
        [-4, 15],
        [3, 28],
        [-1, 31],
        [-10, 24],
        [-15, 7],
        [-24, 8],
        [-20, 19],
        [2, 24],
        [-2, 22],
        [-2, 23],
        [-8, 57],
        [-38, 62],
        [-15, 45],
        [0, 41],
        [2, 115],
        [-14, 21],
        [-18, 28],
        [-18, 70],
        [8, 34],
        [-4, 7],
        [-8, 1],
        [-32, 1],
        [-14, 11],
        [-20, 48],
        [-32, 67],
        [-30, 36],
        [-51, 70],
        [-79, 47],
        [-49, 60],
        [-43, 64],
        [3, 49],
        [-23, 26],
        [-20, 12],
        [-39, 12],
        [-71, 36],
        [-35, 29],
        [-10, 26],
        [-9, 66],
        [-30, 30],
        [-12, 30],
        [-24, 21],
        [-12, 30],
        [-14, 20],
        [-27, 42],
        [-55, 62],
        [-41, 55],
        [-5, 62],
        [-23, 96],
        [-20, 57],
        [-6, 25],
        [8, 38],
        [20, 49],
        [8, 29],
        [16, 46],
        [9, 78],
        [5, 71],
        [-1, 41],
        [31, 30],
        [12, 99],
        [0, 65],
        [8, 15],
        [16, 5],
        [50, -9],
        [33, 15],
        [26, 10],
        [17, 18],
        [12, 21],
        [29, 44],
        [26, 33],
        [5, 65],
        [17, 58],
        [12, 91],
        [3, 75],
        [13, 107],
        [-1, 34],
        [7, 32],
        [31, 59],
        [19, 19],
        [33, 15],
        [11, 18],
        [8, 14],
        [25, 14],
        [30, 12],
        [20, 14],
        [-8, 38],
        [-10, 29],
        [-17, 50],
        [-70, 66],
        [-53, 67],
        [-66, 68],
        [-25, 107],
        [-39, 92],
        [2, 101],
        [29, 96],
        [4, 3],
        [105, 61],
        [4, 0],
        [132, 32],
        [71, 59],
        [7, 82],
        [-62, 38],
        [-65, 55],
        [-81, 73],
        [-16, 38],
        [-44, 51],
        [-14, 32],
        [-50, 61],
        [-14, 84],
        [-23, 55],
        [-22, 25],
        [-26, 20],
        [-25, 14],
        [-14, 4],
        [-21, 6],
        [-21, 17],
        [-18, -1],
        [-18, -5],
        [-16, 1],
        [-22, 8],
        [-14, 7],
        [-14, 38],
        [-8, 44],
        [-8, 20],
        [-6, 23],
        [0, 20],
        [12, 19],
        [12, 39],
        [4, 27],
        [12, 62],
        [-5, 56],
        [-15, 13],
        [-4, 19],
        [6, 6],
        [10, 15],
        [4, 17],
        [0, 17],
        [-10, 8],
        [-18, 0],
        [-10, 9],
        [-4, 21],
        [4, 13],
        [8, 22],
        [16, 63],
        [-28, 69],
        [-9, 33],
        [-48, 73],
        [-18, 40],
        [-31, 42],
        [-40, 16],
        [-11, 37],
        [-14, 4],
        [-12, 7],
        [0, 13],
        [-2, 29],
        [-2, 21],
        [-10, 24],
        [6, 41],
        [20, 26],
        [12, 26],
        [2, 19],
        [5, 20],
        [7, 26],
        [-2, 30],
        [4, 22],
        [3, 17],
        [-5, 20],
        [-4, 16],
        [-5, 20],
        [-9, 24],
        [0, 12],
        [3, 14],
        [9, 26],
        [7, 40],
        [10, 37],
        [12, 20],
        [23, 11],
        [10, 11],
        [8, 25],
        [-6, 17],
        [12, 25],
        [11, 24],
        [28, 25],
        [0, 14],
        [2, 14],
        [3, 8],
        [10, 8],
        [6, 2],
        [2, 6],
        [-2, 18],
        [-2, 12],
        [5, 12],
        [9, 12],
        [-5, 12],
        [-1, 8],
        [4, 2],
        [15, 6],
        [14, 8],
        [15, 10],
        [17, 6],
        [9, 8],
        [4, 9],
        [6, 12],
        [4, 13],
        [-7, 17],
        [-3, 11],
        [-2, 9],
        [-3, 10],
        [-5, 11],
        [-7, 11],
        [-7, 6],
        [-9, 10],
        [-10, 11],
        [-10, 12],
        [-27, 21],
        [-26, 25],
        [-28, 26],
        [-20, 10],
        [-12, 7],
        [-2, 7],
        [2, 9],
        [6, 6],
        [10, 4],
        [10, 4],
        [8, 6],
        [2, 12],
        [1, 6],
        [0, 6],
        [-3, 8],
        [-6, 9],
        [-2, 6],
        [-2, 6],
        [-4, 5],
        [-2, 4],
        [-2, 4],
        [-4, 2],
        [-2, 5],
        [-2, 5],
        [-8, 5],
        [-4, 4],
        [-7, 0],
        [-8, -4],
        [-8, -5],
        [-5, -2],
        [-7, -1],
        [-5, 0],
        [-5, 0],
        [-5, 0],
        [-4, 2],
        [-4, 6],
        [-5, 12],
        [2, 10],
        [2, 4],
        [1, 4],
        [5, 12],
        [2, 10],
        [5, 8],
        [4, 8],
        [1, 6],
        [-1, 4],
        [-10, 4],
        [-8, 4],
        [-4, 4],
        [-4, 4],
        [0, 4],
        [0, 4],
        [0, 4],
        [2, 3],
        [4, 4],
        [10, 6],
        [9, 8],
        [5, 9],
        [5, 7],
        [0, 6],
        [-208, -59],
        [-411, -121],
        [-863, -983],
        [-550, 266],
        [-16, -18],
        [-52, -33],
        [-73, -12],
        [-54, -10],
        [-77, -11],
        [-85, -14],
        [-77, -17],
        [-58, -43],
        [-70, -34],
        [-33, -24],
        [-45, 12],
        [-32, 26],
        [-39, 4],
        [-28, 0],
        [-12, 74],
        [0, 2],
        [-2, 6],
        [-14, 63],
        [-9, 55],
        [-25, 66],
        [-22, 82],
        [-22, 84],
        [-26, 39],
        [-7, 47],
        [13, 76],
        [-535, 258],
        [-1054, 696],
        [-716, 527],
        [0, 28],
        [-5, 23],
        [-38, 31],
        [-21, 31],
        [6, 34],
        [12, 16],
        [27, 14],
        [-2, 20],
        [-8, 21],
        [-10, 32],
        [39, 68],
        [-4, 18],
        [-70, 43],
        [-4, 29],
        [-12, 26],
        [-62, 43],
        [-49, 41],
        [-23, 26],
        [-11, 27],
        [-6, 46],
        [-4, 40],
        [-2, 31],
        [-22, 49],
        [-20, 80],
        [-21, 71],
        [-22, 89],
        [12, 117],
        [18, 63],
        [33, 73],
        [47, 49],
        [39, 55],
        [49, 28],
        [15, 32],
        [31, 26],
        [4, 27],
        [12, 29],
        [9, 10],
        [10, 0],
        [11, 5],
        [12, 21],
        [3, 13],
        [-11, 17],
        [-2, 16],
        [5, 13],
        [16, 2],
        [19, -2],
        [10, 7],
        [2, 16],
        [-16, 2],
        [-19, 2],
        [-21, -2],
        [-8, 6],
        [-7, 18],
        [3, 26],
        [-9, 25],
        [-5, 28],
        [0, 20],
        [14, 33],
        [6, 20],
        [-8, 6],
        [-18, 2],
        [-20, -4],
        [-11, 2],
        [-11, 4],
        [-7, 8],
        [-3, 10],
        [-9, 4],
        [-9, 1],
        [-16, 1],
        [-4, 2],
        [-4, 5],
        [3, 20],
        [3, 28],
        [-3, 28],
        [-5, 10],
        [-13, 16],
        [-17, 6],
        [-13, 2],
        [-13, -5],
        [-10, -9],
        [-15, -2],
        [-14, 7],
        [-14, 16],
        [-6, 13],
        [0, 17],
        [6, 9],
        [8, 7],
        [-4, 11],
        [-18, 10],
        [-9, 5],
        [-4, 1],
        [2, 6],
        [4, 8],
        [19, 32],
        [0, 2],
        [-4, 2],
        [-40, 11],
        [-34, 5],
        [-23, 5],
        [-14, 0],
        [-3, -2],
        [-1, -7],
        [8, -16],
        [8, -22],
        [-4, -10],
        [-10, -3],
        [-10, 1],
        [-17, 6],
        [-22, 12],
        [-21, 2],
        [-22, -2],
        [-6, 10],
        [-1, 12],
        [5, 11],
        [18, 18],
        [6, 8],
        [4, 8],
        [-2, 4],
        [-8, 3],
        [-16, 10],
        [-17, 8],
        [-4, 2],
        [-8, -5],
        [2, -10],
        [-10, -4],
        [-4, 1],
        [-6, 8],
        [-13, 8],
        [-13, -7],
        [-12, -15],
        [2, -16],
        [16, -11],
        [2, -13],
        [-8, -10],
        [-24, -4],
        [-13, 2],
        [-8, -6],
        [-12, -20],
        [-4, -11],
        [-4, -11],
        [-8, -3],
        [-20, -1],
        [-18, 1],
        [-14, -1],
        [-8, -1],
        [-14, -4],
        [-12, -2],
        [-10, 1],
        [-4, 1],
        [-2, 1],
        [-4, 0],
        [-2, 0],
        [-3, 3],
        [-4, 2],
        [-2, 4],
        [-1, 10],
        [6, 11],
        [9, 14],
        [8, 14],
        [1, 6],
        [-4, 6],
        [-14, 2],
        [-12, -6],
        [-5, -6],
        [-9, 0],
        [-19, 11],
        [-8, 14],
        [4, 10],
        [10, 3],
        [21, -3],
        [22, 12],
        [20, 18],
        [2, 9],
        [-14, 9],
        [-7, 11],
        [1, 22],
        [-2, 14],
        [-4, 11],
        [-15, 10],
        [-19, 18],
        [-27, 14],
        [-16, -1],
        [-22, -6],
        [-24, 0],
        [-26, -1],
        [-20, 0],
        [-18, 3],
        [-12, 11],
        [-10, 13],
        [-7, 14],
        [-4, 18],
        [2, 18],
        [13, 35],
        [1, 6],
        [0, 8],
        [-8, 4],
        [-11, 7],
        [0, 26],
        [-7, 19],
        [-7, 15],
        [-5, 13],
        [6, 5],
        [8, 2],
        [13, -5],
        [11, 4],
        [13, 16],
        [18, 20],
        [4, 19],
        [-8, 21],
        [-8, 13],
        [-13, 18],
        [-23, 14],
        [-13, 4],
        [-18, 2],
        [-20, 6],
        [-4, 4],
        [0, 6],
        [12, 14],
        [4, 14],
        [-10, 12],
        [-8, 14],
        [-2, 15],
        [16, 27],
        [4, 17],
        [-4, 22],
        [-13, 30],
        [-12, 26],
        [-18, 23],
        [-2, 27],
        [-24, 11],
        [-21, 16],
        [-2, 8],
        [4, 9],
        [28, 50],
        [2, 25],
        [-4, 18],
        [-12, 16],
        [-6, 11],
        [6, 14],
        [13, 12],
        [3, 8],
        [-5, 8],
        [-23, 8],
        [-23, 12],
        [-5, 11],
        [-1, 13],
        [13, 15],
        [25, 23],
        [0, 13],
        [-7, 15],
        [-6, 8],
        [-30, 33],
        [-48, -2],
        [-24, -2],
        [-15, 10],
        [-19, 4],
        [-12, 4],
        [-13, 10],
        [-39, 25],
        [-13, 6],
        [-6, 9],
        [-18, 15],
        [-23, 10],
        [-14, -9],
        [-35, 0],
        [20, 41],
        [-6, 16],
        [-6, 8],
        [-12, 3],
        [-6, 6],
        [3, 15],
        [16, 8],
        [0, 9],
        [-8, 8],
        [4, 5],
        [17, 14],
        [13, 9],
        [5, 41],
        [11, 12],
        [-7, 26],
        [-2, 46],
        [15, 12],
        [34, 9],
        [20, 11],
        [2, 25],
        [2, 22],
        [23, 18],
        [14, 6],
        [0, 8],
        [-8, 10],
        [-8, 14],
        [0, 8],
        [31, 5],
        [26, 14],
        [37, 28],
        [23, 77],
        [-20, 36],
        [3, 11],
        [13, 9],
        [8, 12],
        [0, 12],
        [-19, 30],
        [-5, 6],
        [3, 5],
        [8, 8],
        [13, 16],
        [-25, 28],
        [-4, 24],
        [8, 22],
        [16, 22],
        [-23, 55],
        [-30, 38],
        [2, 17],
        [6, 23],
        [6, 24],
        [14, 20],
        [1, 21],
        [8, 24],
        [2, 27],
        [-4, 28],
        [-12, 41],
        [-3, 37],
        [-32, 18],
        [-30, 32],
        [-14, 43],
        [-17, 36],
        [9, 32],
        [13, 28],
        [21, 30],
        [-10, 16],
        [-8, 26],
        [4, 22],
        [12, 13],
        [20, 5],
        [-10, 40],
        [-12, 35],
        [2, 7],
        [14, 30],
        [14, 17],
        [29, 37],
        [0, 29],
        [-8, 22],
        [-18, 25],
        [5, 19],
        [-3, 15],
        [-9, 18],
        [-1, 54],
        [3, 20],
        [0, 4],
        [-4, 2],
        [-4, -2],
        [-8, 0],
        [-6, 4],
        [-6, 10],
        [-11, 18],
        [-13, 43],
        [-14, 28],
        [-24, 14],
        [-31, 22],
        [-19, 10],
        [-10, 16],
        [-12, 26],
        [-43, 28],
        [-26, 31],
        [-4, 16],
        [-31, 49],
        [-12, 28],
        [0, 26],
        [-16, 30],
        [-28, 16],
        [-10, 16],
        [-1, 29],
        [-8, 16],
        [-11, 7],
        [-5, 18],
        [-6, 33],
        [-12, 77],
        [-7, 90],
        [6, 68],
        [27, 70],
        [87, 20],
        [37, 48],
        [-34, 70],
        [-49, 49],
        [-22, 23],
        [-16, 1],
        [-26, -18],
        [-28, -30],
        [-43, -41],
        [-47, -38],
        [-23, -8],
        [-58, 19],
        [-18, 8],
        [-45, 42],
        [-32, 62],
        [-6, 89],
        [30, 73],
        [28, 62],
        [68, 90],
        [132, 92],
        [98, 73],
        [142, 83],
        [135, 37],
        [54, 47],
        [16, 21],
        [13, 30],
        [-2, 24],
        [-21, 43],
        [-74, 57],
        [-18, 58],
        [-5, 73],
        [21, 99],
        [37, 80],
        [43, 43],
        [57, 56],
        [52, 49],
        [54, 20],
        [41, 33],
        [35, 31],
        [31, 33],
        [28, 41],
        [34, 31],
        [12, 47],
        [19, 27],
        [21, 39],
        [25, 42],
        [24, 62],
        [14, 43],
        [3, 52],
        [2, 63],
        [3, 58],
        [6, 15],
        [8, 28],
        [10, 13],
        [24, 34],
        [38, 44],
        [21, 28],
        [23, 28],
        [14, 26],
        [18, 28],
        [6, 52],
        [7, 35],
        [-20, 60],
        [-9, 40],
        [-18, 46],
        [-14, 46],
        [-29, 40],
        [-19, 38],
        [-28, 47],
        [-14, 24],
        [-21, 36],
        [-29, 34],
        [-29, 32],
        [-28, 25],
        [-29, 30],
        [-19, 18],
        [-16, 26],
        [-6, 20],
        [11, 36],
        [-3, 38],
        [-4, 38],
        [-2, 25],
        [4, 30],
        [17, 27],
        [17, 21],
        [26, 19],
        [46, 22],
        [29, 10],
        [48, -6],
        [29, -28],
        [17, -23],
        [21, -18],
        [21, -17],
        [28, -7],
        [33, 0],
        [28, 1],
        [31, 0],
        [24, -2],
        [32, -3],
        [29, 2],
        [29, 5],
        [23, 8],
        [33, 3],
        [11, 2],
        [16, 9],
        [20, 23],
        [6, 31],
        [8, 32],
        [17, 29],
        [7, 18],
        [13, 29],
        [0, 32],
        [-2, 29],
        [-5, 32],
        [1, 25],
        [2, 27],
        [-9, 40],
        [9, 28],
        [9, 26],
        [13, 24],
        [13, 12],
        [20, 19],
        [38, 34],
        [32, 20],
        [39, 2],
        [26, 16],
        [44, -16],
        [25, -12],
        [39, -4],
        [43, -4],
        [25, 14],
        [12, 18],
        [22, 24],
        [11, 20],
        [25, 26],
        [21, 24],
        [30, 29],
        [38, 30],
        [31, 29],
        [27, 18],
        [22, 30],
        [8, 20],
        [1, 27],
        [-1, 45],
        [6, 49],
        [10, 64],
        [100, -28],
        [339, -101],
        [122, -37],
        [52, -14],
        [3703, -1568],
        [422, 476],
        [853, 964],
        [552, 622],
        [3151, 3554],
        [327, 795],
        [2, 10],
        [36, 85],
        [1, 4],
        [2, 5],
        [1, 4],
        [15, 35],
        [1, 2],
        [2, 6],
        [19, 44],
        [7, 18],
        [6, 14],
        [18, 45],
        [989, 2418],
        [5382, -3984],
        [3730, -2684],
        [-631, 2000],
        [-968, 1314],
        [-3, 2],
        [-1912, 2596],
        [5067, 2673],
      ],
      [
        [159707, 324772],
        [-1169, -319],
        [7, -100],
        [0, -53],
        [-8, -54],
        [12, -47],
        [48, -51],
        [52, -18],
        [65, 13],
        [38, 36],
        [69, 18],
        [42, 16],
        [51, -10],
        [24, -36],
        [15, -26],
        [30, -20],
        [46, -18],
        [25, -41],
        [27, -34],
        [55, -22],
        [58, 10],
        [40, 0],
        [33, -4],
        [27, -22],
        [43, -13],
        [70, 11],
        [45, 24],
        [44, 6],
        [48, -6],
        [53, -12],
        [73, -10],
        [24, 1],
        [39, 13],
        [45, 38],
        [40, 8],
        [38, -10],
        [70, -41],
        [36, -18],
        [65, -49],
        [59, -43],
        [54, -38],
        [56, -2],
        [32, -17],
        [25, -18],
        [6, -16],
        [-25, -27],
        [-13, -32],
        [-1, -44],
        [-8, -34],
        [0, -39],
        [8, -48],
        [0, -33],
        [-33, -53],
        [-37, -45],
        [-71, -76],
        [-38, -85],
        [-8, -97],
        [-4, -81],
        [-7, -64],
        [5, -43],
        [18, -67],
        [31, -66],
        [24, -79],
        [11, -34],
        [29, -40],
        [9, -24],
        [4, -19],
        [-5, -27],
        [-10, -30],
        [6, -20],
        [15, -30],
        [16, -18],
        [22, -13],
        [19, -14],
        [24, -31],
        [39, -36],
        [32, -20],
        [38, -19],
        [19, -11],
        [12, -13],
        [13, -11],
        [6, -10],
        [2, -5],
        [0, -7],
        [-2, -5],
        [-5, -2],
        [-6, -10],
        [-2, -14],
        [2, -21],
        [-4, -17],
        [-10, -13],
        [-23, -23],
        [-26, -15],
        [-19, -14],
        [-17, -6],
        [-20, -2],
        [-24, 2],
        [-33, 8],
        [-19, 15],
        [-10, -1],
        [-6, -5],
        [-12, -19],
        [-18, -22],
        [-24, -4],
        [-13, 4],
        [-14, 14],
        [-4, 14],
        [-13, 15],
        [-10, 12],
        [-9, 17],
        [-11, 12],
        [-18, 15],
        [-8, 13],
        [-8, 17],
        [-2, 16],
        [4, 15],
        [-3, 10],
        [-13, 2],
        [-19, -9],
        [-23, -6],
        [-19, -6],
        [-19, -14],
        [-30, -75],
        [-121, -148],
        [-92, -137],
        [-45, -100],
        [-27, -53],
        [-27, -41],
        [-249, -163],
        [-286, -152],
        [-212, -72],
        [-40, -30],
        [-34, -58],
        [-14, -111],
        [10, -90],
        [-7, -102],
        [-3, -126],
        [-6, -86],
        [-19, -92],
        [-23, -51],
        [-14, -44],
        [-26, -119],
        [-32, -83],
        [-35, -110],
        [-44, -109],
        [-15, -101],
        [-18, -82],
        [-15, -92],
        [-2, -101],
        [14, -91],
        [49, -93],
        [64, -99],
        [58, -62],
        [57, -51],
        [41, -97],
        [10, -73],
        [-20, -75],
        [2, -39],
        [14, -44],
        [2, -42],
        [-35, -43],
        [-7, -85],
        [-1, -41],
        [-12, -35],
        [-43, -16],
        [-26, -73],
        [-27, -12],
        [-50, -4],
        [-25, 8],
        [-37, -5],
        [-24, -90],
        [-34, -11],
        [-51, -45],
        [-40, -35],
        [-62, -29],
        [-88, -28],
        [-28, 12],
        [-28, 0],
        [-46, -34],
        [-52, -38],
        [-42, 3],
        [-35, -28],
        [20, -30],
        [26, -60],
        [-2, -36],
        [-6, -58],
        [-13, -35],
        [-53, 2],
        [-30, 46],
        [-35, 24],
        [-59, 29],
        [-61, -3],
        [-45, -40],
        [-34, -65],
        [-59, -59],
        [-36, -18],
        [-19, -7],
        [-18, 16],
        [-67, 61],
        [-16, 8],
        [-29, 4],
        [-28, 0],
        [-23, 2],
        [-30, 8],
        [-25, 14],
        [-20, 10],
        [-24, 3],
        [-18, 0],
        [-41, -10],
        [-51, -10],
        [-43, 5],
        [-31, 6],
        [-33, 18],
        [-33, 14],
        [-35, 18],
        [-27, 9],
        [-29, 5],
        [-34, 2],
        [-33, -11],
        [-41, -4],
        [-57, -5],
        [-41, -3],
        [-48, -14],
        [-48, -16],
        [-31, -13],
        [-27, -14],
        [-19, -19],
        [-23, -13],
        [-12, -11],
        [-14, -34],
        [-15, -23],
        [-8, -22],
        [-18, -19],
        [-12, -24],
        [-13, -10],
        [-24, 1],
        [-19, 9],
        [-24, 4],
        [-26, -2],
        [-24, 4],
        [-21, 2],
        [-8, -6],
        [-2, -12],
        [4, -37],
        [-2, -42],
        [-4, -14],
        [-10, -10],
        [-17, 0],
        [-12, -6],
        [-2, -6],
        [2, -10],
        [6, -30],
        [6, -10],
        [9, -8],
        [15, -5],
        [9, -1],
        [13, 1],
        [8, -6],
        [2, -7],
        [0, -30],
        [-4, -31],
        [6, -22],
        [18, -23],
        [20, -7],
        [10, -10],
        [10, -21],
        [12, -38],
        [-2, -27],
        [-8, -54],
        [-2, -36],
        [14, -51],
        [0, -24],
        [-14, -42],
        [4, -44],
        [0, -38],
        [-10, -38],
        [6, -32],
        [8, -27],
        [-4, -35],
        [-10, -14],
        [-28, -23],
        [-14, -22],
        [-12, -8],
        [-14, 0],
        [-25, 9],
        [-15, 2],
        [-20, -11],
        [-18, -14],
        [-23, -2],
        [-24, 5],
        [-25, 6],
        [-23, 17],
        [-17, 7],
        [-14, 1],
        [-13, -6],
        [-7, -14],
        [-9, -14],
        [0, -8],
        [5, -5],
        [17, -12],
        [4, -9],
        [-4, -24],
        [-3, -14],
        [-8, -10],
        [-25, -10],
        [-21, -6],
        [-9, -8],
        [-14, -26],
        [-19, -17],
        [0, -13],
        [8, -9],
        [39, 4],
        [30, 12],
        [33, 9],
        [60, 18],
        [32, 3],
        [21, 45],
        [47, -18],
        [29, -8],
        [79, 12],
        [32, -2],
        [22, -13],
        [26, -18],
        [67, -17],
        [48, -11],
        [33, -18],
        [8, -15],
        [20, -7],
        [24, 4],
        [19, 6],
        [29, 0],
        [38, -14],
        [23, 0],
        [27, 4],
        [46, -4],
        [48, 6],
        [46, 1],
        [22, 0],
        [28, -11],
        [22, -8],
        [26, -12],
        [52, -27],
        [54, 1],
        [63, -11],
        [63, -17],
        [64, -34],
        [56, -26],
        [62, -21],
        [51, -35],
        [88, -58],
        [74, -69],
        [22, -12],
        [30, 4],
        [20, 10],
        [14, 25],
        [10, 22],
        [8, 6],
        [11, 2],
        [12, 2],
        [9, -3],
        [7, -13],
        [1, -12],
        [-8, -23],
        [-8, -26],
        [-9, -102],
        [-2, -34],
        [4, -24],
        [29, -44],
        [63, -62],
        [35, -34],
        [39, -49],
        [29, -28],
        [9, -10],
        [10, -8],
        [8, 0],
        [13, 8],
        [11, 4],
        [11, 6],
        [12, 4],
        [12, -2],
        [8, -12],
        [8, -22],
        [9, -38],
        [17, -22],
        [20, -43],
        [6, -34],
        [-2, -22],
        [8, -8],
        [14, 2],
        [31, 2],
        [13, -6],
        [11, -12],
        [9, -19],
        [15, -16],
        [18, -24],
        [27, -21],
        [17, -32],
        [13, -14],
        [13, -14],
        [19, -14],
        [6, -19],
        [-16, -27],
        [-9, -26],
        [7, -24],
        [20, -8],
        [16, -11],
        [22, -24],
        [20, -13],
        [22, -14],
        [21, -11],
        [14, -4],
        [10, -6],
        [15, -8],
        [8, -8],
        [6, -12],
        [7, -12],
        [12, -12],
        [12, -12],
        [13, -10],
        [11, -10],
        [8, -16],
        [6, -19],
        [4, -21],
        [4, -23],
        [6, -16],
        [11, -14],
        [19, -18],
        [19, -20],
        [42, -37],
        [37, -28],
        [28, -15],
        [23, -4],
        [22, -10],
        [20, -10],
        [26, -5],
        [34, -23],
        [28, -24],
        [25, -25],
        [29, -29],
        [33, -21],
        [26, -8],
        [31, -6],
        [28, -12],
        [17, -26],
        [18, -25],
        [29, -26],
        [9, -33],
        [14, -35],
        [27, -28],
        [41, -15],
        [-35, -179],
        [-27, -140],
        [-20, -98],
        [12, -14],
        [18, -22],
        [15, -23],
        [14, -11],
        [14, -2],
        [15, 3],
        [12, -2],
        [11, -7],
        [7, -8],
        [5, -28],
        [0, -28],
        [-4, -27],
        [-2, -25],
        [10, -21],
        [18, -19],
        [27, -8],
        [33, -3],
        [22, 4],
        [-80, -288],
        [-30, -83],
        [-16, -69],
        [-22, -56],
        [-34, -67],
        [20, -84],
        [16, -65],
        [5, -86],
        [-17, -101],
        [-26, -44],
        [-24, -37],
        [-55, -55],
        [136, -92],
        [41, -20],
        [30, -22],
        [29, -35],
        [38, -37],
        [37, -57],
        [20, -23],
        [27, -32],
        [25, -29],
        [20, -18],
        [22, -12],
        [19, -6],
        [24, -8],
        [16, -10],
        [11, -9],
        [4, -11],
        [-2, -7],
        [-9, 0],
        [-27, 10],
        [-28, 6],
        [-27, 5],
        [-27, 0],
        [-31, -2],
        [-36, 1],
        [-94, -1],
        [-92, -5],
        [-27, -4],
        [-12, -5],
        [-6, -8],
        [-2, -12],
        [-2, -30],
        [-6, -12],
        [-3, -14],
        [-10, -8],
        [-14, -10],
        [-9, -6],
        [-8, 0],
        [-16, 4],
        [-13, 4],
        [-4, -2],
        [-12, -8],
        [-8, -6],
        [-7, -2],
        [-5, 0],
        [-4, 4],
        [-3, 4],
        [-3, 8],
        [-9, 0],
        [-13, 0],
        [-14, -4],
        [-12, -8],
        [-18, -9],
        [-34, -4],
        [-57, -2],
        [-61, 2],
        [-30, 4],
        [-13, 13],
        [-7, 20],
        [-15, 14],
        [-18, 8],
        [-18, 7],
        [-20, 0],
        [-21, 3],
        [-15, -10],
        [-14, -16],
        [-12, -24],
        [-20, -19],
        [-25, -22],
        [-34, -19],
        [-63, -14],
        [-41, -21],
        [-70, -40],
        [-87, -46],
        [-34, -18],
        [-46, -51],
        [-47, -54],
        [-21, -25],
        [-12, -46],
        [0, -73],
        [-2, -50],
        [-2, -51],
        [-4, -10],
        [-18, -10],
        [-21, 0],
        [-25, 16],
        [-14, 58],
        [-9, 63],
        [-9, 40],
        [-56, 4],
        [-12, -70],
        [-13, -52],
        [-66, 23],
        [-78, 41],
        [-69, -6],
        [-59, -15],
        [-62, -34],
        [-57, -15],
        [-48, -63],
        [100, -56],
        [52, -63],
        [70, -121],
        [65, -189],
        [-3, -85],
        [16, -62],
        [16, -35],
        [26, -39],
        [12, -26],
        [21, -26],
        [17, -22],
        [9, -30],
        [-4, -29],
        [-5, -37],
        [-3, -21],
        [1, -50],
        [70, -78],
        [30, -26],
        [26, -31],
        [16, -32],
        [15, -22],
        [9, -25],
        [21, -32],
        [17, -8],
        [8, -10],
        [12, -14],
        [15, -14],
        [5, -10],
        [11, -13],
        [6, -15],
        [10, -15],
        [5, -14],
        [2, -18],
        [0, -14],
        [2, -12],
        [2, -12],
        [6, -15],
        [17, -11],
        [17, -5],
        [12, -11],
        [6, -6],
        [12, -15],
        [6, -13],
        [12, -12],
        [11, -5],
        [8, -2],
        [2, -4],
        [4, -6],
        [2, -14],
        [-2, -29],
        [3, -24],
        [10, -18],
        [25, -16],
        [23, -16],
        [12, -17],
        [4, -12],
        [8, -14],
        [11, -6],
        [11, -2],
        [8, 2],
        [11, 12],
        [6, 0],
        [6, -2],
        [4, -4],
        [4, -10],
        [4, -10],
        [2, -11],
        [12, -24],
        [0, -25],
        [-6, -16],
        [-4, -26],
        [6, -8],
        [24, -12],
        [20, -25],
        [0, -21],
        [-8, -38],
        [1, -21],
        [-15, -34],
        [-18, -57],
        [-18, -46],
        [-16, -25],
        [-23, -13],
        [-36, -11],
        [-68, -13],
        [-60, -13],
        [-15, -9],
        [-13, -14],
        [10, -38],
        [6, -50],
        [-3, -62],
        [1, -47],
        [-8, -26],
        [-16, -14],
        [-28, -6],
        [-38, -14],
        [-54, -10],
        [-58, -8],
        [-76, -3],
        [-87, -3],
        [-51, 15],
        [-57, -1],
        [-73, -23],
        [-61, -14],
        [-37, -17],
        [-31, -9],
        [-36, 6],
        [-37, 20],
        [-53, -7],
        [-67, -27],
        [-26, -26],
        [-21, -37],
        [-4, -57],
        [10, -33],
        [0, -38],
        [-44, -38],
        [-44, -34],
        [-33, -27],
        [-8, -28],
        [2, -36],
        [24, -50],
        [8, -43],
        [-18, -34],
        [-22, -55],
        [2, -55],
        [-12, -36],
        [-42, -36],
        [-63, -10],
        [-78, 0],
        [-14, -5],
        [-16, -3],
        [-12, -10],
        [-11, -12],
        [-19, -47],
        [-6, -41],
        [-2, -55],
        [-12, -42],
        [-32, -41],
        [-2, -50],
        [2, -40],
        [2, -37],
        [12, -32],
        [18, -19],
        [59, -40],
        [51, -30],
        [41, -25],
        [34, -22],
        [38, -20],
        [32, -18],
        [31, -16],
        [23, -24],
        [29, -36],
        [-4, -45],
        [-10, -49],
        [6, -37],
        [23, -45],
        [27, -49],
        [5, -25],
        [9, -12],
        [37, -7],
        [37, 9],
        [61, 32],
        [28, 13],
        [20, 0],
        [10, -5],
        [4, -12],
        [2, -34],
        [6, -18],
        [8, -10],
        [33, -47],
        [33, -56],
        [25, -47],
        [7, -18],
        [1, -15],
        [-4, -7],
        [-10, -5],
        [-25, -24],
        [-10, -15],
        [-2, -16],
        [10, -18],
        [3, -19],
        [1, -12],
        [-7, -8],
        [-22, -5],
        [-31, 2],
        [-10, -5],
        [2, -14],
        [8, -10],
        [15, -9],
        [14, -6],
        [16, -10],
        [12, -10],
        [14, -2],
        [16, -2],
        [14, -4],
        [12, -6],
        [12, -4],
        [18, -4],
        [19, -4],
        [13, -4],
        [12, -7],
        [11, -8],
        [10, -11],
        [18, -7],
        [20, 6],
        [23, 6],
        [18, -3],
        [6, -5],
        [3, -19],
        [4, -15],
        [10, -20],
        [19, -50],
        [19, -36],
        [9, -40],
        [5, -46],
        [-14, -59],
        [-9, -38],
        [-6, -32],
        [-7, -21],
        [3, -31],
        [13, -48],
        [9, -40],
        [14, -38],
        [11, -36],
        [2, -39],
        [5, -14],
        [13, -11],
        [11, -8],
        [4, -3],
        [4, -4],
        [60, -38],
        [30, -14],
        [10, -11],
        [5, -15],
        [-9, -57],
        [2, -41],
        [9, -36],
        [28, -42],
        [28, -40],
        [8, -11],
        [0, -16],
        [-3, -8],
        [-6, -9],
        [-8, -5],
        [-32, -13],
        [-11, -15],
        [-8, -15],
        [4, -13],
        [6, -16],
        [4, -6],
        [2, -12],
        [5, -14],
        [-3, -22],
        [-10, -19],
        [-15, -23],
        [-15, -21],
        [-16, -23],
        [-14, -30],
        [-14, -23],
        [-19, -82],
        [-24, -32],
        [-21, -42],
        [-44, -45],
        [-11, -48],
        [-21, -46],
        [-21, -36],
        [-11, -54],
        [2, -17],
        [0, -67],
        [-5, -22],
        [-5, -31],
        [1, -37],
        [7, -32],
        [8, -46],
        [6, -10],
        [16, -51],
        [-4, -16],
        [-2, -22],
        [-14, -10],
        [-96, -17],
        [-48, -15],
        [-49, -11],
        [-31, -16],
        [-27, -18],
        [-2, -22],
        [0, -26],
        [-14, -10],
        [-64, 6],
        [-45, -27],
        [-35, -28],
        [1889, -2340],
        [1144, -1322],
        [546, -630],
        [4, -5],
        [642, -742],
        [-40, -22],
        [-6, -45],
        [-39, -55],
        [-37, -58],
        [-16, -56],
        [-5, -55],
        [-51, -63],
        [-55, -38],
        [-56, -34],
        [-47, -16],
        [-78, -60],
        [-65, -67],
        [-44, -70],
        [-35, -71],
        [-14, -70],
        [-15, -41],
        [-1, -60],
        [-3, -47],
        [5, -70],
        [6, -54],
        [-11, -47],
        [10, -21],
        [50, -107],
        [29, -66],
        [4, -61],
        [3, -38],
        [-11, -45],
        [-8, -80],
        [4, -37],
        [8, -26],
        [10, -22],
        [8, -17],
        [1, -7],
        [-1, -21],
        [0, -32],
        [-6, -31],
        [-2, -16],
        [-12, -26],
        [-8, -42],
        [-1, -20],
        [1, -20],
        [8, -23],
        [9, -34],
        [22, -49],
        [20, -56],
        [12, -22],
        [0, -20],
        [0, -75],
        [-4, -43],
        [-4, -54],
        [-4, -16],
        [-9, -5],
        [-15, -1],
        [-8, -4],
        [-7, -2],
        [-11, 1],
        [-24, 5],
        [-14, 0],
        [-13, -3],
        [-13, -9],
        [-9, -11],
        [-4, -15],
        [-5, -6],
        [-12, -6],
        [-8, 0],
        [-17, -6],
        [-16, -8],
        [-33, -18],
        [-17, -15],
        [-18, -14],
        [-16, -12],
        [-6, -10],
        [-10, -31],
        [-7, -45],
        [-4, -35],
        [-8, -61],
        [-2, -7],
        [-6, -5],
        [-6, -7],
        [-4, -7],
        [-1, -4],
        [0, -6],
        [-3, -10],
        [-1, -10],
        [-3, -7],
        [-6, -3],
        [-17, -9],
        [-13, -7],
        [-8, -8],
        [-4, -13],
        [2, -15],
        [-10, -71],
        [-6, -51],
        [-4, -19],
        [14, -44],
        [0, -69],
        [-16, -53],
        [-14, -35],
        [-10, -43],
        [0, -41],
        [-16, -34],
        [-7, -28],
        [-9, -26],
        [-18, -14],
        [-28, -16],
        [-28, -11],
        [-2, -15],
        [0, -28],
        [6, -53],
        [2, -64],
        [2, -91],
        [10, -108],
        [-2, -18],
        [-6, -34],
        [-4, -36],
        [-20, -48],
        [-4, -14],
        [-2, -74],
        [2, -77],
        [0, -27],
        [-14, -40],
        [-21, -44],
        [-23, -49],
        [-20, -44],
        [-4, -16],
        [-5, -21],
        [-2, -34],
        [-43, -112],
        [-17, -33],
        [-4, -84],
        [11, -43],
        [20, -80],
        [28, -59],
        [-14, -79],
        [-26, -38],
        [-25, -34],
        [-42, -30],
        [-31, -12],
        [-49, -49],
        [-37, -40],
        [-30, -28],
        [-24, -27],
        [-25, -19],
        [-18, -18],
        [1, -34],
        [-13, -44],
        [-19, -30],
        [9, -41],
        [47, -54],
        [36, -34],
        [34, -36],
        [31, -41],
        [22, -47],
        [2, -29],
        [-8, -44],
        [-30, -48],
        [2, -47],
        [-14, -47],
        [-2, -39],
        [4, -57],
        [1, -56],
        [-1, -45],
        [1, -52],
        [-19, -46],
        [-33, -68],
        [4, -40],
        [4, -33],
        [-10, -15],
        [-12, -24],
        [-12, -8],
        [-19, -12],
        [-13, -6],
        [-16, -15],
        [-5, -22],
        [8, -78],
        [6, -73],
        [6, -87],
        [4, -32],
        [11, -53],
        [11, -42],
        [8, -18],
        [11, -12],
        [49, -38],
        [56, -35],
        [41, -34],
        [13, -12],
        [7, -4],
        [7, -4],
        [10, -4],
        [6, -4],
        [16, -14],
        [8, -16],
        [4, -36],
        [8, -19],
        [6, -16],
        [16, -24],
        [10, -13],
        [9, -13],
        [6, -18],
        [8, -49],
        [9, -35],
        [17, -41],
        [45, -57],
        [33, -51],
        [6, -19],
        [10, -34],
        [4, -22],
        [6, -40],
        [4, -47],
        [2, -43],
        [-2, -129],
        [2, -68],
        [0, -8],
        [71, 23],
        [51, 2],
        [39, 21],
        [86, 16],
        [125, -43],
        [73, -20],
        [83, -34],
        [81, -99],
        [35, -63],
        [22, -61],
        [56, -37],
        [22, -52],
        [26, -47],
        [34, -16],
        [15, -28],
        [16, -24],
        [22, -40],
        [18, -47],
        [6, -43],
        [-9, -33],
        [-11, -37],
        [2, -46],
        [12, -10],
        [15, -8],
        [5, -10],
        [2, -44],
        [-4, -17],
        [-11, -9],
        [-10, -14],
        [-5, -11],
        [0, -25],
        [15, -25],
        [1, -20],
        [5, -38],
        [28, -33],
        [21, -37],
        [2, -61],
        [26, -40],
        [20, -49],
        [39, -75],
        [32, -39],
        [23, -40],
        [23, -38],
        [19, -62],
        [19, -45],
        [22, -24],
        [23, -14],
        [16, -10],
        [16, -14],
        [13, -20],
        [13, -17],
        [18, -21],
        [13, -30],
        [10, -31],
        [14, -24],
        [9, -19],
        [27, -37],
        [12, -18],
        [4, -23],
        [2, -26],
        [-8, -20],
        [-11, -26],
        [-2, -13],
        [-4, -14],
        [1, -22],
        [5, -6],
        [9, -10],
        [13, -20],
        [12, -48],
        [59, -111],
        [17, -45],
        [14, -31],
        [30, -37],
        [24, -30],
        [11, -37],
        [15, -55],
        [7, -56],
        [-11, -43],
        [-19, -71],
        [-11, -25],
        [-18, -47],
        [-16, -47],
        [14, -61],
        [16, -36],
        [21, -6],
        [21, -6],
        [15, -11],
        [1, -13],
        [-11, -31],
        [-14, -38],
        [-22, -49],
        [-31, -38],
        [-30, -48],
        [-31, -38],
        [-14, -19],
        [-7, -26],
        [-12, -24],
        [-21, -24],
        [-44, -38],
        [-42, -64],
        [0, -86],
        [8, -94],
        [-2, -37],
        [-12, -40],
        [-23, -58],
        [-24, -8],
        [-18, 8],
        [-15, 20],
        [-13, 45],
        [-23, 16],
        [-24, 20],
        [-35, 13],
        [-39, -8],
        [-69, 12],
        [-34, 29],
        [-16, 26],
        [-17, 22],
        [-28, 1],
        [-35, -5],
        [-40, 7],
        [-40, -6],
        [-21, -27],
        [-16, -49],
        [-11, -25],
        [-1, -32],
        [8, -24],
        [22, -21],
        [8, -12],
        [11, -14],
        [16, -24],
        [7, -20],
        [3, -24],
        [0, -22],
        [2, -29],
        [2, -18],
        [-1, -32],
        [-12, -20],
        [-18, -12],
        [-16, -9],
        [-18, -3],
        [-18, 3],
        [-15, 3],
        [-14, -6],
        [-16, -11],
        [-13, -9],
        [-11, -12],
        [-13, -12],
        [-15, -22],
        [-14, -38],
        [-10, -13],
        [-17, -14],
        [-10, -13],
        [-8, -21],
        [-12, -70],
        [-13, -44],
        [-19, -38],
        [-31, -67],
        [-8, -22],
        [11, -26],
        [2, -15],
        [-6, -14],
        [6, -22],
        [-2, -39],
        [-12, -33],
        [10, -25],
        [-10, -41],
        [-10, -44],
        [-6, -33],
        [-6, -30],
        [-4, -17],
        [-3, -9],
        [-12, 4],
        [-17, -6],
        [-18, -8],
        [-12, 2],
        [-11, 18],
        [-8, 11],
        [-23, 9],
        [-21, 8],
        [-20, 3],
        [-16, 4],
        [-4, 8],
        [-16, 3],
        [-19, -3],
        [-21, -13],
        [-8, -14],
        [-6, -21],
        [-5, -21],
        [-10, -16],
        [-17, -17],
        [-53, -34],
        [-18, -14],
        [-16, -16],
        [-18, -4],
        [-10, -14],
        [-6, -9],
        [-28, 0],
        [-21, -2],
        [-15, -4],
        [-6, -6],
        [-10, 0],
        [-4, -6],
        [-6, -2],
        [0, -4],
        [-14, -8],
        [-8, -2],
        [-7, -8],
        [-3, -15],
        [-7, -18],
        [-6, -16],
        [-8, -11],
        [-16, -14],
        [-27, -24],
        [-18, -16],
        [-18, -4],
        [-27, 2],
        [-30, 8],
        [-24, 8],
        [-24, 8],
        [-44, 8],
        [-18, 6],
        [-3, 31],
        [-17, 26],
        [-27, 8],
        [-10, -2],
        [-14, -5],
        [-14, -18],
        [0, -26],
        [12, -44],
        [-2, -31],
        [-4, -25],
        [-12, -33],
        [-20, -13],
        [-25, -10],
        [-25, 3],
        [-34, 23],
        [-60, 69],
        [-7, 19],
        [-4, 32],
        [-37, 42],
        [-34, 2],
        [-26, 1],
        [-31, -5],
        [-20, -6],
        [-20, -7],
        [-28, 17],
        [-24, 23],
        [-22, 21],
        [-16, 24],
        [-19, 16],
        [-39, 14],
        [-19, 18],
        [-2, 16],
        [-4, 13],
        [0, 15],
        [4, 15],
        [9, 19],
        [11, 21],
        [-3, 24],
        [-7, 7],
        [-12, 6],
        [-20, 12],
        [-24, 8],
        [-21, 10],
        [-23, 1],
        [-24, -9],
        [-32, -15],
        [-18, -5],
        [-20, 3],
        [-19, 4],
        [-23, -9],
        [-25, -23],
        [-23, -35],
        [-23, -22],
        [-10, -18],
        [-19, -12],
        [-10, -20],
        [-4, -16],
        [-25, -15],
        [-40, -11],
        [-28, -6],
        [-12, -8],
        [-12, -28],
        [-10, -15],
        [-12, -15],
        [-16, -21],
        [-13, -12],
        [-11, -9],
        [-2, -10],
        [-4, -14],
        [-12, -18],
        [-10, -14],
        [-17, -15],
        [-10, -10],
        [-25, -10],
        [-21, -2],
        [-12, -6],
        [-18, -4],
        [-18, -4],
        [-16, -9],
        [-15, -2],
        [-25, -22],
        [-10, -12],
        [-15, -15],
        [-22, -12],
        [-9, -30],
        [0, -19],
        [-1, -23],
        [1, -17],
        [-1, -23],
        [5, -23],
        [13, -39],
        [23, -42],
        [26, -37],
        [13, -22],
        [7, -22],
        [3, -18],
        [-16, -31],
        [-6, -24],
        [-9, -23],
        [-6, -13],
        [-22, -3],
        [-21, -1],
        [-19, -7],
        [-16, -9],
        [-15, -4],
        [-14, 4],
        [-12, 3],
        [10, 12],
        [6, 15],
        [0, 17],
        [2, 11],
        [2, 16],
        [-2, 13],
        [-8, 8],
        [-14, -2],
        [-27, 4],
        [-19, 2],
        [-13, -6],
        [-19, -17],
        [-4, -18],
        [-14, -53],
        [-4, -21],
        [-8, -14],
        [-8, -20],
        [-4, -18],
        [-12, -10],
        [-12, -4],
        [-6, -7],
        [-4, -6],
        [-5, -6],
        [-10, -6],
        [-13, -2],
        [-16, -1],
        [-8, 6],
        [-14, 16],
        [-12, 19],
        [-8, 12],
        [-14, 17],
        [-13, 10],
        [-24, 4],
        [-16, 0],
        [-8, -4],
        [-10, -14],
        [-2, -19],
        [-3, -19],
        [-9, -17],
        [-11, -22],
        [-11, -21],
        [-15, -17],
        [-21, -5],
        [-24, -2],
        [-24, -1],
        [-15, 1],
        [-18, 0],
        [-3, -11],
        [-7, -20],
        [-8, -5],
        [-18, 1],
        [-36, -3],
        [-27, 2],
        [-57, -2],
        [-16, -16],
        [-18, -3],
        [-13, -3],
        [-7, -13],
        [-15, -19],
        [-14, -10],
        [-17, -4],
        [-4, -12],
        [-4, -12],
        [0, -6],
        [-2, -14],
        [-4, -8],
        [-6, -9],
        [-3, -2],
        [-10, -3],
        [-13, 1],
        [-11, 1],
        [-14, 3],
        [-15, -2],
        [-8, -6],
        [-10, 0],
        [-7, 6],
        [-19, -2],
        [-15, -7],
        [-34, -15],
        [-30, -15],
        [-24, -2],
        [-9, -6],
        [-9, -4],
        [-13, -5],
        [-16, -4],
        [-16, -11],
        [-10, -10],
        [-10, -13],
        [-2, -14],
        [4, -12],
        [4, -14],
        [6, -14],
        [8, -19],
        [7, -14],
        [10, -20],
        [-2, -14],
        [-10, -12],
        [-11, -12],
        [-6, -9],
        [-2, -11],
        [-13, -4],
        [-15, 2],
        [-18, 0],
        [-15, -9],
        [-2, -8],
        [-6, -18],
        [-7, -19],
        [-6, -8],
        [-4, -11],
        [-12, -9],
        [-10, -6],
        [-14, -8],
        [-9, -13],
        [-7, -11],
        [-7, -10],
        [-3, -16],
        [-13, -19],
        [-8, -14],
        [-18, -11],
        [-19, -12],
        [-15, -6],
        [-17, -10],
        [-11, -11],
        [-6, -10],
        [-8, -7],
        [-7, -10],
        [-7, -11],
        [-4, -12],
        [-4, -10],
        [-14, -12],
        [-11, -29],
        [-10, -29],
        [-2, -23],
        [-10, -17],
        [-13, -7],
        [-32, -7],
        [-38, 1],
        [-20, 12],
        [-17, 7],
        [-16, 10],
        [-47, 47],
        [-34, 27],
        [-11, 10],
        [-5, 20],
        [1, 14],
        [-7, 40],
        [-7, 30],
        [-7, 10],
        [-13, 9],
        [-24, 15],
        [-26, 25],
        [-39, 12],
        [-31, -8],
        [-22, -22],
        [-19, -14],
        [-17, -22],
        [-35, -34],
        [-10, -32],
        [2, -25],
        [-6, -8],
        [-39, -43],
        [-5, -10],
        [-3, -12],
        [6, -17],
        [26, -48],
        [11, -57],
        [8, -26],
        [29, -44],
        [14, -31],
        [21, -19],
        [8, -24],
        [3, -17],
        [8, -25],
        [12, -12],
        [14, -20],
        [4, -18],
        [-12, -18],
        [2, -18],
        [4, -20],
        [0, -11],
        [-4, -6],
        [-14, -8],
        [-5, -10],
        [-1, -28],
        [-2, -62],
        [2, -28],
        [18, -30],
        [33, -23],
        [55, -27],
        [24, -12],
        [26, -21],
        [15, -8],
        [24, -9],
        [16, -9],
        [8, -11],
        [-2, -19],
        [0, -13],
        [4, -14],
        [2, -31],
        [-4, -16],
        [-12, -21],
        [-16, -11],
        [-11, -10],
        [-8, -10],
        [-13, -9],
        [-25, 3],
        [-24, 9],
        [-21, -1],
        [-17, -9],
        [-31, -18],
        [-29, -19],
        [-8, -24],
        [-4, -16],
        [-9, -22],
        [2, -10],
        [8, -11],
        [13, -15],
        [16, -29],
        [8, -27],
        [13, -52],
        [2, -33],
        [6, -15],
        [10, -7],
        [37, -34],
        [28, -24],
        [19, -36],
        [12, -25],
        [2, -22],
        [2, -16],
        [5, -14],
        [16, -20],
        [27, -30],
        [16, -27],
        [18, -42],
        [9, -27],
        [5, -25],
        [-1, -30],
        [2, -17],
        [11, -25],
        [20, -35],
        [8, -26],
        [10, -24],
        [8, -19],
        [6, -21],
        [-6, -25],
        [-14, -18],
        [-12, -12],
        [-11, -4],
        [-11, -6],
        [-9, -2],
        [-5, -4],
        [-5, -6],
        [-8, -8],
        [-6, -8],
        [-13, -6],
        [-12, -12],
        [-4, -9],
        [-4, -8],
        [0, -9],
        [8, -11],
        [10, -9],
        [2, -6],
        [13, -12],
        [15, -17],
        [14, -7],
        [20, 0],
        [28, -1],
        [14, -6],
        [13, -10],
        [6, -10],
        [-3, -16],
        [-14, -11],
        [-12, -10],
        [-8, -7],
        [-14, -5],
        [-12, -7],
        [-15, -2],
        [-19, -5],
        [-22, -5],
        [-22, -1],
        [-32, 2],
        [-11, 4],
        [-9, -3],
        [-18, -2],
        [-11, -5],
        [-8, -2],
        [-21, 7],
        [-13, 4],
        [-8, 2],
        [-11, 1],
        [-8, -4],
        [-6, -8],
        [-3, -15],
        [-4, -12],
        [-7, -12],
        [-11, -22],
        [-8, -17],
        [-10, -13],
        [-9, -18],
        [-12, -26],
        [-13, -6],
        [-17, -3],
        [-12, -8],
        [-5, -5],
        [-7, -4],
        [-10, -6],
        [-10, -10],
        [-8, -11],
        [-5, -8],
        [-10, -4],
        [-7, -6],
        [-2, -10],
        [-4, -6],
        [-10, -6],
        [-5, -10],
        [-2, -6],
        [-2, -7],
        [-2, -5],
        [0, -10],
        [-4, -10],
        [-7, -3],
        [-10, 0],
        [-12, 2],
      ],
      [
        [156947, 284565],
        [-24, 26],
        [0, 119],
        [-24, 107],
        [-31, 42],
        [-39, 26],
        [-30, 28],
        [-29, 12],
        [-31, 11],
        [-23, 10],
        [-46, 2],
        [-52, -8],
        [-36, -19],
        [-18, -42],
        [-24, -1],
        [-33, -3],
        [-41, -16],
        [-37, -15],
        [-24, -12],
        [-24, -6],
        [-31, -6],
        [-40, -10],
        [-19, 18],
        [-65, 33],
        [-8, 5],
        [-446, 971],
        [-1208, 36],
        [-264, 421],
        [-330, 197],
        [4, 411],
        [-911, 916],
        [-690, 423],
        [-648, 197],
        [-39, -19],
        [-796, 48],
        [-500, 212],
        [-72, -21],
        [-188, -66],
        [-352, -198],
        [-257, 78],
        [-294, -133],
        [-305, 25],
        [-396, 501],
        [-442, -231],
        [-599, 39],
        [-24, -55],
        [-43, -45],
        [-25, -26],
        [-53, -13],
        [-39, -3],
        [-26, -4],
        [-28, -12],
        [-22, -9],
        [-33, -6],
        [-28, -2],
        [-33, -2],
        [-50, 10],
        [-37, 9],
        [-40, 17],
        [-47, 20],
        [-38, 21],
        [-35, 23],
        [-50, 30],
        [-52, 46],
        [-34, 41],
        [-51, 46],
        [-88, 44],
        [-68, 2],
        [-41, -2],
        [-47, -14],
        [-37, -40],
        [-28, -42],
        [-30, -50],
        [-34, -60],
        [-21, -34],
        [-12, -24],
        [-39, 10],
        [-27, -7],
        [-30, -16],
        [-32, -8],
        [-39, -8],
        [-36, -4],
        [-38, -14],
        [-18, 12],
        [-17, 12],
        [-74, 8],
        [-67, 4],
        [-89, 20],
        [-88, 26],
        [-73, 41],
        [-60, 40],
        [-52, 40],
        [-104, 76],
        [-91, 32],
        [-92, 7],
        [-74, -19],
        [-36, -24],
        [-29, -20],
        [-39, -76],
        [-76, -73],
        [-88, -42],
        [-51, -18],
        [-28, 2],
        [-72, -5],
        [-61, -29],
        [-66, -40],
        [-76, -80],
        [-65, -47],
        [-23, -61],
        [-15, -49],
        [-18, -70],
        [-3, -63],
        [-39, -79],
        [-67, -75],
        [-75, -95],
        [-55, -50],
        [-80, -36],
        [-62, -12],
        [-61, -16],
        [-108, -14],
        [-37, -19],
        [-32, -7],
        [-38, -10],
        [-44, 3],
        [-33, -7],
        [-38, -22],
        [-44, -13],
        [-34, 9],
        [-29, 11],
        [-26, 19],
        [-38, 23],
        [-53, 24],
        [-88, 10],
        [-72, -19],
        [-80, -50],
        [-52, -113],
        [-70, -133],
        [-75, -205],
        [-28, -60],
        [-26, -56],
        [-72, 1],
        [-141, 19],
        [-52, -4],
        [-126, -39],
        [-61, -36],
        [-119, -11],
        [-35, -20],
        [-79, -9],
        [-54, -75],
        [-30, 13],
        [-89, 36],
        [-114, 37],
        [-97, 10],
        [-149, 41],
        [-107, 48],
        [-102, 27],
        [-45, -33],
        [-48, -34],
        [-12, -87],
        [-2, -119],
        [10, -127],
        [-79, -63],
        [-91, -95],
        [-3, -7],
        [-4, -8],
        [-7, -2],
        [-24, 6],
        [-40, -2],
        [-38, -2],
        [-45, -3],
        [-108, 13],
        [-97, 86],
        [-96, -15],
        [-63, 33],
        [-99, 69],
        [-94, -12],
        [-23, -11],
        [-60, -48],
        [-29, -84],
        [-12, -92],
        [-24, -40],
        [-46, -4],
        [-56, 22],
        [-46, 53],
        [-78, 70],
        [-99, 80],
        [-35, 39],
        [-20, 27],
        [-20, 20],
        [-14, 27],
        [-33, 36],
        [-63, 26],
        [-33, -28],
        [-31, -20],
        [-43, 16],
        [-43, -14],
        [-68, -8],
        [-102, 12],
        [-65, 19],
        [-50, 6],
        [-87, 5],
        [-87, 12],
        [-65, -22],
        [-25, -81],
        [-15, -14],
        [-36, -31],
        [-28, -34],
        [-66, 26],
        [-102, 5],
        [-90, 8],
        [-85, -72],
        [-122, -38],
        [-100, -15],
        [-20, -56],
        [-67, 9],
        [-77, 23],
        [-86, -2],
        [-70, 6],
        [-41, 53],
        [-49, 43],
        [-19, 122],
        [-52, 87],
        [-32, 114],
        [-30, 73],
        [-18, 68],
        [-103, 34],
        [-14, 5],
        [-96, 5],
        [-74, -21],
        [-57, -43],
        [-66, -54],
        [-15, -35],
        [-4, -64],
        [7, -72],
        [34, -66],
        [58, -87],
        [72, -143],
        [13, -127],
        [10, -101],
        [-129, -92],
        [-128, -120],
        [-74, -111],
        [-29, -100],
        [-41, -8],
        [-35, -42],
        [-52, -52],
        [-38, -101],
        [-27, -45],
        [-7, -29],
        [22, -38],
        [0, -26],
        [-7, -16],
        [-17, -6],
        [-29, -3],
        [-36, 3],
        [-45, 13],
        [-59, 12],
        [-57, 43],
        [-61, 107],
        [-68, 93],
        [-74, 19],
        [-55, -8],
        [-51, -25],
        [-59, -27],
        [-38, -58],
        [-37, -72],
        [-54, -37],
        [-112, 0],
        [-111, -18],
        [-66, -17],
        [-47, -10],
        [-39, 19],
        [-32, 18],
        [-35, 26],
        [-44, 64],
        [-53, 30],
        [-65, -1],
        [-59, -14],
        [-386, 109],
        [-141, 282],
        [-446, 240],
        [-143, 226],
        [-375, -75],
        [-782, 512],
        [-68, 496],
        [-205, -16],
        [-251, 31],
        [-648, 806],
        [-408, 93],
        [-161, 37],
        [-179, 554],
        [-207, 26],
        [-124, 125],
        [-178, 113],
        [-667, -252],
        [-896, 230],
        [-30, 1],
        [-59, -19],
        [-77, -17],
        [-66, 22],
        [-59, 46],
        [-75, 63],
        [-29, 73],
        [-32, 69],
        [-22, 35],
        [-32, 37],
        [-85, 35],
        [-74, 36],
        [-77, 52],
        [-39, 20],
        [-34, 27],
        [-17, 16],
        [-10, 14],
        [-47, 49],
        [-33, 47],
        [-56, 78],
        [-28, 30],
        [-38, 27],
        [-71, -15],
        [-47, -15],
        [-47, -27],
        [-40, -34],
        [-22, -27],
        [-23, -72],
        [-24, -108],
        [-27, -86],
        [-23, -75],
        [-55, -81],
        [-39, -43],
        [-27, -29],
        [-29, -27],
        [-26, -8],
        [-35, 4],
        [-39, 8],
        [-42, 8],
        [-57, 23],
        [-70, 22],
        [-78, 5],
        [-71, -3],
        [-64, -6],
        [-56, -4],
        [-37, -19],
        [-37, -9],
        [-32, -13],
      ],
      [
        [127362, 289382],
        [-27, 42],
        [-64, 72],
        [-31, 95],
        [13, 80],
        [-14, 76],
        [-68, 127],
        [-35, 79],
        [-24, 60],
        [-11, 47],
        [-15, 62],
        [12, 55],
        [-32, 101],
        [-49, 78],
        [-47, 85],
        [-60, 177],
        [-66, 47],
        [-92, 36],
        [-58, -11],
        [-65, -33],
        [-89, 6],
        [-78, 20],
        [-61, 57],
        [-35, 82],
        [-47, 51],
        [-73, 50],
        [-61, 79],
        [-68, 68],
        [-74, 85],
        [-24, 60],
        [-3400, 896],
        [-64, -13],
        [-54, -10],
        [-54, 6],
        [-54, 36],
        [-67, 13],
        [-39, 15],
        [-48, -6],
        [-69, -52],
        [-32, -38],
        [7, -45],
        [25, -73],
        [49, -73],
        [54, -84],
        [2, -77],
        [11, -86],
        [-19, -38],
        [-68, -33],
        [-80, 21],
        [-81, 1],
        [-69, 15],
        [-62, 36],
        [-65, 30],
        [-75, 53],
        [-36, 36],
        [-76, 44],
        [-46, 15],
        [-98, -1],
        [-74, -10],
        [-70, -24],
        [-28, -26],
        [-25, -24],
        [-15, -23],
        [-25, -25],
        [-24, -17],
        [-19, -6],
        [-40, 4],
        [-33, 8],
        [-21, -2],
        [-22, 0],
        [-16, -2],
        [-12, -4],
        [-43, 44],
        [-24, 50],
        [-28, 33],
        [-23, 64],
        [2, 61],
        [-5, 68],
        [-22, 55],
        [-34, 35],
        [-30, 20],
        [-39, 22],
        [-28, 47],
        [-41, 33],
        [-79, 20],
        [-51, -14],
        [-34, -32],
        [-11, -49],
        [4, -71],
        [27, -59],
        [17, -66],
        [22, -43],
        [15, -37],
        [-1, -66],
        [-12, -101],
        [-28, -70],
        [-36, -86],
        [-26, -57],
        [-18, -48],
        [-19, -37],
        [-16, -18],
        [-18, -28],
        [-20, -18],
        [-28, -5],
        [-56, 8],
        [-24, 18],
        [-15, 7],
        [-30, 12],
        [-32, 19],
        [-34, 41],
        [-52, 11],
        [-45, 23],
        [-25, 23],
        [-49, 36],
        [-43, 29],
        [-124, 39],
        [-43, 11],
        [-44, 16],
        [-68, 22],
        [-54, 12],
        [-77, 36],
        [-37, 28],
        [-51, 36],
        [-33, 39],
        [-28, 44],
        [-31, 33],
        [-23, 53],
        [-40, 35],
        [-23, 33],
        [-34, 25],
        [-42, 46],
        [-29, 56],
        [-58, 54],
        [-66, 50],
        [-63, 46],
        [-37, 36],
        [-40, 54],
        [-52, 48],
        [-13, 35],
        [-10, 35],
        [-35, 57],
        [-65, 42],
        [-79, 14],
        [-87, 17],
        [-103, -4],
        [-91, 2],
        [-103, 16],
        [-67, 26],
        [-60, 30],
        [-79, 20],
        [-46, 19],
        [-39, 36],
        [-38, 46],
        [-10, 51],
        [8, 49],
        [48, 72],
        [12, 24],
        [13, 44],
        [2, 64],
        [-13, 32],
        [-40, 38],
        [-38, 24],
        [-33, 10],
        [-44, 4],
        [-36, 4],
        [-43, -3],
        [-45, -5],
        [-31, -4],
        [-34, 2],
        [-46, -6],
        [-36, 4],
        [-40, 0],
        [-32, 8],
        [-21, 27],
        [-12, 34],
        [-23, 24],
        [-28, 19],
        [-40, 29],
        [-33, 18],
        [-55, 37],
        [-41, 35],
        [-46, 13],
        [-39, 4],
        [-51, 0],
        [-35, -3],
        [-20, -2],
        [-45, -22],
        [-35, -36],
        [-13, -36],
        [-41, -36],
        [-26, -36],
        [-35, -32],
        [-56, -45],
        [-29, -9],
        [-86, -46],
        [-30, 0],
        [-50, -3],
        [-37, 14],
        [-24, 22],
        [-19, 33],
        [-62, 67],
        [-28, 47],
        [-15, 38],
        [-8, 48],
        [6, 81],
        [-14, 54],
        [-34, 55],
        [-22, 37],
        [-32, 37],
        [-37, 33],
        [-46, 23],
        [-45, 11],
        [-33, -10],
        [-34, -39],
        [-31, -10],
        [-34, -10],
        [-31, -4],
        [-42, -4],
        [-31, -24],
        [-38, -9],
        [-56, -1],
        [-50, -6],
        [-63, -4],
        [-63, -2],
        [-79, -9],
        [-45, 0],
        [-47, -20],
        [-54, -7],
        [-42, 0],
        [-52, 24],
        [-39, 18],
        [-28, 36],
        [-18, 44],
        [-6, 45],
        [6, 44],
        [35, 66],
        [22, 38],
        [10, 47],
        [-11, 42],
        [-12, 25],
        [-12, 38],
        [-6, 26],
        [-8, 16],
        [-10, 20],
        [-14, 14],
        [-8, 10],
        [-24, 19],
        [-10, 11],
        [-11, 7],
        [-25, 12],
        [-22, 9],
        [-24, 7],
        [-21, -2],
      ],
      [
        [112644, 328662],
        [-244, 1417],
        [-1, 6],
        [-84, 486],
        [-1, 4],
        [-170, 986],
        [0, 6],
        [-98, 570],
        [-250, 1442],
        [-1103, -784],
        [-3783, -2744],
        [-7, -6],
        [-18, 8],
        [-19, 6],
        [-39, 12],
        [-26, 20],
        [-29, 20],
        [-19, 22],
        [-22, 31],
        [-23, 34],
        [-17, 12],
        [-28, 6],
        [-20, 10],
        [-29, 18],
        [-48, 8],
        [-35, -2],
        [-32, -6],
        [-23, -7],
        [-49, -11],
        [-39, 1],
        [-52, 11],
        [-28, 2],
        [-31, -2],
        [-36, -3],
        [-42, -9],
        [-64, -6],
        [-37, -2],
        [-36, 16],
        [-14, 5],
        [-14, 1],
        [-13, -2],
        [-10, -12],
        [-46, -42],
        [-58, -14],
        [-28, 0],
        [-10, 14],
        [-187, 307],
        [-457, 295],
        [-61, -71],
        [-74, -59],
        [-38, -1],
        [-26, 10],
        [-12, 23],
        [-29, 8],
        [-41, 25],
        [-30, 4],
        [-27, 11],
        [-39, 16],
        [-21, 12],
        [-13, 21],
        [-28, 97],
        [-5, 88],
        [10, 91],
        [-56, 80],
        [-63, 32],
        [-34, 37],
        [-31, 53],
        [-19, 44],
        [-10, 13],
        [-16, 5],
        [-34, -5],
        [-55, 22],
        [-66, 23],
        [-56, 12],
        [-45, 5],
        [-49, -2],
        [-28, -5],
        [-20, -15],
        [-24, -32],
        [-13, -14],
        [-27, -21],
        [-10, -17],
        [-14, -38],
        [-16, -36],
        [-22, -25],
        [-31, -23],
        [-22, -16],
        [-22, -17],
        [-25, -32],
        [-16, -26],
        [-15, -22],
        [-15, -6],
        [-21, -8],
        [-40, -10],
        [-43, -2],
        [-20, -11],
        [-32, -6],
        [-19, 11],
        [-16, 18],
        [-27, 8],
        [-36, -4],
        [-20, 4],
        [-27, 18],
        [-39, -6],
        [-34, 12],
        [-33, 6],
        [-24, 6],
        [-30, 8],
        [-26, 13],
        [-28, 11],
        [-7, 12],
        [-9, 22],
        [-18, 22],
        [-16, 12],
        [-35, 17],
        [-42, 25],
        [-66, 23],
        [-48, 23],
        [-33, 21],
        [-26, 8],
        [-42, -2],
        [-46, 1],
        [-47, 8],
        [-41, 1],
        [-37, 11],
        [-39, 0],
        [-36, 7],
        [-68, 0],
        [-58, -7],
        [-47, -10],
        [-28, -18],
        [-36, -22],
        [-39, -10],
        [-42, 24],
        [-40, -8],
        [-32, -16],
        [-38, -13],
        [-25, -13],
        [-34, 6],
        [-19, 11],
        [-24, 21],
        [-33, 22],
        [-35, 26],
        [-32, 9],
        [-42, -9],
        [-35, -10],
        [-48, 5],
        [-32, -3],
        [-24, 6],
        [-28, 20],
        [-24, 11],
        [-9, 4],
        [-14, -1],
        [-39, -23],
        [-22, -6],
        [-26, 10],
        [-23, 13],
        [-28, 13],
        [-28, 7],
        [-21, -11],
        [-16, -14],
        [-31, 11],
        [-51, 37],
        [-20, -13],
        [-22, 3],
        [-55, 20],
        [-73, 25],
        [-14, 21],
        [-22, 18],
        [-39, 14],
        [-30, 8],
        [-15, 18],
        [-37, 30],
        [-36, -1],
        [-24, 23],
        [-41, 13],
        [-65, 0],
        [-43, -31],
        [-21, -38],
        [-36, -34],
        [-30, -31],
        [-24, -10],
        [-14, 0],
        [-8, 3],
        [-9, 8],
        [-28, 18],
        [-48, 8],
        [-26, -4],
        [-13, -12],
        [-15, -2],
        [-16, -22],
        [-14, -24],
        [-16, -16],
        [-27, -10],
        [-29, -12],
        [-19, -5],
        [-32, -3],
        [-39, -5],
        [-26, -8],
        [-32, -15],
        [-26, -18],
        [-14, -18],
        [-19, -9],
        [-24, 0],
        [-19, 11],
        [-29, 12],
        [-27, 3],
        [-26, -3],
        [-30, -6],
        [-36, -13],
        [-14, -6],
        [-14, 2],
        [-23, 18],
        [-15, 4],
        [-17, 9],
        [-16, -8],
        [-14, -12],
        [-24, -7],
        [-11, 4],
        [-16, -10],
        [-8, 2],
        [-7, 4],
        [-10, 5],
        [-18, 1],
        [-14, -5],
        [-8, -9],
        [-13, -18],
        [-14, -7],
        [-20, -1],
        [-22, -2],
        [-18, -3],
        [-20, -7],
        [-10, -4],
        [-15, 1],
        [-39, 12],
        [-32, -7],
        [-20, -12],
        [-27, -15],
        [-22, -33],
        [-12, -8],
        [-17, -6],
        [-49, -10],
        [-21, -24],
        [-31, -38],
        [-26, -22],
        [-27, -14],
        [-29, -10],
        [-28, -2],
        [-15, 8],
        [-7, 10],
        [-5, 12],
        [-4, 8],
        [-8, 8],
        [-11, 7],
        [-9, 8],
        [-8, 13],
        [1211, 640],
        [20, 11],
        [2357, 1246],
        [2528, 939],
        [1017, 2871],
        [531, 3764],
        [3414, 2117],
        [-145, 52],
        [-41, 54],
        [-126, 140],
        [-194, 145],
        [-122, 41],
        [-103, -39],
        [-265, -98],
        [-141, 5],
        [-143, 67],
        [-169, 161],
        [-77, 133],
        [-108, 102],
        [-83, -8],
        [-22, -76],
        [-32, -48],
        [-174, 4],
        [-37, 32],
        [-36, 28],
        [-18, 39],
        [-2, 7],
        [-155, 156],
        [-83, 167],
        [-19, 36],
        [-529, 373],
        [-23, -4],
        [-60, 44],
        [-15, 29],
        [-11, 35],
        [-23, 85],
        [-28, 6],
        [-35, -11],
        [-84, 2],
        [-46, 18],
        [-22, 35],
        [-3, 41],
        [-71, 75],
        [-59, 53],
        [-33, 38],
        [-28, 36],
        [-16, 16],
        [-12, 24],
        [-20, 21],
        [-40, 62],
        [-26, 18],
        [-62, 24],
        [-15, 12],
        [-74, -3],
        [-38, -16],
        [-42, -2],
        [-49, 11],
        [-34, -22],
        [-27, -8],
        [-24, -24],
        [-7, -10],
        [-43, -2],
        [-15, -2],
        [-16, -4],
        [-78, 0],
        [-30, 30],
        [-18, 45],
        [-3, 45],
        [-6, 70],
        [18, 40],
        [-10, 95],
        [-54, 28],
        [-67, 14],
        [-31, 11],
        [-42, 4],
        [-43, -3],
        [-42, -16],
        [-14, -19],
        [-28, -9],
        [-36, -1],
        [-35, 10],
        [-45, 25],
        [-44, 24],
        [-22, 40],
        [-35, 41],
        [-103, 20],
        [-115, 28],
        [-57, 0],
        [-19, 15],
        [-35, 8],
        [-41, 10],
        [-49, 33],
        [-23, 23],
        [-16, 63],
        [-33, 29],
        [-31, 27],
        [-29, 31],
        [-20, 9],
        [-4, 7],
        [-35, 5],
        [-60, -3],
        [-57, -9],
        [-14, -7],
        [-13, 4],
        [-32, -4],
        [-119, -15],
        [-38, 12],
        [-38, 8],
        [-22, 14],
        [-17, 20],
        [-3, 31],
        [-12, 34],
        [5, 44],
        [-22, 34],
        [-20, 38],
        [-14, 35],
        [-17, 26],
        [-23, 43],
        [-11, 45],
        [0, 57],
        [2, 38],
        [20, 23],
        [33, 12],
        [32, 26],
        [33, 12],
        [28, 20],
        [8, 21],
        [6, 26],
        [-16, 23],
        [-34, 17],
        [-2, 16],
        [-59, 53],
        [-37, 0],
        [-45, 27],
        [-42, 2],
        [-42, -18],
        [-38, -76],
        [-20, -15],
      ],
      [
        [104725, 346139],
        [-4, 9],
        [-5, 16],
        [-7, 16],
        [-2, 6],
        [-23, 35],
        [-23, 28],
        [-17, 9],
        [-14, 8],
        [-22, 2],
        [-23, 1],
        [-25, -1],
        [-2, 22],
        [-12, 19],
        [0, 18],
        [-2, 11],
        [18, 20],
        [34, 28],
        [24, 16],
        [31, 20],
        [21, 16],
        [25, 8],
        [46, 2],
        [37, 4],
        [14, 3],
        [8, 14],
        [27, 52],
        [19, 17],
        [21, 45],
        [-1, 16],
        [-2, 12],
        [-3, 10],
        [-26, 21],
        [-35, 4],
        [-2, 12],
        [3, 13],
        [7, 15],
        [13, 19],
        [6, 15],
        [4, 10],
        [-2, 24],
        [4, 20],
        [7, 18],
        [8, 9],
        [8, 12],
        [22, 9],
        [13, 6],
        [21, 12],
        [22, 13],
        [27, 27],
        [21, 41],
        [15, 58],
        [9, 32],
        [23, 26],
        [29, 28],
        [24, 32],
        [39, 54],
        [20, 39],
        [0, 22],
        [-13, 28],
        [-29, 14],
        [-47, 12],
        [-22, 8],
        [2, 13],
        [0, 15],
        [9, 50],
        [-1, 30],
        [-11, 32],
        [-8, 28],
        [-5, 14],
        [-14, 12],
        [-9, 21],
        [-8, 21],
        [-14, 22],
        [14, 43],
        [17, 18],
        [9, -4],
        [27, -10],
        [30, 4],
        [34, 40],
        [1, 38],
        [-21, 29],
        [-18, 11],
        [-25, 14],
        [-27, 12],
        [-16, 17],
        [2, 28],
        [13, 22],
        [47, 35],
        [22, 5],
        [18, 7],
        [18, -6],
        [32, -17],
        [16, -13],
        [23, -15],
        [18, -10],
        [21, -13],
        [29, -17],
        [22, 16],
        [14, 31],
        [7, 51],
        [1, 44],
        [15, 27],
        [7, 19],
        [-1, 26],
        [-4, 18],
        [11, 32],
        [18, 6],
        [12, 19],
        [23, 35],
        [22, 28],
        [17, 14],
        [27, 7],
        [22, 4],
        [20, -5],
        [19, -8],
        [17, -3],
        [22, 12],
        [16, 23],
        [2, 27],
        [-8, 37],
        [2, 24],
        [29, 47],
        [24, 56],
        [-15, 53],
        [-5, 30],
        [9, 36],
        [21, 30],
        [24, 17],
        [6, 17],
        [7, 13],
        [4, 30],
        [10, 28],
        [0, 22],
        [2, 8],
        [6, 29],
        [25, 44],
        [19, 13],
        [22, 3],
        [16, -23],
        [27, -19],
        [12, 12],
        [2, 16],
        [-2, 32],
        [-12, 17],
        [-4, 7],
        [18, 39],
        [41, 20],
        [41, 16],
        [16, 16],
        [5, 16],
        [-5, 18],
        [3, 26],
        [-5, 21],
        [-20, 44],
        [0, 8],
        [2, 26],
        [20, 24],
        [63, 54],
        [85, 70],
        [66, 71],
        [24, 11],
        [30, 0],
        [28, -14],
        [47, -19],
        [36, 11],
        [5, 27],
        [2, 44],
        [35, 44],
        [30, -2],
        [18, 0],
        [19, -2],
        [14, 8],
        [32, 20],
        [11, 9],
        [12, 13],
        [17, 7],
        [19, 18],
        [52, 17],
        [27, 12],
        [25, 29],
        [53, 14],
        [99, 36],
        [51, 69],
        [51, 5],
        [29, 13],
        [10, 11],
        [15, 36],
        [41, 54],
        [51, 64],
        [39, 75],
        [38, 54],
        [59, 91],
        [57, 88],
        [53, 84],
        [-4, 69],
        [38, 42],
        [9, 27],
        [13, 6],
        [27, 6],
        [12, 2],
        [14, 10],
        [33, 47],
        [7, 24],
        [34, -1],
        [51, 35],
        [67, 32],
        [102, 30],
        [35, 9],
        [35, 9],
        [25, -14],
        [22, -28],
        [14, -25],
        [21, -12],
        [45, 4],
        [52, 17],
        [26, -5],
        [39, -21],
        [22, 0],
        [7, 26],
        [-1, 14],
        [-20, 10],
        [-8, 31],
        [16, 25],
        [33, 14],
        [54, 9],
        [131, 10],
        [64, 88],
        [94, 20],
        [126, 121],
        [77, 120],
        [29, 22],
        [22, 43],
        [29, 55],
        [4, 142],
        [3, 45],
        [13, 29],
        [36, 15],
        [68, 1],
        [58, -13],
        [51, 92],
        [45, 16],
        [57, 17],
        [50, 117],
        [28, 98],
        [-4, 146],
        [-32, 105],
        [36, 43],
        [17, 55],
        [106, 70],
        [71, 27],
        [90, 27],
        [34, 14],
        [102, 29],
        [112, 49],
        [78, 28],
        [51, 6],
        [31, 12],
        [60, 36],
        [31, 51],
        [-4, 26],
        [22, 38],
        [11, 30],
        [-7, 42],
        [14, 33],
        [25, 52],
        [23, 106],
        [35, 65],
        [63, 71],
        [78, 87],
        [39, 94],
        [34, 4],
        [42, 28],
        [50, 105],
        [34, 38],
        [58, 48],
        [31, 32],
        [57, 20],
        [21, 8],
        [84, 11],
        [50, 32],
        [2, 120],
        [61, -32],
        [40, -4],
        [28, -8],
        [27, -8],
        [31, -28],
        [30, -3],
        [28, 11],
        [9, 30],
        [-2, 92],
        [134, 16],
        [26, 52],
        [2, 22],
        [-10, 10],
        [-23, 17],
        [-5, 16],
        [24, 11],
        [40, 104],
        [43, 65],
        [46, 60],
        [70, -9],
        [25, -1],
        [68, 54],
        [51, -5],
        [20, -3],
        [29, 2],
        [14, 11],
        [73, 22],
        [73, 43],
        [11, 11],
        [51, 98],
        [10, 18],
        [29, 32],
        [17, 39],
        [19, 125],
        [46, 83],
        [27, 74],
        [37, 62],
        [125, 75],
        [35, 18],
        [14, 21],
        [-2, 21],
        [-6, 22],
        [29, 80],
        [90, 84],
        [19, 81],
        [10, 95],
        [-8, 39],
        [8, 28],
        [130, 71],
        [92, 43],
        [41, 77],
        [27, 102],
        [19, 108],
        [7, 63],
        [27, 49],
        [35, 18],
        [63, -13],
        [21, -17],
        [-2, -59],
        [-11, -22],
        [-3, -19],
        [14, -15],
        [11, -1],
        [14, 2],
        [11, 11],
        [11, 26],
        [13, 71],
        [13, 17],
        [11, 13],
        [23, 18],
        [10, 7],
        [10, 4],
        [18, -6],
        [2, -23],
        [1, -15],
        [4, -12],
        [10, -6],
        [15, 5],
        [16, 13],
        [13, 15],
        [8, 15],
        [8, 15],
        [4, 24],
        [0, 34],
        [15, 22],
        [11, 44],
        [40, 63],
        [49, 9],
        [43, -48],
        [29, -17],
        [29, -3],
        [53, -6],
        [41, -6],
        [53, -15],
        [104, -88],
        [40, -47],
        [34, -23],
        [63, -26],
        [55, -14],
        [67, -10],
        [60, -32],
        [619, 923],
        [1854, -893],
        [23, -12],
        [146, -70],
        [4, -2],
        [3637, -1757],
        [1877, -1836],
        [14, -12],
        [2693, -2639],
        [18, -17],
        [3309, -3248],
        [912, 2160],
        [1, 4],
        [261, 617],
        [0, 2],
        [14, 34],
        [2, 3],
        [695, 1649],
        [2, 4],
        [229, 542],
        [6, 18],
        [2, 2],
        [4, 12],
        [1, 2],
        [44, -22],
        [20, -18],
        [18, -26],
        [14, -16],
        [7, -12],
        [2, -16],
        [4, -10],
        [6, -7],
        [16, -18],
        [19, -14],
        [16, -8],
        [43, 6],
        [36, 12],
        [30, 55],
        [13, 16],
        [6, 22],
        [-7, 20],
        [-11, 24],
        [-26, 26],
        [-5, 109],
        [-36, 45],
        [10, 47],
        [30, 43],
        [16, 30],
        [17, 15],
        [48, 14],
        [24, 33],
        [34, 17],
        [54, 10],
        [85, 20],
        [12, 8],
        [60, 28],
        [36, -4],
        [91, -16],
        [36, -10],
        [22, -10],
        [21, -30],
        [15, -32],
        [-10, -118],
        [-13, -59],
        [31, -61],
        [51, -27],
        [65, 13],
        [67, 72],
        [36, 37],
        [6, 10],
        [9, 14],
        [14, 13],
        [6, 5],
        [16, 6],
        [33, 4],
        [17, -2],
        [23, -8],
        [25, -13],
        [15, -37],
        [11, -30],
        [18, -26],
        [24, -20],
        [1, -70],
        [-49, -58],
        [-33, -37],
        [-15, -31],
        [-21, -25],
        [-26, -32],
        [-7, -36],
        [1, -55],
        [14, -29],
        [44, -45],
        [47, -45],
        [100, -62],
        [34, 12],
        [20, 1],
        [33, 30],
        [15, 21],
        [8, 32],
        [-8, 83],
        [4, 39],
        [-5, 28],
        [25, 91],
        [24, 62],
        [0, 24],
        [-2, 33],
        [-12, 38],
        [-16, 103],
        [-24, 35],
        [-22, 49],
        [3, 48],
        [24, 31],
        [23, 25],
        [12, 13],
        [23, -2],
        [47, -12],
        [43, -24],
        [27, -34],
        [39, -49],
        [44, -37],
        [138, -96],
        [37, -33],
        [38, -40],
        [23, -30],
        [-3, -30],
        [9, -14],
        [67, -24],
        [28, 0],
        [25, 14],
        [26, 30],
        [0, 33],
        [-9, 25],
        [-9, 17],
        [-30, 31],
        [-13, 17],
        [-8, 180],
        [-22, 30],
        [-3, 28],
        [-4, 28],
        [13, 22],
        [22, 12],
        [31, 6],
        [47, -22],
        [50, -26],
        [43, -78],
        [8, -99],
        [4, -32],
        [53, -55],
        [123, -20],
        [60, 29],
        [23, 17],
        [26, 34],
        [10, 37],
        [2, 22],
        [-18, 26],
        [-11, 20],
        [3, 18],
        [14, 22],
        [10, 16],
        [19, 14],
        [39, 13],
        [19, 12],
        [18, 14],
        [20, 6],
        [50, -16],
        [46, -21],
        [54, -53],
        [19, -27],
        [7, -28],
        [18, -42],
        [14, -28],
        [37, -14],
        [58, 12],
        [14, 16],
        [22, 48],
        [1, 55],
        [-11, 44],
        [-18, 78],
        [12, 43],
        [12, 32],
        [23, 30],
        [28, 28],
        [25, 6],
        [18, -2],
        [32, -10],
        [19, -8],
        [14, -13],
        [18, -54],
        [58, -42],
        [90, -30],
        [27, -2],
        [20, 2],
        [68, 0],
        [72, -10],
        [62, 6],
        [24, 12],
        [14, 18],
        [4, 32],
        [10, 11],
        [30, 15],
        [5, 24],
        [0, 18],
        [-7, 43],
        [-7, 57],
        [-3, 45],
        [13, 36],
        [12, 42],
        [19, 32],
        [0, 16],
        [-8, 23],
        [-43, 28],
        [-17, 18],
        [-38, 16],
        [-10, 16],
        [-24, 18],
        [-22, 13],
        [-12, 18],
        [-13, 21],
        [7, 32],
        [17, 61],
        [23, 32],
        [14, 13],
        [21, 8],
        [17, 0],
        [24, 2],
        [15, 2],
        [16, 6],
        [46, 11],
        [18, 10],
        [24, 3],
        [23, -10],
        [45, -22],
        [36, -44],
        [20, -69],
        [0, -43],
        [-9, -17],
        [-8, -10],
        [-7, -11],
        [1, -10],
        [15, -17],
        [3, -59],
        [28, -55],
        [26, -43],
        [43, -28],
        [60, -25],
        [70, -2],
        [53, 20],
        [27, -4],
        [37, -20],
        [32, -13],
        [28, -8],
        [18, -7],
        [18, -16],
        [13, -26],
        [8, -25],
        [42, -27],
        [19, -35],
        [37, -11],
        [49, 2],
        [25, 5],
        [17, 7],
        [16, -3],
        [78, -76],
        [30, -2],
        [50, 7],
        [24, 6],
        [36, -6],
        [24, -3],
        [15, -10],
        [12, -32],
        [3, -32],
        [47, -61],
        [20, -23],
        [72, -33],
        [12, -6],
        [8, -8],
        [19, -2],
        [17, -2],
        [22, 8],
        [25, 4],
        [38, -4],
        [39, 8],
        [23, 10],
        [16, 22],
        [12, 30],
        [-6, 22],
        [-40, 61],
        [-30, 28],
        [-28, 34],
        [-47, 65],
        [-1, 20],
        [6, 10],
        [18, 22],
        [20, 22],
        [20, 7],
        [21, 18],
        [16, 22],
        [21, 25],
        [18, 42],
        [4, 30],
        [20, 44],
        [49, 61],
        [28, 33],
        [35, 18],
        [23, -4],
        [18, -7],
        [15, -34],
        [18, -53],
        [6, -41],
        [10, -22],
        [34, -49],
        [100, -96],
        [33, -67],
        [-1, -59],
        [-11, -27],
        [-37, -46],
        [-17, -31],
        [-10, -25],
        [-20, -101],
        [-4, -87],
        [20, -45],
        [24, -5],
        [18, -18],
        [22, -49],
        [42, -48],
        [36, -34],
        [53, -4],
        [40, 16],
        [17, 88],
        [8, 67],
        [-6, 65],
        [11, 22],
        [18, 19],
        [37, 21],
        [23, 10],
        [64, 2],
        [32, 0],
        [61, 14],
        [36, 2],
        [36, -12],
        [42, -18],
        [22, -31],
        [6, -44],
        [-2, -22],
        [-6, -28],
        [-11, -18],
        [-23, -13],
        [-5, -15],
        [10, -30],
        [-4, -49],
        [-9, -32],
        [-38, -56],
        [-12, -23],
        [-14, -48],
        [-8, -30],
        [5, -40],
        [21, -47],
        [17, -21],
        [22, -15],
        [28, -11],
        [41, -1],
        [49, 13],
        [16, 32],
        [8, 53],
        [22, 61],
        [39, 52],
        [-2, 40],
        [-8, 51],
        [10, 36],
        [37, 44],
        [56, 46],
        [19, 39],
        [46, 86],
        [29, 23],
        [34, 12],
        [38, -6],
        [23, -4],
        [47, -23],
        [55, -23],
        [107, -54],
        [15, -16],
        [63, -27],
        [111, -24],
        [86, -20],
        [55, 6],
        [58, 5],
        [21, 2],
        [22, 20],
        [8, 29],
        [3, 32],
        [-8, 19],
        [-13, 13],
        [-28, 18],
        [-31, 59],
        [-27, 73],
        [-5, 19],
        [-6, 53],
        [-4, 46],
        [24, 40],
        [26, 41],
        [16, 28],
        [9, 15],
        [2, 4],
        [10, 17],
        [20, 14],
        [33, 24],
        [47, -22],
        [6, -3],
        [42, -32],
        [49, -43],
        [18, -15],
        [15, -10],
        [3, -1],
        [27, 9],
        [35, -13],
        [15, -19],
        [0, -1],
        [10, -14],
        [37, -73],
        [7, -57],
        [-1, -1],
        [-10, -75],
        [-12, -64],
        [-7, -53],
        [-29, -57],
        [-10, -42],
        [0, -24],
        [2, -15],
        [19, -19],
        [19, -24],
        [21, -33],
        [30, -20],
        [32, 4],
        [29, 20],
        [31, 39],
        [12, 28],
        [15, 50],
        [-6, 36],
        [-9, 40],
        [6, 26],
        [23, 36],
        [29, 5],
        [23, -6],
        [5, -2],
        [9, -6],
        [18, -2],
        [39, 8],
        [57, 35],
        [77, 48],
        [73, 91],
        [99, 52],
        [39, 14],
        [45, -10],
        [175, 86],
        [218, 134],
        [55, 35],
        [5, 20],
        [28, 4],
        [35, 9],
        [22, 5],
        [103, 0],
        [51, 9],
        [35, 19],
        [16, 36],
        [-4, 30],
        [-22, 23],
        [-16, 4],
        [-16, 14],
        [-28, 58],
        [-5, 29],
        [19, 54],
        [12, 7],
        [22, 17],
        [22, 13],
        [10, 6],
        [16, -5],
        [19, 2],
        [28, -7],
        [39, -33],
        [18, -27],
        [16, -38],
        [40, -123],
        [6, -24],
        [-6, -42],
        [-38, -88],
        [-74, -80],
        [-70, -56],
        [-67, -37],
        [-49, -27],
        [-83, -31],
        [-45, -52],
        [-9, -19],
        [-17, -32],
        [0, -66],
        [4, -56],
        [63, -47],
        [97, -26],
        [120, -2],
        [120, 32],
        [102, 61],
        [71, 89],
        [18, 59],
        [-10, 87],
        [14, 50],
        [26, 21],
        [28, 15],
        [30, 1],
        [23, -11],
        [9, -19],
        [132, -51],
        [112, -12],
        [51, -2],
        [28, 11],
        [11, 24],
        [5, 28],
        [8, 15],
        [31, 4],
        [20, 5],
        [22, -6],
        [4, -10],
        [5, -16],
        [2, -38],
        [-9, -13],
        [-24, -18],
        [-26, -26],
        [-7, -46],
        [-3, -67],
        [-17, -226],
        [9, -31],
        [42, -63],
        [22, -18],
        [19, -3],
        [17, 11],
        [11, 12],
        [29, 10],
        [47, -2],
        [52, 14],
        [39, 20],
        [10, 23],
        [3, 52],
        [-11, 25],
        [-19, 21],
        [-52, 36],
        [-16, 41],
        [-8, 52],
        [11, 58],
        [10, 23],
        [9, 15],
        [10, 15],
        [24, 56],
        [48, 131],
        [12, 120],
        [-6, 39],
        [-3, 35],
        [3, 28],
        [6, 24],
        [17, 21],
        [31, 8],
        [25, 6],
        [6, 18],
        [3, 24],
        [-10, 20],
        [-12, 13],
        [-22, 1],
        [-10, -3],
        [-24, -3],
        [-23, -5],
        [-59, -2],
        [-35, 38],
        [-38, 121],
        [-18, 73],
        [-8, 58],
        [26, 78],
        [81, 100],
        [82, 45],
        [61, 18],
        [70, -8],
        [58, -16],
        [55, -45],
        [56, -74],
        [29, -60],
        [-25, -153],
        [0, -40],
        [-5, -45],
        [-3, -21],
        [-4, -33],
        [25, -60],
        [67, -45],
        [57, -33],
        [31, 2],
        [11, 23],
        [95, 12],
        [34, 0],
        [31, -18],
        [16, -27],
        [4, -44],
        [0, -36],
        [-6, -22],
        [-10, -20],
        [-22, -27],
        [-11, -36],
        [-23, -25],
        [-15, -28],
        [-6, -47],
        [24, -55],
        [51, -53],
        [45, -32],
        [61, -18],
        [35, -8],
        [40, -35],
        [36, -56],
        [0, -40],
        [-4, -35],
        [-18, -18],
        [3, -22],
        [-7, -18],
        [-2, -17],
        [4, -26],
        [4, -64],
        [11, -32],
        [12, -20],
        [18, -6],
        [31, 0],
        [35, -9],
        [71, -28],
        [46, 2],
        [26, 6],
        [25, 29],
        [10, 40],
        [-37, 38],
        [-39, 40],
        [-16, 30],
        [2, 36],
        [-10, 32],
        [2, 17],
        [15, 13],
        [10, 9],
        [12, 20],
        [2, 43],
        [16, 44],
        [12, 48],
        [21, 41],
        [37, 110],
        [20, 70],
        [-2, 79],
        [-28, 67],
        [-40, 32],
        [-20, 8],
        [-52, 18],
        [-24, 23],
        [-11, 21],
        [-2, 26],
        [27, 39],
        [44, 32],
        [28, 21],
        [29, 6],
        [135, -13],
        [25, 19],
        [33, 42],
        [22, 34],
        [14, 59],
        [-5, 87],
        [8, 49],
        [-10, 38],
        [-28, 40],
        [-46, 42],
        [-71, 53],
        [-65, 44],
        [-16, 69],
        [16, 80],
        [18, 51],
        [91, 10],
        [93, -22],
        [94, -22],
        [53, -41],
        [71, -1],
        [47, 13],
        [43, 38],
        [15, 37],
        [-3, 33],
        [-37, 33],
        [-22, 6],
        [-56, 43],
        [-148, 97],
        [-5, 34],
        [5, 25],
        [2, 34],
        [29, 56],
        [33, 32],
        [23, 5],
        [30, 3],
        [23, -8],
        [20, -19],
        [23, -68],
        [55, -48],
        [55, -38],
        [43, -69],
        [38, -40],
        [72, -66],
        [94, 2],
        [29, -2],
        [33, 15],
        [47, 20],
        [38, 32],
        [18, 3],
        [28, -8],
        [87, -72],
        [24, -13],
        [25, -4],
        [22, 11],
        [12, 29],
        [-7, 52],
        [-19, 37],
        [-1, 14],
        [11, 20],
        [123, 86],
        [113, 75],
        [11, 21],
        [6, 26],
        [-13, 39],
        [-56, 130],
        [-34, 81],
        [-32, 44],
        [-15, 22],
        [-21, 58],
        [23, 43],
        [19, 20],
        [28, 4],
        [49, -11],
        [56, -73],
        [36, -92],
        [20, -25],
        [48, -12],
        [19, -2],
        [48, 18],
        [35, 23],
        [12, 40],
        [-18, 48],
        [40, 102],
        [17, 56],
        [24, 64],
        [27, 22],
        [34, 2],
        [49, 2],
        [98, -65],
        [51, -67],
        [8, -25],
        [-17, -36],
        [-57, -57],
        [-14, -36],
        [-13, -33],
        [-14, -56],
        [-6, -67],
        [-8, -40],
        [16, -29],
        [28, -11],
        [39, 26],
        [19, 61],
        [12, 89],
        [-4, 20],
        [8, 21],
        [22, 17],
        [27, 5],
        [61, 13],
        [23, 32],
        [107, -8],
        [59, -39],
        [84, -23],
        [94, -2],
        [84, -2],
        [17, -19],
        [202, -249],
        [-59, -30],
        [-46, -19],
        [-60, -24],
        [-16, -104],
        [-21, -68],
        [-6, -20],
        [4, -21],
        [14, -6],
        [25, 1],
        [63, 32],
        [60, 46],
        [24, 13],
        [27, 7],
        [29, 5],
        [20, 0],
        [32, -23],
        [12, -36],
        [-5, -42],
        [-22, -21],
        [-41, -24],
        [-30, -3],
        [-22, 2],
        [-32, 8],
        [-33, 2],
        [-20, -4],
        [-23, -15],
        [-15, -19],
        [-22, -29],
        [-29, -18],
        [-20, -16],
        [-7, -28],
        [5, -25],
        [10, -22],
        [14, -3],
        [25, 4],
        [43, 12],
        [17, 0],
        [16, -7],
        [12, -13],
        [0, -26],
        [-2, -34],
        [-18, -50],
        [-11, -24],
        [-3, -10],
        [-8, -2],
        [-13, 2],
        [-57, 10],
        [-58, 9],
        [-11, -5],
        [-6, -16],
        [8, -20],
        [28, -14],
        [20, -20],
        [66, -47],
        [20, -30],
        [4, -32],
        [-9, -36],
        [-23, -18],
        [-27, -4],
        [-89, 15],
        [-30, 5],
        [-25, -2],
        [-19, -14],
        [-18, -27],
        [-10, -43],
        [-33, -50],
        [-5, -61],
        [9, -40],
        [17, -22],
        [16, -7],
        [39, -8],
        [40, 2],
        [29, 15],
        [19, 65],
        [33, 25],
        [5, 22],
        [-9, 18],
        [3, 16],
        [20, 14],
        [14, 4],
        [16, -2],
        [29, -10],
        [25, -25],
        [-6, -36],
        [-22, -36],
        [-50, -53],
        [-27, -21],
        [-10, -18],
        [4, -14],
        [27, -32],
        [30, -23],
        [20, -22],
        [58, -18],
        [8, -25],
        [8, -10],
        [48, -40],
        [8, -15],
        [0, -15],
        [-5, -32],
        [22, -16],
        [10, -28],
        [-10, -28],
        [-7, -9],
        [-25, -1],
        [-28, -16],
        [-33, -6],
        [-37, 7],
        [-26, -4],
        [-52, 29],
        [-123, 123],
        [-128, 40],
        [-47, 6],
        [-65, 25],
        [-34, 4],
        [-25, -12],
        [-18, -14],
        [-15, -22],
        [-4, -11],
        [4, -17],
        [24, -48],
        [34, -39],
        [38, -29],
        [22, -38],
        [22, -48],
        [11, -3],
        [6, -6],
        [-5, -15],
        [-6, -22],
        [6, -18],
        [20, -13],
        [22, -18],
        [43, -48],
        [23, -32],
        [13, -27],
        [-8, -42],
        [-4, -46],
        [-5, -11],
        [-16, 2],
        [-13, -6],
        [-37, -43],
        [0, -36],
        [-12, -18],
        [-4, -46],
        [8, -55],
        [-4, -87],
        [8, -36],
        [0, -13],
        [-18, -13],
        [4, -23],
        [12, -70],
        [8, -57],
        [-6, -56],
        [18, -63],
        [6, -39],
        [16, -40],
        [6, -33],
        [18, -17],
        [3, -40],
        [10, -22],
        [2, -39],
        [20, -24],
        [2, -20],
        [0, -32],
        [23, -26],
        [4, -35],
        [-29, -87],
        [-31, -104],
        [-4, -53],
        [-4, -32],
        [-15, -12],
        [-12, -19],
        [-29, -13],
        [-38, -15],
        [-14, -22],
        [-22, -14],
        [-30, -75],
        [27, -169],
        [-13, -40],
        [-17, -14],
        [-23, -20],
        [-18, -23],
        [6, -20],
        [14, -15],
        [19, -16],
        [15, -38],
        [25, -70],
        [-31, -83],
        [-62, -94],
        [24, -67],
        [22, -28],
        [24, -27],
        [9, -24],
        [-1, -23],
        [-6, -31],
        [4, -18],
        [16, -10],
        [14, -2],
        [24, 16],
        [115, 51],
        [33, 16],
        [49, 5],
        [30, 5],
        [25, -4],
        [68, 3],
        [82, 5],
        [22, 18],
        [83, 38],
        [28, -8],
        [29, 0],
        [52, -38],
        [30, -11],
        [25, 8],
        [19, -1],
        [9, -6],
        [7, -13],
        [-8, -15],
        [-21, -53],
        [13, -56],
        [16, -3],
        [26, -2],
        [59, -10],
        [36, -20],
        [20, -18],
        [76, -8],
        [82, -51],
        [97, -92],
        [45, -62],
        [30, -69],
        [31, -74],
        [23, -26],
        [18, -26],
        [22, -23],
        [26, -22],
        [24, -40],
        [39, -60],
        [27, -44],
        [33, -49],
        [35, -29],
        [37, -75],
        [6, -14],
        [12, -8],
        [34, 0],
        [20, -13],
        [2, -14],
        [0, -26],
        [24, -25],
        [85, -86],
        [136, -81],
        [104, 27],
        [16, -47],
        [29, -146],
        [14, -90],
        [24, -77],
        [66, -68],
        [196, -72],
        [84, -10],
        [128, -23],
        [25, -97],
        [16, -20],
        [26, -10],
        [33, -7],
        [37, 7],
        [68, 32],
        [41, 8],
        [36, -2],
        [31, -13],
        [38, -40],
        [35, -42],
        [33, -64],
        [12, -54],
        [22, -34],
        [52, -35],
        [19, -20],
        [7, -29],
        [15, -18],
        [32, -39],
        [13, -36],
        [4, -32],
        [15, -42],
        [34, -49],
        [24, -46],
        [36, -112],
        [62, -57],
        [55, -14],
        [89, -42],
        [51, -4],
        [59, -9],
        [54, 8],
        [18, -4],
        [27, -26],
        [81, -119],
        [90, -96],
        [178, -35],
        [128, -18],
        [156, -18],
        [102, -8],
        [84, 12],
        [75, 8],
        [36, 4],
        [126, 14],
        [33, 5],
        [18, -5],
        [14, -16],
        [23, -12],
        [37, 8],
        [34, 2],
        [22, 12],
        [57, 44],
        [20, 12],
        [20, -2],
        [8, -19],
        [-5, -21],
        [-19, -24],
        [-16, -22],
        [-6, -20],
        [-1, -24],
        [19, -9],
        [6, -8],
        [4, -13],
        [-2, -22],
        [-6, -29],
        [0, -16],
        [4, -9],
        [11, -8],
        [9, -36],
        [5, -44],
        [-6, -18],
        [-15, -21],
        [-12, -21],
        [0, -29],
        [10, -37],
        [8, -33],
        [-4, -28],
        [-6, -29],
        [-6, -23],
        [6, -32],
        [25, -34],
        [6, -28],
        [33, 0],
        [107, 0],
        [104, 7],
        [32, -9],
        [28, -23],
        [52, -112],
        [6, -24],
        [11, -27],
        [-5, -13],
        [-4, -24],
        [4, -3],
        [18, -1],
        [20, -5],
        [12, -18],
        [4, -10],
        [-5, -6],
        [-8, -6],
        [-1, -16],
        [2, -16],
        [8, -15],
        [21, -72],
        [13, -40],
        [4, -30],
        [-3, -24],
        [3, -29],
        [5, -29],
        [8, -13],
        [41, -41],
        [21, -37],
        [3, -57],
        [11, -44],
        [14, -25],
        [12, -17],
        [38, 4],
        [33, -13],
        [14, -9],
        [126, -234],
        [81, -65],
        [162, -25],
        [144, 20],
        [119, 48],
        [152, 44],
        [100, 43],
        [58, 124],
        [82, 31],
        [134, 71],
        [114, 0],
        [93, 7],
        [27, 38],
        [36, 46],
        [32, 23],
        [133, 49],
        [73, 51],
        [93, 42],
        [74, 25],
        [69, 9],
        [70, 15],
        [58, 24],
        [56, 34],
        [43, 13],
        [16, 7],
        [10, 16],
        [6, 24],
        [15, 19],
        [10, 8],
        [39, 44],
        [33, 42],
        [19, 31],
        [1, 26],
        [10, 51],
        [9, 13],
        [11, 10],
        [18, 17],
        [37, 18],
        [25, 10],
        [8, 14],
        [16, 40],
        [4, 75],
        [14, 47],
        [11, 36],
        [8, 85],
        [-8, 102],
        [-6, 17],
        [22, 27],
        [61, 170],
        [42, 86],
        [2, 75],
        [-10, 71],
        [35, 106],
        [70, 208],
        [39, 86],
        [7, 64],
        [13, 55],
        [37, 43],
        [18, 15],
        [4, 17],
        [-10, 81],
        [8, 18],
        [0, 1],
        [8, 4],
        [2, 0],
        [11, 6],
        [39, -3],
        [45, -13],
        [104, -39],
        [8, -4],
        [43, -18],
        [3, -4],
        [3, -2],
        [2, -2],
        [-3, -4],
        [-17, -30],
        [14, -61],
        [1, -5],
        [1, -1],
        [2, -8],
        [5, -19],
        [7, -16],
        [0, -2],
        [4, -12],
        [-2, -3],
        [-16, -26],
        [-23, -29],
        [-27, -11],
        [-9, -15],
        [-4, -4],
        [-4, -6],
        [-8, -17],
        [10, -28],
        [2, -16],
        [4, -8],
        [24, -104],
        [5, -71],
        [-12, -35],
        [-25, -46],
        [-16, -47],
        [8, -46],
        [0, -58],
        [10, -73],
        [0, -42],
        [-2, -26],
        [4, -46],
        [-4, -38],
        [-4, -35],
        [18, -53],
        [45, -109],
        [48, -40],
        [13, -23],
        [7, -24],
        [9, -27],
        [10, -26],
        [21, -25],
        [11, -34],
        [-19, -23],
        [-27, -37],
        [-8, -14],
        [-7, -13],
        [-1, -13],
        [11, -12],
        [55, -61],
        [121, -113],
        [47, -97],
        [40, -87],
        [10, -26],
        [14, -20],
        [16, -57],
        [35, -66],
        [10, -8],
        [6, -9],
        [4, -16],
        [3, -44],
        [6, -50],
        [18, -63],
        [18, -52],
        [15, -54],
        [8, -10],
        [12, -16],
        [3, -14],
        [-2, -17],
        [-4, -13],
        [-17, -11],
        [-7, -5],
        [-6, -9],
        [4, -18],
        [11, -25],
        [13, -16],
        [3, -10],
        [0, -16],
        [-20, -33],
        [-7, -33],
        [-16, -31],
        [0, -10],
        [0, -8],
        [14, -34],
        [-4, -28],
        [-4, -9],
        [-2, -12],
        [8, -11],
        [8, -26],
        [9, -47],
        [14, -30],
        [2, -13],
        [-1, -22],
        [-5, -6],
        [-1, -12],
        [4, -6],
        [10, -3],
        [12, -14],
        [6, -14],
        [0, -31],
        [-3, -23],
        [-2, -49],
        [-2, -66],
        [7, -104],
        [21, -82],
        [20, -75],
        [57, -88],
        [47, -74],
        [54, -84],
        [7, -46],
        [34, -48],
        [15, -45],
        [4, -42],
        [10, -66],
        [181, -177],
        [182, -179],
        [13, -74],
        [36, -49],
        [10, -13],
        [9, -20],
        [2, -10],
        [1, -20],
        [-2, -34],
        [5, -30],
        [-2, -18],
        [4, -18],
        [12, -15],
        [17, -11],
        [6, -5],
        [6, -6],
        [0, -10],
        [-2, -12],
        [-6, -16],
        [-10, -21],
        [-1, -13],
        [13, -50],
        [16, -36],
        [24, -48],
        [35, -33],
        [20, -14],
        [5, -15],
        [10, -33],
        [-1, -15],
        [5, -21],
        [18, -32],
        [33, -84],
        [27, -79],
        [25, -28],
        [30, -19],
        [27, -11],
        [39, -5],
        [8, -8],
        [2, -32],
        [-10, -47],
        [-17, -73],
        [-33, -24],
        [-38, -4],
        [-25, -2],
        [-35, 4],
        [-23, 2],
        [-10, 1],
        [-14, -3],
        [-33, -25],
        [-39, -39],
        [-60, -24],
        [-25, -20],
        [-29, -32],
        [-24, -28],
        [0, -40],
        [-12, -48],
        [-17, -46],
        [-12, -44],
        [-15, -24],
        [-20, -40],
        [13, -46],
        [-4, -39],
        [0, -31],
        [16, -23],
        [4, -21],
        [-10, -16],
        [-8, -10],
        [-10, -27],
        [-3, -23],
        [-29, -42],
        [-14, -13],
        [-6, -22],
        [-3, -38],
        [11, -42],
        [41, -63],
        [32, -52],
        [22, -77],
        [4, -70],
        [10, -31],
        [8, -27],
        [20, -52],
        [15, -40],
        [-2, -32],
        [8, -27],
        [-10, -33],
        [-11, -21],
        [-4, -29],
        [-14, -5],
        [-20, 2],
        [-25, 3],
        [-29, -11],
        [-35, -40],
        [-12, -66],
        [-2, -45],
        [5, -37],
        [-14, -32],
        [9, -32],
        [4, -26],
        [-8, -19],
        [30, -76],
        [36, -84],
        [2, -35],
        [-13, -14],
        [-4, -7],
        [4, -6],
        [11, -2],
        [6, 4],
        [7, -2],
        [4, -33],
        [-15, -19],
        [4, -17],
        [-2, -10],
        [-21, -33],
        [-13, -57],
        [-43, -22],
        [-5, -17],
        [-4, -38],
        [-23, -23],
        [-11, -18],
        [-10, -8],
        [-12, -12],
        [-8, -38],
        [-1, -30],
        [9, -38],
        [2, -25],
        [6, -8],
        [19, -5],
        [6, -17],
        [5, -19],
        [1, -18],
        [4, -22],
        [12, -35],
        [47, -24],
        [59, -17],
        [71, 3],
        [78, 18],
        [135, 51],
        [132, 36],
        [84, 9],
        [44, -12],
        [22, -33],
        [33, -21],
        [19, 2],
        [17, 15],
        [21, 81],
        [18, 28],
        [18, 7],
        [19, -3],
        [27, -11],
        [19, -3],
        [59, -14],
        [26, 22],
        [21, 19],
        [25, 19],
        [68, 4],
        [59, 9],
        [8, 27],
        [13, 11],
        [43, 34],
        [37, 6],
        [32, 4],
        [38, 14],
        [30, 22],
        [17, 28],
        [16, 10],
        [17, 0],
        [14, -8],
        [31, -24],
        [56, -18],
        [119, -26],
        [224, -1150],
        [10, -57],
        [72, -370],
        [149, 73],
        [31, -5],
        [23, -3],
        [30, -9],
        [42, 2],
        [28, 1],
        [18, -7],
        [20, -16],
        [22, -10],
        [25, -10],
        [18, -4],
        [24, -15],
        [16, -16],
        [14, -16],
        [-16, 0],
        [-38, -13],
        [-24, -10],
        [-83, -59],
        [-44, -64],
        [-20, -27],
        [11, -25],
        [-2, -13],
        [-13, -28],
        [-2, -26],
        [0, -21],
        [-6, -28],
        [-8, -14],
        [-6, -6],
        [-23, -6],
        [-24, -8],
        [-21, -19],
        [-18, -45],
        [-15, -19],
        [-15, -9],
        [4, -20],
        [20, -101],
        [-8, 0],
        [-7, -2],
        [-33, -13],
        [-21, -8],
        [-33, -16],
        [-30, -22],
        [-30, -30],
        [-31, -49],
        [-23, -22],
        [-45, -36],
        [-13, -5],
        [-18, 1],
        [-23, 8],
        [-24, 13],
        [-25, -6],
        [-28, -6],
        [-23, -11],
        [-10, -3],
        [-19, 0],
        [-19, 3],
        [-28, 6],
        [-13, 3],
        [-10, -4],
        [-20, -9],
        [-21, -9],
        [-34, -21],
        [-27, -8],
        [-25, -2],
        [-33, -10],
        [-25, -17],
        [-24, -16],
        [-24, -17],
        [-33, -15],
        [-19, -4],
        [-95, 0],
        [-62, 9],
        [-117, 19],
        [-55, 11],
        [-38, -2],
        [-50, -12],
        [-29, -14],
        [-31, -33],
        [-23, -21],
        [-58, -34],
        [-93, -15],
        [-86, -39],
        [-68, -51],
        [-51, -16],
        [-32, 6],
        [-30, 12],
        [-35, 12],
        [-38, 14],
        [-39, 5],
        [-28, -3],
        [-30, 8],
        [-29, 7],
        [-40, 9],
        [-43, 11],
        [-51, 11],
        [-30, -22],
        [-29, -26],
        [-15, -20],
        [-5, -14],
        [-4, -20],
        [-4, -37],
        [-6, -44],
        [-4, -19],
        [-10, -16],
        [-10, -11],
        [-22, -12],
        [-38, -6],
        [-28, 2],
        [-46, 0],
        [-26, 10],
        [-23, 15],
        [-18, 4],
        [-19, -4],
        [-20, -13],
        [-9, -4],
        [-13, 2],
        [-18, 6],
        [-13, 6],
        [-12, 5],
        [-3, -2],
        [2, -5],
        [1, -6],
        [11, -35],
        [30, -144],
        [2, -13],
        [4, -10],
        [6, -4],
        [10, -2],
        [6, -3],
        [6, -13],
        [4, -16],
        [6, -32],
        [6, -20],
        [7, -16],
        [6, -12],
        [1, -19],
        [-6, -20],
        [-4, -8],
        [-2, -7],
        [4, -7],
        [8, -3],
        [15, 1],
        [13, -3],
        [15, -3],
        [7, -6],
        [4, -10],
        [-2, -10],
        [-4, -16],
        [-10, -24],
        [-4, -27],
        [0, -13],
        [4, -14],
        [9, -19],
        [21, -40],
        [10, -15],
        [2, -13],
        [4, -36],
        [2690, -797],
        [1541, -927],
        [1041, -1349],
        [1112, -2837],
        [439, -3453],
        [88, -698],
        [161, -1147],
      ],
      [
        [87603, 351280],
        [22, -2],
        [23, 14],
        [26, 28],
        [12, 38],
        [14, 30],
        [30, 46],
        [29, 54],
        [28, 53],
        [19, 33],
        [10, 13],
        [18, 8],
        [18, 0],
        [85, -2],
        [68, 18],
        [44, 13],
        [12, 18],
        [16, 28],
        [17, 31],
        [30, 49],
        [43, 35],
        [57, 10],
        [88, -13],
        [42, -8],
        [38, 0],
        [13, 6],
        [-8, 16],
        [-13, 33],
        [4, 8],
        [16, 10],
        [55, 15],
        [33, 14],
        [18, 18],
        [11, 27],
        [8, 12],
        [30, 17],
        [22, 0],
        [17, -3],
        [26, -27],
        [8, -9],
        [8, -6],
        [41, -11],
        [28, -14],
        [17, -26],
        [36, -78],
        [13, -32],
        [0, -35],
        [10, -25],
        [79, -87],
        [51, -38],
        [24, -12],
        [21, -11],
        [50, -17],
        [21, -10],
        [36, -7],
        [18, -4],
        [28, -12],
        [11, -4],
        [12, -1],
        [6, 7],
        [4, 7],
        [10, 14],
        [9, 10],
        [17, 10],
        [12, 2],
        [20, -10],
        [7, -10],
        [18, -31],
        [5, -12],
        [9, -29],
        [19, -20],
        [8, -31],
        [43, -29],
        [16, -7],
        [19, 2],
        [21, -16],
        [25, 0],
        [21, -10],
        [52, 16],
        [23, -16],
        [30, -34],
        [15, 6],
        [24, 52],
        [22, 14],
        [18, 19],
        [63, 47],
        [27, 19],
        [32, 14],
        [44, -4],
        [27, -19],
        [25, -33],
        [53, -49],
        [30, -30],
        [19, -36],
        [24, -42],
        [63, -26],
        [53, -20],
        [64, -29],
        [80, -97],
        [6, -31],
        [14, -23],
        [2, -65],
        [4, -38],
        [-4, -62],
        [26, -27],
        [28, -46],
        [7, -46],
        [26, -43],
        [2, -28],
        [20, -27],
        [90, -5],
        [20, -9],
        [34, 8],
        [29, 1],
        [145, -51],
        [62, -2],
        [45, 21],
        [37, 8],
        [69, 10],
        [29, -2],
        [56, 3],
        [47, -13],
        [43, -32],
        [29, -25],
        [25, -42],
        [-14, -106],
        [-18, -41],
        [-1, -28],
        [-2, -33],
        [25, -45],
        [19, -9],
        [18, 7],
        [20, 19],
        [35, 28],
        [2, 35],
        [6, 33],
        [-14, 59],
        [-6, 12],
        [-7, 22],
        [0, 26],
        [0, 40],
        [23, 29],
        [15, 39],
        [44, 57],
        [32, 74],
        [14, 38],
        [16, 111],
        [0, 43],
        [7, 39],
        [26, 93],
        [-13, 97],
        [-15, 56],
        [-3, 47],
        [17, 32],
        [45, 2],
        [86, 42],
        [66, 12],
        [79, 50],
        [83, 37],
        [37, 16],
        [43, 10],
        [33, -8],
        [39, -28],
        [43, -19],
        [25, -1],
        [10, 13],
        [4, 22],
        [-6, 38],
        [-10, 58],
        [-12, 35],
        [-11, 40],
        [1, 20],
        [0, 26],
        [-4, 64],
        [-6, 35],
        [-7, 20],
        [-12, 16],
        [-23, 27],
        [-12, 34],
        [12, 45],
        [-6, 90],
        [3, 56],
        [3, 33],
        [2, 35],
        [4, 57],
        [3, 46],
        [16, 32],
        [20, 27],
        [7, 22],
        [-2, 34],
        [-9, 32],
        [0, 38],
        [4, 28],
        [21, 16],
        [62, 46],
        [51, 37],
        [22, 21],
        [24, 18],
        [24, 6],
        [24, 0],
        [24, -6],
        [62, -29],
        [17, -21],
        [17, -13],
        [26, -14],
        [37, -16],
        [28, -11],
        [48, -46],
        [22, -36],
        [33, -40],
        [13, -38],
        [31, -31],
        [19, -36],
        [9, -38],
        [2, -40],
        [4, -16],
        [-3, -51],
        [10, -46],
        [6, -32],
        [-19, -47],
        [-10, -38],
        [-7, -74],
        [9, -40],
        [13, -92],
        [16, -29],
        [18, -14],
        [12, -15],
        [46, -48],
        [59, -91],
        [12, -28],
        [26, -33],
        [18, -41],
        [16, -10],
        [33, -3],
        [37, 16],
        [23, 13],
        [32, 15],
        [25, 6],
        [28, -4],
        [76, -21],
        [81, -9],
        [27, -17],
        [46, -19],
        [34, -26],
        [19, -27],
        [11, -38],
        [25, -27],
        [31, -30],
        [26, -21],
        [43, -31],
        [66, -51],
        [125, -141],
        [24, -19],
        [44, -24],
        [49, -39],
        [33, -36],
        [27, -32],
        [16, -29],
        [18, -58],
        [3, -80],
        [39, -45],
        [31, -40],
        [32, -39],
        [13, -13],
        [68, -25],
        [80, -30],
        [24, -13],
        [3, -20],
        [-13, -28],
        [12, -25],
        [18, -13],
        [46, 15],
        [69, -18],
        [28, 8],
        [28, 23],
        [33, 32],
        [58, 20],
        [48, 22],
        [43, -8],
        [44, -20],
        [48, 6],
        [35, 4],
        [18, -6],
        [22, -20],
        [28, -43],
        [10, -40],
        [5, -21],
        [1, -35],
        [8, -46],
        [8, -41],
        [26, -37],
        [15, -20],
        [26, -13],
        [50, 6],
        [47, 17],
        [25, 30],
        [10, 37],
        [-4, 33],
        [-20, 24],
        [-38, 35],
        [-14, 40],
        [3, 46],
        [22, 38],
        [22, 26],
        [23, 10],
        [20, 0],
        [30, -12],
        [30, 0],
        [37, 8],
        [43, 17],
        [29, 10],
        [19, 21],
        [21, 37],
        [94, 146],
        [28, 30],
        [33, 20],
        [32, 6],
        [42, 3],
        [29, -5],
        [30, -40],
        [53, -116],
        [71, -41],
        [61, -36],
        [72, -17],
        [23, -22],
        [20, -72],
        [14, -76],
        [22, -70],
        [14, -25],
        [25, -24],
        [90, -51],
        [25, -18],
        [91, -126],
        [23, -62],
        [9, -20],
        [20, -14],
        [27, -7],
        [27, 4],
        [18, 20],
        [24, 37],
        [58, 68],
        [41, 44],
        [44, 14],
        [40, 3],
        [36, -16],
        [48, -19],
        [46, -22],
        [41, -38],
        [6, -53],
        [9, -27],
        [30, -10],
        [25, 19],
        [34, 23],
        [67, 42],
        [58, 62],
        [44, 70],
        [24, 64],
        [-2, 35],
        [-18, 39],
        [-25, 33],
        [-22, 52],
        [-43, 60],
        [-10, 36],
        [10, 28],
        [26, 15],
        [13, 29],
        [-1, 56],
        [-22, 76],
        [-10, 33],
        [-12, 40],
        [-16, 56],
        [7, 29],
        [79, 109],
        [60, 103],
        [8, 41],
        [39, 38],
        [26, 15],
        [53, 4],
        [43, -9],
        [95, -27],
        [61, -6],
        [60, -20],
        [35, -4],
        [41, 13],
        [87, 53],
        [45, 38],
        [46, 21],
        [29, 9],
        [16, 2],
        [60, -13],
        [103, -117],
        [22, -16],
        [39, 5],
        [50, 28],
        [72, 57],
        [46, 45],
        [19, 55],
        [35, 25],
        [27, 2],
        [48, -10],
        [16, -2],
        [16, 8],
        [17, 109],
        [31, 74],
        [88, 100],
        [45, 67],
        [64, 67],
        [25, 45],
        [9, 40],
        [-6, 44],
        [-7, 50],
        [-28, 35],
        [-44, 30],
        [-50, 102],
        [3, 59],
        [16, 47],
        [29, 34],
        [40, 24],
        [79, 18],
        [124, 87],
        [57, 47],
        [26, 80],
        [43, 62],
        [53, 40],
        [72, 19],
        [86, 14],
        [68, -8],
        [75, 22],
        [215, 92],
        [121, 20],
        [107, 35],
        [52, -8],
        [37, -20],
        [16, -29],
        [-19, -81],
        [15, -56],
        [38, -48],
        [52, -27],
        [70, -2],
        [9, -92],
        [28, -90],
        [28, -75],
        [29, -32],
        [28, -22],
        [21, -18],
        [35, -26],
        [14, -45],
        [7, -17],
        [31, -41],
        [14, -47],
        [6, -99],
        [-4, -106],
        [8, -91],
        [-10, -58],
        [46, -70],
        [44, -24],
        [79, -9],
        [61, 1],
        [69, 12],
        [65, 3],
        [77, 17],
        [12, -1],
        [11, -5],
        [56, -54],
        [8, -73],
        [16, -100],
        [18, -94],
        [6, -49],
        [25, -40],
        [33, -57],
        [18, -34],
        [-2, -22],
        [-10, -16],
        [-28, -7],
        [-54, 12],
        [-40, 6],
        [-7, -21],
        [0, -23],
        [11, -72],
        [14, -53],
        [14, -52],
        [-14, -90],
        [24, -17],
        [29, -39],
        [63, -57],
        [77, -91],
        [71, -62],
        [62, -79],
        [41, -61],
        [23, -79],
        [-12, -86],
        [17, -33],
        [32, -22],
        [42, -16],
        [31, -6],
        [10, -28],
        [42, -47],
        [4, -17],
        [36, -17],
        [32, -26],
        [28, -4],
        [10, -6],
        [10, -10],
        [30, -8],
        [49, -22],
        [54, -68],
        [-2, -39],
        [63, -44],
        [18, -19],
        [50, -74],
        [8, -34],
        [15, -21],
        [34, -25],
        [19, -10],
        [13, -25],
        [34, 3],
        [87, -72],
        [26, -72],
        [9, -52],
        [10, -35],
        [12, -60],
        [3, -27],
        [-8, -20],
        [30, -31],
        [15, -29],
        [13, -45],
        [-10, -42],
        [2, -18],
        [18, -13],
        [25, -28],
        [11, -45],
        [9, -31],
        [9, -12],
        [23, -4],
        [40, -53],
        [14, -9],
        [13, -28],
        [51, -14],
        [28, -36],
        [31, -46],
        [20, -32],
        [34, -50],
        [66, -70],
        [46, -17],
        [22, -15],
        [51, -23],
        [47, -34],
        [44, -45],
        [35, -18],
        [6, -17],
        [22, -12],
        [25, -4],
        [49, -25],
        [31, -14],
        [43, -17],
        [25, -33],
        [25, -31],
        [12, -13],
        [45, -16],
        [18, -8],
        [27, -35],
        [27, -25],
        [20, -26],
        [15, -26],
        [31, -20],
        [14, -6],
        [6, -10],
        [-8, -13],
        [-2, -12],
        [8, -12],
        [10, -10],
        [21, -3],
        [8, -6],
        [9, -27],
        [20, -11],
        [12, -5],
        [8, -8],
        [0, -15],
        [-8, -13],
        [-6, -16],
        [-6, -16],
        [-6, -20],
        [-9, -32],
        [-8, -19],
        [-14, -10],
        [-18, -4],
        [-19, 4],
        [-10, 4],
        [-8, -3],
        [-2, -6],
        [-2, -12],
        [-3, -7],
        [-3, -12],
        [-7, -13],
        [-6, -6],
        [-25, 1],
        [-10, -8],
        [-15, -26],
        [-2, -22],
        [10, -22],
        [7, -21],
        [7, -33],
        [-1, -6],
        [-19, -2],
        [-24, -55],
        [-8, -38],
        [0, -26],
        [0, -14],
        [14, -20],
        [2, -22],
        [-8, -18],
        [-16, -31],
        [-1, -11],
        [5, -17],
        [4, -11],
        [10, -5],
        [12, 6],
        [14, -1],
        [11, -8],
        [23, -24],
        [22, -53],
        [11, -5],
        [20, -1],
        [20, -1],
        [45, -26],
        [51, -26],
        [18, -8],
        [14, -12],
        [1, -19],
        [-9, -7],
        [-15, -30],
        [-4, -20],
        [10, -18],
        [24, -5],
        [23, 2],
        [19, -16],
        [12, -22],
        [12, -10],
        [14, -2],
        [11, -2],
        [1, -8],
        [-3, -14],
        [-6, -8],
        [-5, -10],
        [3, -19],
        [10, -9],
        [17, -11],
        [22, -14],
        [17, -32],
        [15, -16],
        [20, -15],
        [9, -22],
        [8, -27],
        [13, -24],
        [19, -19],
        [45, -10],
        [2, -19],
        [14, -37],
        [-3, -16],
        [-17, -24],
        [0, -25],
        [32, -55],
        [8, -18],
        [14, -14],
        [39, -4],
        [22, -32],
        [12, -35],
        [25, -9],
        [55, -31],
        [47, -2],
        [26, -16],
        [8, -33],
        [28, -39],
        [6, -32],
        [8, -39],
        [16, -22],
        [31, -8],
        [39, -11],
        [34, -4],
        [26, -1],
        [29, -8],
        [24, -19],
        [15, -14],
        [6, -12],
        [-4, -18],
        [-12, -12],
        [-20, -6],
        [-17, -13],
        [-12, -12],
        [-2, -15],
        [4, -11],
        [14, -5],
        [17, 2],
        [20, 3],
        [11, -1],
        [12, -12],
        [0, -28],
        [-1, -15],
        [-12, -14],
        [1, -8],
        [11, -12],
        [21, -2],
        [27, -6],
        [12, -7],
        [9, -11],
        [4, -9],
        [-25, -53],
        [36, -49],
        [32, -45],
        [5, 20],
        [28, 31],
        [88, -7],
        [39, -15],
        [53, 2],
        [11, -9],
        [79, 14],
        [30, 16],
        [45, 40],
        [47, 28],
        [18, 28],
        [22, 26],
        [71, 46],
        [47, 0],
        [78, -32],
        [10, -12],
        [33, -11],
        [54, -14],
        [56, 8],
        [36, 21],
        [22, 2],
        [45, 55],
        [9, 25],
        [25, 25],
        [12, 27],
      ],
      [
        [127362, 289382],
        [8, -86],
        [-8, -93],
        [-20, -72],
        [-15, -56],
        [-5, -44],
        [3, -53],
        [-10, -73],
        [-26, -70],
        [-28, -46],
        [-20, -67],
        [-13, -48],
        [-24, -70],
        [-41, -22],
        [-16, -12],
        [-11, -17],
        [0, -34],
        [9, -54],
        [1766, -326],
        [-1327, -4282],
        [251, -517],
        [915, -438],
        [-42, -90],
        [-25, -179],
        [21, -132],
        [-16, -137],
        [35, -130],
        [-32, -186],
        [-40, -244],
        [27, -76],
        [-23, -70],
        [-37, -66],
        [-9, -49],
        [-1, -30],
        [15, -32],
        [18, -21],
        [23, -17],
        [29, -62],
        [38, -46],
        [57, -46],
        [38, -54],
        [66, -47],
        [37, -12],
        [156, -38],
        [13, -11],
        [4, -26],
        [-6, -44],
        [-17, -56],
        [-15, -62],
        [-45, -118],
        [-10, -69],
        [-5, -75],
        [-20, -63],
        [-33, -38],
        [-30, -35],
        [-27, -72],
        [-41, -94],
        [-14, -86],
        [-136, -43],
        [-187, -5],
        [-97, -25],
        [-39, 23],
        [-31, 30],
        [-40, 22],
        [-75, 20],
        [-43, -2],
        [-26, -25],
        [-31, -11],
        [-61, 13],
        [-75, 12],
        [-30, -4],
        [-32, -21],
        [-22, -53],
        [-8, -12],
        [-36, -16],
        [-10, 6],
        [-29, 2],
        [-14, -10],
        [-14, 0],
        [-47, 12],
        [-18, -49],
        [0, -57],
        [23, -62],
        [-27, -78],
        [-17, -59],
        [-14, -34],
        [8, -28],
        [36, -70],
        [44, -57],
        [26, -15],
        [21, -16],
        [15, -35],
        [1, -44],
        [-17, -44],
        [14, -42],
        [14, -44],
        [33, -37],
        [10, -37],
        [23, -21],
        [43, -18],
        [54, -32],
        [-3, -32],
        [18, -35],
        [29, -64],
        [23, -27],
        [35, -19],
        [2, -26],
        [8, -22],
        [8, -17],
        [14, -8],
        [19, 0],
        [23, 2],
        [32, -6],
        [42, -30],
        [36, -41],
        [72, -60],
        [41, -83],
        [17, -36],
        [30, -30],
        [40, -34],
        [42, -19],
        [53, -51],
        [30, -24],
        [26, -34],
        [3, -29],
        [-4, -25],
        [-74, -12],
        [-56, -30],
        [-66, -49],
        [-131, -61],
        [-138, -45],
        [-86, 1],
        [-91, 22],
        [-41, 11],
        [-294, -60],
        [-93, -13],
        [-66, -4],
        [-279, -7],
        [-224, 22],
        [-132, 30],
        [-110, 32],
        [-126, 25],
        [-102, 33],
        [-107, 26],
        [-93, -4],
        [-69, 20],
        [-105, 59],
        [-6, -1],
        [-28, 10],
        [-63, 15],
        [-49, 1],
        [-50, 17],
        [-67, 34],
        [-6, 39],
        [24, 37],
        [9, 40],
        [-15, 16],
        [-42, 13],
        [-30, 22],
        [-6, 17],
        [3, 17],
        [24, 30],
        [0, 22],
        [-12, 24],
        [-35, 34],
        [-30, 49],
        [-13, 3],
        [-19, -3],
        [-15, 22],
        [9, 73],
        [8, 68],
        [-31, 82],
        [-42, 75],
        [-17, 28],
        [-87, 75],
        [7, 58],
        [27, 42],
        [-19, 58],
        [-39, 47],
        [-76, 64],
        [-38, 29],
        [-67, 47],
        [-14, 91],
        [-28, 60],
        [-26, 72],
        [-43, 72],
        [-22, 38],
        [-5, 13],
        [-5, 19],
        [2, 30],
        [27, 55],
        [2, 52],
        [-12, 32],
        [-13, 78],
        [-22, 70],
        [6, 51],
        [27, 58],
        [-25, 80],
        [-11, 28],
        [-23, 12],
        [-14, 23],
        [-34, 63],
        [-4, 37],
        [7, 27],
        [39, 59],
        [71, 48],
        [-3, 60],
        [-26, 59],
        [-11, 44],
        [20, 57],
        [24, 76],
        [-9, 71],
        [-44, 51],
        [-20, 94],
        [-6, 64],
        [-4, 34],
        [-74, 84],
        [-57, 81],
        [-95, 62],
        [-82, 61],
        [-62, 74],
        [-73, 64],
        [-48, 34],
        [-51, 85],
        [-39, 67],
        [10, 131],
        [6, 101],
        [10, 139],
        [17, 113],
        [66, 100],
        [-37, 35],
        [-55, 141],
        [-36, 294],
        [-93, 164],
        [-44, 125],
        [-60, 53],
        [-150, 60],
        [-125, 30],
        [-142, 4],
        [-180, 24],
        [-154, -4],
        [-111, -2],
        [-123, 13],
        [-175, 26],
        [-103, 10],
        [-104, -9],
        [-100, -17],
        [-88, -51],
        [-6, -55],
        [-34, -33],
        [-31, -9],
        [-42, 0],
        [-38, 6],
        [-35, 25],
        [-59, 38],
        [-60, 28],
        [-80, 8],
        [-83, -14],
        [-71, -33],
        [-106, -24],
        [-132, -25],
        [-107, -14],
        [-117, -15],
        [-87, -22],
        [-129, 17],
        [-24, 38],
        [-64, 41],
        [-22, 11],
        [-58, 22],
        [-38, 10],
        [-49, -4],
        [-20, -12],
        [-27, 14],
        [-16, -16],
        [-38, -43],
        [7, -165],
        [51, -121],
        [15, -103],
        [29, -75],
        [40, -31],
        [31, -67],
        [-16, -76],
        [41, -75],
        [8, -57],
        [-43, 2],
        [-41, -2],
        [-45, -12],
        [-63, -24],
        [-77, -53],
        [-121, -146],
        [-64, -55],
        [-173, -9],
        [-48, -16],
        [-393, -135],
        [-77, -39],
        [-34, -46],
        [0, -136],
        [-6, -84],
        [-51, -35],
        [-53, -30],
        [-58, -44],
        [-21, -78],
        [-22, -90],
        [-31, -38],
        [-63, -24],
        [-99, -45],
        [-95, -54],
        [-56, -40],
        [-78, -47],
        [-49, -37],
        [-43, -31],
        [-35, -41],
        [-56, -86],
        [-55, -46],
        [-64, -29],
        [-48, -32],
        [-26, -20],
        [-6, -18],
        [-13, -12],
        [-18, -42],
        [-56, -47],
        [-35, -31],
        [-34, -66],
        [-40, -71],
        [-50, -47],
        [-10, -48],
        [-12, -46],
        [1, -99],
        [-5, -79],
        [-7, -40],
        [-44, -48],
        [-66, -51],
        [-32, -28],
        [-16, -20],
        [-2, -28],
        [16, -30],
        [-8, -22],
        [-35, -69],
        [-14, -76],
        [-19, -15],
        [-27, -9],
        [-108, -38],
        [-75, -64],
        [-59, -53],
        [-4, -6],
        [-28, -21],
        [-9, -14],
        [-12, -20],
        [6, -18],
        [14, -14],
        [3, -25],
        [-10, -17],
        [-13, -7],
        [-21, 3],
        [-17, -6],
        [-12, -7],
        [-10, -11],
        [0, -17],
        [2, -22],
        [-24, -30],
        [-38, -28],
        [-20, -13],
        [-6, -11],
        [0, -16],
        [12, -17],
        [13, -12],
        [3, -19],
        [2, -20],
        [6, -12],
        [13, -13],
        [6, -15],
        [4, -25],
        [7, -4],
        [5, -2],
        [2, -7],
        [-3, -3],
        [-7, -3],
        [-3, -6],
        [14, -17],
        [20, -8],
        [14, -14],
        [21, -30],
        [9, -33],
        [27, -26],
        [44, -19],
        [47, -28],
        [13, -9],
        [3, -8],
        [-5, -53],
        [-4, -28],
        [6, -36],
        [12, -18],
        [27, -5],
        [20, -5],
        [29, 4],
        [22, 2],
        [23, -5],
        [31, -18],
        [19, -15],
        [111, -48],
        [73, -27],
        [77, -34],
        [55, -32],
        [106, -47],
        [69, -58],
        [51, -62],
        [40, -32],
        [13, -13],
        [27, -20],
        [45, -46],
        [47, -88],
        [25, -36],
        [70, -43],
        [44, -36],
        [31, 2],
        [56, -23],
        [85, -22],
        [104, -75],
        [57, -56],
        [73, -50],
        [42, -26],
        [18, -56],
        [32, -28],
        [26, -12],
        [27, -26],
        [18, -19],
        [8, -14],
        [-8, -17],
        [-16, -30],
        [0, -21],
        [24, -22],
        [114, -47],
        [91, -33],
        [49, -18],
        [31, -31],
        [37, -44],
        [14, -28],
        [-17, -6],
        [-36, -18],
        [-29, -24],
        [-20, -26],
        [-27, -21],
        [-29, -14],
        [-23, -9],
        [-65, 14],
        [-68, 21],
        [-79, 43],
        [-93, 55],
        [-109, 69],
        [-95, 4],
        [-79, -10],
        [-11, -32],
        [-8, -41],
        [23, -110],
        [154, -142],
        [-10, -70],
        [-38, -24],
        [-51, 23],
        [-22, 2],
        [-14, -5],
        [-1, -19],
        [5, -9],
        [7, -2],
        [15, -26],
        [23, -24],
        [24, -25],
        [18, -24],
        [14, -28],
        [0, -34],
        [-7, -23],
        [-17, -32],
        [-63, -36],
        [-21, -33],
        [-47, -22],
        [-24, -25],
        [-23, -29],
        [-8, -41],
        [-16, -24],
        [-20, -26],
        [-10, -32],
        [-25, -17],
        [-29, -30],
        [-23, -48],
        [-29, -32],
        [-22, -33],
        [-27, -11],
        [-18, -19],
        [4, -32],
        [-6, -38],
        [-16, -9],
        [-26, -14],
        [-18, -1],
        [-18, -8],
        [-17, -13],
        [-31, -8],
        [-41, -8],
        [-30, 0],
        [-44, 11],
        [-35, 5],
        [-29, -10],
        [-26, -17],
        [-19, -21],
        [-30, -12],
        [-25, 6],
        [-38, -6],
        [-24, -30],
        [-10, -36],
        [7, -13],
        [3, -21],
        [-4, -12],
        [-6, -7],
        [-14, -5],
        [-13, -1],
        [-14, 6],
        [-6, 4],
        [-6, 26],
        [-22, 22],
        [-31, -4],
        [-33, 0],
        [-20, -2],
        [-30, -2],
        [-20, -3],
        [-25, -5],
        [-16, 5],
        [-31, 14],
        [-14, 2],
        [-13, 2],
        [-10, 2],
        [-16, -2],
        [-30, -4],
        [-42, 6],
        [-23, -2],
        [-18, -4],
        [-25, 2],
        [-8, 6],
        [-25, 14],
        [-48, -2],
        [-57, -4],
        [-16, -4],
        [-12, -8],
        [-4, -10],
        [5, -13],
        [8, -17],
        [-1, -12],
        [-2, -11],
        [-4, -25],
        [-3, -25],
        [-18, -26],
        [-32, 2],
        [-47, -8],
        [-90, -2],
        [-34, -1],
        [-12, 7],
        [-27, -1],
        [-26, 7],
        [-28, -4],
        [-14, 8],
        [-11, 8],
        [-12, 0],
        [-12, -6],
        [-18, -2],
        [-5, 0],
        [-13, 0],
        [-18, 6],
        [-38, 6],
        [-33, -2],
        [-46, -16],
        [-18, -18],
        [-6, -13],
        [-4, -16],
        [-2, -23],
        [6, -24],
        [14, -28],
        [6, -44],
        [10, -29],
        [1, -18],
        [-9, -17],
        [-18, -19],
        [-24, -16],
        [-30, -20],
        [-30, -16],
        [-24, -18],
        [-21, -35],
        [-50, -45],
        [-12, -23],
        [-6, -25],
        [-4, -19],
        [12, -31],
        [42, -29],
        [53, -20],
        [22, -20],
        [19, -13],
        [34, -21],
        [37, -6],
        [31, -16],
        [48, -6],
        [57, -1],
        [59, 11],
        [48, 5],
        [-2, -30],
        [4, -49],
        [-7, -53],
        [-6, -50],
        [0, -30],
        [0, -34],
        [8, -45],
        [26, -45],
        [4, -17],
        [-2, -8],
        [2, -19],
        [-4, -32],
        [-6, -18],
        [-8, -24],
        [-14, -23],
        [-9, -13],
        [-26, 2],
        [-40, -10],
        [-37, -41],
        [-39, -37],
        [-34, -61],
        [-14, -83],
        [-32, -56],
        [-15, -32],
        [288, -247],
        [-542, -109],
        [-8, -5],
        [-8, -5],
        [-48, -34],
        [-45, -24],
        [-41, -28],
        [-27, -35],
        [-8, -37],
        [-16, -69],
        [-14, -55],
        [-9, -44],
        [-14, -33],
        [-13, -30],
        [-39, -40],
        [-36, -16],
        [-64, -18],
        [-75, -30],
        [-65, -44],
        [-124, -90],
        [-109, -74],
        [-120, -71],
        [-72, -43],
        [-102, -47],
        [-56, -77],
        [-64, -89],
        [-45, -87],
        [2, -49],
        [-11, -40],
        [-32, -26],
        [-49, -80],
        [-25, -36],
        [-2, -63],
        [14, -42],
        [-8, -34],
        [-31, -12],
        [-40, -13],
        [-22, -39],
        [4, -42],
        [65, -120],
        [6, -83],
        [-18, -36],
        [-30, -28],
        [-21, -24],
        [-28, -22],
        [-35, -34],
        [-13, -35],
        [46, -72],
        [0, -68],
        [0, -30],
        [10, -15],
        [20, -19],
        [29, -30],
        [64, -51],
        [29, -22],
        [10, -15],
        [-6, -31],
        [-18, -30],
        [-39, -14],
        [-40, -4],
        [-25, -11],
        [-10, -35],
        [-2, -31],
        [20, -27],
        [32, -34],
        [66, -51],
        [41, -86],
        [16, -84],
        [25, -66],
        [2, -61],
        [2, -34],
        [-5, -48],
        [3, -61],
        [-10, -37],
        [0, -21],
        [24, -22],
        [12, -19],
        [6, -36],
        [-10, -28],
        [-16, -41],
        [-13, -17],
        [-20, -13],
        [-41, -18],
        [-29, -14],
        [-44, 85],
        [-2982, -657],
        [940, -2661],
        [538, -2550],
        [-1498, 757],
        [-3960, 2000],
        [-583, 1645],
        [380, 2439],
        [-966, -558],
        [-1640, -951],
        [-1628, -2351],
        [-3570, -177],
        [-3808, 350],
        [-113, -775],
        [-14, -95],
        [-21, -696],
        [-1838, -2149],
        [167, -382],
        [-41, -854],
        [-22, -667],
      ],
      [
        [156947, 284565],
        [-12, -9],
        [-7, -22],
        [-1, -22],
        [-4, -18],
        [-10, -19],
        [0, -16],
        [-2, -15],
        [-2, -16],
        [-12, -22],
        [-2, -27],
        [8, -26],
        [-6, -23],
        [-4, -18],
        [-2, -21],
        [-5, -25],
        [-3, -20],
        [-12, -15],
        [-11, -16],
        [-5, -18],
        [-7, -21],
        [-10, -20],
        [-19, -22],
        [-16, -23],
        [-14, -17],
        [-27, -32],
        [-9, -26],
        [-16, -19],
        [-6, -38],
        [-15, -33],
        [-44, -41],
        [-48, -38],
        [-40, -27],
        [-16, -34],
        [-26, -39],
        [-25, -35],
        [-16, -39],
        [-12, -48],
        [9, -38],
        [15, -43],
        [12, -47],
        [6, -27],
        [15, -24],
        [12, -20],
        [11, -25],
        [7, -6],
        [8, -4],
        [8, -4],
        [16, -4],
        [18, -1],
        [18, 7],
        [11, 0],
        [19, -4],
        [19, 0],
        [21, 6],
        [18, -2],
        [25, -14],
        [32, -16],
        [30, -12],
        [19, -9],
        [13, -8],
        [22, -2],
        [24, -8],
        [14, 4],
        [16, 4],
        [18, 8],
        [19, -4],
        [16, 0],
        [21, -10],
        [15, -21],
        [10, -17],
        [5, -14],
        [10, -13],
        [18, -19],
        [15, -11],
        [15, -8],
        [27, -10],
        [20, -12],
        [20, -16],
        [33, -22],
        [29, -16],
        [14, -19],
        [18, -27],
        [4, -20],
        [6, -14],
        [13, -17],
        [27, -6],
        [23, 4],
        [24, 10],
        [15, 16],
        [22, 5],
        [19, 0],
        [20, 3],
        [18, 21],
        [15, 19],
        [16, 10],
        [11, 14],
        [18, 5],
        [19, 2],
        [26, -5],
        [24, -8],
        [26, -14],
        [22, -13],
        [16, -19],
        [7, -23],
        [4, -25],
        [6, -24],
        [-1, -34],
        [3, -22],
        [16, -24],
        [26, -33],
        [21, -20],
        [29, -34],
        [29, -35],
        [33, -38],
        [43, -56],
        [47, -50],
        [58, -43],
        [81, -66],
        [46, -86],
        [17, -48],
        [33, -50],
        [30, -17],
        [24, -2],
        [12, 4],
        [20, 19],
        [18, 15],
        [20, 24],
        [22, 42],
        [34, 31],
        [24, 26],
        [24, 21],
        [18, 13],
        [22, 7],
        [19, 8],
        [25, 13],
        [21, 10],
        [14, 6],
        [14, 0],
        [16, 4],
        [13, 4],
        [14, 4],
        [16, 6],
        [15, -6],
        [20, -6],
        [18, -2],
        [16, 0],
        [37, 0],
        [14, 4],
        [22, 4],
        [31, -4],
        [42, 2],
        [45, -12],
        [16, -6],
        [24, -6],
        [22, -11],
        [26, -9],
        [20, -13],
        [18, -33],
        [9, -23],
        [12, -38],
        [-2, -19],
        [14, -42],
        [8, -26],
        [17, -47],
        [19, -37],
        [12, -38],
        [34, -55],
        [32, -37],
        [34, -37],
        [43, -48],
        [23, -33],
        [31, -42],
        [28, -33],
        [29, -23],
        [21, 3],
        [16, 9],
        [24, 17],
        [15, 15],
        [17, 10],
        [18, 20],
        [21, 16],
        [23, 22],
        [16, 19],
        [29, 10],
        [25, -5],
        [16, -3],
        [16, -7],
        [16, -4],
        [16, -7],
        [20, -7],
        [15, -21],
        [10, -18],
        [14, -17],
        [6, -17],
        [2, -22],
        [4, -16],
        [4, -15],
        [-4, -20],
        [-4, -25],
        [0, -13],
        [0, -16],
        [10, -18],
        [16, -28],
        [11, -9],
        [10, -6],
        [15, -6],
        [10, -6],
        [11, -6],
        [13, -8],
        [10, -4],
        [8, -6],
        [8, -2],
        [8, -4],
        [8, -2],
        [11, -4],
        [10, -14],
        [8, -6],
        [10, -4],
        [20, 0],
        [20, 6],
        [17, 6],
        [14, 6],
        [19, 2],
        [16, 2],
        [16, 0],
        [21, -4],
        [21, -10],
        [31, -4],
        [18, -5],
        [43, -6],
        [24, -3],
        [36, -11],
        [23, -15],
        [16, -17],
        [18, -25],
        [17, -23],
        [14, -14],
        [39, -23],
        [18, -19],
        [14, -23],
        [10, -22],
        [13, -30],
        [19, -45],
        [27, -39],
        [16, -23],
        [12, -18],
        [12, -8],
        [18, -2],
        [14, -6],
        [34, -12],
        [12, -6],
        [13, -6],
        [11, -12],
        [9, -14],
        [11, -17],
        [3, -14],
        [4, -13],
        [7, -12],
        [4, -16],
        [8, -13],
        [1, -16],
        [0, -16],
        [-13, -22],
        [-15, -22],
        [-29, -19],
        [-30, -13],
        [-35, -10],
        [-45, 0],
        [-28, -11],
        [-8, -15],
        [-5, -28],
        [-10, -58],
        [-14, -42],
        [1, -57],
        [-1, -35],
        [24, -40],
        [33, -13],
        [22, 8],
        [19, 9],
        [25, 15],
        [34, 17],
        [14, 23],
        [7, 28],
        [-7, 32],
        [-4, 43],
        [9, 27],
        [18, 9],
        [21, 1],
        [25, -6],
        [28, -14],
        [24, -1],
        [20, -6],
        [32, 9],
        [28, 2],
        [19, 9],
        [31, 3],
        [23, 6],
        [27, 3],
        [35, 8],
        [16, 12],
        [-2, 25],
        [11, 19],
        [22, 14],
        [31, 4],
        [37, -5],
        [39, 8],
        [28, 2],
        [22, -2],
        [32, -20],
        [49, -28],
        [44, -32],
        [2, -15],
        [1, -15],
        [-9, -22],
        [-7, -19],
        [-15, -29],
        [-14, -20],
        [-16, -28],
        [-4, -41],
        [-4, -56],
        [6, -55],
        [0, -46],
        [6, -35],
        [14, -35],
        [21, -20],
        [25, -7],
        [16, -5],
        [12, -2],
        [6, -2],
        [8, 0],
        [8, 0],
        [10, 0],
        [5, 4],
        [4, 6],
        [3, 3],
        [8, 1],
        [9, 2],
        [14, 3],
        [8, 7],
        [6, 8],
        [2, 13],
        [10, 21],
        [6, 16],
        [6, 17],
        [4, 11],
        [8, 13],
        [3, 13],
        [2, 14],
        [5, 11],
        [6, 8],
        [8, 6],
        [14, 0],
        [14, 4],
        [19, -4],
        [18, -4],
        [16, -6],
        [33, -18],
        [20, -5],
        [21, -12],
        [19, -12],
        [18, -24],
        [4, -17],
        [8, -26],
        [2, -21],
        [5, -19],
        [1, -29],
        [2, -35],
        [17, -40],
        [20, -33],
        [10, -19],
        [7, -17],
        [-6, -20],
        [-10, -12],
        [0, -16],
        [10, -20],
        [12, -22],
        [44, -34],
        [37, -34],
        [38, -38],
        [21, -9],
        [18, -12],
        [9, -18],
        [12, -14],
        [14, -9],
        [18, -5],
        [89, -176],
        [10, -22],
        [18, -34],
        [3, -6],
        [2, -5],
        [766, -1525],
        [1462, -2083],
        [11, -17],
        [9, 5],
        [11, 4],
        [12, 0],
        [6, 2],
        [12, 3],
        [14, 12],
        [15, 19],
        [34, 14],
        [16, 17],
        [26, 12],
        [17, 14],
        [4, 17],
        [7, 12],
        [13, 11],
        [26, 13],
        [13, 18],
        [6, 24],
        [-4, 22],
        [4, 13],
        [16, 10],
        [15, 2],
        [48, -5],
        [39, -12],
        [64, -24],
        [87, -36],
        [95, -28],
        [33, -9],
        [19, -5],
        [19, -11],
        [20, -7],
        [25, -11],
        [24, -1],
        [24, 4],
        [34, 2],
        [36, 6],
        [26, 2],
        [50, -11],
        [18, -16],
        [10, -21],
        [16, -10],
        [30, -6],
        [18, 4],
        [17, 8],
        [20, 4],
        [18, 6],
        [13, 9],
        [15, 6],
        [20, 10],
        [6, 11],
        [5, 8],
        [12, 5],
        [16, -1],
        [16, 2],
        [12, 2],
        [9, -3],
        [14, -4],
        [12, -5],
        [11, -14],
        [16, -6],
        [17, -1],
        [12, -4],
        [13, -2],
        [14, -3],
        [16, -8],
        [11, -12],
        [8, -14],
        [15, -8],
        [9, -7],
        [17, -6],
        [14, -9],
        [12, -3],
        [16, -3],
        [26, -7],
        [20, -11],
        [15, -8],
        [12, -19],
        [8, -17],
        [6, -21],
        [6, -28],
        [2, -33],
        [2, -23],
        [7, -23],
        [14, -17],
        [16, -10],
        [30, -31],
        [26, -27],
        [29, -42],
        [28, -34],
        [27, -25],
        [11, -7],
        [14, -2],
        [37, -9],
        [15, -8],
        [10, -8],
        [10, -11],
        [2, -13],
        [-1, -12],
        [-3, -21],
        [-2, -18],
        [-3, -17],
        [1, -16],
        [2, -18],
        [5, -16],
        [3, -23],
        [4, -22],
        [2, -21],
        [6, -21],
        [6, -24],
        [13, -18],
        [18, -14],
        [21, -8],
        [19, -11],
        [18, -8],
        [14, -4],
        [10, -2],
        [10, 1],
        [10, 2],
        [4, 8],
        [8, 9],
        [11, 5],
        [8, 4],
        [9, 4],
        [15, 2],
        [15, -2],
        [9, 4],
        [12, 6],
        [12, 6],
        [12, 6],
        [16, 2],
        [20, 4],
        [15, 2],
        [19, -2],
        [17, -2],
        [7, -8],
        [11, -10],
        [6, -12],
        [12, -12],
        [7, -12],
        [17, -22],
        [11, -17],
        [12, -20],
        [9, -16],
        [17, -18],
        [16, -16],
        [15, -18],
        [13, -16],
        [11, -14],
        [10, -21],
        [25, -30],
        [37, -48],
        [27, -38],
        [10, -25],
        [11, -26],
        [22, -22],
        [26, -18],
        [31, -28],
        [26, -12],
        [38, -22],
        [27, -13],
        [29, -9],
        [32, -9],
        [18, -20],
        [5, -18],
        [8, -22],
        [7, -26],
        [3, -25],
        [-2, -28],
        [4, -21],
        [15, -16],
        [17, -10],
        [13, -14],
        [13, -19],
        [8, -17],
        [5, -19],
        [-2, -24],
        [-3, -22],
        [-8, -22],
        [-11, -18],
        [-12, -19],
        [-6, -23],
        [-6, -19],
        [-2, -21],
        [-6, -20],
        [-2, -21],
        [-8, -18],
        [-6, -12],
        [-8, -13],
        [-10, -14],
        [-16, -26],
        [-8, -15],
        [-6, -18],
        [-4, -14],
        [-2, -19],
        [4, -18],
        [12, -48],
        [9, -27],
        [14, -28],
        [10, -26],
        [9, -18],
        [21, -47],
        [19, -28],
        [8, -30],
        [7, -24],
        [6, -12],
        [7, -6],
        [14, -4],
        [7, -2],
        [30, 1],
        [12, 1],
        [14, 6],
        [17, 10],
        [16, 6],
        [14, 2],
        [10, 0],
        [18, -4],
        [15, 0],
        [14, 0],
        [16, -4],
        [18, -10],
        [12, -8],
        [8, -7],
        [11, -13],
        [13, -18],
        [11, -18],
        [5, -15],
        [13, -17],
        [9, -7],
        [16, -6],
        [12, -6],
        [15, -4],
        [25, -5],
        [41, -1],
        [27, 7],
        [22, 13],
        [11, 13],
        [6, 15],
        [2, 11],
        [6, 15],
        [8, 11],
        [3, 12],
        [7, 12],
        [8, 12],
        [8, 18],
        [6, 18],
        [5, 16],
        [4, 12],
        [2, 20],
        [2, 11],
        [2, 14],
        [8, 14],
        [12, 21],
        [18, 14],
        [22, 7],
        [14, 6],
        [19, -4],
        [28, -8],
        [32, -22],
        [19, -20],
        [14, -22],
        [25, -27],
        [18, -16],
        [15, -22],
        [15, -18],
        [10, -26],
        [9, -35],
        [4, -62],
        [5, -58],
        [-8, -62],
        [-2, -38],
        [2, -48],
        [10, -46],
        [10, -35],
        [22, -26],
        [25, -29],
        [13, -27],
        [14, -32],
        [12, -20],
        [13, -10],
        [8, -11],
        [2, -26],
        [8, -22],
        [21, -14],
        [57, -27],
        [49, -26],
        [27, -8],
        [43, -6],
        [31, -8],
        [20, -6],
        [33, -7],
        [21, -2],
        [26, -4],
        [21, -10],
        [16, -14],
        [24, -19],
        [22, -7],
        [26, -5],
        [21, -15],
        [26, -12],
        [29, -12],
        [30, -30],
        [8, -19],
        [9, -20],
        [-5, -16],
        [-11, -15],
        [-9, -23],
        [-8, -20],
        [-4, -18],
        [4, -18],
        [2, -16],
        [4, -19],
        [0, -18],
        [2, -15],
        [11, -13],
        [48, -43],
        [14, -18],
        [6, -16],
        [-2, -10],
        [2, -7],
        [10, -6],
        [8, -11],
        [5, -16],
        [-1, -13],
        [1, -17],
        [4, -10],
        [15, -12],
        [7, -14],
        [7, -17],
        [8, -11],
        [15, -12],
        [21, -15],
        [18, -15],
        [16, -16],
        [14, -17],
        [15, -18],
        [11, -20],
        [11, -16],
        [10, -6],
        [10, 0],
        [6, 6],
        [17, 12],
        [21, 6],
        [18, -2],
        [16, -6],
        [14, -6],
        [17, -12],
        [18, -19],
        [14, -15],
        [23, -18],
        [29, -11],
        [21, -11],
        [20, -12],
        [20, -25],
        [11, -29],
        [6, -29],
        [13, -25],
        [18, -17],
        [23, -14],
        [26, -2],
        [38, -6],
        [36, -14],
        [25, -16],
        [30, -24],
        [30, -39],
        [29, -37],
        [39, -37],
        [24, -16],
        [20, -10],
        [21, -6],
        [20, -2],
        [19, -8],
        [16, -11],
        [23, -18],
        [16, -14],
        [22, -23],
        [12, -24],
        [6, -23],
        [2, -16],
        [2, -13],
        [8, -10],
        [9, -8],
        [12, 0],
        [10, 4],
        [14, 7],
        [12, 1],
        [21, 8],
        [13, 5],
        [6, 7],
        [17, 7],
        [12, 0],
        [12, 1],
        [8, -1],
        [12, 2],
        [12, -2],
        [7, 0],
        [10, 0],
        [4, 0],
        [10, 3],
        [11, 5],
        [10, 3],
        [7, 1],
        [23, 1],
        [24, -1],
        [27, -1],
        [31, -6],
        [33, -6],
        [36, -18],
        [34, -21],
        [21, -17],
        [19, -16],
        [19, -15],
        [28, -15],
        [20, -10],
        [26, -20],
        [29, -25],
        [8, -13],
        [2, -30],
        [10, -25],
        [23, -36],
        [18, -24],
        [18, -19],
        [22, -25],
        [21, -32],
        [23, -25],
        [13, -26],
        [21, -10],
        [32, -9],
        [51, -2],
        [32, -9],
        [27, -16],
        [15, -17],
        [15, -10],
        [19, -5],
        [29, -4],
        [30, -6],
        [31, -20],
        [17, -13],
        [22, -7],
        [19, -8],
        [19, -18],
        [23, -8],
        [15, -13],
        [10, -8],
        [14, -22],
        [24, -23],
        [25, -26],
        [16, -12],
        [14, -15],
        [15, -10],
        [14, -12],
        [12, -5],
        [16, -2],
        [19, -7],
        [15, -6],
        [14, -9],
        [13, -5],
        [18, -4],
        [17, -5],
        [17, -2],
        [21, -4],
        [18, -2],
        [11, -2],
        [16, 2],
        [17, 6],
        [11, 6],
        [11, 2],
        [16, 4],
        [15, 0],
        [11, -2],
        [8, -8],
        [8, -6],
        [6, -9],
        [9, -10],
        [9, -8],
        [4, -11],
        [5, -11],
        [1, -20],
        [-3, -18],
        [-8, -17],
        [-7, -12],
        [-6, -13],
        [-12, -17],
        [-8, -19],
        [-2, -17],
        [8, -11],
        [10, -17],
        [14, -17],
        [13, -17],
        [10, -14],
        [9, -16],
        [3, -16],
        [5, -10],
        [4, -16],
        [5, -12],
        [9, -8],
        [10, -10],
        [14, -8],
        [13, -8],
        [17, -10],
        [12, -12],
        [10, -12],
        [11, -13],
        [10, -9],
        [8, -14],
        [10, -19],
        [6, -18],
        [12, -12],
        [11, -14],
        [16, -14],
        [19, -14],
        [14, -12],
        [14, -16],
        [11, -19],
        [20, -33],
        [22, -29],
        [18, -22],
        [20, -14],
        [23, -16],
        [16, -6],
        [22, 2],
        [19, 4],
        [12, 14],
        [13, 16],
        [2, 26],
        [9, 29],
        [4, 23],
        [19, 30],
        [28, 31],
        [18, 24],
        [26, 26],
        [37, 43],
        [34, 28],
        [40, 24],
        [37, 8],
        [21, 8],
        [24, 4],
        [21, 8],
        [20, -2],
        [17, 4],
        [20, 0],
        [17, 2],
        [18, 4],
        [19, -4],
        [15, 2],
        [16, -2],
        [16, 2],
        [18, 4],
        [16, 2],
        [25, 2],
        [27, -6],
        [26, -4],
        [30, -4],
        [25, -6],
        [20, -6],
        [22, -10],
        [17, -6],
        [15, -20],
        [15, -19],
        [15, -18],
        [12, -20],
        [10, -20],
        [6, -14],
        [11, -14],
        [10, -14],
        [4, -26],
        [3, -13],
        [8, -17],
        [11, -26],
        [11, -21],
        [19, -17],
        [14, -11],
        [12, -13],
        [9, -9],
        [10, -7],
        [8, -8],
        [10, -15],
        [11, -16],
        [8, -12],
        [13, -14],
        [9, -2],
        [16, -5],
        [15, -4],
        [17, -6],
        [20, -6],
        [24, -6],
        [23, -12],
        [17, -16],
        [25, -11],
        [18, -5],
        [28, -17],
        [19, -38],
        [7, -15],
        [10, -55],
        [8, -44],
        [6, -18],
        [14, -29],
        [13, -18],
        [17, -14],
        [18, -14],
        [26, -16],
        [26, -12],
        [42, -18],
        [91, -41],
        [44, -20],
        [37, -17],
        [24, -14],
        [22, -13],
        [24, -18],
        [20, -11],
        [16, -6],
        [16, -4],
        [11, -4],
        [19, -6],
        [19, -7],
        [20, 2],
        [26, -2],
        [26, 2],
        [18, 8],
        [7, 14],
        [26, 35],
        [34, 45],
        [16, 18],
        [14, 17],
        [22, 31],
        [26, 13],
        [43, 16],
        [32, 20],
        [45, 6],
        [34, 2],
        [30, 10],
        [34, 28],
        [77, 15],
        [37, 25],
        [25, 21],
        [17, 24],
        [18, 20],
        [31, 6],
        [32, -4],
        [16, -20],
        [21, -14],
        [14, -10],
        [21, -10],
        [20, -11],
        [22, -10],
        [24, -5],
        [24, -10],
        [17, -12],
        [15, -9],
        [21, -16],
        [25, -20],
        [24, -30],
        [23, -23],
        [18, -18],
        [8, -15],
        [8, -16],
        [3, -18],
        [7, -8],
        [12, -7],
        [16, -4],
        [10, -2],
        [20, 2],
        [13, 4],
        [19, -1],
        [28, 12],
        [25, 2],
        [21, -7],
        [23, -10],
        [32, -3],
        [17, 9],
        [8, 9],
        [6, 8],
        [10, 2],
        [34, -4],
        [33, -2],
        [51, -13],
        [35, -2],
        [61, 8],
        [48, -4],
        [53, -6],
        [37, -15],
        [30, -12],
        [17, -19],
        [9, -25],
        [3, -35],
        [0, -29],
        [-3, -23],
        [-5, -10],
        [-9, -18],
        [-14, -27],
        [-10, -17],
        [-2, -22],
        [6, -18],
        [10, -22],
        [21, -22],
        [16, -15],
        [20, -16],
        [20, -20],
        [1, -13],
        [7, -14],
        [22, -9],
        [15, -6],
        [12, -3],
        [15, -6],
        [19, -6],
        [18, 0],
        [16, -2],
        [9, 3],
        [11, 6],
        [12, 4],
        [10, 0],
        [13, -2],
        [13, -3],
        [9, 0],
        [11, 5],
        [13, 10],
        [22, 18],
        [22, 25],
        [22, 25],
        [23, 19],
        [21, 18],
        [16, 12],
        [8, 11],
        [13, 9],
        [10, 14],
        [16, 20],
        [9, 15],
        [9, 15],
        [9, 8],
        [9, 16],
        [14, 20],
        [12, 15],
        [9, 12],
        [10, 12],
        [16, 3],
        [18, -1],
        [21, -14],
        [22, -14],
        [17, -5],
        [22, -4],
        [16, -4],
        [18, -4],
        [18, -12],
        [8, -14],
        [2, -23],
        [2, -19],
        [9, -17],
        [14, -15],
        [8, -6],
        [14, -16],
        [7, -10],
        [8, -8],
        [12, -12],
        [11, -13],
        [5, -8],
        [7, -11],
        [9, -12],
        [8, -11],
        [2, -10],
        [4, -11],
        [4, -10],
        [8, -9],
        [10, -9],
        [9, -10],
        [9, -11],
        [6, -9],
        [3, -4],
        [5, -14],
        [4, -15],
        [-2, -19],
        [-4, -15],
        [0, -19],
        [-2, -15],
        [0, -18],
        [-3, -16],
        [-7, -18],
        [-11, -19],
        [-12, -18],
        [-7, -15],
        [2, -26],
        [2, -15],
        [7, -18],
        [3, -24],
        [10, -24],
        [8, -4],
        [9, 6],
        [8, 24],
        [9, 31],
        [12, 50],
        [12, 22],
        [12, 26],
        [13, 26],
        [23, 20],
        [30, 18],
        [41, 4],
        [26, -3],
        [24, 4],
        [22, -6],
        [12, 0],
        [18, 8],
        [23, 5],
        [30, 25],
        [34, 24],
        [29, 6],
        [39, 3],
        [47, 0],
        [30, -8],
        [51, -42],
        [24, -25],
        [43, -37],
        [11, -6],
        [19, -4],
        [19, 2],
        [33, 4],
        [28, -2],
        [50, 16],
        [42, 8],
        [20, 8],
        [28, 6],
        [15, 2],
        [15, 0],
        [12, 2],
        [14, -1],
        [17, 0],
        [12, -1],
        [36, -8],
        [27, -4],
        [82, 10],
        [101, 32],
        [352, -225],
        [4, -4],
        [182, -118],
        [26, -15],
        [517, -334],
        [16, -10],
        [1299, -837],
        [466, -1787],
        [783, -471],
        [27, -16],
        [1470, -886],
        [476, -1163],
        [6, -14],
        [101, -247],
        [17, -45],
        [291, -715],
        [8, -18],
        [262, -640],
        [10, -25],
        [287, -702],
        [966, -961],
        [36, -34],
        [208, -209],
        [1891, -1874],
      ],
    ],
    transform: {
      scale: [0.00001617400774822454, 0.000014977614835401869],
      translate: [-109.44470865602212, 22.3450793025208],
    },
    objects: {
      municipiosdurango: {
        type: "GeometryCollection",
        geometries: [
          {
            arcs: [[0, 1, 2, 3, 4, 5]],
            type: "Polygon",
            properties: {
              CVEGEO: "10023",
              CVE_ENT: "10",
              CVE_MUN: "023",
              NOMGEO: "Pueblo Nuevo",
            },
          },
          {
            arcs: [[6, 7, 8, 9, 10, 11]],
            type: "Polygon",
            properties: {
              CVEGEO: "10032",
              CVE_ENT: "10",
              CVE_MUN: "032",
              NOMGEO: "Santiago Papasquiaro",
            },
          },
          {
            arcs: [[12, 13, -12, 14, 15, 16]],
            type: "Polygon",
            properties: {
              CVEGEO: "10035",
              CVE_ENT: "10",
              CVE_MUN: "035",
              NOMGEO: "Tepehuanes",
            },
          },
          {
            arcs: [[-16, 17, 18]],
            type: "Polygon",
            properties: {
              CVEGEO: "10037",
              CVE_ENT: "10",
              CVE_MUN: "037",
              NOMGEO: "Topia",
            },
          },
          {
            arcs: [[-1, 19, 20]],
            type: "Polygon",
            properties: {
              CVEGEO: "10014",
              CVE_ENT: "10",
              CVE_MUN: "014",
              NOMGEO: "Mezquital",
            },
          },
          {
            arcs: [[-5, 21, 22, 23, 24, 25, -8, 26]],
            type: "Polygon",
            properties: {
              CVEGEO: "10026",
              CVE_ENT: "10",
              CVE_MUN: "026",
              NOMGEO: "San Dimas",
            },
          },
          {
            arcs: [[-9, -26, 27]],
            type: "Polygon",
            properties: {
              CVEGEO: "10019",
              CVE_ENT: "10",
              CVE_MUN: "019",
              NOMGEO: "Otáez",
            },
          },
          {
            arcs: [[28, -17, -19, 29, -10, -28, -25, 30, 31, 32, 33]],
            type: "Polygon",
            properties: {
              CVEGEO: "10034",
              CVE_ENT: "10",
              CVE_MUN: "034",
              NOMGEO: "Tamazula",
            },
          },
          {
            arcs: [[-11, -30, -18, -15]],
            type: "Polygon",
            properties: {
              CVEGEO: "10002",
              CVE_ENT: "10",
              CVE_MUN: "002",
              NOMGEO: "Canelas",
            },
          },
        ],
      },
      estados: {
        type: "GeometryCollection",
        geometries: [
          {
            arcs: [[34, 35, -13, -29, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45]],
            type: "Polygon",
            properties: { CVE_ENT: 8, NOMGEO: "Chihuahua" },
          },
          {
            arcs: [
              [
                46, 20, 1, 2, 3, 21, 22, 23, 30, 31, 32, 33, 28, 12, -36, -35,
                -46, 47,
              ],
            ],
            type: "Polygon",
            properties: { CVE_ENT: 10, NOMGEO: "Durango" },
          },
          {
            arcs: [
              [
                [
                  48, 49, -44, -43, -42, -41, -40, -39, -38, -37, -34, -33, -32,
                  -31, -24, -23, -22, -4, -3, 50, 51, 52, 53, 54, 55, 56, 57,
                ],
              ],
              [[58]],
              [[59]],
              [[60]],
              [[61]],
              [[62]],
              [[63]],
              [[64]],
              [[65]],
              [[66]],
              [[67]],
            ],
            type: "MultiPolygon",
            properties: { CVE_ENT: 25, NOMGEO: "Sinaloa" },
          },
        ],
      },
      sinaloa: {
        type: "GeometryCollection",
        geometries: [
          {
            arcs: [
              [
                [
                  48, 49, -44, -43, -42, -41, -40, -39, -38, -37, -34, -33, -32,
                  -31, -24, -23, -22, -4, -3, 50, 51, 52, 53, 54, 55, 56, 57,
                ],
              ],
              [[58]],
              [[59]],
              [[60]],
              [[61]],
              [[62]],
              [[63]],
              [[64]],
              [[65]],
              [[66]],
              [[67]],
            ],
            type: "MultiPolygon",
            properties: { CVE_ENT: 25, NOMGEO: "Sinaloa" },
          },
        ],
      },
      durango: {
        type: "GeometryCollection",
        geometries: [
          {
            arcs: [
              [
                46, 20, 1, 2, 3, 21, 22, 23, 30, 31, 32, 33, 28, 12, -36, -35,
                -46, 47,
              ],
            ],
            type: "Polygon",
            properties: { CVE_ENT: 10, NOMGEO: "Durango" },
          },
        ],
      },
      chihuahua: {
        type: "GeometryCollection",
        geometries: [
          {
            arcs: [[34, 35, -13, -29, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45]],
            type: "Polygon",
            properties: { CVE_ENT: 8, NOMGEO: "Chihuahua" },
          },
        ],
      },
      municipiossinaloa: {
        type: "GeometryCollection",
        geometries: [
          {
            arcs: [[-24, 68, 52, 69, 70, -31]],
            type: "Polygon",
            properties: {
              CVEGEO: "25016",
              CVE_ENT: "25",
              CVE_MUN: "016",
              NOMGEO: "San Ignacio",
            },
          },
          {
            arcs: [[-37, -34, 71, 72, 73]],
            type: "Polygon",
            properties: {
              CVEGEO: "25003",
              CVE_ENT: "25",
              CVE_MUN: "003",
              NOMGEO: "Badiraguato",
            },
          },
          {
            arcs: [[-4, 74, 75, -22]],
            type: "Polygon",
            properties: {
              CVEGEO: "25004",
              CVE_ENT: "25",
              CVE_MUN: "004",
              NOMGEO: "Concordia",
            },
          },
          {
            arcs: [[-32, -71, 76, 77]],
            type: "Polygon",
            properties: {
              CVEGEO: "25005",
              CVE_ENT: "25",
              CVE_MUN: "005",
              NOMGEO: "Cosalá",
            },
          },
          {
            arcs: [
              [[-23, -76, 78, 51, -69]],
              [[61]],
              [[62]],
              [[63]],
              [[64]],
              [[65]],
              [[66]],
              [[67]],
            ],
            type: "MultiPolygon",
            properties: {
              CVEGEO: "25012",
              CVE_ENT: "25",
              CVE_MUN: "012",
              NOMGEO: "Mazatlán",
            },
          },
          {
            arcs: [[-44, -43, -42, -41, -40, 79, 80, 49]],
            type: "Polygon",
            properties: {
              CVEGEO: "25007",
              CVE_ENT: "25",
              CVE_MUN: "007",
              NOMGEO: "Choix",
            },
          },
          {
            arcs: [[-33, -78, 81, 54, 82, 56, 83, -72]],
            type: "Polygon",
            properties: {
              CVEGEO: "25006",
              CVE_ENT: "25",
              CVE_MUN: "006",
              NOMGEO: "Culiacán",
            },
          },
          {
            arcs: [[-39, -38, -74, 84, -80]],
            type: "Polygon",
            properties: {
              CVEGEO: "25017",
              CVE_ENT: "25",
              CVE_MUN: "017",
              NOMGEO: "Sinaloa",
            },
          },
        ],
      },
      municipioschihuahua: {
        type: "GeometryCollection",
        geometries: [
          {
            arcs: [[85, 40, 86, 87]],
            type: "Polygon",
            properties: {
              CVEGEO: "08008",
              CVE_ENT: "08",
              CVE_MUN: "008",
              NOMGEO: "Batopilas de Manuel Gómez Morín",
            },
          },
          {
            arcs: [[88, 89, 42, 90]],
            type: "Polygon",
            properties: {
              CVEGEO: "08030",
              CVE_ENT: "08",
              CVE_MUN: "030",
              NOMGEO: "Guazapares",
            },
          },
          {
            arcs: [[91, 92, 93, -88, 94, 95]],
            type: "Polygon",
            properties: {
              CVEGEO: "08027",
              CVE_ENT: "08",
              CVE_MUN: "027",
              NOMGEO: "Guachochi",
            },
          },
          {
            arcs: [[96, -95, -87, 41, -90]],
            type: "Polygon",
            properties: {
              CVEGEO: "08065",
              CVE_ENT: "08",
              CVE_MUN: "065",
              NOMGEO: "Urique",
            },
          },
          {
            arcs: [[-86, -94, 97, 38, 39]],
            type: "Polygon",
            properties: {
              CVEGEO: "08046",
              CVE_ENT: "08",
              CVE_MUN: "046",
              NOMGEO: "Morelos",
            },
          },
          {
            arcs: [[98, 35, -13, -29, 36, 37, -98, -93]],
            type: "Polygon",
            properties: {
              CVEGEO: "08029",
              CVE_ENT: "08",
              CVE_MUN: "029",
              NOMGEO: "Guadalupe y Calvo",
            },
          },
        ],
      },
      municipiosinteres: {
        type: "GeometryCollection",
        geometries: [
          {
            arcs: [[85, 40, 86, 87]],
            type: "Polygon",
            properties: {
              CVEGEO: "08008",
              CVE_ENT: "08",
              CVE_MUN: "008",
              NOMGEO: "Batopilas de Manuel Gómez Morín",
            },
          },
          {
            arcs: [[88, 89, 42, 90]],
            type: "Polygon",
            properties: {
              CVEGEO: "08030",
              CVE_ENT: "08",
              CVE_MUN: "030",
              NOMGEO: "Guazapares",
            },
          },
          {
            arcs: [[91, 92, 93, -88, 94, 95]],
            type: "Polygon",
            properties: {
              CVEGEO: "08027",
              CVE_ENT: "08",
              CVE_MUN: "027",
              NOMGEO: "Guachochi",
            },
          },
          {
            arcs: [[96, -95, -87, 41, -90]],
            type: "Polygon",
            properties: {
              CVEGEO: "08065",
              CVE_ENT: "08",
              CVE_MUN: "065",
              NOMGEO: "Urique",
            },
          },
          {
            arcs: [[-86, -94, 97, 38, 39]],
            type: "Polygon",
            properties: {
              CVEGEO: "08046",
              CVE_ENT: "08",
              CVE_MUN: "046",
              NOMGEO: "Morelos",
            },
          },
          {
            arcs: [[98, 35, -13, -29, 36, 37, -98, -93]],
            type: "Polygon",
            properties: {
              CVEGEO: "08029",
              CVE_ENT: "08",
              CVE_MUN: "029",
              NOMGEO: "Guadalupe y Calvo",
            },
          },
          {
            arcs: [[0, 1, 2, 3, 4, 5]],
            type: "Polygon",
            properties: {
              CVEGEO: "10023",
              CVE_ENT: "10",
              CVE_MUN: "023",
              NOMGEO: "Pueblo Nuevo",
            },
          },
          {
            arcs: [[6, 7, 8, 9, 10, 11]],
            type: "Polygon",
            properties: {
              CVEGEO: "10032",
              CVE_ENT: "10",
              CVE_MUN: "032",
              NOMGEO: "Santiago Papasquiaro",
            },
          },
          {
            arcs: [[12, 13, -12, 14, 15, 16]],
            type: "Polygon",
            properties: {
              CVEGEO: "10035",
              CVE_ENT: "10",
              CVE_MUN: "035",
              NOMGEO: "Tepehuanes",
            },
          },
          {
            arcs: [[-16, 17, 18]],
            type: "Polygon",
            properties: {
              CVEGEO: "10037",
              CVE_ENT: "10",
              CVE_MUN: "037",
              NOMGEO: "Topia",
            },
          },
          {
            arcs: [[-1, 19, 20]],
            type: "Polygon",
            properties: {
              CVEGEO: "10014",
              CVE_ENT: "10",
              CVE_MUN: "014",
              NOMGEO: "Mezquital",
            },
          },
          {
            arcs: [[-5, 21, 22, 23, 24, 25, -8, 26]],
            type: "Polygon",
            properties: {
              CVEGEO: "10026",
              CVE_ENT: "10",
              CVE_MUN: "026",
              NOMGEO: "San Dimas",
            },
          },
          {
            arcs: [[-9, -26, 27]],
            type: "Polygon",
            properties: {
              CVEGEO: "10019",
              CVE_ENT: "10",
              CVE_MUN: "019",
              NOMGEO: "Otáez",
            },
          },
          {
            arcs: [[28, -17, -19, 29, -10, -28, -25, 30, 31, 32, 33]],
            type: "Polygon",
            properties: {
              CVEGEO: "10034",
              CVE_ENT: "10",
              CVE_MUN: "034",
              NOMGEO: "Tamazula",
            },
          },
          {
            arcs: [[-11, -30, -18, -15]],
            type: "Polygon",
            properties: {
              CVEGEO: "10002",
              CVE_ENT: "10",
              CVE_MUN: "002",
              NOMGEO: "Canelas",
            },
          },
          {
            arcs: [[-24, 68, 52, 69, 70, -31]],
            type: "Polygon",
            properties: {
              CVEGEO: "25016",
              CVE_ENT: "25",
              CVE_MUN: "016",
              NOMGEO: "San Ignacio",
            },
          },
          {
            arcs: [[-37, -34, 71, 72, 73]],
            type: "Polygon",
            properties: {
              CVEGEO: "25003",
              CVE_ENT: "25",
              CVE_MUN: "003",
              NOMGEO: "Badiraguato",
            },
          },
          {
            arcs: [[-4, 74, 75, -22]],
            type: "Polygon",
            properties: {
              CVEGEO: "25004",
              CVE_ENT: "25",
              CVE_MUN: "004",
              NOMGEO: "Concordia",
            },
          },
          {
            arcs: [[-32, -71, 76, 77]],
            type: "Polygon",
            properties: {
              CVEGEO: "25005",
              CVE_ENT: "25",
              CVE_MUN: "005",
              NOMGEO: "Cosalá",
            },
          },
          {
            arcs: [
              [[-23, -76, 78, 51, -69]],
              [[61]],
              [[62]],
              [[63]],
              [[64]],
              [[65]],
              [[66]],
              [[67]],
            ],
            type: "MultiPolygon",
            properties: {
              CVEGEO: "25012",
              CVE_ENT: "25",
              CVE_MUN: "012",
              NOMGEO: "Mazatlán",
            },
          },
          {
            arcs: [[-44, -43, -42, -41, -40, 79, 80, 49]],
            type: "Polygon",
            properties: {
              CVEGEO: "25007",
              CVE_ENT: "25",
              CVE_MUN: "007",
              NOMGEO: "Choix",
            },
          },
          {
            arcs: [[-33, -78, 81, 54, 82, 56, 83, -72]],
            type: "Polygon",
            properties: {
              CVEGEO: "25006",
              CVE_ENT: "25",
              CVE_MUN: "006",
              NOMGEO: "Culiacán",
            },
          },
          {
            arcs: [[-39, -38, -74, 84, -80]],
            type: "Polygon",
            properties: {
              CVEGEO: "25017",
              CVE_ENT: "25",
              CVE_MUN: "017",
              NOMGEO: "Sinaloa",
            },
          },
        ],
      },
    },
  };
})();
